var xE = Object.defineProperty;
var BE = (n, e, t) => e in n ? xE(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var Kn = (n, e, t) => (BE(n, typeof e != "symbol" ? e + "" : e, t), t);
import { defineComponent as Dt, computed as Ht, openBlock as Oe, createElementBlock as je, normalizeClass as Ct, createElementVNode as ve, renderSlot as pn, toDisplayString as lt, createCommentVNode as mt, createTextVNode as an, ref as st, resolveComponent as Nt, createVNode as dt, normalizeStyle as mr, createBlock as Wt, withModifiers as As, onMounted as ln, onUpdated as _f, watch as un, nextTick as lr, Fragment as dn, renderList as Un, withDirectives as ha, vModelCheckbox as Ef, onBeforeMount as yf, withCtx as Ft, unref as Ye, onBeforeUnmount as oi, onUnmounted as po, Teleport as Tf, vModelText as Tc, reactive as Ul, onBeforeUpdate as FE, Transition as Ac, resolveDynamicComponent as Af, h as na, getCurrentInstance as UE, watchEffect as kE, shallowRef as KE, markRaw as Am, customRef as jE, withKeys as pa, useSlots as Sm, provide as Ti, inject as Ai, vModelRadio as WE, createSlots as Cm, createApp as VE } from "vue";
import { useRouter as kn, useRoute as $r, createRouter as HE, createWebHistory as $E } from "vue-router";
import GE from "primevue/dialog";
import zE from "primevue/progressspinner";
import { defineStore as Ss, createPinia as YE } from "pinia";
import XE from "axios";
import QE from "primevue/overlaypanel";
import JE from "primevue/calendar";
import ZE from "primevue/image";
import Ro from "primevue/skeleton";
import { useToast as Sf } from "primevue/usetoast";
import { useConfirm as Mm } from "primevue/useconfirm";
import qE from "primevue/toast";
import ey from "primevue/confirmdialog";
import ty from "primevue/config";
import ny from "primevue/confirmationservice";
import ry from "primevue/toastservice";
var ja = /* @__PURE__ */ ((n) => (n.none = "", n.info = "info", n.success = "success", n.warning = "warning", n.danger = "danger", n))(ja || {}), fi = /* @__PURE__ */ ((n) => (n.oneOne = "oneOne", n.twoOne = "twoOne", n.oneTwo = "oneTwo", n))(fi || {}), Lo = /* @__PURE__ */ ((n) => (n[n.text = 0] = "text", n[n.email = 1] = "email", n))(Lo || {}), wo = /* @__PURE__ */ ((n) => (n.xl = "xl", n.lg = "lg", n.sm = "sm", n))(wo || {});
const iy = /* @__PURE__ */ Dt({
  __name: "K2ColContainer",
  props: {
    rowClass: { default: "" },
    col1Class: { default: "" },
    col2Class: { default: "" },
    ratio: { default: fi.oneOne }
  },
  setup(n) {
    const e = n, t = Ht(
      () => {
        let o = "col-lg-6";
        switch (e.ratio) {
          case fi.oneOne:
            o = "col-lg-6";
            break;
          case fi.twoOne:
            o = "col-lg-9";
            break;
          case fi.oneTwo:
            o = "col-lg-3";
            break;
        }
        return o;
      }
    ), r = Ht(
      () => {
        let o = "col-lg-6";
        switch (e.ratio) {
          case fi.oneOne:
            o = "col-lg-6";
            break;
          case fi.twoOne:
            o = "col-lg-3";
            break;
          case fi.oneTwo:
            o = "col-lg-9";
            break;
        }
        return o;
      }
    );
    return (o, u) => (Oe(), je("div", {
      class: Ct(["row", o.rowClass])
    }, [
      ve("div", {
        class: Ct(["col-12 col-md-12", [t.value, o.col1Class]]),
        style: { overflow: "auto" }
      }, [
        pn(o.$slots, "col1")
      ], 2),
      ve("div", {
        class: Ct(["col-12 col-md-12", [r.value, o.col2Class]]),
        style: { overflow: "auto" }
      }, [
        pn(o.$slots, "col2")
      ], 2)
    ], 2));
  }
}), ay = /* @__PURE__ */ Dt({
  __name: "K3ColContainer",
  props: {
    rowClass: { default: "" },
    col1Class: { default: "" },
    col2Class: { default: "" },
    col3Class: { default: "" }
  },
  setup(n) {
    return (e, t) => (Oe(), je("div", {
      class: Ct(["row", e.rowClass])
    }, [
      ve("div", {
        class: Ct(["col-12 col-md-12 col-lg-4", e.col1Class])
      }, [
        pn(e.$slots, "col1")
      ], 2),
      ve("div", {
        class: Ct(["col-12 col-md-12 col-lg-4", e.col2Class])
      }, [
        pn(e.$slots, "col2")
      ], 2),
      ve("div", {
        class: Ct(["col-12 col-md-12 col-lg-4", e.col3Class])
      }, [
        pn(e.$slots, "col3")
      ], 2)
    ], 2));
  }
}), oy = { class: "d-flex flex-column flex-md-row justify-content-between align-items-center" }, sy = {
  key: 0,
  class: "pr-2 k-alert-badge"
}, ly = {
  key: 1,
  class: "mr-2 fw-bold"
}, uy = { style: { display: "flex" } }, Cf = /* @__PURE__ */ Dt({
  __name: "KAlert",
  props: {
    badge: { default: "" },
    title: { default: "" },
    body: { default: "" },
    primaryButton: { default: null },
    secondaryButton: { default: null },
    singleRowText: { type: Boolean, default: !1 },
    level: { default: ja.none }
  },
  setup(n) {
    const e = n, t = Ht(() => {
      const u = [];
      return e.level == ja.none && u.push("alert-icon"), e.level != ja.none ? u.push(`alert-${e.level.toString()}`) : u.push("alert-default"), u;
    }), r = Ht(() => e.primaryButton && e.primaryButton.length > 0), o = Ht(() => e.secondaryButton && e.secondaryButton.length > 0);
    return (u, c) => (Oe(), je("div", {
      class: Ct(["alert k-alert", t.value]),
      role: "alert"
    }, [
      ve("div", oy, [
        ve("div", {
          class: Ct(["", { "k-alert-single-row-text": e.singleRowText }])
        }, [
          e.badge && e.badge.length > 0 ? (Oe(), je("label", sy, lt(e.badge), 1)) : mt("", !0),
          e.title ? (Oe(), je("b", ly, lt(e.title), 1)) : mt("", !0),
          an(" " + lt(e.body), 1)
        ], 2),
        ve("div", uy, [
          o.value ? (Oe(), je("button", {
            key: 0,
            style: { "margin-left": "10px" },
            type: "button",
            class: "btn btn-outline-primary btn-xs px-5",
            onClick: c[0] || (c[0] = (l) => u.$emit("on-secondary-button-click"))
          }, [
            pn(u.$slots, "secondary-button-content", {}, () => [
              an(lt(u.secondaryButton), 1)
            ])
          ])) : mt("", !0),
          r.value ? (Oe(), je("button", {
            key: 1,
            style: { "margin-left": "10px" },
            type: "button",
            class: "btn btn-primary btn-xs px-5",
            onClick: c[1] || (c[1] = (l) => u.$emit("on-primary-button-click"))
          }, [
            pn(u.$slots, "primary-button-content", {}, () => [
              an(lt(u.primaryButton), 1)
            ])
          ])) : mt("", !0)
        ])
      ])
    ], 2));
  }
});
const cy = /* @__PURE__ */ Dt({
  __name: "KBackButton",
  setup(n) {
    const e = st(null);
    kn();
    const t = () => {
      history.back();
    };
    return (r, o) => {
      const u = Nt("KIcon");
      return Oe(), je("a", {
        href: "#",
        ref_key: "kBackButton",
        ref: e,
        onClick: t,
        class: "go-back"
      }, [
        dt(u, {
          class: "icon-sm icon-primary me-2",
          icon: "it-arrow-left"
        }),
        an(" Torna indietro")
      ], 512);
    };
  }
}), fy = {
  key: 0,
  class: "flag-icon",
  style: { "margin-left": "24px" }
}, dy = {
  key: 1,
  class: "etichetta"
}, hy = { class: "text" }, py = { class: "visually-hidden" }, my = { class: "text" }, gy = {
  key: 3,
  class: "it-card-footer"
}, vy = ["title"], _y = { class: "text text-uppercase" }, Ey = { class: "visually-hidden" }, yy = ["title", "href"], Ty = { class: "text text-uppercase" }, Ay = { class: "visually-hidden" }, Sy = ["title"], Cy = { class: "visually-hidden" }, bm = /* @__PURE__ */ Dt({
  __name: "KCard",
  props: {
    class: { default: "" },
    style: { default: "" },
    flat: { type: Boolean, default: !1 },
    shadow: { type: Boolean, default: !0 },
    title: { default: "" },
    titleClass: { default: "" },
    titleStyle: { default: "" },
    text: { default: "" },
    textClass: { default: "" },
    textStyle: { default: "" },
    topTitle: { default: "" },
    topTitleIcon: { default: "" },
    topTitleLinkButton: { default: null },
    topTitleClass: { default: null },
    showDetailButton: { type: Boolean, default: !1 },
    labelDetailButton: { default: "" },
    detailButtonLinkUrl: { default: null },
    labelCmdButton: { default: "" },
    showCmdButton: { type: Boolean, default: !1 },
    showFlagIcon: { type: Boolean, default: !1 },
    showBottomBorder: { type: Boolean, default: !1 },
    tagIcon: { default: "" },
    tagTitle: { default: "" }
  },
  emits: ["cmd-button-click", "top-title-link-click", "detail-button-click"],
  setup(n, { emit: e }) {
    const t = n, r = Ht(() => {
      const d = [];
      d.push("card"), t.flat !== !0 && (d.push("card-bg"), d.push("rounded"), t.shadow === !1 && d.push("k-card-mini-shadow")), t.showBottomBorder && d.push("border-bottom-card");
      let v = d.join(" ");
      return t.class && (v += " " + t.class), v;
    }), o = e, u = () => {
      o("detail-button-click");
    }, c = () => {
      o("top-title-link-click");
    }, l = () => {
      o("cmd-button-click");
    }, i = Ht(() => !!(t.tagTitle || t.tagIcon)), h = Ht(() => !!(t.topTitle || t.topTitleIcon || t.topTitleLinkButton)), f = Ht(() => !!(t.showCmdButton || t.showDetailButton)), p = Ht(() => {
      let d = "";
      return t.topTitleIcon ? d = "categoryicon-top" : d = "category-top", t.topTitleClass && (d += " " + t.topTitleClass), d;
    });
    return (d, v) => {
      const g = Nt("KIcon");
      return Oe(), je("div", {
        class: Ct(["card-wrapper", { "card-space": !d.flat }]),
        style: { height: "fit-content" }
      }, [
        ve("div", {
          class: Ct(r.value),
          style: mr(d.style)
        }, [
          d.showFlagIcon ? (Oe(), je("div", fy)) : mt("", !0),
          i.value ? (Oe(), je("div", dy, [
            dt(g, { icon: d.tagIcon }, null, 8, ["icon"]),
            ve("span", null, lt(d.tagTitle), 1)
          ])) : mt("", !0),
          ve("div", {
            class: Ct(["card-body", { "pt-0": d.showFlagIcon }])
          }, [
            h.value ? (Oe(), je("div", {
              key: 0,
              class: Ct(p.value)
            }, [
              d.topTitleIcon ? (Oe(), Wt(g, {
                key: 0,
                class: "icon-primary icon-xs",
                icon: d.topTitleIcon
              }, null, 8, ["icon"])) : mt("", !0),
              t.topTitleLinkButton ? (Oe(), je("a", {
                key: 1,
                class: "category",
                href: "#",
                role: "button",
                onClick: As(c, ["prevent"])
              }, [
                ve("span", hy, lt(t.topTitleLinkButton), 1),
                ve("span", py, lt(t.topTitleLinkButton), 1)
              ])) : mt("", !0),
              an(" " + lt(t.topTitleLinkButton ? " " : "") + " ", 1),
              ve("span", my, lt(t.topTitle), 1)
            ], 2)) : mt("", !0),
            t.title ? (Oe(), je("span", {
              key: 1,
              class: Ct(["card-title h5 text-truncate text-truncate-multiline", d.titleClass]),
              style: mr(d.titleStyle)
            }, lt(t.title), 7)) : mt("", !0),
            t.text ? (Oe(), je("p", {
              key: 2,
              class: Ct(["text-truncate text-truncate-multiline", d.textClass]),
              style: mr(d.textStyle)
            }, lt(t.text), 7)) : mt("", !0),
            pn(d.$slots, "custom-content"),
            f.value ? (Oe(), je("div", gy, [
              ve("span", null, [
                d.showDetailButton && d.detailButtonLinkUrl == null ? (Oe(), je("a", {
                  key: 0,
                  role: "button",
                  class: "read-more",
                  title: d.labelDetailButton,
                  onClick: u
                }, [
                  ve("span", _y, [
                    an(lt(d.labelDetailButton), 1),
                    ve("span", Ey, lt(t.title), 1)
                  ]),
                  dt(g, {
                    class: "icon-primary icon-xs",
                    icon: "it-arrow-right"
                  })
                ], 8, vy)) : d.showDetailButton && d.detailButtonLinkUrl != null ? (Oe(), je("a", {
                  key: 1,
                  role: "button",
                  class: "read-more",
                  title: d.labelDetailButton,
                  target: "_blank",
                  href: d.detailButtonLinkUrl
                }, [
                  ve("span", Ty, [
                    an(lt(d.labelDetailButton), 1),
                    ve("span", Ay, lt(t.title), 1)
                  ]),
                  dt(g, {
                    class: "icon-primary icon-xs",
                    icon: "it-arrow-right"
                  })
                ], 8, yy)) : mt("", !0)
              ]),
              ve("span", null, [
                d.showCmdButton ? (Oe(), je("a", {
                  key: 0,
                  role: "button",
                  class: "btn btn-primary btn-sm text-uppercase float-end",
                  title: d.labelCmdButton,
                  onClick: l
                }, [
                  an(lt(d.labelCmdButton) + " ", 1),
                  ve("span", Cy, lt(d.labelCmdButton), 1)
                ], 8, Sy)) : mt("", !0)
              ])
            ])) : mt("", !0)
          ], 2)
        ], 6)
      ], 2);
    };
  }
});
/*!
 * Splide.js
 * Version  : 3.6.12
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */
const Vn = "splide", Mf = `data-${Vn}`, Pa = 1, My = 2, ll = 3, ul = 4, cl = 5, by = {
  CREATED: Pa,
  MOUNTED: My,
  IDLE: ll,
  MOVING: ul,
  DESTROYED: cl
}, bf = 10, Ry = 20;
function mo(n) {
  n.length = 0;
}
function qo(n) {
  return !Df(n) && typeof n == "object";
}
function Rm(n) {
  return Array.isArray(n);
}
function Dy(n) {
  return typeof n == "function";
}
function Pi(n) {
  return typeof n == "string";
}
function Rf(n) {
  return typeof n > "u";
}
function Df(n) {
  return n === null;
}
function Of(n) {
  return n instanceof HTMLElement;
}
function Cs(n) {
  return Rm(n) ? n : [n];
}
function wi(n, e) {
  Cs(n).forEach(e);
}
function kl(n, e) {
  return n.indexOf(e) > -1;
}
function Ko(n, e) {
  return n.push(...Cs(e)), n;
}
const Oy = Array.prototype;
function go(n, e, t) {
  return Oy.slice.call(n, e, t);
}
function Py(n, e) {
  return go(n).filter(e)[0];
}
function Fa(n, e, t) {
  n && wi(e, (r) => {
    r && n.classList[t ? "add" : "remove"](r);
  });
}
function Ii(n, e) {
  Fa(n, Pi(e) ? e.split(" ") : e, !0);
}
function Kl(n, e) {
  wi(e, n.appendChild.bind(n));
}
function Pf(n, e) {
  wi(n, (t) => {
    const r = e.parentNode;
    r && r.insertBefore(t, e);
  });
}
function If(n, e) {
  return Of(n) && (n.msMatchesSelector || n.matches).call(n, e);
}
function Dm(n, e) {
  return n ? go(n.children).filter((t) => If(t, e)) : [];
}
function ti(n, e) {
  return e ? Dm(n, e)[0] : n.firstElementChild;
}
function ra(n, e, t) {
  if (n) {
    let r = Object.keys(n);
    r = t ? r.reverse() : r;
    for (let o = 0; o < r.length; o++) {
      const u = r[o];
      if (u !== "__proto__" && e(n[u], u) === !1)
        break;
    }
  }
  return n;
}
function Sc(n) {
  return go(arguments, 1).forEach((e) => {
    ra(e, (t, r) => {
      n[r] = e[r];
    });
  }), n;
}
function Zi(n, e) {
  return ra(e, (t, r) => {
    Rm(t) ? n[r] = t.slice() : qo(t) ? n[r] = Zi(qo(n[r]) ? n[r] : {}, t) : n[r] = t;
  }), n;
}
function Kr(n, e) {
  n && wi(e, (t) => {
    n.removeAttribute(t);
  });
}
function vn(n, e, t) {
  qo(e) ? ra(e, (r, o) => {
    vn(n, o, r);
  }) : Df(t) ? Kr(n, e) : n.setAttribute(e, String(t));
}
function Wa(n, e, t) {
  const r = document.createElement(n);
  return e && (Pi(e) ? Ii(r, e) : vn(r, e)), t && Kl(t, r), r;
}
function dr(n, e, t) {
  if (Rf(t))
    return getComputedStyle(n)[e];
  if (!Df(t)) {
    const { style: r } = n;
    t = `${t}`, r[e] !== t && (r[e] = t);
  }
}
function fl(n, e) {
  dr(n, "display", e);
}
function Iy(n) {
  n.setActive && n.setActive() || n.focus({ preventScroll: !0 });
}
function es(n, e) {
  return n.getAttribute(e);
}
function Ud(n, e) {
  return n && n.classList.contains(e);
}
function ir(n) {
  return n.getBoundingClientRect();
}
function vo(n) {
  wi(n, (e) => {
    e && e.parentNode && e.parentNode.removeChild(e);
  });
}
function Ny(n, e) {
  if (Pi(e)) {
    const t = Wa("div", { style: `width: ${e}; position: absolute;` }, n);
    e = ir(t).width, vo(t);
  }
  return e;
}
function Om(n) {
  return ti(new DOMParser().parseFromString(n, "text/html").body);
}
function pi(n, e) {
  n.preventDefault(), e && (n.stopPropagation(), n.stopImmediatePropagation());
}
function Gi(n, e) {
  return n && n.querySelector(e);
}
function Nf(n, e) {
  return go(n.querySelectorAll(e));
}
function ts(n, e) {
  Fa(n, e, !1);
}
function di(n) {
  return Pi(n) ? n : n ? `${n}px` : "";
}
function ns(n, e = "") {
  if (!n)
    throw new Error(`[${Vn}] ${e}`);
}
function Cc(n) {
  setTimeout(n);
}
const Mc = () => {
};
function kd(n) {
  return requestAnimationFrame(n);
}
const { min: rs, max: is, floor: bc, ceil: as, abs: hr } = Math;
function Ly(n, e, t) {
  return hr(n - e) < t;
}
function jo(n, e, t, r) {
  const o = rs(e, t), u = is(e, t);
  return r ? o < n && n < u : o <= n && n <= u;
}
function xo(n, e, t) {
  const r = rs(e, t), o = is(e, t);
  return rs(is(r, n), o);
}
function Kd(n) {
  return +(n > 0) - +(n < 0);
}
function Pm(n, e) {
  return wi(e, (t) => {
    n = n.replace("%s", `${t}`);
  }), n;
}
function Lf(n) {
  return n < 10 ? `0${n}` : `${n}`;
}
const jd = {};
function wy(n) {
  return `${n}${Lf(jd[n] = (jd[n] || 0) + 1)}`;
}
function xy() {
  let n = {};
  function e(l, i, h, f = bf) {
    c(l, (p, d) => {
      n[p] = n[p] || [], Ko(n[p], {
        _event: p,
        _callback: i,
        _namespace: d,
        _priority: f,
        _key: h
      }).sort((v, g) => v._priority - g._priority);
    });
  }
  function t(l, i) {
    c(l, (h, f) => {
      const p = n[h];
      n[h] = p && p.filter((d) => d._key ? d._key !== i : i || d._namespace !== f);
    });
  }
  function r(l) {
    ra(n, (i, h) => {
      t(h, l);
    });
  }
  function o(l) {
    (n[l] || []).forEach((i) => {
      i._callback.apply(i, go(arguments, 1));
    });
  }
  function u() {
    n = {};
  }
  function c(l, i) {
    Cs(l).join(" ").split(" ").forEach((h) => {
      const f = h.split(".");
      i(f[0], f[1]);
    });
  }
  return {
    on: e,
    off: t,
    offBy: r,
    emit: o,
    destroy: u
  };
}
const si = "mounted", Wd = "ready", Ni = "move", ss = "moved", Im = "shifted", Nm = "click", By = "active", Fy = "inactive", Uy = "visible", ky = "hidden", Lm = "slide:keydown", Tn = "refresh", er = "updated", Qa = "resize", wm = "resized", xm = "repositioned", Ky = "drag", jy = "dragging", Wy = "dragged", Bm = "scroll", Ms = "scrolled", Fm = "destroy", Vy = "arrows:mounted", Hy = "arrows:updated", $y = "pagination:mounted", Gy = "pagination:updated", Um = "navigation:mounted", zy = "autoplay:play", Yy = "autoplay:playing", Xy = "autoplay:pause", km = "lazyload:loaded";
function Cn(n) {
  const { event: e } = n, t = {};
  let r = [];
  function o(f, p, d) {
    e.on(f, p, t, d);
  }
  function u(f) {
    e.off(f, t);
  }
  function c(f, p, d, v) {
    i(f, p, (g, m) => {
      r.push([g, m, d, v]), g.addEventListener(m, d, v);
    });
  }
  function l(f, p, d) {
    i(f, p, (v, g) => {
      r = r.filter((m) => m[0] === v && m[1] === g && (!d || m[2] === d) ? (v.removeEventListener(g, m[2], m[3]), !1) : !0);
    });
  }
  function i(f, p, d) {
    wi(f, (v) => {
      v && p.split(" ").forEach(d.bind(null, v));
    });
  }
  function h() {
    r = r.filter((f) => l(f[0], f[1])), e.offBy(t);
  }
  return e.on(Fm, h, t), {
    on: o,
    off: u,
    emit: e.emit,
    bind: c,
    unbind: l,
    destroy: h
  };
}
function wf(n, e, t, r) {
  const { now: o } = Date;
  let u, c = 0, l, i = !0, h = 0;
  function f() {
    if (!i) {
      const b = o() - u;
      if (b >= n ? (c = 1, u = o()) : c = b / n, t && t(c), c === 1 && (e(), r && ++h >= r))
        return d();
      kd(f);
    }
  }
  function p(b) {
    !b && g(), u = o() - (b ? c * n : 0), i = !1, kd(f);
  }
  function d() {
    i = !0;
  }
  function v() {
    u = o(), c = 0, t && t(c);
  }
  function g() {
    cancelAnimationFrame(l), c = 0, l = 0, i = !0;
  }
  function m(b) {
    n = b;
  }
  function A() {
    return i;
  }
  return {
    start: p,
    rewind: v,
    pause: d,
    cancel: g,
    set: m,
    isPaused: A
  };
}
function Qy(n) {
  let e = n;
  function t(o) {
    e = o;
  }
  function r(o) {
    return kl(Cs(o), e);
  }
  return { set: t, is: r };
}
function Km(n, e) {
  let t;
  function r() {
    t || (t = wf(e || 0, () => {
      n.apply(this, arguments), t = null;
    }, null, 1), t.start());
  }
  return r;
}
function Jy(n, e, t) {
  const r = Km(f);
  let o, u, c;
  function l() {
    try {
      Zi(t, JSON.parse(es(n.root, Mf)));
    } catch (v) {
      ns(!1, v.message);
    }
    o = Zi({}, t);
    const { breakpoints: d } = t;
    if (d) {
      const v = t.mediaQuery === "min";
      u = Object.keys(d).sort((g, m) => v ? +m - +g : +g - +m).map((g) => [
        g,
        matchMedia(`(${v ? "min" : "max"}-width:${g}px)`)
      ]), f();
    }
  }
  function i() {
    u && addEventListener("resize", r);
  }
  function h(d) {
    d && removeEventListener("resize", r);
  }
  function f() {
    const d = Py(u, (v) => v[1].matches) || [];
    d[0] !== c && p(c = d[0]);
  }
  function p(d) {
    const v = t.breakpoints[d] || o;
    v.destroy ? (n.options = o, n.destroy(v.destroy === "completely")) : (n.state.is(cl) && (h(!0), n.mount()), n.options = v);
  }
  return {
    setup: l,
    mount: i,
    destroy: h
  };
}
const Vd = "rtl", xf = "ttb", Zy = {
  marginRight: ["marginBottom", "marginLeft"],
  autoWidth: ["autoHeight"],
  fixedWidth: ["fixedHeight"],
  paddingLeft: ["paddingTop", "paddingRight"],
  paddingRight: ["paddingBottom", "paddingLeft"],
  width: ["height"],
  left: ["top", "right"],
  right: ["bottom", "left"],
  x: ["y"],
  X: ["Y"],
  Y: ["X"],
  ArrowLeft: ["ArrowUp", "ArrowRight"],
  ArrowRight: ["ArrowDown", "ArrowLeft"]
};
function qy(n, e, t) {
  function r(u, c) {
    const { direction: l } = t, i = l === Vd && !c ? 1 : l === xf ? 0 : -1;
    return Zy[u][i] || u;
  }
  function o(u) {
    return u * (t.direction === Vd ? 1 : -1);
  }
  return {
    resolve: r,
    orient: o
  };
}
const js = Vn, eT = `${Vn}__slider`, tT = `${Vn}__track`, nT = `${Vn}__list`, jl = `${Vn}__slide`, jm = `${jl}--clone`, rT = `${jl}__container`, Wm = `${Vn}__arrows`, Bf = `${Vn}__arrow`, Vm = `${Bf}--prev`, Hm = `${Bf}--next`, $m = `${Vn}__pagination`, iT = `${$m}__page`, Gm = `${Vn}__progress`, aT = `${Gm}__bar`, oT = `${Vn}__autoplay`, sT = `${Vn}__play`, lT = `${Vn}__pause`, uT = `${Vn}__spinner`, cT = "is-initialized", Ja = "is-active", zm = "is-prev", Ym = "is-next", Rc = "is-visible", Dc = "is-loading", fT = [Ja, Rc, zm, Ym, Dc], dT = {
  slide: jl,
  clone: jm,
  arrows: Wm,
  arrow: Bf,
  prev: Vm,
  next: Hm,
  pagination: $m,
  page: iT,
  spinner: uT
};
function hT(n, e, t) {
  const { on: r } = Cn(n), { root: o } = n, u = {}, c = [];
  let l, i, h, f;
  function p() {
    A(), b(), Ii(o, l = N());
  }
  function d() {
    r(Tn, g, bf - 2), r(er, m);
  }
  function v() {
    [o, h, f].forEach((T) => {
      Kr(T, "style");
    }), mo(c), ts(o, l);
  }
  function g() {
    v(), p();
  }
  function m() {
    ts(o, l), Ii(o, l = N());
  }
  function A() {
    i = ti(o, `.${eT}`), h = Gi(o, `.${tT}`), f = ti(h, `.${nT}`), ns(h && f, "A track/list element is missing."), Ko(c, Dm(f, `.${jl}:not(.${jm})`));
    const T = S(`.${oT}`), R = S(`.${Wm}`);
    Sc(u, {
      root: o,
      slider: i,
      track: h,
      list: f,
      slides: c,
      arrows: R,
      autoplay: T,
      prev: Gi(R, `.${Vm}`),
      next: Gi(R, `.${Hm}`),
      bar: Gi(S(`.${Gm}`), `.${aT}`),
      play: Gi(T, `.${sT}`),
      pause: Gi(T, `.${lT}`)
    });
  }
  function b() {
    const T = o.id || wy(Vn);
    o.id = T, h.id = h.id || `${T}-track`, f.id = f.id || `${T}-list`;
  }
  function S(T) {
    return ti(o, T) || ti(i, T);
  }
  function N() {
    return [
      `${js}--${t.type}`,
      `${js}--${t.direction}`,
      t.drag && `${js}--draggable`,
      t.isNavigation && `${js}--nav`,
      Ja
    ];
  }
  return Sc(u, {
    setup: p,
    mount: d,
    destroy: v
  });
}
const Wl = "role", Za = "aria-controls", dl = "aria-current", qa = "aria-label", Xm = "aria-hidden", ls = "tabindex", pT = "disabled", Qm = "aria-orientation", hl = [
  Wl,
  Za,
  dl,
  qa,
  Xm,
  Qm,
  ls,
  pT
], bs = "slide", _o = "loop", Vl = "fade";
function mT(n, e, t, r) {
  const { on: o, emit: u, bind: c, destroy: l } = Cn(n), { Components: i, root: h, options: f } = n, { isNavigation: p, updateOnMove: d } = f, { resolve: v } = i.Direction, g = es(r, "style"), m = t > -1, A = ti(r, `.${rT}`), b = f.focusableNodes && Nf(r, f.focusableNodes);
  let S;
  function N() {
    m || (r.id = `${h.id}-slide${Lf(e + 1)}`), c(r, "click keydown", (w) => {
      u(w.type === "click" ? Nm : Lm, I, w);
    }), o([Tn, xm, Im, ss, Ms], E), o(Um, R), d && o(Ni, y);
  }
  function T() {
    S = !0, l(), ts(r, fT), Kr(r, hl), vn(r, "style", g);
  }
  function R() {
    const w = m ? t : e, F = Pm(f.i18n.slideX, w + 1), k = n.splides.map((H) => H.splide.root.id).join(" ");
    vn(r, qa, F), vn(r, Za, k), vn(r, Wl, "menuitem"), L(D());
  }
  function y() {
    S || E();
  }
  function E() {
    if (!S) {
      const { index: w } = n;
      L(D()), _(M()), Fa(r, zm, e === w - 1), Fa(r, Ym, e === w + 1);
    }
  }
  function L(w) {
    w !== Ud(r, Ja) && (Fa(r, Ja, w), p && vn(r, dl, w || null), u(w ? By : Fy, I));
  }
  function _(w) {
    const F = !w && (!D() || m);
    vn(r, Xm, F || null), vn(r, ls, !F && f.slideFocus ? 0 : null), b && b.forEach((k) => {
      vn(k, ls, F ? -1 : null);
    }), w !== Ud(r, Rc) && (Fa(r, Rc, w), u(w ? Uy : ky, I));
  }
  function O(w, F, k) {
    dr(k && A || r, w, F);
  }
  function D() {
    const { index: w } = n;
    return w === e || f.cloneStatus && w === t;
  }
  function M() {
    if (n.is(Vl))
      return D();
    const w = ir(i.Elements.track), F = ir(r), k = v("left"), H = v("right");
    return bc(w[k]) <= as(F[k]) && bc(F[H]) <= as(w[H]);
  }
  function C(w, F) {
    let k = hr(w - e);
    return !m && (f.rewind || n.is(_o)) && (k = rs(k, n.length - k)), k <= F;
  }
  const I = {
    index: e,
    slideIndex: t,
    slide: r,
    container: A,
    isClone: m,
    mount: N,
    destroy: T,
    update: E,
    style: O,
    isWithin: C
  };
  return I;
}
function gT(n, e, t) {
  const { on: r, emit: o, bind: u } = Cn(n), { slides: c, list: l } = e.Elements, i = [];
  function h() {
    f(), r(Tn, d), r([si, Tn], () => {
      i.sort((O, D) => O.index - D.index);
    });
  }
  function f() {
    c.forEach((O, D) => {
      g(O, D, -1);
    });
  }
  function p() {
    T((O) => {
      O.destroy();
    }), mo(i);
  }
  function d() {
    p(), f();
  }
  function v() {
    T((O) => {
      O.update();
    });
  }
  function g(O, D, M) {
    const C = mT(n, D, M, O);
    C.mount(), i.push(C);
  }
  function m(O) {
    return O ? R((D) => !D.isClone) : i;
  }
  function A(O) {
    const { Controller: D } = e, M = D.toIndex(O), C = D.hasFocus() ? 1 : t.perPage;
    return R((I) => jo(I.index, M, M + C - 1));
  }
  function b(O) {
    return R(O)[0];
  }
  function S(O, D) {
    wi(O, (M) => {
      if (Pi(M) && (M = Om(M)), Of(M)) {
        const C = c[D];
        C ? Pf(M, C) : Kl(l, M), Ii(M, t.classes.slide), E(M, o.bind(null, Qa));
      }
    }), o(Tn);
  }
  function N(O) {
    vo(R(O).map((D) => D.slide)), o(Tn);
  }
  function T(O, D) {
    m(D).forEach(O);
  }
  function R(O) {
    return i.filter(Dy(O) ? O : (D) => Pi(O) ? If(D.slide, O) : kl(Cs(O), D.index));
  }
  function y(O, D, M) {
    T((C) => {
      C.style(O, D, M);
    });
  }
  function E(O, D) {
    const M = Nf(O, "img");
    let { length: C } = M;
    C ? M.forEach((I) => {
      u(I, "load error", () => {
        --C || D();
      });
    }) : D();
  }
  function L(O) {
    return O ? c.length : i.length;
  }
  function _() {
    return i.length > t.perPage;
  }
  return {
    mount: h,
    destroy: p,
    update: v,
    register: g,
    get: m,
    getIn: A,
    getAt: b,
    add: S,
    remove: N,
    forEach: T,
    filter: R,
    style: y,
    getLength: L,
    isEnough: _
  };
}
function vT(n, e, t) {
  const { on: r, bind: o, emit: u } = Cn(n), { Slides: c } = e, { resolve: l } = e.Direction, { root: i, track: h, list: f } = e.Elements, { getAt: p } = c;
  let d, v;
  function g() {
    m(), o(window, "resize load", Km(u.bind(this, Qa))), r([er, Tn], m), r(Qa, A);
  }
  function m() {
    v = null, d = t.direction === xf, dr(i, "maxWidth", di(t.width)), dr(h, l("paddingLeft"), S(!1)), dr(h, l("paddingRight"), S(!0)), A();
  }
  function A() {
    const I = ir(i);
    (!v || v.width !== I.width || v.height !== I.height) && (dr(h, "height", N()), c.style(l("marginRight"), di(t.gap)), c.style("width", R() || null), b(), v = I, u(wm));
  }
  function b() {
    c.style("height", y() || null, !0);
  }
  function S(I) {
    const { padding: w } = t, F = l(I ? "right" : "left");
    return w && di(w[F] || (qo(w) ? 0 : w)) || "0px";
  }
  function N() {
    let I = "";
    return d && (I = T(), ns(I, "height or heightRatio is missing."), I = `calc(${I} - ${S(!1)} - ${S(!0)})`), I;
  }
  function T() {
    return di(t.height || ir(f).width * t.heightRatio);
  }
  function R() {
    return t.autoWidth ? "" : di(t.fixedWidth) || (d ? "" : E());
  }
  function y() {
    return di(t.fixedHeight) || (d ? t.autoHeight ? "" : E() : T());
  }
  function E() {
    const I = di(t.gap);
    return `calc((100%${I && ` + ${I}`})/${t.perPage || 1}${I && ` - ${I}`})`;
  }
  function L() {
    return ir(f)[l("width")];
  }
  function _(I, w) {
    const F = p(I || 0);
    return F ? ir(F.slide)[l("width")] + (w ? 0 : M()) : 0;
  }
  function O(I, w) {
    const F = p(I);
    if (F) {
      const k = ir(F.slide)[l("right")], H = ir(f)[l("left")];
      return hr(k - H) + (w ? 0 : M());
    }
    return 0;
  }
  function D() {
    return O(n.length - 1, !0) - O(-1, !0);
  }
  function M() {
    const I = p(0);
    return I && parseFloat(dr(I.slide, l("marginRight"))) || 0;
  }
  function C(I) {
    return parseFloat(dr(h, l(`padding${I ? "Right" : "Left"}`))) || 0;
  }
  return {
    mount: g,
    listSize: L,
    slideSize: _,
    sliderSize: D,
    totalSize: O,
    getPadding: C
  };
}
function _T(n, e, t) {
  const { on: r, emit: o } = Cn(n), { Elements: u, Slides: c } = e, { resolve: l } = e.Direction, i = [];
  let h;
  function f() {
    p(), r(Tn, v), r([er, Qa], g);
  }
  function p() {
    (h = b()) && (m(h), o(Qa));
  }
  function d() {
    vo(i), mo(i);
  }
  function v() {
    d(), p();
  }
  function g() {
    h < b() && o(Tn);
  }
  function m(S) {
    const N = c.get().slice(), { length: T } = N;
    if (T) {
      for (; N.length < S; )
        Ko(N, N);
      Ko(N.slice(-S), N.slice(0, S)).forEach((R, y) => {
        const E = y < S, L = A(R.slide, y);
        E ? Pf(L, N[0].slide) : Kl(u.list, L), Ko(i, L), c.register(L, y - S + (E ? 0 : T), R.index);
      });
    }
  }
  function A(S, N) {
    const T = S.cloneNode(!0);
    return Ii(T, t.classes.clone), T.id = `${n.root.id}-clone${Lf(N + 1)}`, T;
  }
  function b() {
    let { clones: S } = t;
    if (!n.is(_o))
      S = 0;
    else if (!S) {
      const N = Ny(u.list, t[l("fixedWidth")]);
      S = (N && as(ir(u.track)[l("width")] / N) || t[l("autoWidth")] && n.length || t.perPage) * (t.drag ? (t.flickMaxPages || 1) + 1 : 2);
    }
    return S;
  }
  return {
    mount: f,
    destroy: d
  };
}
function ET(n, e, t) {
  const { on: r, emit: o } = Cn(n), { slideSize: u, getPadding: c, totalSize: l, listSize: i, sliderSize: h } = e.Layout, { resolve: f, orient: p } = e.Direction, { list: d, track: v } = e.Elements;
  let g;
  function m() {
    g = e.Transition, r([si, wm, er, Tn], b);
  }
  function A() {
    Kr(d, "style");
  }
  function b() {
    I() || (e.Scroll.cancel(), N(n.index), o(xm));
  }
  function S(F, k, H, Z) {
    if (!I()) {
      const { set: Y } = n.state, j = O();
      F !== k && (g.cancel(), T(y(j, F > k), !0)), Y(ul), o(Ni, k, H, F), g.start(k, () => {
        Y(ll), o(ss, k, H, F), t.trimSpace === "move" && F !== H && j === O() ? e.Controller.go(F > H ? ">" : "<", !1, Z) : Z && Z();
      });
    }
  }
  function N(F) {
    T(_(F, !0));
  }
  function T(F, k) {
    if (!n.is(Vl)) {
      const H = k ? F : R(F);
      d.style.transform = `translate${f("X")}(${H}px)`, F !== H && o(Im);
    }
  }
  function R(F) {
    if (n.is(_o)) {
      const k = p(F - O()), H = w(!1, F) && k < 0, Z = w(!0, F) && k > 0;
      (H || Z) && (F = y(F, Z));
    }
    return F;
  }
  function y(F, k) {
    const H = F - C(k), Z = h();
    return F -= p(Z * (as(hr(H) / Z) || 1)) * (k ? 1 : -1), F;
  }
  function E() {
    T(O()), g.cancel();
  }
  function L(F) {
    const k = e.Slides.get();
    let H = 0, Z = 1 / 0;
    for (let Y = 0; Y < k.length; Y++) {
      const j = k[Y].index, J = hr(_(j, !0) - F);
      if (J <= Z)
        Z = J, H = j;
      else
        break;
    }
    return H;
  }
  function _(F, k) {
    const H = p(l(F - 1) - M(F));
    return k ? D(H) : H;
  }
  function O() {
    const F = f("left");
    return ir(d)[F] - ir(v)[F] + p(c(!1));
  }
  function D(F) {
    return t.trimSpace && n.is(bs) && (F = xo(F, 0, p(h() - i()))), F;
  }
  function M(F) {
    const { focus: k } = t;
    return k === "center" ? (i() - u(F, !0)) / 2 : +k * u(F) || 0;
  }
  function C(F) {
    return _(F ? e.Controller.getEnd() : 0, !!t.trimSpace);
  }
  function I() {
    return n.state.is(ul) && t.waitForTransition;
  }
  function w(F, k) {
    k = Rf(k) ? O() : k;
    const H = F !== !0 && p(k) < p(C(!1)), Z = F !== !1 && p(k) > p(C(!0));
    return H || Z;
  }
  return {
    mount: m,
    destroy: A,
    move: S,
    jump: N,
    translate: T,
    shift: y,
    cancel: E,
    toIndex: L,
    toPosition: _,
    getPosition: O,
    getLimit: C,
    isBusy: I,
    exceededLimit: w
  };
}
function yT(n, e, t) {
  const { on: r } = Cn(n), { Move: o } = e, { getPosition: u, getLimit: c } = o, { isEnough: l, getLength: i } = e.Slides, h = n.is(_o), f = n.is(bs);
  let p = t.start || 0, d = p, v, g, m;
  function A() {
    b(), r([er, Tn], b, bf - 1);
  }
  function b() {
    v = i(!0), g = t.perMove, m = t.perPage, p = xo(p, 0, v - 1);
  }
  function S(k, H, Z) {
    const Y = T(k);
    if (t.useScroll)
      N(Y, !0, !0, t.speed, Z);
    else {
      const j = O(Y);
      j > -1 && !o.isBusy() && (H || j !== p) && (I(j), o.move(Y, j, d, Z));
    }
  }
  function N(k, H, Z, Y, j) {
    const J = H ? k : C(k);
    e.Scroll.scroll(H || Z ? o.toPosition(J, !0) : k, Y, () => {
      I(o.toIndex(o.getPosition())), j && j();
    });
  }
  function T(k) {
    let H = p;
    if (Pi(k)) {
      const [, Z, Y] = k.match(/([+\-<>])(\d+)?/) || [];
      Z === "+" || Z === "-" ? H = L(p + +`${Z}${+Y || 1}`, p, !0) : Z === ">" ? H = Y ? D(+Y) : R(!0) : Z === "<" && (H = y(!0));
    } else
      H = h ? k : xo(k, 0, _());
    return H;
  }
  function R(k) {
    return E(!1, k);
  }
  function y(k) {
    return E(!0, k);
  }
  function E(k, H) {
    const Z = g || (F() ? 1 : m), Y = L(p + Z * (k ? -1 : 1), p);
    return Y === -1 && f && !Ly(u(), c(!k), 1) ? k ? 0 : _() : H ? Y : O(Y);
  }
  function L(k, H, Z) {
    if (l()) {
      const Y = _();
      k < 0 || k > Y ? jo(0, k, H, !0) || jo(Y, H, k, !0) ? k = D(M(k)) : h ? k = g || F() ? k : k < 0 ? -(v % m || m) : v : t.rewind ? k = k < 0 ? Y : 0 : k = -1 : !Z && k !== H && (k = g ? k : D(M(H) + (k < H ? -1 : 1)));
    } else
      k = -1;
    return k;
  }
  function _() {
    let k = v - m;
    return (F() || h && g) && (k = v - 1), is(k, 0);
  }
  function O(k) {
    return h ? l() ? k % v + (k < 0 ? v : 0) : -1 : k;
  }
  function D(k) {
    return xo(F() ? k : m * k, 0, _());
  }
  function M(k) {
    return F() || (k = jo(k, v - m, v - 1) ? v - 1 : k, k = bc(k / m)), k;
  }
  function C(k) {
    const H = o.toIndex(k);
    return f ? xo(H, 0, _()) : H;
  }
  function I(k) {
    k !== p && (d = p, p = k);
  }
  function w(k) {
    return k ? d : p;
  }
  function F() {
    return !Rf(t.focus) || t.isNavigation;
  }
  return {
    mount: A,
    go: S,
    scroll: N,
    getNext: R,
    getPrev: y,
    getAdjacent: E,
    getEnd: _,
    setIndex: I,
    getIndex: w,
    toIndex: D,
    toPage: M,
    toDest: C,
    hasFocus: F
  };
}
const TT = "http://www.w3.org/2000/svg", AT = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z", Ws = 40;
function ST(n, e, t) {
  const { on: r, bind: o, emit: u } = Cn(n), { classes: c, i18n: l } = t, { Elements: i, Controller: h } = e;
  let f = i.arrows, p = i.prev, d = i.next, v;
  const g = {};
  function m() {
    A(), r(er, A);
  }
  function A() {
    if (t.arrows && (!p || !d) && N(), p && d)
      if (g.prev)
        fl(f, t.arrows === !1 ? "none" : "");
      else {
        const { id: y } = i.track;
        vn(p, Za, y), vn(d, Za, y), g.prev = p, g.next = d, S(), u(Vy, p, d);
      }
  }
  function b() {
    v ? vo(f) : (Kr(p, hl), Kr(d, hl));
  }
  function S() {
    const { go: y } = h;
    r([si, ss, er, Tn, Ms], R), o(d, "click", () => {
      y(">", !0);
    }), o(p, "click", () => {
      y("<", !0);
    });
  }
  function N() {
    f = Wa("div", c.arrows), p = T(!0), d = T(!1), v = !0, Kl(f, [p, d]), Pf(f, ti(t.arrows === "slider" && i.slider || n.root));
  }
  function T(y) {
    const E = `<button class="${c.arrow} ${y ? c.prev : c.next}" type="button"><svg xmlns="${TT}" viewBox="0 0 ${Ws} ${Ws}" width="${Ws}" height="${Ws}"><path d="${t.arrowPath || AT}" />`;
    return Om(E);
  }
  function R() {
    const y = n.index, E = h.getPrev(), L = h.getNext(), _ = E > -1 && y < E ? l.last : l.prev, O = L > -1 && y > L ? l.first : l.next;
    p.disabled = E < 0, d.disabled = L < 0, vn(p, qa, _), vn(d, qa, O), u(Hy, p, d, E, L);
  }
  return {
    arrows: g,
    mount: m,
    destroy: b
  };
}
const CT = `${Mf}-interval`;
function MT(n, e, t) {
  const { on: r, bind: o, emit: u } = Cn(n), c = wf(t.interval, n.go.bind(n, ">"), S), { isPaused: l } = c, { Elements: i } = e;
  let h, f, p;
  function d() {
    const { autoplay: T } = t;
    T && (v(!0), v(!1), g(), T !== "pause" && m());
  }
  function v(T) {
    const R = T ? "pause" : "play", y = i[R];
    y && (vn(y, Za, i.track.id), vn(y, qa, t.i18n[R]), o(y, "click", T ? A : m));
  }
  function g() {
    const { root: T } = i;
    t.pauseOnHover && o(T, "mouseenter mouseleave", (R) => {
      h = R.type === "mouseenter", b();
    }), t.pauseOnFocus && o(T, "focusin focusout", (R) => {
      f = R.type === "focusin", b();
    }), r([Ni, Bm, Tn], c.rewind), r(Ni, N);
  }
  function m() {
    l() && e.Slides.isEnough() && (c.start(!t.resetProgress), f = h = p = !1, u(zy));
  }
  function A(T = !0) {
    l() || (c.pause(), u(Xy)), p = T;
  }
  function b() {
    p || (!h && !f ? m() : A(!1));
  }
  function S(T) {
    const { bar: R } = i;
    R && dr(R, "width", `${T * 100}%`), u(Yy, T);
  }
  function N() {
    const T = e.Slides.getAt(n.index);
    c.set(T && +es(T.slide, CT) || t.interval);
  }
  return {
    mount: d,
    destroy: c.cancel,
    play: m,
    pause: A,
    isPaused: l
  };
}
function bT(n, e, t) {
  const { on: r } = Cn(n);
  function o() {
    t.cover && (r(km, (i, h) => {
      l(!0, i, h);
    }), r([si, er, Tn], c.bind(null, !0)));
  }
  function u() {
    c(!1);
  }
  function c(i) {
    e.Slides.forEach((h) => {
      const f = ti(h.container || h.slide, "img");
      f && f.src && l(i, f, h);
    });
  }
  function l(i, h, f) {
    f.style("background", i ? `center/cover no-repeat url("${h.src}")` : "", !0), fl(h, i ? "none" : "");
  }
  return {
    mount: o,
    destroy: u
  };
}
const RT = 10, DT = 600, OT = 0.6, PT = 1.5, IT = 800;
function NT(n, e, t) {
  const { on: r, emit: o } = Cn(n), { Move: u } = e, { getPosition: c, getLimit: l, exceededLimit: i } = u;
  let h, f;
  function p() {
    r(Ni, A), r([er, Tn], b);
  }
  function d(N, T, R, y) {
    const E = c();
    let L = 1;
    T = T || m(hr(N - E)), f = R, A(), h = wf(T, g, (_) => {
      const O = c(), M = (E + (N - E) * S(_) - c()) * L;
      u.translate(O + M), n.is(bs) && !y && i() && (L *= OT, hr(M) < RT && v(i(!1)));
    }, 1), o(Bm), h.start();
  }
  function v(N) {
    d(l(!N), DT, null, !0);
  }
  function g() {
    const N = c(), T = u.toIndex(N);
    jo(T, 0, n.length - 1) || u.translate(u.shift(N, T > 0), !0), f && f(), o(Ms);
  }
  function m(N) {
    return is(N / PT, IT);
  }
  function A() {
    h && h.cancel();
  }
  function b() {
    h && !h.isPaused() && (A(), g());
  }
  function S(N) {
    const { easingFunc: T } = t;
    return T ? T(N) : 1 - Math.pow(1 - N, 4);
  }
  return {
    mount: p,
    destroy: A,
    scroll: d,
    cancel: b
  };
}
const Ia = { passive: !1, capture: !0 }, LT = 5, Hd = 200, wT = "touchstart mousedown", Eu = "touchmove mousemove", yu = "touchend touchcancel mouseup";
function xT(n, e, t) {
  const { on: r, emit: o, bind: u, unbind: c } = Cn(n), { Move: l, Scroll: i, Controller: h } = e, { track: f } = e.Elements, { resolve: p, orient: d } = e.Direction, { getPosition: v, exceededLimit: g } = l;
  let m, A, b, S, N, T, R = !1, y, E, L;
  function _() {
    u(f, Eu, Mc, Ia), u(f, yu, Mc, Ia), u(f, wT, D, Ia), u(f, "click", w, { capture: !0 }), u(f, "dragstart", pi), r([si, er], O);
  }
  function O() {
    const { drag: $ } = t;
    G(!$), N = $ === "free";
  }
  function D($) {
    if (!E) {
      const { noDrag: ie } = t, re = J($), ce = !ie || !If($.target, ie);
      y = !1, ce && (re || !$.button) && (l.isBusy() ? pi($, !0) : (L = re ? f : window, b = null, S = null, u(L, Eu, M, Ia), u(L, yu, C, Ia), l.cancel(), i.cancel(), I($)));
    }
  }
  function M($) {
    if (S || o(Ky), S = $, $.cancelable) {
      const ie = Z($) - Z(A);
      if (T) {
        l.translate(m + j(ie));
        const re = Y($) - Y(A) > Hd, ce = R !== (R = g());
        (re || ce) && I($), o(jy), y = !0, pi($);
      } else {
        let { dragMinThreshold: re } = t;
        re = qo(re) ? re : { mouse: 0, touch: +re || 10 }, T = hr(ie) > (J($) ? re.touch : re.mouse), F() && pi($);
      }
    }
  }
  function C($) {
    c(L, Eu, M), c(L, yu, C);
    const { index: ie } = n;
    if (S) {
      if (T || $.cancelable && F()) {
        const re = k($), ce = H(re);
        N ? h.scroll(ce) : n.is(Vl) ? h.go(ie + d(Kd(re))) : h.go(h.toDest(ce), !0), pi($);
      }
      o(Wy);
    } else
      !N && v() !== l.toPosition(ie) && h.go(ie, !0);
    T = !1;
  }
  function I($) {
    b = A, A = $, m = v();
  }
  function w($) {
    !E && y && pi($, !0);
  }
  function F() {
    const $ = hr(Z(S) - Z(A)), ie = hr(Z(S, !0) - Z(A, !0));
    return $ > ie;
  }
  function k($) {
    if (n.is(_o) || !R) {
      const ie = A === S && b || A, re = Z(S) - Z(ie), ce = Y($) - Y(ie), z = Y($) - Y(S) < Hd;
      if (ce && z)
        return re / ce;
    }
    return 0;
  }
  function H($) {
    return v() + Kd($) * rs(hr($) * (t.flickPower || 600), N ? 1 / 0 : e.Layout.listSize() * (t.flickMaxPages || 1));
  }
  function Z($, ie) {
    return (J($) ? $.touches[0] : $)[`page${p(ie ? "Y" : "X")}`];
  }
  function Y($) {
    return $.timeStamp;
  }
  function j($) {
    return $ / (R && n.is(bs) ? LT : 1);
  }
  function J($) {
    return typeof TouchEvent < "u" && $ instanceof TouchEvent;
  }
  function ae() {
    return T;
  }
  function G($) {
    E = $;
  }
  return {
    mount: _,
    disable: G,
    isDragging: ae
  };
}
const BT = ["Left", "Right", "Up", "Down"], $d = "keydown";
function FT(n, e, t) {
  const { on: r, bind: o, unbind: u } = Cn(n), { root: c } = n, { resolve: l } = e.Direction;
  let i, h;
  function f() {
    p(), r(er, m), r(Ni, g);
  }
  function p() {
    const { keyboard: b } = t;
    b && (b === "focused" ? (i = c, vn(c, ls, 0)) : i = window, o(i, $d, A));
  }
  function d() {
    u(i, $d), Of(i) && Kr(i, ls);
  }
  function v(b) {
    h = b;
  }
  function g() {
    const b = h;
    h = !0, Cc(() => {
      h = b;
    });
  }
  function m() {
    d(), p();
  }
  function A(b) {
    if (!h) {
      const { key: S } = b, N = kl(BT, S) ? `Arrow${S}` : S;
      N === l("ArrowLeft") ? n.go("<") : N === l("ArrowRight") && n.go(">");
    }
  }
  return {
    mount: f,
    destroy: d,
    disable: v
  };
}
const pl = `${Mf}-lazy`, Oc = `${pl}-srcset`, UT = `[${pl}], [${Oc}]`;
function kT(n, e, t) {
  const { on: r, off: o, bind: u, emit: c } = Cn(n), l = t.lazyLoad === "sequential";
  let i = [], h = 0;
  function f() {
    t.lazyLoad && (d(), r(Tn, p), l || r([si, Tn, ss, Ms], g));
  }
  function p() {
    v(), d();
  }
  function d() {
    e.Slides.forEach((S) => {
      Nf(S.slide, UT).forEach((N) => {
        const T = es(N, pl), R = es(N, Oc);
        if (T !== N.src || R !== N.srcset) {
          const y = t.classes.spinner, E = N.parentElement, L = ti(E, `.${y}`) || Wa("span", y, E);
          vn(L, Wl, "presentation"), i.push({ _img: N, _Slide: S, src: T, srcset: R, _spinner: L }), !N.src && fl(N, "none");
        }
      });
    }), l && b();
  }
  function v() {
    h = 0, i = [];
  }
  function g() {
    i = i.filter((S) => {
      const N = t.perPage * ((t.preloadPages || 1) + 1) - 1;
      return S._Slide.isWithin(n.index, N) ? m(S) : !0;
    }), i.length || o(ss);
  }
  function m(S) {
    const { _img: N } = S;
    Ii(S._Slide.slide, Dc), u(N, "load error", (T) => {
      A(S, T.type === "error");
    }), ["srcset", "src"].forEach((T) => {
      S[T] && (vn(N, T, S[T]), Kr(N, T === "src" ? pl : Oc));
    });
  }
  function A(S, N) {
    const { _Slide: T } = S;
    ts(T.slide, Dc), N || (vo(S._spinner), fl(S._img, ""), c(km, S._img, T), c(Qa)), l && b();
  }
  function b() {
    h < i.length && m(i[h++]);
  }
  return {
    mount: f,
    destroy: v
  };
}
function KT(n, e, t) {
  const { on: r, emit: o, bind: u, unbind: c } = Cn(n), { Slides: l, Elements: i, Controller: h } = e, { hasFocus: f, getIndex: p } = h, d = [];
  let v;
  function g() {
    m(), r([er, Tn], m), r([Ni, Ms], T);
  }
  function m() {
    A(), t.pagination && l.isEnough() && (b(), o($y, { list: v, items: d }, N(n.index)), T());
  }
  function A() {
    v && (vo(v), d.forEach((R) => {
      c(R.button, "click");
    }), mo(d), v = null);
  }
  function b() {
    const { length: R } = n, { classes: y, i18n: E, perPage: L } = t, _ = t.pagination === "slider" && i.slider || i.root, O = f() ? R : as(R / L);
    v = Wa("ul", y.pagination, _);
    for (let D = 0; D < O; D++) {
      const M = Wa("li", null, v), C = Wa("button", { class: y.page, type: "button" }, M), I = l.getIn(D).map((F) => F.slide.id), w = !f() && L > 1 ? E.pageX : E.slideX;
      u(C, "click", S.bind(null, D)), vn(C, Za, I.join(" ")), vn(C, qa, Pm(w, D + 1)), d.push({ li: M, button: C, page: D });
    }
  }
  function S(R) {
    h.go(`>${R}`, !0, () => {
      const y = l.getAt(h.toIndex(R));
      y && Iy(y.slide);
    });
  }
  function N(R) {
    return d[h.toPage(R)];
  }
  function T() {
    const R = N(p(!0)), y = N(p());
    R && (ts(R.button, Ja), Kr(R.button, dl)), y && (Ii(y.button, Ja), vn(y.button, dl, !0)), o(Gy, { list: v, items: d }, R, y);
  }
  return {
    items: d,
    mount: g,
    destroy: A,
    getAt: N,
    update: T
  };
}
const jT = [" ", "Enter", "Spacebar"];
function WT(n, e, t) {
  const { list: r } = e.Elements, o = [];
  function u() {
    n.splides.forEach((v) => {
      !v.isParent && i(v.splide);
    }), t.isNavigation && h();
  }
  function c() {
    Kr(r, hl), o.forEach((v) => {
      v.destroy();
    }), mo(o);
  }
  function l() {
    c(), u();
  }
  function i(v) {
    [n, v].forEach((g) => {
      const m = Cn(g), A = g === n ? v : n;
      m.on(Ni, (b, S, N) => {
        A.go(A.is(_o) ? N : b);
      }), o.push(m);
    });
  }
  function h() {
    const v = Cn(n), { on: g } = v;
    g(Nm, p), g(Lm, d), g([si, er], f), vn(r, Wl, "menu"), o.push(v), v.emit(Um, n.splides);
  }
  function f() {
    vn(r, Qm, t.direction !== xf ? "horizontal" : null);
  }
  function p(v) {
    n.go(v.index);
  }
  function d(v, g) {
    kl(jT, g.key) && (p(v), pi(g));
  }
  return {
    mount: u,
    destroy: c,
    remount: l
  };
}
function VT(n, e, t) {
  const { bind: r } = Cn(n);
  function o() {
    t.wheel && r(e.Elements.track, "wheel", u, Ia);
  }
  function u(l) {
    if (l.cancelable) {
      const { deltaY: i } = l;
      if (i) {
        const h = i < 0;
        n.go(h ? "<" : ">"), c(h) && pi(l);
      }
    }
  }
  function c(l) {
    return !t.releaseWheel || n.state.is(ul) || e.Controller.getAdjacent(l) !== -1;
  }
  return {
    mount: o
  };
}
var HT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Options: Jy,
  Direction: qy,
  Elements: hT,
  Slides: gT,
  Layout: vT,
  Clones: _T,
  Move: ET,
  Controller: yT,
  Arrows: ST,
  Autoplay: MT,
  Cover: bT,
  Scroll: NT,
  Drag: xT,
  Keyboard: FT,
  LazyLoad: kT,
  Pagination: KT,
  Sync: WT,
  Wheel: VT
});
const $T = {
  prev: "Previous slide",
  next: "Next slide",
  first: "Go to first slide",
  last: "Go to last slide",
  slideX: "Go to slide %s",
  pageX: "Go to page %s",
  play: "Start autoplay",
  pause: "Pause autoplay"
}, Gd = {
  type: "slide",
  speed: 400,
  waitForTransition: !0,
  perPage: 1,
  cloneStatus: !0,
  arrows: !0,
  pagination: !0,
  interval: 5e3,
  pauseOnHover: !0,
  pauseOnFocus: !0,
  resetProgress: !0,
  keyboard: !0,
  easing: "cubic-bezier(0.25, 1, 0.5, 1)",
  drag: !0,
  direction: "ltr",
  slideFocus: !0,
  trimSpace: !0,
  focusableNodes: "a, button, textarea, input, select, iframe",
  classes: dT,
  i18n: $T
};
function GT(n, e, t) {
  const { on: r } = Cn(n);
  function o() {
    r([si, Tn], () => {
      Cc(() => {
        e.Slides.style("transition", `opacity ${t.speed}ms ${t.easing}`);
      });
    });
  }
  function u(c, l) {
    const { track: i } = e.Elements;
    dr(i, "height", di(ir(i).height)), Cc(() => {
      l(), dr(i, "height", "");
    });
  }
  return {
    mount: o,
    start: u,
    cancel: Mc
  };
}
function zT(n, e, t) {
  const { bind: r } = Cn(n), { Move: o, Controller: u } = e, { list: c } = e.Elements;
  let l;
  function i() {
    r(c, "transitionend", (v) => {
      v.target === c && l && (f(), l());
    });
  }
  function h(v, g) {
    const m = o.toPosition(v, !0), A = o.getPosition(), b = p(v);
    hr(m - A) >= 1 && b >= 1 ? (d(`transform ${b}ms ${t.easing}`), o.translate(m, !0), l = g) : (o.jump(v), g());
  }
  function f() {
    d("");
  }
  function p(v) {
    const { rewindSpeed: g } = t;
    if (n.is(bs) && g) {
      const m = u.getIndex(!0), A = u.getEnd();
      if (m === 0 && v >= A || m >= A && v === 0)
        return g;
    }
    return t.speed;
  }
  function d(v) {
    dr(c, "transition", v);
  }
  return {
    mount: i,
    start: h,
    cancel: f
  };
}
const Jm = class {
  constructor(n, e) {
    this.event = xy(), this.Components = {}, this.state = Qy(Pa), this.splides = [], this._options = {}, this._Extensions = {};
    const t = Pi(n) ? Gi(document, n) : n;
    ns(t, `${t} is invalid.`), this.root = t, Zi(Gd, Jm.defaults), Zi(Zi(this._options, Gd), e || {});
  }
  mount(n, e) {
    const { state: t, Components: r } = this;
    ns(t.is([Pa, cl]), "Already mounted!"), t.set(Pa), this._Components = r, this._Transition = e || this._Transition || (this.is(Vl) ? GT : zT), this._Extensions = n || this._Extensions;
    const o = Sc({}, HT, this._Extensions, { Transition: this._Transition });
    return ra(o, (u, c) => {
      const l = u(this, r, this._options);
      r[c] = l, l.setup && l.setup();
    }), ra(r, (u) => {
      u.mount && u.mount();
    }), this.emit(si), Ii(this.root, cT), t.set(ll), this.emit(Wd), this;
  }
  sync(n) {
    return this.splides.push({ splide: n }), n.splides.push({ splide: this, isParent: !0 }), this.state.is(ll) && (this._Components.Sync.remount(), n.Components.Sync.remount()), this;
  }
  go(n) {
    return this._Components.Controller.go(n), this;
  }
  on(n, e) {
    return this.event.on(n, e, null, Ry), this;
  }
  off(n) {
    return this.event.off(n), this;
  }
  emit(n) {
    return this.event.emit(n, ...go(arguments, 1)), this;
  }
  add(n, e) {
    return this._Components.Slides.add(n, e), this;
  }
  remove(n) {
    return this._Components.Slides.remove(n), this;
  }
  is(n) {
    return this._options.type === n;
  }
  refresh() {
    return this.emit(Tn), this;
  }
  destroy(n = !0) {
    const { event: e, state: t } = this;
    return t.is(Pa) ? e.on(Wd, this.destroy.bind(this, n), this) : (ra(this._Components, (r) => {
      r.destroy && r.destroy(n);
    }, !0), e.emit(Fm), e.destroy(), n && mo(this.splides), t.set(cl)), this;
  }
  get options() {
    return this._options;
  }
  set options(n) {
    const { _options: e } = this;
    Zi(e, n), this.state.is(Pa) || this.emit(er, e);
  }
  get length() {
    return this._Components.Slides.getLength(!0);
  }
  get index() {
    return this._Components.Controller.getIndex();
  }
};
let Ff = Jm;
Ff.defaults = {};
Ff.STATES = by;
const li = /* @__PURE__ */ new Map(), Tu = {
  set(n, e, t) {
    li.has(n) || li.set(n, /* @__PURE__ */ new Map());
    const r = li.get(n);
    if (!r.has(e) && r.size !== 0) {
      console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(r.keys())[0]}.`);
      return;
    }
    r.set(e, t);
  },
  get(n, e) {
    return li.has(n) && li.get(n).get(e) || null;
  },
  remove(n, e) {
    if (!li.has(n))
      return;
    const t = li.get(n);
    t.delete(e), t.size === 0 && li.delete(n);
  }
}, YT = 1e3, Pc = "transitionend", XT = (n) => n == null ? `${n}` : Object.prototype.toString.call(n).match(/\s([a-z]+)/i)[1].toLowerCase(), Zm = (n) => {
  let e = n.getAttribute("data-bs-target");
  if (!e || e === "#") {
    let t = n.getAttribute("href");
    if (!t || !t.includes("#") && !t.startsWith("."))
      return null;
    t.includes("#") && !t.startsWith("#") && (t = `#${t.split("#")[1]}`), e = t && t !== "#" ? t.trim() : null;
  }
  return e;
}, qm = (n) => {
  const e = Zm(n);
  return e && document.querySelector(e) ? e : null;
}, ia = (n) => {
  const e = Zm(n);
  return e ? document.querySelector(e) : null;
}, QT = (n) => {
  if (!n)
    return 0;
  let { transitionDuration: e, transitionDelay: t } = window.getComputedStyle(n);
  const r = Number.parseFloat(e), o = Number.parseFloat(t);
  return !r && !o ? 0 : (e = e.split(",")[0], t = t.split(",")[0], (Number.parseFloat(e) + Number.parseFloat(t)) * YT);
}, JT = (n) => {
  n.dispatchEvent(new Event(Pc));
}, Va = (n) => !n || typeof n != "object" ? !1 : (typeof n.jquery < "u" && (n = n[0]), typeof n.nodeType < "u"), ml = (n) => Va(n) ? n.jquery ? n[0] : n : typeof n == "string" && n.length > 0 ? document.querySelector(n) : null, eg = (n) => {
  if (!Va(n) || n.getClientRects().length === 0)
    return !1;
  const e = getComputedStyle(n).getPropertyValue("visibility") === "visible", t = n.closest("details:not([open])");
  if (!t)
    return e;
  if (t !== n) {
    const r = n.closest("summary");
    if (r && r.parentNode !== t || r === null)
      return !1;
  }
  return e;
}, Eo = (n) => !n || n.nodeType !== Node.ELEMENT_NODE || n.classList.contains("disabled") ? !0 : typeof n.disabled < "u" ? n.disabled : n.hasAttribute("disabled") && n.getAttribute("disabled") !== "false", Uf = (n) => {
  n.offsetHeight;
}, tg = () => window.jQuery && !document.body.hasAttribute("data-bs-no-jquery") ? window.jQuery : null, Au = [], ZT = (n) => {
  document.readyState === "loading" ? (Au.length || document.addEventListener("DOMContentLoaded", () => {
    for (const e of Au)
      e();
  }), Au.push(n)) : n();
}, zd = () => document.documentElement.dir === "rtl", Hl = (n) => {
  ZT(() => {
    const e = tg();
    if (e) {
      const t = n.NAME, r = e.fn[t];
      e.fn[t] = n.jQueryInterface, e.fn[t].Constructor = n, e.fn[t].noConflict = () => (e.fn[t] = r, n.jQueryInterface);
    }
  });
}, Yi = (n) => {
  typeof n == "function" && n();
}, ng = (n, e, t = !0) => {
  if (!t) {
    Yi(n);
    return;
  }
  const r = 5, o = QT(e) + r;
  let u = !1;
  const c = ({ target: l }) => {
    l === e && (u = !0, e.removeEventListener(Pc, c), Yi(n));
  };
  e.addEventListener(Pc, c), setTimeout(() => {
    u || JT(e);
  }, o);
}, rg = (n, e, t, r) => {
  const o = n.length;
  let u = n.indexOf(e);
  return u === -1 ? !t && r ? n[o - 1] : n[0] : (u += t ? 1 : -1, r && (u = (u + o) % o), n[Math.max(0, Math.min(u, o - 1))]);
}, qT = /[^.]*(?=\..*)\.|.*/, eA = /\..*/, tA = /::\d+$/, Su = {};
let Yd = 1;
const ig = {
  mouseenter: "mouseover",
  mouseleave: "mouseout"
}, nA = /* @__PURE__ */ new Set([
  "click",
  "dblclick",
  "mouseup",
  "mousedown",
  "contextmenu",
  "mousewheel",
  "DOMMouseScroll",
  "mouseover",
  "mouseout",
  "mousemove",
  "selectstart",
  "selectend",
  "keydown",
  "keypress",
  "keyup",
  "orientationchange",
  "touchstart",
  "touchmove",
  "touchend",
  "touchcancel",
  "pointerdown",
  "pointermove",
  "pointerup",
  "pointerleave",
  "pointercancel",
  "gesturestart",
  "gesturechange",
  "gestureend",
  "focus",
  "blur",
  "change",
  "reset",
  "select",
  "submit",
  "focusin",
  "focusout",
  "load",
  "unload",
  "beforeunload",
  "resize",
  "move",
  "DOMContentLoaded",
  "readystatechange",
  "error",
  "abort",
  "scroll"
]);
function ag(n, e) {
  return e && `${e}::${Yd++}` || n.uidEvent || Yd++;
}
function og(n) {
  const e = ag(n);
  return n.uidEvent = e, Su[e] = Su[e] || {}, Su[e];
}
function rA(n, e) {
  return function t(r) {
    return kf(r, { delegateTarget: n }), t.oneOff && Gt.off(n, r.type, e), e.apply(n, [r]);
  };
}
function iA(n, e, t) {
  return function r(o) {
    const u = n.querySelectorAll(e);
    for (let { target: c } = o; c && c !== this; c = c.parentNode)
      for (const l of u)
        if (l === c)
          return kf(o, { delegateTarget: c }), r.oneOff && Gt.off(n, o.type, e, t), t.apply(c, [o]);
  };
}
function sg(n, e, t = null) {
  return Object.values(n).find((r) => r.callable === e && r.delegationSelector === t);
}
function lg(n, e, t) {
  const r = typeof e == "string", o = r ? t : e || t;
  let u = ug(n);
  return nA.has(u) || (u = n), [r, o, u];
}
function Xd(n, e, t, r, o) {
  if (typeof e != "string" || !n)
    return;
  let [u, c, l] = lg(e, t, r);
  e in ig && (c = ((g) => function(m) {
    if (!m.relatedTarget || m.relatedTarget !== m.delegateTarget && !m.delegateTarget.contains(m.relatedTarget))
      return g.call(this, m);
  })(c));
  const i = og(n), h = i[l] || (i[l] = {}), f = sg(h, c, u ? t : null);
  if (f) {
    f.oneOff = f.oneOff && o;
    return;
  }
  const p = ag(c, e.replace(qT, "")), d = u ? iA(n, t, c) : rA(n, c);
  d.delegationSelector = u ? t : null, d.callable = c, d.oneOff = o, d.uidEvent = p, h[p] = d, n.addEventListener(l, d, u);
}
function Ic(n, e, t, r, o) {
  const u = sg(e[t], r, o);
  u && (n.removeEventListener(t, u, !!o), delete e[t][u.uidEvent]);
}
function aA(n, e, t, r) {
  const o = e[t] || {};
  for (const u of Object.keys(o))
    if (u.includes(r)) {
      const c = o[u];
      Ic(n, e, t, c.callable, c.delegationSelector);
    }
}
function ug(n) {
  return n = n.replace(eA, ""), ig[n] || n;
}
const Gt = {
  on(n, e, t, r) {
    Xd(n, e, t, r, !1);
  },
  one(n, e, t, r) {
    Xd(n, e, t, r, !0);
  },
  off(n, e, t, r) {
    if (typeof e != "string" || !n)
      return;
    const [o, u, c] = lg(e, t, r), l = c !== e, i = og(n), h = i[c] || {}, f = e.startsWith(".");
    if (typeof u < "u") {
      if (!Object.keys(h).length)
        return;
      Ic(n, i, c, u, o ? t : null);
      return;
    }
    if (f)
      for (const p of Object.keys(i))
        aA(n, i, p, e.slice(1));
    for (const p of Object.keys(h)) {
      const d = p.replace(tA, "");
      if (!l || e.includes(d)) {
        const v = h[p];
        Ic(n, i, c, v.callable, v.delegationSelector);
      }
    }
  },
  trigger(n, e, t) {
    if (typeof e != "string" || !n)
      return null;
    const r = tg(), o = ug(e), u = e !== o;
    let c = null, l = !0, i = !0, h = !1;
    u && r && (c = r.Event(e, t), r(n).trigger(c), l = !c.isPropagationStopped(), i = !c.isImmediatePropagationStopped(), h = c.isDefaultPrevented());
    let f = new Event(e, { bubbles: l, cancelable: !0 });
    return f = kf(f, t), h && f.preventDefault(), i && n.dispatchEvent(f), f.defaultPrevented && c && c.preventDefault(), f;
  }
};
function kf(n, e) {
  for (const [t, r] of Object.entries(e || {}))
    try {
      n[t] = r;
    } catch {
      Object.defineProperty(n, t, {
        configurable: !0,
        get() {
          return r;
        }
      });
    }
  return n;
}
function Qd(n) {
  if (n === "true")
    return !0;
  if (n === "false")
    return !1;
  if (n === Number(n).toString())
    return Number(n);
  if (n === "" || n === "null")
    return null;
  if (typeof n != "string")
    return n;
  try {
    return JSON.parse(decodeURIComponent(n));
  } catch {
    return n;
  }
}
function Cu(n) {
  return n.replace(/[A-Z]/g, (e) => `-${e.toLowerCase()}`);
}
const Wo = {
  setDataAttribute(n, e, t) {
    n.setAttribute(`data-bs-${Cu(e)}`, t);
  },
  removeDataAttribute(n, e) {
    n.removeAttribute(`data-bs-${Cu(e)}`);
  },
  getDataAttributes(n) {
    if (!n)
      return {};
    const e = {}, t = Object.keys(n.dataset).filter((r) => r.startsWith("bs") && !r.startsWith("bsConfig"));
    for (const r of t) {
      let o = r.replace(/^bs/, "");
      o = o.charAt(0).toLowerCase() + o.slice(1, o.length), e[o] = Qd(n.dataset[r]);
    }
    return e;
  },
  getDataAttribute(n, e) {
    return Qd(n.getAttribute(`data-bs-${Cu(e)}`));
  }
};
class Kf {
  // Getters
  static get Default() {
    return {};
  }
  static get DefaultType() {
    return {};
  }
  static get NAME() {
    throw new Error('You have to implement the static method "NAME", for each component!');
  }
  _getConfig(e) {
    return e = this._mergeConfigObj(e), e = this._configAfterMerge(e), this._typeCheckConfig(e), e;
  }
  _configAfterMerge(e) {
    return e;
  }
  _mergeConfigObj(e, t) {
    const r = Va(t) ? Wo.getDataAttribute(t, "config") : {};
    return {
      ...this.constructor.Default,
      ...typeof r == "object" ? r : {},
      ...Va(t) ? Wo.getDataAttributes(t) : {},
      ...typeof e == "object" ? e : {}
    };
  }
  _typeCheckConfig(e, t = this.constructor.DefaultType) {
    for (const r of Object.keys(t)) {
      const o = t[r], u = e[r], c = Va(u) ? "element" : XT(u);
      if (!new RegExp(o).test(c))
        throw new TypeError(
          `${this.constructor.NAME.toUpperCase()}: Option "${r}" provided type "${c}" but expected type "${o}".`
        );
    }
  }
}
const oA = "5.2.3";
class sA extends Kf {
  constructor(e, t) {
    super(), e = ml(e), e && (this._element = e, this._config = this._getConfig(t), Tu.set(this._element, this.constructor.DATA_KEY, this));
  }
  // Public
  dispose() {
    Tu.remove(this._element, this.constructor.DATA_KEY), Gt.off(this._element, this.constructor.EVENT_KEY);
    for (const e of Object.getOwnPropertyNames(this))
      this[e] = null;
  }
  _queueCallback(e, t, r = !0) {
    ng(e, t, r);
  }
  _getConfig(e) {
    return e = this._mergeConfigObj(e, this._element), e = this._configAfterMerge(e), this._typeCheckConfig(e), e;
  }
  // Static
  static getInstance(e) {
    return Tu.get(ml(e), this.DATA_KEY);
  }
  static getOrCreateInstance(e, t = {}) {
    return this.getInstance(e) || new this(e, typeof t == "object" ? t : null);
  }
  static get VERSION() {
    return oA;
  }
  static get DATA_KEY() {
    return `bs.${this.NAME}`;
  }
  static get EVENT_KEY() {
    return `.${this.DATA_KEY}`;
  }
  static eventName(e) {
    return `${e}${this.EVENT_KEY}`;
  }
}
const Ea = sA, An = {
  find(n, e = document.documentElement) {
    return [].concat(...Element.prototype.querySelectorAll.call(e, n));
  },
  findOne(n, e = document.documentElement) {
    return Element.prototype.querySelector.call(e, n);
  },
  children(n, e) {
    return [].concat(...n.children).filter((t) => t.matches(e));
  },
  parents(n, e) {
    const t = [];
    let r = n.parentNode.closest(e);
    for (; r; )
      t.push(r), r = r.parentNode.closest(e);
    return t;
  },
  prev(n, e) {
    let t = n.previousElementSibling;
    for (; t; ) {
      if (t.matches(e))
        return [t];
      t = t.previousElementSibling;
    }
    return [];
  },
  // TODO: this is now unused; remove later along with prev()
  next(n, e) {
    let t = n.nextElementSibling;
    for (; t; ) {
      if (t.matches(e))
        return [t];
      t = t.nextElementSibling;
    }
    return [];
  },
  focusableChildren(n) {
    const e = [
      "a",
      "button",
      "input",
      "textarea",
      "select",
      "details",
      "[tabindex]",
      '[contenteditable="true"]'
    ].map((t) => `${t}:not([tabindex^="-"])`).join(",");
    return this.find(e, n).filter((t) => !Eo(t) && eg(t));
  }
}, lA = "carousel", uA = "bs.carousel", cA = `.${uA}`, fA = ".data-api", dA = `load${cA}${fA}`, hA = "[data-bs-carousel-splide]", pA = {
  slideFocus: !0,
  i18n: {
    prev: "Slide precedente",
    next: "Slide successiva",
    first: "Vai alla prima slide",
    last: "Vai all’ultima slide",
    slideX: "Vai alla slide %s",
    pageX: "Vai a pagina %s",
    play: "Attiva autoplay",
    pause: "Pausa autoplay"
  }
}, Jd = {
  "it-carousel-landscape-abstract-three-cols": {
    type: "slide",
    perPage: 3,
    gap: 24,
    padding: { left: 0, right: 0 },
    arrows: !1,
    breakpoints: {
      768: {
        perPage: 1,
        gap: 24,
        padding: { left: 0, right: 0 },
        arrows: !1
      },
      992: {
        perPage: 2,
        gap: 24,
        padding: { left: 40, right: 40 },
        arrows: !1
      }
    }
  },
  "it-carousel-landscape-abstract-three-cols-arrow-visible": {
    type: "slide",
    perPage: 3,
    gap: 24,
    padding: { left: 0, right: 0 },
    arrows: !0,
    breakpoints: {
      768: {
        perPage: 1,
        gap: 24,
        padding: { left: 40, right: 40 },
        arrows: !0
      },
      992: {
        perPage: 2,
        gap: 24,
        padding: { left: 40, right: 40 },
        arrows: !0
      }
    }
  },
  "it-big-img": {
    type: "loop",
    perPage: 1,
    gap: 48,
    padding: { left: 320, right: 320 },
    arrows: !1,
    breakpoints: {
      768: {
        perPage: 1,
        gap: 0,
        padding: { left: 0, right: 0 },
        arrows: !1
      },
      992: {
        perPage: 1,
        gap: 24,
        padding: { left: 160, right: 160 },
        arrows: !1
      }
    }
  },
  "it-standard-image": {
    type: "loop",
    perPage: 3,
    gap: 24,
    padding: { left: 48, right: 48 },
    arrows: !1,
    breakpoints: {
      768: {
        perPage: 1,
        gap: 24,
        padding: { left: 40, right: 40 },
        arrows: !1
      },
      992: {
        perPage: 2,
        gap: 24,
        padding: { left: 48, right: 48 },
        arrows: !1
      }
    }
  },
  "it-carousel-landscape-abstract": {
    type: "slide",
    perPage: 1,
    gap: 24,
    padding: { left: 0, right: 0 },
    arrows: !1,
    breakpoints: {
      768: {
        perPage: 1,
        gap: 24,
        padding: { left: 0, right: 0 },
        arrows: !1
      },
      992: {
        perPage: 1,
        gap: 24,
        padding: { left: 24, right: 24 },
        arrows: !1
      }
    }
  },
  "it-calendar-wrapper": {
    type: "slide",
    perPage: 4,
    gap: 0,
    padding: { left: 0, right: 0 },
    arrows: !1,
    breakpoints: {
      560: {
        perPage: 1,
        gap: 0,
        padding: { left: 24, right: 24 },
        arrows: !1
      },
      768: {
        perPage: 2,
        gap: 0,
        padding: { left: 0, right: 0 },
        arrows: !1
      },
      992: {
        perPage: 3,
        gap: 0,
        padding: { left: 0, right: 0 },
        arrows: !1
      }
    }
  }
};
class cg extends Ea {
  constructor(e) {
    super(e), this._config = this._getConfig(), this._splide = new Ff(this._element, this._config), this._init();
  }
  dispose() {
    this._splide.destroy(), super.dispose();
  }
  // Getters
  static get NAME() {
    return lA;
  }
  // Public
  // Private
  _init() {
    this._splide.mount();
  }
  _getConfig() {
    let e = Object.assign({}, pA);
    return Object.keys(Jd).forEach((t) => {
      this._element.classList.contains(t) && (e = Object.assign({}, e, Jd[t]));
    }), e;
  }
}
Gt.on(window, dA, () => {
  An.find(hA).forEach((e) => {
    cg.getOrCreateInstance(e);
  });
});
const mA = "inputlabel", gA = "bs.inputlabel", jf = `.${gA}`, vA = `focus${jf}`, Zd = `blur${jf}`, _A = `change${jf}`, Mu = "active";
class ya {
  constructor(e) {
    this._element = e, this._init();
  }
  // Getters
  static get NAME() {
    return mA;
  }
  // Public
  // Private
  _init() {
    const e = this._getLabel();
    e && !e.classList.contains(Mu) && (this._labelOut(), this._labelOver()), this._bindEvents();
  }
  _bindEvents() {
    ["date", "time"].includes(this._element.getAttribute("type")) || (this._element.getAttribute("type") === "file" ? Gt.on(this._element, Zd, () => {
      this._labelOut();
    }) : (Gt.on(this._element, vA, () => {
      this._labelOut();
    }), Gt.on(this._element, Zd, () => {
      this._labelOver();
    }), Gt.on(this._element, _A, () => {
      this._labelToggle();
    })));
  }
  _getLabel() {
    return An.findOne('label[for="' + this._element.getAttribute("id") + '"]');
  }
  _isEmpty() {
    return !this._element.value && !this._element.getAttribute("placeholder");
  }
  _labelOut() {
    const e = this._getLabel();
    e && e.classList.add(Mu);
  }
  _labelOver() {
    if (this._isEmpty()) {
      const e = this._getLabel();
      e && e.classList.remove(Mu);
    }
  }
  _labelToggle() {
    this._isEmpty() ? this._labelOver() : this._labelOut();
  }
}
Kn(ya, "getInputFromLabel", (e) => document.querySelector("#" + CSS.escape(e.getAttribute("for"))));
const EA = "inputnumber", yA = "bs.inputnumber", Rs = `.${yA}`, Wf = ".data-api", TA = `click${Rs}`, qd = `change${Rs}`, AA = `click${Rs}${Wf}`, SA = `mousedown${Rs}${Wf}`, CA = `keyup${Rs}${Wf}`, MA = "input-number-adaptive", bA = "input-number-percentage", RA = "input-number-currency", DA = "input-number-sub", fg = ".input-number", $l = 'input[data-bs-input][type="number"]', Vf = 'button[class^="input-number-"]';
class Hf extends Ea {
  constructor(e) {
    super(e), this._wrapperElement = this._element.closest(fg), this._label = new ya(e), this._init(), this._bindEvents();
  }
  // Getters
  static get NAME() {
    return EA;
  }
  // Public
  // Private
  _init() {
    this._wrapperElement && this._inputResize();
  }
  _bindEvents() {
    this._wrapperElement && (An.find(Vf, this._wrapperElement).forEach((e) => {
      Gt.on(e, TA, (t) => {
        t.preventDefault(), this._incrDecr(e.classList.contains(DA));
      });
    }), Gt.on(this._element, qd, () => this._checkLimit()));
  }
  _inputResize() {
    if (this._wrapperElement.classList.contains(MA)) {
      let e = null;
      this._wrapperElement.classList.contains(bA) || (e = "calc(44px + " + this._element.value.length + "ch)"), this._wrapperElement.classList.contains(RA) && (e = "calc(40px + 44px + " + this._element.value.length + "ch)"), e && (this._element.style.width = e);
    }
  }
  _incrDecr(e) {
    const t = parseFloat(this._element.value);
    if (!isNaN(t)) {
      let r = parseFloat(this._element.getAttribute("step"));
      r || (r = 1), this._element.value = t + r * (e ? -1 : 1), Gt.trigger(this._element, qd);
    }
  }
  _checkLimit() {
    const e = parseFloat(this._element.value);
    if (!isNaN(e)) {
      let t = e;
      const r = parseFloat(this._element.getAttribute("max")), o = parseFloat(this._element.getAttribute("min"));
      o && e < o && (t = o), r && e > r && (t = r), this._element.value = t;
    }
    this._inputResize();
  }
}
const dg = (n) => n && n.matches($l) && n.parentNode.querySelector(Vf) ? Hf.getOrCreateInstance(n) : null;
Gt.on(document, SA, $l + ", label", function() {
  const n = ya.getInputFromLabel(this) || this;
  dg(n);
});
Gt.on(document, CA, $l + ", label", function() {
  const n = ya.getInputFromLabel(this) || this, e = dg(n);
  e && e._label && e._label._labelOut();
});
Gt.on(document, AA, Vf, function() {
  const n = this.closest(fg);
  if (n) {
    const e = An.findOne($l, n);
    e && Hf.getOrCreateInstance(e);
  }
});
const OA = (n, e = "hide") => {
  const t = `click.dismiss${n.EVENT_KEY}`, r = n.NAME;
  Gt.on(document, t, `[data-bs-dismiss="${r}"]`, function(o) {
    if (["A", "AREA"].includes(this.tagName) && o.preventDefault(), Eo(this))
      return;
    const u = ia(this) || this.closest(`.${r}`);
    n.getOrCreateInstance(u)[e]();
  });
}, PA = "input", IA = "bs.input", $f = `.${IA}`, hg = ".data-api", NA = `mousedown${$f}${hg}`, LA = `keyup${$f}${hg}`, wA = `change${$f}`;
class ii extends Ea {
  constructor(e) {
    super(e), this._label = new ya(e), this._bindEvents();
  }
  // Getters
  static get NAME() {
    return PA;
  }
  // Public
  // Private
  _bindEvents() {
    this._element.getAttribute("type") === "file" && Gt.on(this._element, wA, () => {
      this._handleFileDescription();
    });
  }
  _handleFileDescription() {
    const e = [];
    let t = "";
    Array.from(this._element.files).forEach((o) => {
      const u = Math.round(parseInt(o.size, 10) / 1024);
      e.push(o.name + " (" + u + "kb)");
    }), this._element.files.length > 1 && (t = this._element.files.length + " file da caricare: ");
    const r = An.findOne('label[for="' + this._element.getAttribute("id") + '"] label.form-file-name', this._element);
    r && (r.innerText = t + e.join("; "));
  }
}
const xA = [
  "select",
  //'input[data-bs-input][type="number"]',
  'input[data-bs-input][type="password"]',
  "input.input-password[data-bs-input]",
  'input[data-bs-autocomplete][type="search"]',
  'input[type="time"]'
], pg = (n) => {
  const e = !!xA.find((r) => n.matches(r)), t = !!(n.getAttribute("type") === "number" && n.parentNode.querySelector('button[class^="input-number-"]'));
  return !e && !t ? ii.getOrCreateInstance(n) : null;
};
Gt.on(document, NA, "input, textarea, label", function() {
  const n = ya.getInputFromLabel(this) || this;
  pg(n);
});
Gt.on(document, LA, "input, textarea, label", function() {
  const n = ya.getInputFromLabel(this) || this, e = pg(n);
  e && e._label && e._label._labelOut();
});
var Gf = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Gl(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
function BA(n) {
  if (n.__esModule)
    return n;
  var e = n.default;
  if (typeof e == "function") {
    var t = function r() {
      return this instanceof r ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    t.prototype = e.prototype;
  } else
    t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(n).forEach(function(r) {
    var o = Object.getOwnPropertyDescriptor(n, r);
    Object.defineProperty(t, r, o.get ? o : {
      enumerable: !0,
      get: function() {
        return n[r];
      }
    });
  }), t;
}
var mg = { exports: {} };
(function(n, e) {
  (function(r, o) {
    n.exports = o();
  })(window, function() {
    return function(t) {
      var r = {};
      function o(u) {
        if (r[u])
          return r[u].exports;
        var c = r[u] = { i: u, l: !1, exports: {} };
        return t[u].call(c.exports, c, c.exports, o), c.l = !0, c.exports;
      }
      return o.m = t, o.c = r, o.d = function(u, c, l) {
        o.o(u, c) || Object.defineProperty(u, c, { enumerable: !0, get: l });
      }, o.r = function(u) {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(u, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(u, "__esModule", { value: !0 });
      }, o.t = function(u, c) {
        if (1 & c && (u = o(u)), 8 & c || 4 & c && typeof u == "object" && u && u.__esModule)
          return u;
        var l = /* @__PURE__ */ Object.create(null);
        if (o.r(l), Object.defineProperty(l, "default", { enumerable: !0, value: u }), 2 & c && typeof u != "string")
          for (var i in u)
            o.d(l, i, (function(h) {
              return u[h];
            }).bind(null, i));
        return l;
      }, o.n = function(u) {
        var c = u && u.__esModule ? function() {
          return u.default;
        } : function() {
          return u;
        };
        return o.d(c, "a", c), c;
      }, o.o = function(u, c) {
        return Object.prototype.hasOwnProperty.call(u, c);
      }, o.p = "/", o(o.s = 37);
    }([function(t, r, o) {
      var u = o(1), c = o(6), l = o(7), i = o(16), h = o(18), f = "prototype", p = function(d, v, g) {
        var m, A, b, S, N = d & p.F, T = d & p.G, R = d & p.S, y = d & p.P, E = d & p.B, L = T ? u : R ? u[v] || (u[v] = {}) : (u[v] || {})[f], _ = T ? c : c[v] || (c[v] = {}), O = _[f] || (_[f] = {});
        for (m in T && (g = v), g)
          b = ((A = !N && L && L[m] !== void 0) ? L : g)[m], S = E && A ? h(b, u) : y && typeof b == "function" ? h(Function.call, b) : b, L && i(L, m, b, d & p.U), _[m] != b && l(_, m, S), y && O[m] != b && (O[m] = b);
      };
      u.core = c, p.F = 1, p.G = 2, p.S = 4, p.P = 8, p.B = 16, p.W = 32, p.U = 64, p.R = 128, t.exports = p;
    }, function(t, r) {
      var o = t.exports = typeof window < "u" && window.Math == Math ? window : typeof self < "u" && self.Math == Math ? self : Function("return this")();
      typeof __g == "number" && (__g = o);
    }, function(t, r) {
      t.exports = function(o) {
        return typeof o == "object" ? o !== null : typeof o == "function";
      };
    }, function(t, r, o) {
      t.exports = !o(4)(function() {
        return Object.defineProperty({}, "a", { get: function() {
          return 7;
        } }).a != 7;
      });
    }, function(t, r) {
      t.exports = function(o) {
        try {
          return !!o();
        } catch {
          return !0;
        }
      };
    }, function(t, r, o) {
      o.r(r), o.d(r, "h", function() {
        return h;
      }), o.d(r, "createElement", function() {
        return h;
      }), o.d(r, "cloneElement", function() {
        return d;
      }), o.d(r, "Component", function() {
        return j;
      }), o.d(r, "render", function() {
        return J;
      }), o.d(r, "rerender", function() {
        return A;
      }), o.d(r, "options", function() {
        return c;
      });
      var u = function() {
      }, c = {}, l = [], i = [];
      function h(G, $) {
        var ie, re, ce, z, oe = i;
        for (z = arguments.length; 2 < z--; )
          l.push(arguments[z]);
        for ($ && $.children != null && (l.length || l.push($.children), delete $.children); l.length; )
          if ((re = l.pop()) && re.pop !== void 0)
            for (z = re.length; z--; )
              l.push(re[z]);
          else
            typeof re == "boolean" && (re = null), (ce = typeof G != "function") && (re == null ? re = "" : typeof re == "number" ? re = String(re) : typeof re != "string" && (ce = !1)), ce && ie ? oe[oe.length - 1] += re : oe === i ? oe = [re] : oe.push(re), ie = ce;
        var de = new u();
        return de.nodeName = G, de.children = oe, de.attributes = $ ?? void 0, de.key = $ == null ? void 0 : $.key, c.vnode !== void 0 && c.vnode(de), de;
      }
      function f(G, $) {
        for (var ie in $)
          G[ie] = $[ie];
        return G;
      }
      var p = typeof Promise == "function" ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout;
      function d(G, $) {
        return h(G.nodeName, f(f({}, G.attributes), $), 2 < arguments.length ? [].slice.call(arguments, 2) : G.children);
      }
      var v = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i, g = [];
      function m(G) {
        !G._dirty && (G._dirty = !0) && g.push(G) == 1 && (c.debounceRendering || p)(A);
      }
      function A() {
        var G, $ = g;
        for (g = []; G = $.pop(); )
          G._dirty && Z(G);
      }
      function b(G, $) {
        return G.normalizedNodeName === $ || G.nodeName.toLowerCase() === $.toLowerCase();
      }
      function S(G) {
        var $ = f({}, G.attributes);
        $.children = G.children;
        var ie = G.nodeName.defaultProps;
        if (ie !== void 0)
          for (var re in ie)
            $[re] === void 0 && ($[re] = ie[re]);
        return $;
      }
      function N(G) {
        var $ = G.parentNode;
        $ && $.removeChild(G);
      }
      function T(G, $, ie, re, ce) {
        if ($ === "className" && ($ = "class"), $ !== "key")
          if ($ === "ref")
            ie && ie(null), re && re(G);
          else if ($ !== "class" || ce)
            if ($ === "style") {
              if (re && typeof re != "string" && typeof ie != "string" || (G.style.cssText = re || ""), re && typeof re == "object") {
                if (typeof ie != "string")
                  for (var z in ie)
                    z in re || (G.style[z] = "");
                for (var z in re)
                  G.style[z] = typeof re[z] == "number" && v.test(z) === !1 ? re[z] + "px" : re[z];
              }
            } else if ($ === "dangerouslySetInnerHTML")
              re && (G.innerHTML = re.__html || "");
            else if ($[0] == "o" && $[1] == "n") {
              var oe = $ !== ($ = $.replace(/Capture$/, ""));
              $ = $.toLowerCase().substring(2), re ? ie || G.addEventListener($, R, oe) : G.removeEventListener($, R, oe), (G._listeners || (G._listeners = {}))[$] = re;
            } else if ($ !== "list" && $ !== "type" && !ce && $ in G) {
              try {
                G[$] = re ?? "";
              } catch {
              }
              re != null && re !== !1 || $ == "spellcheck" || G.removeAttribute($);
            } else {
              var de = ce && $ !== ($ = $.replace(/^xlink:?/, ""));
              re == null || re === !1 ? de ? G.removeAttributeNS("http://www.w3.org/1999/xlink", $.toLowerCase()) : G.removeAttribute($) : typeof re != "function" && (de ? G.setAttributeNS("http://www.w3.org/1999/xlink", $.toLowerCase(), re) : G.setAttribute($, re));
            }
          else
            G.className = re || "";
      }
      function R(G) {
        return this._listeners[G.type](c.event && c.event(G) || G);
      }
      var y = [], E = 0, L = !1, _ = !1;
      function O() {
        for (var G; G = y.pop(); )
          c.afterMount && c.afterMount(G), G.componentDidMount && G.componentDidMount();
      }
      function D(G, $, ie, re, ce, z) {
        E++ || (L = ce != null && ce.ownerSVGElement !== void 0, _ = G != null && !("__preactattr_" in G));
        var oe = M(G, $, ie, re, z);
        return ce && oe.parentNode !== ce && ce.appendChild(oe), --E || (_ = !1, z || O()), oe;
      }
      function M(G, $, ie, re, ce) {
        var z = G, oe = L;
        if ($ != null && typeof $ != "boolean" || ($ = ""), typeof $ == "string" || typeof $ == "number")
          return G && G.splitText !== void 0 && G.parentNode && (!G._component || ce) ? G.nodeValue != $ && (G.nodeValue = $) : (z = document.createTextNode($), G && (G.parentNode && G.parentNode.replaceChild(z, G), C(G, !0))), z.__preactattr_ = !0, z;
        var de = $.nodeName;
        if (typeof de == "function")
          return function(ne, x, P, B) {
            for (var W = ne && ne._component, X = W, K = ne, U = W && ne._componentConstructor === x.nodeName, V = U, Q = S(x); W && !V && (W = W._parentComponent); )
              V = W.constructor === x.nodeName;
            return W && V && (!B || W._component) ? (H(W, Q, 3, P, B), ne = W.base) : (X && !U && (Y(X), ne = K = null), W = F(x.nodeName, Q, P), ne && !W.nextBase && (W.nextBase = ne, K = null), H(W, Q, 1, P, B), ne = W.base, K && ne !== K && (K._component = null, C(K, !1))), ne;
          }(G, $, ie, re);
        if (L = de === "svg" || de !== "foreignObject" && L, de = String(de), (!G || !b(G, de)) && (z = function(ne, x) {
          var P = x ? document.createElementNS("http://www.w3.org/2000/svg", ne) : document.createElement(ne);
          return P.normalizedNodeName = ne, P;
        }(de, L), G)) {
          for (; G.firstChild; )
            z.appendChild(G.firstChild);
          G.parentNode && G.parentNode.replaceChild(z, G), C(G, !0);
        }
        var pe = z.firstChild, he = z.__preactattr_, se = $.children;
        if (he == null) {
          he = z.__preactattr_ = {};
          for (var ee = z.attributes, te = ee.length; te--; )
            he[ee[te].name] = ee[te].value;
        }
        return !_ && se && se.length === 1 && typeof se[0] == "string" && pe != null && pe.splitText !== void 0 && pe.nextSibling == null ? pe.nodeValue != se[0] && (pe.nodeValue = se[0]) : (se && se.length || pe != null) && function(ne, x, P, B, W) {
          var X, K, U, V, Q, fe = ne.childNodes, ue = [], q = {}, _e = 0, ge = 0, Ce = fe.length, Ee = 0, Re = x ? x.length : 0;
          if (Ce !== 0)
            for (var Pe = 0; Pe < Ce; Pe++) {
              var ke = fe[Pe], De = ke.__preactattr_, Ae = Re && De ? ke._component ? ke._component.__key : De.key : null;
              Ae != null ? (_e++, q[Ae] = ke) : (De || (ke.splitText !== void 0 ? !W || ke.nodeValue.trim() : W)) && (ue[Ee++] = ke);
            }
          if (Re !== 0)
            for (var Pe = 0; Pe < Re; Pe++) {
              V = x[Pe], Q = null;
              var Ae = V.key;
              if (Ae != null)
                _e && q[Ae] !== void 0 && (Q = q[Ae], q[Ae] = void 0, _e--);
              else if (ge < Ee) {
                for (X = ge; X < Ee; X++)
                  if (ue[X] !== void 0 && (Ie = K = ue[X], it = W, typeof (Xe = V) == "string" || typeof Xe == "number" ? Ie.splitText !== void 0 : typeof Xe.nodeName == "string" ? !Ie._componentConstructor && b(Ie, Xe.nodeName) : it || Ie._componentConstructor === Xe.nodeName)) {
                    Q = K, ue[X] = void 0, X === Ee - 1 && Ee--, X === ge && ge++;
                    break;
                  }
              }
              Q = M(Q, V, P, B), U = fe[Pe], Q && Q !== ne && Q !== U && (U == null ? ne.appendChild(Q) : Q === U.nextSibling ? N(U) : ne.insertBefore(Q, U));
            }
          var Ie, Xe, it;
          if (_e)
            for (var Pe in q)
              q[Pe] !== void 0 && C(q[Pe], !1);
          for (; ge <= Ee; )
            (Q = ue[Ee--]) !== void 0 && C(Q, !1);
        }(z, se, ie, re, _ || he.dangerouslySetInnerHTML != null), function(ne, x, P) {
          var B;
          for (B in P)
            x && x[B] != null || P[B] == null || T(ne, B, P[B], P[B] = void 0, L);
          for (B in x)
            B === "children" || B === "innerHTML" || B in P && x[B] === (B === "value" || B === "checked" ? ne[B] : P[B]) || T(ne, B, P[B], P[B] = x[B], L);
        }(z, $.attributes, he), L = oe, z;
      }
      function C(G, $) {
        var ie = G._component;
        ie ? Y(ie) : (G.__preactattr_ != null && G.__preactattr_.ref && G.__preactattr_.ref(null), $ !== !1 && G.__preactattr_ != null || N(G), I(G));
      }
      function I(G) {
        for (G = G.lastChild; G; ) {
          var $ = G.previousSibling;
          C(G, !0), G = $;
        }
      }
      var w = [];
      function F(G, $, ie) {
        var re, ce = w.length;
        for (G.prototype && G.prototype.render ? (re = new G($, ie), j.call(re, $, ie)) : ((re = new j($, ie)).constructor = G, re.render = k); ce--; )
          if (w[ce].constructor === G)
            return re.nextBase = w[ce].nextBase, w.splice(ce, 1), re;
        return re;
      }
      function k(G, $, ie) {
        return this.constructor(G, ie);
      }
      function H(G, $, ie, re, ce) {
        G._disable || (G._disable = !0, G.__ref = $.ref, G.__key = $.key, delete $.ref, delete $.key, typeof G.constructor.getDerivedStateFromProps > "u" && (!G.base || ce ? G.componentWillMount && G.componentWillMount() : G.componentWillReceiveProps && G.componentWillReceiveProps($, re)), re && re !== G.context && (G.prevContext || (G.prevContext = G.context), G.context = re), G.prevProps || (G.prevProps = G.props), G.props = $, G._disable = !1, ie !== 0 && (ie !== 1 && c.syncComponentUpdates === !1 && G.base ? m(G) : Z(G, 1, ce)), G.__ref && G.__ref(G));
      }
      function Z(G, $, ie, re) {
        if (!G._disable) {
          var ce, z, oe, de = G.props, pe = G.state, he = G.context, se = G.prevProps || de, ee = G.prevState || pe, te = G.prevContext || he, le = G.base, ne = G.nextBase, x = le || ne, P = G._component, B = !1, W = te;
          if (G.constructor.getDerivedStateFromProps && (pe = f(f({}, pe), G.constructor.getDerivedStateFromProps(de, pe)), G.state = pe), le && (G.props = se, G.state = ee, G.context = te, $ !== 2 && G.shouldComponentUpdate && G.shouldComponentUpdate(de, pe, he) === !1 ? B = !0 : G.componentWillUpdate && G.componentWillUpdate(de, pe, he), G.props = de, G.state = pe, G.context = he), G.prevProps = G.prevState = G.prevContext = G.nextBase = null, G._dirty = !1, !B) {
            ce = G.render(de, pe, he), G.getChildContext && (he = f(f({}, he), G.getChildContext())), le && G.getSnapshotBeforeUpdate && (W = G.getSnapshotBeforeUpdate(se, ee));
            var X, K, U = ce && ce.nodeName;
            if (typeof U == "function") {
              var V = S(ce);
              (z = P) && z.constructor === U && V.key == z.__key ? H(z, V, 1, he, !1) : (X = z, G._component = z = F(U, V, he), z.nextBase = z.nextBase || ne, z._parentComponent = G, H(z, V, 0, he, !1), Z(z, 1, ie, !0)), K = z.base;
            } else
              oe = x, (X = P) && (oe = G._component = null), (x || $ === 1) && (oe && (oe._component = null), K = function(_e, ge, Ce, Ee, Re, Pe) {
                E++ || (L = Re != null && Re.ownerSVGElement !== void 0, _ = _e != null && !("__preactattr_" in _e));
                var ke = M(_e, ge, Ce, Ee, Pe);
                return Re && ke.parentNode !== Re && Re.appendChild(ke), --E || (_ = !1, Pe || O()), ke;
              }(oe, ce, he, ie || !le, x && x.parentNode, !0));
            if (x && K !== x && z !== P) {
              var Q = x.parentNode;
              Q && K !== Q && (Q.replaceChild(K, x), X || (x._component = null, C(x, !1)));
            }
            if (X && Y(X), (G.base = K) && !re) {
              for (var fe = G, ue = G; ue = ue._parentComponent; )
                (fe = ue).base = K;
              K._component = fe, K._componentConstructor = fe.constructor;
            }
          }
          for (!le || ie ? y.unshift(G) : B || (G.componentDidUpdate && G.componentDidUpdate(se, ee, W), c.afterUpdate && c.afterUpdate(G)); G._renderCallbacks.length; )
            G._renderCallbacks.pop().call(G);
          E || re || O();
        }
      }
      function Y(G) {
        c.beforeUnmount && c.beforeUnmount(G);
        var $ = G.base;
        G._disable = !0, G.componentWillUnmount && G.componentWillUnmount(), G.base = null;
        var ie = G._component;
        ie ? Y(ie) : $ && ($.__preactattr_ && $.__preactattr_.ref && $.__preactattr_.ref(null), N(G.nextBase = $), w.push(G), I($)), G.__ref && G.__ref(null);
      }
      function j(G, $) {
        this._dirty = !0, this.context = $, this.props = G, this.state = this.state || {}, this._renderCallbacks = [];
      }
      function J(G, $, ie) {
        return D(ie, G, {}, !1, $, !1);
      }
      f(j.prototype, { setState: function(G, $) {
        this.prevState || (this.prevState = this.state), this.state = f(f({}, this.state), typeof G == "function" ? G(this.state, this.props) : G), $ && this._renderCallbacks.push($), m(this);
      }, forceUpdate: function(G) {
        G && this._renderCallbacks.push(G), Z(this, 2);
      }, render: function() {
      } });
      var ae = { h, createElement: h, cloneElement: d, Component: j, render: J, rerender: A, options: c };
      r.default = ae;
    }, function(t, r) {
      var o = t.exports = { version: "2.5.7" };
      typeof __e == "number" && (__e = o);
    }, function(t, r, o) {
      var u = o(8), c = o(40);
      t.exports = o(3) ? function(l, i, h) {
        return u.f(l, i, c(1, h));
      } : function(l, i, h) {
        return l[i] = h, l;
      };
    }, function(t, r, o) {
      var u = o(9), c = o(38), l = o(39), i = Object.defineProperty;
      r.f = o(3) ? Object.defineProperty : function(h, f, p) {
        if (u(h), f = l(f, !0), u(p), c)
          try {
            return i(h, f, p);
          } catch {
          }
        if ("get" in p || "set" in p)
          throw TypeError("Accessors not supported!");
        return "value" in p && (h[f] = p.value), h;
      };
    }, function(t, r, o) {
      var u = o(2);
      t.exports = function(c) {
        if (!u(c))
          throw TypeError(c + " is not an object!");
        return c;
      };
    }, function(t, r) {
      var o = 0, u = Math.random();
      t.exports = function(c) {
        return "Symbol(".concat(c === void 0 ? "" : c, ")_", (++o + u).toString(36));
      };
    }, function(t, r, o) {
      var u = o(22);
      t.exports = Object("z").propertyIsEnumerable(0) ? Object : function(c) {
        return u(c) == "String" ? c.split("") : Object(c);
      };
    }, function(t, r) {
      t.exports = function(o) {
        if (o == null)
          throw TypeError("Can't call method on  " + o);
        return o;
      };
    }, function(t, r, o) {
      var u = o(4);
      t.exports = function(c, l) {
        return !!c && u(function() {
          l ? c.call(null, function() {
          }, 1) : c.call(null);
        });
      };
    }, function(t, r, o) {
      var u = o(0);
      u(u.S + u.F, "Object", { assign: o(41) });
    }, function(t, r, o) {
      var u = o(2), c = o(1).document, l = u(c) && u(c.createElement);
      t.exports = function(i) {
        return l ? c.createElement(i) : {};
      };
    }, function(t, r, o) {
      var u = o(1), c = o(7), l = o(17), i = o(10)("src"), h = "toString", f = Function[h], p = ("" + f).split(h);
      o(6).inspectSource = function(d) {
        return f.call(d);
      }, (t.exports = function(d, v, g, m) {
        var A = typeof g == "function";
        A && (l(g, "name") || c(g, "name", v)), d[v] !== g && (A && (l(g, i) || c(g, i, d[v] ? "" + d[v] : p.join(String(v)))), d === u ? d[v] = g : m ? d[v] ? d[v] = g : c(d, v, g) : (delete d[v], c(d, v, g)));
      })(Function.prototype, h, function() {
        return typeof this == "function" && this[i] || f.call(this);
      });
    }, function(t, r) {
      var o = {}.hasOwnProperty;
      t.exports = function(u, c) {
        return o.call(u, c);
      };
    }, function(t, r, o) {
      var u = o(19);
      t.exports = function(c, l, i) {
        if (u(c), l === void 0)
          return c;
        switch (i) {
          case 1:
            return function(h) {
              return c.call(l, h);
            };
          case 2:
            return function(h, f) {
              return c.call(l, h, f);
            };
          case 3:
            return function(h, f, p) {
              return c.call(l, h, f, p);
            };
        }
        return function() {
          return c.apply(l, arguments);
        };
      };
    }, function(t, r) {
      t.exports = function(o) {
        if (typeof o != "function")
          throw TypeError(o + " is not a function!");
        return o;
      };
    }, function(t, r, o) {
      var u = o(42), c = o(28);
      t.exports = Object.keys || function(l) {
        return u(l, c);
      };
    }, function(t, r, o) {
      var u = o(11), c = o(12);
      t.exports = function(l) {
        return u(c(l));
      };
    }, function(t, r) {
      var o = {}.toString;
      t.exports = function(u) {
        return o.call(u).slice(8, -1);
      };
    }, function(t, r, o) {
      var u = o(21), c = o(24), l = o(43);
      t.exports = function(i) {
        return function(h, f, p) {
          var d, v = u(h), g = c(v.length), m = l(p, g);
          if (i && f != f) {
            for (; m < g; )
              if ((d = v[m++]) != d)
                return !0;
          } else
            for (; m < g; m++)
              if ((i || m in v) && v[m] === f)
                return i || m || 0;
          return !i && -1;
        };
      };
    }, function(t, r, o) {
      var u = o(25), c = Math.min;
      t.exports = function(l) {
        return 0 < l ? c(u(l), 9007199254740991) : 0;
      };
    }, function(t, r) {
      var o = Math.ceil, u = Math.floor;
      t.exports = function(c) {
        return isNaN(c = +c) ? 0 : (0 < c ? u : o)(c);
      };
    }, function(t, r, o) {
      var u = o(27)("keys"), c = o(10);
      t.exports = function(l) {
        return u[l] || (u[l] = c(l));
      };
    }, function(t, r, o) {
      var u = o(6), c = o(1), l = "__core-js_shared__", i = c[l] || (c[l] = {});
      (t.exports = function(h, f) {
        return i[h] || (i[h] = f !== void 0 ? f : {});
      })("versions", []).push({ version: u.version, mode: o(44) ? "pure" : "global", copyright: "© 2018 Denis Pushkarev (zloirock.ru)" });
    }, function(t, r) {
      t.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
    }, function(t, r, o) {
      var u = o(12);
      t.exports = function(c) {
        return Object(u(c));
      };
    }, function(t, r, o) {
      var u = o(8).f, c = Function.prototype, l = /^\s*function ([^ (]*)/;
      "name" in c || o(3) && u(c, "name", { configurable: !0, get: function() {
        try {
          return ("" + this).match(l)[1];
        } catch {
          return "";
        }
      } });
    }, function(t, r, o) {
      var u = o(0), c = o(32)(1);
      u(u.P + u.F * !o(13)([].map, !0), "Array", { map: function(l) {
        return c(this, l, arguments[1]);
      } });
    }, function(t, r, o) {
      var u = o(18), c = o(11), l = o(29), i = o(24), h = o(47);
      t.exports = function(f, p) {
        var d = f == 1, v = f == 2, g = f == 3, m = f == 4, A = f == 6, b = f == 5 || A, S = p || h;
        return function(N, T, R) {
          for (var y, E, L = l(N), _ = c(L), O = u(T, R, 3), D = i(_.length), M = 0, C = d ? S(N, D) : v ? S(N, 0) : void 0; M < D; M++)
            if ((b || M in _) && (E = O(y = _[M], M, L), f)) {
              if (d)
                C[M] = E;
              else if (E)
                switch (f) {
                  case 3:
                    return !0;
                  case 5:
                    return y;
                  case 6:
                    return M;
                  case 2:
                    C.push(y);
                }
              else if (m)
                return !1;
            }
          return A ? -1 : g || m ? m : C;
        };
      };
    }, function(t, r, o) {
      var u = o(22);
      t.exports = Array.isArray || function(c) {
        return u(c) == "Array";
      };
    }, function(t, r, o) {
      var u = o(27)("wks"), c = o(10), l = o(1).Symbol, i = typeof l == "function";
      (t.exports = function(h) {
        return u[h] || (u[h] = i && l[h] || (i ? l : c)("Symbol." + h));
      }).store = u;
    }, function(t, r, o) {
      var u = o(0), c = o(23)(!1), l = [].indexOf, i = !!l && 1 / [1].indexOf(1, -0) < 0;
      u(u.P + u.F * (i || !o(13)(l)), "Array", { indexOf: function(h) {
        return i ? l.apply(this, arguments) || 0 : c(this, h, arguments[1]);
      } });
    }, function(t, r, o) {
      var u = o(0);
      u(u.S, "Object", { create: o(52) });
    }, function(t, r, o) {
      r.__esModule = !0, r.default = void 0, o(14), o(30), o(31), o(35), o(49), o(50);
      var u = o(5), c = function(p) {
        return p && p.__esModule ? p : { default: p };
      }(o(51));
      function l(f) {
        if (!f.element)
          throw new Error("element is not defined");
        if (!f.id)
          throw new Error("id is not defined");
        if (!f.source)
          throw new Error("source is not defined");
        Array.isArray(f.source) && (f.source = i(f.source)), (0, u.render)((0, u.createElement)(c.default, f), f.element);
      }
      var i = function(p) {
        return function(d, v) {
          v(p.filter(function(g) {
            return g.toLowerCase().indexOf(d.toLowerCase()) !== -1;
          }));
        };
      };
      l.enhanceSelectElement = function(f) {
        if (!f.selectElement)
          throw new Error("selectElement is not defined");
        if (!f.source) {
          var p = [].filter.call(f.selectElement.options, function(g) {
            return g.value || f.preserveNullOptions;
          });
          f.source = p.map(function(g) {
            return g.textContent || g.innerText;
          });
        }
        if (f.onConfirm = f.onConfirm || function(g) {
          var m = [].filter.call(f.selectElement.options, function(A) {
            return (A.textContent || A.innerText) === g;
          })[0];
          m && (m.selected = !0);
        }, f.selectElement.value || f.defaultValue === void 0) {
          var d = f.selectElement.options[f.selectElement.options.selectedIndex];
          f.defaultValue = d.textContent || d.innerText;
        }
        f.name === void 0 && (f.name = ""), f.id === void 0 && (f.selectElement.id === void 0 ? f.id = "" : f.id = f.selectElement.id), f.autoselect === void 0 && (f.autoselect = !0);
        var v = document.createElement("div");
        f.selectElement.parentNode.insertBefore(v, f.selectElement), l(Object.assign({}, f, { element: v })), f.selectElement.style.display = "none", f.selectElement.id = f.selectElement.id + "-select";
      };
      var h = l;
      r.default = h;
    }, function(t, r, o) {
      t.exports = !o(3) && !o(4)(function() {
        return Object.defineProperty(o(15)("div"), "a", { get: function() {
          return 7;
        } }).a != 7;
      });
    }, function(t, r, o) {
      var u = o(2);
      t.exports = function(c, l) {
        if (!u(c))
          return c;
        var i, h;
        if (l && typeof (i = c.toString) == "function" && !u(h = i.call(c)) || typeof (i = c.valueOf) == "function" && !u(h = i.call(c)) || !l && typeof (i = c.toString) == "function" && !u(h = i.call(c)))
          return h;
        throw TypeError("Can't convert object to primitive value");
      };
    }, function(t, r) {
      t.exports = function(o, u) {
        return { enumerable: !(1 & o), configurable: !(2 & o), writable: !(4 & o), value: u };
      };
    }, function(t, r, o) {
      var u = o(20), c = o(45), l = o(46), i = o(29), h = o(11), f = Object.assign;
      t.exports = !f || o(4)(function() {
        var p = {}, d = {}, v = Symbol(), g = "abcdefghijklmnopqrst";
        return p[v] = 7, g.split("").forEach(function(m) {
          d[m] = m;
        }), f({}, p)[v] != 7 || Object.keys(f({}, d)).join("") != g;
      }) ? function(p, d) {
        for (var v = i(p), g = arguments.length, m = 1, A = c.f, b = l.f; m < g; )
          for (var S, N = h(arguments[m++]), T = A ? u(N).concat(A(N)) : u(N), R = T.length, y = 0; y < R; )
            b.call(N, S = T[y++]) && (v[S] = N[S]);
        return v;
      } : f;
    }, function(t, r, o) {
      var u = o(17), c = o(21), l = o(23)(!1), i = o(26)("IE_PROTO");
      t.exports = function(h, f) {
        var p, d = c(h), v = 0, g = [];
        for (p in d)
          p != i && u(d, p) && g.push(p);
        for (; f.length > v; )
          u(d, p = f[v++]) && (~l(g, p) || g.push(p));
        return g;
      };
    }, function(t, r, o) {
      var u = o(25), c = Math.max, l = Math.min;
      t.exports = function(i, h) {
        return (i = u(i)) < 0 ? c(i + h, 0) : l(i, h);
      };
    }, function(t, r) {
      t.exports = !1;
    }, function(t, r) {
      r.f = Object.getOwnPropertySymbols;
    }, function(t, r) {
      r.f = {}.propertyIsEnumerable;
    }, function(t, r, o) {
      var u = o(48);
      t.exports = function(c, l) {
        return new (u(c))(l);
      };
    }, function(t, r, o) {
      var u = o(2), c = o(33), l = o(34)("species");
      t.exports = function(i) {
        var h;
        return c(i) && (typeof (h = i.constructor) != "function" || h !== Array && !c(h.prototype) || (h = void 0), u(h) && (h = h[l]) === null && (h = void 0)), h === void 0 ? Array : h;
      };
    }, function(t, r, o) {
      var u = o(0), c = o(32)(2);
      u(u.P + u.F * !o(13)([].filter, !0), "Array", { filter: function(l) {
        return c(this, l, arguments[1]);
      } });
    }, function(t, r, o) {
      var u = o(0);
      u(u.S, "Array", { isArray: o(33) });
    }, function(t, r, o) {
      r.__esModule = !0, r.default = void 0, o(14), o(36), o(30), o(31), o(35), o(55), o(58);
      var u = o(5), c = i(o(60)), l = i(o(61));
      function i(g) {
        return g && g.__esModule ? g : { default: g };
      }
      function h() {
        return (h = Object.assign || function(g) {
          for (var m = 1; m < arguments.length; m++) {
            var A = arguments[m];
            for (var b in A)
              Object.prototype.hasOwnProperty.call(A, b) && (g[b] = A[b]);
          }
          return g;
        }).apply(this, arguments);
      }
      function f(g) {
        if (g === void 0)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return g;
      }
      var p = { 13: "enter", 27: "escape", 32: "space", 38: "up", 40: "down" };
      function d() {
        return typeof navigator < "u" && !(!navigator.userAgent.match(/(iPod|iPhone|iPad)/g) || !navigator.userAgent.match(/AppleWebKit/g));
      }
      var v = function(g) {
        function m(b) {
          var S;
          return (S = g.call(this, b) || this).elementReferences = {}, S.state = { focused: null, hovered: null, menuOpen: !1, options: b.defaultValue ? [b.defaultValue] : [], query: b.defaultValue, validChoiceMade: !1, selected: null, ariaHint: !0 }, S.handleComponentBlur = S.handleComponentBlur.bind(f(f(S))), S.handleKeyDown = S.handleKeyDown.bind(f(f(S))), S.handleUpArrow = S.handleUpArrow.bind(f(f(S))), S.handleDownArrow = S.handleDownArrow.bind(f(f(S))), S.handleEnter = S.handleEnter.bind(f(f(S))), S.handlePrintableKey = S.handlePrintableKey.bind(f(f(S))), S.handleListMouseLeave = S.handleListMouseLeave.bind(f(f(S))), S.handleOptionBlur = S.handleOptionBlur.bind(f(f(S))), S.handleOptionClick = S.handleOptionClick.bind(f(f(S))), S.handleOptionFocus = S.handleOptionFocus.bind(f(f(S))), S.handleOptionMouseDown = S.handleOptionMouseDown.bind(f(f(S))), S.handleOptionMouseEnter = S.handleOptionMouseEnter.bind(f(f(S))), S.handleInputBlur = S.handleInputBlur.bind(f(f(S))), S.handleInputChange = S.handleInputChange.bind(f(f(S))), S.handleInputFocus = S.handleInputFocus.bind(f(f(S))), S.pollInputElement = S.pollInputElement.bind(f(f(S))), S.getDirectInputChanges = S.getDirectInputChanges.bind(f(f(S))), S;
        }
        (function(S, N) {
          S.prototype = Object.create(N.prototype), (S.prototype.constructor = S).__proto__ = N;
        })(m, g);
        var A = m.prototype;
        return A.isQueryAnOption = function(b, S) {
          var N = this;
          return S.map(function(T) {
            return N.templateInputValue(T).toLowerCase();
          }).indexOf(b.toLowerCase()) !== -1;
        }, A.componentDidMount = function() {
          this.pollInputElement();
        }, A.componentWillUnmount = function() {
          clearTimeout(this.$pollInput);
        }, A.pollInputElement = function() {
          var b = this;
          this.getDirectInputChanges(), this.$pollInput = setTimeout(function() {
            b.pollInputElement();
          }, 100);
        }, A.getDirectInputChanges = function() {
          var b = this.elementReferences[-1];
          b && b.value !== this.state.query && this.handleInputChange({ target: { value: b.value } });
        }, A.componentDidUpdate = function(b, S) {
          var N = this.state.focused, T = N === null, R = S.focused !== N;
          R && !T && this.elementReferences[N].focus();
          var y = N === -1, E = R && S.focused === null;
          if (y && E) {
            var L = this.elementReferences[N];
            L.setSelectionRange(0, L.value.length);
          }
        }, A.hasAutoselect = function() {
          return !d() && this.props.autoselect;
        }, A.templateInputValue = function(b) {
          var S = this.props.templates && this.props.templates.inputValue;
          return S ? S(b) : b;
        }, A.templateSuggestion = function(b) {
          var S = this.props.templates && this.props.templates.suggestion;
          return S ? S(b) : b;
        }, A.handleComponentBlur = function(b) {
          var S, N = this.state, T = N.options, R = N.query, y = N.selected;
          this.props.confirmOnBlur ? (S = b.query || R, this.props.onConfirm(T[y])) : S = R, this.setState({ focused: null, menuOpen: b.menuOpen || !1, query: S, selected: null, validChoiceMade: this.isQueryAnOption(S, T) });
        }, A.handleListMouseLeave = function(b) {
          this.setState({ hovered: null });
        }, A.handleOptionBlur = function(b, S) {
          var N = this.state, T = N.focused, R = N.menuOpen, y = N.options, E = N.selected, L = b.relatedTarget === null, _ = b.relatedTarget === this.elementReferences[-1], O = T !== S && T !== -1;
          if (!O && L || !(O || _)) {
            var D = R && d();
            this.handleComponentBlur({ menuOpen: D, query: this.templateInputValue(y[E]) });
          }
        }, A.handleInputBlur = function(b) {
          var S = this.state, N = S.focused, T = S.menuOpen, R = S.options, y = S.query, E = S.selected;
          if (N === -1) {
            var L = T && d(), _ = d() ? y : this.templateInputValue(R[E]);
            this.handleComponentBlur({ menuOpen: L, query: _ });
          }
        }, A.handleInputChange = function(b) {
          var S = this, N = this.props, T = N.minLength, R = N.source, y = N.showAllValues, E = this.hasAutoselect(), L = b.target.value, _ = L.length === 0, O = this.state.query.length !== L.length, D = L.length >= T;
          this.setState({ query: L, ariaHint: _ }), y || !_ && O && D ? R(L, function(M) {
            var C = 0 < M.length;
            S.setState({ menuOpen: C, options: M, selected: E && C ? 0 : -1, validChoiceMade: !1 });
          }) : !_ && D || this.setState({ menuOpen: !1, options: [] });
        }, A.handleInputClick = function(b) {
          this.handleInputChange(b);
        }, A.handleInputFocus = function(b) {
          var S = this.state, N = S.query, T = S.validChoiceMade, R = S.options, y = this.props.minLength, E = !T && N.length >= y && 0 < R.length;
          E ? this.setState(function(L) {
            var _ = L.menuOpen;
            return { focused: -1, menuOpen: E || _, selected: -1 };
          }) : this.setState({ focused: -1 });
        }, A.handleOptionFocus = function(b) {
          this.setState({ focused: b, hovered: null, selected: b });
        }, A.handleOptionMouseEnter = function(b, S) {
          d() || this.setState({ hovered: S });
        }, A.handleOptionClick = function(b, S) {
          var N = this.state.options[S], T = this.templateInputValue(N);
          this.props.onConfirm(N), this.setState({ focused: -1, hovered: null, menuOpen: !1, query: T, selected: -1, validChoiceMade: !0 }), this.forceUpdate();
        }, A.handleOptionMouseDown = function(b) {
          b.preventDefault();
        }, A.handleUpArrow = function(b) {
          b.preventDefault();
          var S = this.state, N = S.menuOpen, T = S.selected;
          T !== -1 && N && this.handleOptionFocus(T - 1);
        }, A.handleDownArrow = function(b) {
          var S = this;
          if (b.preventDefault(), this.props.showAllValues && this.state.menuOpen === !1)
            b.preventDefault(), this.props.source("", function(E) {
              S.setState({ menuOpen: !0, options: E, selected: 0, focused: 0, hovered: null });
            });
          else if (this.state.menuOpen === !0) {
            var N = this.state, T = N.menuOpen, R = N.options, y = N.selected;
            y !== R.length - 1 && T && this.handleOptionFocus(y + 1);
          }
        }, A.handleSpace = function(b) {
          var S = this;
          this.props.showAllValues && this.state.menuOpen === !1 && this.state.query === "" && (b.preventDefault(), this.props.source("", function(N) {
            S.setState({ menuOpen: !0, options: N });
          })), this.state.focused !== -1 && (b.preventDefault(), this.handleOptionClick(b, this.state.focused));
        }, A.handleEnter = function(b) {
          this.state.menuOpen && (b.preventDefault(), 0 <= this.state.selected && this.handleOptionClick(b, this.state.selected));
        }, A.handlePrintableKey = function(b) {
          var S = this.elementReferences[-1];
          b.target === S || S.focus();
        }, A.handleKeyDown = function(b) {
          switch (p[b.keyCode]) {
            case "up":
              this.handleUpArrow(b);
              break;
            case "down":
              this.handleDownArrow(b);
              break;
            case "space":
              this.handleSpace(b);
              break;
            case "enter":
              this.handleEnter(b);
              break;
            case "escape":
              this.handleComponentBlur({ query: this.state.query });
              break;
            default:
              (function(N) {
                return 47 < N && N < 58 || N === 32 || N === 8 || 64 < N && N < 91 || 95 < N && N < 112 || 185 < N && N < 193 || 218 < N && N < 223;
              })(b.keyCode) && this.handlePrintableKey(b);
          }
        }, A.render = function() {
          var b, S = this, N = this.props, T = N.cssNamespace, R = N.displayMenu, y = N.id, E = N.minLength, L = N.name, _ = N.placeholder, O = N.required, D = N.showAllValues, M = N.tNoResults, C = N.tStatusQueryTooShort, I = N.tStatusNoResults, w = N.tStatusSelectedOption, F = N.tStatusResults, k = N.tAssistiveHint, H = N.dropdownArrow, Z = this.state, Y = Z.focused, j = Z.hovered, J = Z.menuOpen, ae = Z.options, G = Z.query, $ = Z.selected, ie = Z.ariaHint, re = Z.validChoiceMade, ce = this.hasAutoselect(), z = Y === -1, oe = ae.length === 0, de = G.length !== 0, pe = G.length >= E, he = this.props.showNoOptionsFound && z && oe && de && pe, se = T + "__wrapper", ee = T + "__input", te = Y !== null ? " " + ee + "--focused" : "", le = this.props.showAllValues ? " " + ee + "--show-all-values" : " " + ee + "--default", ne = T + "__dropdown-arrow-down", x = Y !== -1 && Y !== null, P = T + "__menu", B = P + "--" + R, W = P + "--" + (J || he ? "visible" : "hidden"), X = T + "__option", K = T + "__hint", U = this.templateInputValue(ae[$]), V = U && U.toLowerCase().indexOf(G.toLowerCase()) === 0 && ce ? G + U.substr(G.length) : "", Q = y + "__assistiveHint", fe = ie ? { "aria-describedby": Q } : null;
          return D && typeof (b = H({ className: ne })) == "string" && (b = (0, u.createElement)("div", { className: T + "__dropdown-arrow-down-wrapper", dangerouslySetInnerHTML: { __html: b } })), (0, u.createElement)("div", { className: se, onKeyDown: this.handleKeyDown }, (0, u.createElement)(c.default, { id: y, length: ae.length, queryLength: G.length, minQueryLength: E, selectedOption: this.templateInputValue(ae[$]), selectedOptionIndex: $, validChoiceMade: re, isInFocus: this.state.focused !== null, tQueryTooShort: C, tNoResults: I, tSelectedOption: w, tResults: F }), V && (0, u.createElement)("span", null, (0, u.createElement)("input", { className: K, readonly: !0, tabIndex: "-1", value: V })), (0, u.createElement)("input", h({ "aria-expanded": J ? "true" : "false", "aria-activedescendant": !!x && y + "__option--" + Y, "aria-owns": y + "__listbox", "aria-autocomplete": this.hasAutoselect() ? "both" : "list" }, fe, { autoComplete: "off", className: "" + ee + te + le, id: y, onClick: function(ue) {
            return S.handleInputClick(ue);
          }, onBlur: this.handleInputBlur }, function(q) {
            return { onInput: q };
          }(this.handleInputChange), { onFocus: this.handleInputFocus, name: L, placeholder: _, ref: function(ue) {
            S.elementReferences[-1] = ue;
          }, type: "text", role: "combobox", required: O, value: G })), b, (0, u.createElement)("ul", { className: P + " " + B + " " + W, onMouseLeave: function(ue) {
            return S.handleListMouseLeave(ue);
          }, id: y + "__listbox", role: "listbox" }, ae.map(function(ue, q) {
            var _e = (Y === -1 ? $ === q : Y === q) && j === null ? " " + X + "--focused" : "", ge = q % 2 ? " " + X + "--odd" : "", Ce = d() ? "<span id=" + y + "__option-suffix--" + q + ' style="border:0;clip:rect(0 0 0 0);height:1px;marginBottom:-1px;marginRight:-1px;overflow:hidden;padding:0;position:absolute;whiteSpace:nowrap;width:1px"> ' + (q + 1) + " of " + ae.length + "</span>" : "";
            return (0, u.createElement)("li", { "aria-selected": Y === q ? "true" : "false", className: "" + X + _e + ge, dangerouslySetInnerHTML: { __html: S.templateSuggestion(ue) + Ce }, id: y + "__option--" + q, key: q, onBlur: function(Ee) {
              return S.handleOptionBlur(Ee, q);
            }, onClick: function(Ee) {
              return S.handleOptionClick(Ee, q);
            }, onMouseDown: S.handleOptionMouseDown, onMouseEnter: function(Ee) {
              return S.handleOptionMouseEnter(Ee, q);
            }, ref: function(Ee) {
              S.elementReferences[q] = Ee;
            }, role: "option", tabIndex: "-1", "aria-posinset": q + 1, "aria-setsize": ae.length });
          }), he && (0, u.createElement)("li", { className: X + " " + X + "--no-results" }, M())), (0, u.createElement)("span", { id: Q, style: { display: "none" } }, k()));
        }, m;
      }(u.Component);
      (r.default = v).defaultProps = { autoselect: !1, cssNamespace: "autocomplete", defaultValue: "", displayMenu: "inline", minLength: 0, name: "input-autocomplete", placeholder: "", onConfirm: function() {
      }, confirmOnBlur: !0, showNoOptionsFound: !0, showAllValues: !1, required: !1, tNoResults: function() {
        return "No results found";
      }, tAssistiveHint: function() {
        return "When autocomplete results are available use up and down arrows to review and enter to select.  Touch device users, explore by touch or with swipe gestures.";
      }, dropdownArrow: l.default };
    }, function(t, r, o) {
      var u = o(9), c = o(53), l = o(28), i = o(26)("IE_PROTO"), h = function() {
      }, f = "prototype", p = function() {
        var d, v = o(15)("iframe"), g = l.length;
        for (v.style.display = "none", o(54).appendChild(v), v.src = "javascript:", (d = v.contentWindow.document).open(), d.write("<script>document.F=Object<\/script>"), d.close(), p = d.F; g--; )
          delete p[f][l[g]];
        return p();
      };
      t.exports = Object.create || function(d, v) {
        var g;
        return d !== null ? (h[f] = u(d), g = new h(), h[f] = null, g[i] = d) : g = p(), v === void 0 ? g : c(g, v);
      };
    }, function(t, r, o) {
      var u = o(8), c = o(9), l = o(20);
      t.exports = o(3) ? Object.defineProperties : function(i, h) {
        c(i);
        for (var f, p = l(h), d = p.length, v = 0; v < d; )
          u.f(i, f = p[v++], h[f]);
        return i;
      };
    }, function(t, r, o) {
      var u = o(1).document;
      t.exports = u && u.documentElement;
    }, function(t, r, o) {
      var u = o(0);
      u(u.P, "Function", { bind: o(56) });
    }, function(t, r, o) {
      var u = o(19), c = o(2), l = o(57), i = [].slice, h = {};
      t.exports = Function.bind || function(f) {
        var p = u(this), d = i.call(arguments, 1), v = function() {
          var g = d.concat(i.call(arguments));
          return this instanceof v ? function(m, A, b) {
            if (!(A in h)) {
              for (var S = [], N = 0; N < A; N++)
                S[N] = "a[" + N + "]";
              h[A] = Function("F,a", "return new F(" + S.join(",") + ")");
            }
            return h[A](m, b);
          }(p, g.length, g) : l(p, g, f);
        };
        return c(p.prototype) && (v.prototype = p.prototype), v;
      };
    }, function(t, r) {
      t.exports = function(o, u, c) {
        var l = c === void 0;
        switch (u.length) {
          case 0:
            return l ? o() : o.call(c);
          case 1:
            return l ? o(u[0]) : o.call(c, u[0]);
          case 2:
            return l ? o(u[0], u[1]) : o.call(c, u[0], u[1]);
          case 3:
            return l ? o(u[0], u[1], u[2]) : o.call(c, u[0], u[1], u[2]);
          case 4:
            return l ? o(u[0], u[1], u[2], u[3]) : o.call(c, u[0], u[1], u[2], u[3]);
        }
        return o.apply(c, u);
      };
    }, function(t, r, o) {
      o(59)("match", 1, function(u, c, l) {
        return [function(i) {
          var h = u(this), f = i == null ? void 0 : i[c];
          return f !== void 0 ? f.call(i, h) : new RegExp(i)[c](String(h));
        }, l];
      });
    }, function(t, r, o) {
      var u = o(7), c = o(16), l = o(4), i = o(12), h = o(34);
      t.exports = function(f, p, d) {
        var v = h(f), g = d(i, v, ""[f]), m = g[0], A = g[1];
        l(function() {
          var b = {};
          return b[v] = function() {
            return 7;
          }, ""[f](b) != 7;
        }) && (c(String.prototype, f, m), u(RegExp.prototype, v, p == 2 ? function(b, S) {
          return A.call(b, this, S);
        } : function(b) {
          return A.call(b, this);
        }));
      };
    }, function(t, r, o) {
      r.__esModule = !0, r.default = void 0, o(36);
      var u = o(5), c = function(h, f, p) {
        var d;
        return function() {
          var v = this, g = arguments, m = function() {
            d = null, p || h.apply(v, g);
          }, A = p && !d;
          clearTimeout(d), d = setTimeout(m, f), A && h.apply(v, g);
        };
      }, l = function(i) {
        function h() {
          for (var p, d = arguments.length, v = new Array(d), g = 0; g < d; g++)
            v[g] = arguments[g];
          return (p = i.call.apply(i, [this].concat(v)) || this).state = { bump: !1, debounced: !1 }, p;
        }
        (function(d, v) {
          d.prototype = Object.create(v.prototype), (d.prototype.constructor = d).__proto__ = v;
        })(h, i);
        var f = h.prototype;
        return f.componentWillMount = function() {
          var p = this;
          this.debounceStatusUpdate = c(function() {
            if (!p.state.debounced) {
              var d = !p.props.isInFocus || p.props.validChoiceMade;
              p.setState(function(v) {
                return { bump: !v.bump, debounced: !0, silenced: d };
              });
            }
          }, 1400);
        }, f.componentWillReceiveProps = function(p) {
          p.queryLength, this.setState({ debounced: !1 });
        }, f.render = function() {
          var p = this.props, d = p.id, v = p.length, g = p.queryLength, m = p.minQueryLength, A = p.selectedOption, b = p.selectedOptionIndex, S = p.tQueryTooShort, N = p.tNoResults, T = p.tSelectedOption, R = p.tResults, y = this.state, E = y.bump, L = y.debounced, _ = y.silenced, O = g < m, D = v === 0, M = A ? T(A, v, b) : "", C = null;
          return C = O ? S(m) : D ? N() : R(v, M), this.debounceStatusUpdate(), (0, u.createElement)("div", { style: { border: "0", clip: "rect(0 0 0 0)", height: "1px", marginBottom: "-1px", marginRight: "-1px", overflow: "hidden", padding: "0", position: "absolute", whiteSpace: "nowrap", width: "1px" } }, (0, u.createElement)("div", { id: d + "__status--A", role: "status", "aria-atomic": "true", "aria-live": "polite" }, !_ && L && E ? C : ""), (0, u.createElement)("div", { id: d + "__status--B", role: "status", "aria-atomic": "true", "aria-live": "polite" }, _ || !L || E ? "" : C));
        }, h;
      }(u.Component);
      (r.default = l).defaultProps = { tQueryTooShort: function(i) {
        return "Type in " + i + " or more characters for results";
      }, tNoResults: function() {
        return "No search results";
      }, tSelectedOption: function(i, h, f) {
        return i + " " + (f + 1) + " of " + h + " is highlighted";
      }, tResults: function(i, h) {
        return i + " " + (i === 1 ? "result" : "results") + " " + (i === 1 ? "is" : "are") + " available. " + h;
      } };
    }, function(t, r, o) {
      r.__esModule = !0, r.default = void 0;
      var u = o(5), c = function(i) {
        var h = i.className;
        return (0, u.createElement)("svg", { version: "1.1", xmlns: "http://www.w3.org/2000/svg", className: h, focusable: "false" }, (0, u.createElement)("g", { stroke: "none", fill: "none", "fill-rule": "evenodd" }, (0, u.createElement)("polygon", { fill: "#000000", points: "0 0 22 0 11 17" })));
      };
      r.default = c;
    }]).default;
  });
})(mg);
var FA = mg.exports;
const UA = /* @__PURE__ */ Gl(FA), kA = "selectautocomplete";
class KA extends Ea {
  constructor(e, t) {
    super(e), this._config = t, this._enhance();
  }
  // Getters
  static get NAME() {
    return kA;
  }
  // Public
  // Private
  _enhance() {
    UA.enhanceSelectElement(Object.assign({}, { selectElement: this._element }, this._config));
  }
}
const jA = "collapse", WA = "bs.collapse", Ds = `.${WA}`, VA = ".data-api", HA = `show${Ds}`, $A = `shown${Ds}`, GA = `hide${Ds}`, zA = `hidden${Ds}`, YA = `click${Ds}${VA}`, bu = "show", Ua = "collapse", Vs = "collapsing", XA = "collapsed", QA = `:scope .${Ua} .${Ua}`, JA = "collapse-horizontal", ZA = "width", qA = "height", eS = ".collapse.show, .collapse.collapsing", Nc = '[data-bs-toggle="collapse"]', tS = {
  parent: null,
  toggle: !0
}, nS = {
  parent: "(null|element)",
  toggle: "boolean"
};
let zf = class Lc extends Ea {
  constructor(e, t) {
    super(e, t), this._isTransitioning = !1, this._triggerArray = [];
    const r = An.find(Nc);
    for (const o of r) {
      const u = qm(o), c = An.find(u).filter((l) => l === this._element);
      u !== null && c.length && this._triggerArray.push(o);
    }
    this._initializeChildren(), this._config.parent || this._addAriaAndCollapsedClass(this._triggerArray, this._isShown()), this._config.toggle && this.toggle();
  }
  // Getters
  static get Default() {
    return tS;
  }
  static get DefaultType() {
    return nS;
  }
  static get NAME() {
    return jA;
  }
  // Public
  toggle() {
    this._isShown() ? this.hide() : this.show();
  }
  show() {
    if (this._isTransitioning || this._isShown())
      return;
    let e = [];
    if (this._config.parent && (e = this._getFirstLevelChildren(eS).filter((l) => l !== this._element).map((l) => Lc.getOrCreateInstance(l, { toggle: !1 }))), e.length && e[0]._isTransitioning || Gt.trigger(this._element, HA).defaultPrevented)
      return;
    for (const l of e)
      l.hide();
    const r = this._getDimension();
    this._element.classList.remove(Ua), this._element.classList.add(Vs), this._element.style[r] = 0, this._addAriaAndCollapsedClass(this._triggerArray, !0), this._isTransitioning = !0;
    const o = () => {
      this._isTransitioning = !1, this._element.classList.remove(Vs), this._element.classList.add(Ua, bu), this._element.style[r] = "", Gt.trigger(this._element, $A);
    }, c = `scroll${r[0].toUpperCase() + r.slice(1)}`;
    this._queueCallback(o, this._element, !0), this._element.style[r] = `${this._element[c]}px`;
  }
  hide() {
    if (this._isTransitioning || !this._isShown() || Gt.trigger(this._element, GA).defaultPrevented)
      return;
    const t = this._getDimension();
    this._element.style[t] = `${this._element.getBoundingClientRect()[t]}px`, Uf(this._element), this._element.classList.add(Vs), this._element.classList.remove(Ua, bu);
    for (const o of this._triggerArray) {
      const u = ia(o);
      u && !this._isShown(u) && this._addAriaAndCollapsedClass([o], !1);
    }
    this._isTransitioning = !0;
    const r = () => {
      this._isTransitioning = !1, this._element.classList.remove(Vs), this._element.classList.add(Ua), Gt.trigger(this._element, zA);
    };
    this._element.style[t] = "", this._queueCallback(r, this._element, !0);
  }
  _isShown(e = this._element) {
    return e.classList.contains(bu);
  }
  // Private
  _configAfterMerge(e) {
    return e.toggle = !!e.toggle, e.parent = ml(e.parent), e;
  }
  _getDimension() {
    return this._element.classList.contains(JA) ? ZA : qA;
  }
  _initializeChildren() {
    if (!this._config.parent)
      return;
    const e = this._getFirstLevelChildren(Nc);
    for (const t of e) {
      const r = ia(t);
      r && this._addAriaAndCollapsedClass([t], this._isShown(r));
    }
  }
  _getFirstLevelChildren(e) {
    const t = An.find(QA, this._config.parent);
    return An.find(e, this._config.parent).filter((r) => !t.includes(r));
  }
  _addAriaAndCollapsedClass(e, t) {
    if (e.length)
      for (const r of e)
        r.classList.toggle(XA, !t), r.setAttribute("aria-expanded", t);
  }
  // Static
  static jQueryInterface(e) {
    const t = {};
    return typeof e == "string" && /show|hide/.test(e) && (t.toggle = !1), this.each(function() {
      const r = Lc.getOrCreateInstance(this, t);
      if (typeof e == "string") {
        if (typeof r[e] > "u")
          throw new TypeError(`No method named "${e}"`);
        r[e]();
      }
    });
  }
};
Gt.on(document, YA, Nc, function(n) {
  (n.target.tagName === "A" || n.delegateTarget && n.delegateTarget.tagName === "A") && n.preventDefault();
  const e = qm(this), t = An.find(e);
  for (const r of t)
    zf.getOrCreateInstance(r, { toggle: !1 }).toggle();
});
Hl(zf);
const rS = zf;
class iS extends rS {
}
var Jn = "top", vr = "bottom", _r = "right", Zn = "left", zl = "auto", Os = [Jn, vr, _r, Zn], eo = "start", us = "end", aS = "clippingParents", gg = "viewport", Do = "popper", oS = "reference", eh = /* @__PURE__ */ Os.reduce(function(n, e) {
  return n.concat([e + "-" + eo, e + "-" + us]);
}, []), vg = /* @__PURE__ */ [].concat(Os, [zl]).reduce(function(n, e) {
  return n.concat([e, e + "-" + eo, e + "-" + us]);
}, []), sS = "beforeRead", lS = "read", uS = "afterRead", cS = "beforeMain", fS = "main", dS = "afterMain", hS = "beforeWrite", pS = "write", mS = "afterWrite", wc = [sS, lS, uS, cS, fS, dS, hS, pS, mS];
function jr(n) {
  return n ? (n.nodeName || "").toLowerCase() : null;
}
function Er(n) {
  if (n == null)
    return window;
  if (n.toString() !== "[object Window]") {
    var e = n.ownerDocument;
    return e && e.defaultView || window;
  }
  return n;
}
function ma(n) {
  var e = Er(n).Element;
  return n instanceof e || n instanceof Element;
}
function sr(n) {
  var e = Er(n).HTMLElement;
  return n instanceof e || n instanceof HTMLElement;
}
function Yf(n) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = Er(n).ShadowRoot;
  return n instanceof e || n instanceof ShadowRoot;
}
function gS(n) {
  var e = n.state;
  Object.keys(e.elements).forEach(function(t) {
    var r = e.styles[t] || {}, o = e.attributes[t] || {}, u = e.elements[t];
    !sr(u) || !jr(u) || (Object.assign(u.style, r), Object.keys(o).forEach(function(c) {
      var l = o[c];
      l === !1 ? u.removeAttribute(c) : u.setAttribute(c, l === !0 ? "" : l);
    }));
  });
}
function vS(n) {
  var e = n.state, t = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, t.popper), e.styles = t, e.elements.arrow && Object.assign(e.elements.arrow.style, t.arrow), function() {
    Object.keys(e.elements).forEach(function(r) {
      var o = e.elements[r], u = e.attributes[r] || {}, c = Object.keys(e.styles.hasOwnProperty(r) ? e.styles[r] : t[r]), l = c.reduce(function(i, h) {
        return i[h] = "", i;
      }, {});
      !sr(o) || !jr(o) || (Object.assign(o.style, l), Object.keys(u).forEach(function(i) {
        o.removeAttribute(i);
      }));
    });
  };
}
const _g = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: gS,
  effect: vS,
  requires: ["computeStyles"]
};
function Sr(n) {
  return n.split("-")[0];
}
var aa = Math.max, gl = Math.min, to = Math.round;
function xc() {
  var n = navigator.userAgentData;
  return n != null && n.brands ? n.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function Eg() {
  return !/^((?!chrome|android).)*safari/i.test(xc());
}
function no(n, e, t) {
  e === void 0 && (e = !1), t === void 0 && (t = !1);
  var r = n.getBoundingClientRect(), o = 1, u = 1;
  e && sr(n) && (o = n.offsetWidth > 0 && to(r.width) / n.offsetWidth || 1, u = n.offsetHeight > 0 && to(r.height) / n.offsetHeight || 1);
  var c = ma(n) ? Er(n) : window, l = c.visualViewport, i = !Eg() && t, h = (r.left + (i && l ? l.offsetLeft : 0)) / o, f = (r.top + (i && l ? l.offsetTop : 0)) / u, p = r.width / o, d = r.height / u;
  return {
    width: p,
    height: d,
    top: f,
    right: h + p,
    bottom: f + d,
    left: h,
    x: h,
    y: f
  };
}
function Xf(n) {
  var e = no(n), t = n.offsetWidth, r = n.offsetHeight;
  return Math.abs(e.width - t) <= 1 && (t = e.width), Math.abs(e.height - r) <= 1 && (r = e.height), {
    x: n.offsetLeft,
    y: n.offsetTop,
    width: t,
    height: r
  };
}
function yg(n, e) {
  var t = e.getRootNode && e.getRootNode();
  if (n.contains(e))
    return !0;
  if (t && Yf(t)) {
    var r = e;
    do {
      if (r && n.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function Mr(n) {
  return Er(n).getComputedStyle(n);
}
function _S(n) {
  return ["table", "td", "th"].indexOf(jr(n)) >= 0;
}
function xi(n) {
  return ((ma(n) ? n.ownerDocument : (
    // $FlowFixMe[prop-missing]
    n.document
  )) || window.document).documentElement;
}
function Yl(n) {
  return jr(n) === "html" ? n : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    n.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    n.parentNode || // DOM Element detected
    (Yf(n) ? n.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    xi(n)
  );
}
function th(n) {
  return !sr(n) || // https://github.com/popperjs/popper-core/issues/837
  Mr(n).position === "fixed" ? null : n.offsetParent;
}
function ES(n) {
  var e = /firefox/i.test(xc()), t = /Trident/i.test(xc());
  if (t && sr(n)) {
    var r = Mr(n);
    if (r.position === "fixed")
      return null;
  }
  var o = Yl(n);
  for (Yf(o) && (o = o.host); sr(o) && ["html", "body"].indexOf(jr(o)) < 0; ) {
    var u = Mr(o);
    if (u.transform !== "none" || u.perspective !== "none" || u.contain === "paint" || ["transform", "perspective"].indexOf(u.willChange) !== -1 || e && u.willChange === "filter" || e && u.filter && u.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function Ps(n) {
  for (var e = Er(n), t = th(n); t && _S(t) && Mr(t).position === "static"; )
    t = th(t);
  return t && (jr(t) === "html" || jr(t) === "body" && Mr(t).position === "static") ? e : t || ES(n) || e;
}
function Qf(n) {
  return ["top", "bottom"].indexOf(n) >= 0 ? "x" : "y";
}
function Vo(n, e, t) {
  return aa(n, gl(e, t));
}
function yS(n, e, t) {
  var r = Vo(n, e, t);
  return r > t ? t : r;
}
function Tg() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Ag(n) {
  return Object.assign({}, Tg(), n);
}
function Sg(n, e) {
  return e.reduce(function(t, r) {
    return t[r] = n, t;
  }, {});
}
var TS = function(e, t) {
  return e = typeof e == "function" ? e(Object.assign({}, t.rects, {
    placement: t.placement
  })) : e, Ag(typeof e != "number" ? e : Sg(e, Os));
};
function AS(n) {
  var e, t = n.state, r = n.name, o = n.options, u = t.elements.arrow, c = t.modifiersData.popperOffsets, l = Sr(t.placement), i = Qf(l), h = [Zn, _r].indexOf(l) >= 0, f = h ? "height" : "width";
  if (!(!u || !c)) {
    var p = TS(o.padding, t), d = Xf(u), v = i === "y" ? Jn : Zn, g = i === "y" ? vr : _r, m = t.rects.reference[f] + t.rects.reference[i] - c[i] - t.rects.popper[f], A = c[i] - t.rects.reference[i], b = Ps(u), S = b ? i === "y" ? b.clientHeight || 0 : b.clientWidth || 0 : 0, N = m / 2 - A / 2, T = p[v], R = S - d[f] - p[g], y = S / 2 - d[f] / 2 + N, E = Vo(T, y, R), L = i;
    t.modifiersData[r] = (e = {}, e[L] = E, e.centerOffset = E - y, e);
  }
}
function SS(n) {
  var e = n.state, t = n.options, r = t.element, o = r === void 0 ? "[data-popper-arrow]" : r;
  if (o != null && !(typeof o == "string" && (o = e.elements.popper.querySelector(o), !o))) {
    if (process.env.NODE_ENV !== "production" && (sr(o) || console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', "To use an SVG arrow, wrap it in an HTMLElement that will be used as", "the arrow."].join(" "))), !yg(e.elements.popper, o)) {
      process.env.NODE_ENV !== "production" && console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', "element."].join(" "));
      return;
    }
    e.elements.arrow = o;
  }
}
const CS = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: AS,
  effect: SS,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function ro(n) {
  return n.split("-")[1];
}
var MS = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function bS(n) {
  var e = n.x, t = n.y, r = window, o = r.devicePixelRatio || 1;
  return {
    x: to(e * o) / o || 0,
    y: to(t * o) / o || 0
  };
}
function nh(n) {
  var e, t = n.popper, r = n.popperRect, o = n.placement, u = n.variation, c = n.offsets, l = n.position, i = n.gpuAcceleration, h = n.adaptive, f = n.roundOffsets, p = n.isFixed, d = c.x, v = d === void 0 ? 0 : d, g = c.y, m = g === void 0 ? 0 : g, A = typeof f == "function" ? f({
    x: v,
    y: m
  }) : {
    x: v,
    y: m
  };
  v = A.x, m = A.y;
  var b = c.hasOwnProperty("x"), S = c.hasOwnProperty("y"), N = Zn, T = Jn, R = window;
  if (h) {
    var y = Ps(t), E = "clientHeight", L = "clientWidth";
    if (y === Er(t) && (y = xi(t), Mr(y).position !== "static" && l === "absolute" && (E = "scrollHeight", L = "scrollWidth")), y = y, o === Jn || (o === Zn || o === _r) && u === us) {
      T = vr;
      var _ = p && y === R && R.visualViewport ? R.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        y[E]
      );
      m -= _ - r.height, m *= i ? 1 : -1;
    }
    if (o === Zn || (o === Jn || o === vr) && u === us) {
      N = _r;
      var O = p && y === R && R.visualViewport ? R.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        y[L]
      );
      v -= O - r.width, v *= i ? 1 : -1;
    }
  }
  var D = Object.assign({
    position: l
  }, h && MS), M = f === !0 ? bS({
    x: v,
    y: m
  }) : {
    x: v,
    y: m
  };
  if (v = M.x, m = M.y, i) {
    var C;
    return Object.assign({}, D, (C = {}, C[T] = S ? "0" : "", C[N] = b ? "0" : "", C.transform = (R.devicePixelRatio || 1) <= 1 ? "translate(" + v + "px, " + m + "px)" : "translate3d(" + v + "px, " + m + "px, 0)", C));
  }
  return Object.assign({}, D, (e = {}, e[T] = S ? m + "px" : "", e[N] = b ? v + "px" : "", e.transform = "", e));
}
function RS(n) {
  var e = n.state, t = n.options, r = t.gpuAcceleration, o = r === void 0 ? !0 : r, u = t.adaptive, c = u === void 0 ? !0 : u, l = t.roundOffsets, i = l === void 0 ? !0 : l;
  if (process.env.NODE_ENV !== "production") {
    var h = Mr(e.elements.popper).transitionProperty || "";
    c && ["transform", "top", "right", "bottom", "left"].some(function(p) {
      return h.indexOf(p) >= 0;
    }) && console.warn(["Popper: Detected CSS transitions on at least one of the following", 'CSS properties: "transform", "top", "right", "bottom", "left".', `

`, 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', "for smooth transitions, or remove these properties from the CSS", "transition declaration on the popper element if only transitioning", "opacity or background-color for example.", `

`, "We recommend using the popper element as a wrapper around an inner", "element that can have any CSS property transitioned for animations."].join(" "));
  }
  var f = {
    placement: Sr(e.placement),
    variation: ro(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: o,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, nh(Object.assign({}, f, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: c,
    roundOffsets: i
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, nh(Object.assign({}, f, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: i
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const DS = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: RS,
  data: {}
};
var Hs = {
  passive: !0
};
function OS(n) {
  var e = n.state, t = n.instance, r = n.options, o = r.scroll, u = o === void 0 ? !0 : o, c = r.resize, l = c === void 0 ? !0 : c, i = Er(e.elements.popper), h = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return u && h.forEach(function(f) {
    f.addEventListener("scroll", t.update, Hs);
  }), l && i.addEventListener("resize", t.update, Hs), function() {
    u && h.forEach(function(f) {
      f.removeEventListener("scroll", t.update, Hs);
    }), l && i.removeEventListener("resize", t.update, Hs);
  };
}
const PS = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: OS,
  data: {}
};
var IS = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function il(n) {
  return n.replace(/left|right|bottom|top/g, function(e) {
    return IS[e];
  });
}
var NS = {
  start: "end",
  end: "start"
};
function rh(n) {
  return n.replace(/start|end/g, function(e) {
    return NS[e];
  });
}
function Jf(n) {
  var e = Er(n), t = e.pageXOffset, r = e.pageYOffset;
  return {
    scrollLeft: t,
    scrollTop: r
  };
}
function Zf(n) {
  return no(xi(n)).left + Jf(n).scrollLeft;
}
function LS(n, e) {
  var t = Er(n), r = xi(n), o = t.visualViewport, u = r.clientWidth, c = r.clientHeight, l = 0, i = 0;
  if (o) {
    u = o.width, c = o.height;
    var h = Eg();
    (h || !h && e === "fixed") && (l = o.offsetLeft, i = o.offsetTop);
  }
  return {
    width: u,
    height: c,
    x: l + Zf(n),
    y: i
  };
}
function wS(n) {
  var e, t = xi(n), r = Jf(n), o = (e = n.ownerDocument) == null ? void 0 : e.body, u = aa(t.scrollWidth, t.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), c = aa(t.scrollHeight, t.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), l = -r.scrollLeft + Zf(n), i = -r.scrollTop;
  return Mr(o || t).direction === "rtl" && (l += aa(t.clientWidth, o ? o.clientWidth : 0) - u), {
    width: u,
    height: c,
    x: l,
    y: i
  };
}
function qf(n) {
  var e = Mr(n), t = e.overflow, r = e.overflowX, o = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(t + o + r);
}
function Cg(n) {
  return ["html", "body", "#document"].indexOf(jr(n)) >= 0 ? n.ownerDocument.body : sr(n) && qf(n) ? n : Cg(Yl(n));
}
function Ho(n, e) {
  var t;
  e === void 0 && (e = []);
  var r = Cg(n), o = r === ((t = n.ownerDocument) == null ? void 0 : t.body), u = Er(r), c = o ? [u].concat(u.visualViewport || [], qf(r) ? r : []) : r, l = e.concat(c);
  return o ? l : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    l.concat(Ho(Yl(c)))
  );
}
function Bc(n) {
  return Object.assign({}, n, {
    left: n.x,
    top: n.y,
    right: n.x + n.width,
    bottom: n.y + n.height
  });
}
function xS(n, e) {
  var t = no(n, !1, e === "fixed");
  return t.top = t.top + n.clientTop, t.left = t.left + n.clientLeft, t.bottom = t.top + n.clientHeight, t.right = t.left + n.clientWidth, t.width = n.clientWidth, t.height = n.clientHeight, t.x = t.left, t.y = t.top, t;
}
function ih(n, e, t) {
  return e === gg ? Bc(LS(n, t)) : ma(e) ? xS(e, t) : Bc(wS(xi(n)));
}
function BS(n) {
  var e = Ho(Yl(n)), t = ["absolute", "fixed"].indexOf(Mr(n).position) >= 0, r = t && sr(n) ? Ps(n) : n;
  return ma(r) ? e.filter(function(o) {
    return ma(o) && yg(o, r) && jr(o) !== "body";
  }) : [];
}
function FS(n, e, t, r) {
  var o = e === "clippingParents" ? BS(n) : [].concat(e), u = [].concat(o, [t]), c = u[0], l = u.reduce(function(i, h) {
    var f = ih(n, h, r);
    return i.top = aa(f.top, i.top), i.right = gl(f.right, i.right), i.bottom = gl(f.bottom, i.bottom), i.left = aa(f.left, i.left), i;
  }, ih(n, c, r));
  return l.width = l.right - l.left, l.height = l.bottom - l.top, l.x = l.left, l.y = l.top, l;
}
function Mg(n) {
  var e = n.reference, t = n.element, r = n.placement, o = r ? Sr(r) : null, u = r ? ro(r) : null, c = e.x + e.width / 2 - t.width / 2, l = e.y + e.height / 2 - t.height / 2, i;
  switch (o) {
    case Jn:
      i = {
        x: c,
        y: e.y - t.height
      };
      break;
    case vr:
      i = {
        x: c,
        y: e.y + e.height
      };
      break;
    case _r:
      i = {
        x: e.x + e.width,
        y: l
      };
      break;
    case Zn:
      i = {
        x: e.x - t.width,
        y: l
      };
      break;
    default:
      i = {
        x: e.x,
        y: e.y
      };
  }
  var h = o ? Qf(o) : null;
  if (h != null) {
    var f = h === "y" ? "height" : "width";
    switch (u) {
      case eo:
        i[h] = i[h] - (e[f] / 2 - t[f] / 2);
        break;
      case us:
        i[h] = i[h] + (e[f] / 2 - t[f] / 2);
        break;
    }
  }
  return i;
}
function cs(n, e) {
  e === void 0 && (e = {});
  var t = e, r = t.placement, o = r === void 0 ? n.placement : r, u = t.strategy, c = u === void 0 ? n.strategy : u, l = t.boundary, i = l === void 0 ? aS : l, h = t.rootBoundary, f = h === void 0 ? gg : h, p = t.elementContext, d = p === void 0 ? Do : p, v = t.altBoundary, g = v === void 0 ? !1 : v, m = t.padding, A = m === void 0 ? 0 : m, b = Ag(typeof A != "number" ? A : Sg(A, Os)), S = d === Do ? oS : Do, N = n.rects.popper, T = n.elements[g ? S : d], R = FS(ma(T) ? T : T.contextElement || xi(n.elements.popper), i, f, c), y = no(n.elements.reference), E = Mg({
    reference: y,
    element: N,
    strategy: "absolute",
    placement: o
  }), L = Bc(Object.assign({}, N, E)), _ = d === Do ? L : y, O = {
    top: R.top - _.top + b.top,
    bottom: _.bottom - R.bottom + b.bottom,
    left: R.left - _.left + b.left,
    right: _.right - R.right + b.right
  }, D = n.modifiersData.offset;
  if (d === Do && D) {
    var M = D[o];
    Object.keys(O).forEach(function(C) {
      var I = [_r, vr].indexOf(C) >= 0 ? 1 : -1, w = [Jn, vr].indexOf(C) >= 0 ? "y" : "x";
      O[C] += M[w] * I;
    });
  }
  return O;
}
function US(n, e) {
  e === void 0 && (e = {});
  var t = e, r = t.placement, o = t.boundary, u = t.rootBoundary, c = t.padding, l = t.flipVariations, i = t.allowedAutoPlacements, h = i === void 0 ? vg : i, f = ro(r), p = f ? l ? eh : eh.filter(function(g) {
    return ro(g) === f;
  }) : Os, d = p.filter(function(g) {
    return h.indexOf(g) >= 0;
  });
  d.length === 0 && (d = p, process.env.NODE_ENV !== "production" && console.error(["Popper: The `allowedAutoPlacements` option did not allow any", "placements. Ensure the `placement` option matches the variation", "of the allowed placements.", 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(" ")));
  var v = d.reduce(function(g, m) {
    return g[m] = cs(n, {
      placement: m,
      boundary: o,
      rootBoundary: u,
      padding: c
    })[Sr(m)], g;
  }, {});
  return Object.keys(v).sort(function(g, m) {
    return v[g] - v[m];
  });
}
function kS(n) {
  if (Sr(n) === zl)
    return [];
  var e = il(n);
  return [rh(n), e, rh(e)];
}
function KS(n) {
  var e = n.state, t = n.options, r = n.name;
  if (!e.modifiersData[r]._skip) {
    for (var o = t.mainAxis, u = o === void 0 ? !0 : o, c = t.altAxis, l = c === void 0 ? !0 : c, i = t.fallbackPlacements, h = t.padding, f = t.boundary, p = t.rootBoundary, d = t.altBoundary, v = t.flipVariations, g = v === void 0 ? !0 : v, m = t.allowedAutoPlacements, A = e.options.placement, b = Sr(A), S = b === A, N = i || (S || !g ? [il(A)] : kS(A)), T = [A].concat(N).reduce(function(G, $) {
      return G.concat(Sr($) === zl ? US(e, {
        placement: $,
        boundary: f,
        rootBoundary: p,
        padding: h,
        flipVariations: g,
        allowedAutoPlacements: m
      }) : $);
    }, []), R = e.rects.reference, y = e.rects.popper, E = /* @__PURE__ */ new Map(), L = !0, _ = T[0], O = 0; O < T.length; O++) {
      var D = T[O], M = Sr(D), C = ro(D) === eo, I = [Jn, vr].indexOf(M) >= 0, w = I ? "width" : "height", F = cs(e, {
        placement: D,
        boundary: f,
        rootBoundary: p,
        altBoundary: d,
        padding: h
      }), k = I ? C ? _r : Zn : C ? vr : Jn;
      R[w] > y[w] && (k = il(k));
      var H = il(k), Z = [];
      if (u && Z.push(F[M] <= 0), l && Z.push(F[k] <= 0, F[H] <= 0), Z.every(function(G) {
        return G;
      })) {
        _ = D, L = !1;
        break;
      }
      E.set(D, Z);
    }
    if (L)
      for (var Y = g ? 3 : 1, j = function($) {
        var ie = T.find(function(re) {
          var ce = E.get(re);
          if (ce)
            return ce.slice(0, $).every(function(z) {
              return z;
            });
        });
        if (ie)
          return _ = ie, "break";
      }, J = Y; J > 0; J--) {
        var ae = j(J);
        if (ae === "break")
          break;
      }
    e.placement !== _ && (e.modifiersData[r]._skip = !0, e.placement = _, e.reset = !0);
  }
}
const jS = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: KS,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function ah(n, e, t) {
  return t === void 0 && (t = {
    x: 0,
    y: 0
  }), {
    top: n.top - e.height - t.y,
    right: n.right - e.width + t.x,
    bottom: n.bottom - e.height + t.y,
    left: n.left - e.width - t.x
  };
}
function oh(n) {
  return [Jn, _r, vr, Zn].some(function(e) {
    return n[e] >= 0;
  });
}
function WS(n) {
  var e = n.state, t = n.name, r = e.rects.reference, o = e.rects.popper, u = e.modifiersData.preventOverflow, c = cs(e, {
    elementContext: "reference"
  }), l = cs(e, {
    altBoundary: !0
  }), i = ah(c, r), h = ah(l, o, u), f = oh(i), p = oh(h);
  e.modifiersData[t] = {
    referenceClippingOffsets: i,
    popperEscapeOffsets: h,
    isReferenceHidden: f,
    hasPopperEscaped: p
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": f,
    "data-popper-escaped": p
  });
}
const VS = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: WS
};
function HS(n, e, t) {
  var r = Sr(n), o = [Zn, Jn].indexOf(r) >= 0 ? -1 : 1, u = typeof t == "function" ? t(Object.assign({}, e, {
    placement: n
  })) : t, c = u[0], l = u[1];
  return c = c || 0, l = (l || 0) * o, [Zn, _r].indexOf(r) >= 0 ? {
    x: l,
    y: c
  } : {
    x: c,
    y: l
  };
}
function $S(n) {
  var e = n.state, t = n.options, r = n.name, o = t.offset, u = o === void 0 ? [0, 0] : o, c = vg.reduce(function(f, p) {
    return f[p] = HS(p, e.rects, u), f;
  }, {}), l = c[e.placement], i = l.x, h = l.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += i, e.modifiersData.popperOffsets.y += h), e.modifiersData[r] = c;
}
const GS = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: $S
};
function zS(n) {
  var e = n.state, t = n.name;
  e.modifiersData[t] = Mg({
    reference: e.rects.reference,
    element: e.rects.popper,
    strategy: "absolute",
    placement: e.placement
  });
}
const YS = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: zS,
  data: {}
};
function XS(n) {
  return n === "x" ? "y" : "x";
}
function QS(n) {
  var e = n.state, t = n.options, r = n.name, o = t.mainAxis, u = o === void 0 ? !0 : o, c = t.altAxis, l = c === void 0 ? !1 : c, i = t.boundary, h = t.rootBoundary, f = t.altBoundary, p = t.padding, d = t.tether, v = d === void 0 ? !0 : d, g = t.tetherOffset, m = g === void 0 ? 0 : g, A = cs(e, {
    boundary: i,
    rootBoundary: h,
    padding: p,
    altBoundary: f
  }), b = Sr(e.placement), S = ro(e.placement), N = !S, T = Qf(b), R = XS(T), y = e.modifiersData.popperOffsets, E = e.rects.reference, L = e.rects.popper, _ = typeof m == "function" ? m(Object.assign({}, e.rects, {
    placement: e.placement
  })) : m, O = typeof _ == "number" ? {
    mainAxis: _,
    altAxis: _
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, _), D = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, M = {
    x: 0,
    y: 0
  };
  if (y) {
    if (u) {
      var C, I = T === "y" ? Jn : Zn, w = T === "y" ? vr : _r, F = T === "y" ? "height" : "width", k = y[T], H = k + A[I], Z = k - A[w], Y = v ? -L[F] / 2 : 0, j = S === eo ? E[F] : L[F], J = S === eo ? -L[F] : -E[F], ae = e.elements.arrow, G = v && ae ? Xf(ae) : {
        width: 0,
        height: 0
      }, $ = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : Tg(), ie = $[I], re = $[w], ce = Vo(0, E[F], G[F]), z = N ? E[F] / 2 - Y - ce - ie - O.mainAxis : j - ce - ie - O.mainAxis, oe = N ? -E[F] / 2 + Y + ce + re + O.mainAxis : J + ce + re + O.mainAxis, de = e.elements.arrow && Ps(e.elements.arrow), pe = de ? T === "y" ? de.clientTop || 0 : de.clientLeft || 0 : 0, he = (C = D == null ? void 0 : D[T]) != null ? C : 0, se = k + z - he - pe, ee = k + oe - he, te = Vo(v ? gl(H, se) : H, k, v ? aa(Z, ee) : Z);
      y[T] = te, M[T] = te - k;
    }
    if (l) {
      var le, ne = T === "x" ? Jn : Zn, x = T === "x" ? vr : _r, P = y[R], B = R === "y" ? "height" : "width", W = P + A[ne], X = P - A[x], K = [Jn, Zn].indexOf(b) !== -1, U = (le = D == null ? void 0 : D[R]) != null ? le : 0, V = K ? W : P - E[B] - L[B] - U + O.altAxis, Q = K ? P + E[B] + L[B] - U - O.altAxis : X, fe = v && K ? yS(V, P, Q) : Vo(v ? V : W, P, v ? Q : X);
      y[R] = fe, M[R] = fe - P;
    }
    e.modifiersData[r] = M;
  }
}
const JS = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: QS,
  requiresIfExists: ["offset"]
};
function ZS(n) {
  return {
    scrollLeft: n.scrollLeft,
    scrollTop: n.scrollTop
  };
}
function qS(n) {
  return n === Er(n) || !sr(n) ? Jf(n) : ZS(n);
}
function e0(n) {
  var e = n.getBoundingClientRect(), t = to(e.width) / n.offsetWidth || 1, r = to(e.height) / n.offsetHeight || 1;
  return t !== 1 || r !== 1;
}
function t0(n, e, t) {
  t === void 0 && (t = !1);
  var r = sr(e), o = sr(e) && e0(e), u = xi(e), c = no(n, o, t), l = {
    scrollLeft: 0,
    scrollTop: 0
  }, i = {
    x: 0,
    y: 0
  };
  return (r || !r && !t) && ((jr(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  qf(u)) && (l = qS(e)), sr(e) ? (i = no(e, !0), i.x += e.clientLeft, i.y += e.clientTop) : u && (i.x = Zf(u))), {
    x: c.left + l.scrollLeft - i.x,
    y: c.top + l.scrollTop - i.y,
    width: c.width,
    height: c.height
  };
}
function n0(n) {
  var e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Set(), r = [];
  n.forEach(function(u) {
    e.set(u.name, u);
  });
  function o(u) {
    t.add(u.name);
    var c = [].concat(u.requires || [], u.requiresIfExists || []);
    c.forEach(function(l) {
      if (!t.has(l)) {
        var i = e.get(l);
        i && o(i);
      }
    }), r.push(u);
  }
  return n.forEach(function(u) {
    t.has(u.name) || o(u);
  }), r;
}
function r0(n) {
  var e = n0(n);
  return wc.reduce(function(t, r) {
    return t.concat(e.filter(function(o) {
      return o.phase === r;
    }));
  }, []);
}
function i0(n) {
  var e;
  return function() {
    return e || (e = new Promise(function(t) {
      Promise.resolve().then(function() {
        e = void 0, t(n());
      });
    })), e;
  };
}
function ui(n) {
  for (var e = arguments.length, t = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++)
    t[r - 1] = arguments[r];
  return [].concat(t).reduce(function(o, u) {
    return o.replace(/%s/, u);
  }, n);
}
var $i = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s', a0 = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available', sh = ["name", "enabled", "phase", "fn", "effect", "requires", "options"];
function o0(n) {
  n.forEach(function(e) {
    [].concat(Object.keys(e), sh).filter(function(t, r, o) {
      return o.indexOf(t) === r;
    }).forEach(function(t) {
      switch (t) {
        case "name":
          typeof e.name != "string" && console.error(ui($i, String(e.name), '"name"', '"string"', '"' + String(e.name) + '"'));
          break;
        case "enabled":
          typeof e.enabled != "boolean" && console.error(ui($i, e.name, '"enabled"', '"boolean"', '"' + String(e.enabled) + '"'));
          break;
        case "phase":
          wc.indexOf(e.phase) < 0 && console.error(ui($i, e.name, '"phase"', "either " + wc.join(", "), '"' + String(e.phase) + '"'));
          break;
        case "fn":
          typeof e.fn != "function" && console.error(ui($i, e.name, '"fn"', '"function"', '"' + String(e.fn) + '"'));
          break;
        case "effect":
          e.effect != null && typeof e.effect != "function" && console.error(ui($i, e.name, '"effect"', '"function"', '"' + String(e.fn) + '"'));
          break;
        case "requires":
          e.requires != null && !Array.isArray(e.requires) && console.error(ui($i, e.name, '"requires"', '"array"', '"' + String(e.requires) + '"'));
          break;
        case "requiresIfExists":
          Array.isArray(e.requiresIfExists) || console.error(ui($i, e.name, '"requiresIfExists"', '"array"', '"' + String(e.requiresIfExists) + '"'));
          break;
        case "options":
        case "data":
          break;
        default:
          console.error('PopperJS: an invalid property has been provided to the "' + e.name + '" modifier, valid properties are ' + sh.map(function(r) {
            return '"' + r + '"';
          }).join(", ") + '; but "' + t + '" was provided.');
      }
      e.requires && e.requires.forEach(function(r) {
        n.find(function(o) {
          return o.name === r;
        }) == null && console.error(ui(a0, String(e.name), r, r));
      });
    });
  });
}
function s0(n, e) {
  var t = /* @__PURE__ */ new Set();
  return n.filter(function(r) {
    var o = e(r);
    if (!t.has(o))
      return t.add(o), !0;
  });
}
function l0(n) {
  var e = n.reduce(function(t, r) {
    var o = t[r.name];
    return t[r.name] = o ? Object.assign({}, o, r, {
      options: Object.assign({}, o.options, r.options),
      data: Object.assign({}, o.data, r.data)
    }) : r, t;
  }, {});
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}
var lh = "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.", u0 = "Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.", uh = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function ch() {
  for (var n = arguments.length, e = new Array(n), t = 0; t < n; t++)
    e[t] = arguments[t];
  return !e.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function c0(n) {
  n === void 0 && (n = {});
  var e = n, t = e.defaultModifiers, r = t === void 0 ? [] : t, o = e.defaultOptions, u = o === void 0 ? uh : o;
  return function(l, i, h) {
    h === void 0 && (h = u);
    var f = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, uh, u),
      modifiersData: {},
      elements: {
        reference: l,
        popper: i
      },
      attributes: {},
      styles: {}
    }, p = [], d = !1, v = {
      state: f,
      setOptions: function(b) {
        var S = typeof b == "function" ? b(f.options) : b;
        m(), f.options = Object.assign({}, u, f.options, S), f.scrollParents = {
          reference: ma(l) ? Ho(l) : l.contextElement ? Ho(l.contextElement) : [],
          popper: Ho(i)
        };
        var N = r0(l0([].concat(r, f.options.modifiers)));
        if (f.orderedModifiers = N.filter(function(D) {
          return D.enabled;
        }), process.env.NODE_ENV !== "production") {
          var T = s0([].concat(N, f.options.modifiers), function(D) {
            var M = D.name;
            return M;
          });
          if (o0(T), Sr(f.options.placement) === zl) {
            var R = f.orderedModifiers.find(function(D) {
              var M = D.name;
              return M === "flip";
            });
            R || console.error(['Popper: "auto" placements require the "flip" modifier be', "present and enabled to work."].join(" "));
          }
          var y = Mr(i), E = y.marginTop, L = y.marginRight, _ = y.marginBottom, O = y.marginLeft;
          [E, L, _, O].some(function(D) {
            return parseFloat(D);
          }) && console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', "between the popper and its reference element or boundary.", "To replicate margin, use the `offset` modifier, as well as", "the `padding` option in the `preventOverflow` and `flip`", "modifiers."].join(" "));
        }
        return g(), v.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!d) {
          var b = f.elements, S = b.reference, N = b.popper;
          if (!ch(S, N)) {
            process.env.NODE_ENV !== "production" && console.error(lh);
            return;
          }
          f.rects = {
            reference: t0(S, Ps(N), f.options.strategy === "fixed"),
            popper: Xf(N)
          }, f.reset = !1, f.placement = f.options.placement, f.orderedModifiers.forEach(function(D) {
            return f.modifiersData[D.name] = Object.assign({}, D.data);
          });
          for (var T = 0, R = 0; R < f.orderedModifiers.length; R++) {
            if (process.env.NODE_ENV !== "production" && (T += 1, T > 100)) {
              console.error(u0);
              break;
            }
            if (f.reset === !0) {
              f.reset = !1, R = -1;
              continue;
            }
            var y = f.orderedModifiers[R], E = y.fn, L = y.options, _ = L === void 0 ? {} : L, O = y.name;
            typeof E == "function" && (f = E({
              state: f,
              options: _,
              name: O,
              instance: v
            }) || f);
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: i0(function() {
        return new Promise(function(A) {
          v.forceUpdate(), A(f);
        });
      }),
      destroy: function() {
        m(), d = !0;
      }
    };
    if (!ch(l, i))
      return process.env.NODE_ENV !== "production" && console.error(lh), v;
    v.setOptions(h).then(function(A) {
      !d && h.onFirstUpdate && h.onFirstUpdate(A);
    });
    function g() {
      f.orderedModifiers.forEach(function(A) {
        var b = A.name, S = A.options, N = S === void 0 ? {} : S, T = A.effect;
        if (typeof T == "function") {
          var R = T({
            state: f,
            name: b,
            instance: v,
            options: N
          }), y = function() {
          };
          p.push(R || y);
        }
      });
    }
    function m() {
      p.forEach(function(A) {
        return A();
      }), p = [];
    }
    return v;
  };
}
var f0 = [PS, YS, DS, _g, GS, jS, JS, CS, VS], d0 = /* @__PURE__ */ c0({
  defaultModifiers: f0
});
const fh = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top", dh = ".sticky-top", $s = "padding-right", hh = "margin-right";
class h0 {
  constructor() {
    this._element = document.body;
  }
  // Public
  getWidth() {
    const e = document.documentElement.clientWidth;
    return Math.abs(window.innerWidth - e);
  }
  hide() {
    const e = this.getWidth();
    this._disableOverFlow(), this._setElementAttributes(this._element, $s, (t) => t + e), this._setElementAttributes(fh, $s, (t) => t + e), this._setElementAttributes(dh, hh, (t) => t - e);
  }
  reset() {
    this._resetElementAttributes(this._element, "overflow"), this._resetElementAttributes(this._element, $s), this._resetElementAttributes(fh, $s), this._resetElementAttributes(dh, hh);
  }
  isOverflowing() {
    return this.getWidth() > 0;
  }
  // Private
  _disableOverFlow() {
    this._saveInitialAttribute(this._element, "overflow"), this._element.style.overflow = "hidden";
  }
  _setElementAttributes(e, t, r) {
    const o = this.getWidth(), u = (c) => {
      if (c !== this._element && window.innerWidth > c.clientWidth + o)
        return;
      this._saveInitialAttribute(c, t);
      const l = window.getComputedStyle(c).getPropertyValue(t);
      c.style.setProperty(t, `${r(Number.parseFloat(l))}px`);
    };
    this._applyManipulationCallback(e, u);
  }
  _saveInitialAttribute(e, t) {
    const r = e.style.getPropertyValue(t);
    r && Wo.setDataAttribute(e, t, r);
  }
  _resetElementAttributes(e, t) {
    const r = (o) => {
      const u = Wo.getDataAttribute(o, t);
      if (u === null) {
        o.style.removeProperty(t);
        return;
      }
      Wo.removeDataAttribute(o, t), o.style.setProperty(t, u);
    };
    this._applyManipulationCallback(e, r);
  }
  _applyManipulationCallback(e, t) {
    if (Va(e)) {
      t(e);
      return;
    }
    for (const r of An.find(e, this._element))
      t(r);
  }
}
const bg = "backdrop", p0 = "fade", ph = "show", mh = `mousedown.bs.${bg}`, m0 = {
  className: "modal-backdrop",
  clickCallback: null,
  isAnimated: !1,
  isVisible: !0,
  // if false, we use the backdrop helper without adding any element to the dom
  rootElement: "body"
  // give the choice to place backdrop under different elements
}, g0 = {
  className: "string",
  clickCallback: "(function|null)",
  isAnimated: "boolean",
  isVisible: "boolean",
  rootElement: "(element|string)"
};
class v0 extends Kf {
  constructor(e) {
    super(), this._config = this._getConfig(e), this._isAppended = !1, this._element = null;
  }
  // Getters
  static get Default() {
    return m0;
  }
  static get DefaultType() {
    return g0;
  }
  static get NAME() {
    return bg;
  }
  // Public
  show(e) {
    if (!this._config.isVisible) {
      Yi(e);
      return;
    }
    this._append();
    const t = this._getElement();
    this._config.isAnimated && Uf(t), t.classList.add(ph), this._emulateAnimation(() => {
      Yi(e);
    });
  }
  hide(e) {
    if (!this._config.isVisible) {
      Yi(e);
      return;
    }
    this._getElement().classList.remove(ph), this._emulateAnimation(() => {
      this.dispose(), Yi(e);
    });
  }
  dispose() {
    this._isAppended && (Gt.off(this._element, mh), this._element.remove(), this._isAppended = !1);
  }
  // Private
  _getElement() {
    if (!this._element) {
      const e = document.createElement("div");
      e.className = this._config.className, this._config.isAnimated && e.classList.add(p0), this._element = e;
    }
    return this._element;
  }
  _configAfterMerge(e) {
    return e.rootElement = ml(e.rootElement), e;
  }
  _append() {
    if (this._isAppended)
      return;
    const e = this._getElement();
    this._config.rootElement.append(e), Gt.on(e, mh, () => {
      Yi(this._config.clickCallback);
    }), this._isAppended = !0;
  }
  _emulateAnimation(e) {
    ng(e, this._getElement(), this._config.isAnimated);
  }
}
const _0 = "focustrap", E0 = "bs.focustrap", vl = `.${E0}`, y0 = `focusin${vl}`, T0 = `keydown.tab${vl}`, A0 = "Tab", S0 = "forward", gh = "backward", C0 = {
  autofocus: !0,
  trapElement: null
  // The element to trap focus inside of
}, M0 = {
  autofocus: "boolean",
  trapElement: "element"
};
class b0 extends Kf {
  constructor(e) {
    super(), this._config = this._getConfig(e), this._isActive = !1, this._lastTabNavDirection = null;
  }
  // Getters
  static get Default() {
    return C0;
  }
  static get DefaultType() {
    return M0;
  }
  static get NAME() {
    return _0;
  }
  // Public
  activate() {
    this._isActive || (this._config.autofocus && this._config.trapElement.focus(), Gt.off(document, vl), Gt.on(document, y0, (e) => this._handleFocusin(e)), Gt.on(document, T0, (e) => this._handleKeydown(e)), this._isActive = !0);
  }
  deactivate() {
    this._isActive && (this._isActive = !1, Gt.off(document, vl));
  }
  // Private
  _handleFocusin(e) {
    const { trapElement: t } = this._config;
    if (e.target === document || e.target === t || t.contains(e.target))
      return;
    const r = An.focusableChildren(t);
    r.length === 0 ? t.focus() : this._lastTabNavDirection === gh ? r[r.length - 1].focus() : r[0].focus();
  }
  _handleKeydown(e) {
    e.key === A0 && (this._lastTabNavDirection = e.shiftKey ? gh : S0);
  }
}
const R0 = "modal", D0 = "bs.modal", Rr = `.${D0}`, O0 = ".data-api", P0 = "Escape", I0 = `hide${Rr}`, N0 = `hidePrevented${Rr}`, Rg = `hidden${Rr}`, Dg = `show${Rr}`, L0 = `shown${Rr}`, w0 = `resize${Rr}`, x0 = `click.dismiss${Rr}`, B0 = `mousedown.dismiss${Rr}`, F0 = `keydown.dismiss${Rr}`, U0 = `click${Rr}${O0}`, vh = "modal-open", k0 = "fade", _h = "show", Ru = "modal-static", K0 = ".modal.show", j0 = ".modal-dialog", W0 = ".modal-body", V0 = '[data-bs-toggle="modal"]', H0 = {
  backdrop: !0,
  focus: !0,
  keyboard: !0
}, $0 = {
  backdrop: "(boolean|string)",
  focus: "boolean",
  keyboard: "boolean"
};
let fs = class Og extends Ea {
  constructor(e, t) {
    super(e, t), this._dialog = An.findOne(j0, this._element), this._backdrop = this._initializeBackDrop(), this._focustrap = this._initializeFocusTrap(), this._isShown = !1, this._isTransitioning = !1, this._scrollBar = new h0(), this._addEventListeners();
  }
  // Getters
  static get Default() {
    return H0;
  }
  static get DefaultType() {
    return $0;
  }
  static get NAME() {
    return R0;
  }
  // Public
  toggle(e) {
    return this._isShown ? this.hide() : this.show(e);
  }
  show(e) {
    this._isShown || this._isTransitioning || Gt.trigger(this._element, Dg, {
      relatedTarget: e
    }).defaultPrevented || (this._isShown = !0, this._isTransitioning = !0, this._scrollBar.hide(), document.body.classList.add(vh), this._adjustDialog(), this._backdrop.show(() => this._showElement(e)));
  }
  hide() {
    !this._isShown || this._isTransitioning || Gt.trigger(this._element, I0).defaultPrevented || (this._isShown = !1, this._isTransitioning = !0, this._focustrap.deactivate(), this._element.classList.remove(_h), this._queueCallback(() => this._hideModal(), this._element, this._isAnimated()));
  }
  dispose() {
    for (const e of [window, this._dialog])
      Gt.off(e, Rr);
    this._backdrop.dispose(), this._focustrap.deactivate(), super.dispose();
  }
  handleUpdate() {
    this._adjustDialog();
  }
  // Private
  _initializeBackDrop() {
    return new v0({
      isVisible: !!this._config.backdrop,
      // 'static' option will be translated to true, and booleans will keep their value,
      isAnimated: this._isAnimated()
    });
  }
  _initializeFocusTrap() {
    return new b0({
      trapElement: this._element
    });
  }
  _showElement(e) {
    document.body.contains(this._element) || document.body.append(this._element), this._element.style.display = "block", this._element.removeAttribute("aria-hidden"), this._element.setAttribute("aria-modal", !0), this._element.setAttribute("role", "dialog"), this._element.scrollTop = 0;
    const t = An.findOne(W0, this._dialog);
    t && (t.scrollTop = 0), Uf(this._element), this._element.classList.add(_h);
    const r = () => {
      this._config.focus && this._focustrap.activate(), this._isTransitioning = !1, Gt.trigger(this._element, L0, {
        relatedTarget: e
      });
    };
    this._queueCallback(r, this._dialog, this._isAnimated());
  }
  _addEventListeners() {
    Gt.on(this._element, F0, (e) => {
      if (e.key === P0) {
        if (this._config.keyboard) {
          e.preventDefault(), this.hide();
          return;
        }
        this._triggerBackdropTransition();
      }
    }), Gt.on(window, w0, () => {
      this._isShown && !this._isTransitioning && this._adjustDialog();
    }), Gt.on(this._element, B0, (e) => {
      Gt.one(this._element, x0, (t) => {
        if (!(this._element !== e.target || this._element !== t.target)) {
          if (this._config.backdrop === "static") {
            this._triggerBackdropTransition();
            return;
          }
          this._config.backdrop && this.hide();
        }
      });
    });
  }
  _hideModal() {
    this._element.style.display = "none", this._element.setAttribute("aria-hidden", !0), this._element.removeAttribute("aria-modal"), this._element.removeAttribute("role"), this._isTransitioning = !1, this._backdrop.hide(() => {
      document.body.classList.remove(vh), this._resetAdjustments(), this._scrollBar.reset(), Gt.trigger(this._element, Rg);
    });
  }
  _isAnimated() {
    return this._element.classList.contains(k0);
  }
  _triggerBackdropTransition() {
    if (Gt.trigger(this._element, N0).defaultPrevented)
      return;
    const t = this._element.scrollHeight > document.documentElement.clientHeight, r = this._element.style.overflowY;
    r === "hidden" || this._element.classList.contains(Ru) || (t || (this._element.style.overflowY = "hidden"), this._element.classList.add(Ru), this._queueCallback(() => {
      this._element.classList.remove(Ru), this._queueCallback(() => {
        this._element.style.overflowY = r;
      }, this._dialog);
    }, this._dialog), this._element.focus());
  }
  /**
   * The following methods are used to handle overflowing modals
   */
  _adjustDialog() {
    const e = this._element.scrollHeight > document.documentElement.clientHeight, t = this._scrollBar.getWidth(), r = t > 0;
    if (r && !e) {
      const o = zd() ? "paddingLeft" : "paddingRight";
      this._element.style[o] = `${t}px`;
    }
    if (!r && e) {
      const o = zd() ? "paddingRight" : "paddingLeft";
      this._element.style[o] = `${t}px`;
    }
  }
  _resetAdjustments() {
    this._element.style.paddingLeft = "", this._element.style.paddingRight = "";
  }
  // Static
  static jQueryInterface(e, t) {
    return this.each(function() {
      const r = Og.getOrCreateInstance(this, e);
      if (typeof e == "string") {
        if (typeof r[e] > "u")
          throw new TypeError(`No method named "${e}"`);
        r[e](t);
      }
    });
  }
};
Gt.on(document, U0, V0, function(n) {
  const e = ia(this);
  ["A", "AREA"].includes(this.tagName) && n.preventDefault(), Gt.one(e, Dg, (o) => {
    o.defaultPrevented || Gt.one(e, Rg, () => {
      eg(this) && this.focus();
    });
  });
  const t = An.findOne(K0);
  t && fs.getInstance(t).hide(), fs.getOrCreateInstance(e).toggle(this);
});
OA(fs);
Hl(fs);
const G0 = fs;
class ed extends G0 {
}
const z0 = "tab", Y0 = "bs.tab", Ta = `.${Y0}`, X0 = `hide${Ta}`, Q0 = `hidden${Ta}`, J0 = `show${Ta}`, Z0 = `shown${Ta}`, q0 = `click${Ta}`, eC = `keydown${Ta}`, tC = `load${Ta}`, nC = "ArrowLeft", Eh = "ArrowRight", rC = "ArrowUp", yh = "ArrowDown", qi = "active", Th = "fade", Du = "show", iC = "dropdown", aC = ".dropdown-toggle", oC = ".dropdown-menu", Ou = ":not(.dropdown-toggle)", sC = '.list-group, .nav, [role="tablist"]', lC = ".nav-item, .list-group-item", uC = `.nav-link${Ou}, .list-group-item${Ou}, [role="tab"]${Ou}`, Pg = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]', Pu = `${uC}, ${Pg}`, cC = `.${qi}[data-bs-toggle="tab"], .${qi}[data-bs-toggle="pill"], .${qi}[data-bs-toggle="list"]`;
let Xl = class Fc extends Ea {
  constructor(e) {
    super(e), this._parent = this._element.closest(sC), this._parent && (this._setInitialAttributes(this._parent, this._getChildren()), Gt.on(this._element, eC, (t) => this._keydown(t)));
  }
  // Getters
  static get NAME() {
    return z0;
  }
  // Public
  show() {
    const e = this._element;
    if (this._elemIsActive(e))
      return;
    const t = this._getActiveElem(), r = t ? Gt.trigger(t, X0, { relatedTarget: e }) : null;
    Gt.trigger(e, J0, { relatedTarget: t }).defaultPrevented || r && r.defaultPrevented || (this._deactivate(t, e), this._activate(e, t));
  }
  // Private
  _activate(e, t) {
    if (!e)
      return;
    e.classList.add(qi), this._activate(ia(e));
    const r = () => {
      if (e.getAttribute("role") !== "tab") {
        e.classList.add(Du);
        return;
      }
      e.removeAttribute("tabindex"), e.setAttribute("aria-selected", !0), this._toggleDropDown(e, !0), Gt.trigger(e, Z0, {
        relatedTarget: t
      });
    };
    this._queueCallback(r, e, e.classList.contains(Th));
  }
  _deactivate(e, t) {
    if (!e)
      return;
    e.classList.remove(qi), e.blur(), this._deactivate(ia(e));
    const r = () => {
      if (e.getAttribute("role") !== "tab") {
        e.classList.remove(Du);
        return;
      }
      e.setAttribute("aria-selected", !1), e.setAttribute("tabindex", "-1"), this._toggleDropDown(e, !1), Gt.trigger(e, Q0, { relatedTarget: t });
    };
    this._queueCallback(r, e, e.classList.contains(Th));
  }
  _keydown(e) {
    if (![nC, Eh, rC, yh].includes(e.key))
      return;
    e.stopPropagation(), e.preventDefault();
    const t = [Eh, yh].includes(e.key), r = rg(this._getChildren().filter((o) => !Eo(o)), e.target, t, !0);
    r && (r.focus({ preventScroll: !0 }), Fc.getOrCreateInstance(r).show());
  }
  _getChildren() {
    return An.find(Pu, this._parent);
  }
  _getActiveElem() {
    return this._getChildren().find((e) => this._elemIsActive(e)) || null;
  }
  _setInitialAttributes(e, t) {
    this._setAttributeIfNotExists(e, "role", "tablist");
    for (const r of t)
      this._setInitialAttributesOnChild(r);
  }
  _setInitialAttributesOnChild(e) {
    e = this._getInnerElement(e);
    const t = this._elemIsActive(e), r = this._getOuterElement(e);
    e.setAttribute("aria-selected", t), r !== e && this._setAttributeIfNotExists(r, "role", "presentation"), t || e.setAttribute("tabindex", "-1"), this._setAttributeIfNotExists(e, "role", "tab"), this._setInitialAttributesOnTargetPanel(e);
  }
  _setInitialAttributesOnTargetPanel(e) {
    const t = ia(e);
    t && (this._setAttributeIfNotExists(t, "role", "tabpanel"), e.id && this._setAttributeIfNotExists(t, "aria-labelledby", `#${e.id}`));
  }
  _toggleDropDown(e, t) {
    const r = this._getOuterElement(e);
    if (!r.classList.contains(iC))
      return;
    const o = (u, c) => {
      const l = An.findOne(u, r);
      l && l.classList.toggle(c, t);
    };
    o(aC, qi), o(oC, Du), r.setAttribute("aria-expanded", t);
  }
  _setAttributeIfNotExists(e, t, r) {
    e.hasAttribute(t) || e.setAttribute(t, r);
  }
  _elemIsActive(e) {
    return e.classList.contains(qi);
  }
  // Try to get the inner element (usually the .nav-link)
  _getInnerElement(e) {
    return e.matches(Pu) ? e : An.findOne(Pu, e);
  }
  // Try to get the outer element (usually the .nav-item)
  _getOuterElement(e) {
    return e.closest(lC) || e;
  }
  // Static
  static jQueryInterface(e) {
    return this.each(function() {
      const t = Fc.getOrCreateInstance(this);
      if (typeof e == "string") {
        if (t[e] === void 0 || e.startsWith("_") || e === "constructor")
          throw new TypeError(`No method named "${e}"`);
        t[e]();
      }
    });
  }
};
Gt.on(document, q0, Pg, function(n) {
  ["A", "AREA"].includes(this.tagName) && n.preventDefault(), !Eo(this) && Xl.getOrCreateInstance(this).show();
});
Gt.on(window, tC, () => {
  for (const n of An.find(cC))
    Xl.getOrCreateInstance(n);
});
Hl(Xl);
const fC = Xl, dC = "bs.tab", Ig = `.${dC}`, hC = `click${Ig}`, pC = `load${Ig}`, mC = "ArrowLeft", Ah = "ArrowRight", gC = "ArrowUp", Sh = "ArrowDown", Ch = "Enter", Mh = " ", Iu = "active", vC = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]', _C = `.${Iu}[data-bs-toggle="tab"], .${Iu}[data-bs-toggle="pill"], .${Iu}[data-bs-toggle="list"]`;
class ai extends fC {
  constructor(e) {
    super(e);
  }
  _keydown(e) {
    if (![mC, Ah, gC, Sh, Ch, Mh].includes(e.key))
      return;
    if (e.stopPropagation(), e.preventDefault(), e.key === Ch || e.key === Mh) {
      ai.getOrCreateInstance(e.target).show();
      return;
    }
    const t = [Ah, Sh].includes(e.key), r = rg(
      this._getChildren().filter((o) => !Eo(o)),
      e.target,
      t,
      !0
    );
    r && r.focus({ preventScroll: !0 });
  }
}
Gt.on(document, hC, vC, function(n) {
  if (["A", "AREA"].includes(this.tagName) && n.preventDefault(), Eo(this))
    return;
  ai.getOrCreateInstance(this).dispose(), ai.getOrCreateInstance(this).show();
});
Gt.on(window, pC, () => {
  for (const n of An.find(_C))
    ai.getOrCreateInstance(n).dispose(), ai.getOrCreateInstance(n);
});
Hl(ai);
const EC = {}, yC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: EC
}, Symbol.toStringTag, { value: "Module" })), TC = /* @__PURE__ */ BA(yC), bh = "data-focus-mouse", Rh = "focus--mouse";
class Ng {
  constructor() {
    this._usingMouse = !1, this._bindEvents();
  }
  // Public
  // Private
  _bindEvents() {
    ["keydown", "mousedown"].forEach((t) => {
      document.addEventListener(t, (r) => {
        this._usingMouse = r.type === "mousedown";
      });
    }), document.addEventListener("focusin", (t) => {
      this._usingMouse && t.target && (t.target.classList.add(Rh), t.target.setAttribute(bh, !0));
    }), document.addEventListener("focusout", (t) => {
      t.target && (t.target.classList.remove(Rh), t.target.setAttribute(bh, !1));
    });
  }
}
new Ng();
const AC = "2.7.5", SC = () => {
  window.BOOTSTRAP_ITALIA_VERSION || (new Ng(), window.BOOTSTRAP_ITALIA_VERSION = AC);
};
SC();
const CC = { class: "splide__track" }, MC = { class: "splide__list" }, bC = { class: "it-single-slide-wrapper" }, RC = /* @__PURE__ */ Dt({
  __name: "KCarousel",
  props: {
    items: {}
  },
  setup(n) {
    const e = st(null);
    let t = null;
    const r = n;
    return ln(() => {
    }), _f(() => {
    }), un(() => r.items, (o) => {
      !o || o.length <= 0 || lr(() => {
        t != null && (t.dispose(), t = null), t = cg.getOrCreateInstance(e.value);
      });
    }, { immediate: !0 }), (o, u) => (Oe(), je("div", {
      ref_key: "kCarousel",
      ref: e,
      class: "k-carousel it-carousel-wrapper it-carousel-landscape-abstract splide",
      "data-bs-carousel-splide": ""
    }, [
      ve("div", CC, [
        ve("ul", MC, [
          (Oe(!0), je(dn, null, Un(o.items, (c, l) => (Oe(), je("li", {
            class: "splide__slide",
            key: l
          }, [
            ve("div", bC, [
              pn(o.$slots, "template", { data: c })
            ])
          ]))), 128))
        ])
      ])
    ], 512));
  }
}), DC = ["disabled", "id"], OC = ["for"], PC = /* @__PURE__ */ Dt({
  __name: "KCheckbox",
  props: {
    id: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    modelValue: { type: Boolean, default: !1 },
    labelText: { default: "" },
    class: { default: "" },
    disabled: { type: Boolean, default: !1 },
    formGroupClass: { default: "" }
  },
  emits: ["update:modelValue", "change"],
  setup(n, { emit: e }) {
    const t = e, r = st(), o = n;
    un(
      () => o.modelValue,
      async (l) => {
        r.value = l;
      },
      { immediate: !0 }
    );
    const u = (l) => {
      t("update:modelValue", l.target.checked);
    }, c = (l) => {
      t("change");
    };
    return (l, i) => (Oe(), je("div", {
      class: Ct(["form-check", l.formGroupClass])
    }, [
      ha(ve("input", {
        disabled: l.disabled,
        onInput: u,
        "onUpdate:modelValue": i[0] || (i[0] = (h) => r.value = h),
        onChange: c,
        class: Ct(l.class),
        id: l.id,
        type: "checkbox"
      }, null, 42, DC), [
        [Ef, r.value]
      ]),
      ve("label", { for: l.id }, lt(l.labelText), 9, OC)
    ], 2));
  }
}), IC = { class: "d-flex align-items-center" }, NC = {
  key: 0,
  class: "text-primary",
  style: { "font-size": "14px" }
}, LC = { class: "d-flex flex-column" }, wC = { class: "d-flex align-items-center" }, xC = /* @__PURE__ */ ve("span", { class: "text-primary" }, "Dettaglio", -1), BC = { class: "d-flex align-items-center" }, FC = /* @__PURE__ */ ve("span", { class: "text-primary" }, "Scarica", -1), UC = { class: "d-flex align-items-center" }, kC = /* @__PURE__ */ ve("span", { class: "text-primary" }, "Sposta in", -1), KC = { class: "d-flex align-items-center" }, jC = /* @__PURE__ */ ve("span", { class: "text-primary" }, "Condividi", -1), WC = { class: "d-flex align-items-center" }, VC = /* @__PURE__ */ ve("span", { class: "text-primary" }, "Copia link", -1), HC = { class: "d-flex align-items-center" }, $C = /* @__PURE__ */ ve("span", { class: "text-primary" }, "Elimina", -1), GC = { class: "d-flex align-items-center" }, zC = /* @__PURE__ */ ve("span", { class: "text-primary" }, "Rimuovi dallo spazio", -1), YC = { class: "d-flex align-items-center" }, XC = /* @__PURE__ */ ve("span", { class: "text-primary" }, "Rinomina cartella", -1), QC = { class: "d-flex align-items-center" }, JC = /* @__PURE__ */ ve("span", { class: "text-primary" }, "Sposta cartella in", -1), ZC = { class: "d-flex align-items-center" }, qC = /* @__PURE__ */ ve("span", { class: "text-primary" }, "Elimina cartella", -1), eM = { class: "d-flex align-items-center" }, tM = /* @__PURE__ */ ve("span", { class: "text-primary" }, "Aggiungi a lista distribuzione", -1), nM = ["onClick"], rM = { class: "d-flex align-items-center" }, iM = { class: "text-primary" }, aM = /* @__PURE__ */ Dt({
  __name: "KDataTableActions",
  props: {
    showActionLabel: { type: Boolean, default: !1 },
    showIcons: { type: Boolean, default: !1 },
    showDetail: { type: Boolean, default: !1 },
    showDownload: { type: Boolean, default: !1 },
    showMove: { type: Boolean, default: !1 },
    showShare: { type: Boolean, default: !1 },
    showCopyLink: { type: Boolean, default: !1 },
    showDelete: { type: Boolean, default: !1 },
    showRemoveFromSpace: { type: Boolean, default: !1 },
    showRenameFolder: { type: Boolean, default: !1 },
    showMoveFolder: { type: Boolean, default: !1 },
    showDeleteFolder: { type: Boolean, default: !1 },
    showAddToDistList: { type: Boolean, default: !1 },
    overlayZIndex: { default: 0 },
    customActions: { default: [] }
  },
  emits: ["doc-detail", "doc-download", "doc-share", "doc-copylink", "doc-delete", "doc-move", "doc-remove-space", "doc-rename-folder", "doc-move-folder", "doc-delete-folder", "add-to-distribution-list"],
  setup(n, { emit: e }) {
    const t = st(), r = st(), o = st(), u = st(), c = st(), l = st(), i = st(), h = st(), f = st(), p = st(), d = st(), v = st(), g = st([]), m = n, A = e, b = (F) => {
      var k;
      Array.from(document.getElementsByClassName("k-actions-menu-panel")).forEach((H) => {
        H.style.display = "none";
      }), t.value.toggle(F), (k = t.value) != null && k.visible && C();
    }, S = () => {
      A("doc-detail");
    }, N = () => {
      A("doc-download");
    }, T = () => {
      A("doc-share");
    }, R = () => {
      A("doc-move");
    }, y = () => {
      A("doc-copylink");
    }, E = () => {
      A("doc-delete");
    }, L = () => {
      A("doc-remove-space");
    }, _ = () => {
      A("doc-rename-folder");
    }, O = () => {
      A("doc-move-folder");
    }, D = () => {
      A("doc-delete-folder");
    }, M = () => {
      A("add-to-distribution-list");
    }, C = () => {
      lr(() => {
        m.showDetail ? r.value.focus() : m.showDownload ? o.value.focus() : m.showDownload ? u.value.focus() : m.showShare ? c.value.focus() : m.showCopyLink ? l.value.focus() : m.showDelete ? i.value.focus() : m.showRemoveFromSpace ? h.value.focus() : m.showRenameFolder ? f.value.focus() : m.showMoveFolder ? p.value.focus() : m.showDeleteFolder ? d.value.focus() : m.showAddToDistList ? v.value.focus() : (g.value || []).length > 0 && g.value[0].value[0].focus();
      });
    }, I = Ht(() => m.showDetail || m.showDownload || m.showMove || m.showShare || m.showCopyLink || m.showDelete || m.showRemoveFromSpace || m.showRenameFolder || m.showMoveFolder || m.showDeleteFolder || m.showAddToDistList || (m.customActions || []).length > 0), w = Ht(() => m.overlayZIndex == null || m.overlayZIndex == null);
    return yf(() => {
      g.value = (m.customActions || []).map((F) => st());
    }), _f(() => {
      g.value = (m.customActions || []).map((F) => st());
    }), (F, k) => {
      const H = Nt("KIcon"), Z = Nt("OverlayPanel");
      return Oe(), je(dn, null, [
        I.value ? (Oe(), je("button", {
          key: 0,
          type: "button",
          class: "btn btn-icon k-btn-flat",
          title: "actions",
          onClick: k[0] || (k[0] = As((Y) => b(Y), ["stop"]))
        }, [
          ve("div", IC, [
            dt(H, {
              icon: "it-more-items",
              class: "icon-primary mr-2"
            }),
            F.showActionLabel ? (Oe(), je("span", NC, "Vedi azioni")) : mt("", !0)
          ])
        ])) : mt("", !0),
        dt(Z, {
          ref_key: "btnOverlayPanel",
          ref: t,
          class: "k-actions-menu-panel",
          style: mr({ "z-index": F.overlayZIndex }),
          "auto-z-index": w.value
        }, {
          default: Ft(() => [
            ve("div", LC, [
              F.showDetail ? (Oe(), je("a", {
                key: 0,
                ref_key: "detailButton",
                ref: r,
                href: "#",
                class: "btn btn-xs btn-icon k-btn-flat",
                onClick: S
              }, [
                ve("div", wC, [
                  F.showIcons ? (Oe(), Wt(H, {
                    key: 0,
                    class: "icon-primary mr-2",
                    icon: "it-search"
                  })) : mt("", !0),
                  xC
                ])
              ], 512)) : mt("", !0),
              F.showDownload ? (Oe(), je("button", {
                key: 1,
                ref_key: "downloadButton",
                ref: o,
                type: "button",
                class: "btn btn-xs btn-icon k-btn-flat",
                onClick: N
              }, [
                ve("div", BC, [
                  F.showIcons ? (Oe(), Wt(H, {
                    key: 0,
                    class: "icon-primary mr-2",
                    icon: "it-download"
                  })) : mt("", !0),
                  FC
                ])
              ], 512)) : mt("", !0),
              F.showMove ? (Oe(), je("button", {
                key: 2,
                ref_key: "moveButton",
                ref: u,
                type: "button",
                class: "btn btn-xs btn-icon k-btn-flat",
                onClick: R
              }, [
                ve("div", UC, [
                  F.showIcons ? (Oe(), Wt(H, {
                    key: 0,
                    class: "icon-primary mr-2",
                    icon: "it-chevron-right"
                  })) : mt("", !0),
                  kC
                ])
              ], 512)) : mt("", !0),
              F.showShare ? (Oe(), je("button", {
                key: 3,
                ref_key: "shareButton",
                ref: c,
                type: "button",
                class: "btn btn-xs btn-icon k-btn-flat",
                onClick: T
              }, [
                ve("div", KC, [
                  F.showIcons ? (Oe(), Wt(H, {
                    key: 0,
                    class: "icon-primary mr-2",
                    icon: "it-share"
                  })) : mt("", !0),
                  jC
                ])
              ], 512)) : mt("", !0),
              F.showCopyLink ? (Oe(), je("button", {
                key: 4,
                ref_key: "copylinkButton",
                ref: l,
                type: "button",
                class: "btn btn-xs btn-icon k-btn-flat",
                onClick: y
              }, [
                ve("div", WC, [
                  F.showIcons ? (Oe(), Wt(H, {
                    key: 0,
                    class: "icon-primary mr-2",
                    icon: "it-link"
                  })) : mt("", !0),
                  VC
                ])
              ], 512)) : mt("", !0),
              F.showDelete ? (Oe(), je("button", {
                key: 5,
                ref_key: "deleteButton",
                ref: i,
                type: "button",
                class: "btn btn-xs btn-icon k-btn-flat",
                onClick: E
              }, [
                ve("div", HC, [
                  F.showIcons ? (Oe(), Wt(H, {
                    key: 0,
                    class: "icon-primary mr-2",
                    icon: "it-delete"
                  })) : mt("", !0),
                  $C
                ])
              ], 512)) : mt("", !0),
              F.showRemoveFromSpace ? (Oe(), je("button", {
                key: 6,
                ref_key: "removeFromSpaceButton",
                ref: h,
                type: "button",
                class: "btn btn-xs btn-icon k-btn-flat",
                onClick: L
              }, [
                ve("div", GC, [
                  F.showIcons ? (Oe(), Wt(H, {
                    key: 0,
                    class: "icon-primary mr-2",
                    icon: "it-close-circle"
                  })) : mt("", !0),
                  zC
                ])
              ], 512)) : mt("", !0),
              F.showRenameFolder ? (Oe(), je("button", {
                key: 7,
                ref_key: "renameFolderButton",
                ref: f,
                type: "button",
                class: "btn btn-xs btn-icon k-btn-flat",
                onClick: _
              }, [
                ve("div", YC, [
                  F.showIcons ? (Oe(), Wt(H, {
                    key: 0,
                    class: "icon-primary mr-2",
                    icon: "it-pencil"
                  })) : mt("", !0),
                  XC
                ])
              ], 512)) : mt("", !0),
              F.showMoveFolder ? (Oe(), je("button", {
                key: 8,
                ref_key: "moveFolderButton",
                ref: p,
                type: "button",
                class: "btn btn-xs btn-icon k-btn-flat",
                onClick: O
              }, [
                ve("div", QC, [
                  F.showIcons ? (Oe(), Wt(H, {
                    key: 0,
                    class: "icon-primary mr-2",
                    icon: "it-chevron-right"
                  })) : mt("", !0),
                  JC
                ])
              ], 512)) : mt("", !0),
              F.showDeleteFolder ? (Oe(), je("button", {
                key: 9,
                ref_key: "deleteFolderButton",
                ref: d,
                type: "button",
                class: "btn btn-xs btn-icon k-btn-flat",
                onClick: D
              }, [
                ve("div", ZC, [
                  F.showIcons ? (Oe(), Wt(H, {
                    key: 0,
                    class: "icon-primary mr-2",
                    icon: "it-delete"
                  })) : mt("", !0),
                  qC
                ])
              ], 512)) : mt("", !0),
              F.showAddToDistList ? (Oe(), je("button", {
                key: 10,
                ref_key: "addToDistListButton",
                ref: v,
                type: "button",
                class: "btn btn-xs btn-icon k-btn-flat",
                onClick: M
              }, [
                ve("div", eM, [
                  F.showIcons ? (Oe(), Wt(H, {
                    key: 0,
                    class: "icon-primary mr-2",
                    icon: "it-list"
                  })) : mt("", !0),
                  tM
                ])
              ], 512)) : mt("", !0),
              (Oe(!0), je(dn, null, Un(F.customActions, (Y, j) => (Oe(), je("button", {
                ref_for: !0,
                ref: g.value[j],
                type: "button",
                class: "btn btn-xs btn-icon k-btn-flat",
                onClick: Y.handler
              }, [
                ve("div", rM, [
                  F.showIcons && (Y.icon || "") != "" ? (Oe(), Wt(H, {
                    key: 0,
                    class: "icon-primary mr-2",
                    icon: Y.icon
                  }, null, 8, ["icon"])) : mt("", !0),
                  ve("span", iM, lt(Y.label), 1)
                ])
              ], 8, nM))), 256))
            ])
          ]),
          _: 1
        }, 8, ["style", "auto-z-index"])
      ], 64);
    };
  }
});
var Lg = { exports: {} };
(function(n, e) {
  (function(t, r) {
    n.exports = r();
  })(Gf, function() {
    var t = 1e3, r = 6e4, o = 36e5, u = "millisecond", c = "second", l = "minute", i = "hour", h = "day", f = "week", p = "month", d = "quarter", v = "year", g = "date", m = "Invalid Date", A = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, b = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, S = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_") }, N = function(C, I, w) {
      var F = String(C);
      return !F || F.length >= I ? C : "" + Array(I + 1 - F.length).join(w) + C;
    }, T = { s: N, z: function(C) {
      var I = -C.utcOffset(), w = Math.abs(I), F = Math.floor(w / 60), k = w % 60;
      return (I <= 0 ? "+" : "-") + N(F, 2, "0") + ":" + N(k, 2, "0");
    }, m: function C(I, w) {
      if (I.date() < w.date())
        return -C(w, I);
      var F = 12 * (w.year() - I.year()) + (w.month() - I.month()), k = I.clone().add(F, p), H = w - k < 0, Z = I.clone().add(F + (H ? -1 : 1), p);
      return +(-(F + (w - k) / (H ? k - Z : Z - k)) || 0);
    }, a: function(C) {
      return C < 0 ? Math.ceil(C) || 0 : Math.floor(C);
    }, p: function(C) {
      return { M: p, y: v, w: f, d: h, D: g, h: i, m: l, s: c, ms: u, Q: d }[C] || String(C || "").toLowerCase().replace(/s$/, "");
    }, u: function(C) {
      return C === void 0;
    } }, R = "en", y = {};
    y[R] = S;
    var E = function(C) {
      return C instanceof D;
    }, L = function C(I, w, F) {
      var k;
      if (!I)
        return R;
      if (typeof I == "string") {
        var H = I.toLowerCase();
        y[H] && (k = H), w && (y[H] = w, k = H);
        var Z = I.split("-");
        if (!k && Z.length > 1)
          return C(Z[0]);
      } else {
        var Y = I.name;
        y[Y] = I, k = Y;
      }
      return !F && k && (R = k), k || !F && R;
    }, _ = function(C, I) {
      if (E(C))
        return C.clone();
      var w = typeof I == "object" ? I : {};
      return w.date = C, w.args = arguments, new D(w);
    }, O = T;
    O.l = L, O.i = E, O.w = function(C, I) {
      return _(C, { locale: I.$L, utc: I.$u, x: I.$x, $offset: I.$offset });
    };
    var D = function() {
      function C(w) {
        this.$L = L(w.locale, null, !0), this.parse(w);
      }
      var I = C.prototype;
      return I.parse = function(w) {
        this.$d = function(F) {
          var k = F.date, H = F.utc;
          if (k === null)
            return /* @__PURE__ */ new Date(NaN);
          if (O.u(k))
            return /* @__PURE__ */ new Date();
          if (k instanceof Date)
            return new Date(k);
          if (typeof k == "string" && !/Z$/i.test(k)) {
            var Z = k.match(A);
            if (Z) {
              var Y = Z[2] - 1 || 0, j = (Z[7] || "0").substring(0, 3);
              return H ? new Date(Date.UTC(Z[1], Y, Z[3] || 1, Z[4] || 0, Z[5] || 0, Z[6] || 0, j)) : new Date(Z[1], Y, Z[3] || 1, Z[4] || 0, Z[5] || 0, Z[6] || 0, j);
            }
          }
          return new Date(k);
        }(w), this.$x = w.x || {}, this.init();
      }, I.init = function() {
        var w = this.$d;
        this.$y = w.getFullYear(), this.$M = w.getMonth(), this.$D = w.getDate(), this.$W = w.getDay(), this.$H = w.getHours(), this.$m = w.getMinutes(), this.$s = w.getSeconds(), this.$ms = w.getMilliseconds();
      }, I.$utils = function() {
        return O;
      }, I.isValid = function() {
        return this.$d.toString() !== m;
      }, I.isSame = function(w, F) {
        var k = _(w);
        return this.startOf(F) <= k && k <= this.endOf(F);
      }, I.isAfter = function(w, F) {
        return _(w) < this.startOf(F);
      }, I.isBefore = function(w, F) {
        return this.endOf(F) < _(w);
      }, I.$g = function(w, F, k) {
        return O.u(w) ? this[F] : this.set(k, w);
      }, I.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, I.valueOf = function() {
        return this.$d.getTime();
      }, I.startOf = function(w, F) {
        var k = this, H = !!O.u(F) || F, Z = O.p(w), Y = function(ce, z) {
          var oe = O.w(k.$u ? Date.UTC(k.$y, z, ce) : new Date(k.$y, z, ce), k);
          return H ? oe : oe.endOf(h);
        }, j = function(ce, z) {
          return O.w(k.toDate()[ce].apply(k.toDate("s"), (H ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(z)), k);
        }, J = this.$W, ae = this.$M, G = this.$D, $ = "set" + (this.$u ? "UTC" : "");
        switch (Z) {
          case v:
            return H ? Y(1, 0) : Y(31, 11);
          case p:
            return H ? Y(1, ae) : Y(0, ae + 1);
          case f:
            var ie = this.$locale().weekStart || 0, re = (J < ie ? J + 7 : J) - ie;
            return Y(H ? G - re : G + (6 - re), ae);
          case h:
          case g:
            return j($ + "Hours", 0);
          case i:
            return j($ + "Minutes", 1);
          case l:
            return j($ + "Seconds", 2);
          case c:
            return j($ + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, I.endOf = function(w) {
        return this.startOf(w, !1);
      }, I.$set = function(w, F) {
        var k, H = O.p(w), Z = "set" + (this.$u ? "UTC" : ""), Y = (k = {}, k[h] = Z + "Date", k[g] = Z + "Date", k[p] = Z + "Month", k[v] = Z + "FullYear", k[i] = Z + "Hours", k[l] = Z + "Minutes", k[c] = Z + "Seconds", k[u] = Z + "Milliseconds", k)[H], j = H === h ? this.$D + (F - this.$W) : F;
        if (H === p || H === v) {
          var J = this.clone().set(g, 1);
          J.$d[Y](j), J.init(), this.$d = J.set(g, Math.min(this.$D, J.daysInMonth())).$d;
        } else
          Y && this.$d[Y](j);
        return this.init(), this;
      }, I.set = function(w, F) {
        return this.clone().$set(w, F);
      }, I.get = function(w) {
        return this[O.p(w)]();
      }, I.add = function(w, F) {
        var k, H = this;
        w = Number(w);
        var Z = O.p(F), Y = function(ae) {
          var G = _(H);
          return O.w(G.date(G.date() + Math.round(ae * w)), H);
        };
        if (Z === p)
          return this.set(p, this.$M + w);
        if (Z === v)
          return this.set(v, this.$y + w);
        if (Z === h)
          return Y(1);
        if (Z === f)
          return Y(7);
        var j = (k = {}, k[l] = r, k[i] = o, k[c] = t, k)[Z] || 1, J = this.$d.getTime() + w * j;
        return O.w(J, this);
      }, I.subtract = function(w, F) {
        return this.add(-1 * w, F);
      }, I.format = function(w) {
        var F = this, k = this.$locale();
        if (!this.isValid())
          return k.invalidDate || m;
        var H = w || "YYYY-MM-DDTHH:mm:ssZ", Z = O.z(this), Y = this.$H, j = this.$m, J = this.$M, ae = k.weekdays, G = k.months, $ = function(z, oe, de, pe) {
          return z && (z[oe] || z(F, H)) || de[oe].slice(0, pe);
        }, ie = function(z) {
          return O.s(Y % 12 || 12, z, "0");
        }, re = k.meridiem || function(z, oe, de) {
          var pe = z < 12 ? "AM" : "PM";
          return de ? pe.toLowerCase() : pe;
        }, ce = { YY: String(this.$y).slice(-2), YYYY: this.$y, M: J + 1, MM: O.s(J + 1, 2, "0"), MMM: $(k.monthsShort, J, G, 3), MMMM: $(G, J), D: this.$D, DD: O.s(this.$D, 2, "0"), d: String(this.$W), dd: $(k.weekdaysMin, this.$W, ae, 2), ddd: $(k.weekdaysShort, this.$W, ae, 3), dddd: ae[this.$W], H: String(Y), HH: O.s(Y, 2, "0"), h: ie(1), hh: ie(2), a: re(Y, j, !0), A: re(Y, j, !1), m: String(j), mm: O.s(j, 2, "0"), s: String(this.$s), ss: O.s(this.$s, 2, "0"), SSS: O.s(this.$ms, 3, "0"), Z };
        return H.replace(b, function(z, oe) {
          return oe || ce[z] || Z.replace(":", "");
        });
      }, I.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, I.diff = function(w, F, k) {
        var H, Z = O.p(F), Y = _(w), j = (Y.utcOffset() - this.utcOffset()) * r, J = this - Y, ae = O.m(this, Y);
        return ae = (H = {}, H[v] = ae / 12, H[p] = ae, H[d] = ae / 3, H[f] = (J - j) / 6048e5, H[h] = (J - j) / 864e5, H[i] = J / o, H[l] = J / r, H[c] = J / t, H)[Z] || J, k ? ae : O.a(ae);
      }, I.daysInMonth = function() {
        return this.endOf(p).$D;
      }, I.$locale = function() {
        return y[this.$L];
      }, I.locale = function(w, F) {
        if (!w)
          return this.$L;
        var k = this.clone(), H = L(w, F, !0);
        return H && (k.$L = H), k;
      }, I.clone = function() {
        return O.w(this.$d, this);
      }, I.toDate = function() {
        return new Date(this.valueOf());
      }, I.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, I.toISOString = function() {
        return this.$d.toISOString();
      }, I.toString = function() {
        return this.$d.toUTCString();
      }, C;
    }(), M = D.prototype;
    return _.prototype = M, [["$ms", u], ["$s", c], ["$m", l], ["$H", i], ["$W", h], ["$M", p], ["$y", v], ["$D", g]].forEach(function(C) {
      M[C[1]] = function(I) {
        return this.$g(I, C[0], C[1]);
      };
    }), _.extend = function(C, I) {
      return C.$i || (C(I, D, _), C.$i = !0), _;
    }, _.locale = L, _.isDayjs = E, _.unix = function(C) {
      return _(1e3 * C);
    }, _.en = y[R], _.Ls = y, _.p = {}, _;
  });
})(Lg);
var wg = Lg.exports;
const gn = /* @__PURE__ */ Gl(wg), oM = { class: "input-group" }, sM = ["id", "for"], lM = /* @__PURE__ */ Dt({
  __name: "KDatePicker",
  props: {
    id: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    inputId: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    modelValue: { default: null },
    labelText: { default: "" },
    class: { default: "" },
    disabled: { type: Boolean },
    dateFormat: { default: "dd/mm/yy" },
    useUTC: { type: Boolean, default: !0 },
    maxDate: { default: null },
    formGroupClass: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    st(null);
    const t = e, r = st(), o = st(Math.floor(Math.random() * 65536).toString(16)), u = n;
    un(
      () => u.modelValue,
      async (l) => {
        l ? r.value = u.useUTC ? gn.utc(l).local().toDate() : l : r.value = null, await lr();
        var i = document.getElementById(u.inputId);
        if (new ii(i), !l) {
          var h = document.getElementById(o.value);
          h.classList.remove("active");
        }
      },
      { immediate: !0 }
    ), ln(() => {
      var l = document.getElementById(u.inputId);
      new ii(l);
    });
    const c = (l) => {
      if (l) {
        var i = u.useUTC ? gn(l).utc(!0).toDate() : l;
        t("update:modelValue", i);
      } else
        t("update:modelValue", null);
    };
    return (l, i) => {
      const h = Nt("Calendar");
      return Oe(), je("div", {
        class: Ct(["form-group", l.formGroupClass])
      }, [
        ve("div", oM, [
          ve("label", {
            id: o.value,
            for: l.inputId,
            class: "input-label-text"
          }, lt(l.labelText), 9, sM),
          dt(h, {
            ref: "kdInputText",
            id: l.id,
            hideOnDateTimeSelect: !0,
            modelValue: r.value,
            "onUpdate:modelValue": [
              i[0] || (i[0] = (f) => r.value = f),
              i[1] || (i[1] = (f) => c(f))
            ],
            class: Ct(["k-datepicker-input", l.class]),
            inputId: l.inputId,
            "append-to": "self",
            maxDate: l.maxDate,
            selectionMode: "single",
            dateFormat: l.dateFormat,
            showIcon: !0,
            disabled: l.disabled,
            manualInput: !1,
            "show-button-bar": !0
          }, null, 8, ["id", "modelValue", "class", "inputId", "maxDate", "dateFormat", "disabled"])
        ])
      ], 2);
    };
  }
}), uM = {
  key: 0,
  class: "exact-center"
}, cM = {
  key: 1,
  class: "exact-center"
}, fM = /* @__PURE__ */ ve("p", null, "Anrteprima per il tipo di documento non disponibile", -1), dM = ["src", "title"], hM = /* @__PURE__ */ Dt({
  __name: "KDocumentPreview",
  props: {
    title: { default: "Anteprima" },
    visible: { type: Boolean },
    loading: { type: Boolean, default: !1 },
    loadingText: { default: "Caricamento.." },
    showDownloadButton: { type: Boolean, default: !1 },
    documentContent: {},
    documentName: { default: null }
  },
  emits: ["update:visible"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = Ht({
      get: () => t.visible,
      set: (f) => r("update:visible", f)
    }), u = [
      { type: "application/pdf", preview: !0, ext: "pdf" },
      { type: "image/png", preview: !0, ext: "png" },
      { type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document", ext: "docx" }
    ], c = Ht(() => {
      if (t.documentContent != null) {
        const f = t.documentContent.type;
        if (f && u.find((p) => p.type == f.trim().toLocaleLowerCase() && p.preview))
          return !0;
      }
      return !1;
    }), l = Ht(() => t.documentContent != null && t.documentContent.size > 0), i = Ht(() => c.value === !0 ? window.URL.createObjectURL(t.documentContent) : null), h = () => {
      if (!l.value)
        return;
      let f = t.documentName;
      if ((f == null || f.length == 0) && (f = `tmp_${(/* @__PURE__ */ new Date()).valueOf()}`), f.lastIndexOf(".") < 0) {
        const d = u.find((v) => {
          var g;
          return v.type == ((g = t.documentContent.type) == null ? void 0 : g.trim().toLocaleLowerCase());
        });
        d && (f += `.${d.ext}`);
      }
      let p = document.createElement("a");
      p.href = i.value, p.download = f, p.click();
    };
    return (f, p) => (Oe(), Wt(Ye(GE), {
      visible: o.value,
      "onUpdate:visible": p[0] || (p[0] = (d) => o.value = d),
      maximizable: !0,
      modal: !0,
      contentStyle: { height: "100%" },
      class: "k-document-preview"
    }, {
      header: Ft(() => [
        ve("h3", null, [
          an(lt(f.title) + " ", 1),
          f.showDownloadButton && !f.loading && l.value ? (Oe(), je("button", {
            key: 0,
            type: "button",
            class: "btn btn-outline-primary btn-xs btn-me ms-2",
            onClick: h
          }, " Scarica file ")) : mt("", !0)
        ])
      ]),
      default: Ft(() => [
        f.loading ? (Oe(), je("div", uM, [
          ve("div", null, [
            dt(Ye(zE)),
            ve("p", null, lt(f.loadingText), 1)
          ])
        ])) : c.value ? (Oe(), je("embed", {
          key: 2,
          src: i.value,
          title: f.title,
          style: { display: "inline", width: "100%", height: "99%" }
        }, null, 8, dM)) : (Oe(), je("div", cM, [
          fM,
          f.showDownloadButton && l.value ? (Oe(), je("button", {
            key: 0,
            type: "button",
            class: "btn",
            onClick: h
          }, "Scarica file")) : mt("", !0)
        ]))
      ]),
      _: 1
    }, 8, ["visible"]));
  }
});
var pM = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var e = {}, t = Symbol("test"), r = Object(t);
  if (typeof t == "string" || Object.prototype.toString.call(t) !== "[object Symbol]" || Object.prototype.toString.call(r) !== "[object Symbol]")
    return !1;
  var o = 42;
  e[t] = o;
  for (t in e)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(e).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(e).length !== 0)
    return !1;
  var u = Object.getOwnPropertySymbols(e);
  if (u.length !== 1 || u[0] !== t || !Object.prototype.propertyIsEnumerable.call(e, t))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var c = Object.getOwnPropertyDescriptor(e, t);
    if (c.value !== o || c.enumerable !== !0)
      return !1;
  }
  return !0;
}, Dh = typeof Symbol < "u" && Symbol, mM = pM, gM = function() {
  return typeof Dh != "function" || typeof Symbol != "function" || typeof Dh("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : mM();
}, vM = "Function.prototype.bind called on incompatible ", Nu = Array.prototype.slice, _M = Object.prototype.toString, EM = "[object Function]", yM = function(e) {
  var t = this;
  if (typeof t != "function" || _M.call(t) !== EM)
    throw new TypeError(vM + t);
  for (var r = Nu.call(arguments, 1), o, u = function() {
    if (this instanceof o) {
      var f = t.apply(
        this,
        r.concat(Nu.call(arguments))
      );
      return Object(f) === f ? f : this;
    } else
      return t.apply(
        e,
        r.concat(Nu.call(arguments))
      );
  }, c = Math.max(0, t.length - r.length), l = [], i = 0; i < c; i++)
    l.push("$" + i);
  if (o = Function("binder", "return function (" + l.join(",") + "){ return binder.apply(this,arguments); }")(u), t.prototype) {
    var h = function() {
    };
    h.prototype = t.prototype, o.prototype = new h(), h.prototype = null;
  }
  return o;
}, TM = yM, td = Function.prototype.bind || TM, AM = td, SM = AM.call(Function.call, Object.prototype.hasOwnProperty), sn, io = SyntaxError, xg = Function, Ha = TypeError, Lu = function(n) {
  try {
    return xg('"use strict"; return (' + n + ").constructor;")();
  } catch {
  }
}, oa = Object.getOwnPropertyDescriptor;
if (oa)
  try {
    oa({}, "");
  } catch {
    oa = null;
  }
var wu = function() {
  throw new Ha();
}, CM = oa ? function() {
  try {
    return arguments.callee, wu;
  } catch {
    try {
      return oa(arguments, "callee").get;
    } catch {
      return wu;
    }
  }
}() : wu, Ma = gM(), mi = Object.getPrototypeOf || function(n) {
  return n.__proto__;
}, Na = {}, MM = typeof Uint8Array > "u" ? sn : mi(Uint8Array), $a = {
  "%AggregateError%": typeof AggregateError > "u" ? sn : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? sn : ArrayBuffer,
  "%ArrayIteratorPrototype%": Ma ? mi([][Symbol.iterator]()) : sn,
  "%AsyncFromSyncIteratorPrototype%": sn,
  "%AsyncFunction%": Na,
  "%AsyncGenerator%": Na,
  "%AsyncGeneratorFunction%": Na,
  "%AsyncIteratorPrototype%": Na,
  "%Atomics%": typeof Atomics > "u" ? sn : Atomics,
  "%BigInt%": typeof BigInt > "u" ? sn : BigInt,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? sn : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": Error,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": EvalError,
  "%Float32Array%": typeof Float32Array > "u" ? sn : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? sn : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? sn : FinalizationRegistry,
  "%Function%": xg,
  "%GeneratorFunction%": Na,
  "%Int8Array%": typeof Int8Array > "u" ? sn : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? sn : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? sn : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": Ma ? mi(mi([][Symbol.iterator]())) : sn,
  "%JSON%": typeof JSON == "object" ? JSON : sn,
  "%Map%": typeof Map > "u" ? sn : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !Ma ? sn : mi((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? sn : Promise,
  "%Proxy%": typeof Proxy > "u" ? sn : Proxy,
  "%RangeError%": RangeError,
  "%ReferenceError%": ReferenceError,
  "%Reflect%": typeof Reflect > "u" ? sn : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? sn : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !Ma ? sn : mi((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? sn : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": Ma ? mi(""[Symbol.iterator]()) : sn,
  "%Symbol%": Ma ? Symbol : sn,
  "%SyntaxError%": io,
  "%ThrowTypeError%": CM,
  "%TypedArray%": MM,
  "%TypeError%": Ha,
  "%Uint8Array%": typeof Uint8Array > "u" ? sn : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? sn : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? sn : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? sn : Uint32Array,
  "%URIError%": URIError,
  "%WeakMap%": typeof WeakMap > "u" ? sn : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? sn : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? sn : WeakSet
}, bM = function n(e) {
  var t;
  if (e === "%AsyncFunction%")
    t = Lu("async function () {}");
  else if (e === "%GeneratorFunction%")
    t = Lu("function* () {}");
  else if (e === "%AsyncGeneratorFunction%")
    t = Lu("async function* () {}");
  else if (e === "%AsyncGenerator%") {
    var r = n("%AsyncGeneratorFunction%");
    r && (t = r.prototype);
  } else if (e === "%AsyncIteratorPrototype%") {
    var o = n("%AsyncGenerator%");
    o && (t = mi(o.prototype));
  }
  return $a[e] = t, t;
}, Oh = {
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, Is = td, _l = SM, RM = Is.call(Function.call, Array.prototype.concat), DM = Is.call(Function.apply, Array.prototype.splice), Ph = Is.call(Function.call, String.prototype.replace), El = Is.call(Function.call, String.prototype.slice), OM = Is.call(Function.call, RegExp.prototype.exec), PM = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, IM = /\\(\\)?/g, NM = function(e) {
  var t = El(e, 0, 1), r = El(e, -1);
  if (t === "%" && r !== "%")
    throw new io("invalid intrinsic syntax, expected closing `%`");
  if (r === "%" && t !== "%")
    throw new io("invalid intrinsic syntax, expected opening `%`");
  var o = [];
  return Ph(e, PM, function(u, c, l, i) {
    o[o.length] = l ? Ph(i, IM, "$1") : c || u;
  }), o;
}, LM = function(e, t) {
  var r = e, o;
  if (_l(Oh, r) && (o = Oh[r], r = "%" + o[0] + "%"), _l($a, r)) {
    var u = $a[r];
    if (u === Na && (u = bM(r)), typeof u > "u" && !t)
      throw new Ha("intrinsic " + e + " exists, but is not available. Please file an issue!");
    return {
      alias: o,
      name: r,
      value: u
    };
  }
  throw new io("intrinsic " + e + " does not exist!");
}, nd = function(e, t) {
  if (typeof e != "string" || e.length === 0)
    throw new Ha("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof t != "boolean")
    throw new Ha('"allowMissing" argument must be a boolean');
  if (OM(/^%?[^%]*%?$/, e) === null)
    throw new io("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var r = NM(e), o = r.length > 0 ? r[0] : "", u = LM("%" + o + "%", t), c = u.name, l = u.value, i = !1, h = u.alias;
  h && (o = h[0], DM(r, RM([0, 1], h)));
  for (var f = 1, p = !0; f < r.length; f += 1) {
    var d = r[f], v = El(d, 0, 1), g = El(d, -1);
    if ((v === '"' || v === "'" || v === "`" || g === '"' || g === "'" || g === "`") && v !== g)
      throw new io("property names with quotes must have matching quotes");
    if ((d === "constructor" || !p) && (i = !0), o += "." + d, c = "%" + o + "%", _l($a, c))
      l = $a[c];
    else if (l != null) {
      if (!(d in l)) {
        if (!t)
          throw new Ha("base intrinsic for " + e + " exists, but the property is not available.");
        return;
      }
      if (oa && f + 1 >= r.length) {
        var m = oa(l, d);
        p = !!m, p && "get" in m && !("originalValue" in m.get) ? l = m.get : l = l[d];
      } else
        p = _l(l, d), l = l[d];
      p && !i && ($a[c] = l);
    }
  }
  return l;
}, Bg = { exports: {} };
(function(n) {
  var e = td, t = nd, r = t("%Function.prototype.apply%"), o = t("%Function.prototype.call%"), u = t("%Reflect.apply%", !0) || e.call(o, r), c = t("%Object.getOwnPropertyDescriptor%", !0), l = t("%Object.defineProperty%", !0), i = t("%Math.max%");
  if (l)
    try {
      l({}, "a", { value: 1 });
    } catch {
      l = null;
    }
  n.exports = function(p) {
    var d = u(e, o, arguments);
    if (c && l) {
      var v = c(d, "length");
      v.configurable && l(
        d,
        "length",
        { value: 1 + i(0, p.length - (arguments.length - 1)) }
      );
    }
    return d;
  };
  var h = function() {
    return u(e, r, arguments);
  };
  l ? l(n.exports, "apply", { value: h }) : n.exports.apply = h;
})(Bg);
var wM = Bg.exports, Fg = nd, Ug = wM, xM = Ug(Fg("String.prototype.indexOf")), BM = function(e, t) {
  var r = Fg(e, !!t);
  return typeof r == "function" && xM(e, ".prototype.") > -1 ? Ug(r) : r;
}, rd = typeof Map == "function" && Map.prototype, xu = Object.getOwnPropertyDescriptor && rd ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, yl = rd && xu && typeof xu.get == "function" ? xu.get : null, FM = rd && Map.prototype.forEach, id = typeof Set == "function" && Set.prototype, Bu = Object.getOwnPropertyDescriptor && id ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, Tl = id && Bu && typeof Bu.get == "function" ? Bu.get : null, UM = id && Set.prototype.forEach, kM = typeof WeakMap == "function" && WeakMap.prototype, $o = kM ? WeakMap.prototype.has : null, KM = typeof WeakSet == "function" && WeakSet.prototype, Go = KM ? WeakSet.prototype.has : null, jM = typeof WeakRef == "function" && WeakRef.prototype, Ih = jM ? WeakRef.prototype.deref : null, WM = Boolean.prototype.valueOf, VM = Object.prototype.toString, HM = Function.prototype.toString, $M = String.prototype.match, ad = String.prototype.slice, Si = String.prototype.replace, GM = String.prototype.toUpperCase, Nh = String.prototype.toLowerCase, kg = RegExp.prototype.test, Lh = Array.prototype.concat, xr = Array.prototype.join, zM = Array.prototype.slice, wh = Math.floor, Uc = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, Fu = Object.getOwnPropertySymbols, kc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, ao = typeof Symbol == "function" && typeof Symbol.iterator == "object", Wn = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === ao || "symbol") ? Symbol.toStringTag : null, Kg = Object.prototype.propertyIsEnumerable, xh = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(n) {
  return n.__proto__;
} : null);
function Bh(n, e) {
  if (n === 1 / 0 || n === -1 / 0 || n !== n || n && n > -1e3 && n < 1e3 || kg.call(/e/, e))
    return e;
  var t = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if (typeof n == "number") {
    var r = n < 0 ? -wh(-n) : wh(n);
    if (r !== n) {
      var o = String(r), u = ad.call(e, o.length + 1);
      return Si.call(o, t, "$&_") + "." + Si.call(Si.call(u, /([0-9]{3})/g, "$&_"), /_$/, "");
    }
  }
  return Si.call(e, t, "$&_");
}
var Kc = TC, Fh = Kc.custom, Uh = Wg(Fh) ? Fh : null, YM = function n(e, t, r, o) {
  var u = t || {};
  if (gi(u, "quoteStyle") && u.quoteStyle !== "single" && u.quoteStyle !== "double")
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  if (gi(u, "maxStringLength") && (typeof u.maxStringLength == "number" ? u.maxStringLength < 0 && u.maxStringLength !== 1 / 0 : u.maxStringLength !== null))
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  var c = gi(u, "customInspect") ? u.customInspect : !0;
  if (typeof c != "boolean" && c !== "symbol")
    throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
  if (gi(u, "indent") && u.indent !== null && u.indent !== "	" && !(parseInt(u.indent, 10) === u.indent && u.indent > 0))
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  if (gi(u, "numericSeparator") && typeof u.numericSeparator != "boolean")
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  var l = u.numericSeparator;
  if (typeof e > "u")
    return "undefined";
  if (e === null)
    return "null";
  if (typeof e == "boolean")
    return e ? "true" : "false";
  if (typeof e == "string")
    return Hg(e, u);
  if (typeof e == "number") {
    if (e === 0)
      return 1 / 0 / e > 0 ? "0" : "-0";
    var i = String(e);
    return l ? Bh(e, i) : i;
  }
  if (typeof e == "bigint") {
    var h = String(e) + "n";
    return l ? Bh(e, h) : h;
  }
  var f = typeof u.depth > "u" ? 5 : u.depth;
  if (typeof r > "u" && (r = 0), r >= f && f > 0 && typeof e == "object")
    return jc(e) ? "[Array]" : "[Object]";
  var p = db(u, r);
  if (typeof o > "u")
    o = [];
  else if (Vg(o, e) >= 0)
    return "[Circular]";
  function d(C, I, w) {
    if (I && (o = zM.call(o), o.push(I)), w) {
      var F = {
        depth: u.depth
      };
      return gi(u, "quoteStyle") && (F.quoteStyle = u.quoteStyle), n(C, F, r + 1, o);
    }
    return n(C, u, r + 1, o);
  }
  if (typeof e == "function" && !kh(e)) {
    var v = rb(e), g = Gs(e, d);
    return "[Function" + (v ? ": " + v : " (anonymous)") + "]" + (g.length > 0 ? " { " + xr.call(g, ", ") + " }" : "");
  }
  if (Wg(e)) {
    var m = ao ? Si.call(String(e), /^(Symbol\(.*\))_[^)]*$/, "$1") : kc.call(e);
    return typeof e == "object" && !ao ? Oo(m) : m;
  }
  if (ub(e)) {
    for (var A = "<" + Nh.call(String(e.nodeName)), b = e.attributes || [], S = 0; S < b.length; S++)
      A += " " + b[S].name + "=" + jg(XM(b[S].value), "double", u);
    return A += ">", e.childNodes && e.childNodes.length && (A += "..."), A += "</" + Nh.call(String(e.nodeName)) + ">", A;
  }
  if (jc(e)) {
    if (e.length === 0)
      return "[]";
    var N = Gs(e, d);
    return p && !fb(N) ? "[" + Wc(N, p) + "]" : "[ " + xr.call(N, ", ") + " ]";
  }
  if (JM(e)) {
    var T = Gs(e, d);
    return !("cause" in Error.prototype) && "cause" in e && !Kg.call(e, "cause") ? "{ [" + String(e) + "] " + xr.call(Lh.call("[cause]: " + d(e.cause), T), ", ") + " }" : T.length === 0 ? "[" + String(e) + "]" : "{ [" + String(e) + "] " + xr.call(T, ", ") + " }";
  }
  if (typeof e == "object" && c) {
    if (Uh && typeof e[Uh] == "function" && Kc)
      return Kc(e, { depth: f - r });
    if (c !== "symbol" && typeof e.inspect == "function")
      return e.inspect();
  }
  if (ib(e)) {
    var R = [];
    return FM.call(e, function(C, I) {
      R.push(d(I, e, !0) + " => " + d(C, e));
    }), Kh("Map", yl.call(e), R, p);
  }
  if (sb(e)) {
    var y = [];
    return UM.call(e, function(C) {
      y.push(d(C, e));
    }), Kh("Set", Tl.call(e), y, p);
  }
  if (ab(e))
    return Uu("WeakMap");
  if (lb(e))
    return Uu("WeakSet");
  if (ob(e))
    return Uu("WeakRef");
  if (qM(e))
    return Oo(d(Number(e)));
  if (tb(e))
    return Oo(d(Uc.call(e)));
  if (eb(e))
    return Oo(WM.call(e));
  if (ZM(e))
    return Oo(d(String(e)));
  if (!QM(e) && !kh(e)) {
    var E = Gs(e, d), L = xh ? xh(e) === Object.prototype : e instanceof Object || e.constructor === Object, _ = e instanceof Object ? "" : "null prototype", O = !L && Wn && Object(e) === e && Wn in e ? ad.call(Bi(e), 8, -1) : _ ? "Object" : "", D = L || typeof e.constructor != "function" ? "" : e.constructor.name ? e.constructor.name + " " : "", M = D + (O || _ ? "[" + xr.call(Lh.call([], O || [], _ || []), ": ") + "] " : "");
    return E.length === 0 ? M + "{}" : p ? M + "{" + Wc(E, p) + "}" : M + "{ " + xr.call(E, ", ") + " }";
  }
  return String(e);
};
function jg(n, e, t) {
  var r = (t.quoteStyle || e) === "double" ? '"' : "'";
  return r + n + r;
}
function XM(n) {
  return Si.call(String(n), /"/g, "&quot;");
}
function jc(n) {
  return Bi(n) === "[object Array]" && (!Wn || !(typeof n == "object" && Wn in n));
}
function QM(n) {
  return Bi(n) === "[object Date]" && (!Wn || !(typeof n == "object" && Wn in n));
}
function kh(n) {
  return Bi(n) === "[object RegExp]" && (!Wn || !(typeof n == "object" && Wn in n));
}
function JM(n) {
  return Bi(n) === "[object Error]" && (!Wn || !(typeof n == "object" && Wn in n));
}
function ZM(n) {
  return Bi(n) === "[object String]" && (!Wn || !(typeof n == "object" && Wn in n));
}
function qM(n) {
  return Bi(n) === "[object Number]" && (!Wn || !(typeof n == "object" && Wn in n));
}
function eb(n) {
  return Bi(n) === "[object Boolean]" && (!Wn || !(typeof n == "object" && Wn in n));
}
function Wg(n) {
  if (ao)
    return n && typeof n == "object" && n instanceof Symbol;
  if (typeof n == "symbol")
    return !0;
  if (!n || typeof n != "object" || !kc)
    return !1;
  try {
    return kc.call(n), !0;
  } catch {
  }
  return !1;
}
function tb(n) {
  if (!n || typeof n != "object" || !Uc)
    return !1;
  try {
    return Uc.call(n), !0;
  } catch {
  }
  return !1;
}
var nb = Object.prototype.hasOwnProperty || function(n) {
  return n in this;
};
function gi(n, e) {
  return nb.call(n, e);
}
function Bi(n) {
  return VM.call(n);
}
function rb(n) {
  if (n.name)
    return n.name;
  var e = $M.call(HM.call(n), /^function\s*([\w$]+)/);
  return e ? e[1] : null;
}
function Vg(n, e) {
  if (n.indexOf)
    return n.indexOf(e);
  for (var t = 0, r = n.length; t < r; t++)
    if (n[t] === e)
      return t;
  return -1;
}
function ib(n) {
  if (!yl || !n || typeof n != "object")
    return !1;
  try {
    yl.call(n);
    try {
      Tl.call(n);
    } catch {
      return !0;
    }
    return n instanceof Map;
  } catch {
  }
  return !1;
}
function ab(n) {
  if (!$o || !n || typeof n != "object")
    return !1;
  try {
    $o.call(n, $o);
    try {
      Go.call(n, Go);
    } catch {
      return !0;
    }
    return n instanceof WeakMap;
  } catch {
  }
  return !1;
}
function ob(n) {
  if (!Ih || !n || typeof n != "object")
    return !1;
  try {
    return Ih.call(n), !0;
  } catch {
  }
  return !1;
}
function sb(n) {
  if (!Tl || !n || typeof n != "object")
    return !1;
  try {
    Tl.call(n);
    try {
      yl.call(n);
    } catch {
      return !0;
    }
    return n instanceof Set;
  } catch {
  }
  return !1;
}
function lb(n) {
  if (!Go || !n || typeof n != "object")
    return !1;
  try {
    Go.call(n, Go);
    try {
      $o.call(n, $o);
    } catch {
      return !0;
    }
    return n instanceof WeakSet;
  } catch {
  }
  return !1;
}
function ub(n) {
  return !n || typeof n != "object" ? !1 : typeof HTMLElement < "u" && n instanceof HTMLElement ? !0 : typeof n.nodeName == "string" && typeof n.getAttribute == "function";
}
function Hg(n, e) {
  if (n.length > e.maxStringLength) {
    var t = n.length - e.maxStringLength, r = "... " + t + " more character" + (t > 1 ? "s" : "");
    return Hg(ad.call(n, 0, e.maxStringLength), e) + r;
  }
  var o = Si.call(Si.call(n, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, cb);
  return jg(o, "single", e);
}
function cb(n) {
  var e = n.charCodeAt(0), t = {
    8: "b",
    9: "t",
    10: "n",
    12: "f",
    13: "r"
  }[e];
  return t ? "\\" + t : "\\x" + (e < 16 ? "0" : "") + GM.call(e.toString(16));
}
function Oo(n) {
  return "Object(" + n + ")";
}
function Uu(n) {
  return n + " { ? }";
}
function Kh(n, e, t, r) {
  var o = r ? Wc(t, r) : xr.call(t, ", ");
  return n + " (" + e + ") {" + o + "}";
}
function fb(n) {
  for (var e = 0; e < n.length; e++)
    if (Vg(n[e], `
`) >= 0)
      return !1;
  return !0;
}
function db(n, e) {
  var t;
  if (n.indent === "	")
    t = "	";
  else if (typeof n.indent == "number" && n.indent > 0)
    t = xr.call(Array(n.indent + 1), " ");
  else
    return null;
  return {
    base: t,
    prev: xr.call(Array(e + 1), t)
  };
}
function Wc(n, e) {
  if (n.length === 0)
    return "";
  var t = `
` + e.prev + e.base;
  return t + xr.call(n, "," + t) + `
` + e.prev;
}
function Gs(n, e) {
  var t = jc(n), r = [];
  if (t) {
    r.length = n.length;
    for (var o = 0; o < n.length; o++)
      r[o] = gi(n, o) ? e(n[o], n) : "";
  }
  var u = typeof Fu == "function" ? Fu(n) : [], c;
  if (ao) {
    c = {};
    for (var l = 0; l < u.length; l++)
      c["$" + u[l]] = u[l];
  }
  for (var i in n)
    gi(n, i) && (t && String(Number(i)) === i && i < n.length || ao && c["$" + i] instanceof Symbol || (kg.call(/[^\w$]/, i) ? r.push(e(i, n) + ": " + e(n[i], n)) : r.push(i + ": " + e(n[i], n))));
  if (typeof Fu == "function")
    for (var h = 0; h < u.length; h++)
      Kg.call(n, u[h]) && r.push("[" + e(u[h]) + "]: " + e(n[u[h]], n));
  return r;
}
var od = nd, yo = BM, hb = YM, pb = od("%TypeError%"), zs = od("%WeakMap%", !0), Ys = od("%Map%", !0), mb = yo("WeakMap.prototype.get", !0), gb = yo("WeakMap.prototype.set", !0), vb = yo("WeakMap.prototype.has", !0), _b = yo("Map.prototype.get", !0), Eb = yo("Map.prototype.set", !0), yb = yo("Map.prototype.has", !0), sd = function(n, e) {
  for (var t = n, r; (r = t.next) !== null; t = r)
    if (r.key === e)
      return t.next = r.next, r.next = n.next, n.next = r, r;
}, Tb = function(n, e) {
  var t = sd(n, e);
  return t && t.value;
}, Ab = function(n, e, t) {
  var r = sd(n, e);
  r ? r.value = t : n.next = {
    // eslint-disable-line no-param-reassign
    key: e,
    next: n.next,
    value: t
  };
}, Sb = function(n, e) {
  return !!sd(n, e);
}, Cb = function() {
  var e, t, r, o = {
    assert: function(u) {
      if (!o.has(u))
        throw new pb("Side channel does not contain " + hb(u));
    },
    get: function(u) {
      if (zs && u && (typeof u == "object" || typeof u == "function")) {
        if (e)
          return mb(e, u);
      } else if (Ys) {
        if (t)
          return _b(t, u);
      } else if (r)
        return Tb(r, u);
    },
    has: function(u) {
      if (zs && u && (typeof u == "object" || typeof u == "function")) {
        if (e)
          return vb(e, u);
      } else if (Ys) {
        if (t)
          return yb(t, u);
      } else if (r)
        return Sb(r, u);
      return !1;
    },
    set: function(u, c) {
      zs && u && (typeof u == "object" || typeof u == "function") ? (e || (e = new zs()), gb(e, u, c)) : Ys ? (t || (t = new Ys()), Eb(t, u, c)) : (r || (r = { key: {}, next: null }), Ab(r, u, c));
    }
  };
  return o;
}, Mb = String.prototype.replace, bb = /%20/g, ku = {
  RFC1738: "RFC1738",
  RFC3986: "RFC3986"
}, ld = {
  default: ku.RFC3986,
  formatters: {
    RFC1738: function(n) {
      return Mb.call(n, bb, "+");
    },
    RFC3986: function(n) {
      return String(n);
    }
  },
  RFC1738: ku.RFC1738,
  RFC3986: ku.RFC3986
}, Rb = ld, Ku = Object.prototype.hasOwnProperty, Xi = Array.isArray, Nr = function() {
  for (var n = [], e = 0; e < 256; ++e)
    n.push("%" + ((e < 16 ? "0" : "") + e.toString(16)).toUpperCase());
  return n;
}(), Db = function(e) {
  for (; e.length > 1; ) {
    var t = e.pop(), r = t.obj[t.prop];
    if (Xi(r)) {
      for (var o = [], u = 0; u < r.length; ++u)
        typeof r[u] < "u" && o.push(r[u]);
      t.obj[t.prop] = o;
    }
  }
}, $g = function(e, t) {
  for (var r = t && t.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, o = 0; o < e.length; ++o)
    typeof e[o] < "u" && (r[o] = e[o]);
  return r;
}, Ob = function n(e, t, r) {
  if (!t)
    return e;
  if (typeof t != "object") {
    if (Xi(e))
      e.push(t);
    else if (e && typeof e == "object")
      (r && (r.plainObjects || r.allowPrototypes) || !Ku.call(Object.prototype, t)) && (e[t] = !0);
    else
      return [e, t];
    return e;
  }
  if (!e || typeof e != "object")
    return [e].concat(t);
  var o = e;
  return Xi(e) && !Xi(t) && (o = $g(e, r)), Xi(e) && Xi(t) ? (t.forEach(function(u, c) {
    if (Ku.call(e, c)) {
      var l = e[c];
      l && typeof l == "object" && u && typeof u == "object" ? e[c] = n(l, u, r) : e.push(u);
    } else
      e[c] = u;
  }), e) : Object.keys(t).reduce(function(u, c) {
    var l = t[c];
    return Ku.call(u, c) ? u[c] = n(u[c], l, r) : u[c] = l, u;
  }, o);
}, Pb = function(e, t) {
  return Object.keys(t).reduce(function(r, o) {
    return r[o] = t[o], r;
  }, e);
}, Ib = function(n, e, t) {
  var r = n.replace(/\+/g, " ");
  if (t === "iso-8859-1")
    return r.replace(/%[0-9a-f]{2}/gi, unescape);
  try {
    return decodeURIComponent(r);
  } catch {
    return r;
  }
}, Nb = function(e, t, r, o, u) {
  if (e.length === 0)
    return e;
  var c = e;
  if (typeof e == "symbol" ? c = Symbol.prototype.toString.call(e) : typeof e != "string" && (c = String(e)), r === "iso-8859-1")
    return escape(c).replace(/%u[0-9a-f]{4}/gi, function(f) {
      return "%26%23" + parseInt(f.slice(2), 16) + "%3B";
    });
  for (var l = "", i = 0; i < c.length; ++i) {
    var h = c.charCodeAt(i);
    if (h === 45 || h === 46 || h === 95 || h === 126 || h >= 48 && h <= 57 || h >= 65 && h <= 90 || h >= 97 && h <= 122 || u === Rb.RFC1738 && (h === 40 || h === 41)) {
      l += c.charAt(i);
      continue;
    }
    if (h < 128) {
      l = l + Nr[h];
      continue;
    }
    if (h < 2048) {
      l = l + (Nr[192 | h >> 6] + Nr[128 | h & 63]);
      continue;
    }
    if (h < 55296 || h >= 57344) {
      l = l + (Nr[224 | h >> 12] + Nr[128 | h >> 6 & 63] + Nr[128 | h & 63]);
      continue;
    }
    i += 1, h = 65536 + ((h & 1023) << 10 | c.charCodeAt(i) & 1023), l += Nr[240 | h >> 18] + Nr[128 | h >> 12 & 63] + Nr[128 | h >> 6 & 63] + Nr[128 | h & 63];
  }
  return l;
}, Lb = function(e) {
  for (var t = [{ obj: { o: e }, prop: "o" }], r = [], o = 0; o < t.length; ++o)
    for (var u = t[o], c = u.obj[u.prop], l = Object.keys(c), i = 0; i < l.length; ++i) {
      var h = l[i], f = c[h];
      typeof f == "object" && f !== null && r.indexOf(f) === -1 && (t.push({ obj: c, prop: h }), r.push(f));
    }
  return Db(t), e;
}, wb = function(e) {
  return Object.prototype.toString.call(e) === "[object RegExp]";
}, xb = function(e) {
  return !e || typeof e != "object" ? !1 : !!(e.constructor && e.constructor.isBuffer && e.constructor.isBuffer(e));
}, Bb = function(e, t) {
  return [].concat(e, t);
}, Fb = function(e, t) {
  if (Xi(e)) {
    for (var r = [], o = 0; o < e.length; o += 1)
      r.push(t(e[o]));
    return r;
  }
  return t(e);
}, Gg = {
  arrayToObject: $g,
  assign: Pb,
  combine: Bb,
  compact: Lb,
  decode: Ib,
  encode: Nb,
  isBuffer: xb,
  isRegExp: wb,
  maybeMap: Fb,
  merge: Ob
}, zg = Cb, Vc = Gg, zo = ld, Ub = Object.prototype.hasOwnProperty, jh = {
  brackets: function(e) {
    return e + "[]";
  },
  comma: "comma",
  indices: function(e, t) {
    return e + "[" + t + "]";
  },
  repeat: function(e) {
    return e;
  }
}, ei = Array.isArray, kb = String.prototype.split, Kb = Array.prototype.push, Yg = function(n, e) {
  Kb.apply(n, ei(e) ? e : [e]);
}, jb = Date.prototype.toISOString, Wh = zo.default, wn = {
  addQueryPrefix: !1,
  allowDots: !1,
  charset: "utf-8",
  charsetSentinel: !1,
  delimiter: "&",
  encode: !0,
  encoder: Vc.encode,
  encodeValuesOnly: !1,
  format: Wh,
  formatter: zo.formatters[Wh],
  // deprecated
  indices: !1,
  serializeDate: function(e) {
    return jb.call(e);
  },
  skipNulls: !1,
  strictNullHandling: !1
}, Wb = function(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e == "symbol" || typeof e == "bigint";
}, ju = {}, Vb = function n(e, t, r, o, u, c, l, i, h, f, p, d, v, g, m, A) {
  for (var b = e, S = A, N = 0, T = !1; (S = S.get(ju)) !== void 0 && !T; ) {
    var R = S.get(e);
    if (N += 1, typeof R < "u") {
      if (R === N)
        throw new RangeError("Cyclic object value");
      T = !0;
    }
    typeof S.get(ju) > "u" && (N = 0);
  }
  if (typeof i == "function" ? b = i(t, b) : b instanceof Date ? b = p(b) : r === "comma" && ei(b) && (b = Vc.maybeMap(b, function(Z) {
    return Z instanceof Date ? p(Z) : Z;
  })), b === null) {
    if (u)
      return l && !g ? l(t, wn.encoder, m, "key", d) : t;
    b = "";
  }
  if (Wb(b) || Vc.isBuffer(b)) {
    if (l) {
      var y = g ? t : l(t, wn.encoder, m, "key", d);
      if (r === "comma" && g) {
        for (var E = kb.call(String(b), ","), L = "", _ = 0; _ < E.length; ++_)
          L += (_ === 0 ? "" : ",") + v(l(E[_], wn.encoder, m, "value", d));
        return [v(y) + (o && ei(b) && E.length === 1 ? "[]" : "") + "=" + L];
      }
      return [v(y) + "=" + v(l(b, wn.encoder, m, "value", d))];
    }
    return [v(t) + "=" + v(String(b))];
  }
  var O = [];
  if (typeof b > "u")
    return O;
  var D;
  if (r === "comma" && ei(b))
    D = [{ value: b.length > 0 ? b.join(",") || null : void 0 }];
  else if (ei(i))
    D = i;
  else {
    var M = Object.keys(b);
    D = h ? M.sort(h) : M;
  }
  for (var C = o && ei(b) && b.length === 1 ? t + "[]" : t, I = 0; I < D.length; ++I) {
    var w = D[I], F = typeof w == "object" && typeof w.value < "u" ? w.value : b[w];
    if (!(c && F === null)) {
      var k = ei(b) ? typeof r == "function" ? r(C, w) : C : C + (f ? "." + w : "[" + w + "]");
      A.set(e, N);
      var H = zg();
      H.set(ju, A), Yg(O, n(
        F,
        k,
        r,
        o,
        u,
        c,
        l,
        i,
        h,
        f,
        p,
        d,
        v,
        g,
        m,
        H
      ));
    }
  }
  return O;
}, Hb = function(e) {
  if (!e)
    return wn;
  if (e.encoder !== null && typeof e.encoder < "u" && typeof e.encoder != "function")
    throw new TypeError("Encoder has to be a function.");
  var t = e.charset || wn.charset;
  if (typeof e.charset < "u" && e.charset !== "utf-8" && e.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var r = zo.default;
  if (typeof e.format < "u") {
    if (!Ub.call(zo.formatters, e.format))
      throw new TypeError("Unknown format option provided.");
    r = e.format;
  }
  var o = zo.formatters[r], u = wn.filter;
  return (typeof e.filter == "function" || ei(e.filter)) && (u = e.filter), {
    addQueryPrefix: typeof e.addQueryPrefix == "boolean" ? e.addQueryPrefix : wn.addQueryPrefix,
    allowDots: typeof e.allowDots > "u" ? wn.allowDots : !!e.allowDots,
    charset: t,
    charsetSentinel: typeof e.charsetSentinel == "boolean" ? e.charsetSentinel : wn.charsetSentinel,
    delimiter: typeof e.delimiter > "u" ? wn.delimiter : e.delimiter,
    encode: typeof e.encode == "boolean" ? e.encode : wn.encode,
    encoder: typeof e.encoder == "function" ? e.encoder : wn.encoder,
    encodeValuesOnly: typeof e.encodeValuesOnly == "boolean" ? e.encodeValuesOnly : wn.encodeValuesOnly,
    filter: u,
    format: r,
    formatter: o,
    serializeDate: typeof e.serializeDate == "function" ? e.serializeDate : wn.serializeDate,
    skipNulls: typeof e.skipNulls == "boolean" ? e.skipNulls : wn.skipNulls,
    sort: typeof e.sort == "function" ? e.sort : null,
    strictNullHandling: typeof e.strictNullHandling == "boolean" ? e.strictNullHandling : wn.strictNullHandling
  };
}, $b = function(n, e) {
  var t = n, r = Hb(e), o, u;
  typeof r.filter == "function" ? (u = r.filter, t = u("", t)) : ei(r.filter) && (u = r.filter, o = u);
  var c = [];
  if (typeof t != "object" || t === null)
    return "";
  var l;
  e && e.arrayFormat in jh ? l = e.arrayFormat : e && "indices" in e ? l = e.indices ? "indices" : "repeat" : l = "indices";
  var i = jh[l];
  if (e && "commaRoundTrip" in e && typeof e.commaRoundTrip != "boolean")
    throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
  var h = i === "comma" && e && e.commaRoundTrip;
  o || (o = Object.keys(t)), r.sort && o.sort(r.sort);
  for (var f = zg(), p = 0; p < o.length; ++p) {
    var d = o[p];
    r.skipNulls && t[d] === null || Yg(c, Vb(
      t[d],
      d,
      i,
      h,
      r.strictNullHandling,
      r.skipNulls,
      r.encode ? r.encoder : null,
      r.filter,
      r.sort,
      r.allowDots,
      r.serializeDate,
      r.format,
      r.formatter,
      r.encodeValuesOnly,
      r.charset,
      f
    ));
  }
  var v = c.join(r.delimiter), g = r.addQueryPrefix === !0 ? "?" : "";
  return r.charsetSentinel && (r.charset === "iso-8859-1" ? g += "utf8=%26%2310003%3B&" : g += "utf8=%E2%9C%93&"), v.length > 0 ? g + v : "";
}, oo = Gg, Hc = Object.prototype.hasOwnProperty, Gb = Array.isArray, On = {
  allowDots: !1,
  allowPrototypes: !1,
  allowSparse: !1,
  arrayLimit: 20,
  charset: "utf-8",
  charsetSentinel: !1,
  comma: !1,
  decoder: oo.decode,
  delimiter: "&",
  depth: 5,
  ignoreQueryPrefix: !1,
  interpretNumericEntities: !1,
  parameterLimit: 1e3,
  parseArrays: !0,
  plainObjects: !1,
  strictNullHandling: !1
}, zb = function(n) {
  return n.replace(/&#(\d+);/g, function(e, t) {
    return String.fromCharCode(parseInt(t, 10));
  });
}, Xg = function(n, e) {
  return n && typeof n == "string" && e.comma && n.indexOf(",") > -1 ? n.split(",") : n;
}, Yb = "utf8=%26%2310003%3B", Xb = "utf8=%E2%9C%93", Qb = function(e, t) {
  var r = {}, o = t.ignoreQueryPrefix ? e.replace(/^\?/, "") : e, u = t.parameterLimit === 1 / 0 ? void 0 : t.parameterLimit, c = o.split(t.delimiter, u), l = -1, i, h = t.charset;
  if (t.charsetSentinel)
    for (i = 0; i < c.length; ++i)
      c[i].indexOf("utf8=") === 0 && (c[i] === Xb ? h = "utf-8" : c[i] === Yb && (h = "iso-8859-1"), l = i, i = c.length);
  for (i = 0; i < c.length; ++i)
    if (i !== l) {
      var f = c[i], p = f.indexOf("]="), d = p === -1 ? f.indexOf("=") : p + 1, v, g;
      d === -1 ? (v = t.decoder(f, On.decoder, h, "key"), g = t.strictNullHandling ? null : "") : (v = t.decoder(f.slice(0, d), On.decoder, h, "key"), g = oo.maybeMap(
        Xg(f.slice(d + 1), t),
        function(m) {
          return t.decoder(m, On.decoder, h, "value");
        }
      )), g && t.interpretNumericEntities && h === "iso-8859-1" && (g = zb(g)), f.indexOf("[]=") > -1 && (g = Gb(g) ? [g] : g), Hc.call(r, v) ? r[v] = oo.combine(r[v], g) : r[v] = g;
    }
  return r;
}, Jb = function(n, e, t, r) {
  for (var o = r ? e : Xg(e, t), u = n.length - 1; u >= 0; --u) {
    var c, l = n[u];
    if (l === "[]" && t.parseArrays)
      c = [].concat(o);
    else {
      c = t.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      var i = l.charAt(0) === "[" && l.charAt(l.length - 1) === "]" ? l.slice(1, -1) : l, h = parseInt(i, 10);
      !t.parseArrays && i === "" ? c = { 0: o } : !isNaN(h) && l !== i && String(h) === i && h >= 0 && t.parseArrays && h <= t.arrayLimit ? (c = [], c[h] = o) : i !== "__proto__" && (c[i] = o);
    }
    o = c;
  }
  return o;
}, Zb = function(e, t, r, o) {
  if (e) {
    var u = r.allowDots ? e.replace(/\.([^.[]+)/g, "[$1]") : e, c = /(\[[^[\]]*])/, l = /(\[[^[\]]*])/g, i = r.depth > 0 && c.exec(u), h = i ? u.slice(0, i.index) : u, f = [];
    if (h) {
      if (!r.plainObjects && Hc.call(Object.prototype, h) && !r.allowPrototypes)
        return;
      f.push(h);
    }
    for (var p = 0; r.depth > 0 && (i = l.exec(u)) !== null && p < r.depth; ) {
      if (p += 1, !r.plainObjects && Hc.call(Object.prototype, i[1].slice(1, -1)) && !r.allowPrototypes)
        return;
      f.push(i[1]);
    }
    return i && f.push("[" + u.slice(i.index) + "]"), Jb(f, t, r, o);
  }
}, qb = function(e) {
  if (!e)
    return On;
  if (e.decoder !== null && e.decoder !== void 0 && typeof e.decoder != "function")
    throw new TypeError("Decoder has to be a function.");
  if (typeof e.charset < "u" && e.charset !== "utf-8" && e.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var t = typeof e.charset > "u" ? On.charset : e.charset;
  return {
    allowDots: typeof e.allowDots > "u" ? On.allowDots : !!e.allowDots,
    allowPrototypes: typeof e.allowPrototypes == "boolean" ? e.allowPrototypes : On.allowPrototypes,
    allowSparse: typeof e.allowSparse == "boolean" ? e.allowSparse : On.allowSparse,
    arrayLimit: typeof e.arrayLimit == "number" ? e.arrayLimit : On.arrayLimit,
    charset: t,
    charsetSentinel: typeof e.charsetSentinel == "boolean" ? e.charsetSentinel : On.charsetSentinel,
    comma: typeof e.comma == "boolean" ? e.comma : On.comma,
    decoder: typeof e.decoder == "function" ? e.decoder : On.decoder,
    delimiter: typeof e.delimiter == "string" || oo.isRegExp(e.delimiter) ? e.delimiter : On.delimiter,
    // eslint-disable-next-line no-implicit-coercion, no-extra-parens
    depth: typeof e.depth == "number" || e.depth === !1 ? +e.depth : On.depth,
    ignoreQueryPrefix: e.ignoreQueryPrefix === !0,
    interpretNumericEntities: typeof e.interpretNumericEntities == "boolean" ? e.interpretNumericEntities : On.interpretNumericEntities,
    parameterLimit: typeof e.parameterLimit == "number" ? e.parameterLimit : On.parameterLimit,
    parseArrays: e.parseArrays !== !1,
    plainObjects: typeof e.plainObjects == "boolean" ? e.plainObjects : On.plainObjects,
    strictNullHandling: typeof e.strictNullHandling == "boolean" ? e.strictNullHandling : On.strictNullHandling
  };
}, eR = function(n, e) {
  var t = qb(e);
  if (n === "" || n === null || typeof n > "u")
    return t.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  for (var r = typeof n == "string" ? Qb(n, t) : n, o = t.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, u = Object.keys(r), c = 0; c < u.length; ++c) {
    var l = u[c], i = Zb(l, r[l], t, typeof n == "string");
    o = oo.merge(o, i, t);
  }
  return t.allowSparse === !0 ? o : oo.compact(o);
}, tR = $b, nR = eR, rR = ld, iR = {
  formats: rR,
  parse: nR,
  stringify: tR
};
const aR = /* @__PURE__ */ Gl(iR), Xs = XE.create({
  headers: { "Content-type": "application/json" },
  withCredentials: !0,
  paramsSerializer: (n) => aR.stringify(n, { arrayFormat: "repeat" })
}), ci = {
  online: !1,
  name: "unknown",
  version: "?"
};
function Dr() {
  return {
    api: Xs,
    execApiCall: async (c, l = null) => {
      l && (l.value = !0);
      try {
        return await c;
      } catch (i) {
        return console.log("Error executing api call: " + i), null;
      } finally {
        l && (l.value = !1);
      }
    },
    configureApiUrl: (c) => {
      Xs.defaults.baseURL = c;
    },
    initializePlatform: async (c) => {
      try {
        const l = await Xs.get("platform/info/" + c);
        if (l && l.status === 200 && l.data) {
          const i = {
            //title: response.data.intranetTitle,
            modules: l.data.modules
          };
          return i == null, i;
        }
      } catch {
        console.error(`Failed call to DP365+ Api info for app type '${c}'!`);
      }
      return null;
    },
    getApiStatus: async () => {
      var c, l, i;
      try {
        const h = await Xs.get("status/ping");
        h && h.status === 200 && h.data && (ci.online = ((c = h.data) == null ? void 0 : c.statusCode) == "OK", ci.lastCall = /* @__PURE__ */ new Date(), ci.name = (l = h.data) == null ? void 0 : l.name, ci.version = (i = h.data) == null ? void 0 : i.version, ci.online && (ci.lastSuccesfulCall = ci.lastCall));
      } catch {
        console.error("Failed call to DP365+ Api ping!");
      }
      return ci;
    },
    kToast: {
      showInfo: (c, l = null, i = 3e3) => {
        const { _toastQueue: h } = fn();
        h.value.push({ type: "info", message: c, detail: l, life: i });
      },
      showSuccess: (c, l = null, i = 3e3) => {
        const { _toastQueue: h } = fn();
        h.value.push({ type: "success", message: c, detail: l, life: i });
      },
      showWarning: (c, l = null, i = 3e3) => {
        const { _toastQueue: h } = fn();
        h.value.push({ type: "warn", message: c, detail: l, life: i });
      },
      showError: (c, l = null, i = 3e3) => {
        const { _toastQueue: h } = fn();
        h.value.push({ type: "error", message: c, detail: l, life: i });
      }
    },
    kConfirm: {
      requireConfirm: (c, l, i = null, h = null) => {
        const { _confirmQueue: f } = fn();
        h || (h = "Conferma richiesta"), f.value.push({ title: h, message: c, accept: l, reject: i });
      }
    }
  };
}
const { api: oR } = Dr();
class To {
  constructor() {
    Kn(this, "_lastResponseStatus", null);
    Kn(this, "tryExecute", async (e) => {
      this._lastResponseStatus = null;
      try {
        return await e;
      } catch (t) {
        console.error("Server communication error.. " + t);
        const r = t;
        return r && r.isAxiosError && r.response && (console.warn("Error status " + r.response.status + " requesting endpoint " + r.config.url), this._lastResponseStatus = r.response.status, r.response.status == 400 && (console.error(r.response.data), r.response.data), r.response.status == 500 ? console.error(r.response.data) : r.response.status == 403 || r.response.status == 401), null;
      }
    });
  }
  get api() {
    return oR;
  }
  handleApiResponse(e) {
    if (e)
      return e.success || console.warn("Server response valid but request unsuccessful.." + JSON.stringify(e.messages)), e.data;
  }
  handleApiResultSuccess(e) {
    if (e)
      return e.success || console.warn("Server response valid but request unsuccessful.." + JSON.stringify(e.messages)), e.success;
  }
  parseDownloadedFileResponse(e, t) {
    if (e) {
      let r = t;
      try {
        r = e.headers["content-disposition"].split("filename=")[1].split(";")[0].replaceAll('"', "");
      } catch {
        console.error("Errore parsing filename dopo download. Uso nome default.");
      }
      return {
        contentType: e.headers["content-type"],
        fileName: `${r}`,
        fileStream: e.data
      };
    }
  }
}
class rj {
  constructor(e) {
    Kn(this, "propertyName", "");
    Kn(this, "code", "");
    Kn(this, "text");
    Kn(this, "type", "");
    this.text = e;
  }
}
class ij {
  constructor() {
    Kn(this, "pageIndex");
    Kn(this, "pageSize");
    Kn(this, "sortField");
    Kn(this, "sortOrder");
  }
}
var sR = /* @__PURE__ */ ((n) => (n[n.Descending = -1] = "Descending", n[n.Ascending = 1] = "Ascending", n))(sR || {}), Bo = /* @__PURE__ */ ((n) => (n.ModuleContainer = "ModuleContainer", n.WebLink = "WebLink", n.ExternalPage = "ExternalPage", n.DMS = "DMS", n.Act = "Act", n.Learning = "Learning", n.WebExpert = "WebExpert", n.WebTv = "WebTv", n.Employee = "Employee", n.DPRDI = "DPRDI", n.Vibes = "Vibes", n.KSoar = "KSoar", n.Custom = "Custom", n))(Bo || {});
class lR extends To {
  async getTreeFromNode(e, t) {
    let r = null;
    return t && t > 0 && (r = { maxNumOfChildren: t }), (await this.tryExecute(
      this.api.get("CMS/node-tree/" + e, { params: r })
    )).data;
  }
  async getNode(e, t) {
    return (await this.tryExecute(
      this.api.get("CMS/node/" + e, { params: t })
    )).data;
  }
}
const Qg = new lR();
class uR extends To {
  async getLatestVideos(e = 3, t = 0) {
    const r = {
      skip: t,
      numOfVideos: e,
      excludeHomeVideos: !1
    };
    return (await this.tryExecute(
      this.api.get("webtv/latest", { params: r })
    )).data;
  }
  async getVideoDetails(e) {
    return (await this.tryExecute(
      this.api.get(`webtv/video/${e}`)
    )).data;
  }
  async getVideoSources(e) {
    return (await this.tryExecute(
      this.api.get(`webtv/video/${e}/sources`)
    )).data;
  }
  async getRelatedVideos(e) {
    return (await this.tryExecute(
      this.api.get(`webtv/video/${e}/related`)
    )).data;
  }
  async updateVideoWatchCounter(e) {
    await this.tryExecute(
      this.api.post(`webtv/video/${e}/watch`)
    );
  }
  async searchVideos(e, t = 15, r = 0) {
    const o = {
      searchText: e,
      skip: r,
      numOfVideos: t
    };
    return (await this.tryExecute(
      this.api.get("webtv/simple-search", { params: o })
    )).data;
  }
  buildVideoAssetUrl(e) {
    return `${this.api.defaults.baseURL}webtv/${e}`;
  }
}
const Jr = new uR();
class cR extends To {
  async getHomeLinks() {
    return (await this.tryExecute(
      this.api.get("platform/home-links")
    )).data;
  }
}
const aj = new cR(), { execApiCall: Qs } = Dr(), Ql = Ss("kappa-web-tv-store", {
  state: () => ({
    latestVideos: [],
    searchedVideos: [],
    searching: !1,
    advancedSearchTerm: "",
    advancedSearchResults: []
  }),
  getters: {
    //
  },
  actions: {
    getSmallThumbnailUrl(n) {
      return Jr.buildVideoAssetUrl(n.smallThumbnailUrl);
    },
    getMediumThumbnailUrl(n) {
      return Jr.buildVideoAssetUrl(n.mediumThumbnailUrl);
    },
    getLargeThumbnailUrl(n) {
      return Jr.buildVideoAssetUrl(n.largeThumbnailUrl);
    },
    async getLatestVideos(n = 3, e = 0) {
      const t = await Qs(Jr.getLatestVideos());
      return t && t.length >= 0 && (this.latestVideos = t), t;
    },
    async searchVideos(n, e = 12, t = 0) {
      const r = await Qs(Jr.searchVideos(n, e, t));
      return r && r.length >= 0 && (this.searchedVideos = r), r;
    },
    async advancedSearch() {
      this.searching = !0;
      try {
        this.advancedSearchTerm && this.advancedSearchTerm.trim().length > 0 ? this.advancedSearchResults = await Qs(Jr.searchVideos(this.advancedSearchTerm, 12)) : this.advancedSearchResults = await Qs(Jr.getLatestVideos(12));
      } catch (n) {
        console.error(n);
      } finally {
        this.searching = !1;
      }
    }
  }
});
class fR {
  constructor() {
    Kn(this, "source", "web-tv");
    Kn(this, "sourceDescription", "Web TV");
    Kn(this, "_lastSearch", "");
    Kn(this, "_lastSkip", 0);
  }
  async searchAsync(e) {
    return this._lastSearch = e, await this._searchVideos();
  }
  async loadMoreAsync() {
    return await this._searchVideos();
  }
  async _searchVideos() {
    const e = Ql(), t = await e.searchVideos(this._lastSearch, 5, this._lastSkip), r = t.map((o) => ({
      source: this.source,
      title: o.title,
      description: o.description,
      thumbnail: e.getSmallThumbnailUrl(o),
      url: "/video/" + o.id
    }));
    return this._lastSkip = this._lastSkip + t.length, r;
  }
}
const Jg = new fR();
let Po = null, Wu = null;
const Vu = st("DP365+ Kappa Application"), Vh = st(null), Hh = st(!1), $h = st("/"), Hu = st("/"), Gh = st(!0), zh = st(!1), Yh = st(""), ba = [], $u = [], Xh = st(null), Gu = st(), dR = st([]), hR = st([]);
function fn() {
  const n = (f) => {
    f.routingOptions || (f.routingOptions = {
      routeBasePath: f.routeBasePath
    }), f.routingOptions.routerBeforeNavigateGuard || (f.routingOptions.routerBeforeNavigateGuard = f.routerBeforeNavigateGuard), f.routingOptions.customUserSignupPath || (f.routingOptions.customUserSignupPath = f.customRegistrationPagePath), Vu.value = f.appName, Vh.value = f.appType, Hh.value = f.beta === !0, Hu.value = f.routingOptions.routeBasePath, f.routingOptions.homeRoutePath && f.routingOptions.homeRoutePath.length > 0 && ($h.value = f.routingOptions.homeRoutePath), Xh.value = f.routingOptions.customUserSignupPath, f.routingOptions.hideLogoInLoginPage && (Gh.value = !f.routingOptions.hideLogoInLoginPage), zh.value = f.showFooter === !0, Yh.value = f.routingOptions.privacyPath, f.notificationOptions ? Gu.value = f.notificationOptions : Gu.value = {
      hideNotificationsButton: !1,
      disableNotificationReply: !1
    };
  }, e = (f) => {
    Po = f, Po && Po.modules && Po.modules.forEach((p) => {
      p.key == "webtv" && ba.push(Jg);
    });
  }, t = () => {
    let f = typeof APP_NAME < "u" ? APP_NAME : "DP365+ kappa app";
    const p = Vu.value;
    return p && p.trim().length > 0 && (f = p.trim()), f;
  }, r = () => typeof APP_VERSION < "u" ? APP_VERSION : "1.0.0", o = (f) => {
    let p = Hu.value;
    p || (p = "/"), p.endsWith("/") || (p = p + "/");
    let d = "";
    if (f)
      for (d = f; d.startsWith("/") || d.startsWith("\\"); )
        d = d.substring(1);
    return p = p + d, p;
  }, u = (f) => {
    let p = null;
    if (Wu) {
      const d = Wu(f), v = d;
      v && v.initModule !== void 0 ? (console.log("caricato modulo custom: " + v.name), l(v.searchPlugins, v.notificationPlugins), v.initModule(), p = v.routes) : (console.log("caricato modulo custom solo come routes.."), p = d);
    }
    return p;
  }, c = (f) => {
    Wu = f;
  }, l = (f, p) => {
    f && f.forEach((d) => {
      if (d == null || d.source == null || d.searchAsync == null || d.source.trim().length == 0)
        throw new Error(`Global search plugin not valid! => '${JSON.stringify(d)}'`);
      ba.findIndex((v) => v.source.trim().toLowerCase() == d.source.trim().toLowerCase()) < 0 && ba.push(d);
    }), p && p.forEach((d) => {
      if (d == null || d.handlingModule == null)
        throw new Error(`Custom notification handler plugin not valid! => '${JSON.stringify(d)}'`);
      i(d.handlingModule) == null && $u.push(d);
    });
  }, i = (f) => $u.find((p) => {
    var d;
    return ((d = p.handlingModule) == null ? void 0 : d.trim().toLowerCase()) == (f == null ? void 0 : f.trim().toLowerCase());
  });
  return {
    // INTERNAL SERVICES STRUCTURES
    _toastQueue: dR,
    _confirmQueue: hR,
    // GENERAL APP SETTINGS
    _appName: Vu,
    _appType: Vh,
    _appBeta: Hh,
    _appHomeRoutePath: $h,
    _appRouteBasePath: Hu,
    _showLogoInLoginPage: Gh,
    _showFooter: zh,
    _privacyPath: Yh,
    storeAppOptions: n,
    getPathForAsset: o,
    getAppTitle: t,
    getAppVersion: r,
    //getLoginEndpoint,
    // INITIAL APPLICATION SETUP
    _config: Po,
    storeConfig: e,
    storePlugins: l,
    // CUSTOM MODULE RESOLVER
    setCustomModuleResolver: c,
    getCustomModule: u,
    // GLOBAL SEARCH PLUGINS
    _searchPlugins: ba,
    isGlobalSearchEnabled: () => ba && ba.length > 0,
    // NOTIFICATION SETTINGS & HANDLERS
    _appOptionsNotification: Gu,
    _customNotificationHandlers: $u,
    getCustomNotificationHandlerForModule: i,
    // CUSTOM routes paths
    _customRegistrationPagePath: Xh
  };
}
const pR = { class: "k-layout-centered-wrapper" }, mR = /* @__PURE__ */ Dt({
  __name: "SplashLayout",
  setup(n) {
    const { getAppTitle: e, getAppVersion: t } = fn();
    return t(), (r, o) => (Oe(), je("div", pR, " Caricamento... "));
  }
}), gR = { class: "k-layout-centered-wrapper" }, vR = {
  class: "k-layout-version-badge",
  role: "presentation"
}, _R = /* @__PURE__ */ Dt({
  __name: "AnonymousLayout",
  setup(n) {
    const { getAppTitle: e, getAppVersion: t } = fn(), r = t();
    return (o, u) => {
      const c = Nt("router-view");
      return Oe(), je(dn, null, [
        ve("div", gR, [
          dt(c)
        ]),
        ve("div", vR, "v. " + lt(Ye(r)), 1)
      ], 64);
    };
  }
});
class ER extends To {
  async login(e, t) {
    const { _appType: r } = fn(), o = await this.tryExecute(
      this.api.post("account/login", { username: e, password: t, application: r.value })
    );
    return this._lastResponseStatus == 422 ? {
      userName: e,
      lastLoginBeforeThis: null,
      passwordExpired: !0,
      defaultLanguageId: "",
      siteId: ""
    } : o.data;
  }
  async loginWithVerificationCode(e, t) {
    const r = "account/mfa-verify-code", o = await this.tryExecute(
      this.api.post(r, { username: e, verificationCode: t })
    );
    return this._lastResponseStatus == 422 ? {
      userName: e,
      lastLoginBeforeThis: null,
      passwordExpired: !0,
      defaultLanguageId: "",
      siteId: ""
    } : o.data;
  }
  async requestNewVerificationCode(e, t) {
    const r = "account/mfa-resend-code";
    return (await this.tryExecute(
      this.api.post(r, { username: e, channel: t })
    )).data;
  }
  async loginWithSsoToken(e) {
    const { _appType: t } = fn();
    return (await this.tryExecute(
      this.api.get(`account/sso-login/${t.value}/${e}`)
    )).data;
  }
  async logout() {
    return (await this.tryExecute(
      this.api.get("account/logout")
    )).data;
  }
  async refresh() {
    const { _appType: e } = fn();
    return (await this.tryExecute(
      this.api.get("account/refresh?application=" + e.value)
    )).data;
  }
  async getLoggedUserInfo() {
    const { _appType: e } = fn();
    return (await this.tryExecute(
      this.api.get("account/me?application=" + e.value)
    )).data;
  }
  async getUserFavourites() {
    return (await this.tryExecute(this.api.get("account/favourites"))).data;
  }
  async changePassword(e, t, r) {
    return (await this.tryExecute(
      this.api.post("account/change-password", { currentpassword: e, newpassword: t, confirmnewpassword: r })
    )).data;
  }
  async changeExpiredPassword(e, t, r, o) {
    return (await this.tryExecute(
      this.api.post("account/change-expired-password", { username: e, currentpassword: t, newpassword: r, confirmnewpassword: o })
    )).data;
  }
  async generateVerificationCode(e) {
    return (await this.tryExecute(
      this.api.post("account/generate-verification-code", { email: e })
    )).data;
  }
  async verifyVerificationCode(e, t) {
    return (await this.tryExecute(
      this.api.post("account/verify-verification-code", { email: e, verificationCode: t })
    )).data;
  }
  async resetPasswordWithToken(e, t) {
    const r = await this.tryExecute(
      this.api.post("account/reset-password-by-token", { token: e, password: t })
    );
    return console.log(r.data), r.data;
  }
}
const rr = new ER();
class yR extends To {
  async getProjects() {
    const e = {}, t = await this.tryExecute(
      this.api.get("dprdi/projects", { params: e })
    );
    return t && t.status == 200 ? t.data.items : null;
  }
}
const TR = new yR(), AR = ["href"], SR = /* @__PURE__ */ Dt({
  __name: "Projects",
  setup(n) {
    const e = st(!1), t = st([]), { toDateString: r } = Gr();
    return ln(async () => {
      e.value = !0;
      try {
        t.value = await TR.getProjects();
      } catch {
      } finally {
        e.value = !1;
      }
    }), (o, u) => {
      const c = Nt("PageHeader"), l = Nt("Column"), i = Nt("DataTable"), h = Nt("Page");
      return Oe(), Wt(h, { loading: e.value }, {
        default: Ft(() => [
          dt(c, { title: "Progetti" }),
          dt(i, {
            value: t.value,
            "table-class": "k-data-table"
          }, {
            default: Ft(() => [
              dt(l, { header: "Cliente" }, {
                body: Ft((f) => [
                  ve("span", null, lt(f.data.clienteRagSociale), 1)
                ]),
                _: 1
              }),
              dt(l, { header: "Codice" }, {
                body: Ft((f) => [
                  ve("span", null, lt(f.data.codice), 1)
                ]),
                _: 1
              }),
              dt(l, { header: "Titolo" }, {
                body: Ft((f) => [
                  ve("span", null, lt(f.data.titolo), 1)
                ]),
                _: 1
              }),
              dt(l, { header: "Inizio" }, {
                body: Ft((f) => [
                  ve("span", null, lt(Ye(r)(f.data.dataInizio)), 1)
                ]),
                _: 1
              }),
              dt(l, { header: "Fine" }, {
                body: Ft((f) => [
                  ve("span", null, lt(Ye(r)(f.data.dataFine)), 1)
                ]),
                _: 1
              }),
              dt(l, { header: "Inizio" }, {
                body: Ft((f) => [
                  ve("span", null, [
                    ve("a", {
                      href: f.data.deepLinkProgetto,
                      target: "_blank"
                    }, "APRI", 8, AR)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _: 1
      }, 8, ["loading"]);
    };
  }
}), Zg = [
  {
    name: "projects-list",
    path: "/projects",
    component: SR,
    meta: {
      requiresAuth: !0,
      menu: {
        order: 4,
        label: "Progetti",
        iconAsset: "icons/ico-comunicazioni.svg"
      }
    }
  }
], CR = { class: "external-iframe-container" }, MR = ["src"], bR = /* @__PURE__ */ Dt({
  __name: "ExternalPage",
  setup(n) {
    const e = st(!1);
    kn();
    const t = $r(), r = Ht(() => t.meta.menu.pageTitle), o = Ht(() => t.meta.menu.pageContent), u = () => {
      e.value = !1, clearTimeout(c);
    };
    let c;
    return ln(async () => {
      c = setTimeout(() => {
        e.value === !0 && (e.value = !1, console.warn("External page loading timeout.."));
      }, 1e4);
    }), oi(() => clearTimeout(c)), (l, i) => {
      const h = Nt("PageHeader"), f = Nt("Page");
      return Oe(), Wt(f, { loading: e.value }, {
        default: Ft(() => [
          dt(h, { title: r.value }, null, 8, ["title"]),
          ve("div", CR, [
            ve("iframe", {
              src: o.value,
              onLoad: u,
              class: "external-iframe"
            }, null, 40, MR)
          ])
        ]),
        _: 1
      }, 8, ["loading"]);
    };
  }
});
const ud = (n, e) => {
  const t = n.__vccOpts || n;
  for (const [r, o] of e)
    t[r] = o;
  return t;
}, qg = /* @__PURE__ */ ud(bR, [["__scopeId", "data-v-6147e4de"]]), oj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qg
}, Symbol.toStringTag, { value: "Module" })), { api: zu, execApiCall: Lr } = Dr();
zu.interceptors.response.use(
  (n) => n,
  async function(n) {
    var o;
    const { _appType: e } = fn(), t = n.config, r = (t == null ? void 0 : t.url).startsWith("account/login");
    if (n.response.status === 401 && !r && !t._retry && ((o = e.value) == null ? void 0 : o.length) > 0) {
      t._retry = !0;
      const u = await zu.get("account/refresh?application=" + e.value);
      if ((u == null ? void 0 : u.status) == 200)
        return await zu(t);
    }
    return Promise.reject(n);
  }
);
const yr = Ss("kappa-user-store", {
  state: () => ({
    userAuthData: void 0,
    user: null,
    userInfo: null,
    userFavourites: [],
    systemFavourites: [],
    userRoutes: []
  }),
  getters: {
    isLogged(n) {
      if (n.userAuthData && n.userAuthData.userName) {
        const e = n.userAuthData.userName.length > 0 && n.userAuthData.passwordExpired === !0, t = n.userAuthData.userName.length > 0 && n.userAuthData.requireVerificationCode === !0;
        return !(e || t);
      }
      return !1;
    },
    userDisplayName(n) {
      return n.user && n.user.displayName && n.user.displayName.length > 0 ? (n.user.displayName.split(" ").length > 3, n.user.displayName) : "unknown";
    }
  },
  actions: {
    async changePassword(n, e, t) {
      return await Lr(rr.changePassword(n, e, t));
    },
    async changeExpiredPassword(n, e, t) {
      const r = await Lr(rr.changeExpiredPassword(this.userAuthData.userName, n, e, t));
      return r && r.success === !0 ? (await this.login(this.userAuthData.userName, e), !0) : !1;
    },
    async login(n, e) {
      const t = await Lr(rr.login(n.trim(), e.trim()));
      t && t.userName && (this.userAuthData = t, t.passwordExpired !== !0 ? await this.initUser() : console.warn("User valid but password expired."));
    },
    async loginWithVerificationCode(n) {
      var r, o;
      const e = (o = (r = this.userAuthData) == null ? void 0 : r.userName) == null ? void 0 : o.trim(), t = await Lr(rr.loginWithVerificationCode(e, n == null ? void 0 : n.trim()));
      t && t.userName && (this.userAuthData = t, t.passwordExpired !== !0 ? await this.initUser() : console.warn("User valid but password expired."));
    },
    async requestNewVerificationCode() {
      var t, r;
      const n = (r = (t = this.userAuthData) == null ? void 0 : t.userName) == null ? void 0 : r.trim();
      return await Lr(rr.requestNewVerificationCode(n, null));
    },
    async loginSso(n) {
      try {
        const e = await Lr(rr.loginWithSsoToken(n));
        if (e && e.userName)
          return this.userAuthData = e, await this.initUser(), !0;
      } catch (e) {
        console.error(e);
      }
      return !1;
    },
    async refreshToken() {
      const n = await Lr(rr.refresh());
      n && n.userName && (this.userAuthData = n);
    },
    async logout() {
      await Lr(rr.logout()) && this.$reset();
    },
    async initUser() {
      const n = await Lr(rr.getLoggedUserInfo());
      if (n && n.user) {
        const e = this.router;
        RR(e, n), this.user = n, this.userInfo = n.user, this.userLastAccess = n.lastAccess;
        const t = await Lr(rr.getUserFavourites());
        t && (this.userFavourites = t.filter((r) => r.category.indexOf("SYSTEM.") > 0), this.systemFavourites = t.filter((r) => r.category.indexOf("SYSTEM.") == 0));
      }
    }
  }
}), RR = (n, e) => {
  n.getRoutes().filter((l) => !l.meta || l.meta.static != !0).map((l) => l.name).filter((l) => l && l.toString().length > 0).forEach((l) => n.removeRoute(l));
  const r = n.getRoutes();
  let o = 0;
  const { getCustomModule: u } = fn(), c = e && e.userModules;
  c && c.length > 0 && c.forEach((l) => {
    if (l.moduleType != Bo.ModuleContainer) {
      if (r.find((h) => h.path == l.routePath))
        console.error("Tentativo di caricare un modulo aggiuntivo con route path già esistente per un modulo differente!");
      else if (l.moduleType == Bo.DPRDI)
        Zg.forEach((h) => {
          Qh(h, o++), n.addRoute(h);
        });
      else if (l.moduleType == Bo.Custom) {
        const h = u(l.pageContent);
        h && h.length > 0 && h.forEach((f) => {
          Qh(f, o++), n.addRoute(f);
        });
      }
    } else
      l.children && l.children.length > 0 && l.children.forEach((i) => {
        if (r.find((f) => f.path == i.routePath || i.routeName && i.routeName.length > 0 && f.name == i.routeName))
          console.error("Tentativo di caricare un modulo aggiuntivo con route path già esistente per un modulo differente!");
        else if (i.moduleType == Bo.ExternalPage) {
          const f = {
            path: i.routePath,
            component: qg,
            meta: {
              requiresAuth: !0,
              menu: {
                isUserCustom: !0,
                order: i.menuOrder && i.menuOrder >= 0 ? i.menuLabel : 99,
                label: i.menuLabel,
                group: l.menuLabel,
                iconAsset: l.menuIconAsset,
                // specific to external page
                pageTitle: i.pageTitle,
                pageContent: i.pageContent
              }
            }
          };
          i.routeName && i.routeName.length > 0 ? f.name = i.routeName : f.name = "_dyn_route_" + o++, n.addRoute(f);
        }
      });
  });
}, Qh = (n, e) => {
  (!n.name || n.name.toString().trim() == "") && (n.name = "_dyn_route_" + e);
}, DR = Ss("kappa-global-calendar-store", {
  state: () => ({
    calendarItems: []
  }),
  getters: {},
  actions: {
    addCalendarEventItems(n) {
      if (n && n.length > 0) {
        let e = [...this.calendarItems];
        n.forEach((t) => {
          const r = e.findIndex((o) => o.moduleKey === t.moduleKey && o.moduleId === t.moduleId);
          r < 0 ? e.push(t) : e.splice(r, 1, t);
        }), this.calendarItems = e;
      }
    }
  }
}), Ns = Ss("kappa-global-search-store", {
  state: () => ({
    isSearchGlobalModalOpened: !1,
    results: [],
    searching: !1,
    searchingMore: !1,
    searchText: "",
    resultSourceSelected: [],
    lastSearchResultCount: -1
    // -1... ricerca in stato default da avviare
  }),
  getters: {
    isGlobalSearchEnabled(n) {
      const { isGlobalSearchEnabled: e } = fn();
      return e();
    },
    sourcesFilters(n) {
      let e = [];
      const { _searchPlugins: t } = fn();
      return t.forEach((r) => {
        const o = {
          source: r.source.trim().toUpperCase(),
          resultsCount: n.results.filter((u) => u.source == r.source).length
        };
        e.push(o);
      }), e;
    },
    filteredResults(n) {
      return n.results.filter((t) => n.resultSourceSelected && n.resultSourceSelected.length > 0 ? n.resultSourceSelected.findIndex((r) => r.source == t.source.trim().toUpperCase()) >= 0 : !0);
    },
    totalResultsCount(n) {
      return n.results.length;
    }
  },
  actions: {
    // addSearchPlugin(plugin: GlobalSearchPlugin) {
    //     if(plugin == null || plugin.source == null || plugin.searchAsync == null || plugin.source.trim().length == 0) {
    //         throw new Error(`Global plugin not valid! => '${JSON.stringify(plugin)}'`);
    //     }
    //     if(this.plugins.findIndex(p => p.source.trim().toLowerCase() == plugin.source.trim().toLowerCase()) > -1) {
    //         throw new Error(`Global plugin already registered for source '${plugin.source.trim()}'`);
    //     }
    //     this.plugins.push(plugin);
    // },
    async executeGlobalSearch(n) {
      let e = [];
      this.searching = !0;
      try {
        this.results = [], this.resultSourceSelected = [];
        let t = [];
        const { _searchPlugins: r } = fn();
        r.forEach((u) => t.push(u.searchAsync(n))), (await Promise.allSettled(t)).forEach((u) => {
          u.status === "fulfilled" && e.push(...u.value);
        }), this.lastSearchResultCount = e.length, this.results = e;
      } catch (t) {
        console.warn(t);
      } finally {
        this.searching = !1;
      }
      return e;
    },
    async executeGlobalSearchMoreResult() {
      let n = [];
      this.searchingMore = !0;
      try {
        let e = [];
        const { _searchPlugins: t } = fn();
        t.forEach((o) => e.push(o.loadMoreAsync())), (await Promise.allSettled(e)).forEach((o) => {
          o.status === "fulfilled" && n.push(...o.value);
        }), this.lastSearchResultCount = n.length, this.results.push(...n);
      } catch (e) {
        console.warn(e);
      } finally {
        this.searchingMore = !1;
      }
      return n;
    },
    resetSearch() {
      this.searchText = "", this.results = [], this.resultSourceSelected = [], this.lastSearchResultCount = -1;
    }
  }
});
class OR extends To {
  async getInAppNotifications(e) {
    const t = {
      pageIndex: e.page,
      pageSize: e.size,
      search: e.search,
      readState: e.readState
    };
    return (await this.tryExecute(
      this.api.get("notifications", { params: t })
    )).data;
  }
  async getLatestInAppNotifications(e, t) {
    const r = {
      itemsNum: e,
      onlyUnread: t
    };
    return (await this.tryExecute(
      this.api.get("notifications/latest", { params: r })
    )).data;
  }
  async getInAppUnreadNotificationsCount() {
    return (await this.tryExecute(
      this.api.get("notifications/unread-count")
    )).data;
  }
  async setNotificationRead(e) {
    return (await this.tryExecute(
      this.api.post(`notifications/${e}/read`)
    )).data;
  }
  async setNotificationUnread(e) {
    return (await this.tryExecute(
      this.api.post(`notifications/${e}/unread`)
    )).data;
  }
  async sendInAppNotification(e, t, r) {
    const o = { targetId: e, subject: t, body: r };
    return (await this.tryExecute(
      this.api.post("notifications", o)
    )).data.success;
  }
}
const vi = new OR(), { execApiCall: Io } = Dr(), cd = Ss("kappa-notifications-store", {
  state: () => ({
    filter: {
      page: 0,
      search: "",
      size: 10,
      unreadOnly: null
    },
    totalUnreadCount: 0,
    searching: !1,
    notifications: [],
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
    selectedNotification: null
  }),
  getters: {
    optionsStates(n) {
      let e = [];
      return e.push({ name: "", value: "" }), e.push({ name: "Lette", value: "true" }), e.push({ name: "Da leggere", value: "false" }), e;
    },
    optionsDepartments(n) {
      return [];
    }
  },
  actions: {
    async loadUnreadNotificationsCount() {
      try {
        this.totalUnreadCount = await Io(vi.getInAppUnreadNotificationsCount());
      } catch {
        console.warn("Unread notifications count request failed!");
      }
    },
    async loadNotifications(n = !1) {
      try {
        this.searching = !0, n && (this.filter.page = 0, this.filter.search = "", this.filter.size = 10, this.filter.unreadOnly = null), this.filter.idNotification = null;
        const e = await Io(vi.getInAppNotifications(this.filter));
        this.notifications = e.items, this.currentPage = e.currentPage, this.totalCount = e.totalCount, this.totalPages = e.totalPages;
      } finally {
        this.searching = !1;
      }
    },
    async loadNotification(n) {
      try {
        this.searching = !0, this.filter.page = 0, this.filter.search = "", this.filter.size = 10, this.filter.unreadOnly = null, this.filter.idNotification = n;
        const e = await Io(vi.getInAppNotifications(this.filter));
        this.notifications = e.items, this.currentPage = e.currentPage, this.totalCount = e.totalCount, this.totalPages = e.totalPages;
      } finally {
        this.searching = !1;
      }
    },
    async setNotificationReadState(n, e) {
      try {
        let t;
        return e == !0 ? t = await Io(vi.setNotificationRead(n)) : t = await Io(vi.setNotificationUnread(n)), this.loadUnreadNotificationsCount(), t;
      } finally {
        this.searching = !1;
      }
    },
    async sendNotification(n) {
      await vi.sendInAppNotification(1, "Ecco la seconda notifica di Martedì", "Prosegue la settimana"), n === !0 && await this.loadNotifications();
    }
  }
}), PR = ["aria-label"], IR = ["href", "xlink:href"], yn = /* @__PURE__ */ Dt({
  __name: "KIcon",
  props: {
    class: { default: null },
    svgStyle: { default: null },
    icon: { default: "" }
  },
  setup(n) {
    const { getPathForAsset: e } = fn(), t = Ht(() => e("bi-sprites.svg#" + r.icon)), r = n;
    return (o, u) => (Oe(), je("svg", {
      class: Ct(["icon", o.class]),
      style: mr(o.svgStyle),
      "aria-label": "icon " + r.icon
    }, [
      ve("use", {
        href: t.value,
        "xlink:href": t.value
      }, null, 8, IR)
    ], 14, PR));
  }
}), NR = {
  key: 0,
  class: "d-flex justify-content-center",
  style: { "min-height": "72px" }
}, LR = /* @__PURE__ */ ve("div", { class: "progress-spinner-inner" }, null, -1), wR = /* @__PURE__ */ ve("div", { class: "progress-spinner-inner" }, null, -1), xR = /* @__PURE__ */ ve("span", { class: "visually-hidden" }, "Caricamento...", -1), BR = [
  LR,
  wR,
  xR
], FR = { key: 1 }, fd = /* @__PURE__ */ Dt({
  __name: "KSpinner",
  props: {
    spinnerClass: { default: "" },
    loading: { type: Boolean, default: !0 }
  },
  setup(n) {
    return (e, t) => e.loading ? (Oe(), je("div", NR, [
      ve("div", {
        class: Ct(["progress-spinner progress-spinner-double progress-spinner-active", e.spinnerClass])
      }, BR, 2)
    ])) : (Oe(), je("div", FR, [
      pn(e.$slots, "default")
    ]));
  }
}), UR = {
  class: "modal-dialog",
  role: "document"
}, kR = { class: "modal-content perfect-scrollbar" }, KR = {
  class: "modal-body",
  style: { "padding-bottom": "50px" }
}, jR = { class: "container" }, WR = { class: "row variable-gutters" }, VR = { class: "col" }, HR = { class: "modal-title" }, $R = {
  class: "search-link d-md-none",
  type: "button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#search-modal",
  "aria-label": "Chiudi e torna alla pagina precedente",
  "data-focus-mouse": "false"
}, GR = {
  class: "search-link d-none d-md-block",
  type: "button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#search-modal",
  "aria-label": "Chiudi e torna alla pagina precedente"
}, zR = { class: "modal-body" }, ev = /* @__PURE__ */ Dt({
  __name: "KModalFullPage",
  props: {
    modelValue: { type: Boolean },
    title: { default: "-" }
  },
  emits: ["closed", "update:modelValue"],
  setup(n, { emit: e }) {
    Ns();
    const t = n, r = e, o = "kmodal_" + Math.floor(Math.random() * 65536).toString(16);
    let u = null;
    ln(() => {
      const i = document.getElementById(o);
      u = ed.getOrCreateInstance(i, {
        keyboard: !1,
        backdrop: "static",
        focus: !0
      }), u && u._element && u._element.addEventListener("hidden.bs.modal", function(h) {
        r("update:modelValue", !1), r("closed");
      });
    }), po(() => {
      u && u.dispose();
    }), un(() => t.modelValue, (i) => {
      i === !0 ? c() : l();
    });
    const c = () => {
      u && u.show();
    }, l = () => {
      u && u.hide();
    };
    return (i, h) => (Oe(), Wt(Tf, { to: "body" }, [
      ve("div", {
        id: o,
        class: "modal fade search-modal",
        tabindex: "-1",
        "data-focus-mouse": "false",
        style: { display: "none" },
        "aria-hidden": "true"
      }, [
        ve("div", UR, [
          ve("div", kR, [
            ve("div", KR, [
              ve("div", jR, [
                ve("div", WR, [
                  ve("div", VR, [
                    ve("div", HR, [
                      ve("button", $R, [
                        dt(yn, {
                          class: "icon-md",
                          icon: "it-arrow-left"
                        })
                      ]),
                      ve("h1", null, lt(i.title), 1),
                      ve("button", GR, [
                        dt(yn, { icon: "it-close-big" })
                      ])
                    ]),
                    ve("div", zR, [
                      pn(i.$slots, "default")
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]));
  }
}), YR = {
  key: 0,
  class: "container"
}, XR = { class: "row justify-content-center" }, QR = { class: "col-lg-3 d-none d-lg-block scroll-filter-wrapper" }, JR = /* @__PURE__ */ ve("h2", {
  class: "visually-hidden",
  id: "filter"
}, "filtri da applicare", -1), ZR = { class: "categoy-list pb-4" }, qR = /* @__PURE__ */ ve("legend", { class: "h6 text-uppercase category-list__title" }, "Tipologie", -1), eD = { class: "form-check" }, tD = { class: "checkbox-body border-light py-3" }, nD = ["id", "value"], rD = ["for"], iD = { class: "col-lg-8 offset-lg-1" }, aD = { class: "d-flex justify-content-between align-items-center border-bottom border-light pb-3 mb-2" }, oD = /* @__PURE__ */ ve("h2", {
  class: "visually-hidden",
  id: "search-result"
}, "Risultati di ricerca", -1), sD = { class: "search-results u-grey-light" }, lD = { class: "numResult" }, uD = {
  type: "button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal-categories",
  class: "btn p-0 pe-2 d-lg-none"
}, cD = { class: "rounded-icon" }, fD = /* @__PURE__ */ ve("span", { class: "t-primary title-xsmall-semi-bold ms-1" }, "Filtra", -1), dD = ["disabled"], hD = { class: "container p-0" }, pD = { class: "row flex-column-reverse flex-lg-row" }, mD = { class: "col-12 pt-3" }, gD = { class: "card shadow-sm px-4 pt-4 pb-4 rounded" }, vD = /* @__PURE__ */ ve("span", { class: "visually-hidden" }, "Categoria:", -1), _D = { class: "card-header border-0 p-0" }, ED = { class: "text-decoration-none title-xsmall-bold mb-2 category text-uppercase" }, yD = { class: "card-body p-0 my-2" }, TD = { class: "green-title-big t-primary" }, AD = ["href"], SD = ["innerHTML"], CD = { class: "container p-0" }, MD = { class: "d-flex justify-content-center" }, bD = ["disabled"], RD = /* @__PURE__ */ ve("span", { class: "" }, "Carica altri risultati", -1), DD = [
  RD
], OD = /* @__PURE__ */ Dt({
  __name: "KModalSearchResults",
  setup(n) {
    const e = Ns();
    return (t, r) => {
      const o = Nt("router-link");
      return Ye(e).lastSearchResultCount >= 0 && Ye(e).results && Ye(e).results.length >= 0 ? (Oe(), je("div", YR, [
        ve("div", XR, [
          ve("div", QR, [
            JR,
            ve("fieldset", null, [
              ve("div", ZR, [
                qR,
                ve("ul", null, [
                  (Oe(!0), je(dn, null, Un(Ye(e).sourcesFilters, (u) => (Oe(), je("li", {
                    key: u.source
                  }, [
                    ve("div", eD, [
                      ve("div", tD, [
                        ha(ve("input", {
                          type: "checkbox",
                          id: u.source,
                          value: u,
                          "onUpdate:modelValue": r[0] || (r[0] = (c) => Ye(e).resultSourceSelected = c),
                          class: "",
                          "data-focus-mouse": "false"
                        }, null, 8, nD), [
                          [Ef, Ye(e).resultSourceSelected]
                        ]),
                        ve("label", {
                          for: u.source,
                          class: "subtitle-small_semi-bold mb-0 category-list__list active"
                        }, lt(u.source) + " (" + lt(u.resultsCount) + ") ", 9, rD)
                      ])
                    ])
                  ]))), 128))
                ])
              ])
            ])
          ]),
          ve("div", iD, [
            ve("div", aD, [
              oD,
              ve("span", sD, [
                ve("span", lD, lt(Ye(e).totalResultsCount), 1),
                an(" Risultati")
              ]),
              ve("button", uD, [
                ve("span", cD, [
                  dt(yn, {
                    class: "icon-primary icon-xs",
                    "aria-hidden": "true",
                    icon: "it-funnel"
                  })
                ]),
                fD
              ]),
              ve("button", {
                type: "button",
                class: "btn d-none d-lg-block btn-result",
                disabled: Ye(e).lastSearchResultCount < 0,
                onClick: r[1] || (r[1] = //@ts-ignore
                (...u) => Ye(e).resetSearch && Ye(e).resetSearch(...u))
              }, " Rimuovi tutti i filtri ", 8, dD)
            ]),
            ve("div", hD, [
              ve("div", pD, [
                ve("div", mD, [
                  dt(fd, {
                    loading: Ye(e).searchingMore
                  }, {
                    default: Ft(() => [
                      (Oe(!0), je(dn, null, Un(Ye(e).filteredResults, (u, c) => (Oe(), je("div", {
                        key: c,
                        class: "cmp-card-latest-messages mb-3 mb-30",
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#",
                        id: ""
                      }, [
                        ve("div", gD, [
                          vD,
                          ve("div", _D, [
                            ve("span", ED, lt(u.source), 1)
                          ]),
                          ve("div", yD, [
                            ve("h3", TD, [
                              u.urlExternal === !0 ? (Oe(), je("a", {
                                key: 0,
                                href: u.url,
                                target: "_blank",
                                class: "text-decoration-none",
                                "data-element": "service-link"
                              }, lt(u.title), 9, AD)) : (Oe(), Wt(o, {
                                key: 1,
                                to: { path: u.url },
                                class: "text-decoration-none",
                                "data-element": "service-link"
                              }, {
                                default: Ft(() => [
                                  an(lt(u.title), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            ]),
                            ve("p", {
                              class: "text-paragraph",
                              innerHTML: u.description
                            }, null, 8, SD)
                          ])
                        ])
                      ]))), 128))
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ])
              ])
            ]),
            ve("div", CD, [
              ve("div", MD, [
                ve("button", {
                  type: "button",
                  disabled: Ye(e).searchingMore || Ye(e).lastSearchResultCount == 0,
                  onClick: r[2] || (r[2] = (u) => Ye(e).executeGlobalSearchMoreResult()),
                  class: "btn btn-outline-primary pt-15 pb-15 pl-90 pr-90 mb-30 mb-lg-50 full-mb text-button"
                }, DD, 8, bD)
              ])
            ])
          ])
        ])
      ])) : mt("", !0);
    };
  }
}), PD = {
  class: "container",
  style: { width: "100%" }
}, ID = { class: "row variable-gutters" }, ND = { class: "col" }, LD = { class: "form-group autocomplete-wrapper" }, wD = {
  for: "kd-global-search-input",
  class: "visually-hidden",
  style: { "background-color": "white" }
}, xD = {
  class: "autocomplete-icon",
  "aria-hidden": "true",
  style: { left: "20px" }
}, BD = ["disabled"], FD = /* @__PURE__ */ Dt({
  __name: "KModalSearch",
  props: {
    title: { default: "Cerca" },
    searchTextHint: { default: "Cerca nel sito" },
    searchButtonText: { default: "Cerca" }
  },
  emits: ["closed", "startSearch"],
  setup(n, { emit: e }) {
    const t = Ns(), r = e, o = () => {
      r("closed");
    }, u = st(!1), c = st(null);
    un(() => t.isSearchGlobalModalOpened, (i, h) => {
      console.log(`${h} -> ${i}`), h != i && i === !0 && lr(() => {
        lr(() => {
          c.value && c.value.focus();
        });
      });
    });
    const l = async () => {
      r("startSearch", t.searchText), u.value = !0;
      try {
        await t.executeGlobalSearch(t.searchText);
      } finally {
        u.value = !1;
      }
    };
    return (i, h) => (Oe(), Wt(ev, {
      title: i.title,
      modelValue: Ye(t).isSearchGlobalModalOpened,
      "onUpdate:modelValue": h[1] || (h[1] = (f) => Ye(t).isSearchGlobalModalOpened = f),
      onClosed: o
    }, {
      default: Ft(() => [
        Ye(t).isSearchGlobalModalOpened ? (Oe(), je("form", {
          key: 0,
          onSubmit: As(l, ["prevent"])
        }, [
          ve("div", PD, [
            ve("div", ID, [
              ve("div", ND, [
                ve("div", LD, [
                  ve("label", wD, lt(i.searchTextHint), 1),
                  ha(ve("input", {
                    type: "search",
                    "onUpdate:modelValue": h[0] || (h[0] = (f) => Ye(t).searchText = f),
                    class: "ps-5",
                    placeholder: "Cerca nel sito",
                    id: "kd-global-search-input",
                    name: "kd-global-search-input",
                    ref_key: "kdglobalsearchinput",
                    ref: c
                  }, null, 512), [
                    [Tc, Ye(t).searchText]
                  ]),
                  ve("span", xD, [
                    dt(yn, { icon: "it-search" })
                  ]),
                  ve("button", {
                    type: "submit",
                    disabled: Ye(t).searching,
                    class: "btn btn-primary pt-15 pb-15 pl-90 pr-90 mb-30 mb-lg-50 full-mb text-button"
                  }, lt(i.searchButtonText), 9, BD)
                ])
              ])
            ])
          ])
        ], 32)) : mt("", !0),
        dt(fd, {
          loading: Ye(t).searching
        }, {
          default: Ft(() => [
            dt(OD)
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"]));
  }
}), UD = { class: "flex align-items-center layout-topbar" }, kD = { class: "flex-grow-0 flex-shrink-0 flex align-items-center justify-content-center layout-topbar-button-menu" }, KD = { class: "flex-grow-1 flex-shrink-1 flex align-items-center justify-content-start" }, jD = ["src"], WD = { class: "flex-grow-1 flex-shrink-1 flex align-items-center justify-content-end" }, VD = /* @__PURE__ */ ve("span", { class: "visually-hidden" }, "Cerca", -1), HD = /* @__PURE__ */ ve("span", { class: "visually-hidden" }, "Notifiche", -1), $D = {
  key: 0,
  class: "avatar-notificatoins-badge"
}, GD = { class: "visually-hidden" }, zD = {
  class: "avatar-wrapper avatar-extra-text",
  style: { "margin-bottom": "0" }
}, YD = ["title"], XD = { "aria-hidden": "true" }, QD = { class: "visually-hidden" }, JD = { class: "extra-text" }, ZD = ["title"], qD = { style: { "font-size": "0.6em", "margin-top": "-5px" } }, eO = { style: { width: "200px" } }, tO = /* @__PURE__ */ ve("hr", null, null, -1), nO = { style: { "font-size": "x-small", padding: "0 0px" } }, rO = { style: { "font-size": "small", "font-weight": "bold" } }, iO = /* @__PURE__ */ ve("br", null, null, -1), aO = /* @__PURE__ */ ve("br", null, null, -1), oO = /* @__PURE__ */ ve("br", null, null, -1), sO = /* @__PURE__ */ Dt({
  __name: "AppTopbar",
  emits: ["menu-toggle"],
  setup(n, { emit: e }) {
    const { toDateTimeString: t } = Gr(), r = e, o = kn(), u = (D) => {
      r("menu-toggle", D);
    }, c = st(), l = async (D) => {
      c.value.toggle(D), D.preventDefault(), c.value.visible && N();
    }, { getAppTitle: i, getAppVersion: h, getPathForAsset: f, _appOptionsNotification: p, _appHomeRoutePath: d } = fn(), { getApiStatus: v } = Dr(), g = i(), m = h(), A = "0.9.7", b = st(null), S = st(!1), N = async () => {
      S.value = !0, (b.value == null || b.value.online == !1) && (b.value = await v()), S.value = !1;
    }, T = yr(), R = Ht(() => {
      var M = T.userDisplayName.match(/\b(\w)/g);
      return M.length > 3 && (M.length = 3), M.join("").toUpperCase();
    }), y = () => {
      T.logout();
    }, E = () => {
      o.push("/changepassword");
    }, L = Ns(), _ = cd();
    let O = null;
    return ln(() => {
      _.loadUnreadNotificationsCount(), O = setInterval(
        () => {
          T.isLogged && _.loadUnreadNotificationsCount();
        },
        1e4
      );
    }), po(() => {
      O && clearInterval(O);
    }), (D, M) => {
      var I;
      const C = Nt("router-link");
      return Oe(), je("div", UD, [
        ve("div", kD, [
          ve("button", {
            type: "button",
            class: "btn layout-menu-button",
            onClick: u,
            "aria-label": "Toggle menu"
          }, [
            dt(yn, {
              class: "icon-primary",
              icon: "it-burger"
            })
          ])
        ]),
        ve("div", KD, [
          dt(C, {
            to: Ye(d),
            class: "layout-topbar-logo"
          }, {
            default: Ft(() => [
              ve("img", {
                alt: "logo",
                title: "logo",
                src: Ye(f)("logo.png"),
                class: "k-topbar-logo"
              }, null, 8, jD)
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        ve("div", WD, [
          Ye(L).isGlobalSearchEnabled ? (Oe(), je("a", {
            key: 0,
            class: "avatar size-lg",
            href: "#",
            onClick: M[0] || (M[0] = (w) => Ye(L).isSearchGlobalModalOpened = !0),
            role: "button",
            "aria-label": "Cerca"
          }, [
            dt(yn, { icon: "it-search" }),
            VD
          ])) : mt("", !0),
          (I = Ye(p)) != null && I.hideNotificationsButton ? mt("", !0) : (Oe(), Wt(C, {
            key: 1,
            to: "/notifications",
            class: "avatar size-lg",
            role: "button",
            "aria-label": "notifiche",
            style: { margin: "0 16px", "text-decoration": "none", overflow: "visible" }
          }, {
            default: Ft(() => [
              dt(yn, { icon: "it-mail" }),
              HD,
              Ye(_).totalUnreadCount > 0 ? (Oe(), je("div", $D, [
                an(lt(Ye(_).totalUnreadCount) + " ", 1),
                ve("span", GD, "Unread messages: " + lt(Ye(_).totalUnreadCount), 1)
              ])) : mt("", !0)
            ]),
            _: 1
          })),
          ve("div", zD, [
            ve("a", {
              class: "avatar avatar-primary size-lg",
              href: "#",
              onClick: l,
              role: "button",
              "aria-label": "user",
              "data-bs-html": "true",
              "data-bs-placement": "top",
              title: Ye(T).userDisplayName
            }, [
              ve("p", XD, lt(R.value), 1),
              ve("span", QD, lt(Ye(T).userDisplayName), 1)
            ], 8, YD),
            ve("div", JD, [
              ve("div", {
                class: "k-user-label",
                title: Ye(T).userDisplayName
              }, [
                ve("a", {
                  href: "#",
                  role: "button",
                  onClick: l,
                  class: "bnt fst-italic"
                }, lt(Ye(T).userDisplayName), 1)
              ], 8, ZD),
              ve("div", qD, " Ultimo accesso: " + lt(Ye(t)(Ye(T).userLastAccess)), 1)
            ])
          ]),
          dt(Ye(QE), {
            ref_key: "opUser",
            ref: c,
            dismissable: !0,
            "append-to": ".layout-topbar",
            class: "k-usr-popup"
          }, {
            default: Ft(() => [
              ve("div", eO, [
                ve("div", null, [
                  ve("button", {
                    type: "button",
                    class: "btn",
                    style: { padding: "0" },
                    onClick: E
                  }, "Modifica password")
                ]),
                ve("div", null, [
                  ve("button", {
                    type: "button",
                    class: "btn",
                    style: { padding: "0", "margin-top": "20px" },
                    onClick: y
                  }, "Esci")
                ]),
                tO,
                ve("div", nO, [
                  ve("span", rO, lt(Ye(g)), 1),
                  iO,
                  an(" App version: " + lt(Ye(m)) + " ", 1),
                  aO,
                  an(" k version: " + lt(Ye(A)) + " ", 1),
                  oO,
                  an(" Api version: " + lt(b.value && b.value.version), 1)
                ])
              ])
            ]),
            _: 1
          }, 512)
        ]),
        Ye(L).isGlobalSearchEnabled ? (Oe(), Wt(FD, { key: 0 })) : mt("", !0)
      ]);
    };
  }
});
const lO = {
  key: 0,
  class: "sidebar-wrapper theme-dark k-layout-menu-container",
  style: { background: "unset", padding: "0" }
}, uO = { class: "layout-menu-button-container" }, cO = { class: "sidebar-linklist-wrapper" }, fO = { class: "link-list-wrapper" }, dO = { class: "link-list" }, hO = ["onClick", "aria-expanded", "aria-controls"], pO = { style: { display: "flex", "align-items": "center" } }, mO = ["alt", "title", "src"], gO = { style: { "margin-left": "10px", "margin-right": "auto" } }, vO = ["id"], _O = { style: { display: "flex", "align-items": "center" } }, EO = ["alt", "title", "src"], yO = /* @__PURE__ */ Dt({
  __name: "AppMenu",
  emits: ["menu-toggle", "menuitem-click"],
  setup(n, { emit: e }) {
    const t = $r(), r = kn(), o = yr(), { getPathForAsset: u } = fn();
    let c = [];
    const l = Ht(() => {
      if (c && c.length > 0 && c.forEach((R) => {
        R && R.dispose && R.dispose();
      }), lr(() => {
        var R = [].slice.call(document.querySelectorAll(".k-menu-item-collapse"));
        c = R.map(function(y) {
          return iS.getOrCreateInstance(y, { toggle: !1 });
        });
      }), !(o.user && o.isLogged))
        return [];
      const S = r.getRoutes().filter((R) => R.meta.menu).sort((R, y) => R.meta.menu.order - y.meta.menu.order);
      let N = {};
      const T = [];
      return S.forEach((R) => {
        const y = R.meta.menu.order;
        if (R.meta.menu && R.meta.menu.group && R.meta.menu.group.length > 0) {
          const E = R.meta.menu.group;
          Object.keys(N).indexOf(E) < 0 && (N[E] = {
            label: E,
            order: y,
            iconAsset: R.meta.menu.iconAsset,
            items: [],
            isOpened: !1,
            idCollapse: "collapse_" + T.length
          }, T.push(N[E]));
          let L = [];
          R.meta.menu.activationAliases && (L = R.meta.menu.activationAliases), N[E].items.push({
            label: f(R),
            order: y,
            to: h(R),
            activeAliases: L
          });
        } else {
          let E = R.meta.menu.icon;
          E && E.length > 0 && E.startsWith("pi") == !1 && (E = "ms-Icon ms-Icon--" + E);
          const L = {
            label: f(R),
            order: y,
            icon: E,
            iconAsset: R.meta.menu.iconAsset,
            visible: R.meta.menu.hidden !== !0,
            to: h(R),
            activeAliases: []
          };
          T.push(L);
        }
      }), T.sort((R, y) => R.order - y.order).map((R) => Ul(R));
    }), i = (b) => {
      if (b && !A(b)) {
        const S = c.find((T) => T._element.id == b.idCollapse), N = l.value.find((T) => T.idCollapse == b.idCollapse);
        S && (N.isOpened = !S._isShown(), S.toggle());
      }
    }, h = (b) => {
      let S = b.path;
      const N = b.meta.menu.defaultParams;
      if (N)
        for (let T = 0; T < N.length; T++) {
          const y = N[T].split(":");
          S = S.replace(`:${y[0]}`, y[1]);
        }
      return S;
    }, f = (b) => b.meta.menu.label, p = e, d = (b) => {
      p("menu-toggle", b);
    }, v = (b, S, N) => {
      if (S.disabled) {
        b.preventDefault();
        return;
      }
      !S.to && !S.url && b.preventDefault(), S.command && S.command({ originalEvent: b, item: S }), p("menuitem-click", {
        originalEvent: b,
        item: S
      });
    }, g = (b) => {
      var N, T;
      if (!b.to)
        return !1;
      const S = r.currentRoute.value;
      if (S && S.fullPath) {
        if (b.to == "/")
          return S.fullPath == b.to;
        const R = S.fullPath.indexOf(b.to) >= 0, y = ((N = S.fullPath.split("/")) == null ? void 0 : N.length) == ((T = b.to.split("/")) == null ? void 0 : T.length);
        return R && y;
      }
      return b.activeAliases && b.activeAliases.length > 0 ? b.activeAliases.some((R) => t.fullPath.indexOf(R) >= 0) : !1;
    }, m = (b) => typeof b.visible == "function" ? b.visible() : b.visible !== !1, A = (b) => typeof b.disabled == "function" ? b.disabled() : b.disabled === !0;
    return (b, S) => {
      const N = Nt("router-link");
      return l.value ? (Oe(), je("div", lO, [
        ve("div", uO, [
          ve("button", {
            type: "button",
            class: "btn layout-menu-button",
            onClick: d,
            "aria-label": "Toggle menu"
          }, [
            dt(yn, {
              class: "icon-white",
              icon: "it-burger"
            })
          ])
        ]),
        ve("div", cO, [
          ve("div", fO, [
            ve("ul", dO, [
              (Oe(!0), je(dn, null, Un(l.value, (T, R) => (Oe(), je(dn, null, [
                m(T) ? (Oe(), je("li", {
                  key: "k-menu-item-" + R,
                  class: Ct([[{ active: g(T) }], "k-menu-item"])
                }, [
                  T.items ? (Oe(), je(dn, { key: 0 }, [
                    ve("a", {
                      class: "list-item medium",
                      href: "#",
                      role: "button",
                      onClick: As((y) => i(T), ["prevent"]),
                      "aria-expanded": T.isOpened === !0,
                      "aria-controls": T.idCollapse
                    }, [
                      ve("div", pO, [
                        T.icon ? (Oe(), je("i", {
                          key: 0,
                          class: Ct(T.icon)
                        }, null, 2)) : mt("", !0),
                        T.iconAsset ? (Oe(), je("img", {
                          key: 1,
                          alt: T.label,
                          title: T.label,
                          src: Ye(u)(T.iconAsset)
                        }, null, 8, mO)) : mt("", !0),
                        ve("span", gO, lt(T.label), 1),
                        dt(yn, {
                          class: "icon-sm icon-white right",
                          icon: "it-expand"
                        })
                      ])
                    ], 8, hO),
                    ve("ul", {
                      class: "collapse k-menu-item-collapse",
                      id: T.idCollapse
                    }, [
                      (Oe(!0), je(dn, null, Un(T.items, (y, E) => (Oe(), je("li", {
                        key: "k-submenu-item-" + E,
                        class: Ct([[{ active: g(y) }], "k-menu-sub-item"])
                      }, [
                        dt(N, {
                          to: y.to,
                          title: y.label,
                          class: Ct(["list-item", [{ "active-route": g(y), active: g(y) }]]),
                          onClick: (L) => v(L, y),
                          exact: "",
                          role: "button"
                        }, {
                          default: Ft(() => [
                            ve("span", null, lt(y.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["to", "title", "class", "onClick"])
                      ], 2))), 128))
                    ], 8, vO)
                  ], 64)) : (Oe(), Wt(N, {
                    key: 1,
                    to: T.to,
                    title: T.label,
                    class: Ct(["list-item medium", [{ "active-route": g(T), active: g(T) }]]),
                    onClick: (y) => v(y, T),
                    exact: "",
                    role: "button"
                  }, {
                    default: Ft(() => [
                      ve("div", _O, [
                        T.icon && T.icon.length > 0 ? (Oe(), je("i", {
                          key: 0,
                          class: Ct(T.icon),
                          style: { margin: "0 5px" }
                        }, null, 2)) : mt("", !0),
                        T.iconAsset ? (Oe(), je("img", {
                          key: 1,
                          alt: T.label,
                          title: T.label,
                          src: Ye(u)(T.iconAsset),
                          class: "img-icon"
                        }, null, 8, EO)) : mt("", !0),
                        ve("span", {
                          style: { "margin-left": "10px" },
                          class: Ct({ "menu-item-no-img": !T.icon || T.icon.length == 0 || !T.iconAsset })
                        }, lt(T.label), 3)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["to", "title", "class", "onClick"]))
                ], 2)) : mt("", !0)
              ], 64))), 256))
            ])
          ])
        ])
      ])) : mt("", !0);
    };
  }
}), TO = {
  key: 0,
  class: "layout-footer"
}, AO = {
  class: "footer-text",
  role: "presentation"
}, SO = ["href"], CO = {
  class: "footer-text k-version-badge",
  role: "presentation"
}, MO = /* @__PURE__ */ Dt({
  __name: "AppFooter",
  setup(n) {
    const { getAppTitle: e, getAppVersion: t, _showFooter: r, _privacyPath: o } = fn(), u = t(), c = e(), l = Ht(() => o && o.value.trim().length > 0 ? !o.value.toLowerCase().startsWith("http") : !1), i = Ht(() => o && o.value.trim().length > 0 ? o.value.toLowerCase().startsWith("http") : !1);
    return (h, f) => {
      const p = Nt("RouterLink");
      return Ye(r) ? (Oe(), je("div", TO, [
        ve("span", AO, [
          an(lt(Ye(c)) + "   ", 1),
          i.value ? (Oe(), je("a", {
            key: 0,
            title: "Privacy",
            href: Ye(o),
            target: "_blank"
          }, "Privacy", 8, SO)) : l.value ? (Oe(), Wt(p, {
            key: 1,
            to: Ye(o),
            title: "Privacy"
          }, {
            default: Ft(() => [
              an("Privacy")
            ]),
            _: 1
          }, 8, ["to"])) : mt("", !0)
        ]),
        ve("span", CO, "v. " + lt(Ye(u)), 1)
      ])) : mt("", !0);
    };
  }
});
const bO = /* @__PURE__ */ Dt({
  __name: "StandardLayout",
  setup(n) {
    const e = $r();
    kn();
    const t = st("static"), r = st("light"), o = st(!1), u = st(!1), c = st(!1), l = st(!1), i = st(!1);
    un(
      () => e,
      () => {
        l.value = !1;
      },
      { immediate: !0 }
    );
    const h = () => window.innerWidth > 1024, f = () => {
      i.value || (u.value = !1, c.value = !1), i.value = !1;
    }, p = () => {
      i.value = !0, h() ? t.value === "overlay" ? (c.value === !0 && (u.value = !0), u.value = !u.value, c.value = !1) : t.value === "static" && (o.value = !o.value) : c.value = !c.value;
    }, d = () => i.value = !0, v = (N) => {
      N.item && !N.item.items && (u.value = !1, c.value = !1);
    }, g = (N, T) => {
      N.classList ? N.classList.add(T) : N.className += " " + T;
    }, m = (N, T) => {
      N.classList ? N.classList.remove(T) : N.className = N.className.replace(new RegExp("(^|\\b)" + T.split(" ").join("|") + "(\\b|$)", "gi"), " ");
    }, A = () => h() ? t.value === "static" ? !o.value : t.value === "overlay" ? u.value : !0 : !0, b = Ht(() => ["layout-wrapper", {
      "layout-overlay": t.value === "overlay",
      "layout-static": t.value === "static",
      "layout-static-sidebar-inactive": o.value && t.value === "static",
      "layout-overlay-sidebar-active": u.value && t.value === "overlay",
      "layout-mobile-sidebar-active": c.value
      // 'p-input-filled': this.$appState.inputStyle === 'filled',
      // 'p-ripple-disabled': this.$primevue.ripple === false
    }]), S = Ht(() => ["layout-sidebar", {
      "layout-sidebar-dark": r.value === "dark",
      "layout-sidebar-light": r.value === "light",
      "layout-sidebar-compact": !A()
    }]);
    return Ht(() => r.value === "dark" ? "assets/layout/images/logo-white.svg" : "assets/layout/images/logo.svg"), FE(() => {
      c.value ? g(document.body, "body-overflow-hidden") : m(document.body, "body-overflow-hidden");
    }), (N, T) => {
      const R = Nt("router-view");
      return Oe(), je("div", {
        class: Ct(b.value),
        onClick: f
      }, [
        dt(sO, { onMenuToggle: p }),
        dt(Ac, { name: "layout-sidebar" }, {
          default: Ft(() => [
            ve("div", {
              class: Ct(S.value),
              onClick: d
            }, [
              dt(yO, {
                onMenuToggle: p,
                onMenuitemClick: v
              })
            ], 2)
          ]),
          _: 1
        }),
        ve("div", {
          class: Ct(["layout-main", { "layout-main-compact": !A() }])
        }, [
          dt(R, null, {
            default: Ft(({ Component: y }) => [
              dt(Ac, {
                name: "fade",
                mode: "out-in"
              }, {
                default: Ft(() => [
                  (Oe(), Wt(Af(y)))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          })
        ], 2),
        dt(MO)
      ], 2);
    };
  }
});
function RO() {
  const n = {
    splash: mR,
    default: bO,
    anonymous: _R
  };
  return {
    appStarting: st(!1),
    layouts: n
    /*, layout*/
  };
}
var DO = { exports: {} };
(function(n, e) {
  (function(t, r) {
    n.exports = r(wg);
  })(Gf, function(t) {
    function r(c) {
      return c && typeof c == "object" && "default" in c ? c : { default: c };
    }
    var o = r(t), u = { name: "it", weekdays: "domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato".split("_"), weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"), weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"), months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"), weekStart: 1, monthsShort: "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"), formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD/MM/YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd D MMMM YYYY HH:mm" }, relativeTime: { future: "tra %s", past: "%s fa", s: "qualche secondo", m: "un minuto", mm: "%d minuti", h: "un' ora", hh: "%d ore", d: "un giorno", dd: "%d giorni", M: "un mese", MM: "%d mesi", y: "un anno", yy: "%d anni" }, ordinal: function(c) {
      return c + "º";
    } };
    return o.default.locale(u, null, !0), u;
  });
})(DO);
gn.locale("it");
function Gr() {
  return {
    capitalize: (g) => g == null ? "" : g.toUpperCase(),
    currency: (g) => isNaN(g) ? "-" : "€" + g.toFixed(2),
    toCurrencyString: (g, m = !1, A = "") => {
      if (g === 0 || g && !isNaN(g)) {
        let b = m ? "€ " : "";
        return b += g.toFixed(2), b;
      }
      return A;
    },
    fileIcon: (g) => {
      let m = "it-file";
      switch (g.split(".").pop()) {
        case "pdf":
          m = "it-file-pdf";
          break;
        case "xml":
          m = "it-file-xml";
          break;
        case "csv":
          m = "it-file-csv";
          break;
        case "xls":
        case "xlsx":
          m = "it-file-sheet";
          break;
        case "ppt":
        case "pptx":
          m = "it-file-slides";
          break;
        case "zip":
        case "rar":
        case "7z":
          m = " it-file-compressed";
          break;
      }
      return m;
    },
    toHumanFileSize: (g, m = 1) => {
      if (Math.abs(g) < 1e3)
        return g + " B";
      const b = ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
      let S = -1;
      const N = 10 ** m;
      do
        g /= 1e3, ++S;
      while (Math.round(Math.abs(g) * N) / N >= 1e3 && S < b.length - 1);
      return Number(g.toFixed(m)).toLocaleString() + " " + b[S];
    },
    toDateTimeString: (g) => g != null ? gn(g).format("DD/MM/YYYY HH:mm") : "",
    toDateString: (g) => g != null ? gn(g).format("DD/MM/YYYY") : "",
    toDateTimeLongString: (g) => g != null ? gn(g).locale("it").format("dddd, DD MMMM YYYY") : "",
    toTimeHMString: (g) => g != null ? gn(g).format("HH:mm") : "",
    toDDMMMMString: (g) => g != null ? gn(g).format("DD MMMM") : "",
    toStringDecimalNumber: (g) => g != null ? g.toFixed(2).replace(".", ",") : "",
    toDateTimeStringWithOptions: (g, m = !0) => g != null ? m ? gn.utc(g).local().format("DD/MM/YYYY HH:mm") : gn(g).format("DD/MM/YYYY HH:mm") : "",
    toTimeStringWithOptions: (g, m = !1, A = !0) => {
      if (g != null) {
        const b = A ? gn.utc(g).local() : gn(g).utc();
        return m ? b.format("HH:mm:ss") : b.format("HH:mm");
      }
      return "";
    },
    toHtmlTextWithBr: (g) => g.replace(/\n/g, "<br />").replace(/&#xA;/g, "<br />")
  };
}
const Js = Gr(), Yu = st(!0);
var tv = /* @__PURE__ */ ((n) => (n.required = "required", n.email = "email", n.number = "number", n.integer = "integer", n.date = "date", n.password = "password", n.minLength = "minLength", n.maxLength = "maxLength", n.minNumber = "minNumber", n.maxNumber = "maxNumber", n.minDate = "minDate", n.maxDate = "maxDate", n.numericRange = "numericRange", n.dateRange = "dateRange", n.cap = "cap", n.codiceFiscale = "codiceFiscale", n.partitaIva = "partitaIva", n.partitaIvaOCodiceFiscale = "partitaIvaOCodiceFiscale", n.regex = "regex", n))(tv || {});
function sj() {
  const { kToast: n } = Dr(), e = st([]);
  var t = {};
  let r = "Ci sono errori nella compilazione del form";
  const o = (_, O = "default") => e.value ? e.value.find((D) => D.name == _ && D.clusterId == O) : null, u = (_) => {
    r = _;
  }, c = Ht(() => {
    if (!e.value)
      return !0;
    for (let _ = 0; _ < e.value.length; _++)
      if (!e.value[_].success)
        return !1;
    return !0;
  }), l = (_, O) => {
    const D = O.split(".");
    let C = _.value ? _.value[D[0]] : _[D[0]];
    if (D.length > 1)
      for (let I = 1; I < D.length; I++)
        C = C[D[I]];
    return C;
  }, i = (_, O, D = "default") => {
    const M = e.value.find((C) => C.name == _ && C.clusterId == D);
    if (M)
      M.rules && M.rules instanceof Array && M.rules.length > 0 && M.rules.splice(0, M.rules.length);
    else {
      let C = null;
      const I = t[D];
      I && (C = l(I, _)), e.value.push({
        name: _,
        fieldValue: C,
        success: null,
        rules: O,
        errors: [],
        customErrors: [],
        messages: [],
        clusterId: D,
        validate: () => d(_, !1, D),
        scrollToFieldToken: null
      });
    }
  }, h = (_, O = "default") => {
    t[O] = _, un(_, () => {
      if (!_.value && !_.$id || !e.value || t[O] != _)
        return;
      const D = e.value.filter((M) => M.clusterId == O);
      for (let M = 0; M < D.length; M++) {
        const C = D[M];
        let I = l(_, C.name);
        (C.fieldValue != I || // aggiorno la validazione anche se il campo ha almeno regola
        // sottoposta ad abilitazione e precedentemente è risultato non valido
        !C.success && C.rules.find((w) => w.enabled && !w.enabled()) || // aggiorno la validazione se c'è una regola custom che può dipendere
        // da altri campi
        C.rules.find((w) => w.customValidationHandler)) && (C.fieldValue = I, g(C));
      }
    }, { deep: !0 });
  }, f = () => {
    for (let _ = 0; _ < e.value.length; _++) {
      const O = e.value[_];
      v(O);
    }
  }, p = (_, O, D = "default") => {
    const M = y(O);
    i(_, M, D);
  }, d = (_, O = !1, D = "default") => {
    if (!e.value)
      return;
    const M = e.value.find((C) => C.name == _ && C.clusterId == D);
    return g(M, O);
  }, v = (_) => {
    _.success = null, _.scrollToFieldToken = null, _.errors.length > 0 && _.errors.splice(0, _.errors.length), _.messages.length > 0 && _.messages.splice(0, _.messages.length), _.fieldValue = null;
  }, g = (_, O = !1) => {
    var M, C, I, w, F, k, H, Z, Y, j, J, ae, G, $, ie, re, ce, z;
    const D = (_ == null ? void 0 : _.rules) || [];
    _.success = !0, _.scrollToFieldToken = null, _.errors.length > 0 && _.errors.splice(0, _.errors.length), _.messages.length > 0 && _.messages.splice(0, _.messages.length);
    for (let oe = 0; oe < D.length; oe++) {
      const de = D[oe];
      let pe = !0, he = "";
      if (!de.enabled || de.enabled())
        switch (de.rule) {
          case "required":
            (_.fieldValue == null || _.fieldValue == null || _.fieldValue.toString() == "" || _.fieldValue === !1) && (pe = !1, de.message || (he = "Il campo è obbligatorio"));
            break;
          case "email":
            (((M = _.fieldValue) == null ? void 0 : M.toString()) || "") != "" && !/^[\s]*[\w-\.]+@([\w-]+\.)+[\w-]{1,4}[\s]*$/.test(_.fieldValue) && (pe = !1, he = "Inserire un'e-mail corretta");
            break;
          case "password":
            const se = [], ee = (((C = _.fieldValue) == null ? void 0 : C.toString()) || "").trim(), te = 8;
            ee.length < te && se.push(`La password deve essere lunga almeno ${te} caratteri.`), /\d/.test(ee) == !1 && se.push("La password deve contenere un numero."), /[a-z]+/g.test(ee) == !1 && se.push("La password deve contenere una lettera minuscola."), /[A-Z]+/g.test(ee) == !1 && se.push("La password deve contenere una lettera minuscola."), /[-+_!@#$%^&*.,?]+/g.test(ee) == !1 && se.push("La password deve contenere un carattere speciale (-+_!@#$%^&*.,?)."), se.length > 0 && (pe = !1, he = se.join("<br/>"));
            break;
          case "minLength":
            (((I = _.fieldValue) == null ? void 0 : I.toString()) || "") != "" && _.fieldValue.toString().length < de.minNumber && (pe = !1, he = `Inserire un testo di minimo ${de.minNumber} caratteri`);
            break;
          case "maxLength":
            (((w = _.fieldValue) == null ? void 0 : w.toString()) || "") != "" && _.fieldValue.toString().length > de.maxNumber && (pe = !1, he = `Inserire un testo di massimo ${de.maxNumber} caratteri`);
            break;
          case "number":
            (((F = _.fieldValue) == null ? void 0 : F.toString()) || "") != "" && isNaN(_.fieldValue) && (pe = !1, he = "Inserire un numero valido");
            break;
          case "integer":
            (((k = _.fieldValue) == null ? void 0 : k.toString()) || "") != "" && !/^[\s]*[0-9]*[\s]*$/.test(_.fieldValue) && (pe = !1, he = "Inserire un numero intero");
            break;
          case "date":
            (((H = _.fieldValue) == null ? void 0 : H.toString()) || "") != "" && (m(_.fieldValue) || (pe = !1, he = "Indicare una data valida"));
            break;
          case "minNumber":
            (((Z = _.fieldValue) == null ? void 0 : Z.toString()) || "") != "" && (isNaN(_.fieldValue) || Number(_.fieldValue) < de.minNumber) && (pe = !1, he = `Inserire un numero a partire da ${de.minNumber}`);
            break;
          case "maxNumber":
            (((Y = _.fieldValue) == null ? void 0 : Y.toString()) || "") != "" && (isNaN(_.fieldValue) || Number(_.fieldValue) > de.maxNumber) && (pe = !1, he = `Inserire un numero fino a ${de.maxNumber}`);
            break;
          case "minDate":
            (((j = _.fieldValue) == null ? void 0 : j.toString()) || "") != "" && m(_.fieldValue) && gn(_.fieldValue).toDate() < de.minDate && (pe = !1, he = `Inserire una data a partire dal ${Js.toDateString(de.minDate)}`);
            break;
          case "maxDate":
            (((J = _.fieldValue) == null ? void 0 : J.toString()) || "") != "" && m(_.fieldValue) && gn(_.fieldValue).toDate() > de.maxDate && (pe = !1, he = `Inserire un data fino al ${Js.toDateString(de.maxDate)}`);
            break;
          case "numericRange":
            (((ae = _.fieldValue) == null ? void 0 : ae.toString()) || "") != "" && (isNaN(_.fieldValue) || Number(_.fieldValue) < de.minNumber || Number(_.fieldValue) > de.maxNumber) && (pe = !1, he = `Inserire un numero fra ${de.minNumber} e ${de.maxNumber}`);
            break;
          case "dateRange":
            (((G = _.fieldValue) == null ? void 0 : G.toString()) || "") != "" && (!m(_.fieldValue) || gn(_.fieldValue).toDate() < de.minDate || gn(_.fieldValue).toDate() > de.maxDate) && (pe = !1, he = `Inserire una data fra ${Js.toDateString(de.minDate)} e ${Js.toDateString(de.maxDate)}`);
            break;
          case "regex":
            ((($ = _.fieldValue) == null ? void 0 : $.toString()) || "") != "" && !de.regex.test(_.fieldValue) && (pe = !1, he = "Inserire un valore nel formato previsto");
            break;
          case "cap":
            (((ie = _.fieldValue) == null ? void 0 : ie.toString()) || "") != "" && !/^[\s]*[0-9]{5}[\s]*$/.test(_.fieldValue) && (pe = !1, he = "Inserire un CAP valido");
            break;
          case "codiceFiscale":
            (((re = _.fieldValue) == null ? void 0 : re.toString()) || "") != "" && (pe = b(_.fieldValue), pe || (he = "Inserire un codice fiscale valido"));
            break;
          case "partitaIva":
            (((ce = _.fieldValue) == null ? void 0 : ce.toString()) || "") != "" && (pe = A(_.fieldValue), pe || (he = "Inserire una partita IVA valida"));
            break;
          case "partitaIvaOCodiceFiscale":
            (((z = _.fieldValue) == null ? void 0 : z.toString()) || "") != "" && (pe = T(_.fieldValue), pe || (he = "Inserire una partita IVA o un codice fiscale valido"));
            break;
          default:
            de.customValidationHandler ? pe = de.customValidationHandler(_.fieldValue) : pe = !1;
            break;
        }
      pe || (_.success = !1, _.errors.push(de.rule), (de.message || "") != "" ? _.messages.push(de.message) : _.messages.push(he), O && (_.scrollToFieldToken = Date.now()));
    }
    return _;
  }, m = (_) => gn(_).isValid(), A = (_) => {
    const O = (_ || "").trim();
    if (!/^[0-9]{11}$/.test(O))
      return !1;
    for (var D = 0, M = 0; M < 11; M++) {
      var C = O.charCodeAt(M) - "0".charCodeAt(0);
      (M & 1) === 1 && (C *= 2, C > 9 && (C -= 9)), D += C;
    }
    return D % 10 === 0;
  }, b = (_) => {
    const O = (_ || "").trim().toUpperCase();
    if (!/^[\s]*(?:[A-Z][AEIOU][AEIOUX]|[AEIOU]X{2}|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z][\s]*$/.test(O))
      return !1;
    console.log("CF pre trattamento omocodia: " + O);
    const D = S(O);
    if (console.log("CF post trattamento omocodia: " + D), !/^[\s]*[0-9A-Za-z]{16}[\s]*$/.test(D))
      return !1;
    for (var M = 0, C = "BAFHJNPRTVCESULDGIMOQKWZYX", I = 0; I < 15; I++) {
      var w = D[I].toUpperCase(), F = 0;
      "0" <= w && w <= "9" ? F = w.charCodeAt(0) - "0".charCodeAt(0) : F = w.charCodeAt(0) - "A".charCodeAt(0), I & 1 || (F = C.charCodeAt(F) - "A".charCodeAt(0)), M += F;
    }
    return M % 26 + "A".charCodeAt(0) === D[15].toUpperCase().charCodeAt(0);
  }, S = (_) => {
    const O = [1, 2, 3, 5, 6, 8, 9], D = [];
    let M = !1;
    const C = _.split("").reverse().join("");
    for (let I = 0; I < C.length; I++) {
      const w = C[I];
      if (O.includes(I) && !M) {
        const F = parseInt(w, 10);
        if (isNaN(F)) {
          const k = N(w);
          D.push(k.toString());
        } else
          D.push(F.toString()), M = !0;
      } else
        D.push(w);
    }
    return D.reverse().join("");
  }, N = (_) => {
    const O = {
      0: "L",
      1: "M",
      2: "N",
      3: "P",
      4: "Q",
      5: "R",
      6: "S",
      7: "T",
      8: "U",
      9: "V"
    };
    for (const [D, M] of Object.entries(O))
      if (M.toLowerCase() === _.toLowerCase())
        return parseInt(D, 10);
    return -1;
  }, T = (_) => {
    if (!_)
      return !1;
    const O = _.trim();
    return O.length == 16 ? b(O) : O.length == 11 ? A(O) : !1;
  }, R = (_ = !0) => {
    if (Yu.value == !1)
      return f(), !0;
    let O = !0, D = !1;
    if (e.value)
      for (let M = 0; M < e.value.length; M++) {
        const C = e.value[M];
        g(C, !D).success || (O = !1, D = !0);
      }
    return !O && _ && n.showError("Attenzione", r), O;
  }, y = (_) => {
    const O = [];
    for (let D = 0; D < _.length; D++) {
      const M = _[D];
      let C = null, I = null;
      typeof M == "string" ? C = M : M instanceof Object && (C = Object.keys(M)[0], I = M[C]);
      const w = {};
      switch (w.rule = C, I != null && I.enabled && (w.enabled = I == null ? void 0 : I.enabled), I != null && I.message && (w.message = I == null ? void 0 : I.message), w.rule) {
        case "numericRange":
          if (I && I.min && Number(I.min))
            w.minNumber = I.min;
          else
            throw "per il range, fornire sia min che max";
          if (I && I.max && Number(I.max))
            w.maxNumber = I.max;
          else
            throw "per il range, fornire sia min che max";
          break;
        case "dateRange":
          if (I && I.min && m(I.min))
            w.minDate = gn(I.min).toDate();
          else
            throw "per il range di date, fornire sia min che max";
          if (I && I.max && m(I.max))
            w.maxDate = gn(I.max).toDate();
          else
            throw "per il range di date, fornire sia min che max";
          break;
        case "minLength":
        case "minNumber":
          if (I && Number(I))
            w.minNumber = I;
          else if (I && I.min && Number(I.min))
            w.minNumber = I.min;
          else
            throw "indicare il valore minimo per la regola " + w.rule;
          break;
        case "maxLength":
        case "maxNumber":
          if (I && Number(I))
            w.maxNumber = I;
          else if (I && I.max && Number(I.max))
            w.maxNumber = I.max;
          else
            throw "indicare il valore massimo per la regola " + w.rule;
          break;
        case "minDate":
          if (I && m(I))
            w.minDate = gn(I).toDate();
          else if (I && I.min && m(I.min))
            w.minDate = gn(I.min).toDate();
          else
            throw "indicare la data minima per la regola " + w.rule;
          break;
        case "maxDate":
          if (I && m(I))
            w.minDate = gn(I).toDate();
          else if (I && I.max && m(I.max))
            w.minDate = gn(I.max).toDate();
          else
            throw "indicare la data massima per la regola " + w.rule;
          break;
        case "regex":
          if (I && I instanceof RegExp)
            w.regex = I;
          else if (I && typeof I == "string")
            w.regex = new RegExp(I);
          else if (I && I.regex)
            w.regex = I.regex;
          else
            throw "indicare la regula expression per regola regex";
          break;
        default:
          if (!Object.values(tv).includes(C)) {
            if (I && I.rule)
              w.customValidationHandler = I.rule;
            else
              throw "indicare l'handler di validazione per regola custom";
            if ((w.message || "").trim() == "")
              throw "indicare il messaggio di errore per regola custom";
          }
          break;
      }
      O.push(w);
    }
    return O;
  };
  return {
    validationEnabled: Ht(() => Yu.value),
    setValidationEnabled: (_) => {
      Yu.value = _;
    },
    bindInstanceToValidate: h,
    clearValidationState: f,
    addField: p,
    getField: o,
    validateField: d,
    validate: R,
    setMainErrorMessage: u,
    success: c,
    validateTaxCode: b,
    validateVatCode: A,
    validateVatOrTaxCode: T
  };
}
const OO = {
  key: 0,
  class: "chip-label"
}, PO = {
  key: 1,
  class: "chip-label"
}, IO = {
  key: 2,
  class: "chip-label"
}, NO = {
  key: 3,
  class: "chip-label"
}, LO = ["onClick"], wO = {
  class: "visually-hidden",
  style: { "background-color": "white" }
}, xO = /* @__PURE__ */ Dt({
  __name: "KFilterChips",
  props: {
    activeFilters: { default: null },
    filterObject: { default: null },
    labelTranslations: { default: null },
    valueTranslations: { default: null }
  },
  emits: ["resetFilter"],
  setup(n, { emit: e }) {
    const t = n, { toDateString: r } = Gr(), o = e, u = (d, v) => Array.isArray(d[v]), c = (d, v) => d[v].length, l = (d, v) => typeof d[v] == "boolean", i = (d, v) => d[v] instanceof Date, h = (d) => {
      o("resetFilter", d);
    }, f = (d) => t.labelTranslations && t.labelTranslations[d] || d.charAt(0).toUpperCase() + d.slice(1), p = (d) => {
      if (u(t.filterObject, d)) {
        try {
          if (t.valueTranslations && t.valueTranslations[d]) {
            const v = t.valueTranslations[d];
            if (v)
              return t.filterObject[d].map((A) => {
                const b = v.find((S) => S.value == A);
                return b ? b.desc : A;
              }).join(", ");
          }
        } catch {
          console.error("Error mapping KFilterChips value for prop: " + d);
        }
        return c(t.filterObject, d);
      } else {
        const v = t.filterObject[d];
        try {
          if (t.valueTranslations && t.valueTranslations[d]) {
            const g = t.valueTranslations[d];
            if (g && g.find((m) => m.value == v))
              return g.find((m) => m.value == v).desc;
          }
        } catch {
          console.error("Error mapping KFilterChips value for prop: " + d);
        }
        return v;
      }
    };
    return (d, v) => {
      const g = Nt("KIcon");
      return Oe(!0), je(dn, null, Un(d.activeFilters, (m, A) => (Oe(), je("div", {
        class: "chip chip-primary chip-lg alert",
        key: A
      }, [
        u(d.filterObject, m) ? (Oe(), je("span", OO, lt(f(m)) + ": " + lt(p(m)), 1)) : l(d.filterObject, m) ? (Oe(), je("span", PO, lt(f(m)) + ": " + lt(d.filterObject[m] ? "Si" : "No"), 1)) : i(d.filterObject, m) ? (Oe(), je("span", IO, lt(f(m)) + ": " + lt(Ye(r)(d.filterObject[m])), 1)) : (Oe(), je("span", NO, lt(f(m)) + ": " + lt(p(m)), 1)),
        ve("button", {
          onClick: (b) => h(m)
        }, [
          dt(g, {
            icon: "it-close",
            class: "icon-sm"
          }),
          ve("span", wO, "Elimina filtro " + lt(m), 1)
        ], 8, LO)
      ]))), 128);
    };
  }
}), BO = {
  key: 0,
  class: "dot-container"
}, FO = ["title"], UO = /* @__PURE__ */ ve("br", null, null, -1), kO = /* @__PURE__ */ Dt({
  __name: "KGlobalCalendarCompact",
  setup(n) {
    const e = DR(), t = st("auto"), r = new ResizeObserver((l) => {
      for (const i of l)
        t.value = `${i.contentRect.width}px`;
    });
    ln(() => {
      const l = document.getElementsByClassName("k-mini-calendar")[0];
      r.observe(l);
    });
    const o = (l) => e.calendarItems.filter(
      (i) => i.dateTimeStart.getDate() === l.day && i.dateTimeStart.getMonth() === l.month && i.dateTimeStart.getFullYear() === l.year
    ), u = st(), c = Ht(() => {
      if (u.value) {
        const l = {
          day: u.value.getDate(),
          month: u.value.getMonth(),
          year: u.value.getFullYear()
        };
        return o(l);
      }
      return [];
    });
    return (l, i) => (Oe(), je(dn, null, [
      dt(Ye(JE), {
        modelValue: u.value,
        "onUpdate:modelValue": i[0] || (i[0] = (h) => u.value = h),
        inline: "",
        class: "k-mini-calendar",
        "aria-label": "compact calendar"
      }, {
        previousicon: Ft(() => [
          dt(yn, { icon: "it-chevron-left" })
        ]),
        nexticon: Ft(() => [
          dt(yn, { icon: "it-chevron-right" })
        ]),
        date: Ft((h) => {
          var f;
          return [
            an(lt(h.date.day) + " ", 1),
            ((f = o(h.date)) == null ? void 0 : f.length) > 0 ? (Oe(), je("span", BO, [
              (Oe(!0), je(dn, null, Un(o(h.date), (p) => (Oe(), je("span", {
                key: p.moduleKey + p.moduleId,
                title: p.title,
                class: Ct(["dot", { "bg-primary": p.isImportant === !0 }])
              }, null, 10, FO))), 128))
            ])) : mt("", !0)
          ];
        }),
        _: 1
      }, 8, ["modelValue"]),
      ve("div", {
        style: mr({ width: t.value })
      }, [
        (Oe(!0), je(dn, null, Un(c.value, (h) => (Oe(), je("div", {
          class: Ct(["k-mini-calendar-detail-item", [h.isImportant === !0 ? "primary-border-color" : "neutral-1-border-color-a2"]]),
          key: h.moduleKey + h.moduleId
        }, [
          ve("em", null, lt(h.title), 1),
          UO,
          an(" " + lt(h.description), 1)
        ], 2))), 128))
      ], 4)
    ], 64));
  }
});
const KO = { class: "lightgrey-bg-c1 k-global-search" }, jO = /* @__PURE__ */ Dt({
  __name: "KGlobalSearchBar",
  setup(n) {
    const e = Ns(), t = async () => {
      e.isSearchGlobalModalOpened = !0, await e.executeGlobalSearch(e.searchText);
    };
    return (r, o) => {
      const u = Nt("KInputText");
      return Oe(), je("div", KO, [
        dt(u, {
          icon: "it-search",
          modelValue: Ye(e).searchText,
          "onUpdate:modelValue": o[0] || (o[0] = (c) => Ye(e).searchText = c),
          onEnterPressed: t,
          placeholder: "CERCA",
          autofocus: !0,
          autocomplete: "off"
        }, {
          "append-container": Ft(() => [
            ve("button", {
              class: "btn btn-primary",
              type: "button",
              onClick: t
            }, "Cerca")
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]);
    };
  }
});
function xn(n) {
  this.content = n;
}
xn.prototype = {
  constructor: xn,
  find: function(n) {
    for (var e = 0; e < this.content.length; e += 2)
      if (this.content[e] === n)
        return e;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(n) {
    var e = this.find(n);
    return e == -1 ? void 0 : this.content[e + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(n, e, t) {
    var r = t && t != n ? this.remove(t) : this, o = r.find(n), u = r.content.slice();
    return o == -1 ? u.push(t || n, e) : (u[o + 1] = e, t && (u[o] = t)), new xn(u);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(n) {
    var e = this.find(n);
    if (e == -1)
      return this;
    var t = this.content.slice();
    return t.splice(e, 2), new xn(t);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(n, e) {
    return new xn([n, e].concat(this.remove(n).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(n, e) {
    var t = this.remove(n).content.slice();
    return t.push(n, e), new xn(t);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(n, e, t) {
    var r = this.remove(e), o = r.content.slice(), u = r.find(n);
    return o.splice(u == -1 ? o.length : u, 0, e, t), new xn(o);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(n) {
    for (var e = 0; e < this.content.length; e += 2)
      n(this.content[e], this.content[e + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(n) {
    return n = xn.from(n), n.size ? new xn(n.content.concat(this.subtract(n).content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(n) {
    return n = xn.from(n), n.size ? new xn(this.subtract(n).content.concat(n.content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(n) {
    var e = this;
    n = xn.from(n);
    for (var t = 0; t < n.content.length; t += 2)
      e = e.remove(n.content[t]);
    return e;
  },
  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var n = {};
    return this.forEach(function(e, t) {
      n[e] = t;
    }), n;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
xn.from = function(n) {
  if (n instanceof xn)
    return n;
  var e = [];
  if (n)
    for (var t in n)
      e.push(t, n[t]);
  return new xn(e);
};
function nv(n, e, t) {
  for (let r = 0; ; r++) {
    if (r == n.childCount || r == e.childCount)
      return n.childCount == e.childCount ? null : t;
    let o = n.child(r), u = e.child(r);
    if (o == u) {
      t += o.nodeSize;
      continue;
    }
    if (!o.sameMarkup(u))
      return t;
    if (o.isText && o.text != u.text) {
      for (let c = 0; o.text[c] == u.text[c]; c++)
        t++;
      return t;
    }
    if (o.content.size || u.content.size) {
      let c = nv(o.content, u.content, t + 1);
      if (c != null)
        return c;
    }
    t += o.nodeSize;
  }
}
function rv(n, e, t, r) {
  for (let o = n.childCount, u = e.childCount; ; ) {
    if (o == 0 || u == 0)
      return o == u ? null : { a: t, b: r };
    let c = n.child(--o), l = e.child(--u), i = c.nodeSize;
    if (c == l) {
      t -= i, r -= i;
      continue;
    }
    if (!c.sameMarkup(l))
      return { a: t, b: r };
    if (c.isText && c.text != l.text) {
      let h = 0, f = Math.min(c.text.length, l.text.length);
      for (; h < f && c.text[c.text.length - h - 1] == l.text[l.text.length - h - 1]; )
        h++, t--, r--;
      return { a: t, b: r };
    }
    if (c.content.size || l.content.size) {
      let h = rv(c.content, l.content, t - 1, r - 1);
      if (h)
        return h;
    }
    t -= i, r -= i;
  }
}
class Tt {
  /**
  @internal
  */
  constructor(e, t) {
    if (this.content = e, this.size = t || 0, t == null)
      for (let r = 0; r < e.length; r++)
        this.size += e[r].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(e, t, r, o = 0, u) {
    for (let c = 0, l = 0; l < t; c++) {
      let i = this.content[c], h = l + i.nodeSize;
      if (h > e && r(i, o + l, u || null, c) !== !1 && i.content.size) {
        let f = l + 1;
        i.nodesBetween(Math.max(0, e - f), Math.min(i.content.size, t - f), r, o + f);
      }
      l = h;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(e) {
    this.nodesBetween(0, this.size, e);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(e, t, r, o) {
    let u = "", c = !0;
    return this.nodesBetween(e, t, (l, i) => {
      let h = l.isText ? l.text.slice(Math.max(e, i) - i, t - i) : l.isLeaf ? o ? typeof o == "function" ? o(l) : o : l.type.spec.leafText ? l.type.spec.leafText(l) : "" : "";
      l.isBlock && (l.isLeaf && h || l.isTextblock) && r && (c ? c = !1 : u += r), u += h;
    }, 0), u;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(e) {
    if (!e.size)
      return this;
    if (!this.size)
      return e;
    let t = this.lastChild, r = e.firstChild, o = this.content.slice(), u = 0;
    for (t.isText && t.sameMarkup(r) && (o[o.length - 1] = t.withText(t.text + r.text), u = 1); u < e.content.length; u++)
      o.push(e.content[u]);
    return new Tt(o, this.size + e.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(e, t = this.size) {
    if (e == 0 && t == this.size)
      return this;
    let r = [], o = 0;
    if (t > e)
      for (let u = 0, c = 0; c < t; u++) {
        let l = this.content[u], i = c + l.nodeSize;
        i > e && ((c < e || i > t) && (l.isText ? l = l.cut(Math.max(0, e - c), Math.min(l.text.length, t - c)) : l = l.cut(Math.max(0, e - c - 1), Math.min(l.content.size, t - c - 1))), r.push(l), o += l.nodeSize), c = i;
      }
    return new Tt(r, o);
  }
  /**
  @internal
  */
  cutByIndex(e, t) {
    return e == t ? Tt.empty : e == 0 && t == this.content.length ? this : new Tt(this.content.slice(e, t));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(e, t) {
    let r = this.content[e];
    if (r == t)
      return this;
    let o = this.content.slice(), u = this.size + t.nodeSize - r.nodeSize;
    return o[e] = t, new Tt(o, u);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(e) {
    return new Tt([e].concat(this.content), this.size + e.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(e) {
    return new Tt(this.content.concat(e), this.size + e.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(e) {
    if (this.content.length != e.content.length)
      return !1;
    for (let t = 0; t < this.content.length; t++)
      if (!this.content[t].eq(e.content[t]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(e) {
    let t = this.content[e];
    if (!t)
      throw new RangeError("Index " + e + " out of range for " + this);
    return t;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content[e] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    for (let t = 0, r = 0; t < this.content.length; t++) {
      let o = this.content[t];
      e(o, r, t), r += o.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(e, t = 0) {
    return nv(this, e, t);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(e, t = this.size, r = e.size) {
    return rv(this, e, t, r);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. (Not public.)
  */
  findIndex(e, t = -1) {
    if (e == 0)
      return Zs(0, e);
    if (e == this.size)
      return Zs(this.content.length, e);
    if (e > this.size || e < 0)
      throw new RangeError(`Position ${e} outside of fragment (${this})`);
    for (let r = 0, o = 0; ; r++) {
      let u = this.child(r), c = o + u.nodeSize;
      if (c >= e)
        return c == e || t > 0 ? Zs(r + 1, c) : Zs(r, o);
      o = c;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((e) => e.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(e, t) {
    if (!t)
      return Tt.empty;
    if (!Array.isArray(t))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new Tt(t.map(e.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(e) {
    if (!e.length)
      return Tt.empty;
    let t, r = 0;
    for (let o = 0; o < e.length; o++) {
      let u = e[o];
      r += u.nodeSize, o && u.isText && e[o - 1].sameMarkup(u) ? (t || (t = e.slice(0, o)), t[t.length - 1] = u.withText(t[t.length - 1].text + u.text)) : t && t.push(u);
    }
    return new Tt(t || e, r);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(e) {
    if (!e)
      return Tt.empty;
    if (e instanceof Tt)
      return e;
    if (Array.isArray(e))
      return this.fromArray(e);
    if (e.attrs)
      return new Tt([e], e.nodeSize);
    throw new RangeError("Can not convert " + e + " to a Fragment" + (e.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
Tt.empty = new Tt([], 0);
const Xu = { index: 0, offset: 0 };
function Zs(n, e) {
  return Xu.index = n, Xu.offset = e, Xu;
}
function Al(n, e) {
  if (n === e)
    return !0;
  if (!(n && typeof n == "object") || !(e && typeof e == "object"))
    return !1;
  let t = Array.isArray(n);
  if (Array.isArray(e) != t)
    return !1;
  if (t) {
    if (n.length != e.length)
      return !1;
    for (let r = 0; r < n.length; r++)
      if (!Al(n[r], e[r]))
        return !1;
  } else {
    for (let r in n)
      if (!(r in e) || !Al(n[r], e[r]))
        return !1;
    for (let r in e)
      if (!(r in n))
        return !1;
  }
  return !0;
}
let hn = class $c {
  /**
  @internal
  */
  constructor(e, t) {
    this.type = e, this.attrs = t;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(e) {
    let t, r = !1;
    for (let o = 0; o < e.length; o++) {
      let u = e[o];
      if (this.eq(u))
        return e;
      if (this.type.excludes(u.type))
        t || (t = e.slice(0, o));
      else {
        if (u.type.excludes(this.type))
          return e;
        !r && u.type.rank > this.type.rank && (t || (t = e.slice(0, o)), t.push(this), r = !0), t && t.push(u);
      }
    }
    return t || (t = e.slice()), r || t.push(this), t;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(e) {
    for (let t = 0; t < e.length; t++)
      if (this.eq(e[t]))
        return e.slice(0, t).concat(e.slice(t + 1));
    return e;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(e) {
    for (let t = 0; t < e.length; t++)
      if (this.eq(e[t]))
        return !0;
    return !1;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(e) {
    return this == e || this.type == e.type && Al(this.attrs, e.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let t in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return e;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(e, t) {
    if (!t)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let r = e.marks[t.type];
    if (!r)
      throw new RangeError(`There is no mark type ${t.type} in this schema`);
    return r.create(t.attrs);
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(e, t) {
    if (e == t)
      return !0;
    if (e.length != t.length)
      return !1;
    for (let r = 0; r < e.length; r++)
      if (!e[r].eq(t[r]))
        return !1;
    return !0;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(e) {
    if (!e || Array.isArray(e) && e.length == 0)
      return $c.none;
    if (e instanceof $c)
      return [e];
    let t = e.slice();
    return t.sort((r, o) => r.type.rank - o.type.rank), t;
  }
};
hn.none = [];
class Sl extends Error {
}
class Lt {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(e, t, r) {
    this.content = e, this.openStart = t, this.openEnd = r;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(e, t) {
    let r = av(this.content, e + this.openStart, t);
    return r && new Lt(r, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(e, t) {
    return new Lt(iv(this.content, e + this.openStart, t + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(e) {
    return this.content.eq(e.content) && this.openStart == e.openStart && this.openEnd == e.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let e = { content: this.content.toJSON() };
    return this.openStart > 0 && (e.openStart = this.openStart), this.openEnd > 0 && (e.openEnd = this.openEnd), e;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(e, t) {
    if (!t)
      return Lt.empty;
    let r = t.openStart || 0, o = t.openEnd || 0;
    if (typeof r != "number" || typeof o != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new Lt(Tt.fromJSON(e, t.content), r, o);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(e, t = !0) {
    let r = 0, o = 0;
    for (let u = e.firstChild; u && !u.isLeaf && (t || !u.type.spec.isolating); u = u.firstChild)
      r++;
    for (let u = e.lastChild; u && !u.isLeaf && (t || !u.type.spec.isolating); u = u.lastChild)
      o++;
    return new Lt(e, r, o);
  }
}
Lt.empty = new Lt(Tt.empty, 0, 0);
function iv(n, e, t) {
  let { index: r, offset: o } = n.findIndex(e), u = n.maybeChild(r), { index: c, offset: l } = n.findIndex(t);
  if (o == e || u.isText) {
    if (l != t && !n.child(c).isText)
      throw new RangeError("Removing non-flat range");
    return n.cut(0, e).append(n.cut(t));
  }
  if (r != c)
    throw new RangeError("Removing non-flat range");
  return n.replaceChild(r, u.copy(iv(u.content, e - o - 1, t - o - 1)));
}
function av(n, e, t, r) {
  let { index: o, offset: u } = n.findIndex(e), c = n.maybeChild(o);
  if (u == e || c.isText)
    return r && !r.canReplace(o, o, t) ? null : n.cut(0, e).append(t).append(n.cut(e));
  let l = av(c.content, e - u - 1, t);
  return l && n.replaceChild(o, c.copy(l));
}
function WO(n, e, t) {
  if (t.openStart > n.depth)
    throw new Sl("Inserted content deeper than insertion position");
  if (n.depth - t.openStart != e.depth - t.openEnd)
    throw new Sl("Inconsistent open depths");
  return ov(n, e, t, 0);
}
function ov(n, e, t, r) {
  let o = n.index(r), u = n.node(r);
  if (o == e.index(r) && r < n.depth - t.openStart) {
    let c = ov(n, e, t, r + 1);
    return u.copy(u.content.replaceChild(o, c));
  } else if (t.content.size)
    if (!t.openStart && !t.openEnd && n.depth == r && e.depth == r) {
      let c = n.parent, l = c.content;
      return la(c, l.cut(0, n.parentOffset).append(t.content).append(l.cut(e.parentOffset)));
    } else {
      let { start: c, end: l } = VO(t, n);
      return la(u, lv(n, c, l, e, r));
    }
  else
    return la(u, Cl(n, e, r));
}
function sv(n, e) {
  if (!e.type.compatibleContent(n.type))
    throw new Sl("Cannot join " + e.type.name + " onto " + n.type.name);
}
function Gc(n, e, t) {
  let r = n.node(t);
  return sv(r, e.node(t)), r;
}
function sa(n, e) {
  let t = e.length - 1;
  t >= 0 && n.isText && n.sameMarkup(e[t]) ? e[t] = n.withText(e[t].text + n.text) : e.push(n);
}
function Yo(n, e, t, r) {
  let o = (e || n).node(t), u = 0, c = e ? e.index(t) : o.childCount;
  n && (u = n.index(t), n.depth > t ? u++ : n.textOffset && (sa(n.nodeAfter, r), u++));
  for (let l = u; l < c; l++)
    sa(o.child(l), r);
  e && e.depth == t && e.textOffset && sa(e.nodeBefore, r);
}
function la(n, e) {
  return n.type.checkContent(e), n.copy(e);
}
function lv(n, e, t, r, o) {
  let u = n.depth > o && Gc(n, e, o + 1), c = r.depth > o && Gc(t, r, o + 1), l = [];
  return Yo(null, n, o, l), u && c && e.index(o) == t.index(o) ? (sv(u, c), sa(la(u, lv(n, e, t, r, o + 1)), l)) : (u && sa(la(u, Cl(n, e, o + 1)), l), Yo(e, t, o, l), c && sa(la(c, Cl(t, r, o + 1)), l)), Yo(r, null, o, l), new Tt(l);
}
function Cl(n, e, t) {
  let r = [];
  if (Yo(null, n, t, r), n.depth > t) {
    let o = Gc(n, e, t + 1);
    sa(la(o, Cl(n, e, t + 1)), r);
  }
  return Yo(e, null, t, r), new Tt(r);
}
function VO(n, e) {
  let t = e.depth - n.openStart, o = e.node(t).copy(n.content);
  for (let u = t - 1; u >= 0; u--)
    o = e.node(u).copy(Tt.from(o));
  return {
    start: o.resolveNoCache(n.openStart + t),
    end: o.resolveNoCache(o.content.size - n.openEnd - t)
  };
}
class ds {
  /**
  @internal
  */
  constructor(e, t, r) {
    this.pos = e, this.path = t, this.parentOffset = r, this.depth = t.length / 3 - 1;
  }
  /**
  @internal
  */
  resolveDepth(e) {
    return e == null ? this.depth : e < 0 ? this.depth + e : e;
  }
  /**
  The parent node that the position points into. Note that even if
  a position points into a text node, that node is not considered
  the parent—text nodes are ‘flat’ in this model, and have no content.
  */
  get parent() {
    return this.node(this.depth);
  }
  /**
  The root node in which the position was resolved.
  */
  get doc() {
    return this.node(0);
  }
  /**
  The ancestor node at the given level. `p.node(p.depth)` is the
  same as `p.parent`.
  */
  node(e) {
    return this.path[this.resolveDepth(e) * 3];
  }
  /**
  The index into the ancestor at the given level. If this points
  at the 3rd node in the 2nd paragraph on the top level, for
  example, `p.index(0)` is 1 and `p.index(1)` is 2.
  */
  index(e) {
    return this.path[this.resolveDepth(e) * 3 + 1];
  }
  /**
  The index pointing after this position into the ancestor at the
  given level.
  */
  indexAfter(e) {
    return e = this.resolveDepth(e), this.index(e) + (e == this.depth && !this.textOffset ? 0 : 1);
  }
  /**
  The (absolute) position at the start of the node at the given
  level.
  */
  start(e) {
    return e = this.resolveDepth(e), e == 0 ? 0 : this.path[e * 3 - 1] + 1;
  }
  /**
  The (absolute) position at the end of the node at the given
  level.
  */
  end(e) {
    return e = this.resolveDepth(e), this.start(e) + this.node(e).content.size;
  }
  /**
  The (absolute) position directly before the wrapping node at the
  given level, or, when `depth` is `this.depth + 1`, the original
  position.
  */
  before(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position before the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1];
  }
  /**
  The (absolute) position directly after the wrapping node at the
  given level, or the original position when `depth` is `this.depth + 1`.
  */
  after(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position after the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1] + this.path[e * 3].nodeSize;
  }
  /**
  When this position points into a text node, this returns the
  distance between the position and the start of the text node.
  Will be zero for positions that point between nodes.
  */
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  /**
  Get the node directly after the position, if any. If the position
  points into a text node, only the part of that node after the
  position is returned.
  */
  get nodeAfter() {
    let e = this.parent, t = this.index(this.depth);
    if (t == e.childCount)
      return null;
    let r = this.pos - this.path[this.path.length - 1], o = e.child(t);
    return r ? e.child(t).cut(r) : o;
  }
  /**
  Get the node directly before the position, if any. If the
  position points into a text node, only the part of that node
  before the position is returned.
  */
  get nodeBefore() {
    let e = this.index(this.depth), t = this.pos - this.path[this.path.length - 1];
    return t ? this.parent.child(e).cut(0, t) : e == 0 ? null : this.parent.child(e - 1);
  }
  /**
  Get the position at the given index in the parent node at the
  given depth (which defaults to `this.depth`).
  */
  posAtIndex(e, t) {
    t = this.resolveDepth(t);
    let r = this.path[t * 3], o = t == 0 ? 0 : this.path[t * 3 - 1] + 1;
    for (let u = 0; u < e; u++)
      o += r.child(u).nodeSize;
    return o;
  }
  /**
  Get the marks at this position, factoring in the surrounding
  marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
  position is at the start of a non-empty node, the marks of the
  node after it (if any) are returned.
  */
  marks() {
    let e = this.parent, t = this.index();
    if (e.content.size == 0)
      return hn.none;
    if (this.textOffset)
      return e.child(t).marks;
    let r = e.maybeChild(t - 1), o = e.maybeChild(t);
    if (!r) {
      let l = r;
      r = o, o = l;
    }
    let u = r.marks;
    for (var c = 0; c < u.length; c++)
      u[c].type.spec.inclusive === !1 && (!o || !u[c].isInSet(o.marks)) && (u = u[c--].removeFromSet(u));
    return u;
  }
  /**
  Get the marks after the current position, if any, except those
  that are non-inclusive and not present at position `$end`. This
  is mostly useful for getting the set of marks to preserve after a
  deletion. Will return `null` if this position is at the end of
  its parent node or its parent node isn't a textblock (in which
  case no marks should be preserved).
  */
  marksAcross(e) {
    let t = this.parent.maybeChild(this.index());
    if (!t || !t.isInline)
      return null;
    let r = t.marks, o = e.parent.maybeChild(e.index());
    for (var u = 0; u < r.length; u++)
      r[u].type.spec.inclusive === !1 && (!o || !r[u].isInSet(o.marks)) && (r = r[u--].removeFromSet(r));
    return r;
  }
  /**
  The depth up to which this position and the given (non-resolved)
  position share the same parent nodes.
  */
  sharedDepth(e) {
    for (let t = this.depth; t > 0; t--)
      if (this.start(t) <= e && this.end(t) >= e)
        return t;
    return 0;
  }
  /**
  Returns a range based on the place where this position and the
  given position diverge around block content. If both point into
  the same textblock, for example, a range around that textblock
  will be returned. If they point into different blocks, the range
  around those blocks in their shared ancestor is returned. You can
  pass in an optional predicate that will be called with a parent
  node to see if a range into that parent is acceptable.
  */
  blockRange(e = this, t) {
    if (e.pos < this.pos)
      return e.blockRange(this);
    for (let r = this.depth - (this.parent.inlineContent || this.pos == e.pos ? 1 : 0); r >= 0; r--)
      if (e.pos <= this.end(r) && (!t || t(this.node(r))))
        return new Ml(this, e, r);
    return null;
  }
  /**
  Query whether the given position shares the same parent node.
  */
  sameParent(e) {
    return this.pos - this.parentOffset == e.pos - e.parentOffset;
  }
  /**
  Return the greater of this and the given position.
  */
  max(e) {
    return e.pos > this.pos ? e : this;
  }
  /**
  Return the smaller of this and the given position.
  */
  min(e) {
    return e.pos < this.pos ? e : this;
  }
  /**
  @internal
  */
  toString() {
    let e = "";
    for (let t = 1; t <= this.depth; t++)
      e += (e ? "/" : "") + this.node(t).type.name + "_" + this.index(t - 1);
    return e + ":" + this.parentOffset;
  }
  /**
  @internal
  */
  static resolve(e, t) {
    if (!(t >= 0 && t <= e.content.size))
      throw new RangeError("Position " + t + " out of range");
    let r = [], o = 0, u = t;
    for (let c = e; ; ) {
      let { index: l, offset: i } = c.content.findIndex(u), h = u - i;
      if (r.push(c, l, o + i), !h || (c = c.child(l), c.isText))
        break;
      u = h - 1, o += i + 1;
    }
    return new ds(t, r, u);
  }
  /**
  @internal
  */
  static resolveCached(e, t) {
    for (let o = 0; o < Qu.length; o++) {
      let u = Qu[o];
      if (u.pos == t && u.doc == e)
        return u;
    }
    let r = Qu[Ju] = ds.resolve(e, t);
    return Ju = (Ju + 1) % HO, r;
  }
}
let Qu = [], Ju = 0, HO = 12;
class Ml {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(e, t, r) {
    this.$from = e, this.$to = t, this.depth = r;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const $O = /* @__PURE__ */ Object.create(null);
let ua = class zc {
  /**
  @internal
  */
  constructor(e, t, r, o = hn.none) {
    this.type = e, this.attrs = t, this.marks = o, this.content = r || Tt.empty;
  }
  /**
  The size of this node, as defined by the integer-based [indexing
  scheme](/docs/guide/#doc.indexing). For text nodes, this is the
  amount of characters. For other leaf nodes, it is one. For
  non-leaf nodes, it is the size of the content plus two (the
  start and end token).
  */
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  /**
  The number of children that the node has.
  */
  get childCount() {
    return this.content.childCount;
  }
  /**
  Get the child node at the given index. Raises an error when the
  index is out of range.
  */
  child(e) {
    return this.content.child(e);
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content.maybeChild(e);
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    this.content.forEach(e);
  }
  /**
  Invoke a callback for all descendant nodes recursively between
  the given two positions that are relative to start of this
  node's content. The callback is invoked with the node, its
  position relative to the original node (method receiver),
  its parent node, and its child index. When the callback returns
  false for a given node, that node's children will not be
  recursed over. The last parameter can be used to specify a
  starting position to count from.
  */
  nodesBetween(e, t, r, o = 0) {
    this.content.nodesBetween(e, t, r, o, this);
  }
  /**
  Call the given callback for every descendant node. Doesn't
  descend into a node when the callback returns `false`.
  */
  descendants(e) {
    this.nodesBetween(0, this.content.size, e);
  }
  /**
  Concatenates all the text nodes found in this fragment and its
  children.
  */
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  /**
  Get all text between positions `from` and `to`. When
  `blockSeparator` is given, it will be inserted to separate text
  from different block nodes. If `leafText` is given, it'll be
  inserted for every non-text leaf node encountered, otherwise
  [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
  */
  textBetween(e, t, r, o) {
    return this.content.textBetween(e, t, r, o);
  }
  /**
  Returns this node's first child, or `null` if there are no
  children.
  */
  get firstChild() {
    return this.content.firstChild;
  }
  /**
  Returns this node's last child, or `null` if there are no
  children.
  */
  get lastChild() {
    return this.content.lastChild;
  }
  /**
  Test whether two nodes represent the same piece of document.
  */
  eq(e) {
    return this == e || this.sameMarkup(e) && this.content.eq(e.content);
  }
  /**
  Compare the markup (type, attributes, and marks) of this node to
  those of another. Returns `true` if both have the same markup.
  */
  sameMarkup(e) {
    return this.hasMarkup(e.type, e.attrs, e.marks);
  }
  /**
  Check whether this node's markup correspond to the given type,
  attributes, and marks.
  */
  hasMarkup(e, t, r) {
    return this.type == e && Al(this.attrs, t || e.defaultAttrs || $O) && hn.sameSet(this.marks, r || hn.none);
  }
  /**
  Create a new node with the same markup as this node, containing
  the given content (or empty, if no content is given).
  */
  copy(e = null) {
    return e == this.content ? this : new zc(this.type, this.attrs, e, this.marks);
  }
  /**
  Create a copy of this node, with the given set of marks instead
  of the node's own marks.
  */
  mark(e) {
    return e == this.marks ? this : new zc(this.type, this.attrs, this.content, e);
  }
  /**
  Create a copy of this node with only the content between the
  given positions. If `to` is not given, it defaults to the end of
  the node.
  */
  cut(e, t = this.content.size) {
    return e == 0 && t == this.content.size ? this : this.copy(this.content.cut(e, t));
  }
  /**
  Cut out the part of the document between the given positions, and
  return it as a `Slice` object.
  */
  slice(e, t = this.content.size, r = !1) {
    if (e == t)
      return Lt.empty;
    let o = this.resolve(e), u = this.resolve(t), c = r ? 0 : o.sharedDepth(t), l = o.start(c), h = o.node(c).content.cut(o.pos - l, u.pos - l);
    return new Lt(h, o.depth - c, u.depth - c);
  }
  /**
  Replace the part of the document between the given positions with
  the given slice. The slice must 'fit', meaning its open sides
  must be able to connect to the surrounding content, and its
  content nodes must be valid children for the node they are placed
  into. If any of this is violated, an error of type
  [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
  */
  replace(e, t, r) {
    return WO(this.resolve(e), this.resolve(t), r);
  }
  /**
  Find the node directly after the given position.
  */
  nodeAt(e) {
    for (let t = this; ; ) {
      let { index: r, offset: o } = t.content.findIndex(e);
      if (t = t.maybeChild(r), !t)
        return null;
      if (o == e || t.isText)
        return t;
      e -= o + 1;
    }
  }
  /**
  Find the (direct) child node after the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childAfter(e) {
    let { index: t, offset: r } = this.content.findIndex(e);
    return { node: this.content.maybeChild(t), index: t, offset: r };
  }
  /**
  Find the (direct) child node before the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childBefore(e) {
    if (e == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: t, offset: r } = this.content.findIndex(e);
    if (r < e)
      return { node: this.content.child(t), index: t, offset: r };
    let o = this.content.child(t - 1);
    return { node: o, index: t - 1, offset: r - o.nodeSize };
  }
  /**
  Resolve the given position in the document, returning an
  [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
  */
  resolve(e) {
    return ds.resolveCached(this, e);
  }
  /**
  @internal
  */
  resolveNoCache(e) {
    return ds.resolve(this, e);
  }
  /**
  Test whether a given mark or mark type occurs in this document
  between the two given positions.
  */
  rangeHasMark(e, t, r) {
    let o = !1;
    return t > e && this.nodesBetween(e, t, (u) => (r.isInSet(u.marks) && (o = !0), !o)), o;
  }
  /**
  True when this is a block (non-inline node)
  */
  get isBlock() {
    return this.type.isBlock;
  }
  /**
  True when this is a textblock node, a block node with inline
  content.
  */
  get isTextblock() {
    return this.type.isTextblock;
  }
  /**
  True when this node allows inline content.
  */
  get inlineContent() {
    return this.type.inlineContent;
  }
  /**
  True when this is an inline node (a text node or a node that can
  appear among text).
  */
  get isInline() {
    return this.type.isInline;
  }
  /**
  True when this is a text node.
  */
  get isText() {
    return this.type.isText;
  }
  /**
  True when this is a leaf node.
  */
  get isLeaf() {
    return this.type.isLeaf;
  }
  /**
  True when this is an atom, i.e. when it does not have directly
  editable content. This is usually the same as `isLeaf`, but can
  be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
  on a node's spec (typically used when the node is displayed as
  an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
  */
  get isAtom() {
    return this.type.isAtom;
  }
  /**
  Return a string representation of this node for debugging
  purposes.
  */
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let e = this.type.name;
    return this.content.size && (e += "(" + this.content.toStringInner() + ")"), uv(this.marks, e);
  }
  /**
  Get the content match in this node at the given index.
  */
  contentMatchAt(e) {
    let t = this.type.contentMatch.matchFragment(this.content, 0, e);
    if (!t)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return t;
  }
  /**
  Test whether replacing the range between `from` and `to` (by
  child index) with the given replacement fragment (which defaults
  to the empty fragment) would leave the node's content valid. You
  can optionally pass `start` and `end` indices into the
  replacement fragment.
  */
  canReplace(e, t, r = Tt.empty, o = 0, u = r.childCount) {
    let c = this.contentMatchAt(e).matchFragment(r, o, u), l = c && c.matchFragment(this.content, t);
    if (!l || !l.validEnd)
      return !1;
    for (let i = o; i < u; i++)
      if (!this.type.allowsMarks(r.child(i).marks))
        return !1;
    return !0;
  }
  /**
  Test whether replacing the range `from` to `to` (by index) with
  a node of the given type would leave the node's content valid.
  */
  canReplaceWith(e, t, r, o) {
    if (o && !this.type.allowsMarks(o))
      return !1;
    let u = this.contentMatchAt(e).matchType(r), c = u && u.matchFragment(this.content, t);
    return c ? c.validEnd : !1;
  }
  /**
  Test whether the given node's content could be appended to this
  node. If that node is empty, this will only return true if there
  is at least one node type that can appear in both nodes (to avoid
  merging completely incompatible nodes).
  */
  canAppend(e) {
    return e.content.size ? this.canReplace(this.childCount, this.childCount, e.content) : this.type.compatibleContent(e.type);
  }
  /**
  Check whether this node and its descendants conform to the
  schema, and raise error when they do not.
  */
  check() {
    this.type.checkContent(this.content);
    let e = hn.none;
    for (let t = 0; t < this.marks.length; t++)
      e = this.marks[t].addToSet(e);
    if (!hn.sameSet(e, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((t) => t.type.name)}`);
    this.content.forEach((t) => t.check());
  }
  /**
  Return a JSON-serializeable representation of this node.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let t in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return this.content.size && (e.content = this.content.toJSON()), this.marks.length && (e.marks = this.marks.map((t) => t.toJSON())), e;
  }
  /**
  Deserialize a node from its JSON representation.
  */
  static fromJSON(e, t) {
    if (!t)
      throw new RangeError("Invalid input for Node.fromJSON");
    let r = null;
    if (t.marks) {
      if (!Array.isArray(t.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      r = t.marks.map(e.markFromJSON);
    }
    if (t.type == "text") {
      if (typeof t.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return e.text(t.text, r);
    }
    let o = Tt.fromJSON(e, t.content);
    return e.nodeType(t.type).create(t.attrs, o, r);
  }
};
ua.prototype.text = void 0;
class bl extends ua {
  /**
  @internal
  */
  constructor(e, t, r, o) {
    if (super(e, t, null, o), !r)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = r;
  }
  toString() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : uv(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(e, t) {
    return this.text.slice(e, t);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(e) {
    return e == this.marks ? this : new bl(this.type, this.attrs, this.text, e);
  }
  withText(e) {
    return e == this.text ? this : new bl(this.type, this.attrs, e, this.marks);
  }
  cut(e = 0, t = this.text.length) {
    return e == 0 && t == this.text.length ? this : this.withText(this.text.slice(e, t));
  }
  eq(e) {
    return this.sameMarkup(e) && this.text == e.text;
  }
  toJSON() {
    let e = super.toJSON();
    return e.text = this.text, e;
  }
}
function uv(n, e) {
  for (let t = n.length - 1; t >= 0; t--)
    e = n[t].type.name + "(" + e + ")";
  return e;
}
class ga {
  /**
  @internal
  */
  constructor(e) {
    this.validEnd = e, this.next = [], this.wrapCache = [];
  }
  /**
  @internal
  */
  static parse(e, t) {
    let r = new GO(e, t);
    if (r.next == null)
      return ga.empty;
    let o = cv(r);
    r.next && r.err("Unexpected trailing text");
    let u = qO(ZO(o));
    return eP(u, r), u;
  }
  /**
  Match a node type, returning a match after that node if
  successful.
  */
  matchType(e) {
    for (let t = 0; t < this.next.length; t++)
      if (this.next[t].type == e)
        return this.next[t].next;
    return null;
  }
  /**
  Try to match a fragment. Returns the resulting match when
  successful.
  */
  matchFragment(e, t = 0, r = e.childCount) {
    let o = this;
    for (let u = t; o && u < r; u++)
      o = o.matchType(e.child(u).type);
    return o;
  }
  /**
  @internal
  */
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  /**
  Get the first matching node type at this match position that can
  be generated.
  */
  get defaultType() {
    for (let e = 0; e < this.next.length; e++) {
      let { type: t } = this.next[e];
      if (!(t.isText || t.hasRequiredAttrs()))
        return t;
    }
    return null;
  }
  /**
  @internal
  */
  compatible(e) {
    for (let t = 0; t < this.next.length; t++)
      for (let r = 0; r < e.next.length; r++)
        if (this.next[t].type == e.next[r].type)
          return !0;
    return !1;
  }
  /**
  Try to match the given fragment, and if that fails, see if it can
  be made to match by inserting nodes in front of it. When
  successful, return a fragment of inserted nodes (which may be
  empty if nothing had to be inserted). When `toEnd` is true, only
  return a fragment if the resulting match goes to the end of the
  content expression.
  */
  fillBefore(e, t = !1, r = 0) {
    let o = [this];
    function u(c, l) {
      let i = c.matchFragment(e, r);
      if (i && (!t || i.validEnd))
        return Tt.from(l.map((h) => h.createAndFill()));
      for (let h = 0; h < c.next.length; h++) {
        let { type: f, next: p } = c.next[h];
        if (!(f.isText || f.hasRequiredAttrs()) && o.indexOf(p) == -1) {
          o.push(p);
          let d = u(p, l.concat(f));
          if (d)
            return d;
        }
      }
      return null;
    }
    return u(this, []);
  }
  /**
  Find a set of wrapping node types that would allow a node of the
  given type to appear at this position. The result may be empty
  (when it fits directly) and will be null when no such wrapping
  exists.
  */
  findWrapping(e) {
    for (let r = 0; r < this.wrapCache.length; r += 2)
      if (this.wrapCache[r] == e)
        return this.wrapCache[r + 1];
    let t = this.computeWrapping(e);
    return this.wrapCache.push(e, t), t;
  }
  /**
  @internal
  */
  computeWrapping(e) {
    let t = /* @__PURE__ */ Object.create(null), r = [{ match: this, type: null, via: null }];
    for (; r.length; ) {
      let o = r.shift(), u = o.match;
      if (u.matchType(e)) {
        let c = [];
        for (let l = o; l.type; l = l.via)
          c.push(l.type);
        return c.reverse();
      }
      for (let c = 0; c < u.next.length; c++) {
        let { type: l, next: i } = u.next[c];
        !l.isLeaf && !l.hasRequiredAttrs() && !(l.name in t) && (!o.type || i.validEnd) && (r.push({ match: l.contentMatch, type: l, via: o }), t[l.name] = !0);
      }
    }
    return null;
  }
  /**
  The number of outgoing edges this node has in the finite
  automaton that describes the content expression.
  */
  get edgeCount() {
    return this.next.length;
  }
  /**
  Get the _n_​th outgoing edge from this node in the finite
  automaton that describes the content expression.
  */
  edge(e) {
    if (e >= this.next.length)
      throw new RangeError(`There's no ${e}th edge in this content match`);
    return this.next[e];
  }
  /**
  @internal
  */
  toString() {
    let e = [];
    function t(r) {
      e.push(r);
      for (let o = 0; o < r.next.length; o++)
        e.indexOf(r.next[o].next) == -1 && t(r.next[o].next);
    }
    return t(this), e.map((r, o) => {
      let u = o + (r.validEnd ? "*" : " ") + " ";
      for (let c = 0; c < r.next.length; c++)
        u += (c ? ", " : "") + r.next[c].type.name + "->" + e.indexOf(r.next[c].next);
      return u;
    }).join(`
`);
  }
}
ga.empty = new ga(!0);
class GO {
  constructor(e, t) {
    this.string = e, this.nodeTypes = t, this.inline = null, this.pos = 0, this.tokens = e.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(e) {
    return this.next == e && (this.pos++ || !0);
  }
  err(e) {
    throw new SyntaxError(e + " (in content expression '" + this.string + "')");
  }
}
function cv(n) {
  let e = [];
  do
    e.push(zO(n));
  while (n.eat("|"));
  return e.length == 1 ? e[0] : { type: "choice", exprs: e };
}
function zO(n) {
  let e = [];
  do
    e.push(YO(n));
  while (n.next && n.next != ")" && n.next != "|");
  return e.length == 1 ? e[0] : { type: "seq", exprs: e };
}
function YO(n) {
  let e = JO(n);
  for (; ; )
    if (n.eat("+"))
      e = { type: "plus", expr: e };
    else if (n.eat("*"))
      e = { type: "star", expr: e };
    else if (n.eat("?"))
      e = { type: "opt", expr: e };
    else if (n.eat("{"))
      e = XO(n, e);
    else
      break;
  return e;
}
function Jh(n) {
  /\D/.test(n.next) && n.err("Expected number, got '" + n.next + "'");
  let e = Number(n.next);
  return n.pos++, e;
}
function XO(n, e) {
  let t = Jh(n), r = t;
  return n.eat(",") && (n.next != "}" ? r = Jh(n) : r = -1), n.eat("}") || n.err("Unclosed braced range"), { type: "range", min: t, max: r, expr: e };
}
function QO(n, e) {
  let t = n.nodeTypes, r = t[e];
  if (r)
    return [r];
  let o = [];
  for (let u in t) {
    let c = t[u];
    c.groups.indexOf(e) > -1 && o.push(c);
  }
  return o.length == 0 && n.err("No node type or group '" + e + "' found"), o;
}
function JO(n) {
  if (n.eat("(")) {
    let e = cv(n);
    return n.eat(")") || n.err("Missing closing paren"), e;
  } else if (/\W/.test(n.next))
    n.err("Unexpected token '" + n.next + "'");
  else {
    let e = QO(n, n.next).map((t) => (n.inline == null ? n.inline = t.isInline : n.inline != t.isInline && n.err("Mixing inline and block content"), { type: "name", value: t }));
    return n.pos++, e.length == 1 ? e[0] : { type: "choice", exprs: e };
  }
}
function ZO(n) {
  let e = [[]];
  return o(u(n, 0), t()), e;
  function t() {
    return e.push([]) - 1;
  }
  function r(c, l, i) {
    let h = { term: i, to: l };
    return e[c].push(h), h;
  }
  function o(c, l) {
    c.forEach((i) => i.to = l);
  }
  function u(c, l) {
    if (c.type == "choice")
      return c.exprs.reduce((i, h) => i.concat(u(h, l)), []);
    if (c.type == "seq")
      for (let i = 0; ; i++) {
        let h = u(c.exprs[i], l);
        if (i == c.exprs.length - 1)
          return h;
        o(h, l = t());
      }
    else if (c.type == "star") {
      let i = t();
      return r(l, i), o(u(c.expr, i), i), [r(i)];
    } else if (c.type == "plus") {
      let i = t();
      return o(u(c.expr, l), i), o(u(c.expr, i), i), [r(i)];
    } else {
      if (c.type == "opt")
        return [r(l)].concat(u(c.expr, l));
      if (c.type == "range") {
        let i = l;
        for (let h = 0; h < c.min; h++) {
          let f = t();
          o(u(c.expr, i), f), i = f;
        }
        if (c.max == -1)
          o(u(c.expr, i), i);
        else
          for (let h = c.min; h < c.max; h++) {
            let f = t();
            r(i, f), o(u(c.expr, i), f), i = f;
          }
        return [r(i)];
      } else {
        if (c.type == "name")
          return [r(l, void 0, c.value)];
        throw new Error("Unknown expr type");
      }
    }
  }
}
function fv(n, e) {
  return e - n;
}
function Zh(n, e) {
  let t = [];
  return r(e), t.sort(fv);
  function r(o) {
    let u = n[o];
    if (u.length == 1 && !u[0].term)
      return r(u[0].to);
    t.push(o);
    for (let c = 0; c < u.length; c++) {
      let { term: l, to: i } = u[c];
      !l && t.indexOf(i) == -1 && r(i);
    }
  }
}
function qO(n) {
  let e = /* @__PURE__ */ Object.create(null);
  return t(Zh(n, 0));
  function t(r) {
    let o = [];
    r.forEach((c) => {
      n[c].forEach(({ term: l, to: i }) => {
        if (!l)
          return;
        let h;
        for (let f = 0; f < o.length; f++)
          o[f][0] == l && (h = o[f][1]);
        Zh(n, i).forEach((f) => {
          h || o.push([l, h = []]), h.indexOf(f) == -1 && h.push(f);
        });
      });
    });
    let u = e[r.join(",")] = new ga(r.indexOf(n.length - 1) > -1);
    for (let c = 0; c < o.length; c++) {
      let l = o[c][1].sort(fv);
      u.next.push({ type: o[c][0], next: e[l.join(",")] || t(l) });
    }
    return u;
  }
}
function eP(n, e) {
  for (let t = 0, r = [n]; t < r.length; t++) {
    let o = r[t], u = !o.validEnd, c = [];
    for (let l = 0; l < o.next.length; l++) {
      let { type: i, next: h } = o.next[l];
      c.push(i.name), u && !(i.isText || i.hasRequiredAttrs()) && (u = !1), r.indexOf(h) == -1 && r.push(h);
    }
    u && e.err("Only non-generatable nodes (" + c.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function dv(n) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let t in n) {
    let r = n[t];
    if (!r.hasDefault)
      return null;
    e[t] = r.default;
  }
  return e;
}
function hv(n, e) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let r in n) {
    let o = e && e[r];
    if (o === void 0) {
      let u = n[r];
      if (u.hasDefault)
        o = u.default;
      else
        throw new RangeError("No value supplied for attribute " + r);
    }
    t[r] = o;
  }
  return t;
}
function pv(n) {
  let e = /* @__PURE__ */ Object.create(null);
  if (n)
    for (let t in n)
      e[t] = new tP(n[t]);
  return e;
}
let qh = class mv {
  /**
  @internal
  */
  constructor(e, t, r) {
    this.name = e, this.schema = t, this.spec = r, this.markSet = null, this.groups = r.group ? r.group.split(" ") : [], this.attrs = pv(r.attrs), this.defaultAttrs = dv(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(r.inline || e == "text"), this.isText = e == "text";
  }
  /**
  True if this is an inline type.
  */
  get isInline() {
    return !this.isBlock;
  }
  /**
  True if this is a textblock type, a block that contains inline
  content.
  */
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  /**
  True for node types that allow no content.
  */
  get isLeaf() {
    return this.contentMatch == ga.empty;
  }
  /**
  True when this node is an atom, i.e. when it does not have
  directly editable content.
  */
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  /**
  The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
  */
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  /**
  Tells you whether this node type has any required attributes.
  */
  hasRequiredAttrs() {
    for (let e in this.attrs)
      if (this.attrs[e].isRequired)
        return !0;
    return !1;
  }
  /**
  Indicates whether this node allows some of the same content as
  the given node type.
  */
  compatibleContent(e) {
    return this == e || this.contentMatch.compatible(e.contentMatch);
  }
  /**
  @internal
  */
  computeAttrs(e) {
    return !e && this.defaultAttrs ? this.defaultAttrs : hv(this.attrs, e);
  }
  /**
  Create a `Node` of this type. The given attributes are
  checked and defaulted (you can pass `null` to use the type's
  defaults entirely, if no required attributes exist). `content`
  may be a `Fragment`, a node, an array of nodes, or
  `null`. Similarly `marks` may be `null` to default to the empty
  set of marks.
  */
  create(e = null, t, r) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new ua(this, this.computeAttrs(e), Tt.from(t), hn.setFrom(r));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
  against the node type's content restrictions, and throw an error
  if it doesn't match.
  */
  createChecked(e = null, t, r) {
    return t = Tt.from(t), this.checkContent(t), new ua(this, this.computeAttrs(e), t, hn.setFrom(r));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
  necessary to add nodes to the start or end of the given fragment
  to make it fit the node. If no fitting wrapping can be found,
  return null. Note that, due to the fact that required nodes can
  always be created, this will always succeed if you pass null or
  `Fragment.empty` as content.
  */
  createAndFill(e = null, t, r) {
    if (e = this.computeAttrs(e), t = Tt.from(t), t.size) {
      let c = this.contentMatch.fillBefore(t);
      if (!c)
        return null;
      t = c.append(t);
    }
    let o = this.contentMatch.matchFragment(t), u = o && o.fillBefore(Tt.empty, !0);
    return u ? new ua(this, e, t.append(u), hn.setFrom(r)) : null;
  }
  /**
  Returns true if the given fragment is valid content for this node
  type with the given attributes.
  */
  validContent(e) {
    let t = this.contentMatch.matchFragment(e);
    if (!t || !t.validEnd)
      return !1;
    for (let r = 0; r < e.childCount; r++)
      if (!this.allowsMarks(e.child(r).marks))
        return !1;
    return !0;
  }
  /**
  Throws a RangeError if the given fragment is not valid content for this
  node type.
  @internal
  */
  checkContent(e) {
    if (!this.validContent(e))
      throw new RangeError(`Invalid content for node ${this.name}: ${e.toString().slice(0, 50)}`);
  }
  /**
  Check whether the given mark type is allowed in this node.
  */
  allowsMarkType(e) {
    return this.markSet == null || this.markSet.indexOf(e) > -1;
  }
  /**
  Test whether the given set of marks are allowed in this node.
  */
  allowsMarks(e) {
    if (this.markSet == null)
      return !0;
    for (let t = 0; t < e.length; t++)
      if (!this.allowsMarkType(e[t].type))
        return !1;
    return !0;
  }
  /**
  Removes the marks that are not allowed in this node from the given set.
  */
  allowedMarks(e) {
    if (this.markSet == null)
      return e;
    let t;
    for (let r = 0; r < e.length; r++)
      this.allowsMarkType(e[r].type) ? t && t.push(e[r]) : t || (t = e.slice(0, r));
    return t ? t.length ? t : hn.none : e;
  }
  /**
  @internal
  */
  static compile(e, t) {
    let r = /* @__PURE__ */ Object.create(null);
    e.forEach((u, c) => r[u] = new mv(u, t, c));
    let o = t.spec.topNode || "doc";
    if (!r[o])
      throw new RangeError("Schema is missing its top node type ('" + o + "')");
    if (!r.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let u in r.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return r;
  }
};
class tP {
  constructor(e) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(e, "default"), this.default = e.default;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class Jl {
  /**
  @internal
  */
  constructor(e, t, r, o) {
    this.name = e, this.rank = t, this.schema = r, this.spec = o, this.attrs = pv(o.attrs), this.excluded = null;
    let u = dv(this.attrs);
    this.instance = u ? new hn(this, u) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(e = null) {
    return !e && this.instance ? this.instance : new hn(this, hv(this.attrs, e));
  }
  /**
  @internal
  */
  static compile(e, t) {
    let r = /* @__PURE__ */ Object.create(null), o = 0;
    return e.forEach((u, c) => r[u] = new Jl(u, o++, t, c)), r;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(e) {
    for (var t = 0; t < e.length; t++)
      e[t].type == this && (e = e.slice(0, t).concat(e.slice(t + 1)), t--);
    return e;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(e) {
    for (let t = 0; t < e.length; t++)
      if (e[t].type == this)
        return e[t];
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(e) {
    return this.excluded.indexOf(e) > -1;
  }
}
class nP {
  /**
  Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
  */
  constructor(e) {
    this.linebreakReplacement = null, this.cached = /* @__PURE__ */ Object.create(null);
    let t = this.spec = {};
    for (let o in e)
      t[o] = e[o];
    t.nodes = xn.from(e.nodes), t.marks = xn.from(e.marks || {}), this.nodes = qh.compile(this.spec.nodes, this), this.marks = Jl.compile(this.spec.marks, this);
    let r = /* @__PURE__ */ Object.create(null);
    for (let o in this.nodes) {
      if (o in this.marks)
        throw new RangeError(o + " can not be both a node and a mark");
      let u = this.nodes[o], c = u.spec.content || "", l = u.spec.marks;
      if (u.contentMatch = r[c] || (r[c] = ga.parse(c, this.nodes)), u.inlineContent = u.contentMatch.inlineContent, u.spec.linebreakReplacement) {
        if (this.linebreakReplacement)
          throw new RangeError("Multiple linebreak nodes defined");
        if (!u.isInline || !u.isLeaf)
          throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
        this.linebreakReplacement = u;
      }
      u.markSet = l == "_" ? null : l ? ep(this, l.split(" ")) : l == "" || !u.inlineContent ? [] : null;
    }
    for (let o in this.marks) {
      let u = this.marks[o], c = u.spec.excludes;
      u.excluded = c == null ? [u] : c == "" ? [] : ep(this, c.split(" "));
    }
    this.nodeFromJSON = this.nodeFromJSON.bind(this), this.markFromJSON = this.markFromJSON.bind(this), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  /**
  Create a node in this schema. The `type` may be a string or a
  `NodeType` instance. Attributes will be extended with defaults,
  `content` may be a `Fragment`, `null`, a `Node`, or an array of
  nodes.
  */
  node(e, t = null, r, o) {
    if (typeof e == "string")
      e = this.nodeType(e);
    else if (e instanceof qh) {
      if (e.schema != this)
        throw new RangeError("Node type from different schema used (" + e.name + ")");
    } else
      throw new RangeError("Invalid node type: " + e);
    return e.createChecked(t, r, o);
  }
  /**
  Create a text node in the schema. Empty text nodes are not
  allowed.
  */
  text(e, t) {
    let r = this.nodes.text;
    return new bl(r, r.defaultAttrs, e, hn.setFrom(t));
  }
  /**
  Create a mark with the given type and attributes.
  */
  mark(e, t) {
    return typeof e == "string" && (e = this.marks[e]), e.create(t);
  }
  /**
  Deserialize a node from its JSON representation. This method is
  bound.
  */
  nodeFromJSON(e) {
    return ua.fromJSON(this, e);
  }
  /**
  Deserialize a mark from its JSON representation. This method is
  bound.
  */
  markFromJSON(e) {
    return hn.fromJSON(this, e);
  }
  /**
  @internal
  */
  nodeType(e) {
    let t = this.nodes[e];
    if (!t)
      throw new RangeError("Unknown node type: " + e);
    return t;
  }
}
function ep(n, e) {
  let t = [];
  for (let r = 0; r < e.length; r++) {
    let o = e[r], u = n.marks[o], c = u;
    if (u)
      t.push(u);
    else
      for (let l in n.marks) {
        let i = n.marks[l];
        (o == "_" || i.spec.group && i.spec.group.split(" ").indexOf(o) > -1) && t.push(c = i);
      }
    if (!c)
      throw new SyntaxError("Unknown mark type: '" + e[r] + "'");
  }
  return t;
}
function rP(n) {
  return n.tag != null;
}
function iP(n) {
  return n.style != null;
}
let dd = class Yc {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(e, t) {
    this.schema = e, this.rules = t, this.tags = [], this.styles = [], t.forEach((r) => {
      rP(r) ? this.tags.push(r) : iP(r) && this.styles.push(r);
    }), this.normalizeLists = !this.tags.some((r) => {
      if (!/^(ul|ol)\b/.test(r.tag) || !r.node)
        return !1;
      let o = e.nodes[r.node];
      return o.contentMatch.matchType(o);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(e, t = {}) {
    let r = new np(this, t, !1);
    return r.addAll(e, t.from, t.to), r.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(e, t = {}) {
    let r = new np(this, t, !0);
    return r.addAll(e, t.from, t.to), Lt.maxOpen(r.finish());
  }
  /**
  @internal
  */
  matchTag(e, t, r) {
    for (let o = r ? this.tags.indexOf(r) + 1 : 0; o < this.tags.length; o++) {
      let u = this.tags[o];
      if (sP(e, u.tag) && (u.namespace === void 0 || e.namespaceURI == u.namespace) && (!u.context || t.matchesContext(u.context))) {
        if (u.getAttrs) {
          let c = u.getAttrs(e);
          if (c === !1)
            continue;
          u.attrs = c || void 0;
        }
        return u;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(e, t, r, o) {
    for (let u = o ? this.styles.indexOf(o) + 1 : 0; u < this.styles.length; u++) {
      let c = this.styles[u], l = c.style;
      if (!(l.indexOf(e) != 0 || c.context && !r.matchesContext(c.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      l.length > e.length && (l.charCodeAt(e.length) != 61 || l.slice(e.length + 1) != t))) {
        if (c.getAttrs) {
          let i = c.getAttrs(t);
          if (i === !1)
            continue;
          c.attrs = i || void 0;
        }
        return c;
      }
    }
  }
  /**
  @internal
  */
  static schemaRules(e) {
    let t = [];
    function r(o) {
      let u = o.priority == null ? 50 : o.priority, c = 0;
      for (; c < t.length; c++) {
        let l = t[c];
        if ((l.priority == null ? 50 : l.priority) < u)
          break;
      }
      t.splice(c, 0, o);
    }
    for (let o in e.marks) {
      let u = e.marks[o].spec.parseDOM;
      u && u.forEach((c) => {
        r(c = rp(c)), c.mark || c.ignore || c.clearMark || (c.mark = o);
      });
    }
    for (let o in e.nodes) {
      let u = e.nodes[o].spec.parseDOM;
      u && u.forEach((c) => {
        r(c = rp(c)), c.node || c.ignore || c.mark || (c.node = o);
      });
    }
    return t;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
  */
  static fromSchema(e) {
    return e.cached.domParser || (e.cached.domParser = new Yc(e, Yc.schemaRules(e)));
  }
};
const gv = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, aP = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, vv = { ol: !0, ul: !0 }, Rl = 1, Dl = 2, Xo = 4;
function tp(n, e, t) {
  return e != null ? (e ? Rl : 0) | (e === "full" ? Dl : 0) : n && n.whitespace == "pre" ? Rl | Dl : t & ~Xo;
}
class qs {
  constructor(e, t, r, o, u, c, l) {
    this.type = e, this.attrs = t, this.marks = r, this.pendingMarks = o, this.solid = u, this.options = l, this.content = [], this.activeMarks = hn.none, this.stashMarks = [], this.match = c || (l & Xo ? null : e.contentMatch);
  }
  findWrapping(e) {
    if (!this.match) {
      if (!this.type)
        return [];
      let t = this.type.contentMatch.fillBefore(Tt.from(e));
      if (t)
        this.match = this.type.contentMatch.matchFragment(t);
      else {
        let r = this.type.contentMatch, o;
        return (o = r.findWrapping(e.type)) ? (this.match = r, o) : null;
      }
    }
    return this.match.findWrapping(e.type);
  }
  finish(e) {
    if (!(this.options & Rl)) {
      let r = this.content[this.content.length - 1], o;
      if (r && r.isText && (o = /[ \t\r\n\u000c]+$/.exec(r.text))) {
        let u = r;
        r.text.length == o[0].length ? this.content.pop() : this.content[this.content.length - 1] = u.withText(u.text.slice(0, u.text.length - o[0].length));
      }
    }
    let t = Tt.from(this.content);
    return !e && this.match && (t = t.append(this.match.fillBefore(Tt.empty, !0))), this.type ? this.type.create(this.attrs, t, this.marks) : t;
  }
  popFromStashMark(e) {
    for (let t = this.stashMarks.length - 1; t >= 0; t--)
      if (e.eq(this.stashMarks[t]))
        return this.stashMarks.splice(t, 1)[0];
  }
  applyPending(e) {
    for (let t = 0, r = this.pendingMarks; t < r.length; t++) {
      let o = r[t];
      (this.type ? this.type.allowsMarkType(o.type) : uP(o.type, e)) && !o.isInSet(this.activeMarks) && (this.activeMarks = o.addToSet(this.activeMarks), this.pendingMarks = o.removeFromSet(this.pendingMarks));
    }
  }
  inlineContext(e) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : e.parentNode && !gv.hasOwnProperty(e.parentNode.nodeName.toLowerCase());
  }
}
class np {
  constructor(e, t, r) {
    this.parser = e, this.options = t, this.isOpen = r, this.open = 0;
    let o = t.topNode, u, c = tp(null, t.preserveWhitespace, 0) | (r ? Xo : 0);
    o ? u = new qs(o.type, o.attrs, hn.none, hn.none, !0, t.topMatch || o.type.contentMatch, c) : r ? u = new qs(null, null, hn.none, hn.none, !0, null, c) : u = new qs(e.schema.topNodeType, null, hn.none, hn.none, !0, null, c), this.nodes = [u], this.find = t.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(e) {
    e.nodeType == 3 ? this.addTextNode(e) : e.nodeType == 1 && this.addElement(e);
  }
  withStyleRules(e, t) {
    let r = e.getAttribute("style");
    if (!r)
      return t();
    let o = this.readStyles(lP(r));
    if (!o)
      return;
    let [u, c] = o, l = this.top;
    for (let i = 0; i < c.length; i++)
      this.removePendingMark(c[i], l);
    for (let i = 0; i < u.length; i++)
      this.addPendingMark(u[i]);
    t();
    for (let i = 0; i < u.length; i++)
      this.removePendingMark(u[i], l);
    for (let i = 0; i < c.length; i++)
      this.addPendingMark(c[i]);
  }
  addTextNode(e) {
    let t = e.nodeValue, r = this.top;
    if (r.options & Dl || r.inlineContext(e) || /[^ \t\r\n\u000c]/.test(t)) {
      if (r.options & Rl)
        r.options & Dl ? t = t.replace(/\r\n?/g, `
`) : t = t.replace(/\r?\n|\r/g, " ");
      else if (t = t.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(t) && this.open == this.nodes.length - 1) {
        let o = r.content[r.content.length - 1], u = e.previousSibling;
        (!o || u && u.nodeName == "BR" || o.isText && /[ \t\r\n\u000c]$/.test(o.text)) && (t = t.slice(1));
      }
      t && this.insertNode(this.parser.schema.text(t)), this.findInText(e);
    } else
      this.findInside(e);
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(e, t) {
    let r = e.nodeName.toLowerCase(), o;
    vv.hasOwnProperty(r) && this.parser.normalizeLists && oP(e);
    let u = this.options.ruleFromNode && this.options.ruleFromNode(e) || (o = this.parser.matchTag(e, this, t));
    if (u ? u.ignore : aP.hasOwnProperty(r))
      this.findInside(e), this.ignoreFallback(e);
    else if (!u || u.skip || u.closeParent) {
      u && u.closeParent ? this.open = Math.max(0, this.open - 1) : u && u.skip.nodeType && (e = u.skip);
      let c, l = this.top, i = this.needsBlock;
      if (gv.hasOwnProperty(r))
        l.content.length && l.content[0].isInline && this.open && (this.open--, l = this.top), c = !0, l.type || (this.needsBlock = !0);
      else if (!e.firstChild) {
        this.leafFallback(e);
        return;
      }
      u && u.skip ? this.addAll(e) : this.withStyleRules(e, () => this.addAll(e)), c && this.sync(l), this.needsBlock = i;
    } else
      this.withStyleRules(e, () => {
        this.addElementByRule(e, u, u.consuming === !1 ? o : void 0);
      });
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(e) {
    e.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(e.ownerDocument.createTextNode(`
`));
  }
  // Called for ignored nodes
  ignoreFallback(e) {
    e.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"));
  }
  // Run any style parser associated with the node's styles. Either
  // return an array of marks, or null to indicate some of the styles
  // had a rule with `ignore` set.
  readStyles(e) {
    let t = hn.none, r = hn.none;
    for (let o = 0; o < e.length; o += 2)
      for (let u = void 0; ; ) {
        let c = this.parser.matchStyle(e[o], e[o + 1], this, u);
        if (!c)
          break;
        if (c.ignore)
          return null;
        if (c.clearMark ? this.top.pendingMarks.concat(this.top.activeMarks).forEach((l) => {
          c.clearMark(l) && (r = l.addToSet(r));
        }) : t = this.parser.schema.marks[c.mark].create(c.attrs).addToSet(t), c.consuming === !1)
          u = c;
        else
          break;
      }
    return [t, r];
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(e, t, r) {
    let o, u, c;
    t.node ? (u = this.parser.schema.nodes[t.node], u.isLeaf ? this.insertNode(u.create(t.attrs)) || this.leafFallback(e) : o = this.enter(u, t.attrs || null, t.preserveWhitespace)) : (c = this.parser.schema.marks[t.mark].create(t.attrs), this.addPendingMark(c));
    let l = this.top;
    if (u && u.isLeaf)
      this.findInside(e);
    else if (r)
      this.addElement(e, r);
    else if (t.getContent)
      this.findInside(e), t.getContent(e, this.parser.schema).forEach((i) => this.insertNode(i));
    else {
      let i = e;
      typeof t.contentElement == "string" ? i = e.querySelector(t.contentElement) : typeof t.contentElement == "function" ? i = t.contentElement(e) : t.contentElement && (i = t.contentElement), this.findAround(e, i, !0), this.addAll(i);
    }
    o && this.sync(l) && this.open--, c && this.removePendingMark(c, l);
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(e, t, r) {
    let o = t || 0;
    for (let u = t ? e.childNodes[t] : e.firstChild, c = r == null ? null : e.childNodes[r]; u != c; u = u.nextSibling, ++o)
      this.findAtPoint(e, o), this.addDOM(u);
    this.findAtPoint(e, o);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(e) {
    let t, r;
    for (let o = this.open; o >= 0; o--) {
      let u = this.nodes[o], c = u.findWrapping(e);
      if (c && (!t || t.length > c.length) && (t = c, r = u, !c.length) || u.solid)
        break;
    }
    if (!t)
      return !1;
    this.sync(r);
    for (let o = 0; o < t.length; o++)
      this.enterInner(t[o], null, !1);
    return !0;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(e) {
    if (e.isInline && this.needsBlock && !this.top.type) {
      let t = this.textblockFromContext();
      t && this.enterInner(t);
    }
    if (this.findPlace(e)) {
      this.closeExtra();
      let t = this.top;
      t.applyPending(e.type), t.match && (t.match = t.match.matchType(e.type));
      let r = t.activeMarks;
      for (let o = 0; o < e.marks.length; o++)
        (!t.type || t.type.allowsMarkType(e.marks[o].type)) && (r = e.marks[o].addToSet(r));
      return t.content.push(e.mark(r)), !0;
    }
    return !1;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(e, t, r) {
    let o = this.findPlace(e.create(t));
    return o && this.enterInner(e, t, !0, r), o;
  }
  // Open a node of the given type
  enterInner(e, t = null, r = !1, o) {
    this.closeExtra();
    let u = this.top;
    u.applyPending(e), u.match = u.match && u.match.matchType(e);
    let c = tp(e, o, u.options);
    u.options & Xo && u.content.length == 0 && (c |= Xo), this.nodes.push(new qs(e, t, u.activeMarks, u.pendingMarks, r, null, c)), this.open++;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(e = !1) {
    let t = this.nodes.length - 1;
    if (t > this.open) {
      for (; t > this.open; t--)
        this.nodes[t - 1].content.push(this.nodes[t].finish(e));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(this.isOpen || this.options.topOpen);
  }
  sync(e) {
    for (let t = this.open; t >= 0; t--)
      if (this.nodes[t] == e)
        return this.open = t, !0;
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let e = 0;
    for (let t = this.open; t >= 0; t--) {
      let r = this.nodes[t].content;
      for (let o = r.length - 1; o >= 0; o--)
        e += r[o].nodeSize;
      t && e++;
    }
    return e;
  }
  findAtPoint(e, t) {
    if (this.find)
      for (let r = 0; r < this.find.length; r++)
        this.find[r].node == e && this.find[r].offset == t && (this.find[r].pos = this.currentPos);
  }
  findInside(e) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].pos == null && e.nodeType == 1 && e.contains(this.find[t].node) && (this.find[t].pos = this.currentPos);
  }
  findAround(e, t, r) {
    if (e != t && this.find)
      for (let o = 0; o < this.find.length; o++)
        this.find[o].pos == null && e.nodeType == 1 && e.contains(this.find[o].node) && t.compareDocumentPosition(this.find[o].node) & (r ? 2 : 4) && (this.find[o].pos = this.currentPos);
  }
  findInText(e) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].node == e && (this.find[t].pos = this.currentPos - (e.nodeValue.length - this.find[t].offset));
  }
  // Determines whether the given context string matches this context.
  matchesContext(e) {
    if (e.indexOf("|") > -1)
      return e.split(/\s*\|\s*/).some(this.matchesContext, this);
    let t = e.split("/"), r = this.options.context, o = !this.isOpen && (!r || r.parent.type == this.nodes[0].type), u = -(r ? r.depth + 1 : 0) + (o ? 0 : 1), c = (l, i) => {
      for (; l >= 0; l--) {
        let h = t[l];
        if (h == "") {
          if (l == t.length - 1 || l == 0)
            continue;
          for (; i >= u; i--)
            if (c(l - 1, i))
              return !0;
          return !1;
        } else {
          let f = i > 0 || i == 0 && o ? this.nodes[i].type : r && i >= u ? r.node(i - u).type : null;
          if (!f || f.name != h && f.groups.indexOf(h) == -1)
            return !1;
          i--;
        }
      }
      return !0;
    };
    return c(t.length - 1, this.open);
  }
  textblockFromContext() {
    let e = this.options.context;
    if (e)
      for (let t = e.depth; t >= 0; t--) {
        let r = e.node(t).contentMatchAt(e.indexAfter(t)).defaultType;
        if (r && r.isTextblock && r.defaultAttrs)
          return r;
      }
    for (let t in this.parser.schema.nodes) {
      let r = this.parser.schema.nodes[t];
      if (r.isTextblock && r.defaultAttrs)
        return r;
    }
  }
  addPendingMark(e) {
    let t = cP(e, this.top.pendingMarks);
    t && this.top.stashMarks.push(t), this.top.pendingMarks = e.addToSet(this.top.pendingMarks);
  }
  removePendingMark(e, t) {
    for (let r = this.open; r >= 0; r--) {
      let o = this.nodes[r];
      if (o.pendingMarks.lastIndexOf(e) > -1)
        o.pendingMarks = e.removeFromSet(o.pendingMarks);
      else {
        o.activeMarks = e.removeFromSet(o.activeMarks);
        let c = o.popFromStashMark(e);
        c && o.type && o.type.allowsMarkType(c.type) && (o.activeMarks = c.addToSet(o.activeMarks));
      }
      if (o == t)
        break;
    }
  }
}
function oP(n) {
  for (let e = n.firstChild, t = null; e; e = e.nextSibling) {
    let r = e.nodeType == 1 ? e.nodeName.toLowerCase() : null;
    r && vv.hasOwnProperty(r) && t ? (t.appendChild(e), e = t) : r == "li" ? t = e : r && (t = null);
  }
}
function sP(n, e) {
  return (n.matches || n.msMatchesSelector || n.webkitMatchesSelector || n.mozMatchesSelector).call(n, e);
}
function lP(n) {
  let e = /\s*([\w-]+)\s*:\s*([^;]+)/g, t, r = [];
  for (; t = e.exec(n); )
    r.push(t[1], t[2].trim());
  return r;
}
function rp(n) {
  let e = {};
  for (let t in n)
    e[t] = n[t];
  return e;
}
function uP(n, e) {
  let t = e.schema.nodes;
  for (let r in t) {
    let o = t[r];
    if (!o.allowsMarkType(n))
      continue;
    let u = [], c = (l) => {
      u.push(l);
      for (let i = 0; i < l.edgeCount; i++) {
        let { type: h, next: f } = l.edge(i);
        if (h == e || u.indexOf(f) < 0 && c(f))
          return !0;
      }
    };
    if (c(o.contentMatch))
      return !0;
  }
}
function cP(n, e) {
  for (let t = 0; t < e.length; t++)
    if (n.eq(e[t]))
      return e[t];
}
class Ur {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(e, t) {
    this.nodes = e, this.marks = t;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(e, t = {}, r) {
    r || (r = Zu(t).createDocumentFragment());
    let o = r, u = [];
    return e.forEach((c) => {
      if (u.length || c.marks.length) {
        let l = 0, i = 0;
        for (; l < u.length && i < c.marks.length; ) {
          let h = c.marks[i];
          if (!this.marks[h.type.name]) {
            i++;
            continue;
          }
          if (!h.eq(u[l][0]) || h.type.spec.spanning === !1)
            break;
          l++, i++;
        }
        for (; l < u.length; )
          o = u.pop()[1];
        for (; i < c.marks.length; ) {
          let h = c.marks[i++], f = this.serializeMark(h, c.isInline, t);
          f && (u.push([h, o]), o.appendChild(f.dom), o = f.contentDOM || f.dom);
        }
      }
      o.appendChild(this.serializeNodeInner(c, t));
    }), r;
  }
  /**
  @internal
  */
  serializeNodeInner(e, t) {
    let { dom: r, contentDOM: o } = Ur.renderSpec(Zu(t), this.nodes[e.type.name](e));
    if (o) {
      if (e.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(e.content, t, o);
    }
    return r;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(e, t = {}) {
    let r = this.serializeNodeInner(e, t);
    for (let o = e.marks.length - 1; o >= 0; o--) {
      let u = this.serializeMark(e.marks[o], e.isInline, t);
      u && ((u.contentDOM || u.dom).appendChild(r), r = u.dom);
    }
    return r;
  }
  /**
  @internal
  */
  serializeMark(e, t, r = {}) {
    let o = this.marks[e.type.name];
    return o && Ur.renderSpec(Zu(r), o(e, t));
  }
  /**
  Render an [output spec](https://prosemirror.net/docs/ref/#model.DOMOutputSpec) to a DOM node. If
  the spec has a hole (zero) in it, `contentDOM` will point at the
  node with the hole.
  */
  static renderSpec(e, t, r = null) {
    if (typeof t == "string")
      return { dom: e.createTextNode(t) };
    if (t.nodeType != null)
      return { dom: t };
    if (t.dom && t.dom.nodeType != null)
      return t;
    let o = t[0], u = o.indexOf(" ");
    u > 0 && (r = o.slice(0, u), o = o.slice(u + 1));
    let c, l = r ? e.createElementNS(r, o) : e.createElement(o), i = t[1], h = 1;
    if (i && typeof i == "object" && i.nodeType == null && !Array.isArray(i)) {
      h = 2;
      for (let f in i)
        if (i[f] != null) {
          let p = f.indexOf(" ");
          p > 0 ? l.setAttributeNS(f.slice(0, p), f.slice(p + 1), i[f]) : l.setAttribute(f, i[f]);
        }
    }
    for (let f = h; f < t.length; f++) {
      let p = t[f];
      if (p === 0) {
        if (f < t.length - 1 || f > h)
          throw new RangeError("Content hole must be the only child of its parent node");
        return { dom: l, contentDOM: l };
      } else {
        let { dom: d, contentDOM: v } = Ur.renderSpec(e, p, r);
        if (l.appendChild(d), v) {
          if (c)
            throw new RangeError("Multiple content holes");
          c = v;
        }
      }
    }
    return { dom: l, contentDOM: c };
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(e) {
    return e.cached.domSerializer || (e.cached.domSerializer = new Ur(this.nodesFromSchema(e), this.marksFromSchema(e)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(e) {
    let t = ip(e.nodes);
    return t.text || (t.text = (r) => r.text), t;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(e) {
    return ip(e.marks);
  }
}
function ip(n) {
  let e = {};
  for (let t in n) {
    let r = n[t].spec.toDOM;
    r && (e[t] = r);
  }
  return e;
}
function Zu(n) {
  return n.document || window.document;
}
const _v = 65535, Ev = Math.pow(2, 16);
function fP(n, e) {
  return n + e * Ev;
}
function ap(n) {
  return n & _v;
}
function dP(n) {
  return (n - (n & _v)) / Ev;
}
const yv = 1, Tv = 2, al = 4, Av = 8;
class Xc {
  /**
  @internal
  */
  constructor(e, t, r) {
    this.pos = e, this.delInfo = t, this.recover = r;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & Av) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (yv | al)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (Tv | al)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & al) > 0;
  }
}
class ar {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(e, t = !1) {
    if (this.ranges = e, this.inverted = t, !e.length && ar.empty)
      return ar.empty;
  }
  /**
  @internal
  */
  recover(e) {
    let t = 0, r = ap(e);
    if (!this.inverted)
      for (let o = 0; o < r; o++)
        t += this.ranges[o * 3 + 2] - this.ranges[o * 3 + 1];
    return this.ranges[r * 3] + t + dP(e);
  }
  mapResult(e, t = 1) {
    return this._map(e, t, !1);
  }
  map(e, t = 1) {
    return this._map(e, t, !0);
  }
  /**
  @internal
  */
  _map(e, t, r) {
    let o = 0, u = this.inverted ? 2 : 1, c = this.inverted ? 1 : 2;
    for (let l = 0; l < this.ranges.length; l += 3) {
      let i = this.ranges[l] - (this.inverted ? o : 0);
      if (i > e)
        break;
      let h = this.ranges[l + u], f = this.ranges[l + c], p = i + h;
      if (e <= p) {
        let d = h ? e == i ? -1 : e == p ? 1 : t : t, v = i + o + (d < 0 ? 0 : f);
        if (r)
          return v;
        let g = e == (t < 0 ? i : p) ? null : fP(l / 3, e - i), m = e == i ? Tv : e == p ? yv : al;
        return (t < 0 ? e != i : e != p) && (m |= Av), new Xc(v, m, g);
      }
      o += f - h;
    }
    return r ? e + o : new Xc(e + o, 0, null);
  }
  /**
  @internal
  */
  touches(e, t) {
    let r = 0, o = ap(t), u = this.inverted ? 2 : 1, c = this.inverted ? 1 : 2;
    for (let l = 0; l < this.ranges.length; l += 3) {
      let i = this.ranges[l] - (this.inverted ? r : 0);
      if (i > e)
        break;
      let h = this.ranges[l + u], f = i + h;
      if (e <= f && l == o * 3)
        return !0;
      r += this.ranges[l + c] - h;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(e) {
    let t = this.inverted ? 2 : 1, r = this.inverted ? 1 : 2;
    for (let o = 0, u = 0; o < this.ranges.length; o += 3) {
      let c = this.ranges[o], l = c - (this.inverted ? u : 0), i = c + (this.inverted ? 0 : u), h = this.ranges[o + t], f = this.ranges[o + r];
      e(l, l + h, i, i + f), u += f - h;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new ar(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(e) {
    return e == 0 ? ar.empty : new ar(e < 0 ? [0, -e, 0] : [0, 0, e]);
  }
}
ar.empty = new ar([]);
class Ga {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(e = [], t, r = 0, o = e.length) {
    this.maps = e, this.mirror = t, this.from = r, this.to = o;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(e = 0, t = this.maps.length) {
    return new Ga(this.maps, this.mirror, e, t);
  }
  /**
  @internal
  */
  copy() {
    return new Ga(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(e, t) {
    this.to = this.maps.push(e), t != null && this.setMirror(this.maps.length - 1, t);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(e) {
    for (let t = 0, r = this.maps.length; t < e.maps.length; t++) {
      let o = e.getMirror(t);
      this.appendMap(e.maps[t], o != null && o < t ? r + o : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(e) {
    if (this.mirror) {
      for (let t = 0; t < this.mirror.length; t++)
        if (this.mirror[t] == e)
          return this.mirror[t + (t % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(e, t) {
    this.mirror || (this.mirror = []), this.mirror.push(e, t);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(e) {
    for (let t = e.maps.length - 1, r = this.maps.length + e.maps.length; t >= 0; t--) {
      let o = e.getMirror(t);
      this.appendMap(e.maps[t].invert(), o != null && o > t ? r - o - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let e = new Ga();
    return e.appendMappingInverted(this), e;
  }
  /**
  Map a position through this mapping.
  */
  map(e, t = 1) {
    if (this.mirror)
      return this._map(e, t, !0);
    for (let r = this.from; r < this.to; r++)
      e = this.maps[r].map(e, t);
    return e;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(e, t = 1) {
    return this._map(e, t, !1);
  }
  /**
  @internal
  */
  _map(e, t, r) {
    let o = 0;
    for (let u = this.from; u < this.to; u++) {
      let c = this.maps[u], l = c.mapResult(e, t);
      if (l.recover != null) {
        let i = this.getMirror(u);
        if (i != null && i > u && i < this.to) {
          u = i, e = this.maps[i].recover(l.recover);
          continue;
        }
      }
      o |= l.delInfo, e = l.pos;
    }
    return r ? e : new Xc(e, o, null);
  }
}
const qu = /* @__PURE__ */ Object.create(null);
class Hn {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return ar.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(e) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(e, t) {
    if (!t || !t.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let r = qu[t.stepType];
    if (!r)
      throw new RangeError(`No step type ${t.stepType} defined`);
    return r.fromJSON(e, t);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(e, t) {
    if (e in qu)
      throw new RangeError("Duplicate use of step JSON ID " + e);
    return qu[e] = t, t.prototype.jsonID = e, t;
  }
}
class Sn {
  /**
  @internal
  */
  constructor(e, t) {
    this.doc = e, this.failed = t;
  }
  /**
  Create a successful step result.
  */
  static ok(e) {
    return new Sn(e, null);
  }
  /**
  Create a failed step result.
  */
  static fail(e) {
    return new Sn(null, e);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(e, t, r, o) {
    try {
      return Sn.ok(e.replace(t, r, o));
    } catch (u) {
      if (u instanceof Sl)
        return Sn.fail(u.message);
      throw u;
    }
  }
}
function hd(n, e, t) {
  let r = [];
  for (let o = 0; o < n.childCount; o++) {
    let u = n.child(o);
    u.content.size && (u = u.copy(hd(u.content, e, u))), u.isInline && (u = e(u, t, o)), r.push(u);
  }
  return Tt.fromArray(r);
}
class Ci extends Hn {
  /**
  Create a mark step.
  */
  constructor(e, t, r) {
    super(), this.from = e, this.to = t, this.mark = r;
  }
  apply(e) {
    let t = e.slice(this.from, this.to), r = e.resolve(this.from), o = r.node(r.sharedDepth(this.to)), u = new Lt(hd(t.content, (c, l) => !c.isAtom || !l.type.allowsMarkType(this.mark.type) ? c : c.mark(this.mark.addToSet(c.marks)), o), t.openStart, t.openEnd);
    return Sn.fromReplace(e, this.from, this.to, u);
  }
  invert() {
    return new kr(this.from, this.to, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return t.deleted && r.deleted || t.pos >= r.pos ? null : new Ci(t.pos, r.pos, this.mark);
  }
  merge(e) {
    return e instanceof Ci && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new Ci(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new Ci(t.from, t.to, e.markFromJSON(t.mark));
  }
}
Hn.jsonID("addMark", Ci);
class kr extends Hn {
  /**
  Create a mark-removing step.
  */
  constructor(e, t, r) {
    super(), this.from = e, this.to = t, this.mark = r;
  }
  apply(e) {
    let t = e.slice(this.from, this.to), r = new Lt(hd(t.content, (o) => o.mark(this.mark.removeFromSet(o.marks)), e), t.openStart, t.openEnd);
    return Sn.fromReplace(e, this.from, this.to, r);
  }
  invert() {
    return new Ci(this.from, this.to, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return t.deleted && r.deleted || t.pos >= r.pos ? null : new kr(t.pos, r.pos, this.mark);
  }
  merge(e) {
    return e instanceof kr && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new kr(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new kr(t.from, t.to, e.markFromJSON(t.mark));
  }
}
Hn.jsonID("removeMark", kr);
class Mi extends Hn {
  /**
  Create a node mark step.
  */
  constructor(e, t) {
    super(), this.pos = e, this.mark = t;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return Sn.fail("No node at mark step's position");
    let r = t.type.create(t.attrs, null, this.mark.addToSet(t.marks));
    return Sn.fromReplace(e, this.pos, this.pos + 1, new Lt(Tt.from(r), 0, t.isLeaf ? 0 : 1));
  }
  invert(e) {
    let t = e.nodeAt(this.pos);
    if (t) {
      let r = this.mark.addToSet(t.marks);
      if (r.length == t.marks.length) {
        for (let o = 0; o < t.marks.length; o++)
          if (!t.marks[o].isInSet(r))
            return new Mi(this.pos, t.marks[o]);
        return new Mi(this.pos, this.mark);
      }
    }
    return new so(this.pos, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new Mi(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new Mi(t.pos, e.markFromJSON(t.mark));
  }
}
Hn.jsonID("addNodeMark", Mi);
class so extends Hn {
  /**
  Create a mark-removing step.
  */
  constructor(e, t) {
    super(), this.pos = e, this.mark = t;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return Sn.fail("No node at mark step's position");
    let r = t.type.create(t.attrs, null, this.mark.removeFromSet(t.marks));
    return Sn.fromReplace(e, this.pos, this.pos + 1, new Lt(Tt.from(r), 0, t.isLeaf ? 0 : 1));
  }
  invert(e) {
    let t = e.nodeAt(this.pos);
    return !t || !this.mark.isInSet(t.marks) ? this : new Mi(this.pos, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new so(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new so(t.pos, e.markFromJSON(t.mark));
  }
}
Hn.jsonID("removeNodeMark", so);
class Pn extends Hn {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(e, t, r, o = !1) {
    super(), this.from = e, this.to = t, this.slice = r, this.structure = o;
  }
  apply(e) {
    return this.structure && Qc(e, this.from, this.to) ? Sn.fail("Structure replace would overwrite content") : Sn.fromReplace(e, this.from, this.to, this.slice);
  }
  getMap() {
    return new ar([this.from, this.to - this.from, this.slice.size]);
  }
  invert(e) {
    return new Pn(this.from, this.from + this.slice.size, e.slice(this.from, this.to));
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return t.deletedAcross && r.deletedAcross ? null : new Pn(t.pos, Math.max(t.pos, r.pos), this.slice);
  }
  merge(e) {
    if (!(e instanceof Pn) || e.structure || this.structure)
      return null;
    if (this.from + this.slice.size == e.from && !this.slice.openEnd && !e.slice.openStart) {
      let t = this.slice.size + e.slice.size == 0 ? Lt.empty : new Lt(this.slice.content.append(e.slice.content), this.slice.openStart, e.slice.openEnd);
      return new Pn(this.from, this.to + (e.to - e.from), t, this.structure);
    } else if (e.to == this.from && !this.slice.openStart && !e.slice.openEnd) {
      let t = this.slice.size + e.slice.size == 0 ? Lt.empty : new Lt(e.slice.content.append(this.slice.content), e.slice.openStart, this.slice.openEnd);
      return new Pn(e.from, this.to, t, this.structure);
    } else
      return null;
  }
  toJSON() {
    let e = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new Pn(t.from, t.to, Lt.fromJSON(e, t.slice), !!t.structure);
  }
}
Hn.jsonID("replace", Pn);
class In extends Hn {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(e, t, r, o, u, c, l = !1) {
    super(), this.from = e, this.to = t, this.gapFrom = r, this.gapTo = o, this.slice = u, this.insert = c, this.structure = l;
  }
  apply(e) {
    if (this.structure && (Qc(e, this.from, this.gapFrom) || Qc(e, this.gapTo, this.to)))
      return Sn.fail("Structure gap-replace would overwrite content");
    let t = e.slice(this.gapFrom, this.gapTo);
    if (t.openStart || t.openEnd)
      return Sn.fail("Gap is not a flat range");
    let r = this.slice.insertAt(this.insert, t.content);
    return r ? Sn.fromReplace(e, this.from, this.to, r) : Sn.fail("Content does not fit in gap");
  }
  getMap() {
    return new ar([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(e) {
    let t = this.gapTo - this.gapFrom;
    return new In(this.from, this.from + this.slice.size + t, this.from + this.insert, this.from + this.insert + t, e.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1), o = this.from == this.gapFrom ? t.pos : e.map(this.gapFrom, -1), u = this.to == this.gapTo ? r.pos : e.map(this.gapTo, 1);
    return t.deletedAcross && r.deletedAcross || o < t.pos || u > r.pos ? null : new In(t.pos, r.pos, o, u, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let e = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number" || typeof t.gapFrom != "number" || typeof t.gapTo != "number" || typeof t.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new In(t.from, t.to, t.gapFrom, t.gapTo, Lt.fromJSON(e, t.slice), t.insert, !!t.structure);
  }
}
Hn.jsonID("replaceAround", In);
function Qc(n, e, t) {
  let r = n.resolve(e), o = t - e, u = r.depth;
  for (; o > 0 && u > 0 && r.indexAfter(u) == r.node(u).childCount; )
    u--, o--;
  if (o > 0) {
    let c = r.node(u).maybeChild(r.indexAfter(u));
    for (; o > 0; ) {
      if (!c || c.isLeaf)
        return !0;
      c = c.firstChild, o--;
    }
  }
  return !1;
}
function hP(n, e, t, r) {
  let o = [], u = [], c, l;
  n.doc.nodesBetween(e, t, (i, h, f) => {
    if (!i.isInline)
      return;
    let p = i.marks;
    if (!r.isInSet(p) && f.type.allowsMarkType(r.type)) {
      let d = Math.max(h, e), v = Math.min(h + i.nodeSize, t), g = r.addToSet(p);
      for (let m = 0; m < p.length; m++)
        p[m].isInSet(g) || (c && c.to == d && c.mark.eq(p[m]) ? c.to = v : o.push(c = new kr(d, v, p[m])));
      l && l.to == d ? l.to = v : u.push(l = new Ci(d, v, r));
    }
  }), o.forEach((i) => n.step(i)), u.forEach((i) => n.step(i));
}
function pP(n, e, t, r) {
  let o = [], u = 0;
  n.doc.nodesBetween(e, t, (c, l) => {
    if (!c.isInline)
      return;
    u++;
    let i = null;
    if (r instanceof Jl) {
      let h = c.marks, f;
      for (; f = r.isInSet(h); )
        (i || (i = [])).push(f), h = f.removeFromSet(h);
    } else
      r ? r.isInSet(c.marks) && (i = [r]) : i = c.marks;
    if (i && i.length) {
      let h = Math.min(l + c.nodeSize, t);
      for (let f = 0; f < i.length; f++) {
        let p = i[f], d;
        for (let v = 0; v < o.length; v++) {
          let g = o[v];
          g.step == u - 1 && p.eq(o[v].style) && (d = g);
        }
        d ? (d.to = h, d.step = u) : o.push({ style: p, from: Math.max(l, e), to: h, step: u });
      }
    }
  }), o.forEach((c) => n.step(new kr(c.from, c.to, c.style)));
}
function Sv(n, e, t, r = t.contentMatch, o = !0) {
  let u = n.doc.nodeAt(e), c = [], l = e + 1;
  for (let i = 0; i < u.childCount; i++) {
    let h = u.child(i), f = l + h.nodeSize, p = r.matchType(h.type);
    if (!p)
      c.push(new Pn(l, f, Lt.empty));
    else {
      r = p;
      for (let d = 0; d < h.marks.length; d++)
        t.allowsMarkType(h.marks[d].type) || n.step(new kr(l, f, h.marks[d]));
      if (o && h.isText && t.whitespace != "pre") {
        let d, v = /\r?\n|\r/g, g;
        for (; d = v.exec(h.text); )
          g || (g = new Lt(Tt.from(t.schema.text(" ", t.allowedMarks(h.marks))), 0, 0)), c.push(new Pn(l + d.index, l + d.index + d[0].length, g));
      }
    }
    l = f;
  }
  if (!r.validEnd) {
    let i = r.fillBefore(Tt.empty, !0);
    n.replace(l, l, new Lt(i, 0, 0));
  }
  for (let i = c.length - 1; i >= 0; i--)
    n.step(c[i]);
}
function mP(n, e, t) {
  return (e == 0 || n.canReplace(e, n.childCount)) && (t == n.childCount || n.canReplace(0, t));
}
function Ao(n) {
  let t = n.parent.content.cutByIndex(n.startIndex, n.endIndex);
  for (let r = n.depth; ; --r) {
    let o = n.$from.node(r), u = n.$from.index(r), c = n.$to.indexAfter(r);
    if (r < n.depth && o.canReplace(u, c, t))
      return r;
    if (r == 0 || o.type.spec.isolating || !mP(o, u, c))
      break;
  }
  return null;
}
function gP(n, e, t) {
  let { $from: r, $to: o, depth: u } = e, c = r.before(u + 1), l = o.after(u + 1), i = c, h = l, f = Tt.empty, p = 0;
  for (let g = u, m = !1; g > t; g--)
    m || r.index(g) > 0 ? (m = !0, f = Tt.from(r.node(g).copy(f)), p++) : i--;
  let d = Tt.empty, v = 0;
  for (let g = u, m = !1; g > t; g--)
    m || o.after(g + 1) < o.end(g) ? (m = !0, d = Tt.from(o.node(g).copy(d)), v++) : h++;
  n.step(new In(i, h, c, l, new Lt(f.append(d), p, v), f.size - p, !0));
}
function pd(n, e, t = null, r = n) {
  let o = vP(n, e), u = o && _P(r, e);
  return u ? o.map(op).concat({ type: e, attrs: t }).concat(u.map(op)) : null;
}
function op(n) {
  return { type: n, attrs: null };
}
function vP(n, e) {
  let { parent: t, startIndex: r, endIndex: o } = n, u = t.contentMatchAt(r).findWrapping(e);
  if (!u)
    return null;
  let c = u.length ? u[0] : e;
  return t.canReplaceWith(r, o, c) ? u : null;
}
function _P(n, e) {
  let { parent: t, startIndex: r, endIndex: o } = n, u = t.child(r), c = e.contentMatch.findWrapping(u.type);
  if (!c)
    return null;
  let i = (c.length ? c[c.length - 1] : e).contentMatch;
  for (let h = r; i && h < o; h++)
    i = i.matchType(t.child(h).type);
  return !i || !i.validEnd ? null : c;
}
function EP(n, e, t) {
  let r = Tt.empty;
  for (let c = t.length - 1; c >= 0; c--) {
    if (r.size) {
      let l = t[c].type.contentMatch.matchFragment(r);
      if (!l || !l.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    r = Tt.from(t[c].type.create(t[c].attrs, r));
  }
  let o = e.start, u = e.end;
  n.step(new In(o, u, o, u, new Lt(r, 0, 0), t.length, !0));
}
function yP(n, e, t, r, o) {
  if (!r.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let u = n.steps.length;
  n.doc.nodesBetween(e, t, (c, l) => {
    if (c.isTextblock && !c.hasMarkup(r, o) && SP(n.doc, n.mapping.slice(u).map(l), r)) {
      let i = null;
      if (r.schema.linebreakReplacement) {
        let d = r.whitespace == "pre", v = !!r.contentMatch.matchType(r.schema.linebreakReplacement);
        d && !v ? i = !1 : !d && v && (i = !0);
      }
      i === !1 && AP(n, c, l, u), Sv(n, n.mapping.slice(u).map(l, 1), r, void 0, i === null);
      let h = n.mapping.slice(u), f = h.map(l, 1), p = h.map(l + c.nodeSize, 1);
      return n.step(new In(f, p, f + 1, p - 1, new Lt(Tt.from(r.create(o, null, c.marks)), 0, 0), 1, !0)), i === !0 && TP(n, c, l, u), !1;
    }
  });
}
function TP(n, e, t, r) {
  e.forEach((o, u) => {
    if (o.isText) {
      let c, l = /\r?\n|\r/g;
      for (; c = l.exec(o.text); ) {
        let i = n.mapping.slice(r).map(t + 1 + u + c.index);
        n.replaceWith(i, i + 1, e.type.schema.linebreakReplacement.create());
      }
    }
  });
}
function AP(n, e, t, r) {
  e.forEach((o, u) => {
    if (o.type == o.type.schema.linebreakReplacement) {
      let c = n.mapping.slice(r).map(t + 1 + u);
      n.replaceWith(c, c + 1, e.type.schema.text(`
`));
    }
  });
}
function SP(n, e, t) {
  let r = n.resolve(e), o = r.index();
  return r.parent.canReplaceWith(o, o + 1, t);
}
function CP(n, e, t, r, o) {
  let u = n.doc.nodeAt(e);
  if (!u)
    throw new RangeError("No node at given position");
  t || (t = u.type);
  let c = t.create(r, null, o || u.marks);
  if (u.isLeaf)
    return n.replaceWith(e, e + u.nodeSize, c);
  if (!t.validContent(u.content))
    throw new RangeError("Invalid content for node type " + t.name);
  n.step(new In(e, e + u.nodeSize, e + 1, e + u.nodeSize - 1, new Lt(Tt.from(c), 0, 0), 1, !0));
}
function za(n, e, t = 1, r) {
  let o = n.resolve(e), u = o.depth - t, c = r && r[r.length - 1] || o.parent;
  if (u < 0 || o.parent.type.spec.isolating || !o.parent.canReplace(o.index(), o.parent.childCount) || !c.type.validContent(o.parent.content.cutByIndex(o.index(), o.parent.childCount)))
    return !1;
  for (let h = o.depth - 1, f = t - 2; h > u; h--, f--) {
    let p = o.node(h), d = o.index(h);
    if (p.type.spec.isolating)
      return !1;
    let v = p.content.cutByIndex(d, p.childCount), g = r && r[f + 1];
    g && (v = v.replaceChild(0, g.type.create(g.attrs)));
    let m = r && r[f] || p;
    if (!p.canReplace(d + 1, p.childCount) || !m.type.validContent(v))
      return !1;
  }
  let l = o.indexAfter(u), i = r && r[0];
  return o.node(u).canReplaceWith(l, l, i ? i.type : o.node(u + 1).type);
}
function MP(n, e, t = 1, r) {
  let o = n.doc.resolve(e), u = Tt.empty, c = Tt.empty;
  for (let l = o.depth, i = o.depth - t, h = t - 1; l > i; l--, h--) {
    u = Tt.from(o.node(l).copy(u));
    let f = r && r[h];
    c = Tt.from(f ? f.type.create(f.attrs, c) : o.node(l).copy(c));
  }
  n.step(new Pn(e, e, new Lt(u.append(c), t, t), !0));
}
function Fi(n, e) {
  let t = n.resolve(e), r = t.index();
  return Cv(t.nodeBefore, t.nodeAfter) && t.parent.canReplace(r, r + 1);
}
function Cv(n, e) {
  return !!(n && e && !n.isLeaf && n.canAppend(e));
}
function Zl(n, e, t = -1) {
  let r = n.resolve(e);
  for (let o = r.depth; ; o--) {
    let u, c, l = r.index(o);
    if (o == r.depth ? (u = r.nodeBefore, c = r.nodeAfter) : t > 0 ? (u = r.node(o + 1), l++, c = r.node(o).maybeChild(l)) : (u = r.node(o).maybeChild(l - 1), c = r.node(o + 1)), u && !u.isTextblock && Cv(u, c) && r.node(o).canReplace(l, l + 1))
      return e;
    if (o == 0)
      break;
    e = t < 0 ? r.before(o) : r.after(o);
  }
}
function bP(n, e, t) {
  let r = new Pn(e - t, e + t, Lt.empty, !0);
  n.step(r);
}
function RP(n, e, t) {
  let r = n.resolve(e);
  if (r.parent.canReplaceWith(r.index(), r.index(), t))
    return e;
  if (r.parentOffset == 0)
    for (let o = r.depth - 1; o >= 0; o--) {
      let u = r.index(o);
      if (r.node(o).canReplaceWith(u, u, t))
        return r.before(o + 1);
      if (u > 0)
        return null;
    }
  if (r.parentOffset == r.parent.content.size)
    for (let o = r.depth - 1; o >= 0; o--) {
      let u = r.indexAfter(o);
      if (r.node(o).canReplaceWith(u, u, t))
        return r.after(o + 1);
      if (u < r.node(o).childCount)
        return null;
    }
  return null;
}
function Mv(n, e, t) {
  let r = n.resolve(e);
  if (!t.content.size)
    return e;
  let o = t.content;
  for (let u = 0; u < t.openStart; u++)
    o = o.firstChild.content;
  for (let u = 1; u <= (t.openStart == 0 && t.size ? 2 : 1); u++)
    for (let c = r.depth; c >= 0; c--) {
      let l = c == r.depth ? 0 : r.pos <= (r.start(c + 1) + r.end(c + 1)) / 2 ? -1 : 1, i = r.index(c) + (l > 0 ? 1 : 0), h = r.node(c), f = !1;
      if (u == 1)
        f = h.canReplace(i, i, o);
      else {
        let p = h.contentMatchAt(i).findWrapping(o.firstChild.type);
        f = p && h.canReplaceWith(i, i, p[0]);
      }
      if (f)
        return l == 0 ? r.pos : l < 0 ? r.before(c + 1) : r.after(c + 1);
    }
  return null;
}
function ql(n, e, t = e, r = Lt.empty) {
  if (e == t && !r.size)
    return null;
  let o = n.resolve(e), u = n.resolve(t);
  return bv(o, u, r) ? new Pn(e, t, r) : new DP(o, u, r).fit();
}
function bv(n, e, t) {
  return !t.openStart && !t.openEnd && n.start() == e.start() && n.parent.canReplace(n.index(), e.index(), t.content);
}
class DP {
  constructor(e, t, r) {
    this.$from = e, this.$to = t, this.unplaced = r, this.frontier = [], this.placed = Tt.empty;
    for (let o = 0; o <= e.depth; o++) {
      let u = e.node(o);
      this.frontier.push({
        type: u.type,
        match: u.contentMatchAt(e.indexAfter(o))
      });
    }
    for (let o = e.depth; o > 0; o--)
      this.placed = Tt.from(e.node(o).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let h = this.findFittable();
      h ? this.placeNodes(h) : this.openMore() || this.dropNode();
    }
    let e = this.mustMoveInline(), t = this.placed.size - this.depth - this.$from.depth, r = this.$from, o = this.close(e < 0 ? this.$to : r.doc.resolve(e));
    if (!o)
      return null;
    let u = this.placed, c = r.depth, l = o.depth;
    for (; c && l && u.childCount == 1; )
      u = u.firstChild.content, c--, l--;
    let i = new Lt(u, c, l);
    return e > -1 ? new In(r.pos, e, this.$to.pos, this.$to.end(), i, t) : i.size || r.pos != this.$to.pos ? new Pn(r.pos, o.pos, i) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let e = this.unplaced.openStart;
    for (let t = this.unplaced.content, r = 0, o = this.unplaced.openEnd; r < e; r++) {
      let u = t.firstChild;
      if (t.childCount > 1 && (o = 0), u.type.spec.isolating && o <= r) {
        e = r;
        break;
      }
      t = u.content;
    }
    for (let t = 1; t <= 2; t++)
      for (let r = t == 1 ? e : this.unplaced.openStart; r >= 0; r--) {
        let o, u = null;
        r ? (u = ec(this.unplaced.content, r - 1).firstChild, o = u.content) : o = this.unplaced.content;
        let c = o.firstChild;
        for (let l = this.depth; l >= 0; l--) {
          let { type: i, match: h } = this.frontier[l], f, p = null;
          if (t == 1 && (c ? h.matchType(c.type) || (p = h.fillBefore(Tt.from(c), !1)) : u && i.compatibleContent(u.type)))
            return { sliceDepth: r, frontierDepth: l, parent: u, inject: p };
          if (t == 2 && c && (f = h.findWrapping(c.type)))
            return { sliceDepth: r, frontierDepth: l, parent: u, wrap: f };
          if (u && h.matchType(u.type))
            break;
        }
      }
  }
  openMore() {
    let { content: e, openStart: t, openEnd: r } = this.unplaced, o = ec(e, t);
    return !o.childCount || o.firstChild.isLeaf ? !1 : (this.unplaced = new Lt(e, t + 1, Math.max(r, o.size + t >= e.size - r ? t + 1 : 0)), !0);
  }
  dropNode() {
    let { content: e, openStart: t, openEnd: r } = this.unplaced, o = ec(e, t);
    if (o.childCount <= 1 && t > 0) {
      let u = e.size - t <= t + o.size;
      this.unplaced = new Lt(Fo(e, t - 1, 1), t - 1, u ? t - 1 : r);
    } else
      this.unplaced = new Lt(Fo(e, t, 1), t, r);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: e, frontierDepth: t, parent: r, inject: o, wrap: u }) {
    for (; this.depth > t; )
      this.closeFrontierNode();
    if (u)
      for (let m = 0; m < u.length; m++)
        this.openFrontierNode(u[m]);
    let c = this.unplaced, l = r ? r.content : c.content, i = c.openStart - e, h = 0, f = [], { match: p, type: d } = this.frontier[t];
    if (o) {
      for (let m = 0; m < o.childCount; m++)
        f.push(o.child(m));
      p = p.matchFragment(o);
    }
    let v = l.size + e - (c.content.size - c.openEnd);
    for (; h < l.childCount; ) {
      let m = l.child(h), A = p.matchType(m.type);
      if (!A)
        break;
      h++, (h > 1 || i == 0 || m.content.size) && (p = A, f.push(Rv(m.mark(d.allowedMarks(m.marks)), h == 1 ? i : 0, h == l.childCount ? v : -1)));
    }
    let g = h == l.childCount;
    g || (v = -1), this.placed = Uo(this.placed, t, Tt.from(f)), this.frontier[t].match = p, g && v < 0 && r && r.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let m = 0, A = l; m < v; m++) {
      let b = A.lastChild;
      this.frontier.push({ type: b.type, match: b.contentMatchAt(b.childCount) }), A = b.content;
    }
    this.unplaced = g ? e == 0 ? Lt.empty : new Lt(Fo(c.content, e - 1, 1), e - 1, v < 0 ? c.openEnd : e - 1) : new Lt(Fo(c.content, e, h), c.openStart, c.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let e = this.frontier[this.depth], t;
    if (!e.type.isTextblock || !tc(this.$to, this.$to.depth, e.type, e.match, !1) || this.$to.depth == this.depth && (t = this.findCloseLevel(this.$to)) && t.depth == this.depth)
      return -1;
    let { depth: r } = this.$to, o = this.$to.after(r);
    for (; r > 1 && o == this.$to.end(--r); )
      ++o;
    return o;
  }
  findCloseLevel(e) {
    e:
      for (let t = Math.min(this.depth, e.depth); t >= 0; t--) {
        let { match: r, type: o } = this.frontier[t], u = t < e.depth && e.end(t + 1) == e.pos + (e.depth - (t + 1)), c = tc(e, t, o, r, u);
        if (c) {
          for (let l = t - 1; l >= 0; l--) {
            let { match: i, type: h } = this.frontier[l], f = tc(e, l, h, i, !0);
            if (!f || f.childCount)
              continue e;
          }
          return { depth: t, fit: c, move: u ? e.doc.resolve(e.after(t + 1)) : e };
        }
      }
  }
  close(e) {
    let t = this.findCloseLevel(e);
    if (!t)
      return null;
    for (; this.depth > t.depth; )
      this.closeFrontierNode();
    t.fit.childCount && (this.placed = Uo(this.placed, t.depth, t.fit)), e = t.move;
    for (let r = t.depth + 1; r <= e.depth; r++) {
      let o = e.node(r), u = o.type.contentMatch.fillBefore(o.content, !0, e.index(r));
      this.openFrontierNode(o.type, o.attrs, u);
    }
    return e;
  }
  openFrontierNode(e, t = null, r) {
    let o = this.frontier[this.depth];
    o.match = o.match.matchType(e), this.placed = Uo(this.placed, this.depth, Tt.from(e.create(t, r))), this.frontier.push({ type: e, match: e.contentMatch });
  }
  closeFrontierNode() {
    let t = this.frontier.pop().match.fillBefore(Tt.empty, !0);
    t.childCount && (this.placed = Uo(this.placed, this.frontier.length, t));
  }
}
function Fo(n, e, t) {
  return e == 0 ? n.cutByIndex(t, n.childCount) : n.replaceChild(0, n.firstChild.copy(Fo(n.firstChild.content, e - 1, t)));
}
function Uo(n, e, t) {
  return e == 0 ? n.append(t) : n.replaceChild(n.childCount - 1, n.lastChild.copy(Uo(n.lastChild.content, e - 1, t)));
}
function ec(n, e) {
  for (let t = 0; t < e; t++)
    n = n.firstChild.content;
  return n;
}
function Rv(n, e, t) {
  if (e <= 0)
    return n;
  let r = n.content;
  return e > 1 && (r = r.replaceChild(0, Rv(r.firstChild, e - 1, r.childCount == 1 ? t - 1 : 0))), e > 0 && (r = n.type.contentMatch.fillBefore(r).append(r), t <= 0 && (r = r.append(n.type.contentMatch.matchFragment(r).fillBefore(Tt.empty, !0)))), n.copy(r);
}
function tc(n, e, t, r, o) {
  let u = n.node(e), c = o ? n.indexAfter(e) : n.index(e);
  if (c == u.childCount && !t.compatibleContent(u.type))
    return null;
  let l = r.fillBefore(u.content, !0, c);
  return l && !OP(t, u.content, c) ? l : null;
}
function OP(n, e, t) {
  for (let r = t; r < e.childCount; r++)
    if (!n.allowsMarks(e.child(r).marks))
      return !0;
  return !1;
}
function PP(n) {
  return n.spec.defining || n.spec.definingForContent;
}
function IP(n, e, t, r) {
  if (!r.size)
    return n.deleteRange(e, t);
  let o = n.doc.resolve(e), u = n.doc.resolve(t);
  if (bv(o, u, r))
    return n.step(new Pn(e, t, r));
  let c = Ov(o, n.doc.resolve(t));
  c[c.length - 1] == 0 && c.pop();
  let l = -(o.depth + 1);
  c.unshift(l);
  for (let d = o.depth, v = o.pos - 1; d > 0; d--, v--) {
    let g = o.node(d).type.spec;
    if (g.defining || g.definingAsContext || g.isolating)
      break;
    c.indexOf(d) > -1 ? l = d : o.before(d) == v && c.splice(1, 0, -d);
  }
  let i = c.indexOf(l), h = [], f = r.openStart;
  for (let d = r.content, v = 0; ; v++) {
    let g = d.firstChild;
    if (h.push(g), v == r.openStart)
      break;
    d = g.content;
  }
  for (let d = f - 1; d >= 0; d--) {
    let v = h[d], g = PP(v.type);
    if (g && !v.sameMarkup(o.node(Math.abs(l) - 1)))
      f = d;
    else if (g || !v.type.isTextblock)
      break;
  }
  for (let d = r.openStart; d >= 0; d--) {
    let v = (d + f + 1) % (r.openStart + 1), g = h[v];
    if (g)
      for (let m = 0; m < c.length; m++) {
        let A = c[(m + i) % c.length], b = !0;
        A < 0 && (b = !1, A = -A);
        let S = o.node(A - 1), N = o.index(A - 1);
        if (S.canReplaceWith(N, N, g.type, g.marks))
          return n.replace(o.before(A), b ? u.after(A) : t, new Lt(Dv(r.content, 0, r.openStart, v), v, r.openEnd));
      }
  }
  let p = n.steps.length;
  for (let d = c.length - 1; d >= 0 && (n.replace(e, t, r), !(n.steps.length > p)); d--) {
    let v = c[d];
    v < 0 || (e = o.before(v), t = u.after(v));
  }
}
function Dv(n, e, t, r, o) {
  if (e < t) {
    let u = n.firstChild;
    n = n.replaceChild(0, u.copy(Dv(u.content, e + 1, t, r, u)));
  }
  if (e > r) {
    let u = o.contentMatchAt(0), c = u.fillBefore(n).append(n);
    n = c.append(u.matchFragment(c).fillBefore(Tt.empty, !0));
  }
  return n;
}
function NP(n, e, t, r) {
  if (!r.isInline && e == t && n.doc.resolve(e).parent.content.size) {
    let o = RP(n.doc, e, r.type);
    o != null && (e = t = o);
  }
  n.replaceRange(e, t, new Lt(Tt.from(r), 0, 0));
}
function LP(n, e, t) {
  let r = n.doc.resolve(e), o = n.doc.resolve(t), u = Ov(r, o);
  for (let c = 0; c < u.length; c++) {
    let l = u[c], i = c == u.length - 1;
    if (i && l == 0 || r.node(l).type.contentMatch.validEnd)
      return n.delete(r.start(l), o.end(l));
    if (l > 0 && (i || r.node(l - 1).canReplace(r.index(l - 1), o.indexAfter(l - 1))))
      return n.delete(r.before(l), o.after(l));
  }
  for (let c = 1; c <= r.depth && c <= o.depth; c++)
    if (e - r.start(c) == r.depth - c && t > r.end(c) && o.end(c) - t != o.depth - c)
      return n.delete(r.before(c), t);
  n.delete(e, t);
}
function Ov(n, e) {
  let t = [], r = Math.min(n.depth, e.depth);
  for (let o = r; o >= 0; o--) {
    let u = n.start(o);
    if (u < n.pos - (n.depth - o) || e.end(o) > e.pos + (e.depth - o) || n.node(o).type.spec.isolating || e.node(o).type.spec.isolating)
      break;
    (u == e.start(o) || o == n.depth && o == e.depth && n.parent.inlineContent && e.parent.inlineContent && o && e.start(o - 1) == u - 1) && t.push(o);
  }
  return t;
}
class Ya extends Hn {
  /**
  Construct an attribute step.
  */
  constructor(e, t, r) {
    super(), this.pos = e, this.attr = t, this.value = r;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return Sn.fail("No node at attribute step's position");
    let r = /* @__PURE__ */ Object.create(null);
    for (let u in t.attrs)
      r[u] = t.attrs[u];
    r[this.attr] = this.value;
    let o = t.type.create(r, null, t.marks);
    return Sn.fromReplace(e, this.pos, this.pos + 1, new Lt(Tt.from(o), 0, t.isLeaf ? 0 : 1));
  }
  getMap() {
    return ar.empty;
  }
  invert(e) {
    return new Ya(this.pos, this.attr, e.nodeAt(this.pos).attrs[this.attr]);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new Ya(t.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(e, t) {
    if (typeof t.pos != "number" || typeof t.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new Ya(t.pos, t.attr, t.value);
  }
}
Hn.jsonID("attr", Ya);
class hs extends Hn {
  /**
  Construct an attribute step.
  */
  constructor(e, t) {
    super(), this.attr = e, this.value = t;
  }
  apply(e) {
    let t = /* @__PURE__ */ Object.create(null);
    for (let o in e.attrs)
      t[o] = e.attrs[o];
    t[this.attr] = this.value;
    let r = e.type.create(t, e.content, e.marks);
    return Sn.ok(r);
  }
  getMap() {
    return ar.empty;
  }
  invert(e) {
    return new hs(this.attr, e.attrs[this.attr]);
  }
  map(e) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(e, t) {
    if (typeof t.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new hs(t.attr, t.value);
  }
}
Hn.jsonID("docAttr", hs);
let lo = class extends Error {
};
lo = function n(e) {
  let t = Error.call(this, e);
  return t.__proto__ = n.prototype, t;
};
lo.prototype = Object.create(Error.prototype);
lo.prototype.constructor = lo;
lo.prototype.name = "TransformError";
class wP {
  /**
  Create a transform that starts with the given document.
  */
  constructor(e) {
    this.doc = e, this.steps = [], this.docs = [], this.mapping = new Ga();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(e) {
    let t = this.maybeStep(e);
    if (t.failed)
      throw new lo(t.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(e) {
    let t = e.apply(this.doc);
    return t.failed || this.addStep(e, t.doc), t;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  @internal
  */
  addStep(e, t) {
    this.docs.push(this.doc), this.steps.push(e), this.mapping.appendMap(e.getMap()), this.doc = t;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(e, t = e, r = Lt.empty) {
    let o = ql(this.doc, e, t, r);
    return o && this.step(o), this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(e, t, r) {
    return this.replace(e, t, new Lt(Tt.from(r), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(e, t) {
    return this.replace(e, t, Lt.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(e, t) {
    return this.replaceWith(e, e, t);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(e, t, r) {
    return IP(this, e, t, r), this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(e, t, r) {
    return NP(this, e, t, r), this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(e, t) {
    return LP(this, e, t), this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(e, t) {
    return gP(this, e, t), this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(e, t = 1) {
    return bP(this, e, t), this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(e, t) {
    return EP(this, e, t), this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(e, t = e, r, o = null) {
    return yP(this, e, t, r, o), this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(e, t, r = null, o) {
    return CP(this, e, t, r, o), this;
  }
  /**
  Set a single attribute on a given node to a new value.
  The `pos` addresses the document content. Use `setDocAttribute`
  to set attributes on the document itself.
  */
  setNodeAttribute(e, t, r) {
    return this.step(new Ya(e, t, r)), this;
  }
  /**
  Set a single attribute on the document to a new value.
  */
  setDocAttribute(e, t) {
    return this.step(new hs(e, t)), this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(e, t) {
    return this.step(new Mi(e, t)), this;
  }
  /**
  Remove a mark (or a mark of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(e, t) {
    if (!(t instanceof hn)) {
      let r = this.doc.nodeAt(e);
      if (!r)
        throw new RangeError("No node at position " + e);
      if (t = t.isInSet(r.marks), !t)
        return this;
    }
    return this.step(new so(e, t)), this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split.
  */
  split(e, t = 1, r) {
    return MP(this, e, t, r), this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(e, t, r) {
    return hP(this, e, t, r), this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(e, t, r) {
    return pP(this, e, t, r), this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(e, t, r) {
    return Sv(this, e, t, r), this;
  }
}
const nc = /* @__PURE__ */ Object.create(null);
class en {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(e, t, r) {
    this.$anchor = e, this.$head = t, this.ranges = r || [new xP(e.min(t), e.max(t))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let e = this.ranges;
    for (let t = 0; t < e.length; t++)
      if (e[t].$from.pos != e[t].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(e, t = Lt.empty) {
    let r = t.content.lastChild, o = null;
    for (let l = 0; l < t.openEnd; l++)
      o = r, r = r.lastChild;
    let u = e.steps.length, c = this.ranges;
    for (let l = 0; l < c.length; l++) {
      let { $from: i, $to: h } = c[l], f = e.mapping.slice(u);
      e.replaceRange(f.map(i.pos), f.map(h.pos), l ? Lt.empty : t), l == 0 && up(e, u, (r ? r.isInline : o && o.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(e, t) {
    let r = e.steps.length, o = this.ranges;
    for (let u = 0; u < o.length; u++) {
      let { $from: c, $to: l } = o[u], i = e.mapping.slice(r), h = i.map(c.pos), f = i.map(l.pos);
      u ? e.deleteRange(h, f) : (e.replaceRangeWith(h, f, t), up(e, r, t.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(e, t, r = !1) {
    let o = e.parent.inlineContent ? new Zt(e) : La(e.node(0), e.parent, e.pos, e.index(), t, r);
    if (o)
      return o;
    for (let u = e.depth - 1; u >= 0; u--) {
      let c = t < 0 ? La(e.node(0), e.node(u), e.before(u + 1), e.index(u), t, r) : La(e.node(0), e.node(u), e.after(u + 1), e.index(u) + 1, t, r);
      if (c)
        return c;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(e, t = 1) {
    return this.findFrom(e, t) || this.findFrom(e, -t) || new Cr(e.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(e) {
    return La(e, e, 0, 0, 1) || new Cr(e);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(e) {
    return La(e, e, e.content.size, e.childCount, -1) || new Cr(e);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(e, t) {
    if (!t || !t.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let r = nc[t.type];
    if (!r)
      throw new RangeError(`No selection type ${t.type} defined`);
    return r.fromJSON(e, t);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(e, t) {
    if (e in nc)
      throw new RangeError("Duplicate use of selection JSON ID " + e);
    return nc[e] = t, t.prototype.jsonID = e, t;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return Zt.between(this.$anchor, this.$head).getBookmark();
  }
}
en.prototype.visible = !0;
class xP {
  /**
  Create a range.
  */
  constructor(e, t) {
    this.$from = e, this.$to = t;
  }
}
let sp = !1;
function lp(n) {
  !sp && !n.parent.inlineContent && (sp = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + n.parent.type.name + ")"));
}
class Zt extends en {
  /**
  Construct a text selection between the given points.
  */
  constructor(e, t = e) {
    lp(e), lp(t), super(e, t);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(e, t) {
    let r = e.resolve(t.map(this.head));
    if (!r.parent.inlineContent)
      return en.near(r);
    let o = e.resolve(t.map(this.anchor));
    return new Zt(o.parent.inlineContent ? o : r, r);
  }
  replace(e, t = Lt.empty) {
    if (super.replace(e, t), t == Lt.empty) {
      let r = this.$from.marksAcross(this.$to);
      r && e.ensureMarks(r);
    }
  }
  eq(e) {
    return e instanceof Zt && e.anchor == this.anchor && e.head == this.head;
  }
  getBookmark() {
    return new eu(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.anchor != "number" || typeof t.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new Zt(e.resolve(t.anchor), e.resolve(t.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(e, t, r = t) {
    let o = e.resolve(t);
    return new this(o, r == t ? o : e.resolve(r));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(e, t, r) {
    let o = e.pos - t.pos;
    if ((!r || o) && (r = o >= 0 ? 1 : -1), !t.parent.inlineContent) {
      let u = en.findFrom(t, r, !0) || en.findFrom(t, -r, !0);
      if (u)
        t = u.$head;
      else
        return en.near(t, r);
    }
    return e.parent.inlineContent || (o == 0 ? e = t : (e = (en.findFrom(e, -r, !0) || en.findFrom(e, r, !0)).$anchor, e.pos < t.pos != o < 0 && (e = t))), new Zt(e, t);
  }
}
en.jsonID("text", Zt);
class eu {
  constructor(e, t) {
    this.anchor = e, this.head = t;
  }
  map(e) {
    return new eu(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    return Zt.between(e.resolve(this.anchor), e.resolve(this.head));
  }
}
class $t extends en {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(e) {
    let t = e.nodeAfter, r = e.node(0).resolve(e.pos + t.nodeSize);
    super(e, r), this.node = t;
  }
  map(e, t) {
    let { deleted: r, pos: o } = t.mapResult(this.anchor), u = e.resolve(o);
    return r ? en.near(u) : new $t(u);
  }
  content() {
    return new Lt(Tt.from(this.node), 0, 0);
  }
  eq(e) {
    return e instanceof $t && e.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new md(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new $t(e.resolve(t.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(e, t) {
    return new $t(e.resolve(t));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(e) {
    return !e.isText && e.type.spec.selectable !== !1;
  }
}
$t.prototype.visible = !1;
en.jsonID("node", $t);
class md {
  constructor(e) {
    this.anchor = e;
  }
  map(e) {
    let { deleted: t, pos: r } = e.mapResult(this.anchor);
    return t ? new eu(r, r) : new md(r);
  }
  resolve(e) {
    let t = e.resolve(this.anchor), r = t.nodeAfter;
    return r && $t.isSelectable(r) ? new $t(t) : en.near(t);
  }
}
class Cr extends en {
  /**
  Create an all-selection over the given document.
  */
  constructor(e) {
    super(e.resolve(0), e.resolve(e.content.size));
  }
  replace(e, t = Lt.empty) {
    if (t == Lt.empty) {
      e.delete(0, e.doc.content.size);
      let r = en.atStart(e.doc);
      r.eq(e.selection) || e.setSelection(r);
    } else
      super.replace(e, t);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(e) {
    return new Cr(e);
  }
  map(e) {
    return new Cr(e);
  }
  eq(e) {
    return e instanceof Cr;
  }
  getBookmark() {
    return BP;
  }
}
en.jsonID("all", Cr);
const BP = {
  map() {
    return this;
  },
  resolve(n) {
    return new Cr(n);
  }
};
function La(n, e, t, r, o, u = !1) {
  if (e.inlineContent)
    return Zt.create(n, t);
  for (let c = r - (o > 0 ? 0 : 1); o > 0 ? c < e.childCount : c >= 0; c += o) {
    let l = e.child(c);
    if (l.isAtom) {
      if (!u && $t.isSelectable(l))
        return $t.create(n, t - (o < 0 ? l.nodeSize : 0));
    } else {
      let i = La(n, l, t + o, o < 0 ? l.childCount : 0, o, u);
      if (i)
        return i;
    }
    t += l.nodeSize * o;
  }
  return null;
}
function up(n, e, t) {
  let r = n.steps.length - 1;
  if (r < e)
    return;
  let o = n.steps[r];
  if (!(o instanceof Pn || o instanceof In))
    return;
  let u = n.mapping.maps[r], c;
  u.forEach((l, i, h, f) => {
    c == null && (c = f);
  }), n.setSelection(en.near(n.doc.resolve(c), t));
}
const cp = 1, el = 2, fp = 4;
class FP extends wP {
  /**
  @internal
  */
  constructor(e) {
    super(e.doc), this.curSelectionFor = 0, this.updated = 0, this.meta = /* @__PURE__ */ Object.create(null), this.time = Date.now(), this.curSelection = e.selection, this.storedMarks = e.storedMarks;
  }
  /**
  The transaction's current selection. This defaults to the editor
  selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
  transaction, but can be overwritten with
  [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
  */
  get selection() {
    return this.curSelectionFor < this.steps.length && (this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor)), this.curSelectionFor = this.steps.length), this.curSelection;
  }
  /**
  Update the transaction's current selection. Will determine the
  selection that the editor gets when the transaction is applied.
  */
  setSelection(e) {
    if (e.$from.doc != this.doc)
      throw new RangeError("Selection passed to setSelection must point at the current document");
    return this.curSelection = e, this.curSelectionFor = this.steps.length, this.updated = (this.updated | cp) & ~el, this.storedMarks = null, this;
  }
  /**
  Whether the selection was explicitly updated by this transaction.
  */
  get selectionSet() {
    return (this.updated & cp) > 0;
  }
  /**
  Set the current stored marks.
  */
  setStoredMarks(e) {
    return this.storedMarks = e, this.updated |= el, this;
  }
  /**
  Make sure the current stored marks or, if that is null, the marks
  at the selection, match the given set of marks. Does nothing if
  this is already the case.
  */
  ensureMarks(e) {
    return hn.sameSet(this.storedMarks || this.selection.$from.marks(), e) || this.setStoredMarks(e), this;
  }
  /**
  Add a mark to the set of stored marks.
  */
  addStoredMark(e) {
    return this.ensureMarks(e.addToSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Remove a mark or mark type from the set of stored marks.
  */
  removeStoredMark(e) {
    return this.ensureMarks(e.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Whether the stored marks were explicitly set for this transaction.
  */
  get storedMarksSet() {
    return (this.updated & el) > 0;
  }
  /**
  @internal
  */
  addStep(e, t) {
    super.addStep(e, t), this.updated = this.updated & ~el, this.storedMarks = null;
  }
  /**
  Update the timestamp for the transaction.
  */
  setTime(e) {
    return this.time = e, this;
  }
  /**
  Replace the current selection with the given slice.
  */
  replaceSelection(e) {
    return this.selection.replace(this, e), this;
  }
  /**
  Replace the selection with the given node. When `inheritMarks` is
  true and the content is inline, it inherits the marks from the
  place where it is inserted.
  */
  replaceSelectionWith(e, t = !0) {
    let r = this.selection;
    return t && (e = e.mark(this.storedMarks || (r.empty ? r.$from.marks() : r.$from.marksAcross(r.$to) || hn.none))), r.replaceWith(this, e), this;
  }
  /**
  Delete the selection.
  */
  deleteSelection() {
    return this.selection.replace(this), this;
  }
  /**
  Replace the given range, or the selection if no range is given,
  with a text node containing the given string.
  */
  insertText(e, t, r) {
    let o = this.doc.type.schema;
    if (t == null)
      return e ? this.replaceSelectionWith(o.text(e), !0) : this.deleteSelection();
    {
      if (r == null && (r = t), r = r ?? t, !e)
        return this.deleteRange(t, r);
      let u = this.storedMarks;
      if (!u) {
        let c = this.doc.resolve(t);
        u = r == t ? c.marks() : c.marksAcross(this.doc.resolve(r));
      }
      return this.replaceRangeWith(t, r, o.text(e, u)), this.selection.empty || this.setSelection(en.near(this.selection.$to)), this;
    }
  }
  /**
  Store a metadata property in this transaction, keyed either by
  name or by plugin.
  */
  setMeta(e, t) {
    return this.meta[typeof e == "string" ? e : e.key] = t, this;
  }
  /**
  Retrieve a metadata property for a given name or plugin.
  */
  getMeta(e) {
    return this.meta[typeof e == "string" ? e : e.key];
  }
  /**
  Returns true if this transaction doesn't contain any metadata,
  and can thus safely be extended.
  */
  get isGeneric() {
    for (let e in this.meta)
      return !1;
    return !0;
  }
  /**
  Indicate that the editor should scroll the selection into view
  when updated to the state produced by this transaction.
  */
  scrollIntoView() {
    return this.updated |= fp, this;
  }
  /**
  True when this transaction has had `scrollIntoView` called on it.
  */
  get scrolledIntoView() {
    return (this.updated & fp) > 0;
  }
}
function dp(n, e) {
  return !e || !n ? n : n.bind(e);
}
class ko {
  constructor(e, t, r) {
    this.name = e, this.init = dp(t.init, r), this.apply = dp(t.apply, r);
  }
}
const UP = [
  new ko("doc", {
    init(n) {
      return n.doc || n.schema.topNodeType.createAndFill();
    },
    apply(n) {
      return n.doc;
    }
  }),
  new ko("selection", {
    init(n, e) {
      return n.selection || en.atStart(e.doc);
    },
    apply(n) {
      return n.selection;
    }
  }),
  new ko("storedMarks", {
    init(n) {
      return n.storedMarks || null;
    },
    apply(n, e, t, r) {
      return r.selection.$cursor ? n.storedMarks : null;
    }
  }),
  new ko("scrollToSelection", {
    init() {
      return 0;
    },
    apply(n, e) {
      return n.scrolledIntoView ? e + 1 : e;
    }
  })
];
class rc {
  constructor(e, t) {
    this.schema = e, this.plugins = [], this.pluginsByKey = /* @__PURE__ */ Object.create(null), this.fields = UP.slice(), t && t.forEach((r) => {
      if (this.pluginsByKey[r.key])
        throw new RangeError("Adding different instances of a keyed plugin (" + r.key + ")");
      this.plugins.push(r), this.pluginsByKey[r.key] = r, r.spec.state && this.fields.push(new ko(r.key, r.spec.state, r));
    });
  }
}
class ka {
  /**
  @internal
  */
  constructor(e) {
    this.config = e;
  }
  /**
  The schema of the state's document.
  */
  get schema() {
    return this.config.schema;
  }
  /**
  The plugins that are active in this state.
  */
  get plugins() {
    return this.config.plugins;
  }
  /**
  Apply the given transaction to produce a new state.
  */
  apply(e) {
    return this.applyTransaction(e).state;
  }
  /**
  @internal
  */
  filterTransaction(e, t = -1) {
    for (let r = 0; r < this.config.plugins.length; r++)
      if (r != t) {
        let o = this.config.plugins[r];
        if (o.spec.filterTransaction && !o.spec.filterTransaction.call(o, e, this))
          return !1;
      }
    return !0;
  }
  /**
  Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
  returns the precise transactions that were applied (which might
  be influenced by the [transaction
  hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
  plugins) along with the new state.
  */
  applyTransaction(e) {
    if (!this.filterTransaction(e))
      return { state: this, transactions: [] };
    let t = [e], r = this.applyInner(e), o = null;
    for (; ; ) {
      let u = !1;
      for (let c = 0; c < this.config.plugins.length; c++) {
        let l = this.config.plugins[c];
        if (l.spec.appendTransaction) {
          let i = o ? o[c].n : 0, h = o ? o[c].state : this, f = i < t.length && l.spec.appendTransaction.call(l, i ? t.slice(i) : t, h, r);
          if (f && r.filterTransaction(f, c)) {
            if (f.setMeta("appendedTransaction", e), !o) {
              o = [];
              for (let p = 0; p < this.config.plugins.length; p++)
                o.push(p < c ? { state: r, n: t.length } : { state: this, n: 0 });
            }
            t.push(f), r = r.applyInner(f), u = !0;
          }
          o && (o[c] = { state: r, n: t.length });
        }
      }
      if (!u)
        return { state: r, transactions: t };
    }
  }
  /**
  @internal
  */
  applyInner(e) {
    if (!e.before.eq(this.doc))
      throw new RangeError("Applying a mismatched transaction");
    let t = new ka(this.config), r = this.config.fields;
    for (let o = 0; o < r.length; o++) {
      let u = r[o];
      t[u.name] = u.apply(e, this[u.name], this, t);
    }
    return t;
  }
  /**
  Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
  */
  get tr() {
    return new FP(this);
  }
  /**
  Create a new state.
  */
  static create(e) {
    let t = new rc(e.doc ? e.doc.type.schema : e.schema, e.plugins), r = new ka(t);
    for (let o = 0; o < t.fields.length; o++)
      r[t.fields[o].name] = t.fields[o].init(e, r);
    return r;
  }
  /**
  Create a new state based on this one, but with an adjusted set
  of active plugins. State fields that exist in both sets of
  plugins are kept unchanged. Those that no longer exist are
  dropped, and those that are new are initialized using their
  [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
  configuration object..
  */
  reconfigure(e) {
    let t = new rc(this.schema, e.plugins), r = t.fields, o = new ka(t);
    for (let u = 0; u < r.length; u++) {
      let c = r[u].name;
      o[c] = this.hasOwnProperty(c) ? this[c] : r[u].init(e, o);
    }
    return o;
  }
  /**
  Serialize this state to JSON. If you want to serialize the state
  of plugins, pass an object mapping property names to use in the
  resulting JSON object to plugin objects. The argument may also be
  a string or number, in which case it is ignored, to support the
  way `JSON.stringify` calls `toString` methods.
  */
  toJSON(e) {
    let t = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
    if (this.storedMarks && (t.storedMarks = this.storedMarks.map((r) => r.toJSON())), e && typeof e == "object")
      for (let r in e) {
        if (r == "doc" || r == "selection")
          throw new RangeError("The JSON fields `doc` and `selection` are reserved");
        let o = e[r], u = o.spec.state;
        u && u.toJSON && (t[r] = u.toJSON.call(o, this[o.key]));
      }
    return t;
  }
  /**
  Deserialize a JSON representation of a state. `config` should
  have at least a `schema` field, and should contain array of
  plugins to initialize the state with. `pluginFields` can be used
  to deserialize the state of plugins, by associating plugin
  instances with the property names they use in the JSON object.
  */
  static fromJSON(e, t, r) {
    if (!t)
      throw new RangeError("Invalid input for EditorState.fromJSON");
    if (!e.schema)
      throw new RangeError("Required config field 'schema' missing");
    let o = new rc(e.schema, e.plugins), u = new ka(o);
    return o.fields.forEach((c) => {
      if (c.name == "doc")
        u.doc = ua.fromJSON(e.schema, t.doc);
      else if (c.name == "selection")
        u.selection = en.fromJSON(u.doc, t.selection);
      else if (c.name == "storedMarks")
        t.storedMarks && (u.storedMarks = t.storedMarks.map(e.schema.markFromJSON));
      else {
        if (r)
          for (let l in r) {
            let i = r[l], h = i.spec.state;
            if (i.key == c.name && h && h.fromJSON && Object.prototype.hasOwnProperty.call(t, l)) {
              u[c.name] = h.fromJSON.call(i, e, t[l], u);
              return;
            }
          }
        u[c.name] = c.init(e, u);
      }
    }), u;
  }
}
function Pv(n, e, t) {
  for (let r in n) {
    let o = n[r];
    o instanceof Function ? o = o.bind(e) : r == "handleDOMEvents" && (o = Pv(o, e, {})), t[r] = o;
  }
  return t;
}
class tr {
  /**
  Create a plugin.
  */
  constructor(e) {
    this.spec = e, this.props = {}, e.props && Pv(e.props, this, this.props), this.key = e.key ? e.key.key : Iv("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const ic = /* @__PURE__ */ Object.create(null);
function Iv(n) {
  return n in ic ? n + "$" + ++ic[n] : (ic[n] = 0, n + "$");
}
class zr {
  /**
  Create a plugin key.
  */
  constructor(e = "key") {
    this.key = Iv(e);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(e) {
    return e.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const Bn = function(n) {
  for (var e = 0; ; e++)
    if (n = n.previousSibling, !n)
      return e;
}, ps = function(n) {
  let e = n.assignedSlot || n.parentNode;
  return e && e.nodeType == 11 ? e.host : e;
};
let Jc = null;
const Zr = function(n, e, t) {
  let r = Jc || (Jc = document.createRange());
  return r.setEnd(n, t ?? n.nodeValue.length), r.setStart(n, e || 0), r;
}, kP = function() {
  Jc = null;
}, va = function(n, e, t, r) {
  return t && (hp(n, e, t, r, -1) || hp(n, e, t, r, 1));
}, KP = /^(img|br|input|textarea|hr)$/i;
function hp(n, e, t, r, o) {
  for (; ; ) {
    if (n == t && e == r)
      return !0;
    if (e == (o < 0 ? 0 : Fr(n))) {
      let u = n.parentNode;
      if (!u || u.nodeType != 1 || Ls(n) || KP.test(n.nodeName) || n.contentEditable == "false")
        return !1;
      e = Bn(n) + (o < 0 ? 0 : 1), n = u;
    } else if (n.nodeType == 1) {
      if (n = n.childNodes[e + (o < 0 ? -1 : 0)], n.contentEditable == "false")
        return !1;
      e = o < 0 ? Fr(n) : 0;
    } else
      return !1;
  }
}
function Fr(n) {
  return n.nodeType == 3 ? n.nodeValue.length : n.childNodes.length;
}
function jP(n, e) {
  for (; ; ) {
    if (n.nodeType == 3 && e)
      return n;
    if (n.nodeType == 1 && e > 0) {
      if (n.contentEditable == "false")
        return null;
      n = n.childNodes[e - 1], e = Fr(n);
    } else if (n.parentNode && !Ls(n))
      e = Bn(n), n = n.parentNode;
    else
      return null;
  }
}
function WP(n, e) {
  for (; ; ) {
    if (n.nodeType == 3 && e < n.nodeValue.length)
      return n;
    if (n.nodeType == 1 && e < n.childNodes.length) {
      if (n.contentEditable == "false")
        return null;
      n = n.childNodes[e], e = 0;
    } else if (n.parentNode && !Ls(n))
      e = Bn(n) + 1, n = n.parentNode;
    else
      return null;
  }
}
function VP(n, e, t) {
  for (let r = e == 0, o = e == Fr(n); r || o; ) {
    if (n == t)
      return !0;
    let u = Bn(n);
    if (n = n.parentNode, !n)
      return !1;
    r = r && u == 0, o = o && u == Fr(n);
  }
}
function Ls(n) {
  let e;
  for (let t = n; t && !(e = t.pmViewDesc); t = t.parentNode)
    ;
  return e && e.node && e.node.isBlock && (e.dom == n || e.contentDOM == n);
}
const tu = function(n) {
  return n.focusNode && va(n.focusNode, n.focusOffset, n.anchorNode, n.anchorOffset);
};
function Qi(n, e) {
  let t = document.createEvent("Event");
  return t.initEvent("keydown", !0, !0), t.keyCode = n, t.key = t.code = e, t;
}
function HP(n) {
  let e = n.activeElement;
  for (; e && e.shadowRoot; )
    e = e.shadowRoot.activeElement;
  return e;
}
function $P(n, e, t) {
  if (n.caretPositionFromPoint)
    try {
      let r = n.caretPositionFromPoint(e, t);
      if (r)
        return { node: r.offsetNode, offset: r.offset };
    } catch {
    }
  if (n.caretRangeFromPoint) {
    let r = n.caretRangeFromPoint(e, t);
    if (r)
      return { node: r.startContainer, offset: r.startOffset };
  }
}
const Wr = typeof navigator < "u" ? navigator : null, pp = typeof document < "u" ? document : null, Ui = Wr && Wr.userAgent || "", Zc = /Edge\/(\d+)/.exec(Ui), Nv = /MSIE \d/.exec(Ui), qc = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(Ui), qn = !!(Nv || qc || Zc), Ri = Nv ? document.documentMode : qc ? +qc[1] : Zc ? +Zc[1] : 0, br = !qn && /gecko\/(\d+)/i.test(Ui);
br && +(/Firefox\/(\d+)/.exec(Ui) || [0, 0])[1];
const ef = !qn && /Chrome\/(\d+)/.exec(Ui), $n = !!ef, GP = ef ? +ef[1] : 0, Gn = !qn && !!Wr && /Apple Computer/.test(Wr.vendor), uo = Gn && (/Mobile\/\w+/.test(Ui) || !!Wr && Wr.maxTouchPoints > 2), fr = uo || (Wr ? /Mac/.test(Wr.platform) : !1), zP = Wr ? /Win/.test(Wr.platform) : !1, Tr = /Android \d/.test(Ui), ws = !!pp && "webkitFontSmoothing" in pp.documentElement.style, YP = ws ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function XP(n) {
  let e = n.defaultView && n.defaultView.visualViewport;
  return e ? {
    left: 0,
    right: e.width,
    top: 0,
    bottom: e.height
  } : {
    left: 0,
    right: n.documentElement.clientWidth,
    top: 0,
    bottom: n.documentElement.clientHeight
  };
}
function Qr(n, e) {
  return typeof n == "number" ? n : n[e];
}
function QP(n) {
  let e = n.getBoundingClientRect(), t = e.width / n.offsetWidth || 1, r = e.height / n.offsetHeight || 1;
  return {
    left: e.left,
    right: e.left + n.clientWidth * t,
    top: e.top,
    bottom: e.top + n.clientHeight * r
  };
}
function mp(n, e, t) {
  let r = n.someProp("scrollThreshold") || 0, o = n.someProp("scrollMargin") || 5, u = n.dom.ownerDocument;
  for (let c = t || n.dom; c; c = ps(c)) {
    if (c.nodeType != 1)
      continue;
    let l = c, i = l == u.body, h = i ? XP(u) : QP(l), f = 0, p = 0;
    if (e.top < h.top + Qr(r, "top") ? p = -(h.top - e.top + Qr(o, "top")) : e.bottom > h.bottom - Qr(r, "bottom") && (p = e.bottom - e.top > h.bottom - h.top ? e.top + Qr(o, "top") - h.top : e.bottom - h.bottom + Qr(o, "bottom")), e.left < h.left + Qr(r, "left") ? f = -(h.left - e.left + Qr(o, "left")) : e.right > h.right - Qr(r, "right") && (f = e.right - h.right + Qr(o, "right")), f || p)
      if (i)
        u.defaultView.scrollBy(f, p);
      else {
        let d = l.scrollLeft, v = l.scrollTop;
        p && (l.scrollTop += p), f && (l.scrollLeft += f);
        let g = l.scrollLeft - d, m = l.scrollTop - v;
        e = { left: e.left - g, top: e.top - m, right: e.right - g, bottom: e.bottom - m };
      }
    if (i || /^(fixed|sticky)$/.test(getComputedStyle(c).position))
      break;
  }
}
function JP(n) {
  let e = n.dom.getBoundingClientRect(), t = Math.max(0, e.top), r, o;
  for (let u = (e.left + e.right) / 2, c = t + 1; c < Math.min(innerHeight, e.bottom); c += 5) {
    let l = n.root.elementFromPoint(u, c);
    if (!l || l == n.dom || !n.dom.contains(l))
      continue;
    let i = l.getBoundingClientRect();
    if (i.top >= t - 20) {
      r = l, o = i.top;
      break;
    }
  }
  return { refDOM: r, refTop: o, stack: Lv(n.dom) };
}
function Lv(n) {
  let e = [], t = n.ownerDocument;
  for (let r = n; r && (e.push({ dom: r, top: r.scrollTop, left: r.scrollLeft }), n != t); r = ps(r))
    ;
  return e;
}
function ZP({ refDOM: n, refTop: e, stack: t }) {
  let r = n ? n.getBoundingClientRect().top : 0;
  wv(t, r == 0 ? 0 : r - e);
}
function wv(n, e) {
  for (let t = 0; t < n.length; t++) {
    let { dom: r, top: o, left: u } = n[t];
    r.scrollTop != o + e && (r.scrollTop = o + e), r.scrollLeft != u && (r.scrollLeft = u);
  }
}
let Ra = null;
function qP(n) {
  if (n.setActive)
    return n.setActive();
  if (Ra)
    return n.focus(Ra);
  let e = Lv(n);
  n.focus(Ra == null ? {
    get preventScroll() {
      return Ra = { preventScroll: !0 }, !0;
    }
  } : void 0), Ra || (Ra = !1, wv(e, 0));
}
function xv(n, e) {
  let t, r = 2e8, o, u = 0, c = e.top, l = e.top, i, h;
  for (let f = n.firstChild, p = 0; f; f = f.nextSibling, p++) {
    let d;
    if (f.nodeType == 1)
      d = f.getClientRects();
    else if (f.nodeType == 3)
      d = Zr(f).getClientRects();
    else
      continue;
    for (let v = 0; v < d.length; v++) {
      let g = d[v];
      if (g.top <= c && g.bottom >= l) {
        c = Math.max(g.bottom, c), l = Math.min(g.top, l);
        let m = g.left > e.left ? g.left - e.left : g.right < e.left ? e.left - g.right : 0;
        if (m < r) {
          t = f, r = m, o = m && t.nodeType == 3 ? {
            left: g.right < e.left ? g.right : g.left,
            top: e.top
          } : e, f.nodeType == 1 && m && (u = p + (e.left >= (g.left + g.right) / 2 ? 1 : 0));
          continue;
        }
      } else
        g.top > e.top && !i && g.left <= e.left && g.right >= e.left && (i = f, h = { left: Math.max(g.left, Math.min(g.right, e.left)), top: g.top });
      !t && (e.left >= g.right && e.top >= g.top || e.left >= g.left && e.top >= g.bottom) && (u = p + 1);
    }
  }
  return !t && i && (t = i, o = h, r = 0), t && t.nodeType == 3 ? eI(t, o) : !t || r && t.nodeType == 1 ? { node: n, offset: u } : xv(t, o);
}
function eI(n, e) {
  let t = n.nodeValue.length, r = document.createRange();
  for (let o = 0; o < t; o++) {
    r.setEnd(n, o + 1), r.setStart(n, o);
    let u = hi(r, 1);
    if (u.top != u.bottom && gd(e, u))
      return { node: n, offset: o + (e.left >= (u.left + u.right) / 2 ? 1 : 0) };
  }
  return { node: n, offset: 0 };
}
function gd(n, e) {
  return n.left >= e.left - 1 && n.left <= e.right + 1 && n.top >= e.top - 1 && n.top <= e.bottom + 1;
}
function tI(n, e) {
  let t = n.parentNode;
  return t && /^li$/i.test(t.nodeName) && e.left < n.getBoundingClientRect().left ? t : n;
}
function nI(n, e, t) {
  let { node: r, offset: o } = xv(e, t), u = -1;
  if (r.nodeType == 1 && !r.firstChild) {
    let c = r.getBoundingClientRect();
    u = c.left != c.right && t.left > (c.left + c.right) / 2 ? 1 : -1;
  }
  return n.docView.posFromDOM(r, o, u);
}
function rI(n, e, t, r) {
  let o = -1;
  for (let u = e, c = !1; u != n.dom; ) {
    let l = n.docView.nearestDesc(u, !0);
    if (!l)
      return null;
    if (l.dom.nodeType == 1 && (l.node.isBlock && l.parent && !c || !l.contentDOM)) {
      let i = l.dom.getBoundingClientRect();
      if (l.node.isBlock && l.parent && !c && (c = !0, i.left > r.left || i.top > r.top ? o = l.posBefore : (i.right < r.left || i.bottom < r.top) && (o = l.posAfter)), !l.contentDOM && o < 0 && !l.node.isText)
        return (l.node.isBlock ? r.top < (i.top + i.bottom) / 2 : r.left < (i.left + i.right) / 2) ? l.posBefore : l.posAfter;
    }
    u = l.dom.parentNode;
  }
  return o > -1 ? o : n.docView.posFromDOM(e, t, -1);
}
function Bv(n, e, t) {
  let r = n.childNodes.length;
  if (r && t.top < t.bottom)
    for (let o = Math.max(0, Math.min(r - 1, Math.floor(r * (e.top - t.top) / (t.bottom - t.top)) - 2)), u = o; ; ) {
      let c = n.childNodes[u];
      if (c.nodeType == 1) {
        let l = c.getClientRects();
        for (let i = 0; i < l.length; i++) {
          let h = l[i];
          if (gd(e, h))
            return Bv(c, e, h);
        }
      }
      if ((u = (u + 1) % r) == o)
        break;
    }
  return n;
}
function iI(n, e) {
  let t = n.dom.ownerDocument, r, o = 0, u = $P(t, e.left, e.top);
  u && ({ node: r, offset: o } = u);
  let c = (n.root.elementFromPoint ? n.root : t).elementFromPoint(e.left, e.top), l;
  if (!c || !n.dom.contains(c.nodeType != 1 ? c.parentNode : c)) {
    let h = n.dom.getBoundingClientRect();
    if (!gd(e, h) || (c = Bv(n.dom, e, h), !c))
      return null;
  }
  if (Gn)
    for (let h = c; r && h; h = ps(h))
      h.draggable && (r = void 0);
  if (c = tI(c, e), r) {
    if (br && r.nodeType == 1 && (o = Math.min(o, r.childNodes.length), o < r.childNodes.length)) {
      let f = r.childNodes[o], p;
      f.nodeName == "IMG" && (p = f.getBoundingClientRect()).right <= e.left && p.bottom > e.top && o++;
    }
    let h;
    ws && o && r.nodeType == 1 && (h = r.childNodes[o - 1]).nodeType == 1 && h.contentEditable == "false" && h.getBoundingClientRect().top >= e.top && o--, r == n.dom && o == r.childNodes.length - 1 && r.lastChild.nodeType == 1 && e.top > r.lastChild.getBoundingClientRect().bottom ? l = n.state.doc.content.size : (o == 0 || r.nodeType != 1 || r.childNodes[o - 1].nodeName != "BR") && (l = rI(n, r, o, e));
  }
  l == null && (l = nI(n, c, e));
  let i = n.docView.nearestDesc(c, !0);
  return { pos: l, inside: i ? i.posAtStart - i.border : -1 };
}
function gp(n) {
  return n.top < n.bottom || n.left < n.right;
}
function hi(n, e) {
  let t = n.getClientRects();
  if (t.length) {
    let r = t[e < 0 ? 0 : t.length - 1];
    if (gp(r))
      return r;
  }
  return Array.prototype.find.call(t, gp) || n.getBoundingClientRect();
}
const aI = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function Fv(n, e, t) {
  let { node: r, offset: o, atom: u } = n.docView.domFromPos(e, t < 0 ? -1 : 1), c = ws || br;
  if (r.nodeType == 3)
    if (c && (aI.test(r.nodeValue) || (t < 0 ? !o : o == r.nodeValue.length))) {
      let i = hi(Zr(r, o, o), t);
      if (br && o && /\s/.test(r.nodeValue[o - 1]) && o < r.nodeValue.length) {
        let h = hi(Zr(r, o - 1, o - 1), -1);
        if (h.top == i.top) {
          let f = hi(Zr(r, o, o + 1), -1);
          if (f.top != i.top)
            return No(f, f.left < h.left);
        }
      }
      return i;
    } else {
      let i = o, h = o, f = t < 0 ? 1 : -1;
      return t < 0 && !o ? (h++, f = -1) : t >= 0 && o == r.nodeValue.length ? (i--, f = 1) : t < 0 ? i-- : h++, No(hi(Zr(r, i, h), f), f < 0);
    }
  if (!n.state.doc.resolve(e - (u || 0)).parent.inlineContent) {
    if (u == null && o && (t < 0 || o == Fr(r))) {
      let i = r.childNodes[o - 1];
      if (i.nodeType == 1)
        return ac(i.getBoundingClientRect(), !1);
    }
    if (u == null && o < Fr(r)) {
      let i = r.childNodes[o];
      if (i.nodeType == 1)
        return ac(i.getBoundingClientRect(), !0);
    }
    return ac(r.getBoundingClientRect(), t >= 0);
  }
  if (u == null && o && (t < 0 || o == Fr(r))) {
    let i = r.childNodes[o - 1], h = i.nodeType == 3 ? Zr(i, Fr(i) - (c ? 0 : 1)) : i.nodeType == 1 && (i.nodeName != "BR" || !i.nextSibling) ? i : null;
    if (h)
      return No(hi(h, 1), !1);
  }
  if (u == null && o < Fr(r)) {
    let i = r.childNodes[o];
    for (; i.pmViewDesc && i.pmViewDesc.ignoreForCoords; )
      i = i.nextSibling;
    let h = i ? i.nodeType == 3 ? Zr(i, 0, c ? 0 : 1) : i.nodeType == 1 ? i : null : null;
    if (h)
      return No(hi(h, -1), !0);
  }
  return No(hi(r.nodeType == 3 ? Zr(r) : r, -t), t >= 0);
}
function No(n, e) {
  if (n.width == 0)
    return n;
  let t = e ? n.left : n.right;
  return { top: n.top, bottom: n.bottom, left: t, right: t };
}
function ac(n, e) {
  if (n.height == 0)
    return n;
  let t = e ? n.top : n.bottom;
  return { top: t, bottom: t, left: n.left, right: n.right };
}
function Uv(n, e, t) {
  let r = n.state, o = n.root.activeElement;
  r != e && n.updateState(e), o != n.dom && n.focus();
  try {
    return t();
  } finally {
    r != e && n.updateState(r), o != n.dom && o && o.focus();
  }
}
function oI(n, e, t) {
  let r = e.selection, o = t == "up" ? r.$from : r.$to;
  return Uv(n, e, () => {
    let { node: u } = n.docView.domFromPos(o.pos, t == "up" ? -1 : 1);
    for (; ; ) {
      let l = n.docView.nearestDesc(u, !0);
      if (!l)
        break;
      if (l.node.isBlock) {
        u = l.contentDOM || l.dom;
        break;
      }
      u = l.dom.parentNode;
    }
    let c = Fv(n, o.pos, 1);
    for (let l = u.firstChild; l; l = l.nextSibling) {
      let i;
      if (l.nodeType == 1)
        i = l.getClientRects();
      else if (l.nodeType == 3)
        i = Zr(l, 0, l.nodeValue.length).getClientRects();
      else
        continue;
      for (let h = 0; h < i.length; h++) {
        let f = i[h];
        if (f.bottom > f.top + 1 && (t == "up" ? c.top - f.top > (f.bottom - c.top) * 2 : f.bottom - c.bottom > (c.bottom - f.top) * 2))
          return !1;
      }
    }
    return !0;
  });
}
const sI = /[\u0590-\u08ac]/;
function lI(n, e, t) {
  let { $head: r } = e.selection;
  if (!r.parent.isTextblock)
    return !1;
  let o = r.parentOffset, u = !o, c = o == r.parent.content.size, l = n.domSelection();
  return !sI.test(r.parent.textContent) || !l.modify ? t == "left" || t == "backward" ? u : c : Uv(n, e, () => {
    let { focusNode: i, focusOffset: h, anchorNode: f, anchorOffset: p } = n.domSelectionRange(), d = l.caretBidiLevel;
    l.modify("move", t, "character");
    let v = r.depth ? n.docView.domAfterPos(r.before()) : n.dom, { focusNode: g, focusOffset: m } = n.domSelectionRange(), A = g && !v.contains(g.nodeType == 1 ? g : g.parentNode) || i == g && h == m;
    try {
      l.collapse(f, p), i && (i != f || h != p) && l.extend && l.extend(i, h);
    } catch {
    }
    return d != null && (l.caretBidiLevel = d), A;
  });
}
let vp = null, _p = null, Ep = !1;
function uI(n, e, t) {
  return vp == e && _p == t ? Ep : (vp = e, _p = t, Ep = t == "up" || t == "down" ? oI(n, e, t) : lI(n, e, t));
}
const gr = 0, yp = 1, ea = 2, Vr = 3;
class xs {
  constructor(e, t, r, o) {
    this.parent = e, this.children = t, this.dom = r, this.contentDOM = o, this.dirty = gr, r.pmViewDesc = this;
  }
  // Used to check whether a given description corresponds to a
  // widget/mark/node.
  matchesWidget(e) {
    return !1;
  }
  matchesMark(e) {
    return !1;
  }
  matchesNode(e, t, r) {
    return !1;
  }
  matchesHack(e) {
    return !1;
  }
  // When parsing in-editor content (in domchange.js), we allow
  // descriptions to determine the parse rules that should be used to
  // parse them.
  parseRule() {
    return null;
  }
  // Used by the editor's event handler to ignore events that come
  // from certain descs.
  stopEvent(e) {
    return !1;
  }
  // The size of the content represented by this desc.
  get size() {
    let e = 0;
    for (let t = 0; t < this.children.length; t++)
      e += this.children[t].size;
    return e;
  }
  // For block nodes, this represents the space taken up by their
  // start/end tokens.
  get border() {
    return 0;
  }
  destroy() {
    this.parent = void 0, this.dom.pmViewDesc == this && (this.dom.pmViewDesc = void 0);
    for (let e = 0; e < this.children.length; e++)
      this.children[e].destroy();
  }
  posBeforeChild(e) {
    for (let t = 0, r = this.posAtStart; ; t++) {
      let o = this.children[t];
      if (o == e)
        return r;
      r += o.size;
    }
  }
  get posBefore() {
    return this.parent.posBeforeChild(this);
  }
  get posAtStart() {
    return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
  }
  get posAfter() {
    return this.posBefore + this.size;
  }
  get posAtEnd() {
    return this.posAtStart + this.size - 2 * this.border;
  }
  localPosFromDOM(e, t, r) {
    if (this.contentDOM && this.contentDOM.contains(e.nodeType == 1 ? e : e.parentNode))
      if (r < 0) {
        let u, c;
        if (e == this.contentDOM)
          u = e.childNodes[t - 1];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          u = e.previousSibling;
        }
        for (; u && !((c = u.pmViewDesc) && c.parent == this); )
          u = u.previousSibling;
        return u ? this.posBeforeChild(c) + c.size : this.posAtStart;
      } else {
        let u, c;
        if (e == this.contentDOM)
          u = e.childNodes[t];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          u = e.nextSibling;
        }
        for (; u && !((c = u.pmViewDesc) && c.parent == this); )
          u = u.nextSibling;
        return u ? this.posBeforeChild(c) : this.posAtEnd;
      }
    let o;
    if (e == this.dom && this.contentDOM)
      o = t > Bn(this.contentDOM);
    else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM))
      o = e.compareDocumentPosition(this.contentDOM) & 2;
    else if (this.dom.firstChild) {
      if (t == 0)
        for (let u = e; ; u = u.parentNode) {
          if (u == this.dom) {
            o = !1;
            break;
          }
          if (u.previousSibling)
            break;
        }
      if (o == null && t == e.childNodes.length)
        for (let u = e; ; u = u.parentNode) {
          if (u == this.dom) {
            o = !0;
            break;
          }
          if (u.nextSibling)
            break;
        }
    }
    return o ?? r > 0 ? this.posAtEnd : this.posAtStart;
  }
  nearestDesc(e, t = !1) {
    for (let r = !0, o = e; o; o = o.parentNode) {
      let u = this.getDesc(o), c;
      if (u && (!t || u.node))
        if (r && (c = u.nodeDOM) && !(c.nodeType == 1 ? c.contains(e.nodeType == 1 ? e : e.parentNode) : c == e))
          r = !1;
        else
          return u;
    }
  }
  getDesc(e) {
    let t = e.pmViewDesc;
    for (let r = t; r; r = r.parent)
      if (r == this)
        return t;
  }
  posFromDOM(e, t, r) {
    for (let o = e; o; o = o.parentNode) {
      let u = this.getDesc(o);
      if (u)
        return u.localPosFromDOM(e, t, r);
    }
    return -1;
  }
  // Find the desc for the node after the given pos, if any. (When a
  // parent node overrode rendering, there might not be one.)
  descAt(e) {
    for (let t = 0, r = 0; t < this.children.length; t++) {
      let o = this.children[t], u = r + o.size;
      if (r == e && u != r) {
        for (; !o.border && o.children.length; )
          o = o.children[0];
        return o;
      }
      if (e < u)
        return o.descAt(e - r - o.border);
      r = u;
    }
  }
  domFromPos(e, t) {
    if (!this.contentDOM)
      return { node: this.dom, offset: 0, atom: e + 1 };
    let r = 0, o = 0;
    for (let u = 0; r < this.children.length; r++) {
      let c = this.children[r], l = u + c.size;
      if (l > e || c instanceof Kv) {
        o = e - u;
        break;
      }
      u = l;
    }
    if (o)
      return this.children[r].domFromPos(o - this.children[r].border, t);
    for (let u; r && !(u = this.children[r - 1]).size && u instanceof kv && u.side >= 0; r--)
      ;
    if (t <= 0) {
      let u, c = !0;
      for (; u = r ? this.children[r - 1] : null, !(!u || u.dom.parentNode == this.contentDOM); r--, c = !1)
        ;
      return u && t && c && !u.border && !u.domAtom ? u.domFromPos(u.size, t) : { node: this.contentDOM, offset: u ? Bn(u.dom) + 1 : 0 };
    } else {
      let u, c = !0;
      for (; u = r < this.children.length ? this.children[r] : null, !(!u || u.dom.parentNode == this.contentDOM); r++, c = !1)
        ;
      return u && c && !u.border && !u.domAtom ? u.domFromPos(0, t) : { node: this.contentDOM, offset: u ? Bn(u.dom) : this.contentDOM.childNodes.length };
    }
  }
  // Used to find a DOM range in a single parent for a given changed
  // range.
  parseRange(e, t, r = 0) {
    if (this.children.length == 0)
      return { node: this.contentDOM, from: e, to: t, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
    let o = -1, u = -1;
    for (let c = r, l = 0; ; l++) {
      let i = this.children[l], h = c + i.size;
      if (o == -1 && e <= h) {
        let f = c + i.border;
        if (e >= f && t <= h - i.border && i.node && i.contentDOM && this.contentDOM.contains(i.contentDOM))
          return i.parseRange(e, t, f);
        e = c;
        for (let p = l; p > 0; p--) {
          let d = this.children[p - 1];
          if (d.size && d.dom.parentNode == this.contentDOM && !d.emptyChildAt(1)) {
            o = Bn(d.dom) + 1;
            break;
          }
          e -= d.size;
        }
        o == -1 && (o = 0);
      }
      if (o > -1 && (h > t || l == this.children.length - 1)) {
        t = h;
        for (let f = l + 1; f < this.children.length; f++) {
          let p = this.children[f];
          if (p.size && p.dom.parentNode == this.contentDOM && !p.emptyChildAt(-1)) {
            u = Bn(p.dom);
            break;
          }
          t += p.size;
        }
        u == -1 && (u = this.contentDOM.childNodes.length);
        break;
      }
      c = h;
    }
    return { node: this.contentDOM, from: e, to: t, fromOffset: o, toOffset: u };
  }
  emptyChildAt(e) {
    if (this.border || !this.contentDOM || !this.children.length)
      return !1;
    let t = this.children[e < 0 ? 0 : this.children.length - 1];
    return t.size == 0 || t.emptyChildAt(e);
  }
  domAfterPos(e) {
    let { node: t, offset: r } = this.domFromPos(e, 0);
    if (t.nodeType != 1 || r == t.childNodes.length)
      throw new RangeError("No node after pos " + e);
    return t.childNodes[r];
  }
  // View descs are responsible for setting any selection that falls
  // entirely inside of them, so that custom implementations can do
  // custom things with the selection. Note that this falls apart when
  // a selection starts in such a node and ends in another, in which
  // case we just use whatever domFromPos produces as a best effort.
  setSelection(e, t, r, o = !1) {
    let u = Math.min(e, t), c = Math.max(e, t);
    for (let d = 0, v = 0; d < this.children.length; d++) {
      let g = this.children[d], m = v + g.size;
      if (u > v && c < m)
        return g.setSelection(e - v - g.border, t - v - g.border, r, o);
      v = m;
    }
    let l = this.domFromPos(e, e ? -1 : 1), i = t == e ? l : this.domFromPos(t, t ? -1 : 1), h = r.getSelection(), f = !1;
    if ((br || Gn) && e == t) {
      let { node: d, offset: v } = l;
      if (d.nodeType == 3) {
        if (f = !!(v && d.nodeValue[v - 1] == `
`), f && v == d.nodeValue.length)
          for (let g = d, m; g; g = g.parentNode) {
            if (m = g.nextSibling) {
              m.nodeName == "BR" && (l = i = { node: m.parentNode, offset: Bn(m) + 1 });
              break;
            }
            let A = g.pmViewDesc;
            if (A && A.node && A.node.isBlock)
              break;
          }
      } else {
        let g = d.childNodes[v - 1];
        f = g && (g.nodeName == "BR" || g.contentEditable == "false");
      }
    }
    if (br && h.focusNode && h.focusNode != i.node && h.focusNode.nodeType == 1) {
      let d = h.focusNode.childNodes[h.focusOffset];
      d && d.contentEditable == "false" && (o = !0);
    }
    if (!(o || f && Gn) && va(l.node, l.offset, h.anchorNode, h.anchorOffset) && va(i.node, i.offset, h.focusNode, h.focusOffset))
      return;
    let p = !1;
    if ((h.extend || e == t) && !f) {
      h.collapse(l.node, l.offset);
      try {
        e != t && h.extend(i.node, i.offset), p = !0;
      } catch {
      }
    }
    if (!p) {
      if (e > t) {
        let v = l;
        l = i, i = v;
      }
      let d = document.createRange();
      d.setEnd(i.node, i.offset), d.setStart(l.node, l.offset), h.removeAllRanges(), h.addRange(d);
    }
  }
  ignoreMutation(e) {
    return !this.contentDOM && e.type != "selection";
  }
  get contentLost() {
    return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
  }
  // Remove a subtree of the element tree that has been touched
  // by a DOM change, so that the next update will redraw it.
  markDirty(e, t) {
    for (let r = 0, o = 0; o < this.children.length; o++) {
      let u = this.children[o], c = r + u.size;
      if (r == c ? e <= c && t >= r : e < c && t > r) {
        let l = r + u.border, i = c - u.border;
        if (e >= l && t <= i) {
          this.dirty = e == r || t == c ? ea : yp, e == l && t == i && (u.contentLost || u.dom.parentNode != this.contentDOM) ? u.dirty = Vr : u.markDirty(e - l, t - l);
          return;
        } else
          u.dirty = u.dom == u.contentDOM && u.dom.parentNode == this.contentDOM && !u.children.length ? ea : Vr;
      }
      r = c;
    }
    this.dirty = ea;
  }
  markParentsDirty() {
    let e = 1;
    for (let t = this.parent; t; t = t.parent, e++) {
      let r = e == 1 ? ea : yp;
      t.dirty < r && (t.dirty = r);
    }
  }
  get domAtom() {
    return !1;
  }
  get ignoreForCoords() {
    return !1;
  }
  isText(e) {
    return !1;
  }
}
class kv extends xs {
  constructor(e, t, r, o) {
    let u, c = t.type.toDOM;
    if (typeof c == "function" && (c = c(r, () => {
      if (!u)
        return o;
      if (u.parent)
        return u.parent.posBeforeChild(u);
    })), !t.type.spec.raw) {
      if (c.nodeType != 1) {
        let l = document.createElement("span");
        l.appendChild(c), c = l;
      }
      c.contentEditable = "false", c.classList.add("ProseMirror-widget");
    }
    super(e, [], c, null), this.widget = t, this.widget = t, u = this;
  }
  matchesWidget(e) {
    return this.dirty == gr && e.type.eq(this.widget.type);
  }
  parseRule() {
    return { ignore: !0 };
  }
  stopEvent(e) {
    let t = this.widget.spec.stopEvent;
    return t ? t(e) : !1;
  }
  ignoreMutation(e) {
    return e.type != "selection" || this.widget.spec.ignoreSelection;
  }
  destroy() {
    this.widget.type.destroy(this.dom), super.destroy();
  }
  get domAtom() {
    return !0;
  }
  get side() {
    return this.widget.type.side;
  }
}
class cI extends xs {
  constructor(e, t, r, o) {
    super(e, [], t, null), this.textDOM = r, this.text = o;
  }
  get size() {
    return this.text.length;
  }
  localPosFromDOM(e, t) {
    return e != this.textDOM ? this.posAtStart + (t ? this.size : 0) : this.posAtStart + t;
  }
  domFromPos(e) {
    return { node: this.textDOM, offset: e };
  }
  ignoreMutation(e) {
    return e.type === "characterData" && e.target.nodeValue == e.oldValue;
  }
}
class _a extends xs {
  constructor(e, t, r, o) {
    super(e, [], r, o), this.mark = t;
  }
  static create(e, t, r, o) {
    let u = o.nodeViews[t.type.name], c = u && u(t, o, r);
    return (!c || !c.dom) && (c = Ur.renderSpec(document, t.type.spec.toDOM(t, r))), new _a(e, t, c.dom, c.contentDOM || c.dom);
  }
  parseRule() {
    return this.dirty & Vr || this.mark.type.spec.reparseInView ? null : { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
  }
  matchesMark(e) {
    return this.dirty != Vr && this.mark.eq(e);
  }
  markDirty(e, t) {
    if (super.markDirty(e, t), this.dirty != gr) {
      let r = this.parent;
      for (; !r.node; )
        r = r.parent;
      r.dirty < this.dirty && (r.dirty = this.dirty), this.dirty = gr;
    }
  }
  slice(e, t, r) {
    let o = _a.create(this.parent, this.mark, !0, r), u = this.children, c = this.size;
    t < c && (u = rf(u, t, c, r)), e > 0 && (u = rf(u, 0, e, r));
    for (let l = 0; l < u.length; l++)
      u[l].parent = o;
    return o.children = u, o;
  }
}
class Di extends xs {
  constructor(e, t, r, o, u, c, l, i, h) {
    super(e, [], u, c), this.node = t, this.outerDeco = r, this.innerDeco = o, this.nodeDOM = l;
  }
  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finicky
  // implementation details to the user code that they probably will
  // never need.)
  static create(e, t, r, o, u, c) {
    let l = u.nodeViews[t.type.name], i, h = l && l(t, u, () => {
      if (!i)
        return c;
      if (i.parent)
        return i.parent.posBeforeChild(i);
    }, r, o), f = h && h.dom, p = h && h.contentDOM;
    if (t.isText) {
      if (!f)
        f = document.createTextNode(t.text);
      else if (f.nodeType != 3)
        throw new RangeError("Text must be rendered as a DOM text node");
    } else
      f || ({ dom: f, contentDOM: p } = Ur.renderSpec(document, t.type.spec.toDOM(t)));
    !p && !t.isText && f.nodeName != "BR" && (f.hasAttribute("contenteditable") || (f.contentEditable = "false"), t.type.spec.draggable && (f.draggable = !0));
    let d = f;
    return f = Vv(f, r, t), h ? i = new fI(e, t, r, o, f, p || null, d, h, u, c + 1) : t.isText ? new nu(e, t, r, o, f, d, u) : new Di(e, t, r, o, f, p || null, d, u, c + 1);
  }
  parseRule() {
    if (this.node.type.spec.reparseInView)
      return null;
    let e = { node: this.node.type.name, attrs: this.node.attrs };
    if (this.node.type.whitespace == "pre" && (e.preserveWhitespace = "full"), !this.contentDOM)
      e.getContent = () => this.node.content;
    else if (!this.contentLost)
      e.contentElement = this.contentDOM;
    else {
      for (let t = this.children.length - 1; t >= 0; t--) {
        let r = this.children[t];
        if (this.dom.contains(r.dom.parentNode)) {
          e.contentElement = r.dom.parentNode;
          break;
        }
      }
      e.contentElement || (e.getContent = () => Tt.empty);
    }
    return e;
  }
  matchesNode(e, t, r) {
    return this.dirty == gr && e.eq(this.node) && nf(t, this.outerDeco) && r.eq(this.innerDeco);
  }
  get size() {
    return this.node.nodeSize;
  }
  get border() {
    return this.node.isLeaf ? 0 : 1;
  }
  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  updateChildren(e, t) {
    let r = this.node.inlineContent, o = t, u = e.composing ? this.localCompositionInfo(e, t) : null, c = u && u.pos > -1 ? u : null, l = u && u.pos < 0, i = new hI(this, c && c.node, e);
    gI(this.node, this.innerDeco, (h, f, p) => {
      h.spec.marks ? i.syncToMarks(h.spec.marks, r, e) : h.type.side >= 0 && !p && i.syncToMarks(f == this.node.childCount ? hn.none : this.node.child(f).marks, r, e), i.placeWidget(h, e, o);
    }, (h, f, p, d) => {
      i.syncToMarks(h.marks, r, e);
      let v;
      i.findNodeMatch(h, f, p, d) || l && e.state.selection.from > o && e.state.selection.to < o + h.nodeSize && (v = i.findIndexWithChild(u.node)) > -1 && i.updateNodeAt(h, f, p, v, e) || i.updateNextNode(h, f, p, e, d, o) || i.addNode(h, f, p, e, o), o += h.nodeSize;
    }), i.syncToMarks([], r, e), this.node.isTextblock && i.addTextblockHacks(), i.destroyRest(), (i.changed || this.dirty == ea) && (c && this.protectLocalComposition(e, c), jv(this.contentDOM, this.children, e), uo && vI(this.dom));
  }
  localCompositionInfo(e, t) {
    let { from: r, to: o } = e.state.selection;
    if (!(e.state.selection instanceof Zt) || r < t || o > t + this.node.content.size)
      return null;
    let u = e.input.compositionNode;
    if (!u || !this.dom.contains(u.parentNode))
      return null;
    if (this.node.inlineContent) {
      let c = u.nodeValue, l = _I(this.node.content, c, r - t, o - t);
      return l < 0 ? null : { node: u, pos: l, text: c };
    } else
      return { node: u, pos: -1, text: "" };
  }
  protectLocalComposition(e, { node: t, pos: r, text: o }) {
    if (this.getDesc(t))
      return;
    let u = t;
    for (; u.parentNode != this.contentDOM; u = u.parentNode) {
      for (; u.previousSibling; )
        u.parentNode.removeChild(u.previousSibling);
      for (; u.nextSibling; )
        u.parentNode.removeChild(u.nextSibling);
      u.pmViewDesc && (u.pmViewDesc = void 0);
    }
    let c = new cI(this, u, t, o);
    e.input.compositionNodes.push(c), this.children = rf(this.children, r, r + o.length, e, c);
  }
  // If this desc must be updated to match the given node decoration,
  // do so and return true.
  update(e, t, r, o) {
    return this.dirty == Vr || !e.sameMarkup(this.node) ? !1 : (this.updateInner(e, t, r, o), !0);
  }
  updateInner(e, t, r, o) {
    this.updateOuterDeco(t), this.node = e, this.innerDeco = r, this.contentDOM && this.updateChildren(o, this.posAtStart), this.dirty = gr;
  }
  updateOuterDeco(e) {
    if (nf(e, this.outerDeco))
      return;
    let t = this.nodeDOM.nodeType != 1, r = this.dom;
    this.dom = Wv(this.dom, this.nodeDOM, tf(this.outerDeco, this.node, t), tf(e, this.node, t)), this.dom != r && (r.pmViewDesc = void 0, this.dom.pmViewDesc = this), this.outerDeco = e;
  }
  // Mark this node as being the selected node.
  selectNode() {
    this.nodeDOM.nodeType == 1 && this.nodeDOM.classList.add("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && (this.dom.draggable = !0);
  }
  // Remove selected node marking from this node.
  deselectNode() {
    this.nodeDOM.nodeType == 1 && this.nodeDOM.classList.remove("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && this.dom.removeAttribute("draggable");
  }
  get domAtom() {
    return this.node.isAtom;
  }
}
function Tp(n, e, t, r, o) {
  Vv(r, e, n);
  let u = new Di(void 0, n, e, t, r, r, r, o, 0);
  return u.contentDOM && u.updateChildren(o, 0), u;
}
class nu extends Di {
  constructor(e, t, r, o, u, c, l) {
    super(e, t, r, o, u, null, c, l, 0);
  }
  parseRule() {
    let e = this.nodeDOM.parentNode;
    for (; e && e != this.dom && !e.pmIsDeco; )
      e = e.parentNode;
    return { skip: e || !0 };
  }
  update(e, t, r, o) {
    return this.dirty == Vr || this.dirty != gr && !this.inParent() || !e.sameMarkup(this.node) ? !1 : (this.updateOuterDeco(t), (this.dirty != gr || e.text != this.node.text) && e.text != this.nodeDOM.nodeValue && (this.nodeDOM.nodeValue = e.text, o.trackWrites == this.nodeDOM && (o.trackWrites = null)), this.node = e, this.dirty = gr, !0);
  }
  inParent() {
    let e = this.parent.contentDOM;
    for (let t = this.nodeDOM; t; t = t.parentNode)
      if (t == e)
        return !0;
    return !1;
  }
  domFromPos(e) {
    return { node: this.nodeDOM, offset: e };
  }
  localPosFromDOM(e, t, r) {
    return e == this.nodeDOM ? this.posAtStart + Math.min(t, this.node.text.length) : super.localPosFromDOM(e, t, r);
  }
  ignoreMutation(e) {
    return e.type != "characterData" && e.type != "selection";
  }
  slice(e, t, r) {
    let o = this.node.cut(e, t), u = document.createTextNode(o.text);
    return new nu(this.parent, o, this.outerDeco, this.innerDeco, u, u, r);
  }
  markDirty(e, t) {
    super.markDirty(e, t), this.dom != this.nodeDOM && (e == 0 || t == this.nodeDOM.nodeValue.length) && (this.dirty = Vr);
  }
  get domAtom() {
    return !1;
  }
  isText(e) {
    return this.node.text == e;
  }
}
class Kv extends xs {
  parseRule() {
    return { ignore: !0 };
  }
  matchesHack(e) {
    return this.dirty == gr && this.dom.nodeName == e;
  }
  get domAtom() {
    return !0;
  }
  get ignoreForCoords() {
    return this.dom.nodeName == "IMG";
  }
}
class fI extends Di {
  constructor(e, t, r, o, u, c, l, i, h, f) {
    super(e, t, r, o, u, c, l, h, f), this.spec = i;
  }
  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  update(e, t, r, o) {
    if (this.dirty == Vr)
      return !1;
    if (this.spec.update) {
      let u = this.spec.update(e, t, r);
      return u && this.updateInner(e, t, r, o), u;
    } else
      return !this.contentDOM && !e.isLeaf ? !1 : super.update(e, t, r, o);
  }
  selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
  }
  deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
  }
  setSelection(e, t, r, o) {
    this.spec.setSelection ? this.spec.setSelection(e, t, r) : super.setSelection(e, t, r, o);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
  stopEvent(e) {
    return this.spec.stopEvent ? this.spec.stopEvent(e) : !1;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
}
function jv(n, e, t) {
  let r = n.firstChild, o = !1;
  for (let u = 0; u < e.length; u++) {
    let c = e[u], l = c.dom;
    if (l.parentNode == n) {
      for (; l != r; )
        r = Ap(r), o = !0;
      r = r.nextSibling;
    } else
      o = !0, n.insertBefore(l, r);
    if (c instanceof _a) {
      let i = r ? r.previousSibling : n.lastChild;
      jv(c.contentDOM, c.children, t), r = i ? i.nextSibling : n.firstChild;
    }
  }
  for (; r; )
    r = Ap(r), o = !0;
  o && t.trackWrites == n && (t.trackWrites = null);
}
const Qo = function(n) {
  n && (this.nodeName = n);
};
Qo.prototype = /* @__PURE__ */ Object.create(null);
const ta = [new Qo()];
function tf(n, e, t) {
  if (n.length == 0)
    return ta;
  let r = t ? ta[0] : new Qo(), o = [r];
  for (let u = 0; u < n.length; u++) {
    let c = n[u].type.attrs;
    if (c) {
      c.nodeName && o.push(r = new Qo(c.nodeName));
      for (let l in c) {
        let i = c[l];
        i != null && (t && o.length == 1 && o.push(r = new Qo(e.isInline ? "span" : "div")), l == "class" ? r.class = (r.class ? r.class + " " : "") + i : l == "style" ? r.style = (r.style ? r.style + ";" : "") + i : l != "nodeName" && (r[l] = i));
      }
    }
  }
  return o;
}
function Wv(n, e, t, r) {
  if (t == ta && r == ta)
    return e;
  let o = e;
  for (let u = 0; u < r.length; u++) {
    let c = r[u], l = t[u];
    if (u) {
      let i;
      l && l.nodeName == c.nodeName && o != n && (i = o.parentNode) && i.nodeName.toLowerCase() == c.nodeName || (i = document.createElement(c.nodeName), i.pmIsDeco = !0, i.appendChild(o), l = ta[0]), o = i;
    }
    dI(o, l || ta[0], c);
  }
  return o;
}
function dI(n, e, t) {
  for (let r in e)
    r != "class" && r != "style" && r != "nodeName" && !(r in t) && n.removeAttribute(r);
  for (let r in t)
    r != "class" && r != "style" && r != "nodeName" && t[r] != e[r] && n.setAttribute(r, t[r]);
  if (e.class != t.class) {
    let r = e.class ? e.class.split(" ").filter(Boolean) : [], o = t.class ? t.class.split(" ").filter(Boolean) : [];
    for (let u = 0; u < r.length; u++)
      o.indexOf(r[u]) == -1 && n.classList.remove(r[u]);
    for (let u = 0; u < o.length; u++)
      r.indexOf(o[u]) == -1 && n.classList.add(o[u]);
    n.classList.length == 0 && n.removeAttribute("class");
  }
  if (e.style != t.style) {
    if (e.style) {
      let r = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, o;
      for (; o = r.exec(e.style); )
        n.style.removeProperty(o[1]);
    }
    t.style && (n.style.cssText += t.style);
  }
}
function Vv(n, e, t) {
  return Wv(n, n, ta, tf(e, t, n.nodeType != 1));
}
function nf(n, e) {
  if (n.length != e.length)
    return !1;
  for (let t = 0; t < n.length; t++)
    if (!n[t].type.eq(e[t].type))
      return !1;
  return !0;
}
function Ap(n) {
  let e = n.nextSibling;
  return n.parentNode.removeChild(n), e;
}
class hI {
  constructor(e, t, r) {
    this.lock = t, this.view = r, this.index = 0, this.stack = [], this.changed = !1, this.top = e, this.preMatch = pI(e.node.content, e);
  }
  // Destroy and remove the children between the given indices in
  // `this.top`.
  destroyBetween(e, t) {
    if (e != t) {
      for (let r = e; r < t; r++)
        this.top.children[r].destroy();
      this.top.children.splice(e, t - e), this.changed = !0;
    }
  }
  // Destroy all remaining children in `this.top`.
  destroyRest() {
    this.destroyBetween(this.index, this.top.children.length);
  }
  // Sync the current stack of mark descs with the given array of
  // marks, reusing existing mark descs when possible.
  syncToMarks(e, t, r) {
    let o = 0, u = this.stack.length >> 1, c = Math.min(u, e.length);
    for (; o < c && (o == u - 1 ? this.top : this.stack[o + 1 << 1]).matchesMark(e[o]) && e[o].type.spec.spanning !== !1; )
      o++;
    for (; o < u; )
      this.destroyRest(), this.top.dirty = gr, this.index = this.stack.pop(), this.top = this.stack.pop(), u--;
    for (; u < e.length; ) {
      this.stack.push(this.top, this.index + 1);
      let l = -1;
      for (let i = this.index; i < Math.min(this.index + 3, this.top.children.length); i++) {
        let h = this.top.children[i];
        if (h.matchesMark(e[u]) && !this.isLocked(h.dom)) {
          l = i;
          break;
        }
      }
      if (l > -1)
        l > this.index && (this.changed = !0, this.destroyBetween(this.index, l)), this.top = this.top.children[this.index];
      else {
        let i = _a.create(this.top, e[u], t, r);
        this.top.children.splice(this.index, 0, i), this.top = i, this.changed = !0;
      }
      this.index = 0, u++;
    }
  }
  // Try to find a node desc matching the given data. Skip over it and
  // return true when successful.
  findNodeMatch(e, t, r, o) {
    let u = -1, c;
    if (o >= this.preMatch.index && (c = this.preMatch.matches[o - this.preMatch.index]).parent == this.top && c.matchesNode(e, t, r))
      u = this.top.children.indexOf(c, this.index);
    else
      for (let l = this.index, i = Math.min(this.top.children.length, l + 5); l < i; l++) {
        let h = this.top.children[l];
        if (h.matchesNode(e, t, r) && !this.preMatch.matched.has(h)) {
          u = l;
          break;
        }
      }
    return u < 0 ? !1 : (this.destroyBetween(this.index, u), this.index++, !0);
  }
  updateNodeAt(e, t, r, o, u) {
    let c = this.top.children[o];
    return c.dirty == Vr && c.dom == c.contentDOM && (c.dirty = ea), c.update(e, t, r, u) ? (this.destroyBetween(this.index, o), this.index++, !0) : !1;
  }
  findIndexWithChild(e) {
    for (; ; ) {
      let t = e.parentNode;
      if (!t)
        return -1;
      if (t == this.top.contentDOM) {
        let r = e.pmViewDesc;
        if (r) {
          for (let o = this.index; o < this.top.children.length; o++)
            if (this.top.children[o] == r)
              return o;
        }
        return -1;
      }
      e = t;
    }
  }
  // Try to update the next node, if any, to the given data. Checks
  // pre-matches to avoid overwriting nodes that could still be used.
  updateNextNode(e, t, r, o, u, c) {
    for (let l = this.index; l < this.top.children.length; l++) {
      let i = this.top.children[l];
      if (i instanceof Di) {
        let h = this.preMatch.matched.get(i);
        if (h != null && h != u)
          return !1;
        let f = i.dom, p, d = this.isLocked(f) && !(e.isText && i.node && i.node.isText && i.nodeDOM.nodeValue == e.text && i.dirty != Vr && nf(t, i.outerDeco));
        if (!d && i.update(e, t, r, o))
          return this.destroyBetween(this.index, l), i.dom != f && (this.changed = !0), this.index++, !0;
        if (!d && (p = this.recreateWrapper(i, e, t, r, o, c)))
          return this.top.children[this.index] = p, p.contentDOM && (p.dirty = ea, p.updateChildren(o, c + 1), p.dirty = gr), this.changed = !0, this.index++, !0;
        break;
      }
    }
    return !1;
  }
  // When a node with content is replaced by a different node with
  // identical content, move over its children.
  recreateWrapper(e, t, r, o, u, c) {
    if (e.dirty || t.isAtom || !e.children.length || !e.node.content.eq(t.content))
      return null;
    let l = Di.create(this.top, t, r, o, u, c);
    if (l.contentDOM) {
      l.children = e.children, e.children = [];
      for (let i of l.children)
        i.parent = l;
    }
    return e.destroy(), l;
  }
  // Insert the node as a newly created node desc.
  addNode(e, t, r, o, u) {
    let c = Di.create(this.top, e, t, r, o, u);
    c.contentDOM && c.updateChildren(o, u + 1), this.top.children.splice(this.index++, 0, c), this.changed = !0;
  }
  placeWidget(e, t, r) {
    let o = this.index < this.top.children.length ? this.top.children[this.index] : null;
    if (o && o.matchesWidget(e) && (e == o.widget || !o.widget.type.toDOM.parentNode))
      this.index++;
    else {
      let u = new kv(this.top, e, t, r);
      this.top.children.splice(this.index++, 0, u), this.changed = !0;
    }
  }
  // Make sure a textblock looks and behaves correctly in
  // contentEditable.
  addTextblockHacks() {
    let e = this.top.children[this.index - 1], t = this.top;
    for (; e instanceof _a; )
      t = e, e = t.children[t.children.length - 1];
    (!e || // Empty textblock
    !(e instanceof nu) || /\n$/.test(e.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(e.node.text)) && ((Gn || $n) && e && e.dom.contentEditable == "false" && this.addHackNode("IMG", t), this.addHackNode("BR", this.top));
  }
  addHackNode(e, t) {
    if (t == this.top && this.index < t.children.length && t.children[this.index].matchesHack(e))
      this.index++;
    else {
      let r = document.createElement(e);
      e == "IMG" && (r.className = "ProseMirror-separator", r.alt = ""), e == "BR" && (r.className = "ProseMirror-trailingBreak");
      let o = new Kv(this.top, [], r, null);
      t != this.top ? t.children.push(o) : t.children.splice(this.index++, 0, o), this.changed = !0;
    }
  }
  isLocked(e) {
    return this.lock && (e == this.lock || e.nodeType == 1 && e.contains(this.lock.parentNode));
  }
}
function pI(n, e) {
  let t = e, r = t.children.length, o = n.childCount, u = /* @__PURE__ */ new Map(), c = [];
  e:
    for (; o > 0; ) {
      let l;
      for (; ; )
        if (r) {
          let h = t.children[r - 1];
          if (h instanceof _a)
            t = h, r = h.children.length;
          else {
            l = h, r--;
            break;
          }
        } else {
          if (t == e)
            break e;
          r = t.parent.children.indexOf(t), t = t.parent;
        }
      let i = l.node;
      if (i) {
        if (i != n.child(o - 1))
          break;
        --o, u.set(l, o), c.push(l);
      }
    }
  return { index: o, matched: u, matches: c.reverse() };
}
function mI(n, e) {
  return n.type.side - e.type.side;
}
function gI(n, e, t, r) {
  let o = e.locals(n), u = 0;
  if (o.length == 0) {
    for (let h = 0; h < n.childCount; h++) {
      let f = n.child(h);
      r(f, o, e.forChild(u, f), h), u += f.nodeSize;
    }
    return;
  }
  let c = 0, l = [], i = null;
  for (let h = 0; ; ) {
    let f, p;
    for (; c < o.length && o[c].to == u; ) {
      let A = o[c++];
      A.widget && (f ? (p || (p = [f])).push(A) : f = A);
    }
    if (f)
      if (p) {
        p.sort(mI);
        for (let A = 0; A < p.length; A++)
          t(p[A], h, !!i);
      } else
        t(f, h, !!i);
    let d, v;
    if (i)
      v = -1, d = i, i = null;
    else if (h < n.childCount)
      v = h, d = n.child(h++);
    else
      break;
    for (let A = 0; A < l.length; A++)
      l[A].to <= u && l.splice(A--, 1);
    for (; c < o.length && o[c].from <= u && o[c].to > u; )
      l.push(o[c++]);
    let g = u + d.nodeSize;
    if (d.isText) {
      let A = g;
      c < o.length && o[c].from < A && (A = o[c].from);
      for (let b = 0; b < l.length; b++)
        l[b].to < A && (A = l[b].to);
      A < g && (i = d.cut(A - u), d = d.cut(0, A - u), g = A, v = -1);
    } else
      for (; c < o.length && o[c].to < g; )
        c++;
    let m = d.isInline && !d.isLeaf ? l.filter((A) => !A.inline) : l.slice();
    r(d, m, e.forChild(u, d), v), u = g;
  }
}
function vI(n) {
  if (n.nodeName == "UL" || n.nodeName == "OL") {
    let e = n.style.cssText;
    n.style.cssText = e + "; list-style: square !important", window.getComputedStyle(n).listStyle, n.style.cssText = e;
  }
}
function _I(n, e, t, r) {
  for (let o = 0, u = 0; o < n.childCount && u <= r; ) {
    let c = n.child(o++), l = u;
    if (u += c.nodeSize, !c.isText)
      continue;
    let i = c.text;
    for (; o < n.childCount; ) {
      let h = n.child(o++);
      if (u += h.nodeSize, !h.isText)
        break;
      i += h.text;
    }
    if (u >= t) {
      if (u >= r && i.slice(r - e.length - l, r - l) == e)
        return r - e.length;
      let h = l < r ? i.lastIndexOf(e, r - l - 1) : -1;
      if (h >= 0 && h + e.length + l >= t)
        return l + h;
      if (t == r && i.length >= r + e.length - l && i.slice(r - l, r - l + e.length) == e)
        return r;
    }
  }
  return -1;
}
function rf(n, e, t, r, o) {
  let u = [];
  for (let c = 0, l = 0; c < n.length; c++) {
    let i = n[c], h = l, f = l += i.size;
    h >= t || f <= e ? u.push(i) : (h < e && u.push(i.slice(0, e - h, r)), o && (u.push(o), o = void 0), f > t && u.push(i.slice(t - h, i.size, r)));
  }
  return u;
}
function vd(n, e = null) {
  let t = n.domSelectionRange(), r = n.state.doc;
  if (!t.focusNode)
    return null;
  let o = n.docView.nearestDesc(t.focusNode), u = o && o.size == 0, c = n.docView.posFromDOM(t.focusNode, t.focusOffset, 1);
  if (c < 0)
    return null;
  let l = r.resolve(c), i, h;
  if (tu(t)) {
    for (i = l; o && !o.node; )
      o = o.parent;
    let f = o.node;
    if (o && f.isAtom && $t.isSelectable(f) && o.parent && !(f.isInline && VP(t.focusNode, t.focusOffset, o.dom))) {
      let p = o.posBefore;
      h = new $t(c == p ? l : r.resolve(p));
    }
  } else {
    let f = n.docView.posFromDOM(t.anchorNode, t.anchorOffset, 1);
    if (f < 0)
      return null;
    i = r.resolve(f);
  }
  if (!h) {
    let f = e == "pointer" || n.state.selection.head < l.pos && !u ? 1 : -1;
    h = _d(n, i, l, f);
  }
  return h;
}
function Hv(n) {
  return n.editable ? n.hasFocus() : Gv(n) && document.activeElement && document.activeElement.contains(n.dom);
}
function ri(n, e = !1) {
  let t = n.state.selection;
  if ($v(n, t), !!Hv(n)) {
    if (!e && n.input.mouseDown && n.input.mouseDown.allowDefault && $n) {
      let r = n.domSelectionRange(), o = n.domObserver.currentSelection;
      if (r.anchorNode && o.anchorNode && va(r.anchorNode, r.anchorOffset, o.anchorNode, o.anchorOffset)) {
        n.input.mouseDown.delayedSelectionSync = !0, n.domObserver.setCurSelection();
        return;
      }
    }
    if (n.domObserver.disconnectSelection(), n.cursorWrapper)
      yI(n);
    else {
      let { anchor: r, head: o } = t, u, c;
      Sp && !(t instanceof Zt) && (t.$from.parent.inlineContent || (u = Cp(n, t.from)), !t.empty && !t.$from.parent.inlineContent && (c = Cp(n, t.to))), n.docView.setSelection(r, o, n.root, e), Sp && (u && Mp(u), c && Mp(c)), t.visible ? n.dom.classList.remove("ProseMirror-hideselection") : (n.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && EI(n));
    }
    n.domObserver.setCurSelection(), n.domObserver.connectSelection();
  }
}
const Sp = Gn || $n && GP < 63;
function Cp(n, e) {
  let { node: t, offset: r } = n.docView.domFromPos(e, 0), o = r < t.childNodes.length ? t.childNodes[r] : null, u = r ? t.childNodes[r - 1] : null;
  if (Gn && o && o.contentEditable == "false")
    return oc(o);
  if ((!o || o.contentEditable == "false") && (!u || u.contentEditable == "false")) {
    if (o)
      return oc(o);
    if (u)
      return oc(u);
  }
}
function oc(n) {
  return n.contentEditable = "true", Gn && n.draggable && (n.draggable = !1, n.wasDraggable = !0), n;
}
function Mp(n) {
  n.contentEditable = "false", n.wasDraggable && (n.draggable = !0, n.wasDraggable = null);
}
function EI(n) {
  let e = n.dom.ownerDocument;
  e.removeEventListener("selectionchange", n.input.hideSelectionGuard);
  let t = n.domSelectionRange(), r = t.anchorNode, o = t.anchorOffset;
  e.addEventListener("selectionchange", n.input.hideSelectionGuard = () => {
    (t.anchorNode != r || t.anchorOffset != o) && (e.removeEventListener("selectionchange", n.input.hideSelectionGuard), setTimeout(() => {
      (!Hv(n) || n.state.selection.visible) && n.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function yI(n) {
  let e = n.domSelection(), t = document.createRange(), r = n.cursorWrapper.dom, o = r.nodeName == "IMG";
  o ? t.setEnd(r.parentNode, Bn(r) + 1) : t.setEnd(r, 0), t.collapse(!1), e.removeAllRanges(), e.addRange(t), !o && !n.state.selection.visible && qn && Ri <= 11 && (r.disabled = !0, r.disabled = !1);
}
function $v(n, e) {
  if (e instanceof $t) {
    let t = n.docView.descAt(e.from);
    t != n.lastSelectedViewDesc && (bp(n), t && t.selectNode(), n.lastSelectedViewDesc = t);
  } else
    bp(n);
}
function bp(n) {
  n.lastSelectedViewDesc && (n.lastSelectedViewDesc.parent && n.lastSelectedViewDesc.deselectNode(), n.lastSelectedViewDesc = void 0);
}
function _d(n, e, t, r) {
  return n.someProp("createSelectionBetween", (o) => o(n, e, t)) || Zt.between(e, t, r);
}
function Rp(n) {
  return n.editable && !n.hasFocus() ? !1 : Gv(n);
}
function Gv(n) {
  let e = n.domSelectionRange();
  if (!e.anchorNode)
    return !1;
  try {
    return n.dom.contains(e.anchorNode.nodeType == 3 ? e.anchorNode.parentNode : e.anchorNode) && (n.editable || n.dom.contains(e.focusNode.nodeType == 3 ? e.focusNode.parentNode : e.focusNode));
  } catch {
    return !1;
  }
}
function TI(n) {
  let e = n.docView.domFromPos(n.state.selection.anchor, 0), t = n.domSelectionRange();
  return va(e.node, e.offset, t.anchorNode, t.anchorOffset);
}
function af(n, e) {
  let { $anchor: t, $head: r } = n.selection, o = e > 0 ? t.max(r) : t.min(r), u = o.parent.inlineContent ? o.depth ? n.doc.resolve(e > 0 ? o.after() : o.before()) : null : o;
  return u && en.findFrom(u, e);
}
function _i(n, e) {
  return n.dispatch(n.state.tr.setSelection(e).scrollIntoView()), !0;
}
function Dp(n, e, t) {
  let r = n.state.selection;
  if (r instanceof Zt)
    if (t.indexOf("s") > -1) {
      let { $head: o } = r, u = o.textOffset ? null : e < 0 ? o.nodeBefore : o.nodeAfter;
      if (!u || u.isText || !u.isLeaf)
        return !1;
      let c = n.state.doc.resolve(o.pos + u.nodeSize * (e < 0 ? -1 : 1));
      return _i(n, new Zt(r.$anchor, c));
    } else if (r.empty) {
      if (n.endOfTextblock(e > 0 ? "forward" : "backward")) {
        let o = af(n.state, e);
        return o && o instanceof $t ? _i(n, o) : !1;
      } else if (!(fr && t.indexOf("m") > -1)) {
        let o = r.$head, u = o.textOffset ? null : e < 0 ? o.nodeBefore : o.nodeAfter, c;
        if (!u || u.isText)
          return !1;
        let l = e < 0 ? o.pos - u.nodeSize : o.pos;
        return u.isAtom || (c = n.docView.descAt(l)) && !c.contentDOM ? $t.isSelectable(u) ? _i(n, new $t(e < 0 ? n.state.doc.resolve(o.pos - u.nodeSize) : o)) : ws ? _i(n, new Zt(n.state.doc.resolve(e < 0 ? l : l + u.nodeSize))) : !1 : !1;
      }
    } else
      return !1;
  else {
    if (r instanceof $t && r.node.isInline)
      return _i(n, new Zt(e > 0 ? r.$to : r.$from));
    {
      let o = af(n.state, e);
      return o ? _i(n, o) : !1;
    }
  }
}
function Ol(n) {
  return n.nodeType == 3 ? n.nodeValue.length : n.childNodes.length;
}
function Jo(n, e) {
  let t = n.pmViewDesc;
  return t && t.size == 0 && (e < 0 || n.nextSibling || n.nodeName != "BR");
}
function Da(n, e) {
  return e < 0 ? AI(n) : SI(n);
}
function AI(n) {
  let e = n.domSelectionRange(), t = e.focusNode, r = e.focusOffset;
  if (!t)
    return;
  let o, u, c = !1;
  for (br && t.nodeType == 1 && r < Ol(t) && Jo(t.childNodes[r], -1) && (c = !0); ; )
    if (r > 0) {
      if (t.nodeType != 1)
        break;
      {
        let l = t.childNodes[r - 1];
        if (Jo(l, -1))
          o = t, u = --r;
        else if (l.nodeType == 3)
          t = l, r = t.nodeValue.length;
        else
          break;
      }
    } else {
      if (zv(t))
        break;
      {
        let l = t.previousSibling;
        for (; l && Jo(l, -1); )
          o = t.parentNode, u = Bn(l), l = l.previousSibling;
        if (l)
          t = l, r = Ol(t);
        else {
          if (t = t.parentNode, t == n.dom)
            break;
          r = 0;
        }
      }
    }
  c ? of(n, t, r) : o && of(n, o, u);
}
function SI(n) {
  let e = n.domSelectionRange(), t = e.focusNode, r = e.focusOffset;
  if (!t)
    return;
  let o = Ol(t), u, c;
  for (; ; )
    if (r < o) {
      if (t.nodeType != 1)
        break;
      let l = t.childNodes[r];
      if (Jo(l, 1))
        u = t, c = ++r;
      else
        break;
    } else {
      if (zv(t))
        break;
      {
        let l = t.nextSibling;
        for (; l && Jo(l, 1); )
          u = l.parentNode, c = Bn(l) + 1, l = l.nextSibling;
        if (l)
          t = l, r = 0, o = Ol(t);
        else {
          if (t = t.parentNode, t == n.dom)
            break;
          r = o = 0;
        }
      }
    }
  u && of(n, u, c);
}
function zv(n) {
  let e = n.pmViewDesc;
  return e && e.node && e.node.isBlock;
}
function CI(n, e) {
  for (; n && e == n.childNodes.length && !Ls(n); )
    e = Bn(n) + 1, n = n.parentNode;
  for (; n && e < n.childNodes.length; ) {
    let t = n.childNodes[e];
    if (t.nodeType == 3)
      return t;
    if (t.nodeType == 1 && t.contentEditable == "false")
      break;
    n = t, e = 0;
  }
}
function MI(n, e) {
  for (; n && !e && !Ls(n); )
    e = Bn(n), n = n.parentNode;
  for (; n && e; ) {
    let t = n.childNodes[e - 1];
    if (t.nodeType == 3)
      return t;
    if (t.nodeType == 1 && t.contentEditable == "false")
      break;
    n = t, e = n.childNodes.length;
  }
}
function of(n, e, t) {
  if (e.nodeType != 3) {
    let u, c;
    (c = CI(e, t)) ? (e = c, t = 0) : (u = MI(e, t)) && (e = u, t = u.nodeValue.length);
  }
  let r = n.domSelection();
  if (tu(r)) {
    let u = document.createRange();
    u.setEnd(e, t), u.setStart(e, t), r.removeAllRanges(), r.addRange(u);
  } else
    r.extend && r.extend(e, t);
  n.domObserver.setCurSelection();
  let { state: o } = n;
  setTimeout(() => {
    n.state == o && ri(n);
  }, 50);
}
function Op(n, e) {
  let t = n.state.doc.resolve(e);
  if (!($n || zP) && t.parent.inlineContent) {
    let o = n.coordsAtPos(e);
    if (e > t.start()) {
      let u = n.coordsAtPos(e - 1), c = (u.top + u.bottom) / 2;
      if (c > o.top && c < o.bottom && Math.abs(u.left - o.left) > 1)
        return u.left < o.left ? "ltr" : "rtl";
    }
    if (e < t.end()) {
      let u = n.coordsAtPos(e + 1), c = (u.top + u.bottom) / 2;
      if (c > o.top && c < o.bottom && Math.abs(u.left - o.left) > 1)
        return u.left > o.left ? "ltr" : "rtl";
    }
  }
  return getComputedStyle(n.dom).direction == "rtl" ? "rtl" : "ltr";
}
function Pp(n, e, t) {
  let r = n.state.selection;
  if (r instanceof Zt && !r.empty || t.indexOf("s") > -1 || fr && t.indexOf("m") > -1)
    return !1;
  let { $from: o, $to: u } = r;
  if (!o.parent.inlineContent || n.endOfTextblock(e < 0 ? "up" : "down")) {
    let c = af(n.state, e);
    if (c && c instanceof $t)
      return _i(n, c);
  }
  if (!o.parent.inlineContent) {
    let c = e < 0 ? o : u, l = r instanceof Cr ? en.near(c, e) : en.findFrom(c, e);
    return l ? _i(n, l) : !1;
  }
  return !1;
}
function Ip(n, e) {
  if (!(n.state.selection instanceof Zt))
    return !0;
  let { $head: t, $anchor: r, empty: o } = n.state.selection;
  if (!t.sameParent(r))
    return !0;
  if (!o)
    return !1;
  if (n.endOfTextblock(e > 0 ? "forward" : "backward"))
    return !0;
  let u = !t.textOffset && (e < 0 ? t.nodeBefore : t.nodeAfter);
  if (u && !u.isText) {
    let c = n.state.tr;
    return e < 0 ? c.delete(t.pos - u.nodeSize, t.pos) : c.delete(t.pos, t.pos + u.nodeSize), n.dispatch(c), !0;
  }
  return !1;
}
function Np(n, e, t) {
  n.domObserver.stop(), e.contentEditable = t, n.domObserver.start();
}
function bI(n) {
  if (!Gn || n.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: e, focusOffset: t } = n.domSelectionRange();
  if (e && e.nodeType == 1 && t == 0 && e.firstChild && e.firstChild.contentEditable == "false") {
    let r = e.firstChild;
    Np(n, r, "true"), setTimeout(() => Np(n, r, "false"), 20);
  }
  return !1;
}
function RI(n) {
  let e = "";
  return n.ctrlKey && (e += "c"), n.metaKey && (e += "m"), n.altKey && (e += "a"), n.shiftKey && (e += "s"), e;
}
function DI(n, e) {
  let t = e.keyCode, r = RI(e);
  if (t == 8 || fr && t == 72 && r == "c")
    return Ip(n, -1) || Da(n, -1);
  if (t == 46 && !e.shiftKey || fr && t == 68 && r == "c")
    return Ip(n, 1) || Da(n, 1);
  if (t == 13 || t == 27)
    return !0;
  if (t == 37 || fr && t == 66 && r == "c") {
    let o = t == 37 ? Op(n, n.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return Dp(n, o, r) || Da(n, o);
  } else if (t == 39 || fr && t == 70 && r == "c") {
    let o = t == 39 ? Op(n, n.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return Dp(n, o, r) || Da(n, o);
  } else {
    if (t == 38 || fr && t == 80 && r == "c")
      return Pp(n, -1, r) || Da(n, -1);
    if (t == 40 || fr && t == 78 && r == "c")
      return bI(n) || Pp(n, 1, r) || Da(n, 1);
    if (r == (fr ? "m" : "c") && (t == 66 || t == 73 || t == 89 || t == 90))
      return !0;
  }
  return !1;
}
function Yv(n, e) {
  n.someProp("transformCopied", (v) => {
    e = v(e, n);
  });
  let t = [], { content: r, openStart: o, openEnd: u } = e;
  for (; o > 1 && u > 1 && r.childCount == 1 && r.firstChild.childCount == 1; ) {
    o--, u--;
    let v = r.firstChild;
    t.push(v.type.name, v.attrs != v.type.defaultAttrs ? v.attrs : null), r = v.content;
  }
  let c = n.someProp("clipboardSerializer") || Ur.fromSchema(n.state.schema), l = e_(), i = l.createElement("div");
  i.appendChild(c.serializeFragment(r, { document: l }));
  let h = i.firstChild, f, p = 0;
  for (; h && h.nodeType == 1 && (f = qv[h.nodeName.toLowerCase()]); ) {
    for (let v = f.length - 1; v >= 0; v--) {
      let g = l.createElement(f[v]);
      for (; i.firstChild; )
        g.appendChild(i.firstChild);
      i.appendChild(g), p++;
    }
    h = i.firstChild;
  }
  h && h.nodeType == 1 && h.setAttribute("data-pm-slice", `${o} ${u}${p ? ` -${p}` : ""} ${JSON.stringify(t)}`);
  let d = n.someProp("clipboardTextSerializer", (v) => v(e, n)) || e.content.textBetween(0, e.content.size, `

`);
  return { dom: i, text: d, slice: e };
}
function Xv(n, e, t, r, o) {
  let u = o.parent.type.spec.code, c, l;
  if (!t && !e)
    return null;
  let i = e && (r || u || !t);
  if (i) {
    if (n.someProp("transformPastedText", (d) => {
      e = d(e, u || r, n);
    }), u)
      return e ? new Lt(Tt.from(n.state.schema.text(e.replace(/\r\n?/g, `
`))), 0, 0) : Lt.empty;
    let p = n.someProp("clipboardTextParser", (d) => d(e, o, r, n));
    if (p)
      l = p;
    else {
      let d = o.marks(), { schema: v } = n.state, g = Ur.fromSchema(v);
      c = document.createElement("div"), e.split(/(?:\r\n?|\n)+/).forEach((m) => {
        let A = c.appendChild(document.createElement("p"));
        m && A.appendChild(g.serializeNode(v.text(m, d)));
      });
    }
  } else
    n.someProp("transformPastedHTML", (p) => {
      t = p(t, n);
    }), c = II(t), ws && NI(c);
  let h = c && c.querySelector("[data-pm-slice]"), f = h && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(h.getAttribute("data-pm-slice") || "");
  if (f && f[3])
    for (let p = +f[3]; p > 0; p--) {
      let d = c.firstChild;
      for (; d && d.nodeType != 1; )
        d = d.nextSibling;
      if (!d)
        break;
      c = d;
    }
  if (l || (l = (n.someProp("clipboardParser") || n.someProp("domParser") || dd.fromSchema(n.state.schema)).parseSlice(c, {
    preserveWhitespace: !!(i || f),
    context: o,
    ruleFromNode(d) {
      return d.nodeName == "BR" && !d.nextSibling && d.parentNode && !OI.test(d.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), f)
    l = LI(Lp(l, +f[1], +f[2]), f[4]);
  else if (l = Lt.maxOpen(PI(l.content, o), !0), l.openStart || l.openEnd) {
    let p = 0, d = 0;
    for (let v = l.content.firstChild; p < l.openStart && !v.type.spec.isolating; p++, v = v.firstChild)
      ;
    for (let v = l.content.lastChild; d < l.openEnd && !v.type.spec.isolating; d++, v = v.lastChild)
      ;
    l = Lp(l, p, d);
  }
  return n.someProp("transformPasted", (p) => {
    l = p(l, n);
  }), l;
}
const OI = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function PI(n, e) {
  if (n.childCount < 2)
    return n;
  for (let t = e.depth; t >= 0; t--) {
    let o = e.node(t).contentMatchAt(e.index(t)), u, c = [];
    if (n.forEach((l) => {
      if (!c)
        return;
      let i = o.findWrapping(l.type), h;
      if (!i)
        return c = null;
      if (h = c.length && u.length && Jv(i, u, l, c[c.length - 1], 0))
        c[c.length - 1] = h;
      else {
        c.length && (c[c.length - 1] = Zv(c[c.length - 1], u.length));
        let f = Qv(l, i);
        c.push(f), o = o.matchType(f.type), u = i;
      }
    }), c)
      return Tt.from(c);
  }
  return n;
}
function Qv(n, e, t = 0) {
  for (let r = e.length - 1; r >= t; r--)
    n = e[r].create(null, Tt.from(n));
  return n;
}
function Jv(n, e, t, r, o) {
  if (o < n.length && o < e.length && n[o] == e[o]) {
    let u = Jv(n, e, t, r.lastChild, o + 1);
    if (u)
      return r.copy(r.content.replaceChild(r.childCount - 1, u));
    if (r.contentMatchAt(r.childCount).matchType(o == n.length - 1 ? t.type : n[o + 1]))
      return r.copy(r.content.append(Tt.from(Qv(t, n, o + 1))));
  }
}
function Zv(n, e) {
  if (e == 0)
    return n;
  let t = n.content.replaceChild(n.childCount - 1, Zv(n.lastChild, e - 1)), r = n.contentMatchAt(n.childCount).fillBefore(Tt.empty, !0);
  return n.copy(t.append(r));
}
function sf(n, e, t, r, o, u) {
  let c = e < 0 ? n.firstChild : n.lastChild, l = c.content;
  return n.childCount > 1 && (u = 0), o < r - 1 && (l = sf(l, e, t, r, o + 1, u)), o >= t && (l = e < 0 ? c.contentMatchAt(0).fillBefore(l, u <= o).append(l) : l.append(c.contentMatchAt(c.childCount).fillBefore(Tt.empty, !0))), n.replaceChild(e < 0 ? 0 : n.childCount - 1, c.copy(l));
}
function Lp(n, e, t) {
  return e < n.openStart && (n = new Lt(sf(n.content, -1, e, n.openStart, 0, n.openEnd), e, n.openEnd)), t < n.openEnd && (n = new Lt(sf(n.content, 1, t, n.openEnd, 0, 0), n.openStart, t)), n;
}
const qv = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let wp = null;
function e_() {
  return wp || (wp = document.implementation.createHTMLDocument("title"));
}
function II(n) {
  let e = /^(\s*<meta [^>]*>)*/.exec(n);
  e && (n = n.slice(e[0].length));
  let t = e_().createElement("div"), r = /<([a-z][^>\s]+)/i.exec(n), o;
  if ((o = r && qv[r[1].toLowerCase()]) && (n = o.map((u) => "<" + u + ">").join("") + n + o.map((u) => "</" + u + ">").reverse().join("")), t.innerHTML = n, o)
    for (let u = 0; u < o.length; u++)
      t = t.querySelector(o[u]) || t;
  return t;
}
function NI(n) {
  let e = n.querySelectorAll($n ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let t = 0; t < e.length; t++) {
    let r = e[t];
    r.childNodes.length == 1 && r.textContent == " " && r.parentNode && r.parentNode.replaceChild(n.ownerDocument.createTextNode(" "), r);
  }
}
function LI(n, e) {
  if (!n.size)
    return n;
  let t = n.content.firstChild.type.schema, r;
  try {
    r = JSON.parse(e);
  } catch {
    return n;
  }
  let { content: o, openStart: u, openEnd: c } = n;
  for (let l = r.length - 2; l >= 0; l -= 2) {
    let i = t.nodes[r[l]];
    if (!i || i.hasRequiredAttrs())
      break;
    o = Tt.from(i.create(r[l + 1], o)), u++, c++;
  }
  return new Lt(o, u, c);
}
const zn = {}, Yn = {}, wI = { touchstart: !0, touchmove: !0 };
class xI {
  constructor() {
    this.shiftKey = !1, this.mouseDown = null, this.lastKeyCode = null, this.lastKeyCodeTime = 0, this.lastClick = { time: 0, x: 0, y: 0, type: "" }, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastIOSEnter = 0, this.lastIOSEnterFallbackTimeout = -1, this.lastFocus = 0, this.lastTouch = 0, this.lastAndroidDelete = 0, this.composing = !1, this.compositionNode = null, this.composingTimeout = -1, this.compositionNodes = [], this.compositionEndedAt = -2e8, this.compositionID = 1, this.compositionPendingChanges = 0, this.domChangeCount = 0, this.eventHandlers = /* @__PURE__ */ Object.create(null), this.hideSelectionGuard = null;
  }
}
function BI(n) {
  for (let e in zn) {
    let t = zn[e];
    n.dom.addEventListener(e, n.input.eventHandlers[e] = (r) => {
      UI(n, r) && !Ed(n, r) && (n.editable || !(r.type in Yn)) && t(n, r);
    }, wI[e] ? { passive: !0 } : void 0);
  }
  Gn && n.dom.addEventListener("input", () => null), lf(n);
}
function bi(n, e) {
  n.input.lastSelectionOrigin = e, n.input.lastSelectionTime = Date.now();
}
function FI(n) {
  n.domObserver.stop();
  for (let e in n.input.eventHandlers)
    n.dom.removeEventListener(e, n.input.eventHandlers[e]);
  clearTimeout(n.input.composingTimeout), clearTimeout(n.input.lastIOSEnterFallbackTimeout);
}
function lf(n) {
  n.someProp("handleDOMEvents", (e) => {
    for (let t in e)
      n.input.eventHandlers[t] || n.dom.addEventListener(t, n.input.eventHandlers[t] = (r) => Ed(n, r));
  });
}
function Ed(n, e) {
  return n.someProp("handleDOMEvents", (t) => {
    let r = t[e.type];
    return r ? r(n, e) || e.defaultPrevented : !1;
  });
}
function UI(n, e) {
  if (!e.bubbles)
    return !0;
  if (e.defaultPrevented)
    return !1;
  for (let t = e.target; t != n.dom; t = t.parentNode)
    if (!t || t.nodeType == 11 || t.pmViewDesc && t.pmViewDesc.stopEvent(e))
      return !1;
  return !0;
}
function kI(n, e) {
  !Ed(n, e) && zn[e.type] && (n.editable || !(e.type in Yn)) && zn[e.type](n, e);
}
Yn.keydown = (n, e) => {
  let t = e;
  if (n.input.shiftKey = t.keyCode == 16 || t.shiftKey, !n_(n, t) && (n.input.lastKeyCode = t.keyCode, n.input.lastKeyCodeTime = Date.now(), !(Tr && $n && t.keyCode == 13)))
    if (t.keyCode != 229 && n.domObserver.forceFlush(), uo && t.keyCode == 13 && !t.ctrlKey && !t.altKey && !t.metaKey) {
      let r = Date.now();
      n.input.lastIOSEnter = r, n.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        n.input.lastIOSEnter == r && (n.someProp("handleKeyDown", (o) => o(n, Qi(13, "Enter"))), n.input.lastIOSEnter = 0);
      }, 200);
    } else
      n.someProp("handleKeyDown", (r) => r(n, t)) || DI(n, t) ? t.preventDefault() : bi(n, "key");
};
Yn.keyup = (n, e) => {
  e.keyCode == 16 && (n.input.shiftKey = !1);
};
Yn.keypress = (n, e) => {
  let t = e;
  if (n_(n, t) || !t.charCode || t.ctrlKey && !t.altKey || fr && t.metaKey)
    return;
  if (n.someProp("handleKeyPress", (o) => o(n, t))) {
    t.preventDefault();
    return;
  }
  let r = n.state.selection;
  if (!(r instanceof Zt) || !r.$from.sameParent(r.$to)) {
    let o = String.fromCharCode(t.charCode);
    !/[\r\n]/.test(o) && !n.someProp("handleTextInput", (u) => u(n, r.$from.pos, r.$to.pos, o)) && n.dispatch(n.state.tr.insertText(o).scrollIntoView()), t.preventDefault();
  }
};
function ru(n) {
  return { left: n.clientX, top: n.clientY };
}
function KI(n, e) {
  let t = e.x - n.clientX, r = e.y - n.clientY;
  return t * t + r * r < 100;
}
function yd(n, e, t, r, o) {
  if (r == -1)
    return !1;
  let u = n.state.doc.resolve(r);
  for (let c = u.depth + 1; c > 0; c--)
    if (n.someProp(e, (l) => c > u.depth ? l(n, t, u.nodeAfter, u.before(c), o, !0) : l(n, t, u.node(c), u.before(c), o, !1)))
      return !0;
  return !1;
}
function Xa(n, e, t) {
  n.focused || n.focus();
  let r = n.state.tr.setSelection(e);
  t == "pointer" && r.setMeta("pointer", !0), n.dispatch(r);
}
function jI(n, e) {
  if (e == -1)
    return !1;
  let t = n.state.doc.resolve(e), r = t.nodeAfter;
  return r && r.isAtom && $t.isSelectable(r) ? (Xa(n, new $t(t), "pointer"), !0) : !1;
}
function WI(n, e) {
  if (e == -1)
    return !1;
  let t = n.state.selection, r, o;
  t instanceof $t && (r = t.node);
  let u = n.state.doc.resolve(e);
  for (let c = u.depth + 1; c > 0; c--) {
    let l = c > u.depth ? u.nodeAfter : u.node(c);
    if ($t.isSelectable(l)) {
      r && t.$from.depth > 0 && c >= t.$from.depth && u.before(t.$from.depth + 1) == t.$from.pos ? o = u.before(t.$from.depth) : o = u.before(c);
      break;
    }
  }
  return o != null ? (Xa(n, $t.create(n.state.doc, o), "pointer"), !0) : !1;
}
function VI(n, e, t, r, o) {
  return yd(n, "handleClickOn", e, t, r) || n.someProp("handleClick", (u) => u(n, e, r)) || (o ? WI(n, t) : jI(n, t));
}
function HI(n, e, t, r) {
  return yd(n, "handleDoubleClickOn", e, t, r) || n.someProp("handleDoubleClick", (o) => o(n, e, r));
}
function $I(n, e, t, r) {
  return yd(n, "handleTripleClickOn", e, t, r) || n.someProp("handleTripleClick", (o) => o(n, e, r)) || GI(n, t, r);
}
function GI(n, e, t) {
  if (t.button != 0)
    return !1;
  let r = n.state.doc;
  if (e == -1)
    return r.inlineContent ? (Xa(n, Zt.create(r, 0, r.content.size), "pointer"), !0) : !1;
  let o = r.resolve(e);
  for (let u = o.depth + 1; u > 0; u--) {
    let c = u > o.depth ? o.nodeAfter : o.node(u), l = o.before(u);
    if (c.inlineContent)
      Xa(n, Zt.create(r, l + 1, l + 1 + c.content.size), "pointer");
    else if ($t.isSelectable(c))
      Xa(n, $t.create(r, l), "pointer");
    else
      continue;
    return !0;
  }
}
function Td(n) {
  return Pl(n);
}
const t_ = fr ? "metaKey" : "ctrlKey";
zn.mousedown = (n, e) => {
  let t = e;
  n.input.shiftKey = t.shiftKey;
  let r = Td(n), o = Date.now(), u = "singleClick";
  o - n.input.lastClick.time < 500 && KI(t, n.input.lastClick) && !t[t_] && (n.input.lastClick.type == "singleClick" ? u = "doubleClick" : n.input.lastClick.type == "doubleClick" && (u = "tripleClick")), n.input.lastClick = { time: o, x: t.clientX, y: t.clientY, type: u };
  let c = n.posAtCoords(ru(t));
  c && (u == "singleClick" ? (n.input.mouseDown && n.input.mouseDown.done(), n.input.mouseDown = new zI(n, c, t, !!r)) : (u == "doubleClick" ? HI : $I)(n, c.pos, c.inside, t) ? t.preventDefault() : bi(n, "pointer"));
};
class zI {
  constructor(e, t, r, o) {
    this.view = e, this.pos = t, this.event = r, this.flushed = o, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = e.state.doc, this.selectNode = !!r[t_], this.allowDefault = r.shiftKey;
    let u, c;
    if (t.inside > -1)
      u = e.state.doc.nodeAt(t.inside), c = t.inside;
    else {
      let f = e.state.doc.resolve(t.pos);
      u = f.parent, c = f.depth ? f.before() : 0;
    }
    const l = o ? null : r.target, i = l ? e.docView.nearestDesc(l, !0) : null;
    this.target = i ? i.dom : null;
    let { selection: h } = e.state;
    (r.button == 0 && u.type.spec.draggable && u.type.spec.selectable !== !1 || h instanceof $t && h.from <= c && h.to > c) && (this.mightDrag = {
      node: u,
      pos: c,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && br && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), e.root.addEventListener("mouseup", this.up = this.up.bind(this)), e.root.addEventListener("mousemove", this.move = this.move.bind(this)), bi(e, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => ri(this.view)), this.view.input.mouseDown = null;
  }
  up(e) {
    if (this.done(), !this.view.dom.contains(e.target))
      return;
    let t = this.pos;
    this.view.state.doc != this.startDoc && (t = this.view.posAtCoords(ru(e))), this.updateAllowDefault(e), this.allowDefault || !t ? bi(this.view, "pointer") : VI(this.view, t.pos, t.inside, e, this.selectNode) ? e.preventDefault() : e.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    Gn && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    $n && !this.view.state.selection.visible && Math.min(Math.abs(t.pos - this.view.state.selection.from), Math.abs(t.pos - this.view.state.selection.to)) <= 2) ? (Xa(this.view, en.near(this.view.state.doc.resolve(t.pos)), "pointer"), e.preventDefault()) : bi(this.view, "pointer");
  }
  move(e) {
    this.updateAllowDefault(e), bi(this.view, "pointer"), e.buttons == 0 && this.done();
  }
  updateAllowDefault(e) {
    !this.allowDefault && (Math.abs(this.event.x - e.clientX) > 4 || Math.abs(this.event.y - e.clientY) > 4) && (this.allowDefault = !0);
  }
}
zn.touchstart = (n) => {
  n.input.lastTouch = Date.now(), Td(n), bi(n, "pointer");
};
zn.touchmove = (n) => {
  n.input.lastTouch = Date.now(), bi(n, "pointer");
};
zn.contextmenu = (n) => Td(n);
function n_(n, e) {
  return n.composing ? !0 : Gn && Math.abs(e.timeStamp - n.input.compositionEndedAt) < 500 ? (n.input.compositionEndedAt = -2e8, !0) : !1;
}
const YI = Tr ? 5e3 : -1;
Yn.compositionstart = Yn.compositionupdate = (n) => {
  if (!n.composing) {
    n.domObserver.flush();
    let { state: e } = n, t = e.selection.$from;
    if (e.selection.empty && (e.storedMarks || !t.textOffset && t.parentOffset && t.nodeBefore.marks.some((r) => r.type.spec.inclusive === !1)))
      n.markCursor = n.state.storedMarks || t.marks(), Pl(n, !0), n.markCursor = null;
    else if (Pl(n), br && e.selection.empty && t.parentOffset && !t.textOffset && t.nodeBefore.marks.length) {
      let r = n.domSelectionRange();
      for (let o = r.focusNode, u = r.focusOffset; o && o.nodeType == 1 && u != 0; ) {
        let c = u < 0 ? o.lastChild : o.childNodes[u - 1];
        if (!c)
          break;
        if (c.nodeType == 3) {
          n.domSelection().collapse(c, c.nodeValue.length);
          break;
        } else
          o = c, u = -1;
      }
    }
    n.input.composing = !0;
  }
  r_(n, YI);
};
Yn.compositionend = (n, e) => {
  n.composing && (n.input.composing = !1, n.input.compositionEndedAt = e.timeStamp, n.input.compositionPendingChanges = n.domObserver.pendingRecords().length ? n.input.compositionID : 0, n.input.compositionNode = null, n.input.compositionPendingChanges && Promise.resolve().then(() => n.domObserver.flush()), n.input.compositionID++, r_(n, 20));
};
function r_(n, e) {
  clearTimeout(n.input.composingTimeout), e > -1 && (n.input.composingTimeout = setTimeout(() => Pl(n), e));
}
function i_(n) {
  for (n.composing && (n.input.composing = !1, n.input.compositionEndedAt = QI()); n.input.compositionNodes.length > 0; )
    n.input.compositionNodes.pop().markParentsDirty();
}
function XI(n) {
  let e = n.domSelectionRange();
  if (!e.focusNode)
    return null;
  let t = jP(e.focusNode, e.focusOffset), r = WP(e.focusNode, e.focusOffset);
  if (t && r && t != r) {
    let o = r.pmViewDesc;
    if (!o || !o.isText(r.nodeValue))
      return r;
    if (n.input.compositionNode == r) {
      let u = t.pmViewDesc;
      if (!(!u || !u.isText(t.nodeValue)))
        return r;
    }
  }
  return t || r;
}
function QI() {
  let n = document.createEvent("Event");
  return n.initEvent("event", !0, !0), n.timeStamp;
}
function Pl(n, e = !1) {
  if (!(Tr && n.domObserver.flushingSoon >= 0)) {
    if (n.domObserver.forceFlush(), i_(n), e || n.docView && n.docView.dirty) {
      let t = vd(n);
      return t && !t.eq(n.state.selection) ? n.dispatch(n.state.tr.setSelection(t)) : n.updateState(n.state), !0;
    }
    return !1;
  }
}
function JI(n, e) {
  if (!n.dom.parentNode)
    return;
  let t = n.dom.parentNode.appendChild(document.createElement("div"));
  t.appendChild(e), t.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let r = getSelection(), o = document.createRange();
  o.selectNodeContents(e), n.dom.blur(), r.removeAllRanges(), r.addRange(o), setTimeout(() => {
    t.parentNode && t.parentNode.removeChild(t), n.focus();
  }, 50);
}
const ms = qn && Ri < 15 || uo && YP < 604;
zn.copy = Yn.cut = (n, e) => {
  let t = e, r = n.state.selection, o = t.type == "cut";
  if (r.empty)
    return;
  let u = ms ? null : t.clipboardData, c = r.content(), { dom: l, text: i } = Yv(n, c);
  u ? (t.preventDefault(), u.clearData(), u.setData("text/html", l.innerHTML), u.setData("text/plain", i)) : JI(n, l), o && n.dispatch(n.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function ZI(n) {
  return n.openStart == 0 && n.openEnd == 0 && n.content.childCount == 1 ? n.content.firstChild : null;
}
function qI(n, e) {
  if (!n.dom.parentNode)
    return;
  let t = n.input.shiftKey || n.state.selection.$from.parent.type.spec.code, r = n.dom.parentNode.appendChild(document.createElement(t ? "textarea" : "div"));
  t || (r.contentEditable = "true"), r.style.cssText = "position: fixed; left: -10000px; top: 10px", r.focus();
  let o = n.input.shiftKey && n.input.lastKeyCode != 45;
  setTimeout(() => {
    n.focus(), r.parentNode && r.parentNode.removeChild(r), t ? gs(n, r.value, null, o, e) : gs(n, r.textContent, r.innerHTML, o, e);
  }, 50);
}
function gs(n, e, t, r, o) {
  let u = Xv(n, e, t, r, n.state.selection.$from);
  if (n.someProp("handlePaste", (i) => i(n, o, u || Lt.empty)))
    return !0;
  if (!u)
    return !1;
  let c = ZI(u), l = c ? n.state.tr.replaceSelectionWith(c, r) : n.state.tr.replaceSelection(u);
  return n.dispatch(l.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
function a_(n) {
  let e = n.getData("text/plain") || n.getData("Text");
  if (e)
    return e;
  let t = n.getData("text/uri-list");
  return t ? t.replace(/\r?\n/g, " ") : "";
}
Yn.paste = (n, e) => {
  let t = e;
  if (n.composing && !Tr)
    return;
  let r = ms ? null : t.clipboardData, o = n.input.shiftKey && n.input.lastKeyCode != 45;
  r && gs(n, a_(r), r.getData("text/html"), o, t) ? t.preventDefault() : qI(n, t);
};
class o_ {
  constructor(e, t, r) {
    this.slice = e, this.move = t, this.node = r;
  }
}
const s_ = fr ? "altKey" : "ctrlKey";
zn.dragstart = (n, e) => {
  let t = e, r = n.input.mouseDown;
  if (r && r.done(), !t.dataTransfer)
    return;
  let o = n.state.selection, u = o.empty ? null : n.posAtCoords(ru(t)), c;
  if (!(u && u.pos >= o.from && u.pos <= (o instanceof $t ? o.to - 1 : o.to))) {
    if (r && r.mightDrag)
      c = $t.create(n.state.doc, r.mightDrag.pos);
    else if (t.target && t.target.nodeType == 1) {
      let p = n.docView.nearestDesc(t.target, !0);
      p && p.node.type.spec.draggable && p != n.docView && (c = $t.create(n.state.doc, p.posBefore));
    }
  }
  let l = (c || n.state.selection).content(), { dom: i, text: h, slice: f } = Yv(n, l);
  t.dataTransfer.clearData(), t.dataTransfer.setData(ms ? "Text" : "text/html", i.innerHTML), t.dataTransfer.effectAllowed = "copyMove", ms || t.dataTransfer.setData("text/plain", h), n.dragging = new o_(f, !t[s_], c);
};
zn.dragend = (n) => {
  let e = n.dragging;
  window.setTimeout(() => {
    n.dragging == e && (n.dragging = null);
  }, 50);
};
Yn.dragover = Yn.dragenter = (n, e) => e.preventDefault();
Yn.drop = (n, e) => {
  let t = e, r = n.dragging;
  if (n.dragging = null, !t.dataTransfer)
    return;
  let o = n.posAtCoords(ru(t));
  if (!o)
    return;
  let u = n.state.doc.resolve(o.pos), c = r && r.slice;
  c ? n.someProp("transformPasted", (g) => {
    c = g(c, n);
  }) : c = Xv(n, a_(t.dataTransfer), ms ? null : t.dataTransfer.getData("text/html"), !1, u);
  let l = !!(r && !t[s_]);
  if (n.someProp("handleDrop", (g) => g(n, t, c || Lt.empty, l))) {
    t.preventDefault();
    return;
  }
  if (!c)
    return;
  t.preventDefault();
  let i = c ? Mv(n.state.doc, u.pos, c) : u.pos;
  i == null && (i = u.pos);
  let h = n.state.tr;
  if (l) {
    let { node: g } = r;
    g ? g.replace(h) : h.deleteSelection();
  }
  let f = h.mapping.map(i), p = c.openStart == 0 && c.openEnd == 0 && c.content.childCount == 1, d = h.doc;
  if (p ? h.replaceRangeWith(f, f, c.content.firstChild) : h.replaceRange(f, f, c), h.doc.eq(d))
    return;
  let v = h.doc.resolve(f);
  if (p && $t.isSelectable(c.content.firstChild) && v.nodeAfter && v.nodeAfter.sameMarkup(c.content.firstChild))
    h.setSelection(new $t(v));
  else {
    let g = h.mapping.map(i);
    h.mapping.maps[h.mapping.maps.length - 1].forEach((m, A, b, S) => g = S), h.setSelection(_d(n, v, h.doc.resolve(g)));
  }
  n.focus(), n.dispatch(h.setMeta("uiEvent", "drop"));
};
zn.focus = (n) => {
  n.input.lastFocus = Date.now(), n.focused || (n.domObserver.stop(), n.dom.classList.add("ProseMirror-focused"), n.domObserver.start(), n.focused = !0, setTimeout(() => {
    n.docView && n.hasFocus() && !n.domObserver.currentSelection.eq(n.domSelectionRange()) && ri(n);
  }, 20));
};
zn.blur = (n, e) => {
  let t = e;
  n.focused && (n.domObserver.stop(), n.dom.classList.remove("ProseMirror-focused"), n.domObserver.start(), t.relatedTarget && n.dom.contains(t.relatedTarget) && n.domObserver.currentSelection.clear(), n.focused = !1);
};
zn.beforeinput = (n, e) => {
  if ($n && Tr && e.inputType == "deleteContentBackward") {
    n.domObserver.flushSoon();
    let { domChangeCount: r } = n.input;
    setTimeout(() => {
      if (n.input.domChangeCount != r || (n.dom.blur(), n.focus(), n.someProp("handleKeyDown", (u) => u(n, Qi(8, "Backspace")))))
        return;
      let { $cursor: o } = n.state.selection;
      o && o.pos > 0 && n.dispatch(n.state.tr.delete(o.pos - 1, o.pos).scrollIntoView());
    }, 50);
  }
};
for (let n in Yn)
  zn[n] = Yn[n];
function vs(n, e) {
  if (n == e)
    return !0;
  for (let t in n)
    if (n[t] !== e[t])
      return !1;
  for (let t in e)
    if (!(t in n))
      return !1;
  return !0;
}
class Il {
  constructor(e, t) {
    this.toDOM = e, this.spec = t || ca, this.side = this.spec.side || 0;
  }
  map(e, t, r, o) {
    let { pos: u, deleted: c } = e.mapResult(t.from + o, this.side < 0 ? -1 : 1);
    return c ? null : new pr(u - r, u - r, this);
  }
  valid() {
    return !0;
  }
  eq(e) {
    return this == e || e instanceof Il && (this.spec.key && this.spec.key == e.spec.key || this.toDOM == e.toDOM && vs(this.spec, e.spec));
  }
  destroy(e) {
    this.spec.destroy && this.spec.destroy(e);
  }
}
class Oi {
  constructor(e, t) {
    this.attrs = e, this.spec = t || ca;
  }
  map(e, t, r, o) {
    let u = e.map(t.from + o, this.spec.inclusiveStart ? -1 : 1) - r, c = e.map(t.to + o, this.spec.inclusiveEnd ? 1 : -1) - r;
    return u >= c ? null : new pr(u, c, this);
  }
  valid(e, t) {
    return t.from < t.to;
  }
  eq(e) {
    return this == e || e instanceof Oi && vs(this.attrs, e.attrs) && vs(this.spec, e.spec);
  }
  static is(e) {
    return e.type instanceof Oi;
  }
  destroy() {
  }
}
class Ad {
  constructor(e, t) {
    this.attrs = e, this.spec = t || ca;
  }
  map(e, t, r, o) {
    let u = e.mapResult(t.from + o, 1);
    if (u.deleted)
      return null;
    let c = e.mapResult(t.to + o, -1);
    return c.deleted || c.pos <= u.pos ? null : new pr(u.pos - r, c.pos - r, this);
  }
  valid(e, t) {
    let { index: r, offset: o } = e.content.findIndex(t.from), u;
    return o == t.from && !(u = e.child(r)).isText && o + u.nodeSize == t.to;
  }
  eq(e) {
    return this == e || e instanceof Ad && vs(this.attrs, e.attrs) && vs(this.spec, e.spec);
  }
  destroy() {
  }
}
class pr {
  /**
  @internal
  */
  constructor(e, t, r) {
    this.from = e, this.to = t, this.type = r;
  }
  /**
  @internal
  */
  copy(e, t) {
    return new pr(e, t, this.type);
  }
  /**
  @internal
  */
  eq(e, t = 0) {
    return this.type.eq(e.type) && this.from + t == e.from && this.to + t == e.to;
  }
  /**
  @internal
  */
  map(e, t, r) {
    return this.type.map(e, this, t, r);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(e, t, r) {
    return new pr(e, e, new Il(t, r));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(e, t, r, o) {
    return new pr(e, t, new Oi(r, o));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(e, t, r, o) {
    return new pr(e, t, new Ad(r, o));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof Oi;
  }
  /**
  @internal
  */
  get widget() {
    return this.type instanceof Il;
  }
}
const wa = [], ca = {};
class bn {
  /**
  @internal
  */
  constructor(e, t) {
    this.local = e.length ? e : wa, this.children = t.length ? t : wa;
  }
  /**
  Create a set of decorations, using the structure of the given
  document. This will consume (modify) the `decorations` array, so
  you must make a copy if you want need to preserve that.
  */
  static create(e, t) {
    return t.length ? Nl(t, e, 0, ca) : jn;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(e, t, r) {
    let o = [];
    return this.findInner(e ?? 0, t ?? 1e9, o, 0, r), o;
  }
  findInner(e, t, r, o, u) {
    for (let c = 0; c < this.local.length; c++) {
      let l = this.local[c];
      l.from <= t && l.to >= e && (!u || u(l.spec)) && r.push(l.copy(l.from + o, l.to + o));
    }
    for (let c = 0; c < this.children.length; c += 3)
      if (this.children[c] < t && this.children[c + 1] > e) {
        let l = this.children[c] + 1;
        this.children[c + 2].findInner(e - l, t - l, r, o + l, u);
      }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(e, t, r) {
    return this == jn || e.maps.length == 0 ? this : this.mapInner(e, t, 0, 0, r || ca);
  }
  /**
  @internal
  */
  mapInner(e, t, r, o, u) {
    let c;
    for (let l = 0; l < this.local.length; l++) {
      let i = this.local[l].map(e, r, o);
      i && i.type.valid(t, i) ? (c || (c = [])).push(i) : u.onRemove && u.onRemove(this.local[l].spec);
    }
    return this.children.length ? eN(this.children, c || [], e, t, r, o, u) : c ? new bn(c.sort(fa), wa) : jn;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Consumes the `decorations` array. Needs
  access to the current document to create the appropriate tree
  structure.
  */
  add(e, t) {
    return t.length ? this == jn ? bn.create(e, t) : this.addInner(e, t, 0) : this;
  }
  addInner(e, t, r) {
    let o, u = 0;
    e.forEach((l, i) => {
      let h = i + r, f;
      if (f = u_(t, l, h)) {
        for (o || (o = this.children.slice()); u < o.length && o[u] < i; )
          u += 3;
        o[u] == i ? o[u + 2] = o[u + 2].addInner(l, f, h + 1) : o.splice(u, 0, i, i + l.nodeSize, Nl(f, l, h + 1, ca)), u += 3;
      }
    });
    let c = l_(u ? c_(t) : t, -r);
    for (let l = 0; l < c.length; l++)
      c[l].type.valid(e, c[l]) || c.splice(l--, 1);
    return new bn(c.length ? this.local.concat(c).sort(fa) : this.local, o || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(e) {
    return e.length == 0 || this == jn ? this : this.removeInner(e, 0);
  }
  removeInner(e, t) {
    let r = this.children, o = this.local;
    for (let u = 0; u < r.length; u += 3) {
      let c, l = r[u] + t, i = r[u + 1] + t;
      for (let f = 0, p; f < e.length; f++)
        (p = e[f]) && p.from > l && p.to < i && (e[f] = null, (c || (c = [])).push(p));
      if (!c)
        continue;
      r == this.children && (r = this.children.slice());
      let h = r[u + 2].removeInner(c, l + 1);
      h != jn ? r[u + 2] = h : (r.splice(u, 3), u -= 3);
    }
    if (o.length) {
      for (let u = 0, c; u < e.length; u++)
        if (c = e[u])
          for (let l = 0; l < o.length; l++)
            o[l].eq(c, t) && (o == this.local && (o = this.local.slice()), o.splice(l--, 1));
    }
    return r == this.children && o == this.local ? this : o.length || r.length ? new bn(o, r) : jn;
  }
  forChild(e, t) {
    if (this == jn)
      return this;
    if (t.isLeaf)
      return bn.empty;
    let r, o;
    for (let l = 0; l < this.children.length; l += 3)
      if (this.children[l] >= e) {
        this.children[l] == e && (r = this.children[l + 2]);
        break;
      }
    let u = e + 1, c = u + t.content.size;
    for (let l = 0; l < this.local.length; l++) {
      let i = this.local[l];
      if (i.from < c && i.to > u && i.type instanceof Oi) {
        let h = Math.max(u, i.from) - u, f = Math.min(c, i.to) - u;
        h < f && (o || (o = [])).push(i.copy(h, f));
      }
    }
    if (o) {
      let l = new bn(o.sort(fa), wa);
      return r ? new yi([l, r]) : l;
    }
    return r || jn;
  }
  /**
  @internal
  */
  eq(e) {
    if (this == e)
      return !0;
    if (!(e instanceof bn) || this.local.length != e.local.length || this.children.length != e.children.length)
      return !1;
    for (let t = 0; t < this.local.length; t++)
      if (!this.local[t].eq(e.local[t]))
        return !1;
    for (let t = 0; t < this.children.length; t += 3)
      if (this.children[t] != e.children[t] || this.children[t + 1] != e.children[t + 1] || !this.children[t + 2].eq(e.children[t + 2]))
        return !1;
    return !0;
  }
  /**
  @internal
  */
  locals(e) {
    return Sd(this.localsInner(e));
  }
  /**
  @internal
  */
  localsInner(e) {
    if (this == jn)
      return wa;
    if (e.inlineContent || !this.local.some(Oi.is))
      return this.local;
    let t = [];
    for (let r = 0; r < this.local.length; r++)
      this.local[r].type instanceof Oi || t.push(this.local[r]);
    return t;
  }
}
bn.empty = new bn([], []);
bn.removeOverlap = Sd;
const jn = bn.empty;
class yi {
  constructor(e) {
    this.members = e;
  }
  map(e, t) {
    const r = this.members.map((o) => o.map(e, t, ca));
    return yi.from(r);
  }
  forChild(e, t) {
    if (t.isLeaf)
      return bn.empty;
    let r = [];
    for (let o = 0; o < this.members.length; o++) {
      let u = this.members[o].forChild(e, t);
      u != jn && (u instanceof yi ? r = r.concat(u.members) : r.push(u));
    }
    return yi.from(r);
  }
  eq(e) {
    if (!(e instanceof yi) || e.members.length != this.members.length)
      return !1;
    for (let t = 0; t < this.members.length; t++)
      if (!this.members[t].eq(e.members[t]))
        return !1;
    return !0;
  }
  locals(e) {
    let t, r = !0;
    for (let o = 0; o < this.members.length; o++) {
      let u = this.members[o].localsInner(e);
      if (u.length)
        if (!t)
          t = u;
        else {
          r && (t = t.slice(), r = !1);
          for (let c = 0; c < u.length; c++)
            t.push(u[c]);
        }
    }
    return t ? Sd(r ? t : t.sort(fa)) : wa;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(e) {
    switch (e.length) {
      case 0:
        return jn;
      case 1:
        return e[0];
      default:
        return new yi(e.every((t) => t instanceof bn) ? e : e.reduce((t, r) => t.concat(r instanceof bn ? r : r.members), []));
    }
  }
}
function eN(n, e, t, r, o, u, c) {
  let l = n.slice();
  for (let h = 0, f = u; h < t.maps.length; h++) {
    let p = 0;
    t.maps[h].forEach((d, v, g, m) => {
      let A = m - g - (v - d);
      for (let b = 0; b < l.length; b += 3) {
        let S = l[b + 1];
        if (S < 0 || d > S + f - p)
          continue;
        let N = l[b] + f - p;
        v >= N ? l[b + 1] = d <= N ? -2 : -1 : d >= f && A && (l[b] += A, l[b + 1] += A);
      }
      p += A;
    }), f = t.maps[h].map(f, -1);
  }
  let i = !1;
  for (let h = 0; h < l.length; h += 3)
    if (l[h + 1] < 0) {
      if (l[h + 1] == -2) {
        i = !0, l[h + 1] = -1;
        continue;
      }
      let f = t.map(n[h] + u), p = f - o;
      if (p < 0 || p >= r.content.size) {
        i = !0;
        continue;
      }
      let d = t.map(n[h + 1] + u, -1), v = d - o, { index: g, offset: m } = r.content.findIndex(p), A = r.maybeChild(g);
      if (A && m == p && m + A.nodeSize == v) {
        let b = l[h + 2].mapInner(t, A, f + 1, n[h] + u + 1, c);
        b != jn ? (l[h] = p, l[h + 1] = v, l[h + 2] = b) : (l[h + 1] = -2, i = !0);
      } else
        i = !0;
    }
  if (i) {
    let h = tN(l, n, e, t, o, u, c), f = Nl(h, r, 0, c);
    e = f.local;
    for (let p = 0; p < l.length; p += 3)
      l[p + 1] < 0 && (l.splice(p, 3), p -= 3);
    for (let p = 0, d = 0; p < f.children.length; p += 3) {
      let v = f.children[p];
      for (; d < l.length && l[d] < v; )
        d += 3;
      l.splice(d, 0, f.children[p], f.children[p + 1], f.children[p + 2]);
    }
  }
  return new bn(e.sort(fa), l);
}
function l_(n, e) {
  if (!e || !n.length)
    return n;
  let t = [];
  for (let r = 0; r < n.length; r++) {
    let o = n[r];
    t.push(new pr(o.from + e, o.to + e, o.type));
  }
  return t;
}
function tN(n, e, t, r, o, u, c) {
  function l(i, h) {
    for (let f = 0; f < i.local.length; f++) {
      let p = i.local[f].map(r, o, h);
      p ? t.push(p) : c.onRemove && c.onRemove(i.local[f].spec);
    }
    for (let f = 0; f < i.children.length; f += 3)
      l(i.children[f + 2], i.children[f] + h + 1);
  }
  for (let i = 0; i < n.length; i += 3)
    n[i + 1] == -1 && l(n[i + 2], e[i] + u + 1);
  return t;
}
function u_(n, e, t) {
  if (e.isLeaf)
    return null;
  let r = t + e.nodeSize, o = null;
  for (let u = 0, c; u < n.length; u++)
    (c = n[u]) && c.from > t && c.to < r && ((o || (o = [])).push(c), n[u] = null);
  return o;
}
function c_(n) {
  let e = [];
  for (let t = 0; t < n.length; t++)
    n[t] != null && e.push(n[t]);
  return e;
}
function Nl(n, e, t, r) {
  let o = [], u = !1;
  e.forEach((l, i) => {
    let h = u_(n, l, i + t);
    if (h) {
      u = !0;
      let f = Nl(h, l, t + i + 1, r);
      f != jn && o.push(i, i + l.nodeSize, f);
    }
  });
  let c = l_(u ? c_(n) : n, -t).sort(fa);
  for (let l = 0; l < c.length; l++)
    c[l].type.valid(e, c[l]) || (r.onRemove && r.onRemove(c[l].spec), c.splice(l--, 1));
  return c.length || o.length ? new bn(c, o) : jn;
}
function fa(n, e) {
  return n.from - e.from || n.to - e.to;
}
function Sd(n) {
  let e = n;
  for (let t = 0; t < e.length - 1; t++) {
    let r = e[t];
    if (r.from != r.to)
      for (let o = t + 1; o < e.length; o++) {
        let u = e[o];
        if (u.from == r.from) {
          u.to != r.to && (e == n && (e = n.slice()), e[o] = u.copy(u.from, r.to), xp(e, o + 1, u.copy(r.to, u.to)));
          continue;
        } else {
          u.from < r.to && (e == n && (e = n.slice()), e[t] = r.copy(r.from, u.from), xp(e, o, r.copy(u.from, r.to)));
          break;
        }
      }
  }
  return e;
}
function xp(n, e, t) {
  for (; e < n.length && fa(t, n[e]) > 0; )
    e++;
  n.splice(e, 0, t);
}
function sc(n) {
  let e = [];
  return n.someProp("decorations", (t) => {
    let r = t(n.state);
    r && r != jn && e.push(r);
  }), n.cursorWrapper && e.push(bn.create(n.state.doc, [n.cursorWrapper.deco])), yi.from(e);
}
const nN = {
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0,
  attributes: !0,
  attributeOldValue: !0,
  subtree: !0
}, rN = qn && Ri <= 11;
class iN {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  set(e) {
    this.anchorNode = e.anchorNode, this.anchorOffset = e.anchorOffset, this.focusNode = e.focusNode, this.focusOffset = e.focusOffset;
  }
  clear() {
    this.anchorNode = this.focusNode = null;
  }
  eq(e) {
    return e.anchorNode == this.anchorNode && e.anchorOffset == this.anchorOffset && e.focusNode == this.focusNode && e.focusOffset == this.focusOffset;
  }
}
class aN {
  constructor(e, t) {
    this.view = e, this.handleDOMChange = t, this.queue = [], this.flushingSoon = -1, this.observer = null, this.currentSelection = new iN(), this.onCharData = null, this.suppressingSelectionUpdates = !1, this.observer = window.MutationObserver && new window.MutationObserver((r) => {
      for (let o = 0; o < r.length; o++)
        this.queue.push(r[o]);
      qn && Ri <= 11 && r.some((o) => o.type == "childList" && o.removedNodes.length || o.type == "characterData" && o.oldValue.length > o.target.nodeValue.length) ? this.flushSoon() : this.flush();
    }), rN && (this.onCharData = (r) => {
      this.queue.push({ target: r.target, type: "characterData", oldValue: r.prevValue }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  flushSoon() {
    this.flushingSoon < 0 && (this.flushingSoon = window.setTimeout(() => {
      this.flushingSoon = -1, this.flush();
    }, 20));
  }
  forceFlush() {
    this.flushingSoon > -1 && (window.clearTimeout(this.flushingSoon), this.flushingSoon = -1, this.flush());
  }
  start() {
    this.observer && (this.observer.takeRecords(), this.observer.observe(this.view.dom, nN)), this.onCharData && this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.connectSelection();
  }
  stop() {
    if (this.observer) {
      let e = this.observer.takeRecords();
      if (e.length) {
        for (let t = 0; t < e.length; t++)
          this.queue.push(e[t]);
        window.setTimeout(() => this.flush(), 20);
      }
      this.observer.disconnect();
    }
    this.onCharData && this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData), this.disconnectSelection();
  }
  connectSelection() {
    this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  disconnectSelection() {
    this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
  }
  suppressSelectionUpdates() {
    this.suppressingSelectionUpdates = !0, setTimeout(() => this.suppressingSelectionUpdates = !1, 50);
  }
  onSelectionChange() {
    if (Rp(this.view)) {
      if (this.suppressingSelectionUpdates)
        return ri(this.view);
      if (qn && Ri <= 11 && !this.view.state.selection.empty) {
        let e = this.view.domSelectionRange();
        if (e.focusNode && va(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset))
          return this.flushSoon();
      }
      this.flush();
    }
  }
  setCurSelection() {
    this.currentSelection.set(this.view.domSelectionRange());
  }
  ignoreSelectionChange(e) {
    if (!e.focusNode)
      return !0;
    let t = /* @__PURE__ */ new Set(), r;
    for (let u = e.focusNode; u; u = ps(u))
      t.add(u);
    for (let u = e.anchorNode; u; u = ps(u))
      if (t.has(u)) {
        r = u;
        break;
      }
    let o = r && this.view.docView.nearestDesc(r);
    if (o && o.ignoreMutation({
      type: "selection",
      target: r.nodeType == 3 ? r.parentNode : r
    }))
      return this.setCurSelection(), !0;
  }
  pendingRecords() {
    if (this.observer)
      for (let e of this.observer.takeRecords())
        this.queue.push(e);
    return this.queue;
  }
  flush() {
    let { view: e } = this;
    if (!e.docView || this.flushingSoon > -1)
      return;
    let t = this.pendingRecords();
    t.length && (this.queue = []);
    let r = e.domSelectionRange(), o = !this.suppressingSelectionUpdates && !this.currentSelection.eq(r) && Rp(e) && !this.ignoreSelectionChange(r), u = -1, c = -1, l = !1, i = [];
    if (e.editable)
      for (let f = 0; f < t.length; f++) {
        let p = this.registerMutation(t[f], i);
        p && (u = u < 0 ? p.from : Math.min(p.from, u), c = c < 0 ? p.to : Math.max(p.to, c), p.typeOver && (l = !0));
      }
    if (br && i.length > 1) {
      let f = i.filter((p) => p.nodeName == "BR");
      if (f.length == 2) {
        let p = f[0], d = f[1];
        p.parentNode && p.parentNode.parentNode == d.parentNode ? d.remove() : p.remove();
      }
    }
    let h = null;
    u < 0 && o && e.input.lastFocus > Date.now() - 200 && Math.max(e.input.lastTouch, e.input.lastClick.time) < Date.now() - 300 && tu(r) && (h = vd(e)) && h.eq(en.near(e.state.doc.resolve(0), 1)) ? (e.input.lastFocus = 0, ri(e), this.currentSelection.set(r), e.scrollToSelection()) : (u > -1 || o) && (u > -1 && (e.docView.markDirty(u, c), oN(e)), this.handleDOMChange(u, c, l, i), e.docView && e.docView.dirty ? e.updateState(e.state) : this.currentSelection.eq(r) || ri(e), this.currentSelection.set(r));
  }
  registerMutation(e, t) {
    if (t.indexOf(e.target) > -1)
      return null;
    let r = this.view.docView.nearestDesc(e.target);
    if (e.type == "attributes" && (r == this.view.docView || e.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
    e.attributeName == "style" && !e.oldValue && !e.target.getAttribute("style")) || !r || r.ignoreMutation(e))
      return null;
    if (e.type == "childList") {
      for (let f = 0; f < e.addedNodes.length; f++)
        t.push(e.addedNodes[f]);
      if (r.contentDOM && r.contentDOM != r.dom && !r.contentDOM.contains(e.target))
        return { from: r.posBefore, to: r.posAfter };
      let o = e.previousSibling, u = e.nextSibling;
      if (qn && Ri <= 11 && e.addedNodes.length)
        for (let f = 0; f < e.addedNodes.length; f++) {
          let { previousSibling: p, nextSibling: d } = e.addedNodes[f];
          (!p || Array.prototype.indexOf.call(e.addedNodes, p) < 0) && (o = p), (!d || Array.prototype.indexOf.call(e.addedNodes, d) < 0) && (u = d);
        }
      let c = o && o.parentNode == e.target ? Bn(o) + 1 : 0, l = r.localPosFromDOM(e.target, c, -1), i = u && u.parentNode == e.target ? Bn(u) : e.target.childNodes.length, h = r.localPosFromDOM(e.target, i, 1);
      return { from: l, to: h };
    } else
      return e.type == "attributes" ? { from: r.posAtStart - r.border, to: r.posAtEnd + r.border } : {
        from: r.posAtStart,
        to: r.posAtEnd,
        // An event was generated for a text change that didn't change
        // any text. Mark the dom change to fall back to assuming the
        // selection was typed over with an identical value if it can't
        // find another change.
        typeOver: e.target.nodeValue == e.oldValue
      };
  }
}
let Bp = /* @__PURE__ */ new WeakMap(), Fp = !1;
function oN(n) {
  if (!Bp.has(n) && (Bp.set(n, null), ["normal", "nowrap", "pre-line"].indexOf(getComputedStyle(n.dom).whiteSpace) !== -1)) {
    if (n.requiresGeckoHackNode = br, Fp)
      return;
    console.warn("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."), Fp = !0;
  }
}
function Up(n, e) {
  let t = e.startContainer, r = e.startOffset, o = e.endContainer, u = e.endOffset, c = n.domAtPos(n.state.selection.anchor);
  return va(c.node, c.offset, o, u) && ([t, r, o, u] = [o, u, t, r]), { anchorNode: t, anchorOffset: r, focusNode: o, focusOffset: u };
}
function sN(n, e) {
  if (e.getComposedRanges) {
    let o = e.getComposedRanges(n.root)[0];
    if (o)
      return Up(n, o);
  }
  let t;
  function r(o) {
    o.preventDefault(), o.stopImmediatePropagation(), t = o.getTargetRanges()[0];
  }
  return n.dom.addEventListener("beforeinput", r, !0), document.execCommand("indent"), n.dom.removeEventListener("beforeinput", r, !0), t ? Up(n, t) : null;
}
function lN(n, e, t) {
  let { node: r, fromOffset: o, toOffset: u, from: c, to: l } = n.docView.parseRange(e, t), i = n.domSelectionRange(), h, f = i.anchorNode;
  if (f && n.dom.contains(f.nodeType == 1 ? f : f.parentNode) && (h = [{ node: f, offset: i.anchorOffset }], tu(i) || h.push({ node: i.focusNode, offset: i.focusOffset })), $n && n.input.lastKeyCode === 8)
    for (let A = u; A > o; A--) {
      let b = r.childNodes[A - 1], S = b.pmViewDesc;
      if (b.nodeName == "BR" && !S) {
        u = A;
        break;
      }
      if (!S || S.size)
        break;
    }
  let p = n.state.doc, d = n.someProp("domParser") || dd.fromSchema(n.state.schema), v = p.resolve(c), g = null, m = d.parse(r, {
    topNode: v.parent,
    topMatch: v.parent.contentMatchAt(v.index()),
    topOpen: !0,
    from: o,
    to: u,
    preserveWhitespace: v.parent.type.whitespace == "pre" ? "full" : !0,
    findPositions: h,
    ruleFromNode: uN,
    context: v
  });
  if (h && h[0].pos != null) {
    let A = h[0].pos, b = h[1] && h[1].pos;
    b == null && (b = A), g = { anchor: A + c, head: b + c };
  }
  return { doc: m, sel: g, from: c, to: l };
}
function uN(n) {
  let e = n.pmViewDesc;
  if (e)
    return e.parseRule();
  if (n.nodeName == "BR" && n.parentNode) {
    if (Gn && /^(ul|ol)$/i.test(n.parentNode.nodeName)) {
      let t = document.createElement("div");
      return t.appendChild(document.createElement("li")), { skip: t };
    } else if (n.parentNode.lastChild == n || Gn && /^(tr|table)$/i.test(n.parentNode.nodeName))
      return { ignore: !0 };
  } else if (n.nodeName == "IMG" && n.getAttribute("mark-placeholder"))
    return { ignore: !0 };
  return null;
}
const cN = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function fN(n, e, t, r, o) {
  let u = n.input.compositionPendingChanges || (n.composing ? n.input.compositionID : 0);
  if (n.input.compositionPendingChanges = 0, e < 0) {
    let _ = n.input.lastSelectionTime > Date.now() - 50 ? n.input.lastSelectionOrigin : null, O = vd(n, _);
    if (O && !n.state.selection.eq(O)) {
      if ($n && Tr && n.input.lastKeyCode === 13 && Date.now() - 100 < n.input.lastKeyCodeTime && n.someProp("handleKeyDown", (M) => M(n, Qi(13, "Enter"))))
        return;
      let D = n.state.tr.setSelection(O);
      _ == "pointer" ? D.setMeta("pointer", !0) : _ == "key" && D.scrollIntoView(), u && D.setMeta("composition", u), n.dispatch(D);
    }
    return;
  }
  let c = n.state.doc.resolve(e), l = c.sharedDepth(t);
  e = c.before(l + 1), t = n.state.doc.resolve(t).after(l + 1);
  let i = n.state.selection, h = lN(n, e, t), f = n.state.doc, p = f.slice(h.from, h.to), d, v;
  n.input.lastKeyCode === 8 && Date.now() - 100 < n.input.lastKeyCodeTime ? (d = n.state.selection.to, v = "end") : (d = n.state.selection.from, v = "start"), n.input.lastKeyCode = null;
  let g = pN(p.content, h.doc.content, h.from, d, v);
  if ((uo && n.input.lastIOSEnter > Date.now() - 225 || Tr) && o.some((_) => _.nodeType == 1 && !cN.test(_.nodeName)) && (!g || g.endA >= g.endB) && n.someProp("handleKeyDown", (_) => _(n, Qi(13, "Enter")))) {
    n.input.lastIOSEnter = 0;
    return;
  }
  if (!g)
    if (r && i instanceof Zt && !i.empty && i.$head.sameParent(i.$anchor) && !n.composing && !(h.sel && h.sel.anchor != h.sel.head))
      g = { start: i.from, endA: i.to, endB: i.to };
    else {
      if (h.sel) {
        let _ = kp(n, n.state.doc, h.sel);
        if (_ && !_.eq(n.state.selection)) {
          let O = n.state.tr.setSelection(_);
          u && O.setMeta("composition", u), n.dispatch(O);
        }
      }
      return;
    }
  n.input.domChangeCount++, n.state.selection.from < n.state.selection.to && g.start == g.endB && n.state.selection instanceof Zt && (g.start > n.state.selection.from && g.start <= n.state.selection.from + 2 && n.state.selection.from >= h.from ? g.start = n.state.selection.from : g.endA < n.state.selection.to && g.endA >= n.state.selection.to - 2 && n.state.selection.to <= h.to && (g.endB += n.state.selection.to - g.endA, g.endA = n.state.selection.to)), qn && Ri <= 11 && g.endB == g.start + 1 && g.endA == g.start && g.start > h.from && h.doc.textBetween(g.start - h.from - 1, g.start - h.from + 1) == "  " && (g.start--, g.endA--, g.endB--);
  let m = h.doc.resolveNoCache(g.start - h.from), A = h.doc.resolveNoCache(g.endB - h.from), b = f.resolve(g.start), S = m.sameParent(A) && m.parent.inlineContent && b.end() >= g.endA, N;
  if ((uo && n.input.lastIOSEnter > Date.now() - 225 && (!S || o.some((_) => _.nodeName == "DIV" || _.nodeName == "P")) || !S && m.pos < h.doc.content.size && !m.sameParent(A) && (N = en.findFrom(h.doc.resolve(m.pos + 1), 1, !0)) && N.head == A.pos) && n.someProp("handleKeyDown", (_) => _(n, Qi(13, "Enter")))) {
    n.input.lastIOSEnter = 0;
    return;
  }
  if (n.state.selection.anchor > g.start && hN(f, g.start, g.endA, m, A) && n.someProp("handleKeyDown", (_) => _(n, Qi(8, "Backspace")))) {
    Tr && $n && n.domObserver.suppressSelectionUpdates();
    return;
  }
  $n && Tr && g.endB == g.start && (n.input.lastAndroidDelete = Date.now()), Tr && !S && m.start() != A.start() && A.parentOffset == 0 && m.depth == A.depth && h.sel && h.sel.anchor == h.sel.head && h.sel.head == g.endA && (g.endB -= 2, A = h.doc.resolveNoCache(g.endB - h.from), setTimeout(() => {
    n.someProp("handleKeyDown", function(_) {
      return _(n, Qi(13, "Enter"));
    });
  }, 20));
  let T = g.start, R = g.endA, y, E, L;
  if (S) {
    if (m.pos == A.pos)
      qn && Ri <= 11 && m.parentOffset == 0 && (n.domObserver.suppressSelectionUpdates(), setTimeout(() => ri(n), 20)), y = n.state.tr.delete(T, R), E = f.resolve(g.start).marksAcross(f.resolve(g.endA));
    else if (
      // Adding or removing a mark
      g.endA == g.endB && (L = dN(m.parent.content.cut(m.parentOffset, A.parentOffset), b.parent.content.cut(b.parentOffset, g.endA - b.start())))
    )
      y = n.state.tr, L.type == "add" ? y.addMark(T, R, L.mark) : y.removeMark(T, R, L.mark);
    else if (m.parent.child(m.index()).isText && m.index() == A.index() - (A.textOffset ? 0 : 1)) {
      let _ = m.parent.textBetween(m.parentOffset, A.parentOffset);
      if (n.someProp("handleTextInput", (O) => O(n, T, R, _)))
        return;
      y = n.state.tr.insertText(_, T, R);
    }
  }
  if (y || (y = n.state.tr.replace(T, R, h.doc.slice(g.start - h.from, g.endB - h.from))), h.sel) {
    let _ = kp(n, y.doc, h.sel);
    _ && !($n && Tr && n.composing && _.empty && (g.start != g.endB || n.input.lastAndroidDelete < Date.now() - 100) && (_.head == T || _.head == y.mapping.map(R) - 1) || qn && _.empty && _.head == T) && y.setSelection(_);
  }
  E && y.ensureMarks(E), u && y.setMeta("composition", u), n.dispatch(y.scrollIntoView());
}
function kp(n, e, t) {
  return Math.max(t.anchor, t.head) > e.content.size ? null : _d(n, e.resolve(t.anchor), e.resolve(t.head));
}
function dN(n, e) {
  let t = n.firstChild.marks, r = e.firstChild.marks, o = t, u = r, c, l, i;
  for (let f = 0; f < r.length; f++)
    o = r[f].removeFromSet(o);
  for (let f = 0; f < t.length; f++)
    u = t[f].removeFromSet(u);
  if (o.length == 1 && u.length == 0)
    l = o[0], c = "add", i = (f) => f.mark(l.addToSet(f.marks));
  else if (o.length == 0 && u.length == 1)
    l = u[0], c = "remove", i = (f) => f.mark(l.removeFromSet(f.marks));
  else
    return null;
  let h = [];
  for (let f = 0; f < e.childCount; f++)
    h.push(i(e.child(f)));
  if (Tt.from(h).eq(n))
    return { mark: l, type: c };
}
function hN(n, e, t, r, o) {
  if (
    // The content must have shrunk
    t - e <= o.pos - r.pos || // newEnd must point directly at or after the end of the block that newStart points into
    lc(r, !0, !1) < o.pos
  )
    return !1;
  let u = n.resolve(e);
  if (!r.parent.isTextblock) {
    let l = u.nodeAfter;
    return l != null && t == e + l.nodeSize;
  }
  if (u.parentOffset < u.parent.content.size || !u.parent.isTextblock)
    return !1;
  let c = n.resolve(lc(u, !0, !0));
  return !c.parent.isTextblock || c.pos > t || lc(c, !0, !1) < t ? !1 : r.parent.content.cut(r.parentOffset).eq(c.parent.content);
}
function lc(n, e, t) {
  let r = n.depth, o = e ? n.end() : n.pos;
  for (; r > 0 && (e || n.indexAfter(r) == n.node(r).childCount); )
    r--, o++, e = !1;
  if (t) {
    let u = n.node(r).maybeChild(n.indexAfter(r));
    for (; u && !u.isLeaf; )
      u = u.firstChild, o++;
  }
  return o;
}
function pN(n, e, t, r, o) {
  let u = n.findDiffStart(e, t);
  if (u == null)
    return null;
  let { a: c, b: l } = n.findDiffEnd(e, t + n.size, t + e.size);
  if (o == "end") {
    let i = Math.max(0, u - Math.min(c, l));
    r -= c + i - u;
  }
  if (c < u && n.size < e.size) {
    let i = r <= u && r >= c ? u - r : 0;
    u -= i, u && u < e.size && Kp(e.textBetween(u - 1, u + 1)) && (u += i ? 1 : -1), l = u + (l - c), c = u;
  } else if (l < u) {
    let i = r <= u && r >= l ? u - r : 0;
    u -= i, u && u < n.size && Kp(n.textBetween(u - 1, u + 1)) && (u += i ? 1 : -1), c = u + (c - l), l = u;
  }
  return { start: u, endA: c, endB: l };
}
function Kp(n) {
  if (n.length != 2)
    return !1;
  let e = n.charCodeAt(0), t = n.charCodeAt(1);
  return e >= 56320 && e <= 57343 && t >= 55296 && t <= 56319;
}
class mN {
  /**
  Create a view. `place` may be a DOM node that the editor should
  be appended to, a function that will place it into the document,
  or an object whose `mount` property holds the node to use as the
  document container. If it is `null`, the editor will not be
  added to the document.
  */
  constructor(e, t) {
    this._root = null, this.focused = !1, this.trackWrites = null, this.mounted = !1, this.markCursor = null, this.cursorWrapper = null, this.lastSelectedViewDesc = void 0, this.input = new xI(), this.prevDirectPlugins = [], this.pluginViews = [], this.requiresGeckoHackNode = !1, this.dragging = null, this._props = t, this.state = t.state, this.directPlugins = t.plugins || [], this.directPlugins.forEach($p), this.dispatch = this.dispatch.bind(this), this.dom = e && e.mount || document.createElement("div"), e && (e.appendChild ? e.appendChild(this.dom) : typeof e == "function" ? e(this.dom) : e.mount && (this.mounted = !0)), this.editable = Vp(this), Wp(this), this.nodeViews = Hp(this), this.docView = Tp(this.state.doc, jp(this), sc(this), this.dom, this), this.domObserver = new aN(this, (r, o, u, c) => fN(this, r, o, u, c)), this.domObserver.start(), BI(this), this.updatePluginViews();
  }
  /**
  Holds `true` when a
  [composition](https://w3c.github.io/uievents/#events-compositionevents)
  is active.
  */
  get composing() {
    return this.input.composing;
  }
  /**
  The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
  */
  get props() {
    if (this._props.state != this.state) {
      let e = this._props;
      this._props = {};
      for (let t in e)
        this._props[t] = e[t];
      this._props.state = this.state;
    }
    return this._props;
  }
  /**
  Update the view's props. Will immediately cause an update to
  the DOM.
  */
  update(e) {
    e.handleDOMEvents != this._props.handleDOMEvents && lf(this);
    let t = this._props;
    this._props = e, e.plugins && (e.plugins.forEach($p), this.directPlugins = e.plugins), this.updateStateInner(e.state, t);
  }
  /**
  Update the view by updating existing props object with the object
  given as argument. Equivalent to `view.update(Object.assign({},
  view.props, props))`.
  */
  setProps(e) {
    let t = {};
    for (let r in this._props)
      t[r] = this._props[r];
    t.state = this.state;
    for (let r in e)
      t[r] = e[r];
    this.update(t);
  }
  /**
  Update the editor's `state` prop, without touching any of the
  other props.
  */
  updateState(e) {
    this.updateStateInner(e, this._props);
  }
  updateStateInner(e, t) {
    var r;
    let o = this.state, u = !1, c = !1;
    e.storedMarks && this.composing && (i_(this), c = !0), this.state = e;
    let l = o.plugins != e.plugins || this._props.plugins != t.plugins;
    if (l || this._props.plugins != t.plugins || this._props.nodeViews != t.nodeViews) {
      let v = Hp(this);
      vN(v, this.nodeViews) && (this.nodeViews = v, u = !0);
    }
    (l || t.handleDOMEvents != this._props.handleDOMEvents) && lf(this), this.editable = Vp(this), Wp(this);
    let i = sc(this), h = jp(this), f = o.plugins != e.plugins && !o.doc.eq(e.doc) ? "reset" : e.scrollToSelection > o.scrollToSelection ? "to selection" : "preserve", p = u || !this.docView.matchesNode(e.doc, h, i);
    (p || !e.selection.eq(o.selection)) && (c = !0);
    let d = f == "preserve" && c && this.dom.style.overflowAnchor == null && JP(this);
    if (c) {
      this.domObserver.stop();
      let v = p && (qn || $n) && !this.composing && !o.selection.empty && !e.selection.empty && gN(o.selection, e.selection);
      if (p) {
        let g = $n ? this.trackWrites = this.domSelectionRange().focusNode : null;
        this.composing && (this.input.compositionNode = XI(this)), (u || !this.docView.update(e.doc, h, i, this)) && (this.docView.updateOuterDeco(h), this.docView.destroy(), this.docView = Tp(e.doc, h, i, this.dom, this)), g && !this.trackWrites && (v = !0);
      }
      v || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && TI(this)) ? ri(this, v) : ($v(this, e.selection), this.domObserver.setCurSelection()), this.domObserver.start();
    }
    this.updatePluginViews(o), !((r = this.dragging) === null || r === void 0) && r.node && !o.doc.eq(e.doc) && this.updateDraggedNode(this.dragging, o), f == "reset" ? this.dom.scrollTop = 0 : f == "to selection" ? this.scrollToSelection() : d && ZP(d);
  }
  /**
  @internal
  */
  scrollToSelection() {
    let e = this.domSelectionRange().focusNode;
    if (!this.someProp("handleScrollToSelection", (t) => t(this)))
      if (this.state.selection instanceof $t) {
        let t = this.docView.domAfterPos(this.state.selection.from);
        t.nodeType == 1 && mp(this, t.getBoundingClientRect(), e);
      } else
        mp(this, this.coordsAtPos(this.state.selection.head, 1), e);
  }
  destroyPluginViews() {
    let e;
    for (; e = this.pluginViews.pop(); )
      e.destroy && e.destroy();
  }
  updatePluginViews(e) {
    if (!e || e.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
      this.prevDirectPlugins = this.directPlugins, this.destroyPluginViews();
      for (let t = 0; t < this.directPlugins.length; t++) {
        let r = this.directPlugins[t];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
      for (let t = 0; t < this.state.plugins.length; t++) {
        let r = this.state.plugins[t];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
    } else
      for (let t = 0; t < this.pluginViews.length; t++) {
        let r = this.pluginViews[t];
        r.update && r.update(this, e);
      }
  }
  updateDraggedNode(e, t) {
    let r = e.node, o = -1;
    if (this.state.doc.nodeAt(r.from) == r.node)
      o = r.from;
    else {
      let u = r.from + (this.state.doc.content.size - t.doc.content.size);
      (u > 0 && this.state.doc.nodeAt(u)) == r.node && (o = u);
    }
    this.dragging = new o_(e.slice, e.move, o < 0 ? void 0 : $t.create(this.state.doc, o));
  }
  someProp(e, t) {
    let r = this._props && this._props[e], o;
    if (r != null && (o = t ? t(r) : r))
      return o;
    for (let c = 0; c < this.directPlugins.length; c++) {
      let l = this.directPlugins[c].props[e];
      if (l != null && (o = t ? t(l) : l))
        return o;
    }
    let u = this.state.plugins;
    if (u)
      for (let c = 0; c < u.length; c++) {
        let l = u[c].props[e];
        if (l != null && (o = t ? t(l) : l))
          return o;
      }
  }
  /**
  Query whether the view has focus.
  */
  hasFocus() {
    if (qn) {
      let e = this.root.activeElement;
      if (e == this.dom)
        return !0;
      if (!e || !this.dom.contains(e))
        return !1;
      for (; e && this.dom != e && this.dom.contains(e); ) {
        if (e.contentEditable == "false")
          return !1;
        e = e.parentElement;
      }
      return !0;
    }
    return this.root.activeElement == this.dom;
  }
  /**
  Focus the editor.
  */
  focus() {
    this.domObserver.stop(), this.editable && qP(this.dom), ri(this), this.domObserver.start();
  }
  /**
  Get the document root in which the editor exists. This will
  usually be the top-level `document`, but might be a [shadow
  DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
  root if the editor is inside one.
  */
  get root() {
    let e = this._root;
    if (e == null) {
      for (let t = this.dom.parentNode; t; t = t.parentNode)
        if (t.nodeType == 9 || t.nodeType == 11 && t.host)
          return t.getSelection || (Object.getPrototypeOf(t).getSelection = () => t.ownerDocument.getSelection()), this._root = t;
    }
    return e || document;
  }
  /**
  When an existing editor view is moved to a new document or
  shadow tree, call this to make it recompute its root.
  */
  updateRoot() {
    this._root = null;
  }
  /**
  Given a pair of viewport coordinates, return the document
  position that corresponds to them. May return null if the given
  coordinates aren't inside of the editor. When an object is
  returned, its `pos` property is the position nearest to the
  coordinates, and its `inside` property holds the position of the
  inner node that the position falls inside of, or -1 if it is at
  the top level, not in any node.
  */
  posAtCoords(e) {
    return iI(this, e);
  }
  /**
  Returns the viewport rectangle at a given document position.
  `left` and `right` will be the same number, as this returns a
  flat cursor-ish rectangle. If the position is between two things
  that aren't directly adjacent, `side` determines which element
  is used. When < 0, the element before the position is used,
  otherwise the element after.
  */
  coordsAtPos(e, t = 1) {
    return Fv(this, e, t);
  }
  /**
  Find the DOM position that corresponds to the given document
  position. When `side` is negative, find the position as close as
  possible to the content before the position. When positive,
  prefer positions close to the content after the position. When
  zero, prefer as shallow a position as possible.
  
  Note that you should **not** mutate the editor's internal DOM,
  only inspect it (and even that is usually not necessary).
  */
  domAtPos(e, t = 0) {
    return this.docView.domFromPos(e, t);
  }
  /**
  Find the DOM node that represents the document node after the
  given position. May return `null` when the position doesn't point
  in front of a node or if the node is inside an opaque node view.
  
  This is intended to be able to call things like
  `getBoundingClientRect` on that DOM node. Do **not** mutate the
  editor DOM directly, or add styling this way, since that will be
  immediately overriden by the editor as it redraws the node.
  */
  nodeDOM(e) {
    let t = this.docView.descAt(e);
    return t ? t.nodeDOM : null;
  }
  /**
  Find the document position that corresponds to a given DOM
  position. (Whenever possible, it is preferable to inspect the
  document structure directly, rather than poking around in the
  DOM, but sometimes—for example when interpreting an event
  target—you don't have a choice.)
  
  The `bias` parameter can be used to influence which side of a DOM
  node to use when the position is inside a leaf node.
  */
  posAtDOM(e, t, r = -1) {
    let o = this.docView.posFromDOM(e, t, r);
    if (o == null)
      throw new RangeError("DOM position not inside the editor");
    return o;
  }
  /**
  Find out whether the selection is at the end of a textblock when
  moving in a given direction. When, for example, given `"left"`,
  it will return true if moving left from the current cursor
  position would leave that position's parent textblock. Will apply
  to the view's current state by default, but it is possible to
  pass a different state.
  */
  endOfTextblock(e, t) {
    return uI(this, t || this.state, e);
  }
  /**
  Run the editor's paste logic with the given HTML string. The
  `event`, if given, will be passed to the
  [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
  */
  pasteHTML(e, t) {
    return gs(this, "", e, !1, t || new ClipboardEvent("paste"));
  }
  /**
  Run the editor's paste logic with the given plain-text input.
  */
  pasteText(e, t) {
    return gs(this, e, null, !0, t || new ClipboardEvent("paste"));
  }
  /**
  Removes the editor from the DOM and destroys all [node
  views](https://prosemirror.net/docs/ref/#view.NodeView).
  */
  destroy() {
    this.docView && (FI(this), this.destroyPluginViews(), this.mounted ? (this.docView.update(this.state.doc, [], sc(this), this), this.dom.textContent = "") : this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.docView.destroy(), this.docView = null, kP());
  }
  /**
  This is true when the view has been
  [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
  used anymore).
  */
  get isDestroyed() {
    return this.docView == null;
  }
  /**
  Used for testing.
  */
  dispatchEvent(e) {
    return kI(this, e);
  }
  /**
  Dispatch a transaction. Will call
  [`dispatchTransaction`](https://prosemirror.net/docs/ref/#view.DirectEditorProps.dispatchTransaction)
  when given, and otherwise defaults to applying the transaction to
  the current state and calling
  [`updateState`](https://prosemirror.net/docs/ref/#view.EditorView.updateState) with the result.
  This method is bound to the view instance, so that it can be
  easily passed around.
  */
  dispatch(e) {
    let t = this._props.dispatchTransaction;
    t ? t.call(this, e) : this.updateState(this.state.apply(e));
  }
  /**
  @internal
  */
  domSelectionRange() {
    let e = this.domSelection();
    return Gn && this.root.nodeType === 11 && HP(this.dom.ownerDocument) == this.dom && sN(this, e) || e;
  }
  /**
  @internal
  */
  domSelection() {
    return this.root.getSelection();
  }
}
function jp(n) {
  let e = /* @__PURE__ */ Object.create(null);
  return e.class = "ProseMirror", e.contenteditable = String(n.editable), n.someProp("attributes", (t) => {
    if (typeof t == "function" && (t = t(n.state)), t)
      for (let r in t)
        r == "class" ? e.class += " " + t[r] : r == "style" ? e.style = (e.style ? e.style + ";" : "") + t[r] : !e[r] && r != "contenteditable" && r != "nodeName" && (e[r] = String(t[r]));
  }), e.translate || (e.translate = "no"), [pr.node(0, n.state.doc.content.size, e)];
}
function Wp(n) {
  if (n.markCursor) {
    let e = document.createElement("img");
    e.className = "ProseMirror-separator", e.setAttribute("mark-placeholder", "true"), e.setAttribute("alt", ""), n.cursorWrapper = { dom: e, deco: pr.widget(n.state.selection.head, e, { raw: !0, marks: n.markCursor }) };
  } else
    n.cursorWrapper = null;
}
function Vp(n) {
  return !n.someProp("editable", (e) => e(n.state) === !1);
}
function gN(n, e) {
  let t = Math.min(n.$anchor.sharedDepth(n.head), e.$anchor.sharedDepth(e.head));
  return n.$anchor.start(t) != e.$anchor.start(t);
}
function Hp(n) {
  let e = /* @__PURE__ */ Object.create(null);
  function t(r) {
    for (let o in r)
      Object.prototype.hasOwnProperty.call(e, o) || (e[o] = r[o]);
  }
  return n.someProp("nodeViews", t), n.someProp("markViews", t), e;
}
function vN(n, e) {
  let t = 0, r = 0;
  for (let o in n) {
    if (n[o] != e[o])
      return !0;
    t++;
  }
  for (let o in e)
    r++;
  return t != r;
}
function $p(n) {
  if (n.spec.state || n.spec.filterTransaction || n.spec.appendTransaction)
    throw new RangeError("Plugins passed directly to the view must not have a state component");
}
var Li = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, Ll = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, _N = typeof navigator < "u" && /Mac/.test(navigator.platform), EN = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var Fn = 0; Fn < 10; Fn++)
  Li[48 + Fn] = Li[96 + Fn] = String(Fn);
for (var Fn = 1; Fn <= 24; Fn++)
  Li[Fn + 111] = "F" + Fn;
for (var Fn = 65; Fn <= 90; Fn++)
  Li[Fn] = String.fromCharCode(Fn + 32), Ll[Fn] = String.fromCharCode(Fn);
for (var uc in Li)
  Ll.hasOwnProperty(uc) || (Ll[uc] = Li[uc]);
function yN(n) {
  var e = _N && n.metaKey && n.shiftKey && !n.ctrlKey && !n.altKey || EN && n.shiftKey && n.key && n.key.length == 1 || n.key == "Unidentified", t = !e && n.key || (n.shiftKey ? Ll : Li)[n.keyCode] || n.key || "Unidentified";
  return t == "Esc" && (t = "Escape"), t == "Del" && (t = "Delete"), t == "Left" && (t = "ArrowLeft"), t == "Up" && (t = "ArrowUp"), t == "Right" && (t = "ArrowRight"), t == "Down" && (t = "ArrowDown"), t;
}
const TN = typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : !1;
function AN(n) {
  let e = n.split(/-(?!$)/), t = e[e.length - 1];
  t == "Space" && (t = " ");
  let r, o, u, c;
  for (let l = 0; l < e.length - 1; l++) {
    let i = e[l];
    if (/^(cmd|meta|m)$/i.test(i))
      c = !0;
    else if (/^a(lt)?$/i.test(i))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(i))
      o = !0;
    else if (/^s(hift)?$/i.test(i))
      u = !0;
    else if (/^mod$/i.test(i))
      TN ? c = !0 : o = !0;
    else
      throw new Error("Unrecognized modifier name: " + i);
  }
  return r && (t = "Alt-" + t), o && (t = "Ctrl-" + t), c && (t = "Meta-" + t), u && (t = "Shift-" + t), t;
}
function SN(n) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let t in n)
    e[AN(t)] = n[t];
  return e;
}
function cc(n, e, t = !0) {
  return e.altKey && (n = "Alt-" + n), e.ctrlKey && (n = "Ctrl-" + n), e.metaKey && (n = "Meta-" + n), t && e.shiftKey && (n = "Shift-" + n), n;
}
function CN(n) {
  return new tr({ props: { handleKeyDown: f_(n) } });
}
function f_(n) {
  let e = SN(n);
  return function(t, r) {
    let o = yN(r), u, c = e[cc(o, r)];
    if (c && c(t.state, t.dispatch, t))
      return !0;
    if (o.length == 1 && o != " ") {
      if (r.shiftKey) {
        let l = e[cc(o, r, !1)];
        if (l && l(t.state, t.dispatch, t))
          return !0;
      }
      if ((r.shiftKey || r.altKey || r.metaKey || o.charCodeAt(0) > 127) && (u = Li[r.keyCode]) && u != o) {
        let l = e[cc(u, r)];
        if (l && l(t.state, t.dispatch, t))
          return !0;
      }
    }
    return !1;
  };
}
const MN = (n, e) => n.selection.empty ? !1 : (e && e(n.tr.deleteSelection().scrollIntoView()), !0);
function d_(n, e) {
  let { $cursor: t } = n.selection;
  return !t || (e ? !e.endOfTextblock("backward", n) : t.parentOffset > 0) ? null : t;
}
const bN = (n, e, t) => {
  let r = d_(n, t);
  if (!r)
    return !1;
  let o = Cd(r);
  if (!o) {
    let c = r.blockRange(), l = c && Ao(c);
    return l == null ? !1 : (e && e(n.tr.lift(c, l).scrollIntoView()), !0);
  }
  let u = o.nodeBefore;
  if (!u.type.spec.isolating && g_(n, o, e))
    return !0;
  if (r.parent.content.size == 0 && (co(u, "end") || $t.isSelectable(u))) {
    let c = ql(n.doc, r.before(), r.after(), Lt.empty);
    if (c && c.slice.size < c.to - c.from) {
      if (e) {
        let l = n.tr.step(c);
        l.setSelection(co(u, "end") ? en.findFrom(l.doc.resolve(l.mapping.map(o.pos, -1)), -1) : $t.create(l.doc, o.pos - u.nodeSize)), e(l.scrollIntoView());
      }
      return !0;
    }
  }
  return u.isAtom && o.depth == r.depth - 1 ? (e && e(n.tr.delete(o.pos - u.nodeSize, o.pos).scrollIntoView()), !0) : !1;
}, RN = (n, e, t) => {
  let r = d_(n, t);
  if (!r)
    return !1;
  let o = Cd(r);
  return o ? h_(n, o, e) : !1;
}, DN = (n, e, t) => {
  let r = p_(n, t);
  if (!r)
    return !1;
  let o = Md(r);
  return o ? h_(n, o, e) : !1;
};
function h_(n, e, t) {
  let r = e.nodeBefore, o = r, u = e.pos - 1;
  for (; !o.isTextblock; u--) {
    if (o.type.spec.isolating)
      return !1;
    let f = o.lastChild;
    if (!f)
      return !1;
    o = f;
  }
  let c = e.nodeAfter, l = c, i = e.pos + 1;
  for (; !l.isTextblock; i++) {
    if (l.type.spec.isolating)
      return !1;
    let f = l.firstChild;
    if (!f)
      return !1;
    l = f;
  }
  let h = ql(n.doc, u, i, Lt.empty);
  if (!h || h.from != u || h instanceof Pn && h.slice.size >= i - u)
    return !1;
  if (t) {
    let f = n.tr.step(h);
    f.setSelection(Zt.create(f.doc, u)), t(f.scrollIntoView());
  }
  return !0;
}
function co(n, e, t = !1) {
  for (let r = n; r; r = e == "start" ? r.firstChild : r.lastChild) {
    if (r.isTextblock)
      return !0;
    if (t && r.childCount != 1)
      return !1;
  }
  return !1;
}
const ON = (n, e, t) => {
  let { $head: r, empty: o } = n.selection, u = r;
  if (!o)
    return !1;
  if (r.parent.isTextblock) {
    if (t ? !t.endOfTextblock("backward", n) : r.parentOffset > 0)
      return !1;
    u = Cd(r);
  }
  let c = u && u.nodeBefore;
  return !c || !$t.isSelectable(c) ? !1 : (e && e(n.tr.setSelection($t.create(n.doc, u.pos - c.nodeSize)).scrollIntoView()), !0);
};
function Cd(n) {
  if (!n.parent.type.spec.isolating)
    for (let e = n.depth - 1; e >= 0; e--) {
      if (n.index(e) > 0)
        return n.doc.resolve(n.before(e + 1));
      if (n.node(e).type.spec.isolating)
        break;
    }
  return null;
}
function p_(n, e) {
  let { $cursor: t } = n.selection;
  return !t || (e ? !e.endOfTextblock("forward", n) : t.parentOffset < t.parent.content.size) ? null : t;
}
const PN = (n, e, t) => {
  let r = p_(n, t);
  if (!r)
    return !1;
  let o = Md(r);
  if (!o)
    return !1;
  let u = o.nodeAfter;
  if (g_(n, o, e))
    return !0;
  if (r.parent.content.size == 0 && (co(u, "start") || $t.isSelectable(u))) {
    let c = ql(n.doc, r.before(), r.after(), Lt.empty);
    if (c && c.slice.size < c.to - c.from) {
      if (e) {
        let l = n.tr.step(c);
        l.setSelection(co(u, "start") ? en.findFrom(l.doc.resolve(l.mapping.map(o.pos)), 1) : $t.create(l.doc, l.mapping.map(o.pos))), e(l.scrollIntoView());
      }
      return !0;
    }
  }
  return u.isAtom && o.depth == r.depth - 1 ? (e && e(n.tr.delete(o.pos, o.pos + u.nodeSize).scrollIntoView()), !0) : !1;
}, IN = (n, e, t) => {
  let { $head: r, empty: o } = n.selection, u = r;
  if (!o)
    return !1;
  if (r.parent.isTextblock) {
    if (t ? !t.endOfTextblock("forward", n) : r.parentOffset < r.parent.content.size)
      return !1;
    u = Md(r);
  }
  let c = u && u.nodeAfter;
  return !c || !$t.isSelectable(c) ? !1 : (e && e(n.tr.setSelection($t.create(n.doc, u.pos)).scrollIntoView()), !0);
};
function Md(n) {
  if (!n.parent.type.spec.isolating)
    for (let e = n.depth - 1; e >= 0; e--) {
      let t = n.node(e);
      if (n.index(e) + 1 < t.childCount)
        return n.doc.resolve(n.after(e + 1));
      if (t.type.spec.isolating)
        break;
    }
  return null;
}
const NN = (n, e) => {
  let t = n.selection, r = t instanceof $t, o;
  if (r) {
    if (t.node.isTextblock || !Fi(n.doc, t.from))
      return !1;
    o = t.from;
  } else if (o = Zl(n.doc, t.from, -1), o == null)
    return !1;
  if (e) {
    let u = n.tr.join(o);
    r && u.setSelection($t.create(u.doc, o - n.doc.resolve(o).nodeBefore.nodeSize)), e(u.scrollIntoView());
  }
  return !0;
}, LN = (n, e) => {
  let t = n.selection, r;
  if (t instanceof $t) {
    if (t.node.isTextblock || !Fi(n.doc, t.to))
      return !1;
    r = t.to;
  } else if (r = Zl(n.doc, t.to, 1), r == null)
    return !1;
  return e && e(n.tr.join(r).scrollIntoView()), !0;
}, wN = (n, e) => {
  let { $from: t, $to: r } = n.selection, o = t.blockRange(r), u = o && Ao(o);
  return u == null ? !1 : (e && e(n.tr.lift(o, u).scrollIntoView()), !0);
}, xN = (n, e) => {
  let { $head: t, $anchor: r } = n.selection;
  return !t.parent.type.spec.code || !t.sameParent(r) ? !1 : (e && e(n.tr.insertText(`
`).scrollIntoView()), !0);
};
function m_(n) {
  for (let e = 0; e < n.edgeCount; e++) {
    let { type: t } = n.edge(e);
    if (t.isTextblock && !t.hasRequiredAttrs())
      return t;
  }
  return null;
}
const BN = (n, e) => {
  let { $head: t, $anchor: r } = n.selection;
  if (!t.parent.type.spec.code || !t.sameParent(r))
    return !1;
  let o = t.node(-1), u = t.indexAfter(-1), c = m_(o.contentMatchAt(u));
  if (!c || !o.canReplaceWith(u, u, c))
    return !1;
  if (e) {
    let l = t.after(), i = n.tr.replaceWith(l, l, c.createAndFill());
    i.setSelection(en.near(i.doc.resolve(l), 1)), e(i.scrollIntoView());
  }
  return !0;
}, FN = (n, e) => {
  let t = n.selection, { $from: r, $to: o } = t;
  if (t instanceof Cr || r.parent.inlineContent || o.parent.inlineContent)
    return !1;
  let u = m_(o.parent.contentMatchAt(o.indexAfter()));
  if (!u || !u.isTextblock)
    return !1;
  if (e) {
    let c = (!r.parentOffset && o.index() < o.parent.childCount ? r : o).pos, l = n.tr.insert(c, u.createAndFill());
    l.setSelection(Zt.create(l.doc, c + 1)), e(l.scrollIntoView());
  }
  return !0;
}, UN = (n, e) => {
  let { $cursor: t } = n.selection;
  if (!t || t.parent.content.size)
    return !1;
  if (t.depth > 1 && t.after() != t.end(-1)) {
    let u = t.before();
    if (za(n.doc, u))
      return e && e(n.tr.split(u).scrollIntoView()), !0;
  }
  let r = t.blockRange(), o = r && Ao(r);
  return o == null ? !1 : (e && e(n.tr.lift(r, o).scrollIntoView()), !0);
}, kN = (n, e) => {
  let { $from: t, to: r } = n.selection, o, u = t.sharedDepth(r);
  return u == 0 ? !1 : (o = t.before(u), e && e(n.tr.setSelection($t.create(n.doc, o))), !0);
};
function KN(n, e, t) {
  let r = e.nodeBefore, o = e.nodeAfter, u = e.index();
  return !r || !o || !r.type.compatibleContent(o.type) ? !1 : !r.content.size && e.parent.canReplace(u - 1, u) ? (t && t(n.tr.delete(e.pos - r.nodeSize, e.pos).scrollIntoView()), !0) : !e.parent.canReplace(u, u + 1) || !(o.isTextblock || Fi(n.doc, e.pos)) ? !1 : (t && t(n.tr.clearIncompatible(e.pos, r.type, r.contentMatchAt(r.childCount)).join(e.pos).scrollIntoView()), !0);
}
function g_(n, e, t) {
  let r = e.nodeBefore, o = e.nodeAfter, u, c;
  if (r.type.spec.isolating || o.type.spec.isolating)
    return !1;
  if (KN(n, e, t))
    return !0;
  let l = e.parent.canReplace(e.index(), e.index() + 1);
  if (l && (u = (c = r.contentMatchAt(r.childCount)).findWrapping(o.type)) && c.matchType(u[0] || o.type).validEnd) {
    if (t) {
      let p = e.pos + o.nodeSize, d = Tt.empty;
      for (let m = u.length - 1; m >= 0; m--)
        d = Tt.from(u[m].create(null, d));
      d = Tt.from(r.copy(d));
      let v = n.tr.step(new In(e.pos - 1, p, e.pos, p, new Lt(d, 1, 0), u.length, !0)), g = p + 2 * u.length;
      Fi(v.doc, g) && v.join(g), t(v.scrollIntoView());
    }
    return !0;
  }
  let i = en.findFrom(e, 1), h = i && i.$from.blockRange(i.$to), f = h && Ao(h);
  if (f != null && f >= e.depth)
    return t && t(n.tr.lift(h, f).scrollIntoView()), !0;
  if (l && co(o, "start", !0) && co(r, "end")) {
    let p = r, d = [];
    for (; d.push(p), !p.isTextblock; )
      p = p.lastChild;
    let v = o, g = 1;
    for (; !v.isTextblock; v = v.firstChild)
      g++;
    if (p.canReplace(p.childCount, p.childCount, v.content)) {
      if (t) {
        let m = Tt.empty;
        for (let b = d.length - 1; b >= 0; b--)
          m = Tt.from(d[b].copy(m));
        let A = n.tr.step(new In(e.pos - d.length, e.pos + o.nodeSize, e.pos + g, e.pos + o.nodeSize - g, new Lt(m, d.length, 0), 0, !0));
        t(A.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function v_(n) {
  return function(e, t) {
    let r = e.selection, o = n < 0 ? r.$from : r.$to, u = o.depth;
    for (; o.node(u).isInline; ) {
      if (!u)
        return !1;
      u--;
    }
    return o.node(u).isTextblock ? (t && t(e.tr.setSelection(Zt.create(e.doc, n < 0 ? o.start(u) : o.end(u)))), !0) : !1;
  };
}
const jN = v_(-1), WN = v_(1);
function VN(n, e = null) {
  return function(t, r) {
    let { $from: o, $to: u } = t.selection, c = o.blockRange(u), l = c && pd(c, n, e);
    return l ? (r && r(t.tr.wrap(c, l).scrollIntoView()), !0) : !1;
  };
}
function Gp(n, e = null) {
  return function(t, r) {
    let o = !1;
    for (let u = 0; u < t.selection.ranges.length && !o; u++) {
      let { $from: { pos: c }, $to: { pos: l } } = t.selection.ranges[u];
      t.doc.nodesBetween(c, l, (i, h) => {
        if (o)
          return !1;
        if (!(!i.isTextblock || i.hasMarkup(n, e)))
          if (i.type == n)
            o = !0;
          else {
            let f = t.doc.resolve(h), p = f.index();
            o = f.parent.canReplaceWith(p, p + 1, n);
          }
      });
    }
    if (!o)
      return !1;
    if (r) {
      let u = t.tr;
      for (let c = 0; c < t.selection.ranges.length; c++) {
        let { $from: { pos: l }, $to: { pos: i } } = t.selection.ranges[c];
        u.setBlockType(l, i, n, e);
      }
      r(u.scrollIntoView());
    }
    return !0;
  };
}
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function HN(n, e = null) {
  return function(t, r) {
    let { $from: o, $to: u } = t.selection, c = o.blockRange(u), l = !1, i = c;
    if (!c)
      return !1;
    if (c.depth >= 2 && o.node(c.depth - 1).type.compatibleContent(n) && c.startIndex == 0) {
      if (o.index(c.depth - 1) == 0)
        return !1;
      let f = t.doc.resolve(c.start - 2);
      i = new Ml(f, f, c.depth), c.endIndex < c.parent.childCount && (c = new Ml(o, t.doc.resolve(u.end(c.depth)), c.depth)), l = !0;
    }
    let h = pd(i, n, e, c);
    return h ? (r && r($N(t.tr, c, h, l, n).scrollIntoView()), !0) : !1;
  };
}
function $N(n, e, t, r, o) {
  let u = Tt.empty;
  for (let f = t.length - 1; f >= 0; f--)
    u = Tt.from(t[f].type.create(t[f].attrs, u));
  n.step(new In(e.start - (r ? 2 : 0), e.end, e.start, e.end, new Lt(u, 0, 0), t.length, !0));
  let c = 0;
  for (let f = 0; f < t.length; f++)
    t[f].type == o && (c = f + 1);
  let l = t.length - c, i = e.start + t.length - (r ? 2 : 0), h = e.parent;
  for (let f = e.startIndex, p = e.endIndex, d = !0; f < p; f++, d = !1)
    !d && za(n.doc, i, l) && (n.split(i, l), i += 2 * l), i += h.child(f).nodeSize;
  return n;
}
function GN(n) {
  return function(e, t) {
    let { $from: r, $to: o } = e.selection, u = r.blockRange(o, (c) => c.childCount > 0 && c.firstChild.type == n);
    return u ? t ? r.node(u.depth - 1).type == n ? zN(e, t, n, u) : YN(e, t, u) : !0 : !1;
  };
}
function zN(n, e, t, r) {
  let o = n.tr, u = r.end, c = r.$to.end(r.depth);
  u < c && (o.step(new In(u - 1, c, u, c, new Lt(Tt.from(t.create(null, r.parent.copy())), 1, 0), 1, !0)), r = new Ml(o.doc.resolve(r.$from.pos), o.doc.resolve(c), r.depth));
  const l = Ao(r);
  if (l == null)
    return !1;
  o.lift(r, l);
  let i = o.mapping.map(u, -1) - 1;
  return Fi(o.doc, i) && o.join(i), e(o.scrollIntoView()), !0;
}
function YN(n, e, t) {
  let r = n.tr, o = t.parent;
  for (let v = t.end, g = t.endIndex - 1, m = t.startIndex; g > m; g--)
    v -= o.child(g).nodeSize, r.delete(v - 1, v + 1);
  let u = r.doc.resolve(t.start), c = u.nodeAfter;
  if (r.mapping.map(t.end) != t.start + u.nodeAfter.nodeSize)
    return !1;
  let l = t.startIndex == 0, i = t.endIndex == o.childCount, h = u.node(-1), f = u.index(-1);
  if (!h.canReplace(f + (l ? 0 : 1), f + 1, c.content.append(i ? Tt.empty : Tt.from(o))))
    return !1;
  let p = u.pos, d = p + c.nodeSize;
  return r.step(new In(p - (l ? 1 : 0), d + (i ? 1 : 0), p + 1, d - 1, new Lt((l ? Tt.empty : Tt.from(o.copy(Tt.empty))).append(i ? Tt.empty : Tt.from(o.copy(Tt.empty))), l ? 0 : 1, i ? 0 : 1), l ? 0 : 1)), e(r.scrollIntoView()), !0;
}
function XN(n) {
  return function(e, t) {
    let { $from: r, $to: o } = e.selection, u = r.blockRange(o, (h) => h.childCount > 0 && h.firstChild.type == n);
    if (!u)
      return !1;
    let c = u.startIndex;
    if (c == 0)
      return !1;
    let l = u.parent, i = l.child(c - 1);
    if (i.type != n)
      return !1;
    if (t) {
      let h = i.lastChild && i.lastChild.type == l.type, f = Tt.from(h ? n.create() : null), p = new Lt(Tt.from(n.create(null, Tt.from(l.type.create(null, f)))), h ? 3 : 1, 0), d = u.start, v = u.end;
      t(e.tr.step(new In(d - (h ? 3 : 1), v, d, v, p, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
function iu(n) {
  const { state: e, transaction: t } = n;
  let { selection: r } = t, { doc: o } = t, { storedMarks: u } = t;
  return {
    ...e,
    apply: e.apply.bind(e),
    applyTransaction: e.applyTransaction.bind(e),
    plugins: e.plugins,
    schema: e.schema,
    reconfigure: e.reconfigure.bind(e),
    toJSON: e.toJSON.bind(e),
    get storedMarks() {
      return u;
    },
    get selection() {
      return r;
    },
    get doc() {
      return o;
    },
    get tr() {
      return r = t.selection, o = t.doc, u = t.storedMarks, t;
    }
  };
}
class au {
  constructor(e) {
    this.editor = e.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = e.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: e, editor: t, state: r } = this, { view: o } = t, { tr: u } = r, c = this.buildProps(u);
    return Object.fromEntries(Object.entries(e).map(([l, i]) => [l, (...f) => {
      const p = i(...f)(c);
      return !u.getMeta("preventDispatch") && !this.hasCustomState && o.dispatch(u), p;
    }]));
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(e, t = !0) {
    const { rawCommands: r, editor: o, state: u } = this, { view: c } = o, l = [], i = !!e, h = e || u.tr, f = () => (!i && t && !h.getMeta("preventDispatch") && !this.hasCustomState && c.dispatch(h), l.every((d) => d === !0)), p = {
      ...Object.fromEntries(Object.entries(r).map(([d, v]) => [d, (...m) => {
        const A = this.buildProps(h, t), b = v(...m)(A);
        return l.push(b), p;
      }])),
      run: f
    };
    return p;
  }
  createCan(e) {
    const { rawCommands: t, state: r } = this, o = !1, u = e || r.tr, c = this.buildProps(u, o);
    return {
      ...Object.fromEntries(Object.entries(t).map(([i, h]) => [i, (...f) => h(...f)({ ...c, dispatch: void 0 })])),
      chain: () => this.createChain(u, o)
    };
  }
  buildProps(e, t = !0) {
    const { rawCommands: r, editor: o, state: u } = this, { view: c } = o, l = {
      tr: e,
      editor: o,
      view: c,
      state: iu({
        state: u,
        transaction: e
      }),
      dispatch: t ? () => {
      } : void 0,
      chain: () => this.createChain(e, t),
      can: () => this.createCan(e),
      get commands() {
        return Object.fromEntries(Object.entries(r).map(([i, h]) => [i, (...f) => h(...f)(l)]));
      }
    };
    return l;
  }
}
class QN {
  constructor() {
    this.callbacks = {};
  }
  on(e, t) {
    return this.callbacks[e] || (this.callbacks[e] = []), this.callbacks[e].push(t), this;
  }
  emit(e, ...t) {
    const r = this.callbacks[e];
    return r && r.forEach((o) => o.apply(this, t)), this;
  }
  off(e, t) {
    const r = this.callbacks[e];
    return r && (t ? this.callbacks[e] = r.filter((o) => o !== t) : delete this.callbacks[e]), this;
  }
  removeAllListeners() {
    this.callbacks = {};
  }
}
function Bt(n, e, t) {
  return n.config[e] === void 0 && n.parent ? Bt(n.parent, e, t) : typeof n.config[e] == "function" ? n.config[e].bind({
    ...t,
    parent: n.parent ? Bt(n.parent, e, t) : null
  }) : n.config[e];
}
function ou(n) {
  const e = n.filter((o) => o.type === "extension"), t = n.filter((o) => o.type === "node"), r = n.filter((o) => o.type === "mark");
  return {
    baseExtensions: e,
    nodeExtensions: t,
    markExtensions: r
  };
}
function __(n) {
  const e = [], { nodeExtensions: t, markExtensions: r } = ou(n), o = [...t, ...r], u = {
    default: null,
    rendered: !0,
    renderHTML: null,
    parseHTML: null,
    keepOnSplit: !0,
    isRequired: !1
  };
  return n.forEach((c) => {
    const l = {
      name: c.name,
      options: c.options,
      storage: c.storage
    }, i = Bt(c, "addGlobalAttributes", l);
    if (!i)
      return;
    i().forEach((f) => {
      f.types.forEach((p) => {
        Object.entries(f.attributes).forEach(([d, v]) => {
          e.push({
            type: p,
            name: d,
            attribute: {
              ...u,
              ...v
            }
          });
        });
      });
    });
  }), o.forEach((c) => {
    const l = {
      name: c.name,
      options: c.options,
      storage: c.storage
    }, i = Bt(c, "addAttributes", l);
    if (!i)
      return;
    const h = i();
    Object.entries(h).forEach(([f, p]) => {
      const d = {
        ...u,
        ...p
      };
      typeof (d == null ? void 0 : d.default) == "function" && (d.default = d.default()), d != null && d.isRequired && (d == null ? void 0 : d.default) === void 0 && delete d.default, e.push({
        type: c.name,
        name: f,
        attribute: d
      });
    });
  }), e;
}
function Ln(n, e) {
  if (typeof n == "string") {
    if (!e.nodes[n])
      throw Error(`There is no node type named '${n}'. Maybe you forgot to add the extension?`);
    return e.nodes[n];
  }
  return n;
}
function Rn(...n) {
  return n.filter((e) => !!e).reduce((e, t) => {
    const r = { ...e };
    return Object.entries(t).forEach(([o, u]) => {
      if (!r[o]) {
        r[o] = u;
        return;
      }
      if (o === "class") {
        const l = u ? u.split(" ") : [], i = r[o] ? r[o].split(" ") : [], h = l.filter((f) => !i.includes(f));
        r[o] = [...i, ...h].join(" ");
      } else
        o === "style" ? r[o] = [r[o], u].join("; ") : r[o] = u;
    }), r;
  }, {});
}
function uf(n, e) {
  return e.filter((t) => t.attribute.rendered).map((t) => t.attribute.renderHTML ? t.attribute.renderHTML(n.attrs) || {} : {
    [t.name]: n.attrs[t.name]
  }).reduce((t, r) => Rn(t, r), {});
}
function E_(n) {
  return typeof n == "function";
}
function qt(n, e = void 0, ...t) {
  return E_(n) ? e ? n.bind(e)(...t) : n(...t) : n;
}
function JN(n = {}) {
  return Object.keys(n).length === 0 && n.constructor === Object;
}
function ZN(n) {
  return typeof n != "string" ? n : n.match(/^[+-]?(?:\d*\.)?\d+$/) ? Number(n) : n === "true" ? !0 : n === "false" ? !1 : n;
}
function zp(n, e) {
  return n.style ? n : {
    ...n,
    getAttrs: (t) => {
      const r = n.getAttrs ? n.getAttrs(t) : n.attrs;
      if (r === !1)
        return !1;
      const o = e.reduce((u, c) => {
        const l = c.attribute.parseHTML ? c.attribute.parseHTML(t) : ZN(t.getAttribute(c.name));
        return l == null ? u : {
          ...u,
          [c.name]: l
        };
      }, {});
      return { ...r, ...o };
    }
  };
}
function Yp(n) {
  return Object.fromEntries(
    // @ts-ignore
    Object.entries(n).filter(([e, t]) => e === "attrs" && JN(t) ? !1 : t != null)
  );
}
function qN(n, e) {
  var t;
  const r = __(n), { nodeExtensions: o, markExtensions: u } = ou(n), c = (t = o.find((h) => Bt(h, "topNode"))) === null || t === void 0 ? void 0 : t.name, l = Object.fromEntries(o.map((h) => {
    const f = r.filter((b) => b.type === h.name), p = {
      name: h.name,
      options: h.options,
      storage: h.storage,
      editor: e
    }, d = n.reduce((b, S) => {
      const N = Bt(S, "extendNodeSchema", p);
      return {
        ...b,
        ...N ? N(h) : {}
      };
    }, {}), v = Yp({
      ...d,
      content: qt(Bt(h, "content", p)),
      marks: qt(Bt(h, "marks", p)),
      group: qt(Bt(h, "group", p)),
      inline: qt(Bt(h, "inline", p)),
      atom: qt(Bt(h, "atom", p)),
      selectable: qt(Bt(h, "selectable", p)),
      draggable: qt(Bt(h, "draggable", p)),
      code: qt(Bt(h, "code", p)),
      defining: qt(Bt(h, "defining", p)),
      isolating: qt(Bt(h, "isolating", p)),
      attrs: Object.fromEntries(f.map((b) => {
        var S;
        return [b.name, { default: (S = b == null ? void 0 : b.attribute) === null || S === void 0 ? void 0 : S.default }];
      }))
    }), g = qt(Bt(h, "parseHTML", p));
    g && (v.parseDOM = g.map((b) => zp(b, f)));
    const m = Bt(h, "renderHTML", p);
    m && (v.toDOM = (b) => m({
      node: b,
      HTMLAttributes: uf(b, f)
    }));
    const A = Bt(h, "renderText", p);
    return A && (v.toText = A), [h.name, v];
  })), i = Object.fromEntries(u.map((h) => {
    const f = r.filter((A) => A.type === h.name), p = {
      name: h.name,
      options: h.options,
      storage: h.storage,
      editor: e
    }, d = n.reduce((A, b) => {
      const S = Bt(b, "extendMarkSchema", p);
      return {
        ...A,
        ...S ? S(h) : {}
      };
    }, {}), v = Yp({
      ...d,
      inclusive: qt(Bt(h, "inclusive", p)),
      excludes: qt(Bt(h, "excludes", p)),
      group: qt(Bt(h, "group", p)),
      spanning: qt(Bt(h, "spanning", p)),
      code: qt(Bt(h, "code", p)),
      attrs: Object.fromEntries(f.map((A) => {
        var b;
        return [A.name, { default: (b = A == null ? void 0 : A.attribute) === null || b === void 0 ? void 0 : b.default }];
      }))
    }), g = qt(Bt(h, "parseHTML", p));
    g && (v.parseDOM = g.map((A) => zp(A, f)));
    const m = Bt(h, "renderHTML", p);
    return m && (v.toDOM = (A) => m({
      mark: A,
      HTMLAttributes: uf(A, f)
    })), [h.name, v];
  }));
  return new nP({
    topNode: c,
    nodes: l,
    marks: i
  });
}
function fc(n, e) {
  return e.nodes[n] || e.marks[n] || null;
}
function Xp(n, e) {
  return Array.isArray(e) ? e.some((t) => (typeof t == "string" ? t : t.name) === n.name) : e;
}
const eL = (n, e = 500) => {
  let t = "";
  const r = n.parentOffset;
  return n.parent.nodesBetween(Math.max(0, r - e), r, (o, u, c, l) => {
    var i, h;
    const f = ((h = (i = o.type.spec).toText) === null || h === void 0 ? void 0 : h.call(i, {
      node: o,
      pos: u,
      parent: c,
      index: l
    })) || o.textContent || "%leaf%";
    t += f.slice(0, Math.max(0, r - u));
  }), t;
};
function bd(n) {
  return Object.prototype.toString.call(n) === "[object RegExp]";
}
class su {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}
const tL = (n, e) => {
  if (bd(e))
    return e.exec(n);
  const t = e(n);
  if (!t)
    return null;
  const r = [t.text];
  return r.index = t.index, r.input = n, r.data = t.data, t.replaceWith && (t.text.includes(t.replaceWith) || console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".'), r.push(t.replaceWith)), r;
};
function tl(n) {
  var e;
  const { editor: t, from: r, to: o, text: u, rules: c, plugin: l } = n, { view: i } = t;
  if (i.composing)
    return !1;
  const h = i.state.doc.resolve(r);
  if (
    // check for code node
    h.parent.type.spec.code || !((e = h.nodeBefore || h.nodeAfter) === null || e === void 0) && e.marks.find((d) => d.type.spec.code)
  )
    return !1;
  let f = !1;
  const p = eL(h) + u;
  return c.forEach((d) => {
    if (f)
      return;
    const v = tL(p, d.find);
    if (!v)
      return;
    const g = i.state.tr, m = iu({
      state: i.state,
      transaction: g
    }), A = {
      from: r - (v[0].length - u.length),
      to: o
    }, { commands: b, chain: S, can: N } = new au({
      editor: t,
      state: m
    });
    d.handler({
      state: m,
      range: A,
      match: v,
      commands: b,
      chain: S,
      can: N
    }) === null || !g.steps.length || (g.setMeta(l, {
      transform: g,
      from: r,
      to: o,
      text: u
    }), i.dispatch(g), f = !0);
  }), f;
}
function nL(n) {
  const { editor: e, rules: t } = n, r = new tr({
    state: {
      init() {
        return null;
      },
      apply(o, u) {
        const c = o.getMeta(r);
        if (c)
          return c;
        const l = o.getMeta("applyInputRules");
        return !!l && setTimeout(() => {
          const { from: h, text: f } = l, p = h + f.length;
          tl({
            editor: e,
            from: h,
            to: p,
            text: f,
            rules: t,
            plugin: r
          });
        }), o.selectionSet || o.docChanged ? null : u;
      }
    },
    props: {
      handleTextInput(o, u, c, l) {
        return tl({
          editor: e,
          from: u,
          to: c,
          text: l,
          rules: t,
          plugin: r
        });
      },
      handleDOMEvents: {
        compositionend: (o) => (setTimeout(() => {
          const { $cursor: u } = o.state.selection;
          u && tl({
            editor: e,
            from: u.pos,
            to: u.pos,
            text: "",
            rules: t,
            plugin: r
          });
        }), !1)
      },
      // add support for input rules to trigger on enter
      // this is useful for example for code blocks
      handleKeyDown(o, u) {
        if (u.key !== "Enter")
          return !1;
        const { $cursor: c } = o.state.selection;
        return c ? tl({
          editor: e,
          from: c.pos,
          to: c.pos,
          text: `
`,
          rules: t,
          plugin: r
        }) : !1;
      }
    },
    // @ts-ignore
    isInputRules: !0
  });
  return r;
}
function rL(n) {
  return typeof n == "number";
}
class iL {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}
const aL = (n, e, t) => {
  if (bd(e))
    return [...n.matchAll(e)];
  const r = e(n, t);
  return r ? r.map((o) => {
    const u = [o.text];
    return u.index = o.index, u.input = n, u.data = o.data, o.replaceWith && (o.text.includes(o.replaceWith) || console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".'), u.push(o.replaceWith)), u;
  }) : [];
};
function oL(n) {
  const { editor: e, state: t, from: r, to: o, rule: u, pasteEvent: c, dropEvent: l } = n, { commands: i, chain: h, can: f } = new au({
    editor: e,
    state: t
  }), p = [];
  return t.doc.nodesBetween(r, o, (v, g) => {
    if (!v.isTextblock || v.type.spec.code)
      return;
    const m = Math.max(r, g), A = Math.min(o, g + v.content.size), b = v.textBetween(m - g, A - g, void 0, "￼");
    aL(b, u.find, c).forEach((N) => {
      if (N.index === void 0)
        return;
      const T = m + N.index + 1, R = T + N[0].length, y = {
        from: t.tr.mapping.map(T),
        to: t.tr.mapping.map(R)
      }, E = u.handler({
        state: t,
        range: y,
        match: N,
        commands: i,
        chain: h,
        can: f,
        pasteEvent: c,
        dropEvent: l
      });
      p.push(E);
    });
  }), p.every((v) => v !== null);
}
const sL = (n) => {
  var e;
  const t = new ClipboardEvent("paste", {
    clipboardData: new DataTransfer()
  });
  return (e = t.clipboardData) === null || e === void 0 || e.setData("text/html", n), t;
};
function lL(n) {
  const { editor: e, rules: t } = n;
  let r = null, o = !1, u = !1, c = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, l = typeof DragEvent < "u" ? new DragEvent("drop") : null;
  const i = ({ state: f, from: p, to: d, rule: v, pasteEvt: g }) => {
    const m = f.tr, A = iu({
      state: f,
      transaction: m
    });
    if (!(!oL({
      editor: e,
      state: A,
      from: Math.max(p - 1, 0),
      to: d.b - 1,
      rule: v,
      pasteEvent: g,
      dropEvent: l
    }) || !m.steps.length))
      return l = typeof DragEvent < "u" ? new DragEvent("drop") : null, c = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, m;
  };
  return t.map((f) => new tr({
    // we register a global drag handler to track the current drag source element
    view(p) {
      const d = (v) => {
        var g;
        r = !((g = p.dom.parentElement) === null || g === void 0) && g.contains(v.target) ? p.dom.parentElement : null;
      };
      return window.addEventListener("dragstart", d), {
        destroy() {
          window.removeEventListener("dragstart", d);
        }
      };
    },
    props: {
      handleDOMEvents: {
        drop: (p, d) => (u = r === p.dom.parentElement, l = d, !1),
        paste: (p, d) => {
          var v;
          const g = (v = d.clipboardData) === null || v === void 0 ? void 0 : v.getData("text/html");
          return c = d, o = !!(g != null && g.includes("data-pm-slice")), !1;
        }
      }
    },
    appendTransaction: (p, d, v) => {
      const g = p[0], m = g.getMeta("uiEvent") === "paste" && !o, A = g.getMeta("uiEvent") === "drop" && !u, b = g.getMeta("applyPasteRules"), S = !!b;
      if (!m && !A && !S)
        return;
      if (S) {
        const { from: R, text: y } = b, E = R + y.length, L = sL(y);
        return i({
          rule: f,
          state: v,
          from: R,
          to: { b: E },
          pasteEvt: L
        });
      }
      const N = d.doc.content.findDiffStart(v.doc.content), T = d.doc.content.findDiffEnd(v.doc.content);
      if (!(!rL(N) || !T || N === T.b))
        return i({
          rule: f,
          state: v,
          from: N,
          to: T,
          pasteEvt: c
        });
    }
  }));
}
function uL(n) {
  const e = n.filter((t, r) => n.indexOf(t) !== r);
  return [...new Set(e)];
}
class Ka {
  constructor(e, t) {
    this.splittableMarks = [], this.editor = t, this.extensions = Ka.resolve(e), this.schema = qN(this.extensions, t), this.setupExtensions();
  }
  /**
   * Returns a flattened and sorted extension list while
   * also checking for duplicated extensions and warns the user.
   * @param extensions An array of Tiptap extensions
   * @returns An flattened and sorted array of Tiptap extensions
   */
  static resolve(e) {
    const t = Ka.sort(Ka.flatten(e)), r = uL(t.map((o) => o.name));
    return r.length && console.warn(`[tiptap warn]: Duplicate extension names found: [${r.map((o) => `'${o}'`).join(", ")}]. This can lead to issues.`), t;
  }
  /**
   * Create a flattened array of extensions by traversing the `addExtensions` field.
   * @param extensions An array of Tiptap extensions
   * @returns A flattened array of Tiptap extensions
   */
  static flatten(e) {
    return e.map((t) => {
      const r = {
        name: t.name,
        options: t.options,
        storage: t.storage
      }, o = Bt(t, "addExtensions", r);
      return o ? [t, ...this.flatten(o())] : t;
    }).flat(10);
  }
  /**
   * Sort extensions by priority.
   * @param extensions An array of Tiptap extensions
   * @returns A sorted array of Tiptap extensions by priority
   */
  static sort(e) {
    return e.sort((r, o) => {
      const u = Bt(r, "priority") || 100, c = Bt(o, "priority") || 100;
      return u > c ? -1 : u < c ? 1 : 0;
    });
  }
  /**
   * Get all commands from the extensions.
   * @returns An object with all commands where the key is the command name and the value is the command function
   */
  get commands() {
    return this.extensions.reduce((e, t) => {
      const r = {
        name: t.name,
        options: t.options,
        storage: t.storage,
        editor: this.editor,
        type: fc(t.name, this.schema)
      }, o = Bt(t, "addCommands", r);
      return o ? {
        ...e,
        ...o()
      } : e;
    }, {});
  }
  /**
   * Get all registered Prosemirror plugins from the extensions.
   * @returns An array of Prosemirror plugins
   */
  get plugins() {
    const { editor: e } = this, t = Ka.sort([...this.extensions].reverse()), r = [], o = [], u = t.map((c) => {
      const l = {
        name: c.name,
        options: c.options,
        storage: c.storage,
        editor: e,
        type: fc(c.name, this.schema)
      }, i = [], h = Bt(c, "addKeyboardShortcuts", l);
      let f = {};
      if (c.type === "mark" && c.config.exitable && (f.ArrowRight = () => Hr.handleExit({ editor: e, mark: c })), h) {
        const m = Object.fromEntries(Object.entries(h()).map(([A, b]) => [A, () => b({ editor: e })]));
        f = { ...f, ...m };
      }
      const p = CN(f);
      i.push(p);
      const d = Bt(c, "addInputRules", l);
      Xp(c, e.options.enableInputRules) && d && r.push(...d());
      const v = Bt(c, "addPasteRules", l);
      Xp(c, e.options.enablePasteRules) && v && o.push(...v());
      const g = Bt(c, "addProseMirrorPlugins", l);
      if (g) {
        const m = g();
        i.push(...m);
      }
      return i;
    }).flat();
    return [
      nL({
        editor: e,
        rules: r
      }),
      ...lL({
        editor: e,
        rules: o
      }),
      ...u
    ];
  }
  /**
   * Get all attributes from the extensions.
   * @returns An array of attributes
   */
  get attributes() {
    return __(this.extensions);
  }
  /**
   * Get all node views from the extensions.
   * @returns An object with all node views where the key is the node name and the value is the node view function
   */
  get nodeViews() {
    const { editor: e } = this, { nodeExtensions: t } = ou(this.extensions);
    return Object.fromEntries(t.filter((r) => !!Bt(r, "addNodeView")).map((r) => {
      const o = this.attributes.filter((i) => i.type === r.name), u = {
        name: r.name,
        options: r.options,
        storage: r.storage,
        editor: e,
        type: Ln(r.name, this.schema)
      }, c = Bt(r, "addNodeView", u);
      if (!c)
        return [];
      const l = (i, h, f, p) => {
        const d = uf(i, o);
        return c()({
          editor: e,
          node: i,
          getPos: f,
          decorations: p,
          HTMLAttributes: d,
          extension: r
        });
      };
      return [r.name, l];
    }));
  }
  /**
   * Go through all extensions, create extension storages & setup marks
   * & bind editor event listener.
   */
  setupExtensions() {
    this.extensions.forEach((e) => {
      var t;
      this.editor.extensionStorage[e.name] = e.storage;
      const r = {
        name: e.name,
        options: e.options,
        storage: e.storage,
        editor: this.editor,
        type: fc(e.name, this.schema)
      };
      e.type === "mark" && (!((t = qt(Bt(e, "keepOnSplit", r))) !== null && t !== void 0) || t) && this.splittableMarks.push(e.name);
      const o = Bt(e, "onBeforeCreate", r), u = Bt(e, "onCreate", r), c = Bt(e, "onUpdate", r), l = Bt(e, "onSelectionUpdate", r), i = Bt(e, "onTransaction", r), h = Bt(e, "onFocus", r), f = Bt(e, "onBlur", r), p = Bt(e, "onDestroy", r);
      o && this.editor.on("beforeCreate", o), u && this.editor.on("create", u), c && this.editor.on("update", c), l && this.editor.on("selectionUpdate", l), i && this.editor.on("transaction", i), h && this.editor.on("focus", h), f && this.editor.on("blur", f), p && this.editor.on("destroy", p);
    });
  }
}
function cL(n) {
  return Object.prototype.toString.call(n).slice(8, -1);
}
function dc(n) {
  return cL(n) !== "Object" ? !1 : n.constructor === Object && Object.getPrototypeOf(n) === Object.prototype;
}
function lu(n, e) {
  const t = { ...n };
  return dc(n) && dc(e) && Object.keys(e).forEach((r) => {
    dc(e[r]) ? r in n ? t[r] = lu(n[r], e[r]) : Object.assign(t, { [r]: e[r] }) : Object.assign(t, { [r]: e[r] });
  }), t;
}
class Xn {
  constructor(e = {}) {
    this.type = "extension", this.name = "extension", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = qt(Bt(this, "addOptions", {
      name: this.name
    }))), this.storage = qt(Bt(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new Xn(e);
  }
  configure(e = {}) {
    const t = this.extend();
    return t.parent = this.parent, t.options = lu(this.options, e), t.storage = qt(Bt(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
  extend(e = {}) {
    const t = new Xn({ ...this.config, ...e });
    return t.parent = this, this.child = t, t.name = e.name ? e.name : t.parent.name, e.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${t.name}".`), t.options = qt(Bt(t, "addOptions", {
      name: t.name
    })), t.storage = qt(Bt(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
}
function y_(n, e, t) {
  const { from: r, to: o } = e, { blockSeparator: u = `

`, textSerializers: c = {} } = t || {};
  let l = "";
  return n.nodesBetween(r, o, (i, h, f, p) => {
    var d;
    i.isBlock && h > r && (l += u);
    const v = c == null ? void 0 : c[i.type.name];
    if (v)
      return f && (l += v({
        node: i,
        pos: h,
        parent: f,
        index: p,
        range: e
      })), !1;
    i.isText && (l += (d = i == null ? void 0 : i.text) === null || d === void 0 ? void 0 : d.slice(Math.max(r, h) - h, o - h));
  }), l;
}
function T_(n) {
  return Object.fromEntries(Object.entries(n.nodes).filter(([, e]) => e.spec.toText).map(([e, t]) => [e, t.spec.toText]));
}
const fL = Xn.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new tr({
        key: new zr("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: n } = this, { state: e, schema: t } = n, { doc: r, selection: o } = e, { ranges: u } = o, c = Math.min(...u.map((f) => f.$from.pos)), l = Math.max(...u.map((f) => f.$to.pos)), i = T_(t);
            return y_(r, { from: c, to: l }, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers: i
            });
          }
        }
      })
    ];
  }
}), dL = () => ({ editor: n, view: e }) => (requestAnimationFrame(() => {
  var t;
  n.isDestroyed || (e.dom.blur(), (t = window == null ? void 0 : window.getSelection()) === null || t === void 0 || t.removeAllRanges());
}), !0), hL = (n = !1) => ({ commands: e }) => e.setContent("", n), pL = () => ({ state: n, tr: e, dispatch: t }) => {
  const { selection: r } = e, { ranges: o } = r;
  return t && o.forEach(({ $from: u, $to: c }) => {
    n.doc.nodesBetween(u.pos, c.pos, (l, i) => {
      if (l.type.isText)
        return;
      const { doc: h, mapping: f } = e, p = h.resolve(f.map(i)), d = h.resolve(f.map(i + l.nodeSize)), v = p.blockRange(d);
      if (!v)
        return;
      const g = Ao(v);
      if (l.type.isTextblock) {
        const { defaultType: m } = p.parent.contentMatchAt(p.index());
        e.setNodeMarkup(v.start, m);
      }
      (g || g === 0) && e.lift(v, g);
    });
  }), !0;
}, mL = (n) => (e) => n(e), gL = () => ({ state: n, dispatch: e }) => FN(n, e), vL = (n, e) => ({ editor: t, tr: r }) => {
  const { state: o } = t, u = o.doc.slice(n.from, n.to);
  r.deleteRange(n.from, n.to);
  const c = r.mapping.map(e);
  return r.insert(c, u.content), r.setSelection(new Zt(r.doc.resolve(c - 1))), !0;
}, _L = () => ({ tr: n, dispatch: e }) => {
  const { selection: t } = n, r = t.$anchor.node();
  if (r.content.size > 0)
    return !1;
  const o = n.selection.$anchor;
  for (let u = o.depth; u > 0; u -= 1)
    if (o.node(u).type === r.type) {
      if (e) {
        const l = o.before(u), i = o.after(u);
        n.delete(l, i).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, EL = (n) => ({ tr: e, state: t, dispatch: r }) => {
  const o = Ln(n, t.schema), u = e.selection.$anchor;
  for (let c = u.depth; c > 0; c -= 1)
    if (u.node(c).type === o) {
      if (r) {
        const i = u.before(c), h = u.after(c);
        e.delete(i, h).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, yL = (n) => ({ tr: e, dispatch: t }) => {
  const { from: r, to: o } = n;
  return t && e.delete(r, o), !0;
}, TL = () => ({ state: n, dispatch: e }) => MN(n, e), AL = () => ({ commands: n }) => n.keyboardShortcut("Enter"), SL = () => ({ state: n, dispatch: e }) => BN(n, e);
function wl(n, e, t = { strict: !0 }) {
  const r = Object.keys(e);
  return r.length ? r.every((o) => t.strict ? e[o] === n[o] : bd(e[o]) ? e[o].test(n[o]) : e[o] === n[o]) : !0;
}
function cf(n, e, t = {}) {
  return n.find((r) => r.type === e && wl(r.attrs, t));
}
function CL(n, e, t = {}) {
  return !!cf(n, e, t);
}
function Rd(n, e, t = {}) {
  if (!n || !e)
    return;
  let r = n.parent.childAfter(n.parentOffset);
  if (n.parentOffset === r.offset && r.offset !== 0 && (r = n.parent.childBefore(n.parentOffset)), !r.node)
    return;
  const o = cf([...r.node.marks], e, t);
  if (!o)
    return;
  let u = r.index, c = n.start() + r.offset, l = u + 1, i = c + r.node.nodeSize;
  for (cf([...r.node.marks], e, t); u > 0 && o.isInSet(n.parent.child(u - 1).marks); )
    u -= 1, c -= n.parent.child(u).nodeSize;
  for (; l < n.parent.childCount && CL([...n.parent.child(l).marks], e, t); )
    i += n.parent.child(l).nodeSize, l += 1;
  return {
    from: c,
    to: i
  };
}
function ki(n, e) {
  if (typeof n == "string") {
    if (!e.marks[n])
      throw Error(`There is no mark type named '${n}'. Maybe you forgot to add the extension?`);
    return e.marks[n];
  }
  return n;
}
const ML = (n, e = {}) => ({ tr: t, state: r, dispatch: o }) => {
  const u = ki(n, r.schema), { doc: c, selection: l } = t, { $from: i, from: h, to: f } = l;
  if (o) {
    const p = Rd(i, u, e);
    if (p && p.from <= h && p.to >= f) {
      const d = Zt.create(c, p.from, p.to);
      t.setSelection(d);
    }
  }
  return !0;
}, bL = (n) => (e) => {
  const t = typeof n == "function" ? n(e) : n;
  for (let r = 0; r < t.length; r += 1)
    if (t[r](e))
      return !0;
  return !1;
};
function Dd(n) {
  return n instanceof Zt;
}
function ni(n = 0, e = 0, t = 0) {
  return Math.min(Math.max(n, e), t);
}
function A_(n, e = null) {
  if (!e)
    return null;
  const t = en.atStart(n), r = en.atEnd(n);
  if (e === "start" || e === !0)
    return t;
  if (e === "end")
    return r;
  const o = t.from, u = r.to;
  return e === "all" ? Zt.create(n, ni(0, o, u), ni(n.content.size, o, u)) : Zt.create(n, ni(e, o, u), ni(e, o, u));
}
function Od() {
  return [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod"
  ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
const RL = (n = null, e = {}) => ({ editor: t, view: r, tr: o, dispatch: u }) => {
  e = {
    scrollIntoView: !0,
    ...e
  };
  const c = () => {
    Od() && r.dom.focus(), requestAnimationFrame(() => {
      t.isDestroyed || (r.focus(), e != null && e.scrollIntoView && t.commands.scrollIntoView());
    });
  };
  if (r.hasFocus() && n === null || n === !1)
    return !0;
  if (u && n === null && !Dd(t.state.selection))
    return c(), !0;
  const l = A_(o.doc, n) || t.state.selection, i = t.state.selection.eq(l);
  return u && (i || o.setSelection(l), i && o.storedMarks && o.setStoredMarks(o.storedMarks), c()), !0;
}, DL = (n, e) => (t) => n.every((r, o) => e(r, { ...t, index: o })), OL = (n, e) => ({ tr: t, commands: r }) => r.insertContentAt({ from: t.selection.from, to: t.selection.to }, n, e), S_ = (n) => {
  const e = n.childNodes;
  for (let t = e.length - 1; t >= 0; t -= 1) {
    const r = e[t];
    r.nodeType === 3 && r.nodeValue && /^(\n\s\s|\n)$/.test(r.nodeValue) ? n.removeChild(r) : r.nodeType === 1 && S_(r);
  }
  return n;
};
function Qp(n) {
  const e = `<body>${n}</body>`, t = new window.DOMParser().parseFromString(e, "text/html").body;
  return S_(t);
}
function xl(n, e, t) {
  t = {
    slice: !0,
    parseOptions: {},
    ...t
  };
  const r = typeof n == "object" && n !== null, o = typeof n == "string";
  if (r)
    try {
      return Array.isArray(n) && n.length > 0 ? Tt.fromArray(n.map((c) => e.nodeFromJSON(c))) : e.nodeFromJSON(n);
    } catch (u) {
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", n, "Error:", u), xl("", e, t);
    }
  if (o) {
    const u = dd.fromSchema(e);
    return t.slice ? u.parseSlice(Qp(n), t.parseOptions).content : u.parse(Qp(n), t.parseOptions);
  }
  return xl("", e, t);
}
function PL(n, e, t) {
  const r = n.steps.length - 1;
  if (r < e)
    return;
  const o = n.steps[r];
  if (!(o instanceof Pn || o instanceof In))
    return;
  const u = n.mapping.maps[r];
  let c = 0;
  u.forEach((l, i, h, f) => {
    c === 0 && (c = f);
  }), n.setSelection(en.near(n.doc.resolve(c), t));
}
const IL = (n) => n.toString().startsWith("<"), NL = (n, e, t) => ({ tr: r, dispatch: o, editor: u }) => {
  if (o) {
    t = {
      parseOptions: {},
      updateSelection: !0,
      applyInputRules: !1,
      applyPasteRules: !1,
      ...t
    };
    const c = xl(e, u.schema, {
      parseOptions: {
        preserveWhitespace: "full",
        ...t.parseOptions
      }
    });
    if (c.toString() === "<>")
      return !0;
    let { from: l, to: i } = typeof n == "number" ? { from: n, to: n } : { from: n.from, to: n.to }, h = !0, f = !0;
    if ((IL(c) ? c : [c]).forEach((v) => {
      v.check(), h = h ? v.isText && v.marks.length === 0 : !1, f = f ? v.isBlock : !1;
    }), l === i && f) {
      const { parent: v } = r.doc.resolve(l);
      v.isTextblock && !v.type.spec.code && !v.childCount && (l -= 1, i += 1);
    }
    let d;
    h ? (Array.isArray(e) ? d = e.map((v) => v.text || "").join("") : typeof e == "object" && e && e.text ? d = e.text : d = e, r.insertText(d, l, i)) : (d = c, r.replaceWith(l, i, d)), t.updateSelection && PL(r, r.steps.length - 1, -1), t.applyInputRules && r.setMeta("applyInputRules", { from: l, text: d }), t.applyPasteRules && r.setMeta("applyPasteRules", { from: l, text: d });
  }
  return !0;
}, LL = () => ({ state: n, dispatch: e }) => NN(n, e), wL = () => ({ state: n, dispatch: e }) => LN(n, e), xL = () => ({ state: n, dispatch: e }) => bN(n, e), BL = () => ({ state: n, dispatch: e }) => PN(n, e), FL = () => ({ tr: n, state: e, dispatch: t }) => {
  try {
    const r = Zl(e.doc, e.selection.$from.pos, -1);
    return r == null ? !1 : (n.join(r, 2), t && t(n), !0);
  } catch {
    return !1;
  }
}, UL = () => ({ state: n, dispatch: e, tr: t }) => {
  try {
    const r = Zl(n.doc, n.selection.$from.pos, 1);
    return r == null ? !1 : (t.join(r, 2), e && e(t), !0);
  } catch {
    return !1;
  }
}, kL = () => ({ state: n, dispatch: e }) => RN(n, e), KL = () => ({ state: n, dispatch: e }) => DN(n, e);
function C_() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function jL(n) {
  const e = n.split(/-(?!$)/);
  let t = e[e.length - 1];
  t === "Space" && (t = " ");
  let r, o, u, c;
  for (let l = 0; l < e.length - 1; l += 1) {
    const i = e[l];
    if (/^(cmd|meta|m)$/i.test(i))
      c = !0;
    else if (/^a(lt)?$/i.test(i))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(i))
      o = !0;
    else if (/^s(hift)?$/i.test(i))
      u = !0;
    else if (/^mod$/i.test(i))
      Od() || C_() ? c = !0 : o = !0;
    else
      throw new Error(`Unrecognized modifier name: ${i}`);
  }
  return r && (t = `Alt-${t}`), o && (t = `Ctrl-${t}`), c && (t = `Meta-${t}`), u && (t = `Shift-${t}`), t;
}
const WL = (n) => ({ editor: e, view: t, tr: r, dispatch: o }) => {
  const u = jL(n).split(/-(?!$)/), c = u.find((h) => !["Alt", "Ctrl", "Meta", "Shift"].includes(h)), l = new KeyboardEvent("keydown", {
    key: c === "Space" ? " " : c,
    altKey: u.includes("Alt"),
    ctrlKey: u.includes("Ctrl"),
    metaKey: u.includes("Meta"),
    shiftKey: u.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), i = e.captureTransaction(() => {
    t.someProp("handleKeyDown", (h) => h(t, l));
  });
  return i == null || i.steps.forEach((h) => {
    const f = h.map(r.mapping);
    f && o && r.maybeStep(f);
  }), !0;
};
function _s(n, e, t = {}) {
  const { from: r, to: o, empty: u } = n.selection, c = e ? Ln(e, n.schema) : null, l = [];
  n.doc.nodesBetween(r, o, (p, d) => {
    if (p.isText)
      return;
    const v = Math.max(r, d), g = Math.min(o, d + p.nodeSize);
    l.push({
      node: p,
      from: v,
      to: g
    });
  });
  const i = o - r, h = l.filter((p) => c ? c.name === p.node.type.name : !0).filter((p) => wl(p.node.attrs, t, { strict: !1 }));
  return u ? !!h.length : h.reduce((p, d) => p + d.to - d.from, 0) >= i;
}
const VL = (n, e = {}) => ({ state: t, dispatch: r }) => {
  const o = Ln(n, t.schema);
  return _s(t, o, e) ? wN(t, r) : !1;
}, HL = () => ({ state: n, dispatch: e }) => UN(n, e), $L = (n) => ({ state: e, dispatch: t }) => {
  const r = Ln(n, e.schema);
  return GN(r)(e, t);
}, GL = () => ({ state: n, dispatch: e }) => xN(n, e);
function uu(n, e) {
  return e.nodes[n] ? "node" : e.marks[n] ? "mark" : null;
}
function Jp(n, e) {
  const t = typeof e == "string" ? [e] : e;
  return Object.keys(n).reduce((r, o) => (t.includes(o) || (r[o] = n[o]), r), {});
}
const zL = (n, e) => ({ tr: t, state: r, dispatch: o }) => {
  let u = null, c = null;
  const l = uu(typeof n == "string" ? n : n.name, r.schema);
  return l ? (l === "node" && (u = Ln(n, r.schema)), l === "mark" && (c = ki(n, r.schema)), o && t.selection.ranges.forEach((i) => {
    r.doc.nodesBetween(i.$from.pos, i.$to.pos, (h, f) => {
      u && u === h.type && t.setNodeMarkup(f, void 0, Jp(h.attrs, e)), c && h.marks.length && h.marks.forEach((p) => {
        c === p.type && t.addMark(f, f + h.nodeSize, c.create(Jp(p.attrs, e)));
      });
    });
  }), !0) : !1;
}, YL = () => ({ tr: n, dispatch: e }) => (e && n.scrollIntoView(), !0), XL = () => ({ tr: n, commands: e }) => e.setTextSelection({
  from: 0,
  to: n.doc.content.size
}), QL = () => ({ state: n, dispatch: e }) => ON(n, e), JL = () => ({ state: n, dispatch: e }) => IN(n, e), ZL = () => ({ state: n, dispatch: e }) => kN(n, e), qL = () => ({ state: n, dispatch: e }) => WN(n, e), ew = () => ({ state: n, dispatch: e }) => jN(n, e);
function M_(n, e, t = {}) {
  return xl(n, e, { slice: !1, parseOptions: t });
}
const tw = (n, e = !1, t = {}) => ({ tr: r, editor: o, dispatch: u }) => {
  const { doc: c } = r, l = M_(n, o.schema, t);
  return u && r.replaceWith(0, c.content.size, l).setMeta("preventUpdate", !e), !0;
};
function cu(n, e) {
  const t = ki(e, n.schema), { from: r, to: o, empty: u } = n.selection, c = [];
  u ? (n.storedMarks && c.push(...n.storedMarks), c.push(...n.selection.$head.marks())) : n.doc.nodesBetween(r, o, (i) => {
    c.push(...i.marks);
  });
  const l = c.find((i) => i.type.name === t.name);
  return l ? { ...l.attrs } : {};
}
function nw(n) {
  for (let e = 0; e < n.edgeCount; e += 1) {
    const { type: t } = n.edge(e);
    if (t.isTextblock && !t.hasRequiredAttrs())
      return t;
  }
  return null;
}
function rw(n, e) {
  for (let t = n.depth; t > 0; t -= 1) {
    const r = n.node(t);
    if (e(r))
      return {
        pos: t > 0 ? n.before(t) : 0,
        start: n.start(t),
        depth: t,
        node: r
      };
  }
}
function Pd(n) {
  return (e) => rw(e.$from, n);
}
function iw(n, e) {
  const t = Ur.fromSchema(e).serializeFragment(n), o = document.implementation.createHTMLDocument().createElement("div");
  return o.appendChild(t), o.innerHTML;
}
function aw(n, e) {
  const t = {
    from: 0,
    to: n.content.size
  };
  return y_(n, t, e);
}
function ow(n, e) {
  const t = Ln(e, n.schema), { from: r, to: o } = n.selection, u = [];
  n.doc.nodesBetween(r, o, (l) => {
    u.push(l);
  });
  const c = u.reverse().find((l) => l.type.name === t.name);
  return c ? { ...c.attrs } : {};
}
function sw(n, e) {
  const t = uu(typeof e == "string" ? e : e.name, n.schema);
  return t === "node" ? ow(n, e) : t === "mark" ? cu(n, e) : {};
}
function b_(n, e, t) {
  const r = [];
  return n === e ? t.resolve(n).marks().forEach((o) => {
    const u = t.resolve(n - 1), c = Rd(u, o.type);
    c && r.push({
      mark: o,
      ...c
    });
  }) : t.nodesBetween(n, e, (o, u) => {
    !o || (o == null ? void 0 : o.nodeSize) === void 0 || r.push(...o.marks.map((c) => ({
      from: u,
      to: u + o.nodeSize,
      mark: c
    })));
  }), r;
}
function ol(n, e, t) {
  return Object.fromEntries(Object.entries(t).filter(([r]) => {
    const o = n.find((u) => u.type === e && u.name === r);
    return o ? o.attribute.keepOnSplit : !1;
  }));
}
function ff(n, e, t = {}) {
  const { empty: r, ranges: o } = n.selection, u = e ? ki(e, n.schema) : null;
  if (r)
    return !!(n.storedMarks || n.selection.$from.marks()).filter((p) => u ? u.name === p.type.name : !0).find((p) => wl(p.attrs, t, { strict: !1 }));
  let c = 0;
  const l = [];
  if (o.forEach(({ $from: p, $to: d }) => {
    const v = p.pos, g = d.pos;
    n.doc.nodesBetween(v, g, (m, A) => {
      if (!m.isText && !m.marks.length)
        return;
      const b = Math.max(v, A), S = Math.min(g, A + m.nodeSize), N = S - b;
      c += N, l.push(...m.marks.map((T) => ({
        mark: T,
        from: b,
        to: S
      })));
    });
  }), c === 0)
    return !1;
  const i = l.filter((p) => u ? u.name === p.mark.type.name : !0).filter((p) => wl(p.mark.attrs, t, { strict: !1 })).reduce((p, d) => p + d.to - d.from, 0), h = l.filter((p) => u ? p.mark.type !== u && p.mark.type.excludes(u) : !0).reduce((p, d) => p + d.to - d.from, 0);
  return (i > 0 ? i + h : i) >= c;
}
function lw(n, e, t = {}) {
  if (!e)
    return _s(n, null, t) || ff(n, null, t);
  const r = uu(e, n.schema);
  return r === "node" ? _s(n, e, t) : r === "mark" ? ff(n, e, t) : !1;
}
function Zp(n, e) {
  const { nodeExtensions: t } = ou(e), r = t.find((c) => c.name === n);
  if (!r)
    return !1;
  const o = {
    name: r.name,
    options: r.options,
    storage: r.storage
  }, u = qt(Bt(r, "group", o));
  return typeof u != "string" ? !1 : u.split(" ").includes("list");
}
function uw(n) {
  var e;
  const t = (e = n.type.createAndFill()) === null || e === void 0 ? void 0 : e.toJSON(), r = n.toJSON();
  return JSON.stringify(t) === JSON.stringify(r);
}
function cw(n) {
  return n instanceof $t;
}
function R_(n, e, t) {
  const o = n.state.doc.content.size, u = ni(e, 0, o), c = ni(t, 0, o), l = n.coordsAtPos(u), i = n.coordsAtPos(c, -1), h = Math.min(l.top, i.top), f = Math.max(l.bottom, i.bottom), p = Math.min(l.left, i.left), d = Math.max(l.right, i.right), v = d - p, g = f - h, b = {
    top: h,
    bottom: f,
    left: p,
    right: d,
    width: v,
    height: g,
    x: p,
    y: h
  };
  return {
    ...b,
    toJSON: () => b
  };
}
function fw(n, e, t) {
  var r;
  const { selection: o } = e;
  let u = null;
  if (Dd(o) && (u = o.$cursor), u) {
    const l = (r = n.storedMarks) !== null && r !== void 0 ? r : u.marks();
    return !!t.isInSet(l) || !l.some((i) => i.type.excludes(t));
  }
  const { ranges: c } = o;
  return c.some(({ $from: l, $to: i }) => {
    let h = l.depth === 0 ? n.doc.inlineContent && n.doc.type.allowsMarkType(t) : !1;
    return n.doc.nodesBetween(l.pos, i.pos, (f, p, d) => {
      if (h)
        return !1;
      if (f.isInline) {
        const v = !d || d.type.allowsMarkType(t), g = !!t.isInSet(f.marks) || !f.marks.some((m) => m.type.excludes(t));
        h = v && g;
      }
      return !h;
    }), h;
  });
}
const dw = (n, e = {}) => ({ tr: t, state: r, dispatch: o }) => {
  const { selection: u } = t, { empty: c, ranges: l } = u, i = ki(n, r.schema);
  if (o)
    if (c) {
      const h = cu(r, i);
      t.addStoredMark(i.create({
        ...h,
        ...e
      }));
    } else
      l.forEach((h) => {
        const f = h.$from.pos, p = h.$to.pos;
        r.doc.nodesBetween(f, p, (d, v) => {
          const g = Math.max(v, f), m = Math.min(v + d.nodeSize, p);
          d.marks.find((b) => b.type === i) ? d.marks.forEach((b) => {
            i === b.type && t.addMark(g, m, i.create({
              ...b.attrs,
              ...e
            }));
          }) : t.addMark(g, m, i.create(e));
        });
      });
  return fw(r, t, i);
}, hw = (n, e) => ({ tr: t }) => (t.setMeta(n, e), !0), pw = (n, e = {}) => ({ state: t, dispatch: r, chain: o }) => {
  const u = Ln(n, t.schema);
  return u.isTextblock ? o().command(({ commands: c }) => Gp(u, e)(t) ? !0 : c.clearNodes()).command(({ state: c }) => Gp(u, e)(c, r)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, mw = (n) => ({ tr: e, dispatch: t }) => {
  if (t) {
    const { doc: r } = e, o = ni(n, 0, r.content.size), u = $t.create(r, o);
    e.setSelection(u);
  }
  return !0;
}, gw = (n) => ({ tr: e, dispatch: t }) => {
  if (t) {
    const { doc: r } = e, { from: o, to: u } = typeof n == "number" ? { from: n, to: n } : n, c = Zt.atStart(r).from, l = Zt.atEnd(r).to, i = ni(o, c, l), h = ni(u, c, l), f = Zt.create(r, i, h);
    e.setSelection(f);
  }
  return !0;
}, vw = (n) => ({ state: e, dispatch: t }) => {
  const r = Ln(n, e.schema);
  return XN(r)(e, t);
};
function qp(n, e) {
  const t = n.storedMarks || n.selection.$to.parentOffset && n.selection.$from.marks();
  if (t) {
    const r = t.filter((o) => e == null ? void 0 : e.includes(o.type.name));
    n.tr.ensureMarks(r);
  }
}
const _w = ({ keepMarks: n = !0 } = {}) => ({ tr: e, state: t, dispatch: r, editor: o }) => {
  const { selection: u, doc: c } = e, { $from: l, $to: i } = u, h = o.extensionManager.attributes, f = ol(h, l.node().type.name, l.node().attrs);
  if (u instanceof $t && u.node.isBlock)
    return !l.parentOffset || !za(c, l.pos) ? !1 : (r && (n && qp(t, o.extensionManager.splittableMarks), e.split(l.pos).scrollIntoView()), !0);
  if (!l.parent.isBlock)
    return !1;
  if (r) {
    const p = i.parentOffset === i.parent.content.size;
    u instanceof Zt && e.deleteSelection();
    const d = l.depth === 0 ? void 0 : nw(l.node(-1).contentMatchAt(l.indexAfter(-1)));
    let v = p && d ? [
      {
        type: d,
        attrs: f
      }
    ] : void 0, g = za(e.doc, e.mapping.map(l.pos), 1, v);
    if (!v && !g && za(e.doc, e.mapping.map(l.pos), 1, d ? [{ type: d }] : void 0) && (g = !0, v = d ? [
      {
        type: d,
        attrs: f
      }
    ] : void 0), g && (e.split(e.mapping.map(l.pos), 1, v), d && !p && !l.parentOffset && l.parent.type !== d)) {
      const m = e.mapping.map(l.before()), A = e.doc.resolve(m);
      l.node(-1).canReplaceWith(A.index(), A.index() + 1, d) && e.setNodeMarkup(e.mapping.map(l.before()), d);
    }
    n && qp(t, o.extensionManager.splittableMarks), e.scrollIntoView();
  }
  return !0;
}, Ew = (n) => ({ tr: e, state: t, dispatch: r, editor: o }) => {
  var u;
  const c = Ln(n, t.schema), { $from: l, $to: i } = t.selection, h = t.selection.node;
  if (h && h.isBlock || l.depth < 2 || !l.sameParent(i))
    return !1;
  const f = l.node(-1);
  if (f.type !== c)
    return !1;
  const p = o.extensionManager.attributes;
  if (l.parent.content.size === 0 && l.node(-1).childCount === l.indexAfter(-1)) {
    if (l.depth === 2 || l.node(-3).type !== c || l.index(-2) !== l.node(-2).childCount - 1)
      return !1;
    if (r) {
      let A = Tt.empty;
      const b = l.index(-1) ? 1 : l.index(-2) ? 2 : 3;
      for (let E = l.depth - b; E >= l.depth - 3; E -= 1)
        A = Tt.from(l.node(E).copy(A));
      const S = l.indexAfter(-1) < l.node(-2).childCount ? 1 : l.indexAfter(-2) < l.node(-3).childCount ? 2 : 3, N = ol(p, l.node().type.name, l.node().attrs), T = ((u = c.contentMatch.defaultType) === null || u === void 0 ? void 0 : u.createAndFill(N)) || void 0;
      A = A.append(Tt.from(c.createAndFill(null, T) || void 0));
      const R = l.before(l.depth - (b - 1));
      e.replace(R, l.after(-S), new Lt(A, 4 - b, 0));
      let y = -1;
      e.doc.nodesBetween(R, e.doc.content.size, (E, L) => {
        if (y > -1)
          return !1;
        E.isTextblock && E.content.size === 0 && (y = L + 1);
      }), y > -1 && e.setSelection(Zt.near(e.doc.resolve(y))), e.scrollIntoView();
    }
    return !0;
  }
  const d = i.pos === l.end() ? f.contentMatchAt(0).defaultType : null, v = ol(p, f.type.name, f.attrs), g = ol(p, l.node().type.name, l.node().attrs);
  e.delete(l.pos, i.pos);
  const m = d ? [
    { type: c, attrs: v },
    { type: d, attrs: g }
  ] : [{ type: c, attrs: v }];
  if (!za(e.doc, l.pos, 2))
    return !1;
  if (r) {
    const { selection: A, storedMarks: b } = t, { splittableMarks: S } = o.extensionManager, N = b || A.$to.parentOffset && A.$from.marks();
    if (e.split(l.pos, 2, m).scrollIntoView(), !N || !r)
      return !0;
    const T = N.filter((R) => S.includes(R.type.name));
    e.ensureMarks(T);
  }
  return !0;
}, hc = (n, e) => {
  const t = Pd((c) => c.type === e)(n.selection);
  if (!t)
    return !0;
  const r = n.doc.resolve(Math.max(0, t.pos - 1)).before(t.depth);
  if (r === void 0)
    return !0;
  const o = n.doc.nodeAt(r);
  return t.node.type === (o == null ? void 0 : o.type) && Fi(n.doc, t.pos) && n.join(t.pos), !0;
}, pc = (n, e) => {
  const t = Pd((c) => c.type === e)(n.selection);
  if (!t)
    return !0;
  const r = n.doc.resolve(t.start).after(t.depth);
  if (r === void 0)
    return !0;
  const o = n.doc.nodeAt(r);
  return t.node.type === (o == null ? void 0 : o.type) && Fi(n.doc, r) && n.join(r), !0;
}, yw = (n, e, t, r = {}) => ({ editor: o, tr: u, state: c, dispatch: l, chain: i, commands: h, can: f }) => {
  const { extensions: p, splittableMarks: d } = o.extensionManager, v = Ln(n, c.schema), g = Ln(e, c.schema), { selection: m, storedMarks: A } = c, { $from: b, $to: S } = m, N = b.blockRange(S), T = A || m.$to.parentOffset && m.$from.marks();
  if (!N)
    return !1;
  const R = Pd((y) => Zp(y.type.name, p))(m);
  if (N.depth >= 1 && R && N.depth - R.depth <= 1) {
    if (R.node.type === v)
      return h.liftListItem(g);
    if (Zp(R.node.type.name, p) && v.validContent(R.node.content) && l)
      return i().command(() => (u.setNodeMarkup(R.pos, v), !0)).command(() => hc(u, v)).command(() => pc(u, v)).run();
  }
  return !t || !T || !l ? i().command(() => f().wrapInList(v, r) ? !0 : h.clearNodes()).wrapInList(v, r).command(() => hc(u, v)).command(() => pc(u, v)).run() : i().command(() => {
    const y = f().wrapInList(v, r), E = T.filter((L) => d.includes(L.type.name));
    return u.ensureMarks(E), y ? !0 : h.clearNodes();
  }).wrapInList(v, r).command(() => hc(u, v)).command(() => pc(u, v)).run();
}, Tw = (n, e = {}, t = {}) => ({ state: r, commands: o }) => {
  const { extendEmptyMarkRange: u = !1 } = t, c = ki(n, r.schema);
  return ff(r, c, e) ? o.unsetMark(c, { extendEmptyMarkRange: u }) : o.setMark(c, e);
}, Aw = (n, e, t = {}) => ({ state: r, commands: o }) => {
  const u = Ln(n, r.schema), c = Ln(e, r.schema);
  return _s(r, u, t) ? o.setNode(c) : o.setNode(u, t);
}, Sw = (n, e = {}) => ({ state: t, commands: r }) => {
  const o = Ln(n, t.schema);
  return _s(t, o, e) ? r.lift(o) : r.wrapIn(o, e);
}, Cw = () => ({ state: n, dispatch: e }) => {
  const t = n.plugins;
  for (let r = 0; r < t.length; r += 1) {
    const o = t[r];
    let u;
    if (o.spec.isInputRules && (u = o.getState(n))) {
      if (e) {
        const c = n.tr, l = u.transform;
        for (let i = l.steps.length - 1; i >= 0; i -= 1)
          c.step(l.steps[i].invert(l.docs[i]));
        if (u.text) {
          const i = c.doc.resolve(u.from).marks();
          c.replaceWith(u.from, u.to, n.schema.text(u.text, i));
        } else
          c.delete(u.from, u.to);
      }
      return !0;
    }
  }
  return !1;
}, Mw = () => ({ tr: n, dispatch: e }) => {
  const { selection: t } = n, { empty: r, ranges: o } = t;
  return r || e && o.forEach((u) => {
    n.removeMark(u.$from.pos, u.$to.pos);
  }), !0;
}, bw = (n, e = {}) => ({ tr: t, state: r, dispatch: o }) => {
  var u;
  const { extendEmptyMarkRange: c = !1 } = e, { selection: l } = t, i = ki(n, r.schema), { $from: h, empty: f, ranges: p } = l;
  if (!o)
    return !0;
  if (f && c) {
    let { from: d, to: v } = l;
    const g = (u = h.marks().find((A) => A.type === i)) === null || u === void 0 ? void 0 : u.attrs, m = Rd(h, i, g);
    m && (d = m.from, v = m.to), t.removeMark(d, v, i);
  } else
    p.forEach((d) => {
      t.removeMark(d.$from.pos, d.$to.pos, i);
    });
  return t.removeStoredMark(i), !0;
}, Rw = (n, e = {}) => ({ tr: t, state: r, dispatch: o }) => {
  let u = null, c = null;
  const l = uu(typeof n == "string" ? n : n.name, r.schema);
  return l ? (l === "node" && (u = Ln(n, r.schema)), l === "mark" && (c = ki(n, r.schema)), o && t.selection.ranges.forEach((i) => {
    const h = i.$from.pos, f = i.$to.pos;
    r.doc.nodesBetween(h, f, (p, d) => {
      u && u === p.type && t.setNodeMarkup(d, void 0, {
        ...p.attrs,
        ...e
      }), c && p.marks.length && p.marks.forEach((v) => {
        if (c === v.type) {
          const g = Math.max(d, h), m = Math.min(d + p.nodeSize, f);
          t.addMark(g, m, c.create({
            ...v.attrs,
            ...e
          }));
        }
      });
    });
  }), !0) : !1;
}, Dw = (n, e = {}) => ({ state: t, dispatch: r }) => {
  const o = Ln(n, t.schema);
  return VN(o, e)(t, r);
}, Ow = (n, e = {}) => ({ state: t, dispatch: r }) => {
  const o = Ln(n, t.schema);
  return HN(o, e)(t, r);
};
var Pw = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blur: dL,
  clearContent: hL,
  clearNodes: pL,
  command: mL,
  createParagraphNear: gL,
  cut: vL,
  deleteCurrentNode: _L,
  deleteNode: EL,
  deleteRange: yL,
  deleteSelection: TL,
  enter: AL,
  exitCode: SL,
  extendMarkRange: ML,
  first: bL,
  focus: RL,
  forEach: DL,
  insertContent: OL,
  insertContentAt: NL,
  joinUp: LL,
  joinDown: wL,
  joinBackward: xL,
  joinForward: BL,
  joinItemBackward: FL,
  joinItemForward: UL,
  joinTextblockBackward: kL,
  joinTextblockForward: KL,
  keyboardShortcut: WL,
  lift: VL,
  liftEmptyBlock: HL,
  liftListItem: $L,
  newlineInCode: GL,
  resetAttributes: zL,
  scrollIntoView: YL,
  selectAll: XL,
  selectNodeBackward: QL,
  selectNodeForward: JL,
  selectParentNode: ZL,
  selectTextblockEnd: qL,
  selectTextblockStart: ew,
  setContent: tw,
  setMark: dw,
  setMeta: hw,
  setNode: pw,
  setNodeSelection: mw,
  setTextSelection: gw,
  sinkListItem: vw,
  splitBlock: _w,
  splitListItem: Ew,
  toggleList: yw,
  toggleMark: Tw,
  toggleNode: Aw,
  toggleWrap: Sw,
  undoInputRule: Cw,
  unsetAllMarks: Mw,
  unsetMark: bw,
  updateAttributes: Rw,
  wrapIn: Dw,
  wrapInList: Ow
});
const Iw = Xn.create({
  name: "commands",
  addCommands() {
    return {
      ...Pw
    };
  }
}), Nw = Xn.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new tr({
        key: new zr("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
}), Lw = Xn.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: n } = this;
    return [
      new tr({
        key: new zr("focusEvents"),
        props: {
          handleDOMEvents: {
            focus: (e, t) => {
              n.isFocused = !0;
              const r = n.state.tr.setMeta("focus", { event: t }).setMeta("addToHistory", !1);
              return e.dispatch(r), !1;
            },
            blur: (e, t) => {
              n.isFocused = !1;
              const r = n.state.tr.setMeta("blur", { event: t }).setMeta("addToHistory", !1);
              return e.dispatch(r), !1;
            }
          }
        }
      })
    ];
  }
}), ww = Xn.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const n = () => this.editor.commands.first(({ commands: c }) => [
      () => c.undoInputRule(),
      // maybe convert first text block node to default node
      () => c.command(({ tr: l }) => {
        const { selection: i, doc: h } = l, { empty: f, $anchor: p } = i, { pos: d, parent: v } = p, g = p.parent.isTextblock && d > 0 ? l.doc.resolve(d - 1) : p, m = g.parent.type.spec.isolating, A = p.pos - p.parentOffset, b = m && g.parent.childCount === 1 ? A === p.pos : en.atStart(h).from === d;
        return !f || !v.type.isTextblock || v.textContent.length || !b || b && p.parent.type.name === "paragraph" ? !1 : c.clearNodes();
      }),
      () => c.deleteSelection(),
      () => c.joinBackward(),
      () => c.selectNodeBackward()
    ]), e = () => this.editor.commands.first(({ commands: c }) => [
      () => c.deleteSelection(),
      () => c.deleteCurrentNode(),
      () => c.joinForward(),
      () => c.selectNodeForward()
    ]), r = {
      Enter: () => this.editor.commands.first(({ commands: c }) => [
        () => c.newlineInCode(),
        () => c.createParagraphNear(),
        () => c.liftEmptyBlock(),
        () => c.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: n,
      "Mod-Backspace": n,
      "Shift-Backspace": n,
      Delete: e,
      "Mod-Delete": e,
      "Mod-a": () => this.editor.commands.selectAll()
    }, o = {
      ...r
    }, u = {
      ...r,
      "Ctrl-h": n,
      "Alt-Backspace": n,
      "Ctrl-d": e,
      "Ctrl-Alt-Backspace": e,
      "Alt-Delete": e,
      "Alt-d": e,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return Od() || C_() ? u : o;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new tr({
        key: new zr("clearDocument"),
        appendTransaction: (n, e, t) => {
          if (!(n.some((g) => g.docChanged) && !e.doc.eq(t.doc)))
            return;
          const { empty: o, from: u, to: c } = e.selection, l = en.atStart(e.doc).from, i = en.atEnd(e.doc).to;
          if (o || !(u === l && c === i) || !(t.doc.textBetween(0, t.doc.content.size, " ", " ").length === 0))
            return;
          const p = t.tr, d = iu({
            state: t,
            transaction: p
          }), { commands: v } = new au({
            editor: this.editor,
            state: d
          });
          if (v.clearNodes(), !!p.steps.length)
            return p;
        }
      })
    ];
  }
}), xw = Xn.create({
  name: "tabindex",
  addProseMirrorPlugins() {
    return [
      new tr({
        key: new zr("tabindex"),
        props: {
          attributes: this.editor.isEditable ? { tabindex: "0" } : {}
        }
      })
    ];
  }
});
class Ji {
  constructor(e, t, r = !1, o = null) {
    this.currentNode = null, this.actualDepth = null, this.isBlock = r, this.resolvedPos = e, this.editor = t, this.currentNode = o;
  }
  get name() {
    return this.node.type.name;
  }
  get node() {
    return this.currentNode || this.resolvedPos.node();
  }
  get element() {
    return this.editor.view.domAtPos(this.pos).node;
  }
  get depth() {
    var e;
    return (e = this.actualDepth) !== null && e !== void 0 ? e : this.resolvedPos.depth;
  }
  get pos() {
    return this.resolvedPos.pos;
  }
  get content() {
    return this.node.content;
  }
  set content(e) {
    let t = this.from, r = this.to;
    if (this.isBlock) {
      if (this.content.size === 0) {
        console.error(`You can’t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
        return;
      }
      t = this.from + 1, r = this.to - 1;
    }
    this.editor.commands.insertContentAt({ from: t, to: r }, e);
  }
  get attributes() {
    return this.node.attrs;
  }
  get textContent() {
    return this.node.textContent;
  }
  get size() {
    return this.node.nodeSize;
  }
  get from() {
    return this.isBlock ? this.pos : this.resolvedPos.start(this.resolvedPos.depth);
  }
  get range() {
    return {
      from: this.from,
      to: this.to
    };
  }
  get to() {
    return this.isBlock ? this.pos + this.size : this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
  }
  get parent() {
    if (this.depth === 0)
      return null;
    const e = this.resolvedPos.start(this.resolvedPos.depth - 1), t = this.resolvedPos.doc.resolve(e);
    return new Ji(t, this.editor);
  }
  get before() {
    let e = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.from - 3)), new Ji(e, this.editor);
  }
  get after() {
    let e = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.to + 3)), new Ji(e, this.editor);
  }
  get children() {
    const e = [];
    return this.node.content.forEach((t, r) => {
      const o = t.isBlock && !t.isTextblock, u = this.pos + r + 1, c = this.resolvedPos.doc.resolve(u);
      if (!o && c.depth <= this.depth)
        return;
      const l = new Ji(c, this.editor, o, o ? t : null);
      o && (l.actualDepth = this.depth + 1), e.push(new Ji(c, this.editor, o, o ? t : null));
    }), e;
  }
  get firstChild() {
    return this.children[0] || null;
  }
  get lastChild() {
    const e = this.children;
    return e[e.length - 1] || null;
  }
  closest(e, t = {}) {
    let r = null, o = this.parent;
    for (; o && !r; ) {
      if (o.node.type.name === e)
        if (Object.keys(t).length > 0) {
          const u = o.node.attrs, c = Object.keys(t);
          for (let l = 0; l < c.length; l += 1) {
            const i = c[l];
            if (u[i] !== t[i])
              break;
          }
        } else
          r = o;
      o = o.parent;
    }
    return r;
  }
  querySelector(e, t = {}) {
    return this.querySelectorAll(e, t, !0)[0] || null;
  }
  querySelectorAll(e, t = {}, r = !1) {
    let o = [];
    if (!this.children || this.children.length === 0)
      return o;
    const u = Object.keys(t);
    return this.children.forEach((c) => {
      r && o.length > 0 || (c.node.type.name === e && u.every((i) => t[i] === c.node.attrs[i]) && o.push(c), !(r && o.length > 0) && (o = o.concat(c.querySelectorAll(e, t, r))));
    }), o;
  }
  setAttribute(e) {
    const t = this.editor.state.selection;
    this.editor.chain().setTextSelection(this.from).updateAttributes(this.node.type.name, e).setTextSelection(t.from).run();
  }
}
const Bw = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 1px !important;
  height: 1px !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}

.tippy-box[data-animation=fade][data-state=hidden] {
  opacity: 0
}`;
function Fw(n, e, t) {
  const r = document.querySelector(`style[data-tiptap-style${t ? `-${t}` : ""}]`);
  if (r !== null)
    return r;
  const o = document.createElement("style");
  return e && o.setAttribute("nonce", e), o.setAttribute(`data-tiptap-style${t ? `-${t}` : ""}`, ""), o.innerHTML = n, document.getElementsByTagName("head")[0].appendChild(o), o;
}
let Uw = class extends QN {
  constructor(e = {}) {
    super(), this.isFocused = !1, this.extensionStorage = {}, this.options = {
      element: document.createElement("div"),
      content: "",
      injectCSS: !0,
      injectNonce: void 0,
      extensions: [],
      autofocus: !1,
      editable: !0,
      editorProps: {},
      parseOptions: {},
      coreExtensionOptions: {},
      enableInputRules: !0,
      enablePasteRules: !0,
      enableCoreExtensions: !0,
      onBeforeCreate: () => null,
      onCreate: () => null,
      onUpdate: () => null,
      onSelectionUpdate: () => null,
      onTransaction: () => null,
      onFocus: () => null,
      onBlur: () => null,
      onDestroy: () => null
    }, this.isCapturingTransaction = !1, this.capturedTransaction = null, this.setOptions(e), this.createExtensionManager(), this.createCommandManager(), this.createSchema(), this.on("beforeCreate", this.options.onBeforeCreate), this.emit("beforeCreate", { editor: this }), this.createView(), this.injectCSS(), this.on("create", this.options.onCreate), this.on("update", this.options.onUpdate), this.on("selectionUpdate", this.options.onSelectionUpdate), this.on("transaction", this.options.onTransaction), this.on("focus", this.options.onFocus), this.on("blur", this.options.onBlur), this.on("destroy", this.options.onDestroy), window.setTimeout(() => {
      this.isDestroyed || (this.commands.focus(this.options.autofocus), this.emit("create", { editor: this }));
    }, 0);
  }
  /**
   * Returns the editor storage.
   */
  get storage() {
    return this.extensionStorage;
  }
  /**
   * An object of all registered commands.
   */
  get commands() {
    return this.commandManager.commands;
  }
  /**
   * Create a command chain to call multiple commands at once.
   */
  chain() {
    return this.commandManager.chain();
  }
  /**
   * Check if a command or a command chain can be executed. Without executing it.
   */
  can() {
    return this.commandManager.can();
  }
  /**
   * Inject CSS styles.
   */
  injectCSS() {
    this.options.injectCSS && document && (this.css = Fw(Bw, this.options.injectNonce));
  }
  /**
   * Update editor options.
   *
   * @param options A list of options
   */
  setOptions(e = {}) {
    this.options = {
      ...this.options,
      ...e
    }, !(!this.view || !this.state || this.isDestroyed) && (this.options.editorProps && this.view.setProps(this.options.editorProps), this.view.updateState(this.state));
  }
  /**
   * Update editable state of the editor.
   */
  setEditable(e, t = !0) {
    this.setOptions({ editable: e }), t && this.emit("update", { editor: this, transaction: this.state.tr });
  }
  /**
   * Returns whether the editor is editable.
   */
  get isEditable() {
    return this.options.editable && this.view && this.view.editable;
  }
  /**
   * Returns the editor state.
   */
  get state() {
    return this.view.state;
  }
  /**
   * Register a ProseMirror plugin.
   *
   * @param plugin A ProseMirror plugin
   * @param handlePlugins Control how to merge the plugin into the existing plugins.
   */
  registerPlugin(e, t) {
    const r = E_(t) ? t(e, [...this.state.plugins]) : [...this.state.plugins, e], o = this.state.reconfigure({ plugins: r });
    this.view.updateState(o);
  }
  /**
   * Unregister a ProseMirror plugin.
   *
   * @param nameOrPluginKey The plugins name
   */
  unregisterPlugin(e) {
    if (this.isDestroyed)
      return;
    const t = typeof e == "string" ? `${e}$` : e.key, r = this.state.reconfigure({
      // @ts-ignore
      plugins: this.state.plugins.filter((o) => !o.key.startsWith(t))
    });
    this.view.updateState(r);
  }
  /**
   * Creates an extension manager.
   */
  createExtensionManager() {
    var e, t;
    const o = [...this.options.enableCoreExtensions ? [
      Nw,
      fL.configure({
        blockSeparator: (t = (e = this.options.coreExtensionOptions) === null || e === void 0 ? void 0 : e.clipboardTextSerializer) === null || t === void 0 ? void 0 : t.blockSeparator
      }),
      Iw,
      Lw,
      ww,
      xw
    ] : [], ...this.options.extensions].filter((u) => ["extension", "node", "mark"].includes(u == null ? void 0 : u.type));
    this.extensionManager = new Ka(o, this);
  }
  /**
   * Creates an command manager.
   */
  createCommandManager() {
    this.commandManager = new au({
      editor: this
    });
  }
  /**
   * Creates a ProseMirror schema.
   */
  createSchema() {
    this.schema = this.extensionManager.schema;
  }
  /**
   * Creates a ProseMirror view.
   */
  createView() {
    const e = M_(this.options.content, this.schema, this.options.parseOptions), t = A_(e, this.options.autofocus);
    this.view = new mN(this.options.element, {
      ...this.options.editorProps,
      dispatchTransaction: this.dispatchTransaction.bind(this),
      state: ka.create({
        doc: e,
        selection: t || void 0
      })
    });
    const r = this.state.reconfigure({
      plugins: this.extensionManager.plugins
    });
    this.view.updateState(r), this.createNodeViews(), this.prependClass();
    const o = this.view.dom;
    o.editor = this;
  }
  /**
   * Creates all node views.
   */
  createNodeViews() {
    this.view.setProps({
      nodeViews: this.extensionManager.nodeViews
    });
  }
  /**
   * Prepend class name to element.
   */
  prependClass() {
    this.view.dom.className = `tiptap ${this.view.dom.className}`;
  }
  captureTransaction(e) {
    this.isCapturingTransaction = !0, e(), this.isCapturingTransaction = !1;
    const t = this.capturedTransaction;
    return this.capturedTransaction = null, t;
  }
  /**
   * The callback over which to send transactions (state updates) produced by the view.
   *
   * @param transaction An editor state transaction
   */
  dispatchTransaction(e) {
    if (this.view.isDestroyed)
      return;
    if (this.isCapturingTransaction) {
      if (!this.capturedTransaction) {
        this.capturedTransaction = e;
        return;
      }
      e.steps.forEach((c) => {
        var l;
        return (l = this.capturedTransaction) === null || l === void 0 ? void 0 : l.step(c);
      });
      return;
    }
    const t = this.state.apply(e), r = !this.state.selection.eq(t.selection);
    this.view.updateState(t), this.emit("transaction", {
      editor: this,
      transaction: e
    }), r && this.emit("selectionUpdate", {
      editor: this,
      transaction: e
    });
    const o = e.getMeta("focus"), u = e.getMeta("blur");
    o && this.emit("focus", {
      editor: this,
      event: o.event,
      transaction: e
    }), u && this.emit("blur", {
      editor: this,
      event: u.event,
      transaction: e
    }), !(!e.docChanged || e.getMeta("preventUpdate")) && this.emit("update", {
      editor: this,
      transaction: e
    });
  }
  /**
   * Get attributes of the currently selected node or mark.
   */
  getAttributes(e) {
    return sw(this.state, e);
  }
  isActive(e, t) {
    const r = typeof e == "string" ? e : null, o = typeof e == "string" ? t : e;
    return lw(this.state, r, o);
  }
  /**
   * Get the document as JSON.
   */
  getJSON() {
    return this.state.doc.toJSON();
  }
  /**
   * Get the document as HTML.
   */
  getHTML() {
    return iw(this.state.doc.content, this.schema);
  }
  /**
   * Get the document as text.
   */
  getText(e) {
    const { blockSeparator: t = `

`, textSerializers: r = {} } = e || {};
    return aw(this.state.doc, {
      blockSeparator: t,
      textSerializers: {
        ...T_(this.schema),
        ...r
      }
    });
  }
  /**
   * Check if there is no content.
   */
  get isEmpty() {
    return uw(this.state.doc);
  }
  /**
   * Get the number of characters for the current document.
   *
   * @deprecated
   */
  getCharacterCount() {
    return console.warn('[tiptap warn]: "editor.getCharacterCount()" is deprecated. Please use "editor.storage.characterCount.characters()" instead.'), this.state.doc.content.size - 2;
  }
  /**
   * Destroy the editor.
   */
  destroy() {
    this.emit("destroy"), this.view && this.view.destroy(), this.removeAllListeners();
  }
  /**
   * Check if the editor is already destroyed.
   */
  get isDestroyed() {
    var e;
    return !(!((e = this.view) === null || e === void 0) && e.docView);
  }
  $node(e, t) {
    var r;
    return ((r = this.$doc) === null || r === void 0 ? void 0 : r.querySelector(e, t)) || null;
  }
  $nodes(e, t) {
    var r;
    return ((r = this.$doc) === null || r === void 0 ? void 0 : r.querySelectorAll(e, t)) || null;
  }
  $pos(e) {
    const t = this.state.doc.resolve(e);
    return new Ji(t, this);
  }
  get $doc() {
    return this.$pos(0);
  }
};
function fo(n) {
  return new su({
    find: n.find,
    handler: ({ state: e, range: t, match: r }) => {
      const o = qt(n.getAttributes, void 0, r);
      if (o === !1 || o === null)
        return null;
      const { tr: u } = e, c = r[r.length - 1], l = r[0];
      if (c) {
        const i = l.search(/\S/), h = t.from + l.indexOf(c), f = h + c.length;
        if (b_(t.from, t.to, e.doc).filter((v) => v.mark.type.excluded.find((m) => m === n.type && m !== v.mark.type)).filter((v) => v.to > h).length)
          return null;
        f < t.to && u.delete(f, t.to), h > t.from && u.delete(t.from + i, h);
        const d = t.from + i + c.length;
        u.addMark(t.from + i, d, n.type.create(o || {})), u.removeStoredMark(n.type);
      }
    }
  });
}
function kw(n) {
  return new su({
    find: n.find,
    handler: ({ state: e, range: t, match: r }) => {
      const o = qt(n.getAttributes, void 0, r) || {}, { tr: u } = e, c = t.from;
      let l = t.to;
      const i = n.type.create(o);
      if (r[1]) {
        const h = r[0].lastIndexOf(r[1]);
        let f = c + h;
        f > l ? f = l : l = f + r[1].length;
        const p = r[0][r[0].length - 1];
        u.insertText(p, c + r[0].length - 1), u.replaceWith(f, l, i);
      } else
        r[0] && u.insert(c - 1, n.type.create(o)).delete(u.mapping.map(c), u.mapping.map(l));
      u.scrollIntoView();
    }
  });
}
function df(n) {
  return new su({
    find: n.find,
    handler: ({ state: e, range: t, match: r }) => {
      const o = e.doc.resolve(t.from), u = qt(n.getAttributes, void 0, r) || {};
      if (!o.node(-1).canReplaceWith(o.index(-1), o.indexAfter(-1), n.type))
        return null;
      e.tr.delete(t.from, t.to).setBlockType(t.from, t.from, n.type, u);
    }
  });
}
function Es(n) {
  return new su({
    find: n.find,
    handler: ({ state: e, range: t, match: r, chain: o }) => {
      const u = qt(n.getAttributes, void 0, r) || {}, c = e.tr.delete(t.from, t.to), i = c.doc.resolve(t.from).blockRange(), h = i && pd(i, n.type, u);
      if (!h)
        return null;
      if (c.wrap(i, h), n.keepMarks && n.editor) {
        const { selection: p, storedMarks: d } = e, { splittableMarks: v } = n.editor.extensionManager, g = d || p.$to.parentOffset && p.$from.marks();
        if (g) {
          const m = g.filter((A) => v.includes(A.type.name));
          c.ensureMarks(m);
        }
      }
      if (n.keepAttributes) {
        const p = n.type.name === "bulletList" || n.type.name === "orderedList" ? "listItem" : "taskList";
        o().updateAttributes(p, u).run();
      }
      const f = c.doc.resolve(t.from - 1).nodeBefore;
      f && f.type === n.type && Fi(c.doc, t.from - 1) && (!n.joinPredicate || n.joinPredicate(r, f)) && c.join(t.from - 1);
    }
  });
}
class Hr {
  constructor(e = {}) {
    this.type = "mark", this.name = "mark", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = qt(Bt(this, "addOptions", {
      name: this.name
    }))), this.storage = qt(Bt(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new Hr(e);
  }
  configure(e = {}) {
    const t = this.extend();
    return t.options = lu(this.options, e), t.storage = qt(Bt(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
  extend(e = {}) {
    const t = new Hr({ ...this.config, ...e });
    return t.parent = this, this.child = t, t.name = e.name ? e.name : t.parent.name, e.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${t.name}".`), t.options = qt(Bt(t, "addOptions", {
      name: t.name
    })), t.storage = qt(Bt(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
  static handleExit({ editor: e, mark: t }) {
    const { tr: r } = e.state, o = e.state.selection.$from;
    if (o.pos === o.end()) {
      const c = o.marks();
      if (!!!c.find((h) => (h == null ? void 0 : h.type.name) === t.name))
        return !1;
      const i = c.find((h) => (h == null ? void 0 : h.type.name) === t.name);
      return i && r.removeStoredMark(i), r.insertText(" ", o.pos), e.view.dispatch(r), !0;
    }
    return !1;
  }
}
let ur = class hf {
  constructor(e = {}) {
    this.type = "node", this.name = "node", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = qt(Bt(this, "addOptions", {
      name: this.name
    }))), this.storage = qt(Bt(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new hf(e);
  }
  configure(e = {}) {
    const t = this.extend();
    return t.options = lu(this.options, e), t.storage = qt(Bt(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
  extend(e = {}) {
    const t = new hf({ ...this.config, ...e });
    return t.parent = this, this.child = t, t.name = e.name ? e.name : t.parent.name, e.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${t.name}".`), t.options = qt(Bt(t, "addOptions", {
      name: t.name
    })), t.storage = qt(Bt(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
};
function ho(n) {
  return new iL({
    find: n.find,
    handler: ({ state: e, range: t, match: r, pasteEvent: o }) => {
      const u = qt(n.getAttributes, void 0, r, o);
      if (u === !1 || u === null)
        return null;
      const { tr: c } = e, l = r[r.length - 1], i = r[0];
      let h = t.to;
      if (l) {
        const f = i.search(/\S/), p = t.from + i.indexOf(l), d = p + l.length;
        if (b_(t.from, t.to, e.doc).filter((g) => g.mark.type.excluded.find((A) => A === n.type && A !== g.mark.type)).filter((g) => g.to > p).length)
          return null;
        d < t.to && c.delete(d, t.to), p > t.from && c.delete(t.from + f, p), h = t.from + f + l.length, c.addMark(t.from + f, h, n.type.create(u || {})), c.removeStoredMark(n.type);
      }
    }
  });
}
var Kw = "tippy-box", D_ = "tippy-content", jw = "tippy-backdrop", O_ = "tippy-arrow", P_ = "tippy-svg-arrow", zi = {
  passive: !0,
  capture: !0
}, I_ = function() {
  return document.body;
};
function Ww(n, e) {
  return {}.hasOwnProperty.call(n, e);
}
function mc(n, e, t) {
  if (Array.isArray(n)) {
    var r = n[e];
    return r ?? (Array.isArray(t) ? t[e] : t);
  }
  return n;
}
function Id(n, e) {
  var t = {}.toString.call(n);
  return t.indexOf("[object") === 0 && t.indexOf(e + "]") > -1;
}
function N_(n, e) {
  return typeof n == "function" ? n.apply(void 0, e) : n;
}
function em(n, e) {
  if (e === 0)
    return n;
  var t;
  return function(r) {
    clearTimeout(t), t = setTimeout(function() {
      n(r);
    }, e);
  };
}
function Vw(n, e) {
  var t = Object.assign({}, n);
  return e.forEach(function(r) {
    delete t[r];
  }), t;
}
function Hw(n) {
  return n.split(/\s+/).filter(Boolean);
}
function xa(n) {
  return [].concat(n);
}
function tm(n, e) {
  n.indexOf(e) === -1 && n.push(e);
}
function $w(n) {
  return n.filter(function(e, t) {
    return n.indexOf(e) === t;
  });
}
function Gw(n) {
  return n.split("-")[0];
}
function Bl(n) {
  return [].slice.call(n);
}
function nm(n) {
  return Object.keys(n).reduce(function(e, t) {
    return n[t] !== void 0 && (e[t] = n[t]), e;
  }, {});
}
function Zo() {
  return document.createElement("div");
}
function ys(n) {
  return ["Element", "Fragment"].some(function(e) {
    return Id(n, e);
  });
}
function zw(n) {
  return Id(n, "NodeList");
}
function Yw(n) {
  return Id(n, "MouseEvent");
}
function Xw(n) {
  return !!(n && n._tippy && n._tippy.reference === n);
}
function Qw(n) {
  return ys(n) ? [n] : zw(n) ? Bl(n) : Array.isArray(n) ? n : Bl(document.querySelectorAll(n));
}
function gc(n, e) {
  n.forEach(function(t) {
    t && (t.style.transitionDuration = e + "ms");
  });
}
function rm(n, e) {
  n.forEach(function(t) {
    t && t.setAttribute("data-state", e);
  });
}
function Jw(n) {
  var e, t = xa(n), r = t[0];
  return r != null && (e = r.ownerDocument) != null && e.body ? r.ownerDocument : document;
}
function Zw(n, e) {
  var t = e.clientX, r = e.clientY;
  return n.every(function(o) {
    var u = o.popperRect, c = o.popperState, l = o.props, i = l.interactiveBorder, h = Gw(c.placement), f = c.modifiersData.offset;
    if (!f)
      return !0;
    var p = h === "bottom" ? f.top.y : 0, d = h === "top" ? f.bottom.y : 0, v = h === "right" ? f.left.x : 0, g = h === "left" ? f.right.x : 0, m = u.top - r + p > i, A = r - u.bottom - d > i, b = u.left - t + v > i, S = t - u.right - g > i;
    return m || A || b || S;
  });
}
function vc(n, e, t) {
  var r = e + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(o) {
    n[r](o, t);
  });
}
function im(n, e) {
  for (var t = e; t; ) {
    var r;
    if (n.contains(t))
      return !0;
    t = t.getRootNode == null || (r = t.getRootNode()) == null ? void 0 : r.host;
  }
  return !1;
}
var Br = {
  isTouch: !1
}, am = 0;
function qw() {
  Br.isTouch || (Br.isTouch = !0, window.performance && document.addEventListener("mousemove", L_));
}
function L_() {
  var n = performance.now();
  n - am < 20 && (Br.isTouch = !1, document.removeEventListener("mousemove", L_)), am = n;
}
function e1() {
  var n = document.activeElement;
  if (Xw(n)) {
    var e = n._tippy;
    n.blur && !e.state.isVisible && n.blur();
  }
}
function t1() {
  document.addEventListener("touchstart", qw, zi), window.addEventListener("blur", e1);
}
var n1 = typeof window < "u" && typeof document < "u", r1 = n1 ? (
  // @ts-ignore
  !!window.msCrypto
) : !1;
function Oa(n) {
  var e = n === "destroy" ? "n already-" : " ";
  return [n + "() was called on a" + e + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function om(n) {
  var e = /[ \t]{2,}/g, t = /^[ \t]*/gm;
  return n.replace(e, " ").replace(t, "").trim();
}
function i1(n) {
  return om(`
  %ctippy.js

  %c` + om(n) + `

  %c👷‍ This is a development-only message. It will be removed in production.
  `);
}
function w_(n) {
  return [
    i1(n),
    // title
    "color: #00C584; font-size: 1.3em; font-weight: bold;",
    // message
    "line-height: 1.5",
    // footer
    "color: #a6a095;"
  ];
}
var Ts;
process.env.NODE_ENV !== "production" && a1();
function a1() {
  Ts = /* @__PURE__ */ new Set();
}
function qr(n, e) {
  if (n && !Ts.has(e)) {
    var t;
    Ts.add(e), (t = console).warn.apply(t, w_(e));
  }
}
function pf(n, e) {
  if (n && !Ts.has(e)) {
    var t;
    Ts.add(e), (t = console).error.apply(t, w_(e));
  }
}
function o1(n) {
  var e = !n, t = Object.prototype.toString.call(n) === "[object Object]" && !n.addEventListener;
  pf(e, ["tippy() was passed", "`" + String(n) + "`", "as its targets (first) argument. Valid types are: String, Element,", "Element[], or NodeList."].join(" ")), pf(t, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
}
var x_ = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, s1 = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, or = Object.assign({
  appendTo: I_,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, x_, s1), l1 = Object.keys(or), u1 = function(e) {
  process.env.NODE_ENV !== "production" && F_(e, []);
  var t = Object.keys(e);
  t.forEach(function(r) {
    or[r] = e[r];
  });
};
function B_(n) {
  var e = n.plugins || [], t = e.reduce(function(r, o) {
    var u = o.name, c = o.defaultValue;
    if (u) {
      var l;
      r[u] = n[u] !== void 0 ? n[u] : (l = or[u]) != null ? l : c;
    }
    return r;
  }, {});
  return Object.assign({}, n, t);
}
function c1(n, e) {
  var t = e ? Object.keys(B_(Object.assign({}, or, {
    plugins: e
  }))) : l1, r = t.reduce(function(o, u) {
    var c = (n.getAttribute("data-tippy-" + u) || "").trim();
    if (!c)
      return o;
    if (u === "content")
      o[u] = c;
    else
      try {
        o[u] = JSON.parse(c);
      } catch {
        o[u] = c;
      }
    return o;
  }, {});
  return r;
}
function sm(n, e) {
  var t = Object.assign({}, e, {
    content: N_(e.content, [n])
  }, e.ignoreAttributes ? {} : c1(n, e.plugins));
  return t.aria = Object.assign({}, or.aria, t.aria), t.aria = {
    expanded: t.aria.expanded === "auto" ? e.interactive : t.aria.expanded,
    content: t.aria.content === "auto" ? e.interactive ? null : "describedby" : t.aria.content
  }, t;
}
function F_(n, e) {
  n === void 0 && (n = {}), e === void 0 && (e = []);
  var t = Object.keys(n);
  t.forEach(function(r) {
    var o = Vw(or, Object.keys(x_)), u = !Ww(o, r);
    u && (u = e.filter(function(c) {
      return c.name === r;
    }).length === 0), qr(u, ["`" + r + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", "a plugin, forgot to pass it in an array as props.plugins.", `

`, `All props: https://atomiks.github.io/tippyjs/v6/all-props/
`, "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"].join(" "));
  });
}
var f1 = function() {
  return "innerHTML";
};
function mf(n, e) {
  n[f1()] = e;
}
function lm(n) {
  var e = Zo();
  return n === !0 ? e.className = O_ : (e.className = P_, ys(n) ? e.appendChild(n) : mf(e, n)), e;
}
function um(n, e) {
  ys(e.content) ? (mf(n, ""), n.appendChild(e.content)) : typeof e.content != "function" && (e.allowHTML ? mf(n, e.content) : n.textContent = e.content);
}
function gf(n) {
  var e = n.firstElementChild, t = Bl(e.children);
  return {
    box: e,
    content: t.find(function(r) {
      return r.classList.contains(D_);
    }),
    arrow: t.find(function(r) {
      return r.classList.contains(O_) || r.classList.contains(P_);
    }),
    backdrop: t.find(function(r) {
      return r.classList.contains(jw);
    })
  };
}
function U_(n) {
  var e = Zo(), t = Zo();
  t.className = Kw, t.setAttribute("data-state", "hidden"), t.setAttribute("tabindex", "-1");
  var r = Zo();
  r.className = D_, r.setAttribute("data-state", "hidden"), um(r, n.props), e.appendChild(t), t.appendChild(r), o(n.props, n.props);
  function o(u, c) {
    var l = gf(e), i = l.box, h = l.content, f = l.arrow;
    c.theme ? i.setAttribute("data-theme", c.theme) : i.removeAttribute("data-theme"), typeof c.animation == "string" ? i.setAttribute("data-animation", c.animation) : i.removeAttribute("data-animation"), c.inertia ? i.setAttribute("data-inertia", "") : i.removeAttribute("data-inertia"), i.style.maxWidth = typeof c.maxWidth == "number" ? c.maxWidth + "px" : c.maxWidth, c.role ? i.setAttribute("role", c.role) : i.removeAttribute("role"), (u.content !== c.content || u.allowHTML !== c.allowHTML) && um(h, n.props), c.arrow ? f ? u.arrow !== c.arrow && (i.removeChild(f), i.appendChild(lm(c.arrow))) : i.appendChild(lm(c.arrow)) : f && i.removeChild(f);
  }
  return {
    popper: e,
    onUpdate: o
  };
}
U_.$$tippy = !0;
var d1 = 1, nl = [], _c = [];
function h1(n, e) {
  var t = sm(n, Object.assign({}, or, B_(nm(e)))), r, o, u, c = !1, l = !1, i = !1, h = !1, f, p, d, v = [], g = em(se, t.interactiveDebounce), m, A = d1++, b = null, S = $w(t.plugins), N = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, T = {
    // properties
    id: A,
    reference: n,
    popper: Zo(),
    popperInstance: b,
    props: t,
    state: N,
    plugins: S,
    // methods
    clearDelayTimeouts: V,
    setProps: Q,
    setContent: fe,
    show: ue,
    hide: q,
    hideWithInteractivity: _e,
    enable: K,
    disable: U,
    unmount: ge,
    destroy: Ce
  };
  if (!t.render)
    return process.env.NODE_ENV !== "production" && pf(!0, "render() function has not been supplied."), T;
  var R = t.render(T), y = R.popper, E = R.onUpdate;
  y.setAttribute("data-tippy-root", ""), y.id = "tippy-" + T.id, T.popper = y, n._tippy = T, y._tippy = T;
  var L = S.map(function(Ee) {
    return Ee.fn(T);
  }), _ = n.hasAttribute("aria-expanded");
  return de(), Y(), k(), H("onCreate", [T]), t.showOnCreate && W(), y.addEventListener("mouseenter", function() {
    T.props.interactive && T.state.isVisible && T.clearDelayTimeouts();
  }), y.addEventListener("mouseleave", function() {
    T.props.interactive && T.props.trigger.indexOf("mouseenter") >= 0 && I().addEventListener("mousemove", g);
  }), T;
  function O() {
    var Ee = T.props.touch;
    return Array.isArray(Ee) ? Ee : [Ee, 0];
  }
  function D() {
    return O()[0] === "hold";
  }
  function M() {
    var Ee;
    return !!((Ee = T.props.render) != null && Ee.$$tippy);
  }
  function C() {
    return m || n;
  }
  function I() {
    var Ee = C().parentNode;
    return Ee ? Jw(Ee) : document;
  }
  function w() {
    return gf(y);
  }
  function F(Ee) {
    return T.state.isMounted && !T.state.isVisible || Br.isTouch || f && f.type === "focus" ? 0 : mc(T.props.delay, Ee ? 0 : 1, or.delay);
  }
  function k(Ee) {
    Ee === void 0 && (Ee = !1), y.style.pointerEvents = T.props.interactive && !Ee ? "" : "none", y.style.zIndex = "" + T.props.zIndex;
  }
  function H(Ee, Re, Pe) {
    if (Pe === void 0 && (Pe = !0), L.forEach(function(De) {
      De[Ee] && De[Ee].apply(De, Re);
    }), Pe) {
      var ke;
      (ke = T.props)[Ee].apply(ke, Re);
    }
  }
  function Z() {
    var Ee = T.props.aria;
    if (Ee.content) {
      var Re = "aria-" + Ee.content, Pe = y.id, ke = xa(T.props.triggerTarget || n);
      ke.forEach(function(De) {
        var Ae = De.getAttribute(Re);
        if (T.state.isVisible)
          De.setAttribute(Re, Ae ? Ae + " " + Pe : Pe);
        else {
          var Ie = Ae && Ae.replace(Pe, "").trim();
          Ie ? De.setAttribute(Re, Ie) : De.removeAttribute(Re);
        }
      });
    }
  }
  function Y() {
    if (!(_ || !T.props.aria.expanded)) {
      var Ee = xa(T.props.triggerTarget || n);
      Ee.forEach(function(Re) {
        T.props.interactive ? Re.setAttribute("aria-expanded", T.state.isVisible && Re === C() ? "true" : "false") : Re.removeAttribute("aria-expanded");
      });
    }
  }
  function j() {
    I().removeEventListener("mousemove", g), nl = nl.filter(function(Ee) {
      return Ee !== g;
    });
  }
  function J(Ee) {
    if (!(Br.isTouch && (i || Ee.type === "mousedown"))) {
      var Re = Ee.composedPath && Ee.composedPath()[0] || Ee.target;
      if (!(T.props.interactive && im(y, Re))) {
        if (xa(T.props.triggerTarget || n).some(function(Pe) {
          return im(Pe, Re);
        })) {
          if (Br.isTouch || T.state.isVisible && T.props.trigger.indexOf("click") >= 0)
            return;
        } else
          H("onClickOutside", [T, Ee]);
        T.props.hideOnClick === !0 && (T.clearDelayTimeouts(), T.hide(), l = !0, setTimeout(function() {
          l = !1;
        }), T.state.isMounted || ie());
      }
    }
  }
  function ae() {
    i = !0;
  }
  function G() {
    i = !1;
  }
  function $() {
    var Ee = I();
    Ee.addEventListener("mousedown", J, !0), Ee.addEventListener("touchend", J, zi), Ee.addEventListener("touchstart", G, zi), Ee.addEventListener("touchmove", ae, zi);
  }
  function ie() {
    var Ee = I();
    Ee.removeEventListener("mousedown", J, !0), Ee.removeEventListener("touchend", J, zi), Ee.removeEventListener("touchstart", G, zi), Ee.removeEventListener("touchmove", ae, zi);
  }
  function re(Ee, Re) {
    z(Ee, function() {
      !T.state.isVisible && y.parentNode && y.parentNode.contains(y) && Re();
    });
  }
  function ce(Ee, Re) {
    z(Ee, Re);
  }
  function z(Ee, Re) {
    var Pe = w().box;
    function ke(De) {
      De.target === Pe && (vc(Pe, "remove", ke), Re());
    }
    if (Ee === 0)
      return Re();
    vc(Pe, "remove", p), vc(Pe, "add", ke), p = ke;
  }
  function oe(Ee, Re, Pe) {
    Pe === void 0 && (Pe = !1);
    var ke = xa(T.props.triggerTarget || n);
    ke.forEach(function(De) {
      De.addEventListener(Ee, Re, Pe), v.push({
        node: De,
        eventType: Ee,
        handler: Re,
        options: Pe
      });
    });
  }
  function de() {
    D() && (oe("touchstart", he, {
      passive: !0
    }), oe("touchend", ee, {
      passive: !0
    })), Hw(T.props.trigger).forEach(function(Ee) {
      if (Ee !== "manual")
        switch (oe(Ee, he), Ee) {
          case "mouseenter":
            oe("mouseleave", ee);
            break;
          case "focus":
            oe(r1 ? "focusout" : "blur", te);
            break;
          case "focusin":
            oe("focusout", te);
            break;
        }
    });
  }
  function pe() {
    v.forEach(function(Ee) {
      var Re = Ee.node, Pe = Ee.eventType, ke = Ee.handler, De = Ee.options;
      Re.removeEventListener(Pe, ke, De);
    }), v = [];
  }
  function he(Ee) {
    var Re, Pe = !1;
    if (!(!T.state.isEnabled || le(Ee) || l)) {
      var ke = ((Re = f) == null ? void 0 : Re.type) === "focus";
      f = Ee, m = Ee.currentTarget, Y(), !T.state.isVisible && Yw(Ee) && nl.forEach(function(De) {
        return De(Ee);
      }), Ee.type === "click" && (T.props.trigger.indexOf("mouseenter") < 0 || c) && T.props.hideOnClick !== !1 && T.state.isVisible ? Pe = !0 : W(Ee), Ee.type === "click" && (c = !Pe), Pe && !ke && X(Ee);
    }
  }
  function se(Ee) {
    var Re = Ee.target, Pe = C().contains(Re) || y.contains(Re);
    if (!(Ee.type === "mousemove" && Pe)) {
      var ke = B().concat(y).map(function(De) {
        var Ae, Ie = De._tippy, Xe = (Ae = Ie.popperInstance) == null ? void 0 : Ae.state;
        return Xe ? {
          popperRect: De.getBoundingClientRect(),
          popperState: Xe,
          props: t
        } : null;
      }).filter(Boolean);
      Zw(ke, Ee) && (j(), X(Ee));
    }
  }
  function ee(Ee) {
    var Re = le(Ee) || T.props.trigger.indexOf("click") >= 0 && c;
    if (!Re) {
      if (T.props.interactive) {
        T.hideWithInteractivity(Ee);
        return;
      }
      X(Ee);
    }
  }
  function te(Ee) {
    T.props.trigger.indexOf("focusin") < 0 && Ee.target !== C() || T.props.interactive && Ee.relatedTarget && y.contains(Ee.relatedTarget) || X(Ee);
  }
  function le(Ee) {
    return Br.isTouch ? D() !== Ee.type.indexOf("touch") >= 0 : !1;
  }
  function ne() {
    x();
    var Ee = T.props, Re = Ee.popperOptions, Pe = Ee.placement, ke = Ee.offset, De = Ee.getReferenceClientRect, Ae = Ee.moveTransition, Ie = M() ? gf(y).arrow : null, Xe = De ? {
      getBoundingClientRect: De,
      contextElement: De.contextElement || C()
    } : n, it = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(He) {
        var $e = He.state;
        if (M()) {
          var nt = w(), ut = nt.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(pt) {
            pt === "placement" ? ut.setAttribute("data-placement", $e.placement) : $e.attributes.popper["data-popper-" + pt] ? ut.setAttribute("data-" + pt, "") : ut.removeAttribute("data-" + pt);
          }), $e.attributes.popper = {};
        }
      }
    }, rt = [{
      name: "offset",
      options: {
        offset: ke
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !Ae
      }
    }, it];
    M() && Ie && rt.push({
      name: "arrow",
      options: {
        element: Ie,
        padding: 3
      }
    }), rt.push.apply(rt, (Re == null ? void 0 : Re.modifiers) || []), T.popperInstance = d0(Xe, y, Object.assign({}, Re, {
      placement: Pe,
      onFirstUpdate: d,
      modifiers: rt
    }));
  }
  function x() {
    T.popperInstance && (T.popperInstance.destroy(), T.popperInstance = null);
  }
  function P() {
    var Ee = T.props.appendTo, Re, Pe = C();
    T.props.interactive && Ee === I_ || Ee === "parent" ? Re = Pe.parentNode : Re = N_(Ee, [Pe]), Re.contains(y) || Re.appendChild(y), T.state.isMounted = !0, ne(), process.env.NODE_ENV !== "production" && qr(T.props.interactive && Ee === or.appendTo && Pe.nextElementSibling !== y, ["Interactive tippy element may not be accessible via keyboard", "navigation because it is not directly after the reference element", "in the DOM source order.", `

`, "Using a wrapper <div> or <span> tag around the reference element", "solves this by creating a new parentNode context.", `

`, "Specifying `appendTo: document.body` silences this warning, but it", "assumes you are using a focus management solution to handle", "keyboard navigation.", `

`, "See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"].join(" "));
  }
  function B() {
    return Bl(y.querySelectorAll("[data-tippy-root]"));
  }
  function W(Ee) {
    T.clearDelayTimeouts(), Ee && H("onTrigger", [T, Ee]), $();
    var Re = F(!0), Pe = O(), ke = Pe[0], De = Pe[1];
    Br.isTouch && ke === "hold" && De && (Re = De), Re ? r = setTimeout(function() {
      T.show();
    }, Re) : T.show();
  }
  function X(Ee) {
    if (T.clearDelayTimeouts(), H("onUntrigger", [T, Ee]), !T.state.isVisible) {
      ie();
      return;
    }
    if (!(T.props.trigger.indexOf("mouseenter") >= 0 && T.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(Ee.type) >= 0 && c)) {
      var Re = F(!1);
      Re ? o = setTimeout(function() {
        T.state.isVisible && T.hide();
      }, Re) : u = requestAnimationFrame(function() {
        T.hide();
      });
    }
  }
  function K() {
    T.state.isEnabled = !0;
  }
  function U() {
    T.hide(), T.state.isEnabled = !1;
  }
  function V() {
    clearTimeout(r), clearTimeout(o), cancelAnimationFrame(u);
  }
  function Q(Ee) {
    if (process.env.NODE_ENV !== "production" && qr(T.state.isDestroyed, Oa("setProps")), !T.state.isDestroyed) {
      H("onBeforeUpdate", [T, Ee]), pe();
      var Re = T.props, Pe = sm(n, Object.assign({}, Re, nm(Ee), {
        ignoreAttributes: !0
      }));
      T.props = Pe, de(), Re.interactiveDebounce !== Pe.interactiveDebounce && (j(), g = em(se, Pe.interactiveDebounce)), Re.triggerTarget && !Pe.triggerTarget ? xa(Re.triggerTarget).forEach(function(ke) {
        ke.removeAttribute("aria-expanded");
      }) : Pe.triggerTarget && n.removeAttribute("aria-expanded"), Y(), k(), E && E(Re, Pe), T.popperInstance && (ne(), B().forEach(function(ke) {
        requestAnimationFrame(ke._tippy.popperInstance.forceUpdate);
      })), H("onAfterUpdate", [T, Ee]);
    }
  }
  function fe(Ee) {
    T.setProps({
      content: Ee
    });
  }
  function ue() {
    process.env.NODE_ENV !== "production" && qr(T.state.isDestroyed, Oa("show"));
    var Ee = T.state.isVisible, Re = T.state.isDestroyed, Pe = !T.state.isEnabled, ke = Br.isTouch && !T.props.touch, De = mc(T.props.duration, 0, or.duration);
    if (!(Ee || Re || Pe || ke) && !C().hasAttribute("disabled") && (H("onShow", [T], !1), T.props.onShow(T) !== !1)) {
      if (T.state.isVisible = !0, M() && (y.style.visibility = "visible"), k(), $(), T.state.isMounted || (y.style.transition = "none"), M()) {
        var Ae = w(), Ie = Ae.box, Xe = Ae.content;
        gc([Ie, Xe], 0);
      }
      d = function() {
        var rt;
        if (!(!T.state.isVisible || h)) {
          if (h = !0, y.offsetHeight, y.style.transition = T.props.moveTransition, M() && T.props.animation) {
            var Ne = w(), He = Ne.box, $e = Ne.content;
            gc([He, $e], De), rm([He, $e], "visible");
          }
          Z(), Y(), tm(_c, T), (rt = T.popperInstance) == null || rt.forceUpdate(), H("onMount", [T]), T.props.animation && M() && ce(De, function() {
            T.state.isShown = !0, H("onShown", [T]);
          });
        }
      }, P();
    }
  }
  function q() {
    process.env.NODE_ENV !== "production" && qr(T.state.isDestroyed, Oa("hide"));
    var Ee = !T.state.isVisible, Re = T.state.isDestroyed, Pe = !T.state.isEnabled, ke = mc(T.props.duration, 1, or.duration);
    if (!(Ee || Re || Pe) && (H("onHide", [T], !1), T.props.onHide(T) !== !1)) {
      if (T.state.isVisible = !1, T.state.isShown = !1, h = !1, c = !1, M() && (y.style.visibility = "hidden"), j(), ie(), k(!0), M()) {
        var De = w(), Ae = De.box, Ie = De.content;
        T.props.animation && (gc([Ae, Ie], ke), rm([Ae, Ie], "hidden"));
      }
      Z(), Y(), T.props.animation ? M() && re(ke, T.unmount) : T.unmount();
    }
  }
  function _e(Ee) {
    process.env.NODE_ENV !== "production" && qr(T.state.isDestroyed, Oa("hideWithInteractivity")), I().addEventListener("mousemove", g), tm(nl, g), g(Ee);
  }
  function ge() {
    process.env.NODE_ENV !== "production" && qr(T.state.isDestroyed, Oa("unmount")), T.state.isVisible && T.hide(), T.state.isMounted && (x(), B().forEach(function(Ee) {
      Ee._tippy.unmount();
    }), y.parentNode && y.parentNode.removeChild(y), _c = _c.filter(function(Ee) {
      return Ee !== T;
    }), T.state.isMounted = !1, H("onHidden", [T]));
  }
  function Ce() {
    process.env.NODE_ENV !== "production" && qr(T.state.isDestroyed, Oa("destroy")), !T.state.isDestroyed && (T.clearDelayTimeouts(), T.unmount(), pe(), delete n._tippy, T.state.isDestroyed = !0, H("onDestroy", [T]));
  }
}
function So(n, e) {
  e === void 0 && (e = {});
  var t = or.plugins.concat(e.plugins || []);
  process.env.NODE_ENV !== "production" && (o1(n), F_(e, t)), t1();
  var r = Object.assign({}, e, {
    plugins: t
  }), o = Qw(n);
  if (process.env.NODE_ENV !== "production") {
    var u = ys(r.content), c = o.length > 1;
    qr(u && c, ["tippy() was passed an Element as the `content` prop, but more than", "one tippy instance was created by this invocation. This means the", "content element will only be appended to the last tippy instance.", `

`, "Instead, pass the .innerHTML of the element, or use a function that", "returns a cloned version of the element instead.", `

`, `1) content: element.innerHTML
`, "2) content: () => element.cloneNode(true)"].join(" "));
  }
  var l = o.reduce(function(i, h) {
    var f = h && h1(h, r);
    return f && i.push(f), i;
  }, []);
  return ys(n) ? l[0] : l;
}
So.defaultProps = or;
So.setDefaultProps = u1;
So.currentInput = Br;
Object.assign({}, _g, {
  effect: function(e) {
    var t = e.state, r = {
      popper: {
        position: t.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(t.elements.popper.style, r.popper), t.styles = r, t.elements.arrow && Object.assign(t.elements.arrow.style, r.arrow);
  }
});
So.setDefaultProps({
  render: U_
});
class p1 {
  constructor({ editor: e, element: t, view: r, tippyOptions: o = {}, updateDelay: u = 250, shouldShow: c }) {
    this.preventHide = !1, this.shouldShow = ({ view: l, state: i, from: h, to: f }) => {
      const { doc: p, selection: d } = i, { empty: v } = d, g = !p.textBetween(h, f).length && Dd(i.selection), m = this.element.contains(document.activeElement);
      return !(!(l.hasFocus() || m) || v || g || !this.editor.isEditable);
    }, this.mousedownHandler = () => {
      this.preventHide = !0;
    }, this.dragstartHandler = () => {
      this.hide();
    }, this.focusHandler = () => {
      setTimeout(() => this.update(this.editor.view));
    }, this.blurHandler = ({ event: l }) => {
      var i;
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      l != null && l.relatedTarget && (!((i = this.element.parentNode) === null || i === void 0) && i.contains(l.relatedTarget)) || this.hide();
    }, this.tippyBlurHandler = (l) => {
      this.blurHandler({ event: l });
    }, this.handleDebouncedUpdate = (l, i) => {
      const h = !(i != null && i.selection.eq(l.state.selection)), f = !(i != null && i.doc.eq(l.state.doc));
      !h && !f || (this.updateDebounceTimer && clearTimeout(this.updateDebounceTimer), this.updateDebounceTimer = window.setTimeout(() => {
        this.updateHandler(l, h, f, i);
      }, this.updateDelay));
    }, this.updateHandler = (l, i, h, f) => {
      var p, d, v;
      const { state: g, composing: m } = l, { selection: A } = g;
      if (m || !i && !h)
        return;
      this.createTooltip();
      const { ranges: S } = A, N = Math.min(...S.map((y) => y.$from.pos)), T = Math.max(...S.map((y) => y.$to.pos));
      if (!((p = this.shouldShow) === null || p === void 0 ? void 0 : p.call(this, {
        editor: this.editor,
        view: l,
        state: g,
        oldState: f,
        from: N,
        to: T
      }))) {
        this.hide();
        return;
      }
      (d = this.tippy) === null || d === void 0 || d.setProps({
        getReferenceClientRect: ((v = this.tippyOptions) === null || v === void 0 ? void 0 : v.getReferenceClientRect) || (() => {
          if (cw(g.selection)) {
            let y = l.nodeDOM(N);
            const E = y.dataset.nodeViewWrapper ? y : y.querySelector("[data-node-view-wrapper]");
            if (E && (y = E.firstChild), y)
              return y.getBoundingClientRect();
          }
          return R_(l, N, T);
        })
      }), this.show();
    }, this.editor = e, this.element = t, this.view = r, this.updateDelay = u, c && (this.shouldShow = c), this.element.addEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.addEventListener("dragstart", this.dragstartHandler), this.editor.on("focus", this.focusHandler), this.editor.on("blur", this.blurHandler), this.tippyOptions = o, this.element.remove(), this.element.style.visibility = "visible";
  }
  createTooltip() {
    const { element: e } = this.editor.options, t = !!e.parentElement;
    this.tippy || !t || (this.tippy = So(e, {
      duration: 0,
      getReferenceClientRect: null,
      content: this.element,
      interactive: !0,
      trigger: "manual",
      placement: "top",
      hideOnClick: "toggle",
      ...this.tippyOptions
    }), this.tippy.popper.firstChild && this.tippy.popper.firstChild.addEventListener("blur", this.tippyBlurHandler));
  }
  update(e, t) {
    const { state: r } = e, o = r.selection.$from.pos !== r.selection.$to.pos;
    if (this.updateDelay > 0 && o) {
      this.handleDebouncedUpdate(e, t);
      return;
    }
    const u = !(t != null && t.selection.eq(e.state.selection)), c = !(t != null && t.doc.eq(e.state.doc));
    this.updateHandler(e, u, c, t);
  }
  show() {
    var e;
    (e = this.tippy) === null || e === void 0 || e.show();
  }
  hide() {
    var e;
    (e = this.tippy) === null || e === void 0 || e.hide();
  }
  destroy() {
    var e, t;
    !((e = this.tippy) === null || e === void 0) && e.popper.firstChild && this.tippy.popper.firstChild.removeEventListener("blur", this.tippyBlurHandler), (t = this.tippy) === null || t === void 0 || t.destroy(), this.element.removeEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.removeEventListener("dragstart", this.dragstartHandler), this.editor.off("focus", this.focusHandler), this.editor.off("blur", this.blurHandler);
  }
}
const k_ = (n) => new tr({
  key: typeof n.pluginKey == "string" ? new zr(n.pluginKey) : n.pluginKey,
  view: (e) => new p1({ view: e, ...n })
});
Xn.create({
  name: "bubbleMenu",
  addOptions() {
    return {
      element: null,
      tippyOptions: {},
      pluginKey: "bubbleMenu",
      updateDelay: void 0,
      shouldShow: null
    };
  },
  addProseMirrorPlugins() {
    return this.options.element ? [
      k_({
        pluginKey: this.options.pluginKey,
        editor: this.editor,
        element: this.options.element,
        tippyOptions: this.options.tippyOptions,
        updateDelay: this.options.updateDelay,
        shouldShow: this.options.shouldShow
      })
    ] : [];
  }
});
class m1 {
  constructor({ editor: e, element: t, view: r, tippyOptions: o = {}, shouldShow: u }) {
    this.preventHide = !1, this.shouldShow = ({ view: c, state: l }) => {
      const { selection: i } = l, { $anchor: h, empty: f } = i, p = h.depth === 1, d = h.parent.isTextblock && !h.parent.type.spec.code && !h.parent.textContent;
      return !(!c.hasFocus() || !f || !p || !d || !this.editor.isEditable);
    }, this.mousedownHandler = () => {
      this.preventHide = !0;
    }, this.focusHandler = () => {
      setTimeout(() => this.update(this.editor.view));
    }, this.blurHandler = ({ event: c }) => {
      var l;
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      c != null && c.relatedTarget && (!((l = this.element.parentNode) === null || l === void 0) && l.contains(c.relatedTarget)) || this.hide();
    }, this.tippyBlurHandler = (c) => {
      this.blurHandler({ event: c });
    }, this.editor = e, this.element = t, this.view = r, u && (this.shouldShow = u), this.element.addEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.editor.on("focus", this.focusHandler), this.editor.on("blur", this.blurHandler), this.tippyOptions = o, this.element.remove(), this.element.style.visibility = "visible";
  }
  createTooltip() {
    const { element: e } = this.editor.options, t = !!e.parentElement;
    this.tippy || !t || (this.tippy = So(e, {
      duration: 0,
      getReferenceClientRect: null,
      content: this.element,
      interactive: !0,
      trigger: "manual",
      placement: "right",
      hideOnClick: "toggle",
      ...this.tippyOptions
    }), this.tippy.popper.firstChild && this.tippy.popper.firstChild.addEventListener("blur", this.tippyBlurHandler));
  }
  update(e, t) {
    var r, o, u;
    const { state: c } = e, { doc: l, selection: i } = c, { from: h, to: f } = i;
    if (t && t.doc.eq(l) && t.selection.eq(i))
      return;
    if (this.createTooltip(), !((r = this.shouldShow) === null || r === void 0 ? void 0 : r.call(this, {
      editor: this.editor,
      view: e,
      state: c,
      oldState: t
    }))) {
      this.hide();
      return;
    }
    (o = this.tippy) === null || o === void 0 || o.setProps({
      getReferenceClientRect: ((u = this.tippyOptions) === null || u === void 0 ? void 0 : u.getReferenceClientRect) || (() => R_(e, h, f))
    }), this.show();
  }
  show() {
    var e;
    (e = this.tippy) === null || e === void 0 || e.show();
  }
  hide() {
    var e;
    (e = this.tippy) === null || e === void 0 || e.hide();
  }
  destroy() {
    var e, t;
    !((e = this.tippy) === null || e === void 0) && e.popper.firstChild && this.tippy.popper.firstChild.removeEventListener("blur", this.tippyBlurHandler), (t = this.tippy) === null || t === void 0 || t.destroy(), this.element.removeEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.editor.off("focus", this.focusHandler), this.editor.off("blur", this.blurHandler);
  }
}
const K_ = (n) => new tr({
  key: typeof n.pluginKey == "string" ? new zr(n.pluginKey) : n.pluginKey,
  view: (e) => new m1({ view: e, ...n })
});
Xn.create({
  name: "floatingMenu",
  addOptions() {
    return {
      element: null,
      tippyOptions: {},
      pluginKey: "floatingMenu",
      shouldShow: null
    };
  },
  addProseMirrorPlugins() {
    return this.options.element ? [
      K_({
        pluginKey: this.options.pluginKey,
        editor: this.editor,
        element: this.options.element,
        tippyOptions: this.options.tippyOptions,
        shouldShow: this.options.shouldShow
      })
    ] : [];
  }
});
Dt({
  name: "BubbleMenu",
  props: {
    pluginKey: {
      type: [String, Object],
      default: "bubbleMenu"
    },
    editor: {
      type: Object,
      required: !0
    },
    updateDelay: {
      type: Number,
      default: void 0
    },
    tippyOptions: {
      type: Object,
      default: () => ({})
    },
    shouldShow: {
      type: Function,
      default: null
    }
  },
  setup(n, { slots: e }) {
    const t = st(null);
    return ln(() => {
      const { updateDelay: r, editor: o, pluginKey: u, shouldShow: c, tippyOptions: l } = n;
      o.registerPlugin(k_({
        updateDelay: r,
        editor: o,
        element: t.value,
        pluginKey: u,
        shouldShow: c,
        tippyOptions: l
      }));
    }), oi(() => {
      const { pluginKey: r, editor: o } = n;
      o.unregisterPlugin(r);
    }), () => {
      var r;
      return na("div", { ref: t }, (r = e.default) === null || r === void 0 ? void 0 : r.call(e));
    };
  }
});
function cm(n) {
  return jE((e, t) => ({
    get() {
      return e(), n;
    },
    set(r) {
      n = r, requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          t();
        });
      });
    }
  }));
}
class g1 extends Uw {
  constructor(e = {}) {
    return super(e), this.vueRenderers = Ul(/* @__PURE__ */ new Map()), this.contentComponent = null, this.reactiveState = cm(this.view.state), this.reactiveExtensionStorage = cm(this.extensionStorage), this.on("transaction", () => {
      this.reactiveState.value = this.view.state, this.reactiveExtensionStorage.value = this.extensionStorage;
    }), Am(this);
  }
  get state() {
    return this.reactiveState ? this.reactiveState.value : this.view.state;
  }
  get storage() {
    return this.reactiveExtensionStorage ? this.reactiveExtensionStorage.value : super.storage;
  }
  /**
   * Register a ProseMirror plugin.
   */
  registerPlugin(e, t) {
    super.registerPlugin(e, t), this.reactiveState.value = this.view.state;
  }
  /**
   * Unregister a ProseMirror plugin.
   */
  unregisterPlugin(e) {
    super.unregisterPlugin(e), this.reactiveState.value = this.view.state;
  }
}
const v1 = Dt({
  name: "EditorContent",
  props: {
    editor: {
      default: null,
      type: Object
    }
  },
  setup(n) {
    const e = st(), t = UE();
    return kE(() => {
      const r = n.editor;
      r && r.options.element && e.value && lr(() => {
        if (!e.value || !r.options.element.firstChild)
          return;
        const o = Ye(e.value);
        e.value.append(...r.options.element.childNodes), r.contentComponent = t.ctx._, r.setOptions({
          element: o
        }), r.createNodeViews();
      });
    }), oi(() => {
      const r = n.editor;
      if (!r || (r.isDestroyed || r.view.setProps({
        nodeViews: {}
      }), r.contentComponent = null, !r.options.element.firstChild))
        return;
      const o = document.createElement("div");
      o.append(...r.options.element.childNodes), r.setOptions({
        element: o
      });
    }), { rootEl: e };
  },
  render() {
    const n = [];
    return this.editor && this.editor.vueRenderers.forEach((e) => {
      const t = na(Tf, {
        to: e.teleportElement,
        key: e.id
      }, na(e.component, {
        ref: e.id,
        ...e.props
      }));
      n.push(t);
    }), na("div", {
      ref: (e) => {
        this.rootEl = e;
      }
    }, ...n);
  }
});
Dt({
  name: "FloatingMenu",
  props: {
    pluginKey: {
      // TODO: TypeScript breaks :(
      // type: [String, Object as PropType<Exclude<FloatingMenuPluginProps['pluginKey'], string>>],
      type: null,
      default: "floatingMenu"
    },
    editor: {
      type: Object,
      required: !0
    },
    tippyOptions: {
      type: Object,
      default: () => ({})
    },
    shouldShow: {
      type: Function,
      default: null
    }
  },
  setup(n, { slots: e }) {
    const t = st(null);
    return ln(() => {
      const { pluginKey: r, editor: o, tippyOptions: u, shouldShow: c } = n;
      o.registerPlugin(K_({
        pluginKey: r,
        editor: o,
        element: t.value,
        tippyOptions: u,
        shouldShow: c
      }));
    }), oi(() => {
      const { pluginKey: r, editor: o } = n;
      o.unregisterPlugin(r);
    }), () => {
      var r;
      return na("div", { ref: t }, (r = e.default) === null || r === void 0 ? void 0 : r.call(e));
    };
  }
});
Dt({
  name: "NodeViewContent",
  props: {
    as: {
      type: String,
      default: "div"
    }
  },
  render() {
    return na(this.as, {
      style: {
        whiteSpace: "pre-wrap"
      },
      "data-node-view-content": ""
    });
  }
});
Dt({
  name: "NodeViewWrapper",
  props: {
    as: {
      type: String,
      default: "div"
    }
  },
  inject: ["onDragStart", "decorationClasses"],
  render() {
    var n, e;
    return na(this.as, {
      // @ts-ignore
      class: this.decorationClasses,
      style: {
        whiteSpace: "normal"
      },
      "data-node-view-wrapper": "",
      // @ts-ignore (https://github.com/vuejs/vue-next/issues/3031)
      onDragstart: this.onDragStart
    }, (e = (n = this.$slots).default) === null || e === void 0 ? void 0 : e.call(n));
  }
});
const _1 = (n = {}) => {
  const e = KE();
  return ln(() => {
    e.value = new g1(n);
  }), oi(() => {
    var t;
    (t = e.value) === null || t === void 0 || t.destroy();
  }), e;
}, E1 = /^\s*>\s$/, y1 = ur.create({
  name: "blockquote",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  group: "block",
  defining: !0,
  parseHTML() {
    return [
      { tag: "blockquote" }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["blockquote", Rn(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setBlockquote: () => ({ commands: n }) => n.wrapIn(this.name),
      toggleBlockquote: () => ({ commands: n }) => n.toggleWrap(this.name),
      unsetBlockquote: () => ({ commands: n }) => n.lift(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-b": () => this.editor.commands.toggleBlockquote()
    };
  },
  addInputRules() {
    return [
      Es({
        find: E1,
        type: this.type
      })
    ];
  }
}), T1 = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/, A1 = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g, S1 = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/, C1 = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g, M1 = Hr.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (n) => n.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight",
        getAttrs: (n) => /^(bold(er)?|[5-9]\d{2,})$/.test(n) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["strong", Rn(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setBold: () => ({ commands: n }) => n.setMark(this.name),
      toggleBold: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetBold: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      fo({
        find: T1,
        type: this.type
      }),
      fo({
        find: S1,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      ho({
        find: A1,
        type: this.type
      }),
      ho({
        find: C1,
        type: this.type
      })
    ];
  }
}), b1 = ur.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["li", Rn(this.options.HTMLAttributes, n), 0];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), fm = Hr.create({
  name: "textStyle",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        getAttrs: (n) => n.hasAttribute("style") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["span", Rn(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      removeEmptyTextStyle: () => ({ state: n, commands: e }) => {
        const t = cu(n, this.type);
        return Object.entries(t).some(([, o]) => !!o) ? !0 : e.unsetMark(this.name);
      }
    };
  }
}), dm = /^\s*([-+*])\s$/, R1 = ur.create({
  name: "bulletList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [
      { tag: "ul" }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["ul", Rn(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      toggleBulletList: () => ({ commands: n, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(b1.name, this.editor.getAttributes(fm.name)).run() : n.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-8": () => this.editor.commands.toggleBulletList()
    };
  },
  addInputRules() {
    let n = Es({
      find: dm,
      type: this.type
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (n = Es({
      find: dm,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: () => this.editor.getAttributes(fm.name),
      editor: this.editor
    })), [
      n
    ];
  }
}), D1 = /(?:^|\s)(`(?!\s+`)((?:[^`]+))`(?!\s+`))$/, O1 = /(?:^|\s)(`(?!\s+`)((?:[^`]+))`(?!\s+`))/g, P1 = Hr.create({
  name: "code",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  excludes: "_",
  code: !0,
  exitable: !0,
  parseHTML() {
    return [
      { tag: "code" }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["code", Rn(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setCode: () => ({ commands: n }) => n.setMark(this.name),
      toggleCode: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetCode: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-e": () => this.editor.commands.toggleCode()
    };
  },
  addInputRules() {
    return [
      fo({
        find: D1,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      ho({
        find: O1,
        type: this.type
      })
    ];
  }
}), I1 = /^```([a-z]+)?[\s\n]$/, N1 = /^~~~([a-z]+)?[\s\n]$/, L1 = ur.create({
  name: "codeBlock",
  addOptions() {
    return {
      languageClassPrefix: "language-",
      exitOnTripleEnter: !0,
      exitOnArrowDown: !0,
      HTMLAttributes: {}
    };
  },
  content: "text*",
  marks: "",
  group: "block",
  code: !0,
  defining: !0,
  addAttributes() {
    return {
      language: {
        default: null,
        parseHTML: (n) => {
          var e;
          const { languageClassPrefix: t } = this.options, u = [...((e = n.firstElementChild) === null || e === void 0 ? void 0 : e.classList) || []].filter((c) => c.startsWith(t)).map((c) => c.replace(t, ""))[0];
          return u || null;
        },
        rendered: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "pre",
        preserveWhitespace: "full"
      }
    ];
  },
  renderHTML({ node: n, HTMLAttributes: e }) {
    return [
      "pre",
      Rn(this.options.HTMLAttributes, e),
      [
        "code",
        {
          class: n.attrs.language ? this.options.languageClassPrefix + n.attrs.language : null
        },
        0
      ]
    ];
  },
  addCommands() {
    return {
      setCodeBlock: (n) => ({ commands: e }) => e.setNode(this.name, n),
      toggleCodeBlock: (n) => ({ commands: e }) => e.toggleNode(this.name, "paragraph", n)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-c": () => this.editor.commands.toggleCodeBlock(),
      // remove code block when at start of document or code block is empty
      Backspace: () => {
        const { empty: n, $anchor: e } = this.editor.state.selection, t = e.pos === 1;
        return !n || e.parent.type.name !== this.name ? !1 : t || !e.parent.textContent.length ? this.editor.commands.clearNodes() : !1;
      },
      // exit node on triple enter
      Enter: ({ editor: n }) => {
        if (!this.options.exitOnTripleEnter)
          return !1;
        const { state: e } = n, { selection: t } = e, { $from: r, empty: o } = t;
        if (!o || r.parent.type !== this.type)
          return !1;
        const u = r.parentOffset === r.parent.nodeSize - 2, c = r.parent.textContent.endsWith(`

`);
        return !u || !c ? !1 : n.chain().command(({ tr: l }) => (l.delete(r.pos - 2, r.pos), !0)).exitCode().run();
      },
      // exit node on arrow down
      ArrowDown: ({ editor: n }) => {
        if (!this.options.exitOnArrowDown)
          return !1;
        const { state: e } = n, { selection: t, doc: r } = e, { $from: o, empty: u } = t;
        if (!u || o.parent.type !== this.type || !(o.parentOffset === o.parent.nodeSize - 2))
          return !1;
        const l = o.after();
        return l === void 0 || r.nodeAt(l) ? !1 : n.commands.exitCode();
      }
    };
  },
  addInputRules() {
    return [
      df({
        find: I1,
        type: this.type,
        getAttributes: (n) => ({
          language: n[1]
        })
      }),
      df({
        find: N1,
        type: this.type,
        getAttributes: (n) => ({
          language: n[1]
        })
      })
    ];
  },
  addProseMirrorPlugins() {
    return [
      // this plugin creates a code block for pasted content from VS Code
      // we can also detect the copied code language
      new tr({
        key: new zr("codeBlockVSCodeHandler"),
        props: {
          handlePaste: (n, e) => {
            if (!e.clipboardData || this.editor.isActive(this.type.name))
              return !1;
            const t = e.clipboardData.getData("text/plain"), r = e.clipboardData.getData("vscode-editor-data"), o = r ? JSON.parse(r) : void 0, u = o == null ? void 0 : o.mode;
            if (!t || !u)
              return !1;
            const { tr: c } = n.state;
            return n.state.selection.from === n.state.doc.nodeSize - (1 + n.state.selection.$to.depth * 2) ? c.insert(n.state.selection.from - 1, this.type.create({ language: u })) : c.replaceSelectionWith(this.type.create({ language: u })), c.setSelection(Zt.near(c.doc.resolve(Math.max(0, c.selection.from - 2)))), c.insertText(t.replace(/\r\n?/g, `
`)), c.setMeta("paste", !0), n.dispatch(c), !0;
          }
        }
      })
    ];
  }
}), w1 = ur.create({
  name: "doc",
  topNode: !0,
  content: "block+"
});
function x1(n = {}) {
  return new tr({
    view(e) {
      return new B1(e, n);
    }
  });
}
class B1 {
  constructor(e, t) {
    var r;
    this.editorView = e, this.cursorPos = null, this.element = null, this.timeout = -1, this.width = (r = t.width) !== null && r !== void 0 ? r : 1, this.color = t.color === !1 ? void 0 : t.color || "black", this.class = t.class, this.handlers = ["dragover", "dragend", "drop", "dragleave"].map((o) => {
      let u = (c) => {
        this[o](c);
      };
      return e.dom.addEventListener(o, u), { name: o, handler: u };
    });
  }
  destroy() {
    this.handlers.forEach(({ name: e, handler: t }) => this.editorView.dom.removeEventListener(e, t));
  }
  update(e, t) {
    this.cursorPos != null && t.doc != e.state.doc && (this.cursorPos > e.state.doc.content.size ? this.setCursor(null) : this.updateOverlay());
  }
  setCursor(e) {
    e != this.cursorPos && (this.cursorPos = e, e == null ? (this.element.parentNode.removeChild(this.element), this.element = null) : this.updateOverlay());
  }
  updateOverlay() {
    let e = this.editorView.state.doc.resolve(this.cursorPos), t = !e.parent.inlineContent, r;
    if (t) {
      let l = e.nodeBefore, i = e.nodeAfter;
      if (l || i) {
        let h = this.editorView.nodeDOM(this.cursorPos - (l ? l.nodeSize : 0));
        if (h) {
          let f = h.getBoundingClientRect(), p = l ? f.bottom : f.top;
          l && i && (p = (p + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2), r = { left: f.left, right: f.right, top: p - this.width / 2, bottom: p + this.width / 2 };
        }
      }
    }
    if (!r) {
      let l = this.editorView.coordsAtPos(this.cursorPos);
      r = { left: l.left - this.width / 2, right: l.left + this.width / 2, top: l.top, bottom: l.bottom };
    }
    let o = this.editorView.dom.offsetParent;
    this.element || (this.element = o.appendChild(document.createElement("div")), this.class && (this.element.className = this.class), this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", this.color && (this.element.style.backgroundColor = this.color)), this.element.classList.toggle("prosemirror-dropcursor-block", t), this.element.classList.toggle("prosemirror-dropcursor-inline", !t);
    let u, c;
    if (!o || o == document.body && getComputedStyle(o).position == "static")
      u = -pageXOffset, c = -pageYOffset;
    else {
      let l = o.getBoundingClientRect();
      u = l.left - o.scrollLeft, c = l.top - o.scrollTop;
    }
    this.element.style.left = r.left - u + "px", this.element.style.top = r.top - c + "px", this.element.style.width = r.right - r.left + "px", this.element.style.height = r.bottom - r.top + "px";
  }
  scheduleRemoval(e) {
    clearTimeout(this.timeout), this.timeout = setTimeout(() => this.setCursor(null), e);
  }
  dragover(e) {
    if (!this.editorView.editable)
      return;
    let t = this.editorView.posAtCoords({ left: e.clientX, top: e.clientY }), r = t && t.inside >= 0 && this.editorView.state.doc.nodeAt(t.inside), o = r && r.type.spec.disableDropCursor, u = typeof o == "function" ? o(this.editorView, t, e) : o;
    if (t && !u) {
      let c = t.pos;
      if (this.editorView.dragging && this.editorView.dragging.slice) {
        let l = Mv(this.editorView.state.doc, c, this.editorView.dragging.slice);
        l != null && (c = l);
      }
      this.setCursor(c), this.scheduleRemoval(5e3);
    }
  }
  dragend() {
    this.scheduleRemoval(20);
  }
  drop() {
    this.scheduleRemoval(20);
  }
  dragleave(e) {
    (e.target == this.editorView.dom || !this.editorView.dom.contains(e.relatedTarget)) && this.setCursor(null);
  }
}
const F1 = Xn.create({
  name: "dropCursor",
  addOptions() {
    return {
      color: "currentColor",
      width: 1,
      class: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      x1(this.options)
    ];
  }
});
class En extends en {
  /**
  Create a gap cursor.
  */
  constructor(e) {
    super(e, e);
  }
  map(e, t) {
    let r = e.resolve(t.map(this.head));
    return En.valid(r) ? new En(r) : en.near(r);
  }
  content() {
    return Lt.empty;
  }
  eq(e) {
    return e instanceof En && e.head == this.head;
  }
  toJSON() {
    return { type: "gapcursor", pos: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for GapCursor.fromJSON");
    return new En(e.resolve(t.pos));
  }
  /**
  @internal
  */
  getBookmark() {
    return new Nd(this.anchor);
  }
  /**
  @internal
  */
  static valid(e) {
    let t = e.parent;
    if (t.isTextblock || !U1(e) || !k1(e))
      return !1;
    let r = t.type.spec.allowGapCursor;
    if (r != null)
      return r;
    let o = t.contentMatchAt(e.index()).defaultType;
    return o && o.isTextblock;
  }
  /**
  @internal
  */
  static findGapCursorFrom(e, t, r = !1) {
    e:
      for (; ; ) {
        if (!r && En.valid(e))
          return e;
        let o = e.pos, u = null;
        for (let c = e.depth; ; c--) {
          let l = e.node(c);
          if (t > 0 ? e.indexAfter(c) < l.childCount : e.index(c) > 0) {
            u = l.child(t > 0 ? e.indexAfter(c) : e.index(c) - 1);
            break;
          } else if (c == 0)
            return null;
          o += t;
          let i = e.doc.resolve(o);
          if (En.valid(i))
            return i;
        }
        for (; ; ) {
          let c = t > 0 ? u.firstChild : u.lastChild;
          if (!c) {
            if (u.isAtom && !u.isText && !$t.isSelectable(u)) {
              e = e.doc.resolve(o + u.nodeSize * t), r = !1;
              continue e;
            }
            break;
          }
          u = c, o += t;
          let l = e.doc.resolve(o);
          if (En.valid(l))
            return l;
        }
        return null;
      }
  }
}
En.prototype.visible = !1;
En.findFrom = En.findGapCursorFrom;
en.jsonID("gapcursor", En);
class Nd {
  constructor(e) {
    this.pos = e;
  }
  map(e) {
    return new Nd(e.map(this.pos));
  }
  resolve(e) {
    let t = e.resolve(this.pos);
    return En.valid(t) ? new En(t) : en.near(t);
  }
}
function U1(n) {
  for (let e = n.depth; e >= 0; e--) {
    let t = n.index(e), r = n.node(e);
    if (t == 0) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let o = r.child(t - 1); ; o = o.lastChild) {
      if (o.childCount == 0 && !o.inlineContent || o.isAtom || o.type.spec.isolating)
        return !0;
      if (o.inlineContent)
        return !1;
    }
  }
  return !0;
}
function k1(n) {
  for (let e = n.depth; e >= 0; e--) {
    let t = n.indexAfter(e), r = n.node(e);
    if (t == r.childCount) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let o = r.child(t); ; o = o.firstChild) {
      if (o.childCount == 0 && !o.inlineContent || o.isAtom || o.type.spec.isolating)
        return !0;
      if (o.inlineContent)
        return !1;
    }
  }
  return !0;
}
function K1() {
  return new tr({
    props: {
      decorations: H1,
      createSelectionBetween(n, e, t) {
        return e.pos == t.pos && En.valid(t) ? new En(t) : null;
      },
      handleClick: W1,
      handleKeyDown: j1,
      handleDOMEvents: { beforeinput: V1 }
    }
  });
}
const j1 = f_({
  ArrowLeft: rl("horiz", -1),
  ArrowRight: rl("horiz", 1),
  ArrowUp: rl("vert", -1),
  ArrowDown: rl("vert", 1)
});
function rl(n, e) {
  const t = n == "vert" ? e > 0 ? "down" : "up" : e > 0 ? "right" : "left";
  return function(r, o, u) {
    let c = r.selection, l = e > 0 ? c.$to : c.$from, i = c.empty;
    if (c instanceof Zt) {
      if (!u.endOfTextblock(t) || l.depth == 0)
        return !1;
      i = !1, l = r.doc.resolve(e > 0 ? l.after() : l.before());
    }
    let h = En.findGapCursorFrom(l, e, i);
    return h ? (o && o(r.tr.setSelection(new En(h))), !0) : !1;
  };
}
function W1(n, e, t) {
  if (!n || !n.editable)
    return !1;
  let r = n.state.doc.resolve(e);
  if (!En.valid(r))
    return !1;
  let o = n.posAtCoords({ left: t.clientX, top: t.clientY });
  return o && o.inside > -1 && $t.isSelectable(n.state.doc.nodeAt(o.inside)) ? !1 : (n.dispatch(n.state.tr.setSelection(new En(r))), !0);
}
function V1(n, e) {
  if (e.inputType != "insertCompositionText" || !(n.state.selection instanceof En))
    return !1;
  let { $from: t } = n.state.selection, r = t.parent.contentMatchAt(t.index()).findWrapping(n.state.schema.nodes.text);
  if (!r)
    return !1;
  let o = Tt.empty;
  for (let c = r.length - 1; c >= 0; c--)
    o = Tt.from(r[c].createAndFill(null, o));
  let u = n.state.tr.replace(t.pos, t.pos, new Lt(o, 0, 0));
  return u.setSelection(Zt.near(u.doc.resolve(t.pos + 1))), n.dispatch(u), !1;
}
function H1(n) {
  if (!(n.selection instanceof En))
    return null;
  let e = document.createElement("div");
  return e.className = "ProseMirror-gapcursor", bn.create(n.doc, [pr.widget(n.selection.head, e, { key: "gapcursor" })]);
}
const $1 = Xn.create({
  name: "gapCursor",
  addProseMirrorPlugins() {
    return [
      K1()
    ];
  },
  extendNodeSchema(n) {
    var e;
    const t = {
      name: n.name,
      options: n.options,
      storage: n.storage
    };
    return {
      allowGapCursor: (e = qt(Bt(n, "allowGapCursor", t))) !== null && e !== void 0 ? e : null
    };
  }
}), G1 = ur.create({
  name: "hardBreak",
  addOptions() {
    return {
      keepMarks: !0,
      HTMLAttributes: {}
    };
  },
  inline: !0,
  group: "inline",
  selectable: !1,
  parseHTML() {
    return [
      { tag: "br" }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["br", Rn(this.options.HTMLAttributes, n)];
  },
  renderText() {
    return `
`;
  },
  addCommands() {
    return {
      setHardBreak: () => ({ commands: n, chain: e, state: t, editor: r }) => n.first([
        () => n.exitCode(),
        () => n.command(() => {
          const { selection: o, storedMarks: u } = t;
          if (o.$from.parent.type.spec.isolating)
            return !1;
          const { keepMarks: c } = this.options, { splittableMarks: l } = r.extensionManager, i = u || o.$to.parentOffset && o.$from.marks();
          return e().insertContent({ type: this.name }).command(({ tr: h, dispatch: f }) => {
            if (f && i && c) {
              const p = i.filter((d) => l.includes(d.type.name));
              h.ensureMarks(p);
            }
            return !0;
          }).run();
        })
      ])
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => this.editor.commands.setHardBreak(),
      "Shift-Enter": () => this.editor.commands.setHardBreak()
    };
  }
}), z1 = ur.create({
  name: "heading",
  addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: "inline*",
  group: "block",
  defining: !0,
  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: !1
      }
    };
  },
  parseHTML() {
    return this.options.levels.map((n) => ({
      tag: `h${n}`,
      attrs: { level: n }
    }));
  },
  renderHTML({ node: n, HTMLAttributes: e }) {
    return [`h${this.options.levels.includes(n.attrs.level) ? n.attrs.level : this.options.levels[0]}`, Rn(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setHeading: (n) => ({ commands: e }) => this.options.levels.includes(n.level) ? e.setNode(this.name, n) : !1,
      toggleHeading: (n) => ({ commands: e }) => this.options.levels.includes(n.level) ? e.toggleNode(this.name, "paragraph", n) : !1
    };
  },
  addKeyboardShortcuts() {
    return this.options.levels.reduce((n, e) => ({
      ...n,
      [`Mod-Alt-${e}`]: () => this.editor.commands.toggleHeading({ level: e })
    }), {});
  },
  addInputRules() {
    return this.options.levels.map((n) => df({
      find: new RegExp(`^(#{1,${n}})\\s$`),
      type: this.type,
      getAttributes: {
        level: n
      }
    }));
  }
});
var Fl = 200, Nn = function() {
};
Nn.prototype.append = function(e) {
  return e.length ? (e = Nn.from(e), !this.length && e || e.length < Fl && this.leafAppend(e) || this.length < Fl && e.leafPrepend(this) || this.appendInner(e)) : this;
};
Nn.prototype.prepend = function(e) {
  return e.length ? Nn.from(e).append(this) : this;
};
Nn.prototype.appendInner = function(e) {
  return new Y1(this, e);
};
Nn.prototype.slice = function(e, t) {
  return e === void 0 && (e = 0), t === void 0 && (t = this.length), e >= t ? Nn.empty : this.sliceInner(Math.max(0, e), Math.min(this.length, t));
};
Nn.prototype.get = function(e) {
  if (!(e < 0 || e >= this.length))
    return this.getInner(e);
};
Nn.prototype.forEach = function(e, t, r) {
  t === void 0 && (t = 0), r === void 0 && (r = this.length), t <= r ? this.forEachInner(e, t, r, 0) : this.forEachInvertedInner(e, t, r, 0);
};
Nn.prototype.map = function(e, t, r) {
  t === void 0 && (t = 0), r === void 0 && (r = this.length);
  var o = [];
  return this.forEach(function(u, c) {
    return o.push(e(u, c));
  }, t, r), o;
};
Nn.from = function(e) {
  return e instanceof Nn ? e : e && e.length ? new j_(e) : Nn.empty;
};
var j_ = /* @__PURE__ */ function(n) {
  function e(r) {
    n.call(this), this.values = r;
  }
  n && (e.__proto__ = n), e.prototype = Object.create(n && n.prototype), e.prototype.constructor = e;
  var t = { length: { configurable: !0 }, depth: { configurable: !0 } };
  return e.prototype.flatten = function() {
    return this.values;
  }, e.prototype.sliceInner = function(o, u) {
    return o == 0 && u == this.length ? this : new e(this.values.slice(o, u));
  }, e.prototype.getInner = function(o) {
    return this.values[o];
  }, e.prototype.forEachInner = function(o, u, c, l) {
    for (var i = u; i < c; i++)
      if (o(this.values[i], l + i) === !1)
        return !1;
  }, e.prototype.forEachInvertedInner = function(o, u, c, l) {
    for (var i = u - 1; i >= c; i--)
      if (o(this.values[i], l + i) === !1)
        return !1;
  }, e.prototype.leafAppend = function(o) {
    if (this.length + o.length <= Fl)
      return new e(this.values.concat(o.flatten()));
  }, e.prototype.leafPrepend = function(o) {
    if (this.length + o.length <= Fl)
      return new e(o.flatten().concat(this.values));
  }, t.length.get = function() {
    return this.values.length;
  }, t.depth.get = function() {
    return 0;
  }, Object.defineProperties(e.prototype, t), e;
}(Nn);
Nn.empty = new j_([]);
var Y1 = /* @__PURE__ */ function(n) {
  function e(t, r) {
    n.call(this), this.left = t, this.right = r, this.length = t.length + r.length, this.depth = Math.max(t.depth, r.depth) + 1;
  }
  return n && (e.__proto__ = n), e.prototype = Object.create(n && n.prototype), e.prototype.constructor = e, e.prototype.flatten = function() {
    return this.left.flatten().concat(this.right.flatten());
  }, e.prototype.getInner = function(r) {
    return r < this.left.length ? this.left.get(r) : this.right.get(r - this.left.length);
  }, e.prototype.forEachInner = function(r, o, u, c) {
    var l = this.left.length;
    if (o < l && this.left.forEachInner(r, o, Math.min(u, l), c) === !1 || u > l && this.right.forEachInner(r, Math.max(o - l, 0), Math.min(this.length, u) - l, c + l) === !1)
      return !1;
  }, e.prototype.forEachInvertedInner = function(r, o, u, c) {
    var l = this.left.length;
    if (o > l && this.right.forEachInvertedInner(r, o - l, Math.max(u, l) - l, c + l) === !1 || u < l && this.left.forEachInvertedInner(r, Math.min(o, l), u, c) === !1)
      return !1;
  }, e.prototype.sliceInner = function(r, o) {
    if (r == 0 && o == this.length)
      return this;
    var u = this.left.length;
    return o <= u ? this.left.slice(r, o) : r >= u ? this.right.slice(r - u, o - u) : this.left.slice(r, u).append(this.right.slice(0, o - u));
  }, e.prototype.leafAppend = function(r) {
    var o = this.right.leafAppend(r);
    if (o)
      return new e(this.left, o);
  }, e.prototype.leafPrepend = function(r) {
    var o = this.left.leafPrepend(r);
    if (o)
      return new e(o, this.right);
  }, e.prototype.appendInner = function(r) {
    return this.left.depth >= Math.max(this.right.depth, r.depth) + 1 ? new e(this.left, new e(this.right, r)) : new e(this, r);
  }, e;
}(Nn);
const X1 = 500;
class Ar {
  constructor(e, t) {
    this.items = e, this.eventCount = t;
  }
  // Pop the latest event off the branch's history and apply it
  // to a document transform.
  popEvent(e, t) {
    if (this.eventCount == 0)
      return null;
    let r = this.items.length;
    for (; ; r--)
      if (this.items.get(r - 1).selection) {
        --r;
        break;
      }
    let o, u;
    t && (o = this.remapping(r, this.items.length), u = o.maps.length);
    let c = e.tr, l, i, h = [], f = [];
    return this.items.forEach((p, d) => {
      if (!p.step) {
        o || (o = this.remapping(r, d + 1), u = o.maps.length), u--, f.push(p);
        return;
      }
      if (o) {
        f.push(new wr(p.map));
        let v = p.step.map(o.slice(u)), g;
        v && c.maybeStep(v).doc && (g = c.mapping.maps[c.mapping.maps.length - 1], h.push(new wr(g, void 0, void 0, h.length + f.length))), u--, g && o.appendMap(g, u);
      } else
        c.maybeStep(p.step);
      if (p.selection)
        return l = o ? p.selection.map(o.slice(u)) : p.selection, i = new Ar(this.items.slice(0, r).append(f.reverse().concat(h)), this.eventCount - 1), !1;
    }, this.items.length, 0), { remaining: i, transform: c, selection: l };
  }
  // Create a new branch with the given transform added.
  addTransform(e, t, r, o) {
    let u = [], c = this.eventCount, l = this.items, i = !o && l.length ? l.get(l.length - 1) : null;
    for (let f = 0; f < e.steps.length; f++) {
      let p = e.steps[f].invert(e.docs[f]), d = new wr(e.mapping.maps[f], p, t), v;
      (v = i && i.merge(d)) && (d = v, f ? u.pop() : l = l.slice(0, l.length - 1)), u.push(d), t && (c++, t = void 0), o || (i = d);
    }
    let h = c - r.depth;
    return h > J1 && (l = Q1(l, h), c -= h), new Ar(l.append(u), c);
  }
  remapping(e, t) {
    let r = new Ga();
    return this.items.forEach((o, u) => {
      let c = o.mirrorOffset != null && u - o.mirrorOffset >= e ? r.maps.length - o.mirrorOffset : void 0;
      r.appendMap(o.map, c);
    }, e, t), r;
  }
  addMaps(e) {
    return this.eventCount == 0 ? this : new Ar(this.items.append(e.map((t) => new wr(t))), this.eventCount);
  }
  // When the collab module receives remote changes, the history has
  // to know about those, so that it can adjust the steps that were
  // rebased on top of the remote changes, and include the position
  // maps for the remote changes in its array of items.
  rebased(e, t) {
    if (!this.eventCount)
      return this;
    let r = [], o = Math.max(0, this.items.length - t), u = e.mapping, c = e.steps.length, l = this.eventCount;
    this.items.forEach((d) => {
      d.selection && l--;
    }, o);
    let i = t;
    this.items.forEach((d) => {
      let v = u.getMirror(--i);
      if (v == null)
        return;
      c = Math.min(c, v);
      let g = u.maps[v];
      if (d.step) {
        let m = e.steps[v].invert(e.docs[v]), A = d.selection && d.selection.map(u.slice(i + 1, v));
        A && l++, r.push(new wr(g, m, A));
      } else
        r.push(new wr(g));
    }, o);
    let h = [];
    for (let d = t; d < c; d++)
      h.push(new wr(u.maps[d]));
    let f = this.items.slice(0, o).append(h).append(r), p = new Ar(f, l);
    return p.emptyItemCount() > X1 && (p = p.compress(this.items.length - r.length)), p;
  }
  emptyItemCount() {
    let e = 0;
    return this.items.forEach((t) => {
      t.step || e++;
    }), e;
  }
  // Compressing a branch means rewriting it to push the air (map-only
  // items) out. During collaboration, these naturally accumulate
  // because each remote change adds one. The `upto` argument is used
  // to ensure that only the items below a given level are compressed,
  // because `rebased` relies on a clean, untouched set of items in
  // order to associate old items with rebased steps.
  compress(e = this.items.length) {
    let t = this.remapping(0, e), r = t.maps.length, o = [], u = 0;
    return this.items.forEach((c, l) => {
      if (l >= e)
        o.push(c), c.selection && u++;
      else if (c.step) {
        let i = c.step.map(t.slice(r)), h = i && i.getMap();
        if (r--, h && t.appendMap(h, r), i) {
          let f = c.selection && c.selection.map(t.slice(r));
          f && u++;
          let p = new wr(h.invert(), i, f), d, v = o.length - 1;
          (d = o.length && o[v].merge(p)) ? o[v] = d : o.push(p);
        }
      } else
        c.map && r--;
    }, this.items.length, 0), new Ar(Nn.from(o.reverse()), u);
  }
}
Ar.empty = new Ar(Nn.empty, 0);
function Q1(n, e) {
  let t;
  return n.forEach((r, o) => {
    if (r.selection && e-- == 0)
      return t = o, !1;
  }), n.slice(t);
}
class wr {
  constructor(e, t, r, o) {
    this.map = e, this.step = t, this.selection = r, this.mirrorOffset = o;
  }
  merge(e) {
    if (this.step && e.step && !e.selection) {
      let t = e.step.merge(this.step);
      if (t)
        return new wr(t.getMap().invert(), t, this.selection);
    }
  }
}
class Ei {
  constructor(e, t, r, o, u) {
    this.done = e, this.undone = t, this.prevRanges = r, this.prevTime = o, this.prevComposition = u;
  }
}
const J1 = 20;
function Z1(n, e, t, r) {
  let o = t.getMeta(da), u;
  if (o)
    return o.historyState;
  t.getMeta(tx) && (n = new Ei(n.done, n.undone, null, 0, -1));
  let c = t.getMeta("appendedTransaction");
  if (t.steps.length == 0)
    return n;
  if (c && c.getMeta(da))
    return c.getMeta(da).redo ? new Ei(n.done.addTransform(t, void 0, r, sl(e)), n.undone, hm(t.mapping.maps[t.steps.length - 1]), n.prevTime, n.prevComposition) : new Ei(n.done, n.undone.addTransform(t, void 0, r, sl(e)), null, n.prevTime, n.prevComposition);
  if (t.getMeta("addToHistory") !== !1 && !(c && c.getMeta("addToHistory") === !1)) {
    let l = t.getMeta("composition"), i = n.prevTime == 0 || !c && n.prevComposition != l && (n.prevTime < (t.time || 0) - r.newGroupDelay || !q1(t, n.prevRanges)), h = c ? Ec(n.prevRanges, t.mapping) : hm(t.mapping.maps[t.steps.length - 1]);
    return new Ei(n.done.addTransform(t, i ? e.selection.getBookmark() : void 0, r, sl(e)), Ar.empty, h, t.time, l ?? n.prevComposition);
  } else
    return (u = t.getMeta("rebased")) ? new Ei(n.done.rebased(t, u), n.undone.rebased(t, u), Ec(n.prevRanges, t.mapping), n.prevTime, n.prevComposition) : new Ei(n.done.addMaps(t.mapping.maps), n.undone.addMaps(t.mapping.maps), Ec(n.prevRanges, t.mapping), n.prevTime, n.prevComposition);
}
function q1(n, e) {
  if (!e)
    return !1;
  if (!n.docChanged)
    return !0;
  let t = !1;
  return n.mapping.maps[0].forEach((r, o) => {
    for (let u = 0; u < e.length; u += 2)
      r <= e[u + 1] && o >= e[u] && (t = !0);
  }), t;
}
function hm(n) {
  let e = [];
  return n.forEach((t, r, o, u) => e.push(o, u)), e;
}
function Ec(n, e) {
  if (!n)
    return null;
  let t = [];
  for (let r = 0; r < n.length; r += 2) {
    let o = e.map(n[r], 1), u = e.map(n[r + 1], -1);
    o <= u && t.push(o, u);
  }
  return t;
}
function ex(n, e, t) {
  let r = sl(e), o = da.get(e).spec.config, u = (t ? n.undone : n.done).popEvent(e, r);
  if (!u)
    return null;
  let c = u.selection.resolve(u.transform.doc), l = (t ? n.done : n.undone).addTransform(u.transform, e.selection.getBookmark(), o, r), i = new Ei(t ? l : u.remaining, t ? u.remaining : l, null, 0, -1);
  return u.transform.setSelection(c).setMeta(da, { redo: t, historyState: i });
}
let yc = !1, pm = null;
function sl(n) {
  let e = n.plugins;
  if (pm != e) {
    yc = !1, pm = e;
    for (let t = 0; t < e.length; t++)
      if (e[t].spec.historyPreserveItems) {
        yc = !0;
        break;
      }
  }
  return yc;
}
const da = new zr("history"), tx = new zr("closeHistory");
function nx(n = {}) {
  return n = {
    depth: n.depth || 100,
    newGroupDelay: n.newGroupDelay || 500
  }, new tr({
    key: da,
    state: {
      init() {
        return new Ei(Ar.empty, Ar.empty, null, 0, -1);
      },
      apply(e, t, r) {
        return Z1(t, r, e, n);
      }
    },
    config: n,
    props: {
      handleDOMEvents: {
        beforeinput(e, t) {
          let r = t.inputType, o = r == "historyUndo" ? V_ : r == "historyRedo" ? H_ : null;
          return o ? (t.preventDefault(), o(e.state, e.dispatch)) : !1;
        }
      }
    }
  });
}
function W_(n, e) {
  return (t, r) => {
    let o = da.getState(t);
    if (!o || (n ? o.undone : o.done).eventCount == 0)
      return !1;
    if (r) {
      let u = ex(o, t, n);
      u && r(e ? u.scrollIntoView() : u);
    }
    return !0;
  };
}
const V_ = W_(!1, !0), H_ = W_(!0, !0), rx = Xn.create({
  name: "history",
  addOptions() {
    return {
      depth: 100,
      newGroupDelay: 500
    };
  },
  addCommands() {
    return {
      undo: () => ({ state: n, dispatch: e }) => V_(n, e),
      redo: () => ({ state: n, dispatch: e }) => H_(n, e)
    };
  },
  addProseMirrorPlugins() {
    return [
      nx(this.options)
    ];
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Shift-Mod-z": () => this.editor.commands.redo(),
      "Mod-y": () => this.editor.commands.redo(),
      // Russian keyboard layouts
      "Mod-я": () => this.editor.commands.undo(),
      "Shift-Mod-я": () => this.editor.commands.redo()
    };
  }
}), ix = ur.create({
  name: "horizontalRule",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  parseHTML() {
    return [{ tag: "hr" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["hr", Rn(this.options.HTMLAttributes, n)];
  },
  addCommands() {
    return {
      setHorizontalRule: () => ({ chain: n, state: e }) => {
        const { $to: t } = e.selection, r = n();
        return t.parentOffset === 0 ? r.insertContentAt(Math.max(t.pos - 2, 0), { type: this.name }) : r.insertContent({ type: this.name }), r.command(({ tr: o, dispatch: u }) => {
          var c;
          if (u) {
            const { $to: l } = o.selection, i = l.end();
            if (l.nodeAfter)
              l.nodeAfter.isTextblock ? o.setSelection(Zt.create(o.doc, l.pos + 1)) : l.nodeAfter.isBlock ? o.setSelection($t.create(o.doc, l.pos)) : o.setSelection(Zt.create(o.doc, l.pos));
            else {
              const h = (c = l.parent.type.contentMatch.defaultType) === null || c === void 0 ? void 0 : c.create();
              h && (o.insert(i, h), o.setSelection(Zt.create(o.doc, i + 1)));
            }
            o.scrollIntoView();
          }
          return !0;
        }).run();
      }
    };
  },
  addInputRules() {
    return [
      kw({
        find: /^(?:---|—-|___\s|\*\*\*\s)$/,
        type: this.type
      })
    ];
  }
}), ax = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/, ox = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g, sx = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/, lx = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g, ux = Hr.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (n) => n.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["em", Rn(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands: n }) => n.setMark(this.name),
      toggleItalic: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetItalic: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      fo({
        find: ax,
        type: this.type
      }),
      fo({
        find: sx,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      ho({
        find: ox,
        type: this.type
      }),
      ho({
        find: lx,
        type: this.type
      })
    ];
  }
}), cx = ur.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["li", Rn(this.options.HTMLAttributes, n), 0];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), fx = ur.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["li", Rn(this.options.HTMLAttributes, n), 0];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), mm = Hr.create({
  name: "textStyle",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        getAttrs: (n) => n.hasAttribute("style") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["span", Rn(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      removeEmptyTextStyle: () => ({ state: n, commands: e }) => {
        const t = cu(n, this.type);
        return Object.entries(t).some(([, o]) => !!o) ? !0 : e.unsetMark(this.name);
      }
    };
  }
}), gm = /^(\d+)\.\s$/, dx = ur.create({
  name: "orderedList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  addAttributes() {
    return {
      start: {
        default: 1,
        parseHTML: (n) => n.hasAttribute("start") ? parseInt(n.getAttribute("start") || "", 10) : 1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "ol"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    const { start: e, ...t } = n;
    return e === 1 ? ["ol", Rn(this.options.HTMLAttributes, t), 0] : ["ol", Rn(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      toggleOrderedList: () => ({ commands: n, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(fx.name, this.editor.getAttributes(mm.name)).run() : n.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-7": () => this.editor.commands.toggleOrderedList()
    };
  },
  addInputRules() {
    let n = Es({
      find: gm,
      type: this.type,
      getAttributes: (e) => ({ start: +e[1] }),
      joinPredicate: (e, t) => t.childCount + t.attrs.start === +e[1]
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (n = Es({
      find: gm,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: (e) => ({ start: +e[1], ...this.editor.getAttributes(mm.name) }),
      joinPredicate: (e, t) => t.childCount + t.attrs.start === +e[1],
      editor: this.editor
    })), [
      n
    ];
  }
}), hx = ur.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [
      { tag: "p" }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["p", Rn(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setParagraph: () => ({ commands: n }) => n.setNode(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setParagraph()
    };
  }
}), px = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/, mx = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g, gx = Hr.create({
  name: "strike",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "s"
      },
      {
        tag: "del"
      },
      {
        tag: "strike"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (n) => n.includes("line-through") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["s", Rn(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setStrike: () => ({ commands: n }) => n.setMark(this.name),
      toggleStrike: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetStrike: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-s": () => this.editor.commands.toggleStrike()
    };
  },
  addInputRules() {
    return [
      fo({
        find: px,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      ho({
        find: mx,
        type: this.type
      })
    ];
  }
}), vx = ur.create({
  name: "text",
  group: "inline"
}), _x = Xn.create({
  name: "starterKit",
  addExtensions() {
    var n, e, t, r, o, u, c, l, i, h, f, p, d, v, g, m, A, b;
    const S = [];
    return this.options.blockquote !== !1 && S.push(y1.configure((n = this.options) === null || n === void 0 ? void 0 : n.blockquote)), this.options.bold !== !1 && S.push(M1.configure((e = this.options) === null || e === void 0 ? void 0 : e.bold)), this.options.bulletList !== !1 && S.push(R1.configure((t = this.options) === null || t === void 0 ? void 0 : t.bulletList)), this.options.code !== !1 && S.push(P1.configure((r = this.options) === null || r === void 0 ? void 0 : r.code)), this.options.codeBlock !== !1 && S.push(L1.configure((o = this.options) === null || o === void 0 ? void 0 : o.codeBlock)), this.options.document !== !1 && S.push(w1.configure((u = this.options) === null || u === void 0 ? void 0 : u.document)), this.options.dropcursor !== !1 && S.push(F1.configure((c = this.options) === null || c === void 0 ? void 0 : c.dropcursor)), this.options.gapcursor !== !1 && S.push($1.configure((l = this.options) === null || l === void 0 ? void 0 : l.gapcursor)), this.options.hardBreak !== !1 && S.push(G1.configure((i = this.options) === null || i === void 0 ? void 0 : i.hardBreak)), this.options.heading !== !1 && S.push(z1.configure((h = this.options) === null || h === void 0 ? void 0 : h.heading)), this.options.history !== !1 && S.push(rx.configure((f = this.options) === null || f === void 0 ? void 0 : f.history)), this.options.horizontalRule !== !1 && S.push(ix.configure((p = this.options) === null || p === void 0 ? void 0 : p.horizontalRule)), this.options.italic !== !1 && S.push(ux.configure((d = this.options) === null || d === void 0 ? void 0 : d.italic)), this.options.listItem !== !1 && S.push(cx.configure((v = this.options) === null || v === void 0 ? void 0 : v.listItem)), this.options.orderedList !== !1 && S.push(dx.configure((g = this.options) === null || g === void 0 ? void 0 : g.orderedList)), this.options.paragraph !== !1 && S.push(hx.configure((m = this.options) === null || m === void 0 ? void 0 : m.paragraph)), this.options.strike !== !1 && S.push(gx.configure((A = this.options) === null || A === void 0 ? void 0 : A.strike)), this.options.text !== !1 && S.push(vx.configure((b = this.options) === null || b === void 0 ? void 0 : b.text)), S;
  }
}), Ex = ["for"], yx = { class: "k-html-editor" }, Tx = {
  key: 0,
  class: "k-html-editor-toolbar"
}, Ax = ["disabled"], Sx = ["disabled"], Cx = /* @__PURE__ */ ve("em", null, "I", -1), Mx = [
  Cx
], bx = ["disabled"], Rx = ["disabled"], Dx = /* @__PURE__ */ Dt({
  __name: "KHtmlEditor",
  props: {
    modelValue: { default: "" },
    id: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    textClass: {},
    class: { default: "" },
    labelText: { default: "" },
    labelClass: { default: "" },
    labelStyle: { default: "" },
    readonly: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = _1({
      content: t.modelValue,
      extensions: [_x],
      onUpdate: () => r("update:modelValue", o.value.getHTML())
    });
    return oi(() => o.value.destroy()), un(() => t.modelValue, (u) => {
      o.value.getHTML() !== u && o.value.commands.setContent(u, !1);
    }), (u, c) => (Oe(), je(dn, null, [
      ve("label", {
        for: u.id,
        class: Ct(["input-label-text", t.labelClass]),
        style: mr(u.labelStyle)
      }, lt(u.labelText), 15, Ex),
      ve("div", yx, [
        Ye(o) ? (Oe(), je("div", Tx, [
          ve("button", {
            class: Ct(["btn btn-xs btn-outline-primary", { "is-active": Ye(o).isActive("bold") }]),
            onClick: c[0] || (c[0] = (l) => Ye(o).chain().focus().toggleBold().run()),
            disabled: !Ye(o).can().chain().focus().toggleBold().run()
          }, " B ", 10, Ax),
          ve("button", {
            class: Ct(["btn btn-xs btn-outline-primary", { "is-active": Ye(o).isActive("italic") }]),
            onClick: c[1] || (c[1] = (l) => Ye(o).chain().focus().toggleItalic().run()),
            disabled: !Ye(o).can().chain().focus().toggleItalic().run()
          }, Mx, 10, Sx),
          ve("button", {
            class: Ct(["btn btn-xs btn-outline-primary", { "is-active": Ye(o).isActive("paragraph") }]),
            onClick: c[2] || (c[2] = (l) => Ye(o).chain().focus().setParagraph().run())
          }, " paragraph ", 2),
          ve("button", {
            class: Ct(["btn btn-xs btn-outline-primary", { "is-active": Ye(o).isActive("heading", { level: 1 }) }]),
            onClick: c[3] || (c[3] = (l) => Ye(o).chain().focus().toggleHeading({ level: 1 }).run())
          }, " h1 ", 2),
          ve("button", {
            class: Ct(["btn btn-xs btn-outline-primary", { "is-active": Ye(o).isActive("heading", { level: 2 }) }]),
            onClick: c[4] || (c[4] = (l) => Ye(o).chain().focus().toggleHeading({ level: 2 }).run())
          }, " h2 ", 2),
          ve("button", {
            class: Ct(["btn btn-xs btn-outline-primary", { "is-active": Ye(o).isActive("heading", { level: 3 }) }]),
            onClick: c[5] || (c[5] = (l) => Ye(o).chain().focus().toggleHeading({ level: 3 }).run())
          }, " h3 ", 2),
          ve("button", {
            class: Ct(["btn btn-xs btn-outline-primary", { "is-active": Ye(o).isActive("heading", { level: 4 }) }]),
            onClick: c[6] || (c[6] = (l) => Ye(o).chain().focus().toggleHeading({ level: 4 }).run())
          }, " h4 ", 2),
          ve("button", {
            class: Ct(["btn btn-xs btn-outline-primary", { "is-active": Ye(o).isActive("heading", { level: 5 }) }]),
            onClick: c[7] || (c[7] = (l) => Ye(o).chain().focus().toggleHeading({ level: 5 }).run())
          }, " h5 ", 2),
          ve("button", {
            class: Ct(["btn btn-xs btn-outline-primary", { "is-active": Ye(o).isActive("heading", { level: 6 }) }]),
            onClick: c[8] || (c[8] = (l) => Ye(o).chain().focus().toggleHeading({ level: 6 }).run())
          }, " h6 ", 2),
          ve("button", {
            class: Ct(["btn btn-xs btn-outline-primary", { "is-active": Ye(o).isActive("bulletList") }]),
            onClick: c[9] || (c[9] = (l) => Ye(o).chain().focus().toggleBulletList().run())
          }, " bullet list ", 2),
          ve("button", {
            class: Ct(["btn btn-xs btn-outline-primary", { "is-active": Ye(o).isActive("orderedList") }]),
            onClick: c[10] || (c[10] = (l) => Ye(o).chain().focus().toggleOrderedList().run())
          }, " ordered list ", 2),
          ve("button", {
            class: Ct(["btn btn-xs btn-outline-primary", { "is-active": Ye(o).isActive("blockquote") }]),
            onClick: c[11] || (c[11] = (l) => Ye(o).chain().focus().toggleBlockquote().run())
          }, " blockquote ", 2),
          ve("button", {
            class: "btn btn-xs btn-outline-primary",
            onClick: c[12] || (c[12] = (l) => Ye(o).chain().focus().undo().run()),
            disabled: !Ye(o).can().chain().focus().undo().run()
          }, " undo ", 8, bx),
          ve("button", {
            class: "btn btn-xs btn-outline-primary",
            onClick: c[13] || (c[13] = (l) => Ye(o).chain().focus().redo().run()),
            disabled: !Ye(o).can().chain().focus().redo().run()
          }, " redo ", 8, Rx)
        ])) : mt("", !0),
        dt(Ye(v1), {
          editor: Ye(o),
          class: "k-html-editor-content"
        }, null, 8, ["editor"])
      ])
    ], 64));
  }
});
const Ox = { class: "chip-label" }, Px = ["onClick"], Ix = { class: "visually-hidden" }, Nx = /* @__PURE__ */ Dt({
  __name: "KInputChips",
  props: {
    id: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    modelValue: {},
    type: { default: Lo.text },
    labelText: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    const t = st(""), r = st([]), o = n, u = e;
    un(
      () => t.value,
      (d) => {
        d && d !== "" && o.type === Lo.email && c();
      }
    ), un(
      () => o.modelValue,
      (d) => {
        r.value = JSON.parse(JSON.stringify(d));
      }
    );
    const c = () => {
      if (t.value.includes(";") || t.value.includes(",") || t.value.includes(" ")) {
        let d = t.value.split(";");
        d.length == 1 && (d = t.value.split(",")), d.length == 1 && (d = t.value.split(" "));
        let v = 0;
        for (; v <= d.length; )
          d.forEach((g) => {
            i(g), v++;
          });
      }
    }, l = () => {
      i(t.value);
    }, i = (d) => {
      d !== "" && (o.type === Lo.email ? f(d) && (o.modelValue.push(d), t.value = "", h()) : (o.modelValue.push(d), t.value = "", h()));
    }, h = () => {
      u("update:modelValue", JSON.parse(JSON.stringify(o.modelValue)));
    }, f = (d) => !!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(d), p = (d) => {
      o.modelValue.splice(o.modelValue.indexOf(d), 1), h();
    };
    return (d, v) => {
      const g = Nt("KIcon"), m = Nt("KInputText");
      return Oe(), je(dn, null, [
        (Oe(!0), je(dn, null, Un(o.modelValue, (A, b) => (Oe(), je("div", {
          class: "chip chip-lg alert",
          key: b
        }, [
          o.type === Ye(Lo).email ? (Oe(), Wt(g, {
            key: 0,
            icon: "it-user"
          })) : mt("", !0),
          ve("span", Ox, lt(A), 1),
          ve("button", {
            onClick: (S) => p(A)
          }, [
            dt(g, { icon: "it-close" }),
            ve("span", Ix, "Elimina " + lt(A), 1)
          ], 8, Px)
        ]))), 128)),
        dt(m, {
          labelText: o.labelText,
          modelValue: t.value,
          "onUpdate:modelValue": v[0] || (v[0] = (A) => t.value = A),
          formGroupClass: o.labelText !== "" ? "mt-4 mb-0" : "mb-0",
          onEnterPressed: l
        }, null, 8, ["labelText", "modelValue", "formGroupClass"])
      ], 64);
    };
  }
}), Lx = { class: "input-group" }, wx = {
  key: 0,
  class: "input-group-prepend"
}, xx = { class: "input-group-text" }, Bx = ["for"], Fx = ["id", "autofocus", "placeholder", "value", "readonly"], Ux = { class: "input-group-append" }, kx = /* @__PURE__ */ Dt({
  __name: "KInputDate",
  props: {
    id: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    modelValue: { default: "" },
    icon: {},
    labelText: { default: "" },
    class: { default: "" },
    readonly: { type: Boolean, default: !1 },
    formGroupClass: { default: "" },
    placeholder: { default: null },
    autofocus: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "enter-pressed"],
  setup(n, { emit: e }) {
    const t = st(null);
    st(0);
    const r = n, o = e;
    un(
      () => r.modelValue,
      async () => {
        await lr(), new ii(t.value);
      }
    ), ln(() => {
      new ii(t.value);
    });
    const u = (l) => {
      o("update:modelValue", l.target.value);
    }, c = () => {
      o("enter-pressed");
    };
    return (l, i) => {
      const h = Nt("KIcon");
      return Oe(), je("div", {
        class: Ct(["form-group", l.formGroupClass])
      }, [
        ve("div", Lx, [
          l.icon ? (Oe(), je("div", wx, [
            ve("div", xx, [
              dt(h, {
                class: "icon-sm",
                icon: l.icon
              }, null, 8, ["icon"])
            ])
          ])) : mt("", !0),
          ve("label", {
            for: l.id,
            class: "input-label-text active",
            style: { "background-color": "white" }
          }, lt(l.labelText), 9, Bx),
          ve("input", {
            type: "date",
            class: Ct(["form-control input-control-text", r.class]),
            id: l.id,
            ref_key: "kdInputDate",
            ref: t,
            autofocus: r.autofocus,
            placeholder: r.placeholder,
            onInput: u,
            onKeyup: pa(c, ["enter"]),
            value: l.modelValue,
            readonly: r.readonly,
            autocomplete: "off"
          }, null, 42, Fx),
          ve("div", Ux, [
            pn(l.$slots, "append-container")
          ])
        ])
      ], 2);
    };
  }
}), Kx = ["name", "id", "multiple", "accept", "capture"], jx = ["for"], Wx = {
  key: 0,
  class: "form-feedback just-validate-error-label"
}, Vx = {
  key: 1,
  class: "upload-file-list"
}, Hx = { key: 2 }, $x = /* @__PURE__ */ ve("span", { class: "visually-hidden" }, "File caricato:", -1), Gx = { class: "upload-file-weight" }, zx = { disabled: "" }, Yx = /* @__PURE__ */ ve("span", { class: "visually-hidden" }, "Caricamento ultimato", -1), Xx = ["onClick"], Qx = /* @__PURE__ */ Dt({
  __name: "KInputFile",
  props: {
    modelValue: { default: () => [] },
    inputName: { default: "" },
    inputId: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    formGroupClass: { default: "" },
    multiple: { type: Boolean, default: !1 },
    buttonLabel: { default: "Carica file" },
    showFileName: { type: Boolean, default: !0 },
    previewSize: { default: "small" },
    fileTypes: {},
    accept: { default: "" },
    capture: { type: [Boolean, String], default: !1 },
    maxFileSize: { default: 1e7 }
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = st([]), u = st(!1), c = st(), l = Ht(() => {
      if ((t.accept || "") != "")
        return t.accept;
      if ((t.fileTypes || "") != "")
        switch (t.fileTypes) {
          case "images":
            return "image/*";
          case "videos":
            return "video/*";
        }
      return "";
    }), i = Ht({
      get() {
        return t.modelValue;
      },
      set(S) {
        h(S || []), r("update:modelValue", S);
      }
    }), h = (S) => {
      if (o.value && o.value.length > 0)
        for (let N = 0; N < o.value.length; N++) {
          const T = o.value[N];
          (T || "") != "" && URL.revokeObjectURL(T);
        }
      if (o.value.length > 0 && o.value.splice(0, o.value.length), S && S instanceof Array)
        for (let N = 0; N < S.length; N++) {
          const T = S[N];
          if (!f(T))
            o.value.push("");
          else {
            const R = URL.createObjectURL(T);
            o.value.push(R);
          }
        }
    };
    un(t.modelValue, () => {
      h(t.modelValue || []);
    }, { immediate: !0 });
    const f = (S) => S && S.type && S.type.startsWith("image/"), p = (S) => {
      const N = [], T = Array.from(c.value.files);
      if (t.multiple)
        for (let E = 0; E < i.value.length; E++) {
          const L = i.value[E];
          N.push(L);
        }
      u.value = !1;
      const R = N.map((E) => d(E));
      let y = !1;
      for (let E = 0; E < T.length; E++) {
        const L = T[E], _ = d(L);
        if (!(R.findIndex((O) => O == _) >= 0)) {
          if (t.maxFileSize && L.size > t.maxFileSize) {
            u.value = !0, y = !0;
            continue;
          }
          N.push(L);
        }
      }
      y && g(), i.value = N;
    }, d = (S) => `${S.name}|${S.size}|${S.lastModified}`, v = (S) => {
      const N = [];
      for (let T = 0; T < i.value.length; T++) {
        const R = i.value[T];
        S != T && N.push(R);
      }
      g(), i.value = N;
    }, g = () => {
      c.value.files = new DataTransfer().files;
    }, m = (S) => o.value[S], A = (S, N = 1) => {
      if (Math.abs(S) < 1e3)
        return S + " B";
      const R = ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
      let y = -1;
      const E = 10 ** N;
      do
        S /= 1e3, ++y;
      while (Math.round(Math.abs(S) * E) / E >= 1e3 && y < R.length - 1);
      return Number(S.toFixed(N)).toLocaleString() + " " + R[y];
    }, b = () => {
      document.querySelectorAll("button.p-image-preview-indicator").forEach((S) => {
        S.onclick = (N) => {
          N.stopPropagation(), N.preventDefault();
        };
      });
    };
    return ln(() => {
      b();
    }), _f(() => {
      b();
    }), (S, N) => (Oe(), je("div", {
      class: Ct(["", S.formGroupClass])
    }, [
      ve("input", {
        type: "file",
        name: S.inputName,
        id: S.inputId,
        class: "upload",
        multiple: S.multiple,
        accept: l.value,
        capture: S.capture,
        onChange: p,
        ref_key: "refFileInput",
        ref: c
      }, null, 40, Kx),
      ve("label", { for: S.inputId }, [
        dt(Ye(yn), {
          class: "icon-sm",
          icon: "it-upload"
        }),
        ve("span", null, lt(S.buttonLabel), 1)
      ], 8, jx),
      u.value ? (Oe(), je("div", Wx, " Selezionare file di dimensione massima " + lt(A(S.maxFileSize)), 1)) : mt("", !0),
      i.value && i.value instanceof Array && i.value.length > 0 ? (Oe(), je("ul", Vx, [
        (Oe(!0), je(dn, null, Un(i.value, (T, R) => (Oe(), je("li", {
          class: Ct(["upload-file success", { "no-file-name": !S.showFileName }])
        }, [
          f(T) ? (Oe(), je("div", {
            key: 0,
            class: Ct(["upload-image", { sm: S.previewSize == "small", md: S.previewSize == "medium", lg: S.previewSize == "large", xl: S.previewSize == "xl" }])
          }, [
            dt(Ye(ZE), {
              src: m(R),
              preview: ""
            }, null, 8, ["src"])
          ], 2)) : (Oe(), Wt(Ye(yn), {
            key: 1,
            icon: "it-file"
          })),
          S.showFileName ? (Oe(), je("p", Hx, [
            $x,
            an(" " + lt(T.name) + " ", 1),
            ve("span", Gx, lt(A(T.size)), 1)
          ])) : mt("", !0),
          ve("button", zx, [
            Yx,
            ve("button", {
              class: "btn",
              type: "button",
              onClick: As((y) => v(R), ["prevent"]),
              title: "Rimuovi file"
            }, [
              dt(Ye(yn), {
                class: "icon-sm",
                icon: "it-close"
              })
            ], 8, Xx)
          ])
        ], 2))), 256))
      ])) : mt("", !0)
    ], 2));
  }
});
const Jx = { class: "input-group" }, Zx = ["for"], qx = ["id", "value", "autocomplete"], eB = {
  class: "password-icon",
  "aria-hidden": "true",
  "aria-label": "toggle-visibility"
}, $_ = /* @__PURE__ */ Dt({
  __name: "KInputPassword",
  props: {
    id: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    modelValue: { default: "" },
    labelText: { default: "" },
    class: { default: null },
    formGroupClass: { default: "" },
    autocomplete: { default: "current-password" }
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    const t = st(null), r = e;
    st(0);
    const o = n;
    un(
      () => o.modelValue,
      async () => {
        await lr(), t.value.dispatchEvent(new Event("change"));
      }
    );
    let u = null, c = null;
    ln(() => {
      const i = document.getElementById(o.id);
      u || (u = ii.getOrCreateInstance(i), c = i.parentElement.getElementsByClassName("password-icon")[0], c.addEventListener("click", (h) => {
        h.stopImmediatePropagation(), i.type == "password" ? (i.type = "text", c.children[0].classList.remove("d-none"), c.children[0].classList.add("d-none"), c.children[1].classList.remove("d-none")) : (i.type = "password", c.children[1].classList.remove("d-none"), c.children[1].classList.add("d-none"), c.children[0].classList.remove("d-none"));
      }));
    }), po(() => {
      u && (u.dispose(), c = null);
    });
    const l = (i) => {
      r("update:modelValue", i.target.value);
    };
    return (i, h) => (Oe(), je("div", {
      class: Ct(["form-group", i.formGroupClass])
    }, [
      ve("div", Jx, [
        ve("label", {
          for: i.id,
          class: "input-label-text"
        }, lt(i.labelText), 9, Zx),
        ve("input", {
          type: "password",
          class: "form-control input-password",
          id: i.id,
          ref_key: "kdInputPassword",
          ref: t,
          value: i.modelValue,
          autocomplete: o.autocomplete,
          onChange: l,
          onBlur: l,
          onInput: l
        }, null, 40, qx),
        ve("span", eB, [
          dt(Ye(yn), {
            class: "password-icon-visible icon icon-sm",
            icon: "it-password-visible"
          }),
          dt(Ye(yn), {
            class: "password-icon-invisible icon icon-sm d-none",
            icon: "it-password-invisible"
          })
        ])
      ])
    ], 2));
  }
});
const tB = { class: "input-group" }, nB = ["value", "placeholder"], rB = { class: "input-group-append" }, iB = /* @__PURE__ */ ve("span", { class: "visually-hidden" }, "Cerca", -1), aB = {
  key: 0,
  class: "form-group col-auto"
}, oB = {
  key: 1,
  class: "form-group col-auto"
}, G_ = /* @__PURE__ */ Dt({
  __name: "KInputSearch",
  props: {
    id: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    modelValue: { default: "" },
    placeholder: { default: "Cerca per nome, tag, parola chiave" },
    moreFilterButton: { type: Boolean, default: !1 },
    formGroupClass: { default: "" }
  },
  emits: ["search", "morefilterclick", "update:modelValue"],
  setup(n, { emit: e }) {
    const t = Sm(), r = Ht(() => {
      const f = t.default;
      if (f) {
        const p = f();
        if (p.length > 0)
          return p[0].children != "v-if";
      }
      return !1;
    }), o = st(null), u = n, c = e, l = Ht(() => {
      let f = "";
      return r.value && (f = "k-search-input-wrap "), f += u.formGroupClass, f;
    }), i = () => {
      c("search");
    };
    ln(() => {
      new ii(o.value);
    });
    const h = (f) => {
      c("update:modelValue", f.target.value);
    };
    return (f, p) => {
      const d = Nt("KIcon");
      return Oe(), je("div", {
        class: Ct(["d-flex", { "flex-wrap": r.value }])
      }, [
        ve("div", {
          class: Ct(["form-group col", l.value])
        }, [
          ve("div", tB, [
            ve("input", {
              type: "search",
              style: { "background-color": "#F4F4F4", color: "#757575" },
              class: "form-control",
              onInput: h,
              onKeyup: pa(i, ["enter"]),
              value: f.modelValue,
              ref_key: "kdSearchText",
              ref: o,
              placeholder: f.placeholder,
              autocomplete: "off"
            }, null, 40, nB),
            ve("div", rB, [
              ve("button", {
                type: "button",
                class: "btn",
                style: { padding: "0" },
                onClick: i
              }, [
                dt(d, {
                  icon: "it-search",
                  class: "icon-white",
                  style: { "background-color": "#757575", padding: "8px", height: "2.4rem", width: "2.4rem" }
                }),
                iB
              ])
            ])
          ])
        ], 2),
        r.value ? (Oe(), je("div", aB, [
          pn(f.$slots, "default")
        ])) : mt("", !0),
        f.moreFilterButton ? (Oe(), je("div", oB, [
          ve("button", {
            type: "button",
            class: "btn btn-outline-primary k-search-btn-more",
            onClick: p[0] || (p[0] = (v) => c("morefilterclick"))
          }, "...")
        ])) : mt("", !0)
      ], 2);
    };
  }
});
const sB = { class: "input-group" }, lB = {
  key: 0,
  class: "input-group-prepend"
}, uB = { class: "input-group-text" }, cB = ["for"], fB = ["id", "autofocus", "autocomplete", "placeholder", "value", "readonly"], dB = { class: "input-group-append" }, z_ = /* @__PURE__ */ Dt({
  __name: "KInputText",
  props: {
    id: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    modelValue: { default: "" },
    icon: {},
    labelText: { default: "" },
    class: { default: "" },
    readonly: { type: Boolean, default: !1 },
    formGroupClass: { default: "" },
    placeholder: { default: null },
    autofocus: { type: Boolean, default: !1 },
    autocomplete: { default: "off" }
  },
  emits: ["update:modelValue", "enter-pressed"],
  setup(n, { emit: e }) {
    const t = st(null), r = e;
    st(0);
    const o = n;
    un(
      () => o.modelValue,
      async () => {
        await lr(), t.value.dispatchEvent(new Event("change"));
      }
    ), ln(() => {
      new ii(t.value);
    });
    const u = (l) => {
      r("update:modelValue", l.target.value);
    }, c = () => {
      r("enter-pressed");
    };
    return (l, i) => {
      const h = Nt("KIcon");
      return Oe(), je("div", {
        class: Ct(["form-group", l.formGroupClass])
      }, [
        ve("div", sB, [
          l.icon ? (Oe(), je("div", lB, [
            ve("div", uB, [
              dt(h, {
                class: "icon-sm",
                icon: l.icon
              }, null, 8, ["icon"])
            ])
          ])) : mt("", !0),
          ve("label", {
            for: l.id,
            class: "input-label-text"
          }, lt(l.labelText), 9, cB),
          ve("input", {
            type: "text",
            class: Ct(["form-control input-control-text", o.class]),
            id: l.id,
            ref_key: "kdInputText",
            ref: t,
            autofocus: o.autofocus,
            autocomplete: o.autocomplete,
            placeholder: o.placeholder,
            onInput: u,
            onKeyup: pa(c, ["enter"]),
            value: l.modelValue,
            readonly: o.readonly
          }, null, 42, fB),
          ve("div", dB, [
            pn(l.$slots, "append-container")
          ])
        ])
      ], 2);
    };
  }
}), hB = { class: "input-group" }, pB = ["for"], mB = ["disabled"], gB = ["id", "name", "autofocus", "placeholder", "min", "max", "step", "value", "readonly", "disabled"], vB = ["disabled"], _B = {
  class: "visually-hidden",
  style: { "background-color": "white" }
}, EB = ["disabled"], yB = {
  class: "visually-hidden",
  style: { "background-color": "white" }
}, TB = /* @__PURE__ */ Dt({
  __name: "KInputNumber",
  props: {
    id: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    modelValue: { default: "" },
    step: { default: "any" },
    min: { default: "any" },
    max: { default: "any" },
    isCurrency: { type: Boolean, default: !1 },
    isPercentage: { type: Boolean, default: !1 },
    removeButton: { type: Boolean, default: !1 },
    labelText: { default: "" },
    labelBtnAdd: { default: "Aumenta valore" },
    labelBtnDecrement: { default: "Diminuisci valore" },
    class: { default: "" },
    readonly: { type: Boolean, default: !1 },
    disabled: { type: Boolean },
    formGroupClass: { default: "" },
    placeholder: { default: null },
    autofocus: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "enter-pressed"],
  setup(n, { emit: e }) {
    const t = st(null), r = e, o = n;
    un(
      () => o.modelValue,
      async () => {
        await lr(), t.value.dispatchEvent(new Event("change"));
      }
    );
    let u = null;
    ln(() => {
      u = new Hf(t.value);
      let f = document.getElementById(t.value.id), p = f.parentNode.querySelectorAll("button");
      for (let d = 0; d < p.length; d++)
        p[d].addEventListener("click", function() {
          f.dispatchEvent(new Event("change"));
        });
    }), po(() => {
      u && u.dispose();
    });
    const c = (f) => {
      r("update:modelValue", f.target.value);
    }, l = (f) => {
      r("update:modelValue", f.target.value), r("enter-pressed");
    }, i = Ht(() => o.labelBtnAdd === "Aumenta valore" ? o.isPercentage || o.isCurrency ? o.labelBtnAdd + " di " + o.step + " €" : o.labelBtnAdd + " di " + o.step : o.labelBtnAdd), h = Ht(() => o.labelBtnDecrement === "Diminuisci valore" ? o.isPercentage || o.isCurrency ? o.labelBtnDecrement + " di " + o.step + " €" : o.labelBtnDecrement + " di " + o.step : o.labelBtnDecrement);
    return (f, p) => (Oe(), je("div", {
      class: Ct(["form-group", f.formGroupClass])
    }, [
      ve("div", hB, [
        ve("label", {
          for: f.id,
          class: "input-label-text input-number-label"
        }, lt(f.labelText), 9, pB),
        ve("span", {
          class: Ct(["input-number", [f.isCurrency ? "input-number-currency" : "", f.isPercentage ? "input-number-percentage" : ""]]),
          disabled: f.disabled
        }, [
          ve("input", {
            type: "number",
            class: Ct(["form-control k-input-number", o.class]),
            autocomplete: "off",
            id: o.id,
            name: o.id,
            ref_key: "kdInputNumber",
            ref: t,
            autofocus: o.autofocus,
            placeholder: o.placeholder,
            min: f.min,
            max: f.max,
            step: f.step,
            value: o.modelValue,
            readonly: o.readonly,
            disabled: o.disabled,
            onChange: c,
            onBlur: c,
            onInput: c,
            onKeyup: pa(l, ["enter"])
          }, null, 42, gB),
          f.removeButton ? mt("", !0) : (Oe(), je("button", {
            key: 0,
            class: "input-number-add",
            disabled: o.disabled
          }, [
            ve("span", _B, lt(i.value), 1)
          ], 8, vB)),
          f.removeButton ? mt("", !0) : (Oe(), je("button", {
            key: 1,
            class: "input-number-sub",
            disabled: o.disabled
          }, [
            ve("span", yB, lt(h.value), 1)
          ], 8, EB))
        ], 10, mB)
      ])
    ], 2));
  }
});
const AB = ["for"], SB = ["id", "value", "placeholder", "readonly"], CB = /* @__PURE__ */ Dt({
  __name: "KInputTextArea",
  props: {
    id: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    modelValue: { default: "" },
    textClass: { default: "" },
    class: { default: "" },
    placeholder: { default: "" },
    labelText: { default: "" },
    labelClass: { default: "" },
    labelStyle: { default: "" },
    readonly: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    const t = st(null), r = e, o = n;
    ln(() => {
      new ii(t.value);
    });
    const u = (c) => {
      r("update:modelValue", c.target.value);
    };
    return (c, l) => (Oe(), je("div", {
      class: Ct(["form-group", o.class])
    }, [
      ve("label", {
        for: c.id,
        class: Ct(["input-label-text", o.labelClass]),
        style: mr(c.labelStyle)
      }, lt(c.labelText), 15, AB),
      ve("textarea", {
        class: Ct(o.textClass),
        id: c.id,
        ref_key: "kdInputTextArea",
        ref: t,
        onInput: u,
        value: c.modelValue,
        placeholder: c.placeholder,
        readonly: o.readonly
      }, null, 42, SB)
    ], 2));
  }
});
const Y_ = /* @__PURE__ */ ud(CB, [["__scopeId", "data-v-ee14e828"]]), MB = ["title"], bB = { class: "d-flex justify-content-center" }, RB = { class: "d-flex justify-content-center" }, DB = { class: "text-center fw-bold text-white k-link-carousel-text" }, vm = /* @__PURE__ */ Dt({
  __name: "KLinkCarouselContent",
  props: {
    item: {},
    compact: { type: Boolean, default: !1 }
  },
  setup(n) {
    const e = n, t = Ht(() => {
      let r = "icon-white pb-2";
      return e.compact || (r += " icon-lg"), r;
    });
    return (r, o) => {
      var u;
      return Oe(), je("div", {
        class: Ct(["card-body", { "k-link-carousel-compact": e.compact }]),
        title: r.item.text,
        role: "button"
      }, [
        ve("div", bB, [
          dt(Ye(yn), {
            icon: (u = r.item) == null ? void 0 : u.icon,
            class: Ct(t.value)
          }, null, 8, ["icon", "class"])
        ]),
        ve("div", RB, [
          ve("div", DB, lt(r.item.text), 1)
        ])
      ], 10, MB);
    };
  }
}), OB = { class: "d-flex justify-content-center" }, PB = ["href"], IB = /* @__PURE__ */ Dt({
  __name: "KLinkCarousel",
  props: {
    items: {},
    numVisible: { default: 3 },
    numScroll: { default: 3 },
    title: { default: "" },
    compact: { type: Boolean, default: !1 }
  },
  setup(n) {
    const e = n;
    return (t, r) => {
      const o = Nt("router-link"), u = Nt("Carousel");
      return Oe(), Wt(u, {
        value: t.items,
        numVisible: t.numVisible,
        numScroll: t.numScroll,
        showIndicators: !1,
        class: Ct("mb-2")
      }, {
        header: Ft(() => [
          t.title ? (Oe(), Wt(Ye(Ld), {
            key: 0,
            title: t.title
          }, null, 8, ["title"])) : mt("", !0)
        ]),
        item: Ft((c) => [
          ve("div", OB, [
            ve("div", {
              class: Ct(["card rounded mb-0 k-link-carousel", { "bg-primary": !e.compact, "bg-secondary": e.compact, "mr-4": !e.compact, "mr-2": e.compact }])
            }, [
              c.data.openExternal ? (Oe(), je("a", {
                key: 0,
                href: c.data.link,
                target: "_blank",
                rel: "noreferrer noopener"
              }, [
                dt(vm, {
                  item: c.data,
                  compact: t.compact
                }, null, 8, ["item", "compact"])
              ], 8, PB)) : (Oe(), Wt(o, {
                key: 1,
                to: c.data.link
              }, {
                default: Ft(() => [
                  dt(vm, {
                    item: c.data,
                    compact: t.compact
                  }, null, 8, ["item", "compact"])
                ]),
                _: 2
              }, 1032, ["to"]))
            ], 2)
          ])
        ]),
        _: 1
      }, 8, ["value", "numVisible", "numScroll"]);
    };
  }
});
const NB = { class: "modal-dialog" }, LB = { class: "modal-content" }, wB = { class: "modal-header" }, xB = { class: "modal-title h5 no_toc" }, BB = {
  key: 0,
  class: "btn-close",
  type: "button",
  "data-bs-dismiss": "modal",
  "aria-label": "Chiudi finestra modale"
}, FB = { class: "modal-body" }, UB = { class: "modal-footer" }, kB = /* @__PURE__ */ Dt({
  __name: "KModalCenter",
  props: {
    title: { default: "" },
    closeButton: { type: Boolean, default: !0 },
    modelValue: { type: Boolean }
  },
  emits: ["closed", "update:modelValue"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = st(null);
    let u = null;
    ln(() => {
      u = ed.getOrCreateInstance(o.value, {
        keyboard: !1,
        backdrop: "static"
      }), u && u._element && u._element.addEventListener("hidden.bs.modal", function(i) {
        r("update:modelValue", !1), r("closed");
      });
    }), po(() => {
      u && u.dispose();
    }), un(() => t.modelValue, (i) => {
      i === !0 ? c() : l();
    });
    const c = () => {
      u && u.show();
    }, l = () => {
      u && u.hide();
    };
    return (i, h) => {
      const f = Nt("KIcon");
      return Oe(), je("div", {
        ref_key: "modalCenter",
        ref: o,
        class: "modal it-dialog-scrollable fade",
        tabindex: "-1",
        role: "dialog",
        id: "modalcenter",
        "aria-labelledby": "modalCenterTitle",
        "aria-hidden": "true"
      }, [
        ve("div", NB, [
          ve("div", LB, [
            ve("div", wB, [
              ve("span", xB, lt(i.title), 1),
              i.closeButton ? (Oe(), je("button", BB, [
                dt(f, { icon: "it-close" })
              ])) : mt("", !0)
            ]),
            ve("div", FB, [
              pn(i.$slots, "default")
            ]),
            ve("div", UB, [
              pn(i.$slots, "actions")
            ])
          ])
        ])
      ], 512);
    };
  }
}), KB = { class: "modal-content" }, jB = {
  key: 0,
  class: "modal-header"
}, WB = { class: "modal-title h5 no_toc" }, VB = {
  key: 0,
  class: "btn-close",
  type: "button",
  "data-bs-dismiss": "modal",
  "aria-label": "Chiudi finestra modale"
}, HB = { class: "modal-footer" }, $B = /* @__PURE__ */ Dt({
  __name: "KModalSlide",
  props: {
    title: {},
    modelValue: { type: Boolean },
    showHeader: { type: Boolean, default: !0 },
    closeButton: { type: Boolean, default: !0 },
    bodyStyle: { default: null },
    dimension: { default: wo.lg }
  },
  emits: ["closed", "update:modelValue"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = st(null);
    let u = null;
    ln(() => {
      u = ed.getOrCreateInstance(o.value, {
        keyboard: !1
      }), u && u._element && u._element.addEventListener("hidden.bs.modal", function(h) {
        r("update:modelValue", !1), r("closed");
      });
    }), po(() => {
      u && u.dispose();
    }), un(() => t.modelValue, (h) => {
      h === !0 ? c() : l();
    });
    const c = () => {
      u && u.show();
    }, l = () => {
      u && u.hide();
    }, i = Ht(
      () => {
        let h = "k-modal-slide-xl";
        switch (t.dimension) {
          case wo.sm:
            h = "k-modal-slide-sm";
            break;
          case wo.lg:
            h = "k-modal-slide-lg";
            break;
          case wo.xl:
            h = "k-modal-slide-xl";
            break;
        }
        return h;
      }
    );
    return (h, f) => {
      const p = Nt("KIcon");
      return Oe(), Wt(Tf, { to: "body" }, [
        ve("div", {
          ref_key: "modal",
          ref: o,
          class: "modal it-dialog-scrollable fade",
          tabindex: "-1",
          role: "dialog",
          id: "modalright",
          "aria-labelledby": "modalrightTitle"
        }, [
          ve("div", {
            class: Ct(["modal-dialog modal-dialog-right", i.value]),
            role: "document"
          }, [
            ve("div", KB, [
              h.showHeader ? (Oe(), je("div", jB, [
                ve("span", WB, lt(h.title), 1),
                h.closeButton ? (Oe(), je("button", VB, [
                  dt(p, { icon: "it-close" })
                ])) : mt("", !0)
              ])) : mt("", !0),
              ve("div", {
                style: mr(h.bodyStyle),
                class: "modal-body"
              }, [
                pn(h.$slots, "default")
              ], 4),
              ve("div", HB, [
                pn(h.$slots, "actions")
              ])
            ])
          ], 2)
        ], 512)
      ]);
    };
  }
}), GB = { class: "row" }, zB = { class: "col-12 col-lg-4" }, YB = {
  "data-bs-toggle": "sticky",
  "data-bs-stackable": "false",
  "data-bs-padding-top": "120"
}, XB = {
  class: "navbar it-navscroll-wrapper navbar-expand-lg it-bottom-navscroll it-right-side",
  "data-bs-navscroll": ""
}, QB = /* @__PURE__ */ ve("button", {
  class: "custom-navbar-toggler",
  type: "button",
  "aria-controls": "navbarNav",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation",
  "data-bs-toggle": "navbarcollapsible",
  "data-bs-target": "#navbarNav",
  "data-focus-mouse": "false"
}, [
  /* @__PURE__ */ ve("span", { class: "it-list" }),
  /* @__PURE__ */ an(" 1. Introduzione ")
], -1), JB = /* @__PURE__ */ ve("div", { class: "progress custom-navbar-progressbar" }, [
  /* @__PURE__ */ ve("div", {
    class: "progress-bar it-navscroll-progressbar",
    role: "progressbar",
    "aria-valuenow": "0",
    "aria-valuemin": "0",
    "aria-valuemax": "100",
    style: { width: "0%" }
  })
], -1), ZB = {
  class: "navbar-collapsable",
  id: "navbarNav",
  style: { display: "none" },
  "aria-hidden": "true"
}, qB = /* @__PURE__ */ ve("div", {
  class: "overlay fade",
  style: { display: "none" }
}, null, -1), eF = {
  class: "it-back-button",
  href: "#",
  role: "button"
}, tF = /* @__PURE__ */ ve("span", null, "Indietro", -1), nF = { class: "menu-wrapper" }, rF = { class: "link-list-wrapper" }, iF = /* @__PURE__ */ ve("div", { class: "progress" }, [
  /* @__PURE__ */ ve("div", {
    class: "progress-bar it-navscroll-progressbar",
    role: "progressbar",
    "aria-valuenow": "0",
    "aria-valuemin": "0",
    "aria-valuemax": "100",
    style: { width: "0%" }
  })
], -1), aF = { class: "link-list" }, oF = ["href"], sF = { class: "col-12 col-lg-8 it-page-sections-container" }, lF = /* @__PURE__ */ Dt({
  __name: "KNavScroll",
  props: {
    headerText: { default: "Header" }
  },
  setup(n) {
    const e = Ul({
      items: []
    });
    return Ti("navScrollProvider", e), Ti("addItem", (t) => {
      e.items.push(t);
    }), Ti("updateItem", (t, r) => {
      let o = e.items.findIndex((u) => u.computedId === t);
      r.isActive = e.items[o].isActive, e.items[o] = r;
    }), Ti("deleteItem", (t) => {
      let r = e.items.findIndex((o) => o.computedId === t);
      e.items.splice(r, 1);
    }), (t, r) => {
      const o = Nt("KIcon");
      return Oe(), je("div", GB, [
        ve("div", zB, [
          ve("div", YB, [
            ve("nav", XB, [
              QB,
              JB,
              ve("div", ZB, [
                qB,
                ve("a", eF, [
                  dt(o, {
                    icon: "it-chevron-left",
                    class: "icon-sm icon-primary align-top"
                  }),
                  tF
                ]),
                ve("div", nF, [
                  ve("div", rF, [
                    ve("h3", null, lt(t.headerText), 1),
                    iF,
                    ve("ul", aF, [
                      (Oe(!0), je(dn, null, Un(e.items, (u, c) => (Oe(), je("li", {
                        key: c,
                        class: "nav-item"
                      }, [
                        ve("a", {
                          class: "nav-link",
                          href: u.hash,
                          "data-focus-mouse": "false"
                        }, [
                          ve("span", null, lt(u.header), 1)
                        ], 8, oF)
                      ]))), 128))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        ve("div", sF, [
          pn(t.$slots, "default")
        ])
      ]);
    };
  }
}), uF = ["id"], cF = /* @__PURE__ */ Dt({
  __name: "KNavScrollItem",
  props: {
    id: {},
    name: {}
  },
  setup(n) {
    const e = n, t = Ai("navScrollProvider"), r = Ai("addItem"), o = Ai("updateItem"), u = Ai("deleteItem"), c = e.name, l = e.id ? e.id : e.name.toLowerCase().replace(/ /g, "-"), i = "#" + l;
    return un(() => Object.assign({}, e), () => {
      o(l, {
        name: e.name,
        header: e.name,
        hash: i,
        index: t.items.length,
        computedId: l
      });
    }), yf(() => {
      r({
        name: e.name,
        header: c,
        hash: i,
        index: t.items.length,
        computedId: l
      });
    }), oi(() => {
      u(l);
    }), (h, f) => (Oe(), je(dn, null, [
      ve("h2", {
        class: "it-page-section",
        id: Ye(l)
      }, lt(h.name), 9, uF),
      pn(h.$slots, "default")
    ], 64));
  }
}), fF = ["aria-label"], dF = { class: "pagination justify-content-center" }, hF = {
  class: "page-link bg-white text-black",
  href: "#"
}, pF = /* @__PURE__ */ ve("span", { class: "visually-hidden" }, "Pagina precedente", -1), mF = /* @__PURE__ */ ve("span", { class: "d-inline-block d-sm-none" }, "Pagina ", -1), gF = {
  key: 2,
  class: "page-item"
}, vF = /* @__PURE__ */ ve("span", { class: "page-link bg-white text-black" }, "...", -1), _F = [
  vF
], EF = {
  key: 0,
  class: "page-link bg-white text-black",
  href: "#",
  "aria-current": "page"
}, yF = /* @__PURE__ */ ve("span", { class: "d-inline-block d-sm-none" }, "Pagina ", -1), TF = ["onClick"], AF = {
  key: 3,
  class: "page-item"
}, SF = /* @__PURE__ */ ve("span", { class: "page-link bg-white text-black" }, "...", -1), CF = [
  SF
], MF = {
  key: 4,
  class: "page-item"
}, bF = /* @__PURE__ */ ve("span", { class: "d-inline-block d-sm-none" }, "Pagina ", -1), RF = {
  key: 5,
  class: "page-item"
}, DF = /* @__PURE__ */ ve("span", { class: "visually-hidden" }, "Pagina successiva", -1), OF = { key: 0 }, PF = /* @__PURE__ */ Dt({
  __name: "KPaginator",
  props: {
    id: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    arialabel: { default: "Paginatore tabella" },
    class: { default: "" },
    currentPage: { default: 1 },
    totalPages: { default: 0 },
    totalCount: { default: 0 },
    nearPages: { default: 2 },
    showTotalCount: { type: Boolean, default: !1 }
  },
  emits: ["page-selected"],
  setup(n, { emit: e }) {
    st(0);
    const t = n, r = e, o = () => {
      r("page-selected", t.currentPage + 1);
    }, u = () => {
      r("page-selected", t.currentPage - 1);
    }, c = (v) => {
      r("page-selected", v);
    }, l = Ht(() => {
      var v = t.class;
      return t.showTotalCount && (v = v + " pagination-total"), v;
    }), i = Ht(() => t.currentPage - t.nearPages > 2), h = Ht(() => t.currentPage + t.nearPages < t.totalPages - 1), f = Ht(() => t.currentPage < t.totalPages), p = Ht(() => t.currentPage > 1), d = Ht(() => {
      var v = t.currentPage - t.nearPages, g = t.currentPage + t.nearPages, m = [];
      for (let A = v; A <= g; A++)
        A > 1 && A < t.totalPages && m.push(A);
      return m;
    });
    return (v, g) => (Oe(), je("nav", {
      class: Ct(["pagination-wrapper justify-content-center d-flex", l.value]),
      "aria-label": v.arialabel
    }, [
      ve("ul", dF, [
        p.value ? (Oe(), je("li", {
          key: 0,
          class: "page-item",
          onClick: u
        }, [
          ve("a", hF, [
            dt(Ye(yn), { icon: "it-chevron-left" }),
            pF
          ])
        ])) : mt("", !0),
        v.totalCount > 0 ? (Oe(), je("li", {
          key: 1,
          class: Ct(["page-item", [{ active: v.currentPage === 1 }]])
        }, [
          v.currentPage === 1 ? (Oe(), je("a", {
            key: 0,
            class: "page-link bg-white text-black",
            href: "#",
            "aria-current": "page",
            onClick: g[0] || (g[0] = (m) => c(1))
          }, [
            mF,
            an(lt(1))
          ])) : (Oe(), je("a", {
            key: 1,
            class: "page-link bg-white text-black",
            href: "#",
            onClick: g[1] || (g[1] = (m) => c(1))
          }, lt(1)))
        ], 2)) : mt("", !0),
        i.value ? (Oe(), je("li", gF, _F)) : mt("", !0),
        (Oe(!0), je(dn, null, Un(d.value, (m) => (Oe(), je("li", {
          key: m,
          class: Ct(["page-item", [{ active: v.currentPage === m }]])
        }, [
          v.currentPage === m ? (Oe(), je("a", EF, [
            yF,
            an(lt(m), 1)
          ])) : (Oe(), je("a", {
            key: 1,
            class: "page-link bg-white text-black",
            href: "#",
            onClick: (A) => c(m)
          }, lt(m), 9, TF))
        ], 2))), 128)),
        h.value ? (Oe(), je("li", AF, CF)) : mt("", !0),
        v.totalPages > 1 ? (Oe(), je("li", MF, [
          v.currentPage === v.totalPages ? (Oe(), je("a", {
            key: 0,
            class: "page-link bg-white text-black",
            href: "#",
            "aria-current": "page",
            onClick: g[2] || (g[2] = (m) => c(v.totalPages))
          }, [
            bF,
            an(lt(v.totalPages), 1)
          ])) : (Oe(), je("a", {
            key: 1,
            class: "page-link bg-white text-black",
            href: "#",
            onClick: g[3] || (g[3] = (m) => c(v.totalPages))
          }, lt(v.totalPages), 1))
        ])) : mt("", !0),
        f.value ? (Oe(), je("li", RF, [
          ve("a", {
            class: "page-link bg-white text-black",
            href: "#",
            onClick: o
          }, [
            DF,
            dt(Ye(yn), { icon: "it-chevron-right" })
          ])
        ])) : mt("", !0)
      ]),
      v.showTotalCount ? (Oe(), je("p", OF, "Totale " + lt(v.totalCount) + " elementi ", 1)) : mt("", !0)
    ], 10, fF));
  }
}), IF = { class: "form-check" }, NF = ["name", "value", "disabled", "id"], LF = ["for"], wF = /* @__PURE__ */ Dt({
  __name: "KRadioButton",
  props: {
    id: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    modelValue: { default: !1 },
    value: {},
    labelText: { default: "" },
    groupName: {},
    class: { default: "" },
    disabled: { type: Boolean, default: !1 },
    formGroupClass: { default: "" }
  },
  emits: ["update:modelValue", "change"],
  setup(n, { emit: e }) {
    const t = e, r = st(), o = n;
    un(
      () => o.modelValue,
      async (l) => {
        r.value = l;
      },
      { immediate: !0 }
    );
    const u = (l) => {
      t("update:modelValue", l.target.value);
    }, c = (l) => {
      t("change");
    };
    return (l, i) => (Oe(), je("div", IF, [
      ha(ve("input", {
        name: l.groupName,
        value: l.value,
        disabled: l.disabled,
        onInput: u,
        "onUpdate:modelValue": i[0] || (i[0] = (h) => r.value = h),
        onChange: c,
        class: Ct(l.class),
        id: l.id,
        type: "radio"
      }, null, 42, NF), [
        [WE, r.value]
      ]),
      ve("label", { for: l.id }, lt(l.labelText), 9, LF)
    ]));
  }
}), xF = { class: "h2" }, Ld = /* @__PURE__ */ Dt({
  __name: "KSectionHeader",
  props: {
    title: { default: "" },
    rowClass: { default: "" },
    startClass: { default: "" },
    endClass: { default: "" },
    separator: { type: Boolean, default: !1 }
  },
  setup(n) {
    const e = n, t = Ht(() => {
      let r = "";
      return e.separator && (r = "k-section-header-separator "), e.rowClass && (r += e.rowClass), r;
    });
    return (r, o) => (Oe(), je("div", {
      class: Ct(["d-flex align-items-center mb-2", t.value])
    }, [
      ve("div", {
        class: Ct(r.startClass)
      }, [
        ve("span", xF, lt(r.title), 1)
      ], 2),
      ve("div", {
        class: Ct(["ms-auto", r.endClass])
      }, [
        pn(r.$slots, "end")
      ], 2)
    ], 2));
  }
});
const BF = { class: "select-wrapper" }, FF = ["for"], UF = ["disabled", "id"], kF = {
  key: 0,
  value: null
}, KF = ["selected", "value"], jF = '<svg class="icon autocomplete__dropdown-arrow-down" style="pointer-events: none; z-index:0; right: 0; width: 20px;"><path d="M11.6 15.4 6 9.8l.7-.8 4.9 4.9L16.5 9l.7.8z"/></svg>', WF = /* @__PURE__ */ Dt({
  __name: "KSelect",
  props: {
    id: { default: () => Math.floor(Math.random() * 65536).toString(16) },
    modelValue: { default: "" },
    labelText: { default: "" },
    class: { default: "" },
    readonly: { type: Boolean, default: !1 },
    formGroupClass: { default: "" },
    disabled: { type: Boolean, default: !1 },
    options: {},
    emptyOptionLabel: { default: "Seleziona un'opzione" },
    showEmptyOption: { type: Boolean, default: !1 },
    autocomplete: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "change"],
  setup(n, { emit: e }) {
    const t = e, r = st(), o = n;
    un(
      () => o.modelValue,
      (i) => {
        r.value = i;
      },
      { immediate: !0 }
    );
    const u = (i) => {
      const h = i.target.options[i.target.selectedIndex]._value;
      t("update:modelValue", h), t("change", h);
    }, c = (i) => i.value == r.value;
    function l() {
      if (o.autocomplete === !0) {
        var i = document.getElementById(o.id);
        KA.getOrCreateInstance(i, {
          showAllValues: !0,
          defaultValue: "",
          autoselect: !1,
          showNoOptionsFound: !1,
          confirmOnBlur: !1,
          dropdownArrow: () => jF,
          onConfirm: (h) => {
            var f = o.options.find((p) => p.name == h);
            f ? r.value = f.value : r.value = null, t("update:modelValue", r.value), t("change", r.value);
          }
        });
      }
    }
    return ln(() => {
      l();
    }), (i, h) => (Oe(), je("div", {
      class: Ct(["form-group", i.formGroupClass])
    }, [
      ve("div", BF, [
        ve("label", {
          for: i.id,
          class: "k-select-label-text"
        }, lt(i.labelText), 9, FF),
        ve("select", {
          disabled: o.disabled,
          onChange: u,
          class: Ct(["k-select-control-text", o.class]),
          id: i.id,
          autocomplete: "off"
        }, [
          o.showEmptyOption ? (Oe(), je("option", kF, lt(o.emptyOptionLabel), 1)) : mt("", !0),
          (Oe(!0), je(dn, null, Un(o.options, (f) => (Oe(), je("option", {
            selected: c(f),
            value: f.value,
            key: f.value
          }, lt(f.name), 9, KF))), 128))
        ], 42, UF)
      ])
    ], 2));
  }
}), VF = { class: "steppers" }, HF = { class: "steppers-header mb-3" }, $F = { style: { "background-color": "#f8f8f8" } }, GF = { class: "steppers-number" }, zF = {
  key: 0,
  class: "visually-hidden"
}, YF = {
  key: 1,
  class: "visually-hidden"
}, XF = { key: 2 }, QF = {
  key: 4,
  class: "visually-hidden"
}, JF = {
  key: 1,
  class: "k-stepper-title-populated"
}, ZF = {
  key: 0,
  class: "k-stepper-inner-title"
}, qF = /* @__PURE__ */ ve("br", null, null, -1), eU = { key: 1 }, tU = {
  class: "steppers-index",
  "aria-hidden": "true",
  style: { "background-color": "#f8f8f8" }
}, nU = /* @__PURE__ */ Dt({
  __name: "KStepperHeader",
  props: {
    steps: {},
    currentIndex: { default: 1 }
  },
  setup(n) {
    const e = n, t = Ht(() => e.currentIndex + "/" + e.steps.length);
    return (r, o) => {
      const u = Nt("KIcon");
      return Oe(), je("div", VF, [
        ve("div", HF, [
          ve("ul", $F, [
            (Oe(!0), je(dn, null, Un(r.steps, (c) => (Oe(), je("li", {
              key: c.index,
              class: Ct([
                { "active no-line": r.currentIndex === c.index },
                { confirmed: r.currentIndex > c.index },
                { "py-1": r.currentIndex > c.index },
                { "py-3": r.currentIndex <= c.index }
              ])
            }, [
              ve("table", null, [
                ve("tr", null, [
                  ve("td", null, [
                    ve("span", GF, [
                      r.currentIndex === c.index ? (Oe(), je("span", zF, "Step")) : mt("", !0),
                      r.currentIndex === c.index ? (Oe(), je("span", YF, "Attivo")) : mt("", !0),
                      r.currentIndex <= c.index ? (Oe(), je("span", XF, lt(c.index), 1)) : mt("", !0),
                      r.currentIndex > c.index ? (Oe(), Wt(u, {
                        key: 3,
                        class: "steppers-success",
                        icon: "it-check"
                      })) : mt("", !0),
                      r.currentIndex > c.index ? (Oe(), je("span", QF, "Confermato")) : mt("", !0)
                    ])
                  ]),
                  r.currentIndex <= c.index ? (Oe(), je("td", {
                    key: 0,
                    class: Ct([{ "k-stepper-title": r.currentIndex === c.index }, { "k-stepper-title-not-populated": r.currentIndex < c.index }])
                  }, lt(c.title), 3)) : (Oe(), je("td", JF, [
                    r.currentIndex > c.index ? (Oe(), je("span", ZF, lt(c.shortTitle), 1)) : mt("", !0),
                    qF,
                    r.currentIndex > c.index ? (Oe(), je("span", eU, lt(c.description), 1)) : mt("", !0)
                  ]))
                ])
              ])
            ], 2))), 128))
          ]),
          ve("span", tU, lt(t.value), 1)
        ])
      ]);
    };
  }
}), rU = ["aria-controls", "aria-selected", "href"], iU = {
  key: 0,
  class: "k-tab-counter-highlight bg-primary"
}, aU = /* @__PURE__ */ Dt({
  __name: "KTabs",
  props: {
    wrapperClass: {},
    navClass: {},
    noContentMargin: { type: Boolean, default: !1 }
  },
  emits: ["changed", "clicked", "to-link"],
  setup(n, { emit: e }) {
    kn();
    const t = $r(), r = n, o = e, u = Ht(() => r && r.noContentMargin === !0 ? "k-tab-no-content-margin" : ""), c = Ul({
      activeTabHash: "",
      lastActiveTabHash: "",
      tabs: []
    }), l = st(null), i = st([]);
    Ti("tabsProvider", c), Ti("addTab", (f) => {
      c.tabs.push(f);
    }), Ti("updateTab", (f, p) => {
      let d = c.tabs.findIndex((v) => v.computedId === f);
      p.isActive = c.tabs[d].isActive, c.tabs[d] = p;
    }), Ti("deleteTab", (f) => {
      let p = c.tabs.findIndex((d) => d.computedId === f);
      c.tabs.splice(p, 1);
    });
    const h = (f) => c.tabs.find((p) => p.hash === f);
    return ln(() => {
      var v;
      if (!c.tabs.length)
        return;
      var f = [].slice.call(l.value.querySelectorAll("a"));
      let p = (v = c.tabs.find((g) => t.matched.some((m) => m.path.includes(g.toLink)))) == null ? void 0 : v.hash, d = !1;
      f.forEach((g) => {
        let m = ai.getOrCreateInstance(g);
        if (i.value.push(m), p)
          p == g.hash && m.show();
        else if (!d) {
          d = !0;
          let A = h(m._element.hash);
          A != null && A.toLink && o("to-link", A.toLink), m.show();
        }
        g.addEventListener("click", (A) => {
          o("clicked", A.currentTarget.hash);
          let b = h(A.currentTarget.hash);
          b != null && b.toLink && o("to-link", b.toLink), o("changed", b);
          var S = document.querySelector(`[href='${A.currentTarget.hash}']`);
          ai.getInstance(S).show();
        });
      });
    }), (f, p) => (Oe(), je("div", {
      class: Ct(f.wrapperClass)
    }, [
      ve("ul", {
        class: Ct(["nav nav-tabs", f.navClass]),
        role: "tablist",
        ref_key: "kTab",
        ref: l
      }, [
        (Oe(!0), je(dn, null, Un(c.tabs, (d, v) => (Oe(), je("li", {
          key: v,
          class: "nav-item",
          style: { position: "relative" }
        }, [
          ve("a", {
            "data-bs-toggle": "tab",
            role: "tab",
            class: Ct(["nav-link", "px-5", (d.isDisabled, ""), d.isActive ? "active" : ""]),
            "aria-controls": d.hash,
            "aria-selected": d.isActive,
            href: d.hash
          }, lt(d.header), 11, rU),
          d.higlightCounter && d.higlightCounter > 0 ? (Oe(), je("div", iU, lt(d.higlightCounter), 1)) : mt("", !0)
        ]))), 128))
      ], 2),
      ve("div", {
        class: Ct(["tab-content", u.value])
      }, [
        pn(f.$slots, "default")
      ], 2)
    ], 2));
  }
}), oU = ["id", "aria-labelledby"], sU = /* @__PURE__ */ Dt({
  __name: "KTab",
  props: {
    id: {},
    name: {},
    prefix: { default: "" },
    suffix: { default: "" },
    isDisabled: { type: Boolean, default: !1 },
    higlightCounter: {},
    toLink: {},
    tabClass: {}
  },
  setup(n) {
    const e = n, t = st(null), r = st(!1), o = Ai("tabsProvider"), u = Ai("addTab"), c = Ai("updateTab"), l = Ai("deleteTab"), i = e.prefix + e.name + e.suffix, h = e.id ? e.id : e.name.toLowerCase().replace(/ /g, "-"), f = "#" + (e.isDisabled ? "" : h);
    return un(
      () => o.activeTabHash,
      () => {
        r.value = f === o.activeTabHash;
      }
    ), un(() => Object.assign({}, e), () => {
      c(h, {
        name: e.name,
        header: e.prefix + e.name + e.suffix,
        higlightCounter: e.higlightCounter,
        isDisabled: e.isDisabled,
        hash: f,
        toLink: e.toLink,
        index: o.tabs.length,
        computedId: h
      });
    }), yf(() => {
      u({
        name: e.name,
        header: i,
        higlightCounter: e.higlightCounter,
        isDisabled: e.isDisabled,
        hash: f,
        toLink: e.toLink,
        index: o.tabs.length,
        computedId: h
      });
    }), oi(() => {
      l(h);
    }), ln(() => {
    }), (p, d) => (Oe(), je("div", {
      class: Ct(["tab-pane p-4 fade", e.tabClass]),
      id: Ye(h),
      ref_key: "tab",
      ref: t,
      "aria-labelledby": p.id + "-tab",
      role: "tabpanel"
    }, [
      pn(p.$slots, "default")
    ], 10, oU));
  }
}), lU = { class: "toggles" }, uU = /* @__PURE__ */ ve("span", { class: "lever" }, null, -1), cU = /* @__PURE__ */ Dt({
  __name: "KToggle",
  props: {
    modelValue: { type: Boolean },
    label: { default: "" },
    disabled: { type: Boolean, default: !1 },
    group: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    st(null);
    const t = n, r = e, o = Ht({
      get: () => t.modelValue,
      set: (c) => r("update:modelValue", c)
    }), u = "ktoggle_" + Math.floor(Math.random() * 65536).toString();
    return (c, l) => (Oe(), je("div", {
      class: Ct(["form-check", { "form-check-group": t.group }])
    }, [
      ve("div", lU, [
        ve("label", { for: u }, [
          an(lt(t.label) + " ", 1),
          ha(ve("input", {
            type: "checkbox",
            id: u,
            "onUpdate:modelValue": l[0] || (l[0] = (i) => o.value = i),
            "true-value": !0,
            "false-value": !1
          }, null, 512), [
            [Ef, o.value]
          ]),
          uU
        ])
      ])
    ], 2));
  }
}), _m = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  K2ColContainer: iy,
  K3ColContainer: ay,
  KAlert: Cf,
  KBackButton: cy,
  KCard: bm,
  KCarousel: RC,
  KCheckbox: PC,
  KDataTableActions: aM,
  KDatePicker: lM,
  KDocumentPreview: hM,
  KFilterChips: xO,
  KGlobalCalendarCompact: kO,
  KGlobalSearchBar: jO,
  KHtmlEditor: Dx,
  KIcon: yn,
  KInputChips: Nx,
  KInputDate: kx,
  KInputFile: Qx,
  KInputNumber: TB,
  KInputPassword: $_,
  KInputSearch: G_,
  KInputText: z_,
  KInputTextArea: Y_,
  KLinkCarousel: IB,
  KModalCenter: kB,
  KModalFullPage: ev,
  KModalSlide: $B,
  KNavScroll: lF,
  KNavScrollItem: cF,
  KPaginator: PF,
  KRadioButton: wF,
  KSectionHeader: Ld,
  KSelect: WF,
  KSpinner: fd,
  KStepperHeader: nU,
  KTab: sU,
  KTabs: aU,
  KToggle: cU
}, Symbol.toStringTag, { value: "Module" })), fU = { class: "col-12" }, dU = /* @__PURE__ */ Dt({
  __name: "KNotificationPreviewCard",
  props: {
    notification: { default: null },
    showTime: { type: Boolean, default: !1 }
  },
  setup(n) {
    const { toDateString: e, toDateTimeString: t } = Gr(), r = kn(), { kToast: o } = Dr(), u = n, { getCustomNotificationHandlerForModule: c } = fn(), l = st(null);
    un(
      () => u.notification,
      (f, p) => {
        if (f != null) {
          const d = c(f.multichannelNotificationLite.module);
          d && d.previewCardhandler && (l.value = d.previewCardhandler.previewCardActionLabel(f));
        } else
          l.value = null;
      },
      { immediate: !0 }
    );
    const i = (f) => {
      if (!f)
        return;
      const p = c(f.multichannelNotificationLite.module);
      if (p && p.previewCardhandler && p.previewCardhandler.previewCardActionHandler)
        try {
          p.previewCardhandler.previewCardActionHandler(f, r);
        } catch (d) {
          o.showError((d == null ? void 0 : d.message) || "Unknown error.");
        }
    }, h = (f) => {
      r.push({ name: "notification-detail", params: { id: f } });
    };
    return (f, p) => {
      const d = Nt("KAlert");
      return Oe(), je("div", fU, [
        dt(d, {
          primaryButton: "APRI",
          secondaryButton: l.value,
          badge: f.showTime ? Ye(t)(f.notification.dateTime) : Ye(e)(f.notification.dateTime),
          title: f.notification.subject,
          body: f.notification.body,
          onOnPrimaryButtonClick: p[0] || (p[0] = (v) => h(f.notification.id)),
          onOnSecondaryButtonClick: p[1] || (p[1] = (v) => i(f.notification))
        }, null, 8, ["secondaryButton", "badge", "title", "body"])
      ]);
    };
  }
}), hU = /* @__PURE__ */ Dt({
  __name: "KLatestNotifications",
  props: {
    itemsToShow: { default: 3 },
    unreadOnly: { type: Boolean, default: !0 }
  },
  setup(n) {
    kn();
    const e = n, t = st(!1), r = st([]);
    ln(async () => {
      await o();
    });
    const o = async () => {
      t.value = !0;
      const u = await vi.getLatestInAppNotifications(e.itemsToShow, e.unreadOnly);
      u && (r.value = u.items), t.value = !1;
    };
    return (u, c) => {
      const l = Nt("KCarousel");
      return Oe(), Wt(l, { items: r.value }, {
        template: Ft((i) => [
          dt(dU, {
            notification: i.data,
            style: { "margin-bottom": "5px" }
          }, null, 8, ["notification"])
        ]),
        _: 1
      }, 8, ["items"]);
    };
  }
}), pU = {
  class: "card-wrapper",
  style: { width: "100%" }
}, mU = { class: "card card-img no-after" }, gU = { class: "img-responsive-wrapper" }, vU = { class: "img-responsive" }, _U = { class: "img-wrapper" }, EU = ["src"], yU = { class: "card-body" }, TU = { class: "text" }, AU = { class: "visually-hidden" }, SU = /* @__PURE__ */ Dt({
  __name: "KWebTvLatest",
  setup(n) {
    const e = Ql();
    return ln(() => {
      e.getLatestVideos();
    }), (t, r) => {
      const o = Nt("router-link"), u = Nt("KCarousel");
      return Oe(), Wt(u, {
        items: Ye(e).latestVideos
      }, {
        template: Ft((c) => [
          ve("div", pU, [
            ve("div", mU, [
              ve("div", gU, [
                ve("div", vU, [
                  ve("div", _U, [
                    ve("img", {
                      src: Ye(e).getLargeThumbnailUrl(c.data),
                      title: "titolo immagine",
                      alt: "descrizione immagine"
                    }, null, 8, EU)
                  ])
                ])
              ]),
              ve("div", yU, [
                dt(o, {
                  class: "read-more",
                  style: { position: "unset" },
                  to: "video/" + c.data.id
                }, {
                  default: Ft(() => [
                    ve("span", TU, lt(c.data.title), 1),
                    ve("span", AU, lt(c.data.title), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["items"]);
    };
  }
});
var X_ = { exports: {} };
(function(n, e) {
  (function(r, o) {
    n.exports = o();
  })(self, () => (
    /******/
    (() => {
      var t = {
        /***/
        "./externals/base64.js": (
          /*!*****************************!*\
            !*** ./externals/base64.js ***!
            \*****************************/
          /***/
          (c, l) => {
            var i = {};
            i.encode = function(f) {
              for (var p = [], d = 0; d < f.length; ++d) {
                var v = f.charCodeAt(d);
                v < 128 ? p.push(v) : v < 2048 ? (p.push(192 | v >> 6), p.push(128 | 63 & v)) : v < 65536 ? (p.push(224 | v >> 12), p.push(128 | 63 & v >> 6), p.push(128 | 63 & v)) : (p.push(240 | v >> 18), p.push(128 | 63 & v >> 12), p.push(128 | 63 & v >> 6), p.push(128 | 63 & v));
              }
              return p;
            }, i.decode = function(f) {
              for (var p = [], d = 0; d < f.length; ) {
                var v = f[d++];
                v < 128 || (v < 224 ? (v = (31 & v) << 6, v |= 63 & f[d++]) : v < 240 ? (v = (15 & v) << 12, v |= (63 & f[d++]) << 6, v |= 63 & f[d++]) : (v = (7 & v) << 18, v |= (63 & f[d++]) << 12, v |= (63 & f[d++]) << 6, v |= 63 & f[d++])), p.push(String.fromCharCode(v));
              }
              return p.join("");
            };
            var h = {};
            (function(f) {
              var p = function(A) {
                for (var b = 0, S = [], N = 0 | A.length / 3; 0 < N--; ) {
                  var T = (A[b] << 16) + (A[b + 1] << 8) + A[b + 2];
                  b += 3, S.push(f.charAt(63 & T >> 18)), S.push(f.charAt(63 & T >> 12)), S.push(f.charAt(63 & T >> 6)), S.push(f.charAt(63 & T));
                }
                if (A.length - b == 2) {
                  var T = (A[b] << 16) + (A[b + 1] << 8);
                  S.push(f.charAt(63 & T >> 18)), S.push(f.charAt(63 & T >> 12)), S.push(f.charAt(63 & T >> 6)), S.push("=");
                } else if (A.length - b == 1) {
                  var T = A[b] << 16;
                  S.push(f.charAt(63 & T >> 18)), S.push(f.charAt(63 & T >> 12)), S.push("==");
                }
                return S.join("");
              }, d = function() {
                for (var m = [], A = 0; A < f.length; ++A)
                  m[f.charCodeAt(A)] = A;
                return m["=".charCodeAt(0)] = 0, m;
              }(), v = function(A) {
                for (var b = 0, S = [], N = 0 | A.length / 4; 0 < N--; ) {
                  var T = (d[A.charCodeAt(b)] << 18) + (d[A.charCodeAt(b + 1)] << 12) + (d[A.charCodeAt(b + 2)] << 6) + d[A.charCodeAt(b + 3)];
                  S.push(255 & T >> 16), S.push(255 & T >> 8), S.push(255 & T), b += 4;
                }
                return S && (A.charAt(b - 2) == "=" ? (S.pop(), S.pop()) : A.charAt(b - 1) == "=" && S.pop()), S;
              }, g = {};
              g.encode = function(m) {
                for (var A = [], b = 0; b < m.length; ++b)
                  A.push(m.charCodeAt(b));
                return A;
              }, g.decode = function(m) {
                for (var A = 0; A < s.length; ++A)
                  a[A] = String.fromCharCode(a[A]);
                return a.join("");
              }, h.decodeArray = function(m) {
                var A = v(m);
                return new Uint8Array(A);
              }, h.encodeASCII = function(m) {
                var A = g.encode(m);
                return p(A);
              }, h.decodeASCII = function(m) {
                var A = v(m);
                return g.decode(A);
              }, h.encode = function(m) {
                var A = i.encode(m);
                return p(A);
              }, h.decode = function(m) {
                var A = v(m);
                return i.decode(A);
              };
            })("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"), l.decode = h.decode, l.decodeArray = h.decodeArray, l.encode = h.encode, l.encodeASCII = h.encodeASCII;
          }
        ),
        /***/
        "./externals/cea608-parser.js": (
          /*!************************************!*\
            !*** ./externals/cea608-parser.js ***!
            \************************************/
          /***/
          (c, l) => {
            (function(i) {
              var h = {
                42: 225,
                // lowercase a, acute accent
                92: 233,
                // lowercase e, acute accent
                94: 237,
                // lowercase i, acute accent
                95: 243,
                // lowercase o, acute accent
                96: 250,
                // lowercase u, acute accent
                123: 231,
                // lowercase c with cedilla
                124: 247,
                // division symbol
                125: 209,
                // uppercase N tilde
                126: 241,
                // lowercase n tilde
                127: 9608,
                // Full block
                // THIS BLOCK INCLUDES THE 16 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
                // THAT COME FROM HI BYTE=0x11 AND LOW BETWEEN 0x30 AND 0x3F
                // THIS MEANS THAT \x50 MUST BE ADDED TO THE VALUES
                128: 174,
                // Registered symbol (R)
                129: 176,
                // degree sign
                130: 189,
                // 1/2 symbol
                131: 191,
                // Inverted (open) question mark
                132: 8482,
                // Trademark symbol (TM)
                133: 162,
                // Cents symbol
                134: 163,
                // Pounds sterling
                135: 9834,
                // Music 8'th note
                136: 224,
                // lowercase a, grave accent
                137: 32,
                // transparent space (regular)
                138: 232,
                // lowercase e, grave accent
                139: 226,
                // lowercase a, circumflex accent
                140: 234,
                // lowercase e, circumflex accent
                141: 238,
                // lowercase i, circumflex accent
                142: 244,
                // lowercase o, circumflex accent
                143: 251,
                // lowercase u, circumflex accent
                // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
                // THAT COME FROM HI BYTE=0x12 AND LOW BETWEEN 0x20 AND 0x3F
                144: 193,
                // capital letter A with acute
                145: 201,
                // capital letter E with acute
                146: 211,
                // capital letter O with acute
                147: 218,
                // capital letter U with acute
                148: 220,
                // capital letter U with diaresis
                149: 252,
                // lowercase letter U with diaeresis
                150: 8216,
                // opening single quote
                151: 161,
                // inverted exclamation mark
                152: 42,
                // asterisk
                153: 8217,
                // closing single quote
                154: 9473,
                // box drawings heavy horizontal
                155: 169,
                // copyright sign
                156: 8480,
                // Service mark
                157: 8226,
                // (round) bullet
                158: 8220,
                // Left double quotation mark
                159: 8221,
                // Right double quotation mark
                160: 192,
                // uppercase A, grave accent
                161: 194,
                // uppercase A, circumflex
                162: 199,
                // uppercase C with cedilla
                163: 200,
                // uppercase E, grave accent
                164: 202,
                // uppercase E, circumflex
                165: 203,
                // capital letter E with diaresis
                166: 235,
                // lowercase letter e with diaresis
                167: 206,
                // uppercase I, circumflex
                168: 207,
                // uppercase I, with diaresis
                169: 239,
                // lowercase i, with diaresis
                170: 212,
                // uppercase O, circumflex
                171: 217,
                // uppercase U, grave accent
                172: 249,
                // lowercase u, grave accent
                173: 219,
                // uppercase U, circumflex
                174: 171,
                // left-pointing double angle quotation mark
                175: 187,
                // right-pointing double angle quotation mark
                // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
                // THAT COME FROM HI BYTE=0x13 AND LOW BETWEEN 0x20 AND 0x3F
                176: 195,
                // Uppercase A, tilde
                177: 227,
                // Lowercase a, tilde
                178: 205,
                // Uppercase I, acute accent
                179: 204,
                // Uppercase I, grave accent
                180: 236,
                // Lowercase i, grave accent
                181: 210,
                // Uppercase O, grave accent
                182: 242,
                // Lowercase o, grave accent
                183: 213,
                // Uppercase O, tilde
                184: 245,
                // Lowercase o, tilde
                185: 123,
                // Open curly brace
                186: 125,
                // Closing curly brace
                187: 92,
                // Backslash
                188: 94,
                // Caret
                189: 95,
                // Underscore
                190: 124,
                // Pipe (vertical line)
                191: 8764,
                // Tilde operator
                192: 196,
                // Uppercase A, umlaut
                193: 228,
                // Lowercase A, umlaut
                194: 214,
                // Uppercase O, umlaut
                195: 246,
                // Lowercase o, umlaut
                196: 223,
                // Esszett (sharp S)
                197: 165,
                // Yen symbol
                198: 164,
                // Generic currency sign
                199: 9475,
                // Box drawings heavy vertical
                200: 197,
                // Uppercase A, ring
                201: 229,
                // Lowercase A, ring
                202: 216,
                // Uppercase O, stroke
                203: 248,
                // Lowercase o, strok
                204: 9487,
                // Box drawings heavy down and right
                205: 9491,
                // Box drawings heavy down and left
                206: 9495,
                // Box drawings heavy up and right
                207: 9499
                // Box drawings heavy up and left
              }, f = function(C) {
                var I = C;
                return h.hasOwnProperty(C) && (I = h[C]), String.fromCharCode(I);
              }, p = 15, d = 32, v = {
                17: 1,
                18: 3,
                21: 5,
                22: 7,
                23: 9,
                16: 11,
                19: 12,
                20: 14
              }, g = {
                17: 2,
                18: 4,
                21: 6,
                22: 8,
                23: 10,
                19: 13,
                20: 15
              }, m = {
                25: 1,
                26: 3,
                29: 5,
                30: 7,
                31: 9,
                24: 11,
                27: 12,
                28: 14
              }, A = {
                25: 2,
                26: 4,
                29: 6,
                30: 8,
                31: 10,
                27: 13,
                28: 15
              }, b = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "black", "transparent"], S = {
                verboseFilter: {
                  DATA: 3,
                  DEBUG: 3,
                  INFO: 2,
                  WARNING: 2,
                  TEXT: 1,
                  ERROR: 0
                },
                time: null,
                verboseLevel: 0,
                // Only write errors
                setTime: function(C) {
                  this.time = C;
                },
                log: function(C, I) {
                  var w = this.verboseFilter[C];
                  this.verboseLevel >= w && console.log(this.time + " [" + C + "] " + I);
                }
              }, N = function(C) {
                for (var I = [], w = 0; w < C.length; w++)
                  I.push(C[w].toString(16));
                return I;
              }, T = function(C, I, w, F, k) {
                this.foreground = C || "white", this.underline = I || !1, this.italics = w || !1, this.background = F || "black", this.flash = k || !1;
              };
              T.prototype = {
                reset: function() {
                  this.foreground = "white", this.underline = !1, this.italics = !1, this.background = "black", this.flash = !1;
                },
                setStyles: function(C) {
                  for (var I = ["foreground", "underline", "italics", "background", "flash"], w = 0; w < I.length; w++) {
                    var F = I[w];
                    C.hasOwnProperty(F) && (this[F] = C[F]);
                  }
                },
                isDefault: function() {
                  return this.foreground === "white" && !this.underline && !this.italics && this.background === "black" && !this.flash;
                },
                equals: function(C) {
                  return this.foreground === C.foreground && this.underline === C.underline && this.italics === C.italics && this.background === C.background && this.flash === C.flash;
                },
                copy: function(C) {
                  this.foreground = C.foreground, this.underline = C.underline, this.italics = C.italics, this.background = C.background, this.flash = C.flash;
                },
                toString: function() {
                  return "color=" + this.foreground + ", underline=" + this.underline + ", italics=" + this.italics + ", background=" + this.background + ", flash=" + this.flash;
                }
              };
              var R = function(C, I, w, F, k, H) {
                this.uchar = C || " ", this.penState = new T(I, w, F, k, H);
              };
              R.prototype = {
                reset: function() {
                  this.uchar = " ", this.penState.reset();
                },
                setChar: function(C, I) {
                  this.uchar = C, this.penState.copy(I);
                },
                setPenState: function(C) {
                  this.penState.copy(C);
                },
                equals: function(C) {
                  return this.uchar === C.uchar && this.penState.equals(C.penState);
                },
                copy: function(C) {
                  this.uchar = C.uchar, this.penState.copy(C.penState);
                },
                isEmpty: function() {
                  return this.uchar === " " && this.penState.isDefault();
                }
              };
              var y = function() {
                this.chars = [];
                for (var C = 0; C < d; C++)
                  this.chars.push(new R());
                this.pos = 0, this.currPenState = new T();
              };
              y.prototype = {
                equals: function(C) {
                  for (var I = !0, w = 0; w < d; w++)
                    if (!this.chars[w].equals(C.chars[w])) {
                      I = !1;
                      break;
                    }
                  return I;
                },
                copy: function(C) {
                  for (var I = 0; I < d; I++)
                    this.chars[I].copy(C.chars[I]);
                },
                isEmpty: function() {
                  for (var C = !0, I = 0; I < d; I++)
                    if (!this.chars[I].isEmpty()) {
                      C = !1;
                      break;
                    }
                  return C;
                },
                /**
                 *  Set the cursor to a valid column.
                 */
                setCursor: function(C) {
                  this.pos !== C && (this.pos = C), this.pos < 0 ? (S.log("ERROR", "Negative cursor position " + this.pos), this.pos = 0) : this.pos > d && (S.log("ERROR", "Too large cursor position " + this.pos), this.pos = d);
                },
                /** 
                 * Move the cursor relative to current position.
                 */
                moveCursor: function(C) {
                  var I = this.pos + C;
                  if (C > 1)
                    for (var w = this.pos + 1; w < I + 1; w++)
                      this.chars[w].setPenState(this.currPenState);
                  this.setCursor(I);
                },
                /**
                 * Backspace, move one step back and clear character.
                 */
                backSpace: function() {
                  this.moveCursor(-1), this.chars[this.pos].setChar(" ", this.currPenState);
                },
                insertChar: function(C) {
                  C >= 144 && this.backSpace();
                  var I = f(C);
                  if (this.pos >= d) {
                    S.log("ERROR", "Cannot insert " + C.toString(16) + " (" + I + ") at position " + this.pos + ". Skipping it!");
                    return;
                  }
                  this.chars[this.pos].setChar(I, this.currPenState), this.moveCursor(1);
                },
                clearFromPos: function(C) {
                  var I;
                  for (I = C; I < d; I++)
                    this.chars[I].reset();
                },
                clear: function() {
                  this.clearFromPos(0), this.pos = 0, this.currPenState.reset();
                },
                clearToEndOfRow: function() {
                  this.clearFromPos(this.pos);
                },
                getTextString: function() {
                  for (var C = [], I = !0, w = 0; w < d; w++) {
                    var F = this.chars[w].uchar;
                    F !== " " && (I = !1), C.push(F);
                  }
                  return I ? "" : C.join("");
                },
                setPenStyles: function(C) {
                  this.currPenState.setStyles(C);
                  var I = this.chars[this.pos];
                  I.setPenState(this.currPenState);
                }
              };
              var E = function() {
                this.rows = [];
                for (var C = 0; C < p; C++)
                  this.rows.push(new y());
                this.currRow = p - 1, this.nrRollUpRows = null, this.reset();
              };
              E.prototype = {
                reset: function() {
                  for (var C = 0; C < p; C++)
                    this.rows[C].clear();
                  this.currRow = p - 1;
                },
                equals: function(C) {
                  for (var I = !0, w = 0; w < p; w++)
                    if (!this.rows[w].equals(C.rows[w])) {
                      I = !1;
                      break;
                    }
                  return I;
                },
                copy: function(C) {
                  for (var I = 0; I < p; I++)
                    this.rows[I].copy(C.rows[I]);
                },
                isEmpty: function() {
                  for (var C = !0, I = 0; I < p; I++)
                    if (!this.rows[I].isEmpty()) {
                      C = !1;
                      break;
                    }
                  return C;
                },
                backSpace: function() {
                  var C = this.rows[this.currRow];
                  C.backSpace();
                },
                clearToEndOfRow: function() {
                  var C = this.rows[this.currRow];
                  C.clearToEndOfRow();
                },
                /**
                 * Insert a character (without styling) in the current row.
                 */
                insertChar: function(C) {
                  var I = this.rows[this.currRow];
                  I.insertChar(C);
                },
                setPen: function(C) {
                  var I = this.rows[this.currRow];
                  I.setPenStyles(C);
                },
                moveCursor: function(C) {
                  var I = this.rows[this.currRow];
                  I.moveCursor(C);
                },
                setCursor: function(C) {
                  S.log("INFO", "setCursor: " + C);
                  var I = this.rows[this.currRow];
                  I.setCursor(C);
                },
                setPAC: function(C) {
                  S.log("INFO", "pacData = " + JSON.stringify(C));
                  var I = C.row - 1;
                  this.nrRollUpRows && I < this.nrRollUpRows - 1 && (I = this.nrRollUpRows - 1), this.currRow = I;
                  var w = this.rows[this.currRow];
                  if (C.indent !== null) {
                    var F = C.indent, k = Math.max(F - 1, 0);
                    w.setCursor(C.indent), C.color = w.chars[k].penState.foreground;
                  }
                  var H = {
                    foreground: C.color,
                    underline: C.underline,
                    italics: C.italics,
                    background: "black",
                    flash: !1
                  };
                  this.setPen(H);
                },
                /**
                 * Set background/extra foreground, but first do back_space, and then insert space (backwards compatibility).
                 */
                setBkgData: function(C) {
                  S.log("INFO", "bkgData = " + JSON.stringify(C)), this.backSpace(), this.setPen(C), this.insertChar(32);
                },
                setRollUpRows: function(C) {
                  this.nrRollUpRows = C;
                },
                rollUp: function() {
                  if (this.nrRollUpRows === null) {
                    S.log("DEBUG", "roll_up but nrRollUpRows not set yet");
                    return;
                  }
                  S.log("TEXT", this.getDisplayText());
                  var C = this.currRow + 1 - this.nrRollUpRows, I = this.rows.splice(C, 1)[0];
                  I.clear(), this.rows.splice(this.currRow, 0, I), S.log("INFO", "Rolling up");
                },
                /**
                 * Get all non-empty rows with as unicode text. 
                 */
                getDisplayText: function(C) {
                  C = C || !1;
                  for (var I = [], w = "", F = -1, k = 0; k < p; k++) {
                    var H = this.rows[k].getTextString();
                    H && (F = k + 1, C ? I.push("Row " + F + ': "' + H + '"') : I.push(H.trim()));
                  }
                  return I.length > 0 && (C ? w = "[" + I.join(" | ") + "]" : w = I.join(`
`)), w;
                },
                getTextAndFormat: function() {
                  return this.rows;
                }
              };
              var L = function(C, I) {
                this.chNr = C, this.outputFilter = I, this.mode = null, this.verbose = 0, this.displayedMemory = new E(), this.nonDisplayedMemory = new E(), this.lastOutputScreen = new E(), this.currRollUpRow = this.displayedMemory.rows[p - 1], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null;
              };
              L.prototype = {
                modes: ["MODE_ROLL-UP", "MODE_POP-ON", "MODE_PAINT-ON", "MODE_TEXT"],
                reset: function() {
                  this.mode = null, this.displayedMemory.reset(), this.nonDisplayedMemory.reset(), this.lastOutputScreen.reset(), this.currRollUpRow = this.displayedMemory.rows[p - 1], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null, this.lastCueEndTime = null;
                },
                getHandler: function() {
                  return this.outputFilter;
                },
                setHandler: function(C) {
                  this.outputFilter = C;
                },
                setPAC: function(C) {
                  this.writeScreen.setPAC(C);
                },
                setBkgData: function(C) {
                  this.writeScreen.setBkgData(C);
                },
                setMode: function(C) {
                  C !== this.mode && (this.mode = C, S.log("INFO", "MODE=" + C), this.mode == "MODE_POP-ON" ? this.writeScreen = this.nonDisplayedMemory : (this.writeScreen = this.displayedMemory, this.writeScreen.reset()), this.mode !== "MODE_ROLL-UP" && (this.displayedMemory.nrRollUpRows = null, this.nonDisplayedMemory.nrRollUpRows = null), this.mode = C);
                },
                insertChars: function(C) {
                  for (var I = 0; I < C.length; I++)
                    this.writeScreen.insertChar(C[I]);
                  var w = this.writeScreen === this.displayedMemory ? "DISP" : "NON_DISP";
                  S.log("INFO", w + ": " + this.writeScreen.getDisplayText(!0)), (this.mode === "MODE_PAINT-ON" || this.mode === "MODE_ROLL-UP") && (S.log("TEXT", "DISPLAYED: " + this.displayedMemory.getDisplayText(!0)), this.outputDataUpdate());
                },
                cc_RCL: function() {
                  S.log("INFO", "RCL - Resume Caption Loading"), this.setMode("MODE_POP-ON");
                },
                cc_BS: function() {
                  S.log("INFO", "BS - BackSpace"), this.mode !== "MODE_TEXT" && (this.writeScreen.backSpace(), this.writeScreen === this.displayedMemory && this.outputDataUpdate());
                },
                cc_AOF: function() {
                },
                cc_AON: function() {
                },
                cc_DER: function() {
                  S.log("INFO", "DER- Delete to End of Row"), this.writeScreen.clearToEndOfRow(), this.outputDataUpdate();
                },
                cc_RU: function(C) {
                  S.log("INFO", "RU(" + C + ") - Roll Up"), this.writeScreen = this.displayedMemory, this.setMode("MODE_ROLL-UP"), this.writeScreen.setRollUpRows(C);
                },
                cc_FON: function() {
                  S.log("INFO", "FON - Flash On"), this.writeScreen.setPen({
                    flash: !0
                  });
                },
                cc_RDC: function() {
                  S.log("INFO", "RDC - Resume Direct Captioning"), this.setMode("MODE_PAINT-ON");
                },
                cc_TR: function() {
                  S.log("INFO", "TR"), this.setMode("MODE_TEXT");
                },
                cc_RTD: function() {
                  S.log("INFO", "RTD"), this.setMode("MODE_TEXT");
                },
                cc_EDM: function() {
                  S.log("INFO", "EDM - Erase Displayed Memory"), this.displayedMemory.reset(), this.outputDataUpdate();
                },
                cc_CR: function() {
                  S.log("CR - Carriage Return"), this.writeScreen.rollUp(), this.outputDataUpdate();
                },
                cc_ENM: function() {
                  S.log("INFO", "ENM - Erase Non-displayed Memory"), this.nonDisplayedMemory.reset();
                },
                cc_EOC: function() {
                  if (S.log("INFO", "EOC - End Of Caption"), this.mode === "MODE_POP-ON") {
                    var C = this.displayedMemory;
                    this.displayedMemory = this.nonDisplayedMemory, this.nonDisplayedMemory = C, this.writeScreen = this.nonDisplayedMemory, S.log("TEXT", "DISP: " + this.displayedMemory.getDisplayText());
                  }
                  this.outputDataUpdate();
                },
                cc_TO: function(C) {
                  S.log("INFO", "TO(" + C + ") - Tab Offset"), this.writeScreen.moveCursor(C);
                },
                cc_MIDROW: function(C) {
                  var I = {
                    flash: !1
                  };
                  if (I.underline = C % 2 === 1, I.italics = C >= 46, I.italics)
                    I.foreground = "white";
                  else {
                    var w = Math.floor(C / 2) - 16, F = ["white", "green", "blue", "cyan", "red", "yellow", "magenta"];
                    I.foreground = F[w];
                  }
                  S.log("INFO", "MIDROW: " + JSON.stringify(I)), this.writeScreen.setPen(I);
                },
                outputDataUpdate: function() {
                  var C = S.time;
                  C !== null && this.outputFilter && (this.outputFilter.updateData && this.outputFilter.updateData(C, this.displayedMemory), this.cueStartTime === null && !this.displayedMemory.isEmpty() ? this.cueStartTime = C : this.displayedMemory.equals(this.lastOutputScreen) || (this.outputFilter.newCue && this.outputFilter.newCue(this.cueStartTime, C, this.lastOutputScreen), this.cueStartTime = this.displayedMemory.isEmpty() ? null : C), this.lastOutputScreen.copy(this.displayedMemory));
                },
                cueSplitAtTime: function(C) {
                  this.outputFilter && (this.displayedMemory.isEmpty() || (this.outputFilter.newCue && this.outputFilter.newCue(this.cueStartTime, C, this.displayedMemory), this.cueStartTime = C));
                }
              };
              var _ = function(C, I, w) {
                this.field = C || 1, this.outputs = [I, w], this.channels = [new L(1, I), new L(2, w)], this.currChNr = -1, this.lastCmdA = null, this.lastCmdB = null, this.bufferedData = [], this.startTime = null, this.lastTime = null, this.dataCounters = {
                  padding: 0,
                  char: 0,
                  cmd: 0,
                  other: 0
                };
              };
              _.prototype = {
                getHandler: function(C) {
                  return this.channels[C].getHandler();
                },
                setHandler: function(C, I) {
                  this.channels[C].setHandler(I);
                },
                /**
                 * Add data for time t in forms of list of bytes (unsigned ints). The bytes are treated as pairs.
                 */
                addData: function(C, I) {
                  var w, F, k, H = !1;
                  this.lastTime = C, S.setTime(C);
                  for (var Z = 0; Z < I.length; Z += 2) {
                    if (F = I[Z] & 127, k = I[Z + 1] & 127, F >= 16 && F <= 31 && F === this.lastCmdA && k === this.lastCmdB) {
                      this.lastCmdA = null, this.lastCmdB = null, S.log("DEBUG", "Repeated command (" + N([F, k]) + ") is dropped");
                      continue;
                    }
                    if (F === 0 && k === 0) {
                      this.dataCounters.padding += 2;
                      continue;
                    } else
                      S.log("DATA", "[" + N([I[Z], I[Z + 1]]) + "] -> (" + N([F, k]) + ")");
                    if (w = this.parseCmd(F, k), w || (w = this.parseMidrow(F, k)), w || (w = this.parsePAC(F, k)), w || (w = this.parseBackgroundAttributes(F, k)), !w && (H = this.parseChars(F, k), H))
                      if (this.currChNr && this.currChNr >= 0) {
                        var Y = this.channels[this.currChNr - 1];
                        Y.insertChars(H);
                      } else
                        S.log("WARNING", "No channel found yet. TEXT-MODE?");
                    w ? this.dataCounters.cmd += 2 : H ? this.dataCounters.char += 2 : (this.dataCounters.other += 2, S.log("WARNING", "Couldn't parse cleaned data " + N([F, k]) + " orig: " + N([I[Z], I[Z + 1]])));
                  }
                },
                /**
                 * Parse Command.
                 * @returns {Boolean} Tells if a command was found
                 */
                parseCmd: function(C, I) {
                  var w = null, F = (C === 20 || C === 21 || C === 28 || C === 29) && 32 <= I && I <= 47, k = (C === 23 || C === 31) && 33 <= I && I <= 35;
                  if (!(F || k))
                    return !1;
                  C === 20 || C === 21 || C === 23 ? w = 1 : w = 2;
                  var H = this.channels[w - 1];
                  return C === 20 || C === 21 || C === 28 || C === 29 ? I === 32 ? H.cc_RCL() : I === 33 ? H.cc_BS() : I === 34 ? H.cc_AOF() : I === 35 ? H.cc_AON() : I === 36 ? H.cc_DER() : I === 37 ? H.cc_RU(2) : I === 38 ? H.cc_RU(3) : I === 39 ? H.cc_RU(4) : I === 40 ? H.cc_FON() : I === 41 ? H.cc_RDC() : I === 42 ? H.cc_TR() : I === 43 ? H.cc_RTD() : I === 44 ? H.cc_EDM() : I === 45 ? H.cc_CR() : I === 46 ? H.cc_ENM() : I === 47 && H.cc_EOC() : H.cc_TO(I - 32), this.lastCmdA = C, this.lastCmdB = I, this.currChNr = w, !0;
                },
                /**
                 * Parse midrow styling command
                 * @returns {Boolean}
                 */
                parseMidrow: function(C, I) {
                  var w = null;
                  if ((C === 17 || C === 25) && 32 <= I && I <= 47) {
                    if (C === 17 ? w = 1 : w = 2, w !== this.currChNr)
                      return S.log("ERROR", "Mismatch channel in midrow parsing"), !1;
                    var F = this.channels[w - 1];
                    return F.insertChars([32]), F.cc_MIDROW(I), S.log("DEBUG", "MIDROW (" + N([C, I]) + ")"), this.lastCmdA = C, this.lastCmdB = I, !0;
                  }
                  return !1;
                },
                /**
                 * Parse Preable Access Codes (Table 53).
                 * @returns {Boolean} Tells if PAC found
                 */
                parsePAC: function(C, I) {
                  var w = null, F = null, k = (17 <= C && C <= 23 || 25 <= C && C <= 31) && 64 <= I && I <= 127, H = (C === 16 || C === 24) && 64 <= I && I <= 95;
                  if (!(k || H))
                    return !1;
                  w = C <= 23 ? 1 : 2, 64 <= I && I <= 95 ? F = w === 1 ? v[C] : m[C] : F = w === 1 ? g[C] : A[C];
                  var Z = this.interpretPAC(F, I), Y = this.channels[w - 1];
                  return Y.setPAC(Z), this.lastCmdA = C, this.lastCmdB = I, this.currChNr = w, !0;
                },
                /**
                 * Interpret the second byte of the pac, and return the information.
                 * @returns {Object} pacData with style parameters.
                 */
                interpretPAC: function(C, I) {
                  var w = I, F = {
                    color: null,
                    italics: !1,
                    indent: null,
                    underline: !1,
                    row: C
                  };
                  return I > 95 ? w = I - 96 : w = I - 64, F.underline = (w & 1) === 1, w <= 13 ? F.color = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "white"][Math.floor(w / 2)] : w <= 15 ? (F.italics = !0, F.color = "white") : F.indent = Math.floor((w - 16) / 2) * 4, F;
                },
                /**
                 * Parse characters.
                 * @returns An array with 1 to 2 codes corresponding to chars, if found. null otherwise.
                 */
                parseChars: function(C, I) {
                  var w = null, F = null, k = null;
                  if (C >= 25 ? (w = 2, k = C - 8) : (w = 1, k = C), 17 <= k && k <= 19) {
                    var H = I;
                    k === 17 ? H = I + 80 : k === 18 ? H = I + 112 : H = I + 144, S.log("INFO", "Special char '" + f(H) + "' in channel " + w), F = [H], this.lastCmdA = C, this.lastCmdB = I;
                  } else
                    32 <= C && C <= 127 && (F = I === 0 ? [C] : [C, I], this.lastCmdA = null, this.lastCmdB = null);
                  if (F) {
                    var Z = N(F);
                    S.log("DEBUG", "Char codes =  " + Z.join(","));
                  }
                  return F;
                },
                /**
                * Parse extended background attributes as well as new foreground color black.
                * @returns{Boolean} Tells if background attributes are found
                */
                parseBackgroundAttributes: function(C, I) {
                  var w, F, k, H, Z = (C === 16 || C === 24) && 32 <= I && I <= 47, Y = (C === 23 || C === 31) && 45 <= I && I <= 47;
                  return Z || Y ? (w = {}, C === 16 || C === 24 ? (F = Math.floor((I - 32) / 2), w.background = b[F], I % 2 === 1 && (w.background = w.background + "_semi")) : I === 45 ? w.background = "transparent" : (w.foreground = "black", I === 47 && (w.underline = !0)), k = C < 24 ? 1 : 2, H = this.channels[k - 1], H.setBkgData(w), this.lastCmdA = C, this.lastCmdB = I, !0) : !1;
                },
                /**
                 * Reset state of parser and its channels.
                 */
                reset: function() {
                  for (var C = 0; C < this.channels.length; C++)
                    this.channels[C] && this.channels[C].reset();
                  this.lastCmdA = null, this.lastCmdB = null;
                },
                /**
                 * Trigger the generation of a cue, and the start of a new one if displayScreens are not empty.
                 */
                cueSplitAtTime: function(C) {
                  for (var I = 0; I < this.channels.length; I++)
                    this.channels[I] && this.channels[I].cueSplitAtTime(C);
                }
              };
              var O = function(C, I, w) {
                for (var F = 0, k = I, H = 0, Z = [], Y = function(ie, re, ce, z) {
                  if (ie !== 4 || re < 8)
                    return null;
                  var oe = ce.getUint8(z), de = ce.getUint16(z + 1), pe = ce.getUint32(z + 3), he = ce.getUint8(z + 7);
                  return oe == 181 && de == 49 && pe == 1195456820 && he == 3;
                }; k < I + w; ) {
                  if (F = C.getUint32(k), H = C.getUint8(k + 4) & 31, H === 6)
                    for (var j = k + 5, J = -1; j < k + 4 + F - 1; ) {
                      J = 0;
                      for (var ae = 255; ae === 255; )
                        ae = C.getUint8(j), J += ae, j++;
                      var G = 0;
                      for (ae = 255; ae === 255; )
                        ae = C.getUint8(j), G += ae, j++;
                      Y(J, G, C, j) && Z.push([j, G]), j += G;
                    }
                  k += F + 4;
                }
                return Z;
              }, D = function(C, I) {
                var w = I[0], F = [[], []];
                w += 8;
                var k = C.getUint8(w) & 31;
                w += 2;
                for (var H = 0; H < k; H++) {
                  var Z = C.getUint8(w), Y = Z & 4, j = Z & 3;
                  w++;
                  var J = C.getUint8(w);
                  w++;
                  var ae = C.getUint8(w);
                  w++, Y && (J & 127) + (ae & 127) !== 0 && (j === 0 ? (F[0].push(J), F[0].push(ae)) : j === 1 && (F[1].push(J), F[1].push(ae)));
                }
                return F;
              };
              i.logger = S, i.PenState = T, i.CaptionScreen = E, i.Cea608Parser = _, i.findCea608Nalus = O, i.extractCea608DataFromRange = D;
            })(l);
          }
        ),
        /***/
        "./externals/xml2json.js": (
          /*!*******************************!*\
            !*** ./externals/xml2json.js ***!
            \*******************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => f
              /* harmony export */
            });
            function h(p) {
              var d = "1.2.0";
              p = p || {}, v();
              function v() {
                p.escapeMode === void 0 && (p.escapeMode = !0), p.attributePrefix === void 0 && (p.attributePrefix = "_"), p.arrayAccessForm = p.arrayAccessForm || "none", p.emptyNodeForm = p.emptyNodeForm || "text", p.enableToStringFunc === void 0 && (p.enableToStringFunc = !0), p.arrayAccessFormPaths = p.arrayAccessFormPaths || [], p.skipEmptyTextNodesForObj === void 0 && (p.skipEmptyTextNodesForObj = !0), p.stripWhitespaces === void 0 && (p.stripWhitespaces = !0), p.datetimeAccessFormPaths = p.datetimeAccessFormPaths || [], p.useDoubleQuotes === void 0 && (p.useDoubleQuotes = !1), p.xmlElementsFilter = p.xmlElementsFilter || [], p.jsonPropertiesFilter = p.jsonPropertiesFilter || [], p.keepCData === void 0 && (p.keepCData = !1), p.ignoreRoot === void 0 && (p.ignoreRoot = !1);
              }
              var g = {
                ELEMENT_NODE: 1,
                TEXT_NODE: 3,
                CDATA_SECTION_NODE: 4,
                COMMENT_NODE: 8,
                DOCUMENT_NODE: 9
              };
              function m(Y) {
                var j = Y.localName;
                return j == null && (j = Y.baseName), (j == null || j == "") && (j = Y.nodeName), j;
              }
              function A(Y) {
                return Y.prefix;
              }
              function b(Y) {
                return typeof Y == "string" ? Y.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;") : Y;
              }
              function S(Y, j, J, ae) {
                for (var G = 0; G < Y.length; G++) {
                  var $ = Y[G];
                  if (typeof $ == "string") {
                    if ($ == ae)
                      break;
                  } else if ($ instanceof RegExp) {
                    if ($.test(ae))
                      break;
                  } else if (typeof $ == "function" && $(j, J, ae))
                    break;
                }
                return G != Y.length;
              }
              function N(Y, j, J) {
                switch (p.arrayAccessForm) {
                  case "property":
                    Y[j] instanceof Array ? Y[j + "_asArray"] = Y[j] : Y[j + "_asArray"] = [Y[j]];
                    break;
                }
                !(Y[j] instanceof Array) && p.arrayAccessFormPaths.length > 0 && S(p.arrayAccessFormPaths, Y, j, J) && (Y[j] = [Y[j]]);
              }
              function T(Y) {
                var j = Y.split(/[-T:+Z]/g), J = new Date(j[0], j[1] - 1, j[2]), ae = j[5].split(".");
                if (J.setHours(j[3], j[4], ae[0]), ae.length > 1 && J.setMilliseconds(ae[1]), j[6] && j[7]) {
                  var G = j[6] * 60 + Number(j[7]), $ = /\d\d-\d\d:\d\d$/.test(Y) ? "-" : "+";
                  G = 0 + ($ == "-" ? -1 * G : G), J.setMinutes(J.getMinutes() - G - J.getTimezoneOffset());
                } else
                  Y.indexOf("Z", Y.length - 1) !== -1 && (J = new Date(Date.UTC(J.getFullYear(), J.getMonth(), J.getDate(), J.getHours(), J.getMinutes(), J.getSeconds(), J.getMilliseconds())));
                return J;
              }
              function R(Y, j, J) {
                if (p.datetimeAccessFormPaths.length > 0) {
                  var ae = J.split(".#")[0];
                  return S(p.datetimeAccessFormPaths, Y, j, ae) ? T(Y) : Y;
                } else
                  return Y;
              }
              function y(Y, j, J, ae) {
                return j == g.ELEMENT_NODE && p.xmlElementsFilter.length > 0 ? S(p.xmlElementsFilter, Y, J, ae) : !0;
              }
              function E(Y, j) {
                if (Y.nodeType == g.DOCUMENT_NODE) {
                  for (var J = new Object(), ae = Y.childNodes, G = 0; G < ae.length; G++) {
                    var $ = ae[G];
                    if ($.nodeType == g.ELEMENT_NODE)
                      if (p.ignoreRoot)
                        J = E($);
                      else {
                        J = {};
                        var ie = m($);
                        J[ie] = E($);
                      }
                  }
                  return J;
                } else if (Y.nodeType == g.ELEMENT_NODE) {
                  var J = new Object();
                  J.__cnt = 0;
                  for (var re = [], ae = Y.childNodes, G = 0; G < ae.length; G++) {
                    var $ = ae[G], ie = m($);
                    if ($.nodeType != g.COMMENT_NODE) {
                      var ce = j + "." + ie;
                      if (y(J, $.nodeType, ie, ce))
                        if (J.__cnt++, J[ie] == null) {
                          var z = E($, ce);
                          if (ie != "#text" || /[^\s]/.test(z)) {
                            var oe = {};
                            oe[ie] = z, re.push(oe);
                          }
                          J[ie] = z, N(J, ie, ce);
                        } else {
                          J[ie] != null && (J[ie] instanceof Array || (J[ie] = [J[ie]], N(J, ie, ce)));
                          var z = E($, ce);
                          if (ie != "#text" || /[^\s]/.test(z)) {
                            var oe = {};
                            oe[ie] = z, re.push(oe);
                          }
                          J[ie][J[ie].length] = z;
                        }
                    }
                  }
                  J.__children = re;
                  for (var de = m(Y), pe = 0; pe < Y.attributes.length; pe++) {
                    var he = Y.attributes[pe];
                    J.__cnt++;
                    for (var se = he.value, ee = 0, te = p.matchers.length; ee < te; ee++) {
                      var le = p.matchers[ee];
                      le.test(he, de) && (se = le.converter(he.value));
                    }
                    J[p.attributePrefix + he.name] = se;
                  }
                  var ne = A(Y);
                  return ne != null && ne != "" && (J.__cnt++, J.__prefix = ne), J["#text"] != null && (J.__text = J["#text"], J.__text instanceof Array && (J.__text = J.__text.join(`
`)), p.stripWhitespaces && (J.__text = J.__text.trim()), delete J["#text"], p.arrayAccessForm == "property" && delete J["#text_asArray"], J.__text = R(J.__text, ie, j + "." + ie)), J["#cdata-section"] != null && (J.__cdata = J["#cdata-section"], delete J["#cdata-section"], p.arrayAccessForm == "property" && delete J["#cdata-section_asArray"]), J.__cnt == 0 && p.emptyNodeForm == "text" ? J = "" : J.__cnt == 1 && J.__text != null ? J = J.__text : J.__cnt == 1 && J.__cdata != null && !p.keepCData ? J = J.__cdata : J.__cnt > 1 && J.__text != null && p.skipEmptyTextNodesForObj && (p.stripWhitespaces && J.__text == "" || J.__text.trim() == "") && delete J.__text, delete J.__cnt, p.enableToStringFunc && (J.__text != null || J.__cdata != null) && (J.toString = function() {
                    return (this.__text != null ? this.__text : "") + (this.__cdata != null ? this.__cdata : "");
                  }), J;
                } else if (Y.nodeType == g.TEXT_NODE || Y.nodeType == g.CDATA_SECTION_NODE)
                  return Y.nodeValue;
              }
              function L(Y, j, J, ae) {
                var G = "<" + (Y != null && Y.__prefix != null ? Y.__prefix + ":" : "") + j;
                if (J != null)
                  for (var $ = 0; $ < J.length; $++) {
                    var ie = J[$], re = Y[ie];
                    p.escapeMode && (re = b(re)), G += " " + ie.substr(p.attributePrefix.length) + "=", p.useDoubleQuotes ? G += '"' + re + '"' : G += "'" + re + "'";
                  }
                return ae ? G += "/>" : G += ">", G;
              }
              function _(Y, j) {
                return "</" + (Y.__prefix != null ? Y.__prefix + ":" : "") + j + ">";
              }
              function O(Y, j) {
                return Y.indexOf(j, Y.length - j.length) !== -1;
              }
              function D(Y, j) {
                return !!(p.arrayAccessForm == "property" && O(j.toString(), "_asArray") || j.toString().indexOf(p.attributePrefix) == 0 || j.toString().indexOf("__") == 0 || Y[j] instanceof Function);
              }
              function M(Y) {
                var j = 0;
                if (Y instanceof Object)
                  for (var J in Y)
                    D(Y, J) || j++;
                return j;
              }
              function C(Y, j, J) {
                return p.jsonPropertiesFilter.length == 0 || J == "" || S(p.jsonPropertiesFilter, Y, j, J);
              }
              function I(Y) {
                var j = [];
                if (Y instanceof Object)
                  for (var J in Y)
                    J.toString().indexOf("__") == -1 && J.toString().indexOf(p.attributePrefix) == 0 && j.push(J);
                return j;
              }
              function w(Y) {
                var j = "";
                return Y.__cdata != null && (j += "<![CDATA[" + Y.__cdata + "]]>"), Y.__text != null && (p.escapeMode ? j += b(Y.__text) : j += Y.__text), j;
              }
              function F(Y) {
                var j = "";
                return Y instanceof Object ? j += w(Y) : Y != null && (p.escapeMode ? j += b(Y) : j += Y), j;
              }
              function k(Y, j) {
                return Y === "" ? j : Y + "." + j;
              }
              function H(Y, j, J, ae) {
                var G = "";
                if (Y.length == 0)
                  G += L(Y, j, J, !0);
                else
                  for (var $ = 0; $ < Y.length; $++)
                    G += L(Y[$], j, I(Y[$]), !1), G += Z(Y[$], k(ae, j)), G += _(Y[$], j);
                return G;
              }
              function Z(Y, j) {
                var J = "", ae = M(Y);
                if (ae > 0) {
                  for (var G in Y)
                    if (!(D(Y, G) || j != "" && !C(Y, G, k(j, G)))) {
                      var $ = Y[G], ie = I($);
                      if ($ == null || $ == null)
                        J += L($, G, ie, !0);
                      else if ($ instanceof Object)
                        if ($ instanceof Array)
                          J += H($, G, ie, j);
                        else if ($ instanceof Date)
                          J += L($, G, ie, !1), J += $.toISOString(), J += _($, G);
                        else {
                          var re = M($);
                          re > 0 || $.__text != null || $.__cdata != null ? (J += L($, G, ie, !1), J += Z($, k(j, G)), J += _($, G)) : J += L($, G, ie, !0);
                        }
                      else
                        J += L($, G, ie, !1), J += F($), J += _($, G);
                    }
                }
                return J += F(Y), J;
              }
              this.parseXmlString = function(Y) {
                if (Y === void 0)
                  return null;
                var j;
                if (window.DOMParser) {
                  var J = new window.DOMParser();
                  try {
                    j = J.parseFromString(Y, "text/xml"), j.getElementsByTagNameNS("*", "parsererror").length > 0 && (j = null);
                  } catch {
                    j = null;
                  }
                } else
                  Y.indexOf("<?") == 0 && (Y = Y.substr(Y.indexOf("?>") + 2)), j = new ActiveXObject("Microsoft.XMLDOM"), j.async = "false", j.loadXML(Y);
                return j;
              }, this.asArray = function(Y) {
                return Y === void 0 || Y == null ? [] : Y instanceof Array ? Y : [Y];
              }, this.toXmlDateTime = function(Y) {
                return Y instanceof Date ? Y.toISOString() : typeof Y == "number" ? new Date(Y).toISOString() : null;
              }, this.asDateTime = function(Y) {
                return typeof Y == "string" ? T(Y) : Y;
              }, this.xml2json = function(Y) {
                return E(Y);
              }, this.xml_str2json = function(Y) {
                var j = this.parseXmlString(Y);
                return j != null ? this.xml2json(j) : null;
              }, this.json2xml_str = function(Y) {
                return Z(Y, "");
              }, this.json2xml = function(Y) {
                var j = this.json2xml_str(Y);
                return this.parseXmlString(j);
              }, this.getVersion = function() {
                return d;
              };
            }
            const f = h;
          }
        ),
        /***/
        "./index_mediaplayerOnly.js": (
          /*!**********************************!*\
            !*** ./index_mediaplayerOnly.js ***!
            \**********************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              Debug: () => (
                /* reexport safe */
                p.default
              ),
              /* harmony export */
              FactoryMaker: () => (
                /* reexport safe */
                f.default
              ),
              /* harmony export */
              MediaPlayer: () => (
                /* reexport safe */
                h.default
              ),
              /* harmony export */
              default: () => m
              /* harmony export */
            });
            var h = i(
              /*! ./src/streaming/MediaPlayer */
              "./src/streaming/MediaPlayer.js"
            ), f = i(
              /*! ./src/core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), p = i(
              /*! ./src/core/Debug */
              "./src/core/Debug.js"
            ), d = i(
              /*! ./src/core/Version */
              "./src/core/Version.js"
            );
            i(
              /*! es6-promise/auto */
              "./node_modules/es6-promise/auto.js"
            );
            var v = typeof window < "u" && window || i.g, g = v.dashjs;
            g || (g = v.dashjs = {}), g.MediaPlayer = h.default, g.FactoryMaker = f.default, g.Debug = p.default, g.Version = (0, d.getVersionString)();
            const m = g;
          }
        ),
        /***/
        "./src/core/Debug.js": (
          /*!***************************!*\
            !*** ./src/core/Debug.js ***!
            \***************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => T
              /* harmony export */
            });
            var h = i(
              /*! ./EventBus */
              "./src/core/EventBus.js"
            ), f = i(
              /*! ./events/Events */
              "./src/core/events/Events.js"
            ), p = i(
              /*! ./FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), d = 0, v = 1, g = 2, m = 3, A = 4, b = 5;
            function S(R) {
              R = R || {};
              var y = this.context, E = (0, h.default)(y).getInstance(), L = R.settings, _ = [], O, D, M, C;
              function I() {
                D = !0, M = !0, C = (/* @__PURE__ */ new Date()).getTime(), typeof window < "u" && window.console && (_[v] = w(window.console.error), _[g] = w(window.console.error), _[m] = w(window.console.warn), _[A] = w(window.console.info), _[b] = w(window.console.debug));
              }
              function w($) {
                return $ && $.bind ? $.bind(window.console) : window.console.log.bind(window.console);
              }
              function F($) {
                return {
                  fatal: Z.bind($),
                  error: Y.bind($),
                  warn: j.bind($),
                  info: J.bind($),
                  debug: ae.bind($)
                };
              }
              function k($) {
                D = $;
              }
              function H($) {
                M = $;
              }
              function Z() {
                for (var $ = arguments.length, ie = new Array($), re = 0; re < $; re++)
                  ie[re] = arguments[re];
                G.apply(void 0, [v, this].concat(ie));
              }
              function Y() {
                for (var $ = arguments.length, ie = new Array($), re = 0; re < $; re++)
                  ie[re] = arguments[re];
                G.apply(void 0, [g, this].concat(ie));
              }
              function j() {
                for (var $ = arguments.length, ie = new Array($), re = 0; re < $; re++)
                  ie[re] = arguments[re];
                G.apply(void 0, [m, this].concat(ie));
              }
              function J() {
                for (var $ = arguments.length, ie = new Array($), re = 0; re < $; re++)
                  ie[re] = arguments[re];
                G.apply(void 0, [A, this].concat(ie));
              }
              function ae() {
                for (var $ = arguments.length, ie = new Array($), re = 0; re < $; re++)
                  ie[re] = arguments[re];
                G.apply(void 0, [b, this].concat(ie));
              }
              function G($, ie) {
                var re = "", ce = null;
                D && (ce = (/* @__PURE__ */ new Date()).getTime(), re += "[" + (ce - C) + "]"), M && ie && ie.getClassName && (re += "[" + ie.getClassName() + "]", ie.getType && (re += "[" + ie.getType() + "]")), re.length > 0 && (re += " ");
                for (var z = arguments.length, oe = new Array(z > 2 ? z - 2 : 0), de = 2; de < z; de++)
                  oe[de - 2] = arguments[de];
                Array.apply(null, oe).forEach(function(pe) {
                  re += pe + " ";
                }), _[$] && L && L.get().debug.logLevel >= $ && _[$](re), L && L.get().debug.dispatchEvent && E.trigger(f.default.LOG, {
                  message: re,
                  level: $
                });
              }
              return O = {
                getLogger: F,
                setLogTimestampVisible: k,
                setCalleeNameVisible: H
              }, I(), O;
            }
            S.__dashjs_factory_name = "Debug";
            var N = p.default.getSingletonFactory(S);
            N.LOG_LEVEL_NONE = d, N.LOG_LEVEL_FATAL = v, N.LOG_LEVEL_ERROR = g, N.LOG_LEVEL_WARNING = m, N.LOG_LEVEL_INFO = A, N.LOG_LEVEL_DEBUG = b, p.default.updateSingletonFactory(S.__dashjs_factory_name, N);
            const T = N;
          }
        ),
        /***/
        "./src/core/EventBus.js": (
          /*!******************************!*\
            !*** ./src/core/EventBus.js ***!
            \******************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => m
              /* harmony export */
            });
            var h = i(
              /*! ./FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ../streaming/MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), p = 0, d = 5e3;
            function v() {
              var A = {};
              function b(E, L, _) {
                var O = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
                if (!E)
                  throw new Error("event type cannot be null or undefined");
                if (!L || typeof L != "function")
                  throw new Error("listener must be a function: " + L);
                var D = O.priority || p;
                if (!(T(E, L, _) >= 0)) {
                  A[E] = A[E] || [];
                  var M = {
                    callback: L,
                    scope: _,
                    priority: D
                  };
                  _ && _.getStreamId && (M.streamId = _.getStreamId()), _ && _.getType && (M.mediaType = _.getType()), O && O.mode && (M.mode = O.mode);
                  var C = A[E].some(function(I, w) {
                    if (I && D > I.priority)
                      return A[E].splice(w, 0, M), !0;
                  });
                  C || A[E].push(M);
                }
              }
              function S(E, L, _) {
                if (!(!E || !L || !A[E])) {
                  var O = T(E, L, _);
                  O < 0 || (A[E][O] = null);
                }
              }
              function N(E) {
                var L = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                if (!(!E || !A[E])) {
                  if (L = L || {}, L.hasOwnProperty("type"))
                    throw new Error("'type' is a reserved word for event dispatching");
                  L.type = E, _.streamId && (L.streamId = _.streamId), _.mediaType && (L.mediaType = _.mediaType), A[E].filter(function(O) {
                    return !(!O || _.streamId && O.streamId && O.streamId !== _.streamId || _.mediaType && O.mediaType && O.mediaType !== _.mediaType || _.mode && O.mode && O.mode !== _.mode || !O.mode && _.mode && _.mode === f.default.EVENT_MODE_ON_RECEIVE);
                  }).forEach(function(O) {
                    return O && O.callback.call(O.scope, L);
                  });
                }
              }
              function T(E, L, _) {
                var O = -1;
                return A[E] && A[E].some(function(D, M) {
                  if (D && D.callback === L && (!_ || _ === D.scope))
                    return O = M, !0;
                }), O;
              }
              function R() {
                A = {};
              }
              var y = {
                on: b,
                off: S,
                trigger: N,
                reset: R
              };
              return y;
            }
            v.__dashjs_factory_name = "EventBus";
            var g = h.default.getSingletonFactory(v);
            g.EVENT_PRIORITY_LOW = p, g.EVENT_PRIORITY_HIGH = d, h.default.updateSingletonFactory(v.__dashjs_factory_name, g);
            const m = g;
          }
        ),
        /***/
        "./src/core/FactoryMaker.js": (
          /*!**********************************!*\
            !*** ./src/core/FactoryMaker.js ***!
            \**********************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => f
              /* harmony export */
            });
            var h = function() {
              var p, d = [], v = {}, g = {};
              function m(M, C, I, w) {
                !w[M] && C && (w[M] = {
                  instance: C,
                  override: I
                });
              }
              function A(M, C) {
                for (var I in d) {
                  var w = d[I];
                  if (w.context === M && w.name === C)
                    return w.instance;
                }
                return null;
              }
              function b(M, C, I) {
                for (var w in d) {
                  var F = d[w];
                  if (F.context === M && F.name === C) {
                    d[w].instance = I;
                    return;
                  }
                }
                d.push({
                  name: C,
                  context: M,
                  instance: I
                });
              }
              function S(M) {
                d = d.filter(function(C) {
                  return C.context !== M;
                });
              }
              function N(M, C) {
                return C[M];
              }
              function T(M, C, I) {
                M in I && (I[M] = C);
              }
              function R(M, C) {
                T(M, C, g);
              }
              function y(M) {
                return N(M, g);
              }
              function E(M) {
                var C = N(M.__dashjs_factory_name, g);
                return C || (C = function(w) {
                  return w === void 0 && (w = {}), {
                    create: function() {
                      return D(M, w, arguments);
                    }
                  };
                }, g[M.__dashjs_factory_name] = C), C;
              }
              function L(M, C) {
                T(M, C, v);
              }
              function _(M) {
                return N(M, v);
              }
              function O(M) {
                var C = N(M.__dashjs_factory_name, v);
                return C || (C = function(w) {
                  var F;
                  return w === void 0 && (w = {}), {
                    getInstance: function() {
                      return F || (F = A(w, M.__dashjs_factory_name)), F || (F = D(M, w, arguments), d.push({
                        name: M.__dashjs_factory_name,
                        context: w,
                        instance: F
                      })), F;
                    }
                  };
                }, v[M.__dashjs_factory_name] = C), C;
              }
              function D(M, C, I) {
                var w, F = M.__dashjs_factory_name, k = C[F];
                if (k) {
                  var H = k.instance;
                  if (k.override) {
                    w = M.apply({
                      context: C
                    }, I), H = H.apply({
                      context: C,
                      factory: p,
                      parent: w
                    }, I);
                    for (var Z in H)
                      w.hasOwnProperty(Z) && (w[Z] = H[Z]);
                  } else
                    return H.apply({
                      context: C,
                      factory: p
                    }, I);
                } else
                  w = M.apply({
                    context: C
                  }, I);
                return w.getClassName = function() {
                  return F;
                }, w;
              }
              return p = {
                extend: m,
                getSingletonInstance: A,
                setSingletonInstance: b,
                deleteSingletonInstances: S,
                getSingletonFactory: O,
                getSingletonFactoryByName: _,
                updateSingletonFactory: L,
                getClassFactory: E,
                getClassFactoryByName: y,
                updateClassFactory: R
              }, p;
            }();
            const f = h;
          }
        ),
        /***/
        "./src/core/Settings.js": (
          /*!******************************!*\
            !*** ./src/core/Settings.js ***!
            \******************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => T
              /* harmony export */
            });
            var h = i(
              /*! ./FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ./Utils.js */
              "./src/core/Utils.js"
            ), p = i(
              /*! ../core/Debug */
              "./src/core/Debug.js"
            ), d = i(
              /*! ../streaming/constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), v = i(
              /*! ../streaming/vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            ), g = i(
              /*! ./EventBus */
              "./src/core/EventBus.js"
            ), m = i(
              /*! ./events/Events */
              "./src/core/events/Events.js"
            );
            function A(R) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? A = function(E) {
                return typeof E;
              } : A = function(E) {
                return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
              }, A(R);
            }
            function b(R, y, E) {
              return y in R ? Object.defineProperty(R, y, { value: E, enumerable: !0, configurable: !0, writable: !0 }) : R[y] = E, R;
            }
            function S() {
              var R, y, E, L = this.context, _ = (0, g.default)(L).getInstance(), O = {
                "streaming.delay.liveDelay": m.default.SETTING_UPDATED_LIVE_DELAY,
                "streaming.delay.liveDelayFragmentCount": m.default.SETTING_UPDATED_LIVE_DELAY_FRAGMENT_COUNT,
                "streaming.liveCatchup.enabled": m.default.SETTING_UPDATED_CATCHUP_ENABLED,
                "streaming.liveCatchup.playbackRate.min": m.default.SETTING_UPDATED_PLAYBACK_RATE_MIN,
                "streaming.liveCatchup.playbackRate.max": m.default.SETTING_UPDATED_PLAYBACK_RATE_MAX
              }, D = {
                debug: {
                  logLevel: p.default.LOG_LEVEL_WARNING,
                  dispatchEvent: !1
                },
                streaming: {
                  abandonLoadTimeout: 1e4,
                  wallclockTimeUpdateInterval: 100,
                  manifestUpdateRetryInterval: 100,
                  cacheInitSegments: !1,
                  applyServiceDescription: !0,
                  applyProducerReferenceTime: !0,
                  applyContentSteering: !0,
                  eventControllerRefreshDelay: 100,
                  enableManifestDurationMismatchFix: !0,
                  enableManifestTimescaleMismatchFix: !1,
                  capabilities: {
                    filterUnsupportedEssentialProperties: !0,
                    useMediaCapabilitiesApi: !1
                  },
                  timeShiftBuffer: {
                    calcFromSegmentTimeline: !1,
                    fallbackToSegmentTimeline: !0
                  },
                  metrics: {
                    maxListDepth: 100
                  },
                  delay: {
                    liveDelayFragmentCount: NaN,
                    liveDelay: NaN,
                    useSuggestedPresentationDelay: !0
                  },
                  protection: {
                    keepProtectionMediaKeys: !1,
                    ignoreEmeEncryptedEvent: !1,
                    detectPlayreadyMessageFormat: !0
                  },
                  buffer: {
                    enableSeekDecorrelationFix: !1,
                    fastSwitchEnabled: !0,
                    flushBufferAtTrackSwitch: !1,
                    reuseExistingSourceBuffers: !0,
                    bufferPruningInterval: 10,
                    bufferToKeep: 20,
                    bufferTimeAtTopQuality: 30,
                    bufferTimeAtTopQualityLongForm: 60,
                    initialBufferLevel: NaN,
                    stableBufferTime: 12,
                    longFormContentDurationThreshold: 600,
                    stallThreshold: 0.3,
                    useAppendWindow: !0,
                    setStallState: !0,
                    avoidCurrentTimeRangePruning: !1,
                    useChangeTypeForTrackSwitch: !0
                  },
                  gaps: {
                    jumpGaps: !0,
                    jumpLargeGaps: !0,
                    smallGapLimit: 1.5,
                    threshold: 0.3,
                    enableSeekFix: !0,
                    enableStallFix: !1,
                    stallSeek: 0.1
                  },
                  utcSynchronization: {
                    enabled: !0,
                    useManifestDateHeaderTimeSource: !0,
                    backgroundAttempts: 2,
                    timeBetweenSyncAttempts: 30,
                    maximumTimeBetweenSyncAttempts: 600,
                    minimumTimeBetweenSyncAttempts: 2,
                    timeBetweenSyncAttemptsAdjustmentFactor: 2,
                    maximumAllowedDrift: 100,
                    enableBackgroundSyncAfterSegmentDownloadError: !0,
                    defaultTimingSource: {
                      scheme: "urn:mpeg:dash:utc:http-xsdate:2014",
                      value: "https://time.akamai.com/?iso&ms"
                    }
                  },
                  scheduling: {
                    defaultTimeout: 500,
                    lowLatencyTimeout: 0,
                    scheduleWhilePaused: !0
                  },
                  text: {
                    defaultEnabled: !0,
                    extendSegmentedCues: !0,
                    webvtt: {
                      customRenderingEnabled: !1
                    }
                  },
                  liveCatchup: {
                    maxDrift: NaN,
                    playbackRate: {
                      min: NaN,
                      max: NaN
                    },
                    playbackBufferMin: 0.5,
                    enabled: null,
                    mode: d.default.LIVE_CATCHUP_MODE_DEFAULT
                  },
                  lastBitrateCachingInfo: {
                    enabled: !0,
                    ttl: 36e4
                  },
                  lastMediaSettingsCachingInfo: {
                    enabled: !0,
                    ttl: 36e4
                  },
                  cacheLoadThresholds: {
                    video: 50,
                    audio: 5
                  },
                  trackSwitchMode: {
                    audio: d.default.TRACK_SWITCH_MODE_ALWAYS_REPLACE,
                    video: d.default.TRACK_SWITCH_MODE_NEVER_REPLACE
                  },
                  selectionModeForInitialTrack: d.default.TRACK_SELECTION_MODE_HIGHEST_SELECTION_PRIORITY,
                  fragmentRequestTimeout: 2e4,
                  manifestRequestTimeout: 1e4,
                  retryIntervals: (R = {}, b(R, v.HTTPRequest.MPD_TYPE, 500), b(R, v.HTTPRequest.XLINK_EXPANSION_TYPE, 500), b(R, v.HTTPRequest.MEDIA_SEGMENT_TYPE, 1e3), b(R, v.HTTPRequest.INIT_SEGMENT_TYPE, 1e3), b(R, v.HTTPRequest.BITSTREAM_SWITCHING_SEGMENT_TYPE, 1e3), b(R, v.HTTPRequest.INDEX_SEGMENT_TYPE, 1e3), b(R, v.HTTPRequest.MSS_FRAGMENT_INFO_SEGMENT_TYPE, 1e3), b(R, v.HTTPRequest.LICENSE, 1e3), b(R, v.HTTPRequest.OTHER_TYPE, 1e3), b(R, "lowLatencyReductionFactor", 10), R),
                  retryAttempts: (y = {}, b(y, v.HTTPRequest.MPD_TYPE, 3), b(y, v.HTTPRequest.XLINK_EXPANSION_TYPE, 1), b(y, v.HTTPRequest.MEDIA_SEGMENT_TYPE, 3), b(y, v.HTTPRequest.INIT_SEGMENT_TYPE, 3), b(y, v.HTTPRequest.BITSTREAM_SWITCHING_SEGMENT_TYPE, 3), b(y, v.HTTPRequest.INDEX_SEGMENT_TYPE, 3), b(y, v.HTTPRequest.MSS_FRAGMENT_INFO_SEGMENT_TYPE, 3), b(y, v.HTTPRequest.LICENSE, 3), b(y, v.HTTPRequest.OTHER_TYPE, 3), b(y, "lowLatencyMultiplyFactor", 5), y),
                  abr: {
                    movingAverageMethod: d.default.MOVING_AVERAGE_SLIDING_WINDOW,
                    ABRStrategy: d.default.ABR_STRATEGY_DYNAMIC,
                    additionalAbrRules: {
                      insufficientBufferRule: !0,
                      switchHistoryRule: !0,
                      droppedFramesRule: !0,
                      abandonRequestsRule: !0
                    },
                    bandwidthSafetyFactor: 0.9,
                    useDefaultABRRules: !0,
                    useDeadTimeLatency: !0,
                    limitBitrateByPortal: !1,
                    usePixelRatioInLimitBitrateByPortal: !1,
                    maxBitrate: {
                      audio: -1,
                      video: -1
                    },
                    minBitrate: {
                      audio: -1,
                      video: -1
                    },
                    maxRepresentationRatio: {
                      audio: 1,
                      video: 1
                    },
                    initialBitrate: {
                      audio: -1,
                      video: -1
                    },
                    initialRepresentationRatio: {
                      audio: -1,
                      video: -1
                    },
                    autoSwitchBitrate: {
                      audio: !0,
                      video: !0
                    },
                    fetchThroughputCalculationMode: d.default.ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING
                  },
                  cmcd: {
                    enabled: !1,
                    sid: null,
                    cid: null,
                    rtp: null,
                    rtpSafetyFactor: 5,
                    mode: d.default.CMCD_MODE_QUERY,
                    enabledKeys: ["br", "d", "ot", "tb", "bl", "dl", "mtp", "nor", "nrr", "su", "bs", "rtp", "cid", "pr", "sf", "sid", "st", "v"]
                  },
                  cmsd: {
                    enabled: !1,
                    abr: {
                      applyMb: !1,
                      etpWeightRatio: 0
                    }
                  }
                },
                errors: {
                  recoverAttempts: {
                    mediaErrorDecode: 5
                  }
                }
              }, M = f.default.clone(D);
              function C(k, H, Z) {
                for (var Y in k)
                  k.hasOwnProperty(Y) && (H.hasOwnProperty(Y) ? A(k[Y]) === "object" && !(k[Y] instanceof Array) && k[Y] !== null ? C(k[Y], H[Y], Z.slice() + Y + ".") : (H[Y] = f.default.clone(k[Y]), O[Z + Y] && _.trigger(O[Z + Y])) : console.error("Settings parameter " + Z + Y + " is not supported"));
              }
              function I() {
                return M;
              }
              function w(k) {
                A(k) === "object" && C(k, M, "");
              }
              function F() {
                M = f.default.clone(D);
              }
              return E = {
                get: I,
                update: w,
                reset: F
              }, E;
            }
            S.__dashjs_factory_name = "Settings";
            var N = h.default.getSingletonFactory(S);
            const T = N;
          }
        ),
        /***/
        "./src/core/Utils.js": (
          /*!***************************!*\
            !*** ./src/core/Utils.js ***!
            \***************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => b
              /* harmony export */
            });
            var h = i(
              /*! path-browserify */
              "./node_modules/path-browserify/index.js"
            ), f = /* @__PURE__ */ i.n(h), p = i(
              /*! ua-parser-js */
              "./node_modules/ua-parser-js/src/ua-parser.js"
            );
            function d(S) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? d = function(T) {
                return typeof T;
              } : d = function(T) {
                return T && typeof Symbol == "function" && T.constructor === Symbol && T !== Symbol.prototype ? "symbol" : typeof T;
              }, d(S);
            }
            function v(S, N) {
              if (!(S instanceof N))
                throw new TypeError("Cannot call a class as a function");
            }
            function g(S, N) {
              for (var T = 0; T < N.length; T++) {
                var R = N[T];
                R.enumerable = R.enumerable || !1, R.configurable = !0, "value" in R && (R.writable = !0), Object.defineProperty(S, R.key, R);
              }
            }
            function m(S, N, T) {
              return N && g(S.prototype, N), T && g(S, T), S;
            }
            var A = /* @__PURE__ */ function() {
              function S() {
                v(this, S);
              }
              return m(S, null, [{
                key: "mixin",
                value: function(T, R, y) {
                  var E, L = {};
                  if (T)
                    for (var _ in R)
                      R.hasOwnProperty(_) && (E = R[_], (!(_ in T) || T[_] !== E && (!(_ in L) || L[_] !== E)) && (d(T[_]) === "object" && T[_] !== null ? T[_] = S.mixin(T[_], E, y) : T[_] = y(E)));
                  return T;
                }
              }, {
                key: "clone",
                value: function(T) {
                  if (!T || d(T) !== "object")
                    return T;
                  var R;
                  if (T instanceof Array) {
                    R = [];
                    for (var y = 0, E = T.length; y < E; ++y)
                      y in T && R.push(S.clone(T[y]));
                  } else
                    R = {};
                  return S.mixin(R, T, S.clone);
                }
              }, {
                key: "addAditionalQueryParameterToUrl",
                value: function(T, R) {
                  try {
                    if (!R || R.length === 0)
                      return T;
                    var y = new URL(T);
                    return R.forEach(function(E) {
                      E.key && E.value && y.searchParams.set(E.key, E.value);
                    }), y.href;
                  } catch {
                    return T;
                  }
                }
              }, {
                key: "parseHttpHeaders",
                value: function(T) {
                  var R = {};
                  if (!T)
                    return R;
                  for (var y = T.trim().split(`\r
`), E = 0, L = y.length; E < L; E++) {
                    var _ = y[E], O = _.indexOf(": ");
                    O > 0 && (R[_.substring(0, O)] = _.substring(O + 2));
                  }
                  return R;
                }
              }, {
                key: "generateUuid",
                value: function() {
                  var T = (/* @__PURE__ */ new Date()).getTime(), R = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(y) {
                    var E = (T + Math.random() * 16) % 16 | 0;
                    return T = Math.floor(T / 16), (y == "x" ? E : E & 3 | 8).toString(16);
                  });
                  return R;
                }
              }, {
                key: "generateHashCode",
                value: function(T) {
                  var R = 0;
                  if (T.length === 0)
                    return R;
                  for (var y = 0; y < T.length; y++) {
                    var E = T.charCodeAt(y);
                    R = (R << 5) - R + E, R |= 0;
                  }
                  return R;
                }
                /**
                 * Compares both urls and returns a relative url (target relative to original)
                 * @param {string} original
                 * @param {string} target
                 * @return {string|*}
                 */
              }, {
                key: "getRelativeUrl",
                value: function(T, R) {
                  try {
                    var y = new URL(T), E = new URL(R);
                    if (y.protocol = E.protocol, y.origin !== E.origin)
                      return R;
                    var L = f().relative(y.pathname.substr(0, y.pathname.lastIndexOf("/")), E.pathname.substr(0, E.pathname.lastIndexOf("/"))), _ = L.length === 0 ? 1 : 0;
                    return L += E.pathname.substr(E.pathname.lastIndexOf("/") + _, E.pathname.length - 1), E.pathname.length < L.length ? E.pathname : L;
                  } catch {
                    return R;
                  }
                }
              }, {
                key: "parseUserAgent",
                value: function() {
                  var T = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                  try {
                    var R = T === null && typeof navigator < "u" ? navigator.userAgent.toLowerCase() : "";
                    return (0, p.UAParser)(R);
                  } catch {
                    return {};
                  }
                }
              }]), S;
            }();
            const b = A;
          }
        ),
        /***/
        "./src/core/Version.js": (
          /*!*****************************!*\
            !*** ./src/core/Version.js ***!
            \*****************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              getVersionString: () => (
                /* binding */
                f
              )
              /* harmony export */
            });
            var h = "4.6.0";
            function f() {
              return h;
            }
          }
        ),
        /***/
        "./src/core/errors/Errors.js": (
          /*!***********************************!*\
            !*** ./src/core/errors/Errors.js ***!
            \***********************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => R
              /* harmony export */
            });
            var h = i(
              /*! ./ErrorsBase */
              "./src/core/errors/ErrorsBase.js"
            );
            function f(y) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? f = function(L) {
                return typeof L;
              } : f = function(L) {
                return L && typeof Symbol == "function" && L.constructor === Symbol && L !== Symbol.prototype ? "symbol" : typeof L;
              }, f(y);
            }
            function p(y, E) {
              if (!(y instanceof E))
                throw new TypeError("Cannot call a class as a function");
            }
            function d(y, E) {
              if (typeof E != "function" && E !== null)
                throw new TypeError("Super expression must either be null or a function");
              y.prototype = Object.create(E && E.prototype, { constructor: { value: y, writable: !0, configurable: !0 } }), E && v(y, E);
            }
            function v(y, E) {
              return v = Object.setPrototypeOf || function(_, O) {
                return _.__proto__ = O, _;
              }, v(y, E);
            }
            function g(y) {
              var E = b();
              return function() {
                var _ = S(y), O;
                if (E) {
                  var D = S(this).constructor;
                  O = Reflect.construct(_, arguments, D);
                } else
                  O = _.apply(this, arguments);
                return m(this, O);
              };
            }
            function m(y, E) {
              return E && (f(E) === "object" || typeof E == "function") ? E : A(y);
            }
            function A(y) {
              if (y === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return y;
            }
            function b() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return !1;
              if (typeof Proxy == "function")
                return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function S(y) {
              return S = Object.setPrototypeOf ? Object.getPrototypeOf : function(L) {
                return L.__proto__ || Object.getPrototypeOf(L);
              }, S(y);
            }
            var N = /* @__PURE__ */ function(y) {
              d(L, y);
              var E = g(L);
              function L() {
                var _;
                return p(this, L), _ = E.call(this), _.MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE = 10, _.MANIFEST_LOADER_LOADING_FAILURE_ERROR_CODE = 11, _.XLINK_LOADER_LOADING_FAILURE_ERROR_CODE = 12, _.SEGMENT_BASE_LOADER_ERROR_CODE = 15, _.TIME_SYNC_FAILED_ERROR_CODE = 16, _.FRAGMENT_LOADER_LOADING_FAILURE_ERROR_CODE = 17, _.FRAGMENT_LOADER_NULL_REQUEST_ERROR_CODE = 18, _.URL_RESOLUTION_FAILED_GENERIC_ERROR_CODE = 19, _.APPEND_ERROR_CODE = 20, _.REMOVE_ERROR_CODE = 21, _.DATA_UPDATE_FAILED_ERROR_CODE = 22, _.CAPABILITY_MEDIASOURCE_ERROR_CODE = 23, _.CAPABILITY_MEDIAKEYS_ERROR_CODE = 24, _.DOWNLOAD_ERROR_ID_MANIFEST_CODE = 25, _.DOWNLOAD_ERROR_ID_SIDX_CODE = 26, _.DOWNLOAD_ERROR_ID_CONTENT_CODE = 27, _.DOWNLOAD_ERROR_ID_INITIALIZATION_CODE = 28, _.DOWNLOAD_ERROR_ID_XLINK_CODE = 29, _.MANIFEST_ERROR_ID_PARSE_CODE = 31, _.MANIFEST_ERROR_ID_NOSTREAMS_CODE = 32, _.TIMED_TEXT_ERROR_ID_PARSE_CODE = 33, _.MANIFEST_ERROR_ID_MULTIPLEXED_CODE = 34, _.MEDIASOURCE_TYPE_UNSUPPORTED_CODE = 35, _.MANIFEST_LOADER_PARSING_FAILURE_ERROR_MESSAGE = "parsing failed for ", _.MANIFEST_LOADER_LOADING_FAILURE_ERROR_MESSAGE = "Failed loading manifest: ", _.XLINK_LOADER_LOADING_FAILURE_ERROR_MESSAGE = "Failed loading Xlink element: ", _.SEGMENTS_UPDATE_FAILED_ERROR_MESSAGE = "Segments update failed", _.SEGMENTS_UNAVAILABLE_ERROR_MESSAGE = "no segments are available yet", _.SEGMENT_BASE_LOADER_ERROR_MESSAGE = "error loading segment ranges from sidx", _.TIME_SYNC_FAILED_ERROR_MESSAGE = "Failed to synchronize client and server time", _.FRAGMENT_LOADER_NULL_REQUEST_ERROR_MESSAGE = "request is null", _.URL_RESOLUTION_FAILED_GENERIC_ERROR_MESSAGE = "Failed to resolve a valid URL", _.APPEND_ERROR_MESSAGE = "chunk is not defined", _.REMOVE_ERROR_MESSAGE = "Removing data from the SourceBuffer", _.DATA_UPDATE_FAILED_ERROR_MESSAGE = "Data update failed", _.CAPABILITY_MEDIASOURCE_ERROR_MESSAGE = "mediasource is not supported", _.CAPABILITY_MEDIAKEYS_ERROR_MESSAGE = "mediakeys is not supported", _.TIMED_TEXT_ERROR_MESSAGE_PARSE = "parsing error :", _.MEDIASOURCE_TYPE_UNSUPPORTED_MESSAGE = "Error creating source buffer of type : ", _;
              }
              return L;
            }(h.default), T = new N();
            const R = T;
          }
        ),
        /***/
        "./src/core/errors/ErrorsBase.js": (
          /*!***************************************!*\
            !*** ./src/core/errors/ErrorsBase.js ***!
            \***************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            function h(g, m) {
              if (!(g instanceof m))
                throw new TypeError("Cannot call a class as a function");
            }
            function f(g, m) {
              for (var A = 0; A < m.length; A++) {
                var b = m[A];
                b.enumerable = b.enumerable || !1, b.configurable = !0, "value" in b && (b.writable = !0), Object.defineProperty(g, b.key, b);
              }
            }
            function p(g, m, A) {
              return m && f(g.prototype, m), A && f(g, A), g;
            }
            var d = /* @__PURE__ */ function() {
              function g() {
                h(this, g);
              }
              return p(g, [{
                key: "extend",
                value: function(A, b) {
                  if (A) {
                    var S = b ? b.override : !1, N = b ? b.publicOnly : !1;
                    for (var T in A)
                      !A.hasOwnProperty(T) || this[T] && !S || N && A[T].indexOf("public_") === -1 || (this[T] = A[T]);
                  }
                }
              }]), g;
            }();
            const v = d;
          }
        ),
        /***/
        "./src/core/events/CoreEvents.js": (
          /*!***************************************!*\
            !*** ./src/core/events/CoreEvents.js ***!
            \***************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => T
              /* harmony export */
            });
            var h = i(
              /*! ./EventsBase */
              "./src/core/events/EventsBase.js"
            );
            function f(R) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? f = function(E) {
                return typeof E;
              } : f = function(E) {
                return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
              }, f(R);
            }
            function p(R, y) {
              if (!(R instanceof y))
                throw new TypeError("Cannot call a class as a function");
            }
            function d(R, y) {
              if (typeof y != "function" && y !== null)
                throw new TypeError("Super expression must either be null or a function");
              R.prototype = Object.create(y && y.prototype, { constructor: { value: R, writable: !0, configurable: !0 } }), y && v(R, y);
            }
            function v(R, y) {
              return v = Object.setPrototypeOf || function(L, _) {
                return L.__proto__ = _, L;
              }, v(R, y);
            }
            function g(R) {
              var y = b();
              return function() {
                var L = S(R), _;
                if (y) {
                  var O = S(this).constructor;
                  _ = Reflect.construct(L, arguments, O);
                } else
                  _ = L.apply(this, arguments);
                return m(this, _);
              };
            }
            function m(R, y) {
              return y && (f(y) === "object" || typeof y == "function") ? y : A(R);
            }
            function A(R) {
              if (R === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return R;
            }
            function b() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return !1;
              if (typeof Proxy == "function")
                return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function S(R) {
              return S = Object.setPrototypeOf ? Object.getPrototypeOf : function(E) {
                return E.__proto__ || Object.getPrototypeOf(E);
              }, S(R);
            }
            var N = /* @__PURE__ */ function(R) {
              d(E, R);
              var y = g(E);
              function E() {
                var L;
                return p(this, E), L = y.call(this), L.ATTEMPT_BACKGROUND_SYNC = "attemptBackgroundSync", L.BUFFERING_COMPLETED = "bufferingCompleted", L.BUFFER_CLEARED = "bufferCleared", L.BYTES_APPENDED_END_FRAGMENT = "bytesAppendedEndFragment", L.BUFFER_REPLACEMENT_STARTED = "bufferReplacementStarted", L.CHECK_FOR_EXISTENCE_COMPLETED = "checkForExistenceCompleted", L.CMSD_STATIC_HEADER = "cmsdStaticHeader", L.CURRENT_TRACK_CHANGED = "currentTrackChanged", L.DATA_UPDATE_COMPLETED = "dataUpdateCompleted", L.INBAND_EVENTS = "inbandEvents", L.INITIAL_STREAM_SWITCH = "initialStreamSwitch", L.INIT_FRAGMENT_LOADED = "initFragmentLoaded", L.INIT_FRAGMENT_NEEDED = "initFragmentNeeded", L.INTERNAL_MANIFEST_LOADED = "internalManifestLoaded", L.ORIGINAL_MANIFEST_LOADED = "originalManifestLoaded", L.LOADING_COMPLETED = "loadingCompleted", L.LOADING_PROGRESS = "loadingProgress", L.LOADING_DATA_PROGRESS = "loadingDataProgress", L.LOADING_ABANDONED = "loadingAborted", L.MANIFEST_UPDATED = "manifestUpdated", L.MEDIA_FRAGMENT_LOADED = "mediaFragmentLoaded", L.MEDIA_FRAGMENT_NEEDED = "mediaFragmentNeeded", L.QUOTA_EXCEEDED = "quotaExceeded", L.SEGMENT_LOCATION_BLACKLIST_ADD = "segmentLocationBlacklistAdd", L.SEGMENT_LOCATION_BLACKLIST_CHANGED = "segmentLocationBlacklistChanged", L.SERVICE_LOCATION_BLACKLIST_ADD = "serviceLocationBlacklistAdd", L.SERVICE_LOCATION_BLACKLIST_CHANGED = "serviceLocationBlacklistChanged", L.SET_FRAGMENTED_TEXT_AFTER_DISABLED = "setFragmentedTextAfterDisabled", L.SET_NON_FRAGMENTED_TEXT = "setNonFragmentedText", L.SOURCE_BUFFER_ERROR = "sourceBufferError", L.STREAMS_COMPOSED = "streamsComposed", L.STREAM_BUFFERING_COMPLETED = "streamBufferingCompleted", L.STREAM_REQUESTING_COMPLETED = "streamRequestingCompleted", L.TEXT_TRACKS_QUEUE_INITIALIZED = "textTracksQueueInitialized", L.TIME_SYNCHRONIZATION_COMPLETED = "timeSynchronizationComplete", L.UPDATE_TIME_SYNC_OFFSET = "updateTimeSyncOffset", L.URL_RESOLUTION_FAILED = "urlResolutionFailed", L.VIDEO_CHUNK_RECEIVED = "videoChunkReceived", L.WALLCLOCK_TIME_UPDATED = "wallclockTimeUpdated", L.XLINK_ELEMENT_LOADED = "xlinkElementLoaded", L.XLINK_READY = "xlinkReady", L.SEEK_TARGET = "seekTarget", L.SETTING_UPDATED_LIVE_DELAY = "settingUpdatedLiveDelay", L.SETTING_UPDATED_LIVE_DELAY_FRAGMENT_COUNT = "settingUpdatedLiveDelayFragmentCount", L.SETTING_UPDATED_CATCHUP_ENABLED = "settingUpdatedCatchupEnabled", L.SETTING_UPDATED_PLAYBACK_RATE_MIN = "settingUpdatedPlaybackRateMin", L.SETTING_UPDATED_PLAYBACK_RATE_MAX = "settingUpdatedPlaybackRateMax", L;
              }
              return E;
            }(h.default);
            const T = N;
          }
        ),
        /***/
        "./src/core/events/Events.js": (
          /*!***********************************!*\
            !*** ./src/core/events/Events.js ***!
            \***********************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => R
              /* harmony export */
            });
            var h = i(
              /*! ./CoreEvents */
              "./src/core/events/CoreEvents.js"
            );
            function f(y) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? f = function(L) {
                return typeof L;
              } : f = function(L) {
                return L && typeof Symbol == "function" && L.constructor === Symbol && L !== Symbol.prototype ? "symbol" : typeof L;
              }, f(y);
            }
            function p(y, E) {
              if (!(y instanceof E))
                throw new TypeError("Cannot call a class as a function");
            }
            function d(y, E) {
              if (typeof E != "function" && E !== null)
                throw new TypeError("Super expression must either be null or a function");
              y.prototype = Object.create(E && E.prototype, { constructor: { value: y, writable: !0, configurable: !0 } }), E && v(y, E);
            }
            function v(y, E) {
              return v = Object.setPrototypeOf || function(_, O) {
                return _.__proto__ = O, _;
              }, v(y, E);
            }
            function g(y) {
              var E = b();
              return function() {
                var _ = S(y), O;
                if (E) {
                  var D = S(this).constructor;
                  O = Reflect.construct(_, arguments, D);
                } else
                  O = _.apply(this, arguments);
                return m(this, O);
              };
            }
            function m(y, E) {
              return E && (f(E) === "object" || typeof E == "function") ? E : A(y);
            }
            function A(y) {
              if (y === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return y;
            }
            function b() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return !1;
              if (typeof Proxy == "function")
                return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function S(y) {
              return S = Object.setPrototypeOf ? Object.getPrototypeOf : function(L) {
                return L.__proto__ || Object.getPrototypeOf(L);
              }, S(y);
            }
            var N = /* @__PURE__ */ function(y) {
              d(L, y);
              var E = g(L);
              function L() {
                return p(this, L), E.apply(this, arguments);
              }
              return L;
            }(h.default), T = new N();
            const R = T;
          }
        ),
        /***/
        "./src/core/events/EventsBase.js": (
          /*!***************************************!*\
            !*** ./src/core/events/EventsBase.js ***!
            \***************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            function h(g, m) {
              if (!(g instanceof m))
                throw new TypeError("Cannot call a class as a function");
            }
            function f(g, m) {
              for (var A = 0; A < m.length; A++) {
                var b = m[A];
                b.enumerable = b.enumerable || !1, b.configurable = !0, "value" in b && (b.writable = !0), Object.defineProperty(g, b.key, b);
              }
            }
            function p(g, m, A) {
              return m && f(g.prototype, m), A && f(g, A), g;
            }
            var d = /* @__PURE__ */ function() {
              function g() {
                h(this, g);
              }
              return p(g, [{
                key: "extend",
                value: function(A, b) {
                  if (A) {
                    var S = b ? b.override : !1, N = b ? b.publicOnly : !1;
                    for (var T in A)
                      !A.hasOwnProperty(T) || this[T] && !S || N && A[T].indexOf("public_") === -1 || (this[T] = A[T]);
                  }
                }
              }]), g;
            }();
            const v = d;
          }
        ),
        /***/
        "./src/dash/DashAdapter.js": (
          /*!*********************************!*\
            !*** ./src/dash/DashAdapter.js ***!
            \*********************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => R
              /* harmony export */
            });
            var h = i(
              /*! ./constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            ), f = i(
              /*! ./vo/RepresentationInfo */
              "./src/dash/vo/RepresentationInfo.js"
            ), p = i(
              /*! ./vo/MediaInfo */
              "./src/dash/vo/MediaInfo.js"
            ), d = i(
              /*! ./vo/StreamInfo */
              "./src/dash/vo/StreamInfo.js"
            ), v = i(
              /*! ./vo/ManifestInfo */
              "./src/dash/vo/ManifestInfo.js"
            ), g = i(
              /*! ./vo/Event */
              "./src/dash/vo/Event.js"
            ), m = i(
              /*! ../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), A = i(
              /*! ./models/DashManifestModel */
              "./src/dash/models/DashManifestModel.js"
            ), b = i(
              /*! ./models/PatchManifestModel */
              "./src/dash/models/PatchManifestModel.js"
            ), S = i(
              /*! bcp-47-normalize */
              "./node_modules/bcp-47-normalize/index.js"
            ), N = /* @__PURE__ */ i.n(S);
            function T() {
              var y, E, L, _, O, D, M, C = this.context, I = "urn:dvb:dash:profile:dvb-dash:2014";
              function w() {
                E = (0, A.default)(C).getInstance(), L = (0, b.default)(C).getInstance(), ke();
              }
              function F(Te) {
                Te && (Te.constants && (D = Te.constants), Te.cea608parser && (M = Te.cea608parser), Te.errHandler && E.setConfig({
                  errHandler: Te.errHandler
                }), Te.BASE64 && E.setConfig({
                  BASE64: Te.BASE64
                }));
              }
              function k(Te) {
                if (Te) {
                  var me = new f.default(), Me = Te.adaptation.period.mpd.manifest.Period_asArray[Te.adaptation.period.index].AdaptationSet_asArray[Te.adaptation.index], Be = E.getRepresentationFor(Te.index, Me);
                  return me.id = Te.id, me.quality = Te.index, me.bandwidth = E.getBandwidth(Be), me.fragmentDuration = Te.segmentDuration || (Te.segments && Te.segments.length > 0 ? Te.segments[0].duration : NaN), me.MSETimeOffset = Te.MSETimeOffset, me.mediaInfo = rt(Te.adaptation), me;
                } else
                  return null;
              }
              function H(Te, me) {
                if (_.length === 0 || !Te)
                  return null;
                var Me = it(Te, _);
                if (!Me)
                  return null;
                var Be = E.getAdaptationsForPeriod(Me), Fe = Y(Te.index, me, Te);
                if (!Fe)
                  return null;
                var Ze = E.getIndexForAdaptation(Fe, _[0].mpd.manifest, Te.index);
                return rt(Be[Ze]);
              }
              function Z(Te) {
                return E.getRolesForAdaptation(Te).filter(function(me) {
                  return me.value === h.default.MAIN;
                })[0];
              }
              function Y(Te, me, Me) {
                var Be = E.getAdaptationsForType(_[0].mpd.manifest, Te, me);
                if (!Be || Be.length === 0)
                  return null;
                if (Be.length > 1 && Me) {
                  var Fe = ae(Me, me);
                  if (O[Me.id] && O[Me.id][me]) {
                    for (var Ze = 0, ot = Be.length; Ze < ot; Ze++)
                      if (j(O[Me.id][me], Fe[Ze]))
                        return Be[Ze];
                  }
                  for (var tt = 0, gt = Be.length; tt < gt; tt++)
                    if (Z(Be[tt]))
                      return Be[tt];
                }
                return Be[0];
              }
              function j(Te, me) {
                if (!Te || !me)
                  return !1;
                var Me = Te.id === me.id, Be = Te.codec === me.codec, Fe = Te.viewpoint === me.viewpoint, Ze = Te.lang === me.lang, ot = Te.roles.toString() === me.roles.toString(), tt = Te.accessibility.toString() === me.accessibility.toString(), gt = Te.audioChannelConfiguration.toString() === me.audioChannelConfiguration.toString();
                return Me && Be && Fe && Ze && ot && tt && gt;
              }
              function J(Te, me, Me, Be, Fe, Ze) {
                var ot = [], tt, gt, Mt, xt, be, We;
                if (!Be || Be.length === 0)
                  return [];
                var et = E.getAdaptationsForPeriod(me);
                for (xt = 0, We = Be.length; xt < We; xt++)
                  if (tt = Be[xt], Mt = E.getIndexForAdaptation(tt, Te, Me.index), gt = rt(et[Mt]), Ze) {
                    var _t = gt.accessibility.length;
                    for (be = 0; be < _t; be++)
                      if (gt) {
                        var ht = gt.accessibility[be];
                        if (ht.indexOf("cea-608:") === 0) {
                          var St = ht.substring(8), kt = St.split(";");
                          if (kt[0].substring(0, 2) === "CC")
                            for (be = 0; be < kt.length; be++)
                              gt || (gt = rt.call(this, et[Mt])), Ne(gt, kt[be].substring(0, 3), kt[be].substring(4)), ot.push(gt), gt = null;
                          else
                            for (be = 0; be < kt.length; be++)
                              gt || (gt = rt.call(this, et[Mt])), Ne(gt, "CC" + (be + 1), kt[be]), ot.push(gt), gt = null;
                        } else
                          ht.indexOf("cea-608") === 0 && (Ne(gt, D.CC1, "eng"), ot.push(gt), gt = null);
                      }
                  } else
                    Fe === D.IMAGE ? (He(gt), ot.push(gt), gt = null) : gt && ot.push(gt);
                return ot;
              }
              function ae(Te, me, Me) {
                var Be = _, Fe = Me, Ze = [];
                if (Fe)
                  ut(), Be = P(Fe);
                else if (_.length > 0)
                  Fe = _[0].mpd.manifest;
                else
                  return Ze;
                var ot = it(Te, Be), tt = E.getAdaptationsForType(Fe, Te ? Te.index : null, me);
                return Ze = J(Fe, ot, Te, tt, me), me === D.TEXT && (tt = E.getAdaptationsForType(Fe, Te ? Te.index : null, D.VIDEO), Ze = Ze.concat(J(Fe, ot, Te, tt, me, !0))), Ze;
              }
              function G(Te) {
                if (!Te)
                  return null;
                ut(), _ = P(Te);
              }
              function $(Te, me) {
                var Me = [], Be = _;
                if (Te && (ut(), Be = P(Te)), Be.length > 0) {
                  (!me || me > Be.length) && (me = Be.length);
                  for (var Fe = 0; Fe < me; Fe++)
                    Me.push($e(Be[Fe]));
                }
                return Me;
              }
              function ie(Te, me) {
                var Me, Be, Fe = it(Te, _);
                return Me = me ? me.id : null, _.length > 0 && Fe && (Be = Me ? E.getAdaptationForId(Me, _[0].mpd.manifest, Fe.index) : E.getAdaptationForIndex(me ? me.index : null, _[0].mpd.manifest, Fe.index)), Be;
              }
              function re(Te, me) {
                var Me, Be, Fe = it(Te, _);
                return Me = me ? me.id : null, _.length > 0 && Fe && (Be = Me ? E.getAdaptationForId(Me, _[0].mpd.manifest, Fe.index) : E.getAdaptationForIndex(me ? me.index : null, _[0].mpd.manifest, Fe.index)), Be ? E.getProducerReferenceTimesForAdaptation(Be) : [];
              }
              function ce(Te) {
                try {
                  return E.getEssentialPropertiesForRepresentation(Te);
                } catch {
                  return [];
                }
              }
              function z(Te) {
                return E.getRealPeriodForIndex(Te, _[0].mpd.manifest);
              }
              function oe(Te) {
                var me, Me = Xe(Te);
                return me = E.getRepresentationsForAdaptation(Me), me;
              }
              function de(Te, me, Me, Be) {
                try {
                  if (!Te || !me || isNaN(Me) || !Be)
                    return null;
                  var Fe = Te.scheme_id_uri, Ze = Te.value;
                  if (!me[Fe + "/" + Ze])
                    return null;
                  var ot = new g.default(), tt = Te.timescale || 1, gt = Be.adaptation.period.start, Mt = me[Fe + "/" + Ze], xt = isNaN(Be.presentationTimeOffset) ? isNaN(Mt.presentationTimeOffset) ? 0 : Mt.presentationTimeOffset : Be.presentationTimeOffset, be = Te.presentation_time_delta / tt, We;
                  Te.version === 0 ? We = gt + Me - xt + be : We = gt - xt + be;
                  var et = Te.event_duration / tt, _t = Te.id, ht = Te.message_data;
                  return ot.eventStream = Mt, ot.eventStream.value = Ze, ot.eventStream.timescale = tt, ot.duration = et, ot.id = _t, ot.calculatedPresentationTime = We, ot.messageData = ht, ot.presentationTimeDelta = be, ot;
                } catch {
                  return null;
                }
              }
              function pe(Te, me, Me) {
                var Be = [];
                if (_.length > 0) {
                  var Fe = _[0].mpd.manifest;
                  if (Te instanceof d.default) {
                    var Ze = it(Te, _);
                    Be = E.getEventsForPeriod(Ze);
                  } else if (Te instanceof p.default) {
                    var ot = it(Me, _);
                    Be = E.getEventStreamForAdaptationSet(Fe, Xe(Te), ot);
                  } else if (Te instanceof f.default) {
                    var tt = it(Me, _);
                    Be = E.getEventStreamForRepresentation(Fe, me, tt);
                  }
                }
                return Be;
              }
              function he(Te, me, Me) {
                O[Te] = O[Te] || {}, O[Te][me] = O[Te][me] || {}, O[Te][me] = Me;
              }
              function se(Te) {
                return E.getIsText(Te);
              }
              function ee() {
                var Te = Ie();
                return E.getUTCTimingSources(Te);
              }
              function te() {
                var Te = _.length > 0 ? _[0].mpd : null;
                return E.getSuggestedPresentationDelay(Te);
              }
              function le(Te) {
                var me = B(Te);
                return E.getAvailabilityStartTime(me);
              }
              function ne(Te) {
                var me = Ie(Te);
                return E.getIsDynamic(me);
              }
              function x(Te) {
                var me = Ie(Te);
                return E.getDuration(me);
              }
              function P(Te) {
                var me = B(Te);
                return E.getRegularPeriods(me);
              }
              function B(Te) {
                var me = Ie(Te);
                return E.getMpd(me);
              }
              function W(Te) {
                return E.getContentSteering(Te);
              }
              function X(Te) {
                return E.getLocation(Te);
              }
              function K(Te) {
                var me = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                return E.getManifestUpdatePeriod(Te, me);
              }
              function U(Te) {
                return E.getPublishTime(Te);
              }
              function V(Te) {
                var me = E.getPatchLocation(Te), Me = E.getPublishTime(Te);
                if (!me || !Me)
                  return null;
                if (me.hasOwnProperty("ttl") && Me) {
                  var Be = parseFloat(me.ttl) * 1e3;
                  if (Me.getTime() + Be <= (/* @__PURE__ */ new Date()).getTime())
                    return null;
                }
                return me.__text;
              }
              function Q(Te) {
                return E.hasProfile(Te, I);
              }
              function fe(Te) {
                return L.getIsPatch(Te);
              }
              function ue(Te) {
                return E.getBaseURLsFromElement(Te);
              }
              function q() {
                return E.getRepresentationSortFunction();
              }
              function _e(Te, me, Me) {
                return E.getCodec(Te, me, Me);
              }
              function ge(Te, me) {
                var Me, Be = pt(me);
                return Me = Ut(Be, Te), Me ? Me.bandwidth : null;
              }
              function Ce(Te, me) {
                var Me = pt(me);
                return vt(Me, Te);
              }
              function Ee(Te, me) {
                var Me = pt(me);
                return Je(Me, Te);
              }
              function Re(Te) {
                if (!Te || _.length === 0)
                  return null;
                var me = _.filter(function(Me) {
                  return Me.id === Te;
                });
                return me && me.length > 0 ? me[0] : null;
              }
              function Pe(Te, me) {
                return E.getIsTypeOf(Te, me);
              }
              function ke() {
                _ = [], O = {};
              }
              function De(Te, me) {
                var Me = E.getId(Te), Be = L.getMpdId(me), Fe = E.getPublishTime(Te), Ze = L.getPublishTime(me), ot = L.getOriginalPublishTime(me);
                return !!(Me && Be && Me == Be && Fe && ot && Fe.getTime() == ot.getTime() && Ze && Fe.getTime() < Ze.getTime());
              }
              function Ae(Te, me) {
                L.getPatchOperations(me).forEach(function(Me) {
                  var Be = Me.getMpdTarget(Te);
                  if (Be !== null) {
                    var Fe = Be.name, Ze = Be.target, ot = Be.leaf;
                    if (Me.xpath.findsAttribute()) {
                      switch (Me.action) {
                        case "add":
                        case "replace":
                          Ze[Fe] = Me.value;
                          break;
                        case "remove":
                          delete Ze[Fe];
                          break;
                      }
                      return;
                    }
                    var tt = (Ze[Fe + "_asArray"] || []).indexOf(ot), gt = Me.position === "prepend" || Me.position === "before";
                    if ((Me.action === "remove" || Me.action === "replace") && (delete Ze[Fe], tt != -1)) {
                      var Mt = Ze[Fe + "_asArray"];
                      Mt.splice(tt, 1), Mt.length > 1 ? Ze[Fe] = Mt : Mt.length == 1 ? Ze[Fe] = Mt[0] : delete Ze[Fe + "_asArray"];
                    }
                    (Me.action === "add" || Me.action === "replace") && Object.keys(Me.value).forEach(function(xt) {
                      var be = Me.value[xt], We = Ze[xt + "_asArray"] || [];
                      if (We.length === 0 && Ze[xt] && We.push(Ze[xt]), We.length === 0)
                        We = be;
                      else {
                        var et = We.length;
                        xt == Fe && tt != -1 ? et = tt + (gt ? 0 : 1) + (Me.action == "replace" ? -1 : 0) : et = gt ? 0 : We.length, We.splice.apply(We, [et, 0].concat(be));
                      }
                      Ze[xt + "_asArray"] = We, Ze[xt] = We.length == 1 ? We[0] : We;
                    });
                  }
                });
              }
              function Ie(Te) {
                return Te || (_.length > 0 ? _[0].mpd.manifest : null);
              }
              function Xe(Te) {
                try {
                  var me = it(Te.streamInfo, _), Me = E.getAdaptationsForPeriod(me);
                  return !Te || !Te.streamInfo || Te.streamInfo.id === void 0 || !Me ? null : Me[Te.index];
                } catch {
                  return null;
                }
              }
              function it(Te, me) {
                for (var Me = me.length, Be = 0; Be < Me; Be++) {
                  var Fe = me[Be];
                  if (Te && Te.id === Fe.id)
                    return Fe;
                }
                return null;
              }
              function rt(Te) {
                if (!Te)
                  return null;
                var me = new p.default(), Me = Te.period.mpd.manifest.Period_asArray[Te.period.index].AdaptationSet_asArray[Te.index], Be;
                if (me.id = Te.id, me.index = Te.index, me.type = Te.type, me.streamInfo = $e(Te.period), me.representationCount = E.getRepresentationCount(Me), me.labels = E.getLabelsForAdaptation(Me), me.lang = E.getLanguageForAdaptation(Me), Be = E.getViewpointForAdaptation(Me), me.viewpoint = Be ? Be.value : void 0, me.accessibility = E.getAccessibilityForAdaptation(Me).map(function(ot) {
                  var tt = ot.value, gt = tt;
                  return ot.schemeIdUri && ot.schemeIdUri.search("cea-608") >= 0 && typeof M < "u" && (tt ? gt = "cea-608:" + tt : gt = "cea-608", me.embeddedCaptions = !0), gt;
                }), me.audioChannelConfiguration = E.getAudioChannelConfigurationForAdaptation(Me).map(function(ot) {
                  return ot.value;
                }), me.audioChannelConfiguration.length === 0 && Array.isArray(Me.Representation_asArray) && Me.Representation_asArray.length > 0 && (me.audioChannelConfiguration = E.getAudioChannelConfigurationForRepresentation(Me.Representation_asArray[0]).map(function(ot) {
                  return ot.value;
                })), me.roles = E.getRolesForAdaptation(Me).map(function(ot) {
                  return ot.value;
                }), me.codec = E.getCodec(Me), me.mimeType = E.getMimeType(Me), me.contentProtection = E.getContentProtectionData(Me), me.bitrateList = E.getBitrateListForAdaptation(Me), me.selectionPriority = E.getSelectionPriority(Me), me.contentProtection) {
                  var Fe = me.contentProtection.map(function(ot) {
                    return E.getKID(ot);
                  }).filter(function(ot) {
                    return ot !== null;
                  });
                  if (Fe.length) {
                    var Ze = Fe[0];
                    me.contentProtection.forEach(function(ot) {
                      ot.keyId = Ze;
                    });
                  }
                }
                return me.isText = E.getIsText(Me), me.supplementalProperties = E.getSupplementalProperties(Me), me.isFragmented = E.getIsFragmented(Me), me.isEmbedded = !1, me;
              }
              function Ne(Te, me, Me) {
                Te.id = me, Te.index = 100 + parseInt(me.substring(2, 3)), Te.type = D.TEXT, Te.codec = "cea-608-in-SEI", Te.isEmbedded = !0, Te.isFragmented = !1, Te.lang = N()(Me), Te.roles = ["caption"];
              }
              function He(Te) {
                Te.type = D.IMAGE;
              }
              function $e(Te) {
                var me = new d.default(), Me = 1;
                return me.id = Te.id, me.index = Te.index, me.start = Te.start, me.duration = Te.duration, me.manifestInfo = nt(Te.mpd), me.isLast = Te.mpd.manifest.Period_asArray.length === 1 || Math.abs(me.start + me.duration - me.manifestInfo.duration) < Me, me;
              }
              function nt(Te) {
                var me = new v.default();
                return me.dvrWindowSize = Te.timeShiftBufferDepth, me.loadedTime = Te.manifest.loadedTime, me.availableFrom = Te.availabilityStartTime, me.minBufferTime = Te.manifest.minBufferTime, me.maxFragmentDuration = Te.maxSegmentDuration, me.duration = E.getDuration(Te.manifest), me.isDynamic = E.getIsDynamic(Te.manifest), me.serviceDescriptions = E.getServiceDescriptions(Te.manifest), me.protocol = Te.manifest.protocol, me;
              }
              function ut() {
                if (!D)
                  throw new Error("setConfig function has to be called previously");
              }
              function pt(Te) {
                return _.length > 0 ? _[0].mpd.manifest.Period_asArray[Te] : null;
              }
              function vt(Te, me) {
                var Me = Ut(Te, me, !0);
                return Me !== null ? Me : -1;
              }
              function Ut(Te, me, Me) {
                var Be, Fe, Ze, ot, tt, gt;
                if (Te) {
                  for (Fe = Te.AdaptationSet_asArray, tt = 0; tt < Fe.length; tt = tt + 1)
                    for (Be = Fe[tt], ot = Be.Representation_asArray, gt = 0; gt < ot.length; gt = gt + 1)
                      if (Ze = ot[gt], me === Ze.id)
                        return Me ? gt : Ze;
                }
                return null;
              }
              function Je(Te, me) {
                var Me, Be, Fe, Ze;
                if (!Te || !me)
                  return -1;
                for (Be = Te.AdaptationSet_asArray, Ze = 0; Ze < Be.length; Ze = Ze + 1)
                  if (Me = Be[Ze], Fe = Me.Representation_asArray, E.getIsTypeOf(Me, me))
                    return Fe.length;
                return -1;
              }
              return y = {
                getBandwidthForRepresentation: ge,
                getIndexForRepresentation: Ce,
                getMaxIndexForBufferType: Ee,
                convertRepresentationToRepresentationInfo: k,
                getStreamsInfo: $,
                getMediaInfoForType: H,
                getAllMediaInfoForType: ae,
                getAdaptationForType: Y,
                getRealAdaptation: ie,
                getProducerReferenceTimes: re,
                getRealPeriodByIndex: z,
                getEssentialPropertiesForRepresentation: ce,
                getVoRepresentations: oe,
                getEventsFor: pe,
                getEvent: de,
                getMpd: B,
                setConfig: F,
                updatePeriods: G,
                getIsTextTrack: se,
                getUTCTimingSources: ee,
                getSuggestedPresentationDelay: te,
                getAvailabilityStartTime: le,
                getIsTypeOf: Pe,
                getIsDynamic: ne,
                getDuration: x,
                getRegularPeriods: P,
                getContentSteering: W,
                getLocation: X,
                getPatchLocation: V,
                getManifestUpdatePeriod: K,
                getPublishTime: U,
                getIsDVB: Q,
                getIsPatch: fe,
                getBaseURLsFromElement: ue,
                getRepresentationSortFunction: q,
                getCodec: _e,
                getPeriodById: Re,
                setCurrentMediaInfo: he,
                isPatchValid: De,
                applyPatchToManifest: Ae,
                areMediaInfosEqual: j,
                reset: ke
              }, w(), y;
            }
            T.__dashjs_factory_name = "DashAdapter";
            const R = m.default.getSingletonFactory(T);
          }
        ),
        /***/
        "./src/dash/DashHandler.js": (
          /*!*********************************!*\
            !*** ./src/dash/DashHandler.js ***!
            \*********************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => S
              /* harmony export */
            });
            var h = i(
              /*! ../streaming/vo/FragmentRequest */
              "./src/streaming/vo/FragmentRequest.js"
            ), f = i(
              /*! ../streaming/vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            ), p = i(
              /*! ../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), d = i(
              /*! ../streaming/MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), v = i(
              /*! ./utils/SegmentsUtils */
              "./src/dash/utils/SegmentsUtils.js"
            ), g = i(
              /*! ./constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            ), m = 0.5, A = 1e-3;
            function b(N) {
              N = N || {};
              var T = N.eventBus, R = N.debug, y = N.urlUtils, E = N.type, L = N.streamInfo, _ = N.segmentsController, O = N.timelineConverter, D = N.baseURLController, M, C, I, w, F;
              function k() {
                C = R.getLogger(M), J(), T.on(d.default.DYNAMIC_TO_STATIC, se, M);
              }
              function H(ee) {
                w = ee, F = !1, _.initialize(ee);
              }
              function Z() {
                return L.id;
              }
              function Y() {
                return E;
              }
              function j() {
                return L;
              }
              function J() {
                I = null;
              }
              function ae() {
                J(), T.off(d.default.DYNAMIC_TO_STATIC, se, M);
              }
              function G(ee, te, le) {
                var ne = D.resolve(le.path), x, P;
                return !ne || te === ne.url || !y.isRelative(te) ? x = te : (x = ne.url, P = ne.serviceLocation, te && (x = y.resolve(te, x))), y.isRelative(x) ? !1 : (ee.url = x, ee.serviceLocation = P, !0);
              }
              function $(ee, te) {
                return te ? ie(ee, te, Y()) : null;
              }
              function ie(ee, te, le) {
                var ne = new h.default(), x = te.adaptation.period, P = x.start;
                if (ne.mediaType = le, ne.type = f.HTTPRequest.INIT_SEGMENT_TYPE, ne.range = te.range, ne.availabilityStartTime = O.calcAvailabilityStartTimeFromPresentationTime(P, te, w), ne.availabilityEndTime = O.calcAvailabilityEndTimeFromPresentationTime(P + x.duration, te, w), ne.quality = te.index, ne.mediaInfo = ee, ne.representationId = te.id, G(ne, te.initialization, te))
                  return ne.url = (0, v.replaceTokenForTemplate)(ne.url, "Bandwidth", te.bandwidth), ne;
              }
              function re(ee, te) {
                if (te == null)
                  return null;
                var le = new h.default(), ne = te.representation, x = ne.adaptation.period.mpd.manifest.Period_asArray[ne.adaptation.period.index].AdaptationSet_asArray[ne.adaptation.index].Representation_asArray[ne.index].bandwidth, P = te.media;
                if (P = (0, v.replaceTokenForTemplate)(P, "Number", te.replacementNumber), P = (0, v.replaceTokenForTemplate)(P, "Time", te.replacementTime), P = (0, v.replaceTokenForTemplate)(P, "Bandwidth", x), P = (0, v.replaceIDForTemplate)(P, ne.id), P = (0, v.unescapeDollarsInTemplate)(P), le.mediaType = Y(), le.type = f.HTTPRequest.MEDIA_SEGMENT_TYPE, le.range = te.mediaRange, le.startTime = te.presentationStartTime, le.mediaStartTime = te.mediaStartTime, le.duration = te.duration, le.timescale = ne.timescale, le.availabilityStartTime = te.availabilityStartTime, le.availabilityEndTime = te.availabilityEndTime, le.availabilityTimeComplete = ne.availabilityTimeComplete, le.wallStartTime = te.wallStartTime, le.quality = ne.index, le.index = te.index, le.mediaInfo = ee, le.adaptationIndex = ne.adaptation.index, le.representationId = ne.id, G(le, P, ne))
                  return le;
              }
              function ce(ee, te) {
                if (!ee || !I)
                  return !1;
                if (F)
                  return !0;
                if (!isFinite(ee.adaptation.period.duration) || I.presentationStartTime + I.duration > te)
                  return !1;
                if (ee.mediaFinishedInformation && !isNaN(ee.mediaFinishedInformation.numberOfSegments) && !isNaN(I.index) && I.index >= ee.mediaFinishedInformation.numberOfSegments - 1) {
                  if (!w || ee.segmentInfoType === g.default.SEGMENT_TEMPLATE)
                    return !0;
                  if (w && ee.segmentInfoType === g.default.SEGMENT_LIST && ee.adaptation.period.nextPeriodId)
                    return !0;
                }
                return !!(w && ee.adaptation.period.nextPeriodId && ee.segmentInfoType === g.default.SEGMENT_TIMELINE && ee.mediaFinishedInformation && !isNaN(ee.mediaFinishedInformation.mediaTimeOfLastSignaledSegment) && I && !isNaN(I.mediaStartTime) && !isNaN(I.duration) && I.mediaStartTime + I.duration >= ee.mediaFinishedInformation.mediaTimeOfLastSignaledSegment - 0.05);
              }
              function z(ee, te, le) {
                var ne = null;
                if (!te || !te.segmentInfoType)
                  return ne;
                var x = _.getSegmentByTime(te, le);
                return x && (I = x, C.debug("Index for time " + le + " is " + x.index), ne = re(ee, x)), ne;
              }
              function oe(ee, te) {
                var le = null, ne = I ? I.index + 1 : 0, x = _.getSegmentByIndex(te, ne, I ? I.mediaStartTime : -1);
                return x ? (le = re(ee, x), le) : null;
              }
              function de(ee, te) {
                var le = null;
                if (!te || !te.segmentInfoType)
                  return null;
                var ne = I ? I.index + 1 : 0, x = _.getSegmentByIndex(te, ne, I ? I.mediaStartTime : -1);
                if (x)
                  le = re(ee, x), I = x;
                else {
                  if (w && !F)
                    return C.debug(Y() + " No segment found at index: " + ne + ". Wait for next loop"), null;
                  F = !0;
                }
                return le;
              }
              function pe(ee, te, le, ne) {
                try {
                  if (isNaN(ee) || !te || !le)
                    return NaN;
                  if (ee < 0 && (ee = 0), isNaN(ne) && (ne = m), z(te, le, ee))
                    return ee;
                  if (le.adaptation.period.start + le.adaptation.period.duration < ee)
                    return NaN;
                  for (var x = isFinite(le.adaptation.period.duration) ? le.adaptation.period.start + le.adaptation.period.duration : ee + 30, P = Math.min(ee + ne, x), B = NaN, W = null; P <= x; ) {
                    var X = null;
                    if (P <= x && (X = z(te, le, P)), X) {
                      B = P, W = X;
                      break;
                    }
                    P += ne;
                  }
                  if (W) {
                    var K = W.startTime + W.duration;
                    return ee > W.startTime && K - ee > ne ? ee : !isNaN(W.startTime) && ee < W.startTime && B > W.startTime ? W.startTime + A : Math.min(K - ne, B);
                  }
                  return B;
                } catch {
                  return NaN;
                }
              }
              function he() {
                return I ? I.index : -1;
              }
              function se() {
                C.debug("Dynamic stream complete"), F = !0;
              }
              return M = {
                initialize: H,
                getStreamId: Z,
                getType: Y,
                getStreamInfo: j,
                getInitRequest: $,
                getSegmentRequestForTime: z,
                getCurrentIndex: he,
                getNextSegmentRequest: de,
                isLastSegmentRequested: ce,
                reset: ae,
                getNextSegmentRequestIdempotent: oe,
                getValidTimeAheadOfTargetTime: pe
              }, k(), M;
            }
            b.__dashjs_factory_name = "DashHandler";
            const S = p.default.getClassFactory(b);
          }
        ),
        /***/
        "./src/dash/DashMetrics.js": (
          /*!*********************************!*\
            !*** ./src/dash/DashMetrics.js ***!
            \*********************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => S
              /* harmony export */
            });
            var h = i(
              /*! ../streaming/constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), f = i(
              /*! ../streaming/vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            ), p = i(
              /*! ../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), d = i(
              /*! ../streaming/constants/MetricsConstants */
              "./src/streaming/constants/MetricsConstants.js"
            ), v = i(
              /*! ./utils/Round10 */
              "./src/dash/utils/Round10.js"
            ), g = i(
              /*! ../streaming/models/MetricsModel */
              "./src/streaming/models/MetricsModel.js"
            ), m = i(
              /*! ../core/Utils */
              "./src/core/Utils.js"
            ), A = i(
              /*! ../streaming/vo/metrics/PlayList */
              "./src/streaming/vo/metrics/PlayList.js"
            );
            function b(N) {
              N = N || {};
              var T = this.context, R, y, E, L, _ = N.metricsModel;
              function O() {
                _ = _ || (0, g.default)(T).getInstance({
                  settings: N.settings
                }), D();
              }
              function D() {
                y = !0, E = null, L = null;
              }
              function M(X) {
                var K = _.getMetricsFor(X, !0);
                return J(K, d.default.TRACK_SWITCH);
              }
              function C(X, K, U, V, Q) {
                _.addRepresentationSwitch(X, K, U, V, Q);
              }
              function I(X) {
                var K = _.getMetricsFor(X, !0);
                return J(K, d.default.BUFFER_STATE);
              }
              function w(X) {
                var K = _.getMetricsFor(X, !0), U = J(K, d.default.BUFFER_LEVEL);
                return U ? v.default.round10(U.level / 1e3, -3) : 0;
              }
              function F(X, K, U) {
                _.addBufferLevel(X, K, U);
              }
              function k(X, K, U) {
                _.addBufferState(X, K, U);
              }
              function H() {
                _.clearAllCurrentMetrics();
              }
              function Z(X) {
                var K = _.getMetricsFor(X, !0);
                if (!K)
                  return null;
                var U = K.HttpList, V = null, Q;
                if (!U || U.length <= 0)
                  return null;
                for (Q = U.length - 1; Q >= 0; ) {
                  if (U[Q].responsecode) {
                    V = U[Q];
                    break;
                  }
                  Q--;
                }
                return V;
              }
              function Y(X) {
                var K = _.getMetricsFor(X, !0);
                return K ? K.HttpList ? K.HttpList : [] : [];
              }
              function j(X, K, U) {
                _.addRequestsQueue(X, K, U);
              }
              function J(X, K) {
                if (!X)
                  return null;
                var U = X[K];
                return !U || U.length === 0 ? null : U[U.length - 1];
              }
              function ae() {
                var X = _.getMetricsFor(h.default.VIDEO, !0);
                return J(X, d.default.DROPPED_FRAMES);
              }
              function G(X) {
                _.addDroppedFrames(h.default.VIDEO, X);
              }
              function $(X) {
                var K = _.getMetricsFor(X, !0);
                return J(K, d.default.SCHEDULING_INFO);
              }
              function ie(X, K) {
                _.addSchedulingInfo(X.mediaType, /* @__PURE__ */ new Date(), X.type, X.startTime, X.availabilityStartTime, X.duration, X.quality, X.range, K);
              }
              function re() {
                var X = _.getMetricsFor(h.default.STREAM);
                return J(X, d.default.MANIFEST_UPDATE);
              }
              function ce(X) {
                var K = this.getCurrentManifestUpdate();
                _.updateManifestUpdateInfo(K, X);
              }
              function z(X) {
                if (X) {
                  var K = this.getCurrentManifestUpdate();
                  _.addManifestUpdateStreamInfo(K, X.id, X.index, X.start, X.duration);
                }
              }
              function oe(X) {
                _.addManifestUpdate(h.default.STREAM, X.type, X.requestStartDate, X.requestEndDate);
              }
              function de(X, K, U, V, Q, fe) {
                _.addHttpRequest(X.mediaType, null, X.type, X.url, X.quality, K, X.serviceLocation || null, X.range || null, X.requestStartDate, X.firstByteDate, X.requestEndDate, U, X.duration, V, Q, X.fileLoaderType, fe);
              }
              function pe(X, K) {
                if (X) {
                  var U = this.getCurrentManifestUpdate();
                  _.addManifestUpdateRepresentationInfo(U, X.id, X.index, X.streamIndex, K, X.presentationTimeOffset, X.startNumber, X.fragmentInfoType);
                }
              }
              function he(X) {
                var K = X ? _.getMetricsFor(X, !0) : _.getMetricsFor(h.default.VIDEO, !0) || _.getMetricsFor(h.default.AUDIO, !0);
                return J(K, d.default.DVR_INFO);
              }
              function se(X, K, U, V) {
                _.addDVRInfo(X, K, U, V);
              }
              function ee(X) {
                if (!X)
                  return null;
                var K = {}, U, V, Q;
                for (U = Y(h.default.STREAM), Q = U.length - 1; Q >= 0; Q--)
                  if (V = U[Q], V.type === f.HTTPRequest.MPD_TYPE) {
                    K = m.default.parseHttpHeaders(V._responseHeaders);
                    break;
                  }
                var fe = K[X.toLowerCase()];
                return fe === void 0 ? null : fe;
              }
              function te(X, K) {
                if (!K)
                  return null;
                var U = {}, V = Z(X);
                V && (U = m.default.parseHttpHeaders(V._responseHeaders));
                var Q = U[K.toLowerCase()];
                return Q === void 0 ? null : Q;
              }
              function le() {
                L && (_.addPlayList(L), L = null);
              }
              function ne(X, K) {
                L = new A.PlayList(), L.start = /* @__PURE__ */ new Date(), L.mstart = X, L.starttype = K;
              }
              function x(X, K, U) {
                y === !0 && (y = !1, E = new A.PlayListTrace(), E.representationid = X, E.start = /* @__PURE__ */ new Date(), E.mstart = K, E.playbackspeed = U !== null ? U.toString() : null);
              }
              function P(X) {
                if (E)
                  for (var K in E)
                    E[K] = X[K];
              }
              function B(X, K) {
                if (y === !1 && L && E && E.start) {
                  var U = E.start, V = X.getTime() - U.getTime();
                  E.duration = V, E.stopreason = K, L.trace.push(E), y = !0;
                }
              }
              function W(X) {
                _.addDVBErrors(X);
              }
              return R = {
                getCurrentRepresentationSwitch: M,
                getCurrentBufferState: I,
                getCurrentBufferLevel: w,
                getCurrentHttpRequest: Z,
                getHttpRequests: Y,
                getCurrentDroppedFrames: ae,
                getCurrentSchedulingInfo: $,
                getCurrentDVRInfo: he,
                getCurrentManifestUpdate: re,
                getLatestFragmentRequestHeaderValueByID: te,
                getLatestMPDRequestHeaderValueByID: ee,
                addRepresentationSwitch: C,
                addDVRInfo: se,
                updateManifestUpdateInfo: ce,
                addManifestUpdateStreamInfo: z,
                addManifestUpdateRepresentationInfo: pe,
                addManifestUpdate: oe,
                addHttpRequest: de,
                addSchedulingInfo: ie,
                addRequestsQueue: j,
                addBufferLevel: F,
                addBufferState: k,
                addDroppedFrames: G,
                addPlayList: le,
                addDVBErrors: W,
                createPlaylistMetrics: ne,
                createPlaylistTraceMetrics: x,
                updatePlayListTraceMetrics: P,
                pushPlayListTraceMetrics: B,
                clearAllCurrentMetrics: H
              }, O(), R;
            }
            b.__dashjs_factory_name = "DashMetrics";
            const S = p.default.getSingletonFactory(b);
          }
        ),
        /***/
        "./src/dash/SegmentBaseLoader.js": (
          /*!***************************************!*\
            !*** ./src/dash/SegmentBaseLoader.js ***!
            \***************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => m
              /* harmony export */
            });
            var h = i(
              /*! ./vo/Segment */
              "./src/dash/vo/Segment.js"
            ), f = i(
              /*! ../streaming/vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), p = i(
              /*! ../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), d = i(
              /*! ../streaming/vo/FragmentRequest */
              "./src/streaming/vo/FragmentRequest.js"
            ), v = i(
              /*! ../streaming/net/URLLoader */
              "./src/streaming/net/URLLoader.js"
            );
            function g() {
              var A = this.context, b, S, N, T, R, y, E, L, _, O, D, M, C;
              function I() {
                L = (0, v.default)(A).create({
                  errHandler: N,
                  dashMetrics: y,
                  mediaPlayerModel: E,
                  requestModifier: R,
                  boxParser: T,
                  errors: _,
                  urlUtils: M,
                  constants: O,
                  dashConstants: D
                });
              }
              function w(G) {
                G.baseURLController && (C = G.baseURLController), G.dashMetrics && (y = G.dashMetrics), G.mediaPlayerModel && (E = G.mediaPlayerModel), G.errHandler && (N = G.errHandler), G.boxParser && (T = G.boxParser), G.debug && (S = G.debug.getLogger(b)), G.requestModifier && (R = G.requestModifier), G.errors && (_ = G.errors), G.urlUtils && (M = G.urlUtils), G.constants && (O = G.constants), G.dashConstants && (D = G.dashConstants);
              }
              function F(G, $) {
                return new Promise(function(ie) {
                  k(G, $, ie);
                });
              }
              function k(G, $, ie, re) {
                var ce = null, z = G ? C.resolve(G.path) : null, oe = re || {
                  init: !0,
                  url: z ? z.url : void 0,
                  range: {
                    start: 0,
                    end: 1500
                  },
                  searching: !1,
                  bytesLoaded: 0,
                  bytesToLoad: 1500,
                  mediaType: $
                };
                S.debug("Start searching for initialization.");
                var de = ae(oe), pe = function(ee) {
                  if (oe.bytesLoaded = oe.range.end, ce = T.findInitRange(ee), ce)
                    G.range = ce, ie(G);
                  else
                    return oe.range.end = oe.bytesLoaded + oe.bytesToLoad, k(G, $, ie, oe);
                }, he = function() {
                  ie(G);
                };
                L.load({
                  request: de,
                  success: pe,
                  error: he
                }), S.debug("Perform init search: " + oe.url);
              }
              function H(G, $, ie) {
                return new Promise(function(re) {
                  Z(G, $, ie, re);
                });
              }
              function Z(G, $, ie, re, ce, z) {
                if (ie && (ie.start === void 0 || ie.end === void 0)) {
                  var oe = ie ? ie.toString().split("-") : null;
                  ie = oe ? {
                    start: parseFloat(oe[0]),
                    end: parseFloat(oe[1])
                  } : null;
                }
                ce = ce || Y;
                var de = null, pe = null, he = !!ie, se = G ? C.resolve(G.path) : null, ee = {
                  init: !1,
                  url: se ? se.url : void 0,
                  range: he ? ie : {
                    start: 0,
                    end: 1500
                  },
                  searching: !he,
                  bytesLoaded: z ? z.bytesLoaded : 0,
                  bytesToLoad: 1500,
                  mediaType: $
                }, te = ae(ee), le = function(P) {
                  var B = ee.bytesToLoad, W = P.byteLength;
                  if (ee.bytesLoaded = ee.range.end - ee.range.start, de = T.parse(P), pe = de.getBox("sidx"), !pe || !pe.isComplete) {
                    if (pe)
                      ee.range.start = pe.offset || ee.range.start, ee.range.end = ee.range.start + (pe.size || B);
                    else if (W < ee.bytesLoaded) {
                      ce(null, G, re);
                      return;
                    } else {
                      var X = de.getLastBox();
                      X && X.size ? (ee.range.start = X.offset + X.size, ee.range.end = ee.range.start + B) : ee.range.end += B;
                    }
                    Z(G, $, ee.range, re, null, ee);
                  } else {
                    var K = pe.references, U, V;
                    if (K != null && K.length > 0 && (U = K[0].reference_type === 1), U) {
                      S.debug("Initiate multiple SIDX load."), ee.range.end = ee.range.start + pe.size;
                      var Q, fe, ue, q, _e, ge = [], Ce = 0, Ee = (pe.offset || ee.range.start) + pe.size, Re = function(ke) {
                        ke ? (ge = ge.concat(ke), Ce++, Ce >= fe && (ge.sort(function(De, Ae) {
                          return De.startTime - Ae.startTime < 0 ? -1 : 0;
                        }), ce(ge, G, re))) : ce(null, G, re);
                      };
                      for (Q = 0, fe = K.length; Q < fe; Q++)
                        ue = Ee, q = Ee + K[Q].referenced_size - 1, Ee = Ee + K[Q].referenced_size, _e = {
                          start: ue,
                          end: q
                        }, Z(G, $, _e, re, Re, ee);
                    } else
                      S.debug("Parsing segments from SIDX. representation " + $ + " - id: " + G.id + " for range : " + ee.range.start + " - " + ee.range.end), V = J(pe, ee), ce(V, G, re);
                  }
                }, ne = function() {
                  ce(null, G, re);
                };
                L.load({
                  request: te,
                  success: le,
                  error: ne
                }), S.debug("Perform SIDX load for type ".concat($, " : ").concat(ee.url, " with range ").concat(ee.range.start, " - ").concat(ee.range.end));
              }
              function Y(G, $, ie) {
                ie({
                  segments: G,
                  representation: $,
                  error: G ? void 0 : new f.default(_.SEGMENT_BASE_LOADER_ERROR_CODE, _.SEGMENT_BASE_LOADER_ERROR_MESSAGE)
                });
              }
              function j() {
                L && (L.abort(), L = null);
              }
              function J(G, $) {
                for (var ie = G.references, re = ie.length, ce = G.timescale, z = G.earliest_presentation_time, oe = $.range.start + G.offset + G.first_offset + G.size, de = [], pe, he, se, ee, te = 0; te < re; te++)
                  se = ie[te].subsegment_duration, ee = ie[te].referenced_size, pe = new h.default(), pe.duration = se, pe.startTime = z, pe.timescale = ce, he = oe + ee - 1, pe.mediaRange = oe + "-" + he, de.push(pe), z += se, oe += ee;
                return de;
              }
              function ae(G) {
                if (G.url) {
                  var $ = new d.default();
                  return $.setInfo(G), $;
                }
              }
              return b = {
                setConfig: w,
                initialize: I,
                loadInitialization: F,
                loadSegments: H,
                reset: j
              }, b;
            }
            g.__dashjs_factory_name = "SegmentBaseLoader";
            const m = p.default.getSingletonFactory(g);
          }
        ),
        /***/
        "./src/dash/WebmSegmentBaseLoader.js": (
          /*!*******************************************!*\
            !*** ./src/dash/WebmSegmentBaseLoader.js ***!
            \*******************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => b
              /* harmony export */
            });
            var h = i(
              /*! ../streaming/utils/EBMLParser */
              "./src/streaming/utils/EBMLParser.js"
            ), f = i(
              /*! ../streaming/constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), p = i(
              /*! ../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), d = i(
              /*! ./vo/Segment */
              "./src/dash/vo/Segment.js"
            ), v = i(
              /*! ../streaming/vo/FragmentRequest */
              "./src/streaming/vo/FragmentRequest.js"
            ), g = i(
              /*! ../streaming/net/URLLoader */
              "./src/streaming/net/URLLoader.js"
            ), m = i(
              /*! ../streaming/vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            );
            function A() {
              var S = this.context, N, T, R, y, E, L, _, O, D, M;
              function C() {
                R = {
                  EBML: {
                    tag: 440786851,
                    required: !0
                  },
                  Segment: {
                    tag: 408125543,
                    required: !0,
                    SeekHead: {
                      tag: 290298740,
                      required: !0
                    },
                    Info: {
                      tag: 357149030,
                      required: !0,
                      TimecodeScale: {
                        tag: 2807729,
                        required: !0,
                        parse: "getMatroskaUint"
                      },
                      Duration: {
                        tag: 17545,
                        required: !0,
                        parse: "getMatroskaFloat"
                      }
                    },
                    Tracks: {
                      tag: 374648427,
                      required: !0
                    },
                    Cues: {
                      tag: 475249515,
                      required: !0,
                      CuePoint: {
                        tag: 187,
                        required: !0,
                        CueTime: {
                          tag: 179,
                          required: !0,
                          parse: "getMatroskaUint"
                        },
                        CueTrackPositions: {
                          tag: 183,
                          required: !0,
                          CueTrack: {
                            tag: 247,
                            required: !0,
                            parse: "getMatroskaUint"
                          },
                          CueClusterPosition: {
                            tag: 241,
                            required: !0,
                            parse: "getMatroskaUint"
                          }
                        }
                      }
                    }
                  },
                  Void: {
                    tag: 236,
                    required: !0
                  }
                };
              }
              function I() {
                O = (0, g.default)(S).create({
                  errHandler: y,
                  dashMetrics: L,
                  mediaPlayerModel: _,
                  requestModifier: E,
                  errors: D
                });
              }
              function w(ae) {
                if (!ae.baseURLController || !ae.dashMetrics || !ae.mediaPlayerModel || !ae.errHandler)
                  throw new Error(f.default.MISSING_CONFIG_ERROR);
                M = ae.baseURLController, L = ae.dashMetrics, _ = ae.mediaPlayerModel, y = ae.errHandler, D = ae.errors, T = ae.debug.getLogger(N), E = ae.requestModifier;
              }
              function F(ae) {
                var G = [], $ = (0, h.default)(S).create({
                  data: ae
                }), ie, re;
                for ($.consumeTagAndSize(R.Segment.Cues); $.moreData() && $.consumeTagAndSize(R.Segment.Cues.CuePoint, !0); ) {
                  for (ie = {}, ie.CueTime = $.parseTag(R.Segment.Cues.CuePoint.CueTime), ie.CueTracks = []; $.moreData() && $.consumeTag(R.Segment.Cues.CuePoint.CueTrackPositions, !0); ) {
                    var ce = $.getMatroskaCodedNum(), z = $.getPos();
                    if (re = {}, re.Track = $.parseTag(R.Segment.Cues.CuePoint.CueTrackPositions.CueTrack), re.Track === 0)
                      throw new Error("Cue track cannot be 0");
                    re.ClusterPosition = $.parseTag(R.Segment.Cues.CuePoint.CueTrackPositions.CueClusterPosition), ie.CueTracks.push(re), $.setPos(z + ce);
                  }
                  if (ie.CueTracks.length === 0)
                    throw new Error("Mandatory cuetrack not found");
                  G.push(ie);
                }
                if (G.length === 0)
                  throw new Error("mandatory cuepoint not found");
                return G;
              }
              function k(ae, G, $, ie) {
                var re, ce, z, oe, de, pe, he, se;
                for (ce = F(ae), z = [], de = 0, pe = ce.length; de < pe; de += 1)
                  oe = new d.default(), re = 0, de < ce.length - 1 ? re = ce[de + 1].CueTime - ce[de].CueTime : re = ie - ce[de].CueTime, oe.duration = re, oe.startTime = ce[de].CueTime, oe.timescale = 1e3, he = ce[de].CueTracks[0].ClusterPosition + G, de < ce.length - 1 ? se = ce[de + 1].CueTracks[0].ClusterPosition + G - 1 : se = $ - 1, oe.mediaRange = he + "-" + se, z.push(oe);
                return T.debug("Parsed cues: " + z.length + " cues."), z;
              }
              function H(ae, G, $, ie) {
                if (!ae || ae.byteLength === 0) {
                  ie(null);
                  return;
                }
                var re = (0, h.default)(S).create({
                  data: ae
                }), ce, z, oe, de, pe = $ ? $.split("-") : null, he = null, se = {
                  url: G,
                  range: {
                    start: pe ? parseFloat(pe[0]) : null,
                    end: pe ? parseFloat(pe[1]) : null
                  },
                  request: he
                };
                for (T.debug("Parse EBML header: " + se.url), re.skipOverElement(R.EBML), re.consumeTag(R.Segment), oe = re.getMatroskaCodedNum(), oe += re.getPos(), de = re.getPos(); re.moreData() && !re.consumeTagAndSize(R.Segment.Info, !0); )
                  if (!(re.skipOverElement(R.Segment.SeekHead, !0) || re.skipOverElement(R.Segment.Tracks, !0) || re.skipOverElement(R.Segment.Cues, !0) || re.skipOverElement(R.Void, !0)))
                    throw new Error("no valid top level element found");
                for (; ce === void 0; ) {
                  var ee = re.getMatroskaCodedNum(!0), te = re.getMatroskaCodedNum();
                  switch (ee) {
                    case R.Segment.Info.Duration.tag:
                      ce = re[R.Segment.Info.Duration.parse](te);
                      break;
                    default:
                      re.setPos(re.getPos() + te);
                      break;
                  }
                }
                he = j(se);
                var le = function(P) {
                  z = k(P, de, oe, ce), ie(z);
                }, ne = function() {
                  T.error("Download Error: Cues " + se.url), ie(null);
                };
                O.load({
                  request: he,
                  success: le,
                  error: ne
                }), T.debug("Perform cues load: " + se.url + " bytes=" + se.range.start + "-" + se.range.end);
              }
              function Z(ae, G) {
                return new Promise(function($) {
                  var ie = null, re = ae ? M.resolve(ae.path) : null, ce = ae ? ae.range.split("-") : null, z = {
                    range: {
                      start: ce ? parseFloat(ce[0]) : null,
                      end: ce ? parseFloat(ce[1]) : null
                    },
                    request: ie,
                    url: re ? re.url : void 0,
                    init: !0,
                    mediaType: G
                  };
                  T.info("Start loading initialization."), ie = j(z);
                  var oe = function() {
                    $(ae);
                  }, de = function() {
                    $(ae);
                  };
                  O.load({
                    request: ie,
                    success: oe,
                    error: de
                  }), T.debug("Perform init load: " + z.url);
                });
              }
              function Y(ae, G, $) {
                return new Promise(function(ie) {
                  var re = null, ce = ae ? M.resolve(ae.path) : null, z = ce ? ce.url : void 0, oe = 8192, de = {
                    bytesLoaded: 0,
                    bytesToLoad: oe,
                    range: {
                      start: 0,
                      end: oe
                    },
                    request: re,
                    url: z,
                    init: !1,
                    mediaType: G
                  };
                  re = j(de), T.debug("Parsing ebml header");
                  var pe = function(ee) {
                    H(ee, z, $, function(te) {
                      ie({
                        segments: te,
                        representation: ae,
                        error: te ? void 0 : new m.default(D.SEGMENT_BASE_LOADER_ERROR_CODE, D.SEGMENT_BASE_LOADER_ERROR_MESSAGE)
                      });
                    });
                  }, he = function() {
                    ie({
                      representation: ae,
                      error: new m.default(D.SEGMENT_BASE_LOADER_ERROR_CODE, D.SEGMENT_BASE_LOADER_ERROR_MESSAGE)
                    });
                  };
                  O.load({
                    request: re,
                    success: pe,
                    error: he
                  });
                });
              }
              function j(ae) {
                var G = new v.default();
                return G.setInfo(ae), G;
              }
              function J() {
                O && (O.abort(), O = null);
              }
              return N = {
                setConfig: w,
                initialize: I,
                loadInitialization: Z,
                loadSegments: Y,
                reset: J
              }, C(), N;
            }
            A.__dashjs_factory_name = "WebmSegmentBaseLoader";
            const b = p.default.getSingletonFactory(A);
          }
        ),
        /***/
        "./src/dash/constants/DashConstants.js": (
          /*!*********************************************!*\
            !*** ./src/dash/constants/DashConstants.js ***!
            \*********************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => g
              /* harmony export */
            });
            function h(m, A) {
              if (!(m instanceof A))
                throw new TypeError("Cannot call a class as a function");
            }
            function f(m, A) {
              for (var b = 0; b < A.length; b++) {
                var S = A[b];
                S.enumerable = S.enumerable || !1, S.configurable = !0, "value" in S && (S.writable = !0), Object.defineProperty(m, S.key, S);
              }
            }
            function p(m, A, b) {
              return A && f(m.prototype, A), b && f(m, b), m;
            }
            var d = /* @__PURE__ */ function() {
              function m() {
                h(this, m), this.init();
              }
              return p(m, [{
                key: "init",
                value: function() {
                  this.BASE_URL = "BaseURL", this.SEGMENT_BASE = "SegmentBase", this.SEGMENT_TEMPLATE = "SegmentTemplate", this.SEGMENT_LIST = "SegmentList", this.SEGMENT_URL = "SegmentURL", this.SEGMENT_TIMELINE = "SegmentTimeline", this.SEGMENT_PROFILES = "segmentProfiles", this.ADAPTATION_SET = "AdaptationSet", this.REPRESENTATION = "Representation", this.REPRESENTATION_INDEX = "RepresentationIndex", this.SUB_REPRESENTATION = "SubRepresentation", this.INITIALIZATION = "Initialization", this.INITIALIZATION_MINUS = "initialization", this.MPD = "MPD", this.PERIOD = "Period", this.ASSET_IDENTIFIER = "AssetIdentifier", this.EVENT_STREAM = "EventStream", this.ID = "id", this.PROFILES = "profiles", this.SERVICE_LOCATION = "serviceLocation", this.RANGE = "range", this.INDEX = "index", this.MEDIA = "media", this.BYTE_RANGE = "byteRange", this.INDEX_RANGE = "indexRange", this.MEDIA_RANGE = "mediaRange", this.VALUE = "value", this.CONTENT_TYPE = "contentType", this.MIME_TYPE = "mimeType", this.BITSTREAM_SWITCHING = "BitstreamSwitching", this.BITSTREAM_SWITCHING_MINUS = "bitstreamSwitching", this.CODECS = "codecs", this.DEPENDENCY_ID = "dependencyId", this.MEDIA_STREAM_STRUCTURE_ID = "mediaStreamStructureId", this.METRICS = "Metrics", this.METRICS_MINUS = "metrics", this.REPORTING = "Reporting", this.WIDTH = "width", this.HEIGHT = "height", this.SAR = "sar", this.FRAMERATE = "frameRate", this.AUDIO_SAMPLING_RATE = "audioSamplingRate", this.MAXIMUM_SAP_PERIOD = "maximumSAPPeriod", this.START_WITH_SAP = "startWithSAP", this.MAX_PLAYOUT_RATE = "maxPlayoutRate", this.CODING_DEPENDENCY = "codingDependency", this.SCAN_TYPE = "scanType", this.FRAME_PACKING = "FramePacking", this.AUDIO_CHANNEL_CONFIGURATION = "AudioChannelConfiguration", this.CONTENT_PROTECTION = "ContentProtection", this.ESSENTIAL_PROPERTY = "EssentialProperty", this.SUPPLEMENTAL_PROPERTY = "SupplementalProperty", this.INBAND_EVENT_STREAM = "InbandEventStream", this.PRODUCER_REFERENCE_TIME = "ProducerReferenceTime", this.ACCESSIBILITY = "Accessibility", this.ROLE = "Role", this.RATING = "Rating", this.CONTENT_COMPONENT = "ContentComponent", this.SUBSET = "Subset", this.LANG = "lang", this.VIEWPOINT = "Viewpoint", this.ROLE_ASARRAY = "Role_asArray", this.REPRESENTATION_ASARRAY = "Representation_asArray", this.PRODUCERREFERENCETIME_ASARRAY = "ProducerReferenceTime_asArray", this.ACCESSIBILITY_ASARRAY = "Accessibility_asArray", this.AUDIOCHANNELCONFIGURATION_ASARRAY = "AudioChannelConfiguration_asArray", this.CONTENTPROTECTION_ASARRAY = "ContentProtection_asArray", this.MAIN = "main", this.DYNAMIC = "dynamic", this.STATIC = "static", this.MEDIA_PRESENTATION_DURATION = "mediaPresentationDuration", this.MINIMUM_UPDATE_PERIOD = "minimumUpdatePeriod", this.CODEC_PRIVATE_DATA = "codecPrivateData", this.BANDWITH = "bandwidth", this.SOURCE_URL = "sourceURL", this.TIMESCALE = "timescale", this.DURATION = "duration", this.START_NUMBER = "startNumber", this.PRESENTATION_TIME_OFFSET = "presentationTimeOffset", this.AVAILABILITY_START_TIME = "availabilityStartTime", this.AVAILABILITY_END_TIME = "availabilityEndTime", this.TIMESHIFT_BUFFER_DEPTH = "timeShiftBufferDepth", this.MAX_SEGMENT_DURATION = "maxSegmentDuration", this.PRESENTATION_TIME = "presentationTime", this.MIN_BUFFER_TIME = "minBufferTime", this.MAX_SUBSEGMENT_DURATION = "maxSubsegmentDuration", this.START = "start", this.AVAILABILITY_TIME_OFFSET = "availabilityTimeOffset", this.AVAILABILITY_TIME_COMPLETE = "availabilityTimeComplete", this.CENC_DEFAULT_KID = "cenc:default_KID", this.DVB_PRIORITY = "dvb:priority", this.DVB_WEIGHT = "dvb:weight", this.SUGGESTED_PRESENTATION_DELAY = "suggestedPresentationDelay", this.SERVICE_DESCRIPTION = "ServiceDescription", this.SERVICE_DESCRIPTION_SCOPE = "Scope", this.SERVICE_DESCRIPTION_LATENCY = "Latency", this.SERVICE_DESCRIPTION_PLAYBACK_RATE = "PlaybackRate", this.SERVICE_DESCRIPTION_OPERATING_QUALITY = "OperatingQuality", this.SERVICE_DESCRIPTION_OPERATING_BANDWIDTH = "OperatingBandwidth", this.PATCH_LOCATION = "PatchLocation", this.PUBLISH_TIME = "publishTime", this.ORIGINAL_PUBLISH_TIME = "originalPublishTime", this.ORIGINAL_MPD_ID = "mpdId", this.WALL_CLOCK_TIME = "wallClockTime", this.PRESENTATION_TIME = "presentationTime", this.LABEL = "Label", this.GROUP_LABEL = "GroupLabel", this.CONTENT_STEERING = "ContentSteering", this.CONTENT_STEERING_AS_ARRAY = "ContentSteering_asArray", this.DEFAULT_SERVICE_LOCATION = "defaultServiceLocation", this.QUERY_BEFORE_START = "queryBeforeStart", this.PROXY_SERVER_URL = "proxyServerURL", this.CONTENT_STEERING_RESPONSE = {
                    VERSION: "VERSION",
                    TTL: "TTL",
                    RELOAD_URI: "RELOAD-URI",
                    SERVICE_LOCATION_PRIORITY: "SERVICE-LOCATION-PRIORITY"
                  };
                }
              }]), m;
            }(), v = new d();
            const g = v;
          }
        ),
        /***/
        "./src/dash/controllers/ContentSteeringController.js": (
          /*!***********************************************************!*\
            !*** ./src/dash/controllers/ContentSteeringController.js ***!
            \***********************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => E
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), p = i(
              /*! ../../streaming/net/URLLoader */
              "./src/streaming/net/URLLoader.js"
            ), d = i(
              /*! ../../core/errors/Errors */
              "./src/core/errors/Errors.js"
            ), v = i(
              /*! ../vo/ContentSteeringRequest */
              "./src/dash/vo/ContentSteeringRequest.js"
            ), g = i(
              /*! ../vo/ContentSteeringResponse */
              "./src/dash/vo/ContentSteeringResponse.js"
            ), m = i(
              /*! ../constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            ), A = i(
              /*! ../../streaming/MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), b = i(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), S = i(
              /*! ../../streaming/constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), N = i(
              /*! ../../core/Utils */
              "./src/core/Utils.js"
            ), T = i(
              /*! ../../streaming/utils/URLUtils */
              "./src/streaming/utils/URLUtils.js"
            ), R = {
              THROUGHPUT: "_DASH_throughput",
              PATHWAY: "_DASH_pathway",
              URL: "url"
            };
            function y() {
              var L = this.context, _ = (0, T.default)(L).getInstance(), O, D, M, C, I, w, F, k, H, Z, Y, j, J, ae, G;
              function $() {
                D = (0, f.default)(L).getInstance().getLogger(O), P();
              }
              function ie(B) {
                B && (B.adapter && (G = B.adapter), B.errHandler && (k = B.errHandler), B.dashMetrics && (H = B.dashMetrics), B.mediaPlayerModel && (Z = B.mediaPlayerModel), B.requestModifier && (j = B.requestModifier), B.manifestModel && (Y = B.manifestModel), B.abrController && (J = B.abrController), B.eventBus && (ae = B.eventBus));
              }
              function re() {
                F = (0, p.default)(L).create({
                  errHandler: k,
                  dashMetrics: H,
                  mediaPlayerModel: Z,
                  requestModifier: j,
                  errors: d.default
                }), ae.on(A.default.PERIOD_SWITCH_COMPLETED, ce, O), ae.on(b.default.FRAGMENT_LOADING_STARTED, z, O);
              }
              function ce(B) {
                B && B.toStreamInfo && (C = B.toStreamInfo);
              }
              function z(B) {
                B && B.request && B.request.serviceLocation && (I = B.request.serviceLocation);
              }
              function oe() {
                var B = Y.getValue();
                return G.getContentSteering(B);
              }
              function de() {
                var B = oe();
                return B && B.queryBeforeStart;
              }
              function pe() {
                return new Promise(function(B) {
                  try {
                    var W = oe();
                    if (!W || !W.serverUrl) {
                      B();
                      return;
                    }
                    var X = he(W), K = new v.default(X);
                    F.load({
                      request: K,
                      success: function(V) {
                        se(V), ae.trigger(A.default.CONTENT_STEERING_REQUEST_COMPLETED, {
                          currentSteeringResponseData: M,
                          url: X
                        }), B();
                      },
                      error: function(V) {
                        le(V), B(V);
                      }
                    });
                  } catch (U) {
                    B(U);
                  }
                });
              }
              function he(B) {
                var W = B.proxyServerUrl ? B.proxyServerUrl : B.serverUrl;
                M && M.reloadUri && (_.isRelative(M.reloadUri) ? W = _.resolve(M.reloadUri, B.serverUrl) : W = M.reloadUri);
                var X = [];
                if (C) {
                  var K = G.getIsDynamic(), U = G.getAllMediaInfoForType(C, S.default.VIDEO).length > 0 ? S.default.VIDEO : S.default.AUDIO, V = J.getThroughputHistory(), Q = V ? V.getAverageThroughput(U, K) : NaN;
                  isNaN(Q) || X.push({
                    key: R.THROUGHPUT,
                    value: Q * 1e3
                  });
                }
                return I && X.push({
                  key: R.PATHWAY,
                  value: I
                }), B.proxyServerUrl && B.proxyServerUrl === W && B.serverUrl && X.push({
                  key: R.URL,
                  value: encodeURI(B.serverUrl)
                }), W = N.default.addAditionalQueryParameterToUrl(W, X), W;
              }
              function se(B) {
                !B || !B[m.default.CONTENT_STEERING_RESPONSE.VERSION] || parseInt(B[m.default.CONTENT_STEERING_RESPONSE.VERSION]) !== 1 || (M = new g.default(), M.version = B[m.default.CONTENT_STEERING_RESPONSE.VERSION], B[m.default.CONTENT_STEERING_RESPONSE.TTL] && !isNaN(B[m.default.CONTENT_STEERING_RESPONSE.TTL]) && (M.ttl = B[m.default.CONTENT_STEERING_RESPONSE.TTL]), B[m.default.CONTENT_STEERING_RESPONSE.RELOAD_URI] && (M.reloadUri = B[m.default.CONTENT_STEERING_RESPONSE.RELOAD_URI]), B[m.default.CONTENT_STEERING_RESPONSE.SERVICE_LOCATION_PRIORITY] && (M.serviceLocationPriority = B[m.default.CONTENT_STEERING_RESPONSE.SERVICE_LOCATION_PRIORITY]), ee());
              }
              function ee() {
                M && M.ttl && !isNaN(M.ttl) && (w && clearTimeout(w), w = setTimeout(function() {
                  pe();
                }, M.ttl * 1e3));
              }
              function te() {
                w && clearTimeout(w), w = null;
              }
              function le(B) {
                D.warn("Error fetching data from content steering server", B), ee();
              }
              function ne() {
                return M;
              }
              function x() {
                P(), ae.off(A.default.PERIOD_SWITCH_COMPLETED, ce, O), ae.off(b.default.FRAGMENT_LOADING_STARTED, z, O);
              }
              function P() {
                M = null, C = null, I = null, te();
              }
              return O = {
                reset: x,
                setConfig: ie,
                loadSteeringData: pe,
                getCurrentSteeringResponseData: ne,
                shouldQueryBeforeStart: de,
                getSteeringDataFromManifest: oe,
                stopSteeringRequestTimer: te,
                initialize: re
              }, $(), O;
            }
            y.__dashjs_factory_name = "ContentSteeringController";
            const E = h.default.getSingletonFactory(y);
          }
        ),
        /***/
        "./src/dash/controllers/RepresentationController.js": (
          /*!**********************************************************!*\
            !*** ./src/dash/controllers/RepresentationController.js ***!
            \**********************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => g
              /* harmony export */
            });
            var h = i(
              /*! ../../streaming/constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), f = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), p = i(
              /*! ../../streaming/MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), d = i(
              /*! ../utils/SegmentsUtils */
              "./src/dash/utils/SegmentsUtils.js"
            );
            function v(m) {
              m = m || {};
              var A = m.eventBus, b = m.events, S = m.abrController, N = m.dashMetrics, T = m.playbackController, R = m.timelineConverter, y = m.type, E = m.streamInfo, L = m.dashConstants, _ = m.segmentsController, O = m.isDynamic, D, M, C, I, w;
              function F() {
                ae(), A.on(p.default.MANIFEST_VALIDITY_CHANGED, ne, D);
              }
              function k() {
                return E.id;
              }
              function H() {
                return y;
              }
              function Z() {
                if (!S || !N || !T || !R)
                  throw new Error(h.default.MISSING_CONFIG_ERROR);
              }
              function Y() {
                return M;
              }
              function j() {
                return C;
              }
              function J() {
                return w;
              }
              function ae() {
                M = null, C = !0, I = [];
              }
              function G() {
                A.off(p.default.MANIFEST_VALIDITY_CHANGED, ne, D), ae();
              }
              function $(x, P, B, W, X) {
                Z(), C = !0, I = P;
                var K = de(X);
                if (le(K), M = x, B !== h.default.VIDEO && B !== h.default.AUDIO && (B !== h.default.TEXT || !W))
                  return se(), Promise.resolve();
                for (var U = [], V = 0, Q = I.length; V < Q; V++) {
                  var fe = I[V];
                  U.push(ie(fe));
                }
                return Promise.all(U);
              }
              function ie(x) {
                return new Promise(function(P, B) {
                  var W = x.hasInitialization(), X = x.hasSegments(), K = [];
                  K.push(_.updateInitData(x, W)), K.push(_.updateSegmentData(x, X)), Promise.all(K).then(function(U) {
                    U[0] && !U[0].error && (x = ce(x, U[0])), U[1] && !U[1].error && (x = z(x, U[1])), re(x), ee(x), P();
                  }).catch(function(U) {
                    B(U);
                  });
                });
              }
              function re(x) {
                x.mediaFinishedInformation = _.getMediaFinishedInformation(x);
              }
              function ce(x, P) {
                return !P || P.error || !P.representation ? x : P.representation;
              }
              function z(x, P) {
                if (!(!P || P.error)) {
                  var B = P.segments, W = [], X = 0, K, U, V, Q;
                  for (K = 0, U = B ? B.length : 0; K < U; K++)
                    V = B[K], Q = (0, d.getTimeBasedSegment)(R, O, x, V.startTime, V.duration, V.timescale, V.media, V.mediaRange, X), Q && (W.push(Q), Q = null, X++);
                  return W.length > 0 && (x.segments = W), x;
                }
              }
              function oe() {
                Z();
                var x = /* @__PURE__ */ new Date(), P = J(), B = T.getTime() * 1e3;
                P && N.addRepresentationSwitch(P.adaptation.type, x, B, P.id), A.trigger(p.default.REPRESENTATION_SWITCH, {
                  mediaType: y,
                  streamId: E.id,
                  currentRepresentation: P,
                  numberOfRepresentations: I.length
                }, {
                  streamId: E.id,
                  mediaType: y
                });
              }
              function de(x) {
                return x == null || x >= I.length ? null : I[x];
              }
              function pe(x) {
                return I.indexOf(x);
              }
              function he() {
                for (var x = 0, P = I.length; x < P; x++) {
                  var B = I[x].segmentInfoType;
                  if (!I[x].hasInitialization() || (B === L.SEGMENT_BASE || B === L.BASE_URL) && !I[x].segments)
                    return !1;
                }
                return !0;
              }
              function se(x) {
                C = !1, A.trigger(b.DATA_UPDATE_COMPLETED, {
                  data: M,
                  currentRepresentation: w,
                  error: x
                }, {
                  streamId: E.id,
                  mediaType: y
                });
              }
              function ee(x) {
                if (j()) {
                  var P = N.getCurrentManifestUpdate(), B = !1, W, X;
                  if (P) {
                    for (var K = 0; K < P.representationInfo.length; K++)
                      if (W = P.representationInfo[K], W.index === x.index && W.mediaType === H()) {
                        B = !0;
                        break;
                      }
                    B || N.addManifestUpdateRepresentationInfo(x, H());
                  }
                  if (he()) {
                    S.setPlaybackQuality(y, E, pe(w));
                    var U = N.getCurrentDVRInfo(y);
                    U && N.updateManifestUpdateInfo({
                      latency: U.range.end - T.getTime()
                    }), X = N.getCurrentRepresentationSwitch(J().adaptation.type), X || oe(), se();
                  }
                }
              }
              function te(x) {
                var P = de(x);
                le(P), oe();
              }
              function le(x) {
                w = x;
              }
              function ne(x) {
                if (x.newDuration) {
                  var P = J();
                  if (P && P.adaptation.period) {
                    var B = P.adaptation.period;
                    B.duration = x.newDuration;
                  }
                }
              }
              return D = {
                getStreamId: k,
                getType: H,
                getData: Y,
                isUpdating: j,
                updateData: $,
                getCurrentRepresentation: J,
                getRepresentationForQuality: de,
                prepareQualityChange: te,
                reset: G
              }, F(), D;
            }
            v.__dashjs_factory_name = "RepresentationController";
            const g = f.default.getClassFactory(v);
          }
        ),
        /***/
        "./src/dash/controllers/SegmentBaseController.js": (
          /*!*******************************************************!*\
            !*** ./src/dash/controllers/SegmentBaseController.js ***!
            \*******************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => g
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ../SegmentBaseLoader */
              "./src/dash/SegmentBaseLoader.js"
            ), p = i(
              /*! ../WebmSegmentBaseLoader */
              "./src/dash/WebmSegmentBaseLoader.js"
            );
            function d(m) {
              m = m || {};
              var A = this.context, b = m.eventBus, S = m.events, N = m.dashMetrics, T = m.mediaPlayerModel, R = m.errHandler, y = m.baseURLController, E = m.debug, L = m.boxParser, _ = m.requestModifier, O = m.errors, D, M, C;
              function I() {
                M = (0, f.default)(A).getInstance(), C = (0, p.default)(A).getInstance(), M.setConfig({
                  baseURLController: y,
                  dashMetrics: N,
                  mediaPlayerModel: T,
                  errHandler: R,
                  eventBus: b,
                  events: S,
                  errors: O,
                  debug: E,
                  boxParser: L,
                  requestModifier: _
                }), C.setConfig({
                  baseURLController: y,
                  dashMetrics: N,
                  mediaPlayerModel: T,
                  errHandler: R,
                  eventBus: b,
                  events: S,
                  errors: O,
                  debug: E,
                  requestModifier: _
                });
              }
              function w(Y) {
                var j = Y ? Y.split("/")[1] : "";
                return j.toLowerCase() === "webm";
              }
              function F() {
                M.initialize(), C.initialize();
              }
              function k(Y) {
                return w(Y.representation.mimeType) ? C.loadInitialization(Y.representation, Y.mediaType) : M.loadInitialization(Y.representation, Y.mediaType);
              }
              function H(Y) {
                return w(Y.mimeType) ? C.loadSegments(Y.representation, Y.mediaType, Y.representation ? Y.representation.indexRange : null) : M.loadSegments(Y.representation, Y.mediaType, Y.representation ? Y.representation.indexRange : null);
              }
              function Z() {
                M.reset(), C.reset();
              }
              return D = {
                initialize: F,
                getSegmentBaseInitSegment: k,
                getSegmentList: H,
                reset: Z
              }, I(), D;
            }
            d.__dashjs_factory_name = "SegmentBaseController";
            var v = h.default.getSingletonFactory(d);
            const g = v;
          }
        ),
        /***/
        "./src/dash/controllers/SegmentsController.js": (
          /*!****************************************************!*\
            !*** ./src/dash/controllers/SegmentsController.js ***!
            \****************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => A
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ../utils/TimelineSegmentsGetter */
              "./src/dash/utils/TimelineSegmentsGetter.js"
            ), p = i(
              /*! ../utils/TemplateSegmentsGetter */
              "./src/dash/utils/TemplateSegmentsGetter.js"
            ), d = i(
              /*! ../utils/ListSegmentsGetter */
              "./src/dash/utils/ListSegmentsGetter.js"
            ), v = i(
              /*! ../utils/SegmentBaseGetter */
              "./src/dash/utils/SegmentBaseGetter.js"
            );
            function g(b) {
              b = b || {};
              var S = this.context, N = b.dashConstants, T = b.type, R = b.segmentBaseController, y, E;
              function L() {
                E = {};
              }
              function _(F) {
                E[N.SEGMENT_TIMELINE] = (0, f.default)(S).create(b, F), E[N.SEGMENT_TEMPLATE] = (0, p.default)(S).create(b, F), E[N.SEGMENT_LIST] = (0, d.default)(S).create(b, F), E[N.SEGMENT_BASE] = (0, v.default)(S).create(b, F);
              }
              function O(F, k) {
                return k ? Promise.resolve() : R.getSegmentBaseInitSegment({
                  representation: F,
                  mediaType: T
                });
              }
              function D(F, k) {
                return k ? Promise.resolve() : R.getSegmentList({
                  mimeType: F.mimeType,
                  representation: F,
                  mediaType: T
                });
              }
              function M(F) {
                return F ? F.segments ? E[N.SEGMENT_BASE] : E[F.segmentInfoType] : null;
              }
              function C(F, k, H) {
                var Z = M(F);
                return Z ? Z.getSegmentByIndex(F, k, H) : null;
              }
              function I(F, k) {
                var H = M(F);
                return H ? H.getSegmentByTime(F, k) : null;
              }
              function w(F) {
                var k = M(F);
                return k ? k.getMediaFinishedInformation(F) : {
                  numberOfSegments: 0,
                  mediaTimeOfLastSignaledSegment: NaN
                };
              }
              return y = {
                initialize: _,
                updateInitData: O,
                updateSegmentData: D,
                getSegmentByIndex: C,
                getSegmentByTime: I,
                getMediaFinishedInformation: w
              }, L(), y;
            }
            g.__dashjs_factory_name = "SegmentsController";
            var m = h.default.getClassFactory(g);
            const A = m;
          }
        ),
        /***/
        "./src/dash/controllers/ServiceDescriptionController.js": (
          /*!**************************************************************!*\
            !*** ./src/dash/controllers/ServiceDescriptionController.js ***!
            \**************************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => A
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), p = i(
              /*! ../../streaming/constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), d = i(
              /*! ../constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            ), v = [p.default.SERVICE_DESCRIPTION_DVB_LL_SCHEME], g = {
              VIDEO: "video",
              AUDIO: "audio",
              ANY: "any",
              ALL: "all"
            };
            function m() {
              var b = this.context, S, N, T, R, y;
              function E() {
                R = (0, f.default)(b).getInstance().getLogger(S), O();
              }
              function L(J) {
                J && J.adapter && (y = J.adapter);
              }
              function _() {
                O();
              }
              function O() {
                N = {
                  liveDelay: NaN,
                  liveCatchup: {
                    maxDrift: NaN,
                    playbackRate: {
                      min: NaN,
                      max: NaN
                    }
                  },
                  minBitrate: {},
                  maxBitrate: {},
                  initialBitrate: {}
                }, T = [];
              }
              function D() {
                return N;
              }
              function M(J) {
                if (!(!J || !J.serviceDescriptions)) {
                  var ae = J.serviceDescriptions.filter(function(ie) {
                    return v.includes(ie.schemeIdUri);
                  }), G = J.serviceDescriptions.filter(function(ie) {
                    return ie.schemeIdUri == null;
                  }), $ = ae.length > 0 ? ae[ae.length - 1] : G[G.length - 1];
                  $ && ($.latency && $.latency.target > 0 && C($), $.playbackRate && F($), $.operatingQuality, $.operatingBandwidth && k($));
                }
              }
              function C(J) {
                var ae;
                if (J.schemeIdUri === p.default.SERVICE_DESCRIPTION_DVB_LL_SCHEME ? ae = w(J) : ae = I(J), T.length > 0) {
                  var G = j(ae), $ = G.to, ie = G.id;
                  N.liveDelay = ae.liveDelay - $, N.liveCatchup.maxDrift = ae.maxDrift, R.debug(`
                Found latency properties coming from service description. Applied time offset of `.concat($, " from ProducerReferenceTime element with id ").concat(ie, `.
                Live Delay: `).concat(ae.liveDelay - $, ", Live catchup max drift: ").concat(ae.maxDrift, `
            `));
                } else
                  N.liveDelay = ae.liveDelay, N.liveCatchup.maxDrift = ae.maxDrift, R.debug("Found latency properties coming from service description: Live Delay: ".concat(ae.liveDelay, ", Live catchup max drift: ").concat(ae.maxDrift));
              }
              function I(J) {
                var ae = J.latency.target / 1e3, G = !isNaN(J.latency.max) && J.latency.max > J.latency.target ? (J.latency.max - J.latency.target + 500) / 1e3 : NaN, $ = J.latency.referenceId || NaN;
                return {
                  liveDelay: ae,
                  maxDrift: G,
                  referenceId: $
                };
              }
              function w(J) {
                var ae = J.latency.target / 1e3, G = !isNaN(J.latency.max) && J.latency.max > J.latency.target ? (J.latency.max - J.latency.target + 500) / 1e3 : NaN, $ = J.latency.referenceId || NaN;
                return {
                  liveDelay: ae,
                  maxDrift: G,
                  referenceId: $
                };
              }
              function F(J) {
                var ae = J.playbackRate.min ? Math.round((J.playbackRate.min - 1) * 1e3) / 1e3 : NaN, G = J.playbackRate.max ? Math.round((J.playbackRate.max - 1) * 1e3) / 1e3 : NaN;
                N.liveCatchup.playbackRate.min = ae, N.liveCatchup.playbackRate.max = G, R.debug("Found latency properties coming from service description: Live catchup min playback rate: ".concat(ae)), R.debug("Found latency properties coming from service description: Live catchup max playback rate: ".concat(G));
              }
              function k(J) {
                if (!(!J || !J.operatingBandwidth || !J.operatingBandwidth.mediaType || J.operatingBandwidth.mediaType === g.ALL)) {
                  var ae = {};
                  ae.minBandwidth = J.operatingBandwidth.min, ae.maxBandwidth = J.operatingBandwidth.max, ae.targetBandwidth = J.operatingBandwidth.target;
                  var G = [];
                  J.operatingBandwidth.mediaType === g.VIDEO || J.operatingBandwidth.mediaType === g.AUDIO ? G.push(J.operatingBandwidth.mediaType) : J.operatingBandwidth.mediaType === g.ANY && (G.push(g.AUDIO), G.push(g.VIDEO)), G.forEach(function($) {
                    isNaN(ae.minBandwidth) || H("minBitrate", $, ae.minBandwidth), isNaN(ae.maxBandwidth) || H("maxBitrate", $, ae.maxBandwidth), isNaN(ae.targetBandwidth) || H("initialBitrate", $, ae.targetBandwidth);
                  });
                }
              }
              function H(J, ae, G) {
                try {
                  N[J][ae] = G / 1e3;
                } catch ($) {
                  R.error($);
                }
              }
              function Z() {
                return T;
              }
              function Y(J) {
                try {
                  var ae = [];
                  if (J && J.length > 0) {
                    var G = [p.default.VIDEO, p.default.AUDIO, p.default.TEXT], $ = y.getAvailabilityStartTime() / 1e3;
                    J.forEach(function(ie) {
                      var re = G.reduce(function(ce, z) {
                        return ce = ce.concat(y.getAllMediaInfoForType(ie, z)), ce;
                      }, []).reduce(function(ce, z) {
                        var oe = y.getProducerReferenceTimes(ie, z);
                        return oe.forEach(function(de) {
                          var pe = y.getVoRepresentations(z);
                          if (pe && pe.length > 0 && pe[0].adaptation && pe[0].segmentInfoType === d.default.SEGMENT_TEMPLATE) {
                            var he = pe[0], se = new Date(de[d.default.WALL_CLOCK_TIME]), ee = se.getTime() / 1e3, te = ee - (de[d.default.PRESENTATION_TIME] / he[d.default.TIMESCALE] - he[d.default.PRESENTATION_TIME_OFFSET] + ie.start), le = $ - te;
                            ce.push({
                              id: de[d.default.ID],
                              to: le
                            });
                          }
                        }), ce;
                      }, []);
                      ae = ae.concat(re);
                    });
                  }
                  T = ae;
                } catch (ie) {
                  R.error(ie), T = [];
                }
              }
              function j(J) {
                var ae = 0, G, $ = T.filter(function(ie) {
                  return ie.id === J.referenceId;
                });
                return $.length === 0 ? (ae = T.length > 0 ? T[0].to : 0, G = T[0].id || NaN) : (ae = $[0].to || 0, G = $[0].id || NaN), {
                  to: ae,
                  id: G
                };
              }
              return S = {
                getServiceDescriptionSettings: D,
                getProducerReferenceTimeOffsets: Z,
                calculateProducerReferenceTimeOffsets: Y,
                applyServiceDescription: M,
                reset: _,
                setConfig: L
              }, E(), S;
            }
            m.__dashjs_factory_name = "ServiceDescriptionController";
            const A = h.default.getSingletonFactory(m);
          }
        ),
        /***/
        "./src/dash/models/DashManifestModel.js": (
          /*!**********************************************!*\
            !*** ./src/dash/models/DashManifestModel.js ***!
            \**********************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => Y
              /* harmony export */
            });
            var h = i(
              /*! ../../streaming/constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), f = i(
              /*! ../constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            ), p = i(
              /*! ../vo/Representation */
              "./src/dash/vo/Representation.js"
            ), d = i(
              /*! ../vo/AdaptationSet */
              "./src/dash/vo/AdaptationSet.js"
            ), v = i(
              /*! ../vo/Period */
              "./src/dash/vo/Period.js"
            ), g = i(
              /*! ../vo/Mpd */
              "./src/dash/vo/Mpd.js"
            ), m = i(
              /*! ../vo/UTCTiming */
              "./src/dash/vo/UTCTiming.js"
            ), A = i(
              /*! ../vo/Event */
              "./src/dash/vo/Event.js"
            ), b = i(
              /*! ../vo/BaseURL */
              "./src/dash/vo/BaseURL.js"
            ), S = i(
              /*! ../vo/EventStream */
              "./src/dash/vo/EventStream.js"
            ), N = i(
              /*! ../vo/ProducerReferenceTime */
              "./src/dash/vo/ProducerReferenceTime.js"
            ), T = i(
              /*! ../vo/ContentSteering */
              "./src/dash/vo/ContentSteering.js"
            ), R = i(
              /*! ../../streaming/utils/ObjectUtils */
              "./src/streaming/utils/ObjectUtils.js"
            ), y = i(
              /*! ../../streaming/utils/URLUtils */
              "./src/streaming/utils/URLUtils.js"
            ), E = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), L = i(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), _ = i(
              /*! ../../streaming/vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), O = i(
              /*! ../../core/errors/Errors */
              "./src/core/errors/Errors.js"
            ), D = i(
              /*! ../../streaming/thumbnail/ThumbnailTracks */
              "./src/streaming/thumbnail/ThumbnailTracks.js"
            );
            function M(j, J) {
              var ae;
              if (typeof Symbol > "u" || j[Symbol.iterator] == null) {
                if (Array.isArray(j) || (ae = w(j)) || J && j && typeof j.length == "number") {
                  ae && (j = ae);
                  var G = 0, $ = function() {
                  };
                  return { s: $, n: function() {
                    return G >= j.length ? { done: !0 } : { done: !1, value: j[G++] };
                  }, e: function(oe) {
                    throw oe;
                  }, f: $ };
                }
                throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
              var ie = !0, re = !1, ce;
              return { s: function() {
                ae = j[Symbol.iterator]();
              }, n: function() {
                var oe = ae.next();
                return ie = oe.done, oe;
              }, e: function(oe) {
                re = !0, ce = oe;
              }, f: function() {
                try {
                  !ie && ae.return != null && ae.return();
                } finally {
                  if (re)
                    throw ce;
                }
              } };
            }
            function C(j) {
              return k(j) || F(j) || w(j) || I();
            }
            function I() {
              throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }
            function w(j, J) {
              if (j) {
                if (typeof j == "string")
                  return H(j, J);
                var ae = Object.prototype.toString.call(j).slice(8, -1);
                if (ae === "Object" && j.constructor && (ae = j.constructor.name), ae === "Map" || ae === "Set")
                  return Array.from(j);
                if (ae === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ae))
                  return H(j, J);
              }
            }
            function F(j) {
              if (typeof Symbol < "u" && Symbol.iterator in Object(j))
                return Array.from(j);
            }
            function k(j) {
              if (Array.isArray(j))
                return H(j);
            }
            function H(j, J) {
              (J == null || J > j.length) && (J = j.length);
              for (var ae = 0, G = new Array(J); ae < J; ae++)
                G[ae] = j[ae];
              return G;
            }
            function Z() {
              var j, J, ae, G, $ = this.context, ie = (0, y.default)($).getInstance(), re = Number.isInteger || function(ye) {
                return typeof ye == "number" && isFinite(ye) && Math.floor(ye) === ye;
              };
              function ce() {
                J = (0, L.default)($).getInstance().getLogger(j);
              }
              function z(ye, ze) {
                if (!ye)
                  throw new Error("adaptation is not defined");
                if (!ze)
                  throw new Error("type is not defined");
                if (ye.Representation_asArray && ye.Representation_asArray.length) {
                  var ft = nt(ye.Representation_asArray[0]);
                  if (ft && ft.length > 0 && D.THUMBNAILS_SCHEME_ID_URIS.indexOf(ft[0].schemeIdUri) >= 0)
                    return ze === h.default.IMAGE;
                }
                if (ye.ContentComponent_asArray && ye.ContentComponent_asArray.length > 0) {
                  if (ye.ContentComponent_asArray.length > 1)
                    return ze === h.default.MUXED;
                  if (ye.ContentComponent_asArray[0].contentType === ze)
                    return !0;
                }
                var Le = ze === h.default.TEXT ? new RegExp("(ttml|vtt|wvtt|stpp)") : new RegExp(ze);
                if (ye.Representation_asArray && ye.Representation_asArray.length) {
                  var Ke = ye.Representation_asArray[0].codecs;
                  if (Le.test(Ke))
                    return !0;
                }
                if (ye.hasOwnProperty(f.default.MIME_TYPE))
                  return Le.test(ye.mimeType);
                if (ye.Representation_asArray) {
                  for (var Qe, Et = 0; Et < ye.Representation_asArray.length; Et++)
                    if (Qe = ye.Representation_asArray[Et], Qe.hasOwnProperty(f.default.MIME_TYPE))
                      return Le.test(Qe.mimeType);
                }
                return !1;
              }
              function oe(ye) {
                if (!ye)
                  throw new Error("adaptation is not defined");
                if (ye.hasOwnProperty(f.default.SEGMENT_TEMPLATE) || ye.hasOwnProperty(f.default.SEGMENT_TIMELINE) || ye.hasOwnProperty(f.default.SEGMENT_LIST) || ye.hasOwnProperty(f.default.SEGMENT_BASE))
                  return !0;
                if (ye.Representation_asArray && ye.Representation_asArray.length > 0) {
                  var ze = ye.Representation_asArray[0];
                  if (ze.hasOwnProperty(f.default.SEGMENT_TEMPLATE) || ze.hasOwnProperty(f.default.SEGMENT_TIMELINE) || ze.hasOwnProperty(f.default.SEGMENT_LIST) || ze.hasOwnProperty(f.default.SEGMENT_BASE))
                    return !0;
                }
                return !1;
              }
              function de(ye) {
                return z(ye, h.default.AUDIO);
              }
              function pe(ye) {
                return z(ye, h.default.VIDEO);
              }
              function he(ye) {
                return z(ye, h.default.TEXT);
              }
              function se(ye) {
                return z(ye, h.default.MUXED);
              }
              function ee(ye) {
                return z(ye, h.default.IMAGE);
              }
              function te(ye) {
                var ze = ye && ye.hasOwnProperty(f.default.PRODUCERREFERENCETIME_ASARRAY) ? ye[f.default.PRODUCERREFERENCETIME_ASARRAY] : [], ft = ye && ye.hasOwnProperty(f.default.REPRESENTATION_ASARRAY) ? ye[f.default.REPRESENTATION_ASARRAY] : [];
                ft.forEach(function(Ke) {
                  Ke.hasOwnProperty(f.default.PRODUCERREFERENCETIME_ASARRAY) && ze.push.apply(ze, C(Ke[f.default.PRODUCERREFERENCETIME_ASARRAY]));
                });
                var Le = [];
                return ze.forEach(function(Ke) {
                  var Qe = new N.default();
                  if (Ke.hasOwnProperty(f.default.ID))
                    Qe[f.default.ID] = Ke[f.default.ID];
                  else
                    return;
                  if (Ke.hasOwnProperty(f.default.WALL_CLOCK_TIME))
                    Qe[f.default.WALL_CLOCK_TIME] = Ke[f.default.WALL_CLOCK_TIME];
                  else
                    return;
                  if (Ke.hasOwnProperty(f.default.PRESENTATION_TIME))
                    Qe[f.default.PRESENTATION_TIME] = Ke[f.default.PRESENTATION_TIME];
                  else
                    return;
                  Le.push(Qe);
                }), Le;
              }
              function le(ye) {
                var ze = "";
                return ye && ye.hasOwnProperty(f.default.LANG) && (ze = ye.lang), ze;
              }
              function ne(ye) {
                return ye && ye.hasOwnProperty(f.default.VIEWPOINT) ? ye.Viewpoint : null;
              }
              function x(ye) {
                return ye && ye.hasOwnProperty(f.default.ROLE_ASARRAY) ? ye.Role_asArray : [];
              }
              function P(ye) {
                return ye && ye.hasOwnProperty(f.default.ACCESSIBILITY_ASARRAY) ? ye.Accessibility_asArray : [];
              }
              function B(ye) {
                return ye && ye.hasOwnProperty(f.default.AUDIOCHANNELCONFIGURATION_ASARRAY) ? ye.AudioChannelConfiguration_asArray : [];
              }
              function W(ye) {
                return ye && ye.hasOwnProperty(f.default.AUDIOCHANNELCONFIGURATION_ASARRAY) ? ye.AudioChannelConfiguration_asArray : [];
              }
              function X() {
                return function(ye, ze) {
                  return ye.bandwidth - ze.bandwidth;
                };
              }
              function K(ye) {
                return ye && Array.isArray(ye.Representation_asArray) && ye.Representation_asArray.sort(X()), ye;
              }
              function U(ye, ze) {
                return ye && ye.Period_asArray && re(ze) ? ye.Period_asArray[ze] ? ye.Period_asArray[ze].AdaptationSet_asArray : [] : [];
              }
              function V(ye) {
                return ye && ye.Period_asArray ? ye.Period_asArray : [];
              }
              function Q(ye, ze) {
                var ft = V(ze);
                return ft.length > 0 && re(ye) ? ft[ye] : null;
              }
              function fe(ye, ze, ft) {
                var Le = U(ze, ft), Ke, Qe;
                for (Ke = 0, Qe = Le.length; Ke < Qe; Ke++)
                  if (Le[Ke].hasOwnProperty(f.default.ID) && Le[Ke].id === ye)
                    return Le[Ke];
                return null;
              }
              function ue(ye, ze, ft) {
                var Le = U(ze, ft);
                return Le.length > 0 && re(ye) ? Le[ye] : null;
              }
              function q(ye, ze, ft) {
                if (!ye)
                  return -1;
                for (var Le = U(ze, ft), Ke = 0; Ke < Le.length; Ke++) {
                  var Qe = (0, R.default)($).getInstance();
                  if (Qe.areEqual(Le[Ke], ye))
                    return Ke;
                }
                return -1;
              }
              function _e(ye, ze, ft) {
                var Le = U(ye, ze), Ke, Qe, Et = [];
                for (Ke = 0, Qe = Le.length; Ke < Qe; Ke++)
                  z(Le[Ke], ft) && Et.push(K(Le[Ke]));
                return Et;
              }
              function ge(ye, ze, ft) {
                var Le = null;
                if (ye && ye.Representation_asArray && ye.Representation_asArray.length > 0) {
                  var Ke = re(ze) && ze >= 0 && ze < ye.Representation_asArray.length ? ye.Representation_asArray[ze] : ye.Representation_asArray[0];
                  Ke && (Le = Ke.mimeType + ';codecs="' + Ke.codecs + '"', ft && Ke.width !== void 0 && (Le += ';width="' + Ke.width + '";height="' + Ke.height + '"'));
                }
                return Le && (Le = Le.replace(/\sprofiles=[^;]*/g, "")), Le;
              }
              function Ce(ye) {
                return ye && ye.Representation_asArray && ye.Representation_asArray.length > 0 ? ye.Representation_asArray[0].mimeType : null;
              }
              function Ee(ye) {
                return !ye || !ye.hasOwnProperty(f.default.CENC_DEFAULT_KID) ? null : ye[f.default.CENC_DEFAULT_KID];
              }
              function Re(ye) {
                if (!ye || !Array.isArray(ye.Label_asArray))
                  return [];
                for (var ze = [], ft = 0; ft < ye.Label_asArray.length; ft++)
                  ze.push({
                    lang: ye.Label_asArray[ft].lang,
                    text: ye.Label_asArray[ft].__text || ye.Label_asArray[ft]
                  });
                return ze;
              }
              function Pe(ye) {
                return !ye || !ye.hasOwnProperty(f.default.CONTENTPROTECTION_ASARRAY) || ye.ContentProtection_asArray.length === 0 ? null : ye.ContentProtection_asArray;
              }
              function ke(ye) {
                var ze = !1;
                return ye && ye.hasOwnProperty("type") && (ze = ye.type === f.default.DYNAMIC), ze;
              }
              function De(ye) {
                return ye && ye[f.default.ID] || null;
              }
              function Ae(ye, ze) {
                var ft = !1;
                return ye && ye.profiles && ye.profiles.length > 0 && (ft = ye.profiles.indexOf(ze) !== -1), ft;
              }
              function Ie(ye) {
                var ze;
                return ye && ye.hasOwnProperty(f.default.MEDIA_PRESENTATION_DURATION) ? ze = ye.mediaPresentationDuration : ye && ye.type == "dynamic" ? ze = Number.POSITIVE_INFINITY : ze = Number.MAX_SAFE_INTEGER || Number.MAX_VALUE, ze;
              }
              function Xe(ye) {
                return ye && ye.bandwidth ? ye.bandwidth : NaN;
              }
              function it(ye) {
                var ze = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, ft = NaN;
                return ye && ye.hasOwnProperty(f.default.MINIMUM_UPDATE_PERIOD) && (ft = ye.minimumUpdatePeriod), isNaN(ft) ? ft : Math.max(ft - ze, 1);
              }
              function rt(ye) {
                return ye && ye.hasOwnProperty(f.default.PUBLISH_TIME) ? new Date(ye[f.default.PUBLISH_TIME]) : null;
              }
              function Ne(ye) {
                return ye && Array.isArray(ye.Representation_asArray) ? ye.Representation_asArray.length : 0;
              }
              function He(ye) {
                var ze = K(ye), ft = ze && Array.isArray(ze.Representation_asArray) ? ze.Representation_asArray : [];
                return ft.map(function(Le) {
                  return {
                    bandwidth: Le.bandwidth,
                    width: Le.width || 0,
                    height: Le.height || 0,
                    scanType: Le.scanType || null,
                    id: Le.id || null
                  };
                });
              }
              function $e(ye) {
                try {
                  var ze = ye && typeof ye.selectionPriority < "u" ? parseInt(ye.selectionPriority) : 1;
                  return isNaN(ze) ? 1 : ze;
                } catch {
                  return 1;
                }
              }
              function nt(ye) {
                return !ye || !ye.EssentialProperty_asArray || !ye.EssentialProperty_asArray.length ? null : ye.EssentialProperty_asArray.map(function(ze) {
                  return {
                    schemeIdUri: ze.schemeIdUri,
                    value: ze.value
                  };
                });
              }
              function ut(ye, ze) {
                return ze && ze.Representation_asArray && ze.Representation_asArray.length > 0 && re(ye) ? ze.Representation_asArray[ye] : null;
              }
              function pt(ye) {
                if (ye && ye.period && re(ye.period.index)) {
                  var ze = ye.period.mpd.manifest.Period_asArray[ye.period.index];
                  if (ze && ze.AdaptationSet_asArray && re(ye.index))
                    return K(ze.AdaptationSet_asArray[ye.index]);
                }
              }
              function vt(ye) {
                var ze = [], ft = pt(ye), Le, Ke;
                if (ft && ft.Representation_asArray) {
                  if (ye && ye.period && re(ye.period.index)) {
                    var Qe = be(ye.period.mpd.manifest);
                    Qe && (Ke = Qe[0]);
                  }
                  for (var Et = 0, Vt = ft.Representation_asArray.length; Et < Vt; ++Et) {
                    var It = ft.Representation_asArray[Et], Pt = new p.default();
                    if (Pt.index = Et, Pt.adaptation = ye, It.hasOwnProperty(f.default.ID) && (Pt.id = It.id), It.hasOwnProperty(f.default.CODECS) && (Pt.codecs = It.codecs), It.hasOwnProperty(f.default.MIME_TYPE) && (Pt.mimeType = It[f.default.MIME_TYPE]), It.hasOwnProperty(f.default.CODEC_PRIVATE_DATA) && (Pt.codecPrivateData = It.codecPrivateData), It.hasOwnProperty(f.default.BANDWITH) && (Pt.bandwidth = It.bandwidth), It.hasOwnProperty(f.default.WIDTH) && (Pt.width = It.width), It.hasOwnProperty(f.default.HEIGHT) && (Pt.height = It.height), It.hasOwnProperty(f.default.SCAN_TYPE) && (Pt.scanType = It.scanType), It.hasOwnProperty(f.default.MAX_PLAYOUT_RATE) && (Pt.maxPlayoutRate = It.maxPlayoutRate), It.hasOwnProperty(f.default.SEGMENT_BASE) ? (Le = It.SegmentBase, Pt.segmentInfoType = f.default.SEGMENT_BASE) : It.hasOwnProperty(f.default.SEGMENT_LIST) ? (Le = It.SegmentList, Le.hasOwnProperty(f.default.SEGMENT_TIMELINE) ? Pt.segmentInfoType = f.default.SEGMENT_TIMELINE : Pt.segmentInfoType = f.default.SEGMENT_LIST) : It.hasOwnProperty(f.default.SEGMENT_TEMPLATE) ? (Le = It.SegmentTemplate, Le.hasOwnProperty(f.default.SEGMENT_TIMELINE) ? Pt.segmentInfoType = f.default.SEGMENT_TIMELINE : Pt.segmentInfoType = f.default.SEGMENT_TEMPLATE, Le.hasOwnProperty(f.default.INITIALIZATION_MINUS) && (Pt.initialization = Le.initialization.split("$Bandwidth$").join(It.bandwidth).split("$RepresentationID$").join(It.id))) : Pt.segmentInfoType = f.default.BASE_URL, Pt.essentialProperties = nt(It), Le) {
                      if (Le.hasOwnProperty(f.default.INITIALIZATION)) {
                        var mn = Le.Initialization;
                        mn.hasOwnProperty(f.default.SOURCE_URL) && (Pt.initialization = mn.sourceURL), mn.hasOwnProperty(f.default.RANGE) && (Pt.range = mn.range);
                      } else
                        he(ft) && oe(ft) && ft.mimeType && ft.mimeType.indexOf("application/mp4") === -1 && (Pt.range = 0);
                      Le.hasOwnProperty(f.default.TIMESCALE) && (Pt.timescale = Le.timescale), Le.hasOwnProperty(f.default.DURATION) ? Pt.segmentDuration = Le.duration / Pt.timescale : It.hasOwnProperty(f.default.SEGMENT_TEMPLATE) && (Le = It.SegmentTemplate, Le.hasOwnProperty(f.default.SEGMENT_TIMELINE) && (Pt.segmentDuration = Ut(Le.SegmentTimeline) / Pt.timescale)), Le.hasOwnProperty(f.default.MEDIA) && (Pt.media = Le.media), Le.hasOwnProperty(f.default.START_NUMBER) && (Pt.startNumber = Le.startNumber), Le.hasOwnProperty(f.default.INDEX_RANGE) && (Pt.indexRange = Le.indexRange), Le.hasOwnProperty(f.default.PRESENTATION_TIME_OFFSET) && (Pt.presentationTimeOffset = Le.presentationTimeOffset / Pt.timescale), Le.hasOwnProperty(f.default.AVAILABILITY_TIME_OFFSET) ? Pt.availabilityTimeOffset = Le.availabilityTimeOffset : Ke && Ke.availabilityTimeOffset !== void 0 && (Pt.availabilityTimeOffset = Ke.availabilityTimeOffset), Le.hasOwnProperty(f.default.AVAILABILITY_TIME_COMPLETE) ? Pt.availabilityTimeComplete = Le.availabilityTimeComplete !== "false" : Ke && Ke.availabilityTimeComplete !== void 0 && (Pt.availabilityTimeComplete = Ke.availabilityTimeComplete);
                    }
                    Pt.MSETimeOffset = Je(Pt), Pt.path = [ye.period.index, ye.index, Et], ze.push(Pt);
                  }
                }
                return ze;
              }
              function Ut(ye) {
                if (!ye || !ye.S_asArray)
                  return NaN;
                var ze = ye.S_asArray[0], ft = ye.S_asArray[1];
                return ze.hasOwnProperty("d") ? ze.d : ft.t - ze.t;
              }
              function Je(ye) {
                var ze = ye.presentationTimeOffset, ft = ye.adaptation.period.start;
                return ft - ze;
              }
              function Te(ye) {
                var ze = ye && re(ye.index) ? ye.mpd.manifest.Period_asArray[ye.index] : null, ft = [], Le, Ke, Qe;
                if (ze && ze.AdaptationSet_asArray)
                  for (Qe = 0; Qe < ze.AdaptationSet_asArray.length; Qe++)
                    Ke = ze.AdaptationSet_asArray[Qe], Le = new d.default(), Ke.hasOwnProperty(f.default.ID) && (Le.id = Ke.id), Le.index = Qe, Le.period = ye, se(Ke) ? Le.type = h.default.MUXED : de(Ke) ? Le.type = h.default.AUDIO : pe(Ke) ? Le.type = h.default.VIDEO : he(Ke) ? Le.type = h.default.TEXT : ee(Ke) ? Le.type = h.default.IMAGE : J.warn("Unknown Adaptation stream type"), ft.push(Le);
                return ft;
              }
              function me(ye) {
                var ze = ye ? ke(ye.manifest) : !1, ft = [], Le = null, Ke = null, Qe = null, Et = null, Vt, It;
                for (It = 0, Vt = ye && ye.manifest && ye.manifest.Period_asArray ? ye.manifest.Period_asArray.length : 0; It < Vt; It++)
                  Ke = ye.manifest.Period_asArray[It], Ke.hasOwnProperty(f.default.START) ? (Et = new v.default(), Et.start = Ke.start) : Le !== null && Le.hasOwnProperty(f.default.DURATION) && Qe !== null ? (Et = new v.default(), Et.start = parseFloat((Qe.start + Qe.duration).toFixed(5))) : It === 0 && !ze && (Et = new v.default(), Et.start = 0), Qe !== null && isNaN(Qe.duration) && (Et !== null ? Qe.duration = parseFloat((Et.start - Qe.start).toFixed(5)) : J.warn("First period duration could not be calculated because lack of start and duration period properties. This will cause timing issues during playback")), Et !== null && (Et.id = Me(Ke, It), Et.index = It, Et.mpd = ye, Ke.hasOwnProperty(f.default.DURATION) && (Et.duration = Ke.duration), Qe && (Qe.nextPeriodId = Et.id), ft.push(Et), Le = Ke, Qe = Et), Ke = null, Et = null;
                return ft.length === 0 || Qe !== null && isNaN(Qe.duration) && (Qe.duration = parseFloat((Ze(Qe) - Qe.start).toFixed(5))), ft;
              }
              function Me(ye, ze) {
                if (!ye)
                  throw new Error("Period cannot be null or undefined");
                var ft = v.default.DEFAULT_ID + "_" + ze;
                return ye.hasOwnProperty(f.default.ID) && ye.id.length > 0 && ye.id !== "__proto__" && (ft = ye.id), ft;
              }
              function Be(ye) {
                var ze = new g.default();
                return ye && (ze.manifest = ye, ye.hasOwnProperty(f.default.AVAILABILITY_START_TIME) ? ze.availabilityStartTime = new Date(ye.availabilityStartTime.getTime()) : ye.loadedTime && (ze.availabilityStartTime = new Date(ye.loadedTime.getTime())), ye.hasOwnProperty(f.default.AVAILABILITY_END_TIME) && (ze.availabilityEndTime = new Date(ye.availabilityEndTime.getTime())), ye.hasOwnProperty(f.default.MINIMUM_UPDATE_PERIOD) && (ze.minimumUpdatePeriod = ye.minimumUpdatePeriod), ye.hasOwnProperty(f.default.MEDIA_PRESENTATION_DURATION) && (ze.mediaPresentationDuration = ye.mediaPresentationDuration), ye.hasOwnProperty(f.default.SUGGESTED_PRESENTATION_DELAY) && (ze.suggestedPresentationDelay = ye.suggestedPresentationDelay), ye.hasOwnProperty(f.default.TIMESHIFT_BUFFER_DEPTH) && (ze.timeShiftBufferDepth = ye.timeShiftBufferDepth), ye.hasOwnProperty(f.default.MAX_SEGMENT_DURATION) && (ze.maxSegmentDuration = ye.maxSegmentDuration), ye.hasOwnProperty(f.default.PUBLISH_TIME) && (ze.publishTime = new Date(ye.publishTime))), ze;
              }
              function Fe() {
                if (!ae || !ae.hasOwnProperty("error"))
                  throw new Error(h.default.MISSING_CONFIG_ERROR);
              }
              function Ze(ye) {
                Fe();
                var ze = ke(ye.mpd.manifest), ft;
                return ye.mpd.manifest.mediaPresentationDuration ? ft = ye.mpd.manifest.mediaPresentationDuration : ye.duration ? ft = ye.duration : ze ? ft = Number.POSITIVE_INFINITY : ae.error(new _.default(O.default.MANIFEST_ERROR_ID_PARSE_CODE, "Must have @mediaPresentationDuration on MPD or an explicit @duration on the last period.", ye)), ft;
              }
              function ot(ye) {
                var ze = ye && ye.mpd && ye.mpd.manifest ? ye.mpd.manifest : null, ft = ze ? ze.Period_asArray : null, Le = ft && ye && re(ye.index) ? ft[ye.index].EventStream_asArray : null, Ke = [], Qe, Et;
                if (Le)
                  for (Qe = 0; Qe < Le.length; Qe++) {
                    var Vt = new S.default();
                    if (Vt.period = ye, Vt.timescale = 1, Le[Qe].hasOwnProperty(h.default.SCHEME_ID_URI))
                      Vt.schemeIdUri = Le[Qe][h.default.SCHEME_ID_URI];
                    else
                      throw new Error("Invalid EventStream. SchemeIdUri has to be set");
                    for (Le[Qe].hasOwnProperty(f.default.TIMESCALE) && (Vt.timescale = Le[Qe][f.default.TIMESCALE]), Le[Qe].hasOwnProperty(f.default.VALUE) && (Vt.value = Le[Qe][f.default.VALUE]), Le[Qe].hasOwnProperty(f.default.PRESENTATION_TIME_OFFSET) && (Vt.presentationTimeOffset = Le[Qe][f.default.PRESENTATION_TIME_OFFSET]), Et = 0; Le[Qe].Event_asArray && Et < Le[Qe].Event_asArray.length; Et++) {
                      var It = Le[Qe].Event_asArray[Et], Pt = new A.default();
                      Pt.presentationTime = 0, Pt.eventStream = Vt, It.hasOwnProperty(f.default.PRESENTATION_TIME) && (Pt.presentationTime = It.presentationTime);
                      var mn = Vt.presentationTimeOffset ? Vt.presentationTimeOffset / Vt.timescale : 0;
                      Pt.calculatedPresentationTime = Pt.presentationTime / Vt.timescale + ye.start - mn, It.hasOwnProperty(f.default.DURATION) && (Pt.duration = It.duration / Vt.timescale), It.hasOwnProperty(f.default.ID) ? Pt.id = It.id : Pt.id = null, It.Signal && It.Signal.Binary ? Pt.messageData = G.decodeArray(It.Signal.Binary.toString()) : Pt.messageData = It.messageData || It.__cdata || It.__text, Ke.push(Pt);
                    }
                  }
                return Ke;
              }
              function tt(ye, ze, ft) {
                var Le = [], Ke;
                if (!ye)
                  return Le;
                for (Ke = 0; Ke < ye.length; Ke++) {
                  var Qe = new S.default();
                  if (Qe.timescale = 1, Qe.representation = ze, ye[Ke].hasOwnProperty(h.default.SCHEME_ID_URI))
                    Qe.schemeIdUri = ye[Ke].schemeIdUri;
                  else
                    throw new Error("Invalid EventStream. SchemeIdUri has to be set");
                  ye[Ke].hasOwnProperty(f.default.TIMESCALE) && (Qe.timescale = ye[Ke].timescale), ye[Ke].hasOwnProperty(f.default.VALUE) && (Qe.value = ye[Ke].value), Le.push(Qe), Qe.period = ft;
                }
                return Le;
              }
              function gt(ye, ze, ft) {
                var Le, Ke, Qe;
                return ye && ye.Period_asArray && ze && ze.period && re(ze.period.index) && (Ke = ye.Period_asArray[ze.period.index], Ke && Ke.AdaptationSet_asArray && re(ze.index) && (Qe = Ke.AdaptationSet_asArray[ze.index], Qe && (Le = Qe.InbandEventStream_asArray))), tt(Le, null, ft);
              }
              function Mt(ye, ze, ft) {
                var Le, Ke, Qe, Et;
                return ye && ye.Period_asArray && ze && ze.adaptation && ze.adaptation.period && re(ze.adaptation.period.index) && (Ke = ye.Period_asArray[ze.adaptation.period.index], Ke && Ke.AdaptationSet_asArray && re(ze.adaptation.index) && (Qe = Ke.AdaptationSet_asArray[ze.adaptation.index], Qe && Qe.Representation_asArray && re(ze.index) && (Et = Qe.Representation_asArray[ze.index], Et && (Le = Et.InbandEventStream_asArray)))), tt(Le, ze, ft);
              }
              function xt(ye) {
                var ze = ke(ye), ft = ye ? ye.hasOwnProperty(f.default.AVAILABILITY_START_TIME) : !1, Le = ye ? ye.UTCTiming_asArray : null, Ke = [];
                return (ze || ft) && Le && Le.forEach(function(Qe) {
                  var Et = new m.default();
                  if (Qe.hasOwnProperty(h.default.SCHEME_ID_URI))
                    Et.schemeIdUri = Qe.schemeIdUri;
                  else
                    return;
                  if (Qe.hasOwnProperty(f.default.VALUE))
                    Et.value = Qe.value.toString();
                  else
                    return;
                  Ke.push(Et);
                }), Ke;
              }
              function be(ye) {
                var ze = [], ft = ye.BaseURL_asArray || [ye.baseUri], Le = !1;
                return ft.some(function(Ke) {
                  if (Ke) {
                    var Qe = new b.default(), Et = Ke.__text || Ke;
                    return ie.isRelative(Et) && (Le = !0, ye.baseUri && (Et = ie.resolve(Et, ye.baseUri))), Qe.url = Et, Ke.hasOwnProperty(f.default.SERVICE_LOCATION) && Ke.serviceLocation.length ? Qe.serviceLocation = Ke.serviceLocation : Qe.serviceLocation = Et, Ke.hasOwnProperty(f.default.DVB_PRIORITY) && (Qe.dvb_priority = Ke[f.default.DVB_PRIORITY]), Ke.hasOwnProperty(f.default.DVB_WEIGHT) && (Qe.dvb_weight = Ke[f.default.DVB_WEIGHT]), Ke.hasOwnProperty(f.default.AVAILABILITY_TIME_OFFSET) && (Qe.availabilityTimeOffset = Ke[f.default.AVAILABILITY_TIME_OFFSET]), Ke.hasOwnProperty(f.default.AVAILABILITY_TIME_COMPLETE) && (Qe.availabilityTimeComplete = Ke[f.default.AVAILABILITY_TIME_COMPLETE] !== "false"), ze.push(Qe), Le;
                  }
                }), ze;
              }
              function We(ye) {
                if (ye && ye.hasOwnProperty(f.default.CONTENT_STEERING_AS_ARRAY)) {
                  var ze = ye[f.default.CONTENT_STEERING_AS_ARRAY][0], ft = new T.default();
                  return ft.serverUrl = ze.__text, ze.hasOwnProperty(f.default.DEFAULT_SERVICE_LOCATION) && (ft.defaultServiceLocation = ze[f.default.DEFAULT_SERVICE_LOCATION]), ze.hasOwnProperty(f.default.QUERY_BEFORE_START) && (ft.queryBeforeStart = ze[f.default.QUERY_BEFORE_START].toLowerCase() === "true"), ze.hasOwnProperty(f.default.PROXY_SERVER_URL) && (ft.proxyServerUrl = ze[f.default.PROXY_SERVER_URL]), ft;
                }
              }
              function et(ye) {
                if (ye && ye.hasOwnProperty(h.default.LOCATION))
                  return ye.Location = ye.Location_asArray[0], ye.Location;
              }
              function _t(ye) {
                if (ye && ye.hasOwnProperty(f.default.PATCH_LOCATION))
                  return ye.PatchLocation = ye.PatchLocation_asArray[0], ye.PatchLocation;
              }
              function ht(ye) {
                return ye && ye.hasOwnProperty(f.default.SUGGESTED_PRESENTATION_DELAY) ? ye.suggestedPresentationDelay : null;
              }
              function St(ye) {
                return ye && ye.hasOwnProperty(f.default.AVAILABILITY_START_TIME) && ye.availabilityStartTime !== null ? ye.availabilityStartTime.getTime() : null;
              }
              function kt(ye) {
                var ze = [];
                if (ye && ye.hasOwnProperty(f.default.SERVICE_DESCRIPTION)) {
                  var ft = M(ye.ServiceDescription_asArray), Le;
                  try {
                    for (ft.s(); !(Le = ft.n()).done; ) {
                      var Ke = Le.value, Qe = null, Et = null, Vt = null, It = null, Pt = null, mn = null;
                      for (var Jt in Ke)
                        Ke.hasOwnProperty(Jt) && (Jt === f.default.ID ? Qe = Ke[Jt] : Jt === f.default.SERVICE_DESCRIPTION_SCOPE ? Et = Ke[Jt].schemeIdUri : Jt === f.default.SERVICE_DESCRIPTION_LATENCY ? Vt = {
                          target: parseInt(Ke[Jt].target),
                          max: parseInt(Ke[Jt].max),
                          min: parseInt(Ke[Jt].min),
                          referenceId: parseInt(Ke[Jt].referenceId)
                        } : Jt === f.default.SERVICE_DESCRIPTION_PLAYBACK_RATE ? It = {
                          max: parseFloat(Ke[Jt].max),
                          min: parseFloat(Ke[Jt].min)
                        } : Jt === f.default.SERVICE_DESCRIPTION_OPERATING_QUALITY ? Pt = {
                          mediaType: Ke[Jt].mediaType,
                          max: parseInt(Ke[Jt].max),
                          min: parseInt(Ke[Jt].min),
                          target: parseInt(Ke[Jt].target),
                          type: Ke[Jt].type,
                          maxQualityDifference: parseInt(Ke[Jt].maxQualityDifference)
                        } : Jt === f.default.SERVICE_DESCRIPTION_OPERATING_BANDWIDTH && (mn = {
                          mediaType: Ke[Jt].mediaType,
                          max: parseInt(Ke[Jt].max),
                          min: parseInt(Ke[Jt].min),
                          target: parseInt(Ke[Jt].target)
                        }));
                      ze.push({
                        id: Qe,
                        schemeIdUri: Et,
                        latency: Vt,
                        playbackRate: It,
                        operatingQuality: Pt,
                        operatingBandwidth: mn
                      });
                    }
                  } catch (qe) {
                    ft.e(qe);
                  } finally {
                    ft.f();
                  }
                }
                return ze;
              }
              function Qt(ye) {
                var ze = {};
                if (ye && ye.hasOwnProperty(f.default.SUPPLEMENTAL_PROPERTY)) {
                  var ft = M(ye.SupplementalProperty_asArray), Le;
                  try {
                    for (ft.s(); !(Le = ft.n()).done; ) {
                      var Ke = Le.value;
                      Ke.hasOwnProperty(h.default.SCHEME_ID_URI) && Ke.hasOwnProperty(f.default.VALUE) && (ze[Ke[h.default.SCHEME_ID_URI]] = Ke[f.default.VALUE]);
                    }
                  } catch (Qe) {
                    ft.e(Qe);
                  } finally {
                    ft.f();
                  }
                }
                return ze;
              }
              function tn(ye) {
                ye && (ye.errHandler && (ae = ye.errHandler), ye.BASE64 && (G = ye.BASE64));
              }
              return j = {
                getIsTypeOf: z,
                getIsText: he,
                getIsFragmented: oe,
                getProducerReferenceTimesForAdaptation: te,
                getLanguageForAdaptation: le,
                getViewpointForAdaptation: ne,
                getRolesForAdaptation: x,
                getAccessibilityForAdaptation: P,
                getAudioChannelConfigurationForAdaptation: B,
                getAudioChannelConfigurationForRepresentation: W,
                getAdaptationForIndex: ue,
                getIndexForAdaptation: q,
                getAdaptationForId: fe,
                getAdaptationsForType: _e,
                getRealPeriods: V,
                getRealPeriodForIndex: Q,
                getCodec: ge,
                getSelectionPriority: $e,
                getMimeType: Ce,
                getKID: Ee,
                getLabelsForAdaptation: Re,
                getContentProtectionData: Pe,
                getIsDynamic: ke,
                getId: De,
                hasProfile: Ae,
                getDuration: Ie,
                getBandwidth: Xe,
                getManifestUpdatePeriod: it,
                getPublishTime: rt,
                getRepresentationCount: Ne,
                getBitrateListForAdaptation: He,
                getRepresentationFor: ut,
                getRepresentationsForAdaptation: vt,
                getAdaptationsForPeriod: Te,
                getRegularPeriods: me,
                getMpd: Be,
                getEventsForPeriod: ot,
                getEssentialPropertiesForRepresentation: nt,
                getEventStreamForAdaptationSet: gt,
                getEventStreamForRepresentation: Mt,
                getUTCTimingSources: xt,
                getBaseURLsFromElement: be,
                getRepresentationSortFunction: X,
                getContentSteering: We,
                getLocation: et,
                getPatchLocation: _t,
                getSuggestedPresentationDelay: ht,
                getAvailabilityStartTime: St,
                getServiceDescriptions: kt,
                getSupplementalProperties: Qt,
                setConfig: tn
              }, ce(), j;
            }
            Z.__dashjs_factory_name = "DashManifestModel";
            const Y = E.default.getSingletonFactory(Z);
          }
        ),
        /***/
        "./src/dash/models/PatchManifestModel.js": (
          /*!***********************************************!*\
            !*** ./src/dash/models/PatchManifestModel.js ***!
            \***********************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => m
              /* harmony export */
            });
            var h = i(
              /*! ../constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            ), f = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), p = i(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), d = i(
              /*! ../vo/SimpleXPath */
              "./src/dash/vo/SimpleXPath.js"
            ), v = i(
              /*! ../vo/PatchOperation */
              "./src/dash/vo/PatchOperation.js"
            );
            function g() {
              var A, b, S = this.context;
              function N() {
                b = (0, p.default)(S).getInstance().getLogger(A);
              }
              function T(_) {
                return _ && _.hasOwnProperty(h.default.ORIGINAL_MPD_ID) || !1;
              }
              function R(_) {
                return _ && _.hasOwnProperty(h.default.PUBLISH_TIME) ? new Date(_[h.default.PUBLISH_TIME]) : null;
              }
              function y(_) {
                return _ && _.hasOwnProperty(h.default.ORIGINAL_PUBLISH_TIME) ? new Date(_[h.default.ORIGINAL_PUBLISH_TIME]) : null;
              }
              function E(_) {
                return _ && _[h.default.ORIGINAL_MPD_ID] || null;
              }
              function L(_) {
                return _ ? (_.__children || []).map(function(O) {
                  var D = Object.keys(O)[0];
                  if (D !== "add" && D !== "remove" && D !== "replace")
                    return b.warn("Ignoring node of invalid action: ".concat(D)), null;
                  var M = O[D], C = M.sel;
                  if (D === "add" && M.type) {
                    if (!M.type.startsWith("@"))
                      return b.warn("Ignoring add action for prefixed namespace declaration: ".concat(M.type, "=").concat(M.__text)), null;
                    C = "".concat(C, "/").concat(M.type);
                  }
                  var I = new d.default(C);
                  if (!I.isValid())
                    return b.warn("Ignoring action with invalid selector: ".concat(D, " - ").concat(C)), null;
                  var w = null;
                  I.findsAttribute() ? w = M.__text || "" : D !== "remove" && (w = M.__children.reduce(function(k, H) {
                    var Z = Object.keys(H)[0];
                    return Z !== "#text" && (k[Z] = k[Z] || [], k[Z].push(H[Z])), k;
                  }, {}));
                  var F = new v.default(D, I, w);
                  return D === "add" && (F.position = M.pos), F;
                }).filter(function(O) {
                  return !!O;
                }) : [];
              }
              return A = {
                getIsPatch: T,
                getPublishTime: R,
                getOriginalPublishTime: y,
                getMpdId: E,
                getPatchOperations: L
              }, N(), A;
            }
            g.__dashjs_factory_name = "PatchManifestModel";
            const m = f.default.getSingletonFactory(g);
          }
        ),
        /***/
        "./src/dash/parser/DashParser.js": (
          /*!***************************************!*\
            !*** ./src/dash/parser/DashParser.js ***!
            \***************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => T
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ./objectiron */
              "./src/dash/parser/objectiron.js"
            ), p = i(
              /*! ../../../externals/xml2json */
              "./externals/xml2json.js"
            ), d = i(
              /*! ./matchers/StringMatcher */
              "./src/dash/parser/matchers/StringMatcher.js"
            ), v = i(
              /*! ./matchers/DurationMatcher */
              "./src/dash/parser/matchers/DurationMatcher.js"
            ), g = i(
              /*! ./matchers/DateTimeMatcher */
              "./src/dash/parser/matchers/DateTimeMatcher.js"
            ), m = i(
              /*! ./matchers/NumericMatcher */
              "./src/dash/parser/matchers/NumericMatcher.js"
            ), A = i(
              /*! ./matchers/LangMatcher */
              "./src/dash/parser/matchers/LangMatcher.js"
            ), b = i(
              /*! ./maps/RepresentationBaseValuesMap */
              "./src/dash/parser/maps/RepresentationBaseValuesMap.js"
            ), S = i(
              /*! ./maps/SegmentValuesMap */
              "./src/dash/parser/maps/SegmentValuesMap.js"
            );
            function N(R) {
              R = R || {};
              var y = this.context, E = R.debug, L, _, O, D, M;
              function C() {
                _ = E.getLogger(L), O = [
                  new v.default(),
                  new g.default(),
                  new m.default(),
                  new A.default(),
                  new d.default()
                  // last in list to take precedence over NumericMatcher
                ], D = new p.default({
                  escapeMode: !1,
                  attributePrefix: "",
                  arrayAccessForm: "property",
                  emptyNodeForm: "object",
                  stripWhitespaces: !1,
                  enableToStringFunc: !0,
                  ignoreRoot: !1,
                  matchers: O
                }), M = (0, f.default)(y).create({
                  adaptationset: new b.default(),
                  period: new S.default()
                });
              }
              function I() {
                return O;
              }
              function w() {
                return M;
              }
              function F(k) {
                var H, Z = window.performance.now();
                if (H = D.xml_str2json(k), !H)
                  throw new Error("parsing the manifest failed");
                var Y = window.performance.now();
                H.Patch ? (H = H.Patch, H.add_asArray && H.add_asArray.forEach(function(J) {
                  return M.run(J);
                }), H.replace_asArray && H.replace_asArray.forEach(function(J) {
                  return M.run(J);
                })) : (H = H.MPD, M.run(H));
                var j = window.performance.now();
                return _.info("Parsing complete: ( xml2json: " + (Y - Z).toPrecision(3) + "ms, objectiron: " + (j - Y).toPrecision(3) + "ms, total: " + ((j - Z) / 1e3).toPrecision(3) + "s)"), H.protocol = "DASH", H;
              }
              return L = {
                parse: F,
                getMatchers: I,
                getIron: w
              }, C(), L;
            }
            N.__dashjs_factory_name = "DashParser";
            const T = h.default.getClassFactory(N);
          }
        ),
        /***/
        "./src/dash/parser/maps/CommonProperty.js": (
          /*!************************************************!*\
            !*** ./src/dash/parser/maps/CommonProperty.js ***!
            \************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            function h(g, m) {
              if (!(g instanceof m))
                throw new TypeError("Cannot call a class as a function");
            }
            function f(g, m) {
              for (var A = 0; A < m.length; A++) {
                var b = m[A];
                b.enumerable = b.enumerable || !1, b.configurable = !0, "value" in b && (b.writable = !0), Object.defineProperty(g, b.key, b);
              }
            }
            function p(g, m, A) {
              return m && f(g.prototype, m), A && f(g, A), g;
            }
            var d = /* @__PURE__ */ function() {
              function g(m) {
                h(this, g);
                var A = function(S) {
                  return S && S.length && S.charAt(0) === S.charAt(0).toUpperCase();
                };
                this._name = m, this._merge = A(m);
              }
              return p(g, [{
                key: "name",
                get: function() {
                  return this._name;
                }
              }, {
                key: "merge",
                get: function() {
                  return this._merge;
                }
              }]), g;
            }();
            const v = d;
          }
        ),
        /***/
        "./src/dash/parser/maps/MapNode.js": (
          /*!*****************************************!*\
            !*** ./src/dash/parser/maps/MapNode.js ***!
            \*****************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => g
              /* harmony export */
            });
            var h = i(
              /*! ./CommonProperty */
              "./src/dash/parser/maps/CommonProperty.js"
            );
            function f(m, A) {
              if (!(m instanceof A))
                throw new TypeError("Cannot call a class as a function");
            }
            function p(m, A) {
              for (var b = 0; b < A.length; b++) {
                var S = A[b];
                S.enumerable = S.enumerable || !1, S.configurable = !0, "value" in S && (S.writable = !0), Object.defineProperty(m, S.key, S);
              }
            }
            function d(m, A, b) {
              return A && p(m.prototype, A), b && p(m, b), m;
            }
            var v = /* @__PURE__ */ function() {
              function m(A, b, S) {
                var N = this;
                f(this, m), this._name = A || "", this._properties = [], this._children = S || [], Array.isArray(b) && b.forEach(function(T) {
                  N._properties.push(new h.default(T));
                });
              }
              return d(m, [{
                key: "name",
                get: function() {
                  return this._name;
                }
              }, {
                key: "children",
                get: function() {
                  return this._children;
                }
              }, {
                key: "properties",
                get: function() {
                  return this._properties;
                }
              }]), m;
            }();
            const g = v;
          }
        ),
        /***/
        "./src/dash/parser/maps/RepresentationBaseValuesMap.js": (
          /*!*************************************************************!*\
            !*** ./src/dash/parser/maps/RepresentationBaseValuesMap.js ***!
            \*************************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => R
              /* harmony export */
            });
            var h = i(
              /*! ./MapNode */
              "./src/dash/parser/maps/MapNode.js"
            ), f = i(
              /*! ../../constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            );
            function p(y) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? p = function(L) {
                return typeof L;
              } : p = function(L) {
                return L && typeof Symbol == "function" && L.constructor === Symbol && L !== Symbol.prototype ? "symbol" : typeof L;
              }, p(y);
            }
            function d(y, E) {
              if (!(y instanceof E))
                throw new TypeError("Cannot call a class as a function");
            }
            function v(y, E) {
              if (typeof E != "function" && E !== null)
                throw new TypeError("Super expression must either be null or a function");
              y.prototype = Object.create(E && E.prototype, { constructor: { value: y, writable: !0, configurable: !0 } }), E && g(y, E);
            }
            function g(y, E) {
              return g = Object.setPrototypeOf || function(_, O) {
                return _.__proto__ = O, _;
              }, g(y, E);
            }
            function m(y) {
              var E = S();
              return function() {
                var _ = N(y), O;
                if (E) {
                  var D = N(this).constructor;
                  O = Reflect.construct(_, arguments, D);
                } else
                  O = _.apply(this, arguments);
                return A(this, O);
              };
            }
            function A(y, E) {
              return E && (p(E) === "object" || typeof E == "function") ? E : b(y);
            }
            function b(y) {
              if (y === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return y;
            }
            function S() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return !1;
              if (typeof Proxy == "function")
                return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function N(y) {
              return N = Object.setPrototypeOf ? Object.getPrototypeOf : function(L) {
                return L.__proto__ || Object.getPrototypeOf(L);
              }, N(y);
            }
            var T = /* @__PURE__ */ function(y) {
              v(L, y);
              var E = m(L);
              function L() {
                d(this, L);
                var _ = [f.default.PROFILES, f.default.WIDTH, f.default.HEIGHT, f.default.SAR, f.default.FRAMERATE, f.default.AUDIO_SAMPLING_RATE, f.default.MIME_TYPE, f.default.SEGMENT_PROFILES, f.default.CODECS, f.default.MAXIMUM_SAP_PERIOD, f.default.START_WITH_SAP, f.default.MAX_PLAYOUT_RATE, f.default.CODING_DEPENDENCY, f.default.SCAN_TYPE, f.default.FRAME_PACKING, f.default.AUDIO_CHANNEL_CONFIGURATION, f.default.CONTENT_PROTECTION, f.default.ESSENTIAL_PROPERTY, f.default.SUPPLEMENTAL_PROPERTY, f.default.INBAND_EVENT_STREAM];
                return E.call(this, f.default.ADAPTATION_SET, _, [new h.default(f.default.REPRESENTATION, _, [new h.default(f.default.SUB_REPRESENTATION, _)])]);
              }
              return L;
            }(h.default);
            const R = T;
          }
        ),
        /***/
        "./src/dash/parser/maps/SegmentValuesMap.js": (
          /*!**************************************************!*\
            !*** ./src/dash/parser/maps/SegmentValuesMap.js ***!
            \**************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => R
              /* harmony export */
            });
            var h = i(
              /*! ./MapNode */
              "./src/dash/parser/maps/MapNode.js"
            ), f = i(
              /*! ../../constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            );
            function p(y) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? p = function(L) {
                return typeof L;
              } : p = function(L) {
                return L && typeof Symbol == "function" && L.constructor === Symbol && L !== Symbol.prototype ? "symbol" : typeof L;
              }, p(y);
            }
            function d(y, E) {
              if (!(y instanceof E))
                throw new TypeError("Cannot call a class as a function");
            }
            function v(y, E) {
              if (typeof E != "function" && E !== null)
                throw new TypeError("Super expression must either be null or a function");
              y.prototype = Object.create(E && E.prototype, { constructor: { value: y, writable: !0, configurable: !0 } }), E && g(y, E);
            }
            function g(y, E) {
              return g = Object.setPrototypeOf || function(_, O) {
                return _.__proto__ = O, _;
              }, g(y, E);
            }
            function m(y) {
              var E = S();
              return function() {
                var _ = N(y), O;
                if (E) {
                  var D = N(this).constructor;
                  O = Reflect.construct(_, arguments, D);
                } else
                  O = _.apply(this, arguments);
                return A(this, O);
              };
            }
            function A(y, E) {
              return E && (p(E) === "object" || typeof E == "function") ? E : b(y);
            }
            function b(y) {
              if (y === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return y;
            }
            function S() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return !1;
              if (typeof Proxy == "function")
                return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function N(y) {
              return N = Object.setPrototypeOf ? Object.getPrototypeOf : function(L) {
                return L.__proto__ || Object.getPrototypeOf(L);
              }, N(y);
            }
            var T = /* @__PURE__ */ function(y) {
              v(L, y);
              var E = m(L);
              function L() {
                d(this, L);
                var _ = [f.default.SEGMENT_BASE, f.default.SEGMENT_TEMPLATE, f.default.SEGMENT_LIST];
                return E.call(this, f.default.PERIOD, _, [new h.default(f.default.ADAPTATION_SET, _, [new h.default(f.default.REPRESENTATION, _)])]);
              }
              return L;
            }(h.default);
            const R = T;
          }
        ),
        /***/
        "./src/dash/parser/matchers/BaseMatcher.js": (
          /*!*************************************************!*\
            !*** ./src/dash/parser/matchers/BaseMatcher.js ***!
            \*************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            function h(g, m) {
              if (!(g instanceof m))
                throw new TypeError("Cannot call a class as a function");
            }
            function f(g, m) {
              for (var A = 0; A < m.length; A++) {
                var b = m[A];
                b.enumerable = b.enumerable || !1, b.configurable = !0, "value" in b && (b.writable = !0), Object.defineProperty(g, b.key, b);
              }
            }
            function p(g, m, A) {
              return m && f(g.prototype, m), A && f(g, A), g;
            }
            var d = /* @__PURE__ */ function() {
              function g(m, A) {
                h(this, g), this._test = m, this._converter = A;
              }
              return p(g, [{
                key: "test",
                get: function() {
                  return this._test;
                }
              }, {
                key: "converter",
                get: function() {
                  return this._converter;
                }
              }]), g;
            }();
            const v = d;
          }
        ),
        /***/
        "./src/dash/parser/matchers/DateTimeMatcher.js": (
          /*!*****************************************************!*\
            !*** ./src/dash/parser/matchers/DateTimeMatcher.js ***!
            \*****************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => L
              /* harmony export */
            });
            var h = i(
              /*! ./BaseMatcher */
              "./src/dash/parser/matchers/BaseMatcher.js"
            );
            function f(_) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? f = function(D) {
                return typeof D;
              } : f = function(D) {
                return D && typeof Symbol == "function" && D.constructor === Symbol && D !== Symbol.prototype ? "symbol" : typeof D;
              }, f(_);
            }
            function p(_, O) {
              if (!(_ instanceof O))
                throw new TypeError("Cannot call a class as a function");
            }
            function d(_, O) {
              if (typeof O != "function" && O !== null)
                throw new TypeError("Super expression must either be null or a function");
              _.prototype = Object.create(O && O.prototype, { constructor: { value: _, writable: !0, configurable: !0 } }), O && v(_, O);
            }
            function v(_, O) {
              return v = Object.setPrototypeOf || function(M, C) {
                return M.__proto__ = C, M;
              }, v(_, O);
            }
            function g(_) {
              var O = b();
              return function() {
                var M = S(_), C;
                if (O) {
                  var I = S(this).constructor;
                  C = Reflect.construct(M, arguments, I);
                } else
                  C = M.apply(this, arguments);
                return m(this, C);
              };
            }
            function m(_, O) {
              return O && (f(O) === "object" || typeof O == "function") ? O : A(_);
            }
            function A(_) {
              if (_ === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return _;
            }
            function b() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return !1;
              if (typeof Proxy == "function")
                return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function S(_) {
              return S = Object.setPrototypeOf ? Object.getPrototypeOf : function(D) {
                return D.__proto__ || Object.getPrototypeOf(D);
              }, S(_);
            }
            var N = 60, T = 60, R = 1e3, y = /^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2})(?::([0-9]*)(\.[0-9]*)?)?(?:([+-])([0-9]{2})(?::?)([0-9]{2}))?/, E = /* @__PURE__ */ function(_) {
              d(D, _);
              var O = g(D);
              function D() {
                return p(this, D), O.call(this, function(M) {
                  return y.test(M.value);
                }, function(M) {
                  var C = y.exec(M), I;
                  if (I = Date.UTC(
                    parseInt(C[1], 10),
                    parseInt(C[2], 10) - 1,
                    // months start from zero
                    parseInt(C[3], 10),
                    parseInt(C[4], 10),
                    parseInt(C[5], 10),
                    C[6] && parseInt(C[6], 10) || 0,
                    C[7] && parseFloat(C[7]) * R || 0
                  ), C[9] && C[10]) {
                    var w = parseInt(C[9], 10) * T + parseInt(C[10], 10);
                    I += (C[8] === "+" ? -1 : 1) * w * N * R;
                  }
                  return new Date(I);
                });
              }
              return D;
            }(h.default);
            const L = E;
          }
        ),
        /***/
        "./src/dash/parser/matchers/DurationMatcher.js": (
          /*!*****************************************************!*\
            !*** ./src/dash/parser/matchers/DurationMatcher.js ***!
            \*****************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => M
              /* harmony export */
            });
            var h = i(
              /*! ./BaseMatcher */
              "./src/dash/parser/matchers/BaseMatcher.js"
            ), f = i(
              /*! ../../../streaming/constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), p = i(
              /*! ../../constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            );
            function d(C) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? d = function(w) {
                return typeof w;
              } : d = function(w) {
                return w && typeof Symbol == "function" && w.constructor === Symbol && w !== Symbol.prototype ? "symbol" : typeof w;
              }, d(C);
            }
            function v(C, I) {
              if (!(C instanceof I))
                throw new TypeError("Cannot call a class as a function");
            }
            function g(C, I) {
              if (typeof I != "function" && I !== null)
                throw new TypeError("Super expression must either be null or a function");
              C.prototype = Object.create(I && I.prototype, { constructor: { value: C, writable: !0, configurable: !0 } }), I && m(C, I);
            }
            function m(C, I) {
              return m = Object.setPrototypeOf || function(F, k) {
                return F.__proto__ = k, F;
              }, m(C, I);
            }
            function A(C) {
              var I = N();
              return function() {
                var F = T(C), k;
                if (I) {
                  var H = T(this).constructor;
                  k = Reflect.construct(F, arguments, H);
                } else
                  k = F.apply(this, arguments);
                return b(this, k);
              };
            }
            function b(C, I) {
              return I && (d(I) === "object" || typeof I == "function") ? I : S(C);
            }
            function S(C) {
              if (C === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return C;
            }
            function N() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return !1;
              if (typeof Proxy == "function")
                return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function T(C) {
              return T = Object.setPrototypeOf ? Object.getPrototypeOf : function(w) {
                return w.__proto__ || Object.getPrototypeOf(w);
              }, T(C);
            }
            var R = /^([-])?P(([\d.]*)Y)?(([\d.]*)M)?(([\d.]*)D)?T?(([\d.]*)H)?(([\d.]*)M)?(([\d.]*)S)?/, y = 365 * 24 * 60 * 60, E = 30 * 24 * 60 * 60, L = 24 * 60 * 60, _ = 60 * 60, O = 60, D = /* @__PURE__ */ function(C) {
              g(w, C);
              var I = A(w);
              function w() {
                return v(this, w), I.call(this, function(F) {
                  for (var k = [p.default.MIN_BUFFER_TIME, p.default.MEDIA_PRESENTATION_DURATION, p.default.MINIMUM_UPDATE_PERIOD, p.default.TIMESHIFT_BUFFER_DEPTH, p.default.MAX_SEGMENT_DURATION, p.default.MAX_SUBSEGMENT_DURATION, p.default.SUGGESTED_PRESENTATION_DELAY, p.default.START, f.default.START_TIME, p.default.DURATION], H = k.length, Z = 0; Z < H; Z++)
                    if (F.nodeName === k[Z])
                      return R.test(F.value);
                  return !1;
                }, function(F) {
                  var k = R.exec(F), H = parseFloat(k[3] || 0) * y + parseFloat(k[5] || 0) * E + parseFloat(k[7] || 0) * L + parseFloat(k[9] || 0) * _ + parseFloat(k[11] || 0) * O + parseFloat(k[13] || 0);
                  return k[1] !== void 0 && (H = -H), H;
                });
              }
              return w;
            }(h.default);
            const M = D;
          }
        ),
        /***/
        "./src/dash/parser/matchers/LangMatcher.js": (
          /*!*************************************************!*\
            !*** ./src/dash/parser/matchers/LangMatcher.js ***!
            \*************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => L
              /* harmony export */
            });
            var h = i(
              /*! ./BaseMatcher */
              "./src/dash/parser/matchers/BaseMatcher.js"
            ), f = i(
              /*! ../../constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            ), p = i(
              /*! bcp-47-normalize */
              "./node_modules/bcp-47-normalize/index.js"
            ), d = /* @__PURE__ */ i.n(p);
            function v(_) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? v = function(D) {
                return typeof D;
              } : v = function(D) {
                return D && typeof Symbol == "function" && D.constructor === Symbol && D !== Symbol.prototype ? "symbol" : typeof D;
              }, v(_);
            }
            function g(_, O, D) {
              return O in _ ? Object.defineProperty(_, O, { value: D, enumerable: !0, configurable: !0, writable: !0 }) : _[O] = D, _;
            }
            function m(_, O) {
              if (!(_ instanceof O))
                throw new TypeError("Cannot call a class as a function");
            }
            function A(_, O) {
              if (typeof O != "function" && O !== null)
                throw new TypeError("Super expression must either be null or a function");
              _.prototype = Object.create(O && O.prototype, { constructor: { value: _, writable: !0, configurable: !0 } }), O && b(_, O);
            }
            function b(_, O) {
              return b = Object.setPrototypeOf || function(M, C) {
                return M.__proto__ = C, M;
              }, b(_, O);
            }
            function S(_) {
              var O = R();
              return function() {
                var M = y(_), C;
                if (O) {
                  var I = y(this).constructor;
                  C = Reflect.construct(M, arguments, I);
                } else
                  C = M.apply(this, arguments);
                return N(this, C);
              };
            }
            function N(_, O) {
              return O && (v(O) === "object" || typeof O == "function") ? O : T(_);
            }
            function T(_) {
              if (_ === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return _;
            }
            function R() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return !1;
              if (typeof Proxy == "function")
                return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function y(_) {
              return y = Object.setPrototypeOf ? Object.getPrototypeOf : function(D) {
                return D.__proto__ || Object.getPrototypeOf(D);
              }, y(_);
            }
            var E = /* @__PURE__ */ function(_) {
              A(D, _);
              var O = S(D);
              function D() {
                return m(this, D), O.call(this, function(M, C) {
                  var I, w = (I = {}, g(I, f.default.ADAPTATION_SET, [f.default.LANG]), g(I, f.default.REPRESENTATION, [f.default.LANG]), g(I, f.default.CONTENT_COMPONENT, [f.default.LANG]), g(I, f.default.LABEL, [f.default.LANG]), g(I, f.default.GROUP_LABEL, [f.default.LANG]), I);
                  if (w.hasOwnProperty(C)) {
                    var F = w[C];
                    return F !== void 0 ? F.indexOf(M.name) >= 0 : !1;
                  }
                  return !1;
                }, function(M) {
                  var C = d()(M);
                  return C !== void 0 ? C : String(M);
                });
              }
              return D;
            }(h.default);
            const L = E;
          }
        ),
        /***/
        "./src/dash/parser/matchers/NumericMatcher.js": (
          /*!****************************************************!*\
            !*** ./src/dash/parser/matchers/NumericMatcher.js ***!
            \****************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => R
              /* harmony export */
            });
            var h = i(
              /*! ./BaseMatcher */
              "./src/dash/parser/matchers/BaseMatcher.js"
            );
            function f(y) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? f = function(L) {
                return typeof L;
              } : f = function(L) {
                return L && typeof Symbol == "function" && L.constructor === Symbol && L !== Symbol.prototype ? "symbol" : typeof L;
              }, f(y);
            }
            function p(y, E) {
              if (!(y instanceof E))
                throw new TypeError("Cannot call a class as a function");
            }
            function d(y, E) {
              if (typeof E != "function" && E !== null)
                throw new TypeError("Super expression must either be null or a function");
              y.prototype = Object.create(E && E.prototype, { constructor: { value: y, writable: !0, configurable: !0 } }), E && v(y, E);
            }
            function v(y, E) {
              return v = Object.setPrototypeOf || function(_, O) {
                return _.__proto__ = O, _;
              }, v(y, E);
            }
            function g(y) {
              var E = b();
              return function() {
                var _ = S(y), O;
                if (E) {
                  var D = S(this).constructor;
                  O = Reflect.construct(_, arguments, D);
                } else
                  O = _.apply(this, arguments);
                return m(this, O);
              };
            }
            function m(y, E) {
              return E && (f(E) === "object" || typeof E == "function") ? E : A(y);
            }
            function A(y) {
              if (y === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return y;
            }
            function b() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return !1;
              if (typeof Proxy == "function")
                return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function S(y) {
              return S = Object.setPrototypeOf ? Object.getPrototypeOf : function(L) {
                return L.__proto__ || Object.getPrototypeOf(L);
              }, S(y);
            }
            var N = /^[-+]?[0-9]+[.]?[0-9]*([eE][-+]?[0-9]+)?$/, T = /* @__PURE__ */ function(y) {
              d(L, y);
              var E = g(L);
              function L() {
                return p(this, L), E.call(this, function(_) {
                  return N.test(_.value);
                }, function(_) {
                  return parseFloat(_);
                });
              }
              return L;
            }(h.default);
            const R = T;
          }
        ),
        /***/
        "./src/dash/parser/matchers/StringMatcher.js": (
          /*!***************************************************!*\
            !*** ./src/dash/parser/matchers/StringMatcher.js ***!
            \***************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => y
              /* harmony export */
            });
            var h = i(
              /*! ./BaseMatcher */
              "./src/dash/parser/matchers/BaseMatcher.js"
            ), f = i(
              /*! ../../constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            );
            function p(E) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? p = function(_) {
                return typeof _;
              } : p = function(_) {
                return _ && typeof Symbol == "function" && _.constructor === Symbol && _ !== Symbol.prototype ? "symbol" : typeof _;
              }, p(E);
            }
            function d(E, L, _) {
              return L in E ? Object.defineProperty(E, L, { value: _, enumerable: !0, configurable: !0, writable: !0 }) : E[L] = _, E;
            }
            function v(E, L) {
              if (!(E instanceof L))
                throw new TypeError("Cannot call a class as a function");
            }
            function g(E, L) {
              if (typeof L != "function" && L !== null)
                throw new TypeError("Super expression must either be null or a function");
              E.prototype = Object.create(L && L.prototype, { constructor: { value: E, writable: !0, configurable: !0 } }), L && m(E, L);
            }
            function m(E, L) {
              return m = Object.setPrototypeOf || function(O, D) {
                return O.__proto__ = D, O;
              }, m(E, L);
            }
            function A(E) {
              var L = N();
              return function() {
                var O = T(E), D;
                if (L) {
                  var M = T(this).constructor;
                  D = Reflect.construct(O, arguments, M);
                } else
                  D = O.apply(this, arguments);
                return b(this, D);
              };
            }
            function b(E, L) {
              return L && (p(L) === "object" || typeof L == "function") ? L : S(E);
            }
            function S(E) {
              if (E === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return E;
            }
            function N() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return !1;
              if (typeof Proxy == "function")
                return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function T(E) {
              return T = Object.setPrototypeOf ? Object.getPrototypeOf : function(_) {
                return _.__proto__ || Object.getPrototypeOf(_);
              }, T(E);
            }
            var R = /* @__PURE__ */ function(E) {
              g(_, E);
              var L = A(_);
              function _() {
                return v(this, _), L.call(this, function(O, D) {
                  var M, C = (M = {}, d(M, f.default.MPD, [f.default.ID, f.default.PROFILES]), d(M, f.default.PERIOD, [f.default.ID]), d(M, f.default.BASE_URL, [f.default.SERVICE_LOCATION, f.default.BYTE_RANGE]), d(M, f.default.SEGMENT_BASE, [f.default.INDEX_RANGE]), d(M, f.default.INITIALIZATION, [f.default.RANGE]), d(M, f.default.REPRESENTATION_INDEX, [f.default.RANGE]), d(M, f.default.SEGMENT_LIST, [f.default.INDEX_RANGE]), d(M, f.default.BITSTREAM_SWITCHING, [f.default.RANGE]), d(M, f.default.SEGMENT_URL, [f.default.MEDIA_RANGE, f.default.INDEX_RANGE]), d(M, f.default.SEGMENT_TEMPLATE, [f.default.INDEX_RANGE, f.default.MEDIA, f.default.INDEX, f.default.INITIALIZATION_MINUS, f.default.BITSTREAM_SWITCHING_MINUS]), d(M, f.default.ASSET_IDENTIFIER, [f.default.VALUE, f.default.ID]), d(M, f.default.EVENT_STREAM, [f.default.VALUE]), d(M, f.default.ADAPTATION_SET, [f.default.PROFILES, f.default.MIME_TYPE, f.default.SEGMENT_PROFILES, f.default.CODECS, f.default.CONTENT_TYPE]), d(M, f.default.FRAME_PACKING, [f.default.VALUE, f.default.ID]), d(M, f.default.AUDIO_CHANNEL_CONFIGURATION, [f.default.VALUE, f.default.ID]), d(M, f.default.CONTENT_PROTECTION, [f.default.VALUE, f.default.ID]), d(M, f.default.ESSENTIAL_PROPERTY, [f.default.VALUE, f.default.ID]), d(M, f.default.SUPPLEMENTAL_PROPERTY, [f.default.VALUE, f.default.ID]), d(M, f.default.INBAND_EVENT_STREAM, [f.default.VALUE, f.default.ID]), d(M, f.default.ACCESSIBILITY, [f.default.VALUE, f.default.ID]), d(M, f.default.ROLE, [f.default.VALUE, f.default.ID]), d(M, f.default.RATING, [f.default.VALUE, f.default.ID]), d(M, f.default.VIEWPOINT, [f.default.VALUE, f.default.ID]), d(M, f.default.CONTENT_COMPONENT, [f.default.CONTENT_TYPE]), d(M, f.default.REPRESENTATION, [f.default.ID, f.default.DEPENDENCY_ID, f.default.MEDIA_STREAM_STRUCTURE_ID]), d(M, f.default.SUBSET, [f.default.ID]), d(M, f.default.METRICS, [f.default.METRICS_MINUS]), d(M, f.default.REPORTING, [f.default.VALUE, f.default.ID]), M);
                  if (C.hasOwnProperty(D)) {
                    var I = C[D];
                    return I !== void 0 ? I.indexOf(O.name) >= 0 : !1;
                  }
                  return !1;
                }, function(O) {
                  return String(O);
                });
              }
              return _;
            }(h.default);
            const y = R;
          }
        ),
        /***/
        "./src/dash/parser/objectiron.js": (
          /*!***************************************!*\
            !*** ./src/dash/parser/objectiron.js ***!
            \***************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function f(g) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? f = function(A) {
                return typeof A;
              } : f = function(A) {
                return A && typeof Symbol == "function" && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : typeof A;
              }, f(g);
            }
            function p(g) {
              function m(N, T) {
                for (var R in N)
                  T.hasOwnProperty(R) || (T[R] = N[R]);
              }
              function A(N, T, R) {
                for (var y = 0, E = N.length; y < E; ++y) {
                  var L = N[y];
                  if (T[L.name])
                    if (R[L.name]) {
                      if (L.merge) {
                        var _ = T[L.name], O = R[L.name];
                        f(_) === "object" && f(O) === "object" ? m(_, O) : R[L.name] = _ + O;
                      }
                    } else
                      R[L.name] = T[L.name];
                }
              }
              function b(N, T) {
                for (var R = 0, y = N.children.length; R < y; ++R) {
                  var E = N.children[R], L = T[E.name + "_asArray"];
                  if (L)
                    for (var _ = 0, O = L.length; _ < O; ++_) {
                      var D = L[_];
                      A(N.properties, T, D), b(E, D);
                    }
                }
              }
              function S(N) {
                if (N === null || f(N) !== "object")
                  return N;
                if (N.Period_asArray && "period" in g)
                  for (var T = g.period, R = N.Period_asArray, y = 0, E = R.length; y < E; ++y) {
                    var L = R[y];
                    if (b(T, L), "adaptationset" in g) {
                      var _ = L.AdaptationSet_asArray;
                      if (_)
                        for (var O = g.adaptationset, D = 0, M = _.length; D < M; ++D)
                          b(O, _[D]);
                    }
                  }
                return N;
              }
              return {
                run: S
              };
            }
            p.__dashjs_factory_name = "ObjectIron";
            var d = h.default.getClassFactory(p);
            const v = d;
          }
        ),
        /***/
        "./src/dash/utils/ListSegmentsGetter.js": (
          /*!**********************************************!*\
            !*** ./src/dash/utils/ListSegmentsGetter.js ***!
            \**********************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => g
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ../../streaming/constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), p = i(
              /*! ./SegmentsUtils */
              "./src/dash/utils/SegmentsUtils.js"
            );
            function d(m, A) {
              m = m || {};
              var b = m.timelineConverter, S;
              function N() {
                if (!b || !b.hasOwnProperty("calcPeriodRelativeTimeFromMpdRelativeTime"))
                  throw new Error(f.default.MISSING_CONFIG_ERROR);
              }
              function T(E) {
                var L = {
                  numberOfSegments: 0,
                  mediaTimeOfLastSignaledSegment: NaN
                };
                if (!E)
                  return L;
                var _ = E.adaptation.period.mpd.manifest.Period_asArray[E.adaptation.period.index].AdaptationSet_asArray[E.adaptation.index].Representation_asArray[E.index].SegmentList, O = E && !isNaN(E.startNumber) ? E.startNumber : 1, D = Math.max(O - 1, 0);
                return L.numberOfSegments = D + _.SegmentURL_asArray.length, L;
              }
              function R(E, L) {
                if (N(), !E)
                  return null;
                var _ = E.adaptation.period.mpd.manifest.Period_asArray[E.adaptation.period.index].AdaptationSet_asArray[E.adaptation.index].Representation_asArray[E.index].SegmentList, O = _.SegmentURL_asArray.length, D = E && !isNaN(E.startNumber) ? E.startNumber : 1, M = Math.max(D - 1, 0), C = Math.max(L - M, 0), I = null;
                if (C < O) {
                  var w = _.SegmentURL_asArray[C];
                  I = (0, p.getIndexBasedSegment)(b, A, E, L), I && (I.replacementTime = (D + L - 1) * E.segmentDuration, I.media = w.media ? w.media : "", I.mediaRange = w.mediaRange, I.indexRange = w.indexRange);
                }
                return I;
              }
              function y(E, L) {
                if (N(), !E)
                  return null;
                var _ = E.segmentDuration;
                if (isNaN(_))
                  return null;
                var O = b.calcPeriodRelativeTimeFromMpdRelativeTime(E, L), D = Math.floor(O / _);
                return R(E, D);
              }
              return S = {
                getSegmentByIndex: R,
                getSegmentByTime: y,
                getMediaFinishedInformation: T
              }, S;
            }
            d.__dashjs_factory_name = "ListSegmentsGetter";
            var v = h.default.getClassFactory(d);
            const g = v;
          }
        ),
        /***/
        "./src/dash/utils/Round10.js": (
          /*!***********************************!*\
            !*** ./src/dash/utils/Round10.js ***!
            \***********************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => (
                /* binding */
                d
              )
              /* harmony export */
            });
            function h(g, m) {
              if (!(g instanceof m))
                throw new TypeError("Cannot call a class as a function");
            }
            function f(g, m) {
              for (var A = 0; A < m.length; A++) {
                var b = m[A];
                b.enumerable = b.enumerable || !1, b.configurable = !0, "value" in b && (b.writable = !0), Object.defineProperty(g, b.key, b);
              }
            }
            function p(g, m, A) {
              return m && f(g.prototype, m), A && f(g, A), g;
            }
            var d = /* @__PURE__ */ function() {
              function g() {
                h(this, g);
              }
              return p(g, null, [{
                key: "round10",
                value: (
                  /**
                  * Decimal round.
                  *
                  * @param {Number}  value The number.
                  * @param {Integer} exp   The exponent (the 10 logarithm of the adjustment base).
                  * @returns {Number} The adjusted value.
                  * @ignore
                  */
                  function(A, b) {
                    return v("round", A, b);
                  }
                )
              }]), g;
            }();
            function v(g, m, A) {
              return typeof A > "u" || +A == 0 ? Math[g](m) : (m = +m, A = +A, m === null || isNaN(m) || !(typeof A == "number" && A % 1 === 0) ? NaN : (m = m.toString().split("e"), m = Math[g](+(m[0] + "e" + (m[1] ? +m[1] - A : -A))), m = m.toString().split("e"), +(m[0] + "e" + (m[1] ? +m[1] + A : A))));
            }
          }
        ),
        /***/
        "./src/dash/utils/SegmentBaseGetter.js": (
          /*!*********************************************!*\
            !*** ./src/dash/utils/SegmentBaseGetter.js ***!
            \*********************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ../../streaming/constants/Constants */
              "./src/streaming/constants/Constants.js"
            );
            function p(g) {
              g = g || {};
              var m = g.timelineConverter, A;
              function b() {
                if (!m || !m.hasOwnProperty("calcPeriodRelativeTimeFromMpdRelativeTime"))
                  throw new Error(f.default.MISSING_CONFIG_ERROR);
              }
              function S(y) {
                var E = {
                  numberOfSegments: 0,
                  mediaTimeOfLastSignaledSegment: NaN
                };
                return !y || !y.segments || (E.numberOfSegments = y.segments.length), E;
              }
              function N(y, E) {
                if (b(), !y)
                  return null;
                var L = y.segments ? y.segments.length : -1, _;
                if (E < L && (_ = y.segments[E], _ && _.index === E))
                  return _;
                for (var O = 0; O < L; O++)
                  if (_ = y.segments[O], _ && _.index === E)
                    return _;
                return null;
              }
              function T(y, E) {
                b();
                var L = R(y, E);
                return N(y, L);
              }
              function R(y, E) {
                if (!y)
                  return -1;
                var L = y.segments, _ = L ? L.length : null, O = -1, D, M, C, I, w;
                if (L && _ > 0) {
                  for (w = 0; w < _; w++)
                    if (M = L[w], C = M.presentationStartTime, I = M.duration, D = I / 2, E + D >= C && E - D < C + I) {
                      O = M.index;
                      break;
                    }
                }
                return O;
              }
              return A = {
                getSegmentByIndex: N,
                getSegmentByTime: T,
                getMediaFinishedInformation: S
              }, A;
            }
            p.__dashjs_factory_name = "SegmentBaseGetter";
            var d = h.default.getClassFactory(p);
            const v = d;
          }
        ),
        /***/
        "./src/dash/utils/SegmentsUtils.js": (
          /*!*****************************************!*\
            !*** ./src/dash/utils/SegmentsUtils.js ***!
            \*****************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              getIndexBasedSegment: () => (
                /* binding */
                b
              ),
              /* harmony export */
              getTimeBasedSegment: () => (
                /* binding */
                S
              ),
              /* harmony export */
              replaceIDForTemplate: () => (
                /* binding */
                v
              ),
              /* harmony export */
              replaceTokenForTemplate: () => (
                /* binding */
                g
              ),
              /* harmony export */
              unescapeDollarsInTemplate: () => (
                /* binding */
                d
              )
              /* harmony export */
            });
            var h = i(
              /*! ./../vo/Segment */
              "./src/dash/vo/Segment.js"
            );
            function f(N, T) {
              for (; N.length < T; )
                N = "0" + N;
              return N;
            }
            function p(N, T) {
              return N.representation.startNumber + T;
            }
            function d(N) {
              return N && N.split("$$").join("$");
            }
            function v(N, T) {
              if (!T || !N || N.indexOf("$RepresentationID$") === -1)
                return N;
              var R = T.toString();
              return N.split("$RepresentationID$").join(R);
            }
            function g(N, T, R) {
              var y = "%0", E, L, _, O, D, M, C = T.length, I = y.length;
              if (!N)
                return N;
              for (; ; ) {
                if (E = N.indexOf("$" + T), E < 0 || (L = N.indexOf("$", E + C), L < 0))
                  return N;
                if (_ = N.indexOf(y, E + C), _ > E && _ < L)
                  switch (O = N.charAt(L - 1), D = parseInt(N.substring(_ + I, L - 1), 10), O) {
                    case "d":
                    case "i":
                    case "u":
                      M = f(R.toString(), D);
                      break;
                    case "x":
                      M = f(R.toString(16), D);
                      break;
                    case "X":
                      M = f(R.toString(16), D).toUpperCase();
                      break;
                    case "o":
                      M = f(R.toString(8), D);
                      break;
                    default:
                      return N;
                  }
                else
                  M = R;
                N = N.substring(0, E) + M + N.substring(L + 1);
              }
            }
            function m(N, T, R, y, E, L, _, O) {
              var D = new h.default();
              return D.representation = N, D.duration = T, D.presentationStartTime = R, D.mediaStartTime = y, D.availabilityStartTime = E.calcAvailabilityStartTimeFromPresentationTime(L, N, _), D.availabilityEndTime = E.calcAvailabilityEndTimeFromPresentationTime(L + T, N, _), D.wallStartTime = E.calcWallTimeForSegment(D, _), D.replacementNumber = p(D, O), D.index = O, D;
            }
            function A(N, T, R, y) {
              var E = T.adaptation.period;
              if (isFinite(E.duration) && E.start + E.duration <= R.presentationStartTime)
                return !1;
              if (y) {
                if (T.availabilityTimeOffset === "INF")
                  return !0;
                var L = N.getClientReferenceTime();
                return R.availabilityStartTime.getTime() <= L && (!isFinite(R.availabilityEndTime) || R.availabilityEndTime.getTime() >= L);
              }
              return !0;
            }
            function b(N, T, R, y) {
              var E, L, _;
              E = R.segmentDuration, isNaN(E) && (E = R.adaptation.period.duration), L = parseFloat((R.adaptation.period.start + y * E).toFixed(5)), _ = parseFloat((L + E).toFixed(5));
              var O = N.calcMediaTimeFromPresentationTime(L, R), D = m(R, E, L, O, N, _, T, y);
              return A(N, R, D, T) ? D : null;
            }
            function S(N, T, R, y, E, L, _, O, D, M) {
              var C = y / L, I = E / L, w, F, k;
              return w = N.calcPresentationTimeFromMediaTime(C, R), F = w + I, k = m(R, I, w, C, N, F, T, D), A(N, R, k, T) ? (k.replacementTime = M || y, _ = g(_, "Number", k.replacementNumber), _ = g(_, "Time", k.replacementTime), k.media = _, k.mediaRange = O, k) : null;
            }
          }
        ),
        /***/
        "./src/dash/utils/TemplateSegmentsGetter.js": (
          /*!**************************************************!*\
            !*** ./src/dash/utils/TemplateSegmentsGetter.js ***!
            \**************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => g
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ../../streaming/constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), p = i(
              /*! ./SegmentsUtils */
              "./src/dash/utils/SegmentsUtils.js"
            );
            function d(m, A) {
              m = m || {};
              var b = m.timelineConverter, S;
              function N() {
                if (!b || !b.hasOwnProperty("calcPeriodRelativeTimeFromMpdRelativeTime"))
                  throw new Error(f.default.MISSING_CONFIG_ERROR);
              }
              function T(E) {
                var L = {
                  numberOfSegments: 0,
                  mediaTimeOfLastSignaledSegment: NaN
                };
                if (!E)
                  return L;
                var _ = E.segmentDuration;
                return isNaN(_) ? L.numberOfSegments = 1 : L.numberOfSegments = Math.ceil(E.adaptation.period.duration / _), L;
              }
              function R(E, L) {
                if (N(), !E)
                  return null;
                var _ = E.adaptation.period.mpd.manifest.Period_asArray[E.adaptation.period.index].AdaptationSet_asArray[E.adaptation.index].Representation_asArray[E.index].SegmentTemplate;
                L = Math.max(L, 0);
                var O = (0, p.getIndexBasedSegment)(b, A, E, L);
                if (O) {
                  O.replacementTime = Math.round((L - 1) * E.segmentDuration * E.timescale, 10);
                  var D = _.media;
                  D = (0, p.replaceTokenForTemplate)(D, "Number", O.replacementNumber), D = (0, p.replaceTokenForTemplate)(D, "Time", O.replacementTime), O.media = D;
                }
                return O;
              }
              function y(E, L) {
                if (N(), !E)
                  return null;
                var _ = E.segmentDuration;
                if (isNaN(_))
                  return null;
                var O = b.calcPeriodRelativeTimeFromMpdRelativeTime(E, L), D = Math.floor(O / _);
                return R(E, D);
              }
              return S = {
                getSegmentByIndex: R,
                getSegmentByTime: y,
                getMediaFinishedInformation: T
              }, S;
            }
            d.__dashjs_factory_name = "TemplateSegmentsGetter";
            var v = h.default.getClassFactory(d);
            const g = v;
          }
        ),
        /***/
        "./src/dash/utils/TimelineConverter.js": (
          /*!*********************************************!*\
            !*** ./src/dash/utils/TimelineConverter.js ***!
            \*********************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => N
              /* harmony export */
            });
            var h = i(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), f = i(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), p = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), d = i(
              /*! ../constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            ), v = i(
              /*! ../models/DashManifestModel */
              "./src/dash/models/DashManifestModel.js"
            ), g = i(
              /*! ../../core/Settings */
              "./src/core/Settings.js"
            ), m = i(
              /*! ../../streaming/constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), A = i(
              /*! ../../streaming/MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), b = i(
              /*! ../../streaming/constants/ConformanceViolationConstants */
              "./src/streaming/constants/ConformanceViolationConstants.js"
            );
            function S() {
              var T = this.context, R = (0, h.default)(T).getInstance(), y = (0, g.default)(T).getInstance(), E, L, _, O;
              function D() {
                L = (0, v.default)(T).getInstance(), he();
              }
              function M() {
                pe(), R.on(f.default.UPDATE_TIME_SYNC_OFFSET, de, this);
              }
              function C() {
                return O;
              }
              function I(se) {
                O = se;
              }
              function w() {
                return Date.now() - _ * 1e3 + O * 1e3;
              }
              function F(se, ee, te, le) {
                var ne, x = ee.adaptation.period.mpd, P = x.availabilityStartTime;
                if (le)
                  te && x.timeShiftBufferDepth !== Number.POSITIVE_INFINITY ? ne = new Date(P.getTime() + (se + x.timeShiftBufferDepth) * 1e3) : ne = x.availabilityEndTime;
                else if (te) {
                  var B = ee.availabilityTimeOffset;
                  ne = new Date(P.getTime() + (se - B) * 1e3);
                } else
                  ne = P;
                return ne;
              }
              function k(se, ee, te) {
                return F(se, ee, te);
              }
              function H(se, ee, te) {
                return F(se, ee, te, !0);
              }
              function Z(se, ee) {
                return (se.getTime() - ee.mpd.availabilityStartTime.getTime() + O * 1e3) / 1e3;
              }
              function Y(se, ee) {
                var te = ee.adaptation.period.start, le = ee.presentationTimeOffset;
                return se + (te - le);
              }
              function j(se, ee) {
                var te = ee.adaptation.period.start, le = ee.presentationTimeOffset;
                return se - te + le;
              }
              function J(se, ee) {
                var te, le, ne;
                return ee && (te = se.representation.adaptation.period.mpd.suggestedPresentationDelay, le = se.presentationStartTime + te, ne = new Date(se.availabilityStartTime.getTime() + le * 1e3)), ne;
              }
              function ae(se, ee) {
                if (!ee)
                  return G(se);
                if (y.get().streaming.timeShiftBuffer.calcFromSegmentTimeline) {
                  var te = ie(se);
                  return re(te.now, te.range), te.range;
                }
                return $(se);
              }
              function G(se) {
                var ee = {
                  start: NaN,
                  end: NaN
                }, te = 0, le = NaN;
                return se.forEach(function(ne) {
                  var x = ne.getStreamInfo();
                  te += x.duration, (isNaN(le) || x.start < le) && (le = x.start);
                }), ee.start = le, ee.end = le + te, ee;
              }
              function $(se) {
                var ee = {
                  start: NaN,
                  end: NaN
                };
                if (!se || se.length === 0)
                  return ee;
                var te = se[0].getAdapter().getRegularPeriods()[0], le = Z(/* @__PURE__ */ new Date(), te), ne = te.mpd.timeShiftBufferDepth, x = isNaN(ne) ? 0 : le - ne;
                if (ee.start = ce(se, x), ee.end = !isNaN(ee.start) && le < ee.start ? le : ce(se, le, !0), !isNaN(ne) && ee.end < le - ne && (ee.end = NaN), y.get().streaming.timeShiftBuffer.fallbackToSegmentTimeline) {
                  var P = ie(se);
                  if (P.range.end < ee.start)
                    return R.trigger(A.default.CONFORMANCE_VIOLATION, {
                      level: b.default.LEVELS.WARNING,
                      event: b.default.EVENTS.INVALID_DVR_WINDOW
                    }), re(P.now, P.range), P.range;
                }
                return ee;
              }
              function ie(se) {
                var ee = {
                  start: NaN,
                  end: NaN
                }, te = se[0].getAdapter().getRegularPeriods()[0], le = Z(/* @__PURE__ */ new Date(), te);
                if (!se || se.length === 0)
                  return {
                    range: ee,
                    now: le
                  };
                se.forEach(function(x) {
                  var P = x.getAdapter(), B = P.getMediaInfoForType(x.getStreamInfo(), m.default.VIDEO) || P.getMediaInfoForType(x.getStreamInfo(), m.default.AUDIO), W = P.getVoRepresentations(B), X = W[0], K = {
                    start: NaN,
                    end: NaN
                  };
                  if (X)
                    if (X.segmentInfoType === d.default.SEGMENT_TIMELINE)
                      K = z(X);
                    else {
                      var U = X.adaptation.period;
                      K.start = U.start, K.end = Math.max(le, U.start + U.duration);
                    }
                  !isNaN(K.start) && (isNaN(ee.start) || ee.start > K.start) && (ee.start = K.start), !isNaN(K.end) && (isNaN(ee.end) || ee.end < K.end) && (ee.end = K.end);
                }), ee.end = Math.min(le, ee.end);
                var ne = ce(se, ee.end, !0);
                return ee.end = isNaN(ne) ? ee.end : ne, ee.start = te && te.mpd && te.mpd.timeShiftBufferDepth && !isNaN(te.mpd.timeShiftBufferDepth) && !isNaN(ee.end) ? Math.max(ee.end - te.mpd.timeShiftBufferDepth, ee.start) : ee.start, ee.start = ce(se, ee.start), {
                  range: ee,
                  now: le
                };
              }
              function re(se, ee) {
                _ = se - ee.end;
              }
              function ce(se, ee) {
                var te = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
                try {
                  for (var le = 0, ne = !1, x = NaN; !ne && le < se.length; ) {
                    var P = se[le].getStreamInfo();
                    P.start <= ee && (!isFinite(P.duration) || P.start + P.duration >= ee) ? (x = ee, ne = !0) : !te && P.start > ee && (isNaN(x) || P.start < x) ? x = P.start : te && P.start + P.duration < ee && (isNaN(x) || P.start + P.duration > x) && (x = P.start + P.duration), le += 1;
                  }
                  return x;
                } catch {
                  return ee;
                }
              }
              function z(se) {
                var ee = se.adaptation.period.mpd.manifest.Period_asArray[se.adaptation.period.index].AdaptationSet_asArray[se.adaptation.index], te = L.getRepresentationFor(se.index, ee), le = te.SegmentTemplate.SegmentTimeline, ne = te.SegmentTemplate.timescale, x = le.S_asArray, P = {
                  start: 0,
                  end: 0
                }, B = 0, W, X, K, U;
                for (P.start = Y(x[0].t / ne, se), K = 0, U = x.length; K < U; K++)
                  W = x[K], X = 0, W.hasOwnProperty("r") && (X = W.r), B += W.d * (1 + X);
                return P.end = Y((x[0].t + B) / ne, se), P;
              }
              function oe(se, ee) {
                var te = se.adaptation.period.start;
                return ee - te;
              }
              function de(se) {
                se.offset !== void 0 && !isNaN(se.offset) && I(se.offset / 1e3);
              }
              function pe() {
                O = 0, _ = 0;
              }
              function he() {
                R.off(f.default.UPDATE_TIME_SYNC_OFFSET, de, this), pe();
              }
              return E = {
                initialize: M,
                getClientTimeOffset: C,
                setClientTimeOffset: I,
                getClientReferenceTime: w,
                calcAvailabilityStartTimeFromPresentationTime: k,
                calcAvailabilityEndTimeFromPresentationTime: H,
                calcPresentationTimeFromWallTime: Z,
                calcPresentationTimeFromMediaTime: Y,
                calcPeriodRelativeTimeFromMpdRelativeTime: oe,
                calcMediaTimeFromPresentationTime: j,
                calcWallTimeForSegment: J,
                calcTimeShiftBufferWindow: ae,
                reset: he
              }, D(), E;
            }
            S.__dashjs_factory_name = "TimelineConverter";
            const N = p.default.getSingletonFactory(S);
          }
        ),
        /***/
        "./src/dash/utils/TimelineSegmentsGetter.js": (
          /*!**************************************************!*\
            !*** ./src/dash/utils/TimelineSegmentsGetter.js ***!
            \**************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => g
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ../../streaming/constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), p = i(
              /*! ./SegmentsUtils */
              "./src/dash/utils/SegmentsUtils.js"
            );
            function d(m, A) {
              m = m || {};
              var b = m.timelineConverter, S = m.dashMetrics, N;
              function T() {
                if (!b)
                  throw new Error(f.default.MISSING_CONFIG_ERROR);
              }
              function R(D) {
                if (!D)
                  return 0;
                var M = D.adaptation.period.mpd.manifest.Period_asArray[D.adaptation.period.index].AdaptationSet_asArray[D.adaptation.index].Representation_asArray[D.index].SegmentTemplate || D.adaptation.period.mpd.manifest.Period_asArray[D.adaptation.period.index].AdaptationSet_asArray[D.adaptation.index].Representation_asArray[D.index].SegmentList, C = M.SegmentTimeline, I = 0, w = 0, F = 0, k, H, Z, Y, j, J, ae;
                for (ae = D.timescale, k = C.S_asArray, Y = k.length, Z = 0; Z < Y; Z++) {
                  if (H = k[Z], J = 0, H.hasOwnProperty("r") && (J = H.r), H.hasOwnProperty("t") && (I = H.t, w = I / ae), J < 0) {
                    var G = k[Z + 1];
                    J = E(D, G, H, ae, w);
                  }
                  for (j = 0; j <= J; j++)
                    F++, I += H.d, w = I / ae;
                }
                return {
                  numberOfSegments: F,
                  mediaTimeOfLastSignaledSegment: w
                };
              }
              function y(D, M) {
                var C = D.adaptation.period.mpd.manifest.Period_asArray[D.adaptation.period.index].AdaptationSet_asArray[D.adaptation.index].Representation_asArray[D.index].SegmentTemplate || D.adaptation.period.mpd.manifest.Period_asArray[D.adaptation.period.index].AdaptationSet_asArray[D.adaptation.index].Representation_asArray[D.index].SegmentList, I = C.SegmentTimeline, w = C.SegmentURL_asArray, F = 0, k = -1, H, Z, Y, j, J, ae, G;
                G = D.timescale, H = I.S_asArray;
                var $ = !1;
                for (Y = 0, j = H.length; Y < j && !$; Y++) {
                  if (Z = H[Y], ae = 0, Z.hasOwnProperty("r") && (ae = Z.r), Z.hasOwnProperty("t") && (F = Z.t), ae < 0) {
                    var ie = H[Y + 1];
                    ae = E(D, ie, Z, G, F / G);
                  }
                  for (J = 0; J <= ae && !$; J++)
                    k++, $ = M(F, C, w, Z, G, k, Y), $ && (D.segmentDuration = Z.d / G), F += Z.d;
                }
              }
              function E(D, M, C, I, w) {
                var F;
                if (M && M.hasOwnProperty("t"))
                  F = M.t / I;
                else
                  try {
                    var k = 0;
                    if (!isNaN(D.adaptation.period.start) && !isNaN(D.adaptation.period.duration) && isFinite(D.adaptation.period.duration))
                      k = D.adaptation.period.start + D.adaptation.period.duration;
                    else {
                      var H = S.getCurrentDVRInfo();
                      k = isNaN(H.end) ? 0 : H.end;
                    }
                    F = b.calcMediaTimeFromPresentationTime(k, D), D.segmentDuration = C.d / I;
                  } catch {
                    F = 0;
                  }
                return Math.max(Math.ceil((F - w) / (C.d / I)) - 1, 0);
              }
              function L(D, M, C) {
                if (T(), !D)
                  return null;
                var I = null, w = !1;
                return y(D, function(F, k, H, Z, Y, j, J) {
                  if (w || C < 0) {
                    var ae = k.media, G = Z.mediaRange;
                    return H && (ae = H[J].media || "", G = H[J].mediaRange), I = (0, p.getTimeBasedSegment)(b, A, D, F, Z.d, Y, ae, G, j, Z.tManifest), !0;
                  } else
                    F >= C * Y - Z.d * 0.5 && (w = !0);
                  return !1;
                }), I;
              }
              function _(D, M) {
                if (T(), !D)
                  return null;
                M === void 0 && (M = null);
                var C = null, I = b.calcMediaTimeFromPresentationTime(M, D);
                return y(D, function(w, F, k, H, Z, Y, j) {
                  var J = O(I * Z);
                  if (J < w + H.d && J >= w) {
                    var ae = F.media, G = H.mediaRange;
                    return k && (ae = k[j].media || "", G = k[j].mediaRange), C = (0, p.getTimeBasedSegment)(b, A, D, w, H.d, Z, ae, G, Y, H.tManifest), !0;
                  }
                  return !1;
                }), C;
              }
              function O(D) {
                return parseFloat(D.toPrecision(15));
              }
              return N = {
                getSegmentByIndex: L,
                getSegmentByTime: _,
                getMediaFinishedInformation: R
              }, N;
            }
            d.__dashjs_factory_name = "TimelineSegmentsGetter";
            var v = h.default.getClassFactory(d);
            const g = v;
          }
        ),
        /***/
        "./src/dash/vo/AdaptationSet.js": (
          /*!**************************************!*\
            !*** ./src/dash/vo/AdaptationSet.js ***!
            \**************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = function d() {
              h(this, d), this.period = null, this.index = -1, this.type = null;
            };
            const p = f;
          }
        ),
        /***/
        "./src/dash/vo/BaseURL.js": (
          /*!********************************!*\
            !*** ./src/dash/vo/BaseURL.js ***!
            \********************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            function h(g, m) {
              if (!(g instanceof m))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = 1, p = 1, d = function g(m, A, b, S) {
              h(this, g), this.url = m || "", this.serviceLocation = A || m || "", this.dvb_priority = b || f, this.dvb_weight = S || p, this.availabilityTimeOffset = 0, this.availabilityTimeComplete = !0;
            };
            d.DEFAULT_DVB_PRIORITY = f, d.DEFAULT_DVB_WEIGHT = p;
            const v = d;
          }
        ),
        /***/
        "./src/dash/vo/ContentSteering.js": (
          /*!****************************************!*\
            !*** ./src/dash/vo/ContentSteering.js ***!
            \****************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = function d() {
              h(this, d), this.defaultServiceLocation = null, this.queryBeforeStart = !1, this.proxyServerUrl = null, this.serverUrl = null;
            };
            const p = f;
          }
        ),
        /***/
        "./src/dash/vo/ContentSteeringRequest.js": (
          /*!***********************************************!*\
            !*** ./src/dash/vo/ContentSteeringRequest.js ***!
            \***********************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => d
              /* harmony export */
            });
            var h = i(
              /*! ../../streaming/vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            );
            function f(v, g) {
              if (!(v instanceof g))
                throw new TypeError("Cannot call a class as a function");
            }
            var p = function v(g) {
              f(this, v), this.url = g || null, this.type = h.HTTPRequest.CONTENT_STEERING_TYPE, this.responseType = "json";
            };
            const d = p;
          }
        ),
        /***/
        "./src/dash/vo/ContentSteeringResponse.js": (
          /*!************************************************!*\
            !*** ./src/dash/vo/ContentSteeringResponse.js ***!
            \************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = function d() {
              h(this, d), this.version = null, this.ttl = 300, this.reloadUri = null, this.serviceLocationPriority = [];
            };
            const p = f;
          }
        ),
        /***/
        "./src/dash/vo/Event.js": (
          /*!******************************!*\
            !*** ./src/dash/vo/Event.js ***!
            \******************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = function d() {
              h(this, d), this.duration = NaN, this.presentationTime = NaN, this.id = NaN, this.messageData = "", this.eventStream = null, this.presentationTimeDelta = NaN;
            };
            const p = f;
          }
        ),
        /***/
        "./src/dash/vo/EventStream.js": (
          /*!************************************!*\
            !*** ./src/dash/vo/EventStream.js ***!
            \************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = function d() {
              h(this, d), this.adaptionSet = null, this.representation = null, this.period = null, this.timescale = 1, this.value = "", this.schemeIdUri = "", this.presentationTimeOffset = 0;
            };
            const p = f;
          }
        ),
        /***/
        "./src/dash/vo/ManifestInfo.js": (
          /*!*************************************!*\
            !*** ./src/dash/vo/ManifestInfo.js ***!
            \*************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = function d() {
              h(this, d), this.dvrWindowSize = NaN, this.loadedTime = null, this.availableFrom = null, this.minBufferTime = NaN, this.duration = NaN, this.isDynamic = !1, this.maxFragmentDuration = null;
            };
            const p = f;
          }
        ),
        /***/
        "./src/dash/vo/MediaInfo.js": (
          /*!**********************************!*\
            !*** ./src/dash/vo/MediaInfo.js ***!
            \**********************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = function d() {
              h(this, d), this.id = null, this.index = null, this.type = null, this.streamInfo = null, this.representationCount = 0, this.labels = null, this.lang = null, this.viewpoint = null, this.accessibility = null, this.audioChannelConfiguration = null, this.roles = null, this.codec = null, this.mimeType = null, this.contentProtection = null, this.KID = null, this.bitrateList = null, this.isFragmented = null, this.isEmbedded = null, this.selectionPriority = 1, this.supplementalProperties = {};
            };
            const p = f;
          }
        ),
        /***/
        "./src/dash/vo/Mpd.js": (
          /*!****************************!*\
            !*** ./src/dash/vo/Mpd.js ***!
            \****************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = function d() {
              h(this, d), this.manifest = null, this.suggestedPresentationDelay = 0, this.availabilityStartTime = null, this.availabilityEndTime = Number.POSITIVE_INFINITY, this.timeShiftBufferDepth = Number.POSITIVE_INFINITY, this.maxSegmentDuration = Number.POSITIVE_INFINITY, this.publishTime = null, this.minimumUpdatePeriod = NaN, this.mediaPresentationDuration = NaN;
            };
            const p = f;
          }
        ),
        /***/
        "./src/dash/vo/PatchOperation.js": (
          /*!***************************************!*\
            !*** ./src/dash/vo/PatchOperation.js ***!
            \***************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            function h(g, m) {
              if (!(g instanceof m))
                throw new TypeError("Cannot call a class as a function");
            }
            function f(g, m) {
              for (var A = 0; A < m.length; A++) {
                var b = m[A];
                b.enumerable = b.enumerable || !1, b.configurable = !0, "value" in b && (b.writable = !0), Object.defineProperty(g, b.key, b);
              }
            }
            function p(g, m, A) {
              return m && f(g.prototype, m), A && f(g, A), g;
            }
            var d = /* @__PURE__ */ function() {
              function g(m, A, b) {
                h(this, g), this.action = m, this.xpath = A, this.value = b, this.position = null;
              }
              return p(g, [{
                key: "getMpdTarget",
                value: function(A) {
                  var b = this.action === "remove" || this.action === "replace" || this.position === "before" || this.position === "after";
                  return this.xpath.getMpdTarget(A, b);
                }
              }]), g;
            }();
            const v = d;
          }
        ),
        /***/
        "./src/dash/vo/Period.js": (
          /*!*******************************!*\
            !*** ./src/dash/vo/Period.js ***!
            \*******************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = function d() {
              h(this, d), this.id = null, this.index = -1, this.duration = NaN, this.start = NaN, this.mpd = null, this.nextPeriodId = null;
            };
            f.DEFAULT_ID = "defaultId";
            const p = f;
          }
        ),
        /***/
        "./src/dash/vo/ProducerReferenceTime.js": (
          /*!**********************************************!*\
            !*** ./src/dash/vo/ProducerReferenceTime.js ***!
            \**********************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = function d() {
              h(this, d), this.id = null, this.inband = !1, this.type = "encoder", this.applicationScheme = null, this.wallClockTime = null, this.presentationTime = NaN, this.UTCTiming = null;
            };
            const p = f;
          }
        ),
        /***/
        "./src/dash/vo/Representation.js": (
          /*!***************************************!*\
            !*** ./src/dash/vo/Representation.js ***!
            \***************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => g
              /* harmony export */
            });
            var h = i(
              /*! ../constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            );
            function f(m, A) {
              if (!(m instanceof A))
                throw new TypeError("Cannot call a class as a function");
            }
            function p(m, A) {
              for (var b = 0; b < A.length; b++) {
                var S = A[b];
                S.enumerable = S.enumerable || !1, S.configurable = !0, "value" in S && (S.writable = !0), Object.defineProperty(m, S.key, S);
              }
            }
            function d(m, A, b) {
              return A && p(m.prototype, A), b && p(m, b), m;
            }
            var v = /* @__PURE__ */ function() {
              function m() {
                f(this, m), this.id = null, this.index = -1, this.adaptation = null, this.segmentInfoType = null, this.initialization = null, this.codecs = null, this.mimeType = null, this.codecPrivateData = null, this.segmentDuration = NaN, this.timescale = 1, this.startNumber = 1, this.indexRange = null, this.range = null, this.presentationTimeOffset = 0, this.MSETimeOffset = NaN, this.mediaFinishedInformation = {
                  numberOfSegments: 0,
                  mediaTimeOfLastSignaledSegment: NaN
                }, this.bandwidth = NaN, this.width = NaN, this.height = NaN, this.scanType = null, this.maxPlayoutRate = NaN, this.availabilityTimeOffset = 0, this.availabilityTimeComplete = !0;
              }
              return d(m, [{
                key: "hasInitialization",
                value: function() {
                  return this.initialization !== null || this.range !== null;
                }
              }, {
                key: "hasSegments",
                value: function() {
                  return this.segmentInfoType !== h.default.BASE_URL && this.segmentInfoType !== h.default.SEGMENT_BASE && !this.indexRange;
                }
              }]), m;
            }();
            const g = v;
          }
        ),
        /***/
        "./src/dash/vo/RepresentationInfo.js": (
          /*!*******************************************!*\
            !*** ./src/dash/vo/RepresentationInfo.js ***!
            \*******************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = function d() {
              h(this, d), this.id = null, this.quality = null, this.fragmentDuration = null, this.mediaInfo = null, this.MSETimeOffset = null;
            };
            const p = f;
          }
        ),
        /***/
        "./src/dash/vo/Segment.js": (
          /*!********************************!*\
            !*** ./src/dash/vo/Segment.js ***!
            \********************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = function d() {
              h(this, d), this.indexRange = null, this.index = null, this.mediaRange = null, this.media = null, this.duration = NaN, this.replacementTime = null, this.replacementNumber = NaN, this.mediaStartTime = NaN, this.presentationStartTime = NaN, this.availabilityStartTime = NaN, this.availabilityEndTime = NaN, this.wallStartTime = NaN, this.representation = null;
            };
            const p = f;
          }
        ),
        /***/
        "./src/dash/vo/SimpleXPath.js": (
          /*!************************************!*\
            !*** ./src/dash/vo/SimpleXPath.js ***!
            \************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            function h(g, m) {
              if (!(g instanceof m))
                throw new TypeError("Cannot call a class as a function");
            }
            function f(g, m) {
              for (var A = 0; A < m.length; A++) {
                var b = m[A];
                b.enumerable = b.enumerable || !1, b.configurable = !0, "value" in b && (b.writable = !0), Object.defineProperty(g, b.key, b);
              }
            }
            function p(g, m, A) {
              return m && f(g.prototype, m), A && f(g, A), g;
            }
            var d = /* @__PURE__ */ function() {
              function g(m) {
                var A = this;
                h(this, g), this.valid = m[0] == "/", this.path = m.split("/").filter(function(b) {
                  return b.length !== 0;
                }).map(function(b) {
                  var S = {
                    name: b
                  }, N = b.indexOf("[");
                  if (N != -1) {
                    S.name = b.substring(0, N);
                    var T = b.substring(N + 1, b.length - 1);
                    A.valid = A.valid && T.indexOf("[") == -1;
                    var R = T.indexOf("=");
                    R != -1 ? (S.attribute = {
                      name: T.substring(1, R),
                      // skip the @
                      value: T.substring(R + 1)
                    }, ["'", '"'].indexOf(S.attribute.value[0]) != -1 && (S.attribute.value = S.attribute.value.substring(1, S.attribute.value.length - 1))) : S.position = parseInt(T, 10) - 1;
                  }
                  return S;
                });
              }
              return p(g, [{
                key: "isValid",
                value: function() {
                  return this.valid;
                }
              }, {
                key: "findsElement",
                value: function() {
                  return !this.findsAttribute();
                }
              }, {
                key: "findsAttribute",
                value: function() {
                  return this.path[this.path.length - 1].name.startsWith("@");
                }
              }, {
                key: "getMpdTarget",
                value: function(A, b) {
                  for (var S = null, N = A, T = 1, R = "MPD"; T < this.path.length && N !== null; ) {
                    S = N;
                    var y = this.path[T];
                    if (R = y.name, T !== this.path.length - 1 || !R.startsWith("@")) {
                      var E = S[R + "_asArray"] || [];
                      E.length === 0 && S[R] && E.push(S[R]), y.position ? N = E[y.position] || null : y.attribute ? function() {
                        var L = y.attribute;
                        N = E.filter(function(_) {
                          return _[L.name] == L.value;
                        })[0] || null;
                      }() : N = E[0] || null;
                    }
                    T++;
                  }
                  return N === null ? null : R.startsWith("@") ? {
                    name: R.substring(1),
                    leaf: N,
                    target: N
                  } : {
                    name: R,
                    leaf: N,
                    target: b ? S : N
                  };
                }
              }]), g;
            }();
            const v = d;
          }
        ),
        /***/
        "./src/dash/vo/StreamInfo.js": (
          /*!***********************************!*\
            !*** ./src/dash/vo/StreamInfo.js ***!
            \***********************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = function d() {
              h(this, d), this.id = null, this.index = null, this.start = NaN, this.duration = NaN, this.manifestInfo = null, this.isLast = !0;
            };
            const p = f;
          }
        ),
        /***/
        "./src/dash/vo/UTCTiming.js": (
          /*!**********************************!*\
            !*** ./src/dash/vo/UTCTiming.js ***!
            \**********************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = function d() {
              h(this, d), this.schemeIdUri = "", this.value = "";
            };
            const p = f;
          }
        ),
        /***/
        "./src/streaming/FragmentLoader.js": (
          /*!*****************************************!*\
            !*** ./src/streaming/FragmentLoader.js ***!
            \*****************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => m
              /* harmony export */
            });
            var h = i(
              /*! ./constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), f = i(
              /*! ./net/URLLoader */
              "./src/streaming/net/URLLoader.js"
            ), p = i(
              /*! ./vo/HeadRequest */
              "./src/streaming/vo/HeadRequest.js"
            ), d = i(
              /*! ./vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), v = i(
              /*! ../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function g(A) {
              A = A || {};
              var b = this.context, S = A.eventBus, N = A.events, T = A.urlUtils, R = A.errors, y = A.streamId, E, L;
              function _() {
                L = (0, f.default)(b).create({
                  errHandler: A.errHandler,
                  errors: R,
                  dashMetrics: A.dashMetrics,
                  mediaPlayerModel: A.mediaPlayerModel,
                  requestModifier: A.requestModifier,
                  urlUtils: T,
                  constants: h.default,
                  boxParser: A.boxParser,
                  dashConstants: A.dashConstants,
                  requestTimeout: A.settings.get().streaming.fragmentRequestTimeout
                });
              }
              function O(I) {
                var w = function(H) {
                  S.trigger(N.CHECK_FOR_EXISTENCE_COMPLETED, {
                    request: I,
                    exists: H
                  });
                };
                if (I) {
                  var F = new p.default(I.url);
                  L.load({
                    request: F,
                    success: function() {
                      w(!0);
                    },
                    error: function() {
                      w(!1);
                    }
                  });
                } else
                  w(!1);
              }
              function D(I) {
                var w = function(k, H) {
                  S.trigger(N.LOADING_COMPLETED, {
                    request: I,
                    response: k || null,
                    error: H || null,
                    sender: E
                  });
                };
                I ? L.load({
                  request: I,
                  progress: function(k) {
                    S.trigger(N.LOADING_PROGRESS, {
                      request: I,
                      stream: k.stream,
                      streamId: y
                    }), k.data && S.trigger(N.LOADING_DATA_PROGRESS, {
                      request: I,
                      response: k.data || null,
                      error: null,
                      sender: E
                    });
                  },
                  success: function(k) {
                    w(k);
                  },
                  error: function(k, H, Z) {
                    w(void 0, new d.default(R.FRAGMENT_LOADER_LOADING_FAILURE_ERROR_CODE, Z, H));
                  },
                  abort: function(k) {
                    k && S.trigger(N.LOADING_ABANDONED, {
                      mediaType: k.mediaType,
                      request: k,
                      sender: E
                    });
                  }
                }) : w(void 0, new d.default(R.FRAGMENT_LOADER_NULL_REQUEST_ERROR_CODE, R.FRAGMENT_LOADER_NULL_REQUEST_ERROR_MESSAGE));
              }
              function M() {
                L && L.abort();
              }
              function C() {
                L && (L.abort(), L = null);
              }
              return E = {
                checkForExistence: O,
                load: D,
                abort: M,
                reset: C
              }, _(), E;
            }
            g.__dashjs_factory_name = "FragmentLoader";
            const m = v.default.getClassFactory(g);
          }
        ),
        /***/
        "./src/streaming/ManifestLoader.js": (
          /*!*****************************************!*\
            !*** ./src/streaming/ManifestLoader.js ***!
            \*****************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => L
              /* harmony export */
            });
            var h = i(
              /*! ./constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), f = i(
              /*! ../dash/constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            ), p = i(
              /*! ./controllers/XlinkController */
              "./src/streaming/controllers/XlinkController.js"
            ), d = i(
              /*! ./net/URLLoader */
              "./src/streaming/net/URLLoader.js"
            ), v = i(
              /*! ./utils/URLUtils */
              "./src/streaming/utils/URLUtils.js"
            ), g = i(
              /*! ./vo/TextRequest */
              "./src/streaming/vo/TextRequest.js"
            ), m = i(
              /*! ./vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), A = i(
              /*! ./vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            ), b = i(
              /*! ../core/EventBus */
              "./src/core/EventBus.js"
            ), S = i(
              /*! ../core/events/Events */
              "./src/core/events/Events.js"
            ), N = i(
              /*! ../core/errors/Errors */
              "./src/core/errors/Errors.js"
            ), T = i(
              /*! ../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), R = i(
              /*! ../dash/parser/DashParser */
              "./src/dash/parser/DashParser.js"
            );
            function y(_) {
              _ = _ || {};
              var O = this.context, D = _.debug, M = _.settings, C = (0, b.default)(O).getInstance(), I = (0, v.default)(O).getInstance(), w, F, k, H, Z, Y = _.mssHandler, j = _.errHandler;
              function J() {
                F = D.getLogger(w), C.on(S.default.XLINK_READY, ae, w), k = (0, d.default)(O).create({
                  errHandler: _.errHandler,
                  dashMetrics: _.dashMetrics,
                  mediaPlayerModel: _.mediaPlayerModel,
                  requestModifier: _.requestModifier,
                  urlUtils: I,
                  constants: h.default,
                  dashConstants: f.default,
                  errors: N.default,
                  requestTimeout: _.settings.get().streaming.manifestRequestTimeout
                }), H = (0, p.default)(O).create({
                  errHandler: j,
                  dashMetrics: _.dashMetrics,
                  mediaPlayerModel: _.mediaPlayerModel,
                  requestModifier: _.requestModifier,
                  settings: _.settings
                }), Z = null;
              }
              function ae(re) {
                C.trigger(S.default.INTERNAL_MANIFEST_LOADED, {
                  manifest: re.manifest
                });
              }
              function G(re) {
                var ce = null;
                return re.indexOf("SmoothStreamingMedia") > -1 ? (Y && (ce = Y.createMssParser(), Y.registerEvents()), ce) : re.indexOf("MPD") > -1 || re.indexOf("Patch") > -1 ? (0, R.default)(O).create({
                  debug: D
                }) : ce;
              }
              function $(re) {
                var ce = new g.default(re, A.HTTPRequest.MPD_TYPE);
                k.load({
                  request: ce,
                  success: function(oe, de, pe) {
                    if (H) {
                      var he, se, ee;
                      if (pe && pe !== re ? (se = I.parseBaseUrl(pe), he = pe) : (I.isRelative(re) && (re = I.resolve(re, window.location.href)), se = I.parseBaseUrl(re)), de == "No Content") {
                        C.trigger(S.default.INTERNAL_MANIFEST_LOADED, {
                          manifest: null
                        });
                        return;
                      }
                      if (Z === null && (Z = G(oe)), Z === null) {
                        C.trigger(S.default.INTERNAL_MANIFEST_LOADED, {
                          manifest: null,
                          error: new m.default(N.default.MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE, N.default.MANIFEST_LOADER_PARSING_FAILURE_ERROR_MESSAGE + "".concat(re))
                        });
                        return;
                      }
                      H.setMatchers(Z.getMatchers()), H.setIron(Z.getIron());
                      try {
                        ee = Z.parse(oe);
                      } catch {
                        C.trigger(S.default.INTERNAL_MANIFEST_LOADED, {
                          manifest: null,
                          error: new m.default(N.default.MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE, N.default.MANIFEST_LOADER_PARSING_FAILURE_ERROR_MESSAGE + "".concat(re))
                        });
                        return;
                      }
                      if (ee) {
                        if (ee.url = he || re, ee.originalUrl || (ee.originalUrl = ee.url), ee.hasOwnProperty(h.default.LOCATION) && (se = I.parseBaseUrl(ee.Location_asArray[0]), F.debug("BaseURI set by Location to: " + se)), M && M.get().streaming.enableManifestDurationMismatchFix && ee.mediaPresentationDuration && ee.Period_asArray.length > 1) {
                          var te = ee.Period_asArray.reduce(function(le, ne) {
                            return le + ne.duration;
                          }, 0);
                          !isNaN(te) && ee.mediaPresentationDuration > te && (F.warn("Media presentation duration greater than duration of all periods. Setting duration to total period duration"), ee.mediaPresentationDuration = te);
                        }
                        ee.baseUri = se, ee.loadedTime = /* @__PURE__ */ new Date(), H.resolveManifestOnLoad(ee), C.trigger(S.default.ORIGINAL_MANIFEST_LOADED, {
                          originalManifest: oe
                        });
                      } else
                        C.trigger(S.default.INTERNAL_MANIFEST_LOADED, {
                          manifest: null,
                          error: new m.default(N.default.MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE, N.default.MANIFEST_LOADER_PARSING_FAILURE_ERROR_MESSAGE + "".concat(re))
                        });
                    }
                  },
                  error: function(oe, de, pe) {
                    C.trigger(S.default.INTERNAL_MANIFEST_LOADED, {
                      manifest: null,
                      error: new m.default(N.default.MANIFEST_LOADER_LOADING_FAILURE_ERROR_CODE, N.default.MANIFEST_LOADER_LOADING_FAILURE_ERROR_MESSAGE + "".concat(re, ", ").concat(pe))
                    });
                  }
                });
              }
              function ie() {
                C.off(S.default.XLINK_READY, ae, w), Y && Y.reset(), H && (H.reset(), H = null), k && (k.abort(), k = null);
              }
              return w = {
                load: $,
                reset: ie
              }, J(), w;
            }
            y.__dashjs_factory_name = "ManifestLoader";
            var E = T.default.getClassFactory(y);
            const L = E;
          }
        ),
        /***/
        "./src/streaming/ManifestUpdater.js": (
          /*!******************************************!*\
            !*** ./src/streaming/ManifestUpdater.js ***!
            \******************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => S
              /* harmony export */
            });
            var h = i(
              /*! ../core/EventBus */
              "./src/core/EventBus.js"
            ), f = i(
              /*! ../core/events/Events */
              "./src/core/events/Events.js"
            ), p = i(
              /*! ../streaming/MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), d = i(
              /*! ../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), v = i(
              /*! ../core/Debug */
              "./src/core/Debug.js"
            ), g = i(
              /*! ../core/errors/Errors */
              "./src/core/errors/Errors.js"
            ), m = i(
              /*! ../dash/constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            ), A = i(
              /*! ./utils/URLUtils */
              "./src/streaming/utils/URLUtils.js"
            );
            function b() {
              var N = this.context, T = (0, h.default)(N).getInstance(), R = (0, A.default)(N).getInstance(), y, E, L, _, O, D, M, C, I, w, F, k;
              function H() {
                E = (0, v.default)(N).getInstance().getLogger(y);
              }
              function Z(se) {
                se && (se.manifestModel && (I = se.manifestModel), se.adapter && (w = se.adapter), se.manifestLoader && (C = se.manifestLoader), se.errHandler && (F = se.errHandler), se.settings && (k = se.settings));
              }
              function Y() {
                J(), T.on(f.default.STREAMS_COMPOSED, pe, this), T.on(p.default.PLAYBACK_STARTED, oe, this), T.on(p.default.PLAYBACK_PAUSED, de, this), T.on(f.default.INTERNAL_MANIFEST_LOADED, z, this);
              }
              function j(se) {
                re(se);
              }
              function J() {
                L = NaN, M = !1, O = !0, D = !1, G();
              }
              function ae() {
                T.off(p.default.PLAYBACK_STARTED, oe, this), T.off(p.default.PLAYBACK_PAUSED, de, this), T.off(f.default.STREAMS_COMPOSED, pe, this), T.off(f.default.INTERNAL_MANIFEST_LOADED, z, this), J();
              }
              function G() {
                _ !== null && (clearTimeout(_), _ = null);
              }
              function $(se) {
                G(), !D && (isNaN(se) && !isNaN(L) && (se = L * 1e3), isNaN(se) || (E.debug("Refresh manifest in " + se + " milliseconds."), _ = setTimeout(ce, se)));
              }
              function ie() {
                var se = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
                M = !0;
                var ee = I.getValue(), te = ee.url, le = w.getPatchLocation(ee), ne = w.getLocation(ee);
                le && !se ? te = le : ne && (te = ne), R.isRelative(te) && (te = R.resolve(te, ee.url)), C.load(te);
              }
              function re(se) {
                if (!se)
                  se = I.getValue(), se.loadedTime = /* @__PURE__ */ new Date();
                else if (w.getIsPatch(se)) {
                  var ee = se;
                  se = I.getValue();
                  var te = w.isPatchValid(se, ee), le = te;
                  if (te) {
                    var ne = w.getPublishTime(se);
                    le = w.applyPatchToManifest(se, ee);
                    var x = w.getPublishTime(se);
                    le = ne.getTime() != x.getTime();
                  }
                  if (!le) {
                    E.debug("Patch provided is invalid, performing full manifest refresh"), ie(!0);
                    return;
                  }
                  se.loadedTime = /* @__PURE__ */ new Date();
                }
                if (I.getValue() && I.getValue().type === m.default.DYNAMIC && se.type === m.default.STATIC) {
                  T.trigger(f.default.DYNAMIC_TO_STATIC), M = !1, D = !0;
                  return;
                }
                I.setValue(se);
                var P = /* @__PURE__ */ new Date(), B = (P.getTime() - se.loadedTime.getTime()) / 1e3;
                L = w.getManifestUpdatePeriod(se, B), L * 1e3 > 2147483647 && (L = 2147483647e-3), T.trigger(f.default.MANIFEST_UPDATED, {
                  manifest: se
                }), E.info("Manifest has been refreshed at " + P + "[" + P.getTime() / 1e3 + "] "), O || $();
              }
              function ce() {
                if (!O) {
                  if (M) {
                    $(k.get().streaming.manifestUpdateRetryInterval);
                    return;
                  }
                  ie();
                }
              }
              function z(se) {
                se.error ? se.error.code === g.default.MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE && F.error(se.error) : re(se.manifest);
              }
              function oe() {
                O = !1, $();
              }
              function de() {
                O = !k.get().streaming.scheduling.scheduleWhilePaused, O && G();
              }
              function pe() {
                M = !1;
              }
              function he() {
                return M;
              }
              return y = {
                initialize: Y,
                setManifest: j,
                refreshManifest: ie,
                getIsUpdating: he,
                setConfig: Z,
                reset: ae
              }, H(), y;
            }
            b.__dashjs_factory_name = "ManifestUpdater";
            const S = d.default.getClassFactory(b);
          }
        ),
        /***/
        "./src/streaming/MediaPlayer.js": (
          /*!**************************************!*\
            !*** ./src/streaming/MediaPlayer.js ***!
            \**************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => K
              /* harmony export */
            });
            var h = i(
              /*! ../../externals/cea608-parser */
              "./externals/cea608-parser.js"
            ), f = /* @__PURE__ */ i.n(h), p = i(
              /*! ./constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), d = i(
              /*! ../dash/constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            ), v = i(
              /*! ./constants/MetricsConstants */
              "./src/streaming/constants/MetricsConstants.js"
            ), g = i(
              /*! ./controllers/PlaybackController */
              "./src/streaming/controllers/PlaybackController.js"
            ), m = i(
              /*! ./controllers/StreamController */
              "./src/streaming/controllers/StreamController.js"
            ), A = i(
              /*! ./controllers/GapController */
              "./src/streaming/controllers/GapController.js"
            ), b = i(
              /*! ./controllers/CatchupController */
              "./src/streaming/controllers/CatchupController.js"
            ), S = i(
              /*! ../dash/controllers/ServiceDescriptionController */
              "./src/dash/controllers/ServiceDescriptionController.js"
            ), N = i(
              /*! ../dash/controllers/ContentSteeringController */
              "./src/dash/controllers/ContentSteeringController.js"
            ), T = i(
              /*! ./controllers/MediaController */
              "./src/streaming/controllers/MediaController.js"
            ), R = i(
              /*! ./controllers/BaseURLController */
              "./src/streaming/controllers/BaseURLController.js"
            ), y = i(
              /*! ./ManifestLoader */
              "./src/streaming/ManifestLoader.js"
            ), E = i(
              /*! ./utils/ErrorHandler */
              "./src/streaming/utils/ErrorHandler.js"
            ), L = i(
              /*! ./utils/Capabilities */
              "./src/streaming/utils/Capabilities.js"
            ), _ = i(
              /*! ./utils/CapabilitiesFilter */
              "./src/streaming/utils/CapabilitiesFilter.js"
            ), O = i(
              /*! ./utils/RequestModifier */
              "./src/streaming/utils/RequestModifier.js"
            ), D = i(
              /*! ./models/URIFragmentModel */
              "./src/streaming/models/URIFragmentModel.js"
            ), M = i(
              /*! ./models/ManifestModel */
              "./src/streaming/models/ManifestModel.js"
            ), C = i(
              /*! ./models/MediaPlayerModel */
              "./src/streaming/models/MediaPlayerModel.js"
            ), I = i(
              /*! ./controllers/AbrController */
              "./src/streaming/controllers/AbrController.js"
            ), w = i(
              /*! ./net/SchemeLoaderFactory */
              "./src/streaming/net/SchemeLoaderFactory.js"
            ), F = i(
              /*! ./models/VideoModel */
              "./src/streaming/models/VideoModel.js"
            ), k = i(
              /*! ./models/CmcdModel */
              "./src/streaming/models/CmcdModel.js"
            ), H = i(
              /*! ./models/CmsdModel */
              "./src/streaming/models/CmsdModel.js"
            ), Z = i(
              /*! ./utils/DOMStorage */
              "./src/streaming/utils/DOMStorage.js"
            ), Y = i(
              /*! ./../core/Debug */
              "./src/core/Debug.js"
            ), j = i(
              /*! ./../core/errors/Errors */
              "./src/core/errors/Errors.js"
            ), J = i(
              /*! ./../core/EventBus */
              "./src/core/EventBus.js"
            ), ae = i(
              /*! ./../core/events/Events */
              "./src/core/events/Events.js"
            ), G = i(
              /*! ./MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), $ = i(
              /*! ../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), ie = i(
              /*! ../core/Settings */
              "./src/core/Settings.js"
            ), re = i(
              /*! ../core/Version */
              "./src/core/Version.js"
            ), ce = i(
              /*! ../dash/controllers/SegmentBaseController */
              "./src/dash/controllers/SegmentBaseController.js"
            ), z = i(
              /*! ../dash/DashAdapter */
              "./src/dash/DashAdapter.js"
            ), oe = i(
              /*! ../dash/DashMetrics */
              "./src/dash/DashMetrics.js"
            ), de = i(
              /*! ../dash/utils/TimelineConverter */
              "./src/dash/utils/TimelineConverter.js"
            ), pe = i(
              /*! ./vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            ), he = i(
              /*! ../../externals/base64 */
              "./externals/base64.js"
            ), se = i(
              /*! codem-isoboxer */
              "./node_modules/codem-isoboxer/dist/iso_boxer.js"
            ), ee = i(
              /*! ./vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), te = i(
              /*! ./utils/SupervisorTools */
              "./src/streaming/utils/SupervisorTools.js"
            ), le = i(
              /*! ./ManifestUpdater */
              "./src/streaming/ManifestUpdater.js"
            ), ne = i(
              /*! ../streaming/utils/URLUtils */
              "./src/streaming/utils/URLUtils.js"
            ), x = i(
              /*! ./utils/BoxParser */
              "./src/streaming/utils/BoxParser.js"
            ), P = i(
              /*! ./text/TextController */
              "./src/streaming/text/TextController.js"
            ), B = i(
              /*! ./models/CustomParametersModel */
              "./src/streaming/models/CustomParametersModel.js"
            );
            function W() {
              var U = "You must first call initialize() and set a source before calling this method", V = "You must first call initialize() and set a valid source and view before calling this method", Q = "You must first call attachView() to set the video element before calling this method", fe = "You must first call attachSource() with a valid source before calling this method", ue = "MediaPlayer not initialized!", q = this.context, _e = (0, J.default)(q).getInstance(), ge = (0, ie.default)(q).getInstance(), Ce = (0, Y.default)(q).getInstance({
                settings: ge
              }), Ee, Re, Pe, ke, De, Ae, Ie, Xe, it, rt, Ne, He, $e, nt, ut, pt, vt, Ut, Je, Te, me, Me, Be, Fe, Ze, ot, tt, gt, Mt, xt, be, We, et, _t, ht, St, kt, Qt;
              function tn() {
                Re = Ce.getLogger(Ee), De = !1, Ie = !1, Ae = !1, Xe = !0, $e = null, pt = null, ke = null, vt = null, Qt = null, ae.default.extend(G.default), Ut = (0, C.default)(q).getInstance(), Je = (0, B.default)(q).getInstance(), ht = (0, F.default)(q).getInstance(), St = (0, D.default)(q).getInstance();
              }
              function ye(Ue) {
                Ue && (Ue.capabilities && (Me = Ue.capabilities), Ue.capabilitiesFilter && (Be = Ue.capabilitiesFilter), Ue.streamController && (Fe = Ue.streamController), Ue.textController && (Ze = Ue.textController), Ue.gapController && (ot = Ue.gapController), Ue.playbackController && (tt = Ue.playbackController), Ue.serviceDescriptionController && (gt = Ue.serviceDescriptionController), Ue.contentSteeringController && (Mt = Ue.contentSteeringController), Ue.catchupController && (xt = Ue.catchupController), Ue.mediaPlayerModel && (Ut = Ue.mediaPlayerModel), Ue.customParametersModel && (Je = Ue.customParametersModel), Ue.abrController && (it = Ue.abrController), Ue.schemeLoaderFactory && (rt = Ue.schemeLoaderFactory), Ue.mediaController && (He = Ue.mediaController), Ue.settings && (ge = Ue.settings));
              }
              function ze(Ue, yt, Kt) {
                var cn = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : NaN;
                if (Me || (Me = (0, L.default)(q).getInstance(), Me.setConfig({
                  settings: ge
                })), Te || (Te = (0, E.default)(q).getInstance()), !Me.supportsMediaSource()) {
                  Te.error(new ee.default(j.default.CAPABILITY_MEDIASOURCE_ERROR_CODE, j.default.CAPABILITY_MEDIASOURCE_ERROR_MESSAGE));
                  return;
                }
                De || (De = !0, Ne = (0, de.default)(q).getInstance(), it || (it = (0, I.default)(q).getInstance(), it.setConfig({
                  settings: ge
                })), rt || (rt = (0, w.default)(q).getInstance()), tt || (tt = (0, g.default)(q).getInstance()), He || (He = (0, T.default)(q).getInstance()), Fe || (Fe = (0, m.default)(q).getInstance()), ot || (ot = (0, A.default)(q).getInstance()), xt || (xt = (0, b.default)(q).getInstance()), gt || (gt = (0, S.default)(q).getInstance()), Mt || (Mt = (0, N.default)(q).getInstance()), Be || (Be = (0, _.default)(q).getInstance()), vt = (0, z.default)(q).getInstance(), We = (0, M.default)(q).getInstance(), et = (0, k.default)(q).getInstance(), _t = (0, H.default)(q).getInstance(), be = (0, oe.default)(q).getInstance({
                  settings: ge
                }), kt = (0, Z.default)(q).getInstance({
                  settings: ge
                }), vt.setConfig({
                  constants: p.default,
                  cea608parser: f(),
                  errHandler: Te,
                  BASE64: he
                }), me || (me = (0, R.default)(q).create()), me.setConfig({
                  adapter: vt
                }), gt.setConfig({
                  adapter: vt
                }), Qt || (Qt = (0, ce.default)(q).getInstance({
                  dashMetrics: be,
                  mediaPlayerModel: Ut,
                  errHandler: Te,
                  baseURLController: me,
                  events: ae.default,
                  eventBus: _e,
                  debug: Ce,
                  boxParser: (0, x.default)(q).getInstance(),
                  requestModifier: (0, O.default)(q).getInstance(),
                  errors: j.default
                })), He.setConfig({
                  domStorage: kt,
                  settings: ge,
                  customParametersModel: Je
                }), Ut.setConfig({
                  playbackController: tt,
                  serviceDescriptionController: gt
                }), Mt.setConfig({
                  adapter: vt,
                  errHandler: Te,
                  dashMetrics: be,
                  mediaPlayerModel: Ut,
                  manifestModel: We,
                  abrController: it,
                  eventBus: _e,
                  requestModifier: (0, O.default)(q).getInstance()
                }), Vi(), Xr(Kt !== void 0 ? Kt : !0), Bd()), Ue && Hi(Ue), yt && mu(yt, cn), Re.info("[dash.js " + Vt() + "] MediaPlayer has been initialized");
              }
              function ft() {
                mu(null), Hi(null), ke = null, $e && ($e.reset(), $e = null), nt && (nt.reset(), nt = null), Je && Je.reset(), ge.reset(), pt && (pt.reset(), pt = null);
              }
              function Le() {
                ft(), $.default.deleteSingletonInstances(q);
              }
              function Ke() {
                return !!Pe && !!ht.getElement();
              }
              function Qe(Ue, yt, Kt, cn) {
                _e.on(Ue, yt, Kt, cn);
              }
              function Et(Ue, yt, Kt) {
                _e.off(Ue, yt, Kt);
              }
              function Vt() {
                return (0, re.getVersionString)();
              }
              function It() {
                return Ce;
              }
              function Pt() {
                if (ht.getElement() || Ae)
                  return !1;
                if (Pe)
                  _u();
                else
                  throw fe;
              }
              function mn() {
                if (!Ie)
                  throw V;
                (!Xe || qe() && Ie) && tt.play(!0);
              }
              function Jt() {
                if (!Ie)
                  throw V;
                tt.pause();
              }
              function qe() {
                if (!Ie)
                  throw V;
                return tt.isPaused();
              }
              function Rt(Ue) {
                if (!Ie)
                  throw V;
                if ((0, te.checkParameterType)(Ue, "number"), isNaN(Ue))
                  throw p.default.BAD_ARGUMENT_ERROR;
                Ue < 0 && (Ue = 0);
                var yt = tt.getIsDynamic() ? Or(Ue) : Ue, Kt = Qn();
                !tt.getIsDynamic() && Kt.duration && (yt = Math.min(Kt.duration, yt)), tt.seek(yt, !1, !1, !0);
              }
              function bt() {
                !Ie || !Ve() || tt.seekToOriginalLive();
              }
              function we() {
                if (!Ie)
                  throw V;
                return tt.isSeeking();
              }
              function Ve() {
                if (!Ie)
                  throw V;
                return tt.getIsDynamic();
              }
              function Se() {
                if (!Ie)
                  throw V;
                return tt.getLowLatencyModeEnabled();
              }
              function Ge(Ue) {
                Qn().playbackRate = Ue;
              }
              function ct() {
                return Qn().playbackRate;
              }
              function Ot(Ue) {
                (0, te.checkParameterType)(Ue, "boolean"), Qn().muted = Ue;
              }
              function wt() {
                return Qn().muted;
              }
              function Xt(Ue) {
                if (typeof Ue != "number" || isNaN(Ue) || Ue < 0 || Ue > 1)
                  throw p.default.BAD_ARGUMENT_ERROR;
                Qn().volume = Ue;
              }
              function nn() {
                return Qn().volume;
              }
              function Yt(Ue) {
                var yt = [p.default.VIDEO, p.default.AUDIO, p.default.TEXT];
                if (Ue)
                  if (yt.indexOf(Ue) !== -1) {
                    var cn = zt().getCurrentBufferLevel(Ue);
                    return cn || NaN;
                  } else
                    return Re.warn("getBufferLength requested for invalid type"), NaN;
                else {
                  var Kt = yt.map(function(_n) {
                    return wd(_n).length > 0 ? zt().getCurrentBufferLevel(_n) : Number.MAX_VALUE;
                  }).reduce(function(_n, bo) {
                    return Math.min(_n, bo);
                  });
                  return Kt === Number.MAX_VALUE ? NaN : Kt;
                }
              }
              function Dn() {
                var Ue = Fe && Fe.hasVideoTrack() ? p.default.VIDEO : p.default.AUDIO, yt = be.getCurrentDVRInfo(Ue);
                return yt ? yt.manifestInfo.dvrWindowSize : 0;
              }
              function Or(Ue) {
                var yt = Fe && Fe.hasVideoTrack() ? p.default.VIDEO : p.default.AUDIO, Kt = be.getCurrentDVRInfo(yt);
                if (!Kt)
                  return 0;
                var cn = tt.getOriginalLiveDelay(), _n = Kt.range.start + Ue;
                return _n > Kt.range.end - cn && (_n = Kt.range.end - cn), _n;
              }
              function Yr() {
                if (!Ie)
                  throw V;
                return tt.getOriginalLiveDelay();
              }
              function cr(Ue) {
                if (!Ie)
                  throw V;
                var yt = Qn().currentTime;
                if (Ue !== void 0)
                  yt = Fe.getTimeRelativeToStreamId(yt, Ue);
                else if (tt.getIsDynamic()) {
                  var Kt = Fe && Fe.hasVideoTrack() ? p.default.VIDEO : p.default.AUDIO, cn = be.getCurrentDVRInfo(Kt);
                  yt = cn === null || yt === 0 ? 0 : Math.max(0, yt - cn.range.start);
                }
                return yt;
              }
              function Ki() {
                if (!Ie)
                  throw V;
                var Ue = Qn().duration;
                if (tt.getIsDynamic()) {
                  var yt = Fe && Fe.hasVideoTrack() ? p.default.VIDEO : p.default.AUDIO, Kt = be.getCurrentDVRInfo(yt);
                  Ue = Kt ? Kt.range.end - Kt.range.start : 0;
                }
                return Ue;
              }
              function Aa() {
                if (!Ie)
                  throw V;
                return cr() < 0 ? NaN : Fd(cr());
              }
              function Co() {
                if (!Ie)
                  throw V;
                return Fd(Ki());
              }
              function Pr(Ue) {
                if (!Ae)
                  throw U;
                return it.getTopBitrateInfoFor(Ue);
              }
              function ji(Ue) {
                if (!Ae)
                  throw U;
                if (Ue === p.default.IMAGE) {
                  var yt = Ks();
                  if (!yt)
                    return -1;
                  var Kt = yt.getThumbnailController();
                  return Kt ? Kt.getCurrentTrackIndex() : -1;
                }
                return it.getQualityFor(Ue);
              }
              function Wi(Ue, yt) {
                var Kt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
                if (!Ae)
                  throw U;
                if (Ue === p.default.IMAGE) {
                  var cn = Ks();
                  if (!cn)
                    return;
                  var _n = cn.getThumbnailController();
                  _n && _n.setTrackByIndex(yt);
                }
                it.setPlaybackQuality(Ue, Fe.getActiveStreamInfo(), yt, {
                  forceReplace: Kt
                });
              }
              function Bs() {
                it.setElementSize(), it.setWindowResizeEventCalled(!0);
              }
              function Xr(Ue) {
                (0, te.checkParameterType)(Ue, "boolean"), Xe = Ue;
              }
              function fu() {
                return Xe;
              }
              function du() {
                if (!De)
                  throw ue;
                return Ie ? tt.getCurrentLiveLatency() : NaN;
              }
              function Mo(Ue, yt, Kt) {
                Je.addAbrCustomRule(Ue, yt, Kt);
              }
              function Fs(Ue) {
                Je.removeAbrCustomRule(Ue);
              }
              function hu() {
                Je.removeAllAbrCustomRule();
              }
              function pu() {
                return Je.getAbrCustomRules();
              }
              function Us(Ue, yt) {
                Je.addUTCTimingSource(Ue, yt);
              }
              function Sa(Ue, yt) {
                Je.removeUTCTimingSource(Ue, yt);
              }
              function ks() {
                Je.clearDefaultUTCTimingSources();
              }
              function Vi() {
                Je.restoreDefaultUTCTimingSources();
              }
              function xe(Ue) {
                var yt = it.getThroughputHistory(), Kt = tt.getIsDynamic();
                return yt ? yt.getAverageThroughput(Ue, Kt) : 0;
              }
              function at(Ue, yt) {
                Je.setXHRWithCredentialsForType(Ue, yt);
              }
              function At(Ue) {
                return Je.getXHRWithCredentialsForType(Ue);
              }
              function jt() {
                return Bd();
              }
              function zt() {
                return be;
              }
              function rn(Ue) {
                var yt = Fe.getActiveStreamInfo();
                return !yt || !Ze ? !1 : Ze.enableText(yt.id, Ue);
              }
              function on(Ue) {
                var yt = Fe.getActiveStreamInfo();
                return !yt || !Ze ? !1 : Ze.enableForcedTextStreaming(Ue);
              }
              function nr() {
                var Ue = Fe.getActiveStreamInfo();
                return !Ue || !Ze ? !1 : Ze.isTextEnabled(Ue);
              }
              function Mn(Ue) {
                if (!Ie)
                  throw V;
                var yt = Fe.getActiveStreamInfo();
                !yt || !Ze || Ze.setTextTrack(yt.id, Ue);
              }
              function Ir() {
                var Ue = NaN, yt = Fe.getActiveStreamInfo();
                if (!(!yt || !Ze))
                  return Ue = Ze.getCurrentTrackIdx(yt.id), Ue;
              }
              function Qn() {
                if (!ht.getElement())
                  throw Q;
                return ht.getElement();
              }
              function Hi(Ue) {
                if (!De)
                  throw ue;
                ht.setElement(Ue), Ue && (vu(), LE(), wE(), Fe && Fe.switchToVideoElement()), Ie && xd(), _u();
              }
              function Z_() {
                return ht ? ht.getTTMLRenderingDiv() : null;
              }
              function q_(Ue) {
                if (!ht.getElement())
                  throw Q;
                ht.setTTMLRenderingDiv(Ue);
              }
              function eE(Ue) {
                if (!ht.getElement())
                  throw Q;
                ht.setVttRenderingDiv(Ue);
              }
              function tE(Ue) {
                if (!Ae)
                  throw U;
                var yt = Ks();
                return yt ? yt.getBitrateListFor(Ue) : [];
              }
              function nE(Ue) {
                if (!Ae)
                  throw U;
                return vt.getStreamsInfo(Ue);
              }
              function wd(Ue) {
                if (!Ae)
                  throw U;
                var yt = Fe.getActiveStreamInfo();
                return yt ? He.getTracksFor(Ue, yt.id) : [];
              }
              function rE(Ue, yt, Kt) {
                if (!Ae)
                  throw U;
                return Kt = Kt || vt.getStreamsInfo(yt, 1)[0], Kt ? vt.getAllMediaInfoForType(Kt, Ue, yt) : [];
              }
              function iE(Ue) {
                if (!Ae)
                  throw U;
                var yt = Fe.getActiveStreamInfo();
                return He.getCurrentTrackFor(Ue, yt.id);
              }
              function aE(Ue, yt) {
                if (!De)
                  throw ue;
                He.setInitialSettings(Ue, yt);
              }
              function oE(Ue) {
                if (!De)
                  throw ue;
                return He.getInitialSettings(Ue);
              }
              function sE(Ue) {
                if (!Ae)
                  throw U;
                He.setTrack(Ue);
              }
              function lE(Ue) {
                Je.registerCustomCapabilitiesFilter(Ue);
              }
              function uE(Ue) {
                Je.unregisterCustomCapabilitiesFilter(Ue);
              }
              function cE(Ue) {
                Je.setCustomInitialTrackSelectionFunction(Ue);
              }
              function fE() {
                Je.resetCustomInitialTrackSelectionFunction(null);
              }
              function dE(Ue) {
                Je.registerLicenseRequestFilter(Ue);
              }
              function hE(Ue) {
                Je.registerLicenseResponseFilter(Ue);
              }
              function pE(Ue) {
                Je.unregisterLicenseRequestFilter(Ue);
              }
              function mE(Ue) {
                Je.unregisterLicenseResponseFilter(Ue);
              }
              function gE() {
                return vu();
              }
              function vE(Ue) {
                $e = Ue;
              }
              function _E(Ue) {
                ke = Ue, Fe && Fe.setProtectionData(ke);
              }
              function EE(Ue, yt) {
                if (typeof yt == "function") {
                  if (Ue < 0) {
                    yt(null);
                    return;
                  }
                  var Kt = tt.getIsDynamic() ? Or(Ue) : Ue, cn = Fe.getStreamForTime(Kt);
                  if (cn === null) {
                    yt(null);
                    return;
                  }
                  var _n = cn.getThumbnailController();
                  if (!_n) {
                    yt(null);
                    return;
                  }
                  return _n.provide(Kt, yt);
                }
              }
              function yE(Ue, yt) {
                var Kt = gu(), cn = this, _n = function bo(Ca) {
                  Ca.error ? yt(null, Ca.error) : yt(Ca.manifest), _e.off(ae.default.INTERNAL_MANIFEST_LOADED, bo, cn), Kt.reset();
                };
                _e.on(ae.default.INTERNAL_MANIFEST_LOADED, _n, cn), St.initialize(Ue), Kt.load(Ue);
              }
              function TE() {
                if (!Pe)
                  throw fe;
                return Pe;
              }
              function AE(Ue) {
                Pe = Ue, Fe.load(Pe);
              }
              function mu(Ue) {
                var yt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : NaN;
                if (!De)
                  throw ue;
                typeof Ue == "string" && St.initialize(Ue), yt == null && (yt = NaN), isNaN(yt) || (yt = Math.max(0, yt)), Pe = Ue, (Ae || Ie) && xd(), Ke() && _u(yt);
              }
              function SE() {
                return ge.get();
              }
              function CE(Ue) {
                ge.update(Ue);
              }
              function ME() {
                ge.reset();
              }
              function bE(Ue, yt, Kt) {
                var cn = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, _n = new Date(Ue * 1e3), bo = _n.toLocaleDateString(yt), Ca = _n.toLocaleTimeString(yt, {
                  hour12: Kt
                });
                return cn ? Ca + " " + bo : Ca;
              }
              function RE(Ue) {
                Ue = Math.max(Ue, 0);
                var yt = Math.floor(Ue / 3600), Kt = Math.floor(Ue % 3600 / 60), cn = Math.floor(Ue % 3600 % 60);
                return (yt === 0 ? "" : yt < 10 ? "0" + yt.toString() + ":" : yt.toString() + ":") + (Kt < 10 ? "0" + Kt.toString() : Kt.toString()) + ":" + (cn < 10 ? "0" + cn.toString() : cn.toString());
              }
              function DE(Ue, yt, Kt) {
                $.default.extend(Ue, yt, Kt, q);
              }
              function Ks() {
                if (!Ae)
                  throw U;
                var Ue = Fe.getActiveStreamInfo();
                return Ue ? Fe.getStreamById(Ue.id) : null;
              }
              function OE() {
                return vt;
              }
              function PE() {
                if (Mt)
                  return Mt.loadSteeringData();
              }
              function IE() {
                if (Mt)
                  return Mt.getCurrentSteeringResponseData();
              }
              function xd() {
                Ie = !1, Ae = !1, vt.reset(), Fe.reset(), ot.reset(), xt.reset(), tt.reset(), gt.reset(), Mt.reset(), it.reset(), He.reset(), Qt.reset(), $e && (ge.get().streaming.protection.keepProtectionMediaKeys ? $e.stop() : ($e.reset(), $e = null, vu())), Ze.reset(), et.reset(), _t.reset();
              }
              function NE() {
                var Ue = gu();
                Fe || (Fe = (0, m.default)(q).getInstance()), Ze || (Ze = (0, P.default)(q).create({
                  errHandler: Te,
                  manifestModel: We,
                  adapter: vt,
                  mediaController: He,
                  videoModel: ht,
                  settings: ge
                })), Be.setConfig({
                  capabilities: Me,
                  customParametersModel: Je,
                  adapter: vt,
                  settings: ge,
                  manifestModel: We,
                  errHandler: Te
                }), Fe.setConfig({
                  capabilities: Me,
                  capabilitiesFilter: Be,
                  manifestLoader: Ue,
                  manifestModel: We,
                  mediaPlayerModel: Ut,
                  customParametersModel: Je,
                  protectionController: $e,
                  textController: Ze,
                  adapter: vt,
                  dashMetrics: be,
                  errHandler: Te,
                  timelineConverter: Ne,
                  videoModel: ht,
                  playbackController: tt,
                  serviceDescriptionController: gt,
                  contentSteeringController: Mt,
                  abrController: it,
                  mediaController: He,
                  settings: ge,
                  baseURLController: me,
                  uriFragmentModel: St,
                  segmentBaseController: Qt
                }), ot.setConfig({
                  settings: ge,
                  playbackController: tt,
                  streamController: Fe,
                  videoModel: ht,
                  timelineConverter: Ne,
                  adapter: vt
                }), tt.setConfig({
                  streamController: Fe,
                  serviceDescriptionController: gt,
                  dashMetrics: be,
                  adapter: vt,
                  videoModel: ht,
                  timelineConverter: Ne,
                  settings: ge
                }), xt.setConfig({
                  streamController: Fe,
                  playbackController: tt,
                  mediaPlayerModel: Ut,
                  videoModel: ht,
                  settings: ge
                }), it.setConfig({
                  streamController: Fe,
                  domStorage: kt,
                  mediaPlayerModel: Ut,
                  customParametersModel: Je,
                  cmsdModel: _t,
                  dashMetrics: be,
                  adapter: vt,
                  videoModel: ht,
                  settings: ge
                }), et.setConfig({
                  abrController: it,
                  dashMetrics: be,
                  playbackController: tt
                }), _t.setConfig({}), it.initialize(), Fe.initialize(Xe, ke), Ze.initialize(), ot.initialize(), xt.initialize(), et.initialize(), _t.initialize(), Mt.initialize(), Qt.initialize();
              }
              function gu() {
                return (0, y.default)(q).create({
                  debug: Ce,
                  errHandler: Te,
                  dashMetrics: be,
                  mediaPlayerModel: Ut,
                  requestModifier: (0, O.default)(q).getInstance(),
                  mssHandler: ut,
                  settings: ge
                });
              }
              function vu() {
                if ($e)
                  return $e;
                var Ue = dashjs.Protection;
                if (typeof Ue == "function") {
                  var yt = Ue(q).create();
                  return ae.default.extend(Ue.events), G.default.extend(Ue.events, {
                    publicOnly: !0
                  }), j.default.extend(Ue.errors), Me || (Me = (0, L.default)(q).getInstance()), $e = yt.createProtectionSystem({
                    debug: Ce,
                    errHandler: Te,
                    videoModel: ht,
                    customParametersModel: Je,
                    capabilities: Me,
                    eventBus: _e,
                    events: ae.default,
                    BASE64: he,
                    constants: p.default,
                    cmcdModel: et,
                    settings: ge
                  }), $e;
                }
                return null;
              }
              function LE() {
                if (!nt) {
                  var Ue = dashjs.MetricsReporting;
                  if (typeof Ue == "function") {
                    var yt = Ue(q).create();
                    nt = yt.createMetricsReporting({
                      debug: Ce,
                      eventBus: _e,
                      mediaElement: Qn(),
                      adapter: vt,
                      dashMetrics: be,
                      mediaPlayerModel: Ut,
                      events: ae.default,
                      constants: p.default,
                      metricsConstants: v.default
                    });
                  }
                }
              }
              function wE() {
                if (!ut) {
                  var Ue = dashjs.MssHandler;
                  typeof Ue == "function" && (j.default.extend(Ue.errors), ut = Ue(q).create({
                    eventBus: _e,
                    mediaPlayerModel: Ut,
                    dashMetrics: be,
                    manifestModel: We,
                    playbackController: tt,
                    streamController: Fe,
                    protectionController: $e,
                    baseURLController: me,
                    errHandler: Te,
                    events: ae.default,
                    constants: p.default,
                    debug: Ce,
                    initSegmentType: pe.HTTPRequest.INIT_SEGMENT_TYPE,
                    BASE64: he,
                    ISOBoxer: se,
                    settings: ge
                  }));
                }
              }
              function Bd() {
                if (!De)
                  throw ue;
                if (pt)
                  return pt;
                var Ue = dashjs.OfflineController;
                if (typeof Ue == "function") {
                  ae.default.extend(Ue.events), G.default.extend(Ue.events, {
                    publicOnly: !0
                  }), j.default.extend(Ue.errors);
                  var yt = gu(), Kt = (0, le.default)(q).create();
                  return Kt.setConfig({
                    manifestModel: We,
                    adapter: vt,
                    manifestLoader: yt,
                    errHandler: Te
                  }), pt = Ue(q).create({
                    debug: Ce,
                    manifestUpdater: Kt,
                    baseURLController: me,
                    manifestLoader: yt,
                    manifestModel: We,
                    mediaPlayerModel: Ut,
                    abrController: it,
                    playbackController: tt,
                    adapter: vt,
                    errHandler: Te,
                    dashMetrics: be,
                    timelineConverter: Ne,
                    segmentBaseController: Qt,
                    schemeLoaderFactory: rt,
                    eventBus: _e,
                    events: ae.default,
                    errors: j.default,
                    constants: p.default,
                    settings: ge,
                    dashConstants: d.default,
                    urlUtils: (0, ne.default)(q).getInstance()
                  }), pt;
                }
                return null;
              }
              function Fd(Ue) {
                var yt = Fe && Fe.hasVideoTrack() ? p.default.VIDEO : p.default.AUDIO, Kt = be.getCurrentDVRInfo(yt), cn, _n;
                return Kt ? (cn = Kt.manifestInfo.availableFrom.getTime() / 1e3, _n = Ue + (cn + Kt.range.start), _n) : 0;
              }
              function _u() {
                var Ue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : NaN;
                pt && pt.resetRecords(), !Ae && Pe && (Ae = !0, Re.info("Streaming Initialized"), NE(), typeof Pe == "string" ? Fe.load(Pe, Ue) : Fe.loadWithManifest(Pe, Ue)), !Ie && Ke() && (Ie = !0, Re.info("Playback Initialized"));
              }
              return Ee = {
                initialize: ze,
                setConfig: ye,
                on: Qe,
                off: Et,
                extend: DE,
                attachView: Hi,
                attachSource: mu,
                isReady: Ke,
                preload: Pt,
                play: mn,
                isPaused: qe,
                pause: Jt,
                isSeeking: we,
                isDynamic: Ve,
                getLowLatencyModeEnabled: Se,
                seek: Rt,
                seekToOriginalLive: bt,
                setPlaybackRate: Ge,
                getPlaybackRate: ct,
                setMute: Ot,
                isMuted: wt,
                setVolume: Xt,
                getVolume: nn,
                time: cr,
                duration: Ki,
                timeAsUTC: Aa,
                durationAsUTC: Co,
                getActiveStream: Ks,
                getDVRWindowSize: Dn,
                getDVRSeekOffset: Or,
                getTargetLiveDelay: Yr,
                convertToTimeCode: RE,
                formatUTC: bE,
                getVersion: Vt,
                getDebug: It,
                getBufferLength: Yt,
                getTTMLRenderingDiv: Z_,
                getVideoElement: Qn,
                getSource: TE,
                updateSource: AE,
                getCurrentLiveLatency: du,
                getTopBitrateInfoFor: Pr,
                setAutoPlay: Xr,
                getAutoPlay: fu,
                getDashMetrics: zt,
                getQualityFor: ji,
                setQualityFor: Wi,
                updatePortalSize: Bs,
                enableText: rn,
                enableForcedTextStreaming: on,
                isTextEnabled: nr,
                setTextTrack: Mn,
                getBitrateInfoListFor: tE,
                getStreamsFromManifest: nE,
                getTracksFor: wd,
                getTracksForTypeFromManifest: rE,
                getCurrentTrackFor: iE,
                setInitialMediaSettingsFor: aE,
                getInitialMediaSettingsFor: oE,
                setCurrentTrack: sE,
                addABRCustomRule: Mo,
                removeABRCustomRule: Fs,
                removeAllABRCustomRule: hu,
                getABRCustomRules: pu,
                getAverageThroughput: xe,
                retrieveManifest: yE,
                addUTCTimingSource: Us,
                removeUTCTimingSource: Sa,
                clearDefaultUTCTimingSources: ks,
                restoreDefaultUTCTimingSources: Vi,
                setXHRWithCredentialsForType: at,
                getXHRWithCredentialsForType: At,
                getProtectionController: gE,
                attachProtectionController: vE,
                setProtectionData: _E,
                registerLicenseRequestFilter: dE,
                registerLicenseResponseFilter: hE,
                unregisterLicenseRequestFilter: pE,
                unregisterLicenseResponseFilter: mE,
                registerCustomCapabilitiesFilter: lE,
                unregisterCustomCapabilitiesFilter: uE,
                setCustomInitialTrackSelectionFunction: cE,
                resetCustomInitialTrackSelectionFunction: fE,
                attachTTMLRenderingDiv: q_,
                attachVttRenderingDiv: eE,
                getCurrentTextTrackIndex: Ir,
                provideThumbnail: EE,
                getDashAdapter: OE,
                getOfflineController: jt,
                triggerSteeringRequest: PE,
                getCurrentSteeringResponseData: IE,
                getSettings: SE,
                updateSettings: CE,
                resetSettings: ME,
                reset: ft,
                destroy: Le
              }, tn(), Ee;
            }
            W.__dashjs_factory_name = "MediaPlayer";
            var X = $.default.getClassFactory(W);
            X.events = G.default, X.errors = j.default, $.default.updateClassFactory(W.__dashjs_factory_name, X);
            const K = X;
          }
        ),
        /***/
        "./src/streaming/MediaPlayerEvents.js": (
          /*!********************************************!*\
            !*** ./src/streaming/MediaPlayerEvents.js ***!
            \********************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => R
              /* harmony export */
            });
            var h = i(
              /*! ../core/events/EventsBase */
              "./src/core/events/EventsBase.js"
            );
            function f(y) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? f = function(L) {
                return typeof L;
              } : f = function(L) {
                return L && typeof Symbol == "function" && L.constructor === Symbol && L !== Symbol.prototype ? "symbol" : typeof L;
              }, f(y);
            }
            function p(y, E) {
              if (!(y instanceof E))
                throw new TypeError("Cannot call a class as a function");
            }
            function d(y, E) {
              if (typeof E != "function" && E !== null)
                throw new TypeError("Super expression must either be null or a function");
              y.prototype = Object.create(E && E.prototype, { constructor: { value: y, writable: !0, configurable: !0 } }), E && v(y, E);
            }
            function v(y, E) {
              return v = Object.setPrototypeOf || function(_, O) {
                return _.__proto__ = O, _;
              }, v(y, E);
            }
            function g(y) {
              var E = b();
              return function() {
                var _ = S(y), O;
                if (E) {
                  var D = S(this).constructor;
                  O = Reflect.construct(_, arguments, D);
                } else
                  O = _.apply(this, arguments);
                return m(this, O);
              };
            }
            function m(y, E) {
              return E && (f(E) === "object" || typeof E == "function") ? E : A(y);
            }
            function A(y) {
              if (y === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return y;
            }
            function b() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return !1;
              if (typeof Proxy == "function")
                return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function S(y) {
              return S = Object.setPrototypeOf ? Object.getPrototypeOf : function(L) {
                return L.__proto__ || Object.getPrototypeOf(L);
              }, S(y);
            }
            var N = /* @__PURE__ */ function(y) {
              d(L, y);
              var E = g(L);
              function L() {
                var _;
                return p(this, L), _ = E.call(this), _.AST_IN_FUTURE = "astInFuture", _.BUFFER_EMPTY = "bufferStalled", _.BUFFER_LOADED = "bufferLoaded", _.BUFFER_LEVEL_STATE_CHANGED = "bufferStateChanged", _.BUFFER_LEVEL_UPDATED = "bufferLevelUpdated", _.DYNAMIC_TO_STATIC = "dynamicToStatic", _.ERROR = "error", _.FRAGMENT_LOADING_COMPLETED = "fragmentLoadingCompleted", _.FRAGMENT_LOADING_PROGRESS = "fragmentLoadingProgress", _.FRAGMENT_LOADING_STARTED = "fragmentLoadingStarted", _.FRAGMENT_LOADING_ABANDONED = "fragmentLoadingAbandoned", _.LOG = "log", _.MANIFEST_LOADED = "manifestLoaded", _.METRICS_CHANGED = "metricsChanged", _.METRIC_CHANGED = "metricChanged", _.METRIC_ADDED = "metricAdded", _.METRIC_UPDATED = "metricUpdated", _.PERIOD_SWITCH_STARTED = "periodSwitchStarted", _.PERIOD_SWITCH_COMPLETED = "periodSwitchCompleted", _.QUALITY_CHANGE_REQUESTED = "qualityChangeRequested", _.QUALITY_CHANGE_RENDERED = "qualityChangeRendered", _.TRACK_CHANGE_RENDERED = "trackChangeRendered", _.STREAM_INITIALIZING = "streamInitializing", _.STREAM_UPDATED = "streamUpdated", _.STREAM_ACTIVATED = "streamActivated", _.STREAM_DEACTIVATED = "streamDeactivated", _.STREAM_INITIALIZED = "streamInitialized", _.STREAM_TEARDOWN_COMPLETE = "streamTeardownComplete", _.TEXT_TRACKS_ADDED = "allTextTracksAdded", _.TEXT_TRACK_ADDED = "textTrackAdded", _.TTML_PARSED = "ttmlParsed", _.TTML_TO_PARSE = "ttmlToParse", _.CAPTION_RENDERED = "captionRendered", _.CAPTION_CONTAINER_RESIZE = "captionContainerResize", _.CAN_PLAY = "canPlay", _.CAN_PLAY_THROUGH = "canPlayThrough", _.PLAYBACK_ENDED = "playbackEnded", _.PLAYBACK_ERROR = "playbackError", _.PLAYBACK_NOT_ALLOWED = "playbackNotAllowed", _.PLAYBACK_METADATA_LOADED = "playbackMetaDataLoaded", _.PLAYBACK_LOADED_DATA = "playbackLoadedData", _.PLAYBACK_PAUSED = "playbackPaused", _.PLAYBACK_PLAYING = "playbackPlaying", _.PLAYBACK_PROGRESS = "playbackProgress", _.PLAYBACK_RATE_CHANGED = "playbackRateChanged", _.PLAYBACK_SEEKED = "playbackSeeked", _.PLAYBACK_SEEKING = "playbackSeeking", _.PLAYBACK_STALLED = "playbackStalled", _.PLAYBACK_STARTED = "playbackStarted", _.PLAYBACK_TIME_UPDATED = "playbackTimeUpdated", _.PLAYBACK_VOLUME_CHANGED = "playbackVolumeChanged", _.PLAYBACK_WAITING = "playbackWaiting", _.MANIFEST_VALIDITY_CHANGED = "manifestValidityChanged", _.EVENT_MODE_ON_START = "eventModeOnStart", _.EVENT_MODE_ON_RECEIVE = "eventModeOnReceive", _.CONFORMANCE_VIOLATION = "conformanceViolation", _.REPRESENTATION_SWITCH = "representationSwitch", _.ADAPTATION_SET_REMOVED_NO_CAPABILITIES = "adaptationSetRemovedNoCapabilities", _.CONTENT_STEERING_REQUEST_COMPLETED = "contentSteeringRequestCompleted", _;
              }
              return L;
            }(h.default), T = new N();
            const R = T;
          }
        ),
        /***/
        "./src/streaming/MediaPlayerFactory.js": (
          /*!*********************************************!*\
            !*** ./src/streaming/MediaPlayerFactory.js ***!
            \*********************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => A
              /* harmony export */
            });
            var h = i(
              /*! ./MediaPlayer */
              "./src/streaming/MediaPlayer.js"
            );
            function f() {
              var b = "application/dash+xml", S;
              function N(y, E, L) {
                if (!y || !/^VIDEO$/i.test(y.nodeName))
                  return null;
                if (y._dashjs_player)
                  return y._dashjs_player;
                var _, O = y.id || y.name || "video element";
                if (E = E || [].slice.call(y.querySelectorAll("source")).filter(function(D) {
                  return D.type == b;
                })[0], !E && y.src)
                  E = document.createElement("source"), E.src = y.src;
                else if (!E && !y.src)
                  return null;
                return L = L || {}, _ = (0, h.default)(L).create(), _.initialize(y, E.src, y.autoplay), S || (S = _.getDebug().getLogger()), S.debug("Converted " + O + " to dash.js player and added content: " + E.src), y._dashjs_player = _, _;
              }
              function T(y, E) {
                var L = [];
                y = y || "[data-dashjs-player]", E = E || document;
                for (var _ = E.querySelectorAll(y), O = 0; O < _.length; O++) {
                  var D = N(_[O], null);
                  L.push(D);
                }
                for (var M = E.querySelectorAll('source[type="' + b + '"]'), C = 0; C < M.length; C++) {
                  var I = R(M[C]), w = N(I, null);
                  L.push(w);
                }
                return L;
              }
              function R(y) {
                return /^VIDEO$/i.test(y.nodeName) ? y : R(y.parentNode);
              }
              return {
                create: N,
                createAll: T
              };
            }
            var p = f(), d;
            function v() {
              window.removeEventListener("load", v), p.createAll();
            }
            function g() {
              window.dashjs && (window.clearInterval(d), p.createAll());
            }
            var m = typeof window < "u" && window && window.dashjs && window.dashjs.skipAutoCreate;
            !m && typeof window < "u" && window && window.addEventListener && (window.document.readyState === "complete" ? window.dashjs ? p.createAll() : d = window.setInterval(g, 500) : window.addEventListener("load", v));
            const A = p;
          }
        ),
        /***/
        "./src/streaming/PreBufferSink.js": (
          /*!****************************************!*\
            !*** ./src/streaming/PreBufferSink.js ***!
            \****************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var h = i(
              /*! ../core/Debug */
              "./src/core/Debug.js"
            ), f = i(
              /*! ../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function p(g) {
              var m = this.context, A, b, S, N = [], T = g;
              function R() {
                b = (0, h.default)(m).getInstance().getLogger(A);
              }
              function y() {
                N = [], S = null, T = null;
              }
              function E(F) {
                return F.segmentType !== "InitializationSegment" ? (N.push(F), N.sort(function(k, H) {
                  return k.start - H.start;
                }), S = null) : S = F, b.debug("PreBufferSink appended chunk s: " + F.start + "; e: " + F.end), T && T({
                  chunk: F
                }), Promise.resolve();
              }
              function L(F, k) {
                return N = N.filter(function(H) {
                  return !((isNaN(k) || H.start < k) && (isNaN(F) || H.end > F));
                }), Promise.resolve();
              }
              function _() {
                return Promise.resolve();
              }
              function O() {
                for (var F = [], k = 0; k < N.length; k++) {
                  var H = N[k];
                  F.length === 0 || H.start > F[F.length - 1].end ? F.push({
                    start: H.start,
                    end: H.end
                  }) : F[F.length - 1].end = H.end;
                }
                var Z = {
                  start: function(j) {
                    return F[j].start;
                  },
                  end: function(j) {
                    return F[j].end;
                  }
                };
                return Object.defineProperty(Z, "length", {
                  get: function() {
                    return F.length;
                  }
                }), Z;
              }
              function D() {
                return Promise.resolve();
              }
              function M() {
                return this;
              }
              function C(F, k) {
                var H = I(F, k);
                return S && (H.push(S), S = null), L(F, k), H;
              }
              function I(F, k) {
                return N.filter(function(H) {
                  return (isNaN(k) || H.start < k) && (isNaN(F) || H.end > F);
                });
              }
              function w(F) {
                F();
              }
              return A = {
                getAllBufferRanges: O,
                append: E,
                remove: L,
                abort: _,
                discharge: C,
                reset: y,
                updateTimestampOffset: D,
                waitForUpdateEnd: w,
                getBuffer: M
              }, R(), A;
            }
            p.__dashjs_factory_name = "PreBufferSink";
            var d = f.default.getClassFactory(p);
            const v = d;
          }
        ),
        /***/
        "./src/streaming/SourceBufferSink.js": (
          /*!*******************************************!*\
            !*** ./src/streaming/SourceBufferSink.js ***!
            \*******************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => y
              /* harmony export */
            });
            var h = i(
              /*! ../core/Debug */
              "./src/core/Debug.js"
            ), f = i(
              /*! ./vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), p = i(
              /*! ../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), d = i(
              /*! ../core/errors/Errors */
              "./src/core/errors/Errors.js"
            ), v = i(
              /*! ../core/Settings */
              "./src/core/Settings.js"
            ), g = i(
              /*! ./constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), m = i(
              /*! ./vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            ), A = i(
              /*! ../core/events/Events */
              "./src/core/events/Events.js"
            ), b = 0.1, S = 0.01, N = 50;
            function T(E) {
              var L = this.context, _ = (0, v.default)(L).getInstance(), O = E.textController, D = E.eventBus, M, C, I, w, F, k, H = [], Z = [], Y = !1, j = E.mediaSource, J = null;
              function ae() {
                I = (0, h.default)(L).getInstance().getLogger(M);
              }
              function G(Q, fe, ue) {
                F = Q, C = F.type;
                var q = F.codec;
                ie(ue), z();
                var _e = [];
                return _e.push(ne()), _e.push(pe(F.streamInfo)), _e.push($(q)), fe && fe.MSETimeOffset !== void 0 && _e.push(he(fe.MSETimeOffset)), Promise.all(_e);
              }
              function $(Q) {
                return new Promise(function(fe) {
                  V(function() {
                    w.changeType && w.changeType(Q), fe();
                  });
                });
              }
              function ie(Q) {
                w = Q.getBuffer();
              }
              function re(Q, fe, ue) {
                F = fe, C = F.type;
                var q = F.codec;
                try {
                  if (q.match(/application\/mp4;\s*codecs="(stpp|wvtt).*"/i))
                    return ce(Q);
                  w = j.addSourceBuffer(q), z();
                  var _e = [];
                  return _e.push(pe(F.streamInfo)), ue && ue.MSETimeOffset !== void 0 && _e.push(he(ue.MSETimeOffset)), Promise.all(_e);
                } catch (ge) {
                  return F.type == g.default.TEXT && !F.isFragmented || q.indexOf('codecs="stpp') !== -1 || q.indexOf('codecs="vtt') !== -1 ? ce(Q) : Promise.reject(ge);
                }
              }
              function ce(Q) {
                return w = O.getTextSourceBuffer(Q), Promise.resolve();
              }
              function z() {
                if (typeof w.addEventListener == "function")
                  try {
                    w.addEventListener("updateend", X, !1), w.addEventListener("error", K, !1), w.addEventListener("abort", K, !1);
                  } catch {
                    k = setInterval(X, N);
                  }
                else
                  k = setInterval(X, N);
              }
              function oe() {
                return C;
              }
              function de() {
                try {
                  typeof w.removeEventListener == "function" && (w.removeEventListener("updateend", X, !1), w.removeEventListener("error", K, !1), w.removeEventListener("abort", K, !1)), clearInterval(k);
                } catch (Q) {
                  I.error(Q);
                }
              }
              function pe(Q) {
                return new Promise(function(fe) {
                  if (!w || !_.get().streaming.buffer.useAppendWindow) {
                    fe();
                    return;
                  }
                  V(function() {
                    try {
                      if (!w) {
                        fe();
                        return;
                      }
                      var ue = j.duration, q = 0;
                      Q && !isNaN(Q.start) && !isNaN(Q.duration) && isFinite(Q.duration) && (ue = Q.start + Q.duration), Q && !isNaN(Q.start) && (q = Q.start), (w.appendWindowEnd !== ue || w.appendWindowStart !== q) && (w.appendWindowStart = 0, w.appendWindowEnd = ue + S, w.appendWindowStart = Math.max(q - b, 0), I.debug("Updated append window for ".concat(F.type, ". Set start to ").concat(w.appendWindowStart, " and end to ").concat(w.appendWindowEnd))), fe();
                    } catch {
                      I.warn("Failed to set append window"), fe();
                    }
                  });
                });
              }
              function he(Q) {
                return new Promise(function(fe) {
                  if (!w) {
                    fe();
                    return;
                  }
                  V(function() {
                    try {
                      w.timestampOffset !== Q && !isNaN(Q) && (w.timestampOffset = Q, I.debug("Set MSE timestamp offset to ".concat(Q))), fe();
                    } catch {
                      fe();
                    }
                  });
                });
              }
              function se() {
                if (w) {
                  try {
                    H = [], de(), Y = !1, Z = [], (!w.getClassName || w.getClassName() !== "TextSourceBuffer") && (I.debug("Removing sourcebuffer from media source"), j.removeSourceBuffer(w));
                  } catch {
                  }
                  w = null;
                }
                J = null;
              }
              function ee() {
                return w;
              }
              function te() {
                try {
                  return w.buffered;
                } catch (Q) {
                  return I.error("getAllBufferRanges exception: " + Q.message), null;
                }
              }
              function le(Q) {
                var fe = this, ue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                return new Promise(function(q, _e) {
                  if (!Q) {
                    _e({
                      chunk: Q,
                      error: new f.default(d.default.APPEND_ERROR_CODE, d.default.APPEND_ERROR_MESSAGE)
                    });
                    return;
                  }
                  Z.push({
                    data: Q,
                    promise: {
                      resolve: q,
                      reject: _e
                    },
                    request: ue
                  }), V(P.bind(fe));
                });
              }
              function ne() {
                return new Promise(function(Q) {
                  V(function() {
                    var fe = w.appendWindowStart, ue = w.appendWindowEnd;
                    w && (w.abort(), w.appendWindowStart = fe, w.appendWindowEnd = ue), Q();
                  });
                });
              }
              function x(Q) {
                return new Promise(function(fe, ue) {
                  var q = Q.start, _e = Q.end;
                  if (!(q >= 0 && _e > q)) {
                    fe();
                    return;
                  }
                  V(function() {
                    try {
                      w.remove(q, _e), V(function() {
                        fe({
                          from: q,
                          to: _e,
                          unintended: !1
                        }), Q.resolve && Q.resolve();
                      });
                    } catch (ge) {
                      ue({
                        from: q,
                        to: _e,
                        unintended: !1,
                        error: new f.default(d.default.REMOVE_ERROR_CODE, d.default.REMOVE_ERROR_MESSAGE)
                      }), Q.reject && Q.reject(ge);
                    }
                  });
                });
              }
              function P() {
                if (!Y && Z.length > 0) {
                  Y = !0;
                  var Q = Z[0];
                  Z.splice(0, 1);
                  var fe = function() {
                    Y = !1, Z.length > 0 && P.call(this), Q && Q.data && Q.data.segmentType && Q.data.segmentType !== m.HTTPRequest.INIT_SEGMENT_TYPE && delete Q.data.bytes, Q.promise.resolve({
                      chunk: Q.data
                    });
                  };
                  try {
                    J = Q.request, Q.data.bytes.byteLength === 0 ? fe.call(this) : (w.appendBuffer ? w.appendBuffer(Q.data.bytes) : w.append(Q.data.bytes, Q.data), V(fe.bind(this)));
                  } catch (ue) {
                    I.fatal('SourceBuffer append failed "' + ue + '"'), Z.length > 0 ? P() : Y = !1, delete Q.data.bytes, Q.promise.reject({
                      chunk: Q.data,
                      error: new f.default(ue.code, ue.message)
                    });
                  }
                }
              }
              function B() {
                return new Promise(function(Q) {
                  try {
                    Z = [], j.readyState === "open" ? V(function() {
                      try {
                        w && w.abort(), Q();
                      } catch {
                        Q();
                      }
                    }) : (w && w.setTextTrack && j.readyState === "ended" && w.abort(), Q());
                  } catch {
                    Q();
                  }
                });
              }
              function W() {
                if (H.length > 0 && !w.updating) {
                  var Q = H.shift();
                  Q(), W();
                }
              }
              function X() {
                w.updating || W();
              }
              function K(Q) {
                var fe = Q.target || {};
                U(A.default.SOURCE_BUFFER_ERROR, {
                  error: fe,
                  lastRequestAppended: J
                });
              }
              function U(Q, fe) {
                var ue = fe || {};
                D.trigger(Q, ue, {
                  streamId: F.streamInfo.id,
                  mediaType: C
                });
              }
              function V(Q) {
                H.push(Q), w.updating || W();
              }
              return M = {
                getType: oe,
                getAllBufferRanges: te,
                getBuffer: ee,
                append: le,
                remove: x,
                abort: B,
                reset: se,
                updateTimestampOffset: he,
                initializeForStreamSwitch: G,
                initializeForFirstUse: re,
                updateAppendWindow: pe,
                changeType: $
              }, ae(), M;
            }
            T.__dashjs_factory_name = "SourceBufferSink";
            var R = p.default.getClassFactory(T);
            const y = R;
          }
        ),
        /***/
        "./src/streaming/Stream.js": (
          /*!*********************************!*\
            !*** ./src/streaming/Stream.js ***!
            \*********************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => _
              /* harmony export */
            });
            var h = i(
              /*! ./constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), f = i(
              /*! ../dash/constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            ), p = i(
              /*! ./StreamProcessor */
              "./src/streaming/StreamProcessor.js"
            ), d = i(
              /*! ./controllers/FragmentController */
              "./src/streaming/controllers/FragmentController.js"
            ), v = i(
              /*! ./thumbnail/ThumbnailController */
              "./src/streaming/thumbnail/ThumbnailController.js"
            ), g = i(
              /*! ../core/EventBus */
              "./src/core/EventBus.js"
            ), m = i(
              /*! ../core/events/Events */
              "./src/core/events/Events.js"
            ), A = i(
              /*! ../core/Debug */
              "./src/core/Debug.js"
            ), b = i(
              /*! ../core/errors/Errors */
              "./src/core/errors/Errors.js"
            ), S = i(
              /*! ../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), N = i(
              /*! ./vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), T = i(
              /*! ./utils/BoxParser */
              "./src/streaming/utils/BoxParser.js"
            ), R = i(
              /*! ./utils/URLUtils */
              "./src/streaming/utils/URLUtils.js"
            ), y = i(
              /*! ./controllers/BlacklistController */
              "./src/streaming/controllers/BlacklistController.js"
            ), E = [h.default.VIDEO, h.default.AUDIO, h.default.TEXT, h.default.MUXED, h.default.IMAGE];
            function L(O) {
              O = O || {};
              var D = this.context, M = (0, g.default)(D).getInstance(), C = (0, R.default)(D).getInstance(), I = O.manifestModel, w = O.mediaPlayerModel, F = O.dashMetrics, k = O.manifestUpdater, H = O.adapter, Z = O.timelineConverter, Y = O.capabilities, j = O.errHandler, J = O.abrController, ae = O.playbackController, G = O.eventController, $ = O.mediaController, ie = O.protectionController, re = O.textController, ce = O.videoModel, z = O.streamInfo, oe = O.settings, de, pe, he, se, ee, te, le, ne, x, P, B, W, X, K, U, V, Q, fe;
              function ue() {
                try {
                  V = (0, A.default)(D).getInstance(), pe = V.getLogger(de), pt(), U = (0, T.default)(D).getInstance(), X = (0, y.default)(D).create({
                    updateEventName: m.default.SEGMENT_LOCATION_BLACKLIST_CHANGED,
                    addBlacklistEventName: m.default.SEGMENT_LOCATION_BLACKLIST_ADD
                  }), B = (0, d.default)(D).create({
                    streamInfo: z,
                    mediaPlayerModel: w,
                    dashMetrics: F,
                    errHandler: j,
                    settings: oe,
                    boxParser: U,
                    dashConstants: f.default,
                    urlUtils: C
                  });
                } catch (qe) {
                  throw qe;
                }
              }
              function q() {
                _e(), Ce(), re.initializeForStream(z), M.trigger(m.default.STREAM_UPDATED, {
                  streamInfo: z
                });
              }
              function _e() {
                M.on(m.default.BUFFERING_COMPLETED, ht, de), M.on(m.default.DATA_UPDATE_COMPLETED, St, de), M.on(m.default.INBAND_EVENTS, kt, de);
              }
              function ge() {
                M.off(m.default.DATA_UPDATE_COMPLETED, St, de), M.off(m.default.BUFFERING_COMPLETED, ht, de), M.off(m.default.INBAND_EVENTS, kt, de);
              }
              function Ce() {
                ie && (M.on(m.default.KEY_ERROR, Mt, de), M.on(m.default.SERVER_CERTIFICATE_UPDATED, Mt, de), M.on(m.default.LICENSE_REQUEST_COMPLETE, Mt, de), M.on(m.default.KEY_SYSTEM_SELECTED, Mt, de), M.on(m.default.KEY_SESSION_CREATED, Mt, de), M.on(m.default.KEY_STATUSES_CHANGED, Mt, de));
              }
              function Ee() {
                ie && (M.off(m.default.KEY_ERROR, Mt, de), M.off(m.default.SERVER_CERTIFICATE_UPDATED, Mt, de), M.off(m.default.LICENSE_REQUEST_COMPLETE, Mt, de), M.off(m.default.KEY_SYSTEM_SELECTED, Mt, de), M.off(m.default.KEY_SESSION_CREATED, Mt, de), M.off(m.default.KEY_STATUSES_CHANGED, Mt, de));
              }
              function Re() {
                return z ? z.id : null;
              }
              function Pe(qe, Rt) {
                return new Promise(function(bt, we) {
                  if (ee) {
                    bt(Rt);
                    return;
                  }
                  if (Pt()) {
                    ee = !0, M.trigger(m.default.STREAM_ACTIVATED, {
                      streamInfo: z
                    }), bt(Rt);
                    return;
                  }
                  De(qe, Rt).then(function(Ve) {
                    ee = !0, M.trigger(m.default.STREAM_ACTIVATED, {
                      streamInfo: z
                    }), bt(Ve);
                  }).catch(function(Ve) {
                    we(Ve);
                  });
                });
              }
              function ke(qe, Rt) {
                return new Promise(function(bt, we) {
                  if (Pt()) {
                    we();
                    return;
                  }
                  pe.info("[startPreloading] Preloading next stream with id ".concat(Me())), It(!0), Ae(qe, Rt).then(function() {
                    for (var Ve = 0; Ve < he.length && he[Ve]; Ve++)
                      he[Ve].setExplicitBufferingTime(me()), he[Ve].getScheduleController().startScheduleTimer();
                    bt();
                  }).catch(function() {
                    It(!1), we();
                  });
                });
              }
              function De(qe, Rt) {
                return Ae(qe, Rt);
              }
              function Ae(qe, Rt) {
                return new Promise(function(bt, we) {
                  tt(), P = !0, We();
                  var Ve = ce.getElement();
                  E.forEach(function(Se) {
                    !(Se === h.default.TEXT && !qe) && (Se !== h.default.VIDEO || !Ve || Ve && /^VIDEO$/i.test(Ve.nodeName)) && Xe(Se, qe);
                  }), Ne(Rt).then(function(Se) {
                    if (P = !1, he.length === 0) {
                      var Ge = "No streams to play.";
                      j.error(new N.default(b.default.MANIFEST_ERROR_ID_NOSTREAMS_CODE, Ge, I.getValue())), pe.fatal(Ge);
                    } else
                      et();
                    qe && re.createTracks(z), bt(Se);
                  }).catch(function(Se) {
                    we(Se);
                  });
                });
              }
              function Ie(qe) {
                return new Promise(function(Rt, bt) {
                  Xe(h.default.TEXT, qe), He().then(function() {
                    re.createTracks(z), Rt();
                  }).catch(function(we) {
                    bt(we);
                  });
                });
              }
              function Xe(qe, Rt) {
                var bt = H.getAllMediaInfoForType(z, qe), we = [], Ve = null, Se;
                if (!bt || bt.length === 0) {
                  pe.info("No " + qe + " data.");
                  return;
                }
                qe === h.default.VIDEO && (le = !0), qe === h.default.AUDIO && (ne = !0);
                for (var Ge = 0, ct = bt.length; Ge < ct; Ge++)
                  Ve = bt[Ge], qe === h.default.TEXT && Ve.isEmbedded && (re.addEmbeddedTrack(z, Ve), we.push(Ve)), it(Ve) && $.addTrack(Ve);
                if (we.length > 0 && ($.setInitialMediaSettingsForType(qe, z), re.addMediaInfosToBuffer(z, qe, we)), bt = bt.filter(function(wt) {
                  return !wt.isEmbedded;
                }), bt.length !== 0) {
                  if (qe === h.default.IMAGE) {
                    W = (0, v.default)(D).create({
                      streamInfo: z,
                      adapter: H,
                      baseURLController: O.baseURLController,
                      timelineConverter: O.timelineConverter,
                      debug: V,
                      eventBus: M,
                      events: m.default,
                      dashConstants: f.default,
                      dashMetrics: O.dashMetrics,
                      segmentBaseController: O.segmentBaseController
                    }), W.initialize();
                    return;
                  }
                  M.trigger(m.default.STREAM_INITIALIZING, {
                    streamInfo: z,
                    mediaInfo: Ve
                  }), $.setInitialMediaSettingsForType(qe, z);
                  var Ot = rt(bt, Rt);
                  Se = $.getCurrentTrackFor(qe, z.id), Se && (J.updateTopQualityIndex(Se), Ot.selectMediaInfo(qe !== h.default.TEXT || !Se.isEmbedded ? Se : bt[0]));
                }
              }
              function it(qe) {
                var Rt = qe ? qe.type : null, bt;
                return Rt === h.default.MUXED ? (bt = "Multiplexed representations are intentionally not supported, as they are not compliant with the DASH-AVC/264 guidelines", pe.fatal(bt), j.error(new N.default(b.default.MANIFEST_ERROR_ID_MULTIPLEXED_CODE, bt, I.getValue())), !1) : Rt === h.default.TEXT || Rt === h.default.IMAGE ? !0 : qe.contentProtection && !Y.supportsEncryptedMedia() ? (j.error(new N.default(b.default.CAPABILITY_MEDIAKEYS_ERROR_CODE, b.default.CAPABILITY_MEDIAKEYS_ERROR_MESSAGE)), !1) : !0;
              }
              function rt(qe, Rt) {
                var bt = qe && qe.length > 0 ? qe[0] : null, we = B.getModel(bt ? bt.type : null), Ve = bt ? bt.type : null, Se = bt ? bt.mimeType : null, Ge = bt ? bt.isFragmented : null, ct = (0, p.default)(D).create({
                  streamInfo: z,
                  type: Ve,
                  mimeType: Se,
                  timelineConverter: Z,
                  adapter: H,
                  manifestModel: I,
                  mediaPlayerModel: w,
                  fragmentModel: we,
                  dashMetrics: O.dashMetrics,
                  baseURLController: O.baseURLController,
                  segmentBaseController: O.segmentBaseController,
                  abrController: J,
                  playbackController: ae,
                  mediaController: $,
                  textController: re,
                  errHandler: j,
                  settings: oe,
                  boxParser: U,
                  segmentBlacklistController: X
                });
                ct.initialize(Rt, le, Ge), he.push(ct);
                for (var Ot = 0; Ot < qe.length; Ot++)
                  ct.addMediaInfo(qe[Ot]);
                return Ve === h.default.TEXT && re.addMediaInfosToBuffer(z, Ve, qe, we), ct;
              }
              function Ne(qe) {
                return new Promise(function(Rt) {
                  var bt = {}, we = he.map(function(Ve) {
                    return Ve.createBufferSinks(qe);
                  });
                  Promise.all(we).then(function(Ve) {
                    Ve.forEach(function(Se) {
                      Se && (bt[Se.getType()] = Se);
                    }), Rt(bt);
                  }).catch(function() {
                    Rt(bt);
                  });
                });
              }
              function He() {
                var qe = tn(h.default.TEXT);
                return qe ? qe.createBufferSinks() : Promise.resolve();
              }
              function $e(qe) {
                for (var Rt = he ? he.length : 0, bt = !1, we = 0; we < Rt; we++) {
                  var Ve = he[we].getFragmentModel();
                  Ve.abortRequests(), Ve.resetInitialSettings(), he[we].reset(bt, qe);
                }
                re && re.deactivateStream(z), he = [], ee = !1, te = !1, It(!1), Te(!1), M.trigger(m.default.STREAM_DEACTIVATED, {
                  streamInfo: z
                });
              }
              function nt() {
                return ee;
              }
              function ut(qe) {
                return new Promise(function(Rt, bt) {
                  for (var we = [], Ve = 0; Ve < he.length; )
                    it(he[Ve].getMediaInfo()) ? (we.push(he[Ve].setMediaSource(qe)), Ve++) : (he[Ve].reset(), he.splice(Ve, 1));
                  Promise.all(we).then(function() {
                    for (var Se = 0; Se < he.length; Se++)
                      he[Se].dischargePreBuffer();
                    if (he.length === 0) {
                      var Ge = "No streams to play.";
                      j.error(new N.default(b.default.MANIFEST_ERROR_ID_NOSTREAMS_CODE, Ge + "nostreams", I.getValue())), pe.fatal(Ge);
                    }
                    Rt();
                  }).catch(function(Se) {
                    pe.error(Se), bt(Se);
                  });
                });
              }
              function pt(qe) {
                $e(qe), se = !1, le = !1, ne = !1, x = {}, P = !1, Q = !1, fe = [];
              }
              function vt(qe) {
                B && (B.reset(), B = null), J && z && J.clearDataForStream(z.id), X && (X.reset(), X = null), pt(qe), z = null, ge(), Ee();
              }
              function Ut() {
                return z ? z.duration : NaN;
              }
              function Je() {
                return Q;
              }
              function Te(qe) {
                Q = qe;
              }
              function me() {
                return z ? z.start : NaN;
              }
              function Me() {
                return z ? z.id : null;
              }
              function Be() {
                return z;
              }
              function Fe() {
                return ne;
              }
              function Ze() {
                return le;
              }
              function ot() {
                return W;
              }
              function tt() {
                if (!ce || !J)
                  throw new Error(h.default.MISSING_CONFIG_ERROR);
              }
              function gt(qe) {
                if (tt(), qe === h.default.IMAGE)
                  return W ? W.getBitrateList() : [];
                var Rt = _t(qe);
                return J.getBitrateList(Rt);
              }
              function Mt(qe) {
                qe.error && (j.error(qe.error), pe.fatal(qe.error.message));
              }
              function xt(qe) {
                if (!(!ee || !z)) {
                  te = !1;
                  var Rt = qe.newMediaInfo, bt = I.getValue();
                  H.setCurrentMediaInfo(z.id, Rt.type, Rt);
                  var we = Qt(Rt);
                  if (we) {
                    var Ve = ae.getTime();
                    pe.info("Stream -  Process track changed at current time " + Ve), bt.refreshManifestOnSwitchTrack ? (fe.push(qe), k.getIsUpdating() || (pe.debug("Stream -  Refreshing manifest for switch track"), k.refreshManifest())) : we.selectMediaInfo(Rt).then(function() {
                      (Rt.type === h.default.VIDEO || Rt.type === h.default.AUDIO) && J.updateTopQualityIndex(Rt), we.prepareTrackSwitch();
                    });
                  }
                }
              }
              function be(qe) {
                var Rt = tn(qe.mediaType);
                Rt && Rt.prepareQualityChange(qe);
              }
              function We() {
                if (G) {
                  var qe = H.getEventsFor(z);
                  qe && qe.length > 0 && G.addInlineEvents(qe, z.id);
                }
              }
              function et() {
                for (var qe = he.length, Rt = !!x.audio || !!x.video, bt = Rt ? new N.default(b.default.DATA_UPDATE_FAILED_ERROR_CODE, b.default.DATA_UPDATE_FAILED_ERROR_MESSAGE) : null, we = 0; we < qe; we++)
                  if (he[we].isUpdating() || P)
                    return;
                if (ie) {
                  ie.clearMediaInfoArray();
                  for (var Ve = 0; Ve < qe && he[Ve]; Ve++) {
                    var Se = he[Ve].getType(), Ge = he[Ve].getMediaInfo();
                    if (Se === h.default.AUDIO || Se === h.default.VIDEO || Se === h.default.TEXT && Ge.isFragmented) {
                      var ct = he[Ve].getMediaInfo();
                      ct && ie.initializeForMedia(ct);
                    }
                  }
                  ie.handleKeySystemFromManifest();
                }
                bt ? j.error(bt) : se || (se = !0, ce.waitForReadyState(h.default.VIDEO_ELEMENT_READY_STATES.HAVE_METADATA, function() {
                  M.trigger(m.default.STREAM_INITIALIZED, {
                    streamInfo: z
                  });
                }));
              }
              function _t(qe) {
                for (var Rt = null, bt = 0; bt < he.length; bt++)
                  if (Rt = he[bt], Rt.getType() === qe)
                    return Rt.getMediaInfo();
                return null;
              }
              function ht() {
                var qe = ye(), Rt = qe.length;
                if (Rt === 0) {
                  pe.warn("onBufferingCompleted - can't trigger STREAM_BUFFERING_COMPLETED because no streamProcessor is defined");
                  return;
                }
                for (var bt = 0; bt < Rt; bt++)
                  if (!qe[bt].isBufferingCompleted() && (qe[bt].getType() === h.default.AUDIO || qe[bt].getType() === h.default.VIDEO)) {
                    pe.debug("onBufferingCompleted - One streamProcessor has finished but", qe[bt].getType(), "one is not buffering completed");
                    return;
                  }
                pe.debug("onBufferingCompleted - trigger STREAM_BUFFERING_COMPLETED"), te = !0, M.trigger(m.default.STREAM_BUFFERING_COMPLETED, {
                  streamInfo: z
                }, {
                  streamInfo: z
                });
              }
              function St(qe) {
                x[qe.mediaType] = qe.error, et();
              }
              function kt(qe) {
                G && G.addInbandEvents(qe.events, z.id);
              }
              function Qt(qe) {
                return !qe || !qe.type ? null : tn(qe.type);
              }
              function tn(qe) {
                if (!qe)
                  return null;
                var Rt = ye();
                return Rt.filter(function(bt) {
                  return bt.getType() === qe;
                })[0];
              }
              function ye() {
                for (var qe = [], Rt, bt, we = 0; we < he.length; we++)
                  bt = he[we], Rt = bt.getType(), (Rt === h.default.AUDIO || Rt === h.default.VIDEO || Rt === h.default.TEXT) && qe.push(bt);
                return qe;
              }
              function ze() {
                for (var qe = he.length, Rt = 0; Rt < qe && he[Rt]; Rt++)
                  he[Rt].getScheduleController().startScheduleTimer();
              }
              function ft(qe) {
                return new Promise(function(Rt) {
                  P = !0, z = qe, G && We();
                  for (var bt = [], we = 0, Ve = he.length; we < Ve; we++) {
                    var Se = he[we], Ge = Se.getMediaInfo();
                    bt.push(Se.updateStreamInfo(z));
                    var ct = H.getAllMediaInfoForType(z, Se.getType());
                    if (ct = ct.filter(function(Xt) {
                      return !Xt.isEmbedded;
                    }), ct) {
                      Se.clearMediaInfoArray();
                      for (var Ot = 0; Ot < ct.length; Ot++) {
                        var wt = ct[Ot];
                        Se.addMediaInfo(ct[Ot]), H.areMediaInfosEqual(Ge, wt) && (J.updateTopQualityIndex(wt), bt.push(Se.selectMediaInfo(wt)));
                      }
                    }
                  }
                  Promise.all(bt).then(function() {
                    for (bt = []; fe.length > 0; ) {
                      var Xt = fe.pop(), nn = Xt.newMediaInfo, Yt = Qt(Xt.oldMediaInfo);
                      if (!Yt)
                        return;
                      bt.push(Yt.prepareTrackSwitch()), Yt.selectMediaInfo(nn);
                    }
                    return Promise.all(bt);
                  }).then(function() {
                    P = !1, et(), M.trigger(m.default.STREAM_UPDATED, {
                      streamInfo: z
                    }), Rt();
                  });
                });
              }
              function Le(qe) {
                var Rt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                return Vt(qe, h.default.VIDEO, Rt) && Vt(qe, h.default.AUDIO, Rt);
              }
              function Ke(qe) {
                return qe ? Qe(h.default.VIDEO, qe) && Qe(h.default.AUDIO, qe) : !0;
              }
              function Qe(qe, Rt) {
                var bt = Be(), we = Rt.getStreamInfo();
                if (!we || !bt)
                  return !0;
                var Ve = H.getAdaptationForType(we.index, qe, we), Se = H.getAdaptationForType(bt.index, qe, bt);
                return !Ve || !Se ? !Ve && !Se : !(!Et(Se) && Et(Ve));
              }
              function Et(qe) {
                return qe ? !!(qe.ContentProtection || qe.Representation && qe.Representation.length > 0 && qe.Representation[0].ContentProtection) : !1;
              }
              function Vt(qe, Rt) {
                var bt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
                if (!qe || !qe.hasOwnProperty("getStreamInfo"))
                  return !1;
                var we = qe.getStreamInfo(), Ve = bt ? bt.getStreamInfo() : Be();
                if (!we || !Ve)
                  return !1;
                var Se = H.getAdaptationForType(we.index, Rt, we), Ge = H.getAdaptationForType(Ve.index, Rt, Ve);
                if (!Se || !Ge)
                  return !Se && !Ge;
                var ct = Se && Ge && Se.mimeType === Ge.mimeType, Ot = Ge.Representation_asArray.map(function(Yt) {
                  return Yt.codecs;
                }), wt = Se.Representation_asArray.map(function(Yt) {
                  return Yt.codecs;
                }), Xt = wt.some(function(Yt) {
                  return Ot.indexOf(Yt) > -1;
                }), nn = wt.some(function(Yt) {
                  return Ot.some(function(Dn) {
                    return Y.codecRootCompatibleWithCodec(Dn, Yt);
                  });
                });
                return Xt || nn && ct;
              }
              function It(qe) {
                K = qe;
              }
              function Pt() {
                return K;
              }
              function mn() {
                return te;
              }
              function Jt() {
                return H;
              }
              return de = {
                initialize: q,
                getStreamId: Re,
                activate: Pe,
                deactivate: $e,
                getIsActive: nt,
                getDuration: Ut,
                getStartTime: me,
                getId: Me,
                getStreamInfo: Be,
                getHasAudioTrack: Fe,
                getHasVideoTrack: Ze,
                startPreloading: ke,
                initializeForTextWithMediaSource: Ie,
                getThumbnailController: ot,
                getBitrateListFor: gt,
                updateData: ft,
                reset: vt,
                getProcessors: ye,
                setMediaSource: ut,
                isMediaCodecCompatible: Le,
                isProtectionCompatible: Ke,
                getPreloaded: Pt,
                getIsEndedEventSignaled: Je,
                setIsEndedEventSignaled: Te,
                getAdapter: Jt,
                getHasFinishedBuffering: mn,
                setPreloaded: It,
                startScheduleControllers: ze,
                prepareTrackChange: xt,
                prepareQualityChange: be
              }, ue(), de;
            }
            L.__dashjs_factory_name = "Stream";
            const _ = S.default.getClassFactory(L);
          }
        ),
        /***/
        "./src/streaming/StreamProcessor.js": (
          /*!******************************************!*\
            !*** ./src/streaming/StreamProcessor.js ***!
            \******************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => F
              /* harmony export */
            });
            var h = i(
              /*! ./constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), f = i(
              /*! ../dash/constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            ), p = i(
              /*! ./constants/MetricsConstants */
              "./src/streaming/constants/MetricsConstants.js"
            ), d = i(
              /*! ./models/FragmentModel */
              "./src/streaming/models/FragmentModel.js"
            ), v = i(
              /*! ./controllers/BufferController */
              "./src/streaming/controllers/BufferController.js"
            ), g = i(
              /*! ./text/NotFragmentedTextBufferController */
              "./src/streaming/text/NotFragmentedTextBufferController.js"
            ), m = i(
              /*! ./controllers/ScheduleController */
              "./src/streaming/controllers/ScheduleController.js"
            ), A = i(
              /*! ../dash/controllers/RepresentationController */
              "./src/dash/controllers/RepresentationController.js"
            ), b = i(
              /*! ../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), S = i(
              /*! ./utils/SupervisorTools */
              "./src/streaming/utils/SupervisorTools.js"
            ), N = i(
              /*! ../core/EventBus */
              "./src/core/EventBus.js"
            ), T = i(
              /*! ../core/events/Events */
              "./src/core/events/Events.js"
            ), R = i(
              /*! ../dash/DashHandler */
              "./src/dash/DashHandler.js"
            ), y = i(
              /*! ../core/errors/Errors */
              "./src/core/errors/Errors.js"
            ), E = i(
              /*! ./vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), L = i(
              /*! ../core/Debug */
              "./src/core/Debug.js"
            ), _ = i(
              /*! ./utils/RequestModifier */
              "./src/streaming/utils/RequestModifier.js"
            ), O = i(
              /*! ../streaming/utils/URLUtils */
              "./src/streaming/utils/URLUtils.js"
            ), D = i(
              /*! ./utils/BoxParser */
              "./src/streaming/utils/BoxParser.js"
            ), M = i(
              /*! ./vo/metrics/PlayList */
              "./src/streaming/vo/metrics/PlayList.js"
            ), C = i(
              /*! ../dash/controllers/SegmentsController */
              "./src/dash/controllers/SegmentsController.js"
            ), I = i(
              /*! ./vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            );
            function w(k) {
              k = k || {};
              var H = this.context, Z = (0, N.default)(H).getInstance(), Y = k.streamInfo, j = k.type, J = k.errHandler, ae = k.mimeType, G = k.timelineConverter, $ = k.adapter, ie = k.manifestModel, re = k.mediaPlayerModel, ce = k.fragmentModel, z = k.abrController, oe = k.playbackController, de = k.mediaController, pe = k.textController, he = k.dashMetrics, se = k.settings, ee = k.boxParser, te = k.segmentBlacklistController, le, ne, x, P, B, W, X, K, U, V, Q, fe, ue;
              function q() {
                ne = (0, L.default)(H).getInstance().getLogger(le), Re(), Z.on(T.default.DATA_UPDATE_COMPLETED, nt, le, {
                  priority: N.default.EVENT_PRIORITY_HIGH
                }), Z.on(T.default.INIT_FRAGMENT_NEEDED, Ie, le), Z.on(T.default.MEDIA_FRAGMENT_NEEDED, Xe, le), Z.on(T.default.INIT_FRAGMENT_LOADED, Et, le), Z.on(T.default.MEDIA_FRAGMENT_LOADED, Vt, le), Z.on(T.default.BUFFER_LEVEL_STATE_CHANGED, ut, le), Z.on(T.default.BUFFER_CLEARED, pt, le), Z.on(T.default.SEEK_TARGET, bt, le), Z.on(T.default.FRAGMENT_LOADING_ABANDONED, Me, le), Z.on(T.default.FRAGMENT_LOADING_COMPLETED, Be, le), Z.on(T.default.QUOTA_EXCEEDED, tt, le), Z.on(T.default.SET_FRAGMENTED_TEXT_AFTER_DISABLED, Ze, le), Z.on(T.default.SET_NON_FRAGMENTED_TEXT, ot, le), Z.on(T.default.SOURCE_BUFFER_ERROR, vt, le);
              }
              function _e(Se, Ge, ct) {
                fe = (0, C.default)(H).create({
                  events: T.default,
                  eventBus: Z,
                  streamInfo: Y,
                  timelineConverter: G,
                  dashConstants: f.default,
                  segmentBaseController: k.segmentBaseController,
                  type: j
                }), Q = (0, R.default)(H).create({
                  streamInfo: Y,
                  type: j,
                  timelineConverter: G,
                  dashMetrics: he,
                  mediaPlayerModel: re,
                  baseURLController: k.baseURLController,
                  errHandler: J,
                  segmentsController: fe,
                  settings: se,
                  boxParser: ee,
                  events: T.default,
                  eventBus: Z,
                  errors: y.default,
                  debug: (0, L.default)(H).getInstance(),
                  requestModifier: (0, _.default)(H).getInstance(),
                  dashConstants: f.default,
                  constants: h.default,
                  urlUtils: (0, O.default)(H).getInstance()
                }), x = Y.manifestInfo.isDynamic, Q.initialize(x), z.registerStreamType(j, le), K = (0, A.default)(H).create({
                  streamInfo: Y,
                  type: j,
                  abrController: z,
                  dashMetrics: he,
                  playbackController: oe,
                  timelineConverter: G,
                  dashConstants: f.default,
                  events: T.default,
                  eventBus: Z,
                  errors: y.default,
                  isDynamic: x,
                  segmentsController: fe
                }), W = Rt(j, ct), W && W.initialize(Se), X = (0, m.default)(H).create({
                  streamInfo: Y,
                  type: j,
                  mimeType: ae,
                  adapter: $,
                  dashMetrics: he,
                  mediaPlayerModel: re,
                  fragmentModel: ce,
                  abrController: z,
                  playbackController: oe,
                  textController: pe,
                  mediaController: de,
                  bufferController: W,
                  settings: se
                }), X.initialize(Ge), ue = 0, U = !1;
              }
              function ge() {
                return Y.id;
              }
              function Ce() {
                return j;
              }
              function Ee() {
                return $.getIsTextTrack(K.getData());
              }
              function Re() {
                B = [], P = null, ue = 0, U = !1, V = !1;
              }
              function Pe(Se, Ge) {
                Q && Q.reset(), W && (W.reset(Se, Ge), W = null), X && (X.reset(), X = null), K && (K.reset(), K = null), fe && (fe = null), z && z.unRegisterStreamType(ge(), j), Z.off(T.default.DATA_UPDATE_COMPLETED, nt, le), Z.off(T.default.INIT_FRAGMENT_NEEDED, Ie, le), Z.off(T.default.MEDIA_FRAGMENT_NEEDED, Xe, le), Z.off(T.default.INIT_FRAGMENT_LOADED, Et, le), Z.off(T.default.MEDIA_FRAGMENT_LOADED, Vt, le), Z.off(T.default.BUFFER_LEVEL_STATE_CHANGED, ut, le), Z.off(T.default.BUFFER_CLEARED, pt, le), Z.off(T.default.SEEK_TARGET, bt, le), Z.off(T.default.FRAGMENT_LOADING_ABANDONED, Me, le), Z.off(T.default.FRAGMENT_LOADING_COMPLETED, Be, le), Z.off(T.default.SET_FRAGMENTED_TEXT_AFTER_DISABLED, Ze, le), Z.off(T.default.SET_NON_FRAGMENTED_TEXT, ot, le), Z.off(T.default.QUOTA_EXCEEDED, tt, le), Z.off(T.default.SOURCE_BUFFER_ERROR, vt, le), Re(), j = null, Y = null;
              }
              function ke() {
                return K ? K.isUpdating() : !1;
              }
              function De(Se) {
                return new Promise(function(Ge) {
                  var ct = W.hasBufferAtTime(Se.seekTime);
                  if (ct) {
                    W.pruneBuffer(), Ge();
                    return;
                  }
                  X.clearScheduleTimer(), ce.abortRequests(), W.prepareForPlaybackSeek().then(function() {
                    var Ot = W.getAllRangesWithSafetyFactor(Se.seekTime);
                    return W.clearBuffers(Ot);
                  }).then(function() {
                    var Ot = W.getContinuousBufferTimeForTargetTime(Se.seekTime);
                    if (!isNaN(Ot) && !isNaN(Y.duration) && isFinite(Y.duration) && Ot >= Y.start + Y.duration)
                      W.setIsBufferingCompleted(!0), Ge();
                    else {
                      var wt = isNaN(Ot) ? Se.seekTime : Ot;
                      we(wt), W.setSeekTarget(wt);
                      var Xt = [];
                      Xt.push(W.updateAppendWindow());
                      var nn = ft();
                      Xt.push(W.updateBufferTimestampOffset(nn)), Promise.all(Xt).then(function() {
                        X.setInitSegmentRequired(!0), X.setCheckPlaybackQuality(!1), X.startScheduleTimer(), Ge();
                      });
                    }
                  }).catch(function(Ot) {
                    ne.error(Ot);
                  });
                });
              }
              function Ae() {
                return new Promise(function(Se, Ge) {
                  try {
                    X.clearScheduleTimer(), ce.abortRequests(), W.prepareForPlaybackSeek().then(function() {
                      return W.pruneAllSafely();
                    }).then(function() {
                      Se();
                    });
                  } catch (ct) {
                    Ge(ct);
                  }
                });
              }
              function Ie(Se) {
                var Ge = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
                if (Se.sender) {
                  if (oe.getIsManifestUpdateInProgress()) {
                    $e();
                    return;
                  }
                  if (!(Ee() && !pe.isTextEnabled()) && W && Se.representationId && !W.appendInitSegmentFromCache(Se.representationId)) {
                    var ct = K.getCurrentRepresentation();
                    if (ct.range === 0) {
                      Xe();
                      return;
                    }
                    var Ot = Q ? Q.getInitRequest(P, ct) : null;
                    Ot ? ce.executeRequest(Ot) : Ge && (X.setInitSegmentRequired(!0), $e());
                  }
                }
              }
              function Xe(Se) {
                var Ge = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
                if (oe.getIsManifestUpdateInProgress() || W.getIsPruningInProgress()) {
                  $e();
                  return;
                }
                var ct = He();
                ct ? (U = !1, it(ct)) : rt(Ge);
              }
              function it(Se) {
                isNaN(Se.startTime + Se.duration) || (ue = Se.startTime + Se.duration), Se.delayLoadingTime = (/* @__PURE__ */ new Date()).getTime() + X.getTimeToLoadDelay(), X.setTimeToLoadDelay(0), Ne(Se) ? (ne.warn("Fragment request url ".concat(Se.url, " for stream id ").concat(Y.id, " and media type ").concat(j, " is on the ignore list and will be skipped")), $e()) : (ne.debug("Next fragment request url for stream id ".concat(Y.id, " and media type ").concat(j, " is ").concat(Se.url)), ce.executeRequest(Se));
              }
              function rt(Se) {
                var Ge = K.getCurrentRepresentation();
                if (se.get().streaming.gaps.enableSeekFix && (U || oe.getTime() === 0)) {
                  var ct;
                  if (x ? x && Ge.segmentInfoType === f.default.SEGMENT_TIMELINE && (ct = Q.getValidTimeAheadOfTargetTime(ue, P, Ge, se.get().streaming.gaps.threshold)) : ct = Q.getValidTimeAheadOfTargetTime(ue, P, Ge, se.get().streaming.gaps.threshold), !isNaN(ct) && ct !== ue) {
                    oe.isSeeking() || oe.getTime() === 0 ? (ne.warn("Adjusting playback time ".concat(ct, " because of gap in the manifest. Seeking by ").concat(ct - ue)), oe.seek(ct, !1, !1)) : (ne.warn("Adjusting buffering time ".concat(ct, " because of gap in the manifest. Adjusting time by ").concat(ct - ue)), we(ct), Se && $e());
                    return;
                  }
                }
                var Ot = Q.isLastSegmentRequested(Ge, ue);
                if (Ot) {
                  var wt = Q.getCurrentIndex();
                  ne.debug("Segment requesting for stream ".concat(Y.id, " has finished")), Z.trigger(T.default.STREAM_REQUESTING_COMPLETED, {
                    segmentIndex: wt
                  }, {
                    streamId: Y.id,
                    mediaType: j
                  }), W.segmentRequestingCompleted(wt), X.clearScheduleTimer();
                  return;
                }
                Se && $e();
              }
              function Ne(Se) {
                var Ge = Se.url;
                return Se.range && (Ge = Ge.concat("_", Se.range)), te.contains(Ge);
              }
              function He() {
                var Se = ft(), Ge;
                if (isNaN(ue) || Ce() === h.default.TEXT && !pe.isTextEnabled())
                  return null;
                if (Q) {
                  var ct = K && Se ? K.getRepresentationForQuality(Se.quality) : null;
                  U ? Ge = Q.getSegmentRequestForTime(P, ct, ue) : Ge = Q.getNextSegmentRequest(P, ct);
                }
                return Ge;
              }
              function $e() {
                X.startScheduleTimer(oe.getLowLatencyModeEnabled() ? se.get().streaming.scheduling.lowLatencyTimeout : se.get().streaming.scheduling.defaultTimeout);
              }
              function nt(Se) {
                Se.error || (X.setCurrentRepresentation($.convertRepresentationToRepresentationInfo(Se.currentRepresentation)), W.getIsBufferingCompleted() || W.updateBufferTimestampOffset(Se.currentRepresentation));
              }
              function ut(Se) {
                he.addBufferState(j, Se.state, X.getBufferTarget()), Se.state === p.default.BUFFER_EMPTY && !oe.isSeeking() && (ne.info("Buffer is empty! Stalling!"), he.pushPlayListTraceMetrics(/* @__PURE__ */ new Date(), M.PlayListTrace.REBUFFERING_REASON));
              }
              function pt(Se) {
                ce.syncExecutedRequestsWithBufferedRange(W.getBuffer().getAllBufferRanges(), Y.duration), Se.quotaExceeded && Se.from > oe.getTime() && we(Se.from), Se.hasEnoughSpaceToAppend && Se.quotaExceeded && X.startScheduleTimer();
              }
              function vt(Se) {
                if (!(!Se || !Se.lastRequestAppended || !Se.lastRequestAppended.url)) {
                  var Ge = Se.lastRequestAppended.url;
                  Se.lastRequestAppended.range && (Ge = Ge.concat("_", Se.lastRequestAppended.range)), ne.warn("Blacklisting segment with url ".concat(Ge)), te.add(Ge);
                }
              }
              function Ut(Se) {
                ne.debug("Preparing quality switch for type ".concat(j));
                var Ge = Se.newQuality;
                V = !0, X.clearScheduleTimer();
                var ct = ft(Ge);
                X.setCurrentRepresentation(ct), K.prepareQualityChange(Ge), ce.abortRequests(), W.updateBufferTimestampOffset(ct).then(function() {
                  Se.reason && Se.reason.forceReplace ? Je() : se.get().streaming.buffer.fastSwitchEnabled ? Te(ct) : me(), he.pushPlayListTraceMetrics(/* @__PURE__ */ new Date(), M.PlayListTrace.REPRESENTATION_SWITCH_STOP_REASON), he.createPlaylistTraceMetrics(ct.id, oe.getTime() * 1e3, oe.getPlaybackRate());
                });
              }
              function Je() {
                Z.trigger(T.default.BUFFER_REPLACEMENT_STARTED, {
                  mediaType: j,
                  streamId: Y.id
                }, {
                  mediaType: j,
                  streamId: Y.id
                }), W.prepareForReplacementQualitySwitch().then(function() {
                  Jt(), V = !1;
                }).catch(function() {
                  Jt(), V = !1;
                });
              }
              function Te(Se) {
                var Ge = oe.getTime(), ct = 1.5 * (isNaN(Se.fragmentDuration) ? 1 : Se.fragmentDuration), Ot = ce.getRequests({
                  state: d.default.FRAGMENT_MODEL_EXECUTED,
                  time: Ge + ct,
                  threshold: 0
                })[0];
                if (Ot && !Ee()) {
                  var wt = W.getBufferLevel(), Xt = z.getAbandonmentStateFor(Y.id, j);
                  if (Ot.quality < Se.quality && wt >= ct && Xt !== p.default.ABANDON_LOAD) {
                    var nn = Ge + ct;
                    we(nn), X.setCheckPlaybackQuality(!1), X.startScheduleTimer();
                  } else
                    me();
                } else
                  X.startScheduleTimer();
                V = !1;
              }
              function me() {
                qe(), V = !1;
              }
              function Me(Se) {
                ne.info("onFragmentLoadingAbandoned request: " + Se.request.url + " has been aborted"), !oe.isSeeking() && !X.getSwitchStrack() && !V && (ne.info("onFragmentLoadingAbandoned request: " + Se.request.url + " has to be downloaded again, origin is not seeking process or switch track call"), Se.request && Se.request.isInitializationRequest() ? X.setInitSegmentRequired(!0) : we(Se.request.startTime + Se.request.duration / 2), X.startScheduleTimer(0));
              }
              function Be(Se) {
                ne.info("OnFragmentLoadingCompleted for stream id " + Y.id + " and media type " + j + " - Url:", Se.request ? Se.request.url : "undefined", Se.request.range ? ", Range:" + Se.request.range : ""), Ee() && X.startScheduleTimer(0), Se.error && Se.request.serviceLocation && Fe(Se);
              }
              function Fe(Se) {
                ne.info("Fragment loading completed with an error"), !(!Se || !Se.request || !Se.request.type) && (Se.request.type === I.HTTPRequest.INIT_SEGMENT_TYPE ? Ie({
                  representationId: Se.request.representationId,
                  sender: {}
                }, !1) : Se.request.type === I.HTTPRequest.MEDIA_SEGMENT_TYPE && (we(Se.request.startTime + Se.request.duration / 2), Xe({}, !1)));
              }
              function Ze() {
                we(oe.getTime()), ze().startScheduleTimer();
              }
              function ot(Se) {
                var Ge = Se.currentTrackInfo;
                if (Ge) {
                  var ct = B.find(function(Ot) {
                    return Ot.index === Ge.index && Ot.lang === Ge.lang;
                  });
                  ct && ht(ct).then(function() {
                    W.setIsBufferingCompleted(!1), we(oe.getTime()), X.setInitSegmentRequired(!0), X.startScheduleTimer();
                  });
                }
              }
              function tt(Se) {
                we(Se.quotaExceededTime), X.clearScheduleTimer();
              }
              function gt() {
                return K;
              }
              function Mt() {
                return W ? W.getBuffer() : null;
              }
              function xt() {
                return W;
              }
              function be() {
                W.dischargePreBuffer();
              }
              function We() {
                return ce;
              }
              function et(Se) {
                return Y = Se, Le() ? Promise.resolve() : W.updateAppendWindow();
              }
              function _t() {
                return Y;
              }
              function ht(Se) {
                Se !== P && (!Se || !P || Se.type === P.type) && (P = Se);
                var Ge = $.getRealAdaptation(Y, P), ct = $.getVoRepresentations(P);
                if (K) {
                  var Ot = K.getData(), wt = z.getMaxAllowedIndexFor(j, Y.id), Xt = z.getMinAllowedIndexFor(j, Y.id), nn, Yt, Dn = null;
                  return (Ot === null || Ot.id !== Ge.id) && j !== h.default.TEXT ? (Yt = z.getThroughputHistory().getAverageThroughput(j, x), Dn = Yt || z.getInitialBitrateFor(j, Y.id), nn = z.getQualityForBitrate(P, Dn, Y.id)) : nn = z.getQualityFor(j, Y.id), Xt !== void 0 && nn < Xt && (nn = Xt), nn > wt && (nn = wt), K.updateData(Ge, ct, j, P.isFragmented, nn);
                } else
                  return Promise.resolve();
              }
              function St(Se) {
                B.indexOf(Se) === -1 && B.push(Se);
              }
              function kt() {
                B = [];
              }
              function Qt() {
                return P;
              }
              function tn() {
                return W.getMediaSource();
              }
              function ye(Se) {
                return W.setMediaSource(Se, P);
              }
              function ze() {
                return X;
              }
              function ft(Se) {
                var Ge;
                return Se !== void 0 ? ((0, S.checkInteger)(Se), Ge = K ? K.getRepresentationForQuality(Se) : null) : Ge = K ? K.getCurrentRepresentation() : null, $.convertRepresentationToRepresentationInfo(Ge);
              }
              function Le() {
                return W ? W.getIsBufferingCompleted() : !1;
              }
              function Ke() {
                return W ? W.getBufferLevel() : 0;
              }
              function Qe() {
                var Se = ft(), Ge = K && Se ? K.getRepresentationForQuality(Se.quality) : null;
                return Q.getNextSegmentRequestIdempotent(P, Ge);
              }
              function Et(Se) {
                if (se.get().streaming.enableManifestTimescaleMismatchFix) {
                  var Ge = Se.chunk, ct = Ge.bytes, Ot = Ge.quality, wt = ft(Ot), Xt = K && wt ? K.getRepresentationForQuality(wt.quality) : null;
                  if (wt && Xt) {
                    var nn = ee.getMediaTimescaleFromMoov(ct);
                    Xt.timescale = nn;
                  }
                }
              }
              function Vt(Se) {
                var Ge = Se.chunk, ct = Ge.bytes, Ot = Ge.quality, wt = ft(Ot), Xt = K && wt ? K.getRepresentationForQuality(wt.quality) : null;
                if (wt && Xt) {
                  var nn = $.getEventsFor(wt.mediaInfo, null, Y), Yt = $.getEventsFor(wt, Xt, Y);
                  if (nn && nn.length > 0 || Yt && Yt.length > 0) {
                    var Dn = ce.getRequests({
                      state: d.default.FRAGMENT_MODEL_EXECUTED,
                      quality: Ot,
                      index: Ge.index
                    })[0], Or = It(ct, Dn, nn, Yt);
                    Z.trigger(T.default.INBAND_EVENTS, {
                      events: Or
                    }, {
                      streamId: Y.id
                    });
                  }
                }
              }
              function It(Se, Ge, ct, Ot) {
                try {
                  for (var wt = {}, Xt = [], nn = ct.concat(Ot), Yt = 0, Dn = nn.length; Yt < Dn; Yt++)
                    wt[nn[Yt].schemeIdUri + "/" + nn[Yt].value] = nn[Yt];
                  var Or = (0, D.default)(H).getInstance().parse(Se), Yr = Or.getBoxes("emsg");
                  if (!Yr || Yr.length === 0)
                    return Xt;
                  for (var cr = Or.getBox("sidx"), Ki = cr && !isNaN(cr.earliest_presentation_time) && !isNaN(cr.timescale) ? cr.earliest_presentation_time / cr.timescale : Ge && !isNaN(Ge.mediaStartTime) ? Ge.mediaStartTime : 0, Aa = Math.max(Ki, 0), Co = K.getCurrentRepresentation(), Pr = 0, ji = Yr.length; Pr < ji; Pr++) {
                    var Wi = $.getEvent(Yr[Pr], wt, Aa, Co);
                    Wi && Xt.push(Wi);
                  }
                  return Xt;
                } catch {
                  return [];
                }
              }
              function Pt(Se) {
                var Ge = Mt();
                return Ge ? Promise.resolve(Ge) : W ? W.createBufferSink(P, Se) : Promise.resolve(null);
              }
              function mn() {
                return new Promise(function(Se) {
                  ne.debug("Preparing track switch for type ".concat(j));
                  var Ge = j === h.default.TEXT || se.get().streaming.trackSwitchMode[j] === h.default.TRACK_SWITCH_MODE_ALWAYS_REPLACE && oe.getTimeToStreamEnd(Y) > se.get().streaming.buffer.stallThreshold;
                  if (W.getIsBufferingCompleted() && !Ge) {
                    W.prepareForNonReplacementTrackSwitch(P.codec).then(function() {
                      Z.trigger(T.default.BUFFERING_COMPLETED, {}, {
                        streamId: Y.id,
                        mediaType: j
                      });
                    }).catch(function() {
                      Z.trigger(T.default.BUFFERING_COMPLETED, {}, {
                        streamId: Y.id,
                        mediaType: j
                      });
                    }), Se();
                    return;
                  }
                  X.clearScheduleTimer(), X.setSwitchTrack(!0), Ge ? (Z.trigger(T.default.BUFFER_REPLACEMENT_STARTED, {
                    mediaType: j,
                    streamId: Y.id
                  }, {
                    mediaType: j,
                    streamId: Y.id
                  }), ce.abortRequests(), W.prepareForReplacementTrackSwitch(P.codec).then(function() {
                    var ct = ft();
                    return W.updateBufferTimestampOffset(ct);
                  }).then(function() {
                    Jt(), Se();
                  }).catch(function() {
                    Jt(), Se();
                  })) : W.prepareForNonReplacementTrackSwitch(P.codec).then(function() {
                    qe(), Se();
                  }).catch(function() {
                    qe(), Se();
                  });
                });
              }
              function Jt() {
                var Se = oe.getTime();
                se.get().streaming.buffer.flushBufferAtTrackSwitch && oe.seek(Se + 1e-3, !1, !0), we(Se), W.setSeekTarget(Se), X.startScheduleTimer();
              }
              function qe() {
                var Se = oe.getTime(), Ge = W.getContinuousBufferTimeForTargetTime(Se), ct = isNaN(Ge) ? Se : Ge;
                we(ct), X.startScheduleTimer();
              }
              function Rt(Se, Ge) {
                var ct = null;
                return Se ? (Se === h.default.TEXT && !Ge ? ct = (0, g.default)(H).create({
                  streamInfo: Y,
                  type: Se,
                  mimeType: ae,
                  fragmentModel: ce,
                  textController: pe,
                  errHandler: J,
                  settings: se
                }) : ct = (0, v.default)(H).create({
                  streamInfo: Y,
                  type: Se,
                  mediaPlayerModel: re,
                  manifestModel: ie,
                  fragmentModel: ce,
                  errHandler: J,
                  mediaController: de,
                  representationController: K,
                  adapter: $,
                  textController: pe,
                  abrController: z,
                  playbackController: oe,
                  settings: se
                }), ct) : (J.error(new E.default(y.default.MEDIASOURCE_TYPE_UNSUPPORTED_CODE, y.default.MEDIASOURCE_TYPE_UNSUPPORTED_MESSAGE + "not properly defined")), null);
              }
              function bt(Se) {
                Se && !isNaN(Se.time) && (we(Se.time), W.setSeekTarget(Se.time));
              }
              function we(Se) {
                ue = Se, U = !0;
              }
              function Ve(Se, Ge) {
                he.pushPlayListTraceMetrics(Se, Ge);
              }
              return le = {
                initialize: _e,
                getStreamId: ge,
                getType: Ce,
                isUpdating: ke,
                getBufferController: xt,
                dischargePreBuffer: be,
                getFragmentModel: We,
                getScheduleController: ze,
                getRepresentationController: gt,
                getRepresentationInfo: ft,
                getBufferLevel: Ke,
                isBufferingCompleted: Le,
                createBufferSinks: Pt,
                updateStreamInfo: et,
                getStreamInfo: _t,
                selectMediaInfo: ht,
                clearMediaInfoArray: kt,
                addMediaInfo: St,
                prepareTrackSwitch: mn,
                prepareQualityChange: Ut,
                getMediaInfo: Qt,
                getMediaSource: tn,
                setMediaSource: ye,
                getBuffer: Mt,
                setExplicitBufferingTime: we,
                finalisePlayList: Ve,
                probeNextRequest: Qe,
                prepareInnerPeriodPlaybackSeeking: De,
                prepareOuterPeriodPlaybackSeeking: Ae,
                reset: Pe
              }, q(), le;
            }
            w.__dashjs_factory_name = "StreamProcessor";
            const F = b.default.getClassFactory(w);
          }
        ),
        /***/
        "./src/streaming/XlinkLoader.js": (
          /*!**************************************!*\
            !*** ./src/streaming/XlinkLoader.js ***!
            \**************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => S
              /* harmony export */
            });
            var h = i(
              /*! ./vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), f = i(
              /*! ./net/URLLoader */
              "./src/streaming/net/URLLoader.js"
            ), p = i(
              /*! ./vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            ), d = i(
              /*! ./vo/TextRequest */
              "./src/streaming/vo/TextRequest.js"
            ), v = i(
              /*! ../core/EventBus */
              "./src/core/EventBus.js"
            ), g = i(
              /*! ../core/events/Events */
              "./src/core/events/Events.js"
            ), m = i(
              /*! ../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), A = i(
              /*! ../core/errors/Errors */
              "./src/core/errors/Errors.js"
            );
            function b(N) {
              N = N || {};
              var T = "urn:mpeg:dash:resolve-to-zero:2013", R = this.context, y = (0, v.default)(R).getInstance(), E = (0, f.default)(R).create({
                errHandler: N.errHandler,
                dashMetrics: N.dashMetrics,
                mediaPlayerModel: N.mediaPlayerModel,
                requestModifier: N.requestModifier,
                errors: A.default
              }), L;
              function _(D, M, C) {
                var I = function(k, H) {
                  M.resolved = !0, M.resolvedContent = k || null, y.trigger(g.default.XLINK_ELEMENT_LOADED, {
                    element: M,
                    resolveObject: C,
                    error: k || H ? null : new h.default(A.default.XLINK_LOADER_LOADING_FAILURE_ERROR_CODE, A.default.XLINK_LOADER_LOADING_FAILURE_ERROR_MESSAGE + D)
                  });
                };
                if (D === T)
                  I(null, !0);
                else {
                  var w = new d.default(D, p.HTTPRequest.XLINK_EXPANSION_TYPE);
                  E.load({
                    request: w,
                    success: function(k) {
                      I(k);
                    },
                    error: function() {
                      I(null);
                    }
                  });
                }
              }
              function O() {
                E && (E.abort(), E = null);
              }
              return L = {
                load: _,
                reset: O
              }, L;
            }
            b.__dashjs_factory_name = "XlinkLoader";
            const S = m.default.getClassFactory(b);
          }
        ),
        /***/
        "./src/streaming/constants/ConformanceViolationConstants.js": (
          /*!******************************************************************!*\
            !*** ./src/streaming/constants/ConformanceViolationConstants.js ***!
            \******************************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => h
              /* harmony export */
            });
            const h = {
              LEVELS: {
                SUGGESTION: "Suggestion",
                WARNING: "Warning",
                ERROR: "Error"
              },
              EVENTS: {
                NO_UTC_TIMING_ELEMENT: {
                  key: "NO_UTC_TIMING_ELEMENT",
                  message: "No UTCTiming element is present in the manifest. You may experience playback failures. For a detailed validation use https://conformance.dashif.org/"
                },
                NON_COMPLIANT_SMPTE_IMAGE_ATTRIBUTE: {
                  key: "NON_COMPLIANT_SMPTE_IMAGE_ATTRIBUTE",
                  message: 'SMPTE 2052-1:2013 defines the attribute name as "imageType" and does not define "imagetype"'
                },
                INVALID_DVR_WINDOW: {
                  key: "INVALID_DVR_WINDOW",
                  message: "No valid segment found when applying a specification compliant DVR window calculation. Using SegmentTimeline entries as a fallback."
                }
              }
            };
          }
        ),
        /***/
        "./src/streaming/constants/Constants.js": (
          /*!**********************************************!*\
            !*** ./src/streaming/constants/Constants.js ***!
            \**********************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => g
              /* harmony export */
            });
            function h(m, A) {
              if (!(m instanceof A))
                throw new TypeError("Cannot call a class as a function");
            }
            function f(m, A) {
              for (var b = 0; b < A.length; b++) {
                var S = A[b];
                S.enumerable = S.enumerable || !1, S.configurable = !0, "value" in S && (S.writable = !0), Object.defineProperty(m, S.key, S);
              }
            }
            function p(m, A, b) {
              return A && f(m.prototype, A), b && f(m, b), m;
            }
            var d = /* @__PURE__ */ function() {
              function m() {
                h(this, m), this.init();
              }
              return p(m, [{
                key: "init",
                value: function() {
                  this.STREAM = "stream", this.VIDEO = "video", this.AUDIO = "audio", this.TEXT = "text", this.MUXED = "muxed", this.IMAGE = "image", this.STPP = "stpp", this.TTML = "ttml", this.VTT = "vtt", this.WVTT = "wvtt", this.CONTENT_STEERING = "contentSteering", this.ABR_STRATEGY_DYNAMIC = "abrDynamic", this.ABR_STRATEGY_BOLA = "abrBola", this.ABR_STRATEGY_L2A = "abrL2A", this.ABR_STRATEGY_LoLP = "abrLoLP", this.ABR_STRATEGY_THROUGHPUT = "abrThroughput", this.ABR_FETCH_THROUGHPUT_CALCULATION_DOWNLOADED_DATA = "abrFetchThroughputCalculationDownloadedData", this.ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING = "abrFetchThroughputCalculationMoofParsing", this.ABR_FETCH_THROUGHPUT_CALCULATION_AAST = "abrFetchThroughputCalculationAAST", this.LIVE_CATCHUP_MODE_DEFAULT = "liveCatchupModeDefault", this.LIVE_CATCHUP_MODE_LOLP = "liveCatchupModeLoLP", this.MOVING_AVERAGE_SLIDING_WINDOW = "slidingWindow", this.MOVING_AVERAGE_EWMA = "ewma", this.BAD_ARGUMENT_ERROR = "Invalid Arguments", this.MISSING_CONFIG_ERROR = "Missing config parameter(s)", this.TRACK_SWITCH_MODE_ALWAYS_REPLACE = "alwaysReplace", this.TRACK_SWITCH_MODE_NEVER_REPLACE = "neverReplace", this.TRACK_SELECTION_MODE_FIRST_TRACK = "firstTrack", this.TRACK_SELECTION_MODE_HIGHEST_BITRATE = "highestBitrate", this.TRACK_SELECTION_MODE_HIGHEST_EFFICIENCY = "highestEfficiency", this.TRACK_SELECTION_MODE_WIDEST_RANGE = "widestRange", this.TRACK_SELECTION_MODE_HIGHEST_SELECTION_PRIORITY = "highestSelectionPriority", this.CMCD_MODE_QUERY = "query", this.CMCD_MODE_HEADER = "header", this.LOCATION = "Location", this.INITIALIZE = "initialize", this.TEXT_SHOWING = "showing", this.TEXT_HIDDEN = "hidden", this.CC1 = "CC1", this.CC3 = "CC3", this.UTF8 = "utf-8", this.SCHEME_ID_URI = "schemeIdUri", this.START_TIME = "starttime", this.SERVICE_DESCRIPTION_DVB_LL_SCHEME = "urn:dvb:dash:lowlatency:scope:2019", this.SUPPLEMENTAL_PROPERTY_DVB_LL_SCHEME = "urn:dvb:dash:lowlatency:critical:2019", this.XML = "XML", this.ARRAY_BUFFER = "ArrayBuffer", this.DVB_REPORTING_URL = "dvb:reportingUrl", this.DVB_PROBABILITY = "dvb:probability", this.VIDEO_ELEMENT_READY_STATES = {
                    HAVE_NOTHING: 0,
                    HAVE_METADATA: 1,
                    HAVE_CURRENT_DATA: 2,
                    HAVE_FUTURE_DATA: 3,
                    HAVE_ENOUGH_DATA: 4
                  }, this.FILE_LOADER_TYPES = {
                    FETCH: "fetch_loader",
                    XHR: "xhr_loader"
                  };
                }
              }]), m;
            }(), v = new d();
            const g = v;
          }
        ),
        /***/
        "./src/streaming/constants/MetricsConstants.js": (
          /*!*****************************************************!*\
            !*** ./src/streaming/constants/MetricsConstants.js ***!
            \*****************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => g
              /* harmony export */
            });
            function h(m, A) {
              if (!(m instanceof A))
                throw new TypeError("Cannot call a class as a function");
            }
            function f(m, A) {
              for (var b = 0; b < A.length; b++) {
                var S = A[b];
                S.enumerable = S.enumerable || !1, S.configurable = !0, "value" in S && (S.writable = !0), Object.defineProperty(m, S.key, S);
              }
            }
            function p(m, A, b) {
              return A && f(m.prototype, A), b && f(m, b), m;
            }
            var d = /* @__PURE__ */ function() {
              function m() {
                h(this, m), this.init();
              }
              return p(m, [{
                key: "init",
                value: function() {
                  this.TCP_CONNECTION = "TcpList", this.HTTP_REQUEST = "HttpList", this.TRACK_SWITCH = "RepSwitchList", this.BUFFER_LEVEL = "BufferLevel", this.BUFFER_LOADED = "bufferLoaded", this.ABANDON_LOAD = "abandonload", this.ALLOW_LOAD = "allowload", this.BUFFER_EMPTY = "bufferStalled", this.BUFFER_STATE = "BufferState", this.DVR_INFO = "DVRInfo", this.DROPPED_FRAMES = "DroppedFrames", this.SCHEDULING_INFO = "SchedulingInfo", this.REQUESTS_QUEUE = "RequestsQueue", this.MANIFEST_UPDATE = "ManifestUpdate", this.MANIFEST_UPDATE_STREAM_INFO = "ManifestUpdatePeriodInfo", this.MANIFEST_UPDATE_TRACK_INFO = "ManifestUpdateRepresentationInfo", this.PLAY_LIST = "PlayList", this.DVB_ERRORS = "DVBErrors", this.HTTP_REQUEST_DVB_REPORTING_TYPE = "DVBReporting";
                }
              }]), m;
            }(), v = new d();
            const g = v;
          }
        ),
        /***/
        "./src/streaming/constants/ProtectionConstants.js": (
          /*!********************************************************!*\
            !*** ./src/streaming/constants/ProtectionConstants.js ***!
            \********************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => g
              /* harmony export */
            });
            function h(m, A) {
              if (!(m instanceof A))
                throw new TypeError("Cannot call a class as a function");
            }
            function f(m, A) {
              for (var b = 0; b < A.length; b++) {
                var S = A[b];
                S.enumerable = S.enumerable || !1, S.configurable = !0, "value" in S && (S.writable = !0), Object.defineProperty(m, S.key, S);
              }
            }
            function p(m, A, b) {
              return A && f(m.prototype, A), b && f(m, b), m;
            }
            var d = /* @__PURE__ */ function() {
              function m() {
                h(this, m), this.init();
              }
              return p(m, [{
                key: "init",
                value: function() {
                  this.CLEARKEY_KEYSTEM_STRING = "org.w3.clearkey", this.WIDEVINE_KEYSTEM_STRING = "com.widevine.alpha", this.PLAYREADY_KEYSTEM_STRING = "com.microsoft.playready", this.PLAYREADY_RECOMMENDATION_KEYSTEM_STRING = "com.microsoft.playready.recommendation", this.INITIALIZATION_DATA_TYPE_CENC = "cenc", this.INITIALIZATION_DATA_TYPE_KEYIDS = "keyids", this.INITIALIZATION_DATA_TYPE_WEBM = "webm";
                }
              }]), m;
            }(), v = new d();
            const g = v;
          }
        ),
        /***/
        "./src/streaming/controllers/AbrController.js": (
          /*!****************************************************!*\
            !*** ./src/streaming/controllers/AbrController.js ***!
            \****************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => w
              /* harmony export */
            });
            var h = i(
              /*! ../rules/abr/ABRRulesCollection */
              "./src/streaming/rules/abr/ABRRulesCollection.js"
            ), f = i(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), p = i(
              /*! ../constants/MetricsConstants */
              "./src/streaming/constants/MetricsConstants.js"
            ), d = i(
              /*! ../vo/BitrateInfo */
              "./src/streaming/vo/BitrateInfo.js"
            ), v = i(
              /*! ../models/FragmentModel */
              "./src/streaming/models/FragmentModel.js"
            ), g = i(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), m = i(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), A = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), b = i(
              /*! ../rules/RulesContext */
              "./src/streaming/rules/RulesContext.js"
            ), S = i(
              /*! ../rules/SwitchRequest */
              "./src/streaming/rules/SwitchRequest.js"
            ), N = i(
              /*! ../rules/SwitchRequestHistory */
              "./src/streaming/rules/SwitchRequestHistory.js"
            ), T = i(
              /*! ../rules/DroppedFramesHistory */
              "./src/streaming/rules/DroppedFramesHistory.js"
            ), R = i(
              /*! ../rules/ThroughputHistory */
              "./src/streaming/rules/ThroughputHistory.js"
            ), y = i(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), E = i(
              /*! ../vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            ), L = i(
              /*! ../utils/SupervisorTools */
              "./src/streaming/utils/SupervisorTools.js"
            ), _ = i(
              /*! ../MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), O = 1e3, D = 100, M = 0;
            function C() {
              var F = this.context, k = (0, y.default)(F).getInstance(), H = (0, g.default)(F).getInstance(), Z, Y, j, J, ae, G, $, ie, re, ce, z, oe, de, pe, he, se, ee, te, le, ne, x, P, B, W, X, K, U;
              function V() {
                Y = k.getLogger(Z), _e();
              }
              function Q() {
                x = (0, T.default)(F).create(), P = (0, R.default)(F).create({
                  settings: U
                }), j = (0, h.default)(F).create({
                  dashMetrics: K,
                  customParametersModel: se,
                  mediaPlayerModel: he,
                  settings: U
                }), j.initialize(), H.on(_.default.QUALITY_CHANGE_RENDERED, Pe, Z), H.on(_.default.METRIC_ADDED, ke, Z), H.on(m.default.LOADING_PROGRESS, Re, Z);
              }
              function fe(be, We) {
                var et = We.getStreamInfo().id;
                $[et] || ($[et] = {}), ne[et] || (ne[et] = {}), ie[et] || (ie[et] = {}), ne[et][be] = (0, N.default)(F).create(), $[et][be] = We, ie[et][be] = {}, ie[et][be].state = p.default.ALLOW_LOAD, ue(be), be === f.default.VIDEO && Mt();
              }
              function ue(be) {
                var We = U.get().streaming.abr.ABRStrategy;
                We === f.default.ABR_STRATEGY_L2A ? (B[be] = !1, X[be] = !1, W[be] = !0) : We === f.default.ABR_STRATEGY_LoLP ? (B[be] = !1, X[be] = !0, W[be] = !1) : We === f.default.ABR_STRATEGY_BOLA ? (B[be] = !0, X[be] = !1, W[be] = !1) : We === f.default.ABR_STRATEGY_THROUGHPUT ? (B[be] = !1, X[be] = !1, W[be] = !1) : We === f.default.ABR_STRATEGY_DYNAMIC && (B[be] = B && B[be] ? B[be] : !1, X[be] = !1, W[be] = !1);
              }
              function q(be, We) {
                try {
                  $[be] && $[be][We] && delete $[be][We], ne[be] && ne[be][We] && delete ne[be][We], ie[be] && ie[be][We] && delete ie[be][We];
                } catch {
                }
              }
              function _e() {
                ae = {}, G = {}, ie = {}, $ = {}, ne = {}, B = {}, W = {}, X = {}, ce === void 0 && (ce = !1), x && x.reset(), le = void 0, x = void 0, P = void 0, clearTimeout(re), re = null;
              }
              function ge() {
                _e(), H.off(m.default.LOADING_PROGRESS, Re, Z), H.off(_.default.QUALITY_CHANGE_RENDERED, Pe, Z), H.off(_.default.METRIC_ADDED, ke, Z), j && j.reset();
              }
              function Ce(be) {
                be && (be.streamController && (J = be.streamController), be.domStorage && (te = be.domStorage), be.mediaPlayerModel && (he = be.mediaPlayerModel), be.customParametersModel && (se = be.customParametersModel), be.cmsdModel && (ee = be.cmsdModel), be.dashMetrics && (K = be.dashMetrics), be.adapter && (de = be.adapter), be.videoModel && (pe = be.videoModel), be.settings && (U = be.settings));
              }
              function Ee() {
                if (!te || !te.hasOwnProperty("getSavedBitrateSettings"))
                  throw new Error(f.default.MISSING_CONFIG_ERROR);
              }
              function Re(be) {
                var We = be.request.mediaType, et = be.streamId;
                if (!(!We || !et || !$[et] || !U.get().streaming.abr.autoSwitchBitrate[We])) {
                  var _t = $[et][We];
                  if (_t) {
                    var ht = (0, b.default)(F).create({
                      abrController: Z,
                      streamProcessor: _t,
                      currentRequest: be.request,
                      useBufferOccupancyABR: B[We],
                      useL2AABR: W[We],
                      useLoLPABR: X[We],
                      videoModel: pe
                    }), St = j.shouldAbandonFragment(ht, et);
                    if (St.quality > S.default.NO_CHANGE) {
                      var kt = _t.getFragmentModel(), Qt = kt.getRequests({
                        state: v.default.FRAGMENT_MODEL_LOADING,
                        index: be.request.index
                      })[0];
                      Qt && (ie[et][We].state = p.default.ABANDON_LOAD, ne[et][We].reset(), ne[et][We].push({
                        oldValue: pt(We, et),
                        newValue: St.quality,
                        confidence: 1,
                        reason: St.reason
                      }), vt(We, J.getActiveStreamInfo(), St.quality, St.reason), clearTimeout(re), re = setTimeout(function() {
                        ie[et][We].state = p.default.ALLOW_LOAD, re = null;
                      }, U.get().streaming.abandonLoadTimeout));
                    }
                  }
                }
              }
              function Pe(be) {
                be.mediaType === f.default.VIDEO && (le !== void 0 && x.push(be.streamId, le, pe.getPlaybackQuality()), le = be.newQuality);
              }
              function ke(be) {
                be.metric === p.default.HTTP_REQUEST && be.value && be.value.type === E.HTTPRequest.MEDIA_SEGMENT_TYPE && (be.mediaType === f.default.AUDIO || be.mediaType === f.default.VIDEO) && P.push(be.mediaType, be.value, U.get().streaming.abr.useDeadTimeLatency), be.metric === p.default.BUFFER_LEVEL && (be.mediaType === f.default.AUDIO || be.mediaType === f.default.VIDEO) && Be(be.mediaType, 1e-3 * be.value.level);
              }
              function De(be, We) {
                try {
                  var et;
                  return ae[We] = ae[We] || {}, ae[We].hasOwnProperty(be) || (ae[We][be] = 0), et = it(be, We), et = Ne(et, be, We), et = He(et, be, We), U.get().streaming.cmsd.enabled && U.get().streaming.cmsd.abr.applyMb && (et = rt(et, be, We)), et;
                } catch {
                  return;
                }
              }
              function Ae(be, We) {
                try {
                  return Xe(be, We);
                } catch {
                  return;
                }
              }
              function Ie(be, We) {
                try {
                  var et = he.getAbrBitrateParameter("maxBitrate", be);
                  return et > -1 ? me($[We][be].getMediaInfo(), et, We) : void 0;
                } catch {
                  return;
                }
              }
              function Xe(be, We) {
                try {
                  var et = he.getAbrBitrateParameter("minBitrate", be);
                  if (et > -1) {
                    var _t = $[We][be].getMediaInfo(), ht = Me(_t), St = me(_t, et, We);
                    return ht[St] && St < ht.length - 1 && ht[St].bitrate < et * 1e3 && St++, St;
                  } else
                    return;
                } catch {
                  return;
                }
              }
              function it(be, We) {
                var et = ae[We][be], _t = et;
                if (!$[We] || !$[We][be])
                  return _t;
                var ht = Ae(be, We);
                ht !== void 0 && (_t = Math.max(et, ht));
                var St = Ie(be, We);
                return St !== void 0 && (_t = Math.min(_t, St)), _t;
              }
              function rt(be, We, et) {
                if (We !== "video")
                  return be;
                var _t = ee.getMaxBitrate(We);
                if (_t < 0)
                  return be;
                var ht = Te(et, "audio", pt("audio", et));
                _t -= ht ? ht.bitrate / 1e3 : 0;
                var St = me($[et][We].getMediaInfo(), _t, et);
                return Y.debug("Stream ID: " + et + " [" + We + "] Apply max bit rate from CMSD: " + _t), Math.min(be, St);
              }
              function Ne(be, We, et) {
                var _t = ae[et][We], ht = U.get().streaming.abr.maxRepresentationRatio[We];
                return isNaN(ht) || ht >= 1 || ht < 0 ? be : Math.min(be, Math.round(_t * ht));
              }
              function He(be, We, et) {
                if (We !== f.default.VIDEO || !U.get().streaming.abr.limitBitrateByPortal || !$[et] || !$[et][We])
                  return be;
                ce || Mt();
                var _t = $[et][We].getStreamInfo(), ht = de.getAdaptationForType(_t.index, We, _t).Representation_asArray, St = be;
                if (z > 0 && oe > 0) {
                  for (; St > 0 && ht[St] && z < ht[St].width && z - ht[St - 1].width < ht[St].width - z; )
                    St = St - 1;
                  for (; St < ht.length - 1 && ht[St].width === ht[St + 1].width; )
                    St = St + 1;
                }
                return St;
              }
              function $e(be) {
                var We = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                if (We || (We = J.getActiveStreamInfo().id), be && $ && $[We] && $[We][be]) {
                  var et = De(be, We), _t = Me($[We][be].getMediaInfo());
                  return _t[et] ? _t[et] : null;
                }
                return null;
              }
              function nt(be, We) {
                if (Ee(), be === f.default.TEXT)
                  return NaN;
                var et = te.getSavedBitrateSettings(be), _t = he.getAbrBitrateParameter("initialBitrate", be), ht = U.get().streaming.abr.initialRepresentationRatio[be];
                if (_t === -1)
                  if (ht > -1) {
                    var St = $[We][be].getStreamInfo(), kt = de.getAdaptationForType(St.index, be, St).Representation_asArray;
                    if (Array.isArray(kt)) {
                      var Qt = Math.max(Math.round(kt.length * ht) - 1, 0);
                      _t = kt[Qt].bandwidth / 1e3;
                    } else
                      _t = 0;
                  } else
                    isNaN(et) ? _t = be === f.default.VIDEO ? O : D : _t = et;
                return _t;
              }
              function ut(be, We) {
                try {
                  if (!be || !$ || !$[We] || !$[We][be])
                    return !1;
                  if (x) {
                    var et = pe.getPlaybackQuality();
                    et && x.push(We, le, et);
                  }
                  if (!U.get().streaming.abr.autoSwitchBitrate[be])
                    return !1;
                  var _t = pt(be, We), ht = (0, b.default)(F).create({
                    abrController: Z,
                    switchHistory: ne[We][be],
                    droppedFramesHistory: x,
                    streamProcessor: $[We][be],
                    currentValue: _t,
                    useBufferOccupancyABR: B[be],
                    useL2AABR: W[be],
                    useLoLPABR: X[be],
                    videoModel: pe
                  }), St = Ae(be, We), kt = De(be, We), Qt = j.getMaxQuality(ht), tn = Qt.quality;
                  return St !== void 0 && (tn > S.default.NO_CHANGE ? tn : _t) < St && (tn = St), tn > kt && (tn = kt), ne[We][be].push({
                    oldValue: _t,
                    newValue: tn
                  }), tn > S.default.NO_CHANGE && tn !== _t && (ie[We][be].state === p.default.ALLOW_LOAD || tn < _t) ? (Je(be, _t, tn, kt, Qt.reason, We), !0) : !1;
                } catch {
                  return !1;
                }
              }
              function pt(be) {
                var We = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                try {
                  if (We || (We = J.getActiveStreamInfo().id), be && $[We] && $[We][be]) {
                    var et;
                    if (We)
                      return G[We] = G[We] || {}, G[We].hasOwnProperty(be) || (G[We][be] = M), et = G[We][be], et;
                  }
                  return M;
                } catch {
                  return M;
                }
              }
              function vt(be, We, et) {
                var _t = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
                if (!(!We || !We.id || !be)) {
                  var ht = We.id, St = pt(be, ht);
                  (0, L.checkInteger)(et);
                  var kt = De(be, ht);
                  et !== St && et >= 0 && et <= kt && Je(be, St, et, kt, _t, ht);
                }
              }
              function Ut(be, We) {
                return ie[be] && ie[be][We] ? ie[be][We].state : null;
              }
              function Je(be, We, et, _t, ht, St) {
                if (be && $[St] && $[St][be]) {
                  var kt = $[St][be].getStreamInfo(), Qt = kt && kt.manifestInfo && kt.manifestInfo.isDynamic, tn = K.getCurrentBufferLevel(be);
                  Y.info("Stream ID: " + St + " [" + be + "] switch from " + We + " to " + et + "/" + _t + " (buffer: " + tn + ") " + (ht ? JSON.stringify(ht) : ".")), G[St] = G[St] || {}, G[St][be] = et;
                  var ye = Te(St, be, et);
                  H.trigger(m.default.QUALITY_CHANGE_REQUESTED, {
                    oldQuality: We,
                    newQuality: et,
                    reason: ht,
                    streamInfo: kt,
                    bitrateInfo: ye,
                    maxIdx: _t,
                    mediaType: be
                  }, {
                    streamId: kt.id,
                    mediaType: be
                  });
                  var ze = P.getAverageThroughput(be, Qt);
                  isNaN(ze) || te.setSavedBitrateSettings(be, ze);
                }
              }
              function Te(be, We, et) {
                if (We && $ && $[be] && $[be][We]) {
                  var _t = Me($[be][We].getMediaInfo());
                  return _t[et] ? _t[et] : null;
                }
                return null;
              }
              function me(be, We, et) {
                var _t = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, ht = be && be.type ? $[et][be.type].getRepresentationInfo() : null;
                if (U.get().streaming.abr.useDeadTimeLatency && _t && ht && ht.fragmentDuration) {
                  _t = _t / 1e3;
                  var St = ht.fragmentDuration;
                  if (_t > St)
                    return 0;
                  var kt = _t / St;
                  We = We * (1 - kt);
                }
                for (var Qt = Me(be), tn = Qt.length - 1; tn >= 0; tn--) {
                  var ye = Qt[tn];
                  if (We * 1e3 >= ye.bitrate)
                    return tn;
                }
                return M;
              }
              function Me(be) {
                var We = [];
                if (!be || !be.bitrateList)
                  return We;
                for (var et = be.bitrateList, _t = be.type, ht, St = 0, kt = et.length; St < kt; St++)
                  ht = new d.default(), ht.mediaType = _t, ht.qualityIndex = St, ht.bitrate = et[St].bandwidth, ht.width = et[St].width, ht.height = et[St].height, ht.scanType = et[St].scanType, We.push(ht);
                return We;
              }
              function Be(be, We) {
                var et = U.get().streaming.abr.ABRStrategy;
                et === f.default.ABR_STRATEGY_DYNAMIC && Fe(be, We);
              }
              function Fe(be, We) {
                try {
                  var et = he.getStableBufferTime(), _t = et, ht = 0.5 * et, St = B[be], kt = We > (St ? ht : _t);
                  B[be] = kt, kt !== St && (kt ? Y.info("[" + be + "] switching from throughput to buffer occupancy ABR rule (buffer: " + We.toFixed(3) + ").") : Y.info("[" + be + "] switching from buffer occupancy to throughput ABR rule (buffer: " + We.toFixed(3) + ")."));
                } catch (Qt) {
                  Y.error(Qt);
                }
              }
              function Ze() {
                return P;
              }
              function ot(be) {
                var We = be.type, et = be.streamInfo.id, _t = be.representationCount - 1;
                return ae[et] = ae[et] || {}, ae[et][We] = _t, _t;
              }
              function tt(be) {
                var We = be ? be.id : null, et = pt(f.default.AUDIO, We), _t = pt(f.default.VIDEO, We), ht = et === De(f.default.AUDIO, We) && _t === De(f.default.VIDEO, We);
                return ht;
              }
              function gt(be) {
                ce = be;
              }
              function Mt() {
                if (pe) {
                  var be = U.get().streaming.abr.usePixelRatioInLimitBitrateByPortal && window.hasOwnProperty("devicePixelRatio"), We = be ? window.devicePixelRatio : 1;
                  z = pe.getClientWidth() * We, oe = pe.getClientHeight() * We;
                }
              }
              function xt(be) {
                x && x.clearForStream(be), $[be] && delete $[be], ne[be] && delete ne[be], ie[be] && delete ie[be];
              }
              return Z = {
                initialize: Q,
                isPlayingAtTopQuality: tt,
                updateTopQualityIndex: ot,
                clearDataForStream: xt,
                getThroughputHistory: Ze,
                getBitrateList: Me,
                getQualityForBitrate: me,
                getTopBitrateInfoFor: $e,
                getMinAllowedIndexFor: Ae,
                getMaxAllowedIndexFor: De,
                getInitialBitrateFor: nt,
                getQualityFor: pt,
                getAbandonmentStateFor: Ut,
                setPlaybackQuality: vt,
                checkPlaybackQuality: ut,
                setElementSize: Mt,
                setWindowResizeEventCalled: gt,
                registerStreamType: fe,
                unRegisterStreamType: q,
                setConfig: Ce,
                reset: ge
              }, V(), Z;
            }
            C.__dashjs_factory_name = "AbrController";
            var I = A.default.getSingletonFactory(C);
            I.QUALITY_DEFAULT = M, A.default.updateSingletonFactory(C.__dashjs_factory_name, I);
            const w = I;
          }
        ),
        /***/
        "./src/streaming/controllers/BaseURLController.js": (
          /*!********************************************************!*\
            !*** ./src/streaming/controllers/BaseURLController.js ***!
            \********************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => b
              /* harmony export */
            });
            var h = i(
              /*! ../models/BaseURLTreeModel */
              "./src/streaming/models/BaseURLTreeModel.js"
            ), f = i(
              /*! ../utils/BaseURLSelector */
              "./src/streaming/utils/BaseURLSelector.js"
            ), p = i(
              /*! ../utils/URLUtils */
              "./src/streaming/utils/URLUtils.js"
            ), d = i(
              /*! ../../dash/vo/BaseURL */
              "./src/dash/vo/BaseURL.js"
            ), v = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), g = i(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), m = i(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            );
            function A() {
              var S, N, T = this.context, R = (0, g.default)(T).getInstance(), y = (0, p.default)(T).getInstance(), E, L;
              function _(F) {
                E.invalidateSelectedIndexes(F.entry);
              }
              function O() {
                E = (0, h.default)(T).create(), L = (0, f.default)(T).create(), R.on(m.default.SERVICE_LOCATION_BLACKLIST_CHANGED, _, S);
              }
              function D(F) {
                F.baseURLTreeModel && (E = F.baseURLTreeModel), F.baseURLSelector && (L = F.baseURLSelector), F.adapter && (N = F.adapter);
              }
              function M(F) {
                E.update(F), L.chooseSelector(N.getIsDVB(F));
              }
              function C(F) {
                var k = E.getForPath(F), H = k.reduce(function(Z, Y) {
                  var j = L.select(Y);
                  if (j)
                    y.isRelative(j.url) ? Z.url = y.resolve(j.url, Z.url) : (Z.url = j.url, Z.serviceLocation = j.serviceLocation), Z.availabilityTimeOffset = j.availabilityTimeOffset, Z.availabilityTimeComplete = j.availabilityTimeComplete;
                  else
                    return new d.default();
                  return Z;
                }, new d.default());
                if (!y.isRelative(H.url))
                  return H;
              }
              function I() {
                E.reset(), L.reset();
              }
              function w(F) {
                E.setConfig({
                  adapter: N
                }), M(F);
              }
              return S = {
                reset: I,
                initialize: w,
                resolve: C,
                setConfig: D
              }, O(), S;
            }
            A.__dashjs_factory_name = "BaseURLController";
            const b = v.default.getClassFactory(A);
          }
        ),
        /***/
        "./src/streaming/controllers/BlacklistController.js": (
          /*!**********************************************************!*\
            !*** ./src/streaming/controllers/BlacklistController.js ***!
            \**********************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => d
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            );
            function p(v) {
              v = v || {};
              var g, m = [], A = (0, f.default)(this.context).getInstance(), b = v.updateEventName, S = v.addBlacklistEventName;
              function N(L) {
                return !m.length || !L || !L.length ? !1 : m.indexOf(L) !== -1;
              }
              function T(L) {
                m.indexOf(L) === -1 && (m.push(L), A.trigger(b, {
                  entry: L
                }));
              }
              function R(L) {
                T(L.entry);
              }
              function y() {
                S && A.on(S, R, g);
              }
              function E() {
                m = [];
              }
              return g = {
                add: T,
                contains: N,
                reset: E
              }, y(), g;
            }
            p.__dashjs_factory_name = "BlackListController";
            const d = h.default.getClassFactory(p);
          }
        ),
        /***/
        "./src/streaming/controllers/BufferController.js": (
          /*!*******************************************************!*\
            !*** ./src/streaming/controllers/BufferController.js ***!
            \*******************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => M
              /* harmony export */
            });
            var h = i(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), f = i(
              /*! ../constants/MetricsConstants */
              "./src/streaming/constants/MetricsConstants.js"
            ), p = i(
              /*! ../models/FragmentModel */
              "./src/streaming/models/FragmentModel.js"
            ), d = i(
              /*! ../SourceBufferSink */
              "./src/streaming/SourceBufferSink.js"
            ), v = i(
              /*! ../PreBufferSink */
              "./src/streaming/PreBufferSink.js"
            ), g = i(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), m = i(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), A = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), b = i(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), S = i(
              /*! ../utils/InitCache */
              "./src/streaming/utils/InitCache.js"
            ), N = i(
              /*! ../vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), T = i(
              /*! ../../core/errors/Errors */
              "./src/core/errors/Errors.js"
            ), R = i(
              /*! ../vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            ), y = i(
              /*! ../../streaming/MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), E = 0.5, L = 0.01, _ = 22, O = "BufferController";
            function D(C) {
              C = C || {};
              var I = this.context, w = (0, g.default)(I).getInstance(), F = C.errHandler, k = C.fragmentModel, H = C.representationController, Z = C.adapter, Y = C.textController, j = C.abrController, J = C.playbackController, ae = C.streamInfo, G = C.type, $ = C.settings, ie, re, ce, z, oe, de, pe, he, se, ee, te, le, ne, x, P, B, W, X, K, U;
              function V() {
                re = (0, b.default)(I).getInstance().getLogger(ie), W = (0, S.default)(I).getInstance(), Rt();
              }
              function Q(we) {
                _e(we), w.on(m.default.INIT_FRAGMENT_LOADED, De, ie), w.on(m.default.MEDIA_FRAGMENT_LOADED, Ie, ie), w.on(m.default.WALLCLOCK_TIME_UPDATED, ye, ie), w.on(y.default.PLAYBACK_PLAYING, Be, ie), w.on(y.default.PLAYBACK_PROGRESS, me, ie), w.on(y.default.PLAYBACK_TIME_UPDATED, me, ie), w.on(y.default.PLAYBACK_RATE_CHANGED, ze, ie), w.on(y.default.PLAYBACK_STALLED, Me, ie);
              }
              function fe() {
                return ae.id;
              }
              function ue() {
                return G;
              }
              function q() {
                return O;
              }
              function _e(we) {
                var Ve = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                return new Promise(function(Se, Ge) {
                  de = we, se && Ve && typeof se.discharge == "function" ? (ee = se, Ce(Ve).then(function() {
                    Se();
                  }).catch(function(ct) {
                    Ge(ct);
                  })) : Se();
                });
              }
              function ge(we) {
                return Z.convertRepresentationToRepresentationInfo(H.getRepresentationForQuality(we));
              }
              function Ce(we) {
                var Ve = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
                return new Promise(function(Se, Ge) {
                  if (!W || !we) {
                    Se(null);
                    return;
                  }
                  de ? Re(we, Ve).then(function(ct) {
                    Se(ct);
                  }).catch(function(ct) {
                    Ge(ct);
                  }) : Ee().then(function(ct) {
                    Se(ct);
                  }).catch(function(ct) {
                    Ge(ct);
                  });
                });
              }
              function Ee() {
                var we = this;
                return new Promise(function(Ve, Se) {
                  var Ge = j.getQualityFor(G, ae.id);
                  se = (0, v.default)(I).create(rt.bind(we)), kt(ge(Ge)).then(function() {
                    Ve(se);
                  }).catch(function() {
                    Se();
                  });
                });
              }
              function Re(we, Ve) {
                return new Promise(function(Se, Ge) {
                  var ct = j.getQualityFor(G, ae.id);
                  se = (0, d.default)(I).create({
                    mediaSource: de,
                    textController: Y,
                    eventBus: w
                  }), Pe(we, Ve, ct).then(function() {
                    return kt(ge(ct));
                  }).then(function() {
                    Se(se);
                  }).catch(function(Ot) {
                    re.fatal("Caught error on create SourceBuffer: " + Ot), F.error(new N.default(T.default.MEDIASOURCE_TYPE_UNSUPPORTED_CODE, T.default.MEDIASOURCE_TYPE_UNSUPPORTED_MESSAGE + G)), Ge(Ot);
                  });
                });
              }
              function Pe(we, Ve, Se) {
                var Ge = ge(Se);
                return Ve && Ve[G] && (G === h.default.VIDEO || G === h.default.AUDIO) ? se.initializeForStreamSwitch(we, Ge, Ve[G]) : se.initializeForFirstUse(ae, we, Ge);
              }
              function ke() {
                if (se && ee && typeof ee.discharge == "function") {
                  var we = ee.getAllBufferRanges();
                  if (we.length > 0) {
                    for (var Ve = "Beginning " + G + "PreBuffer discharge, adding buffer for:", Se = 0; Se < we.length; Se++)
                      Ve += " start: " + we.start(Se) + ", end: " + we.end(Se) + ";";
                    re.debug(Ve);
                  } else
                    re.debug("PreBuffer discharge requested, but there were no media segments in the PreBuffer.");
                  te = [];
                  for (var Ge = ee.discharge(), ct = null, Ot = 0; Ot < Ge.length; Ot++) {
                    var wt = Ge[Ot];
                    if (wt.segmentType !== R.HTTPRequest.INIT_SEGMENT_TYPE) {
                      var Xt = W.extract(wt.streamId, wt.representationId);
                      Xt && ct !== Xt && (te.push(Xt), se.append(Xt), ct = Xt);
                    }
                    te.push(wt), se.append(wt);
                  }
                  ee.reset(), ee = null;
                }
              }
              function De(we) {
                $.get().streaming.cacheInitSegments && (re.info("Init fragment finished loading saving to", G + "'s init cache"), W.save(we.chunk)), re.debug("Append Init fragment", G, " with representationId:", we.chunk.representationId, " and quality:", we.chunk.quality, ", data size:", we.chunk.bytes.byteLength), Xe(we.chunk);
              }
              function Ae(we) {
                var Ve = W.extract(ae.id, we);
                return Ve ? (re.info("Append Init fragment", G, " with representationId:", Ve.representationId, " and quality:", Ve.quality, ", data size:", Ve.bytes.byteLength), Xe(Ve), !0) : !1;
              }
              function Ie(we) {
                Xe(we.chunk, we.request);
              }
              function Xe(we) {
                var Ve = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                se.append(we, Ve).then(function(Se) {
                  rt(Se);
                }).catch(function(Se) {
                  rt(Se);
                }), we.mediaInfo.type === h.default.VIDEO && qe(m.default.VIDEO_CHUNK_RECEIVED, {
                  chunk: we
                });
              }
              function it(we) {
                if (we && we.length > 0)
                  for (var Ve = 0, Se = we.length; Ve < Se; Ve++)
                    re.debug("Buffered range: " + we.start(Ve) + " - " + we.end(Ve) + ", currentTime = ", J.getTime());
              }
              function rt(we) {
                if (we.error) {
                  we.error.code === _ && He(), (we.error.code === _ || !mn()) && (re.warn("Clearing playback buffer to overcome quota exceed situation"), qe(m.default.QUOTA_EXCEEDED, {
                    criticalBufferLevel: oe,
                    quotaExceededTime: we.chunk.start
                  }), et(We()));
                  return;
                }
                if (se && (tt(), B = !1, ne = we.chunk, !(!ne || !ne.endFragment))) {
                  ne && !isNaN(ne.index) && (pe = Math.max(ne.index, pe), gt());
                  var Ve = se.getAllBufferRanges();
                  ne.segmentType === R.HTTPRequest.MEDIA_SEGMENT_TYPE && (it(Ve), me(), Ne());
                  var Se = !1;
                  te && (te.indexOf(ne) > 0 && (Se = !0), te = null), ne && !Se && qe(m.default.BYTES_APPENDED_END_FRAGMENT, {
                    quality: ne.quality,
                    startTime: ne.start,
                    index: ne.index,
                    bufferedRanges: Ve,
                    segmentType: ne.segmentType,
                    mediaType: G
                  });
                }
              }
              function Ne() {
                if (!isNaN(U)) {
                  if (G !== h.default.AUDIO && G !== h.default.VIDEO) {
                    U = NaN;
                    return;
                  }
                  var we = J.getTime(), Ve = Ze(we, 0), Se = Ze(U, 0);
                  if (Ve && Se && Ve.start === Se.start) {
                    U = NaN;
                    return;
                  }
                  var Ge = H.getCurrentRepresentation().segmentDuration, ct = Ze(U, Ge);
                  ct && ($.get().streaming.buffer.enableSeekDecorrelationFix && Math.abs(we - U) > Ge ? U <= ct.end && J.seek(Math.max(U, ct.start), !1, !0) : we < ct.start && J.seek(ct.start, !1, !0));
                }
              }
              function He() {
                if (B = !0, oe = It() * 0.8, re.warn("Quota exceeded, Critical Buffer: " + oe), oe > 0) {
                  var we = Math.max(0.2 * oe, 1), Ve = oe - we, Se = Math.min($.get().streaming.buffer.bufferTimeAtTopQuality, Ve * 0.9), Ge = Math.min($.get().streaming.buffer.bufferTimeAtTopQualityLongForm, Ve * 0.9), ct = {
                    streaming: {
                      buffer: {
                        bufferToKeep: parseFloat(we.toFixed(5)),
                        bufferTimeAtTopQuality: parseFloat(Se.toFixed(5)),
                        bufferTimeAtTopQualityLongForm: parseFloat(Ge.toFixed(5))
                      }
                    }
                  };
                  $.update(ct);
                }
              }
              function $e() {
                return ce && Et(!1), se.abort();
              }
              function nt(we) {
                return new Promise(function(Ve, Se) {
                  se.abort().then(function() {
                    return Qt();
                  }).then(function() {
                    return $.get().streaming.buffer.useChangeTypeForTrackSwitch ? se.changeType(we) : Promise.resolve();
                  }).then(function() {
                    return vt();
                  }).then(function() {
                    Et(!1), Ve();
                  }).catch(function(Ge) {
                    Se(Ge);
                  });
                });
              }
              function ut() {
                return new Promise(function(we, Ve) {
                  se.abort().then(function() {
                    return Qt();
                  }).then(function() {
                    return vt();
                  }).then(function() {
                    Et(!1), we();
                  }).catch(function(Se) {
                    Ve(Se);
                  });
                });
              }
              function pt(we) {
                return new Promise(function(Ve, Se) {
                  Qt().then(function() {
                    return $.get().streaming.buffer.useChangeTypeForTrackSwitch ? se.changeType(we) : Promise.resolve();
                  }).then(function() {
                    Ve();
                  }).catch(function(Ge) {
                    Se(Ge);
                  });
                });
              }
              function vt() {
                return new Promise(function(we, Ve) {
                  var Se = Ut();
                  if (!Se || Se.length === 0) {
                    me(), we();
                    return;
                  }
                  et(Se).then(function() {
                    we();
                  }).catch(function(Ge) {
                    Ve(Ge);
                  });
                });
              }
              function Ut(we) {
                var Ve = [], Se = se.getAllBufferRanges();
                if (!Se || Se.length === 0)
                  return Ve;
                if (!we && we !== 0 || isNaN(we))
                  Ve.push({
                    start: Se.start(0),
                    end: Se.end(Se.length - 1) + E
                  });
                else {
                  var Ge = Je(we, Se), ct = Te(we, Se);
                  Ge && Ve.push(Ge), ct && Ve.push(ct);
                }
                return Ve;
              }
              function Je(we, Ve) {
                var Se = $.get().streaming.buffer.bufferToKeep, Ge = Ve.start(0), ct = we - Ge;
                if (ct > Se) {
                  var Ot = Math.max(0, we - Se), wt = k.getRequests({
                    state: p.default.FRAGMENT_MODEL_EXECUTED,
                    time: we,
                    threshold: L
                  })[0];
                  if (wt && (Ot = Math.min(wt.startTime, Ot)), Ot > 0)
                    return {
                      start: Ge,
                      end: Ot
                    };
                }
                return null;
              }
              function Te(we, Ve) {
                var Se = Ve.end(Ve.length - 1) + E, Ge = Pt(we), ct = ae.manifestInfo.duration >= $.get().streaming.buffer.longFormContentDurationThreshold, Ot = ct ? $.get().streaming.buffer.bufferTimeAtTopQualityLongForm : $.get().streaming.buffer.bufferTimeAtTopQuality, wt = isNaN(Ge) ? we : Math.min(Ge, we + Ot);
                if (wt >= Ve.end(Ve.length - 1))
                  return null;
                var Xt = k.getRequests({
                  state: p.default.FRAGMENT_MODEL_EXECUTED,
                  time: we,
                  threshold: L
                })[0];
                Xt && (wt = Math.max(Xt.startTime + Xt.duration, wt));
                var nn = $.get().streaming.buffer.avoidCurrentTimeRangePruning;
                if (nn) {
                  for (var Yt = 0; Yt < Ve.length; Yt++)
                    if (Ve.start(Yt) <= we && we <= Ve.end(Yt) && Ve.start(Yt) <= wt && wt <= Ve.end(Yt)) {
                      var Dn = wt;
                      Yt + 1 < Ve.length ? wt = Ve.start(Yt + 1) : wt = Ve.end(Yt) + 1, re.debug("Buffered range [" + Ve.start(Yt) + ", " + Ve.end(Yt) + "] overlaps with targetTime " + we + " and range to be pruned [" + Dn + ", " + Se + "], using [" + wt + ", " + Se + "] instead" + (wt < Se ? "" : " (no actual pruning)"));
                      break;
                    }
                }
                return wt < Ve.end(Ve.length - 1) ? {
                  start: wt,
                  end: Se
                } : null;
              }
              function me() {
                (!K || G === h.default.TEXT && Y.isTextEnabled()) && tt();
              }
              function Me() {
                Mt();
              }
              function Be() {
                Mt(), U = NaN;
              }
              function Fe(we) {
                try {
                  var Ve = se.getAllBufferRanges();
                  if (!Ve || Ve.length === 0)
                    return !1;
                  for (var Se = 0; Se < Ve.length; ) {
                    var Ge = Ve.start(Se), ct = Ve.end(Se);
                    if (we >= Ge && we <= ct)
                      return !0;
                    Se += 1;
                  }
                  return !1;
                } catch (Ot) {
                  return re.error(Ot), !1;
                }
              }
              function Ze(we, Ve) {
                var Se = se.getAllBufferRanges(), Ge = 0, ct = 0, Ot = null, wt = null, Xt = 0, nn, Yt, Dn = isNaN(Ve) ? 0.15 : Ve;
                if (Se != null) {
                  for (Yt = 0, nn = Se.length; Yt < nn; Yt++)
                    if (Ge = Se.start(Yt), ct = Se.end(Yt), Ot === null)
                      Xt = Math.abs(Ge - we), (we >= Ge && we < ct || Xt <= Dn) && (Ot = Ge, wt = ct);
                    else if (Xt = Ge - wt, Xt <= Dn)
                      wt = ct;
                    else
                      break;
                  if (Ot !== null)
                    return {
                      start: Ot,
                      end: wt
                    };
                }
                return null;
              }
              function ot(we, Ve) {
                var Se, Ge;
                return $.get().streaming.gaps.jumpGaps && (Ve = $.get().streaming.gaps.smallGapLimit), Se = Ze(we, Ve), Se === null ? Ge = 0 : Ge = Se.end - we, Ge;
              }
              function tt() {
                if (J) {
                  var we = $.get().streaming.gaps.jumpGaps && !isNaN($.get().streaming.gaps.smallGapLimit) ? $.get().streaming.gaps.smallGapLimit : NaN;
                  z = Math.max(ot(J.getTime() || 0, we), 0), qe(m.default.BUFFER_LEVEL_UPDATED, {
                    mediaType: G,
                    bufferLevel: z
                  }), Mt();
                }
              }
              function gt() {
                var we = pe >= he - 1, Ve = J.getTimeToStreamEnd(ae) - z < 1e-5;
                (we || Ve) && !ce && (Et(!0), re.debug("checkIfBufferingCompleted trigger BUFFERING_COMPLETED for stream id ".concat(ae.id, " and type ").concat(G)));
              }
              function Mt() {
                G !== h.default.AUDIO && G !== h.default.VIDEO || ((!J.getLowLatencyModeEnabled() && z < $.get().streaming.buffer.stallThreshold || z === 0) && !ce ? xt(f.default.BUFFER_EMPTY) : (ce || z >= $.get().streaming.buffer.stallThreshold || J.getLowLatencyModeEnabled() && z > 0) && xt(f.default.BUFFER_LOADED));
              }
              function xt(we) {
                le === we || we === f.default.BUFFER_EMPTY && J.getTime() === 0 || // Don't trigger BUFFER_EMPTY if it's initial loading
                G === h.default.TEXT && !Y.isTextEnabled() || (le = we, qe(m.default.BUFFER_LEVEL_STATE_CHANGED, {
                  state: we
                }), qe(we === f.default.BUFFER_LOADED ? m.default.BUFFER_LOADED : m.default.BUFFER_EMPTY), re.debug(we === f.default.BUFFER_LOADED ? "Got enough buffer to start" : "Waiting for more buffer before starting playback"));
              }
              function be() {
                !se || G === h.default.TEXT || ce || et(We());
              }
              function We() {
                var we = [], Ve = se.getAllBufferRanges();
                if (!Ve || Ve.length === 0)
                  return we;
                var Se = J.getTime(), Ge = Math.max(0, Se - $.get().streaming.buffer.bufferToKeep), ct = k.getRequests({
                  state: p.default.FRAGMENT_MODEL_EXECUTED,
                  time: Se,
                  threshold: L
                })[0];
                if (ct)
                  Ge = Math.min(ct.startTime, Ge);
                else if (Se === 0 && J.getIsDynamic())
                  return [];
                if (Ve.start(0) <= Ge) {
                  for (var Ot = {
                    start: 0,
                    end: Ge
                  }, wt = 0; wt < Ve.length && Ve.end(wt) <= Ge; wt++)
                    Ot.end = Ve.end(wt);
                  Ot.start < Ot.end && we.push(Ot);
                }
                return we;
              }
              function et(we) {
                return new Promise(function(Ve, Se) {
                  if (!we || !se || we.length === 0) {
                    Ve();
                    return;
                  }
                  var Ge = [];
                  we.forEach(function(ct) {
                    Ge.push(_t(ct));
                  }), P || ht(), Promise.all(Ge).then(function() {
                    Ve();
                  }).catch(function(ct) {
                    Se(ct);
                  });
                });
              }
              function _t(we) {
                return new Promise(function(Ve, Se) {
                  we.resolve = Ve, we.reject = Se, X.push(we);
                });
              }
              function ht() {
                try {
                  if (X.length === 0 || !se) {
                    re.debug("Nothing to prune, halt pruning"), X = [], P = !1;
                    return;
                  }
                  var we = se.getBuffer();
                  if (!we || !we.buffered || we.buffered.length === 0) {
                    re.debug("SourceBuffer is empty (or does not exist), halt pruning"), X = [], P = !1;
                    return;
                  }
                  var Ve = X.shift();
                  re.debug("".concat(G, ": Removing buffer from: ").concat(Ve.start, " to ").concat(Ve.end)), P = !0;
                  var Se = J.getTime();
                  Se < Ve.end && Et(!1), se.remove(Ve).then(function(Ge) {
                    St(Ge);
                  }).catch(function(Ge) {
                    St(Ge);
                  });
                } catch {
                  P = !1;
                }
              }
              function St(we) {
                re.debug("onRemoved buffer from:", we.from, "to", we.to);
                var Ve = se.getAllBufferRanges();
                it(Ve), X.length === 0 && (P = !1, tt()), we.unintended && (re.warn("Detected unintended removal from:", we.from, "to", we.to, "setting streamprocessor time to", we.from), qe(m.default.SEEK_TARGET, {
                  time: we.from
                })), P ? ht() : (K ? K = !1 : tt(), qe(m.default.BUFFER_CLEARED, {
                  from: we.from,
                  to: we.to,
                  unintended: we.unintended,
                  hasEnoughSpaceToAppend: mn(),
                  quotaExceeded: B
                }));
              }
              function kt(we) {
                return new Promise(function(Ve) {
                  if (!we || we.MSETimeOffset === void 0 || !se || !se.updateTimestampOffset) {
                    Ve();
                    return;
                  }
                  se.updateTimestampOffset(we.MSETimeOffset).then(function() {
                    Ve();
                  }).catch(function() {
                    Ve();
                  });
                });
              }
              function Qt() {
                return se && !ce ? se.updateAppendWindow(ae) : Promise.resolve();
              }
              function tn(we) {
                isNaN(we) || (he = we, gt());
              }
              function ye() {
                x++;
                var we = x * ($.get().streaming.wallclockTimeUpdateInterval / 1e3);
                we >= $.get().streaming.buffer.bufferPruningInterval && (x = 0, be());
              }
              function ze() {
                Mt();
              }
              function ft() {
                return se;
              }
              function Le() {
                return z;
              }
              function Ke() {
                return de;
              }
              function Qe() {
                return ce;
              }
              function Et(we) {
                ce !== we && (ce = we, ce ? qe(m.default.BUFFERING_COMPLETED) : he = Number.POSITIVE_INFINITY);
              }
              function Vt() {
                return P;
              }
              function It() {
                try {
                  var we = se.getAllBufferRanges(), Ve = 0, Se, Ge;
                  if (!we)
                    return Ve;
                  for (Ge = 0, Se = we.length; Ge < Se; Ge++)
                    Ve += we.end(Ge) - we.start(Ge);
                  return Ve;
                } catch {
                  return 0;
                }
              }
              function Pt(we) {
                try {
                  var Ve = we, Se = se.getAllBufferRanges();
                  if (!Se || Se.length === 0)
                    return NaN;
                  for (var Ge = 0; Ve === we && Ge < Se.length; ) {
                    var ct = Se.start(Ge), Ot = Se.end(Ge);
                    Ve >= ct && Ve <= Ot && (Ve = Ot), Ge += 1;
                  }
                  return Ve === we ? NaN : Ve;
                } catch {
                }
              }
              function mn() {
                var we = It();
                return isNaN(we) || we < oe;
              }
              function Jt(we) {
                U = we;
              }
              function qe(we, Ve) {
                var Se = Ve || {};
                w.trigger(we, Se, {
                  streamId: ae.id,
                  mediaType: G
                });
              }
              function Rt(we, Ve) {
                if (oe = Number.POSITIVE_INFINITY, le = void 0, he = Number.POSITIVE_INFINITY, pe = 0, ne = null, ce = !1, P = !1, B = !1, z = 0, x = 0, X = [], U = NaN, se) {
                  var Se = se;
                  se = null, !we && !Ve && Se.abort().then(function() {
                    Se.reset(Ve), Se = null;
                  });
                }
                K = !1;
              }
              function bt(we, Ve) {
                w.off(m.default.INIT_FRAGMENT_LOADED, De, this), w.off(m.default.MEDIA_FRAGMENT_LOADED, Ie, this), w.off(m.default.WALLCLOCK_TIME_UPDATED, ye, this), w.off(y.default.PLAYBACK_PLAYING, Be, this), w.off(y.default.PLAYBACK_PROGRESS, me, this), w.off(y.default.PLAYBACK_TIME_UPDATED, me, this), w.off(y.default.PLAYBACK_RATE_CHANGED, ze, this), w.off(y.default.PLAYBACK_STALLED, Me, this), Rt(we, Ve);
              }
              return ie = {
                initialize: Q,
                getStreamId: fe,
                getType: ue,
                getBufferControllerType: q,
                createBufferSink: Ce,
                dischargePreBuffer: ke,
                getBuffer: ft,
                getBufferLevel: Le,
                getRangeAt: Ze,
                hasBufferAtTime: Fe,
                pruneBuffer: be,
                setMediaSource: _e,
                getMediaSource: Ke,
                appendInitSegmentFromCache: Ae,
                getIsBufferingCompleted: Qe,
                setIsBufferingCompleted: Et,
                getIsPruningInProgress: Vt,
                reset: bt,
                prepareForPlaybackSeek: $e,
                prepareForReplacementTrackSwitch: nt,
                prepareForNonReplacementTrackSwitch: pt,
                prepareForReplacementQualitySwitch: ut,
                updateAppendWindow: Qt,
                getAllRangesWithSafetyFactor: Ut,
                getContinuousBufferTimeForTargetTime: Pt,
                clearBuffers: et,
                pruneAllSafely: vt,
                updateBufferTimestampOffset: kt,
                setSeekTarget: Jt,
                segmentRequestingCompleted: tn
              }, V(), ie;
            }
            D.__dashjs_factory_name = O;
            const M = A.default.getClassFactory(D);
          }
        ),
        /***/
        "./src/streaming/controllers/CatchupController.js": (
          /*!********************************************************!*\
            !*** ./src/streaming/controllers/CatchupController.js ***!
            \********************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => S
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), p = i(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), d = i(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), v = i(
              /*! ../MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), g = i(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), m = i(
              /*! ../constants/MetricsConstants */
              "./src/streaming/constants/MetricsConstants.js"
            ), A = i(
              /*! ../../core/Utils */
              "./src/core/Utils.js"
            );
            function b() {
              var N = this.context, T = (0, p.default)(N).getInstance(), R, y, E, L, _, O, D, M, C, I;
              function w() {
                k(), ee();
              }
              function F(te) {
                te && (te.settings && (_ = te.settings), te.videoModel && (L = te.videoModel), te.streamController && (O = te.streamController), te.playbackController && (D = te.playbackController), te.mediaPlayerModel && (M = te.mediaPlayerModel));
              }
              function k() {
                T.on(v.default.BUFFER_LEVEL_UPDATED, ae, R), T.on(v.default.BUFFER_LEVEL_STATE_CHANGED, G, R), T.on(v.default.PLAYBACK_PROGRESS, ie, R), T.on(v.default.PLAYBACK_TIME_UPDATED, ie, R), T.on(v.default.PLAYBACK_SEEKED, J, R), T.on(g.default.SETTING_UPDATED_CATCHUP_ENABLED, $, R), T.on(g.default.SETTING_UPDATED_PLAYBACK_RATE_MIN, ee, R), T.on(g.default.SETTING_UPDATED_PLAYBACK_RATE_MAX, ee, R), T.on(v.default.STREAM_INITIALIZED, ee, R);
              }
              function H() {
                T.off(v.default.BUFFER_LEVEL_UPDATED, ae, R), T.off(v.default.BUFFER_LEVEL_STATE_CHANGED, G, R), T.off(v.default.PLAYBACK_PROGRESS, ie, R), T.off(v.default.PLAYBACK_TIME_UPDATED, ie, R), T.off(v.default.PLAYBACK_SEEKED, ie, R), T.off(g.default.SETTING_UPDATED_CATCHUP_ENABLED, $, R), T.off(g.default.SETTING_UPDATED_PLAYBACK_RATE_MIN, ee, R), T.off(g.default.SETTING_UPDATED_PLAYBACK_RATE_MAX, ee, R), T.off(v.default.STREAM_INITIALIZED, ee, R);
              }
              function Z() {
                I = (0, f.default)(N).getInstance().getLogger(R), j();
              }
              function Y() {
                H(), j(), L.setPlaybackRate(1, !0);
              }
              function j() {
                y = !1;
                var te = A.default.parseUserAgent();
                E = te && te.browser && te.browser.name && te.browser.name.toLowerCase() === "safari";
              }
              function J() {
                y = !1;
              }
              function ae(te) {
                if (!(te.streamId !== O.getActiveStreamInfo().id || !C)) {
                  var le = D.getLiveDelay(), ne = D.getBufferLevel();
                  ne > le / 2 && (C = !1);
                }
              }
              function G(te) {
                te.streamId === O.getActiveStreamInfo().id && (C = te.state === m.default.BUFFER_EMPTY);
              }
              function $() {
                M.getCatchupModeEnabled() || L.setPlaybackRate(1);
              }
              function ie() {
                D.getIsDynamic() && M.getCatchupModeEnabled() && (M.getCatchupPlaybackRates().max > 0 || M.getCatchupPlaybackRates().min < 0) && !D.isPaused() && !D.isSeeking() && z() && re();
              }
              function re() {
                if (!y && L) {
                  var te, le = L.getPlaybackRate(), ne = M.getCatchupPlaybackRates(), x = D.getBufferLevel(), P = ce(), B = M.getCatchupMaxDrift();
                  if (!isNaN(B) && B > 0 && P > B)
                    I.info("[CatchupController]: Low Latency catchup mechanism. Latency too high, doing a seek to live point"), y = !0, D.seekToCurrentLive(!0, !1);
                  else {
                    var W = D.getCurrentLiveLatency(), X = D.getLiveDelay();
                    if (oe() === d.default.LIVE_CATCHUP_MODE_LOLP) {
                      var K = _.get().streaming.liveCatchup.playbackBufferMin;
                      te = se(ne, W, X, K, x);
                    } else
                      te = he(ne, W, X, x);
                    var U = E ? 0.25 : 0.02 / (0.5 / ne.max);
                    te && Math.abs(le - te) >= U && (I.debug("[CatchupController]: Setting playback rate to ".concat(te)), L.setPlaybackRate(te));
                  }
                }
              }
              function ce() {
                var te = D.getCurrentLiveLatency(), le = D.getLiveDelay();
                return te - le;
              }
              function z() {
                try {
                  if (!D.getTime() > 0 || y)
                    return !1;
                  var te = oe();
                  if (te === d.default.LIVE_CATCHUP_MODE_LOLP) {
                    var le = D.getBufferLevel(), ne = _.get().streaming.liveCatchup.playbackBufferMin;
                    return pe(le, ne);
                  } else
                    return de();
                } catch {
                  return !1;
                }
              }
              function oe() {
                var te = _.get().streaming.liveCatchup.playbackBufferMin;
                return _.get().streaming.liveCatchup.mode === d.default.LIVE_CATCHUP_MODE_LOLP && te !== null && !isNaN(te) ? d.default.LIVE_CATCHUP_MODE_LOLP : d.default.LIVE_CATCHUP_MODE_DEFAULT;
              }
              function de() {
                try {
                  var te = Math.abs(ce());
                  return te > 0;
                } catch {
                  return !1;
                }
              }
              function pe(te, le) {
                try {
                  var ne = Math.abs(ce());
                  return ne > 0 || te < le;
                } catch {
                  return !1;
                }
              }
              function he(te, le, ne, x) {
                if (C)
                  return 1;
                var P = le - ne, B = P < 0 ? Math.abs(te.min) : te.max, W = P * 5, X = B * 2 / (1 + Math.pow(Math.E, -W)), K = 1 - B + X;
                return D.getPlaybackStalled() && x <= ne / 2 && P > 0 && (K = 1), K;
              }
              function se(te, le, ne, x, P) {
                var B;
                if (P < x) {
                  var W = Math.abs(te.min), X = P - x, K = X * 5, U = W * 2 / (1 + Math.pow(Math.E, -K));
                  B = 1 - W + U, I.debug("[LoL+ playback control_buffer-based] bufferLevel: " + P + ", newRate: " + B);
                } else {
                  var V = te.max, Q = 0.02;
                  if (Math.abs(le - ne) <= Q * ne)
                    B = 1;
                  else {
                    var fe = le - ne, ue = fe * 5, q = V * 2 / (1 + Math.pow(Math.E, -ue));
                    B = 1 - V + q;
                  }
                  I.debug("[LoL+ playback control_latency-based] latency: " + le + ", newRate: " + B);
                }
                return B;
              }
              function ee() {
                M.getCatchupPlaybackRates(!0);
              }
              return R = {
                reset: Y,
                setConfig: F,
                initialize: w
              }, Z(), R;
            }
            b.__dashjs_factory_name = "CatchupController";
            const S = h.default.getSingletonFactory(b);
          }
        ),
        /***/
        "./src/streaming/controllers/EventController.js": (
          /*!******************************************************!*\
            !*** ./src/streaming/controllers/EventController.js ***!
            \******************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => m
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), p = i(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), d = i(
              /*! ../../streaming/MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), v = i(
              /*! ../net/XHRLoader */
              "./src/streaming/net/XHRLoader.js"
            );
            function g() {
              var A = "urn:mpeg:dash:event:2012", b = 1, S = "urn:mpeg:dash:event:callback:2015", N = 1, T = 300, R = {
                DISCARDED: "discarded",
                UPDATED: "updated",
                ADDED: "added"
              }, y = this.context, E = (0, p.default)(y).getInstance(), L, _, O, D, M, C, I, w, F, k, H;
              function Z() {
                _ = (0, f.default)(y).getInstance().getLogger(L), j();
              }
              function Y() {
                if (!I || !w)
                  throw new Error("setConfig function has to be called previously");
              }
              function j() {
                H = !1, O = {}, D = {}, M = null, k = !1, C = Date.now() / 1e3;
              }
              function J() {
                try {
                  M !== null && H && (clearInterval(M), M = null, H = !1, de());
                } catch (K) {
                  throw K;
                }
              }
              function ae() {
                try {
                  Y(), _.debug("Start Event Controller");
                  var K = F.get().streaming.eventControllerRefreshDelay;
                  !H && !isNaN(K) && (H = !0, M = setInterval(G, K));
                } catch (U) {
                  throw U;
                }
              }
              function G() {
                try {
                  if (!k) {
                    k = !0;
                    var K = w.getTime(), U = K - C;
                    U = C > 0 ? Math.max(0, U) : 0, $(D, U, K), $(O, U, K), ie(D), ie(O), C = K, k = !1;
                  }
                } catch (V) {
                  k = !1, _.error(V);
                }
              }
              function $(K, U, V) {
                try {
                  var Q = function(ue) {
                    if (ue !== void 0) {
                      var q = isNaN(ue.duration) ? 0 : ue.duration;
                      ue.calculatedPresentationTime <= V && ue.calculatedPresentationTime + U + q >= V ? te(ue, d.default.EVENT_MODE_ON_START) : (se(V, q + U, ue.calculatedPresentationTime) || ee(ue)) && (_.debug("Removing event ".concat(ue.id, " from period ").concat(ue.eventStream.period.id, " as it is expired or invalid")), le(K, ue));
                    }
                  };
                  he(K, Q);
                } catch (fe) {
                  _.error(fe);
                }
              }
              function ie(K) {
                try {
                  for (var U in K)
                    K.hasOwnProperty(U) && Object.keys(K[U]).length === 0 && delete K[U];
                } catch (V) {
                  _.error(V);
                }
              }
              function re(K, U) {
                try {
                  if (Y(), O[U] || (O[U] = {}), K)
                    for (var V = 0; V < K.length; V++) {
                      var Q = K[V], fe = w.getTime(), ue = isNaN(Q.duration) ? 0 : Q.duration;
                      if (!se(fe, ue, Q.calculatedPresentationTime)) {
                        var q = z(Q, O[U], !0);
                        q === R.ADDED ? (_.debug("Added inline event with id ".concat(Q.id, " from period ").concat(U)), te(Q, d.default.EVENT_MODE_ON_RECEIVE)) : q === R.UPDATED && _.debug("Updated inline event with id ".concat(Q.id, " from period ").concat(U));
                      }
                    }
                } catch (_e) {
                  throw _e;
                }
              }
              function ce(K, U) {
                try {
                  Y(), D[U] || (D[U] = {});
                  for (var V = 0; V < K.length; V++) {
                    var Q = K[V], fe = w.getTime(), ue = isNaN(Q.duration) ? 0 : Q.duration;
                    if (!se(fe, ue, Q.calculatedPresentationTime)) {
                      var q = z(Q, D[U], !1);
                      q === R.ADDED ? (Q.eventStream.schemeIdUri === A && oe(Q), _.debug("Added inband event with id ".concat(Q.id, " from period ").concat(U)), te(Q, d.default.EVENT_MODE_ON_RECEIVE)) : _.debug("Inband event with scheme_id_uri ".concat(Q.eventStream.schemeIdUri, ", value ").concat(Q.eventStream.value, ", period id ").concat(U, " and event id ").concat(Q.id, " was ignored because it has been added before."));
                    }
                  }
                  G();
                } catch (_e) {
                  throw _e;
                }
              }
              function z(K, U) {
                var V = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, Q = K.eventStream.schemeIdUri, fe = K.eventStream.value, ue = K.id, q = R.DISCARDED;
                U[Q] || (U[Q] = []);
                var _e = U[Q].findIndex(function(Ce) {
                  return (!fe || Ce.eventStream.value && Ce.eventStream.value === fe) && Ce.id === ue;
                });
                if (_e === -1)
                  U[Q].push(K), K.triggeredReceivedEvent = !1, K.triggeredStartEvent = !1, q = R.ADDED;
                else if (V) {
                  var ge = U[Q][_e];
                  K.triggeredReceivedEvent = ge.triggeredReceivedEvent, K.triggeredStartEvent = ge.triggeredStartEvent, U[Q][_e] = K, q = R.UPDATED;
                }
                return q;
              }
              function oe(K) {
                try {
                  if (K.eventStream.value == b) {
                    var U = K.calculatedPresentationTime, V;
                    K.calculatedPresentationTime == 4294967295 ? V = NaN : V = K.calculatedPresentationTime + K.duration, E.trigger(d.default.MANIFEST_VALIDITY_CHANGED, {
                      id: K.id,
                      validUntil: U,
                      newDuration: V,
                      newManifestValidAfter: NaN
                      //event.message_data - this is an arraybuffer with a timestring in it, but not used yet
                    }, {
                      mode: d.default.EVENT_MODE_ON_START
                    });
                  }
                } catch (Q) {
                  _.error(Q);
                }
              }
              function de() {
                try {
                  pe(D), pe(O);
                } catch (K) {
                  _.error(K);
                }
              }
              function pe(K) {
                try {
                  var U = w.getTime(), V = function(fe) {
                    var ue = fe.eventStream && fe.eventStream.period && !isNaN(fe.eventStream.period.duration) ? fe.eventStream.period.duration : NaN, q = fe.eventStream && fe.eventStream.period && !isNaN(fe.eventStream.period.start) ? fe.eventStream.period.start : NaN;
                    if (!(isNaN(ue) || isNaN(q))) {
                      var _e = fe.calculatedPresentationTime;
                      Math.abs(_e - U) < T && te(fe, d.default.EVENT_MODE_ON_START);
                    }
                  };
                  he(K, V);
                } catch (Q) {
                  _.error(Q);
                }
              }
              function he(K, U) {
                try {
                  if (K)
                    for (var V = Object.keys(K), Q = 0; Q < V.length; Q++)
                      for (var fe = K[V[Q]], ue = Object.keys(fe), q = 0; q < ue.length; q++) {
                        var _e = fe[ue[q]];
                        _e.forEach(function(ge) {
                          ge !== void 0 && U(ge);
                        });
                      }
                } catch (ge) {
                  _.error(ge);
                }
              }
              function se(K, U, V) {
                try {
                  return K - U > V;
                } catch (Q) {
                  return _.error(Q), !1;
                }
              }
              function ee(K) {
                try {
                  var U = K.eventStream.period.start + K.eventStream.period.duration;
                  return K.calculatedPresentationTime > U;
                } catch (V) {
                  return _.error(V), !1;
                }
              }
              function te(K, U) {
                try {
                  var V = w.getTime(), Q = K.id;
                  if (U === d.default.EVENT_MODE_ON_RECEIVE && !K.triggeredReceivedEvent) {
                    _.debug("Received event ".concat(Q)), K.triggeredReceivedEvent = !0, E.trigger(K.eventStream.schemeIdUri, {
                      event: K
                    }, {
                      mode: U
                    });
                    return;
                  }
                  K.triggeredStartEvent || (K.eventStream.schemeIdUri === A && K.eventStream.value == b ? (K.duration !== 0 || K.presentationTimeDelta !== 0) && (_.debug("Starting manifest refresh event ".concat(Q, " at ").concat(V)), ne()) : K.eventStream.schemeIdUri === S && K.eventStream.value == N ? (_.debug("Starting callback event ".concat(Q, " at ").concat(V)), x(K.messageData)) : (_.debug("Starting event ".concat(Q, " from period ").concat(K.eventStream.period.id, " at ").concat(V)), E.trigger(K.eventStream.schemeIdUri, {
                    event: K
                  }, {
                    mode: U
                  })), K.triggeredStartEvent = !0);
                } catch (fe) {
                  _.error(fe);
                }
              }
              function le(K, U) {
                try {
                  var V = U.eventStream.schemeIdUri, Q = U.eventStream.period.id, fe = U.eventStream.value, ue = U.id;
                  K[Q][V] = K[Q][V].filter(function(q) {
                    return fe && q.eventStream.value && q.eventStream.value !== fe || q.id !== ue;
                  }), K[Q][V].length === 0 && delete K[Q][V];
                } catch (q) {
                  _.error(q);
                }
              }
              function ne() {
                try {
                  Y(), I.refreshManifest();
                } catch (K) {
                  _.error(K);
                }
              }
              function x(K) {
                try {
                  var U = (0, v.default)(y).create({});
                  U.load({
                    method: "get",
                    url: K,
                    request: {
                      responseType: "arraybuffer"
                    }
                  });
                } catch (V) {
                  _.error(V);
                }
              }
              function P(K) {
                try {
                  if (!K)
                    return;
                  K.manifestUpdater && (I = K.manifestUpdater), K.playbackController && (w = K.playbackController), K.settings && (F = K.settings);
                } catch (U) {
                  throw U;
                }
              }
              function B() {
                return O;
              }
              function W() {
                return D;
              }
              function X() {
                J(), j();
              }
              return L = {
                addInlineEvents: re,
                addInbandEvents: ce,
                getInbandEvents: W,
                getInlineEvents: B,
                start: ae,
                setConfig: P,
                reset: X
              }, Z(), L;
            }
            g.__dashjs_factory_name = "EventController";
            const m = h.default.getSingletonFactory(g);
          }
        ),
        /***/
        "./src/streaming/controllers/FragmentController.js": (
          /*!*********************************************************!*\
            !*** ./src/streaming/controllers/FragmentController.js ***!
            \*********************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => y
              /* harmony export */
            });
            var h = i(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), f = i(
              /*! ../vo/DataChunk */
              "./src/streaming/vo/DataChunk.js"
            ), p = i(
              /*! ../models/FragmentModel */
              "./src/streaming/models/FragmentModel.js"
            ), d = i(
              /*! ../FragmentLoader */
              "./src/streaming/FragmentLoader.js"
            ), v = i(
              /*! ../utils/RequestModifier */
              "./src/streaming/utils/RequestModifier.js"
            ), g = i(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), m = i(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), A = i(
              /*! ../MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), b = i(
              /*! ../../core/errors/Errors */
              "./src/core/errors/Errors.js"
            ), S = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), N = i(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), T = i(
              /*! ../utils/SegmentResponseModifier */
              "./src/streaming/utils/SegmentResponseModifier.js"
            );
            function R(E) {
              E = E || {};
              var L = this.context, _ = (0, g.default)(L).getInstance(), O = E.errHandler, D = E.mediaPlayerModel, M = E.dashMetrics, C = (0, N.default)(L).getInstance(), I = (0, T.default)(L).getInstance(), w = E.streamInfo, F, k, H;
              function Z() {
                k = C.getLogger(F), J(), _.on(A.default.FRAGMENT_LOADING_COMPLETED, $, F), _.on(A.default.FRAGMENT_LOADING_PROGRESS, $, F);
              }
              function Y() {
                return w.id;
              }
              function j(ie) {
                var re = H[ie];
                return re || (re = (0, p.default)(L).create({
                  streamInfo: w,
                  type: ie,
                  dashMetrics: M,
                  fragmentLoader: (0, d.default)(L).create({
                    dashMetrics: M,
                    mediaPlayerModel: D,
                    errHandler: O,
                    requestModifier: (0, v.default)(L).getInstance(),
                    settings: E.settings,
                    boxParser: E.boxParser,
                    eventBus: _,
                    events: m.default,
                    errors: b.default,
                    dashConstants: E.dashConstants,
                    urlUtils: E.urlUtils,
                    streamId: Y()
                  }),
                  debug: C,
                  eventBus: _,
                  events: m.default
                }), H[ie] = re), re;
              }
              function J() {
                for (var ie in H)
                  H[ie].reset();
                H = {};
              }
              function ae() {
                _.off(A.default.FRAGMENT_LOADING_COMPLETED, $, this), _.off(A.default.FRAGMENT_LOADING_PROGRESS, $, this), J();
              }
              function G(ie, re, ce, z) {
                var oe = new f.default();
                return oe.streamId = ce, oe.mediaInfo = re.mediaInfo, oe.segmentType = re.type, oe.start = re.startTime, oe.duration = re.duration, oe.end = oe.start + oe.duration, oe.bytes = ie, oe.index = re.index, oe.quality = re.quality, oe.representationId = re.representationId, oe.endFragment = z, oe;
              }
              function $(ie) {
                if (ie.sender) {
                  var re = ie.request, ce = ie.response, z = re.isInitializationRequest(), oe = re.mediaInfo.streamInfo;
                  if (ie.error && (re.mediaType === h.default.AUDIO || re.mediaType === h.default.VIDEO || re.mediaType === h.default.TEXT && re.mediaInfo.isFragmented) && _.trigger(m.default.SERVICE_LOCATION_BLACKLIST_ADD, {
                    entry: ie.request.serviceLocation
                  }), !ce || !oe) {
                    k.warn("No " + re.mediaType + " bytes to push or stream is inactive.");
                    return;
                  }
                  var de = G(ce, re, w.id, ie.type !== m.default.FRAGMENT_LOADING_PROGRESS);
                  I.modifyResponseAsync(de).then(function(pe) {
                    _.trigger(z ? m.default.INIT_FRAGMENT_LOADED : m.default.MEDIA_FRAGMENT_LOADED, {
                      chunk: pe,
                      request: re
                    }, {
                      streamId: oe.id,
                      mediaType: re.mediaType
                    });
                  }).catch(function(pe) {
                    k.error(pe), _.trigger(z ? m.default.INIT_FRAGMENT_LOADED : m.default.MEDIA_FRAGMENT_LOADED, {
                      chunk: de,
                      request: re
                    }, {
                      streamId: oe.id,
                      mediaType: re.mediaType
                    });
                  });
                }
              }
              return F = {
                getStreamId: Y,
                getModel: j,
                reset: ae
              }, Z(), F;
            }
            R.__dashjs_factory_name = "FragmentController";
            const y = S.default.getClassFactory(R);
          }
        ),
        /***/
        "./src/streaming/controllers/GapController.js": (
          /*!****************************************************!*\
            !*** ./src/streaming/controllers/GapController.js ***!
            \****************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => S
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), p = i(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), d = i(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), v = i(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), g = 100, m = 10, A = 0.1;
            function b() {
              var N = this.context, T = (0, d.default)(N).getInstance(), R, y, E, L, _, O, D, M, C, I, w, F;
              function k() {
                J();
              }
              function H() {
                F = (0, f.default)(N).getInstance().getLogger(R), Z();
              }
              function Z() {
                se(), ae(), Y();
              }
              function Y() {
                _ = null, O = NaN, L = 0, I = null, w = {};
              }
              function j(te) {
                te && (te.settings && (E = te.settings), te.playbackController && (D = te.playbackController), te.streamController && (M = te.streamController), te.videoModel && (C = te.videoModel));
              }
              function J() {
                T.on(p.default.WALLCLOCK_TIME_UPDATED, ce, this), T.on(p.default.INITIAL_STREAM_SWITCH, re, this), T.on(p.default.PLAYBACK_SEEKING, G, this), T.on(p.default.BUFFER_REPLACEMENT_STARTED, $, R), T.on(p.default.TRACK_CHANGE_RENDERED, ie, R);
              }
              function ae() {
                T.off(p.default.WALLCLOCK_TIME_UPDATED, ce, this), T.off(p.default.INITIAL_STREAM_SWITCH, re, this), T.off(p.default.PLAYBACK_SEEKING, G, this), T.off(p.default.BUFFER_REPLACEMENT_STARTED, $, R), T.off(p.default.TRACK_CHANGE_RENDERED, ie, R);
              }
              function G() {
                I && (clearTimeout(I), I = null);
              }
              function $(te) {
                try {
                  if (te.streamId !== M.getActiveStreamInfo().id || te.mediaType !== v.default.VIDEO && te.mediaType !== v.default.AUDIO)
                    return;
                  te.streamId === M.getActiveStreamInfo().id && (w[te.mediaType] = !0);
                } catch (le) {
                  F.error(le);
                }
              }
              function ie(te) {
                !te || !te.mediaType || (w[te.mediaType] = !1);
              }
              function re() {
                _ || he();
              }
              function ce() {
                if (z(E.get().streaming.gaps.enableSeekFix) && (L++, L >= m)) {
                  var te = D.getTime();
                  y === te ? ee(te, !0) : (y = te, O = NaN), L = 0;
                }
              }
              function z() {
                var te = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
                if (!M.getActiveStream())
                  return !1;
                var le = Object.keys(w).some(function(x) {
                  return w[x];
                }), ne = te ? oe() : !1;
                return !le && E.get().streaming.gaps.jumpGaps && M.getActiveStreamProcessors().length > 0 && (!D.isSeeking() || ne) && !D.isPaused() && !M.getIsStreamSwitchInProgress() && !M.getHasMediaOrInitialisationError();
              }
              function oe() {
                var te = M.getActiveStream(), le = parseFloat((te.getStartTime() + te.getDuration()).toFixed(5));
                return D.getTime() + E.get().streaming.gaps.threshold >= le;
              }
              function de(te, le) {
                try {
                  if (!te || te.length <= 1 && le > 0)
                    return NaN;
                  for (var ne = NaN, x = 0; isNaN(ne) && x < te.length; ) {
                    var P = x > 0 ? te.end(x - 1) : 0;
                    le < te.start(x) && P - le < E.get().streaming.gaps.threshold && (ne = x), x += 1;
                  }
                  return ne;
                } catch {
                  return null;
                }
              }
              function pe(te, le) {
                for (var ne = 0, x = te.length; ne < x; ne++)
                  if (le >= te.start(ne) && le <= te.end(ne))
                    return !0;
                return !1;
              }
              function he() {
                try {
                  _ || (F.debug("Starting the gap controller"), _ = setInterval(function() {
                    if (z()) {
                      var te = D.getTime();
                      ee(te);
                    }
                  }, g));
                } catch {
                }
              }
              function se() {
                F.debug("Stopping the gap controller"), _ && (clearInterval(_), _ = null);
              }
              function ee(te) {
                var le = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, ne = E.get().streaming.gaps.enableStallFix, x = E.get().streaming.gaps.stallSeek, P = E.get().streaming.gaps.smallGapLimit, B = E.get().streaming.gaps.jumpLargeGaps, W = C.getBufferRange(), X, K = NaN, U = !1;
                if (X = de(W, te), !isNaN(X)) {
                  var V = W.start(X), Q = V - te;
                  Q > 0 && (Q <= P || B) && (K = V);
                }
                var fe = D.getTimeToStreamEnd();
                if (isNaN(K) && le && isFinite(fe) && !isNaN(fe) && fe < P && (K = parseFloat(D.getStreamEndTime().toFixed(5)), U = !0), ne && isNaN(K) && le && isNaN(X) && pe(W, te) && (x === 0 ? (F.warn("Toggle play pause to break stall"), C.pause(), C.play()) : (F.warn("Jumping ".concat(x, "s to break stall")), K = te + x)), K > 0 && O !== K && K > te && !I) {
                  var ue = K - te;
                  if (U) {
                    var q = M.getStreamForTime(K), _e = q && !!q.getPreloaded();
                    F.warn("Jumping to end of stream because of gap from ".concat(te, " to ").concat(K, ". Gap duration: ").concat(ue)), D.seek(K, !0, _e);
                  } else {
                    var ge = D.getIsDynamic(), Ce = X > 0 ? W.end(X - 1) : te, Ee = ge ? Math.max(0, ue - A) * 1e3 : 0;
                    I = window.setTimeout(function() {
                      D.seek(K, !0, !0), F.warn("Jumping gap occuring in period ".concat(M.getActiveStream().getStreamId(), " starting at ").concat(Ce, " and ending at ").concat(K, ". Jumping by: ").concat(K - Ce)), I = null;
                    }, Ee);
                  }
                  O = K;
                }
              }
              return R = {
                reset: Z,
                setConfig: j,
                initialize: k
              }, H(), R;
            }
            b.__dashjs_factory_name = "GapController";
            const S = h.default.getSingletonFactory(b);
          }
        ),
        /***/
        "./src/streaming/controllers/MediaController.js": (
          /*!******************************************************!*\
            !*** ./src/streaming/controllers/MediaController.js ***!
            \******************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => N
              /* harmony export */
            });
            var h = i(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), f = i(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), p = i(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), d = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), v = i(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), g = i(
              /*! bcp-47-normalize */
              "./node_modules/bcp-47-normalize/index.js"
            ), m = /* @__PURE__ */ i.n(g), A = i(
              /*! bcp-47-match */
              "./node_modules/bcp-47-match/index.js"
            );
            function b() {
              var T = this.context, R = (0, p.default)(T).getInstance(), y, E, L, _, O, D, M, C;
              function I() {
                E = (0, v.default)(T).getInstance().getLogger(y), re();
              }
              function w(ue, q) {
                var _e = D[ue] || J(ue), ge = k(ue, q.id), Ce = [];
                _e || (_e = C.getSavedMediaSettings(ue), j(ue, _e)), !(!ge || ge.length === 0) && (_e && (Ce = Array.from(ge), Ce = z(Ce, oe, _e), Ce = z(Ce, de, _e), Ce = z(Ce, pe, _e), ue === h.default.AUDIO && D[ue] || (Ce = z(Ce, he, _e)), Ce = z(Ce, se, _e), Ce = z(Ce, ee, _e)), Ce.length === 0 ? Y(W(ue, ge), !0) : Ce.length > 1 ? Y(W(ue, Ce, !!D[ue])) : Y(Ce[0]));
              }
              function F(ue) {
                if (ue) {
                  var q = ue.type;
                  if (G(q)) {
                    var _e = ue.streamInfo.id;
                    L[_e] || (L[_e] = fe());
                    for (var ge = L[_e][q].list, Ce = 0, Ee = ge.length; Ce < Ee; ++Ce)
                      if ($(ge[Ce], ue))
                        return;
                    ge.push(ue);
                  }
                }
              }
              function k(ue, q) {
                return ue ? !L[q] || !L[q][ue] ? [] : L[q][ue].list : [];
              }
              function H(ue, q) {
                return !ue || !L[q] || !L[q][ue] ? null : L[q][ue].current;
              }
              function Z(ue) {
                if (!ue)
                  return !1;
                var q = ue.type, _e = ue.streamInfo.id;
                return L[_e] && L[_e][q] && $(L[_e][q].current, ue);
              }
              function Y(ue) {
                var q = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
                if (!(!ue || !ue.streamInfo)) {
                  var _e = ue.type, ge = ue.streamInfo, Ce = ge.id, Ee = H(_e, Ce);
                  if (!(!L[Ce] || !L[Ce][_e]) && (L[Ce][_e].current = ue, L[Ce][_e].current && (_e !== h.default.TEXT && !$(ue, Ee) || _e === h.default.TEXT && ue.isFragmented) && R.trigger(f.default.CURRENT_TRACK_CHANGED, {
                    oldMediaInfo: Ee,
                    newMediaInfo: ue,
                    switchMode: _.get().streaming.trackSwitchMode[_e]
                  }, {
                    streamId: Ce
                  }), !q)) {
                    var Re = ce(ue);
                    if (!Re || !L[Ce][_e].storeLastSettings)
                      return;
                    Re.roles && (Re.role = Re.roles[0], delete Re.roles), Re.accessibility && (Re.accessibility = Re.accessibility[0]), Re.audioChannelConfiguration && (Re.audioChannelConfiguration = Re.audioChannelConfiguration[0]), D[_e] = Re, C.setSavedMediaSettings(_e, Re);
                  }
                }
              }
              function j(ue, q) {
                !ue || !q || (O[ue] = q);
              }
              function J(ue) {
                return ue ? O[ue] : null;
              }
              function ae() {
                C.setSavedMediaSettings(h.default.TEXT, null);
              }
              function G(ue) {
                return ue === h.default.AUDIO || ue === h.default.VIDEO || ue === h.default.TEXT || ue === h.default.IMAGE;
              }
              function $(ue, q) {
                if (!ue && !q)
                  return !0;
                if (!ue || !q)
                  return !1;
                var _e = ue.id === q.id, ge = ue.viewpoint === q.viewpoint, Ce = ue.lang === q.lang, Ee = ue.codec === q.codec, Re = ue.roles.toString() === q.roles.toString(), Pe = ue.accessibility.toString() === q.accessibility.toString(), ke = ue.audioChannelConfiguration.toString() === q.audioChannelConfiguration.toString();
                return _e && Ee && ge && Ce && Re && Pe && ke;
              }
              function ie(ue) {
                ue && (ue.domStorage && (C = ue.domStorage), ue.settings && (_ = ue.settings), ue.customParametersModel && (M = ue.customParametersModel));
              }
              function re() {
                L = {}, D = {}, le();
              }
              function ce(ue) {
                var q = {
                  lang: ue.lang,
                  viewpoint: ue.viewpoint,
                  roles: ue.roles,
                  accessibility: ue.accessibility,
                  audioChannelConfiguration: ue.audioChannelConfiguration
                }, _e = q.lang || q.viewpoint || q.role && q.role.length > 0 || q.accessibility && q.accessibility.length > 0 || q.audioChannelConfiguration && q.audioChannelConfiguration.length > 0;
                return _e ? q : null;
              }
              function z(ue, q, _e) {
                var ge = [];
                return ue.forEach(function(Ce) {
                  q(_e, Ce) && ge.push(Ce);
                }), ge.length !== 0 ? ge : ue;
              }
              function oe(ue, q) {
                return !ue.lang || ue.lang instanceof RegExp ? q.lang.match(ue.lang) : q.lang !== "" ? (0, A.extendedFilter)(q.lang, m()(ue.lang)).length > 0 : !1;
              }
              function de(ue, q) {
                return ue.index === void 0 || ue.index === null || q.index === ue.index;
              }
              function pe(ue, q) {
                return !ue.viewpoint || ue.viewpoint === q.viewpoint;
              }
              function he(ue, q) {
                var _e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, ge = !ue.role || !!q.roles.filter(function(Ce) {
                  return Ce === ue.role;
                })[0];
                return ge || q.type === h.default.AUDIO && _e;
              }
              function se(ue, q) {
                var _e;
                return ue.accessibility ? _e = !!q.accessibility.filter(function(ge) {
                  return ge === ue.accessibility;
                })[0] : _e = !q.accessibility.length, _e;
              }
              function ee(ue, q) {
                var _e = !ue.audioChannelConfiguration || !!q.audioChannelConfiguration.filter(function(ge) {
                  return ge === ue.audioChannelConfiguration;
                })[0];
                return _e;
              }
              function te(ue, q) {
                var _e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
                try {
                  var ge = !1;
                  if (!ue.lang)
                    ge = !0;
                  else if (ue.lang instanceof RegExp)
                    ge = q.lang.match(ue.lang);
                  else if (q.lang !== "") {
                    var Ce = m()(ue.lang);
                    Ce && (ge = (0, A.extendedFilter)(q.lang, Ce).length > 0);
                  }
                  var Ee = ue.index === void 0 || ue.index === null || q.index === ue.index, Re = !ue.viewpoint || ue.viewpoint === q.viewpoint, Pe = !ue.role || !!q.roles.filter(function(Ae) {
                    return Ae === ue.role;
                  })[0], ke = !ue.accessibility || !!q.accessibility.filter(function(Ae) {
                    return Ae === ue.accessibility;
                  })[0], De = !ue.audioChannelConfiguration || !!q.audioChannelConfiguration.filter(function(Ae) {
                    return Ae === ue.audioChannelConfiguration;
                  })[0];
                  return ge && Ee && Re && (Pe || q.type === h.default.AUDIO && _e) && ke && De;
                } catch {
                  return !1;
                }
              }
              function le() {
                O = {
                  audio: null,
                  video: null,
                  text: null
                };
              }
              function ne(ue) {
                var q = 0, _e = [];
                return ue.forEach(function(ge) {
                  isNaN(ge.selectionPriority) || (ge.selectionPriority > q ? (q = ge.selectionPriority, _e = [ge]) : ge.selectionPriority === q && _e.push(ge));
                }), _e;
              }
              function x(ue) {
                var q = 0, _e = [], ge;
                return ue.forEach(function(Ce) {
                  ge = Math.max.apply(Math, Ce.bitrateList.map(function(Ee) {
                    return Ee.bandwidth;
                  })), ge > q ? (q = ge, _e = [Ce]) : ge === q && _e.push(Ce);
                }), _e;
              }
              function P(ue) {
                var q = 1 / 0, _e = [], ge;
                return ue.forEach(function(Ce) {
                  var Ee = Ce.bitrateList.reduce(function(Re, Pe) {
                    var ke = Math.max(1, Pe.width * Pe.height), De = Pe.bandwidth / ke;
                    return Re + De;
                  }, 0);
                  ge = Ee / Ce.bitrateList.length, ge < q ? (q = ge, _e = [Ce]) : ge === q && _e.push(Ce);
                }), _e;
              }
              function B(ue) {
                var q = 0, _e = [], ge;
                return ue.forEach(function(Ce) {
                  ge = Ce.representationCount, ge > q ? (q = ge, _e = [Ce]) : ge === q && _e.push(Ce);
                }), _e;
              }
              function W(ue, q) {
                if (ue === h.default.TEXT)
                  return q[0];
                var _e = _.get().streaming.selectionModeForInitialTrack, ge, Ce = M.getCustomInitialTrackSelectionFunction();
                if (Ce && typeof Ce == "function")
                  ge = Ce(q);
                else
                  switch (_e) {
                    case h.default.TRACK_SELECTION_MODE_HIGHEST_SELECTION_PRIORITY:
                      ge = X(q);
                      break;
                    case h.default.TRACK_SELECTION_MODE_HIGHEST_BITRATE:
                      ge = K(q);
                      break;
                    case h.default.TRACK_SELECTION_MODE_FIRST_TRACK:
                      ge = U(q);
                      break;
                    case h.default.TRACK_SELECTION_MODE_HIGHEST_EFFICIENCY:
                      ge = V(q);
                      break;
                    case h.default.TRACK_SELECTION_MODE_WIDEST_RANGE:
                      ge = Q(q);
                      break;
                    default:
                      E.warn("Track selection mode ".concat(_e, " is not supported. Falling back to TRACK_SELECTION_MODE_FIRST_TRACK")), ge = U(q);
                      break;
                  }
                return ge.length > 0 ? ge[0] : q[0];
              }
              function X(ue) {
                var q = ne(ue);
                return q.length > 1 && (q = x(q)), q.length > 1 && (q = B(q)), q;
              }
              function K(ue) {
                var q = x(ue);
                return q.length > 1 && (q = B(q)), q;
              }
              function U(ue) {
                return ue[0];
              }
              function V(ue) {
                var q = P(ue);
                return q.length > 1 && (q = x(q)), q;
              }
              function Q(ue) {
                var q = B(ue);
                return q.length > 1 && (q = x(ue)), q;
              }
              function fe() {
                return {
                  audio: {
                    list: [],
                    storeLastSettings: !0,
                    current: null
                  },
                  video: {
                    list: [],
                    storeLastSettings: !0,
                    current: null
                  },
                  text: {
                    list: [],
                    storeLastSettings: !0,
                    current: null
                  },
                  image: {
                    list: [],
                    storeLastSettings: !0,
                    current: null
                  }
                };
              }
              return y = {
                setInitialMediaSettingsForType: w,
                addTrack: F,
                getTracksFor: k,
                getCurrentTrackFor: H,
                isCurrentTrack: Z,
                setTrack: Y,
                selectInitialTrack: W,
                setInitialSettings: j,
                getInitialSettings: J,
                getTracksWithHighestBitrate: x,
                getTracksWithHighestEfficiency: P,
                getTracksWithWidestRange: B,
                isTracksEqual: $,
                matchSettings: te,
                matchSettingsLang: oe,
                matchSettingsIndex: de,
                matchSettingsViewPoint: pe,
                matchSettingsRole: he,
                matchSettingsAccessibility: se,
                matchSettingsAudioChannelConfig: ee,
                saveTextSettingsDisabled: ae,
                setConfig: ie,
                reset: re
              }, I(), y;
            }
            b.__dashjs_factory_name = "MediaController";
            var S = d.default.getSingletonFactory(b);
            d.default.updateSingletonFactory(b.__dashjs_factory_name, S);
            const N = S;
          }
        ),
        /***/
        "./src/streaming/controllers/MediaSourceController.js": (
          /*!************************************************************!*\
            !*** ./src/streaming/controllers/MediaSourceController.js ***!
            \************************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => d
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            );
            function p() {
              var v, g, m, A = this.context;
              function b() {
                m = (0, f.default)(A).getInstance().getLogger(v);
              }
              function S() {
                var _ = "WebKitMediaSource" in window, O = "MediaSource" in window;
                return O ? g = new MediaSource() : _ && (g = new WebKitMediaSource()), g;
              }
              function N(_) {
                var O = window.URL.createObjectURL(g);
                return _.setSource(O), O;
              }
              function T(_) {
                _.setSource(null);
              }
              function R(_) {
                !g || g.readyState !== "open" || _ === null && isNaN(_) || g.duration !== _ && (L(g) ? setTimeout(R.bind(null, _), 50) : (m.info("Set MediaSource duration:" + _), g.duration = _));
              }
              function y(_, O) {
                g && typeof g.setLiveSeekableRange == "function" && typeof g.clearLiveSeekableRange == "function" && g.readyState === "open" && _ >= 0 && _ < O && (g.clearLiveSeekableRange(), g.setLiveSeekableRange(_, O));
              }
              function E(_) {
                if (!(!_ || _.readyState !== "open")) {
                  for (var O = _.sourceBuffers, D = 0; D < O.length; D++)
                    if (O[D].updating || O[D].buffered.length === 0)
                      return;
                  m.info("call to mediaSource endOfStream"), _.endOfStream();
                }
              }
              function L(_) {
                for (var O = _.sourceBuffers, D = 0; D < O.length; D++)
                  if (O[D].updating)
                    return !0;
                return !1;
              }
              return v = {
                createMediaSource: S,
                attachMediaSource: N,
                detachMediaSource: T,
                setDuration: R,
                setSeekable: y,
                signalEndOfStream: E
              }, b(), v;
            }
            p.__dashjs_factory_name = "MediaSourceController";
            const d = h.default.getSingletonFactory(p);
          }
        ),
        /***/
        "./src/streaming/controllers/PlaybackController.js": (
          /*!*********************************************************!*\
            !*** ./src/streaming/controllers/PlaybackController.js ***!
            \*********************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => S
              /* harmony export */
            });
            var h = i(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), f = i(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), p = i(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), d = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), v = i(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), g = i(
              /*! ../../streaming/MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), m = i(
              /*! ../constants/MetricsConstants */
              "./src/streaming/constants/MetricsConstants.js"
            ), A = 500;
            function b() {
              var N = this.context, T = (0, f.default)(N).getInstance(), R, y, E, L, _, O, D, M, C, I, w, F, k, H, Z, Y, j, J, ae, G, $, ie, re, ce;
              function z() {
                y = (0, v.default)(N).getInstance().getLogger(R), oe();
              }
              function oe() {
                le(), H = !1, I = 0, w = 0, Y = 0, ie = !1, j = !0, J = !1, re = !1, ae = NaN, D && (T.off(p.default.DATA_UPDATE_COMPLETED, rt, R), T.off(p.default.LOADING_PROGRESS, et, R), T.off(p.default.MANIFEST_UPDATED, Qt, R), T.off(p.default.STREAMS_COMPOSED, tn, R), T.off(g.default.PLAYBACK_ENDED, tt, R), T.off(g.default.STREAM_INITIALIZING, ht, R), T.off(g.default.REPRESENTATION_SWITCH, St, R), T.off(g.default.BUFFER_LEVEL_STATE_CHANGED, $e, R), it(), ft()), C = null, D = null, F = null, k = null;
              }
              function de(Le, Ke) {
                F = Le, Ke !== !0 && pe();
              }
              function pe() {
                ze(), k = F.manifestInfo.isDynamic, $ = !1, G = !1, T.on(p.default.DATA_UPDATE_COMPLETED, rt, R), T.on(p.default.LOADING_PROGRESS, et, R), T.on(p.default.MANIFEST_UPDATED, Qt, R), T.on(p.default.STREAMS_COMPOSED, tn, R), T.on(g.default.PLAYBACK_ENDED, tt, R, {
                  priority: f.default.EVENT_PRIORITY_HIGH
                }), T.on(g.default.STREAM_INITIALIZING, ht, R), T.on(g.default.REPRESENTATION_SWITCH, St, R), T.on(g.default.BUFFER_LEVEL_STATE_CHANGED, $e, R), H && (H = !1, te());
              }
              function he() {
                return $;
              }
              function se() {
                var Le = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                return parseFloat((ee(Le) - X()).toFixed(5));
              }
              function ee(Le) {
                var Ke = Le || F;
                return Ke.start + Ke.duration;
              }
              function te() {
                var Le = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
                F && D && D.getElement() ? (Le && k && W(X()), D.play()) : H = !0;
              }
              function le() {
                F && D && D.pause();
              }
              function ne(Le) {
                var Ke = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, Qe = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, Et = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
                if (!(!F || !D)) {
                  var Vt = isNaN(ae) ? D.getTime() : ae;
                  Le !== Vt && (G = Qe === !0, G || (ae = Le), y.info("Requesting seek to time: " + Le + (G ? " (internal)" : "")), k && Et && W(Le), D.setCurrentTime(Le, Ke));
                }
              }
              function x() {
                var Le = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, Ke = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, Qe = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, Et = B();
                if (Et !== 0) {
                  I = w;
                  var Vt = Et - I;
                  ne(Vt, Le, Ke, Qe);
                }
              }
              function P() {
                var Le = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, Ke = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, Qe = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, Et = B();
                if (Et !== 0) {
                  var Vt = Et - I;
                  ne(Vt, Le, Ke, Qe);
                }
              }
              function B() {
                if (!(!F || !D || !k)) {
                  var Le = E && E.hasVideoTrack() ? h.default.VIDEO : h.default.AUDIO, Ke = _.getCurrentDVRInfo(Le);
                  return Ke && Ke.range ? Ke.range.end : 0;
                }
              }
              function W(Le) {
                var Ke = new Date(M.getClientReferenceTime()), Qe = O.getRegularPeriods()[0], Et = M.calcPresentationTimeFromWallTime(Ke, Qe);
                I = Et - Le;
              }
              function X() {
                return F && D ? D.getTime() : null;
              }
              function K() {
                return F && D ? D.isPaused() : null;
              }
              function U() {
                return F && D ? D.isSeeking() : null;
              }
              function V() {
                return F && D ? D.isStalled() : null;
              }
              function Q() {
                return F && D ? D.getPlaybackRate() : null;
              }
              function fe() {
                return F && D ? D.getPlayedRanges() : null;
              }
              function ue() {
                return F && D ? D.getEnded() : null;
              }
              function q() {
                return k;
              }
              function _e() {
                return E;
              }
              function ge() {
                return ie;
              }
              function Ce() {
                return Y;
              }
              function Ee() {
                return I;
              }
              function Re() {
                return w;
              }
              function Pe() {
                if (!k || isNaN(Y))
                  return NaN;
                var Le = X();
                if (isNaN(Le) || Le === 0)
                  return 0;
                var Ke = (/* @__PURE__ */ new Date()).getTime() + M.getClientTimeOffset() * 1e3;
                return Math.max(((Ke - Y - Le * 1e3) / 1e3).toFixed(3), 0);
              }
              function ke(Le, Ke) {
                var Qe, Et, Vt, It = 4, Pt = 4, mn = !isNaN(Le) && isFinite(Le) ? Le : NaN, Jt = O.getSuggestedPresentationDelay(), qe = L.getServiceDescriptionSettings();
                return isNaN(ce.get().streaming.delay.liveDelay) ? ce.get().streaming.delay.liveDelayFragmentCount !== null && !isNaN(ce.get().streaming.delay.liveDelayFragmentCount) && !isNaN(mn) ? Qe = mn * ce.get().streaming.delay.liveDelayFragmentCount : qe && !isNaN(qe.liveDelay) && qe.liveDelay > 0 ? Qe = qe.liveDelay : ce.get().streaming.delay.useSuggestedPresentationDelay === !0 && Jt !== null && !isNaN(Jt) && Jt > 0 ? Qe = Jt : isNaN(mn) ? Qe = Ke && !isNaN(Ke.minBufferTime) ? Ke.minBufferTime * It : F.manifestInfo.minBufferTime * It : Qe = mn * Pt : Qe = ce.get().streaming.delay.liveDelay, Vt = O.getAvailabilityStartTime(), Vt !== null && (Y = Vt), Ke && Ke.dvrWindowSize > 0 ? Et = Math.min(Qe, Ke.dvrWindowSize) : Et = Qe, I = Et, w = Et, Et;
              }
              function De(Le) {
                Le && (Le.streamController && (E = Le.streamController), Le.serviceDescriptionController && (L = Le.serviceDescriptionController), Le.dashMetrics && (_ = Le.dashMetrics), Le.adapter && (O = Le.adapter), Le.videoModel && (D = Le.videoModel), Le.timelineConverter && (M = Le.timelineConverter), Le.settings && (ce = Le.settings));
              }
              function Ae() {
                var Le = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                if (!(K() || !k || D.getReadyState() === 0 || U() || ie)) {
                  Le || (Le = E.hasVideoTrack() ? h.default.VIDEO : h.default.AUDIO);
                  var Ke = X(), Qe = Ie(Ke, Le), Et = !isNaN(Qe) && Qe !== Ke;
                  Et && !U() && (V() || $ || D.getReadyState() === 1) && (y.debug("UpdateCurrentTime: Seek to actual time: ".concat(Qe, " from currentTime: ").concat(Ke)), ne(Qe, !1, !1));
                }
              }
              function Ie(Le, Ke) {
                var Qe = _.getCurrentDVRInfo(Ke), Et = Qe ? Qe.range : null, Vt;
                return Et ? (Le > Et.end ? Vt = Math.max(Et.end - I, Et.start) : Le > 0 && Le + 0.25 < Et.start && Math.abs(Le - Et.start) < 31536e4 ? J ? Vt = Math.max(Et.end - I, Et.start) : Vt = Et.start : Vt = Le, Vt) : NaN;
              }
              function Xe() {
                C === null && (C = setInterval(function() {
                  Mt();
                }, ce.get().streaming.wallclockTimeUpdateInterval));
              }
              function it() {
                clearInterval(C), C = null;
              }
              function rt(Le) {
                var Ke = O.convertRepresentationToRepresentationInfo(Le.currentRepresentation), Qe = Ke ? Ke.mediaInfo.streamInfo : null;
                Qe === null || F.id !== Qe.id || (F = Qe);
              }
              function Ne() {
                T.trigger(p.default.CAN_PLAY);
              }
              function He() {
                T.trigger(p.default.CAN_PLAY_THROUGH);
              }
              function $e(Le) {
                Le.streamId === E.getActiveStreamInfo().id && ($ = Le.state === m.default.BUFFER_EMPTY, ce.get().streaming.buffer.setStallState && D.setStallState(Le.mediaType, Le.state === m.default.BUFFER_EMPTY));
              }
              function nt() {
                y.info("Native video element event: play"), Ae(), Xe(), T.trigger(p.default.PLAYBACK_STARTED, {
                  startTime: X()
                });
              }
              function ut() {
                y.info("Native video element event: waiting"), T.trigger(p.default.PLAYBACK_WAITING, {
                  playingTime: X()
                });
              }
              function pt() {
                y.info("Native video element event: playing"), G = !1, T.trigger(p.default.PLAYBACK_PLAYING, {
                  playingTime: X()
                });
              }
              function vt() {
                y.info("Native video element event: pause"), T.trigger(p.default.PLAYBACK_PAUSED, {
                  ended: ue()
                });
              }
              function Ut() {
                if (!G) {
                  var Le = X();
                  !isNaN(ae) && ae !== Le && (Le = ae), ae = NaN, y.info("Seeking to: " + Le), Xe(), T.trigger(p.default.PLAYBACK_SEEKING, {
                    seekTime: Le,
                    streamId: F.id
                  });
                }
              }
              function Je() {
                y.info("Native video element event: seeked"), G = !1, T.trigger(p.default.PLAYBACK_SEEKED);
              }
              function Te() {
                F && T.trigger(p.default.PLAYBACK_TIME_UPDATED, {
                  timeToEnd: se(),
                  time: X(),
                  streamId: F.id
                });
              }
              function me() {
                T.trigger(p.default.PLAYBACK_PROGRESS, {
                  streamId: F.id
                });
              }
              function Me() {
                var Le = Q();
                y.info("Native video element event: ratechange: ", Le), T.trigger(p.default.PLAYBACK_RATE_CHANGED, {
                  playbackRate: Le
                });
              }
              function Be() {
                y.info("Native video element event: loadedmetadata"), T.trigger(p.default.PLAYBACK_METADATA_LOADED), Xe();
              }
              function Fe() {
                y.info("Native video element event: loadeddata"), T.trigger(p.default.PLAYBACK_LOADED_DATA);
              }
              function Ze() {
                y.info("Native video element event: ended"), le(), it();
                var Le = E ? E.getActiveStreamInfo() : null;
                Le && T.trigger(p.default.PLAYBACK_ENDED, {
                  isLast: Le.isLast
                });
              }
              function ot() {
                T.trigger(p.default.PLAYBACK_VOLUME_CHANGED);
              }
              function tt(Le) {
                if (C && Le.isLast) {
                  y.info("onPlaybackEnded -- PLAYBACK_ENDED but native video element didn't fire ended");
                  var Ke = Le.seekTime ? Le.seekTime : ee();
                  D.setCurrentTime(Ke), le(), it();
                }
              }
              function gt(Le) {
                var Ke = Le.target || Le.srcElement;
                T.trigger(p.default.PLAYBACK_ERROR, {
                  error: Ke.error
                });
              }
              function Mt() {
                T.trigger(p.default.WALLCLOCK_TIME_UPDATED, {
                  isDynamic: k,
                  time: /* @__PURE__ */ new Date()
                }), q() && (E.addDVRMetric(), K() ? xt() : Ae());
              }
              function xt() {
                var Le = Date.now();
                (!Z || Le > Z + A) && (Z = Le, Te());
              }
              function be() {
                var Le = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, Ke = null;
                return E.getActiveStreamProcessors().forEach(function(Qe) {
                  if (!Le || Le.length === 0 || Le.indexOf(Qe.getType()) === -1) {
                    var Et = Qe.getBufferLevel();
                    Ke === null ? Ke = Et : Ke = Math.min(Ke, Et);
                  }
                }), Ke;
              }
              function We() {
                return J;
              }
              function et(Le) {
                if (Le.stream === !1 && J && !isNaN(Le.request.duration)) {
                  var Ke = 1.2 * Le.request.duration;
                  Ke > I && (y.warn("Browser does not support fetch API with StreamReader. Increasing live delay to be 20% higher than segment duration:", Ke.toFixed(2)), I = Ke, w = Ke);
                }
              }
              function _t(Le) {
                T.trigger(p.default.PLAYBACK_STALLED, {
                  e: Le
                });
              }
              function ht(Le) {
                ye(Le.mediaInfo);
              }
              function St(Le) {
                var Ke = E.getActiveStreamInfo();
                !Le || !Ke || !Le.currentRepresentation || !Le.streamId || Le.streamId !== Ke.id || !Le.mediaType || Le.mediaType !== h.default.VIDEO && Le.mediaType !== h.default.AUDIO || (j = Le.currentRepresentation.availabilityTimeComplete, J = !j, J && !re && (re = !0));
              }
              function kt() {
                return re;
              }
              function Qt() {
                ie = !0;
              }
              function tn() {
                ie = !1;
              }
              function ye(Le) {
                Le && Le.supplementalProperties && Le.supplementalProperties[h.default.SUPPLEMENTAL_PROPERTY_DVB_LL_SCHEME] === "true" && (y.debug("Low Latency critical SupplementalProperty set: Enabling low Latency"), J = !0);
              }
              function ze() {
                D.addEventListener("canplay", Ne), D.addEventListener("canplaythrough", He), D.addEventListener("play", nt), D.addEventListener("waiting", ut), D.addEventListener("playing", pt), D.addEventListener("pause", vt), D.addEventListener("error", gt), D.addEventListener("seeking", Ut), D.addEventListener("seeked", Je), D.addEventListener("timeupdate", Te), D.addEventListener("progress", me), D.addEventListener("ratechange", Me), D.addEventListener("loadedmetadata", Be), D.addEventListener("loadeddata", Fe), D.addEventListener("stalled", _t), D.addEventListener("ended", Ze), D.addEventListener("volumechange", ot);
              }
              function ft() {
                D.removeEventListener("canplay", Ne), D.removeEventListener("canplaythrough", He), D.removeEventListener("play", nt), D.removeEventListener("waiting", ut), D.removeEventListener("playing", pt), D.removeEventListener("pause", vt), D.removeEventListener("error", gt), D.removeEventListener("seeking", Ut), D.removeEventListener("seeked", Je), D.removeEventListener("timeupdate", Te), D.removeEventListener("progress", me), D.removeEventListener("ratechange", Me), D.removeEventListener("loadedmetadata", Be), D.removeEventListener("loadeddata", Fe), D.removeEventListener("stalled", _t), D.removeEventListener("ended", Ze), D.removeEventListener("volumechange", ot);
              }
              return R = {
                initialize: de,
                setConfig: De,
                getTimeToStreamEnd: se,
                getBufferLevel: be,
                getPlaybackStalled: he,
                getTime: X,
                getLowLatencyModeEnabled: We,
                getInitialCatchupModeActivated: kt,
                getIsManifestUpdateInProgress: ge,
                getPlaybackRate: Q,
                getPlayedRanges: fe,
                getEnded: ue,
                getIsDynamic: q,
                getStreamController: _e,
                computeAndSetLiveDelay: ke,
                getLiveDelay: Ee,
                getOriginalLiveDelay: Re,
                getCurrentLiveLatency: Pe,
                play: te,
                isPaused: K,
                isStalled: V,
                pause: le,
                isSeeking: U,
                getStreamEndTime: ee,
                seek: ne,
                seekToOriginalLive: x,
                seekToCurrentLive: P,
                reset: oe,
                updateCurrentTime: Ae,
                getAvailabilityStartTime: Ce
              }, z(), R;
            }
            b.__dashjs_factory_name = "PlaybackController";
            const S = d.default.getSingletonFactory(b);
          }
        ),
        /***/
        "./src/streaming/controllers/ScheduleController.js": (
          /*!*********************************************************!*\
            !*** ./src/streaming/controllers/ScheduleController.js ***!
            \*********************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => S
              /* harmony export */
            });
            var h = i(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), f = i(
              /*! ../models/FragmentModel */
              "./src/streaming/models/FragmentModel.js"
            ), p = i(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), d = i(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), v = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), g = i(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), m = i(
              /*! ../constants/MetricsConstants */
              "./src/streaming/constants/MetricsConstants.js"
            ), A = i(
              /*! ../MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            );
            function b(N) {
              N = N || {};
              var T = this.context, R = (0, p.default)(T).getInstance(), y = N.dashMetrics, E = N.mediaPlayerModel, L = N.fragmentModel, _ = N.abrController, O = N.playbackController, D = N.textController, M = N.type, C = N.bufferController, I = N.settings, w, F, k, H, Z, Y, j, J, ae, G, $, ie, re;
              function ce() {
                k = (0, g.default)(T).getInstance().getLogger(w), ke(), F = N.streamInfo;
              }
              function z(Ie) {
                j = Ie, R.on(d.default.BYTES_APPENDED_END_FRAGMENT, ue, w), R.on(d.default.URL_RESOLUTION_FAILED, q, w), R.on(A.default.PLAYBACK_STARTED, _e, w), R.on(A.default.PLAYBACK_RATE_CHANGED, ge, w), R.on(A.default.PLAYBACK_TIME_UPDATED, Q, w);
              }
              function oe() {
                return M;
              }
              function de() {
                return F.id;
              }
              function pe(Ie) {
                H = Ie;
              }
              function he(Ie) {
                if (!C.getIsBufferingCompleted()) {
                  se();
                  var Xe = isNaN(Ie) ? 0 : Ie;
                  Y = setTimeout(te, Xe);
                }
              }
              function se() {
                Y && (clearTimeout(Y), Y = null);
              }
              function ee() {
                var Ie = F.id, Xe = _.getMaxAllowedIndexFor(M, Ie);
                return isNaN(ae) || ae != Xe ? (k.info("Top quality " + M + " index has changed from " + ae + " to " + Xe), ae = Xe, !0) : !1;
              }
              function te() {
                try {
                  if (ne()) {
                    se();
                    return;
                  }
                  if (x()) {
                    var Ie = !1;
                    re && (Ie = _.checkPlaybackQuality(M, F.id)), Ie || le();
                  } else
                    he(O.getLowLatencyModeEnabled() ? I.get().streaming.scheduling.lowLatencyTimeout : I.get().streaming.scheduling.defaultTimeout);
                } catch {
                  he(O.getLowLatencyModeEnabled() ? I.get().streaming.scheduling.lowLatencyTimeout : I.get().streaming.scheduling.defaultTimeout);
                }
              }
              function le() {
                ie || H.quality !== G || $ ? ($ ? (k.debug("Switch track for " + M + ", representation id = " + H.id), $ = !1) : k.debug("Quality has changed, get init request for representationid = " + H.id), R.trigger(d.default.INIT_FRAGMENT_NEEDED, {
                  representationId: H.id,
                  sender: w
                }, {
                  streamId: F.id,
                  mediaType: M
                }), re = !1, ie = !1) : (k.debug("Media segment needed for ".concat(M, " and stream id ").concat(F.id)), R.trigger(d.default.MEDIA_FRAGMENT_NEEDED, {}, {
                  streamId: F.id,
                  mediaType: M
                }), re = !0);
              }
              function ne() {
                try {
                  return M === h.default.TEXT && !D.isTextEnabled() || O.isPaused() && (!O.getStreamController().getInitialPlayback() || !O.getStreamController().getAutoPlay()) && !I.get().streaming.scheduling.scheduleWhilePaused;
                } catch {
                  return !1;
                }
              }
              function x() {
                try {
                  return H && (isNaN(G) || $ || ee() || P());
                } catch {
                  return !1;
                }
              }
              function P() {
                if (!M || !H)
                  return !0;
                var Ie = y.getCurrentBufferLevel(M);
                return Ie < B();
              }
              function B() {
                var Ie = NaN;
                return !M || !H || (M === h.default.TEXT ? Ie = W() : M === h.default.AUDIO && j ? Ie = X() : Ie = K()), Ie;
              }
              function W() {
                try {
                  if (D.isTextEnabled())
                    if (isNaN(H.fragmentDuration)) {
                      var Ie = y.getCurrentSchedulingInfo(m.default.SCHEDULING_INFO);
                      return Ie ? Ie.duration : 0;
                    } else
                      return H.fragmentDuration;
                  else
                    return 0;
                } catch {
                  return 0;
                }
              }
              function X() {
                try {
                  var Ie = y.getCurrentBufferLevel(h.default.VIDEO);
                  return isNaN(H.fragmentDuration) ? Ie + 1 : Math.max(Ie + 1, H.fragmentDuration);
                } catch {
                  return 0;
                }
              }
              function K() {
                try {
                  var Ie = H.mediaInfo.streamInfo;
                  if (_.isPlayingAtTopQuality(Ie)) {
                    var Xe = Ie.manifestInfo.duration >= I.get().streaming.buffer.longFormContentDurationThreshold;
                    return Xe ? I.get().streaming.buffer.bufferTimeAtTopQualityLongForm : I.get().streaming.buffer.bufferTimeAtTopQuality;
                  } else
                    return E.getStableBufferTime();
                } catch {
                  return E.getStableBufferTime();
                }
              }
              function U(Ie) {
                $ = Ie;
              }
              function V() {
                return $;
              }
              function Q() {
                fe(!0);
              }
              function fe(Ie) {
                if (O && L) {
                  var Xe = L.getRequests({
                    state: f.default.FRAGMENT_MODEL_EXECUTED,
                    time: O.getTime(),
                    threshold: 0
                  })[0];
                  Xe && O.getTime() >= Xe.startTime && ((!J.mediaInfo || Xe.mediaInfo.type === J.mediaInfo.type && Xe.mediaInfo.id !== J.mediaInfo.id) && Ie && R.trigger(d.default.TRACK_CHANGE_RENDERED, {
                    mediaType: M,
                    oldMediaInfo: J.mediaInfo,
                    newMediaInfo: Xe.mediaInfo,
                    streamId: F.id
                  }), (Xe.quality !== J.quality || Xe.adaptationIndex !== J.adaptationIndex) && Ie && (k.debug("Quality change rendered for streamId ".concat(F.id, " and type ").concat(M)), R.trigger(d.default.QUALITY_CHANGE_RENDERED, {
                    mediaType: M,
                    oldQuality: J.quality,
                    newQuality: Xe.quality,
                    streamId: F.id
                  })), J = {
                    mediaInfo: Xe.mediaInfo,
                    quality: Xe.quality,
                    adaptationIndex: Xe.adaptationIndex
                  });
                }
              }
              function ue(Ie) {
                k.debug("Appended bytes for ".concat(Ie.mediaType, " and stream id ").concat(F.id)), (isNaN(Ie.index) || isNaN(G)) && (G = Ie.quality, k.info("[" + M + "] lastInitializedRepresentationInfo changed to " + Ie.quality)), he(0);
              }
              function q() {
                L.abortRequests(), se();
              }
              function _e() {
                I.get().streaming.scheduling.scheduleWhilePaused || he();
              }
              function ge(Ie) {
                y.updatePlayListTraceMetrics({
                  playbackspeed: Ie.playbackRate.toString()
                });
              }
              function Ce(Ie) {
                Z = Ie;
              }
              function Ee() {
                return Z;
              }
              function Re(Ie) {
                re = Ie;
              }
              function Pe(Ie) {
                ie = Ie;
              }
              function ke() {
                re = !0, Z = 0, G = NaN, J = {
                  mediaInfo: void 0,
                  quality: NaN,
                  adaptationIndex: NaN
                }, ae = NaN, $ = !1, ie = !1;
              }
              function De() {
                R.off(d.default.BYTES_APPENDED_END_FRAGMENT, ue, w), R.off(d.default.URL_RESOLUTION_FAILED, q, w), R.off(A.default.PLAYBACK_STARTED, _e, w), R.off(A.default.PLAYBACK_RATE_CHANGED, ge, w), R.off(A.default.PLAYBACK_TIME_UPDATED, Q, w), se(), fe(!1), ke(), F = null;
              }
              function Ae() {
                return O;
              }
              return w = {
                initialize: z,
                getType: oe,
                getStreamId: de,
                setCurrentRepresentation: pe,
                setTimeToLoadDelay: Ce,
                getTimeToLoadDelay: Ee,
                setSwitchTrack: U,
                getSwitchStrack: V,
                startScheduleTimer: he,
                clearScheduleTimer: se,
                reset: De,
                getBufferTarget: B,
                getPlaybackController: Ae,
                setCheckPlaybackQuality: Re,
                setInitSegmentRequired: Pe
              }, ce(), w;
            }
            b.__dashjs_factory_name = "ScheduleController";
            const S = v.default.getClassFactory(b);
          }
        ),
        /***/
        "./src/streaming/controllers/StreamController.js": (
          /*!*******************************************************!*\
            !*** ./src/streaming/controllers/StreamController.js ***!
            \*******************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => Z
              /* harmony export */
            });
            var h = i(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), f = i(
              /*! ../constants/MetricsConstants */
              "./src/streaming/constants/MetricsConstants.js"
            ), p = i(
              /*! ../Stream */
              "./src/streaming/Stream.js"
            ), d = i(
              /*! ../ManifestUpdater */
              "./src/streaming/ManifestUpdater.js"
            ), v = i(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), g = i(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), m = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), A = i(
              /*! ../vo/metrics/PlayList */
              "./src/streaming/vo/metrics/PlayList.js"
            ), b = i(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), S = i(
              /*! ../utils/InitCache */
              "./src/streaming/utils/InitCache.js"
            ), N = i(
              /*! ../MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), T = i(
              /*! ./TimeSyncController */
              "./src/streaming/controllers/TimeSyncController.js"
            ), R = i(
              /*! ./MediaSourceController */
              "./src/streaming/controllers/MediaSourceController.js"
            ), y = i(
              /*! ../vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), E = i(
              /*! ../../core/errors/Errors */
              "./src/core/errors/Errors.js"
            ), L = i(
              /*! ./EventController */
              "./src/streaming/controllers/EventController.js"
            ), _ = i(
              /*! ../constants/ConformanceViolationConstants */
              "./src/streaming/constants/ConformanceViolationConstants.js"
            );
            function O(Y) {
              return I(Y) || C(Y) || M(Y) || D();
            }
            function D() {
              throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }
            function M(Y, j) {
              if (Y) {
                if (typeof Y == "string")
                  return w(Y, j);
                var J = Object.prototype.toString.call(Y).slice(8, -1);
                if (J === "Object" && Y.constructor && (J = Y.constructor.name), J === "Map" || J === "Set")
                  return Array.from(Y);
                if (J === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(J))
                  return w(Y, j);
              }
            }
            function C(Y) {
              if (typeof Symbol < "u" && Symbol.iterator in Object(Y))
                return Array.from(Y);
            }
            function I(Y) {
              if (Array.isArray(Y))
                return w(Y);
            }
            function w(Y, j) {
              (j == null || j > Y.length) && (j = Y.length);
              for (var J = 0, ae = new Array(j); J < j; J++)
                ae[J] = Y[J];
              return ae;
            }
            var F = 200, k = 2;
            function H() {
              var Y = this.context, j = (0, v.default)(Y).getInstance(), J, ae, G, $, ie, re, ce, z, oe, de, pe, he, se, ee, te, le, ne, x, P, B, W, X, K, U, V, Q, fe, ue, q, _e, ge, Ce, Ee, Re, Pe, ke, De, Ae, Ie, Xe, it, rt, Ne, He, $e, nt, ut, pt;
              function vt() {
                ae = (0, b.default)(Y).getInstance().getLogger(J), pe = (0, T.default)(Y).getInstance(), de = (0, R.default)(Y).getInstance(), P = (0, S.default)(Y).getInstance(), Us();
              }
              function Ut(xe, at) {
                me(), fe = xe, Q = at, W.initialize(), ie = (0, d.default)(Y).create(), ie.setConfig({
                  manifestModel: ce,
                  adapter: z,
                  manifestLoader: re,
                  errHandler: B,
                  settings: He
                }), ie.initialize(), x = (0, L.default)(Y).getInstance(), x.setConfig({
                  manifestUpdater: ie,
                  playbackController: Ee,
                  settings: He
                }), x.start(), pe.setConfig({
                  dashMetrics: oe,
                  baseURLController: se,
                  errHandler: B,
                  settings: He
                }), pe.initialize(), U && (j.trigger(g.default.PROTECTION_CREATED, {
                  controller: U
                }), U.setMediaElement(Ce.getElement()), Q && U.setProtectionData(Q)), Je();
              }
              function Je() {
                j.on(N.default.PLAYBACK_TIME_UPDATED, Et, J), j.on(N.default.PLAYBACK_SEEKING, et, J), j.on(N.default.PLAYBACK_ERROR, Wi, J), j.on(N.default.PLAYBACK_STARTED, Vt, J), j.on(N.default.PLAYBACK_PAUSED, It, J), j.on(N.default.PLAYBACK_ENDED, we, J), j.on(N.default.METRIC_ADDED, ks, J), j.on(N.default.MANIFEST_VALIDITY_CHANGED, Fs, J), j.on(N.default.BUFFER_LEVEL_UPDATED, Le, J), j.on(N.default.QUALITY_CHANGE_REQUESTED, Ke, J), g.default.KEY_SESSION_UPDATED && j.on(g.default.KEY_SESSION_UPDATED, ot, J), j.on(g.default.MANIFEST_UPDATED, cr, J), j.on(g.default.STREAM_BUFFERING_COMPLETED, Pt, J), j.on(g.default.TIME_SYNCHRONIZATION_COMPLETED, Ze, J), j.on(g.default.CURRENT_TRACK_CHANGED, Qt, J), j.on(g.default.SETTING_UPDATED_LIVE_DELAY, Qe, J), j.on(g.default.SETTING_UPDATED_LIVE_DELAY_FRAGMENT_COUNT, Qe, J);
              }
              function Te() {
                j.off(N.default.PLAYBACK_TIME_UPDATED, Et, J), j.off(N.default.PLAYBACK_SEEKING, et, J), j.off(N.default.PLAYBACK_ERROR, Wi, J), j.off(N.default.PLAYBACK_STARTED, Vt, J), j.off(N.default.PLAYBACK_PAUSED, It, J), j.off(N.default.PLAYBACK_ENDED, we, J), j.off(N.default.METRIC_ADDED, ks, J), j.off(N.default.MANIFEST_VALIDITY_CHANGED, Fs, J), j.off(N.default.BUFFER_LEVEL_UPDATED, Le, J), j.off(N.default.QUALITY_CHANGE_REQUESTED, Ke, J), g.default.KEY_SESSION_UPDATED && j.off(g.default.KEY_SESSION_UPDATED, ot, J), j.off(g.default.MANIFEST_UPDATED, cr, J), j.off(g.default.STREAM_BUFFERING_COMPLETED, Pt, J), j.off(g.default.TIME_SYNCHRONIZATION_COMPLETED, Ze, J), j.off(g.default.CURRENT_TRACK_CHANGED, Qt, J), j.off(g.default.SETTING_UPDATED_LIVE_DELAY, Qe, J), j.off(g.default.SETTING_UPDATED_LIVE_DELAY_FRAGMENT_COUNT, Qe, J);
              }
              function me() {
                if (!re || !re.hasOwnProperty("load") || !W || !W.hasOwnProperty("initialize") || !W.hasOwnProperty("reset") || !W.hasOwnProperty("getClientTimeOffset") || !ce || !B || !oe || !Ee)
                  throw new Error(h.default.MISSING_CONFIG_ERROR);
              }
              function Me() {
                if (!ie || !ie.hasOwnProperty("setManifest"))
                  throw new Error("initialize function has to be called previously");
              }
              function Be(xe) {
                var at = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : NaN;
                me(), ut = at, re.load(xe);
              }
              function Fe(xe) {
                var at = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : NaN;
                Me(), ut = at, ie.setManifest(xe);
              }
              function Ze() {
                tt();
              }
              function ot() {
                $e = !0;
              }
              function tt() {
                try {
                  var xe = z.getStreamsInfo();
                  if (!K && xe.length === 0)
                    throw new Error("There are no periods in the MPD");
                  K && xe.length > 0 && oe.updateManifestUpdateInfo({
                    currentTime: Ee.getTime(),
                    buffered: Ce.getBufferRange(),
                    presentationStartTime: xe[0].start,
                    clientTimeOffset: W.getClientTimeOffset()
                  }), X.length > 0 && Or(xe);
                  for (var at = [], At = 0, jt = xe.length; At < jt; At++) {
                    var zt = xe[At];
                    at.push(gt(zt)), oe.addManifestUpdateStreamInfo(zt);
                  }
                  Promise.all(at).then(function() {
                    return He.get().streaming.applyContentSteering && !K && he.shouldQueryBeforeStart() ? he.loadSteeringData() : Promise.resolve();
                  }).then(function() {
                    K || Mt(xe), j.trigger(g.default.STREAMS_COMPOSED), mn();
                  }).catch(function(rn) {
                    throw rn;
                  });
                } catch (rn) {
                  B.error(new y.default(E.default.MANIFEST_ERROR_ID_NOSTREAMS_CODE, rn.message + " nostreamscomposed", ce.getValue())), _e = !0, Sa();
                }
              }
              function gt(xe) {
                var at = Mo(xe.id);
                return at ? at.updateData(xe) : (at = (0, p.default)(Y).create({
                  manifestModel: ce,
                  mediaPlayerModel: Pe,
                  dashMetrics: oe,
                  manifestUpdater: ie,
                  adapter: z,
                  timelineConverter: W,
                  capabilities: G,
                  capabilitiesFilter: $,
                  errHandler: B,
                  baseURLController: se,
                  segmentBaseController: ee,
                  textController: V,
                  abrController: le,
                  playbackController: Ee,
                  eventController: x,
                  mediaController: ne,
                  protectionController: U,
                  videoModel: Ce,
                  streamInfo: xe,
                  settings: He
                }), X.push(at), at.initialize(), Promise.resolve());
              }
              function Mt(xe) {
                ft();
                var at = oe.getCurrentDVRInfo().range;
                if (at.end < at.start) {
                  nt && clearTimeout(nt);
                  var At = Math.min(((at.end - at.start) * -1 + k) * 1e3, 2147483647);
                  ae.debug("Waiting for ".concat(At, " ms before playback can start")), j.trigger(g.default.AST_IN_FUTURE, {
                    delay: At
                  }), nt = setTimeout(function() {
                    Mt(xe);
                  }, At);
                  return;
                }
                He.get().streaming.applyProducerReferenceTime && Re.calculateProducerReferenceTimeOffsets(xe);
                var jt = xe[0].manifestInfo;
                if (He.get().streaming.applyServiceDescription && Re.applyServiceDescription(jt), z.getIsDynamic()) {
                  var zt = Yr(xe, jt);
                  Ee.computeAndSetLiveDelay(zt, jt);
                }
                var rn = Xt(), on = ze(rn), nr = on !== null ? on : X[0];
                j.trigger(g.default.INITIAL_STREAM_SWITCH, {
                  startTime: rn
                }), xt(nr, null, rn), Jt();
              }
              function xt(xe, at, At) {
                try {
                  if (ue || !xe || at === xe && xe.getIsActive())
                    return;
                  ue = !0, j.trigger(g.default.PERIOD_SWITCH_STARTED, {
                    fromStreamInfo: at ? at.getStreamInfo() : null,
                    toStreamInfo: xe.getStreamInfo()
                  });
                  var jt = !1;
                  K = xe, at && (jt = tn(xe, at), at.deactivate(jt)), At = isNaN(At) ? !jt && at ? xe.getStreamInfo().start : NaN : At, ae.info("Switch to stream ".concat(xe.getId(), ". Seektime is ").concat(At, ", current playback time is ").concat(Ee.getTime(), ". Seamless period switch is set to ").concat(jt)), rt = rt.filter(function(zt) {
                    return zt.getId() !== K.getId();
                  }), Ee.initialize(Xr(), !!at), Ce.getElement() ? be(At, jt, !1) : We(At, jt);
                } catch {
                  ue = !1;
                }
              }
              function be(xe, at) {
                var At = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, jt;
                function zt() {
                  if (!(!ge || ge.readyState !== "open")) {
                    ae.debug("MediaSource is open!"), window.URL.revokeObjectURL(jt), ge.removeEventListener("sourceopen", zt), ge.removeEventListener("webkitsourceopen", zt), Ge();
                    var on = oe.getCurrentDVRInfo();
                    de.setSeekable(on.range.start, on.range.end), At ? K.setMediaSource(ge).then(function() {
                      K.initializeForTextWithMediaSource(ge);
                    }) : We(xe, at);
                  }
                }
                function rn() {
                  ge.addEventListener("sourceopen", zt, !1), ge.addEventListener("webkitsourceopen", zt, !1), jt = de.attachMediaSource(Ce), ae.debug("MediaSource attached to element.  Waiting on open...");
                }
                ge ? at ? We(xe, at) : (de.detachMediaSource(Ce), rn()) : (ge = de.createMediaSource(), rn());
              }
              function We(xe, at) {
                K.activate(ge, at ? it : void 0, xe).then(function(At) {
                  if (At) {
                    var jt = Object.keys(At);
                    jt.length > 0 && At[jt[0]].getBuffer().changeType && (Ne = !0), it = At;
                  }
                  isNaN(xe) || (j.trigger(g.default.SEEK_TARGET, {
                    time: xe
                  }, {
                    streamId: K.getId()
                  }), Ee.seek(xe, !1, !0), K.startScheduleControllers()), ue = !1, j.trigger(g.default.PERIOD_SWITCH_COMPLETED, {
                    toStreamInfo: Xr()
                  });
                });
              }
              function et(xe) {
                var at = xe.seekTime, At = ze(at);
                !At || At === K ? (_t(), St(xe)) : At && At !== K && (_t(At), kt(xe, At)), ji(A.PlayList.SEEK_START_REASON);
              }
              function _t() {
                var xe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                ht();
              }
              function ht() {
                rt && rt.length > 0 && (rt.forEach(function(xe) {
                  xe.deactivate(!0);
                }), rt = []);
              }
              function St(xe) {
                var at = K.getProcessors();
                at.forEach(function(At) {
                  return At.prepareInnerPeriodPlaybackSeeking(xe);
                }), Pr(A.PlayListTrace.USER_REQUEST_STOP_REASON);
              }
              function kt(xe, at) {
                var At = xe && !isNaN(xe.seekTime) ? xe.seekTime : NaN, jt = K.getProcessors(), zt = jt.map(function(rn) {
                  return rn.prepareOuterPeriodPlaybackSeeking(xe);
                });
                Promise.all(zt).then(function() {
                  xt(at, K, At);
                }).catch(function(rn) {
                  B.error(rn);
                });
              }
              function Qt(xe) {
                xe.newMediaInfo.streamInfo.id === K.getId() && (ht(), K.prepareTrackChange(xe));
              }
              function tn(xe, at) {
                try {
                  return He.get().streaming.buffer.reuseExistingSourceBuffers && (at.isProtectionCompatible(xe) || $e) && (Ne || at.isMediaCodecCompatible(xe, at));
                } catch {
                  return !1;
                }
              }
              function ye(xe) {
                var at = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                if (ge && !xe.getPreloaded()) {
                  var At = tn(xe, at);
                  At && xe.startPreloading(ge, it).then(function() {
                    rt.push(xe);
                  });
                }
              }
              function ze(xe) {
                if (isNaN(xe))
                  return null;
                for (var at = X.length, At = 0; At < at; At++) {
                  var jt = X[At], zt = parseFloat((jt.getStartTime() + jt.getDuration()).toFixed(5));
                  if (xe < zt)
                    return jt;
                }
                return null;
              }
              function ft() {
                try {
                  var xe = z.getIsDynamic(), at = z.getStreamsInfo(), At = at[0].manifestInfo, jt = Ee.getTime(), zt = W.calcTimeShiftBufferWindow(X, xe), rn = bt();
                  if (typeof zt.start > "u" || typeof zt.end > "u")
                    return;
                  !rn || rn.length === 0 ? oe.addDVRInfo(h.default.VIDEO, jt, At, zt) : rn.forEach(function(on) {
                    oe.addDVRInfo(on.getType(), jt, At, zt);
                  });
                } catch {
                }
              }
              function Le(xe) {
                if (Ae && fe) {
                  var at = Pe.getInitialBufferLevel(), At = [h.default.TEXT];
                  (isNaN(at) || at <= Ee.getBufferLevel(At) || z.getIsDynamic() && at > Ee.getLiveDelay()) && (Ae = !1, ji(A.PlayList.INITIAL_PLAYOUT_START_REASON), Ee.play());
                }
                xe && xe.mediaType && oe.addBufferLevel(xe.mediaType, /* @__PURE__ */ new Date(), xe.bufferLevel * 1e3);
              }
              function Ke(xe) {
                xe.streamInfo.id === K.getId() && xe.reason && xe.reason.forceReplace && ht();
                var at = Mo(xe.streamInfo.id);
                at.prepareQualityChange(xe);
              }
              function Qe() {
                if (z.getIsDynamic() && Ee.getOriginalLiveDelay() !== 0 && K) {
                  var xe = z.getStreamsInfo();
                  if (xe.length > 0) {
                    var at = xe[0].manifestInfo, At = Yr(xe, at);
                    Ee.computeAndSetLiveDelay(At, at);
                  }
                }
              }
              function Et() {
                if (Ki()) {
                  var xe = Ce.getPlaybackQuality();
                  xe && oe.addDroppedFrames(xe);
                }
              }
              function Vt() {
                ae.debug("[onPlaybackStarted]"), !Ae && De && ji(A.PlayList.RESUME_FROM_PAUSE_START_REASON), Ae && (Ae = !1), Ie && (Ie = !1, He.get().streaming.applyContentSteering && !he.shouldQueryBeforeStart() && he.loadSteeringData()), De = !1;
              }
              function It(xe) {
                ae.debug("[onPlaybackPaused]"), xe.ended || (De = !0, Pr(A.PlayListTrace.USER_REQUEST_STOP_REASON));
              }
              function Pt(xe) {
                ae.debug("Stream with id ".concat(xe.streamInfo.id, " finished buffering"));
                var at = xe.streamInfo.isLast;
                ge && at ? (ae.info("[onStreamBufferingCompleted] calls signalEndOfStream of mediaSourceController."), de.signalEndOfStream(ge)) : mn();
              }
              function mn() {
                if (!(!K || !K.getHasFinishedBuffering()))
                  for (var xe = Se(K), at = 0; at < xe.length; ) {
                    var At = xe[at], jt = at === 0 ? K : xe[at - 1];
                    !At.getPreloaded() && jt.getHasFinishedBuffering() && ge && ye(At, jt), at += 1;
                  }
              }
              function Jt() {
                Xe || (Xe = setInterval(function() {
                  !ue && Ee.getTimeToStreamEnd() <= 0 && !Ee.isSeeking() && j.trigger(g.default.PLAYBACK_ENDED, {
                    isLast: Xr().isLast
                  });
                }, F));
              }
              function qe() {
                Xe && (clearInterval(Xe), Xe = null);
              }
              function Rt(xe, at) {
                for (var At = null, jt = 0, zt = 0, rn = null, on = 0; on < X.length; on++) {
                  if (At = X[on], zt = At.getStartTime(), rn = At.getDuration(), Number.isFinite(zt) && (jt = zt), At.getId() === at)
                    return xe - jt;
                  Number.isFinite(rn) && (jt += rn);
                }
                return null;
              }
              function bt() {
                return K ? K.getProcessors() : [];
              }
              function we(xe) {
                if (K && !K.getIsEndedEventSignaled()) {
                  K.setIsEndedEventSignaled(!0);
                  var at = Ve();
                  at ? (ae.debug("StreamController onEnded, found next stream with id ".concat(at.getStreamInfo().id, ". Switching from ").concat(K.getStreamInfo().id, " to ").concat(at.getStreamInfo().id)), xt(at, K, NaN)) : (ae.debug("StreamController no next stream found"), K.setIsEndedEventSignaled(!1)), Pr(at ? A.PlayListTrace.END_OF_PERIOD_STOP_REASON : A.PlayListTrace.END_OF_CONTENT_STOP_REASON);
                }
                xe && xe.isLast && (qe(), he.stopSteeringRequestTimer());
              }
              function Ve() {
                var xe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, at = xe || K || null;
                if (!at)
                  return null;
                for (var At = at.getStreamInfo(), jt = At.start, zt = 0, rn = -1, on = NaN; zt < X.length; ) {
                  var nr = X[zt], Mn = nr.getStreamInfo(), Ir = Mn.start - jt;
                  Ir > 0 && (isNaN(on) || Ir < on) && At.id !== Mn.id && (on = Ir, rn = zt), zt += 1;
                }
                return rn >= 0 ? X[rn] : null;
              }
              function Se() {
                var xe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                try {
                  var at = xe || K || null;
                  if (at) {
                    var At = at.getStreamInfo();
                    return X.filter(function(jt) {
                      var zt = jt.getStreamInfo();
                      return zt.start > At.start && At.id !== zt.id;
                    });
                  }
                } catch {
                  return [];
                }
              }
              function Ge(xe) {
                var at = xe || Xr().manifestInfo.duration;
                de.setDuration(at);
              }
              function ct() {
                return K;
              }
              function Ot() {
                return Ae;
              }
              function wt() {
                return fe;
              }
              function Xt() {
                var xe, at = z.getIsDynamic();
                if (at) {
                  var At = oe.getCurrentDVRInfo(), jt = At && At.range ? At.range.end : 0;
                  xe = jt - Ee.getOriginalLiveDelay();
                  var zt = At ? At.range : null;
                  if (zt) {
                    if (!isNaN(ut) || ut.toString().indexOf("posix:") !== -1) {
                      ae.info("Start time provided by the app: ".concat(ut));
                      var rn = Yt(!0, ut);
                      isNaN(rn) || (xe = Math.min(xe, rn));
                    } else {
                      var on = nn(!0);
                      isNaN(on) || (ae.info("Start time from URI parameters: ".concat(on)), xe = Math.min(xe, on));
                    }
                    var nr = He.get().streaming.timeShiftBuffer.calcFromSegmentTimeline ? 0.1 : 0;
                    xe = Math.max(xe, zt.start + nr);
                  }
                } else {
                  var Mn = Vi(), Ir = Mn[0].getStreamInfo();
                  if (xe = Ir.start, isNaN(ut)) {
                    var Hi = nn(!1);
                    isNaN(Hi) || (ae.info("Start time from URI parameters: ".concat(Hi)), xe = Math.max(xe, Hi));
                  } else {
                    ae.info("Start time provided by the app: ".concat(ut));
                    var Qn = Yt(!1, ut);
                    isNaN(Qn) || (xe = Math.max(xe, Qn));
                  }
                }
                return xe;
              }
              function nn(xe) {
                var at = te.getURIFragmentData();
                if (!at || !at.t)
                  return NaN;
                var At = Vi()[0], jt = At.getStreamInfo().start;
                return at.t = at.t.split(",")[0], Dn(xe, at.t, jt);
              }
              function Yt(xe, at) {
                var At = 0;
                if (!xe) {
                  var jt = Vi()[0];
                  At = jt.getStreamInfo().start;
                }
                return Dn(xe, at, At);
              }
              function Dn(xe, at, At) {
                var jt = z.getRegularPeriods()[0], zt = at.toString(), rn = zt.indexOf("posix:") !== -1 ? zt.substring(6) === "now" ? Date.now() / 1e3 : parseFloat(zt.substring(6)) : NaN, on = xe && !isNaN(rn) ? W.calcPresentationTimeFromWallTime(new Date(rn * 1e3), jt) : parseFloat(zt) + At;
                return on;
              }
              function Or(xe) {
                if (xe.length === 0) {
                  ae.warn("No periods included in the current manifest. Skipping the filtering of outdated stream objects.");
                  return;
                }
                X = X.filter(function(at) {
                  var At = xe.filter(function(zt) {
                    return zt.id === at.getId();
                  }).length > 0, jt = At || at.getId() === K.getId();
                  return jt || (ae.debug("Removing stream ".concat(at.getId())), at.reset(!0)), jt;
                });
              }
              function Yr(xe, at) {
                try {
                  var At = NaN;
                  if (at && !isNaN(at.maxFragmentDuration) && isFinite(at.maxFragmentDuration))
                    return at.maxFragmentDuration;
                  if (xe && xe.length === 1) {
                    var jt = xe[0], zt = [h.default.VIDEO, h.default.AUDIO, h.default.TEXT], rn = zt.reduce(function(on, nr) {
                      var Mn = z.getMediaInfoForType(jt, nr);
                      return Mn && Mn.isFragmented !== !1 && on.push(Mn), on;
                    }, []).reduce(function(on, nr) {
                      var Mn = z.getVoRepresentations(nr);
                      return Mn && Mn.length > 0 && Mn.forEach(function(Ir) {
                        Ir && on.push(Ir);
                      }), on;
                    }, []).reduce(function(on, nr) {
                      var Mn = z.convertRepresentationToRepresentationInfo(nr);
                      return Mn && Mn.fragmentDuration && !isNaN(Mn.fragmentDuration) && on.push(Mn.fragmentDuration), on;
                    }, []);
                    At = Math.max.apply(Math, O(rn));
                  }
                  return isFinite(At) ? At : NaN;
                } catch {
                  return NaN;
                }
              }
              function cr(xe) {
                if (xe.error)
                  _e = !0, Sa();
                else {
                  ae.info("Manifest updated... updating data system wide.");
                  var at = xe.manifest;
                  z.updatePeriods(at);
                  var At = z.getUTCTimingSources();
                  z.getIsDynamic() && (!At || At.length === 0) && j.trigger(N.default.CONFORMANCE_VIOLATION, {
                    level: _.default.LEVELS.WARNING,
                    event: _.default.EVENTS.NO_UTC_TIMING_ELEMENT
                  });
                  var jt = z.getIsDynamic() ? At.concat(ke.getUTCTimingSources()) : At;
                  $.filterUnsupportedFeatures(at).then(function() {
                    se.initialize(at), pe.attemptSync(jt, z.getIsDynamic());
                  });
                }
              }
              function Ki() {
                return K ? K.getHasVideoTrack() : !1;
              }
              function Aa() {
                return K ? K.getHasAudioTrack() : !1;
              }
              function Co(xe) {
                K && (Ee.initialize(Xr()), be(xe, !1, !0));
              }
              function Pr(xe, at) {
                at = at || /* @__PURE__ */ new Date(), bt().forEach(function(At) {
                  At.finalisePlayList(at, xe);
                }), oe.addPlayList();
              }
              function ji(xe) {
                oe.createPlaylistMetrics(Ee.getTime() * 1e3, xe);
              }
              function Wi(xe) {
                if (xe.error) {
                  var at = "";
                  switch (xe.error.code) {
                    case 1:
                      at = "MEDIA_ERR_ABORTED";
                      break;
                    case 2:
                      at = "MEDIA_ERR_NETWORK";
                      break;
                    case 3:
                      at = "MEDIA_ERR_DECODE", pt.counts.mediaErrorDecode += 1;
                      break;
                    case 4:
                      at = "MEDIA_ERR_SRC_NOT_SUPPORTED";
                      break;
                    case 5:
                      at = "MEDIA_ERR_ENCRYPTED";
                      break;
                    default:
                      at = "UNKNOWN";
                      break;
                  }
                  if (at === "MEDIA_ERR_DECODE" && He.get().errors.recoverAttempts.mediaErrorDecode >= pt.counts.mediaErrorDecode) {
                    Bs();
                    return;
                  }
                  q = !0, xe.error.message && (at += " (" + xe.error.message + ")"), xe.error.msExtendedCode && (at += " (0x" + (xe.error.msExtendedCode >>> 0).toString(16).toUpperCase() + ")"), ae.fatal("Video Element Error: " + at), xe.error && ae.fatal(xe.error), B.error(new y.default(xe.error.code, at)), Sa();
                }
              }
              function Bs() {
                ae.warn("A MEDIA_ERR_DECODE occured: Resetting the MediaSource");
                var xe = Ee.getTime();
                K.deactivate(!1), ae.warn("MediaSource has been resetted. Resuming playback from time ".concat(xe)), be(xe, !1, !1);
              }
              function Xr() {
                return K ? K.getStreamInfo() : null;
              }
              function fu() {
                return ue;
              }
              function du() {
                return q || _e;
              }
              function Mo(xe) {
                for (var at = 0, At = X.length; at < At; at++)
                  if (X[at].getId() === xe)
                    return X[at];
                return null;
              }
              function Fs(xe) {
                isNaN(xe.newDuration) || Ge(xe.newDuration);
              }
              function hu(xe) {
                xe && (xe.capabilities && (G = xe.capabilities), xe.capabilitiesFilter && ($ = xe.capabilitiesFilter), xe.manifestLoader && (re = xe.manifestLoader), xe.manifestModel && (ce = xe.manifestModel), xe.mediaPlayerModel && (Pe = xe.mediaPlayerModel), xe.customParametersModel && (ke = xe.customParametersModel), xe.protectionController && (U = xe.protectionController), xe.adapter && (z = xe.adapter), xe.dashMetrics && (oe = xe.dashMetrics), xe.errHandler && (B = xe.errHandler), xe.timelineConverter && (W = xe.timelineConverter), xe.videoModel && (Ce = xe.videoModel), xe.playbackController && (Ee = xe.playbackController), xe.serviceDescriptionController && (Re = xe.serviceDescriptionController), xe.contentSteeringController && (he = xe.contentSteeringController), xe.textController && (V = xe.textController), xe.abrController && (le = xe.abrController), xe.mediaController && (ne = xe.mediaController), xe.settings && (He = xe.settings), xe.baseURLController && (se = xe.baseURLController), xe.uriFragmentModel && (te = xe.uriFragmentModel), xe.segmentBaseController && (ee = xe.segmentBaseController));
              }
              function pu(xe) {
                Q = xe, U && U.setProtectionData(Q);
              }
              function Us() {
                X = [], ut = NaN, U = null, ue = !1, K = null, q = !1, _e = !1, Ae = !0, Ie = !0, De = !1, fe = !0, Xe = null, $e = !1, Ne = !1, rt = [], nt = null, pt = {
                  counts: {
                    mediaErrorDecode: 0
                  }
                };
              }
              function Sa() {
                me(), pe.reset(), Pr(q || _e ? A.PlayListTrace.FAILURE_STOP_REASON : A.PlayListTrace.USER_REQUEST_STOP_REASON);
                for (var xe = 0, at = X ? X.length : 0; xe < at; xe++) {
                  var At = X[xe];
                  At.reset(q);
                }
                Te(), se.reset(), ie.reset(), x.reset(), oe.clearAllCurrentMetrics(), ce.setValue(null), re.reset(), W.reset(), P.reset(), ge && (de.detachMediaSource(Ce), ge = null), Ce = null, U && (U = null, Q = null, ce.getValue() && j.trigger(g.default.PROTECTION_DESTROYED, {
                  data: ce.getValue().url
                })), qe(), j.trigger(g.default.STREAM_TEARDOWN_COMPLETE), Us();
              }
              function ks(xe) {
                if (xe.metric === f.default.DVR_INFO) {
                  var at = Aa() ? h.default.AUDIO : h.default.VIDEO;
                  xe.mediaType === at && de.setSeekable(xe.value.range.start, xe.value.range.end);
                }
              }
              function Vi() {
                return X;
              }
              return J = {
                initialize: Ut,
                getActiveStreamInfo: Xr,
                addDVRMetric: ft,
                hasVideoTrack: Ki,
                hasAudioTrack: Aa,
                getStreamById: Mo,
                getStreamForTime: ze,
                getTimeRelativeToStreamId: Rt,
                load: Be,
                loadWithManifest: Fe,
                getActiveStreamProcessors: bt,
                setConfig: hu,
                setProtectionData: pu,
                getIsStreamSwitchInProgress: fu,
                switchToVideoElement: Co,
                getHasMediaOrInitialisationError: du,
                getStreams: Vi,
                getActiveStream: ct,
                getInitialPlayback: Ot,
                getAutoPlay: wt,
                reset: Sa
              }, vt(), J;
            }
            H.__dashjs_factory_name = "StreamController";
            const Z = m.default.getSingletonFactory(H);
          }
        ),
        /***/
        "./src/streaming/controllers/TimeSyncController.js": (
          /*!*********************************************************!*\
            !*** ./src/streaming/controllers/TimeSyncController.js ***!
            \*********************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => D
              /* harmony export */
            });
            var h = i(
              /*! ./../vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), f = i(
              /*! ../vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            ), p = i(
              /*! ./../../core/EventBus */
              "./src/core/EventBus.js"
            ), d = i(
              /*! ./../../core/events/Events */
              "./src/core/events/Events.js"
            ), v = i(
              /*! ./../../core/errors/Errors */
              "./src/core/errors/Errors.js"
            ), g = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), m = i(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), A = i(
              /*! ../utils/URLUtils */
              "./src/streaming/utils/URLUtils.js"
            ), b = 5e3, S = 100, N = 2, T = 2, R = 30, y = 30, E = 600, L = 2;
            function _() {
              var M = this.context, C = (0, p.default)(M).getInstance(), I = (0, A.default)(M).getInstance(), w, F, k, H, Z, Y, j, J, ae, G, $, ie, re, ce, z, oe;
              function de() {
                F = (0, m.default)(M).getInstance().getLogger(w), C.on(d.default.ATTEMPT_BACKGROUND_SYNC, te, w);
              }
              function pe(Pe) {
                Pe && (Pe.dashMetrics && (j = Pe.dashMetrics), Pe.baseURLController && (oe = Pe.baseURLController), Pe.errHandler && (z = Pe.errHandler), Pe.settings && (Z = Pe.settings));
              }
              function he() {
                J = [], ae = [], G = null, $ = null, re = null, ie = NaN, k = !1, H = !1, ce = Z.get().streaming.utcSynchronization.timeBetweenSyncAttempts;
              }
              function se() {
                he(), Y = {
                  "urn:mpeg:dash:utc:http-head:2014": ue,
                  "urn:mpeg:dash:utc:http-xsdate:2014": fe.bind(null, X),
                  "urn:mpeg:dash:utc:http-iso:2014": fe.bind(null, K),
                  "urn:mpeg:dash:utc:direct:2014": Q,
                  // some specs referencing early ISO23009-1 drafts incorrectly use
                  // 2012 in the URI, rather than 2014. support these for now.
                  "urn:mpeg:dash:utc:http-head:2012": ue,
                  "urn:mpeg:dash:utc:http-xsdate:2012": fe.bind(null, X),
                  "urn:mpeg:dash:utc:http-iso:2012": fe.bind(null, K),
                  "urn:mpeg:dash:utc:direct:2012": Q,
                  // it isn't clear how the data returned would be formatted, and
                  // no public examples available so http-ntp not supported for now.
                  // presumably you would do an arraybuffer type xhr and decode the
                  // binary data returned but I would want to see a sample first.
                  "urn:mpeg:dash:utc:http-ntp:2014": V,
                  // not clear how this would be supported in javascript (in browser)
                  "urn:mpeg:dash:utc:ntp:2014": V,
                  "urn:mpeg:dash:utc:sntp:2014": V
                };
              }
              function ee(Pe, ke) {
                if (ae = Pe, !k) {
                  if (!P(ke)) {
                    C.trigger(d.default.TIME_SYNCHRONIZATION_COMPLETED);
                    return;
                  }
                  k = !0, ne();
                }
              }
              function te() {
                if (!(!Z.get().streaming.utcSynchronization.enabled || k || H || !re || !re.value || !re.schemeIdUri || isNaN(ie) || isNaN(Z.get().streaming.utcSynchronization.backgroundAttempts)) && !($ && (Date.now() - $) / 1e3 < y)) {
                  J = [], H = !0;
                  var Pe = isNaN(Z.get().streaming.utcSynchronization.backgroundAttempts) ? T : Z.get().streaming.utcSynchronization.backgroundAttempts;
                  le(Pe);
                }
              }
              function le(Pe) {
                try {
                  if (Pe <= 0) {
                    Ce();
                    return;
                  }
                  var ke = Date.now();
                  Y[re.schemeIdUri](re.value, function(De) {
                    var Ae = Date.now(), Ie = x(ke, Ae, De);
                    J.push(Ie), le(Pe - 1);
                  }, function() {
                    Ce();
                  });
                } catch {
                  Ce();
                }
              }
              function ne() {
                var Pe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, ke = Pe || 0;
                if (!ae || ae.length === 0 || ke >= ae.length) {
                  B();
                  return;
                }
                var De = ae[ke];
                if (De)
                  if (Y.hasOwnProperty(De.schemeIdUri)) {
                    var Ae = (/* @__PURE__ */ new Date()).getTime();
                    Y[De.schemeIdUri](De.value, function(Ie) {
                      var Xe = (/* @__PURE__ */ new Date()).getTime(), it = x(Ae, Xe, Ie);
                      re = De, B(it);
                    }, function() {
                      ne(ke + 1);
                    });
                  } else
                    ne(ke + 1);
                else
                  B();
              }
              function x(Pe, ke, De) {
                var Ae = ke - (ke - Pe) / 2;
                return De - Ae;
              }
              function P(Pe) {
                try {
                  if (!Pe || !Z.get().streaming.utcSynchronization.enabled)
                    return !1;
                  var ke = isNaN(ce) ? R : ce;
                  return !G || !ke || isNaN(ke) ? !0 : (Date.now() - G) / 1e3 >= ke;
                } catch {
                  return !0;
                }
              }
              function B() {
                var Pe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : NaN, ke = isNaN(Pe);
                ke && Z.get().streaming.utcSynchronization.useManifestDateHeaderTimeSource ? q() : _e(ke, Pe);
              }
              function W(Pe) {
                var ke = 60, De = 60, Ae = 1e3, Ie = /^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2})(?::([0-9]*)(\.[0-9]*)?)?(?:([+\-])([0-9]{2})([0-9]{2}))?/, Xe, it, rt = Ie.exec(Pe);
                return Xe = Date.UTC(
                  parseInt(rt[1], 10),
                  parseInt(rt[2], 10) - 1,
                  // months start from zero
                  parseInt(rt[3], 10),
                  parseInt(rt[4], 10),
                  parseInt(rt[5], 10),
                  rt[6] && (parseInt(rt[6], 10) || 0),
                  rt[7] && parseFloat(rt[7]) * Ae || 0
                ), rt[9] && rt[10] && (it = parseInt(rt[9], 10) * De + parseInt(rt[10], 10), Xe += (rt[8] === "+" ? -1 : 1) * it * ke * Ae), new Date(Xe).getTime();
              }
              function X(Pe) {
                var ke = Date.parse(Pe);
                return isNaN(ke) && (ke = W(Pe)), ke;
              }
              function K(Pe) {
                return Date.parse(Pe);
              }
              function U(Pe) {
                return Date.parse(Pe);
              }
              function V(Pe, ke, De) {
                De();
              }
              function Q(Pe, ke, De) {
                var Ae = X(Pe);
                if (!isNaN(Ae)) {
                  ke(Ae);
                  return;
                }
                De();
              }
              function fe(Pe, ke, De, Ae, Ie) {
                var Xe, it, rt = !1, Ne = new XMLHttpRequest(), He = Ie ? f.HTTPRequest.HEAD : f.HTTPRequest.GET, $e = ke.match(/\S+/g);
                if (ke = $e.shift(), Xe = function() {
                  rt || (rt = !0, $e.length ? fe(Pe, $e.join(" "), De, Ae, Ie) : Ae());
                }, it = function() {
                  var pt, vt;
                  Ne.status === 200 && (pt = Ie ? Ne.getResponseHeader("Date") : Ne.response, vt = Pe(pt), isNaN(vt) || (De(vt), rt = !0));
                }, I.isRelative(ke)) {
                  var nt = oe.resolve();
                  nt && (ke = I.resolve(ke, nt.url));
                }
                Ne.open(He, ke), Ne.timeout = b, Ne.onload = it, Ne.onloadend = Xe, Ne.send();
              }
              function ue(Pe, ke, De) {
                fe(U, Pe, ke, De, !0);
              }
              function q() {
                var Pe = j.getLatestMPDRequestHeaderValueByID("Date"), ke = Pe !== null ? new Date(Pe).getTime() : Number.NaN;
                if (isNaN(ke))
                  _e(!0);
                else {
                  var De = ke - Date.now();
                  _e(!1, De);
                }
              }
              function _e(Pe, ke) {
                if (!isNaN(ie) && !isNaN(ke) && !Pe && ge(ke), !Pe && !isNaN(ke)) {
                  G = Date.now(), k = !1;
                  var De = isNaN(ie);
                  ie = ke, De && te(), F.debug("Completed UTC sync. Setting client - server offset to ".concat(ke));
                }
                Pe && (re = null, k = !1, z.error(new h.default(v.default.TIME_SYNC_FAILED_ERROR_CODE, v.default.TIME_SYNC_FAILED_ERROR_MESSAGE))), C.trigger(d.default.UPDATE_TIME_SYNC_OFFSET, {
                  offset: ke
                }), C.trigger(d.default.TIME_SYNCHRONIZATION_COMPLETED);
              }
              function ge(Pe) {
                try {
                  var ke = Ee(Pe), De = isNaN(ce) ? R : ce, Ae = isNaN(Z.get().streaming.utcSynchronization.timeBetweenSyncAttemptsAdjustmentFactor) ? N : Z.get().streaming.utcSynchronization.timeBetweenSyncAttemptsAdjustmentFactor, Ie = isNaN(Z.get().streaming.utcSynchronization.maximumTimeBetweenSyncAttempts) ? E : Z.get().streaming.utcSynchronization.maximumTimeBetweenSyncAttempts, Xe = isNaN(Z.get().streaming.utcSynchronization.minimumTimeBetweenSyncAttempts) ? L : Z.get().streaming.utcSynchronization.minimumTimeBetweenSyncAttempts, it;
                  ke ? (it = Math.min(De * Ae, Ie), F.debug("Increasing timeBetweenSyncAttempts to ".concat(it))) : (it = Math.max(De / Ae, Xe), F.debug("Decreasing timeBetweenSyncAttempts to ".concat(it))), ce = it;
                } catch {
                }
              }
              function Ce() {
                if (!(!J || J.length === 0)) {
                  var Pe = J.reduce(function(ke, De) {
                    return ke + De;
                  }, 0) / J.length;
                  Ee(Pe) ? F.debug("Completed background UTC sync. Offset is within allowed threshold and is not adjusted.") : (F.debug("Completed background UTC sync. Setting client - server offset to ".concat(Pe)), ie = Pe, C.trigger(d.default.UPDATE_TIME_SYNC_OFFSET, {
                    offset: ie
                  })), H = !1, $ = Date.now();
                }
              }
              function Ee(Pe) {
                try {
                  if (isNaN(ie))
                    return !0;
                  var ke = Z.get().streaming.utcSynchronization.maximumAllowedDrift && !isNaN(Z.get().streaming.utcSynchronization.maximumAllowedDrift) ? Z.get().streaming.utcSynchronization.maximumAllowedDrift : S, De = ie - ke, Ae = ie + ke;
                  return Pe >= De && Pe <= Ae;
                } catch {
                  return !0;
                }
              }
              function Re() {
                he(), C.off(d.default.ATTEMPT_BACKGROUND_SYNC, te, w);
              }
              return w = {
                initialize: se,
                attemptSync: ee,
                setConfig: pe,
                reset: Re
              }, de(), w;
            }
            _.__dashjs_factory_name = "TimeSyncController";
            var O = g.default.getSingletonFactory(_);
            O.HTTP_TIMEOUT_MS = b, g.default.updateSingletonFactory(_.__dashjs_factory_name, O);
            const D = O;
          }
        ),
        /***/
        "./src/streaming/controllers/XlinkController.js": (
          /*!******************************************************!*\
            !*** ./src/streaming/controllers/XlinkController.js ***!
            \******************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => T
              /* harmony export */
            });
            var h = i(
              /*! ../XlinkLoader */
              "./src/streaming/XlinkLoader.js"
            ), f = i(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), p = i(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), d = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), v = i(
              /*! ../../../externals/xml2json */
              "./externals/xml2json.js"
            ), g = i(
              /*! ../utils/URLUtils */
              "./src/streaming/utils/URLUtils.js"
            ), m = i(
              /*! ../../dash/constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            ), A = "onLoad", b = "onActuate", S = "urn:mpeg:dash:resolve-to-zero:2013";
            function N(R) {
              R = R || {};
              var y = this.context, E = (0, f.default)(y).getInstance(), L = (0, g.default)(y).getInstance(), _, O, D, M, C, I;
              function w() {
                E.on(p.default.XLINK_ELEMENT_LOADED, j, _), I = (0, h.default)(y).create({
                  errHandler: R.errHandler,
                  dashMetrics: R.dashMetrics,
                  mediaPlayerModel: R.mediaPlayerModel,
                  requestModifier: R.requestModifier,
                  settings: R.settings
                });
              }
              function F(ce) {
                ce && (O = ce);
              }
              function k(ce) {
                ce && (D = ce);
              }
              function H(ce) {
                var z;
                C = new v.default({
                  escapeMode: !1,
                  attributePrefix: "",
                  arrayAccessForm: "property",
                  emptyNodeForm: "object",
                  stripWhitespaces: !1,
                  enableToStringFunc: !1,
                  ignoreRoot: !0,
                  matchers: O
                }), M = ce, M.Period_asArray ? (z = ae(M.Period_asArray, M, m.default.PERIOD, A), Y(z, m.default.PERIOD, A)) : E.trigger(p.default.XLINK_READY, {
                  manifest: M
                });
              }
              function Z() {
                E.off(p.default.XLINK_ELEMENT_LOADED, j, _), I && (I.reset(), I = null);
              }
              function Y(ce, z, oe) {
                var de = {}, pe, he;
                de.elements = ce, de.type = z, de.resolveType = oe, de.elements.length === 0 && J(de);
                for (var se = 0; se < de.elements.length; se++)
                  pe = de.elements[se], L.isHTTPURL(pe.url) ? he = pe.url : he = pe.originalContent.BaseURL + pe.url, I.load(he, pe, de);
              }
              function j(ce) {
                var z, oe, de = "<response>", pe = "</response>", he = "";
                if (z = ce.element, oe = ce.resolveObject, z.resolvedContent) {
                  var se = 0;
                  z.resolvedContent.indexOf("<?xml") === 0 && (se = z.resolvedContent.indexOf("?>") + 2), he = z.resolvedContent.substr(0, se) + de + z.resolvedContent.substr(se) + pe, z.resolvedContent = C.xml_str2json(he);
                }
                ie(oe) && J(oe);
              }
              function J(ce) {
                var z = [], oe, de;
                if (G(ce), ce.resolveType === b && E.trigger(p.default.XLINK_READY, {
                  manifest: M
                }), ce.resolveType === A)
                  switch (ce.type) {
                    case m.default.PERIOD:
                      for (oe = 0; oe < M[m.default.PERIOD + "_asArray"].length; oe++)
                        de = M[m.default.PERIOD + "_asArray"][oe], de.hasOwnProperty(m.default.ADAPTATION_SET + "_asArray") && (z = z.concat(ae(de[m.default.ADAPTATION_SET + "_asArray"], de, m.default.ADAPTATION_SET, A))), de.hasOwnProperty(m.default.EVENT_STREAM + "_asArray") && (z = z.concat(ae(de[m.default.EVENT_STREAM + "_asArray"], de, m.default.EVENT_STREAM, A)));
                      Y(z, m.default.ADAPTATION_SET, A);
                      break;
                    case m.default.ADAPTATION_SET:
                      E.trigger(p.default.XLINK_READY, {
                        manifest: M
                      });
                      break;
                  }
              }
              function ae(ce, z, oe, de) {
                var pe = [], he, se, ee;
                for (se = ce.length - 1; se >= 0; se--)
                  he = ce[se], he.hasOwnProperty("xlink:href") && he["xlink:href"] === S && ce.splice(se, 1);
                for (se = 0; se < ce.length; se++)
                  he = ce[se], he.hasOwnProperty("xlink:href") && he.hasOwnProperty("xlink:actuate") && he["xlink:actuate"] === de && (ee = $(he["xlink:href"], z, oe, se, de, he), pe.push(ee));
                return pe;
              }
              function G(ce) {
                var z = [], oe, de, pe, he, se, ee;
                for (he = ce.elements.length - 1; he >= 0; he--) {
                  if (oe = ce.elements[he], de = oe.type + "_asArray", !oe.resolvedContent || re())
                    delete oe.originalContent["xlink:actuate"], delete oe.originalContent["xlink:href"], z.push(oe.originalContent);
                  else if (oe.resolvedContent)
                    for (se = 0; se < oe.resolvedContent[de].length; se++)
                      pe = oe.resolvedContent[de][se], z.push(pe);
                  for (oe.parentElement[de].splice(oe.index, 1), ee = 0; ee < z.length; ee++)
                    oe.parentElement[de].splice(oe.index + ee, 0, z[ee]);
                  z = [];
                }
                ce.elements.length > 0 && D.run(M);
              }
              function $(ce, z, oe, de, pe, he) {
                return {
                  url: ce,
                  parentElement: z,
                  type: oe,
                  index: de,
                  resolveType: pe,
                  originalContent: he,
                  resolvedContent: null,
                  resolved: !1
                };
              }
              function ie(ce) {
                var z, oe;
                for (z = 0; z < ce.elements.length; z++)
                  if (oe = ce.elements[z], oe.resolved === !1)
                    return !1;
                return !0;
              }
              function re() {
                return !1;
              }
              return _ = {
                resolveManifestOnLoad: H,
                setMatchers: F,
                setIron: k,
                reset: Z
              }, w(), _;
            }
            N.__dashjs_factory_name = "XlinkController";
            const T = d.default.getClassFactory(N);
          }
        ),
        /***/
        "./src/streaming/metrics/MetricsReporting.js": (
          /*!***************************************************!*\
            !*** ./src/streaming/metrics/MetricsReporting.js ***!
            \***************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => A
              /* harmony export */
            });
            var h = i(
              /*! ./utils/DVBErrorsTranslator */
              "./src/streaming/metrics/utils/DVBErrorsTranslator.js"
            ), f = i(
              /*! ./MetricsReportingEvents */
              "./src/streaming/metrics/MetricsReportingEvents.js"
            ), p = i(
              /*! ./controllers/MetricsCollectionController */
              "./src/streaming/metrics/controllers/MetricsCollectionController.js"
            ), d = i(
              /*! ./metrics/MetricsHandlerFactory */
              "./src/streaming/metrics/metrics/MetricsHandlerFactory.js"
            ), v = i(
              /*! ./reporting/ReportingFactory */
              "./src/streaming/metrics/reporting/ReportingFactory.js"
            );
            function g() {
              var b = this.context, S, N;
              function T(E) {
                return N = (0, h.default)(b).getInstance({
                  eventBus: E.eventBus,
                  dashMetrics: E.dashMetrics,
                  metricsConstants: E.metricsConstants,
                  events: E.events
                }), N.initialise(), (0, p.default)(b).create(E);
              }
              function R() {
                return (0, v.default)(b).getInstance();
              }
              function y() {
                return (0, d.default)(b).getInstance();
              }
              return S = {
                createMetricsReporting: T,
                getReportingFactory: R,
                getMetricsHandlerFactory: y
              }, S;
            }
            g.__dashjs_factory_name = "MetricsReporting";
            var m = dashjs.FactoryMaker.getClassFactory(g);
            m.events = f.default, dashjs.FactoryMaker.updateClassFactory(g.__dashjs_factory_name, m);
            const A = m;
          }
        ),
        /***/
        "./src/streaming/metrics/MetricsReportingEvents.js": (
          /*!*********************************************************!*\
            !*** ./src/streaming/metrics/MetricsReportingEvents.js ***!
            \*********************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => R
              /* harmony export */
            });
            var h = i(
              /*! ../../core/events/EventsBase */
              "./src/core/events/EventsBase.js"
            );
            function f(y) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? f = function(L) {
                return typeof L;
              } : f = function(L) {
                return L && typeof Symbol == "function" && L.constructor === Symbol && L !== Symbol.prototype ? "symbol" : typeof L;
              }, f(y);
            }
            function p(y, E) {
              if (!(y instanceof E))
                throw new TypeError("Cannot call a class as a function");
            }
            function d(y, E) {
              if (typeof E != "function" && E !== null)
                throw new TypeError("Super expression must either be null or a function");
              y.prototype = Object.create(E && E.prototype, { constructor: { value: y, writable: !0, configurable: !0 } }), E && v(y, E);
            }
            function v(y, E) {
              return v = Object.setPrototypeOf || function(_, O) {
                return _.__proto__ = O, _;
              }, v(y, E);
            }
            function g(y) {
              var E = b();
              return function() {
                var _ = S(y), O;
                if (E) {
                  var D = S(this).constructor;
                  O = Reflect.construct(_, arguments, D);
                } else
                  O = _.apply(this, arguments);
                return m(this, O);
              };
            }
            function m(y, E) {
              return E && (f(E) === "object" || typeof E == "function") ? E : A(y);
            }
            function A(y) {
              if (y === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return y;
            }
            function b() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return !1;
              if (typeof Proxy == "function")
                return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function S(y) {
              return S = Object.setPrototypeOf ? Object.getPrototypeOf : function(L) {
                return L.__proto__ || Object.getPrototypeOf(L);
              }, S(y);
            }
            var N = /* @__PURE__ */ function(y) {
              d(L, y);
              var E = g(L);
              function L() {
                var _;
                return p(this, L), _ = E.call(this), _.METRICS_INITIALISATION_COMPLETE = "internal_metricsReportingInitialized", _.BECAME_REPORTING_PLAYER = "internal_becameReportingPlayer", _.CMCD_DATA_GENERATED = "cmcdDataGenerated", _;
              }
              return L;
            }(h.default), T = new N();
            const R = T;
          }
        ),
        /***/
        "./src/streaming/metrics/controllers/MetricsCollectionController.js": (
          /*!**************************************************************************!*\
            !*** ./src/streaming/metrics/controllers/MetricsCollectionController.js ***!
            \**************************************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var h = i(
              /*! ./MetricsController */
              "./src/streaming/metrics/controllers/MetricsController.js"
            ), f = i(
              /*! ../utils/ManifestParsing */
              "./src/streaming/metrics/utils/ManifestParsing.js"
            ), p = i(
              /*! ../MetricsReportingEvents */
              "./src/streaming/metrics/MetricsReportingEvents.js"
            );
            function d(g) {
              g = g || {};
              var m, A = {}, b = this.context, S = g.eventBus, N = g.events;
              function T(L) {
                if (!L.error) {
                  var _ = Object.keys(A), O = (0, f.default)(b).getInstance({
                    adapter: g.adapter,
                    constants: g.constants
                  }).getMetrics(L.manifest);
                  O.forEach(function(D) {
                    var M = JSON.stringify(D);
                    if (A.hasOwnProperty(M))
                      _.splice(M, 1);
                    else
                      try {
                        var C = (0, h.default)(b).create(g);
                        C.initialize(D), A[M] = C;
                      } catch {
                      }
                  }), _.forEach(function(D) {
                    A[D].reset(), delete A[D];
                  }), S.trigger(p.default.METRICS_INITIALISATION_COMPLETE);
                }
              }
              function R() {
                Object.keys(A).forEach(function(L) {
                  A[L].reset();
                }), A = {};
              }
              function y() {
                S.on(N.MANIFEST_UPDATED, T, m), S.on(N.STREAM_TEARDOWN_COMPLETE, R, m);
              }
              function E() {
                S.off(N.MANIFEST_UPDATED, T, m), S.off(N.STREAM_TEARDOWN_COMPLETE, R, m);
              }
              return m = {
                reset: E
              }, y(), m;
            }
            d.__dashjs_factory_name = "MetricsCollectionController";
            const v = dashjs.FactoryMaker.getClassFactory(d);
          }
        ),
        /***/
        "./src/streaming/metrics/controllers/MetricsController.js": (
          /*!****************************************************************!*\
            !*** ./src/streaming/metrics/controllers/MetricsController.js ***!
            \****************************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var h = i(
              /*! ./RangeController */
              "./src/streaming/metrics/controllers/RangeController.js"
            ), f = i(
              /*! ./ReportingController */
              "./src/streaming/metrics/controllers/ReportingController.js"
            ), p = i(
              /*! ./MetricsHandlersController */
              "./src/streaming/metrics/controllers/MetricsHandlersController.js"
            );
            function d(g) {
              g = g || {};
              var m, A, b, S, N = this.context;
              function T(y) {
                try {
                  b = (0, h.default)(N).create({
                    mediaElement: g.mediaElement
                  }), b.initialize(y.Range), A = (0, f.default)(N).create({
                    debug: g.debug,
                    metricsConstants: g.metricsConstants,
                    mediaPlayerModel: g.mediaPlayerModel
                  }), A.initialize(y.Reporting, b), m = (0, p.default)(N).create({
                    debug: g.debug,
                    eventBus: g.eventBus,
                    metricsConstants: g.metricsConstants,
                    events: g.events
                  }), m.initialize(y.metrics, A);
                } catch (E) {
                  throw R(), E;
                }
              }
              function R() {
                m && m.reset(), A && A.reset(), b && b.reset();
              }
              return S = {
                initialize: T,
                reset: R
              }, S;
            }
            d.__dashjs_factory_name = "MetricsController";
            const v = dashjs.FactoryMaker.getClassFactory(d);
          }
        ),
        /***/
        "./src/streaming/metrics/controllers/MetricsHandlersController.js": (
          /*!************************************************************************!*\
            !*** ./src/streaming/metrics/controllers/MetricsHandlersController.js ***!
            \************************************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            var h = i(
              /*! ../metrics/MetricsHandlerFactory */
              "./src/streaming/metrics/metrics/MetricsHandlerFactory.js"
            );
            function f(d) {
              d = d || {};
              var v = [], g, m = this.context, A = d.eventBus, b = d.events, S = (0, h.default)(m).getInstance({
                debug: d.debug,
                eventBus: d.eventBus,
                metricsConstants: d.metricsConstants
              });
              function N(y) {
                v.forEach(function(E) {
                  E.handleNewMetric(y.metric, y.value, y.mediaType);
                });
              }
              function T(y, E) {
                y.split(",").forEach(function(L, _, O) {
                  var D;
                  if (L.indexOf("(") !== -1 && L.indexOf(")") === -1) {
                    var M = O[_ + 1];
                    M && M.indexOf("(") === -1 && M.indexOf(")") !== -1 && (L += "," + M, delete O[_ + 1]);
                  }
                  D = S.create(L, E), D && v.push(D);
                }), A.on(b.METRIC_ADDED, N, g), A.on(b.METRIC_UPDATED, N, g);
              }
              function R() {
                A.off(b.METRIC_ADDED, N, g), A.off(b.METRIC_UPDATED, N, g), v.forEach(function(y) {
                  return y.reset();
                }), v = [];
              }
              return g = {
                initialize: T,
                reset: R
              }, g;
            }
            f.__dashjs_factory_name = "MetricsHandlersController";
            const p = dashjs.FactoryMaker.getClassFactory(f);
          }
        ),
        /***/
        "./src/streaming/metrics/controllers/RangeController.js": (
          /*!**************************************************************!*\
            !*** ./src/streaming/metrics/controllers/RangeController.js ***!
            \**************************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            var h = i(
              /*! ../../utils/CustomTimeRanges */
              "./src/streaming/utils/CustomTimeRanges.js"
            );
            function f(d) {
              d = d || {};
              var v = !1, g = this.context, m, A, b = d.mediaElement;
              function S(y) {
                y && y.length && (y.forEach(function(E) {
                  var L = E.starttime, _ = L + E.duration;
                  A.add(L, _);
                }), v = !!y[0]._useWallClockTime);
              }
              function N() {
                A.clear();
              }
              function T() {
                A = (0, h.default)(g).create();
              }
              function R() {
                var y = A.length, E;
                if (!y)
                  return !0;
                E = v ? (/* @__PURE__ */ new Date()).getTime() / 1e3 : b.currentTime;
                for (var L = 0; L < y; L += 1) {
                  var _ = A.start(L), O = A.end(L);
                  if (_ <= E && E < O)
                    return !0;
                }
                return !1;
              }
              return m = {
                initialize: S,
                reset: N,
                isEnabled: R
              }, T(), m;
            }
            f.__dashjs_factory_name = "RangeController";
            const p = dashjs.FactoryMaker.getClassFactory(f);
          }
        ),
        /***/
        "./src/streaming/metrics/controllers/ReportingController.js": (
          /*!******************************************************************!*\
            !*** ./src/streaming/metrics/controllers/ReportingController.js ***!
            \******************************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            var h = i(
              /*! ../reporting/ReportingFactory */
              "./src/streaming/metrics/reporting/ReportingFactory.js"
            );
            function f(d) {
              var v = [], g, m = (0, h.default)(this.context).getInstance(d);
              function A(N, T) {
                N.some(function(R) {
                  var y = m.create(R, T);
                  if (y)
                    return v.push(y), !0;
                });
              }
              function b() {
                v.forEach(function(N) {
                  return N.reset();
                }), v = [];
              }
              function S(N, T) {
                v.forEach(function(R) {
                  return R.report(N, T);
                });
              }
              return g = {
                initialize: A,
                reset: b,
                report: S
              }, g;
            }
            f.__dashjs_factory_name = "ReportingController";
            const p = dashjs.FactoryMaker.getClassFactory(f);
          }
        ),
        /***/
        "./src/streaming/metrics/metrics/MetricsHandlerFactory.js": (
          /*!****************************************************************!*\
            !*** ./src/streaming/metrics/metrics/MetricsHandlerFactory.js ***!
            \****************************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => g
              /* harmony export */
            });
            var h = i(
              /*! ./handlers/BufferLevelHandler */
              "./src/streaming/metrics/metrics/handlers/BufferLevelHandler.js"
            ), f = i(
              /*! ./handlers/DVBErrorsHandler */
              "./src/streaming/metrics/metrics/handlers/DVBErrorsHandler.js"
            ), p = i(
              /*! ./handlers/HttpListHandler */
              "./src/streaming/metrics/metrics/handlers/HttpListHandler.js"
            ), d = i(
              /*! ./handlers/GenericMetricHandler */
              "./src/streaming/metrics/metrics/handlers/GenericMetricHandler.js"
            );
            function v(m) {
              m = m || {};
              var A, b = m.debug ? m.debug.getLogger(A) : {}, S = /([a-zA-Z]*)(\(([0-9]*)(\,\s*([a-zA-Z]*))?\))?/, N = this.context, T = {
                BufferLevel: h.default,
                DVBErrors: f.default,
                HttpList: p.default,
                PlayList: d.default,
                RepSwitchList: d.default,
                TcpList: d.default
              };
              function R(L, _) {
                var O = L.match(S), D;
                if (O) {
                  try {
                    D = T[O[1]](N).create({
                      eventBus: m.eventBus,
                      metricsConstants: m.metricsConstants
                    }), D.initialize(O[1], _, O[3], O[5]);
                  } catch (M) {
                    D = null, b.error("MetricsHandlerFactory: Could not create handler for type ".concat(O[1], " with args ").concat(O[3], ", ").concat(O[5], " (").concat(M.message, ")"));
                  }
                  return D;
                }
              }
              function y(L, _) {
                T[L] = _;
              }
              function E(L) {
                delete T[L];
              }
              return A = {
                create: R,
                register: y,
                unregister: E
              }, A;
            }
            v.__dashjs_factory_name = "MetricsHandlerFactory";
            const g = dashjs.FactoryMaker.getSingletonFactory(v);
          }
        ),
        /***/
        "./src/streaming/metrics/metrics/handlers/BufferLevelHandler.js": (
          /*!**********************************************************************!*\
            !*** ./src/streaming/metrics/metrics/handlers/BufferLevelHandler.js ***!
            \**********************************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            var h = i(
              /*! ../../utils/HandlerHelpers */
              "./src/streaming/metrics/utils/HandlerHelpers.js"
            );
            function f(d) {
              d = d || {};
              var v, g, m, A, b, S, N = this.context, T = (0, h.default)(N).getInstance(), R = [], y = d.metricsConstants;
              function E() {
                try {
                  return Object.keys(R).map(function(M) {
                    return R[M];
                  }).reduce(function(M, C) {
                    return M.level < C.level ? M : C;
                  });
                } catch {
                  return;
                }
              }
              function L() {
                var M = E();
                M && S !== M.t && (S = M.t, g.report(A, M));
              }
              function _(M, C, I) {
                C && (m = T.validateN(I), g = C, A = T.reconstructFullMetricName(M, I), b = setInterval(L, m));
              }
              function O() {
                clearInterval(b), b = null, m = 0, g = null, S = null;
              }
              function D(M, C, I) {
                M === y.BUFFER_LEVEL && (R[I] = C);
              }
              return v = {
                initialize: _,
                reset: O,
                handleNewMetric: D
              }, v;
            }
            f.__dashjs_factory_name = "BufferLevelHandler";
            const p = dashjs.FactoryMaker.getClassFactory(f);
          }
        ),
        /***/
        "./src/streaming/metrics/metrics/handlers/DVBErrorsHandler.js": (
          /*!********************************************************************!*\
            !*** ./src/streaming/metrics/metrics/handlers/DVBErrorsHandler.js ***!
            \********************************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            var h = i(
              /*! ../../MetricsReportingEvents */
              "./src/streaming/metrics/MetricsReportingEvents.js"
            );
            function f(d) {
              d = d || {};
              var v, g, m = d.eventBus, A = d.metricsConstants;
              function b() {
                m.off(h.default.METRICS_INITIALISATION_COMPLETE, b, this), m.trigger(h.default.BECAME_REPORTING_PLAYER);
              }
              function S(R, y) {
                y && (g = y, m.on(h.default.METRICS_INITIALISATION_COMPLETE, b, this));
              }
              function N() {
                g = null;
              }
              function T(R, y) {
                R === A.DVB_ERRORS && g && g.report(R, y);
              }
              return v = {
                initialize: S,
                reset: N,
                handleNewMetric: T
              }, v;
            }
            const p = dashjs.FactoryMaker.getClassFactory(f);
          }
        ),
        /***/
        "./src/streaming/metrics/metrics/handlers/GenericMetricHandler.js": (
          /*!************************************************************************!*\
            !*** ./src/streaming/metrics/metrics/handlers/GenericMetricHandler.js ***!
            \************************************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => f
              /* harmony export */
            });
            function h() {
              var p, d, v;
              function g(b, S) {
                d = b, v = S;
              }
              function m() {
                v = null, d = void 0;
              }
              function A(b, S) {
                b === d && v && v.report(d, S);
              }
              return p = {
                initialize: g,
                reset: m,
                handleNewMetric: A
              }, p;
            }
            h.__dashjs_factory_name = "GenericMetricHandler";
            const f = dashjs.FactoryMaker.getClassFactory(h);
          }
        ),
        /***/
        "./src/streaming/metrics/metrics/handlers/HttpListHandler.js": (
          /*!*******************************************************************!*\
            !*** ./src/streaming/metrics/metrics/handlers/HttpListHandler.js ***!
            \*******************************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            var h = i(
              /*! ../../utils/HandlerHelpers */
              "./src/streaming/metrics/utils/HandlerHelpers.js"
            );
            function f(d) {
              d = d || {};
              var v, g, m, A, b, S, N = [], T = (0, h.default)(this.context).getInstance(), R = d.metricsConstants;
              function y() {
                var O = N;
                O.length && g && g.report(b, O), N = [];
              }
              function E(O, D, M, C) {
                D && (m = T.validateN(M), g = D, C && C.length && (A = C), b = T.reconstructFullMetricName(O, M, C), S = setInterval(y, m));
              }
              function L() {
                clearInterval(S), S = null, m = null, A = null, N = [], g = null;
              }
              function _(O, D) {
                O === R.HTTP_REQUEST && (!A || A === D.type) && N.push(D);
              }
              return v = {
                initialize: E,
                reset: L,
                handleNewMetric: _
              }, v;
            }
            f.__dashjs_factory_name = "HttpListHandler";
            const p = dashjs.FactoryMaker.getClassFactory(f);
          }
        ),
        /***/
        "./src/streaming/metrics/reporting/ReportingFactory.js": (
          /*!*************************************************************!*\
            !*** ./src/streaming/metrics/reporting/ReportingFactory.js ***!
            \*************************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            var h = i(
              /*! ./reporters/DVBReporting */
              "./src/streaming/metrics/reporting/reporters/DVBReporting.js"
            );
            function f(d) {
              d = d || {};
              var v = {
                "urn:dvb:dash:reporting:2014": h.default
              }, g = this.context, m, A = d.debug ? d.debug.getLogger(m) : {}, b = d.metricsConstants, S = d.mediaPlayerModel || {};
              function N(y, E) {
                var L;
                try {
                  L = v[y.schemeIdUri](g).create({
                    metricsConstants: b,
                    mediaPlayerModel: S
                  }), L.initialize(y, E);
                } catch (_) {
                  L = null, A.error("ReportingFactory: could not create Reporting with schemeIdUri ".concat(y.schemeIdUri, " (").concat(_.message, ")"));
                }
                return L;
              }
              function T(y, E) {
                v[y] = E;
              }
              function R(y) {
                delete v[y];
              }
              return m = {
                create: N,
                register: T,
                unregister: R
              }, m;
            }
            f.__dashjs_factory_name = "ReportingFactory";
            const p = dashjs.FactoryMaker.getSingletonFactory(f);
          }
        ),
        /***/
        "./src/streaming/metrics/reporting/reporters/DVBReporting.js": (
          /*!*******************************************************************!*\
            !*** ./src/streaming/metrics/reporting/reporters/DVBReporting.js ***!
            \*******************************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var h = i(
              /*! ../../utils/MetricSerialiser */
              "./src/streaming/metrics/utils/MetricSerialiser.js"
            ), f = i(
              /*! ../../utils/RNG */
              "./src/streaming/metrics/utils/RNG.js"
            ), p = i(
              /*! ../../../models/CustomParametersModel */
              "./src/streaming/models/CustomParametersModel.js"
            );
            function d(g) {
              g = g || {};
              var m, A = this.context, b, S, N, T, R, y, E, L = [], _ = g.metricsConstants;
              function O() {
                b = (0, h.default)(A).getInstance(), N = (0, f.default)(A).getInstance(), S = (0, p.default)(A).getInstance(), I();
              }
              function D(F, k, H) {
                var Z = new XMLHttpRequest();
                Z.withCredentials = S.getXHRWithCredentialsForType(_.HTTP_REQUEST_DVB_REPORTING_TYPE);
                var Y = function() {
                  var J = L.indexOf(Z);
                  J !== -1 && (L.splice(J, 1), Z.status >= 200 && Z.status < 300 ? k && k() : H && H());
                };
                L.push(Z);
                try {
                  Z.open("GET", F), Z.onloadend = Y, Z.onerror = Y, Z.send();
                } catch {
                  Z.onerror();
                }
              }
              function M(F, k) {
                Array.isArray(k) || (k = [k]), R && E.isEnabled() && k.forEach(function(H) {
                  var Z = b.serialise(H);
                  F !== _.DVB_ERRORS && (Z = "metricname=".concat(F, "&").concat(Z)), Z = "".concat(y, "?").concat(Z), D(Z, null, function() {
                    R = !1;
                  });
                });
              }
              function C(F, k) {
                var H;
                if (E = k, y = F.dvb_reportingUrl, !y)
                  throw new Error("required parameter missing (dvb:reportingUrl)");
                T || (H = F.dvb_probability, H && (H === 1e3 || H / 1e3 >= N.random()) && (R = !0), T = !0);
              }
              function I() {
                T = !1, R = !1, y = null, E = null;
              }
              function w() {
                I();
              }
              return m = {
                report: M,
                initialize: C,
                reset: w
              }, O(), m;
            }
            d.__dashjs_factory_name = "DVBReporting";
            const v = dashjs.FactoryMaker.getClassFactory(d);
          }
        ),
        /***/
        "./src/streaming/metrics/utils/DVBErrorsTranslator.js": (
          /*!************************************************************!*\
            !*** ./src/streaming/metrics/utils/DVBErrorsTranslator.js ***!
            \************************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => d
              /* harmony export */
            });
            var h = i(
              /*! ../vo/DVBErrors */
              "./src/streaming/metrics/vo/DVBErrors.js"
            ), f = i(
              /*! ../MetricsReportingEvents */
              "./src/streaming/metrics/MetricsReportingEvents.js"
            );
            function p(v) {
              v = v || {};
              var g, m, A = v.eventBus, b = v.dashMetrics, S = v.metricsConstants, N = v.events;
              function T(C) {
                var I = new h.default();
                if (m) {
                  for (var w in C)
                    C.hasOwnProperty(w) && (I[w] = C[w]);
                  I.mpdurl || (I.mpdurl = m.originalUrl || m.url), I.terror || (I.terror = /* @__PURE__ */ new Date()), b.addDVBErrors(I);
                }
              }
              function R(C) {
                C.error || (m = C.manifest);
              }
              function y(C) {
                T({
                  errorcode: h.default.BASE_URL_CHANGED,
                  servicelocation: C.entry
                });
              }
              function E() {
                T({
                  errorcode: h.default.BECAME_REPORTER
                });
              }
              function L(C) {
                (C.responsecode === 0 || // connection failure - unknown
                C.responsecode == null || // Generated on .catch() and when uninitialised
                C.responsecode >= 400 || // HTTP error status code
                C.responsecode < 100 || // unknown status codes
                C.responsecode >= 600) && T({
                  errorcode: C.responsecode || h.default.CONNECTION_ERROR,
                  url: C.url,
                  terror: C.tresponse,
                  servicelocation: C._serviceLocation
                });
              }
              function _(C) {
                switch (C.metric) {
                  case S.HTTP_REQUEST:
                    L(C.value);
                    break;
                }
              }
              function O(C) {
                var I = C.error ? C.error.code : 0, w;
                switch (I) {
                  case MediaError.MEDIA_ERR_NETWORK:
                    w = h.default.CONNECTION_ERROR;
                    break;
                  case MediaError.MEDIA_ERR_DECODE:
                    w = h.default.CORRUPT_MEDIA_OTHER;
                    break;
                  default:
                    return;
                }
                T({
                  errorcode: w
                });
              }
              function D() {
                A.on(N.MANIFEST_UPDATED, R, g), A.on(N.SERVICE_LOCATION_BLACKLIST_CHANGED, y, g), A.on(N.METRIC_ADDED, _, g), A.on(N.METRIC_UPDATED, _, g), A.on(N.PLAYBACK_ERROR, O, g), A.on(f.default.BECAME_REPORTING_PLAYER, E, g);
              }
              function M() {
                A.off(N.MANIFEST_UPDATED, R, g), A.off(N.SERVICE_LOCATION_BLACKLIST_CHANGED, y, g), A.off(N.METRIC_ADDED, _, g), A.off(N.METRIC_UPDATED, _, g), A.off(N.PLAYBACK_ERROR, O, g), A.off(f.default.BECAME_REPORTING_PLAYER, E, g);
              }
              return g = {
                initialise: D,
                reset: M
              }, g;
            }
            p.__dashjs_factory_name = "DVBErrorsTranslator";
            const d = dashjs.FactoryMaker.getSingletonFactory(p);
          }
        ),
        /***/
        "./src/streaming/metrics/utils/HandlerHelpers.js": (
          /*!*******************************************************!*\
            !*** ./src/streaming/metrics/utils/HandlerHelpers.js ***!
            \*******************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => f
              /* harmony export */
            });
            function h() {
              return {
                reconstructFullMetricName: function(d, v, g) {
                  var m = d;
                  return v && (m += "(" + v, g && g.length && (m += "," + g), m += ")"), m;
                },
                validateN: function(d) {
                  if (!d)
                    throw new Error("missing n");
                  if (isNaN(d))
                    throw new Error("n is NaN");
                  if (d < 0)
                    throw new Error("n must be positive");
                  return d;
                }
              };
            }
            h.__dashjs_factory_name = "HandlerHelpers";
            const f = dashjs.FactoryMaker.getSingletonFactory(h);
          }
        ),
        /***/
        "./src/streaming/metrics/utils/ManifestParsing.js": (
          /*!********************************************************!*\
            !*** ./src/streaming/metrics/utils/ManifestParsing.js ***!
            \********************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var h = i(
              /*! ../vo/Metrics */
              "./src/streaming/metrics/vo/Metrics.js"
            ), f = i(
              /*! ../vo/Range */
              "./src/streaming/metrics/vo/Range.js"
            ), p = i(
              /*! ../vo/Reporting */
              "./src/streaming/metrics/vo/Reporting.js"
            );
            function d(g) {
              g = g || {};
              var m, A = g.adapter, b = g.constants;
              function S(T, R, y) {
                var E, L, _ = 0;
                return R ? _ = A.getAvailabilityStartTime(T) / 1e3 : (E = A.getRegularPeriods(T), E.length && (_ = E[0].start)), L = _, y && y.hasOwnProperty(b.START_TIME) && (L += y.starttime), L;
              }
              function N(T) {
                var R = [];
                return T && T.Metrics_asArray && T.Metrics_asArray.forEach(function(y) {
                  var E = new h.default(), L = A.getIsDynamic(T);
                  if (y.hasOwnProperty("metrics"))
                    E.metrics = y.metrics;
                  else
                    return;
                  if (y.Range_asArray && y.Range_asArray.forEach(function(_) {
                    var O = new f.default();
                    O.starttime = S(T, L, _), _.hasOwnProperty("duration") ? O.duration = _.duration : O.duration = A.getDuration(T), O._useWallClockTime = L, E.Range.push(O);
                  }), y.Reporting_asArray)
                    y.Reporting_asArray.forEach(function(_) {
                      var O = new p.default();
                      if (_.hasOwnProperty(b.SCHEME_ID_URI))
                        O.schemeIdUri = _.schemeIdUri;
                      else
                        return;
                      _.hasOwnProperty("value") && (O.value = _.value), _.hasOwnProperty(b.DVB_REPORTING_URL) && (O.dvb_reportingUrl = _[b.DVB_REPORTING_URL]), _.hasOwnProperty(b.DVB_PROBABILITY) && (O.dvb_probability = _[b.DVB_PROBABILITY]), E.Reporting.push(O);
                    });
                  else
                    return;
                  R.push(E);
                }), R;
              }
              return m = {
                getMetrics: N
              }, m;
            }
            d.__dashjs_factory_name = "ManifestParsing";
            const v = dashjs.FactoryMaker.getSingletonFactory(d);
          }
        ),
        /***/
        "./src/streaming/metrics/utils/MetricSerialiser.js": (
          /*!*********************************************************!*\
            !*** ./src/streaming/metrics/utils/MetricSerialiser.js ***!
            \*********************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => f
              /* harmony export */
            });
            function h() {
              function p(d) {
                var v = [], g = [], m, A;
                for (m in d)
                  if (d.hasOwnProperty(m) && m.indexOf("_") !== 0) {
                    if (A = d[m], A == null && (A = ""), Array.isArray(A)) {
                      if (!A.length)
                        continue;
                      g = [], A.forEach(function(b) {
                        var S = Object.prototype.toString.call(b).slice(8, -1) !== "Object";
                        g.push(S ? b : p(b));
                      }), A = g.map(encodeURIComponent).join(",");
                    } else
                      typeof A == "string" ? A = encodeURIComponent(A) : A instanceof Date ? A = A.toISOString() : typeof A == "number" && (A = Math.round(A));
                    v.push(m + "=" + A);
                  }
                return v.join("&");
              }
              return {
                serialise: p
              };
            }
            h.__dashjs_factory_name = "MetricSerialiser";
            const f = dashjs.FactoryMaker.getSingletonFactory(h);
          }
        ),
        /***/
        "./src/streaming/metrics/utils/RNG.js": (
          /*!********************************************!*\
            !*** ./src/streaming/metrics/utils/RNG.js ***!
            \********************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => f
              /* harmony export */
            });
            function h() {
              var p = window.crypto || window.msCrypto, d = Uint32Array, v = Math.pow(2, d.BYTES_PER_ELEMENT * 8) - 1, g = 10, m, A, b;
              function S() {
                p && (m || (m = new d(g)), p.getRandomValues(m), A = 0);
              }
              function N(T, R) {
                var y;
                return T || (T = 0), R || (R = 1), p ? (A === m.length && S(), y = m[A] / v, A += 1) : y = Math.random(), y * (R - T) + T;
              }
              return b = {
                random: N
              }, S(), b;
            }
            h.__dashjs_factory_name = "RNG";
            const f = dashjs.FactoryMaker.getSingletonFactory(h);
          }
        ),
        /***/
        "./src/streaming/metrics/vo/DVBErrors.js": (
          /*!***********************************************!*\
            !*** ./src/streaming/metrics/vo/DVBErrors.js ***!
            \***********************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = function d() {
              h(this, d), this.mpdurl = null, this.errorcode = null, this.terror = null, this.url = null, this.ipaddress = null, this.servicelocation = null;
            };
            f.SSL_CONNECTION_FAILED_PREFIX = "SSL", f.DNS_RESOLUTION_FAILED = "C00", f.HOST_UNREACHABLE = "C01", f.CONNECTION_REFUSED = "C02", f.CONNECTION_ERROR = "C03", f.CORRUPT_MEDIA_ISOBMFF = "M00", f.CORRUPT_MEDIA_OTHER = "M01", f.BASE_URL_CHANGED = "F00", f.BECAME_REPORTER = "S00";
            const p = f;
          }
        ),
        /***/
        "./src/streaming/metrics/vo/Metrics.js": (
          /*!*********************************************!*\
            !*** ./src/streaming/metrics/vo/Metrics.js ***!
            \*********************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = function d() {
              h(this, d), this.metrics = "", this.Range = [], this.Reporting = [];
            };
            const p = f;
          }
        ),
        /***/
        "./src/streaming/metrics/vo/Range.js": (
          /*!*******************************************!*\
            !*** ./src/streaming/metrics/vo/Range.js ***!
            \*******************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = function d() {
              h(this, d), this.starttime = 0, this.duration = 1 / 0, this._useWallClockTime = !1;
            };
            const p = f;
          }
        ),
        /***/
        "./src/streaming/metrics/vo/Reporting.js": (
          /*!***********************************************!*\
            !*** ./src/streaming/metrics/vo/Reporting.js ***!
            \***********************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => d
              /* harmony export */
            });
            function h(v, g) {
              if (!(v instanceof g))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = 1e3, p = function v() {
              h(this, v), this.schemeIdUri = "", this.value = "", this.dvb_reportingUrl = "", this.dvb_probability = f;
            };
            const d = p;
          }
        ),
        /***/
        "./src/streaming/models/BaseURLTreeModel.js": (
          /*!**************************************************!*\
            !*** ./src/streaming/models/BaseURLTreeModel.js ***!
            \**************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => m
              /* harmony export */
            });
            var h = i(
              /*! ../utils/ObjectUtils */
              "./src/streaming/utils/ObjectUtils.js"
            ), f = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function p(A, b) {
              if (!(A instanceof b))
                throw new TypeError("Cannot call a class as a function");
            }
            var d = NaN, v = function A(b, S) {
              p(this, A), this.data = {
                baseUrls: b || null,
                selectedIdx: S || d
              }, this.children = [];
            };
            function g() {
              var A, b, S, N = this.context, T = (0, h.default)(N).getInstance();
              function R() {
                C();
              }
              function y(w) {
                w.adapter && (S = w.adapter);
              }
              function E() {
                if (!S || !S.hasOwnProperty("getBaseURLsFromElement") || !S.hasOwnProperty("getRepresentationSortFunction"))
                  throw new Error("setConfig function has to be called previously");
              }
              function L(w, F, k) {
                var H = S.getBaseURLsFromElement(k);
                w[F] ? T.areEqual(H, w[F].data.baseUrls) || (w[F].data.baseUrls = H, w[F].data.selectedIdx = d) : w[F] = new v(H);
              }
              function _(w) {
                E();
                var F = S.getBaseURLsFromElement(w);
                T.areEqual(F, b.data.baseUrls) || (b.data.baseUrls = F, b.data.selectedIdx = d), w && w.Period_asArray && w.Period_asArray.forEach(function(k, H) {
                  L(b.children, H, k), k.AdaptationSet_asArray && k.AdaptationSet_asArray.forEach(function(Z, Y) {
                    L(b.children[H].children, Y, Z), Z.Representation_asArray && Z.Representation_asArray.sort(S.getRepresentationSortFunction()).forEach(function(j, J) {
                      L(b.children[H].children[Y].children, J, j);
                    });
                  });
                });
              }
              function O(w, F) {
                var k = F || b;
                w(k.data), k.children && k.children.forEach(function(H) {
                  return O(w, H);
                });
              }
              function D(w) {
                O(function(F) {
                  isNaN(F.selectedIdx) || w === F.baseUrls[F.selectedIdx].serviceLocation && (F.selectedIdx = d);
                });
              }
              function M(w) {
                _(w);
              }
              function C() {
                b = new v();
              }
              function I(w) {
                var F = b, k = [F.data];
                return w && w.forEach(function(H) {
                  F = F.children[H], F && k.push(F.data);
                }), k.filter(function(H) {
                  return H.baseUrls.length;
                });
              }
              return A = {
                reset: C,
                update: M,
                getForPath: I,
                invalidateSelectedIndexes: D,
                setConfig: y
              }, R(), A;
            }
            g.__dashjs_factory_name = "BaseURLTreeModel";
            const m = f.default.getClassFactory(g);
          }
        ),
        /***/
        "./src/streaming/models/CmcdModel.js": (
          /*!*******************************************!*\
            !*** ./src/streaming/models/CmcdModel.js ***!
            \*******************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => M
              /* harmony export */
            });
            var h = i(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), f = i(
              /*! ../MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), p = i(
              /*! ../metrics/MetricsReportingEvents */
              "./src/streaming/metrics/MetricsReportingEvents.js"
            ), d = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), v = i(
              /*! ../../core/Settings */
              "./src/core/Settings.js"
            ), g = i(
              /*! ../../streaming/constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), m = i(
              /*! ../vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            ), A = i(
              /*! ../../dash/models/DashManifestModel */
              "./src/dash/models/DashManifestModel.js"
            ), b = i(
              /*! ../../core/Utils */
              "./src/core/Utils.js"
            );
            function S(C, I) {
              var w;
              if (typeof Symbol > "u" || C[Symbol.iterator] == null) {
                if (Array.isArray(C) || (w = N(C)) || I && C && typeof C.length == "number") {
                  w && (C = w);
                  var F = 0, k = function() {
                  };
                  return { s: k, n: function() {
                    return F >= C.length ? { done: !0 } : { done: !1, value: C[F++] };
                  }, e: function(J) {
                    throw J;
                  }, f: k };
                }
                throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
              var H = !0, Z = !1, Y;
              return { s: function() {
                w = C[Symbol.iterator]();
              }, n: function() {
                var J = w.next();
                return H = J.done, J;
              }, e: function(J) {
                Z = !0, Y = J;
              }, f: function() {
                try {
                  !H && w.return != null && w.return();
                } finally {
                  if (Z)
                    throw Y;
                }
              } };
            }
            function N(C, I) {
              if (C) {
                if (typeof C == "string")
                  return T(C, I);
                var w = Object.prototype.toString.call(C).slice(8, -1);
                if (w === "Object" && C.constructor && (w = C.constructor.name), w === "Map" || w === "Set")
                  return Array.from(C);
                if (w === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(w))
                  return T(C, I);
              }
            }
            function T(C, I) {
              (I == null || I > C.length) && (I = C.length);
              for (var w = 0, F = new Array(I); w < I; w++)
                F[w] = C[w];
              return F;
            }
            var R = "CMCD", y = 1, E = {
              MANIFEST: "m",
              AUDIO: "a",
              VIDEO: "v",
              INIT: "i",
              CAPTION: "c",
              ISOBMFF_TEXT_TRACK: "tt",
              ENCRYPTION_KEY: "k",
              OTHER: "o"
            }, L = {
              DASH: "d",
              MSS: "s"
            }, _ = {
              VOD: "v",
              LIVE: "l"
            }, O = 5;
            function D() {
              var C, I, w, F, k, H, Z, Y, j, J, ae = this.context, G = (0, h.default)(ae).getInstance(), $ = (0, v.default)(ae).getInstance();
              function ie() {
                C = (0, A.default)(ae).getInstance(), z();
              }
              function re() {
                G.on(f.default.PLAYBACK_RATE_CHANGED, _e, I), G.on(f.default.MANIFEST_LOADED, ge, I), G.on(f.default.BUFFER_LEVEL_STATE_CHANGED, Ce, I), G.on(f.default.PLAYBACK_SEEKED, Ee, I), G.on(f.default.PERIOD_SWITCH_COMPLETED, oe, I);
              }
              function ce(Ae) {
                Ae && (Ae.abrController && (F = Ae.abrController), Ae.dashMetrics && (k = Ae.dashMetrics), Ae.playbackController && (H = Ae.playbackController));
              }
              function z() {
                w = {
                  pr: 1,
                  nor: null,
                  st: null,
                  sf: null,
                  sid: "".concat(b.default.generateUuid()),
                  cid: null
                }, j = {}, Y = {}, J = {}, de();
              }
              function oe() {
                de();
              }
              function de() {
                if (H) {
                  var Ae = H.getStreamController();
                  if (Ae && typeof Ae.getActiveStream == "function") {
                    var Ie = Ae.getActiveStream();
                    Ie && (Z = Ie.getProcessors());
                  }
                }
              }
              function pe(Ae) {
                try {
                  if ($.get().streaming.cmcd && $.get().streaming.cmcd.enabled) {
                    var Ie = le(Ae), Xe = he(Ie), it = Re(Xe);
                    return G.trigger(p.default.CMCD_DATA_GENERATED, {
                      url: Ae.url,
                      mediaType: Ae.mediaType,
                      cmcdData: Ie,
                      cmcdString: it
                    }), {
                      key: R,
                      value: it
                    };
                  }
                  return null;
                } catch {
                  return null;
                }
              }
              function he(Ae) {
                try {
                  var Ie = $.get().streaming.cmcd.enabledKeys;
                  return Object.keys(Ae).filter(function(Xe) {
                    return Ie.includes(Xe);
                  }).reduce(function(Xe, it) {
                    return Xe[it] = Ae[it], Xe;
                  }, {});
                } catch {
                  return Ae;
                }
              }
              function se(Ae, Ie) {
                var Xe = {}, it = S(Ie), rt;
                try {
                  for (it.s(); !(rt = it.n()).done; ) {
                    var Ne = rt.value;
                    Ae[Ne] && (Xe[Ne] = Ae[Ne]);
                  }
                } catch (He) {
                  it.e(He);
                } finally {
                  it.f();
                }
                return Xe;
              }
              function ee(Ae) {
                try {
                  if ($.get().streaming.cmcd && $.get().streaming.cmcd.enabled) {
                    var Ie = le(Ae), Xe = se(Ie, te(["br", "d", "ot", "tb"])), it = se(Ie, te(["bl", "dl", "mtp", "nor", "nrr", "su"])), rt = se(Ie, te(["bs", "rtp"])), Ne = se(Ie, te(["cid", "pr", "sf", "sid", "st", "v"])), He = {
                      "CMCD-Object": Re(Xe),
                      "CMCD-Request": Re(it),
                      "CMCD-Status": Re(rt),
                      "CMCD-Session": Re(Ne)
                    };
                    return G.trigger(p.default.CMCD_DATA_GENERATED, {
                      url: Ae.url,
                      mediaType: Ae.mediaType,
                      cmcdData: Ie,
                      headers: He
                    }), He;
                  }
                  return null;
                } catch {
                  return null;
                }
              }
              function te(Ae) {
                var Ie = $.get().streaming.cmcd.enabledKeys;
                return Ae.filter(function(Xe) {
                  return Ie.includes(Xe);
                });
              }
              function le(Ae) {
                try {
                  var Ie = null;
                  return Ae.type === m.HTTPRequest.MPD_TYPE ? x(Ae) : Ae.type === m.HTTPRequest.MEDIA_SEGMENT_TYPE ? (B(Ae.mediaType), P(Ae)) : Ae.type === m.HTTPRequest.INIT_SEGMENT_TYPE ? W(Ae) : Ae.type === m.HTTPRequest.OTHER_TYPE || Ae.type === m.HTTPRequest.XLINK_EXPANSION_TYPE ? X(Ae) : Ae.type === m.HTTPRequest.LICENSE ? ne(Ae) : Ie;
                } catch {
                  return null;
                }
              }
              function ne(Ae) {
                var Ie = K();
                return Ie.ot = E.ENCRYPTION_KEY, Ie;
              }
              function x() {
                var Ae = K();
                return Ae.ot = E.MANIFEST, Ae;
              }
              function P(Ae) {
                var Ie = K(), Xe = U(Ae), it = Q(Ae), rt = fe(Ae.mediaType), Ne = ue(Ae.mediaType), He = q(Ae.mediaType), $e = V(Ae.mediaType), nt = w.pr, ut = Pe(Ae.mediaType), pt;
                Ae.mediaType === g.default.VIDEO && (pt = E.VIDEO), Ae.mediaType === g.default.AUDIO && (pt = E.AUDIO), Ae.mediaType === g.default.TEXT && (Ae.mediaInfo.mimeType === "application/mp4" ? pt = E.ISOBMFF_TEXT_TRACK : pt = E.CAPTION);
                var vt = $.get().streaming.cmcd.rtp;
                return vt || (vt = ke(Ae)), Ie.rtp = vt, ut && (Ae.url !== ut.url ? Ie.nor = encodeURIComponent(b.default.getRelativeUrl(Ae.url, ut.url)) : ut.range && (Ie.nrr = ut.range)), Xe && (Ie.br = Xe), pt && (Ie.ot = pt), isNaN(it) || (Ie.d = it), isNaN(rt) || (Ie.mtp = rt), isNaN(Ne) || (Ie.dl = Ne), isNaN(He) || (Ie.bl = He), isNaN($e) || (Ie.tb = $e), !isNaN(nt) && nt !== 1 && (Ie.pr = nt), j[Ae.mediaType] && (Ie.bs = !0, j[Ae.mediaType] = !1), (Y[Ae.mediaType] || !J[Ae.mediaType]) && (Ie.su = !0, Y[Ae.mediaType] = !1, J[Ae.mediaType] = !0), Ie;
              }
              function B(Ae) {
                J.hasOwnProperty(Ae) || (J[Ae] = !1), Y.hasOwnProperty(Ae) || (Y[Ae] = !1), j.hasOwnProperty(Ae) || (j[Ae] = !1);
              }
              function W() {
                var Ae = K();
                return Ae.ot = E.INIT, Ae.su = !0, Ae;
              }
              function X() {
                var Ae = K();
                return Ae.ot = E.OTHER, Ae;
              }
              function K() {
                var Ae = {}, Ie = $.get().streaming.cmcd.cid ? $.get().streaming.cmcd.cid : w.cid;
                return Ae.v = y, Ae.sid = $.get().streaming.cmcd.sid ? $.get().streaming.cmcd.sid : w.sid, Ae.sid = "".concat(Ae.sid), Ie && (Ae.cid = "".concat(Ie)), !isNaN(w.pr) && w.pr !== 1 && w.pr !== null && (Ae.pr = w.pr), w.st && (Ae.st = w.st), w.sf && (Ae.sf = w.sf), Ae;
              }
              function U(Ae) {
                try {
                  var Ie = Ae.quality, Xe = Ae.mediaInfo.bitrateList;
                  return parseInt(Xe[Ie].bandwidth / 1e3);
                } catch {
                  return null;
                }
              }
              function V(Ae) {
                try {
                  var Ie = F.getTopBitrateInfoFor(Ae);
                  return Math.round(Ie.bitrate / 1e3);
                } catch {
                  return null;
                }
              }
              function Q(Ae) {
                try {
                  return isNaN(Ae.duration) ? null : Math.round(Ae.duration * 1e3);
                } catch {
                  return null;
                }
              }
              function fe(Ae) {
                try {
                  return parseInt(F.getThroughputHistory().getSafeAverageThroughput(Ae) / 100) * 100;
                } catch {
                  return null;
                }
              }
              function ue(Ae) {
                try {
                  var Ie = w.pr, Xe = k.getCurrentBufferLevel(Ae);
                  return !isNaN(Ie) && !isNaN(Xe) ? parseInt(Xe / Ie * 10) * 100 : null;
                } catch {
                  return null;
                }
              }
              function q(Ae) {
                try {
                  var Ie = k.getCurrentBufferLevel(Ae);
                  return isNaN(Ie) ? null : parseInt(Ie * 10) * 100;
                } catch {
                  return null;
                }
              }
              function _e(Ae) {
                try {
                  w.pr = Ae.playbackRate;
                } catch {
                }
              }
              function ge(Ae) {
                try {
                  var Ie = C.getIsDynamic(Ae.data), Xe = Ie ? _.LIVE : _.VOD, it = Ae.protocol && Ae.protocol === "MSS" ? L.MSS : L.DASH;
                  w.st = "".concat(Xe), w.sf = "".concat(it);
                } catch {
                }
              }
              function Ce(Ae) {
                try {
                  Ae.state && Ae.mediaType && Ae.state === f.default.BUFFER_EMPTY && (j[Ae.mediaType] || (j[Ae.mediaType] = !0), Y[Ae.mediaType] || (Y[Ae.mediaType] = !0));
                } catch {
                }
              }
              function Ee() {
                for (var Ae in j)
                  j.hasOwnProperty(Ae) && (j[Ae] = !0);
                for (var Ie in Y)
                  Y.hasOwnProperty(Ie) && (Y[Ie] = !0);
              }
              function Re(Ae) {
                try {
                  if (!Ae)
                    return null;
                  var Ie = Object.keys(Ae).sort(function(rt, Ne) {
                    return rt.localeCompare(Ne);
                  }), Xe = Ie.length, it = Ie.reduce(function(rt, Ne, He) {
                    return Ne === "v" && Ae[Ne] === 1 || (typeof Ae[Ne] == "string" && Ne !== "ot" && Ne !== "sf" && Ne !== "st" ? rt += "".concat(Ne, "=").concat(JSON.stringify(Ae[Ne])) : rt += "".concat(Ne, "=").concat(Ae[Ne]), He < Xe - 1 && (rt += ",")), rt;
                  }, "");
                  return it = it.replace(/=true/g, ""), it = it.replace(/,\s*$/, ""), it;
                } catch {
                  return null;
                }
              }
              function Pe(Ae) {
                if (!(!Z || Z.length === 0)) {
                  var Ie = S(Z), Xe;
                  try {
                    for (Ie.s(); !(Xe = Ie.n()).done; ) {
                      var it = Xe.value;
                      if (it.getType() === Ae)
                        return it.probeNextRequest();
                    }
                  } catch (rt) {
                    Ie.e(rt);
                  } finally {
                    Ie.f();
                  }
                }
              }
              function ke(Ae) {
                var Ie = H.getPlaybackRate();
                Ie || (Ie = 1);
                var Xe = Ae.quality, it = Ae.mediaType, rt = Ae.mediaInfo, Ne = Ae.duration, He = q(it);
                He === 0 && (He = 500);
                var $e = rt.bitrateList[Xe].bandwidth, nt = $e * Ne / 1e3, ut = He / Ie / 1e3, pt = nt / ut, vt = $.get().streaming.cmcd.rtpSafetyFactor && !isNaN($.get().streaming.cmcd.rtpSafetyFactor) ? $.get().streaming.cmcd.rtpSafetyFactor : O, Ut = pt * vt, Je = (parseInt(Ut / 100) + 1) * 100;
                return Je;
              }
              function De() {
                G.off(f.default.PLAYBACK_RATE_CHANGED, _e, this), G.off(f.default.MANIFEST_LOADED, ge, this), G.off(f.default.BUFFER_LEVEL_STATE_CHANGED, Ce, I), G.off(f.default.PLAYBACK_SEEKED, Ee, I), z();
              }
              return I = {
                getQueryParameter: pe,
                getHeaderParameters: ee,
                setConfig: ce,
                reset: De,
                initialize: re
              }, ie(), I;
            }
            D.__dashjs_factory_name = "CmcdModel";
            const M = d.default.getSingletonFactory(D);
          }
        ),
        /***/
        "./src/streaming/models/CmsdModel.js": (
          /*!*******************************************!*\
            !*** ./src/streaming/models/CmsdModel.js ***!
            \*******************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => k
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), p = i(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), d = i(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            );
            function v(H) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? v = function(Y) {
                return typeof Y;
              } : v = function(Y) {
                return Y && typeof Symbol == "function" && Y.constructor === Symbol && Y !== Symbol.prototype ? "symbol" : typeof Y;
              }, v(H);
            }
            function g(H, Z) {
              g = function(ie, re) {
                return new ae(ie, void 0, re);
              };
              var Y = A(RegExp), j = RegExp.prototype, J = /* @__PURE__ */ new WeakMap();
              function ae($, ie, re) {
                var ce = Y.call(this, $, ie);
                return J.set(ce, re || J.get($)), ce;
              }
              m(ae, Y), ae.prototype.exec = function($) {
                var ie = j.exec.call(this, $);
                return ie && (ie.groups = G(ie, this)), ie;
              }, ae.prototype[Symbol.replace] = function($, ie) {
                if (typeof ie == "string") {
                  var re = J.get(this);
                  return j[Symbol.replace].call(this, $, ie.replace(/\$<([^>]+)>/g, function(z, oe) {
                    return "$" + re[oe];
                  }));
                } else if (typeof ie == "function") {
                  var ce = this;
                  return j[Symbol.replace].call(this, $, function() {
                    var z = [];
                    return z.push.apply(z, arguments), v(z[z.length - 1]) !== "object" && z.push(G(z, ce)), ie.apply(this, z);
                  });
                } else
                  return j[Symbol.replace].call(this, $, ie);
              };
              function G($, ie) {
                var re = J.get(ie);
                return Object.keys(re).reduce(function(ce, z) {
                  return ce[z] = $[re[z]], ce;
                }, /* @__PURE__ */ Object.create(null));
              }
              return g.apply(this, arguments);
            }
            function m(H, Z) {
              if (typeof Z != "function" && Z !== null)
                throw new TypeError("Super expression must either be null or a function");
              H.prototype = Object.create(Z && Z.prototype, { constructor: { value: H, writable: !0, configurable: !0 } }), Z && T(H, Z);
            }
            function A(H) {
              var Z = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
              return A = function(j) {
                if (j === null || !N(j))
                  return j;
                if (typeof j != "function")
                  throw new TypeError("Super expression must either be null or a function");
                if (typeof Z < "u") {
                  if (Z.has(j))
                    return Z.get(j);
                  Z.set(j, J);
                }
                function J() {
                  return b(j, arguments, R(this).constructor);
                }
                return J.prototype = Object.create(j.prototype, { constructor: { value: J, enumerable: !1, writable: !0, configurable: !0 } }), T(J, j);
              }, A(H);
            }
            function b(H, Z, Y) {
              return S() ? b = Reflect.construct : b = function(J, ae, G) {
                var $ = [null];
                $.push.apply($, ae);
                var ie = Function.bind.apply(J, $), re = new ie();
                return G && T(re, G.prototype), re;
              }, b.apply(null, arguments);
            }
            function S() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return !1;
              if (typeof Proxy == "function")
                return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function N(H) {
              return Function.toString.call(H).indexOf("[native code]") !== -1;
            }
            function T(H, Z) {
              return T = Object.setPrototypeOf || function(j, J) {
                return j.__proto__ = J, j;
              }, T(H, Z);
            }
            function R(H) {
              return R = Object.setPrototypeOf ? Object.getPrototypeOf : function(Y) {
                return Y.__proto__ || Object.getPrototypeOf(Y);
              }, R(H);
            }
            var y = "static", E = "dynamic", L = "cmsd-", _ = L + y, O = L + E, D = {
              AVAILABILITY_TIME: "at",
              DURESS: "du",
              ENCODED_BITRATE: "br",
              ESTIMATED_THROUGHPUT: "etp",
              HELD_TIME: "ht",
              INTERMEDIARY_IDENTIFIER: "n",
              MAX_SUGGESTED_BITRATE: "mb",
              NEXT_OBJECT_RESPONSE: "nor",
              NEXT_RANGE_RESPONSE: "nrr",
              OBJECT_DURATION: "d",
              OBJECT_TYPE: "ot",
              RESPONSE_DELAY: "rd",
              ROUND_TRIP_TIME: "rtt",
              STARTUP: "su",
              STREAM_TYPE: "st",
              STREAMING_FORMAT: "sf",
              VERSION: "v"
            }, M = {
              MANIFEST: "m",
              AUDIO: "a",
              VIDEO: "v",
              INIT: "i",
              CAPTION: "c",
              ISOBMFF_TEXT_TRACK: "tt",
              ENCRYPTION_KEY: "k",
              OTHER: "o",
              STREAM: "stream"
              // Specific value for parameters without object type, which apply for all media/objects
            }, C = [D.MAX_SUGGESTED_BITRATE, D.STREAM_TYPE, D.STREAMING_FORMAT, D.VERSION], I = {
              video: M.VIDEO,
              audio: M.AUDIO,
              text: M.ISOBMFF_TEXT_TRACK,
              stream: M.STREAM
            }, w = /^[-0-9]/;
            function F() {
              var H = this.context, Z = (0, f.default)(H).getInstance(), Y, j, J, ae;
              function G() {
                j = (0, d.default)(H).getInstance().getLogger(Y), re();
              }
              function $() {
              }
              function ie() {
              }
              function re() {
                J = {}, ae = {};
              }
              function ce(P) {
                P && Object.keys(P).forEach(function(B) {
                  C.includes(B) || delete P[B];
                });
              }
              function z(P) {
                return P ? P.toLowerCase() === "false" ? !1 : w.test(P) ? parseInt(P, 10) : P.replace(/["]+/g, "") : !0;
              }
              function oe(P) {
                try {
                  for (var B = {}, W = P.split(","), X = 0; X < W.length; X++) {
                    var K = W[X].split("="), U = K[0], V = z(K[1]);
                    B[U] = V;
                  }
                  return B;
                } catch (Q) {
                  j.error("Failed to parse CMSD-Static response header value:", Q);
                }
              }
              function de(P) {
                try {
                  for (var B = {}, W = P.split(","), X = W[W.length - 1], K = X.split(";"), U = 1; U < K.length; U++) {
                    var V = K[U].split("="), Q = V[0], fe = z(V[1]);
                    B[Q] = fe;
                  }
                  return B;
                } catch (ue) {
                  return j.error("Failed to parse CMSD-Dynamic response header value:", ue), [];
                }
              }
              function pe(P) {
                return I[P] || M.OTHER;
              }
              function he(P, B, W) {
                var X = P === y ? J : ae, K = X[B] || {}, U = X[M.STREAM] || {}, V = K[W] || U[W];
                return V;
              }
              function se(P, B) {
                for (var W = null, X = null, K = P.split(`\r
`), U = K.length - 1; U >= 0; U--) {
                  var V = K[U], Q = V.match(/* @__PURE__ */ g(/^((?:(?!:)[\s\S])*):[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*(.*)$/, {
                    key: 1,
                    value: 2
                  }));
                  if (Q && Q.groups) {
                    var fe = Q.groups.key.toLowerCase(), ue = Q.groups.value;
                    switch (fe) {
                      case _:
                        W = oe(ue), Z.trigger(p.default.CMSD_STATIC_HEADER, W);
                        break;
                      case O:
                        X || (X = de(ue));
                        break;
                    }
                  }
                }
                var q = M.STREAM;
                return W && W[D.OBJECT_TYPE] ? q = W[D.OBJECT_TYPE] : B && (q = pe(B)), ce(J[q]), ce(ae[q]), W && (J[q] = Object.assign(J[q] || {}, W)), X && (ae[q] = Object.assign(ae[q] || {}, X)), {
                  static: W,
                  dynamic: X
                };
              }
              function ee(P) {
                var B = pe(P), W = he(E, B, D.MAX_SUGGESTED_BITRATE);
                return W || -1;
              }
              function te(P) {
                var B = pe(P), W = he(E, B, D.ESTIMATED_THROUGHPUT);
                return W || null;
              }
              function le(P) {
                var B = pe(P), W = he(E, B, D.RESPONSE_DELAY);
                return W || null;
              }
              function ne(P) {
                var B = pe(P), W = he(E, B, D.ROUND_TRIP_TIME);
                return W || null;
              }
              function x() {
                re();
              }
              return Y = {
                setConfig: ie,
                initialize: $,
                reset: x,
                parseResponseHeaders: se,
                getMaxBitrate: ee,
                getEstimatedThroughput: te,
                getResponseDelay: le,
                getRoundTripTime: ne
              }, G(), Y;
            }
            F.__dashjs_factory_name = "CmsdModel";
            const k = h.default.getSingletonFactory(F);
          }
        ),
        /***/
        "./src/streaming/models/CustomParametersModel.js": (
          /*!*******************************************************!*\
            !*** ./src/streaming/models/CustomParametersModel.js ***!
            \*******************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => b
              /* harmony export */
            });
            var h = i(
              /*! ../../dash/vo/UTCTiming */
              "./src/dash/vo/UTCTiming.js"
            ), f = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), p = i(
              /*! ../../core/Settings */
              "./src/core/Settings.js"
            ), d = i(
              /*! ../utils/SupervisorTools */
              "./src/streaming/utils/SupervisorTools.js"
            ), v = i(
              /*! ../rules/abr/ABRRulesCollection */
              "./src/streaming/rules/abr/ABRRulesCollection.js"
            ), g = i(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), m = !1;
            function A() {
              var S, N, T, R, y, E, L, _, O = this.context, D = (0, p.default)(O).getInstance();
              function M() {
                T = {
                  default: m
                }, C();
              }
              function C() {
                R = [], y = [], E = [], _ = [], L = null, N = [];
              }
              function I() {
                C();
              }
              function w() {
              }
              function F(B) {
                L = B;
              }
              function k() {
                L = null;
              }
              function H() {
                return L;
              }
              function Z() {
                return R;
              }
              function Y() {
                return y;
              }
              function j(B) {
                R.push(B);
              }
              function J(B) {
                y.push(B);
              }
              function ae(B) {
                ce(R, B);
              }
              function G(B) {
                ce(y, B);
              }
              function $() {
                return E;
              }
              function ie(B) {
                E.push(B);
              }
              function re(B) {
                ce(E, B);
              }
              function ce(B, W) {
                var X = -1;
                B.some(function(K, U) {
                  if (K === W)
                    return X = U, !0;
                }), !(X < 0) && B.splice(X, 1);
              }
              function z(B) {
                var W;
                for (W = 0; W < _.length; W++)
                  if (_[W].rulename === B)
                    return W;
                return -1;
              }
              function oe(B, W, X) {
                if (typeof B != "string" || B !== v.default.ABANDON_FRAGMENT_RULES && B !== v.default.QUALITY_SWITCH_RULES || typeof W != "string")
                  throw g.default.BAD_ARGUMENT_ERROR;
                var K = z(W);
                K === -1 ? _.push({
                  type: B,
                  rulename: W,
                  rule: X
                }) : (_[K].type = B, _[K].rule = X);
              }
              function de(B) {
                if (B) {
                  var W = z(B);
                  W !== -1 && _.splice(W, 1);
                } else
                  _ = [];
              }
              function pe() {
                _ = [];
              }
              function he() {
                return _;
              }
              function se(B, W) {
                te(B, W);
                var X = new h.default();
                X.schemeIdUri = B, X.value = W, N.push(X);
              }
              function ee() {
                return N;
              }
              function te(B, W) {
                (0, d.checkParameterType)(B, "string"), (0, d.checkParameterType)(W, "string"), N.forEach(function(X, K) {
                  X.schemeIdUri === B && X.value === W && N.splice(K, 1);
                });
              }
              function le() {
                N = [];
              }
              function ne() {
                var B = D.get().streaming.utcSynchronization.defaultTimingSource;
                se(B.scheme, B.value);
              }
              function x(B, W) {
                B ? T[B] = !!W : Object.keys(T).forEach(function(X) {
                  x(X, W);
                });
              }
              function P(B) {
                var W = T[B];
                return W === void 0 ? T.default : W;
              }
              return S = {
                getCustomInitialTrackSelectionFunction: H,
                setCustomInitialTrackSelectionFunction: F,
                resetCustomInitialTrackSelectionFunction: k,
                getLicenseResponseFilters: Y,
                getLicenseRequestFilters: Z,
                getCustomCapabilitiesFilters: $,
                registerCustomCapabilitiesFilter: ie,
                registerLicenseResponseFilter: J,
                registerLicenseRequestFilter: j,
                unregisterCustomCapabilitiesFilter: re,
                unregisterLicenseResponseFilter: G,
                unregisterLicenseRequestFilter: ae,
                addAbrCustomRule: oe,
                removeAllAbrCustomRule: pe,
                removeAbrCustomRule: de,
                getAbrCustomRules: he,
                addUTCTimingSource: se,
                removeUTCTimingSource: te,
                getUTCTimingSources: ee,
                clearDefaultUTCTimingSources: le,
                restoreDefaultUTCTimingSources: ne,
                setXHRWithCredentialsForType: x,
                getXHRWithCredentialsForType: P,
                setConfig: w,
                reset: I
              }, M(), S;
            }
            A.__dashjs_factory_name = "CustomParametersModel";
            const b = f.default.getSingletonFactory(A);
          }
        ),
        /***/
        "./src/streaming/models/FragmentModel.js": (
          /*!***********************************************!*\
            !*** ./src/streaming/models/FragmentModel.js ***!
            \***********************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => b
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ../vo/FragmentRequest */
              "./src/streaming/vo/FragmentRequest.js"
            ), p = "loading", d = "executed", v = "canceled", g = "failed";
            function m(S) {
              S = S || {};
              var N = S.eventBus, T = S.events, R = S.dashMetrics, y = S.fragmentLoader, E = S.debug, L = S.streamInfo, _ = S.type, O, D, M, C;
              function I() {
                D = E.getLogger(O), ee(), N.on(T.LOADING_COMPLETED, pe, O), N.on(T.LOADING_DATA_PROGRESS, he, O), N.on(T.LOADING_ABANDONED, se, O);
              }
              function w() {
                return L.id;
              }
              function F() {
                return _;
              }
              function k(ne) {
                var x = function(K, U) {
                  return K.action === f.default.ACTION_COMPLETE && K.action === U.action;
                }, P = function(K, U) {
                  return !isNaN(K.index) && K.startTime === U.startTime && K.adaptationIndex === U.adaptationIndex && K.type === U.type;
                }, B = function(K, U) {
                  return isNaN(K.index) && isNaN(U.index) && K.quality === U.quality;
                }, W = function(K) {
                  var U = !1;
                  return K.some(function(V) {
                    if (P(ne, V) || B(ne, V) || x(ne, V))
                      return U = !0, U;
                  }), U;
                };
                return ne ? W(M) : !1;
              }
              function H(ne) {
                var x = !1, P = 0, B;
                if (x = k(ne), !x)
                  for (P = 0; P < C.length; P++)
                    B = C[P], ne.url === B.url && ne.startTime === B.startTime && (x = !0);
                return x;
              }
              function Z(ne) {
                var x = ne ? ne.state instanceof Array ? ne.state : [ne.state] : [], P = [];
                return x.forEach(function(B) {
                  var W = oe(B);
                  P = P.concat(z(W, ne));
                }), P;
              }
              function Y(ne) {
                return isNaN(ne.duration) ? 0.25 : Math.min(ne.duration / 8, 0.5);
              }
              function j(ne) {
                M = M.filter(function(x) {
                  var P = Y(x);
                  return isNaN(x.startTime) || (ne !== void 0 ? x.startTime >= ne - P : !1);
                });
              }
              function J(ne) {
                M = M.filter(function(x) {
                  return isNaN(x.startTime) || (ne !== void 0 ? x.startTime < ne : !1);
                });
              }
              function ae(ne, x) {
                x <= ne + 0.5 || (M = M.filter(function(P) {
                  var B = Y(P);
                  return isNaN(P.startTime) || P.startTime >= x - B || isNaN(P.duration) || P.startTime + P.duration <= ne + B;
                }));
              }
              function G(ne, x) {
                if (!ne || ne.length === 0) {
                  j();
                  return;
                }
                for (var P = 0, B = 0, W = ne.length; B < W; B++)
                  ae(P, ne.start(B)), P = ne.end(B);
                x > 0 && ae(P, x);
              }
              function $() {
                D.debug("abort requests"), y.abort(), C = [];
              }
              function ie(ne) {
                switch (ne.action) {
                  case f.default.ACTION_DOWNLOAD:
                    de(ne, p), C.push(ne), re(ne);
                    break;
                  default:
                    D.warn("Unknown request action.");
                }
              }
              function re(ne) {
                N.trigger(T.FRAGMENT_LOADING_STARTED, {
                  request: ne
                }, {
                  streamId: L.id,
                  mediaType: _
                }), y.load(ne);
              }
              function ce(ne, x, P) {
                for (var B = ne.length - 1, W = B; W >= 0; W--) {
                  var X = ne[W], K = X.startTime, U = K + X.duration;
                  if (P = isNaN(P) ? Y(X) : P, !isNaN(K) && !isNaN(U) && x + P >= K && x - P < U || isNaN(K) && isNaN(x))
                    return X;
                }
                return null;
              }
              function z(ne, x) {
                return x.hasOwnProperty("time") ? [ce(ne, x.time, x.threshold)] : ne.filter(function(P) {
                  for (var B in x)
                    if (B !== "state" && x.hasOwnProperty(B) && P[B] != x[B])
                      return !1;
                  return !0;
                });
              }
              function oe(ne) {
                var x;
                switch (ne) {
                  case p:
                    x = C;
                    break;
                  case d:
                    x = M;
                    break;
                  default:
                    x = [];
                }
                return x;
              }
              function de(ne, x) {
                R.addSchedulingInfo(ne, x), R.addRequestsQueue(ne.mediaType, C, M);
              }
              function pe(ne) {
                ne.sender === y && (C.splice(C.indexOf(ne.request), 1), ne.response && !ne.error && M.push(ne.request), de(ne.request, ne.error ? g : d), N.trigger(T.FRAGMENT_LOADING_COMPLETED, {
                  request: ne.request,
                  response: ne.response,
                  error: ne.error,
                  sender: this
                }, {
                  streamId: L.id,
                  mediaType: _
                }));
              }
              function he(ne) {
                ne.sender === y && N.trigger(T.FRAGMENT_LOADING_PROGRESS, {
                  request: ne.request,
                  response: ne.response,
                  error: ne.error,
                  sender: this
                }, {
                  streamId: L.id,
                  mediaType: _
                });
              }
              function se(ne) {
                ne.sender === y && N.trigger(T.FRAGMENT_LOADING_ABANDONED, {
                  request: ne.request
                }, {
                  streamId: L.id,
                  mediaType: _
                });
              }
              function ee() {
                M = [], C = [];
              }
              function te() {
                N.off(T.LOADING_COMPLETED, pe, this), N.off(T.LOADING_DATA_PROGRESS, he, this), N.off(T.LOADING_ABANDONED, se, this), y && y.reset(), ee();
              }
              function le(ne) {
                M.push(ne);
              }
              return O = {
                getStreamId: w,
                getType: F,
                getRequests: Z,
                isFragmentLoaded: k,
                isFragmentLoadedOrPending: H,
                removeExecutedRequestsBeforeTime: j,
                removeExecutedRequestsAfterTime: J,
                syncExecutedRequestsWithBufferedRange: G,
                abortRequests: $,
                executeRequest: ie,
                reset: te,
                resetInitialSettings: ee,
                addExecutedRequest: le
              }, I(), O;
            }
            m.__dashjs_factory_name = "FragmentModel";
            var A = h.default.getClassFactory(m);
            A.FRAGMENT_MODEL_LOADING = p, A.FRAGMENT_MODEL_EXECUTED = d, A.FRAGMENT_MODEL_CANCELED = v, A.FRAGMENT_MODEL_FAILED = g, h.default.updateClassFactory(m.__dashjs_factory_name, A);
            const b = A;
          }
        ),
        /***/
        "./src/streaming/models/LowLatencyThroughputModel.js": (
          /*!***********************************************************!*\
            !*** ./src/streaming/models/LowLatencyThroughputModel.js ***!
            \***********************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => d
              /* harmony export */
            });
            var h = i(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), f = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function p() {
              var v = 10, g = 0.8, m = 0.6, A = 1.05, b = 250, S = this.context, N, T, R = {};
              function y() {
                T = (0, h.default)(S).getInstance().getLogger(N);
              }
              function E(M) {
                for (var C = {}, I = 0, w = 0, F = 0, k = 0, H = M.length, Z = 0; Z < H; ++Z)
                  I += M[Z].chunkDownloadTimeRelativeMS, w += M[Z].bufferLevel, F += M[Z].chunkDownloadTimeRelativeMS * M[Z].bufferLevel, k += M[Z].chunkDownloadTimeRelativeMS * M[Z].chunkDownloadTimeRelativeMS;
                return C.m = (F - I * w / H) / (k - I * I / H), C.b = w / H - C.m * I / H, function(Y) {
                  return C.m * Y + C.b;
                };
              }
              function L(M) {
                var C = !0, I, w = M.reduce(function(F, k) {
                  return F + k.bufferLevelAtSegmentEnd;
                }, 0) / M.length;
                return M.forEach(function(F) {
                  Math.abs(F.bufferLevelAtSegmentEnd / F.bufferLevelAtSegmentStart) < 0.95 && (C = !1), F.bufferLevelAtSegmentEnd / w < 0.8 && (C = !1), I ? I > F.bitrate && (C = !1) : I = F.bitrate;
                }), C;
              }
              function _(M) {
                var C = R[M.mediaType].slice(-1).pop(), I = R[M.mediaType].slice(-3), w = C.chunkMeasurements.slice(-1).pop().chunkDownloadTimeRelativeMS;
                C.bufferLevelAtSegmentStart = C.getEstimatedBufferLevel(w / 2), C.bufferLevelAtSegmentEnd = C.getEstimatedBufferLevel(w);
                var F = L(I), k = F ? m : g;
                if (C.isBufferStable && C.segDurationMS * A < C.fetchDownloadDurationMS)
                  return C.fetchDownloadDurationMS;
                if (!F || C.segDurationMS < C.fetchDownloadDurationMS || C.adjustedAvailabilityStartTimeMS <= C.requestTimeMS + C.throughputCapacityDelayMS - C.segDurationMS)
                  return C.fetchDownloadDurationMS * g;
                for (var H = C.requestTimeMS + C.throughputCapacityDelayMS - C.adjustedAvailabilityStartTimeMS, Z = 0, Y = 0, j = 0, J = 0; J < C.chunkMeasurements.length; J++) {
                  var ae = C.chunkMeasurements[J];
                  if (H < Y + ae.chunkDownloadDurationMS)
                    break;
                  Y += ae.chunkDownloadDurationMS, Z += ae.chunkBytes, j++;
                }
                if (H < 0 && T.warn("request time was before adjusted availibitly start time"), Z && Y && j > C.chunkMeasurements.length * 0.2) {
                  var G = Z / Y, $ = C.segmentBytes / G;
                  return C.fetchDownloadDurationMS < $ ? C.fetchDownloadDurationMS * k : $ * k;
                }
                var ie = C.bitrate;
                return C.bitrateList.some(function(re) {
                  if (re.bandwidth > C.bitrate)
                    return ie = re.bandwidth, !0;
                }), ie === C.bitrate ? C.fetchDownloadDurationMS * k : k * C.segmentBytes * 8 * 1e3 / ie;
              }
              function O(M, C) {
                var I = R[M.mediaType] && R[M.mediaType].slice(-3);
                return !I || I.length < 3 || !L(I) ? 0 : C / 4 > b ? b : C / 4;
              }
              function D(M, C, I, w, F) {
                M && M.mediaType && !R[M.mediaType] && (R[M.mediaType] = []);
                var k = M.mediaInfo.bitrateList.find(function(H) {
                  return H.id === M.representationId;
                });
                R[M.mediaType].push({
                  index: M.index,
                  repId: M.representationId,
                  mediaType: M.mediaType,
                  requestTimeMS: w,
                  adjustedAvailabilityStartTimeMS: M.availabilityStartTime.getTime(),
                  segDurationMS: M.duration * 1e3,
                  chunksDurationMS: I.reduce(function(H, Z) {
                    return H + Z.chunkDownloadDurationMS;
                  }, 0),
                  segmentBytes: I.reduce(function(H, Z) {
                    return H + Z.chunkBytes;
                  }, 0),
                  bitrate: k && k.bandwidth,
                  bitrateList: M.mediaInfo.bitrateList,
                  chunkMeasurements: I,
                  fetchDownloadDurationMS: C,
                  throughputCapacityDelayMS: F,
                  getEstimatedBufferLevel: E(I.slice(1))
                  // don't use first chunk's buffer level
                }), R[M.mediaType].length > v && R[M.mediaType].shift();
              }
              return N = {
                setup: y,
                addMeasurement: D,
                getThroughputCapacityDelayMS: O,
                getEstimatedDownloadDurationMS: _
              }, y(), N;
            }
            p.__dashjs_factory_name = "LowLatencyThroughputModel";
            const d = f.default.getSingletonFactory(p);
          }
        ),
        /***/
        "./src/streaming/models/ManifestModel.js": (
          /*!***********************************************!*\
            !*** ./src/streaming/models/ManifestModel.js ***!
            \***********************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var h = i(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), f = i(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), p = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function d() {
              var g = this.context, m = (0, h.default)(g).getInstance(), A, b;
              function S() {
                return b;
              }
              function N(T) {
                b = T, T && m.trigger(f.default.MANIFEST_LOADED, {
                  data: T
                });
              }
              return A = {
                getValue: S,
                setValue: N
              }, A;
            }
            d.__dashjs_factory_name = "ManifestModel";
            const v = p.default.getSingletonFactory(d);
          }
        ),
        /***/
        "./src/streaming/models/MediaPlayerModel.js": (
          /*!**************************************************!*\
            !*** ./src/streaming/models/MediaPlayerModel.js ***!
            \**************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => y
              /* harmony export */
            });
            var h = i(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), f = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), p = i(
              /*! ../../core/Settings */
              "./src/core/Settings.js"
            ), d = 12, v = 20, g = 10, m = 5, A = 12, b = -0.5, S = 0.5, N = -0.5, T = 1;
            function R() {
              var E, L, _, O, D = this.context, M = (0, p.default)(D).getInstance();
              function C() {
                L = (0, h.default)(D).getInstance().getLogger(E);
              }
              function I(ie) {
                ie.playbackController && (_ = ie.playbackController), ie.serviceDescriptionController && (O = ie.serviceDescriptionController);
              }
              function w(ie, re) {
                return isNaN(ie) ? 0 : ie > 0 ? (re && L.warn("Supplied minimum playback rate is a positive value when it should be negative or 0. The supplied rate will not be applied and set to 0: 100% playback speed."), 0) : ie < N ? (re && L.warn("Supplied minimum playback rate is out of range and will be limited to ".concat(N, ": ").concat(N * 100, "% playback speed.")), N) : ie;
              }
              function F(ie, re) {
                return isNaN(ie) ? 0 : ie < 0 ? (re && L.warn("Supplied maximum playback rate is a negative value when it should be negative or 0. The supplied rate will not be applied and set to 0: 100% playback speed."), 0) : ie > T ? (re && L.warn("Supplied maximum playback rate is out of range and will be limited to ".concat(T, ": ").concat((1 + T) * 100, "% playback speed.")), T) : ie;
              }
              function k() {
                if (!isNaN(M.get().streaming.liveCatchup.maxDrift) && M.get().streaming.liveCatchup.maxDrift > 0)
                  return M.get().streaming.liveCatchup.maxDrift;
                var ie = O.getServiceDescriptionSettings();
                return ie && ie.liveCatchup && !isNaN(ie.liveCatchup.maxDrift) && ie.liveCatchup.maxDrift > 0 ? ie.liveCatchup.maxDrift : A;
              }
              function H(ie) {
                var re = M.get().streaming.liveCatchup.playbackRate;
                if (!isNaN(re.min) || !isNaN(re.max))
                  return {
                    min: w(re.min, ie),
                    max: F(re.max, ie)
                  };
                var ce = O.getServiceDescriptionSettings();
                if (ce && ce.liveCatchup && (!isNaN(ce.liveCatchup.playbackRate.min) || !isNaN(ce.liveCatchup.playbackRate.max))) {
                  var z = ce.liveCatchup.playbackRate;
                  return {
                    min: w(z.min, ie),
                    max: F(z.max, ie)
                  };
                }
                return {
                  min: b,
                  max: S
                };
              }
              function Z() {
                return M.get().streaming.liveCatchup.enabled !== null ? M.get().streaming.liveCatchup.enabled : _.getInitialCatchupModeActivated();
              }
              function Y(ie, re) {
                try {
                  var ce = M.get().streaming.abr[ie][re];
                  if (!isNaN(ce) && ce !== -1)
                    return ce;
                  var z = O.getServiceDescriptionSettings();
                  return z && z[ie] && !isNaN(z[ie][re]) ? z[ie][re] : -1;
                } catch {
                  return -1;
                }
              }
              function j() {
                var ie = M.get().streaming.buffer.initialBufferLevel;
                return isNaN(ie) || ie < 0 ? 0 : Math.min(J(), ie);
              }
              function J() {
                var ie = M.get().streaming.buffer.stableBufferTime > 0 ? M.get().streaming.buffer.stableBufferTime : M.get().streaming.buffer.fastSwitchEnabled ? v : d, re = _.getLiveDelay();
                return !isNaN(re) && re > 0 ? Math.min(ie, re) : ie;
              }
              function ae(ie) {
                var re = isNaN(M.get().streaming.retryAttempts.lowLatencyMultiplyFactor) ? m : M.get().streaming.retryAttempts.lowLatencyMultiplyFactor;
                return _.getLowLatencyModeEnabled() ? M.get().streaming.retryAttempts[ie] * re : M.get().streaming.retryAttempts[ie];
              }
              function G(ie) {
                var re = isNaN(M.get().streaming.retryIntervals.lowLatencyReductionFactor) ? g : M.get().streaming.retryIntervals.lowLatencyReductionFactor;
                return _.getLowLatencyModeEnabled() ? M.get().streaming.retryIntervals[ie] / re : M.get().streaming.retryIntervals[ie];
              }
              function $() {
              }
              return E = {
                getCatchupMaxDrift: k,
                getCatchupModeEnabled: Z,
                getStableBufferTime: J,
                getInitialBufferLevel: j,
                getRetryAttemptsForType: ae,
                getRetryIntervalsForType: G,
                getCatchupPlaybackRates: H,
                getAbrBitrateParameter: Y,
                setConfig: I,
                reset: $
              }, C(), E;
            }
            R.__dashjs_factory_name = "MediaPlayerModel";
            const y = f.default.getSingletonFactory(R);
          }
        ),
        /***/
        "./src/streaming/models/MetricsModel.js": (
          /*!**********************************************!*\
            !*** ./src/streaming/models/MetricsModel.js ***!
            \**********************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => _
              /* harmony export */
            });
            var h = i(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), f = i(
              /*! ../constants/MetricsConstants */
              "./src/streaming/constants/MetricsConstants.js"
            ), p = i(
              /*! ../vo/MetricsList */
              "./src/streaming/vo/MetricsList.js"
            ), d = i(
              /*! ../vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            ), v = i(
              /*! ../vo/metrics/RepresentationSwitch */
              "./src/streaming/vo/metrics/RepresentationSwitch.js"
            ), g = i(
              /*! ../vo/metrics/BufferLevel */
              "./src/streaming/vo/metrics/BufferLevel.js"
            ), m = i(
              /*! ../vo/metrics/BufferState */
              "./src/streaming/vo/metrics/BufferState.js"
            ), A = i(
              /*! ../vo/metrics/DVRInfo */
              "./src/streaming/vo/metrics/DVRInfo.js"
            ), b = i(
              /*! ../vo/metrics/DroppedFrames */
              "./src/streaming/vo/metrics/DroppedFrames.js"
            ), S = i(
              /*! ../vo/metrics/ManifestUpdate */
              "./src/streaming/vo/metrics/ManifestUpdate.js"
            ), N = i(
              /*! ../vo/metrics/SchedulingInfo */
              "./src/streaming/vo/metrics/SchedulingInfo.js"
            ), T = i(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), R = i(
              /*! ../vo/metrics/RequestsQueue */
              "./src/streaming/vo/metrics/RequestsQueue.js"
            ), y = i(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), E = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function L(O) {
              O = O || {};
              var D = O.settings, M = this.context, C = (0, T.default)(M).getInstance(), I, w;
              function F() {
                w = {};
              }
              function k() {
                C.trigger(y.default.METRICS_CHANGED);
              }
              function H(B) {
                C.trigger(y.default.METRIC_CHANGED, {
                  mediaType: B
                }), k();
              }
              function Z(B, W, X) {
                C.trigger(y.default.METRIC_UPDATED, {
                  mediaType: B,
                  metric: W,
                  value: X
                }), H(B);
              }
              function Y(B, W, X) {
                C.trigger(y.default.METRIC_ADDED, {
                  mediaType: B,
                  metric: W,
                  value: X
                }), H(B);
              }
              function j(B) {
                delete w[B], H(B);
              }
              function J() {
                w = {}, k();
              }
              function ae(B, W) {
                var X = null;
                return B && (w.hasOwnProperty(B) ? X = w[B] : W || (X = new p.default(), w[B] = X)), X;
              }
              function G(B, W, X) {
                var K = ae(B);
                K !== null && (K[W].push(X), K[W].length > D.get().streaming.metrics.maxListDepth && K[W].shift());
              }
              function $(B, W, X, K) {
                var U = new d.HTTPRequestTrace();
                return U.s = W, U.d = X, U.b = K, B.trace.push(U), B.interval || (B.interval = 0), B.interval += X, U;
              }
              function ie(B, W, X, K, U, V, Q, fe, ue, q, _e, ge, Ce, Ee, Re, Pe, ke) {
                var De = new d.HTTPRequest();
                V && V !== K && (ie(
                  B,
                  null,
                  X,
                  K,
                  U,
                  null,
                  null,
                  fe,
                  ue,
                  null,
                  // unknown
                  null,
                  // unknown
                  null,
                  // unknown, probably a 302
                  Ce,
                  null,
                  null,
                  Pe,
                  ke
                ), De.actualurl = V), De.tcpid = W, De.type = X, De.url = K, De.range = fe, De.trequest = ue, De.tresponse = q, De.responsecode = ge, De.cmsd = ke, De._tfinish = _e, De._stream = B, De._mediaduration = Ce, De._quality = U, De._responseHeaders = Ee, De._serviceLocation = Q, De._fileLoaderType = Pe, Re ? Re.forEach(function(Ae) {
                  $(De, Ae.s, Ae.d, Ae.b);
                }) : (delete De.interval, delete De.trace), ce(B, f.default.HTTP_REQUEST, De);
              }
              function re(B, W, X, K, U) {
                var V = new v.default();
                V.t = W, V.mt = X, V.to = K, U ? V.lto = U : delete V.lto, ce(B, f.default.TRACK_SWITCH, V);
              }
              function ce(B, W, X) {
                G(B, W, X), Y(B, W, X);
              }
              function z(B, W, X) {
                var K = new g.default();
                K.t = W, K.level = X, ce(B, f.default.BUFFER_LEVEL, K);
              }
              function oe(B, W, X) {
                var K = new m.default();
                K.target = X, K.state = W, ce(B, f.default.BUFFER_STATE, K);
              }
              function de(B, W, X, K) {
                var U = new A.default();
                U.time = W, U.range = K, U.manifestInfo = X, ce(B, f.default.DVR_INFO, U);
              }
              function pe(B, W) {
                var X = new b.default(), K = ae(B).DroppedFrames;
                W && (X.time = W.creationTime, X.droppedFrames = W.droppedVideoFrames, !(K.length > 0 && K[K.length - 1] == X) && ce(B, f.default.DROPPED_FRAMES, X));
              }
              function he(B, W, X, K, U, V, Q, fe, ue) {
                var q = new N.default();
                q.mediaType = B, q.t = W, q.type = X, q.startTime = K, q.availabilityStartTime = U, q.duration = V, q.quality = Q, q.range = fe, q.state = ue, ce(B, f.default.SCHEDULING_INFO, q);
              }
              function se(B, W, X) {
                var K = new R.default();
                K.loadingRequests = W, K.executedRequests = X, ae(B).RequestsQueue = K, Y(B, f.default.REQUESTS_QUEUE, K);
              }
              function ee(B, W, X, K, U, V, Q, fe, ue, q) {
                var _e = new S.ManifestUpdate();
                _e.mediaType = B, _e.type = W, _e.requestTime = X, _e.fetchTime = K, _e.availabilityStartTime = U, _e.presentationStartTime = V, _e.clientTimeOffset = Q, _e.currentTime = fe, _e.buffered = ue, _e.latency = q, G(h.default.STREAM, f.default.MANIFEST_UPDATE, _e), Y(B, f.default.MANIFEST_UPDATE, _e);
              }
              function te(B, W) {
                if (B) {
                  for (var X in W)
                    B[X] = W[X];
                  Z(B.mediaType, f.default.MANIFEST_UPDATE, B);
                }
              }
              function le(B, W, X, K, U) {
                if (B) {
                  var V = new S.ManifestUpdateStreamInfo();
                  V.id = W, V.index = X, V.start = K, V.duration = U, B.streamInfo.push(V), Z(B.mediaType, f.default.MANIFEST_UPDATE_STREAM_INFO, B);
                }
              }
              function ne(B, W, X, K, U, V, Q, fe) {
                if (B && B.representationInfo) {
                  var ue = new S.ManifestUpdateRepresentationInfo();
                  ue.id = W, ue.index = X, ue.streamIndex = K, ue.mediaType = U, ue.startNumber = Q, ue.fragmentInfoType = fe, ue.presentationTimeOffset = V, B.representationInfo.push(ue), Z(B.mediaType, f.default.MANIFEST_UPDATE_TRACK_INFO, B);
                }
              }
              function x(B) {
                B.trace && Array.isArray(B.trace) ? B.trace.forEach(function(W) {
                  W.hasOwnProperty("subreplevel") && !W.subreplevel && delete W.subreplevel;
                }) : delete B.trace, ce(h.default.STREAM, f.default.PLAY_LIST, B);
              }
              function P(B) {
                ce(h.default.STREAM, f.default.DVB_ERRORS, B);
              }
              return I = {
                clearCurrentMetricsForType: j,
                clearAllCurrentMetrics: J,
                getMetricsFor: ae,
                addHttpRequest: ie,
                addRepresentationSwitch: re,
                addBufferLevel: z,
                addBufferState: oe,
                addDVRInfo: de,
                addDroppedFrames: pe,
                addSchedulingInfo: he,
                addRequestsQueue: se,
                addManifestUpdate: ee,
                updateManifestUpdateInfo: te,
                addManifestUpdateStreamInfo: le,
                addManifestUpdateRepresentationInfo: ne,
                addPlayList: x,
                addDVBErrors: P
              }, F(), I;
            }
            L.__dashjs_factory_name = "MetricsModel";
            const _ = E.default.getSingletonFactory(L);
          }
        ),
        /***/
        "./src/streaming/models/URIFragmentModel.js": (
          /*!**************************************************!*\
            !*** ./src/streaming/models/URIFragmentModel.js ***!
            \**************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => d
              /* harmony export */
            });
            var h = i(
              /*! ../vo/URIFragmentData */
              "./src/streaming/vo/URIFragmentData.js"
            ), f = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function p() {
              var v, g;
              function m(b) {
                if (g = new h.default(), !b)
                  return null;
                var S = b.indexOf("#");
                if (S !== -1)
                  for (var N = b.substr(S + 1).split("&"), T = 0, R = N.length; T < R; ++T) {
                    var y = N[T], E = y.indexOf("=");
                    if (E !== -1) {
                      var L = y.substring(0, E);
                      g.hasOwnProperty(L) && (g[L] = y.substr(E + 1));
                    }
                  }
              }
              function A() {
                return g;
              }
              return v = {
                initialize: m,
                getURIFragmentData: A
              }, v;
            }
            p.__dashjs_factory_name = "URIFragmentModel";
            const d = f.default.getSingletonFactory(p);
          }
        ),
        /***/
        "./src/streaming/models/VideoModel.js": (
          /*!********************************************!*\
            !*** ./src/streaming/models/VideoModel.js ***!
            \********************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => A
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), p = i(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), d = i(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), v = i(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), g = /* @__PURE__ */ new Map([[v.default.VIDEO_ELEMENT_READY_STATES.HAVE_METADATA, "loadedmetadata"], [v.default.VIDEO_ELEMENT_READY_STATES.HAVE_CURRENT_DATA, "loadeddata"], [v.default.VIDEO_ELEMENT_READY_STATES.HAVE_FUTURE_DATA, "canplay"], [v.default.VIDEO_ELEMENT_READY_STATES.HAVE_ENOUGH_DATA, "canplaythrough"]]);
            function m() {
              var b, S, N, T, R, y, E = "element is not video or audio DOM type!", L = this.context, _ = (0, f.default)(L).getInstance(), O = [];
              function D() {
                S = (0, d.default)(L).getInstance().getLogger(b), T = NaN;
              }
              function M() {
                _.on(p.default.PLAYBACK_PLAYING, de, this);
              }
              function C() {
                _.off(p.default.PLAYBACK_PLAYING, de, this);
              }
              function I() {
                N && (N.playbackRate = 1, N.removeEventListener("canplay", I));
              }
              function w(De) {
                var Ae = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
                N && (!Ae && N.readyState <= 2 && De > 0 ? N.addEventListener("canplay", I) : N.playbackRate = De);
              }
              function F(De, Ae) {
                N && (T = De, Pe(v.default.VIDEO_ELEMENT_READY_STATES.HAVE_METADATA, function() {
                  if (N.currentTime === T) {
                    T = NaN;
                    return;
                  }
                  try {
                    T = Ae ? k(T) : T, N.currentTime = T, T = NaN;
                  } catch (Ie) {
                    N.readyState === 0 && Ie.code === Ie.INVALID_STATE_ERR && setTimeout(function() {
                      N.currentTime = T, T = NaN;
                    }, 400);
                  }
                }));
              }
              function k(De) {
                var Ae = K(), Ie = De, Xe = 9999999999;
                if (Ae)
                  for (var it = 0; it < Ae.length; it++) {
                    var rt = Ae.start(it), Ne = Ae.end(it), He = Math.abs(rt - De), $e = Math.abs(Ne - De);
                    if (De >= rt && De <= Ne)
                      return De;
                    He < Xe && (Xe = He, Ie = rt), $e < Xe && (Xe = $e, Ie = Ne);
                  }
                return Ie;
              }
              function H() {
                return N;
              }
              function Z(De) {
                if (De == null || De && /^(VIDEO|AUDIO)$/i.test(De.nodeName))
                  N = De, N && (N.preload = "auto");
                else
                  throw E;
              }
              function Y(De) {
                N && (De ? N.src = De : (N.removeAttribute("src"), N.load()));
              }
              function j() {
                return N ? N.src : null;
              }
              function J() {
                return R;
              }
              function ae() {
                return y;
              }
              function G(De) {
                R = De, R.style.position = "absolute", R.style.display = "flex", R.style.overflow = "hidden", R.style.pointerEvents = "none", R.style.top = 0, R.style.left = 0;
              }
              function $(De) {
                y = De;
              }
              function ie(De, Ae) {
                oe(De, Ae);
              }
              function re() {
                return O.length > 0;
              }
              function ce(De) {
                De === null || !N || N.seeking || O.indexOf(De) !== -1 || O.push(De);
              }
              function z(De) {
                var Ae = O.indexOf(De);
                De !== null && Ae !== -1 && O.splice(Ae, 1);
              }
              function oe(De, Ae) {
                Ae ? ce(De) : z(De);
              }
              function de() {
                if (N && re() && N.playbackRate === 0) {
                  var De = document.createEvent("Event");
                  De.initEvent("waiting", !0, !1), N.dispatchEvent(De);
                }
              }
              function pe() {
                if (!N)
                  return null;
                var De = "webkitDroppedFrameCount" in N && "webkitDecodedFrameCount" in N, Ae = "getVideoPlaybackQuality" in N, Ie = null;
                return Ae ? Ie = N.getVideoPlaybackQuality() : De && (Ie = {
                  droppedVideoFrames: N.webkitDroppedFrameCount,
                  totalVideoFrames: N.webkitDroppedFrameCount + N.webkitDecodedFrameCount,
                  creationTime: /* @__PURE__ */ new Date()
                }), Ie;
              }
              function he() {
                if (N) {
                  N.autoplay = !0;
                  var De = N.play();
                  De && De.catch && typeof Promise < "u" && De.catch(function(Ae) {
                    Ae.name === "NotAllowedError" && _.trigger(p.default.PLAYBACK_NOT_ALLOWED), S.warn("Caught pending play exception - continuing (".concat(Ae, ")"));
                  });
                }
              }
              function se() {
                return N ? N.paused : null;
              }
              function ee() {
                N && (N.pause(), N.autoplay = !1);
              }
              function te() {
                return N ? N.seeking || !isNaN(T) : null;
              }
              function le() {
                return N ? isNaN(T) ? N.currentTime : T : null;
              }
              function ne() {
                return N ? N.playbackRate : null;
              }
              function x() {
                return N ? N.played : null;
              }
              function P() {
                return N ? N.ended : null;
              }
              function B(De, Ae) {
                N && N.addEventListener(De, Ae);
              }
              function W(De, Ae) {
                N && N.removeEventListener(De, Ae);
              }
              function X() {
                return N ? N.readyState : NaN;
              }
              function K() {
                return N ? N.buffered : null;
              }
              function U() {
                return N ? N.clientWidth : NaN;
              }
              function V() {
                return N ? N.clientHeight : NaN;
              }
              function Q() {
                return N ? N.videoWidth : NaN;
              }
              function fe() {
                return N ? N.videoHeight : NaN;
              }
              function ue() {
                var De = N.parentNode.host || N.parentNode;
                return De ? N.getBoundingClientRect().top - De.getBoundingClientRect().top : NaN;
              }
              function q() {
                var De = N.parentNode.host || N.parentNode;
                return De ? N.getBoundingClientRect().left - De.getBoundingClientRect().left : NaN;
              }
              function _e() {
                return N ? N.textTracks : [];
              }
              function ge(De, Ae, Ie, Xe, it) {
                if (N) {
                  for (var rt = 0; rt < N.textTracks.length; rt++)
                    if (N.textTracks[rt].kind === De && (!Ae || N.textTracks[rt].label == Ae) && N.textTracks[rt].language === Ie && N.textTracks[rt].isTTML === Xe && N.textTracks[rt].isEmbedded === it)
                      return N.textTracks[rt];
                }
                return null;
              }
              function Ce(De, Ae, Ie, Xe, it) {
                if (!N)
                  return null;
                var rt = ge(De, Ae, Ie, Xe, it);
                return rt || (rt = N.addTextTrack(De, Ae, Ie), rt.isEmbedded = it, rt.isTTML = Xe), rt;
              }
              function Ee(De) {
                N && (N.appendChild(De), De.isTTML !== void 0 && (N.textTracks[N.textTracks.length - 1].isTTML = De.isTTML, N.textTracks[N.textTracks.length - 1].isEmbedded = De.isEmbedded));
              }
              function Re(De) {
                N && N.removeChild(De);
              }
              function Pe(De, Ae) {
                if (De === v.default.VIDEO_ELEMENT_READY_STATES.HAVE_NOTHING || X() >= De)
                  Ae();
                else {
                  var Ie = g.get(De);
                  ke(Ie, Ae);
                }
              }
              function ke(De, Ae) {
                var Ie = function Xe() {
                  W(De, Xe), Ae(De);
                };
                B(De, Ie);
              }
              return b = {
                initialize: M,
                setCurrentTime: F,
                play: he,
                isPaused: se,
                pause: ee,
                isStalled: re,
                isSeeking: te,
                getTime: le,
                getPlaybackRate: ne,
                setPlaybackRate: w,
                getPlayedRanges: x,
                getEnded: P,
                setStallState: ie,
                getElement: H,
                setElement: Z,
                setSource: Y,
                getSource: j,
                getTTMLRenderingDiv: J,
                setTTMLRenderingDiv: G,
                getVttRenderingDiv: ae,
                setVttRenderingDiv: $,
                getPlaybackQuality: pe,
                addEventListener: B,
                removeEventListener: W,
                getReadyState: X,
                getBufferRange: K,
                getClientWidth: U,
                getClientHeight: V,
                getTextTracks: _e,
                getTextTrack: ge,
                addTextTrack: Ce,
                appendChild: Ee,
                removeChild: Re,
                getVideoWidth: Q,
                getVideoHeight: fe,
                getVideoRelativeOffsetTop: ue,
                getVideoRelativeOffsetLeft: q,
                waitForReadyState: Pe,
                reset: C
              }, D(), b;
            }
            m.__dashjs_factory_name = "VideoModel";
            const A = h.default.getSingletonFactory(m);
          }
        ),
        /***/
        "./src/streaming/net/FetchLoader.js": (
          /*!******************************************!*\
            !*** ./src/streaming/net/FetchLoader.js ***!
            \******************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => y
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ../../core/Settings */
              "./src/core/Settings.js"
            ), p = i(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), d = i(
              /*! ../utils/RequestModifier */
              "./src/streaming/utils/RequestModifier.js"
            );
            function v(E, L) {
              return A(E) || m(E, L) || S(E, L) || g();
            }
            function g() {
              throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }
            function m(E, L) {
              if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(E)))) {
                var _ = [], O = !0, D = !1, M = void 0;
                try {
                  for (var C = E[Symbol.iterator](), I; !(O = (I = C.next()).done) && (_.push(I.value), !(L && _.length === L)); O = !0)
                    ;
                } catch (w) {
                  D = !0, M = w;
                } finally {
                  try {
                    !O && C.return != null && C.return();
                  } finally {
                    if (D)
                      throw M;
                  }
                }
                return _;
              }
            }
            function A(E) {
              if (Array.isArray(E))
                return E;
            }
            function b(E, L) {
              var _;
              if (typeof Symbol > "u" || E[Symbol.iterator] == null) {
                if (Array.isArray(E) || (_ = S(E)) || L && E && typeof E.length == "number") {
                  _ && (E = _);
                  var O = 0, D = function() {
                  };
                  return { s: D, n: function() {
                    return O >= E.length ? { done: !0 } : { done: !1, value: E[O++] };
                  }, e: function(F) {
                    throw F;
                  }, f: D };
                }
                throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
              var M = !0, C = !1, I;
              return { s: function() {
                _ = E[Symbol.iterator]();
              }, n: function() {
                var F = _.next();
                return M = F.done, F;
              }, e: function(F) {
                C = !0, I = F;
              }, f: function() {
                try {
                  !M && _.return != null && _.return();
                } finally {
                  if (C)
                    throw I;
                }
              } };
            }
            function S(E, L) {
              if (E) {
                if (typeof E == "string")
                  return N(E, L);
                var _ = Object.prototype.toString.call(E).slice(8, -1);
                if (_ === "Object" && E.constructor && (_ = E.constructor.name), _ === "Map" || _ === "Set")
                  return Array.from(E);
                if (_ === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(_))
                  return N(E, L);
              }
            }
            function N(E, L) {
              (L == null || L > E.length) && (L = E.length);
              for (var _ = 0, O = new Array(L); _ < L; _++)
                O[_] = E[_];
              return O;
            }
            function T(E) {
              E = E || {};
              var L = this.context, _ = E.requestModifier, O = E.lowLatencyThroughputModel, D = E.boxParser, M = (0, f.default)(L).getInstance(), C, I;
              function w(ae) {
                I = ae.dashMetrics;
              }
              function F(ae) {
                _ && _.modifyRequest ? (0, d.modifyRequest)(ae, _).then(function() {
                  return k(ae);
                }) : k(ae);
              }
              function k(ae) {
                var G = /* @__PURE__ */ new Date(), $ = ae.request, ie = new Headers();
                if ($.range && ie.append("Range", "bytes=" + $.range), ae.headers)
                  for (var re in ae.headers) {
                    var ce = ae.headers[re];
                    ce && ie.append(re, ce);
                  }
                $.requestStartDate || ($.requestStartDate = G), _ && _.modifyRequestHeader && _.modifyRequestHeader({
                  setRequestHeader: function(ee, te) {
                    ie.append(ee, te);
                  }
                }, {
                  url: ae.url
                });
                var z;
                typeof window.AbortController == "function" && (z = new AbortController(), ae.abortController = z, z.signal.onabort = ae.onabort);
                var oe = {
                  method: ae.method,
                  headers: ie,
                  credentials: ae.withCredentials ? "include" : void 0,
                  signal: z ? z.signal : void 0
                }, de = M.get().streaming.abr.fetchThroughputCalculationMode, pe = Date.now(), he = 0;
                new Promise(function(se) {
                  if (de === p.default.ABR_FETCH_THROUGHPUT_CALCULATION_AAST && O && (he = O.getThroughputCapacityDelayMS($, I.getCurrentBufferLevel($.mediaType) * 1e3), he))
                    return setTimeout(se, he);
                  se();
                }).then(function() {
                  var se = Date.now();
                  fetch(ae.url, oe).then(function(ee) {
                    ae.response || (ae.response = {}), ae.response.status = ee.status, ae.response.statusText = ee.statusText, ae.response.responseURL = ee.url, ee.ok || ae.onerror();
                    var te = "", le = b(ee.headers.keys()), ne;
                    try {
                      for (le.s(); !(ne = le.n()).done; ) {
                        var x = ne.value;
                        te += x + ": " + ee.headers.get(x) + `\r
`;
                      }
                    } catch (ke) {
                      le.e(ke);
                    } finally {
                      le.f();
                    }
                    if (ae.response.responseHeaders = te, !ee.body)
                      return ee.arrayBuffer().then(function(ke) {
                        ae.response.response = ke;
                        var De = {
                          loaded: ke.byteLength,
                          total: ke.byteLength,
                          stream: !1
                        };
                        ae.progress(De), ae.onload(), ae.onend();
                      });
                    var P = parseInt(ee.headers.get("Content-Length"), 10), B = 0, W = !1, X = new Uint8Array(), K = 0;
                    if (de === p.default.ABR_FETCH_THROUGHPUT_CALCULATION_AAST && O) {
                      var U = function(De) {
                        var Ae = De.getReader(), Ie = [];
                        Ae.read().then(function Xe(it) {
                          var rt = it.value, Ne = it.done;
                          if (Q = Date.now(), rt && rt.length) {
                            var He = Q - V, $e = rt.length;
                            Ie.push({
                              chunkDownloadTimeRelativeMS: Q - se,
                              chunkDownloadDurationMS: He,
                              chunkBytes: $e,
                              kbps: Math.round(8 * $e / (He / 1e3)),
                              bufferLevel: I.getCurrentBufferLevel($.mediaType)
                            });
                          }
                          if (Ne) {
                            var nt = Q - se, ut = Ie.reduce(function(pt, vt) {
                              return pt + vt.chunkBytes;
                            }, 0);
                            O.addMeasurement($, nt, Ie, pe, he, te), ae.progress({
                              loaded: ut,
                              total: ut,
                              lengthComputable: !0,
                              time: O.getEstimatedDownloadDurationMS($),
                              stream: !0
                            });
                            return;
                          }
                          return V = Date.now(), Ae.read().then(Xe);
                        });
                      }, V = se, Q = 0, fe = ee.body.tee(), ue = v(fe, 2), q = ue[0], _e = ue[1];
                      U(q), ae.reader = _e.getReader();
                    } else
                      ae.reader = ee.body.getReader();
                    var ge = [], Ce = [], Ee = [], Re = !0, Pe = function ke(De) {
                      var Ae = De.value, Ie = De.done;
                      if (Ie) {
                        if (X) {
                          if (de !== p.default.ABR_FETCH_THROUGHPUT_CALCULATION_AAST) {
                            var Xe = null, it = null;
                            de === p.default.ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING ? (Xe = J(Ce, Ee), Xe && (it = B * 8 / Xe)) : de === p.default.ABR_FETCH_THROUGHPUT_CALCULATION_DOWNLOADED_DATA && (it = j(ge, B)), ae.progress({
                              loaded: B,
                              total: isNaN(P) ? B : P,
                              lengthComputable: !0,
                              time: it,
                              stream: !0
                            });
                          }
                          ae.response.response = X.buffer;
                        }
                        ae.onload(), ae.onend();
                        return;
                      }
                      if (Ae && Ae.length > 0) {
                        if (X = Z(X, Ae), B += Ae.length, ge.push({
                          ts: Date.now(),
                          bytes: Ae.length
                        }), de === p.default.ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING && Re) {
                          var rt = D.findLastTopIsoBoxCompleted(["moof"], X, K);
                          rt.found && (Re = !1, Ce.push({
                            ts: performance.now(),
                            /* jshint ignore:line */
                            bytes: Ae.length
                          }));
                        }
                        var Ne = D.findLastTopIsoBoxCompleted(["moov", "mdat"], X, K);
                        if (Ne.found) {
                          var He = Ne.lastCompletedOffset + Ne.size;
                          de === p.default.ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING && !Re && (Re = !0, Ee.push({
                            ts: performance.now(),
                            /* jshint ignore:line */
                            bytes: X.length
                          }));
                          var $e;
                          He === X.length ? ($e = X, X = new Uint8Array()) : ($e = new Uint8Array(X.subarray(0, He)), X = X.subarray(He)), ae.progress({
                            data: $e.buffer,
                            lengthComputable: !1,
                            noTrace: !0
                          }), K = 0;
                        } else
                          K = Ne.lastCompletedOffset, W || (ae.progress({
                            lengthComputable: !1,
                            noTrace: !0
                          }), W = !0);
                      }
                      H(ae, ke);
                    };
                    H(ae, Pe);
                  }).catch(function(ee) {
                    ae.onerror && ae.onerror(ee);
                  });
                });
              }
              function H(ae, G) {
                ae.reader.read().then(G).catch(function($) {
                  ae.onerror && ae.response.status === 200 && ae.onerror($);
                });
              }
              function Z(ae, G) {
                if (ae.length === 0)
                  return G;
                var $ = new Uint8Array(ae.length + G.length);
                return $.set(ae), $.set(G, ae.length), $;
              }
              function Y(ae) {
                if (ae.abortController)
                  ae.abortController.abort();
                else if (ae.reader)
                  try {
                    ae.reader.cancel(), ae.onabort();
                  } catch {
                  }
              }
              function j(ae, G) {
                try {
                  if (ae = ae.filter(function(re) {
                    return re.bytes > G / 4 / ae.length;
                  }), ae.length > 1) {
                    var $ = 0, ie = (ae[ae.length - 1].ts - ae[0].ts) / ae.length;
                    return ae.forEach(function(re, ce) {
                      var z = ae[ce + 1];
                      if (z) {
                        var oe = z.ts - re.ts;
                        $ += oe < ie ? oe : 0;
                      }
                    }), $;
                  }
                  return null;
                } catch {
                  return null;
                }
              }
              function J(ae, G) {
                try {
                  var $, ie;
                  $ = ae.filter(function(se, ee) {
                    return ee < ae.length - 1;
                  }), ie = G.filter(function(se, ee) {
                    return ee < G.length - 1;
                  });
                  var re = [];
                  if ($.length > 1) {
                    for (var ce = 0, z = 0, oe = 0; oe < $.length; oe++)
                      if ($[oe] && ie[oe]) {
                        var de = ie[oe].ts - $[oe].ts;
                        if (de > 1)
                          re.push(8 * ie[oe].bytes / de);
                        else {
                          z === 0 && (z = $[oe].ts);
                          var pe = ie[oe].ts - z;
                          pe > 1 ? (re.push(8 * ce / pe), ce = 0, z = 0) : ce += ie[oe].bytes;
                        }
                      }
                    if (re.length > 0) {
                      var he = re.reduce(function(se, ee) {
                        return se + ee;
                      }, 0);
                      return he / re.length;
                    }
                  }
                  return null;
                } catch {
                  return null;
                }
              }
              return C = {
                load: F,
                abort: Y,
                calculateDownloadedTime: j,
                setup: w
              }, C;
            }
            T.__dashjs_factory_name = "FetchLoader";
            var R = h.default.getClassFactory(T);
            const y = R;
          }
        ),
        /***/
        "./src/streaming/net/HTTPLoader.js": (
          /*!*****************************************!*\
            !*** ./src/streaming/net/HTTPLoader.js ***!
            \*****************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => D
              /* harmony export */
            });
            var h = i(
              /*! ./XHRLoader */
              "./src/streaming/net/XHRLoader.js"
            ), f = i(
              /*! ./FetchLoader */
              "./src/streaming/net/FetchLoader.js"
            ), p = i(
              /*! ../vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            ), d = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), v = i(
              /*! ../vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), g = i(
              /*! ../models/CmcdModel */
              "./src/streaming/models/CmcdModel.js"
            ), m = i(
              /*! ../models/CmsdModel */
              "./src/streaming/models/CmsdModel.js"
            ), A = i(
              /*! ../../core/Utils */
              "./src/core/Utils.js"
            ), b = i(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), S = i(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), N = i(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), T = i(
              /*! ../../core/Settings */
              "./src/core/Settings.js"
            ), R = i(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), y = i(
              /*! ../models/LowLatencyThroughputModel */
              "./src/streaming/models/LowLatencyThroughputModel.js"
            ), E = i(
              /*! ../models/CustomParametersModel */
              "./src/streaming/models/CustomParametersModel.js"
            );
            function L(M, C, I) {
              return C in M ? Object.defineProperty(M, C, { value: I, enumerable: !0, configurable: !0, writable: !0 }) : M[C] = I, M;
            }
            function _(M) {
              M = M || {};
              var C = this.context, I = M.errHandler, w = M.dashMetrics, F = M.mediaPlayerModel, k = M.requestModifier, H = M.boxParser, Z = M.errors, Y = M.requestTimeout || 0, j = (0, S.default)(C).getInstance(), J = (0, T.default)(C).getInstance(), ae, G, $, ie, re, ce, z, oe, de, pe;
              function he() {
                var ne;
                pe = (0, b.default)(C).getInstance().getLogger(ae), G = [], $ = [], ie = [], ce = (0, g.default)(C).getInstance(), z = (0, m.default)(C).getInstance(), de = (0, y.default)(C).getInstance(), oe = (0, E.default)(C).getInstance(), re = (ne = {}, L(ne, p.HTTPRequest.MPD_TYPE, Z.DOWNLOAD_ERROR_ID_MANIFEST_CODE), L(ne, p.HTTPRequest.XLINK_EXPANSION_TYPE, Z.DOWNLOAD_ERROR_ID_XLINK_CODE), L(ne, p.HTTPRequest.INIT_SEGMENT_TYPE, Z.DOWNLOAD_ERROR_ID_INITIALIZATION_CODE), L(ne, p.HTTPRequest.MEDIA_SEGMENT_TYPE, Z.DOWNLOAD_ERROR_ID_CONTENT_CODE), L(ne, p.HTTPRequest.INDEX_SEGMENT_TYPE, Z.DOWNLOAD_ERROR_ID_CONTENT_CODE), L(ne, p.HTTPRequest.BITSTREAM_SWITCHING_SEGMENT_TYPE, Z.DOWNLOAD_ERROR_ID_CONTENT_CODE), L(ne, p.HTTPRequest.OTHER_TYPE, Z.DOWNLOAD_ERROR_ID_CONTENT_CODE), ne);
              }
              function se(ne, x) {
                var P = ne.request, B = [], W = !0, X = !0, K = /* @__PURE__ */ new Date(), U = K, V = 0, Q = null, fe;
                if (!k || !w || !I)
                  throw new Error("config object is not correct or missing");
                var ue = function(He) {
                  if (X = !1, P.requestStartDate = K, P.requestEndDate = /* @__PURE__ */ new Date(), P.firstByteDate = P.firstByteDate || K, P.fileLoaderType = Q, !P.checkExistenceOnly) {
                    var $e = fe.response ? fe.response.responseURL : null, nt = fe.response ? fe.response.status : null, ut = fe.response && fe.response.getAllResponseHeaders ? fe.response.getAllResponseHeaders() : fe.response ? fe.response.responseHeaders : null, pt = J.get().streaming.cmsd && J.get().streaming.cmsd.enabled ? z.parseResponseHeaders(ut, P.mediaType) : null;
                    w.addHttpRequest(P, $e, nt, ut, He ? B : null, pt), P.type === p.HTTPRequest.MPD_TYPE && w.addManifestUpdate(P);
                  }
                }, q = function() {
                  if (G.indexOf(fe) !== -1 && (G.splice(G.indexOf(fe), 1), X))
                    if (ue(!1), x > 0) {
                      try {
                        if (J.get().streaming.utcSynchronization.enableBackgroundSyncAfterSegmentDownloadError && P.type === p.HTTPRequest.MEDIA_SEGMENT_TYPE) {
                          var He = F.getRetryAttemptsForType(p.HTTPRequest.MEDIA_SEGMENT_TYPE);
                          He === x && j.trigger(N.default.ATTEMPT_BACKGROUND_SYNC);
                        }
                      } catch {
                      }
                      x--;
                      var $e = {
                        config: ne
                      };
                      ie.push($e), $e.timeout = setTimeout(function() {
                        ie.indexOf($e) !== -1 && (ie.splice(ie.indexOf($e), 1), se(ne, x));
                      }, F.getRetryIntervalsForType(P.type));
                    } else {
                      if (P.type === p.HTTPRequest.MSS_FRAGMENT_INFO_SEGMENT_TYPE)
                        return;
                      I.error(new v.default(re[P.type], P.url + " is not available", {
                        request: P,
                        response: fe.response
                      })), ne.error && ne.error(P, "error", fe.response.statusText), ne.complete && ne.complete(P, fe.response.statusText);
                    }
                }, _e = function(He) {
                  var $e = /* @__PURE__ */ new Date();
                  W && (W = !1, (!He.lengthComputable || He.lengthComputable && He.total !== He.loaded) && (P.firstByteDate = $e)), He.lengthComputable && (P.bytesLoaded = He.loaded, P.bytesTotal = He.total), He.noTrace || (B.push({
                    s: U,
                    d: He.time ? He.time : $e.getTime() - U.getTime(),
                    b: [He.loaded ? He.loaded - V : 0]
                  }), U = $e, V = He.loaded), ne.progress && He && ne.progress(He);
                }, ge = function() {
                  fe.response.status >= 200 && fe.response.status <= 299 && (ue(!0), ne.success && ne.success(fe.response.response, fe.response.statusText, fe.response.responseURL), ne.complete && ne.complete(P, fe.response.statusText));
                }, Ce = function() {
                  ne.abort && ne.abort(P);
                }, Ee = function(He) {
                  var $e;
                  if (He.lengthComputable) {
                    var nt = He.loaded / He.total * 100;
                    $e = "Request timeout: loaded: " + He.loaded + ", out of: " + He.total + " : " + nt.toFixed(3) + "% Completed";
                  } else
                    $e = "Request timeout: non-computable download size";
                  pe.warn($e);
                }, Re;
                P.hasOwnProperty("availabilityTimeComplete") && P.availabilityTimeComplete === !1 && window.fetch && P.responseType === "arraybuffer" && P.type === p.HTTPRequest.MEDIA_SEGMENT_TYPE ? (Re = (0, f.default)(C).create({
                  requestModifier: k,
                  lowLatencyThroughputModel: de,
                  boxParser: H
                }), Re.setup({
                  dashMetrics: w
                }), Q = R.default.FILE_LOADER_TYPES.FETCH) : (Re = (0, h.default)(C).create({
                  requestModifier: k
                }), Q = R.default.FILE_LOADER_TYPES.XHR);
                var Pe = null, ke = k.modifyRequestURL ? k.modifyRequestURL(P.url) : P.url;
                if (J.get().streaming.cmcd && J.get().streaming.cmcd.enabled) {
                  var De = J.get().streaming.cmcd.mode;
                  if (De === R.default.CMCD_MODE_QUERY) {
                    var Ae = ee(P);
                    ke = A.default.addAditionalQueryParameterToUrl(ke, Ae);
                  } else
                    De === R.default.CMCD_MODE_HEADER && (Pe = ce.getHeaderParameters(P));
                }
                P.url = ke;
                var Ie = P.checkExistenceOnly ? p.HTTPRequest.HEAD : p.HTTPRequest.GET, Xe = oe.getXHRWithCredentialsForType(P.type);
                fe = {
                  url: ke,
                  method: Ie,
                  withCredentials: Xe,
                  request: P,
                  onload: ge,
                  onend: q,
                  onerror: q,
                  progress: _e,
                  onabort: Ce,
                  ontimeout: Ee,
                  loader: Re,
                  timeout: Y,
                  headers: Pe
                };
                var it = (/* @__PURE__ */ new Date()).getTime();
                if (isNaN(P.delayLoadingTime) || it >= P.delayLoadingTime)
                  G.push(fe), Re.load(fe);
                else {
                  var rt = {
                    httpRequest: fe
                  };
                  $.push(rt), rt.delayTimeout = setTimeout(function() {
                    if ($.indexOf(rt) !== -1) {
                      $.splice($.indexOf(rt), 1);
                      try {
                        K = /* @__PURE__ */ new Date(), U = K, G.push(rt.httpRequest), Re.load(rt.httpRequest);
                      } catch {
                        rt.httpRequest.onerror();
                      }
                    }
                  }, P.delayLoadingTime - it);
                }
              }
              function ee(ne) {
                try {
                  var x = [], P = ce.getQueryParameter(ne);
                  return P && x.push(P), x;
                } catch {
                  return [];
                }
              }
              function te(ne) {
                ne.request ? se(ne, F.getRetryAttemptsForType(ne.request.type)) : ne.error && ne.error(ne.request, "error");
              }
              function le() {
                ie.forEach(function(ne) {
                  clearTimeout(ne.timeout), ne.config.request && ne.config.abort && ne.config.abort(ne.config.request);
                }), ie = [], $.forEach(function(ne) {
                  return clearTimeout(ne.delayTimeout);
                }), $ = [], G.forEach(function(ne) {
                  ne.request.type !== p.HTTPRequest.MSS_FRAGMENT_INFO_SEGMENT_TYPE && (ne.onloadend = ne.onerror = ne.onprogress = void 0, ne.loader.abort(ne));
                }), G = [];
              }
              return ae = {
                load: te,
                abort: le
              }, he(), ae;
            }
            _.__dashjs_factory_name = "HTTPLoader";
            var O = d.default.getClassFactory(_);
            const D = O;
          }
        ),
        /***/
        "./src/streaming/net/SchemeLoaderFactory.js": (
          /*!**************************************************!*\
            !*** ./src/streaming/net/SchemeLoaderFactory.js ***!
            \**************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ../../streaming/net/HTTPLoader */
              "./src/streaming/net/HTTPLoader.js"
            );
            function p() {
              var g, m;
              function A(y, E) {
                m[y] = E;
              }
              function b(y) {
                m[y] && delete m[y];
              }
              function S() {
                m = {};
              }
              function N(y) {
                for (var E in m)
                  if (m.hasOwnProperty(E) && y.startsWith(E))
                    return m[E];
                return f.default;
              }
              function T() {
                S();
              }
              function R() {
                T();
              }
              return R(), g = {
                getLoader: N,
                registerLoader: A,
                unregisterLoader: b,
                unregisterAllLoader: S,
                reset: T
              }, g;
            }
            p.__dashjs_factory_name = "SchemeLoaderFactory";
            var d = h.default.getSingletonFactory(p);
            const v = d;
          }
        ),
        /***/
        "./src/streaming/net/URLLoader.js": (
          /*!****************************************!*\
            !*** ./src/streaming/net/URLLoader.js ***!
            \****************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ../../streaming/net/SchemeLoaderFactory */
              "./src/streaming/net/SchemeLoaderFactory.js"
            );
            function p(g) {
              g = g || {};
              var m = this.context, A, b, S;
              b = (0, f.default)(m).getInstance();
              function N(R) {
                if (!S) {
                  var y = b.getLoader(R && R.request ? R.request.url : null);
                  S = y(m).create({
                    errHandler: g.errHandler,
                    mediaPlayerModel: g.mediaPlayerModel,
                    requestModifier: g.requestModifier,
                    dashMetrics: g.dashMetrics,
                    boxParser: g.boxParser ? g.boxParser : null,
                    constants: g.constants ? g.constants : null,
                    dashConstants: g.dashConstants ? g.dashConstants : null,
                    urlUtils: g.urlUtils ? g.urlUtils : null,
                    requestTimeout: isNaN(g.requestTimeout) ? 0 : g.requestTimeout,
                    errors: g.errors
                  });
                }
                S.load(R);
              }
              function T() {
                S && S.abort();
              }
              return A = {
                load: N,
                abort: T
              }, A;
            }
            p.__dashjs_factory_name = "URLLoader";
            var d = h.default.getClassFactory(p);
            const v = d;
          }
        ),
        /***/
        "./src/streaming/net/XHRLoader.js": (
          /*!****************************************!*\
            !*** ./src/streaming/net/XHRLoader.js ***!
            \****************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ../utils/RequestModifier */
              "./src/streaming/utils/RequestModifier.js"
            );
            function p(g) {
              g = g || {};
              var m = g.requestModifier, A;
              function b(T) {
                m && m.modifyRequest ? (0, f.modifyRequest)(T, m).then(function() {
                  return S(T);
                }) : S(T);
              }
              function S(T) {
                var R = /* @__PURE__ */ new Date(), y = T.request, E = new XMLHttpRequest();
                if (E.open(T.method, T.url, !0), y.responseType && (E.responseType = y.responseType), y.range && E.setRequestHeader("Range", "bytes=" + y.range), y.requestStartDate || (y.requestStartDate = R), m && m.modifyRequestHeader && (E = m.modifyRequestHeader(E, {
                  url: T.url
                })), T.headers)
                  for (var L in T.headers) {
                    var _ = T.headers[L];
                    _ && E.setRequestHeader(L, _);
                  }
                E.withCredentials = T.withCredentials, E.onload = T.onload, E.onloadend = T.onend, E.onerror = T.onerror, E.onprogress = T.progress, E.onabort = T.onabort, E.ontimeout = T.ontimeout, E.timeout = T.timeout, E.send(), T.response = E;
              }
              function N(T) {
                var R = T.response;
                R.onloadend = R.onerror = R.onprogress = void 0, R.abort();
              }
              return A = {
                load: b,
                abort: N
              }, A;
            }
            p.__dashjs_factory_name = "XHRLoader";
            var d = h.default.getClassFactory(p);
            const v = d;
          }
        ),
        /***/
        "./src/streaming/protection/CommonEncryption.js": (
          /*!******************************************************!*\
            !*** ./src/streaming/protection/CommonEncryption.js ***!
            \******************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => g
              /* harmony export */
            });
            function h(m, A) {
              if (!(m instanceof A))
                throw new TypeError("Cannot call a class as a function");
            }
            function f(m, A) {
              for (var b = 0; b < A.length; b++) {
                var S = A[b];
                S.enumerable = S.enumerable || !1, S.configurable = !0, "value" in S && (S.writable = !0), Object.defineProperty(m, S.key, S);
              }
            }
            function p(m, A, b) {
              return A && f(m.prototype, A), b && f(m, b), m;
            }
            var d = {
              attributes: ["Laurl", "laurl"],
              prefixes: ["clearkey", "dashif"]
            }, v = /* @__PURE__ */ function() {
              function m() {
                h(this, m);
              }
              return p(m, null, [{
                key: "findCencContentProtection",
                value: (
                  /**
                   * Find and return the ContentProtection element in the given array
                   * that indicates support for MPEG Common Encryption
                   *
                   * @param {Array} cpArray array of content protection elements
                   * @returns {Object|null} the Common Encryption content protection element or
                   * null if one was not found
                   */
                  function(b) {
                    for (var S = null, N = 0; N < b.length; ++N) {
                      var T = b[N];
                      T.schemeIdUri.toLowerCase() === "urn:mpeg:dash:mp4protection:2011" && (T.value.toLowerCase() === "cenc" || T.value.toLowerCase() === "cbcs") && (S = T);
                    }
                    return S;
                  }
                )
                /**
                 * Returns just the data portion of a single PSSH
                 *
                 * @param {ArrayBuffer} pssh - the PSSH
                 * @return {ArrayBuffer} data portion of the PSSH
                 */
              }, {
                key: "getPSSHData",
                value: function(b) {
                  var S = 8, N = new DataView(b), T = N.getUint8(S);
                  return S += 20, T > 0 && (S += 4 + 16 * N.getUint32(S)), S += 4, b.slice(S);
                }
                /**
                 * Returns the PSSH associated with the given key system from the concatenated
                 * list of PSSH boxes in the given initData
                 *
                 * @param {KeySystem} keySystem the desired
                 * key system
                 * @param {ArrayBuffer} initData 'cenc' initialization data.  Concatenated list of PSSH.
                 * @returns {ArrayBuffer|null} The PSSH box data corresponding to the given key system, null if not found
                 * or null if a valid association could not be found.
                 */
              }, {
                key: "getPSSHForKeySystem",
                value: function(b, S) {
                  var N = m.parsePSSHList(S);
                  return b && N.hasOwnProperty(b.uuid.toLowerCase()) ? N[b.uuid.toLowerCase()] : null;
                }
                /**
                 * Parse a standard common encryption PSSH which contains a simple
                 * base64-encoding of the init data
                 *
                 * @param {Object} cpData the ContentProtection element
                 * @param {BASE64} BASE64 reference
                 * @returns {ArrayBuffer|null} the init data or null if not found
                 */
              }, {
                key: "parseInitDataFromContentProtection",
                value: function(b, S) {
                  return "pssh" in b ? (b.pssh.__text = b.pssh.__text.replace(/\r?\n|\r/g, "").replace(/\s+/g, ""), S.decodeArray(b.pssh.__text).buffer) : null;
                }
                /**
                 * Parses list of PSSH boxes into keysystem-specific PSSH data
                 *
                 * @param {ArrayBuffer} data - the concatenated list of PSSH boxes as provided by
                 * CDM as initialization data when CommonEncryption content is detected
                 * @returns {Object|Array} an object that has a property named according to each of
                 * the detected key system UUIDs (e.g. 00000000-0000-0000-0000-0000000000)
                 * and a ArrayBuffer (the entire PSSH box) as the property value
                 */
              }, {
                key: "parsePSSHList",
                value: function(b) {
                  if (b == null)
                    return [];
                  for (var S = new DataView(b.buffer || b), N = !1, T = {}, R = 0; !N; ) {
                    var y = void 0, E = void 0, L = void 0, _ = void 0, O = R;
                    if (R >= S.buffer.byteLength)
                      break;
                    if (y = S.getUint32(R), E = R + y, R += 4, S.getUint32(R) !== 1886614376) {
                      R = E;
                      continue;
                    }
                    if (R += 4, L = S.getUint8(R), L !== 0 && L !== 1) {
                      R = E;
                      continue;
                    }
                    R++, R += 3, _ = "";
                    var D = void 0, M = void 0;
                    for (D = 0; D < 4; D++)
                      M = S.getUint8(R + D).toString(16), _ += M.length === 1 ? "0" + M : M;
                    for (R += 4, _ += "-", D = 0; D < 2; D++)
                      M = S.getUint8(R + D).toString(16), _ += M.length === 1 ? "0" + M : M;
                    for (R += 2, _ += "-", D = 0; D < 2; D++)
                      M = S.getUint8(R + D).toString(16), _ += M.length === 1 ? "0" + M : M;
                    for (R += 2, _ += "-", D = 0; D < 2; D++)
                      M = S.getUint8(R + D).toString(16), _ += M.length === 1 ? "0" + M : M;
                    for (R += 2, _ += "-", D = 0; D < 6; D++)
                      M = S.getUint8(R + D).toString(16), _ += M.length === 1 ? "0" + M : M;
                    R += 6, _ = _.toLowerCase(), R += 4, T[_] = S.buffer.slice(O, E), R = E;
                  }
                  return T;
                }
              }, {
                key: "getLicenseServerUrlFromMediaInfo",
                value: function(b, S) {
                  try {
                    if (!b || b.length === 0)
                      return null;
                    for (var N = 0, T = null; N < b.length && !T; ) {
                      var R = b[N];
                      if (R && R.contentProtection && R.contentProtection.length > 0) {
                        var y = R.contentProtection.filter(function(C) {
                          return C.schemeIdUri && C.schemeIdUri === S;
                        });
                        if (y && y.length > 0)
                          for (var E = 0; E < y.length && !T; ) {
                            for (var L = y[E], _ = 0; _ < d.attributes.length && !T; ) {
                              for (var O = 0, D = d.attributes[_]; O < d.prefixes.length && !T; ) {
                                var M = d.prefixes[O];
                                L[D] && L[D].__prefix && L[D].__prefix === M && L[D].__text && (T = L[D].__text), O += 1;
                              }
                              _ += 1;
                            }
                            E += 1;
                          }
                      }
                      N += 1;
                    }
                    return T;
                  } catch {
                    return null;
                  }
                }
              }]), m;
            }();
            const g = v;
          }
        ),
        /***/
        "./src/streaming/protection/Protection.js": (
          /*!************************************************!*\
            !*** ./src/streaming/protection/Protection.js ***!
            \************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => T
              /* harmony export */
            });
            var h = i(
              /*! ./controllers/ProtectionController */
              "./src/streaming/protection/controllers/ProtectionController.js"
            ), f = i(
              /*! ./controllers/ProtectionKeyController */
              "./src/streaming/protection/controllers/ProtectionKeyController.js"
            ), p = i(
              /*! ./ProtectionEvents */
              "./src/streaming/protection/ProtectionEvents.js"
            ), d = i(
              /*! ./errors/ProtectionErrors */
              "./src/streaming/protection/errors/ProtectionErrors.js"
            ), v = i(
              /*! ./models/ProtectionModel_21Jan2015 */
              "./src/streaming/protection/models/ProtectionModel_21Jan2015.js"
            ), g = i(
              /*! ./models/ProtectionModel_3Feb2014 */
              "./src/streaming/protection/models/ProtectionModel_3Feb2014.js"
            ), m = i(
              /*! ./models/ProtectionModel_01b */
              "./src/streaming/protection/models/ProtectionModel_01b.js"
            ), A = [
              // Un-prefixed as per spec
              {
                // Video Element
                generateKeyRequest: "generateKeyRequest",
                addKey: "addKey",
                cancelKeyRequest: "cancelKeyRequest",
                // Events
                needkey: "needkey",
                keyerror: "keyerror",
                keyadded: "keyadded",
                keymessage: "keymessage"
              },
              // Webkit-prefixed (early Chrome versions and Chrome with EME disabled in chrome://flags)
              {
                // Video Element
                generateKeyRequest: "webkitGenerateKeyRequest",
                addKey: "webkitAddKey",
                cancelKeyRequest: "webkitCancelKeyRequest",
                // Events
                needkey: "webkitneedkey",
                keyerror: "webkitkeyerror",
                keyadded: "webkitkeyadded",
                keymessage: "webkitkeymessage"
              }
            ], b = [
              // Un-prefixed as per spec
              // Chrome 38-39 (and some earlier versions) with chrome://flags -- Enable Encrypted Media Extensions
              {
                // Video Element
                setMediaKeys: "setMediaKeys",
                // MediaKeys
                MediaKeys: "MediaKeys",
                // MediaKeySession
                release: "close",
                // Events
                needkey: "needkey",
                error: "keyerror",
                message: "keymessage",
                ready: "keyadded",
                close: "keyclose"
              },
              // MS-prefixed (IE11, Windows 8.1)
              {
                // Video Element
                setMediaKeys: "msSetMediaKeys",
                // MediaKeys
                MediaKeys: "MSMediaKeys",
                // MediaKeySession
                release: "close",
                // Events
                needkey: "msneedkey",
                error: "mskeyerror",
                message: "mskeymessage",
                ready: "mskeyadded",
                close: "mskeyclose"
              }
            ];
            function S() {
              var R, y = this.context;
              function E(O) {
                var D = null, M = (0, f.default)(y).getInstance();
                M.setConfig({
                  debug: O.debug,
                  BASE64: O.BASE64,
                  settings: O.settings
                }), M.initialize();
                var C = L(O);
                return !D && C && (D = (0, h.default)(y).create({
                  protectionModel: C,
                  protectionKeyController: M,
                  eventBus: O.eventBus,
                  debug: O.debug,
                  events: O.events,
                  BASE64: O.BASE64,
                  constants: O.constants,
                  cmcdModel: O.cmcdModel,
                  customParametersModel: O.customParametersModel,
                  settings: O.settings
                }), O.capabilities.setEncryptedMediaSupported(!0)), D;
              }
              function L(O) {
                var D = O.debug, M = D.getLogger(R), C = O.eventBus, I = O.errHandler, w = O.videoModel ? O.videoModel.getElement() : null;
                return (!w || w.onencrypted !== void 0) && (!w || w.mediaKeys !== void 0) ? (M.info("EME detected on this user agent! (ProtectionModel_21Jan2015)"), (0, v.default)(y).create({
                  debug: D,
                  eventBus: C,
                  events: O.events
                })) : _(w, b) ? (M.info("EME detected on this user agent! (ProtectionModel_3Feb2014)"), (0, g.default)(y).create({
                  debug: D,
                  eventBus: C,
                  events: O.events,
                  api: _(w, b)
                })) : _(w, A) ? (M.info("EME detected on this user agent! (ProtectionModel_01b)"), (0, m.default)(y).create({
                  debug: D,
                  eventBus: C,
                  errHandler: I,
                  events: O.events,
                  api: _(w, A)
                })) : (M.warn("No supported version of EME detected on this user agent! - Attempts to play encrypted content will fail!"), null);
              }
              function _(O, D) {
                for (var M = 0; M < D.length; M++) {
                  var C = D[M];
                  if (typeof O[C[Object.keys(C)[0]]] == "function")
                    return C;
                }
                return null;
              }
              return R = {
                createProtectionSystem: E
              }, R;
            }
            S.__dashjs_factory_name = "Protection";
            var N = dashjs.FactoryMaker.getClassFactory(S);
            N.events = p.default, N.errors = d.default, dashjs.FactoryMaker.updateClassFactory(S.__dashjs_factory_name, N);
            const T = N;
          }
        ),
        /***/
        "./src/streaming/protection/ProtectionEvents.js": (
          /*!******************************************************!*\
            !*** ./src/streaming/protection/ProtectionEvents.js ***!
            \******************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => R
              /* harmony export */
            });
            var h = i(
              /*! ../../core/events/EventsBase */
              "./src/core/events/EventsBase.js"
            );
            function f(y) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? f = function(L) {
                return typeof L;
              } : f = function(L) {
                return L && typeof Symbol == "function" && L.constructor === Symbol && L !== Symbol.prototype ? "symbol" : typeof L;
              }, f(y);
            }
            function p(y, E) {
              if (!(y instanceof E))
                throw new TypeError("Cannot call a class as a function");
            }
            function d(y, E) {
              if (typeof E != "function" && E !== null)
                throw new TypeError("Super expression must either be null or a function");
              y.prototype = Object.create(E && E.prototype, { constructor: { value: y, writable: !0, configurable: !0 } }), E && v(y, E);
            }
            function v(y, E) {
              return v = Object.setPrototypeOf || function(_, O) {
                return _.__proto__ = O, _;
              }, v(y, E);
            }
            function g(y) {
              var E = b();
              return function() {
                var _ = S(y), O;
                if (E) {
                  var D = S(this).constructor;
                  O = Reflect.construct(_, arguments, D);
                } else
                  O = _.apply(this, arguments);
                return m(this, O);
              };
            }
            function m(y, E) {
              return E && (f(E) === "object" || typeof E == "function") ? E : A(y);
            }
            function A(y) {
              if (y === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return y;
            }
            function b() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return !1;
              if (typeof Proxy == "function")
                return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function S(y) {
              return S = Object.setPrototypeOf ? Object.getPrototypeOf : function(L) {
                return L.__proto__ || Object.getPrototypeOf(L);
              }, S(y);
            }
            var N = /* @__PURE__ */ function(y) {
              d(L, y);
              var E = g(L);
              function L() {
                var _;
                return p(this, L), _ = E.call(this), _.INTERNAL_KEY_MESSAGE = "internalKeyMessage", _.INTERNAL_KEY_STATUS_CHANGED = "internalkeyStatusChanged", _.KEY_ADDED = "public_keyAdded", _.KEY_ERROR = "public_keyError", _.KEY_MESSAGE = "public_keyMessage", _.KEY_SESSION_CLOSED = "public_keySessionClosed", _.KEY_SESSION_CREATED = "public_keySessionCreated", _.KEY_SESSION_REMOVED = "public_keySessionRemoved", _.KEY_STATUSES_CHANGED = "public_keyStatusesChanged", _.KEY_SYSTEM_ACCESS_COMPLETE = "public_keySystemAccessComplete", _.KEY_SYSTEM_SELECTED = "public_keySystemSelected", _.LICENSE_REQUEST_COMPLETE = "public_licenseRequestComplete", _.LICENSE_REQUEST_SENDING = "public_licenseRequestSending", _.NEED_KEY = "needkey", _.PROTECTION_CREATED = "public_protectioncreated", _.PROTECTION_DESTROYED = "public_protectiondestroyed", _.SERVER_CERTIFICATE_UPDATED = "serverCertificateUpdated", _.TEARDOWN_COMPLETE = "protectionTeardownComplete", _.VIDEO_ELEMENT_SELECTED = "videoElementSelected", _.KEY_SESSION_UPDATED = "public_keySessionUpdated", _;
              }
              return L;
            }(h.default), T = new N();
            const R = T;
          }
        ),
        /***/
        "./src/streaming/protection/controllers/ProtectionController.js": (
          /*!**********************************************************************!*\
            !*** ./src/streaming/protection/controllers/ProtectionController.js ***!
            \**********************************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => D
              /* harmony export */
            });
            var h = i(
              /*! ../CommonEncryption */
              "./src/streaming/protection/CommonEncryption.js"
            ), f = i(
              /*! ../vo/MediaCapability */
              "./src/streaming/protection/vo/MediaCapability.js"
            ), p = i(
              /*! ../vo/KeySystemConfiguration */
              "./src/streaming/protection/vo/KeySystemConfiguration.js"
            ), d = i(
              /*! ../errors/ProtectionErrors */
              "./src/streaming/protection/errors/ProtectionErrors.js"
            ), v = i(
              /*! ../../vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), g = i(
              /*! ../vo/LicenseRequest */
              "./src/streaming/protection/vo/LicenseRequest.js"
            ), m = i(
              /*! ../vo/LicenseResponse */
              "./src/streaming/protection/vo/LicenseResponse.js"
            ), A = i(
              /*! ../../vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            ), b = i(
              /*! ../../../core/Utils */
              "./src/core/Utils.js"
            ), S = i(
              /*! ../../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), N = i(
              /*! ../../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function T(M) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? T = function(I) {
                return typeof I;
              } : T = function(I) {
                return I && typeof Symbol == "function" && I.constructor === Symbol && I !== Symbol.prototype ? "symbol" : typeof I;
              }, T(M);
            }
            var R = 5, y = 500, E = 3, L = 1e3, _ = 8e3;
            function O(M) {
              M = M || {};
              var C = M.protectionKeyController, I = M.protectionModel, w = M.eventBus, F = M.events, k = M.debug, H = M.BASE64, Z = M.constants, Y = [], j = M.cmcdModel, J = M.settings, ae = M.customParametersModel, G, $, ie, re, ce, z, oe, de, pe, he, se;
              function ee() {
                $ = k.getLogger(G), ie = [], re = [], z = "temporary", oe = "", he = null, se = null, w.on(F.INTERNAL_KEY_MESSAGE, it, G), w.on(F.INTERNAL_KEY_STATUS_CHANGED, Xe, G);
              }
              function te() {
                if (!w || !w.hasOwnProperty("on") || !C || !C.hasOwnProperty("getSupportedKeySystemsFromContentProtection"))
                  throw new Error("Missing config parameter(s)");
              }
              function le(me) {
                if (!me)
                  throw new Error("mediaInfo can not be null or undefined");
                te(), re.push(me);
              }
              function ne() {
                if (!(!re || re.length === 0)) {
                  var me = [];
                  re.forEach(function(Me) {
                    var Be = C.getSupportedKeySystemsFromContentProtection(Me.contentProtection, ce, z);
                    Be.length > 0 && (me.length === 0 && (me = Be), ie.push(Be));
                  }), me && me.length > 0 && P(me, !0);
                }
              }
              function x(me) {
                ie.push(me), P(me, !1);
              }
              function P(me, Me) {
                !de && !pe ? B(me, Me) : de && W();
              }
              function B(me, Me) {
                if (!pe) {
                  pe = !0;
                  var Be = [];
                  me = me.sort(function(tt, gt) {
                    var Mt = ce && ce[tt.ks.systemString] && ce[tt.ks.systemString].priority >= 0 ? ce[tt.ks.systemString].priority : me.length, xt = ce && ce[gt.ks.systemString] && ce[gt.ks.systemString].priority >= 0 ? ce[gt.ks.systemString].priority : me.length;
                    return Mt - xt;
                  });
                  for (var Fe = 0; Fe < me.length; Fe++) {
                    var Ze = Ie(me[Fe]);
                    Be.push({
                      ks: me[Fe].ks,
                      configs: [Ze],
                      protData: me[Fe].protData
                    });
                  }
                  var ot;
                  I.requestKeySystemAccess(Be).then(function(tt) {
                    ot = tt.data;
                    var gt = ot.mksa && ot.mksa.selectedSystemString ? ot.mksa.selectedSystemString : ot.keySystem.systemString;
                    return $.info("DRM: KeySystem Access Granted for system string (" + gt + ")!  Selecting key system..."), I.selectKeySystem(ot);
                  }).then(function(tt) {
                    if (de = tt, pe = !1, !!I) {
                      w.trigger(F.KEY_SYSTEM_SELECTED, {
                        data: ot
                      });
                      var gt = V(de);
                      gt && gt.serverCertificate && gt.serverCertificate.length > 0 && I.setServerCertificate(H.decodeArray(gt.serverCertificate).buffer), W();
                    }
                  }).catch(function(tt) {
                    de = null, pe = !1, Me || w.trigger(F.KEY_SYSTEM_SELECTED, {
                      data: null,
                      error: new v.default(d.default.KEY_SYSTEM_ACCESS_DENIED_ERROR_CODE, d.default.KEY_SYSTEM_ACCESS_DENIED_ERROR_MESSAGE + "Error selecting key system! -- " + tt.error)
                    });
                  });
                }
              }
              function W() {
                for (var me, Me = 0; Me < ie.length; Me++)
                  for (me = 0; me < ie[Me].length; me++)
                    if (de === ie[Me][me].ks) {
                      var Be = ie[Me][me];
                      X(Be);
                      break;
                    }
                ie = [];
              }
              function X(me) {
                if (C.isClearKey(de) && me.protData && me.protData.hasOwnProperty("clearkeys") && Object.keys(me.protData.clearkeys).length !== 0) {
                  var Me = {
                    kids: Object.keys(me.protData.clearkeys)
                  };
                  me.initData = new TextEncoder().encode(JSON.stringify(Me));
                }
                me.sessionId ? K(me) : me.initData !== null && U(me);
              }
              function K(me) {
                te(), I.loadKeySession(me);
              }
              function U(me) {
                var Me = h.default.getPSSHForKeySystem(de, me ? me.initData : null);
                if (Me) {
                  if (ue(me.keyId) || q(Me))
                    return;
                  try {
                    me.initData = Me, I.createKeySession(me);
                  } catch (Be) {
                    w.trigger(F.KEY_SESSION_CREATED, {
                      data: null,
                      error: new v.default(d.default.KEY_SESSION_CREATED_ERROR_CODE, d.default.KEY_SESSION_CREATED_ERROR_MESSAGE + Be.message)
                    });
                  }
                } else
                  me && me.initData ? I.createKeySession(me) : w.trigger(F.KEY_SESSION_CREATED, {
                    data: null,
                    error: new v.default(d.default.KEY_SESSION_CREATED_ERROR_CODE, d.default.KEY_SESSION_CREATED_ERROR_MESSAGE + "Selected key system is " + (de ? de.systemString : null) + ".  needkey/encrypted event contains no initData corresponding to that key system!")
                  });
              }
              function V(me) {
                if (me) {
                  var Me = me.systemString;
                  if (ce)
                    return Me in ce ? ce[Me] : null;
                }
                return null;
              }
              function Q() {
                re = [];
              }
              function fe(me) {
                return te(), C.getSupportedKeySystemsFromContentProtection(me, ce, z);
              }
              function ue(me) {
                if (!me)
                  return !1;
                try {
                  for (var Me = I.getSessions(), Be = 0; Be < Me.length; Be++)
                    if (Me[Be].getKeyId() === me)
                      return !0;
                  return !1;
                } catch {
                  return !1;
                }
              }
              function q(me) {
                if (!me)
                  return !1;
                try {
                  for (var Me = I.getAllInitData(), Be = 0; Be < Me.length; Be++)
                    if (C.initDataEquals(me, Me[Be]))
                      return $.debug("DRM: Ignoring initData because we have already seen it!"), !0;
                  return !1;
                } catch {
                  return !1;
                }
              }
              function _e(me) {
                te(), I.removeKeySession(me);
              }
              function ge(me) {
                te(), I.closeKeySession(me);
              }
              function Ce(me) {
                te(), I.setServerCertificate(me);
              }
              function Ee(me) {
                te(), me ? (I.setMediaElement(me), w.on(F.NEED_KEY, Ut, G)) : me === null && (I.setMediaElement(me), w.off(F.NEED_KEY, Ut, G));
              }
              function Re(me) {
                z = me;
              }
              function Pe(me) {
                oe = me;
              }
              function ke(me) {
                ce = me, C.setProtectionData(me);
              }
              function De() {
                $e(), I && I.stop();
              }
              function Ae() {
                w.off(F.INTERNAL_KEY_MESSAGE, it, G), w.off(F.INTERNAL_KEY_STATUS_CHANGED, Xe, G), te(), $e(), Ee(null), de = null, pe = !1, I && (I.reset(), I = null), Y.forEach(function(me) {
                  return clearTimeout(me);
                }), Y = [], re = [], ie = [];
              }
              function Ie(me) {
                var Me = me.protData, Be = [], Fe = [], Ze = Me && Me.audioRobustness && Me.audioRobustness.length > 0 ? Me.audioRobustness : oe, ot = Me && Me.videoRobustness && Me.videoRobustness.length > 0 ? Me.videoRobustness : oe, tt = me.sessionType, gt = Me && Me.distinctiveIdentifier ? Me.distinctiveIdentifier : "optional", Mt = Me && Me.persistentState ? Me.persistentState : tt === "temporary" ? "optional" : "required";
                return re.forEach(function(xt) {
                  xt.type === Z.AUDIO ? Be.push(new f.default(xt.codec, Ze)) : xt.type === Z.VIDEO && Fe.push(new f.default(xt.codec, ot));
                }), new p.default(Be, Fe, gt, Mt, [tt]);
              }
              function Xe(me) {
                me.error ? w.trigger(F.KEY_STATUSES_CHANGED, {
                  data: null,
                  error: me.error
                }) : $.debug("DRM: key status = " + me.status);
              }
              function it(me) {
                $.debug("DRM: onKeyMessage");
                var Me = me.data;
                w.trigger(F.KEY_MESSAGE, {
                  data: Me
                });
                var Be = Me.messageType ? Me.messageType : "license-request", Fe = Me.message, Ze = Me.sessionToken, ot = V(de), tt = C.getLicenseServerModelInstance(de, ot, Be), gt = {
                  sessionToken: Ze,
                  messageType: Be
                };
                if (!Fe || Fe.byteLength === 0) {
                  rt(gt, new v.default(d.default.MEDIA_KEY_MESSAGE_NO_CHALLENGE_ERROR_CODE, d.default.MEDIA_KEY_MESSAGE_NO_CHALLENGE_ERROR_MESSAGE));
                  return;
                }
                if (!tt) {
                  $.debug("DRM: License server request not required for this message (type = " + me.data.messageType + ").  Session ID = " + Ze.getSessionId()), rt(gt);
                  return;
                }
                if (C.isClearKey(de)) {
                  var Mt = C.processClearKeyLicenseRequest(de, ot, Fe);
                  if (Mt && Mt.keyPairs && Mt.keyPairs.length > 0) {
                    $.debug("DRM: ClearKey license request handled by application!"), rt(gt), I.updateKeySession(Ze, Mt);
                    return;
                  }
                }
                Ne(Me, tt, ot);
              }
              function rt(me, Me) {
                w.trigger(F.LICENSE_REQUEST_COMPLETE, {
                  data: me,
                  error: Me
                });
              }
              function Ne(me, Me, Be) {
                var Fe = me.sessionToken, Ze = me.messageType ? me.messageType : "license-request", ot = {
                  sessionToken: Fe,
                  messageType: Ze
                }, tt = de ? de.systemString : null, gt = nt(Be, Ze, Fe, me, Me);
                if (!gt) {
                  rt(ot, new v.default(d.default.MEDIA_KEY_MESSAGE_NO_LICENSE_SERVER_URL_ERROR_CODE, d.default.MEDIA_KEY_MESSAGE_NO_LICENSE_SERVER_URL_ERROR_MESSAGE));
                  return;
                }
                var Mt = {}, xt = !1;
                Be && ut(Mt, Be.httpRequestHeaders);
                var be = me.message, We = de.getRequestHeadersFromMessage(be);
                ut(Mt, We), Object.keys(Mt).forEach(function(Ke) {
                  Ke.toLowerCase() === "authorization" && (xt = !0);
                }), Be && typeof Be.withCredentials == "boolean" && (xt = Be.withCredentials);
                var et = function(Qe) {
                  if (I)
                    if (Qe.status >= 200 && Qe.status <= 299) {
                      var Et = b.default.parseHttpHeaders(Qe.getAllResponseHeaders ? Qe.getAllResponseHeaders() : null), Vt = new m.default(Qe.responseURL, Et, Qe.response), It = ae.getLicenseResponseFilters();
                      vt(It, Vt).then(function() {
                        var Pt = Me.getLicenseMessage(Vt.data, tt, Ze);
                        Pt !== null ? (rt(ot), I.updateKeySession(Fe, Pt)) : pt(Qe, ot, tt, Ze, Me);
                      });
                    } else
                      pt(Qe, ot, tt, Ze, Me);
                }, _t = function(Qe) {
                  rt(ot, new v.default(d.default.MEDIA_KEY_MESSAGE_LICENSER_ERROR_CODE, d.default.MEDIA_KEY_MESSAGE_LICENSER_ERROR_MESSAGE + tt + ' update, XHR aborted. status is "' + Qe.statusText + '" (' + Qe.status + "), readyState is " + Qe.readyState));
                }, ht = function(Qe) {
                  rt(ot, new v.default(d.default.MEDIA_KEY_MESSAGE_LICENSER_ERROR_CODE, d.default.MEDIA_KEY_MESSAGE_LICENSER_ERROR_MESSAGE + tt + ' update, XHR error. status is "' + Qe.statusText + '" (' + Qe.status + "), readyState is " + Qe.readyState));
                }, St = de.getLicenseRequestFromMessage(be), kt = Me.getHTTPMethod(Ze), Qt = Me.getResponseType(tt, Ze), tn = Be && !isNaN(Be.httpTimeout) ? Be.httpTimeout : _, ye = Fe.getSessionId() || null, ze = new g.default(gt, kt, Qt, Mt, xt, Ze, ye, St), ft = isNaN(J.get().streaming.retryAttempts[A.HTTPRequest.LICENSE]) ? E : J.get().streaming.retryAttempts[A.HTTPRequest.LICENSE], Le = ae.getLicenseRequestFilters();
                vt(Le, ze).then(function() {
                  He(ze, ft, tn, et, _t, ht);
                });
              }
              function He(me, Me, Be, Fe, Ze, ot) {
                var tt = new XMLHttpRequest();
                if (J.get().streaming.cmcd && J.get().streaming.cmcd.enabled) {
                  var gt = J.get().streaming.cmcd.mode;
                  if (gt === S.default.CMCD_MODE_QUERY) {
                    var Mt = j.getQueryParameter({
                      url: me.url,
                      type: A.HTTPRequest.LICENSE
                    });
                    Mt && (me.url = b.default.addAditionalQueryParameterToUrl(me.url, [Mt]));
                  }
                }
                tt.open(me.method, me.url, !0), tt.responseType = me.responseType, tt.withCredentials = me.withCredentials, Be > 0 && (tt.timeout = Be);
                for (var xt in me.headers)
                  tt.setRequestHeader(xt, me.headers[xt]);
                if (J.get().streaming.cmcd && J.get().streaming.cmcd.enabled) {
                  var be = J.get().streaming.cmcd.mode;
                  if (be === S.default.CMCD_MODE_HEADER) {
                    var We = j.getHeaderParameters({
                      url: me.url,
                      type: A.HTTPRequest.LICENSE
                    });
                    if (We)
                      for (var et in We) {
                        var _t = We[et];
                        _t && tt.setRequestHeader(et, _t);
                      }
                  }
                }
                var ht = function() {
                  Me--;
                  var kt = isNaN(J.get().streaming.retryIntervals[A.HTTPRequest.LICENSE]) ? L : J.get().streaming.retryIntervals[A.HTTPRequest.LICENSE];
                  se = setTimeout(function() {
                    He(me, Me, Be, Fe, Ze, ot);
                  }, kt);
                };
                tt.onload = function() {
                  he = null, this.status >= 200 && this.status <= 299 || Me <= 0 ? Fe(this) : ($.warn("License request failed (" + this.status + "). Retrying it... Pending retries: " + Me), ht());
                }, tt.ontimeout = tt.onerror = function() {
                  he = null, Me <= 0 ? ot(this) : ($.warn("License request network request failed . Retrying it... Pending retries: " + Me), ht());
                }, tt.onabort = function() {
                  Ze(this);
                }, w.trigger(F.LICENSE_REQUEST_SENDING, {
                  url: me.url,
                  headers: me.headers,
                  payload: me.data,
                  sessionId: me.sessionId
                }), he = tt, tt.send(me.data);
              }
              function $e() {
                he && (he.onloadend = he.onerror = he.onprogress = void 0, he.abort(), he = null), se && (clearTimeout(se), se = null);
              }
              function nt(me, Me, Be, Fe, Ze) {
                var ot = null, tt = Fe.message;
                if (me && me.serverURL) {
                  var gt = me.serverURL;
                  typeof gt == "string" && gt !== "" ? ot = gt : T(gt) === "object" && gt.hasOwnProperty(Me) && (ot = gt[Me]);
                } else if (me && me.laURL && me.laURL !== "")
                  ot = me.laURL;
                else if (ot = h.default.getLicenseServerUrlFromMediaInfo(re, de.schemeIdURI), !ot && !C.isClearKey(de)) {
                  var Mt = h.default.getPSSHData(Be.initData);
                  ot = de.getLicenseServerURLFromInitData(Mt), ot || (ot = Fe.laURL);
                }
                return ot = Ze.getServerURLFromMessage(ot, tt, Me), ot;
              }
              function ut(me, Me) {
                if (Me)
                  for (var Be in Me)
                    me[Be] = Me[Be];
              }
              function pt(me, Me, Be, Fe, Ze) {
                var ot = "NONE", tt = null;
                me.response && (ot = Ze.getErrorResponse(me.response, Be, Fe), tt = {
                  serverResponse: me.response || null,
                  responseCode: me.status || null,
                  responseText: me.statusText || null
                }), rt(Me, new v.default(d.default.MEDIA_KEY_MESSAGE_LICENSER_ERROR_CODE, d.default.MEDIA_KEY_MESSAGE_LICENSER_ERROR_MESSAGE + Be + ' update, XHR complete. status is "' + me.statusText + '" (' + me.status + "), readyState is " + me.readyState + ".  Response is " + ot, tt));
              }
              function vt(me, Me) {
                return me ? me.reduce(function(Be, Fe) {
                  return Be.then(function() {
                    return Fe(Me);
                  });
                }, Promise.resolve()) : Promise.resolve();
              }
              function Ut(me, Me) {
                if (!J.get().streaming.protection.ignoreEmeEncryptedEvent) {
                  if ($.debug("DRM: onNeedKey"), me.key.initDataType !== "cenc") {
                    $.warn("DRM:  Only 'cenc' initData is supported!  Ignoring initData of type: " + me.key.initDataType);
                    return;
                  }
                  if (re.length === 0 && ($.warn("DRM: onNeedKey called before initializeForMedia, wait until initialized"), Me = typeof Me > "u" ? 1 : Me + 1, Me < R)) {
                    Y.push(setTimeout(function() {
                      Ut(me, Me);
                    }, y));
                    return;
                  }
                  var Be = me.key.initData;
                  if (ArrayBuffer.isView(Be) && (Be = Be.buffer), de) {
                    var Fe = h.default.getPSSHForKeySystem(de, Be);
                    if (Fe && q(Fe))
                      return;
                  }
                  $.debug("DRM: initData:", String.fromCharCode.apply(null, new Uint8Array(Be)));
                  var Ze = C.getSupportedKeySystemsFromSegmentPssh(Be, ce, z);
                  if (Ze.length === 0) {
                    $.debug("DRM: Received needkey event with initData, but we don't support any of the key systems!");
                    return;
                  }
                  x(Ze);
                }
              }
              function Je() {
                return C ? C.getKeySystems() : [];
              }
              function Te(me) {
                C && C.setKeySystems(me);
              }
              return G = {
                initializeForMedia: le,
                clearMediaInfoArray: Q,
                handleKeySystemFromManifest: ne,
                createKeySession: U,
                loadKeySession: K,
                removeKeySession: _e,
                closeKeySession: ge,
                setServerCertificate: Ce,
                setMediaElement: Ee,
                setSessionType: Re,
                setRobustnessLevel: Pe,
                setProtectionData: ke,
                getSupportedKeySystemsFromContentProtection: fe,
                getKeySystems: Je,
                setKeySystems: Te,
                stop: De,
                reset: Ae
              }, ee(), G;
            }
            O.__dashjs_factory_name = "ProtectionController";
            const D = N.default.getClassFactory(O);
          }
        ),
        /***/
        "./src/streaming/protection/controllers/ProtectionKeyController.js": (
          /*!*************************************************************************!*\
            !*** ./src/streaming/protection/controllers/ProtectionKeyController.js ***!
            \*************************************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => T
              /* harmony export */
            });
            var h = i(
              /*! ./../CommonEncryption */
              "./src/streaming/protection/CommonEncryption.js"
            ), f = i(
              /*! ./../drm/KeySystemClearKey */
              "./src/streaming/protection/drm/KeySystemClearKey.js"
            ), p = i(
              /*! ./../drm/KeySystemW3CClearKey */
              "./src/streaming/protection/drm/KeySystemW3CClearKey.js"
            ), d = i(
              /*! ./../drm/KeySystemWidevine */
              "./src/streaming/protection/drm/KeySystemWidevine.js"
            ), v = i(
              /*! ./../drm/KeySystemPlayReady */
              "./src/streaming/protection/drm/KeySystemPlayReady.js"
            ), g = i(
              /*! ./../servers/DRMToday */
              "./src/streaming/protection/servers/DRMToday.js"
            ), m = i(
              /*! ./../servers/PlayReady */
              "./src/streaming/protection/servers/PlayReady.js"
            ), A = i(
              /*! ./../servers/Widevine */
              "./src/streaming/protection/servers/Widevine.js"
            ), b = i(
              /*! ./../servers/ClearKey */
              "./src/streaming/protection/servers/ClearKey.js"
            ), S = i(
              /*! ../../constants/ProtectionConstants */
              "./src/streaming/constants/ProtectionConstants.js"
            );
            function N() {
              var R = this.context, y, E, L, _, O, D, M, C;
              function I(z) {
                z && (z.debug && (E = z.debug, L = E.getLogger(y)), z.BASE64 && (O = z.BASE64), z.settings && (D = z.settings));
              }
              function w() {
                _ = [];
                var z;
                z = (0, v.default)(R).getInstance({
                  BASE64: O,
                  settings: D
                }), _.push(z), z = (0, d.default)(R).getInstance({
                  BASE64: O
                }), _.push(z), z = (0, f.default)(R).getInstance({
                  BASE64: O
                }), _.push(z), M = z, z = (0, p.default)(R).getInstance({
                  BASE64: O,
                  debug: E
                }), _.push(z), C = z;
              }
              function F() {
                return _;
              }
              function k(z) {
                _ = z;
              }
              function H(z) {
                for (var oe = 0; oe < _.length; oe++)
                  if (_[oe].systemString === z)
                    return _[oe];
                return null;
              }
              function Z(z) {
                return z === M || z === C;
              }
              function Y(z, oe) {
                if (z.byteLength === oe.byteLength) {
                  for (var de = new Uint8Array(z), pe = new Uint8Array(oe), he = 0; he < de.length; he++)
                    if (de[he] !== pe[he])
                      return !1;
                  return !0;
                }
                return !1;
              }
              function j(z, oe, de) {
                var pe, he, se, ee, te = [];
                if (z) {
                  var le = h.default.findCencContentProtection(z);
                  for (se = 0; se < _.length; ++se) {
                    he = _[se];
                    var ne = ie(he.systemString, oe);
                    for (ee = 0; ee < z.length; ++ee)
                      if (pe = z[ee], pe.schemeIdUri.toLowerCase() === he.schemeIdURI) {
                        var x = he.getInitData(pe, le);
                        te.push({
                          ks: _[se],
                          keyId: pe.keyId,
                          initData: x,
                          protData: ne,
                          cdmData: he.getCDMData(ne ? ne.cdmData : null),
                          sessionId: re(ne, pe),
                          sessionType: ce(ne, de)
                        });
                      }
                  }
                }
                return te;
              }
              function J(z, oe, de) {
                for (var pe = [], he = h.default.parsePSSHList(z), se, ee, te = 0; te < _.length; ++te) {
                  se = _[te], ee = se.systemString;
                  var le = ie(ee, oe);
                  se.uuid in he && pe.push({
                    ks: se,
                    initData: he[se.uuid],
                    protData: le,
                    cdmData: se.getCDMData(le ? le.cdmData : null),
                    sessionId: re(le),
                    sessionType: ce(le, de)
                  });
                }
                return pe;
              }
              function ae(z, oe, de) {
                if (de === "license-release" || de === "individualization-request")
                  return null;
                var pe = null;
                return oe && oe.hasOwnProperty("drmtoday") ? pe = (0, g.default)(R).getInstance({
                  BASE64: O
                }) : z.systemString === S.default.WIDEVINE_KEYSTEM_STRING ? pe = (0, A.default)(R).getInstance() : z.systemString === S.default.PLAYREADY_KEYSTEM_STRING ? pe = (0, m.default)(R).getInstance() : z.systemString === S.default.CLEARKEY_KEYSTEM_STRING && (pe = (0, b.default)(R).getInstance()), pe;
              }
              function G(z, oe, de) {
                try {
                  return z.getClearKeysFromProtectionData(oe, de);
                } catch {
                  return L.error("Failed to retrieve clearkeys from ProtectionData"), null;
                }
              }
              function $(z) {
                for (var oe = function(se) {
                  var ee = null;
                  return z && (ee = se in z ? z[se] : null), ee;
                }, de = 0; de < _.length; de++) {
                  var pe = _[de];
                  pe.hasOwnProperty("init") && pe.init(oe(pe.systemString));
                }
              }
              function ie(z, oe) {
                return oe && z in oe ? oe[z] : null;
              }
              function re(z, oe) {
                return z && z.sessionId ? z.sessionId : oe && oe.sessionId ? oe.sessionId : null;
              }
              function ce(z, oe) {
                return z && z.sessionType ? z.sessionType : oe;
              }
              return y = {
                initialize: w,
                setProtectionData: $,
                isClearKey: Z,
                initDataEquals: Y,
                getKeySystems: F,
                setKeySystems: k,
                getKeySystemBySystemString: H,
                getSupportedKeySystemsFromContentProtection: j,
                getSupportedKeySystemsFromSegmentPssh: J,
                getLicenseServerModelInstance: ae,
                processClearKeyLicenseRequest: G,
                setConfig: I
              }, y;
            }
            N.__dashjs_factory_name = "ProtectionKeyController";
            const T = dashjs.FactoryMaker.getSingletonFactory(N);
          }
        ),
        /***/
        "./src/streaming/protection/drm/KeySystemClearKey.js": (
          /*!***********************************************************!*\
            !*** ./src/streaming/protection/drm/KeySystemClearKey.js ***!
            \***********************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => b
              /* harmony export */
            });
            var h = i(
              /*! ../vo/KeyPair */
              "./src/streaming/protection/vo/KeyPair.js"
            ), f = i(
              /*! ../vo/ClearKeyKeySet */
              "./src/streaming/protection/vo/ClearKeyKeySet.js"
            ), p = i(
              /*! ../CommonEncryption */
              "./src/streaming/protection/CommonEncryption.js"
            ), d = i(
              /*! ../../constants/ProtectionConstants */
              "./src/streaming/constants/ProtectionConstants.js"
            ), v = "e2719d58-a985-b3c9-781a-b030af78d30e", g = d.default.CLEARKEY_KEYSTEM_STRING, m = "urn:uuid:" + v;
            function A(S) {
              S = S || {};
              var N, T = S.BASE64;
              function R(M, C) {
                var I = null;
                if (M) {
                  for (var w = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(C))), F = [], k = 0; k < w.kids.length; k++) {
                    var H = w.kids[k], Z = M.clearkeys && M.clearkeys.hasOwnProperty(H) ? M.clearkeys[H] : null;
                    if (!Z)
                      throw new Error("DRM: ClearKey keyID (" + H + ") is not known!");
                    F.push(new h.default(H, Z));
                  }
                  I = new f.default(F);
                }
                return I;
              }
              function y(M, C) {
                try {
                  var I = p.default.parseInitDataFromContentProtection(M, T);
                  if (!I && C) {
                    var w = E(C["cenc:default_KID"]), F = {
                      kids: [w]
                    };
                    I = new TextEncoder().encode(JSON.stringify(F));
                  }
                  return I;
                } catch {
                  return null;
                }
              }
              function E(M) {
                try {
                  var C = M.replace(/-/g, "");
                  return C = btoa(C.match(/\w{2}/g).map(function(I) {
                    return String.fromCharCode(parseInt(I, 16));
                  }).join("")), C.replace(/=/g, "").replace(/\//g, "_").replace(/\+/g, "-");
                } catch {
                  return null;
                }
              }
              function L() {
                return {
                  "Content-Type": "application/json"
                };
              }
              function _(M) {
                return JSON.stringify(JSON.parse(String.fromCharCode.apply(null, new Uint8Array(M))));
              }
              function O() {
                return null;
              }
              function D() {
                return null;
              }
              return N = {
                uuid: v,
                schemeIdURI: m,
                systemString: g,
                getInitData: y,
                getRequestHeadersFromMessage: L,
                getLicenseRequestFromMessage: _,
                getLicenseServerURLFromInitData: O,
                getCDMData: D,
                getClearKeysFromProtectionData: R
              }, N;
            }
            A.__dashjs_factory_name = "KeySystemClearKey";
            const b = dashjs.FactoryMaker.getSingletonFactory(A);
          }
        ),
        /***/
        "./src/streaming/protection/drm/KeySystemPlayReady.js": (
          /*!************************************************************!*\
            !*** ./src/streaming/protection/drm/KeySystemPlayReady.js ***!
            \************************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => A
              /* harmony export */
            });
            var h = i(
              /*! ../CommonEncryption */
              "./src/streaming/protection/CommonEncryption.js"
            ), f = i(
              /*! ../../constants/ProtectionConstants */
              "./src/streaming/constants/ProtectionConstants.js"
            ), p = "9a04f079-9840-4286-ab92-e65be0885f95", d = f.default.PLAYREADY_KEYSTEM_STRING, v = "urn:uuid:" + p, g = '<PlayReadyCDMData type="LicenseAcquisition"><LicenseAcquisition version="1.0" Proactive="false"><CustomData encoding="base64encoded">%CUSTOMDATA%</CustomData></LicenseAcquisition></PlayReadyCDMData>';
            function m(b) {
              b = b || {};
              var S, N = "utf-16", T = b.BASE64, R = b.settings;
              function y() {
                if (!T || !T.hasOwnProperty("decodeArray") || !T.hasOwnProperty("decodeArray"))
                  throw new Error("Missing config parameter(s)");
              }
              function E(C) {
                var I, w, F = {}, k = new DOMParser();
                if (R && R.get().streaming.protection.detectPlayreadyMessageFormat && N === "utf-16" && C && C.byteLength % 2 === 1)
                  return F["Content-Type"] = "text/xml; charset=utf-8", F;
                var H = N === "utf-16" ? new Uint16Array(C) : new Uint8Array(C);
                I = String.fromCharCode.apply(null, H), w = k.parseFromString(I, "application/xml");
                for (var Z = w.getElementsByTagName("name"), Y = w.getElementsByTagName("value"), j = 0; j < Z.length; j++)
                  F[Z[j].childNodes[0].nodeValue] = Y[j].childNodes[0].nodeValue;
                return F.hasOwnProperty("Content") && (F["Content-Type"] = F.Content, delete F.Content), F.hasOwnProperty("Content-Type") || (F["Content-Type"] = "text/xml; charset=utf-8"), F;
              }
              function L(C) {
                var I = null, w = new DOMParser();
                if (R && R.get().streaming.protection.detectPlayreadyMessageFormat && N === "utf-16" && C && C.byteLength % 2 === 1)
                  return C;
                var F = N === "utf-16" ? new Uint16Array(C) : new Uint8Array(C);
                y();
                var k = String.fromCharCode.apply(null, F), H = w.parseFromString(k, "application/xml");
                if (H.getElementsByTagName("PlayReadyKeyMessage")[0]) {
                  var Z = H.getElementsByTagName("Challenge")[0].childNodes[0].nodeValue;
                  Z && (I = T.decode(Z));
                } else
                  return C;
                return I;
              }
              function _(C) {
                if (C)
                  for (var I = new DataView(C), w = I.getUint16(4, !0), F = 6, k = new DOMParser(), H = 0; H < w; H++) {
                    var Z = I.getUint16(F, !0);
                    F += 2;
                    var Y = I.getUint16(F, !0);
                    if (F += 2, Z !== 1) {
                      F += Y;
                      continue;
                    }
                    var j = C.slice(F, F + Y), J = String.fromCharCode.apply(null, new Uint16Array(j)), ae = k.parseFromString(J, "application/xml");
                    if (ae.getElementsByTagName("LA_URL")[0]) {
                      var G = ae.getElementsByTagName("LA_URL")[0].childNodes[0].nodeValue;
                      if (G)
                        return G;
                    }
                    if (ae.getElementsByTagName("LUI_URL")[0]) {
                      var $ = ae.getElementsByTagName("LUI_URL")[0].childNodes[0].nodeValue;
                      if ($)
                        return $;
                    }
                  }
                return null;
              }
              function O(C) {
                var I = new Uint8Array([112, 115, 115, 104, 0, 0, 0, 0]), w = new Uint8Array([154, 4, 240, 121, 152, 64, 66, 134, 171, 146, 230, 91, 224, 136, 95, 149]), F = 0, k = null, H, Z, Y, j, J;
                if (y(), !C)
                  return null;
                if ("pssh" in C)
                  return h.default.parseInitDataFromContentProtection(C, T);
                if ("pro" in C)
                  k = T.decodeArray(C.pro.__text);
                else if ("prheader" in C)
                  k = T.decodeArray(C.prheader.__text);
                else
                  return null;
                return H = k.length, Z = 4 + I.length + w.length + 4 + H, Y = new ArrayBuffer(Z), j = new Uint8Array(Y), J = new DataView(Y), J.setUint32(F, Z), F += 4, j.set(I, F), F += I.length, j.set(w, F), F += w.length, J.setUint32(F, H), F += 4, j.set(k, F), F += H, j.buffer;
              }
              function D(C) {
                if (C !== "utf-8" && C !== "utf-16")
                  throw new Error('Specified message format is not one of "utf-8" or "utf-16"');
                N = C;
              }
              function M(C) {
                var I, w, F, k;
                if (y(), !C)
                  return null;
                for (I = [], k = 0; k < C.length; ++k)
                  I.push(C.charCodeAt(k)), I.push(0);
                for (I = String.fromCharCode.apply(null, I), I = T.encode(I), w = g.replace("%CUSTOMDATA%", I), F = [], k = 0; k < w.length; ++k)
                  F.push(w.charCodeAt(k)), F.push(0);
                return new Uint8Array(F).buffer;
              }
              return S = {
                uuid: p,
                schemeIdURI: v,
                systemString: d,
                getInitData: O,
                getRequestHeadersFromMessage: E,
                getLicenseRequestFromMessage: L,
                getLicenseServerURLFromInitData: _,
                getCDMData: M,
                setPlayReadyMessageFormat: D
              }, S;
            }
            m.__dashjs_factory_name = "KeySystemPlayReady";
            const A = dashjs.FactoryMaker.getSingletonFactory(m);
          }
        ),
        /***/
        "./src/streaming/protection/drm/KeySystemW3CClearKey.js": (
          /*!**************************************************************!*\
            !*** ./src/streaming/protection/drm/KeySystemW3CClearKey.js ***!
            \**************************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => b
              /* harmony export */
            });
            var h = i(
              /*! ../vo/KeyPair */
              "./src/streaming/protection/vo/KeyPair.js"
            ), f = i(
              /*! ../vo/ClearKeyKeySet */
              "./src/streaming/protection/vo/ClearKeyKeySet.js"
            ), p = i(
              /*! ../CommonEncryption */
              "./src/streaming/protection/CommonEncryption.js"
            ), d = i(
              /*! ../../constants/ProtectionConstants */
              "./src/streaming/constants/ProtectionConstants.js"
            ), v = "1077efec-c0b2-4d02-ace3-3c1e52e2fb4b", g = d.default.CLEARKEY_KEYSTEM_STRING, m = "urn:uuid:" + v;
            function A(S) {
              var N, T = S.BASE64, R = S.debug.getLogger(N);
              function y(M, C) {
                var I = null;
                if (M) {
                  for (var w = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(C))), F = [], k = 0; k < w.kids.length; k++) {
                    var H = w.kids[k], Z = M.clearkeys && M.clearkeys.hasOwnProperty(H) ? M.clearkeys[H] : null;
                    if (!Z)
                      throw new Error("DRM: ClearKey keyID (" + H + ") is not known!");
                    F.push(new h.default(H, Z));
                  }
                  I = new f.default(F), R.warn("ClearKey schemeIdURI is using W3C Common PSSH systemID (1077efec-c0b2-4d02-ace3-3c1e52e2fb4b) in Content Protection. See DASH-IF IOP v4.1 section 7.6.2.4");
                }
                return I;
              }
              function E(M) {
                return p.default.parseInitDataFromContentProtection(M, T);
              }
              function L() {
                return null;
              }
              function _(M) {
                return new Uint8Array(M);
              }
              function O() {
                return null;
              }
              function D() {
                return null;
              }
              return N = {
                uuid: v,
                schemeIdURI: m,
                systemString: g,
                getInitData: E,
                getRequestHeadersFromMessage: L,
                getLicenseRequestFromMessage: _,
                getLicenseServerURLFromInitData: O,
                getCDMData: D,
                getClearKeysFromProtectionData: y
              }, N;
            }
            A.__dashjs_factory_name = "KeySystemW3CClearKey";
            const b = dashjs.FactoryMaker.getSingletonFactory(A);
          }
        ),
        /***/
        "./src/streaming/protection/drm/KeySystemWidevine.js": (
          /*!***********************************************************!*\
            !*** ./src/streaming/protection/drm/KeySystemWidevine.js ***!
            \***********************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => m
              /* harmony export */
            });
            var h = i(
              /*! ../CommonEncryption */
              "./src/streaming/protection/CommonEncryption.js"
            ), f = i(
              /*! ../../constants/ProtectionConstants */
              "./src/streaming/constants/ProtectionConstants.js"
            ), p = "edef8ba9-79d6-4ace-a3c8-27dcd51d21ed", d = f.default.WIDEVINE_KEYSTEM_STRING, v = "urn:uuid:" + p;
            function g(A) {
              A = A || {};
              var b, S = A.BASE64;
              function N(L) {
                return h.default.parseInitDataFromContentProtection(L, S);
              }
              function T() {
                return null;
              }
              function R(L) {
                return new Uint8Array(L);
              }
              function y() {
                return null;
              }
              function E() {
                return null;
              }
              return b = {
                uuid: p,
                schemeIdURI: v,
                systemString: d,
                getInitData: N,
                getRequestHeadersFromMessage: T,
                getLicenseRequestFromMessage: R,
                getLicenseServerURLFromInitData: y,
                getCDMData: E
              }, b;
            }
            g.__dashjs_factory_name = "KeySystemWidevine";
            const m = dashjs.FactoryMaker.getSingletonFactory(g);
          }
        ),
        /***/
        "./src/streaming/protection/errors/ProtectionErrors.js": (
          /*!*************************************************************!*\
            !*** ./src/streaming/protection/errors/ProtectionErrors.js ***!
            \*************************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => R
              /* harmony export */
            });
            var h = i(
              /*! ../../../core/errors/ErrorsBase */
              "./src/core/errors/ErrorsBase.js"
            );
            function f(y) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? f = function(L) {
                return typeof L;
              } : f = function(L) {
                return L && typeof Symbol == "function" && L.constructor === Symbol && L !== Symbol.prototype ? "symbol" : typeof L;
              }, f(y);
            }
            function p(y, E) {
              if (!(y instanceof E))
                throw new TypeError("Cannot call a class as a function");
            }
            function d(y, E) {
              if (typeof E != "function" && E !== null)
                throw new TypeError("Super expression must either be null or a function");
              y.prototype = Object.create(E && E.prototype, { constructor: { value: y, writable: !0, configurable: !0 } }), E && v(y, E);
            }
            function v(y, E) {
              return v = Object.setPrototypeOf || function(_, O) {
                return _.__proto__ = O, _;
              }, v(y, E);
            }
            function g(y) {
              var E = b();
              return function() {
                var _ = S(y), O;
                if (E) {
                  var D = S(this).constructor;
                  O = Reflect.construct(_, arguments, D);
                } else
                  O = _.apply(this, arguments);
                return m(this, O);
              };
            }
            function m(y, E) {
              return E && (f(E) === "object" || typeof E == "function") ? E : A(y);
            }
            function A(y) {
              if (y === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return y;
            }
            function b() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return !1;
              if (typeof Proxy == "function")
                return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function S(y) {
              return S = Object.setPrototypeOf ? Object.getPrototypeOf : function(L) {
                return L.__proto__ || Object.getPrototypeOf(L);
              }, S(y);
            }
            var N = /* @__PURE__ */ function(y) {
              d(L, y);
              var E = g(L);
              function L() {
                var _;
                return p(this, L), _ = E.call(this), _.MEDIA_KEYERR_CODE = 100, _.MEDIA_KEYERR_UNKNOWN_CODE = 101, _.MEDIA_KEYERR_CLIENT_CODE = 102, _.MEDIA_KEYERR_SERVICE_CODE = 103, _.MEDIA_KEYERR_OUTPUT_CODE = 104, _.MEDIA_KEYERR_HARDWARECHANGE_CODE = 105, _.MEDIA_KEYERR_DOMAIN_CODE = 106, _.MEDIA_KEY_MESSAGE_ERROR_CODE = 107, _.MEDIA_KEY_MESSAGE_NO_CHALLENGE_ERROR_CODE = 108, _.SERVER_CERTIFICATE_UPDATED_ERROR_CODE = 109, _.KEY_STATUS_CHANGED_EXPIRED_ERROR_CODE = 110, _.MEDIA_KEY_MESSAGE_NO_LICENSE_SERVER_URL_ERROR_CODE = 111, _.KEY_SYSTEM_ACCESS_DENIED_ERROR_CODE = 112, _.KEY_SESSION_CREATED_ERROR_CODE = 113, _.MEDIA_KEY_MESSAGE_LICENSER_ERROR_CODE = 114, _.MEDIA_KEYERR_UNKNOWN_MESSAGE = "An unspecified error occurred. This value is used for errors that don't match any of the other codes.", _.MEDIA_KEYERR_CLIENT_MESSAGE = "The Key System could not be installed or updated.", _.MEDIA_KEYERR_SERVICE_MESSAGE = "The message passed into update indicated an error from the license service.", _.MEDIA_KEYERR_OUTPUT_MESSAGE = "There is no available output device with the required characteristics for the content protection system.", _.MEDIA_KEYERR_HARDWARECHANGE_MESSAGE = "A hardware configuration change caused a content protection error.", _.MEDIA_KEYERR_DOMAIN_MESSAGE = "An error occurred in a multi-device domain licensing configuration. The most common error is a failure to join the domain.", _.MEDIA_KEY_MESSAGE_ERROR_MESSAGE = "Multiple key sessions were creates with a user-agent that does not support sessionIDs!! Unpredictable behavior ahead!", _.MEDIA_KEY_MESSAGE_NO_CHALLENGE_ERROR_MESSAGE = "DRM: Empty key message from CDM", _.SERVER_CERTIFICATE_UPDATED_ERROR_MESSAGE = "Error updating server certificate -- ", _.KEY_STATUS_CHANGED_EXPIRED_ERROR_MESSAGE = "DRM: KeyStatusChange error! -- License has expired", _.MEDIA_KEY_MESSAGE_NO_LICENSE_SERVER_URL_ERROR_MESSAGE = "DRM: No license server URL specified!", _.KEY_SYSTEM_ACCESS_DENIED_ERROR_MESSAGE = "DRM: KeySystem Access Denied! -- ", _.KEY_SESSION_CREATED_ERROR_MESSAGE = "DRM: unable to create session! --", _.MEDIA_KEY_MESSAGE_LICENSER_ERROR_MESSAGE = "DRM: licenser error! --", _;
              }
              return L;
            }(h.default), T = new N();
            const R = T;
          }
        ),
        /***/
        "./src/streaming/protection/models/ProtectionModel_01b.js": (
          /*!****************************************************************!*\
            !*** ./src/streaming/protection/models/ProtectionModel_01b.js ***!
            \****************************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => b
              /* harmony export */
            });
            var h = i(
              /*! ../controllers/ProtectionKeyController */
              "./src/streaming/protection/controllers/ProtectionKeyController.js"
            ), f = i(
              /*! ../vo/NeedKey */
              "./src/streaming/protection/vo/NeedKey.js"
            ), p = i(
              /*! ../../vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), d = i(
              /*! ../vo/KeyMessage */
              "./src/streaming/protection/vo/KeyMessage.js"
            ), v = i(
              /*! ../vo/KeySystemConfiguration */
              "./src/streaming/protection/vo/KeySystemConfiguration.js"
            ), g = i(
              /*! ../vo/KeySystemAccess */
              "./src/streaming/protection/vo/KeySystemAccess.js"
            ), m = i(
              /*! ../errors/ProtectionErrors */
              "./src/streaming/protection/errors/ProtectionErrors.js"
            );
            function A(S) {
              S = S || {};
              var N = this.context, T = S.eventBus, R = S.events, y = S.debug, E = S.api, L = S.errHandler, _, O, D, M, C, I, w, F, k;
              function H() {
                O = y.getLogger(_), D = null, M = null, I = [], w = [], C = (0, h.default)(N).getInstance(), k = de();
              }
              function Z() {
                D && he();
                for (var se = 0; se < w.length; se++)
                  re(w[se]);
                T.trigger(R.TEARDOWN_COMPLETE);
              }
              function Y() {
                for (var se = [], ee = 0; ee < I.length; ee++)
                  se.push(I[ee].initData);
                for (var te = 0; te < w.length; te++)
                  se.push(w[te].initData);
                return se;
              }
              function j() {
                return w.concat(I);
              }
              function J(se) {
                return new Promise(function(ee, te) {
                  var le = D;
                  le || (le = document.createElement("video"));
                  for (var ne = !1, x = 0; x < se.length; x++)
                    for (var P = se[x].ks.systemString, B = se[x].configs, W = null, X = null, K = 0; K < B.length; K++) {
                      var U = B[K].videoCapabilities;
                      if (U && U.length !== 0) {
                        X = [];
                        for (var V = 0; V < U.length; V++)
                          le.canPlayType(U[V].contentType, P) !== "" && X.push(U[V]);
                      }
                      if (!(!W && !X || W && W.length === 0 || X && X.length === 0)) {
                        ne = !0;
                        var Q = new v.default(W, X), fe = C.getKeySystemBySystemString(P), ue = new g.default(fe, Q);
                        T.trigger(R.KEY_SYSTEM_ACCESS_COMPLETE, {
                          data: ue
                        }), ee({
                          data: ue
                        });
                        break;
                      }
                    }
                  if (!ne) {
                    var q = "Key system access denied! -- No valid audio/video content configurations detected!";
                    T.trigger(R.KEY_SYSTEM_ACCESS_COMPLETE, {
                      error: q
                    }), te({
                      error: q
                    });
                  }
                });
              }
              function ae(se) {
                return M = se.keySystem, Promise.resolve(M);
              }
              function G(se) {
                if (D !== se) {
                  if (D) {
                    he();
                    for (var ee = 0; ee < w.length; ee++)
                      re(w[ee]);
                    w = [];
                  }
                  D = se, D && (D.addEventListener(E.keyerror, k), D.addEventListener(E.needkey, k), D.addEventListener(E.keymessage, k), D.addEventListener(E.keyadded, k), T.trigger(R.VIDEO_ELEMENT_SELECTED));
                }
              }
              function $(se) {
                if (!M)
                  throw new Error("Can not create sessions until you have selected a key system");
                if (F || w.length === 0) {
                  var ee = {
                    // Implements SessionToken
                    sessionId: null,
                    keyId: se.keyId,
                    initData: se.initData,
                    getKeyId: function() {
                      return this.keyId;
                    },
                    getSessionId: function() {
                      return this.sessionId;
                    },
                    getExpirationTime: function() {
                      return NaN;
                    },
                    getSessionType: function() {
                      return "temporary";
                    }
                  };
                  return I.push(ee), D[E.generateKeyRequest](M.systemString, new Uint8Array(se.initData)), ee;
                } else
                  throw new Error("Multiple sessions not allowed!");
              }
              function ie(se, ee) {
                var te = se.sessionId;
                if (!C.isClearKey(M))
                  D[E.addKey](M.systemString, new Uint8Array(ee), new Uint8Array(se.initData), te);
                else
                  for (var le = 0; le < ee.keyPairs.length; le++)
                    D[E.addKey](M.systemString, ee.keyPairs[le].key, ee.keyPairs[le].keyID, te);
                T.trigger(R.KEY_SESSION_UPDATED);
              }
              function re(se) {
                try {
                  D[E.cancelKeyRequest](M.systemString, se.sessionId);
                } catch (ee) {
                  T.trigger(R.KEY_SESSION_CLOSED, {
                    data: null,
                    error: "Error closing session (" + se.sessionId + ") " + ee.message
                  });
                }
              }
              function ce() {
              }
              function z() {
              }
              function oe() {
              }
              function de() {
                return {
                  handleEvent: function(ee) {
                    var te = null;
                    switch (ee.type) {
                      case E.needkey:
                        var le = ArrayBuffer.isView(ee.initData) ? ee.initData.buffer : ee.initData;
                        T.trigger(R.NEED_KEY, {
                          key: new f.default(le, "cenc")
                        });
                        break;
                      case E.keyerror:
                        if (te = pe(w, ee.sessionId), te || (te = pe(I, ee.sessionId)), te) {
                          var ne = m.default.MEDIA_KEYERR_CODE, x = "";
                          switch (ee.errorCode.code) {
                            case 1:
                              ne = m.default.MEDIA_KEYERR_UNKNOWN_CODE, x += "MEDIA_KEYERR_UNKNOWN - " + m.default.MEDIA_KEYERR_UNKNOWN_MESSAGE;
                              break;
                            case 2:
                              ne = m.default.MEDIA_KEYERR_CLIENT_CODE, x += "MEDIA_KEYERR_CLIENT - " + m.default.MEDIA_KEYERR_CLIENT_MESSAGE;
                              break;
                            case 3:
                              ne = m.default.MEDIA_KEYERR_SERVICE_CODE, x += "MEDIA_KEYERR_SERVICE - " + m.default.MEDIA_KEYERR_SERVICE_MESSAGE;
                              break;
                            case 4:
                              ne = m.default.MEDIA_KEYERR_OUTPUT_CODE, x += "MEDIA_KEYERR_OUTPUT - " + m.default.MEDIA_KEYERR_OUTPUT_MESSAGE;
                              break;
                            case 5:
                              ne = m.default.MEDIA_KEYERR_HARDWARECHANGE_CODE, x += "MEDIA_KEYERR_HARDWARECHANGE - " + m.default.MEDIA_KEYERR_HARDWARECHANGE_MESSAGE;
                              break;
                            case 6:
                              ne = m.default.MEDIA_KEYERR_DOMAIN_CODE, x += "MEDIA_KEYERR_DOMAIN - " + m.default.MEDIA_KEYERR_DOMAIN_MESSAGE;
                              break;
                          }
                          x += "  System Code = " + ee.systemCode, T.trigger(R.KEY_ERROR, {
                            error: new p.default(ne, x, te)
                          });
                        } else
                          O.error("No session token found for key error");
                        break;
                      case E.keyadded:
                        te = pe(w, ee.sessionId), te || (te = pe(I, ee.sessionId)), te ? (O.debug("DRM: Key added."), T.trigger(R.KEY_ADDED, {
                          data: te
                        })) : O.debug("No session token found for key added");
                        break;
                      case E.keymessage:
                        if (F = ee.sessionId !== null && ee.sessionId !== void 0, F ? (te = pe(w, ee.sessionId), !te && I.length > 0 && (te = I.shift(), w.push(te), te.sessionId = ee.sessionId, T.trigger(R.KEY_SESSION_CREATED, {
                          data: te
                        }))) : I.length > 0 && (te = I.shift(), w.push(te), I.length !== 0 && L.error(new p.default(m.default.MEDIA_KEY_MESSAGE_ERROR_CODE, m.default.MEDIA_KEY_MESSAGE_ERROR_MESSAGE))), te) {
                          var P = ArrayBuffer.isView(ee.message) ? ee.message.buffer : ee.message;
                          te.keyMessage = P, T.trigger(R.INTERNAL_KEY_MESSAGE, {
                            data: new d.default(te, P, ee.defaultURL)
                          });
                        } else
                          O.warn("No session token found for key message");
                        break;
                    }
                  }
                };
              }
              function pe(se, ee) {
                if (!ee || !se)
                  return null;
                for (var te = se.length, le = 0; le < te; le++)
                  if (se[le].sessionId == ee)
                    return se[le];
                return null;
              }
              function he() {
                D.removeEventListener(E.keyerror, k), D.removeEventListener(E.needkey, k), D.removeEventListener(E.keymessage, k), D.removeEventListener(E.keyadded, k);
              }
              return _ = {
                getAllInitData: Y,
                getSessions: j,
                requestKeySystemAccess: J,
                selectKeySystem: ae,
                setMediaElement: G,
                createKeySession: $,
                updateKeySession: ie,
                closeKeySession: re,
                setServerCertificate: ce,
                loadKeySession: z,
                removeKeySession: oe,
                stop: Z,
                reset: Z
              }, H(), _;
            }
            A.__dashjs_factory_name = "ProtectionModel_01b";
            const b = dashjs.FactoryMaker.getClassFactory(A);
          }
        ),
        /***/
        "./src/streaming/protection/models/ProtectionModel_21Jan2015.js": (
          /*!**********************************************************************!*\
            !*** ./src/streaming/protection/models/ProtectionModel_21Jan2015.js ***!
            \**********************************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => S
              /* harmony export */
            });
            var h = i(
              /*! ../controllers/ProtectionKeyController */
              "./src/streaming/protection/controllers/ProtectionKeyController.js"
            ), f = i(
              /*! ../vo/NeedKey */
              "./src/streaming/protection/vo/NeedKey.js"
            ), p = i(
              /*! ../errors/ProtectionErrors */
              "./src/streaming/protection/errors/ProtectionErrors.js"
            ), d = i(
              /*! ../../vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), v = i(
              /*! ../vo/KeyMessage */
              "./src/streaming/protection/vo/KeyMessage.js"
            ), g = i(
              /*! ../vo/KeySystemAccess */
              "./src/streaming/protection/vo/KeySystemAccess.js"
            ), m = i(
              /*! ../../constants/ProtectionConstants */
              "./src/streaming/constants/ProtectionConstants.js"
            ), A = {};
            A[m.default.PLAYREADY_KEYSTEM_STRING] = [m.default.PLAYREADY_KEYSTEM_STRING, m.default.PLAYREADY_RECOMMENDATION_KEYSTEM_STRING], A[m.default.WIDEVINE_KEYSTEM_STRING] = [m.default.WIDEVINE_KEYSTEM_STRING], A[m.default.CLEARKEY_KEYSTEM_STRING] = [m.default.CLEARKEY_KEYSTEM_STRING];
            function b(N) {
              N = N || {};
              var T = this.context, R = N.eventBus, y = N.events, E = N.debug, L, _, O, D, M, C, I, w;
              function F() {
                _ = E.getLogger(L), O = null, D = null, M = null, C = [], w = (0, h.default)(T).getInstance(), I = se();
              }
              function k() {
                var ne = C.length, x;
                ne !== 0 ? function() {
                  for (var P = function(X) {
                    ee(X), C.length === 0 && (D ? (D.removeEventListener("encrypted", I), D.setMediaKeys(null).then(function() {
                      R.trigger(y.TEARDOWN_COMPLETE);
                    })) : R.trigger(y.TEARDOWN_COMPLETE));
                  }, B = 0; B < ne; B++)
                    x = C[B], function(W) {
                      x.session.closed.then(function() {
                        P(W);
                      }), he(x).catch(function() {
                        P(W);
                      });
                    }(x);
                }() : R.trigger(y.TEARDOWN_COMPLETE);
              }
              function H() {
                for (var ne, x = 0; x < C.length; x++)
                  ne = C[x], ne.getUsable() || he(ne).catch(function() {
                    ee(ne);
                  });
              }
              function Z() {
                for (var ne = [], x = 0; x < C.length; x++)
                  C[x].initData && ne.push(C[x].initData);
                return ne;
              }
              function Y() {
                return C;
              }
              function j(ne) {
                return new Promise(function(x, P) {
                  J(ne, 0, x, P);
                });
              }
              function J(ne, x, P, B) {
                if (navigator.requestMediaKeySystemAccess === void 0 || typeof navigator.requestMediaKeySystemAccess != "function") {
                  var W = "Insecure origins are not allowed";
                  R.trigger(y.KEY_SYSTEM_ACCESS_COMPLETE, {
                    error: W
                  }), B({
                    error: W
                  });
                  return;
                }
                var X = ne[x].protData && ne[x].protData.systemStringPriority ? ne[x].protData.systemStringPriority : null, K = ne[x].configs, U = ne[x].ks, V = U.systemString, Q = X || (A[V] ? A[V] : [V]);
                ae(Q, K).then(function(fe) {
                  var ue = typeof fe.getConfiguration == "function" ? fe.getConfiguration() : null, q = new g.default(U, ue);
                  q.mksa = fe, R.trigger(y.KEY_SYSTEM_ACCESS_COMPLETE, {
                    data: q
                  }), P({
                    data: q
                  });
                }).catch(function(fe) {
                  if (x + 1 < ne.length)
                    J(ne, x + 1, P, B);
                  else {
                    var ue = "Key system access denied! ";
                    R.trigger(y.KEY_SYSTEM_ACCESS_COMPLETE, {
                      error: ue + fe.message
                    }), B({
                      error: ue + fe.message
                    });
                  }
                });
              }
              function ae(ne, x) {
                return new Promise(function(P, B) {
                  G(ne, x, 0, P, B);
                });
              }
              function G(ne, x, P, B, W) {
                var X = ne[P];
                _.debug("Requesting key system access for system string ".concat(X)), navigator.requestMediaKeySystemAccess(X, x).then(function(K) {
                  K.selectedSystemString = X, B(K);
                }).catch(function(K) {
                  P + 1 < ne.length ? G(ne, x, P + 1, B, W) : W(K);
                });
              }
              function $(ne) {
                return new Promise(function(x, P) {
                  ne.mksa.createMediaKeys().then(function(B) {
                    return O = ne.keySystem, M = B, D ? D.setMediaKeys(M) : Promise.resolve();
                  }).then(function() {
                    x(O);
                  }).catch(function() {
                    P({
                      error: "Error selecting keys system (" + ne.keySystem.systemString + ")! Could not create MediaKeys -- TODO"
                    });
                  });
                });
              }
              function ie(ne) {
                D !== ne && (D && (D.removeEventListener("encrypted", I), D.setMediaKeys && D.setMediaKeys(null)), D = ne, D && (D.addEventListener("encrypted", I), D.setMediaKeys && M && D.setMediaKeys(M)));
              }
              function re(ne) {
                if (!O || !M)
                  throw new Error("Can not set server certificate until you have selected a key system");
                M.setServerCertificate(ne).then(function() {
                  _.info("DRM: License server certificate successfully updated."), R.trigger(y.SERVER_CERTIFICATE_UPDATED);
                }).catch(function(x) {
                  R.trigger(y.SERVER_CERTIFICATE_UPDATED, {
                    error: new d.default(p.default.SERVER_CERTIFICATE_UPDATED_ERROR_CODE, p.default.SERVER_CERTIFICATE_UPDATED_ERROR_MESSAGE + x.name)
                  });
                });
              }
              function ce(ne) {
                if (!O || !M)
                  throw new Error("Can not create sessions until you have selected a key system");
                var x = M.createSession(ne.sessionType), P = le(x, ne), B = O.systemString === m.default.CLEARKEY_KEYSTEM_STRING && (ne.initData || ne.protData && ne.protData.clearkeys) ? m.default.INITIALIZATION_DATA_TYPE_KEYIDS : m.default.INITIALIZATION_DATA_TYPE_CENC;
                x.generateRequest(B, ne.initData).then(function() {
                  _.debug("DRM: Session created.  SessionID = " + P.getSessionId()), R.trigger(y.KEY_SESSION_CREATED, {
                    data: P
                  });
                }).catch(function(W) {
                  ee(P), R.trigger(y.KEY_SESSION_CREATED, {
                    data: null,
                    error: new d.default(p.default.KEY_SESSION_CREATED_ERROR_CODE, p.default.KEY_SESSION_CREATED_ERROR_MESSAGE + "Error generating key request -- " + W.name)
                  });
                });
              }
              function z(ne, x) {
                var P = ne.session;
                w.isClearKey(O) && (x = x.toJWK()), P.update(x).then(function() {
                  R.trigger(y.KEY_SESSION_UPDATED);
                }).catch(function(B) {
                  R.trigger(y.KEY_ERROR, {
                    error: new d.default(p.default.MEDIA_KEYERR_CODE, "Error sending update() message! " + B.name, ne)
                  });
                });
              }
              function oe(ne) {
                if (!O || !M)
                  throw new Error("Can not load sessions until you have selected a key system");
                for (var x = ne.sessionId, P = 0; P < C.length; P++)
                  if (x === C[P].sessionId) {
                    _.warn("DRM: Ignoring session ID because we have already seen it!");
                    return;
                  }
                var B = M.createSession(ne.sessionType), W = le(B, ne);
                B.load(x).then(function(X) {
                  X ? (_.debug("DRM: Session loaded.  SessionID = " + W.getSessionId()), R.trigger(y.KEY_SESSION_CREATED, {
                    data: W
                  })) : (ee(W), R.trigger(y.KEY_SESSION_CREATED, {
                    data: null,
                    error: new d.default(p.default.KEY_SESSION_CREATED_ERROR_CODE, p.default.KEY_SESSION_CREATED_ERROR_MESSAGE + "Could not load session! Invalid Session ID (" + x + ")")
                  }));
                }).catch(function(X) {
                  ee(W), R.trigger(y.KEY_SESSION_CREATED, {
                    data: null,
                    error: new d.default(p.default.KEY_SESSION_CREATED_ERROR_CODE, p.default.KEY_SESSION_CREATED_ERROR_MESSAGE + "Could not load session (" + x + ")! " + X.name)
                  });
                });
              }
              function de(ne) {
                var x = ne.session;
                x.remove().then(function() {
                  _.debug("DRM: Session removed.  SessionID = " + ne.getSessionId()), R.trigger(y.KEY_SESSION_REMOVED, {
                    data: ne.getSessionId()
                  });
                }, function(P) {
                  R.trigger(y.KEY_SESSION_REMOVED, {
                    data: null,
                    error: "Error removing session (" + ne.getSessionId() + "). " + P.name
                  });
                });
              }
              function pe(ne) {
                he(ne).catch(function(x) {
                  ee(ne), R.trigger(y.KEY_SESSION_CLOSED, {
                    data: null,
                    error: "Error closing session (" + ne.getSessionId() + ") " + x.name
                  });
                });
              }
              function he(ne) {
                var x = ne.session;
                return x.removeEventListener("keystatuseschange", ne), x.removeEventListener("message", ne), x.close();
              }
              function se() {
                return {
                  handleEvent: function(x) {
                    switch (x.type) {
                      case "encrypted":
                        if (x.initData) {
                          var P = ArrayBuffer.isView(x.initData) ? x.initData.buffer : x.initData;
                          R.trigger(y.NEED_KEY, {
                            key: new f.default(P, x.initDataType)
                          });
                        }
                        break;
                    }
                  }
                };
              }
              function ee(ne) {
                for (var x = 0; x < C.length; x++)
                  if (C[x] === ne) {
                    C.splice(x, 1);
                    break;
                  }
              }
              function te(ne) {
                var x, P;
                return ne && ne.length > 0 && (ne[0] && (typeof ne[0] == "string" ? x = ne[0] : P = ne[0]), ne[1] && (typeof ne[1] == "string" ? x = ne[1] : P = ne[1])), {
                  status: x,
                  keyId: P
                };
              }
              function le(ne, x) {
                var P = {
                  // Implements SessionToken
                  session: ne,
                  keyId: x.keyId,
                  initData: x.initData,
                  sessionId: x.sessionId,
                  sessionType: x.sessionType,
                  // This is our main event handler for all desired MediaKeySession events
                  // These events are translated into our API-independent versions of the
                  // same events
                  handleEvent: function(W) {
                    switch (W.type) {
                      case "keystatuseschange":
                        R.trigger(y.KEY_STATUSES_CHANGED, {
                          data: this
                        }), W.target.keyStatuses.forEach(function() {
                          var K = te(arguments);
                          switch (K.status) {
                            case "expired":
                              R.trigger(y.INTERNAL_KEY_STATUS_CHANGED, {
                                error: new d.default(p.default.KEY_STATUS_CHANGED_EXPIRED_ERROR_CODE, p.default.KEY_STATUS_CHANGED_EXPIRED_ERROR_MESSAGE)
                              });
                              break;
                            default:
                              R.trigger(y.INTERNAL_KEY_STATUS_CHANGED, K);
                              break;
                          }
                        });
                        break;
                      case "message":
                        var X = ArrayBuffer.isView(W.message) ? W.message.buffer : W.message;
                        R.trigger(y.INTERNAL_KEY_MESSAGE, {
                          data: new v.default(this, X, void 0, W.messageType)
                        });
                        break;
                    }
                  },
                  getKeyId: function() {
                    return this.keyId;
                  },
                  getSessionId: function() {
                    return ne.sessionId;
                  },
                  getSessionType: function() {
                    return this.sessionType;
                  },
                  getExpirationTime: function() {
                    return ne.expiration;
                  },
                  getKeyStatuses: function() {
                    return ne.keyStatuses;
                  },
                  getUsable: function() {
                    var W = !1;
                    return ne.keyStatuses.forEach(function() {
                      var X = te(arguments);
                      X.status === "usable" && (W = !0);
                    }), W;
                  }
                };
                return ne.addEventListener("keystatuseschange", P), ne.addEventListener("message", P), ne.closed.then(function() {
                  ee(P), _.debug("DRM: Session closed.  SessionID = " + P.getSessionId()), R.trigger(y.KEY_SESSION_CLOSED, {
                    data: P.getSessionId()
                  });
                }), C.push(P), P;
              }
              return L = {
                getAllInitData: Z,
                getSessions: Y,
                requestKeySystemAccess: j,
                selectKeySystem: $,
                setMediaElement: ie,
                setServerCertificate: re,
                createKeySession: ce,
                updateKeySession: z,
                loadKeySession: oe,
                removeKeySession: de,
                closeKeySession: pe,
                stop: H,
                reset: k
              }, F(), L;
            }
            b.__dashjs_factory_name = "ProtectionModel_21Jan2015";
            const S = dashjs.FactoryMaker.getClassFactory(b);
          }
        ),
        /***/
        "./src/streaming/protection/models/ProtectionModel_3Feb2014.js": (
          /*!*********************************************************************!*\
            !*** ./src/streaming/protection/models/ProtectionModel_3Feb2014.js ***!
            \*********************************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => b
              /* harmony export */
            });
            var h = i(
              /*! ../controllers/ProtectionKeyController */
              "./src/streaming/protection/controllers/ProtectionKeyController.js"
            ), f = i(
              /*! ../vo/NeedKey */
              "./src/streaming/protection/vo/NeedKey.js"
            ), p = i(
              /*! ../../vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), d = i(
              /*! ../errors/ProtectionErrors */
              "./src/streaming/protection/errors/ProtectionErrors.js"
            ), v = i(
              /*! ../vo/KeyMessage */
              "./src/streaming/protection/vo/KeyMessage.js"
            ), g = i(
              /*! ../vo/KeySystemConfiguration */
              "./src/streaming/protection/vo/KeySystemConfiguration.js"
            ), m = i(
              /*! ../vo/KeySystemAccess */
              "./src/streaming/protection/vo/KeySystemAccess.js"
            );
            function A(S) {
              S = S || {};
              var N = this.context, T = S.eventBus, R = S.events, y = S.debug, E = S.api, L, _, O, D, M, C, I, w, F;
              function k() {
                _ = y.getLogger(L), O = null, D = null, M = null, C = null, I = [], F = (0, h.default)(N).getInstance(), w = oe();
              }
              function H() {
                try {
                  for (var he = 0; he < I.length; he++)
                    ie(I[he]);
                  O && O.removeEventListener(E.needkey, w), T.trigger(R.TEARDOWN_COMPLETE);
                } catch (se) {
                  T.trigger(R.TEARDOWN_COMPLETE, {
                    error: "Error tearing down key sessions and MediaKeys! -- " + se.message
                  });
                }
              }
              function Z() {
                for (var he = [], se = 0; se < I.length; se++)
                  he.push(I[se].initData);
                return he;
              }
              function Y() {
                return I;
              }
              function j(he) {
                return new Promise(function(se, ee) {
                  for (var te = !1, le = 0; le < he.length; le++)
                    for (var ne = he[le].ks.systemString, x = he[le].configs, P = null, B = null, W = 0; W < x.length; W++) {
                      var X = x[W].audioCapabilities, K = x[W].videoCapabilities;
                      if (X && X.length !== 0) {
                        P = [];
                        for (var U = 0; U < X.length; U++)
                          window[E.MediaKeys].isTypeSupported(ne, X[U].contentType) && P.push(X[U]);
                      }
                      if (K && K.length !== 0) {
                        B = [];
                        for (var V = 0; V < K.length; V++)
                          window[E.MediaKeys].isTypeSupported(ne, K[V].contentType) && B.push(K[V]);
                      }
                      if (!(!P && !B || P && P.length === 0 || B && B.length === 0)) {
                        te = !0;
                        var Q = new g.default(P, B), fe = F.getKeySystemBySystemString(ne), ue = new m.default(fe, Q);
                        T.trigger(R.KEY_SYSTEM_ACCESS_COMPLETE, {
                          data: ue
                        }), se({
                          data: ue
                        });
                        break;
                      }
                    }
                  if (!te) {
                    var q = "Key system access denied! -- No valid audio/video content configurations detected!";
                    T.trigger(R.KEY_SYSTEM_ACCESS_COMPLETE, {
                      error: q
                    }), ee({
                      error: q
                    });
                  }
                });
              }
              function J(he) {
                return new Promise(function(se, ee) {
                  try {
                    M = he.mediaKeys = new window[E.MediaKeys](he.keySystem.systemString), D = he.keySystem, C = he, O && de(), se(D);
                  } catch {
                    ee({
                      error: "Error selecting keys system (" + D.systemString + ")! Could not create MediaKeys -- TODO"
                    });
                  }
                });
              }
              function ae(he) {
                O !== he && (O && O.removeEventListener(E.needkey, w), O = he, O && (O.addEventListener(E.needkey, w), M && de()));
              }
              function G(he) {
                if (!D || !M || !C)
                  throw new Error("Can not create sessions until you have selected a key system");
                var se = null;
                if (C.ksConfiguration.videoCapabilities && C.ksConfiguration.videoCapabilities.length > 0 && (se = C.ksConfiguration.videoCapabilities[0]), se === null && C.ksConfiguration.audioCapabilities && C.ksConfiguration.audioCapabilities.length > 0 && (se = C.ksConfiguration.audioCapabilities[0]), se === null)
                  throw new Error("Can not create sessions for unknown content types.");
                var ee = se.contentType, te = M.createSession(ee, new Uint8Array(he.initData), he.cdmData ? new Uint8Array(he.cdmData) : null), le = pe(te, he);
                te.addEventListener(E.error, le), te.addEventListener(E.message, le), te.addEventListener(E.ready, le), te.addEventListener(E.close, le), I.push(le), _.debug("DRM: Session created.  SessionID = " + le.getSessionId()), T.trigger(R.KEY_SESSION_CREATED, {
                  data: le
                });
              }
              function $(he, se) {
                var ee = he.session;
                F.isClearKey(D) ? ee.update(new Uint8Array(se.toJWK())) : ee.update(new Uint8Array(se)), T.trigger(R.KEY_SESSION_UPDATED);
              }
              function ie(he) {
                var se = he.session;
                se.removeEventListener(E.error, he), se.removeEventListener(E.message, he), se.removeEventListener(E.ready, he), se.removeEventListener(E.close, he);
                for (var ee = 0; ee < I.length; ee++)
                  if (I[ee] === he) {
                    I.splice(ee, 1);
                    break;
                  }
                se[E.release]();
              }
              function re() {
              }
              function ce() {
              }
              function z() {
              }
              function oe() {
                return {
                  handleEvent: function(se) {
                    switch (se.type) {
                      case E.needkey:
                        if (se.initData) {
                          var ee = ArrayBuffer.isView(se.initData) ? se.initData.buffer : se.initData;
                          T.trigger(R.NEED_KEY, {
                            key: new f.default(ee, "cenc")
                          });
                        }
                        break;
                    }
                  }
                };
              }
              function de() {
                var he = null, se = function() {
                  O.removeEventListener("loadedmetadata", he), O[E.setMediaKeys](M), T.trigger(R.VIDEO_ELEMENT_SELECTED);
                };
                O.readyState >= 1 ? se() : (he = se.bind(this), O.addEventListener("loadedmetadata", he));
              }
              function pe(he, se) {
                return {
                  // Implements SessionToken
                  session: he,
                  keyId: se.keyId,
                  initData: se.initData,
                  getKeyId: function() {
                    return this.keyId;
                  },
                  getSessionId: function() {
                    return this.session.sessionId;
                  },
                  getExpirationTime: function() {
                    return NaN;
                  },
                  getSessionType: function() {
                    return "temporary";
                  },
                  // This is our main event handler for all desired MediaKeySession events
                  // These events are translated into our API-independent versions of the
                  // same events
                  handleEvent: function(te) {
                    switch (te.type) {
                      case E.error:
                        var le = "KeyError";
                        T.trigger(R.KEY_ERROR, {
                          error: new p.default(d.default.MEDIA_KEYERR_CODE, le, this)
                        });
                        break;
                      case E.message:
                        var ne = ArrayBuffer.isView(te.message) ? te.message.buffer : te.message;
                        T.trigger(R.INTERNAL_KEY_MESSAGE, {
                          data: new v.default(this, ne, te.destinationURL)
                        });
                        break;
                      case E.ready:
                        _.debug("DRM: Key added."), T.trigger(R.KEY_ADDED);
                        break;
                      case E.close:
                        _.debug("DRM: Session closed.  SessionID = " + this.getSessionId()), T.trigger(R.KEY_SESSION_CLOSED, {
                          data: this.getSessionId()
                        });
                        break;
                    }
                  }
                };
              }
              return L = {
                getAllInitData: Z,
                getSessions: Y,
                requestKeySystemAccess: j,
                selectKeySystem: J,
                setMediaElement: ae,
                createKeySession: G,
                updateKeySession: $,
                closeKeySession: ie,
                setServerCertificate: re,
                loadKeySession: ce,
                removeKeySession: z,
                stop: H,
                reset: H
              }, k(), L;
            }
            A.__dashjs_factory_name = "ProtectionModel_3Feb2014";
            const b = dashjs.FactoryMaker.getClassFactory(A);
          }
        ),
        /***/
        "./src/streaming/protection/servers/ClearKey.js": (
          /*!******************************************************!*\
            !*** ./src/streaming/protection/servers/ClearKey.js ***!
            \******************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => d
              /* harmony export */
            });
            var h = i(
              /*! ../vo/KeyPair */
              "./src/streaming/protection/vo/KeyPair.js"
            ), f = i(
              /*! ../vo/ClearKeyKeySet */
              "./src/streaming/protection/vo/ClearKeyKeySet.js"
            );
            function p() {
              var v;
              function g(N) {
                return N;
              }
              function m() {
                return "POST";
              }
              function A() {
                return "json";
              }
              function b(N) {
                if (!N.hasOwnProperty("keys"))
                  return null;
                for (var T = [], R = 0; R < N.keys.length; R++) {
                  var y = N.keys[R], E = y.kid.replace(/=/g, ""), L = y.k.replace(/=/g, "");
                  T.push(new h.default(E, L));
                }
                return new f.default(T);
              }
              function S(N) {
                return String.fromCharCode.apply(null, new Uint8Array(N));
              }
              return v = {
                getServerURLFromMessage: g,
                getHTTPMethod: m,
                getResponseType: A,
                getLicenseMessage: b,
                getErrorResponse: S
              }, v;
            }
            p.__dashjs_factory_name = "ClearKey";
            const d = dashjs.FactoryMaker.getSingletonFactory(p);
          }
        ),
        /***/
        "./src/streaming/protection/servers/DRMToday.js": (
          /*!******************************************************!*\
            !*** ./src/streaming/protection/servers/DRMToday.js ***!
            \******************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            var h = i(
              /*! ../../constants/ProtectionConstants */
              "./src/streaming/constants/ProtectionConstants.js"
            );
            function f(d) {
              d = d || {};
              var v = d.BASE64, g = {};
              g[h.default.WIDEVINE_KEYSTEM_STRING] = {
                responseType: "json",
                getLicenseMessage: function(E) {
                  return v.decodeArray(E.license);
                },
                getErrorResponse: function(E) {
                  return E;
                }
              }, g[h.default.PLAYREADY_KEYSTEM_STRING] = {
                responseType: "arraybuffer",
                getLicenseMessage: function(E) {
                  return E;
                },
                getErrorResponse: function(E) {
                  return String.fromCharCode.apply(null, new Uint8Array(E));
                }
              };
              var m;
              function A() {
                if (!v || !v.hasOwnProperty("decodeArray"))
                  throw new Error("Missing config parameter(s)");
              }
              function b(y) {
                return y;
              }
              function S() {
                return "POST";
              }
              function N(y) {
                return g[y].responseType;
              }
              function T(y, E) {
                return A(), g[E].getLicenseMessage(y);
              }
              function R(y, E) {
                return g[E].getErrorResponse(y);
              }
              return m = {
                getServerURLFromMessage: b,
                getHTTPMethod: S,
                getResponseType: N,
                getLicenseMessage: T,
                getErrorResponse: R
              }, m;
            }
            f.__dashjs_factory_name = "DRMToday";
            const p = dashjs.FactoryMaker.getSingletonFactory(f);
          }
        ),
        /***/
        "./src/streaming/protection/servers/PlayReady.js": (
          /*!*******************************************************!*\
            !*** ./src/streaming/protection/servers/PlayReady.js ***!
            \*******************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            var h = i(
              /*! ../../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function f() {
              var d, v = "http://schemas.xmlsoap.org/soap/envelope/";
              function g(y) {
                var E = String.fromCharCode.apply(null, new Uint8Array(y)), L = decodeURIComponent(escape(E));
                return L;
              }
              function m(y) {
                if (window.DOMParser) {
                  var E = g(y), L = new window.DOMParser(), _ = L.parseFromString(E, "text/xml"), O = _ ? _.getElementsByTagNameNS(v, "Envelope")[0] : null, D = O ? O.getElementsByTagNameNS(v, "Body")[0] : null, M = D ? D.getElementsByTagNameNS(v, "Fault")[0] : null;
                  if (M)
                    return null;
                }
                return y;
              }
              function A(y) {
                var E = "", L = "", _ = "", O = -1, D = -1;
                if (window.DOMParser) {
                  var M = g(y), C = new window.DOMParser(), I = C.parseFromString(M, "text/xml"), w = I ? I.getElementsByTagNameNS(v, "Envelope")[0] : null, F = w ? w.getElementsByTagNameNS(v, "Body")[0] : null, k = F ? F.getElementsByTagNameNS(v, "Fault")[0] : null, H = k ? k.getElementsByTagName("detail")[0] : null, Z = H ? H.getElementsByTagName("Exception")[0] : null, Y = null;
                  if (k === null)
                    return M;
                  Y = k.getElementsByTagName("faultstring")[0].firstChild, E = Y ? Y.nodeValue : null, Z !== null && (Y = Z.getElementsByTagName("StatusCode")[0], L = Y ? Y.firstChild.nodeValue : null, Y = Z.getElementsByTagName("Message")[0], _ = Y ? Y.firstChild.nodeValue : null, O = _ ? _.lastIndexOf("[") + 1 : -1, D = _ ? _.indexOf("]") : -1, _ = _ ? _.substring(O, D) : "");
                }
                var j = "code: ".concat(L, ", name: ").concat(E);
                return _ && (j += ", message: ".concat(_)), j;
              }
              function b(y) {
                return y;
              }
              function S() {
                return "POST";
              }
              function N() {
                return "arraybuffer";
              }
              function T(y) {
                return m.call(this, y);
              }
              function R(y) {
                return A.call(this, y);
              }
              return d = {
                getServerURLFromMessage: b,
                getHTTPMethod: S,
                getResponseType: N,
                getLicenseMessage: T,
                getErrorResponse: R
              }, d;
            }
            f.__dashjs_factory_name = "PlayReady";
            const p = h.default.getSingletonFactory(f);
          }
        ),
        /***/
        "./src/streaming/protection/servers/Widevine.js": (
          /*!******************************************************!*\
            !*** ./src/streaming/protection/servers/Widevine.js ***!
            \******************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => f
              /* harmony export */
            });
            function h() {
              var p;
              function d(b) {
                return b;
              }
              function v() {
                return "POST";
              }
              function g() {
                return "arraybuffer";
              }
              function m(b) {
                return b;
              }
              function A(b) {
                return String.fromCharCode.apply(null, new Uint8Array(b));
              }
              return p = {
                getServerURLFromMessage: d,
                getHTTPMethod: v,
                getResponseType: g,
                getLicenseMessage: m,
                getErrorResponse: A
              }, p;
            }
            h.__dashjs_factory_name = "Widevine";
            const f = dashjs.FactoryMaker.getSingletonFactory(h);
          }
        ),
        /***/
        "./src/streaming/protection/vo/ClearKeyKeySet.js": (
          /*!*******************************************************!*\
            !*** ./src/streaming/protection/vo/ClearKeyKeySet.js ***!
            \*******************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            function h(g, m) {
              if (!(g instanceof m))
                throw new TypeError("Cannot call a class as a function");
            }
            function f(g, m) {
              for (var A = 0; A < m.length; A++) {
                var b = m[A];
                b.enumerable = b.enumerable || !1, b.configurable = !0, "value" in b && (b.writable = !0), Object.defineProperty(g, b.key, b);
              }
            }
            function p(g, m, A) {
              return m && f(g.prototype, m), A && f(g, A), g;
            }
            var d = /* @__PURE__ */ function() {
              function g(m, A) {
                if (h(this, g), A && A !== "persistent" && A !== "temporary")
                  throw new Error("Invalid ClearKey key set type!  Must be one of 'persistent' or 'temporary'");
                this.keyPairs = m, this.type = A;
              }
              return p(g, [{
                key: "toJWK",
                value: function() {
                  var A, b = this.keyPairs.length, S = {
                    keys: []
                  };
                  for (A = 0; A < b; A++) {
                    var N = {
                      kty: "oct",
                      alg: "A128KW",
                      kid: this.keyPairs[A].keyID,
                      k: this.keyPairs[A].key
                    };
                    S.keys.push(N);
                  }
                  this.type && (S.type = this.type);
                  var T = JSON.stringify(S), R = T.length, y = new ArrayBuffer(R), E = new Uint8Array(y);
                  for (A = 0; A < R; A++)
                    E[A] = T.charCodeAt(A);
                  return y;
                }
              }]), g;
            }();
            const v = d;
          }
        ),
        /***/
        "./src/streaming/protection/vo/KeyMessage.js": (
          /*!***************************************************!*\
            !*** ./src/streaming/protection/vo/KeyMessage.js ***!
            \***************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = (
              /**
               * @param {SessionToken} sessionToken the session
               * to which the key message is associated
               * @param {ArrayBuffer} message the key message
               * @param {string} defaultURL license acquisition URL provided by the CDM
               * @param {string} messageType Supported message types can be found
               * {@link https://w3c.github.io/encrypted-media/#idl-def-MediaKeyMessageType|here}.
               * @class
               */
              function d(v, g, m, A) {
                h(this, d), this.sessionToken = v, this.message = g, this.defaultURL = m, this.messageType = A || "license-request";
              }
            );
            const p = f;
          }
        ),
        /***/
        "./src/streaming/protection/vo/KeyPair.js": (
          /*!************************************************!*\
            !*** ./src/streaming/protection/vo/KeyPair.js ***!
            \************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = (
              /**
               * @param {string} keyID 128-bit key ID, base64 encoded, with no padding
               * @param {string} key 128-bit encryption key, base64 encoded, with no padding
               * @class
               * @ignore
               */
              function d(v, g) {
                h(this, d), this.keyID = v, this.key = g;
              }
            );
            const p = f;
          }
        ),
        /***/
        "./src/streaming/protection/vo/KeySystemAccess.js": (
          /*!********************************************************!*\
            !*** ./src/streaming/protection/vo/KeySystemAccess.js ***!
            \********************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = (
              /**
               * @param {MediaPlayer.dependencies.protection.KeySystem} keySystem the key system
               * @param {KeySystemConfiguration} ksConfiguration the
               * subset of configurations passed to the key system access request that are supported
               * by this user agent
               * @class
               * @ignore
               */
              function d(v, g) {
                h(this, d), this.keySystem = v, this.ksConfiguration = g;
              }
            );
            const p = f;
          }
        ),
        /***/
        "./src/streaming/protection/vo/KeySystemConfiguration.js": (
          /*!***************************************************************!*\
            !*** ./src/streaming/protection/vo/KeySystemConfiguration.js ***!
            \***************************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = (
              /**
               * @param {Array.<MediaCapability>} audioCapabilities array of
               * desired audio capabilities.  Higher preference capabilities should be placed earlier
               * in the array.
               * @param {Array.<MediaCapability>} videoCapabilities array of
               * desired video capabilities.  Higher preference capabilities should be placed earlier
               * in the array.
               * @param {string} distinctiveIdentifier desired use of distinctive identifiers.
               * One of "required", "optional", or "not-allowed"
               * @param {string} persistentState desired support for persistent storage of
               * key systems.  One of "required", "optional", or "not-allowed"
               * @param {Array.<string>} sessionTypes List of session types that must
               * be supported by the key system
               * @class
               */
              function d(v, g, m, A, b) {
                h(this, d), this.initDataTypes = ["cenc"], v && v.length && (this.audioCapabilities = v), g && g.length && (this.videoCapabilities = g), this.distinctiveIdentifier = m, this.persistentState = A, this.sessionTypes = b;
              }
            );
            const p = f;
          }
        ),
        /***/
        "./src/streaming/protection/vo/LicenseRequest.js": (
          /*!*******************************************************!*\
            !*** ./src/streaming/protection/vo/LicenseRequest.js ***!
            \*******************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = (
              /**
               * Defines a license request
               *
               * @class
               */
              function d(v, g, m, A, b, S, N, T) {
                h(this, d), this.url = v, this.method = g, this.responseType = m, this.headers = A, this.withCredentials = b, this.messageType = S, this.sessionId = N, this.data = T;
              }
            );
            const p = f;
          }
        ),
        /***/
        "./src/streaming/protection/vo/LicenseResponse.js": (
          /*!********************************************************!*\
            !*** ./src/streaming/protection/vo/LicenseResponse.js ***!
            \********************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = (
              /**
               * Defines a license request
               *
               * @class
               * @ignore
               */
              function d(v, g, m) {
                h(this, d), this.url = v, this.headers = g, this.data = m;
              }
            );
            const p = f;
          }
        ),
        /***/
        "./src/streaming/protection/vo/MediaCapability.js": (
          /*!********************************************************!*\
            !*** ./src/streaming/protection/vo/MediaCapability.js ***!
            \********************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = (
              /**
               * @param {string} contentType MIME type and codecs (RFC6386)
               * @param {string} robustness
               * @class
               * @ignore
               */
              function d(v, g) {
                h(this, d), this.contentType = v, this.robustness = g;
              }
            );
            const p = f;
          }
        ),
        /***/
        "./src/streaming/protection/vo/NeedKey.js": (
          /*!************************************************!*\
            !*** ./src/streaming/protection/vo/NeedKey.js ***!
            \************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = (
              /**
               * @param {ArrayBuffer} initData the initialization data
               * @param {string} initDataType initialization data type
               * @class
               */
              function d(v, g) {
                h(this, d), this.initData = v, this.initDataType = g;
              }
            );
            const p = f;
          }
        ),
        /***/
        "./src/streaming/rules/DroppedFramesHistory.js": (
          /*!*****************************************************!*\
            !*** ./src/streaming/rules/DroppedFramesHistory.js ***!
            \*****************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => d
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function f() {
              var v = {}, g = {}, m = {};
              function A(T, R, y) {
                if (R) {
                  v[T] || (v[T] = [], g[T] = 0, m[T] = 0);
                  var E = y && y.droppedVideoFrames ? y.droppedVideoFrames : 0, L = y && y.totalVideoFrames ? y.totalVideoFrames : 0, _ = E - g[T];
                  g[T] = E;
                  var O = L - m[T];
                  m[T] = L;
                  var D = v[T];
                  isNaN(R) || (D[R] ? (D[R].droppedVideoFrames += _, D[R].totalVideoFrames += O) : D[R] = {
                    droppedVideoFrames: _,
                    totalVideoFrames: O
                  });
                }
              }
              function b(T) {
                return v[T];
              }
              function S(T) {
                try {
                  delete v[T], delete g[T], delete m[T];
                } catch {
                }
              }
              function N() {
                v = {}, g = {}, m = {};
              }
              return {
                push: A,
                getFrameHistory: b,
                clearForStream: S,
                reset: N
              };
            }
            f.__dashjs_factory_name = "DroppedFramesHistory";
            var p = h.default.getClassFactory(f);
            const d = p;
          }
        ),
        /***/
        "./src/streaming/rules/RulesContext.js": (
          /*!*********************************************!*\
            !*** ./src/streaming/rules/RulesContext.js ***!
            \*********************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function f(d) {
              d = d || {};
              var v, g = d.abrController, m = d.switchHistory, A = d.droppedFramesHistory, b = d.currentRequest, S = d.useBufferOccupancyABR, N = d.useL2AABR, T = d.useLoLPABR, R = d.streamProcessor ? d.streamProcessor.getScheduleController() : null, y = d.streamProcessor ? d.streamProcessor.getRepresentationInfo() : null, E = d.videoModel ? d.videoModel : null;
              function L() {
                var j = O();
                return j ? j.type : null;
              }
              function _() {
                var j = O();
                return j ? j.streamInfo : null;
              }
              function O() {
                return y ? y.mediaInfo : null;
              }
              function D() {
                return y;
              }
              function M() {
                return R;
              }
              function C() {
                return g;
              }
              function I() {
                return m;
              }
              function w() {
                return E;
              }
              function F() {
                return A;
              }
              function k() {
                return b;
              }
              function H() {
                return S;
              }
              function Z() {
                return N;
              }
              function Y() {
                return T;
              }
              return v = {
                getMediaType: L,
                getMediaInfo: O,
                getDroppedFramesHistory: F,
                getCurrentRequest: k,
                getSwitchHistory: I,
                getStreamInfo: _,
                getScheduleController: M,
                getAbrController: C,
                getRepresentationInfo: D,
                useBufferOccupancyABR: H,
                useL2AABR: Z,
                useLoLPABR: Y,
                getVideoModel: w
              }, v;
            }
            f.__dashjs_factory_name = "RulesContext";
            const p = h.default.getClassFactory(f);
          }
        ),
        /***/
        "./src/streaming/rules/SwitchRequest.js": (
          /*!**********************************************!*\
            !*** ./src/streaming/rules/SwitchRequest.js ***!
            \**********************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => g
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = -1, p = {
              DEFAULT: 0.5,
              STRONG: 1,
              WEAK: 0
            };
            function d(m, A, b) {
              var S, N, T, R;
              function y(E) {
                var L = p.DEFAULT;
                return (E === p.DEFAULT || E === p.STRONG || E === p.WEAK) && (L = E), L;
              }
              return N = m === void 0 ? f : m, T = y(b), R = A === void 0 ? null : A, S = {
                quality: N,
                reason: R,
                priority: T
              }, S;
            }
            d.__dashjs_factory_name = "SwitchRequest";
            var v = h.default.getClassFactory(d);
            v.NO_CHANGE = f, v.PRIORITY = p, h.default.updateClassFactory(d.__dashjs_factory_name, v);
            const g = v;
          }
        ),
        /***/
        "./src/streaming/rules/SwitchRequestHistory.js": (
          /*!*****************************************************!*\
            !*** ./src/streaming/rules/SwitchRequestHistory.js ***!
            \*****************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => g
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ./SwitchRequest */
              "./src/streaming/rules/SwitchRequest.js"
            ), p = 8;
            function d() {
              var m = [], A = [];
              function b(T) {
                T.newValue === f.default.NO_CHANGE && (T.newValue = T.oldValue), m[T.oldValue] || (m[T.oldValue] = {
                  noDrops: 0,
                  drops: 0,
                  dropSize: 0
                });
                var R = T.newValue - T.oldValue, y = R < 0 ? 1 : 0, E = y ? -R : 0, L = y ? 0 : 1;
                if (m[T.oldValue].drops += y, m[T.oldValue].dropSize += E, m[T.oldValue].noDrops += L, A.push({
                  idx: T.oldValue,
                  noDrop: L,
                  drop: y,
                  dropSize: E
                }), A.length > p) {
                  var _ = A.shift();
                  m[_.idx].drops -= _.drop, m[_.idx].dropSize -= _.dropSize, m[_.idx].noDrops -= _.noDrop;
                }
              }
              function S() {
                return m;
              }
              function N() {
                m = [], A = [];
              }
              return {
                push: b,
                getSwitchRequests: S,
                reset: N
              };
            }
            d.__dashjs_factory_name = "SwitchRequestHistory";
            var v = h.default.getClassFactory(d);
            const g = v;
          }
        ),
        /***/
        "./src/streaming/rules/ThroughputHistory.js": (
          /*!**************************************************!*\
            !*** ./src/streaming/rules/ThroughputHistory.js ***!
            \**************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => d
              /* harmony export */
            });
            var h = i(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), f = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function p(v) {
              v = v || {};
              var g = 20, m = 3, A = 4, b = 4, S = 1.3, N = 1.3, T = 8, R = 3, y = 2, E = 1, L = v.settings, _, O, D, M, C;
              function I() {
                C = {
                  throughputHalfLife: {
                    fast: R,
                    slow: T
                  },
                  latencyHalfLife: {
                    fast: E,
                    slow: y
                  }
                }, re();
              }
              function w(z, oe, de) {
                if (z === h.default.VIDEO)
                  return de < L.get().streaming.cacheLoadThresholds[h.default.VIDEO];
                if (z === h.default.AUDIO)
                  return de < L.get().streaming.cacheLoadThresholds[h.default.AUDIO];
              }
              function F(z, oe, de) {
                if (!(!oe.trace || !oe.trace.length)) {
                  var pe = oe.tresponse.getTime() - oe.trequest.getTime() || 1, he = oe._tfinish.getTime() - oe.tresponse.getTime() || 1, se = oe.trace.reduce(function(x, P) {
                    return x + P.b[0];
                  }, 0), ee = 0, te = 0;
                  if (oe._fileLoaderType && oe._fileLoaderType === h.default.FILE_LOADER_TYPES.FETCH ? ee = oe.trace.reduce(function(x, P) {
                    return x + P.d;
                  }, 0) : ee = de ? he : pe + he, ee !== 0 && (te = Math.round(8 * se / ee)), oe.cmsd) {
                    var le = oe.cmsd.dynamic && oe.cmsd.dynamic.etp ? oe.cmsd.dynamic.etp : null;
                    if (le) {
                      var ne = L.get().streaming.cmsd.abr.etpWeightRatio;
                      ne > 0 && ne <= 1 && (te = te * (1 - ne) + le * ne);
                    }
                  }
                  if ($(z), w(z, pe, he)) {
                    if (_[z].length > 0 && !_[z].hasCachedEntries)
                      return;
                    _[z].hasCachedEntries = !0;
                  } else
                    _[z] && _[z].hasCachedEntries && ie(z);
                  _[z].push(te), _[z].length > g && _[z].shift(), O[z].push(pe), O[z].length > g && O[z].shift(), k(D[z], te, 1e-3 * he, C.throughputHalfLife), k(M[z], pe, 1, C.latencyHalfLife);
                }
              }
              function k(z, oe, de, pe) {
                var he = Math.pow(0.5, de / pe.fast);
                z.fastEstimate = (1 - he) * oe + he * z.fastEstimate;
                var se = Math.pow(0.5, de / pe.slow);
                z.slowEstimate = (1 - se) * oe + se * z.slowEstimate, z.totalWeight += de;
              }
              function H(z, oe, de) {
                var pe, he;
                if (z ? (pe = _[oe], he = de ? m : A) : (pe = O[oe], he = b), !pe)
                  he = 0;
                else if (he >= pe.length)
                  he = pe.length;
                else if (z)
                  for (var se = 1; se < he; ++se) {
                    var ee = pe[pe.length - se] / pe[pe.length - se - 1];
                    if ((ee >= N || ee <= 1 / S) && (he += 1, he === pe.length))
                      break;
                  }
                return he;
              }
              function Z(z, oe, de) {
                return L.get().streaming.abr.movingAverageMethod !== h.default.MOVING_AVERAGE_SLIDING_WINDOW ? j(z, oe) : Y(z, oe, de);
              }
              function Y(z, oe, de) {
                var pe = H(z, oe, de), he = z ? _ : O, se = he[oe];
                return pe === 0 || !se || se.length === 0 ? NaN : (se = se.slice(-pe), se.reduce(function(ee, te) {
                  return ee + te;
                }) / se.length);
              }
              function j(z, oe) {
                var de = z ? C.throughputHalfLife : C.latencyHalfLife, pe = z ? D[oe] : M[oe];
                if (!pe || pe.totalWeight <= 0)
                  return NaN;
                var he = pe.fastEstimate / (1 - Math.pow(0.5, pe.totalWeight / de.fast)), se = pe.slowEstimate / (1 - Math.pow(0.5, pe.totalWeight / de.slow));
                return z ? Math.min(he, se) : Math.max(he, se);
              }
              function J(z, oe) {
                return Z(!0, z, oe);
              }
              function ae(z, oe) {
                var de = J(z, oe);
                return isNaN(de) || (de *= L.get().streaming.abr.bandwidthSafetyFactor), de;
              }
              function G(z) {
                return Z(!1, z);
              }
              function $(z) {
                _[z] = _[z] || [], O[z] = O[z] || [], D[z] = D[z] || {
                  fastEstimate: 0,
                  slowEstimate: 0,
                  totalWeight: 0
                }, M[z] = M[z] || {
                  fastEstimate: 0,
                  slowEstimate: 0,
                  totalWeight: 0
                };
              }
              function ie(z) {
                delete _[z], delete O[z], delete D[z], delete M[z], $(z);
              }
              function re() {
                _ = {}, O = {}, D = {}, M = {};
              }
              var ce = {
                push: F,
                getAverageThroughput: J,
                getSafeAverageThroughput: ae,
                getAverageLatency: G,
                reset: re
              };
              return I(), ce;
            }
            p.__dashjs_factory_name = "ThroughputHistory";
            const d = f.default.getClassFactory(p);
          }
        ),
        /***/
        "./src/streaming/rules/abr/ABRRulesCollection.js": (
          /*!*******************************************************!*\
            !*** ./src/streaming/rules/abr/ABRRulesCollection.js ***!
            \*******************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => L
              /* harmony export */
            });
            var h = i(
              /*! ./ThroughputRule */
              "./src/streaming/rules/abr/ThroughputRule.js"
            ), f = i(
              /*! ./InsufficientBufferRule */
              "./src/streaming/rules/abr/InsufficientBufferRule.js"
            ), p = i(
              /*! ./AbandonRequestsRule */
              "./src/streaming/rules/abr/AbandonRequestsRule.js"
            ), d = i(
              /*! ./DroppedFramesRule */
              "./src/streaming/rules/abr/DroppedFramesRule.js"
            ), v = i(
              /*! ./SwitchHistoryRule */
              "./src/streaming/rules/abr/SwitchHistoryRule.js"
            ), g = i(
              /*! ./BolaRule */
              "./src/streaming/rules/abr/BolaRule.js"
            ), m = i(
              /*! ./L2ARule.js */
              "./src/streaming/rules/abr/L2ARule.js"
            ), A = i(
              /*! ./lolp/LoLpRule.js */
              "./src/streaming/rules/abr/lolp/LoLpRule.js"
            ), b = i(
              /*! ../../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), S = i(
              /*! ../SwitchRequest */
              "./src/streaming/rules/SwitchRequest.js"
            ), N = i(
              /*! ../../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), T = "qualitySwitchRules", R = "abandonFragmentRules";
            function y(_) {
              _ = _ || {};
              var O = this.context, D = _.mediaPlayerModel, M = _.customParametersModel, C = _.dashMetrics, I = _.settings, w, F, k;
              function H() {
                F = [], k = [], I.get().streaming.abr.useDefaultABRRules && (I.get().streaming.abr.ABRStrategy === N.default.ABR_STRATEGY_L2A ? F.push((0, m.default)(O).create({
                  dashMetrics: C,
                  settings: I
                })) : I.get().streaming.abr.ABRStrategy === N.default.ABR_STRATEGY_LoLP ? F.push((0, A.default)(O).create({
                  dashMetrics: C
                })) : (F.push((0, g.default)(O).create({
                  dashMetrics: C,
                  mediaPlayerModel: D,
                  settings: I
                })), F.push((0, h.default)(O).create({
                  dashMetrics: C
                })), I.get().streaming.abr.additionalAbrRules.insufficientBufferRule && F.push((0, f.default)(O).create({
                  dashMetrics: C,
                  settings: I
                })), I.get().streaming.abr.additionalAbrRules.switchHistoryRule && F.push((0, v.default)(O).create()), I.get().streaming.abr.additionalAbrRules.droppedFramesRule && F.push((0, d.default)(O).create()), I.get().streaming.abr.additionalAbrRules.abandonRequestsRule && k.push((0, p.default)(O).create({
                  dashMetrics: C,
                  mediaPlayerModel: D,
                  settings: I
                }))));
                var $ = M.getAbrCustomRules();
                $.forEach(function(ie) {
                  ie.type === T && F.push(ie.rule(O).create()), ie.type === R && k.push(ie.rule(O).create());
                });
              }
              function Z($) {
                return $.filter(function(ie) {
                  return ie.quality > S.default.NO_CHANGE;
                });
              }
              function Y($) {
                var ie = {}, re = null, ce, z, oe, de, pe;
                if ($.length !== 0) {
                  for (ie[S.default.PRIORITY.STRONG] = {
                    quality: S.default.NO_CHANGE,
                    reason: null
                  }, ie[S.default.PRIORITY.WEAK] = {
                    quality: S.default.NO_CHANGE,
                    reason: null
                  }, ie[S.default.PRIORITY.DEFAULT] = {
                    quality: S.default.NO_CHANGE,
                    reason: null
                  }, ce = 0, z = $.length; ce < z; ce += 1)
                    oe = $[ce], oe.quality !== S.default.NO_CHANGE && (ie[oe.priority].quality === S.default.NO_CHANGE || ie[oe.priority].quality > oe.quality) && (ie[oe.priority].quality = oe.quality, ie[oe.priority].reason = oe.reason || null);
                  return ie[S.default.PRIORITY.WEAK].quality !== S.default.NO_CHANGE && (re = ie[S.default.PRIORITY.WEAK]), ie[S.default.PRIORITY.DEFAULT].quality !== S.default.NO_CHANGE && (re = ie[S.default.PRIORITY.DEFAULT]), ie[S.default.PRIORITY.STRONG].quality !== S.default.NO_CHANGE && (re = ie[S.default.PRIORITY.STRONG]), re && (de = re.quality, pe = re.reason), (0, S.default)(O).create(de, pe);
                }
              }
              function j($) {
                var ie = F.map(function(z) {
                  return z.getMaxIndex($);
                }), re = Z(ie), ce = Y(re);
                return ce || (0, S.default)(O).create();
              }
              function J($, ie) {
                var re = k.map(function(oe) {
                  return oe.shouldAbandon($, ie);
                }), ce = Z(re), z = Y(ce);
                return z || (0, S.default)(O).create();
              }
              function ae() {
                [F, k].forEach(function($) {
                  $ && $.length && $.forEach(function(ie) {
                    return ie.reset && ie.reset();
                  });
                }), F = [], k = [];
              }
              function G() {
                return F;
              }
              return w = {
                initialize: H,
                reset: ae,
                getMaxQuality: j,
                getMinSwitchRequest: Y,
                shouldAbandonFragment: J,
                getQualitySwitchRules: G
              }, w;
            }
            y.__dashjs_factory_name = "ABRRulesCollection";
            var E = b.default.getClassFactory(y);
            E.QUALITY_SWITCH_RULES = T, E.ABANDON_FRAGMENT_RULES = R, b.default.updateSingletonFactory(y.__dashjs_factory_name, E);
            const L = E;
          }
        ),
        /***/
        "./src/streaming/rules/abr/AbandonRequestsRule.js": (
          /*!********************************************************!*\
            !*** ./src/streaming/rules/abr/AbandonRequestsRule.js ***!
            \********************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var h = i(
              /*! ../SwitchRequest */
              "./src/streaming/rules/SwitchRequest.js"
            ), f = i(
              /*! ../../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), p = i(
              /*! ../../../core/Debug */
              "./src/core/Debug.js"
            );
            function d(g) {
              g = g || {};
              var m = 1.8, A = 500, b = 5, S = this.context, N = g.mediaPlayerModel, T = g.dashMetrics, R = g.settings, y, E, L, _, O;
              function D() {
                E = (0, p.default)(S).getInstance().getLogger(y), w();
              }
              function M(F, k) {
                L[F] = L[F] || {}, L[F][k] = L[F][k] || {};
              }
              function C(F, k) {
                O[F] = O[F] || [], O[F].push(k);
              }
              function I(F) {
                var k = (0, h.default)(S).create(h.default.NO_CHANGE, {
                  name: d.__dashjs_factory_name
                });
                if (!F || !F.hasOwnProperty("getMediaInfo") || !F.hasOwnProperty("getMediaType") || !F.hasOwnProperty("getCurrentRequest") || !F.hasOwnProperty("getRepresentationInfo") || !F.hasOwnProperty("getAbrController"))
                  return k;
                var H = F.getMediaInfo(), Z = F.getMediaType(), Y = F.getStreamInfo(), j = Y ? Y.id : null, J = F.getCurrentRequest();
                if (!isNaN(J.index)) {
                  M(Z, J.index);
                  var ae = N.getStableBufferTime(), G = T.getCurrentBufferLevel(Z);
                  if (G > ae)
                    return k;
                  var $ = L[Z][J.index];
                  if ($ === null || J.firstByteDate === null || _.hasOwnProperty($.id))
                    return k;
                  if ($.firstByteTime === void 0 && (O[Z] = [], $.firstByteTime = J.firstByteDate.getTime(), $.segmentDuration = J.duration, $.bytesTotal = J.bytesTotal, $.id = J.index), $.bytesLoaded = J.bytesLoaded, $.elapsedTime = (/* @__PURE__ */ new Date()).getTime() - $.firstByteTime, $.bytesLoaded > 0 && $.elapsedTime > 0 && C(Z, Math.round($.bytesLoaded * 8 / $.elapsedTime)), O[Z].length >= b && $.elapsedTime > A && $.bytesLoaded < $.bytesTotal) {
                    var ie = O[Z].reduce(function(se, ee) {
                      return se + ee;
                    }, 0);
                    if ($.measuredBandwidthInKbps = Math.round(ie / O[Z].length), $.estimatedTimeOfDownload = +($.bytesTotal * 8 / $.measuredBandwidthInKbps / 1e3).toFixed(2), $.estimatedTimeOfDownload < $.segmentDuration * m || F.getRepresentationInfo().quality === 0)
                      return k;
                    if (!_.hasOwnProperty($.id)) {
                      var re = F.getAbrController(), ce = $.bytesTotal - $.bytesLoaded, z = re.getBitrateList(H), oe = re.getQualityForBitrate(H, $.measuredBandwidthInKbps * R.get().streaming.abr.bandwidthSafetyFactor, j), de = re.getMinAllowedIndexFor(Z, j), pe = de !== void 0 ? Math.max(de, oe) : oe, he = $.bytesTotal * z[pe].bitrate / z[re.getQualityFor(Z, j)].bitrate;
                      ce > he && (k.quality = pe, k.reason.throughput = $.measuredBandwidthInKbps, k.reason.fragmentID = $.id, _[$.id] = $, E.debug("[" + Z + "] frag id", $.id, " is asking to abandon and switch to quality to ", pe, " measured bandwidth was", $.measuredBandwidthInKbps), delete L[Z][$.id]);
                    }
                  } else
                    $.bytesLoaded === $.bytesTotal && delete L[Z][$.id];
                }
                return k;
              }
              function w() {
                L = {}, _ = {}, O = [];
              }
              return y = {
                shouldAbandon: I,
                reset: w
              }, D(), y;
            }
            d.__dashjs_factory_name = "AbandonRequestsRule";
            const v = f.default.getClassFactory(d);
          }
        ),
        /***/
        "./src/streaming/rules/abr/BolaRule.js": (
          /*!*********************************************!*\
            !*** ./src/streaming/rules/abr/BolaRule.js ***!
            \*********************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => _
              /* harmony export */
            });
            var h = i(
              /*! ../../constants/MetricsConstants */
              "./src/streaming/constants/MetricsConstants.js"
            ), f = i(
              /*! ../SwitchRequest */
              "./src/streaming/rules/SwitchRequest.js"
            ), p = i(
              /*! ../../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), d = i(
              /*! ../../vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            ), v = i(
              /*! ../../../core/EventBus */
              "./src/core/EventBus.js"
            ), g = i(
              /*! ../../../core/events/Events */
              "./src/core/events/Events.js"
            ), m = i(
              /*! ../../../core/Debug */
              "./src/core/Debug.js"
            ), A = i(
              /*! ../../MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), b = i(
              /*! ../../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), S = 0, N = 1, T = 2, R = 10, y = 2, E = 0.99;
            function L(O) {
              O = O || {};
              var D = this.context, M = O.dashMetrics, C = O.mediaPlayerModel, I = (0, v.default)(D).getInstance(), w, F, k;
              function H() {
                F = (0, m.default)(D).getInstance().getLogger(w), le(), I.on(A.default.BUFFER_EMPTY, z, w), I.on(A.default.PLAYBACK_SEEKING, oe, w), I.on(A.default.METRIC_ADDED, pe, w), I.on(A.default.QUALITY_CHANGE_REQUESTED, se, w), I.on(A.default.FRAGMENT_LOADING_ABANDONED, ee, w), I.on(g.default.MEDIA_FRAGMENT_LOADED, de, w);
              }
              function Z(x) {
                return x.map(function(P) {
                  return Math.log(P);
                });
              }
              function Y(x, P, B) {
                var W = B.reduce(function(V, Q, fe) {
                  return Q > B[V] ? fe : V;
                }, 0);
                if (W === 0)
                  return null;
                var X = Math.max(x, R + y * P.length), K = (B[W] - 1) / (X / R - 1), U = R / K;
                return {
                  gp: K,
                  Vp: U
                };
              }
              function j(x) {
                var P = {}, B = x.getMediaInfo(), W = B.bitrateList.map(function(V) {
                  return V.bandwidth;
                }), X = Z(W);
                X = X.map(function(V) {
                  return V - X[0] + 1;
                });
                var K = C.getStableBufferTime(), U = Y(K, W, X);
                return U ? (P.state = N, P.bitrates = W, P.utilities = X, P.stableBufferTime = K, P.Vp = U.Vp, P.gp = U.gp, P.lastQuality = 0, J(P)) : P.state = S, P;
              }
              function J(x) {
                x.placeholderBuffer = 0, x.mostAdvancedSegmentStart = NaN, x.lastSegmentWasReplacement = !1, x.lastSegmentStart = NaN, x.lastSegmentDurationS = NaN, x.lastSegmentRequestTimeMs = NaN, x.lastSegmentFinishTimeMs = NaN;
              }
              function ae(x, P) {
                var B = C.getStableBufferTime();
                if (x.stableBufferTime !== B) {
                  var W = Y(B, x.bitrates, x.utilities);
                  if (W.Vp !== x.Vp || W.gp !== x.gp) {
                    var X = M.getCurrentBufferLevel(P), K = X + x.placeholderBuffer;
                    K -= R, K *= W.Vp / x.Vp, K += R, x.stableBufferTime = B, x.Vp = W.Vp, x.gp = W.gp, x.placeholderBuffer = Math.max(0, K - X);
                  }
                }
              }
              function G(x) {
                var P = x.getMediaType(), B = k[P];
                return B ? B.state !== S && ae(B, P) : (B = j(x), k[P] = B), B;
              }
              function $(x, P) {
                for (var B = x.bitrates.length, W = NaN, X = NaN, K = 0; K < B; ++K) {
                  var U = (x.Vp * (x.utilities[K] + x.gp) - P) / x.bitrates[K];
                  (isNaN(X) || U >= X) && (X = U, W = K);
                }
                return W;
              }
              function ie(x, P) {
                return x.Vp * (x.utilities[P] + x.gp);
              }
              function re(x, P) {
                for (var B = x.bitrates[P], W = x.utilities[P], X = 0, K = P - 1; K >= 0; --K)
                  if (x.utilities[K] < x.utilities[P]) {
                    var U = x.bitrates[K], V = x.utilities[K], Q = x.Vp * (x.gp + (B * V - U * W) / (B - U));
                    X = Math.max(X, Q);
                  }
                return X;
              }
              function ce(x, P) {
                var B = Date.now();
                if (isNaN(x.lastSegmentFinishTimeMs)) {
                  if (!isNaN(x.lastCallTimeMs)) {
                    var X = 1e-3 * (B - x.lastCallTimeMs);
                    x.placeholderBuffer += Math.max(0, X);
                  }
                } else {
                  var W = 1e-3 * (B - x.lastSegmentFinishTimeMs);
                  x.placeholderBuffer += Math.max(0, W);
                }
                x.lastCallTimeMs = B, x.lastSegmentStart = NaN, x.lastSegmentRequestTimeMs = NaN, x.lastSegmentFinishTimeMs = NaN, ae(x, P);
              }
              function z(x) {
                var P = x.mediaType, B = P === b.default.AUDIO ? [b.default.AUDIO] : k;
                for (var W in B)
                  k.hasOwnProperty(W) && k[W].state === T && (k[W].placeholderBuffer = 0);
              }
              function oe() {
                for (var x in k)
                  if (k.hasOwnProperty(x)) {
                    var P = k[x];
                    P.state !== S && (P.state = N, J(P));
                  }
              }
              function de(x) {
                if (x && x.chunk && x.chunk.mediaInfo) {
                  var P = k[x.chunk.mediaInfo.type];
                  if (P && P.state !== S) {
                    var B = x.chunk.start;
                    isNaN(P.mostAdvancedSegmentStart) || B > P.mostAdvancedSegmentStart ? (P.mostAdvancedSegmentStart = B, P.lastSegmentWasReplacement = !1) : P.lastSegmentWasReplacement = !0, P.lastSegmentStart = B, P.lastSegmentDurationS = x.chunk.duration, P.lastQuality = x.chunk.quality, he(P, x.chunk.mediaInfo.type);
                  }
                }
              }
              function pe(x) {
                if (x && x.metric === h.default.HTTP_REQUEST && x.value && x.value.type === d.HTTPRequest.MEDIA_SEGMENT_TYPE && x.value.trace && x.value.trace.length) {
                  var P = k[x.mediaType];
                  P && P.state !== S && (P.lastSegmentRequestTimeMs = x.value.trequest.getTime(), P.lastSegmentFinishTimeMs = x.value._tfinish.getTime(), he(P, x.mediaType));
                }
              }
              function he(x, P) {
                if (!isNaN(x.lastSegmentStart) && !isNaN(x.lastSegmentRequestTimeMs) && !isNaN(x.placeholderBuffer)) {
                  if (x.placeholderBuffer *= E, !isNaN(x.lastSegmentFinishTimeMs)) {
                    var B = M.getCurrentBufferLevel(P), W = B + 1e-3 * (x.lastSegmentFinishTimeMs - x.lastSegmentRequestTimeMs), X = ie(x, x.lastQuality), K = Math.max(0, X - W);
                    x.placeholderBuffer = Math.min(K, x.placeholderBuffer);
                  }
                  x.lastSegmentWasReplacement && !isNaN(x.lastSegmentDurationS) && (x.placeholderBuffer += x.lastSegmentDurationS), x.lastSegmentStart = NaN, x.lastSegmentRequestTimeMs = NaN;
                }
              }
              function se(x) {
                if (x) {
                  var P = k[x.mediaType];
                  P && P.state !== S && (P.abrQuality = x.newQuality);
                }
              }
              function ee(x) {
                if (x) {
                  var P = k[x.mediaType];
                  if (P && P.state !== S) {
                    var B = M.getCurrentBufferLevel(x.mediaType), W;
                    P.abrQuality > 0 ? W = re(P, P.abrQuality) : W = R;
                    var X = Math.max(0, W - B);
                    P.placeholderBuffer = Math.min(P.placeholderBuffer, X);
                  }
                }
              }
              function te(x) {
                var P = (0, f.default)(D).create();
                if (!x || !x.hasOwnProperty("getMediaInfo") || !x.hasOwnProperty("getMediaType") || !x.hasOwnProperty("getScheduleController") || !x.hasOwnProperty("getStreamInfo") || !x.hasOwnProperty("getAbrController") || !x.hasOwnProperty("useBufferOccupancyABR"))
                  return P;
                var B = x.getMediaInfo(), W = x.getMediaType(), X = x.getScheduleController(), K = x.getStreamInfo(), U = x.getAbrController(), V = U.getThroughputHistory(), Q = K ? K.id : null, fe = K && K.manifestInfo && K.manifestInfo.isDynamic, ue = x.useBufferOccupancyABR();
                if (P.reason = P.reason || {}, !ue)
                  return P;
                X.setTimeToLoadDelay(0);
                var q = G(x);
                if (q.state === S)
                  return P;
                var _e = M.getCurrentBufferLevel(W), ge = V.getAverageThroughput(W, fe), Ce = V.getSafeAverageThroughput(W, fe), Ee = V.getAverageLatency(W), Re;
                if (P.reason.state = q.state, P.reason.throughput = ge, P.reason.latency = Ee, isNaN(ge))
                  return P;
                switch (q.state) {
                  case N:
                    Re = U.getQualityForBitrate(B, Ce, Q, Ee), P.quality = Re, P.reason.throughput = Ce, q.placeholderBuffer = Math.max(0, re(q, Re) - _e), q.lastQuality = Re, !isNaN(q.lastSegmentDurationS) && _e >= q.lastSegmentDurationS && (q.state = T);
                    break;
                  case T:
                    ce(q, W), Re = $(q, _e + q.placeholderBuffer);
                    var Pe = U.getQualityForBitrate(B, Ce, Q, Ee);
                    Re > q.lastQuality && Re > Pe && (Re = Math.max(Pe, q.lastQuality));
                    var ke = Math.max(0, _e + q.placeholderBuffer - ie(q, Re));
                    ke <= q.placeholderBuffer ? (q.placeholderBuffer -= ke, ke = 0) : (ke -= q.placeholderBuffer, q.placeholderBuffer = 0, Re < U.getMaxAllowedIndexFor(W, Q) ? X.setTimeToLoadDelay(1e3 * ke) : ke = 0), P.quality = Re, P.reason.throughput = ge, P.reason.latency = Ee, P.reason.bufferLevel = _e, P.reason.placeholderBuffer = q.placeholderBuffer, P.reason.delay = ke, q.lastQuality = Re;
                    break;
                  default:
                    F.debug("BOLA ABR rule invoked in bad state."), P.quality = U.getQualityForBitrate(B, Ce, Q, Ee), P.reason.state = q.state, P.reason.throughput = Ce, P.reason.latency = Ee, q.state = N, J(q);
                }
                return P;
              }
              function le() {
                k = {};
              }
              function ne() {
                le(), I.off(A.default.BUFFER_EMPTY, z, w), I.off(A.default.PLAYBACK_SEEKING, oe, w), I.off(A.default.METRIC_ADDED, pe, w), I.off(A.default.QUALITY_CHANGE_REQUESTED, se, w), I.off(A.default.FRAGMENT_LOADING_ABANDONED, ee, w), I.off(g.default.MEDIA_FRAGMENT_LOADED, de, w);
              }
              return w = {
                getMaxIndex: te,
                reset: ne
              }, H(), w;
            }
            L.__dashjs_factory_name = "BolaRule";
            const _ = p.default.getClassFactory(L);
          }
        ),
        /***/
        "./src/streaming/rules/abr/DroppedFramesRule.js": (
          /*!******************************************************!*\
            !*** ./src/streaming/rules/abr/DroppedFramesRule.js ***!
            \******************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var h = i(
              /*! ../../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ../SwitchRequest */
              "./src/streaming/rules/SwitchRequest.js"
            ), p = i(
              /*! ../../../core/Debug */
              "./src/core/Debug.js"
            );
            function d() {
              var g = this.context, m, A, b = 0.15, S = 375;
              function N() {
                A = (0, p.default)(g).getInstance().getLogger(m);
              }
              function T(R) {
                var y = (0, f.default)(g).create();
                if (!R || !R.hasOwnProperty("getDroppedFramesHistory"))
                  return y;
                var E = R.getDroppedFramesHistory(), L = R.getStreamInfo().id;
                if (E) {
                  var _ = E.getFrameHistory(L);
                  if (!_ || _.length === 0)
                    return y;
                  for (var O = 0, D = 0, M = f.default.NO_CHANGE, C = 1; C < _.length; C++)
                    if (_[C] && (O = _[C].droppedVideoFrames, D = _[C].totalVideoFrames, D > S && O / D > b)) {
                      M = C - 1, A.debug("index: " + M + " Dropped Frames: " + O + " Total Frames: " + D);
                      break;
                    }
                  return (0, f.default)(g).create(M, {
                    droppedFrames: O
                  });
                }
                return y;
              }
              return m = {
                getMaxIndex: T
              }, N(), m;
            }
            d.__dashjs_factory_name = "DroppedFramesRule";
            const v = h.default.getClassFactory(d);
          }
        ),
        /***/
        "./src/streaming/rules/abr/InsufficientBufferRule.js": (
          /*!***********************************************************!*\
            !*** ./src/streaming/rules/abr/InsufficientBufferRule.js ***!
            \***********************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => S
              /* harmony export */
            });
            var h = i(
              /*! ../../../core/EventBus */
              "./src/core/EventBus.js"
            ), f = i(
              /*! ../../../core/events/Events */
              "./src/core/events/Events.js"
            ), p = i(
              /*! ../../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), d = i(
              /*! ../../../core/Debug */
              "./src/core/Debug.js"
            ), v = i(
              /*! ../SwitchRequest */
              "./src/streaming/rules/SwitchRequest.js"
            ), g = i(
              /*! ../../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), m = i(
              /*! ../../constants/MetricsConstants */
              "./src/streaming/constants/MetricsConstants.js"
            ), A = i(
              /*! ../../MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            );
            function b(N) {
              N = N || {};
              var T = 0.5, R = 2, y = this.context, E = (0, h.default)(y).getInstance(), L = N.dashMetrics, _, O, D;
              function M() {
                O = (0, d.default)(y).getInstance().getLogger(_), F(), E.on(A.default.PLAYBACK_SEEKING, k, _), E.on(f.default.BYTES_APPENDED_END_FRAGMENT, H, _);
              }
              function C() {
                if (!L || !L.hasOwnProperty("getCurrentBufferLevel") || !L.hasOwnProperty("getCurrentBufferState"))
                  throw new Error(g.default.MISSING_CONFIG_ERROR);
              }
              function I(Y) {
                var j = (0, v.default)(y).create();
                if (!Y || !Y.hasOwnProperty("getMediaType"))
                  return j;
                C();
                var J = Y.getMediaType(), ae = L.getCurrentBufferState(J), G = Y.getRepresentationInfo(), $ = G.fragmentDuration, ie = Y.getStreamInfo(), re = ie ? ie.id : null, ce = Y.getScheduleController(), z = ie && ie.manifestInfo && ie.manifestInfo.isDynamic, oe = ce.getPlaybackController(), de = oe.getLowLatencyModeEnabled();
                if (w(de, J) || !$)
                  return j;
                if (ae && ae.state === m.default.BUFFER_EMPTY)
                  O.debug("[" + J + "] Switch to index 0; buffer is empty."), j.quality = 0, j.reason = "InsufficientBufferRule: Buffer is empty";
                else {
                  var pe = Y.getMediaInfo(), he = Y.getAbrController(), se = he.getThroughputHistory(), ee = L.getCurrentBufferLevel(J), te = se.getAverageThroughput(J, z), le = se.getAverageLatency(J), ne = te * (ee / $) * T;
                  j.quality = he.getQualityForBitrate(pe, ne, re, le), j.reason = "InsufficientBufferRule: being conservative to avoid immediate rebuffering";
                }
                return j;
              }
              function w(Y, j) {
                return !Y && D[j].ignoreCount > 0;
              }
              function F() {
                D = {}, D[g.default.VIDEO] = {
                  ignoreCount: R
                }, D[g.default.AUDIO] = {
                  ignoreCount: R
                };
              }
              function k() {
                F();
              }
              function H(Y) {
                !isNaN(Y.startTime) && (Y.mediaType === g.default.AUDIO || Y.mediaType === g.default.VIDEO) && D[Y.mediaType].ignoreCount > 0 && D[Y.mediaType].ignoreCount--;
              }
              function Z() {
                F(), E.off(A.default.PLAYBACK_SEEKING, k, _), E.off(f.default.BYTES_APPENDED_END_FRAGMENT, H, _);
              }
              return _ = {
                getMaxIndex: I,
                reset: Z
              }, M(), _;
            }
            b.__dashjs_factory_name = "InsufficientBufferRule";
            const S = p.default.getClassFactory(b);
          }
        ),
        /***/
        "./src/streaming/rules/abr/L2ARule.js": (
          /*!********************************************!*\
            !*** ./src/streaming/rules/abr/L2ARule.js ***!
            \********************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => R
              /* harmony export */
            });
            var h = i(
              /*! ../../constants/MetricsConstants */
              "./src/streaming/constants/MetricsConstants.js"
            ), f = i(
              /*! ../SwitchRequest */
              "./src/streaming/rules/SwitchRequest.js"
            ), p = i(
              /*! ../../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), d = i(
              /*! ../../vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            ), v = i(
              /*! ../../../core/EventBus */
              "./src/core/EventBus.js"
            ), g = i(
              /*! ../../../core/events/Events */
              "./src/core/events/Events.js"
            ), m = i(
              /*! ../../../core/Debug */
              "./src/core/Debug.js"
            ), A = i(
              /*! ../../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), b = 0, S = 1, N = 2;
            function T(y) {
              y = y || {};
              var E = this.context, L = y.dashMetrics, _ = (0, v.default)(E).getInstance(), O, D, M, C;
              function I() {
                C = (0, m.default)(E).getInstance().getLogger(O), re(), _.on(g.default.PLAYBACK_SEEKING, Z, O), _.on(g.default.MEDIA_FRAGMENT_LOADED, Y, O), _.on(g.default.METRIC_ADDED, j, O), _.on(g.default.QUALITY_CHANGE_REQUESTED, ae, O);
              }
              function w(z) {
                var oe = {}, de = z.getMediaInfo(), pe = de.bitrateList.map(function(he) {
                  return he.bandwidth / 1e3;
                });
                return oe.state = S, oe.bitrates = pe, oe.lastQuality = 0, F(de), k(oe), oe;
              }
              function F(z) {
                !z || !z.type || (M[z.type] = {}, M[z.type].w = [], M[z.type].prev_w = [], M[z.type].Q = 0, M[z.type].segment_request_start_s = 0, M[z.type].segment_download_finish_s = 0, M[z.type].B_target = 1.5);
              }
              function k(z) {
                z.placeholderBuffer = 0, z.mostAdvancedSegmentStart = NaN, z.lastSegmentWasReplacement = !1, z.lastSegmentStart = NaN, z.lastSegmentDurationS = NaN, z.lastSegmentRequestTimeMs = NaN, z.lastSegmentFinishTimeMs = NaN;
              }
              function H(z) {
                var oe = z.getMediaType(), de = D[oe];
                return de || (de = w(z), D[oe] = de), de;
              }
              function Z() {
                for (var z in D)
                  if (D.hasOwnProperty(z)) {
                    var oe = D[z];
                    oe.state !== b && (oe.state = S, k(oe));
                  }
              }
              function Y(z) {
                if (z && z.chunk && z.chunk.mediaInfo) {
                  var oe = D[z.chunk.mediaInfo.type], de = M[z.chunk.mediaInfo.type];
                  if (oe && oe.state !== b) {
                    var pe = z.chunk.start;
                    isNaN(oe.mostAdvancedSegmentStart) || pe > oe.mostAdvancedSegmentStart ? (oe.mostAdvancedSegmentStart = pe, oe.lastSegmentWasReplacement = !1) : oe.lastSegmentWasReplacement = !0, oe.lastSegmentStart = pe, oe.lastSegmentDurationS = z.chunk.duration, oe.lastQuality = z.chunk.quality, J(oe, de);
                  }
                }
              }
              function j(z) {
                if (z && z.metric === h.default.HTTP_REQUEST && z.value && z.value.type === d.HTTPRequest.MEDIA_SEGMENT_TYPE && z.value.trace && z.value.trace.length) {
                  var oe = D[z.mediaType], de = M[z.mediaType];
                  oe && oe.state !== b && (oe.lastSegmentRequestTimeMs = z.value.trequest.getTime(), oe.lastSegmentFinishTimeMs = z.value._tfinish.getTime(), J(oe, de));
                }
              }
              function J(z, oe) {
                !isNaN(z.lastSegmentStart) && !isNaN(z.lastSegmentRequestTimeMs) && (oe.segment_request_start_s = 1e-3 * z.lastSegmentRequestTimeMs, oe.segment_download_finish_s = 1e-3 * z.lastSegmentFinishTimeMs, z.lastSegmentStart = NaN, z.lastSegmentRequestTimeMs = NaN);
              }
              function ae(z) {
                if (z && z.mediaType) {
                  var oe = D[z.mediaType];
                  oe && oe.state !== b && (oe.abrQuality = z.newQuality);
                }
              }
              function G(z, oe) {
                if (z.length !== oe.length)
                  return -1;
                for (var de = 0, pe = 0; pe < z.length; pe++)
                  de = de + z[pe] * oe[pe];
                return de;
              }
              function $(z) {
                for (var oe = z.length, de = !1, pe = [], he = 0; he < oe; ++he)
                  pe[he] = z[he];
                for (var se = z.sort(function(P, B) {
                  return B - P;
                }), ee = 0, te = 0, le = [], ne = 0; ne < oe - 1; ++ne)
                  if (ee = ee + se[ne], te = (ee - 1) / (ne + 1), te >= se[ne + 1]) {
                    de = !0;
                    break;
                  }
                de || (te = (ee + se[oe - 1] - 1) / oe);
                for (var x = 0; x < oe; ++x)
                  le[x] = Math.max(pe[x] - te, 0);
                return le;
              }
              function ie(z) {
                var oe = (0, f.default)(E).create(), de = 4, pe = Math.pow(de, 0.99), he = Math.max(Math.pow(de, 1), pe * Math.sqrt(de)), se = z.getMediaInfo(), ee = z.getMediaType(), te = se.bitrateList.map(function(He) {
                  return He.bandwidth;
                }), le = te.length, ne = z.getScheduleController(), x = z.getStreamInfo(), P = z.getAbrController(), B = P.getThroughputHistory(), W = x && x.manifestInfo && x.manifestInfo.isDynamic, X = z.useL2AABR(), K = L.getCurrentBufferLevel(ee, !0), U = B.getSafeAverageThroughput(ee, W), V = B.getAverageThroughput(ee, W), Q = 2, fe = B.getAverageLatency(ee), ue = z.getVideoModel(), q, _e = ue.getPlaybackRate();
                if (!z || !z.hasOwnProperty("getMediaInfo") || !z.hasOwnProperty("getMediaType") || !z.hasOwnProperty("getScheduleController") || !z.hasOwnProperty("getStreamInfo") || !z.hasOwnProperty("getAbrController") || !z.hasOwnProperty("useL2AABR") || (oe.reason = oe.reason || {}, !X || ee === A.default.AUDIO))
                  return oe;
                ne.setTimeToLoadDelay(0);
                var ge = H(z);
                if (ge.state === b)
                  return oe;
                var Ce = M[ee];
                if (!Ce || (oe.reason.state = ge.state, oe.reason.throughput = V, oe.reason.latency = fe, isNaN(V)))
                  return oe;
                switch (ge.state) {
                  case S:
                    if (q = P.getQualityForBitrate(se, U, x.id, fe), oe.quality = q, oe.reason.throughput = U, ge.lastQuality = q, !isNaN(ge.lastSegmentDurationS) && K >= Ce.B_target) {
                      ge.state = N, Ce.Q = pe;
                      for (var Ee = 0; Ee < le; ++Ee)
                        Ee === ge.lastQuality ? Ce.prev_w[Ee] = 1 : Ce.prev_w[Ee] = 0;
                    }
                    break;
                  case N:
                    var Re = [], Pe = L.getCurrentHttpRequest(ee).trace.reduce(function(He, $e) {
                      return He + $e.d;
                    }, 0), ke = L.getCurrentHttpRequest(ee).trace.reduce(function(He, $e) {
                      return He + $e.b[0];
                    }, 0), De = Math.round(8 * ke / Pe);
                    De < 1 && (De = 1);
                    for (var Ae = ge.lastSegmentDurationS, Ie = 1, Xe = 0; Xe < le; ++Xe)
                      te[Xe] = te[Xe] / 1e3, _e * te[Xe] > De && (Ie = -1), Ce.w[Xe] = Ce.prev_w[Xe] + Ie * (Ae / (2 * he)) * ((Ce.Q + pe) * (_e * te[Xe] / De));
                    Ce.w = $(Ce.w);
                    for (var it = 0; it < le; ++it)
                      Re[it] = Ce.w[it] - Ce.prev_w[it], Ce.prev_w[it] = Ce.w[it];
                    Ce.Q = Math.max(0, Ce.Q - Ae + Ae * _e * ((G(te, Ce.prev_w) + G(te, Re)) / De));
                    for (var rt = [], Ne = 0; Ne < le; ++Ne)
                      rt[Ne] = Math.abs(te[Ne] - G(Ce.w, te));
                    q = rt.indexOf(Math.min.apply(Math, rt)), q > ge.lastQuality && te[ge.lastQuality + 1] <= De && (q = ge.lastQuality + 1), te[q] >= De && (Ce.Q = Q * Math.max(pe, Ce.Q)), oe.quality = q, oe.reason.throughput = V, oe.reason.latency = fe, oe.reason.bufferLevel = K, ge.lastQuality = oe.quality;
                    break;
                  default:
                    C.debug("L2A ABR rule invoked in bad state."), oe.quality = P.getQualityForBitrate(se, U, x.id, fe), oe.reason.state = ge.state, oe.reason.throughput = U, oe.reason.latency = fe, ge.state = S, k(ge);
                }
                return oe;
              }
              function re() {
                D = {}, M = {};
              }
              function ce() {
                re(), _.off(g.default.PLAYBACK_SEEKING, Z, O), _.off(g.default.MEDIA_FRAGMENT_LOADED, Y, O), _.off(g.default.METRIC_ADDED, j, O), _.off(g.default.QUALITY_CHANGE_REQUESTED, ae, O);
              }
              return O = {
                getMaxIndex: ie,
                reset: ce
              }, I(), O;
            }
            T.__dashjs_factory_name = "L2ARule";
            const R = p.default.getClassFactory(T);
          }
        ),
        /***/
        "./src/streaming/rules/abr/SwitchHistoryRule.js": (
          /*!******************************************************!*\
            !*** ./src/streaming/rules/abr/SwitchHistoryRule.js ***!
            \******************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var h = i(
              /*! ../../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ../../../core/Debug */
              "./src/core/Debug.js"
            ), p = i(
              /*! ../SwitchRequest */
              "./src/streaming/rules/SwitchRequest.js"
            );
            function d() {
              var g = this.context, m, A, b = 0.075, S = 6;
              function N() {
                A = (0, f.default)(g).getInstance().getLogger(m);
              }
              function T(R) {
                for (var y = R ? R.getSwitchHistory() : null, E = y ? y.getSwitchRequests() : [], L = 0, _ = 0, O = 0, D = (0, p.default)(g).create(), M = 0; M < E.length; M++)
                  if (E[M] !== void 0 && (L += E[M].drops, _ += E[M].noDrops, O += E[M].dropSize, L + _ >= S && L / _ > b)) {
                    D.quality = M > 0 && E[M].drops > 0 ? M - 1 : M, D.reason = {
                      index: D.quality,
                      drops: L,
                      noDrops: _,
                      dropSize: O
                    }, A.debug("Switch history rule index: " + D.quality + " samples: " + (L + _) + " drops: " + L);
                    break;
                  }
                return D;
              }
              return m = {
                getMaxIndex: T
              }, N(), m;
            }
            d.__dashjs_factory_name = "SwitchHistoryRule";
            const v = h.default.getClassFactory(d);
          }
        ),
        /***/
        "./src/streaming/rules/abr/ThroughputRule.js": (
          /*!***************************************************!*\
            !*** ./src/streaming/rules/abr/ThroughputRule.js ***!
            \***************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => g
              /* harmony export */
            });
            var h = i(
              /*! ../../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ../SwitchRequest */
              "./src/streaming/rules/SwitchRequest.js"
            ), p = i(
              /*! ../../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), d = i(
              /*! ../../constants/MetricsConstants */
              "./src/streaming/constants/MetricsConstants.js"
            );
            function v(m) {
              m = m || {};
              var A = this.context, b = m.dashMetrics, S;
              function N() {
                if (!b || !b.hasOwnProperty("getCurrentBufferState"))
                  throw new Error(p.default.MISSING_CONFIG_ERROR);
              }
              function T(y) {
                var E = (0, f.default)(A).create();
                if (!y || !y.hasOwnProperty("getMediaInfo") || !y.hasOwnProperty("getMediaType") || !y.hasOwnProperty("useBufferOccupancyABR") || !y.hasOwnProperty("getAbrController") || !y.hasOwnProperty("getScheduleController"))
                  return E;
                N();
                var L = y.getMediaInfo(), _ = y.getMediaType(), O = b.getCurrentBufferState(_), D = y.getScheduleController(), M = y.getAbrController(), C = y.getStreamInfo(), I = C ? C.id : null, w = C && C.manifestInfo ? C.manifestInfo.isDynamic : null, F = M.getThroughputHistory(), k = F.getSafeAverageThroughput(_, w), H = F.getAverageLatency(_), Z = y.useBufferOccupancyABR();
                return isNaN(k) || !O || Z || M.getAbandonmentStateFor(I, _) !== d.default.ABANDON_LOAD && (O.state === d.default.BUFFER_LOADED || w) && (E.quality = M.getQualityForBitrate(L, k, I, H), D.setTimeToLoadDelay(0), E.reason = {
                  throughput: k,
                  latency: H
                }), E;
              }
              function R() {
              }
              return S = {
                getMaxIndex: T,
                reset: R
              }, S;
            }
            v.__dashjs_factory_name = "ThroughputRule";
            const g = h.default.getClassFactory(v);
          }
        ),
        /***/
        "./src/streaming/rules/abr/lolp/LearningAbrController.js": (
          /*!***************************************************************!*\
            !*** ./src/streaming/rules/abr/lolp/LearningAbrController.js ***!
            \***************************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var h = i(
              /*! ../../../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ../../../../core/Debug */
              "./src/core/Debug.js"
            ), p = {
              MANUAL: "manual_weight_selection",
              RANDOM: "random_weight_selection",
              DYNAMIC: "dynamic_weight_selection"
            };
            function d() {
              var g = this.context, m, A, b, S, N, T, R, y, E;
              function L() {
                A = (0, f.default)(g).getInstance().getLogger(m), O();
              }
              function _() {
                O();
              }
              function O() {
                b = null, S = 1, N = 100, T = 0, R = null, y = null, E = p.DYNAMIC;
              }
              function D() {
                var ie = 0;
                if (b)
                  for (var re = 0; re < b.length; re++) {
                    var ce = b[re];
                    ce.state.throughput > ie && (ie = ce.state.throughput);
                  }
                return ie;
              }
              function M(ie) {
                var re = ie.map(function(ce) {
                  return Math.pow(ce, 2);
                }).reduce(function(ce, z) {
                  return ce + z;
                });
                return Math.sqrt(re);
              }
              function C(ie, re, ce) {
                var z = ie.map(function(de, pe) {
                  return ce[pe] * Math.pow(de - re[pe], 2);
                }).reduce(function(de, pe) {
                  return de + pe;
                }), oe = z < 0 ? -1 : 1;
                return oe * Math.sqrt(Math.abs(z));
              }
              function I(ie, re) {
                var ce = [ie.state.throughput, ie.state.latency, ie.state.rebuffer, ie.state.switch], z = [re.state.throughput, re.state.latency, re.state.rebuffer, re.state.switch];
                return C(ce, z, [1, 1, 1, 1]);
              }
              function w(ie, re, ce) {
                for (var z = 0; z < re.length; z++) {
                  var oe = re[z], de = 0.1, pe = I(oe, ie), he = Math.exp(-1 * Math.pow(pe, 2) / (2 * Math.pow(de, 2)));
                  F(oe, ce, he);
                }
              }
              function F(ie, re, ce) {
                var z = ie.state, oe = [0.01, 0.01, 0.01, 0.01];
                z.throughput = z.throughput + (re[0] - z.throughput) * oe[0] * ce, z.latency = z.latency + (re[1] - z.latency) * oe[1] * ce, z.rebuffer = z.rebuffer + (re[2] - z.rebuffer) * oe[2] * ce, z.switch = z.switch + (re[3] - z.switch) * oe[3] * ce;
              }
              function k(ie, re) {
                var ce = 0, z = ie;
                if (b)
                  for (var oe = 0; oe < b.length; oe++) {
                    var de = b[oe];
                    de.bitrate < ie.bitrate && de.bitrate > ce && re > de.bitrate && (ce = de.bitrate, z = de);
                  }
                return z;
              }
              function H(ie, re, ce, z, oe, de, pe) {
                var he = ce, se = z, ee = re, te = ae(ie), le = re / S;
                le > 1 && (le = D()), ce = ce / N;
                var ne = 0, x = 0, P = 0, B = 1e4;
                A.debug("getNextQuality called throughput:".concat(le, " latency:").concat(ce, " bufferSize:").concat(z, " currentQualityIndex:").concat(de, " playbackRate:").concat(oe));
                var W = te[de], X = W.bitrate * pe.getSegmentDuration() / ee, K = Math.max(0, X - se);
                if (se - X < pe.getMinBuffer())
                  return A.debug("Buffer is low for bitrate= ".concat(W.bitrate, " downloadTime=").concat(X, " currentBuffer=").concat(se, " rebuffer=").concat(K)), k(W, ee).qualityIndex;
                switch (E) {
                  case p.MANUAL:
                    Z();
                    break;
                  case p.RANDOM:
                    Y(te);
                    break;
                  case p.DYNAMIC:
                    j(pe, te, he, se, K, ee, oe);
                    break;
                  default:
                    j(pe, te, he, se, K, ee, oe);
                }
                for (var U = null, V = null, Q = null, fe = 0; fe < te.length; fe++) {
                  var ue = te[fe], q = ue.state, _e = [q.throughput, q.latency, q.rebuffer, q.switch], ge = R.slice(), Ce = pe.getNextBufferWithBitrate(ue.bitrate, se, ee), Ee = Ce < pe.getMinBuffer();
                  Ee && A.debug("Buffer is low for bitrate=".concat(ue.bitrate, " downloadTime=").concat(X, " currentBuffer=").concat(se, " nextBuffer=").concat(Ce)), (ue.bitrate > re - B || Ee) && ue.bitrate !== T && (ge[0] = 100);
                  var Re = C(_e, [le, ne, x, P], ge);
                  (U === null || Re < U) && (U = Re, V = ue.qualityIndex, Q = ue);
                }
                var Pe = Math.abs(W.bitrate - Q.bitrate) / S;
                return w(W, te, [le, ce, K, Pe]), w(Q, te, [le, ne, x, Pe]), V;
              }
              function Z() {
                var ie = 0.4, re = 0.4, ce = 0.4, z = 0.4;
                R = [ie, re, ce, z];
              }
              function Y(ie) {
                R = J(ie.length, 4);
              }
              function j(ie, re, ce, z, oe, de, pe) {
                R || (R = y[y.length - 1]);
                var he = ie.findWeightVector(re, ce, z, oe, de, pe);
                he !== null && he !== -1 && (R = he);
              }
              function J(ie, re) {
                for (var ce = [], z = Math.sqrt(2 / ie), oe = 0; oe < re; oe++)
                  ce.push(Math.random() * z);
                return R = ce, R;
              }
              function ae(ie) {
                if (!b) {
                  b = [];
                  var re = ie.bitrateList, ce = [];
                  T = re[0].bandwidth, re.forEach(function(de) {
                    ce.push(de.bandwidth), de.bandwidth < T && (T = de.bandwidth);
                  }), S = M(ce);
                  for (var z = 0; z < re.length; z++) {
                    var oe = {
                      qualityIndex: z,
                      bitrate: re[z].bandwidth,
                      state: {
                        // normalize throughputs
                        throughput: re[z].bandwidth / S,
                        latency: 0,
                        rebuffer: 0,
                        switch: 0
                      }
                    };
                    b.push(oe);
                  }
                  y = $(b);
                }
                return b;
              }
              function G(ie) {
                for (var re = [], ce = 0; ce < ie; ce++) {
                  var z = [
                    Math.random() * D(),
                    //throughput
                    Math.random(),
                    //latency
                    Math.random(),
                    //buffersize
                    Math.random()
                    //switch
                  ];
                  re.push(z);
                }
                return re;
              }
              function $(ie) {
                var re = [], ce = G(Math.pow(ie.length, 2));
                re.push(ce[0]);
                for (var z = [1, 1, 1, 1], oe = 1; oe < ie.length; oe++) {
                  for (var de = null, pe = null, he = 0; he < ce.length; he++) {
                    for (var se = ce[he], ee = null, te = 0; te < re.length; te++) {
                      var le = C(se, re[te], z);
                      (ee === null || le < ee) && (ee = le);
                    }
                    (pe === null || ee > pe) && (de = se, pe = ee);
                  }
                  re.push(de);
                }
                for (var ne = null, x = null, P = 0; P < re.length; P++) {
                  for (var B = 0, W = 0; W < re.length; W++)
                    P !== W && (B += C(re[P], re[W], z));
                  (ne === null || B > ne) && (ne = B, x = P);
                }
                var X = [];
                for (X.push(re[x]), re.splice(x, 1); re.length > 0; ) {
                  for (var K = null, U = null, V = 0; V < re.length; V++) {
                    var Q = C(X[0], re[V], z);
                    (K === null || Q < K) && (K = Q, U = V);
                  }
                  X.push(re[U]), re.splice(U, 1);
                }
                return X;
              }
              return m = {
                getNextQuality: H,
                reset: _
              }, L(), m;
            }
            d.__dashjs_factory_name = "LearningAbrController";
            const v = h.default.getClassFactory(d);
          }
        ),
        /***/
        "./src/streaming/rules/abr/lolp/LoLpQoEEvaluator.js": (
          /*!**********************************************************!*\
            !*** ./src/streaming/rules/abr/lolp/LoLpQoEEvaluator.js ***!
            \**********************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => d
              /* harmony export */
            });
            var h = i(
              /*! ../../../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ./QoeInfo */
              "./src/streaming/rules/abr/lolp/QoeInfo.js"
            );
            function p() {
              var v, g, m, A, b;
              function S() {
                N();
              }
              function N() {
                g = null, m = null, A = null, b = null;
              }
              function T(D, M, C) {
                g = R("segment", D, M, C), m = D, A = M, b = C;
              }
              function R(D, M, C, I) {
                var w = new f.default();
                return w.type = D, M ? w.weights.bitrateReward = M : w.weights.bitrateReward = 1, w.weights.bitrateSwitchPenalty = 1, C ? w.weights.rebufferPenalty = C : w.weights.rebufferPenalty = 1e3, w.weights.latencyPenalty = [], w.weights.latencyPenalty.push({
                  threshold: 1.1,
                  penalty: I * 0.05
                }), w.weights.latencyPenalty.push({
                  threshold: 1e8,
                  penalty: C * 0.1
                }), I ? w.weights.playbackSpeedPenalty = I : w.weights.playbackSpeedPenalty = 200, w;
              }
              function y(D, M, C, I) {
                g && E(D, M, C, I, g);
              }
              function E(D, M, C, I, w) {
                w.bitrateWSum += w.weights.bitrateReward * D, w.lastBitrate && (w.bitrateSwitchWSum += w.weights.bitrateSwitchPenalty * Math.abs(D - w.lastBitrate)), w.lastBitrate = D, w.rebufferWSum += w.weights.rebufferPenalty * M;
                for (var F = 0; F < w.weights.latencyPenalty.length; F++) {
                  var k = w.weights.latencyPenalty[F];
                  if (C <= k.threshold) {
                    w.latencyWSum += k.penalty * C;
                    break;
                  }
                }
                w.playbackSpeedWSum += w.weights.playbackSpeedPenalty * Math.abs(1 - I), w.totalQoe = w.bitrateWSum - w.bitrateSwitchWSum - w.rebufferWSum - w.latencyWSum - w.playbackSpeedWSum;
              }
              function L() {
                return g;
              }
              function _(D, M, C, I) {
                var w = null;
                return m && A && b && (w = R("segment", m, A, b)), w ? (E(D, M, C, I, w), w.totalQoe) : 0;
              }
              function O() {
                N();
              }
              return v = {
                setupPerSegmentQoe: T,
                logSegmentMetrics: y,
                getPerSegmentQoe: L,
                calculateSingleUseQoe: _,
                reset: O
              }, S(), v;
            }
            p.__dashjs_factory_name = "LoLpQoeEvaluator";
            const d = h.default.getClassFactory(p);
          }
        ),
        /***/
        "./src/streaming/rules/abr/lolp/LoLpRule.js": (
          /*!**************************************************!*\
            !*** ./src/streaming/rules/abr/lolp/LoLpRule.js ***!
            \**************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => T
              /* harmony export */
            });
            var h = i(
              /*! ../../../../core/Debug */
              "./src/core/Debug.js"
            ), f = i(
              /*! ../../../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), p = i(
              /*! ./LearningAbrController */
              "./src/streaming/rules/abr/lolp/LearningAbrController.js"
            ), d = i(
              /*! ./LoLpQoEEvaluator */
              "./src/streaming/rules/abr/lolp/LoLpQoEEvaluator.js"
            ), v = i(
              /*! ../../SwitchRequest */
              "./src/streaming/rules/SwitchRequest.js"
            ), g = i(
              /*! ../../../constants/MetricsConstants */
              "./src/streaming/constants/MetricsConstants.js"
            ), m = i(
              /*! ./LoLpWeightSelector */
              "./src/streaming/rules/abr/lolp/LoLpWeightSelector.js"
            ), A = i(
              /*! ../../../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), b = 1.5, S = 0.3;
            function N(R) {
              R = R || {};
              var y = R.dashMetrics, E = this.context, L, _, O, D;
              function M() {
                L = (0, h.default)(E).getInstance().getLogger(_), O = (0, p.default)(E).create(), D = (0, d.default)(E).create();
              }
              function C(F) {
                try {
                  var k = (0, v.default)(E).create(), H = F.getMediaInfo().type, Z = F.getAbrController(), Y = F.getStreamInfo(), j = Z.getQualityFor(H, Y.id), J = F.getMediaInfo(), ae = y.getCurrentBufferState(H), G = F.getScheduleController(), $ = y.getCurrentBufferLevel(H, !0), ie = Y && Y.manifestInfo ? Y.manifestInfo.isDynamic : null, re = G.getPlaybackController(), ce = re.getCurrentLiveLatency();
                  if (!F.useLoLPABR() || H === A.default.AUDIO)
                    return k;
                  ce || (ce = 0);
                  var z = re.getPlaybackRate(), oe = Z.getThroughputHistory(), de = oe.getSafeAverageThroughput(H, ie);
                  if (L.debug("Throughput ".concat(Math.round(de), " kbps")), isNaN(de) || !ae || Z.getAbandonmentStateFor(Y.id, H) === g.default.ABANDON_LOAD)
                    return k;
                  for (var pe = J.bitrateList, he = F.getRepresentationInfo().fragmentDuration, se = pe[0].bandwidth / 1e3, ee = pe[pe.length - 1].bandwidth / 1e3, te = 0; te < pe.length; te++) {
                    var le = pe[te].bandwidth / 1e3;
                    le > ee ? ee = le : le < se && (se = le);
                  }
                  var ne = pe[j].bandwidth, x = ne / 1e3, P = y.getCurrentHttpRequest(H, !0), B = (P.tresponse.getTime() - P.trequest.getTime()) / 1e3, W = B > he ? B - he : 0;
                  D.setupPerSegmentQoe(he, ee, se), D.logSegmentMetrics(x, W, ce, z);
                  var X = (0, m.default)(E).create({
                    targetLatency: b,
                    bufferMin: S,
                    segmentDuration: he,
                    qoeEvaluator: D
                  });
                  return k.quality = O.getNextQuality(J, de * 1e3, ce, $, z, j, X), k.reason = {
                    throughput: de,
                    latency: ce
                  }, k.priority = v.default.PRIORITY.STRONG, G.setTimeToLoadDelay(0), k.quality !== j && console.log("[TgcLearningRule][" + H + "] requesting switch to index: ", k.quality, "Average throughput", Math.round(de), "kbps"), k;
                } catch (K) {
                  throw K;
                }
              }
              function I() {
                O.reset(), D.reset();
              }
              function w() {
                I();
              }
              return _ = {
                getMaxIndex: C,
                reset: w
              }, M(), _;
            }
            N.__dashjs_factory_name = "LoLPRule";
            const T = f.default.getClassFactory(N);
          }
        ),
        /***/
        "./src/streaming/rules/abr/lolp/LoLpWeightSelector.js": (
          /*!************************************************************!*\
            !*** ./src/streaming/rules/abr/lolp/LoLpWeightSelector.js ***!
            \************************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            var h = i(
              /*! ../../../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function f(d) {
              var v = d.targetLatency, g = d.bufferMin, m = d.segmentDuration, A = d.qoeEvaluator, b, S, N, T, R;
              function y() {
                E();
              }
              function E() {
                S = [0.2, 0.4, 0.6, 0.8, 1], N = 4, T = O(S, N), R = 0;
              }
              function L(w, F, k, H, Z, Y) {
                var j = null, J = null, ae = null, G = Math.abs(F - R);
                return w.forEach(function($) {
                  T.forEach(function(ie) {
                    var re = {
                      throughput: ie[0],
                      latency: ie[1],
                      buffer: ie[2],
                      switch: ie[3]
                    }, ce = $.bitrate * m / Z, z = I(k, ce), oe = Math.max(1e-5, ce - z), de;
                    re.buffer === 0 ? de = 10 : de = 1 / re.buffer;
                    var pe = de * oe;
                    re.latency === 0 ? de = 10 : de = 1 / re.latency;
                    var he = de * $.state.latency, se = A.calculateSingleUseQoe($.bitrate, pe, he, Y);
                    (j === null || se > j) && _(F, z, G) && (j = se, J = ie, ae = $.bitrate);
                  });
                }), J === null && ae === null && (J = -1), R = F, J;
              }
              function _(w, F, k) {
                return w > v + k ? !1 : F >= g;
              }
              function O(w, F) {
                var k = w.map(function(Z) {
                  return [Z];
                }), H = function Z(Y, j, J) {
                  if (J === j)
                    return Y;
                  for (var ae = Y.length, G = 0; G < ae; G++)
                    for (var $ = Y.shift(), ie = 0; ie < w.length; ie++)
                      Y.push($.concat(w[ie]));
                  return Z(Y, j, J + 1);
                };
                return H(k, F, 1);
              }
              function D() {
                return g;
              }
              function M() {
                return m;
              }
              function C(w, F, k) {
                var H = w * m / k;
                return I(F, H);
              }
              function I(w, F) {
                var k = M(), H;
                return F > k ? H = w - k : H = w + k - F, H;
              }
              return b = {
                getMinBuffer: D,
                getSegmentDuration: M,
                getNextBufferWithBitrate: C,
                getNextBuffer: I,
                findWeightVector: L
              }, y(), b;
            }
            f.__dashjs_factory_name = "LoLpWeightSelector";
            const p = h.default.getClassFactory(f);
          }
        ),
        /***/
        "./src/streaming/rules/abr/lolp/QoeInfo.js": (
          /*!*************************************************!*\
            !*** ./src/streaming/rules/abr/lolp/QoeInfo.js ***!
            \*************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = function d() {
              h(this, d), this.type = null, this.lastBitrate = null, this.weights = {}, this.weights.bitrateReward = null, this.weights.bitrateSwitchPenalty = null, this.weights.rebufferPenalty = null, this.weights.latencyPenalty = null, this.weights.playbackSpeedPenalty = null, this.bitrateWSum = 0, this.bitrateSwitchWSum = 0, this.rebufferWSum = 0, this.latencyWSum = 0, this.playbackSpeedWSum = 0, this.totalQoe = 0;
            };
            const p = f;
          }
        ),
        /***/
        "./src/streaming/text/EmbeddedTextHtmlRender.js": (
          /*!******************************************************!*\
            !*** ./src/streaming/text/EmbeddedTextHtmlRender.js ***!
            \******************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function f() {
              var d = 0, v;
              function g(R) {
                for (var y = "", E = 0; E < R.length; ++E) {
                  var L = R[E];
                  y += L.uchar;
                }
                var _ = y.length, O = y.replace(/^\s+/, "").length;
                return _ - O;
              }
              function m(R) {
                return "left: " + R.x * 3.125 + "%; top: " + R.y1 * 6.66 + "%; width: " + (100 - R.x * 3.125) + "%; height: " + Math.max(R.y2 - 1 - R.y1, 1) * 6.66 + "%; align-items: flex-start; overflow: visible; -webkit-writing-mode: horizontal-tb;";
              }
              function A(R) {
                return R === "red" ? "rgb(255, 0, 0)" : R === "green" ? "rgb(0, 255, 0)" : R === "blue" ? "rgb(0, 0, 255)" : R === "cyan" ? "rgb(0, 255, 255)" : R === "magenta" ? "rgb(255, 0, 255)" : R === "yellow" ? "rgb(255, 255, 0)" : R === "white" ? "rgb(255, 255, 255)" : R === "black" ? "rgb(0, 0, 0)" : R;
              }
              function b(R, y) {
                var E = R.videoHeight / 15;
                return y ? "font-size: " + E + "px; font-family: Menlo, Consolas, 'Cutive Mono', monospace; color: " + (y.foreground ? A(y.foreground) : "rgb(255, 255, 255)") + "; font-style: " + (y.italics ? "italic" : "normal") + "; text-decoration: " + (y.underline ? "underline" : "none") + "; white-space: pre; background-color: " + (y.background ? A(y.background) : "transparent") + ";" : "font-size: " + E + "px; font-family: Menlo, Consolas, 'Cutive Mono', monospace; justify-content: flex-start; text-align: left; color: rgb(255, 255, 255); font-style: normal; white-space: pre; line-height: normal; font-weight: normal; text-decoration: none; width: 100%; display: flex;";
              }
              function S(R) {
                return R.replace(/^\s+/g, "");
              }
              function N(R) {
                return R.replace(/\s+$/g, "");
              }
              function T(R, y, E, L) {
                var _ = null, O = null, D = !1, M = -1, C = {
                  start: y,
                  end: E,
                  spans: []
                }, I = "style_cea608_white_black", w = {}, F = {}, k = [], H, Z;
                for (H = 0; H < 15; ++H) {
                  var Y = L.rows[H], j = "", J = null;
                  if (Y.isEmpty() === !1) {
                    var ae = g(Y.chars);
                    _ === null && (_ = {
                      x: ae,
                      y1: H,
                      y2: H + 1,
                      p: []
                    }), ae !== M && D && (_.p.push(C), C = {
                      start: y,
                      end: E,
                      spans: []
                    }, _.y2 = H, _.name = "region_" + _.x + "_" + _.y1 + "_" + _.y2, w.hasOwnProperty(_.name) === !1 ? (k.push(_), w[_.name] = _) : (O = w[_.name], O.p.contat(_.p)), _ = {
                      x: ae,
                      y1: H,
                      y2: H + 1,
                      p: []
                    });
                    for (var G = 0; G < Y.chars.length; ++G) {
                      var $ = Y.chars[G], ie = $.penState;
                      if (J === null || !ie.equals(J)) {
                        j.trim().length > 0 && (C.spans.push({
                          name: I,
                          line: j,
                          row: H
                        }), j = "");
                        var re = "style_cea608_" + ie.foreground + "_" + ie.background;
                        ie.underline && (re += "_underline"), ie.italics && (re += "_italics"), F.hasOwnProperty(re) || (F[re] = JSON.parse(JSON.stringify(ie))), J = ie, I = re;
                      }
                      j += $.uchar;
                    }
                    j.trim().length > 0 && C.spans.push({
                      name: I,
                      line: j,
                      row: H
                    }), D = !0, M = ae;
                  } else
                    D = !1, M = -1, _ && (_.p.push(C), C = {
                      start: y,
                      end: E,
                      spans: []
                    }, _.y2 = H, _.name = "region_" + _.x + "_" + _.y1 + "_" + _.y2, w.hasOwnProperty(_.name) === !1 ? (k.push(_), w[_.name] = _) : (O = w[_.name], O.p.contat(_.p)), _ = null);
                }
                _ && (_.p.push(C), _.y2 = H + 1, _.name = "region_" + _.x + "_" + _.y1 + "_" + _.y2, w.hasOwnProperty(_.name) === !1 ? (k.push(_), w[_.name] = _) : (O = w[_.name], O.p.contat(_.p)), _ = null);
                var ce = [];
                for (H = 0; H < k.length; ++H) {
                  var z = k[H], oe = "sub_cea608_" + d++, de = document.createElement("div");
                  de.id = oe;
                  var pe = m(z);
                  de.style.cssText = "position: absolute; margin: 0; display: flex; box-sizing: border-box; pointer-events: none;" + pe;
                  var he = document.createElement("div");
                  he.className = "paragraph bodyStyle", he.style.cssText = b(R);
                  var se = document.createElement("div");
                  se.className = "cueUniWrapper", se.style.cssText = "unicode-bidi: normal; direction: ltr;";
                  for (var ee = 0; ee < z.p.length; ++ee) {
                    var te = z.p[ee], le = 0;
                    for (Z = 0; Z < te.spans.length; ++Z) {
                      var ne = te.spans[Z];
                      if (ne.line.length > 0) {
                        if (Z !== 0 && le != ne.row) {
                          var x = document.createElement("br");
                          x.className = "lineBreak", se.appendChild(x);
                        }
                        var P = !1;
                        le === ne.row && (P = !0), le = ne.row;
                        var B = F[ne.name], W = document.createElement("span");
                        W.className = "spanPadding " + ne.name + " customSpanColor", W.style.cssText = b(R, B), Z !== 0 && P ? Z === te.spans.length - 1 ? W.textContent = N(ne.line) : W.textContent = ne.line : te.spans.length > 1 && Z < te.spans.length - 1 && ne.row === te.spans[Z + 1].row ? W.textContent = S(ne.line) : W.textContent = ne.line.trim(), se.appendChild(W);
                      }
                    }
                  }
                  he.appendChild(se), de.appendChild(he);
                  var X = {
                    bodyStyle: ["%", 90]
                  };
                  for (var K in F)
                    F.hasOwnProperty(K) && (X[K] = ["%", 90]);
                  ce.push({
                    type: "html",
                    start: y,
                    end: E,
                    cueHTMLElement: de,
                    cueID: oe,
                    cellResolution: [32, 15],
                    isFromCEA608: !0,
                    fontSize: X,
                    lineHeight: {},
                    linePadding: {}
                  });
                }
                return ce;
              }
              return v = {
                createHTMLCaptionsFromScreen: T
              }, v;
            }
            f.__dashjs_factory_name = "EmbeddedTextHtmlRender";
            const p = h.default.getSingletonFactory(f);
          }
        ),
        /***/
        "./src/streaming/text/NotFragmentedTextBufferController.js": (
          /*!*****************************************************************!*\
            !*** ./src/streaming/text/NotFragmentedTextBufferController.js ***!
            \*****************************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => S
              /* harmony export */
            });
            var h = i(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), f = i(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), p = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), d = i(
              /*! ../utils/InitCache */
              "./src/streaming/utils/InitCache.js"
            ), v = i(
              /*! ../SourceBufferSink */
              "./src/streaming/SourceBufferSink.js"
            ), g = i(
              /*! ../../streaming/vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), m = i(
              /*! ../../core/errors/Errors */
              "./src/core/errors/Errors.js"
            ), A = "NotFragmentedTextBufferController";
            function b(N) {
              N = N || {};
              var T = this.context, R = (0, h.default)(T).getInstance(), y = N.textController, E = N.errHandler, L = N.streamInfo, _ = N.type, O, D, M, C, I, w;
              function F() {
                M = !1, C = null, D = !1, w = (0, d.default)(T).getInstance(), R.on(f.default.INIT_FRAGMENT_LOADED, pe, O);
              }
              function k() {
                return A;
              }
              function H(Q) {
                ae(Q);
              }
              function Z(Q) {
                return new Promise(function(fe, ue) {
                  try {
                    I = (0, v.default)(T).create({
                      mediaSource: C,
                      textController: y,
                      eventBus: R
                    }), I.initializeForFirstUse(L, Q), M || (I.getBuffer() && typeof I.getBuffer().initialize == "function" && I.getBuffer().initialize(), M = !0), fe(I);
                  } catch (q) {
                    E.error(new g.default(m.default.MEDIASOURCE_TYPE_UNSUPPORTED_CODE, m.default.MEDIASOURCE_TYPE_UNSUPPORTED_MESSAGE + _)), ue(q);
                  }
                });
              }
              function Y() {
                return L.id;
              }
              function j() {
                return _;
              }
              function J() {
                return I;
              }
              function ae(Q) {
                C = Q;
              }
              function G() {
                return C;
              }
              function $() {
                return !1;
              }
              function ie() {
              }
              function re() {
                return 0;
              }
              function ce() {
                return D;
              }
              function z(Q) {
                D !== Q && (D = Q, D && V(f.default.BUFFERING_COMPLETED));
              }
              function oe(Q) {
                R.off(f.default.INIT_FRAGMENT_LOADED, pe, O), !Q && I && (I.abort(), I.reset(), I = null);
              }
              function de(Q) {
                return w.extract(L.id, Q) !== null;
              }
              function pe(Q) {
                !Q.chunk.bytes || D || (w.save(Q.chunk), I.append(Q.chunk), z(!0));
              }
              function he() {
                return null;
              }
              function se() {
                return !0;
              }
              function ee() {
                return [];
              }
              function te() {
                return Number.POSITIVE_INFINITY;
              }
              function le() {
                return Promise.resolve();
              }
              function ne() {
              }
              function x() {
                return Promise.resolve();
              }
              function P() {
                return Promise.resolve();
              }
              function B() {
                return D = !1, Promise.resolve();
              }
              function W() {
                return Promise.resolve();
              }
              function X() {
              }
              function K() {
              }
              function U() {
                return Promise.resolve();
              }
              function V(Q, fe) {
                var ue = fe || {};
                R.trigger(Q, ue, {
                  streamId: L.id,
                  mediaType: _
                });
              }
              return O = {
                initialize: H,
                getStreamId: Y,
                getType: j,
                getBufferControllerType: k,
                createBufferSink: Z,
                dischargePreBuffer: ie,
                getBuffer: J,
                getBufferLevel: re,
                getRangeAt: he,
                pruneBuffer: ne,
                hasBufferAtTime: se,
                getAllRangesWithSafetyFactor: ee,
                getContinuousBufferTimeForTargetTime: te,
                setMediaSource: ae,
                getMediaSource: G,
                appendInitSegmentFromCache: de,
                getIsBufferingCompleted: ce,
                setIsBufferingCompleted: z,
                getIsPruningInProgress: $,
                reset: oe,
                clearBuffers: le,
                prepareForPlaybackSeek: P,
                prepareForReplacementTrackSwitch: B,
                setSeekTarget: X,
                updateAppendWindow: W,
                pruneAllSafely: U,
                updateBufferTimestampOffset: x,
                segmentRequestingCompleted: K
              }, F(), O;
            }
            b.__dashjs_factory_name = A;
            const S = p.default.getClassFactory(b);
          }
        ),
        /***/
        "./src/streaming/text/TextController.js": (
          /*!**********************************************!*\
            !*** ./src/streaming/text/TextController.js ***!
            \**********************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => R
              /* harmony export */
            });
            var h = i(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), f = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), p = i(
              /*! ./TextSourceBuffer */
              "./src/streaming/text/TextSourceBuffer.js"
            ), d = i(
              /*! ./TextTracks */
              "./src/streaming/text/TextTracks.js"
            ), v = i(
              /*! ../utils/VTTParser */
              "./src/streaming/utils/VTTParser.js"
            ), g = i(
              /*! ../utils/VttCustomRenderingParser */
              "./src/streaming/utils/VttCustomRenderingParser.js"
            ), m = i(
              /*! ../utils/TTMLParser */
              "./src/streaming/utils/TTMLParser.js"
            ), A = i(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), b = i(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), S = i(
              /*! ../../streaming/MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), N = i(
              /*! ../utils/SupervisorTools */
              "./src/streaming/utils/SupervisorTools.js"
            );
            function T(y) {
              var E = this.context, L = y.adapter, _ = y.errHandler, O = y.manifestModel, D = y.mediaController, M = y.videoModel, C = y.settings, I, w, F, k, H, Z, Y, j, J, ae, G, $;
              function ie() {
                ae = !1, G = !1, $ = !1, H = (0, v.default)(E).getInstance(), Z = (0, g.default)(E).getInstance(), Y = (0, m.default)(E).getInstance(), j = (0, A.default)(E).getInstance(), U();
              }
              function re() {
                j.on(b.default.TEXT_TRACKS_QUEUE_INITIALIZED, se, I), C.get().streaming.text.webvtt.customRenderingEnabled && (j.on(b.default.PLAYBACK_TIME_UPDATED, ee, I), j.on(b.default.PLAYBACK_SEEKING, te, I));
              }
              function ce(Q) {
                var fe = Q.id, ue = (0, d.default)(E).create({
                  videoModel: M,
                  settings: C,
                  streamInfo: Q
                });
                ue.initialize(), k[fe] = ue;
                var q = (0, p.default)(E).create({
                  errHandler: _,
                  adapter: L,
                  manifestModel: O,
                  mediaController: D,
                  videoModel: M,
                  textTracks: ue,
                  vttParser: H,
                  vttCustomRenderingParser: Z,
                  ttmlParser: Y,
                  streamInfo: Q,
                  settings: C
                });
                q.initialize(), F[fe] = q, w[fe] = {}, w[fe].lastEnabledIndex = -1;
              }
              function z(Q) {
                var fe = Q.id;
                k[fe] && k[fe].createTracks();
              }
              function oe(Q, fe, ue) {
                var q = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, _e = Q.id;
                F[_e] && F[_e].addMediaInfos(fe, ue, q);
              }
              function de(Q) {
                var fe = Q.id;
                if (F && F[fe])
                  return F[fe];
              }
              function pe() {
                return J;
              }
              function he(Q, fe) {
                var ue = Q.id;
                F[ue] && F[ue].addEmbeddedTrack(fe);
              }
              function se(Q) {
                var fe = Q.tracks, ue = Q.index, q = Q.streamId, _e = C.get().streaming.text.defaultEnabled;
                if (_e === !1 && !ne() || $)
                  P(q, -1);
                else {
                  var ge = D.getCurrentTrackFor(h.default.TEXT, q);
                  if (ge) {
                    var Ce = {
                      lang: ge.lang,
                      role: ge.roles[0],
                      index: ge.index,
                      codec: ge.codec,
                      accessibility: ge.accessibility[0]
                    };
                    fe.some(function(Ee, Re) {
                      if (D.matchSettings(Ce, Ee))
                        return P(q, Re), ue = Re, !0;
                    });
                  }
                  J = !1;
                }
                w[q].lastEnabledIndex = ue, j.trigger(S.default.TEXT_TRACKS_ADDED, {
                  enabled: ne(),
                  index: ue,
                  tracks: fe,
                  streamId: q
                }), G = !0;
              }
              function ee(Q) {
                try {
                  var fe = Q.streamId;
                  if (!k[fe] || isNaN(Q.time))
                    return;
                  k[fe].manualCueProcessing(Q.time);
                } catch {
                }
              }
              function te(Q) {
                try {
                  var fe = Q.streamId;
                  if (!k[fe])
                    return;
                  k[fe].disableManualTracks();
                } catch {
                }
              }
              function le(Q, fe) {
                (0, N.checkParameterType)(fe, "boolean"), ne() !== fe && (fe && P(Q, w[Q].lastEnabledIndex), fe || (w[Q].lastEnabledIndex = X(Q), G ? P(Q, -1) : $ = !0));
              }
              function ne() {
                var Q = !0;
                return J && !ae && (Q = !1), Q;
              }
              function x(Q) {
                (0, N.checkParameterType)(Q, "boolean"), ae = Q;
              }
              function P(Q, fe) {
                J = fe === -1, J && D && D.saveTextSettingsDisabled();
                var ue = X(Q);
                if (!(ue === fe || !k[Q])) {
                  k[Q].disableManualTracks(), k[Q].setModeForTrackIdx(ue, h.default.TEXT_HIDDEN), k[Q].setCurrentTrackIdx(fe), k[Q].setModeForTrackIdx(fe, h.default.TEXT_SHOWING);
                  var q = k[Q].getCurrentTrackInfo();
                  q && q.isFragmented && !q.isEmbedded ? B(Q, q, ue) : q && !q.isFragmented && W(Q, q), D.setTrack(q);
                }
              }
              function B(Q, fe, ue) {
                if (F[Q])
                  for (var q = F[Q].getConfig(), _e = q.fragmentedTracks, ge = 0; ge < _e.length; ge++) {
                    var Ce = _e[ge];
                    if (fe.lang === Ce.lang && (Ce.id ? fe.id === Ce.id : fe.index === Ce.index)) {
                      var Ee = D.getCurrentTrackFor(h.default.TEXT, Q);
                      (Ce.id ? Ee.id !== Ce.id : Ee.index !== Ce.index) ? (k[Q].deleteCuesFromTrackIdx(ue), F[Q].setCurrentFragmentedTrackIdx(ge)) : ue === -1 && j.trigger(b.default.SET_FRAGMENTED_TEXT_AFTER_DISABLED, {}, {
                        streamId: Q,
                        mediaType: h.default.TEXT
                      });
                    }
                  }
              }
              function W(Q, fe) {
                j.trigger(b.default.SET_NON_FRAGMENTED_TEXT, {
                  currentTrackInfo: fe
                }, {
                  streamId: Q,
                  mediaType: h.default.TEXT
                });
              }
              function X(Q) {
                return k[Q].getCurrentTrackIdx();
              }
              function K(Q) {
                if (Q) {
                  var fe = Q.id;
                  F[fe] && F[fe].resetMediaInfos(), k[fe] && k[fe].deleteAllTextTracks();
                }
              }
              function U() {
                F = {}, k = {}, w = {}, J = !0, G = !1, $ = !1;
              }
              function V() {
                U(), j.off(b.default.TEXT_TRACKS_QUEUE_INITIALIZED, se, I), C.get().streaming.text.webvtt.customRenderingEnabled && (j.off(b.default.PLAYBACK_TIME_UPDATED, ee, I), j.off(b.default.PLAYBACK_SEEKING, te, I)), Object.keys(F).forEach(function(Q) {
                  F[Q].resetEmbedded(), F[Q].reset();
                });
              }
              return I = {
                deactivateStream: K,
                initialize: re,
                initializeForStream: ce,
                createTracks: z,
                getTextSourceBuffer: de,
                getAllTracksAreDisabled: pe,
                addEmbeddedTrack: he,
                enableText: le,
                isTextEnabled: ne,
                setTextTrack: P,
                getCurrentTrackIdx: X,
                enableForcedTextStreaming: x,
                addMediaInfosToBuffer: oe,
                reset: V
              }, ie(), I;
            }
            T.__dashjs_factory_name = "TextController";
            const R = f.default.getClassFactory(T);
          }
        ),
        /***/
        "./src/streaming/text/TextSourceBuffer.js": (
          /*!************************************************!*\
            !*** ./src/streaming/text/TextSourceBuffer.js ***!
            \************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => _
              /* harmony export */
            });
            var h = i(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), f = i(
              /*! ../vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            ), p = i(
              /*! ../vo/TextTrackInfo */
              "./src/streaming/vo/TextTrackInfo.js"
            ), d = i(
              /*! ../utils/BoxParser */
              "./src/streaming/utils/BoxParser.js"
            ), v = i(
              /*! ../utils/CustomTimeRanges */
              "./src/streaming/utils/CustomTimeRanges.js"
            ), g = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), m = i(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), A = i(
              /*! ./EmbeddedTextHtmlRender */
              "./src/streaming/text/EmbeddedTextHtmlRender.js"
            ), b = i(
              /*! codem-isoboxer */
              "./node_modules/codem-isoboxer/dist/iso_boxer.js"
            ), S = i(
              /*! ../../../externals/cea608-parser */
              "./externals/cea608-parser.js"
            ), N = /* @__PURE__ */ i.n(S), T = i(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), R = i(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), y = i(
              /*! ../vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), E = i(
              /*! ../../core/errors/Errors */
              "./src/core/errors/Errors.js"
            );
            function L(O) {
              var D = O.errHandler, M = O.manifestModel, C = O.mediaController, I = O.videoModel, w = O.textTracks, F = O.vttParser, k = O.vttCustomRenderingParser, H = O.ttmlParser, Z = O.streamInfo, Y = O.settings, j = this.context, J = (0, T.default)(j).getInstance(), ae = !1, G, $, ie, re, ce, z, oe, de, pe, he, se, ee, te, le, ne, x;
              function P() {
                $ = (0, m.default)(j).getInstance().getLogger(G), ie = (0, d.default)(j).getInstance(), X();
              }
              function B() {
                return Z.id;
              }
              function W() {
                z = null, de = NaN, pe = [], he = null, oe = !1;
              }
              function X() {
                W(), ce = [], re = null;
              }
              function K() {
                ae || q();
              }
              function U(Je, Te, me) {
                if (ce = ce.concat(Te), Je === h.default.TEXT && Te[0].isFragmented && !Te[0].isEmbedded) {
                  z = me, G.buffered = (0, v.default)(j).create(), pe = C.getTracksFor(h.default.TEXT, Z.id).filter(function(Ze) {
                    return Ze.isFragmented;
                  });
                  for (var Me = C.getCurrentTrackFor(h.default.TEXT, Z.id), Be = 0; Be < pe.length; Be++)
                    if (pe[Be] === Me) {
                      Ee(Be);
                      break;
                    }
                }
                for (var Fe = 0; Fe < Te.length; Fe++)
                  V(Te[Fe]);
              }
              function V(Je) {
                var Te = new p.default(), me = {
                  subtitle: "subtitles",
                  caption: "captions"
                };
                for (var Me in Je)
                  Te[Me] = Je[Me];
                Te.labels = Je.labels, Te.defaultTrack = nt(Je), Te.isFragmented = Je.isFragmented, Te.isEmbedded = !!Je.isEmbedded, Te.isTTML = Re(Je), Te.kind = Pe(Je, me), w.addTextTrack(Te);
              }
              function Q() {
              }
              function fe() {
                X(), ce = [], ie = null;
              }
              function ue(Je) {
                var Te = Je.chunk;
                Te.mediaInfo.embeddedCaptions && ke(Te.bytes, Te);
              }
              function q() {
                ee = [], se = null, te = 0, ne = [], le = null, ae = !0, x = (0, A.default)(j).getInstance(), J.on(R.default.VIDEO_CHUNK_RECEIVED, ue, G), J.on(R.default.BUFFER_CLEARED, vt, G);
              }
              function _e() {
                J.off(R.default.VIDEO_CHUNK_RECEIVED, ue, G), J.off(R.default.BUFFER_CLEARED, vt, G), w && w.deleteAllTextTracks(), ae = !1, ee = [], ne = [null, null], le = null;
              }
              function ge(Je) {
                if (ae && Je)
                  if (Je.id === h.default.CC1 || Je.id === h.default.CC3) {
                    for (var Te = 0; Te < ee.length; Te++)
                      if (ee[Te].id === Je.id)
                        return;
                    ee.push(Je);
                  } else
                    $.warn("Embedded track " + Je.id + " not supported!");
              }
              function Ce() {
                var Je = {
                  fragmentModel: z,
                  fragmentedTracks: pe,
                  videoModel: I
                };
                return Je;
              }
              function Ee(Je) {
                se = Je;
              }
              function Re(Je) {
                return Je.codec && Je.codec.search(h.default.STPP) >= 0 || Je.mimeType && Je.mimeType.search(h.default.TTML) >= 0;
              }
              function Pe(Je, Te) {
                var me = Je.roles && Je.roles.length > 0 ? Te[Je.roles[0]] : Te.caption;
                return me = me === Te.caption || me === Te.subtitle ? me : Te.caption, me;
              }
              function ke(Je, Te) {
                var me = Te.mediaInfo, Me = me.type, Be = me.mimeType, Fe = me.codec || Be;
                if (!Fe) {
                  $.error("No text type defined");
                  return;
                }
                me.codec.indexOf("application/mp4") !== -1 ? De(Je, Te, Fe) : Me === h.default.VIDEO ? it(Je, Te) : Xe(Je, Te, Fe);
              }
              function De(Je, Te, me) {
                var Me, Be;
                if (Te.segmentType === "InitializationSegment")
                  oe = !0, de = ie.getMediaTimescaleFromMoov(Je);
                else {
                  if (!oe)
                    return;
                  Be = ie.getSamplesInfo(Je), Me = Be.sampleList, Me.length > 0 && (he = Me[0].cts - Te.start * de), me.search(h.default.STPP) >= 0 ? Ae(Je, Me, me) : Ie(Je, Me);
                }
              }
              function Ae(Je, Te, me) {
                var Me, Be;
                for (re = re !== null ? re : ut(me), Me = 0; Me < Te.length; Me++) {
                  var Fe = Te[Me], Ze = Fe.cts, ot = $e(), tt = ot + Ze / de, gt = tt + Fe.duration / de;
                  G.buffered.add(tt, gt);
                  var Mt = new DataView(Je, Fe.offset, Fe.subSizes[0]), xt = b.Utils.dataViewToString(Mt, h.default.UTF8), be = [], We = Fe.offset + Fe.subSizes[0];
                  for (Be = 1; Be < Fe.subSizes.length; Be++) {
                    var et = new Uint8Array(Je, We, Fe.subSizes[Be]), _t = String.fromCharCode.apply(null, et);
                    be.push(_t), We += Fe.subSizes[Be];
                  }
                  try {
                    var ht = M.getValue(), St = ht.ttmlTimeIsRelative ? Ze / de : 0, kt = re.parse(xt, St, Ze / de, (Ze + Fe.duration) / de, be);
                    w.addCaptions(se, ot, kt);
                  } catch (Qt) {
                    z.removeExecutedRequestsBeforeTime(), this.remove(), $.error("TTML parser error: " + Qt.message);
                  }
                }
              }
              function Ie(Je, Te) {
                var me, Me, Be, Fe = [];
                for (me = 0; me < Te.length; me++) {
                  var Ze = Te[me];
                  Ze.cts -= he;
                  var ot = $e(), tt = ot + Ze.cts / de, gt = tt + Ze.duration / de;
                  G.buffered.add(tt, gt);
                  var Mt = Je.slice(Ze.offset, Ze.offset + Ze.size), xt = b.parseBuffer(Mt);
                  for (Me = 0; Me < xt.boxes.length; Me++) {
                    var be = xt.boxes[Me];
                    if ($.debug("VTT box1: " + be.type), be.type !== "vtte" && be.type === "vttc")
                      for ($.debug("VTT vttc boxes.length = " + be.boxes.length), Be = 0; Be < be.boxes.length; Be++) {
                        var We = be.boxes[Be];
                        if ($.debug("VTT box2: " + We.type), We.type === "payl") {
                          var et = We.cue_text;
                          $.debug("VTT cue_text = " + et);
                          var _t = Ze.cts / de, ht = (Ze.cts + Ze.duration) / de;
                          Fe.push({
                            start: _t,
                            end: ht,
                            data: et,
                            styles: {}
                          }), $.debug("VTT " + _t + "-" + ht + " : " + et);
                        }
                      }
                  }
                }
                Fe.length > 0 && w.addCaptions(se, 0, Fe);
              }
              function Xe(Je, Te, me) {
                var Me, Be, Fe = new DataView(Je, 0, Je.byteLength);
                Be = b.Utils.dataViewToString(Fe, h.default.UTF8);
                try {
                  Me = ut(me).parse(Be, 0), w.addCaptions(w.getCurrentTrackIdx(), 0, Me), G.buffered && G.buffered.add(Te.start, Te.end);
                } catch (Ze) {
                  D.error(new y.default(E.default.TIMED_TEXT_ERROR_ID_PARSE_CODE, E.default.TIMED_TEXT_ERROR_MESSAGE_PARSE + Ze.message, Be));
                }
              }
              function it(Je, Te) {
                var me, Me;
                if (Te.segmentType === f.HTTPRequest.INIT_SEGMENT_TYPE)
                  te === 0 && (te = ie.getMediaTimescaleFromMoov(Je));
                else if (Te.segmentType === f.HTTPRequest.MEDIA_SEGMENT_TYPE) {
                  if (te === 0) {
                    $.warn("CEA-608: No timescale for embeddedTextTrack yet");
                    return;
                  }
                  Me = ie.getSamplesInfo(Je);
                  var Be = Me.lastSequenceNumber;
                  if (!ne[0] && !ne[1] && rt(), te) {
                    if (le !== null && Be !== le + Me.numSequences)
                      for (me = 0; me < ne.length; me++)
                        ne[me] && ne[me].reset();
                    for (var Fe = He(Je, Me.sampleList), Ze = 0; Ze < ne.length; Ze++) {
                      var ot = Fe.fields[Ze], tt = ne[Ze];
                      if (tt)
                        for (me = 0; me < ot.length; me++)
                          tt.addData(ot[me][0] / te, ot[me][1]);
                    }
                    le = Be;
                  }
                }
              }
              function rt() {
                for (var Je, Te = 0; Te < ee.length; Te++) {
                  if (Je = w.getTrackIdxForId(ee[Te].id), Je === -1) {
                    $.warn("CEA-608: data before track is ready.");
                    return;
                  }
                  var me = Ne(Je);
                  ne[Te] = new (N()).Cea608Parser(Te + 1, {
                    newCue: me
                  }, null);
                }
              }
              function Ne(Je) {
                function Te(me, Me, Be) {
                  var Fe;
                  if (I.getTTMLRenderingDiv())
                    Fe = x.createHTMLCaptionsFromScreen(I.getElement(), me, Me, Be);
                  else {
                    var Ze = Be.getDisplayText();
                    Fe = [{
                      start: me,
                      end: Me,
                      data: Ze,
                      styles: {}
                    }];
                  }
                  Fe && w.addCaptions(Je, 0, Fe);
                }
                return Te;
              }
              function He(Je, Te) {
                if (Te.length === 0)
                  return null;
                for (var me = {
                  splits: [],
                  fields: [[], []]
                }, Me = new DataView(Je), Be = 0; Be < Te.length; Be++)
                  for (var Fe = Te[Be], Ze = N().findCea608Nalus(Me, Fe.offset, Fe.size), ot = null, tt = 0, gt = 0; gt < Ze.length; gt++)
                    for (var Mt = N().extractCea608DataFromRange(Me, Ze[gt]), xt = 0; xt < 2; xt++)
                      if (Mt[xt].length > 0) {
                        Fe.cts !== ot ? tt = 0 : tt += 1;
                        var be = $e();
                        me.fields[xt].push([Fe.cts + be * te, Mt[xt], tt]), ot = Fe.cts;
                      }
                return me.fields.forEach(function(et) {
                  et.sort(function(_t, ht) {
                    return _t[0] === ht[0] ? _t[2] - ht[2] : _t[0] - ht[0];
                  });
                }), me;
              }
              function $e() {
                return isNaN(G.timestampOffset) ? 0 : G.timestampOffset;
              }
              function nt(Je) {
                var Te = !1;
                return ee.length > 1 && Je.isEmbedded ? Te = Je.id && Je.id === h.default.CC1 : ee.length === 1 ? Je.id && typeof Je.id == "string" && Je.id.substring(0, 2) === "CC" && (Te = !0) : ee.length === 0 && (Te = Je.index === ce[0].index), Te;
              }
              function ut(Je) {
                var Te;
                return Je.search(h.default.VTT) >= 0 ? Te = Y.get().streaming.text.webvtt.customRenderingEnabled && k ? k : F : (Je.search(h.default.TTML) >= 0 || Je.search(h.default.STPP) >= 0) && (Te = H), Te;
              }
              function pt(Je, Te) {
                Je === void 0 && Je === Te && (Je = G.buffered.start(0), Te = G.buffered.end(G.buffered.length - 1)), G.buffered.remove(Je, Te), w.deleteCuesFromTrackIdx(se, Je, Te);
              }
              function vt(Je) {
                ee.forEach(function(Te) {
                  var me = w.getTrackIdxForId(Te.id);
                  me >= 0 && w.deleteCuesFromTrackIdx(me, Je.from, Je.to);
                });
              }
              function Ut() {
                ce = [];
              }
              return G = {
                initialize: K,
                addMediaInfos: U,
                resetMediaInfos: Ut,
                getStreamId: B,
                append: ke,
                abort: Q,
                addEmbeddedTrack: ge,
                resetEmbedded: _e,
                getConfig: Ce,
                setCurrentFragmentedTrackIdx: Ee,
                remove: pt,
                reset: fe
              }, P(), G;
            }
            L.__dashjs_factory_name = "TextSourceBuffer";
            const _ = g.default.getClassFactory(L);
          }
        ),
        /***/
        "./src/streaming/text/TextTracks.js": (
          /*!******************************************!*\
            !*** ./src/streaming/text/TextTracks.js ***!
            \******************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => R
              /* harmony export */
            });
            var h = i(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), f = i(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), p = i(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), d = i(
              /*! ../../streaming/MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), v = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), g = i(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), m = i(
              /*! imsc */
              "./node_modules/imsc/src/main/js/main.js"
            );
            function A(y, E) {
              var L;
              if (typeof Symbol > "u" || y[Symbol.iterator] == null) {
                if (Array.isArray(y) || (L = b(y)) || E && y && typeof y.length == "number") {
                  L && (y = L);
                  var _ = 0, O = function() {
                  };
                  return { s: O, n: function() {
                    return _ >= y.length ? { done: !0 } : { done: !1, value: y[_++] };
                  }, e: function(w) {
                    throw w;
                  }, f: O };
                }
                throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
              var D = !0, M = !1, C;
              return { s: function() {
                L = y[Symbol.iterator]();
              }, n: function() {
                var w = L.next();
                return D = w.done, w;
              }, e: function(w) {
                M = !0, C = w;
              }, f: function() {
                try {
                  !D && L.return != null && L.return();
                } finally {
                  if (M)
                    throw C;
                }
              } };
            }
            function b(y, E) {
              if (y) {
                if (typeof y == "string")
                  return S(y, E);
                var L = Object.prototype.toString.call(y).slice(8, -1);
                if (L === "Object" && y.constructor && (L = y.constructor.name), L === "Map" || L === "Set")
                  return Array.from(y);
                if (L === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(L))
                  return S(y, E);
              }
            }
            function S(y, E) {
              (E == null || E > y.length) && (E = y.length);
              for (var L = 0, _ = new Array(E); L < E; L++)
                _[L] = y[L];
              return _;
            }
            var N = ["text", "images", "embeddedImages", "align", "fontSize", "id", "isd", "line", "lineAlign", "lineHeight", "linePadding", "position", "positionAlign", "region", "size", "snapToLines", "vertical"];
            function T(y) {
              var E = this.context, L = (0, f.default)(E).getInstance(), _ = y.videoModel, O = y.streamInfo, D = y.settings, M, C, I, w, F, k, H, Z, Y, j, J, ae, G, $, ie, re, ce, z;
              function oe() {
                C = (0, g.default)(E).getInstance().getLogger(M);
              }
              function de() {
                typeof window > "u" || typeof navigator > "u" || (I = window.VTTCue || window.TextTrackCue, w = [], F = [], k = -1, H = 0, Z = 0, Y = 0, j = 0, J = null, ae = null, G = null, ie = !1, ce = 2147483647, re = null, document.fullscreenElement !== void 0 ? $ = "fullscreenElement" : document.webkitIsFullScreen !== void 0 ? $ = "webkitIsFullScreen" : document.msFullscreenElement ? $ = "msFullscreenElement" : document.mozFullScreen && ($ = "mozFullScreen"));
              }
              function pe() {
                return O.id;
              }
              function he(Ne) {
                var He = Ne.kind, $e = Ne.id !== void 0 ? Ne.id : Ne.lang, nt = Ne.lang, ut = Ne.isTTML, pt = Ne.isEmbedded, vt = _.addTextTrack(He, $e, nt, ut, pt);
                return vt;
              }
              function se(Ne) {
                w.push(Ne);
              }
              function ee() {
                w.sort(function(Ut, Je) {
                  return Ut.index - Je.index;
                }), J = _.getTTMLRenderingDiv(), ae = _.getVttRenderingDiv();
                for (var Ne = -1, He = 0; He < w.length; He++) {
                  var $e = he(w[He]);
                  F.push($e), w[He].defaultTrack && ($e.default = !0, Ne = He);
                  var nt = fe(He);
                  nt && (nt.mode = h.default.TEXT_SHOWING, J && (w[He].isTTML || w[He].isEmbedded) ? nt.renderingType = "html" : nt.renderingType = "default"), W(He, 0, w[He].captionData), L.trigger(d.default.TEXT_TRACK_ADDED);
                }
                if (_e.call(this, Ne), Ne >= 0) {
                  var ut = function Ut() {
                    var Je = fe(Ne);
                    Je && Je.renderingType === "html" && le.call(this, Je, !0), L.off(d.default.PLAYBACK_METADATA_LOADED, Ut, this);
                  };
                  L.on(d.default.PLAYBACK_METADATA_LOADED, ut, this);
                  for (var pt = 0; pt < w.length; pt++) {
                    var vt = fe(pt);
                    vt && (vt.mode = pt === Ne ? h.default.TEXT_SHOWING : h.default.TEXT_HIDDEN, vt.manualMode = pt === Ne ? h.default.TEXT_SHOWING : h.default.TEXT_HIDDEN);
                  }
                }
                L.trigger(p.default.TEXT_TRACKS_QUEUE_INITIALIZED, {
                  index: k,
                  tracks: w,
                  streamId: O.id
                });
              }
              function te(Ne, He, $e, nt, ut, pt) {
                var vt = Ne / He, Ut = $e / nt, Je = 0, Te = 0;
                vt > Ut ? (Te = He, Je = Te / nt * $e) : (Je = Ne, Te = Je / $e * nt);
                var me = 0, Me = 0, Be = 0, Fe = 0, Ze = Je / Te;
                return Ze > ut ? (Fe = Te, Be = Te * ut) : (Be = Je, Fe = Je / ut), me = (Ne - Be) / 2, Me = (He - Fe) / 2, pt ? {
                  x: me + Be * 0.1,
                  y: Me + Fe * 0.1,
                  w: Be * 0.8,
                  h: Fe * 0.8
                } : {
                  x: me,
                  y: Me,
                  w: Be,
                  h: Fe
                };
              }
              function le(Ne, He) {
                var $e = _.getClientWidth(), nt = _.getClientHeight(), ut = _.getVideoWidth(), pt = _.getVideoHeight(), vt = _.getVideoRelativeOffsetTop(), Ut = _.getVideoRelativeOffsetLeft();
                if (ut !== 0 && pt !== 0) {
                  var Je = ut / pt, Te = !1;
                  Ne.isFromCEA608 && (Je = 1.1666666666666667, Te = !0);
                  var me = te.call(this, $e, nt, ut, pt, Je, Te), Me = me.w, Be = me.h, Fe = me.x, Ze = me.y;
                  if (Me != Y || Be != j || Fe != H || Ze != Z || He) {
                    if (H = Fe + Ut, Z = Ze + vt, Y = Me, j = Be, J) {
                      var ot = J.style;
                      ot && (ot.left = H + "px", ot.top = Z + "px", ot.width = Y + "px", ot.height = j + "px", ot.zIndex = $ && document[$] || ie ? ce : null, L.trigger(d.default.CAPTION_CONTAINER_RESIZE));
                    }
                    var tt = Ne.activeCues;
                    if (tt)
                      for (var gt = tt.length, Mt = 0; Mt < gt; ++Mt) {
                        var xt = tt[Mt];
                        xt.scaleCue(xt);
                      }
                  }
                }
              }
              function ne(Ne) {
                var He = Y, $e = j, nt, ut, pt, vt, Ut;
                if (Ne.cellResolution) {
                  var Je = [He / Ne.cellResolution[0], $e / Ne.cellResolution[1]];
                  if (Ne.linePadding) {
                    for (nt in Ne.linePadding)
                      if (Ne.linePadding.hasOwnProperty(nt)) {
                        var Te = Ne.linePadding[nt];
                        ut = (Te * Je[0]).toString();
                        for (var me = document.getElementsByClassName("spanPadding"), Me = 0; Me < me.length; Me++)
                          me[Me].style.cssText = me[Me].style.cssText.replace(/(padding-left\s*:\s*)[\d.,]+(?=\s*px)/gi, "$1" + ut), me[Me].style.cssText = me[Me].style.cssText.replace(/(padding-right\s*:\s*)[\d.,]+(?=\s*px)/gi, "$1" + ut);
                      }
                  }
                  if (Ne.fontSize) {
                    for (nt in Ne.fontSize)
                      if (Ne.fontSize.hasOwnProperty(nt)) {
                        Ne.fontSize[nt][0] === "%" ? pt = Ne.fontSize[nt][1] / 100 : Ne.fontSize[nt][0] === "c" && (pt = Ne.fontSize[nt][1]), ut = (pt * Je[1]).toString(), nt !== "defaultFontSize" ? Ut = document.getElementsByClassName(nt) : Ut = document.getElementsByClassName("paragraph");
                        for (var Be = 0; Be < Ut.length; Be++)
                          Ut[Be].style.cssText = Ut[Be].style.cssText.replace(/(font-size\s*:\s*)[\d.,]+(?=\s*px)/gi, "$1" + ut);
                      }
                    if (Ne.lineHeight) {
                      for (nt in Ne.lineHeight)
                        if (Ne.lineHeight.hasOwnProperty(nt)) {
                          Ne.lineHeight[nt][0] === "%" ? vt = Ne.lineHeight[nt][1] / 100 : Ne.fontSize[nt][0] === "c" && (vt = Ne.lineHeight[nt][1]), ut = (vt * Je[1]).toString(), Ut = document.getElementsByClassName(nt);
                          for (var Fe = 0; Fe < Ut.length; Fe++)
                            Ut[Fe].style.cssText = Ut[Fe].style.cssText.replace(/(line-height\s*:\s*)[\d.,]+(?=\s*px)/gi, "$1" + ut);
                        }
                    }
                  }
                }
                if (Ne.isd) {
                  var Ze = document.getElementById(Ne.cueID);
                  Ze && J.removeChild(Ze), x(Ne);
                }
              }
              function x(Ne) {
                if (J) {
                  var He = document.createElement("div");
                  J.appendChild(He), re = (0, m.renderHTML)(
                    Ne.isd,
                    He,
                    function($e) {
                      var nt = /^(urn:)(mpeg:[a-z0-9][a-z0-9-]{0,31}:)(subs:)([0-9]+)$/, ut = /^#(.*)$/;
                      if (nt.test($e)) {
                        var pt = nt.exec($e), vt = parseInt(pt[4], 10) - 1, Ut = btoa(Ne.images[vt]), Je = "data:image/png;base64," + Ut;
                        return Je;
                      } else if (ut.test($e)) {
                        var Te = ut.exec($e), me = Te[1], Me = "data:image/png;base64," + Ne.embeddedImages[me];
                        return Me;
                      } else
                        return null;
                    },
                    J.clientHeight,
                    J.clientWidth,
                    !1,
                    function($e) {
                      C.info("renderCaption :", $e);
                    },
                    re,
                    !0
                    /*enableRollUp*/
                  ), He.id = Ne.cueID, L.trigger(d.default.CAPTION_RENDERED, {
                    captionDiv: He,
                    currentTrackIdx: k
                  });
                }
              }
              function P(Ne, He) {
                if (!D.get().streaming.text.extendSegmentedCues || !He.cues || He.cues.length === 0)
                  return !1;
                var $e = He.cues[He.cues.length - 1];
                return $e.endTime !== Ne.startTime || !B($e, Ne, N) ? !1 : ($e.endTime = Ne.endTime, !0);
              }
              function B(Ne, He, $e) {
                for (var nt = 0; nt < $e.length; nt++) {
                  var ut = $e[nt];
                  if (JSON.stringify(Ne[ut]) !== JSON.stringify(He[ut]))
                    return !1;
                }
                return !0;
              }
              function W(Ne, He, $e) {
                var nt = fe(Ne);
                if (nt && !(!Array.isArray($e) || $e.length === 0))
                  for (var ut = 0; ut < $e.length; ut++) {
                    var pt = void 0, vt = $e[ut];
                    nt.cellResolution = vt.cellResolution, nt.isFromCEA608 = vt.isFromCEA608, !isNaN(vt.start) && !isNaN(vt.end) && (pt = vt.type === "html" && J ? X(vt, He, nt) : vt.data ? K(vt, He, nt) : null);
                    try {
                      pt ? Ce(nt, pt) || (D.get().streaming.text.webvtt.customRenderingEnabled ? (nt.manualCueList || (nt.manualCueList = []), nt.manualCueList.push(pt)) : P(pt, nt) || nt.addCue(pt)) : C.error("Impossible to display subtitles. You might have missed setting a TTML rendering div via player.attachTTMLRenderingDiv(TTMLRenderingDiv)");
                    } catch (Ut) {
                      throw Re(nt), nt.addCue(pt), Ut;
                    }
                  }
              }
              function X(Ne, He, $e) {
                var nt = this, ut = new I(Ne.start + He, Ne.end + He, "");
                return ut.cueHTMLElement = Ne.cueHTMLElement, ut.isd = Ne.isd, ut.images = Ne.images, ut.embeddedImages = Ne.embeddedImages, ut.cueID = Ne.cueID, ut.scaleCue = ne.bind(nt), ut.cellResolution = Ne.cellResolution, ut.lineHeight = Ne.lineHeight, ut.linePadding = Ne.linePadding, ut.fontSize = Ne.fontSize, J.style.left = H + "px", J.style.top = Z + "px", J.style.width = Y + "px", J.style.height = j + "px", ut.onenter = function() {
                  $e.mode === h.default.TEXT_SHOWING && (this.isd ? (x(this), C.debug("Cue enter id:" + this.cueID)) : (J.appendChild(this.cueHTMLElement), ne.call(nt, this), L.trigger(d.default.CAPTION_RENDERED, {
                    captionDiv: this.cueHTMLElement,
                    currentTrackIdx: k
                  })));
                }, ut.onexit = function() {
                  if (J)
                    for (var pt = J.childNodes, vt = 0; vt < pt.length; ++vt)
                      pt[vt].id === this.cueID && (C.debug("Cue exit id:" + pt[vt].id), J.removeChild(pt[vt]), --vt);
                }, ut;
              }
              function K(Ne, He, $e) {
                var nt = new I(Ne.start - He, Ne.end - He, Ne.data);
                if (nt.cueID = "".concat(nt.startTime, "_").concat(nt.endTime), nt.isActive = !1, Ne.styles)
                  try {
                    Ne.styles.align !== void 0 && "align" in nt && (nt.align = Ne.styles.align), Ne.styles.line !== void 0 && "line" in nt && (nt.line = Ne.styles.line), Ne.styles.position !== void 0 && "position" in nt && (nt.position = Ne.styles.position), Ne.styles.size !== void 0 && "size" in nt && (nt.size = Ne.styles.size);
                  } catch (ut) {
                    C.error(ut);
                  }
                return nt.onenter = function() {
                  $e.mode === h.default.TEXT_SHOWING && L.trigger(d.default.CAPTION_RENDERED, {
                    currentTrackIdx: k
                  });
                }, nt;
              }
              function U(Ne) {
                var He = Q();
                if (He && He.length > 0) {
                  var $e = He[0], nt = $e.manualCueList;
                  nt && nt.length > 0 && nt.forEach(function(ut) {
                    if (ut.startTime <= Ne && ut.endTime >= Ne && !ut.isActive)
                      ut.isActive = !0, WebVTT.processCues(window, [ut], ae, ut.cueID);
                    else if (ut.isActive && (ut.startTime > Ne || ut.endTime < Ne) && (ut.isActive = !1, ae))
                      for (var pt = ae.childNodes, vt = 0; vt < pt.length; ++vt)
                        pt[vt].id === ut.cueID && (ae.removeChild(pt[vt]), --vt);
                  });
                }
              }
              function V() {
                var Ne = Q();
                if (Ne && Ne.length > 0) {
                  var He = Ne[0], $e = He.manualCueList;
                  $e && $e.length > 0 && $e.forEach(function(nt) {
                    if (nt.isActive && (nt.isActive = !1, ae))
                      for (var ut = ae.childNodes, pt = 0; pt < ut.length; ++pt)
                        ut[pt].id === nt.cueID && (ae.removeChild(ut[pt]), --pt);
                  });
                }
              }
              function Q() {
                var Ne = _.getTextTracks(), He = [], $e = A(Ne), nt;
                try {
                  for ($e.s(); !(nt = $e.n()).done; ) {
                    var ut = nt.value;
                    ut.manualMode === h.default.TEXT_SHOWING && He.push(ut);
                  }
                } catch (pt) {
                  $e.e(pt);
                } finally {
                  $e.f();
                }
                return He;
              }
              function fe(Ne) {
                return Ne >= 0 && w[Ne] ? _.getTextTrack(w[Ne].kind, w[Ne].id, w[Ne].lang, w[Ne].isTTML, w[Ne].isEmbedded) : null;
              }
              function ue() {
                return k;
              }
              function q(Ne) {
                for (var He = -1, $e = 0; $e < w.length; $e++)
                  if (w[$e].id === Ne) {
                    He = $e;
                    break;
                  }
                return He;
              }
              function _e(Ne) {
                var He = this;
                if (Ne !== k) {
                  k = Ne;
                  var $e = fe(k);
                  ge.call(this, $e), G && (clearInterval(G), G = null), $e && $e.renderingType === "html" && (le.call(this, $e, !0), window.ResizeObserver ? (z = new window.ResizeObserver(function() {
                    le.call(He, $e, !0);
                  }), z.observe(_.getElement())) : G = setInterval(le.bind(this, $e), 500));
                }
              }
              function ge(Ne) {
                Xe.call(this), Ne ? Ne.renderingType === "html" ? Ae.call(this) : Ie.call(this) : Ie.call(this);
              }
              function Ce(Ne, He) {
                if (!Ne.cues)
                  return !1;
                for (var $e = 0; $e < Ne.cues.length; $e++)
                  if (Ne.cues[$e].startTime === He.startTime && Ne.cues[$e].endTime === He.endTime)
                    return !0;
                return !1;
              }
              function Ee(Ne, He, $e) {
                var nt = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0;
                return (isNaN(He) || (nt ? Ne.startTime : Ne.endTime) >= He) && (isNaN($e) || (nt ? Ne.endTime : Ne.startTime) <= $e);
              }
              function Re(Ne, He, $e) {
                var nt = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0;
                if (Ne.cues)
                  for (var ut = Ne.cues, pt = ut.length - 1, vt = pt; vt >= 0; vt--)
                    Ee(ut[vt], He, $e, nt) && (ut[vt].onexit && ut[vt].onexit(), Ne.removeCue(ut[vt]));
              }
              function Pe(Ne, He, $e) {
                var nt = fe(Ne);
                nt && Re(nt, He, $e);
              }
              function ke() {
                for (var Ne = F ? F.length : 0, He = 0; He < Ne; He++) {
                  var $e = fe(He);
                  $e && Re.call(this, $e, O.start, O.start + O.duration, !1);
                }
                F = [], w = [], G && (clearInterval(G), G = null), z && _ && (z.unobserve(_.getElement()), z = null), k = -1, Xe.call(this);
              }
              function De(Ne) {
                _.removeChild(F[Ne]), F.splice(Ne, 1);
              }
              function Ae() {
                var Ne = document.getElementById("native-cue-style");
                if (!Ne) {
                  Ne = document.createElement("style"), Ne.id = "native-cue-style", document.head.appendChild(Ne);
                  var He = Ne.sheet, $e = _.getElement();
                  try {
                    $e && ($e.id ? He.insertRule("#" + $e.id + "::cue {background: transparent}", 0) : $e.classList.length !== 0 ? He.insertRule("." + $e.className + "::cue {background: transparent}", 0) : He.insertRule("video::cue {background: transparent}", 0));
                  } catch (nt) {
                    C.info("" + nt.message);
                  }
                }
              }
              function Ie() {
                var Ne = document.getElementById("native-cue-style");
                Ne && document.head.removeChild(Ne);
              }
              function Xe() {
                if (J)
                  for (; J.firstChild; )
                    J.removeChild(J.firstChild);
              }
              function it(Ne, He) {
                var $e = fe(Ne);
                $e && $e.mode !== He && ($e.mode = He), $e && $e.manualMode !== He && ($e.manualMode = He);
              }
              function rt() {
                return w[k];
              }
              return M = {
                initialize: de,
                getStreamId: pe,
                addTextTrack: se,
                addCaptions: W,
                createTracks: ee,
                getCurrentTrackIdx: ue,
                setCurrentTrackIdx: _e,
                getTrackIdxForId: q,
                getCurrentTrackInfo: rt,
                setModeForTrackIdx: it,
                deleteCuesFromTrackIdx: Pe,
                deleteAllTextTracks: ke,
                deleteTextTrack: De,
                manualCueProcessing: U,
                disableManualTracks: V
              }, oe(), M;
            }
            T.__dashjs_factory_name = "TextTracks";
            const R = v.default.getClassFactory(T);
          }
        ),
        /***/
        "./src/streaming/thumbnail/ThumbnailController.js": (
          /*!********************************************************!*\
            !*** ./src/streaming/thumbnail/ThumbnailController.js ***!
            \********************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => A
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), p = i(
              /*! ../vo/Thumbnail */
              "./src/streaming/vo/Thumbnail.js"
            ), d = i(
              /*! ./ThumbnailTracks */
              "./src/streaming/thumbnail/ThumbnailTracks.js"
            ), v = i(
              /*! ../vo/BitrateInfo */
              "./src/streaming/vo/BitrateInfo.js"
            ), g = i(
              /*! ../../dash/utils/SegmentsUtils */
              "./src/dash/utils/SegmentsUtils.js"
            );
            function m(b) {
              var S = this.context, N = b.streamInfo, T, R;
              function y() {
                I(), R = (0, d.default)(S).create({
                  streamInfo: N,
                  adapter: b.adapter,
                  baseURLController: b.baseURLController,
                  timelineConverter: b.timelineConverter,
                  debug: b.debug,
                  eventBus: b.eventBus,
                  events: b.events,
                  dashConstants: b.dashConstants,
                  dashMetrics: b.dashMetrics,
                  segmentBaseController: b.segmentBaseController
                });
              }
              function E() {
                R.addTracks();
                var w = R.getTracks();
                w && w.length > 0 && D(0);
              }
              function L() {
                return N.id;
              }
              function _(w, F) {
                if (typeof F == "function") {
                  var k = R.getCurrentTrack(), H, Z;
                  if (!k || k.segmentDuration <= 0 || w === void 0 || w === null) {
                    F(null);
                    return;
                  }
                  Z = R.getThumbnailRequestForTime(w), Z && (k.segmentDuration = Z.duration), H = w % k.segmentDuration;
                  var Y = Math.floor(H * k.tilesHor * k.tilesVert / k.segmentDuration), j = new p.default();
                  if (j.width = Math.floor(k.widthPerTile), j.height = Math.floor(k.heightPerTile), j.x = Math.floor(Y % k.tilesHor) * k.widthPerTile, j.y = Math.floor(Y / k.tilesHor) * k.heightPerTile, "readThumbnail" in k)
                    return k.readThumbnail(w, function(ae) {
                      j.url = ae, F(j);
                    });
                  if (Z)
                    j.url = Z.url, k.segmentDuration = NaN;
                  else {
                    var J = Math.floor(w / k.segmentDuration);
                    j.url = O(k, J);
                  }
                  F(j);
                }
              }
              function O(w, F) {
                var k = F + w.startNumber, H = (0, g.replaceTokenForTemplate)(w.templateUrl, "Number", k);
                return H = (0, g.replaceTokenForTemplate)(H, "Time", (k - 1) * w.segmentDuration * w.timescale), H = (0, g.replaceTokenForTemplate)(H, "Bandwidth", w.bandwidth), (0, g.unescapeDollarsInTemplate)(H);
              }
              function D(w) {
                R.setTrackByIndex(w);
              }
              function M() {
                return R.getCurrentTrackIndex();
              }
              function C() {
                var w = R.getTracks(), F = 0;
                return w.map(function(k) {
                  var H = new v.default();
                  return H.mediaType = f.default.IMAGE, H.qualityIndex = F++, H.bitrate = k.bitrate, H.width = k.width, H.height = k.height, H;
                });
              }
              function I() {
                R && R.reset();
              }
              return T = {
                getStreamId: L,
                initialize: E,
                provide: _,
                setTrackByIndex: D,
                getCurrentTrackIndex: M,
                getBitrateList: C,
                reset: I
              }, y(), T;
            }
            m.__dashjs_factory_name = "ThumbnailController";
            const A = h.default.getClassFactory(m);
          }
        ),
        /***/
        "./src/streaming/thumbnail/ThumbnailTracks.js": (
          /*!****************************************************!*\
            !*** ./src/streaming/thumbnail/ThumbnailTracks.js ***!
            \****************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              THUMBNAILS_SCHEME_ID_URIS: () => (
                /* binding */
                N
              ),
              /* harmony export */
              default: () => R
              /* harmony export */
            });
            var h = i(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), f = i(
              /*! ../../dash/constants/DashConstants */
              "./src/dash/constants/DashConstants.js"
            ), p = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), d = i(
              /*! ../vo/ThumbnailTrackInfo */
              "./src/streaming/vo/ThumbnailTrackInfo.js"
            ), v = i(
              /*! ../../streaming/utils/URLUtils */
              "./src/streaming/utils/URLUtils.js"
            ), g = i(
              /*! ../../dash/utils/SegmentsUtils */
              "./src/dash/utils/SegmentsUtils.js"
            ), m = i(
              /*! ../../streaming/utils/BoxParser */
              "./src/streaming/utils/BoxParser.js"
            ), A = i(
              /*! ../../streaming/net/XHRLoader */
              "./src/streaming/net/XHRLoader.js"
            ), b = i(
              /*! ../../dash/DashHandler */
              "./src/dash/DashHandler.js"
            ), S = i(
              /*! ../../dash/controllers/SegmentsController */
              "./src/dash/controllers/SegmentsController.js"
            ), N = ["http://dashif.org/thumbnail_tile", "http://dashif.org/guidelines/thumbnail_tile"];
            function T(y) {
              var E = this.context, L = y.adapter, _ = y.baseURLController, O = y.streamInfo, D = y.timelineConverter, M = y.debug, C = y.eventBus, I = y.events, w = y.dashConstants, F = (0, v.default)(E).getInstance(), k, H, Z, Y, j, J, ae, G;
              function $() {
                te(), ae = (0, A.default)(E).create({}), G = (0, m.default)(E).getInstance(), J = (0, S.default)(E).create({
                  events: I,
                  eventBus: C,
                  streamInfo: O,
                  timelineConverter: D,
                  dashConstants: w,
                  dashMetrics: y.dashMetrics,
                  segmentBaseController: y.segmentBaseController,
                  type: h.default.IMAGE
                }), Z = (0, b.default)(E).create({
                  streamInfo: O,
                  type: h.default.IMAGE,
                  timelineConverter: D,
                  segmentsController: J,
                  baseURLController: _,
                  debug: M,
                  eventBus: C,
                  events: I,
                  dashConstants: w,
                  urlUtils: F
                }), Z.initialize(L ? L.getIsDynamic() : !1);
              }
              function ie() {
                if (!(!O || !L) && (j = L.getMediaInfoForType(O, h.default.IMAGE), !!j)) {
                  var le = L.getVoRepresentations(j);
                  le && le.length > 0 && le.forEach(function(ne) {
                    (ne.segmentInfoType === f.default.SEGMENT_TEMPLATE && ne.segmentDuration > 0 && ne.media || ne.segmentInfoType === f.default.SEGMENT_TIMELINE) && re(ne), ne.segmentInfoType === f.default.SEGMENT_BASE && re(ne, !0);
                  }), H.length > 0 && H.sort(function(ne, x) {
                    return ne.bitrate - x.bitrate;
                  });
                }
              }
              function re(le, ne) {
                var x = new d.default();
                x.id = le.id, x.bitrate = le.bandwidth, x.width = le.width, x.height = le.height, x.tilesHor = 1, x.tilesVert = 1, le.essentialProperties && le.essentialProperties.forEach(function(P) {
                  if (N.indexOf(P.schemeIdUri) >= 0 && P.value) {
                    var B = P.value.split("x");
                    B.length === 2 && !isNaN(B[0]) && !isNaN(B[1]) && (x.tilesHor = parseInt(B[0], 10), x.tilesVert = parseInt(B[1], 10));
                  }
                }), ne ? J.updateSegmentData(le).then(function(P) {
                  ce(x, le, P);
                }) : (x.startNumber = le.startNumber, x.segmentDuration = le.segmentDuration, x.timescale = le.timescale, x.templateUrl = oe(le)), x.tilesHor > 0 && x.tilesVert > 0 && (x.widthPerTile = x.width / x.tilesHor, x.heightPerTile = x.height / x.tilesVert, H.push(x));
              }
              function ce(le, ne, x) {
                var P = [], B = z(x, ne);
                ne.segments = B, le.segmentDuration = ne.segments[0].duration, le.readThumbnail = function(W, X) {
                  var K = null;
                  P.some(function(U) {
                    if (U.start <= W && U.end > W)
                      return K = U.url, !0;
                  }), K ? X(K) : ne.segments.some(function(U) {
                    if (U.mediaStartTime <= W && U.mediaStartTime + U.duration > W) {
                      var V = _.resolve(ne.path);
                      return ae.load({
                        method: "get",
                        url: V.url,
                        request: {
                          range: U.mediaRange,
                          responseType: "arraybuffer"
                        },
                        onload: function(fe) {
                          var ue = G.getSamplesInfo(fe.target.response), q = new Blob([fe.target.response.slice(ue.sampleList[0].offset, ue.sampleList[0].offset + ue.sampleList[0].size)], {
                            type: "image/jpeg"
                          }), _e = window.URL.createObjectURL(q);
                          P.push({
                            start: U.mediaStartTime,
                            end: U.mediaStartTime + U.duration,
                            url: _e
                          }), X && X(_e);
                        }
                      }), !0;
                    }
                  });
                };
              }
              function z(le, ne) {
                var x = [], P = 0, B, W, X, K;
                for (B = 0, W = le.segments.length; B < W; B++)
                  X = le.segments[B], K = (0, g.getTimeBasedSegment)(D, L.getIsDynamic(), ne, X.startTime, X.duration, X.timescale, X.media, X.mediaRange, P), K && (x.push(K), K = null, P++);
                return x;
              }
              function oe(le) {
                var ne = F.isRelative(le.media) ? F.resolve(le.media, _.resolve(le.path).url) : le.media;
                return ne ? (0, g.replaceIDForTemplate)(ne, le.id) : "";
              }
              function de() {
                return H;
              }
              function pe() {
                return Y;
              }
              function he() {
                return Y < 0 ? null : H[Y];
              }
              function se(le) {
                !H || H.length === 0 || (le >= H.length && (le = H.length - 1), Y = le);
              }
              function ee(le) {
                for (var ne, x = L.getVoRepresentations(j), P = 0; P < x.length; P++)
                  if (H[Y].id === x[P].id) {
                    ne = x[P];
                    break;
                  }
                return Z.getSegmentRequestForTime(j, ne, le);
              }
              function te() {
                H = [], Y = -1, j = null;
              }
              return k = {
                getTracks: de,
                addTracks: ie,
                reset: te,
                setTrackByIndex: se,
                getCurrentTrack: he,
                getCurrentTrackIndex: pe,
                getThumbnailRequestForTime: ee
              }, $(), k;
            }
            T.__dashjs_factory_name = "ThumbnailTracks";
            const R = p.default.getClassFactory(T);
          }
        ),
        /***/
        "./src/streaming/utils/BaseURLSelector.js": (
          /*!************************************************!*\
            !*** ./src/streaming/utils/BaseURLSelector.js ***!
            \************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => R
              /* harmony export */
            });
            var h = i(
              /*! ../../core/errors/Errors */
              "./src/core/errors/Errors.js"
            ), f = i(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), p = i(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), d = i(
              /*! ../controllers/BlacklistController */
              "./src/streaming/controllers/BlacklistController.js"
            ), v = i(
              /*! ./baseUrlResolution/DVBSelector */
              "./src/streaming/utils/baseUrlResolution/DVBSelector.js"
            ), g = i(
              /*! ./baseUrlResolution/BasicSelector */
              "./src/streaming/utils/baseUrlResolution/BasicSelector.js"
            ), m = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), A = i(
              /*! ../vo/DashJSError */
              "./src/streaming/vo/DashJSError.js"
            ), b = i(
              /*! ../utils/SupervisorTools */
              "./src/streaming/utils/SupervisorTools.js"
            ), S = i(
              /*! ./baseUrlResolution/ContentSteeringSelector */
              "./src/streaming/utils/baseUrlResolution/ContentSteeringSelector.js"
            ), N = i(
              /*! ../../core/Settings */
              "./src/core/Settings.js"
            );
            function T() {
              var y = this.context, E = (0, f.default)(y).getInstance(), L = (0, N.default)(y).getInstance(), _, O, D, M, C, I;
              function w() {
                O = (0, d.default)(y).create({
                  updateEventName: p.default.SERVICE_LOCATION_BLACKLIST_CHANGED,
                  addBlacklistEventName: p.default.SERVICE_LOCATION_BLACKLIST_ADD
                }), D = (0, g.default)(y).create({
                  blacklistController: O
                }), M = (0, v.default)(y).create({
                  blacklistController: O
                }), C = (0, S.default)(y).create(), C.setConfig({
                  blacklistController: O
                }), I = D;
              }
              function F(Y) {
                Y.selector && (I = Y.selector), Y.contentSteeringSelector && (C = Y.contentSteeringSelector);
              }
              function k(Y) {
                (0, b.checkParameterType)(Y, "boolean"), I = Y ? M : D;
              }
              function H(Y) {
                if (Y) {
                  if (L.get().streaming.applyContentSteering) {
                    var j = C.selectBaseUrlIndex(Y);
                    !isNaN(j) && j !== -1 && (Y.selectedIdx = j);
                  }
                  if (!isNaN(Y.selectedIdx))
                    return Y.baseUrls[Y.selectedIdx];
                  var J = I.select(Y.baseUrls);
                  if (!J) {
                    E.trigger(p.default.URL_RESOLUTION_FAILED, {
                      error: new A.default(h.default.URL_RESOLUTION_FAILED_GENERIC_ERROR_CODE, h.default.URL_RESOLUTION_FAILED_GENERIC_ERROR_MESSAGE)
                    }), I === D && Z();
                    return;
                  }
                  return Y.selectedIdx = Y.baseUrls.indexOf(J), J;
                }
              }
              function Z() {
                O.reset();
              }
              return _ = {
                chooseSelector: k,
                select: H,
                reset: Z,
                setConfig: F
              }, w(), _;
            }
            T.__dashjs_factory_name = "BaseURLSelector";
            const R = m.default.getClassFactory(T);
          }
        ),
        /***/
        "./src/streaming/utils/BoxParser.js": (
          /*!******************************************!*\
            !*** ./src/streaming/utils/BoxParser.js ***!
            \******************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => m
              /* harmony export */
            });
            var h = i(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), f = i(
              /*! ./IsoFile */
              "./src/streaming/utils/IsoFile.js"
            ), p = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), d = i(
              /*! codem-isoboxer */
              "./node_modules/codem-isoboxer/dist/iso_boxer.js"
            ), v = i(
              /*! ../vo/IsoBoxSearchInfo */
              "./src/streaming/vo/IsoBoxSearchInfo.js"
            );
            function g() {
              var A, b, S = this.context;
              function N() {
                A = (0, h.default)(S).getInstance().getLogger(b);
              }
              function T(M) {
                if (!M)
                  return null;
                M.fileStart === void 0 && (M.fileStart = 0);
                var C = d.parseBuffer(M), I = (0, f.default)(S).create();
                return I.setData(C), I;
              }
              function R(M, C, I) {
                if (I === void 0 && (I = 0), !C || I + 8 >= C.byteLength)
                  return new v.default(0, !1);
                for (var w = C instanceof ArrayBuffer ? new Uint8Array(C) : C, F, k = 0; I < w.byteLength; ) {
                  var H = L(w, I), Z = _(w, I + 4);
                  if (H === 0)
                    break;
                  I + H <= w.byteLength && (M.indexOf(Z) >= 0 ? F = new v.default(I, !0, H) : k = I + H), I += H;
                }
                return F || new v.default(k, !1);
              }
              function y(M) {
                if (!M || M.byteLength === 0)
                  return {
                    sampleList: [],
                    lastSequenceNumber: NaN,
                    totalDuration: NaN,
                    numSequences: NaN
                  };
                var C = T(M), I = C.getBoxes("moof"), w = C.getBoxes("mfhd"), F, k, H, Z, Y, j, J, ae, G, $, ie, re, ce, z, oe, de, pe;
                de = C.getBoxes("moof").length, oe = w[w.length - 1].sequence_number, H = 0, j = [];
                var he = -1, se = -1;
                for (ie = 0; ie < I.length; ie++) {
                  var ee = I[ie], te = ee.getChildBoxes("traf");
                  for (G = 0; G < te.length; G++) {
                    var le = te[G], ne = le.getChildBox("tfhd"), x = le.getChildBox("tfdt");
                    Y = x.baseMediaDecodeTime;
                    var P = le.getChildBoxes("trun"), B = le.getChildBoxes("subs");
                    for ($ = 0; $ < P.length; $++) {
                      var W = P[$];
                      for (H = W.sample_count, z = (ne.base_data_offset || 0) + (W.data_offset || 0), ae = 0; ae < H; ae++) {
                        J = W.samples[ae], F = J.sample_duration !== void 0 ? J.sample_duration : ne.default_sample_duration, Z = J.sample_size !== void 0 ? J.sample_size : ne.default_sample_size, k = J.sample_composition_time_offset !== void 0 ? J.sample_composition_time_offset : 0;
                        var X = {
                          dts: Y,
                          cts: Y + k,
                          duration: F,
                          offset: ee.offset + z,
                          size: Z,
                          subSizes: [Z]
                        };
                        if (B)
                          for (re = 0; re < B.length; re++) {
                            var K = B[re];
                            if (he < K.entry_count - 1 && ae > se && (he++, se += K.entries[he].sample_delta), ae == se) {
                              X.subSizes = [];
                              var U = K.entries[he];
                              for (ce = 0; ce < U.subsample_count; ce++)
                                X.subSizes.push(U.subsamples[ce].subsample_size);
                            }
                          }
                        j.push(X), z += Z, Y += F;
                      }
                    }
                    pe = Y - x.baseMediaDecodeTime;
                  }
                }
                return {
                  sampleList: j,
                  lastSequenceNumber: oe,
                  totalDuration: pe,
                  numSequences: de
                };
              }
              function E(M) {
                var C = T(M), I = C ? C.getBox("mdhd") : void 0;
                return I ? I.timescale : NaN;
              }
              function L(M, C) {
                return M[C + 3] >>> 0 | M[C + 2] << 8 >>> 0 | M[C + 1] << 16 >>> 0 | M[C] << 24 >>> 0;
              }
              function _(M, C) {
                return String.fromCharCode(M[C++]) + String.fromCharCode(M[C++]) + String.fromCharCode(M[C++]) + String.fromCharCode(M[C]);
              }
              function O(M) {
                var C = null, I, w, F = T(M);
                if (!F)
                  return C;
                var k = F.getBox("ftyp"), H = F.getBox("moov");
                return A.debug("Searching for initialization."), H && H.isComplete && (I = k ? k.offset : H.offset, w = H.offset + H.size - 1, C = I + "-" + w, A.debug("Found the initialization.  Range: " + C)), C;
              }
              function D(M, C, I) {
                if (I === void 0 && (I = 0), !C || I + 8 >= C.byteLength)
                  return new v.default(0, !1);
                for (var w = C instanceof ArrayBuffer ? new Uint8Array(C) : C, F, k = 0; I < w.byteLength; ) {
                  var H = L(w, I), Z = _(w, I + 4);
                  if (H === 0)
                    break;
                  I + H <= w.byteLength && (M.indexOf(Z) >= 0 ? F = new v.default(I, !0, H, Z) : k = I + H), I += H;
                }
                return F || new v.default(k, !1);
              }
              return b = {
                parse: T,
                findLastTopIsoBoxCompleted: R,
                getMediaTimescaleFromMoov: E,
                getSamplesInfo: y,
                findInitRange: O,
                parsePayload: D
              }, N(), b;
            }
            g.__dashjs_factory_name = "BoxParser";
            const m = p.default.getSingletonFactory(g);
          }
        ),
        /***/
        "./src/streaming/utils/Capabilities.js": (
          /*!*********************************************!*\
            !*** ./src/streaming/utils/Capabilities.js ***!
            \*********************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => m,
              /* harmony export */
              supportsMediaSource: () => (
                /* binding */
                v
              )
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ../thumbnail/ThumbnailTracks */
              "./src/streaming/thumbnail/ThumbnailTracks.js"
            ), p = i(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), d = [{
              codec: "avc1",
              compatibleCodecs: ["avc3"]
            }, {
              codec: "avc3",
              compatibleCodecs: ["avc1"]
            }];
            function v() {
              var A = "WebKitMediaSource" in window, b = "MediaSource" in window;
              return A || b;
            }
            function g() {
              var A, b, S;
              function N() {
                S = !1;
              }
              function T(C) {
                C && C.settings && (b = C.settings);
              }
              function R() {
                return S;
              }
              function y(C) {
                S = C;
              }
              function E(C, I) {
                return I !== p.default.AUDIO && I !== p.default.VIDEO ? Promise.resolve(!0) : L(C, I) ? O(C, I) : _(C);
              }
              function L(C, I) {
                return b.get().streaming.capabilities.useMediaCapabilitiesApi && navigator.mediaCapabilities && navigator.mediaCapabilities.decodingInfo && (C.codec && I === p.default.AUDIO || I === p.default.VIDEO && C.codec && C.width && C.height && C.bitrate && C.framerate);
              }
              function _(C) {
                return new Promise(function(I) {
                  if (!C || !C.codec) {
                    I(!1);
                    return;
                  }
                  var w = C.codec;
                  if (C.width && C.height && (w += ';width="' + C.width + '";height="' + C.height + '"'), "MediaSource" in window && MediaSource.isTypeSupported(w)) {
                    I(!0);
                    return;
                  } else if ("WebKitMediaSource" in window && WebKitMediaSource.isTypeSupported(w)) {
                    I(!0);
                    return;
                  }
                  I(!1);
                });
              }
              function O(C, I) {
                return new Promise(function(w) {
                  if (!C || !C.codec) {
                    w(!1);
                    return;
                  }
                  var F = {
                    type: "media-source"
                  };
                  F[I] = {}, F[I].contentType = C.codec, F[I].width = C.width, F[I].height = C.height, F[I].bitrate = parseInt(C.bitrate), F[I].framerate = parseFloat(C.framerate), navigator.mediaCapabilities.decodingInfo(F).then(function(k) {
                    w(k.supported);
                  }).catch(function() {
                    w(!1);
                  });
                });
              }
              function D(C) {
                try {
                  return f.THUMBNAILS_SCHEME_ID_URIS.indexOf(C.schemeIdUri) !== -1;
                } catch {
                  return !0;
                }
              }
              function M(C, I) {
                for (var w = C.split(".")[0], F = I.indexOf(w) === 0, k, H = 0; H < d.length; H++)
                  if (d[H].codec === w) {
                    k = d[H];
                    break;
                  }
                return k ? F || k.compatibleCodecs.some(function(Z) {
                  return I.indexOf(Z) === 0;
                }) : F;
              }
              return A = {
                setConfig: T,
                supportsMediaSource: v,
                supportsEncryptedMedia: R,
                supportsCodec: E,
                setEncryptedMediaSupported: y,
                supportsEssentialProperty: D,
                codecRootCompatibleWithCodec: M
              }, N(), A;
            }
            g.__dashjs_factory_name = "Capabilities";
            const m = h.default.getSingletonFactory(g);
          }
        ),
        /***/
        "./src/streaming/utils/CapabilitiesFilter.js": (
          /*!***************************************************!*\
            !*** ./src/streaming/utils/CapabilitiesFilter.js ***!
            \***************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => m
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), p = i(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), d = i(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), v = i(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            );
            function g() {
              var A = this.context, b = (0, d.default)(A).getInstance(), S, N, T, R, y, E;
              function L() {
                E = (0, f.default)(A).getInstance().getLogger(S);
              }
              function _(Z) {
                Z && (Z.adapter && (N = Z.adapter), Z.capabilities && (T = Z.capabilities), Z.settings && (R = Z.settings), Z.customParametersModel && (y = Z.customParametersModel));
              }
              function O(Z) {
                return new Promise(function(Y) {
                  var j = [];
                  j.push(D(p.default.VIDEO, Z)), j.push(D(p.default.AUDIO, Z)), Promise.all(j).then(function() {
                    R.get().streaming.capabilities.filterUnsupportedEssentialProperties && k(Z), H(Z), Y();
                  }).catch(function() {
                    Y();
                  });
                });
              }
              function D(Z, Y) {
                if (!Y || !Y.Period_asArray || Y.Period_asArray.length === 0)
                  return Promise.resolve();
                var j = [];
                return Y.Period_asArray.forEach(function(J) {
                  j.push(M(J, Z));
                }), Promise.all(j);
              }
              function M(Z, Y) {
                return new Promise(function(j) {
                  if (!Z || !Z.AdaptationSet_asArray || Z.AdaptationSet_asArray.length === 0) {
                    j();
                    return;
                  }
                  var J = [];
                  Z.AdaptationSet_asArray.forEach(function(ae) {
                    N.getIsTypeOf(ae, Y) && J.push(C(ae, Y));
                  }), Promise.all(J).then(function() {
                    Z.AdaptationSet_asArray = Z.AdaptationSet_asArray.filter(function(ae) {
                      var G = ae.Representation_asArray && ae.Representation_asArray.length > 0;
                      return G || (b.trigger(v.default.ADAPTATION_SET_REMOVED_NO_CAPABILITIES, {
                        adaptationSet: ae
                      }), E.warn("AdaptationSet has been removed because of no supported Representation")), G;
                    }), j();
                  }).catch(function() {
                    j();
                  });
                });
              }
              function C(Z, Y) {
                return new Promise(function(j) {
                  if (!Z.Representation_asArray || Z.Representation_asArray.length === 0) {
                    j();
                    return;
                  }
                  var J = [], ae = [];
                  Z.Representation_asArray.forEach(function(G, $) {
                    var ie = N.getCodec(Z, $, !1), re = I(Y, G, ie);
                    ae.push(re), J.push(T.supportsCodec(re, Y));
                  }), Promise.all(J).then(function(G) {
                    Z.Representation_asArray = Z.Representation_asArray.filter(function($, ie) {
                      return G[ie] || E.debug("[Stream] Codec ".concat(ae[ie].codec, " not supported ")), G[ie];
                    }), j();
                  }).catch(function() {
                    j();
                  });
                });
              }
              function I(Z, Y, j) {
                switch (Z) {
                  case p.default.VIDEO:
                    return w(Y, j);
                  case p.default.AUDIO:
                    return F(Y, j);
                  default:
                    return null;
                }
              }
              function w(Z, Y) {
                var j = Z.width || null, J = Z.height || null, ae = Z.frameRate || null, G = Z.bandwidth || null;
                return {
                  codec: Y,
                  width: j,
                  height: J,
                  framerate: ae,
                  bitrate: G
                };
              }
              function F(Z, Y) {
                var j = Z.audioSamplingRate || null, J = Z.bandwidth || null;
                return {
                  codec: Y,
                  bitrate: J,
                  samplerate: j
                };
              }
              function k(Z) {
                !Z || !Z.Period_asArray || Z.Period_asArray.length === 0 || Z.Period_asArray.forEach(function(Y) {
                  Y.AdaptationSet_asArray = Y.AdaptationSet_asArray.filter(function(j) {
                    return !j.Representation_asArray || j.Representation_asArray.length === 0 ? !0 : (j.Representation_asArray = j.Representation_asArray.filter(function(J) {
                      var ae = N.getEssentialPropertiesForRepresentation(J);
                      if (ae && ae.length > 0)
                        for (var G = 0; G < ae.length; ) {
                          if (!T.supportsEssentialProperty(ae[G]))
                            return E.debug("[Stream] EssentialProperty not supported: " + ae[G].schemeIdUri), !1;
                          G += 1;
                        }
                      return !0;
                    }), j.Representation_asArray && j.Representation_asArray.length > 0);
                  });
                });
              }
              function H(Z) {
                var Y = y.getCustomCapabilitiesFilters();
                !Y || Y.length === 0 || !Z || !Z.Period_asArray || Z.Period_asArray.length === 0 || Z.Period_asArray.forEach(function(j) {
                  j.AdaptationSet_asArray = j.AdaptationSet_asArray.filter(function(J) {
                    return !J.Representation_asArray || J.Representation_asArray.length === 0 ? !0 : (J.Representation_asArray = J.Representation_asArray.filter(function(ae) {
                      return !Y.some(function(G) {
                        return !G(ae);
                      });
                    }), J.Representation_asArray && J.Representation_asArray.length > 0);
                  });
                });
              }
              return S = {
                setConfig: _,
                filterUnsupportedFeatures: O
              }, L(), S;
            }
            g.__dashjs_factory_name = "CapabilitiesFilter";
            const m = h.default.getSingletonFactory(g);
          }
        ),
        /***/
        "./src/streaming/utils/CustomTimeRanges.js": (
          /*!*************************************************!*\
            !*** ./src/streaming/utils/CustomTimeRanges.js ***!
            \*************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => d
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ../utils/SupervisorTools */
              "./src/streaming/utils/SupervisorTools.js"
            );
            function p() {
              var v = [], g = 0;
              function m(R, y) {
                var E = 0;
                for (E = 0; E < this.customTimeRangeArray.length && R > this.customTimeRangeArray[E].start; E++)
                  ;
                for (this.customTimeRangeArray.splice(E, 0, {
                  start: R,
                  end: y
                }), E = 0; E < this.customTimeRangeArray.length - 1; E++)
                  this.mergeRanges(E, E + 1) && E--;
                this.length = this.customTimeRangeArray.length;
              }
              function A() {
                this.customTimeRangeArray = [], this.length = 0;
              }
              function b(R, y) {
                for (var E = 0; E < this.customTimeRangeArray.length; E++)
                  if (R <= this.customTimeRangeArray[E].start && y >= this.customTimeRangeArray[E].end)
                    this.customTimeRangeArray.splice(E, 1), E--;
                  else if (R > this.customTimeRangeArray[E].start && y < this.customTimeRangeArray[E].end) {
                    this.customTimeRangeArray.splice(E + 1, 0, {
                      start: y,
                      end: this.customTimeRangeArray[E].end
                    }), this.customTimeRangeArray[E].end = R;
                    break;
                  } else
                    R > this.customTimeRangeArray[E].start && R < this.customTimeRangeArray[E].end ? this.customTimeRangeArray[E].end = R : y > this.customTimeRangeArray[E].start && y < this.customTimeRangeArray[E].end && (this.customTimeRangeArray[E].start = y);
                this.length = this.customTimeRangeArray.length;
              }
              function S(R, y) {
                var E = this.customTimeRangeArray[R], L = this.customTimeRangeArray[y];
                return E.start <= L.start && L.start <= E.end && E.end <= L.end ? (E.end = L.end, this.customTimeRangeArray.splice(y, 1), !0) : L.start <= E.start && E.start <= L.end && L.end <= E.end ? (E.start = L.start, this.customTimeRangeArray.splice(y, 1), !0) : L.start <= E.start && E.start <= L.end && E.end <= L.end ? (this.customTimeRangeArray.splice(R, 1), !0) : E.start <= L.start && L.start <= E.end && L.end <= E.end ? (this.customTimeRangeArray.splice(y, 1), !0) : !1;
              }
              function N(R) {
                return (0, f.checkInteger)(R), R >= this.customTimeRangeArray.length || R < 0 ? NaN : this.customTimeRangeArray[R].start;
              }
              function T(R) {
                return (0, f.checkInteger)(R), R >= this.customTimeRangeArray.length || R < 0 ? NaN : this.customTimeRangeArray[R].end;
              }
              return {
                customTimeRangeArray: v,
                length: g,
                add: m,
                clear: A,
                remove: b,
                mergeRanges: S,
                start: N,
                end: T
              };
            }
            p.__dashjs_factory_name = "CustomTimeRanges";
            const d = h.default.getClassFactory(p);
          }
        ),
        /***/
        "./src/streaming/utils/DOMStorage.js": (
          /*!*******************************************!*\
            !*** ./src/streaming/utils/DOMStorage.js ***!
            \*******************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => R
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), p = i(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), d = [{
              oldKey: "dashjs_vbitrate",
              newKey: "dashjs_video_bitrate"
            }, {
              oldKey: "dashjs_abitrate",
              newKey: "dashjs_audio_bitrate"
            }, {
              oldKey: "dashjs_vsettings",
              newKey: "dashjs_video_settings"
            }, {
              oldKey: "dashjs_asettings",
              newKey: "dashjs_audio_settings"
            }], v = "dashjs_?_bitrate", g = "dashjs_?_settings", m = "localStorage", A = "sessionStorage", b = "lastBitrate", S = "lastMediaSettings";
            function N(y) {
              y = y || {};
              var E = this.context, L = y.settings, _, O, D;
              function M() {
                O = (0, f.default)(E).getInstance().getLogger(_), I();
              }
              function C(J) {
                if (D !== void 0)
                  return D;
                D = !1;
                var ae = "1", G = "1", $;
                try {
                  typeof window < "u" && ($ = window[J]);
                } catch (ie) {
                  return O.warn("DOMStorage access denied: " + ie.message), D;
                }
                if (!$ || J !== m && J !== A)
                  return D;
                try {
                  $.setItem(ae, G), $.removeItem(ae), D = !0;
                } catch (ie) {
                  O.warn("DOMStorage is supported, but cannot be used: " + ie.message);
                }
                return D;
              }
              function I() {
                C(m) && d.forEach(function(J) {
                  var ae = localStorage.getItem(J.oldKey);
                  if (ae) {
                    localStorage.removeItem(J.oldKey);
                    try {
                      localStorage.setItem(J.newKey, ae);
                    } catch (G) {
                      O.error(G.message);
                    }
                  }
                });
              }
              function w() {
                var J = 6e5;
                return Math.round((/* @__PURE__ */ new Date()).getTime() / J) * J;
              }
              function F(J, ae) {
                return C(J) && L.get().streaming[ae + "CachingInfo"].enabled;
              }
              function k() {
                if (!L)
                  throw new Error(p.default.MISSING_CONFIG_ERROR);
              }
              function H(J) {
                if (k(), !L.get().streaming.lastMediaSettingsCachingInfo.enabled)
                  return null;
                var ae = null;
                if (F(m, S)) {
                  var G = g.replace(/\?/, J);
                  try {
                    var $ = JSON.parse(localStorage.getItem(G)) || {}, ie = (/* @__PURE__ */ new Date()).getTime() - parseInt($.timestamp, 10) >= L.get().streaming.lastMediaSettingsCachingInfo.ttl || !1;
                    ae = $.settings, ie && (localStorage.removeItem(G), ae = null);
                  } catch {
                    return null;
                  }
                }
                return ae;
              }
              function Z(J) {
                if (k(), !L.get().streaming.lastBitrateCachingInfo.enabled)
                  return NaN;
                var ae = NaN;
                if (F(m, b)) {
                  var G = v.replace(/\?/, J);
                  try {
                    var $ = JSON.parse(localStorage.getItem(G)) || {}, ie = (/* @__PURE__ */ new Date()).getTime() - parseInt($.timestamp, 10) >= L.get().streaming.lastBitrateCachingInfo.ttl || !1, re = parseFloat($.bitrate);
                    !isNaN(re) && !ie ? (ae = re, O.debug("Last saved bitrate for " + J + " was " + re)) : ie && localStorage.removeItem(G);
                  } catch {
                    return null;
                  }
                }
                return ae;
              }
              function Y(J, ae) {
                if (F(m, S)) {
                  var G = g.replace(/\?/, J);
                  try {
                    localStorage.setItem(G, JSON.stringify({
                      settings: ae,
                      timestamp: w()
                    }));
                  } catch ($) {
                    O.error($.message);
                  }
                }
              }
              function j(J, ae) {
                if (F(m, b) && ae) {
                  var G = v.replace(/\?/, J);
                  try {
                    localStorage.setItem(G, JSON.stringify({
                      bitrate: ae.toFixed(3),
                      timestamp: w()
                    }));
                  } catch ($) {
                    O.error($.message);
                  }
                }
              }
              return _ = {
                getSavedBitrateSettings: Z,
                setSavedBitrateSettings: j,
                getSavedMediaSettings: H,
                setSavedMediaSettings: Y
              }, M(), _;
            }
            N.__dashjs_factory_name = "DOMStorage";
            var T = h.default.getSingletonFactory(N);
            const R = T;
          }
        ),
        /***/
        "./src/streaming/utils/DefaultURLUtils.js": (
          /*!************************************************!*\
            !*** ./src/streaming/utils/DefaultURLUtils.js ***!
            \************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function f() {
              var d, v = /^[a-z][a-z0-9+\-_.]*:/i, g = /^https?:\/\//i, m = /^https:\/\//i, A = /^([a-z][a-z0-9+\-_.]*:\/\/[^\/]+)\/?/i, b = function(F, k) {
                try {
                  return new window.URL(F, k).toString();
                } catch {
                  return F;
                }
              }, S = function(F, k) {
                var H = T;
                if (!k || !L(F))
                  return F;
                _(F) && (H = R), O(F) && (H = E);
                var Z = H(k), Y = Z.charAt(Z.length - 1) !== "/" && F.charAt(0) !== "/" ? "/" : "";
                return [Z, F].join(Y);
              };
              function N() {
                try {
                  var w = new window.URL("x", "http://y");
                  d = b;
                } catch {
                } finally {
                  d = d || S;
                }
              }
              function T(w) {
                var F = w.indexOf("/"), k = w.lastIndexOf("/");
                return F !== -1 ? k === F + 1 ? w : (w.indexOf("?") !== -1 && (w = w.substring(0, w.indexOf("?"))), w.substring(0, k + 1)) : "";
              }
              function R(w) {
                var F = w.match(A);
                return F ? F[1] : "";
              }
              function y(w) {
                var F = /^(?:\w+\:\/\/)?([^\/]+)(.*)$/.exec(w);
                return F[2].substring(1);
              }
              function E(w) {
                var F = w.match(v);
                return F ? F[0] : "";
              }
              function L(w) {
                return !v.test(w);
              }
              function _(w) {
                return L(w) && w.charAt(0) === "/";
              }
              function O(w) {
                return w.indexOf("//") === 0;
              }
              function D(w) {
                return g.test(w);
              }
              function M(w) {
                return m.test(w);
              }
              function C(w, F) {
                return d(w, F);
              }
              N();
              var I = {
                parseBaseUrl: T,
                parseOrigin: R,
                parseScheme: E,
                isRelative: L,
                isPathAbsolute: _,
                isSchemeRelative: O,
                isHTTPURL: D,
                isHTTPS: M,
                removeHostname: y,
                resolve: C
              };
              return I;
            }
            f.__dashjs_factory_name = "DefaultURLUtils";
            const p = h.default.getSingletonFactory(f);
          }
        ),
        /***/
        "./src/streaming/utils/EBMLParser.js": (
          /*!*******************************************!*\
            !*** ./src/streaming/utils/EBMLParser.js ***!
            \*******************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function f(d) {
              d = d || {};
              var v, g = new DataView(d.data), m = 0;
              function A() {
                return m;
              }
              function b(O) {
                m = O;
              }
              function S(O, D) {
                var M = !0, C = 0, I, w;
                if (D === void 0 && (D = !1), O.tag > 16777215 ? (g.getUint32(m) !== O.tag && (M = !1), C = 4) : O.tag > 65535 ? (I = g.getUint16(m), w = g.getUint8(m + 2), I * 256 + w !== O.tag && (M = !1), C = 3) : O.tag > 255 ? (g.getUint16(m) !== O.tag && (M = !1), C = 2) : (g.getUint8(m) !== O.tag && (M = !1), C = 1), !M && O.required && !D)
                  throw new Error("required tag not found");
                return M && (m += C), M;
              }
              function N(O, D) {
                var M = S(O, D);
                return M && y(), M;
              }
              function T(O) {
                var D;
                return S(O), D = y(), v[O.parse](D);
              }
              function R(O, D) {
                var M = S(O, D), C;
                return M && (C = y(), m += C), M;
              }
              function y(O) {
                var D = 1, M = 128, C = 8, I = -1, w = 0, F = g.getUint8(m), k = 0;
                for (k = 0; k < C; k += 1) {
                  if ((F & M) === M) {
                    w = O === void 0 ? F & ~M : F, I = k;
                    break;
                  }
                  M >>= 1;
                }
                for (k = 0; k < I; k += 1, D += 1)
                  w = w << 8 | 255 & g.getUint8(m + D);
                return m += D, w;
              }
              function E(O) {
                var D;
                switch (O) {
                  case 4:
                    D = g.getFloat32(m), m += 4;
                    break;
                  case 8:
                    D = g.getFloat64(m), m += 8;
                    break;
                }
                return D;
              }
              function L(O) {
                for (var D = 0, M = 0; M < O; M += 1)
                  D <<= 8, D |= g.getUint8(m + M) & 255;
                return m += O, D;
              }
              function _() {
                return m < g.byteLength;
              }
              return v = {
                getPos: A,
                setPos: b,
                consumeTag: S,
                consumeTagAndSize: N,
                parseTag: T,
                skipOverElement: R,
                getMatroskaCodedNum: y,
                getMatroskaFloat: E,
                getMatroskaUint: L,
                moreData: _
              }, v;
            }
            f.__dashjs_factory_name = "EBMLParser";
            const p = h.default.getClassFactory(f);
          }
        ),
        /***/
        "./src/streaming/utils/ErrorHandler.js": (
          /*!*********************************************!*\
            !*** ./src/streaming/utils/ErrorHandler.js ***!
            \*********************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var h = i(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), f = i(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), p = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function d() {
              var g, m = this.context, A = (0, h.default)(m).getInstance();
              function b(S) {
                A.trigger(f.default.ERROR, {
                  error: S
                });
              }
              return g = {
                error: b
              }, g;
            }
            d.__dashjs_factory_name = "ErrorHandler";
            const v = p.default.getSingletonFactory(d);
          }
        ),
        /***/
        "./src/streaming/utils/InitCache.js": (
          /*!******************************************!*\
            !*** ./src/streaming/utils/InitCache.js ***!
            \******************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function f() {
              var d = {};
              function v(b) {
                var S = b.streamId, N = b.representationId;
                d[S] = d[S] || {}, d[S][N] = b;
              }
              function g(b, S) {
                return d && d[b] && d[b][S] ? d[b][S] : null;
              }
              function m() {
                d = {};
              }
              var A = {
                save: v,
                extract: g,
                reset: m
              };
              return A;
            }
            f.__dashjs_factory_name = "InitCache";
            const p = h.default.getSingletonFactory(f);
          }
        ),
        /***/
        "./src/streaming/utils/IsoFile.js": (
          /*!****************************************!*\
            !*** ./src/streaming/utils/IsoFile.js ***!
            \****************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => d
              /* harmony export */
            });
            var h = i(
              /*! ../vo/IsoBox */
              "./src/streaming/vo/IsoBox.js"
            ), f = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function p() {
              var v, g;
              function m(T) {
                return !T || !g || !g.boxes || g.boxes.length === 0 || typeof g.fetch != "function" ? null : N(g.fetch(T));
              }
              function A(T) {
                var R = [];
                if (!T || !g || typeof g.fetchAll != "function")
                  return R;
                for (var y = g.fetchAll(T), E, L = 0, _ = y.length; L < _; L++)
                  E = N(y[L]), E && R.push(E);
                return R;
              }
              function b(T) {
                g = T;
              }
              function S() {
                if (!g || !g.boxes || !g.boxes.length)
                  return null;
                var T = g.boxes[g.boxes.length - 1].type, R = A(T);
                return R.length > 0 ? R[R.length - 1] : null;
              }
              function N(T) {
                if (!T)
                  return null;
                var R = new h.default(T);
                return T.hasOwnProperty("_incomplete") && (R.isComplete = !T._incomplete), R;
              }
              return v = {
                getBox: m,
                getBoxes: A,
                setData: b,
                getLastBox: S
              }, v;
            }
            p.__dashjs_factory_name = "IsoFile";
            const d = f.default.getClassFactory(p);
          }
        ),
        /***/
        "./src/streaming/utils/ObjectUtils.js": (
          /*!********************************************!*\
            !*** ./src/streaming/utils/ObjectUtils.js ***!
            \********************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! fast-deep-equal */
              "./node_modules/fast-deep-equal/index.js"
            ), p = /* @__PURE__ */ i.n(f);
            function d() {
              var g;
              function m(A, b) {
                return p()(A, b);
              }
              return g = {
                areEqual: m
              }, g;
            }
            d.__dashjs_factory_name = "ObjectUtils";
            const v = h.default.getSingletonFactory(d);
          }
        ),
        /***/
        "./src/streaming/utils/RequestModifier.js": (
          /*!************************************************!*\
            !*** ./src/streaming/utils/RequestModifier.js ***!
            \************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => d,
              /* harmony export */
              modifyRequest: () => (
                /* binding */
                f
              )
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function f(v, g) {
              var m = {
                url: v.url,
                method: v.method,
                headers: Object.assign({}, v.headers),
                credentials: v.withCredentials ? "include" : void 0
              };
              return Promise.resolve(g.modifyRequest(m)).then(function() {
                return Object.assign(v, m, {
                  withCredentials: m.credentials === "include"
                });
              });
            }
            function p() {
              var v;
              function g(A) {
                return A;
              }
              function m(A, b) {
                return b.url, A;
              }
              return v = {
                modifyRequest: null,
                modifyRequestURL: g,
                modifyRequestHeader: m
              }, v;
            }
            p.__dashjs_factory_name = "RequestModifier";
            const d = h.default.getSingletonFactory(p);
          }
        ),
        /***/
        "./src/streaming/utils/SegmentResponseModifier.js": (
          /*!********************************************************!*\
            !*** ./src/streaming/utils/SegmentResponseModifier.js ***!
            \********************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function f() {
              var d;
              function v(g) {
                return Promise.resolve(g);
              }
              return d = {
                modifyResponseAsync: v
              }, d;
            }
            f.__dashjs_factory_name = "SegmentResponseModifier";
            const p = h.default.getSingletonFactory(f);
          }
        ),
        /***/
        "./src/streaming/utils/SupervisorTools.js": (
          /*!************************************************!*\
            !*** ./src/streaming/utils/SupervisorTools.js ***!
            \************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              checkInteger: () => (
                /* binding */
                d
              ),
              /* harmony export */
              checkIsVideoOrAudioType: () => (
                /* binding */
                g
              ),
              /* harmony export */
              checkParameterType: () => (
                /* binding */
                p
              ),
              /* harmony export */
              checkRange: () => (
                /* binding */
                v
              )
              /* harmony export */
            });
            var h = i(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            );
            function f(m) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? f = function(b) {
                return typeof b;
              } : f = function(b) {
                return b && typeof Symbol == "function" && b.constructor === Symbol && b !== Symbol.prototype ? "symbol" : typeof b;
              }, f(m);
            }
            function p(m, A) {
              if (f(m) !== A)
                throw h.default.BAD_ARGUMENT_ERROR;
            }
            function d(m) {
              var A = m !== null && !isNaN(m) && m % 1 === 0;
              if (!A)
                throw h.default.BAD_ARGUMENT_ERROR + " : argument is not an integer";
            }
            function v(m, A, b) {
              if (m < A || m > b)
                throw h.default.BAD_ARGUMENT_ERROR + " : argument out of range";
            }
            function g(m) {
              if (typeof m != "string" || m !== h.default.AUDIO && m !== h.default.VIDEO)
                throw h.default.BAD_ARGUMENT_ERROR;
            }
          }
        ),
        /***/
        "./src/streaming/utils/TTMLParser.js": (
          /*!*******************************************!*\
            !*** ./src/streaming/utils/TTMLParser.js ***!
            \*******************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => b
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), p = i(
              /*! ../../core/EventBus */
              "./src/core/EventBus.js"
            ), d = i(
              /*! ../../core/events/Events */
              "./src/core/events/Events.js"
            ), v = i(
              /*! imsc */
              "./node_modules/imsc/src/main/js/main.js"
            ), g = i(
              /*! ../MediaPlayerEvents */
              "./src/streaming/MediaPlayerEvents.js"
            ), m = i(
              /*! ../constants/ConformanceViolationConstants */
              "./src/streaming/constants/ConformanceViolationConstants.js"
            );
            function A() {
              var S = this.context, N = (0, p.default)(S).getInstance(), T, R, y = 0;
              function E() {
                R = (0, f.default)(S).getInstance().getLogger(T);
              }
              function L() {
                var O = "cue_TTML_" + y;
                return y++, O;
              }
              function _(O, D, M, C, I) {
                var w = "", F = [], k, H, Z, Y = {}, j = {}, J = "", ae = "", G = {
                  onOpenTag: function(z, oe, de) {
                    if (de[" imagetype"] && !de[" imageType"] && (N.trigger(g.default.CONFORMANCE_VIOLATION, {
                      level: m.default.LEVELS.ERROR,
                      event: m.default.EVENTS.NON_COMPLIANT_SMPTE_IMAGE_ATTRIBUTE
                    }), de[" imageType"] = de[" imagetype"]), oe === "image" && (z === "http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt" || z === "http://www.smpte-ra.org/schemas/2052-1/2013/smpte-tt")) {
                      if (!de[" imageType"] || de[" imageType"].value !== "PNG") {
                        R.warn("smpte-tt imageType != PNG. Discarded");
                        return;
                      }
                      J = de["http://www.w3.org/XML/1998/namespace id"].value;
                    }
                  },
                  onCloseTag: function() {
                    J && (j[J] = ae.trim()), ae = "", J = "";
                  },
                  onText: function(z) {
                    J && (ae = ae + z);
                  }
                };
                if (!O)
                  throw w = "no ttml data to parse", new Error(w);
                Y.data = O, N.trigger(d.default.TTML_TO_PARSE, Y);
                var $ = (0, v.fromXML)(Y.data, function(ce) {
                  w = ce;
                }, G);
                N.trigger(d.default.TTML_PARSED, {
                  ttmlString: Y.data,
                  ttmlDoc: $
                });
                var ie = $.getMediaTimeEvents();
                for (Z = 0; Z < ie.length; Z++) {
                  var re = (0, v.generateISD)($, ie[Z], function(ce) {
                    w = ce;
                  });
                  re.contents.some(function(ce) {
                    return ce.contents.length;
                  }) && (k = ie[Z] + D < M ? M : ie[Z] + D, H = ie[Z + 1] + D > C ? C : ie[Z + 1] + D, k < H && F.push({
                    start: k,
                    end: H,
                    type: "html",
                    cueID: L(),
                    isd: re,
                    images: I,
                    embeddedImages: j
                  }));
                }
                if (w !== "")
                  throw R.error(w), new Error(w);
                return F;
              }
              return T = {
                parse: _
              }, E(), T;
            }
            A.__dashjs_factory_name = "TTMLParser";
            const b = h.default.getSingletonFactory(A);
          }
        ),
        /***/
        "./src/streaming/utils/URLUtils.js": (
          /*!*****************************************!*\
            !*** ./src/streaming/utils/URLUtils.js ***!
            \*****************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ./DefaultURLUtils */
              "./src/streaming/utils/DefaultURLUtils.js"
            );
            function p() {
              var g, m, A = [], b = this.context;
              function S(F) {
                var k;
                for (k = 0; k < A.length; k++) {
                  var H = A[k].regex;
                  if (H.test(F))
                    return A[k].utils;
                }
                return m;
              }
              function N() {
                m = (0, f.default)(b).getInstance();
              }
              function T(F, k) {
                A.push({
                  regex: F,
                  utils: k
                });
              }
              function R(F, k, H) {
                var Z = S(H || k);
                return Z && typeof Z[F] == "function" ? Z[F](k, H) : m[F](k, H);
              }
              function y(F) {
                return R("parseBaseUrl", F);
              }
              function E(F) {
                return R("parseOrigin", F);
              }
              function L(F) {
                return R("removeHostname", F);
              }
              function _(F) {
                return R("parseScheme", F);
              }
              function O(F) {
                return R("isRelative", F);
              }
              function D(F) {
                return R("isPathAbsolute", F);
              }
              function M(F) {
                return R("isSchemeRelative", F);
              }
              function C(F) {
                return R("isHTTPURL", F);
              }
              function I(F) {
                return R("isHTTPS", F);
              }
              function w(F, k) {
                return R("resolve", F, k);
              }
              return N(), g = {
                registerUrlRegex: T,
                parseBaseUrl: y,
                parseOrigin: E,
                parseScheme: _,
                isRelative: O,
                isPathAbsolute: D,
                isSchemeRelative: M,
                isHTTPURL: C,
                isHTTPS: I,
                removeHostname: L,
                resolve: w
              }, g;
            }
            p.__dashjs_factory_name = "URLUtils";
            var d = h.default.getSingletonFactory(p);
            const v = d;
          }
        ),
        /***/
        "./src/streaming/utils/VTTParser.js": (
          /*!******************************************!*\
            !*** ./src/streaming/utils/VTTParser.js ***!
            \******************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ../../core/Debug */
              "./src/core/Debug.js"
            ), p = "WEBVTT";
            function d() {
              var g = this.context, m, A, b, S, N, T;
              function R() {
                A = (0, f.default)(g).getInstance().getLogger(m), b = /(?:\r\n|\r|\n)/gm, S = /-->/, N = /(^[\s]+|[\s]+$)/g, T = /\s\b/g;
              }
              function y(D) {
                var M = [], C, I;
                if (!D)
                  return M;
                D = D.split(b), C = D.length, I = -1;
                for (var w = 0; w < C; w++) {
                  var F = D[w];
                  if (F.length > 0 && F !== p && F.match(S)) {
                    var k = L(F), H = k.cuePoints, Z = k.styles, Y = O(D, w + 1), j = E(H[0].replace(N, "")), J = E(H[1].replace(N, ""));
                    !isNaN(j) && !isNaN(J) && j >= I && J > j ? Y !== "" ? (I = j, M.push({
                      start: j,
                      end: J,
                      data: Y,
                      styles: Z
                    })) : A.error("Skipping cue due to empty/malformed cue text") : A.error("Skipping cue due to incorrect cue timing");
                  }
                }
                return M;
              }
              function E(D) {
                var M = D.split(":"), C = M.length - 1;
                return D = parseInt(M[C - 1], 10) * 60 + parseFloat(M[C]), C === 2 && (D += parseInt(M[0], 10) * 3600), D;
              }
              function L(D) {
                var M = D.split(S), C = M[1].split(T);
                return C.shift(), M[1] = C[0], C.shift(), {
                  cuePoints: M,
                  styles: _(C)
                };
              }
              function _(D) {
                var M = {};
                return D.forEach(function(C) {
                  if (C.split(/:/).length > 1) {
                    var I = C.split(/:/)[1];
                    I && I.search(/%/) != -1 && (I = parseInt(I.replace(/%/, ""), 10)), (C.match(/align/) || C.match(/A/)) && (M.align = I), (C.match(/line/) || C.match(/L/)) && (M.line = I), (C.match(/position/) || C.match(/P/)) && (M.position = I), (C.match(/size/) || C.match(/S/)) && (M.size = I);
                  }
                }), M;
              }
              function O(D, M) {
                for (var C = M, I = "", w = "", F; D[C] !== "" && C < D.length; )
                  C++;
                if (F = C - M, F > 1)
                  for (var k = 0; k < F; k++)
                    if (w = D[M + k], !w.match(S))
                      I += w, k !== F - 1 && (I += `
`);
                    else {
                      I = "";
                      break;
                    }
                else
                  w = D[M], w.match(S) || (I = w);
                return I;
              }
              return m = {
                parse: y
              }, R(), m;
            }
            d.__dashjs_factory_name = "VTTParser";
            const v = h.default.getSingletonFactory(d);
          }
        ),
        /***/
        "./src/streaming/utils/VttCustomRenderingParser.js": (
          /*!*********************************************************!*\
            !*** ./src/streaming/utils/VttCustomRenderingParser.js ***!
            \*********************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            var h = i(
              /*! ../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function f() {
              var d, v;
              function g() {
                try {
                  window && window.WebVTT && window.WebVTT.Parser && (v = new window.WebVTT.Parser(window, window.vttjs, window.WebVTT.StringDecoder()));
                } catch {
                }
              }
              function m(A) {
                var b = [];
                return v.oncue = function(S) {
                  S.start = S.startTime, S.end = S.endTime, S.data = S.text, S.styles = {
                    align: S.align,
                    line: S.line,
                    position: S.position,
                    size: S.size
                  }, b.push(S);
                }, v.parse(A), b;
              }
              return d = {
                parse: m
              }, g(), d;
            }
            f.__dashjs_factory_name = "VttCustomRenderingParser";
            const p = h.default.getSingletonFactory(f);
          }
        ),
        /***/
        "./src/streaming/utils/baseUrlResolution/BasicSelector.js": (
          /*!****************************************************************!*\
            !*** ./src/streaming/utils/baseUrlResolution/BasicSelector.js ***!
            \****************************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            var h = i(
              /*! ../../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function f(d) {
              d = d || {};
              var v, g = d.blacklistController;
              function m(A) {
                var b = 0, S;
                return A && A.some(function(N, T) {
                  return b = T, !g.contains(N.serviceLocation);
                }) && (S = A[b]), S;
              }
              return v = {
                select: m
              }, v;
            }
            f.__dashjs_factory_name = "BasicSelector";
            const p = h.default.getClassFactory(f);
          }
        ),
        /***/
        "./src/streaming/utils/baseUrlResolution/ContentSteeringSelector.js": (
          /*!**************************************************************************!*\
            !*** ./src/streaming/utils/baseUrlResolution/ContentSteeringSelector.js ***!
            \**************************************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => d
              /* harmony export */
            });
            var h = i(
              /*! ../../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            ), f = i(
              /*! ../../../dash/controllers/ContentSteeringController */
              "./src/dash/controllers/ContentSteeringController.js"
            );
            function p() {
              var v = this.context, g, m, A;
              function b() {
                m = (0, f.default)(v).getInstance();
              }
              function S(R) {
                R.blacklistController && (A = R.blacklistController), R.contentSteeringController && (m = R.contentSteeringController);
              }
              function N(R) {
                var y = NaN;
                if (isNaN(R.selectedIdx)) {
                  var E = m.getSteeringDataFromManifest();
                  E && E.defaultServiceLocation && (y = T([E.defaultServiceLocation], R.baseUrls));
                }
                var L = m.getCurrentSteeringResponseData();
                return R.baseUrls && R.baseUrls.length && L && L.serviceLocationPriority && L.serviceLocationPriority.length && (y = T(L.serviceLocationPriority, R.baseUrls)), y;
              }
              function T() {
                for (var R = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], E = 0, L = NaN, _ = function() {
                  var M = R[E], C = y.findIndex(function(I) {
                    return I.serviceLocation && I.serviceLocation === M;
                  });
                  if (C !== -1 && !A.contains(y[C].serviceLocation))
                    return L = C, "break";
                  E += 1;
                }; E < R.length; ) {
                  var O = _();
                  if (O === "break")
                    break;
                }
                return L;
              }
              return g = {
                selectBaseUrlIndex: N,
                setConfig: S
              }, b(), g;
            }
            p.__dashjs_factory_name = "ContentSteeringSelector";
            const d = h.default.getClassFactory(p);
          }
        ),
        /***/
        "./src/streaming/utils/baseUrlResolution/DVBSelector.js": (
          /*!**************************************************************!*\
            !*** ./src/streaming/utils/baseUrlResolution/DVBSelector.js ***!
            \**************************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            var h = i(
              /*! ../../../core/FactoryMaker */
              "./src/core/FactoryMaker.js"
            );
            function f(d) {
              d = d || {};
              var v, g = d.blacklistController;
              function m(S) {
                var N = [], T = function(E) {
                  return !(N.length && E.dvb_priority && N.indexOf(E.dvb_priority) !== -1);
                }, R = function(E) {
                  return g.contains(E.serviceLocation) ? (E.dvb_priority && N.push(E.dvb_priority), !1) : !0;
                };
                return S.filter(R).filter(T);
              }
              function A(S) {
                var N = function(D, M) {
                  var C = D.dvb_priority - M.dvb_priority;
                  return isNaN(C) ? 0 : C;
                }, T = function(D, M, C) {
                  return !M || C[0].dvb_priority && D.dvb_priority && C[0].dvb_priority === D.dvb_priority;
                }, R = 0, y = [], E = 0, L, _;
                if (_ = S.sort(N).filter(T), _.length)
                  return _.length > 1 && (_.forEach(function(O) {
                    R += O.dvb_weight, y.push(R);
                  }), L = Math.floor(Math.random() * (R - 1)), y.every(function(O, D) {
                    return E = D, !(L < O);
                  })), _[E];
              }
              function b(S) {
                return S && A(m(S));
              }
              return v = {
                select: b
              }, v;
            }
            f.__dashjs_factory_name = "DVBSelector";
            const p = h.default.getClassFactory(f);
          }
        ),
        /***/
        "./src/streaming/vo/BitrateInfo.js": (
          /*!*****************************************!*\
            !*** ./src/streaming/vo/BitrateInfo.js ***!
            \*****************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = function d() {
              h(this, d), this.mediaType = null, this.bitrate = null, this.width = null, this.height = null, this.scanType = null, this.qualityIndex = NaN;
            };
            const p = f;
          }
        ),
        /***/
        "./src/streaming/vo/DashJSError.js": (
          /*!*****************************************!*\
            !*** ./src/streaming/vo/DashJSError.js ***!
            \*****************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = function d(v, g, m) {
              h(this, d), this.code = v || null, this.message = g || null, this.data = m || null;
            };
            const p = f;
          }
        ),
        /***/
        "./src/streaming/vo/DataChunk.js": (
          /*!***************************************!*\
            !*** ./src/streaming/vo/DataChunk.js ***!
            \***************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = (
              //Represents a data structure that keep all the necessary info about a single init/media segment
              function d() {
                h(this, d), this.streamId = null, this.mediaInfo = null, this.segmentType = null, this.quality = NaN, this.index = NaN, this.bytes = null, this.start = NaN, this.end = NaN, this.duration = NaN, this.representationId = null, this.endFragment = null;
              }
            );
            const p = f;
          }
        ),
        /***/
        "./src/streaming/vo/FragmentRequest.js": (
          /*!*********************************************!*\
            !*** ./src/streaming/vo/FragmentRequest.js ***!
            \*********************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => g
              /* harmony export */
            });
            var h = i(
              /*! ../vo/metrics/HTTPRequest */
              "./src/streaming/vo/metrics/HTTPRequest.js"
            );
            function f(m, A) {
              if (!(m instanceof A))
                throw new TypeError("Cannot call a class as a function");
            }
            function p(m, A) {
              for (var b = 0; b < A.length; b++) {
                var S = A[b];
                S.enumerable = S.enumerable || !1, S.configurable = !0, "value" in S && (S.writable = !0), Object.defineProperty(m, S.key, S);
              }
            }
            function d(m, A, b) {
              return A && p(m.prototype, A), b && p(m, b), m;
            }
            var v = /* @__PURE__ */ function() {
              function m(A) {
                f(this, m), this.action = m.ACTION_DOWNLOAD, this.startTime = NaN, this.mediaStartTime = NaN, this.mediaType = null, this.mediaInfo = null, this.type = null, this.duration = NaN, this.timescale = NaN, this.range = null, this.url = A || null, this.serviceLocation = null, this.requestStartDate = null, this.firstByteDate = null, this.requestEndDate = null, this.quality = NaN, this.index = NaN, this.availabilityStartTime = null, this.availabilityEndTime = null, this.wallStartTime = null, this.bytesLoaded = NaN, this.bytesTotal = NaN, this.delayLoadingTime = NaN, this.responseType = "arraybuffer", this.representationId = null;
              }
              return d(m, [{
                key: "isInitializationRequest",
                value: function() {
                  return this.type && this.type === h.HTTPRequest.INIT_SEGMENT_TYPE;
                }
              }, {
                key: "setInfo",
                value: function(b) {
                  this.type = b && b.init ? h.HTTPRequest.INIT_SEGMENT_TYPE : h.HTTPRequest.MEDIA_SEGMENT_TYPE, this.url = b && b.url ? b.url : null, this.range = b && b.range ? b.range.start + "-" + b.range.end : null, this.mediaType = b && b.mediaType ? b.mediaType : null;
                }
              }]), m;
            }();
            v.ACTION_DOWNLOAD = "download", v.ACTION_COMPLETE = "complete";
            const g = v;
          }
        ),
        /***/
        "./src/streaming/vo/HeadRequest.js": (
          /*!*****************************************!*\
            !*** ./src/streaming/vo/HeadRequest.js ***!
            \*****************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => T
              /* harmony export */
            });
            var h = i(
              /*! ./FragmentRequest */
              "./src/streaming/vo/FragmentRequest.js"
            );
            function f(R) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? f = function(E) {
                return typeof E;
              } : f = function(E) {
                return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
              }, f(R);
            }
            function p(R, y) {
              if (!(R instanceof y))
                throw new TypeError("Cannot call a class as a function");
            }
            function d(R, y) {
              if (typeof y != "function" && y !== null)
                throw new TypeError("Super expression must either be null or a function");
              R.prototype = Object.create(y && y.prototype, { constructor: { value: R, writable: !0, configurable: !0 } }), y && v(R, y);
            }
            function v(R, y) {
              return v = Object.setPrototypeOf || function(L, _) {
                return L.__proto__ = _, L;
              }, v(R, y);
            }
            function g(R) {
              var y = b();
              return function() {
                var L = S(R), _;
                if (y) {
                  var O = S(this).constructor;
                  _ = Reflect.construct(L, arguments, O);
                } else
                  _ = L.apply(this, arguments);
                return m(this, _);
              };
            }
            function m(R, y) {
              return y && (f(y) === "object" || typeof y == "function") ? y : A(R);
            }
            function A(R) {
              if (R === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return R;
            }
            function b() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return !1;
              if (typeof Proxy == "function")
                return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function S(R) {
              return S = Object.setPrototypeOf ? Object.getPrototypeOf : function(E) {
                return E.__proto__ || Object.getPrototypeOf(E);
              }, S(R);
            }
            var N = /* @__PURE__ */ function(R) {
              d(E, R);
              var y = g(E);
              function E(L) {
                var _;
                return p(this, E), _ = y.call(this, L), _.checkForExistenceOnly = !0, _;
              }
              return E;
            }(h.default);
            const T = N;
          }
        ),
        /***/
        "./src/streaming/vo/IsoBox.js": (
          /*!************************************!*\
            !*** ./src/streaming/vo/IsoBox.js ***!
            \************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => v
              /* harmony export */
            });
            function h(g, m) {
              if (!(g instanceof m))
                throw new TypeError("Cannot call a class as a function");
            }
            function f(g, m) {
              for (var A = 0; A < m.length; A++) {
                var b = m[A];
                b.enumerable = b.enumerable || !1, b.configurable = !0, "value" in b && (b.writable = !0), Object.defineProperty(g, b.key, b);
              }
            }
            function p(g, m, A) {
              return m && f(g.prototype, m), A && f(g, A), g;
            }
            var d = /* @__PURE__ */ function() {
              function g(m) {
                if (h(this, g), this.offset = m._offset, this.type = m.type, this.size = m.size, this.boxes = [], m.boxes)
                  for (var A = 0; A < m.boxes.length; A++)
                    this.boxes.push(new g(m.boxes[A]));
                switch (this.isComplete = !0, m.type) {
                  case "sidx":
                    if (this.timescale = m.timescale, this.earliest_presentation_time = m.earliest_presentation_time, this.first_offset = m.first_offset, this.references = m.references, m.references) {
                      this.references = [];
                      for (var b = 0; b < m.references.length; b++) {
                        var S = {
                          reference_type: m.references[b].reference_type,
                          referenced_size: m.references[b].referenced_size,
                          subsegment_duration: m.references[b].subsegment_duration
                        };
                        this.references.push(S);
                      }
                    }
                    break;
                  case "emsg":
                    this.id = m.id, this.version = m.version === 1 ? 1 : 0, this.value = m.value, this.timescale = m.timescale, this.scheme_id_uri = m.scheme_id_uri, this.presentation_time_delta = m.version === 1 ? m.presentation_time : m.presentation_time_delta, this.event_duration = m.event_duration, this.message_data = m.message_data;
                    break;
                  case "mdhd":
                    this.timescale = m.timescale;
                    break;
                  case "mfhd":
                    this.sequence_number = m.sequence_number;
                    break;
                  case "subs":
                    this.entry_count = m.entry_count, this.entries = m.entries;
                    break;
                  case "tfhd":
                    this.base_data_offset = m.base_data_offset, this.sample_description_index = m.sample_description_index, this.default_sample_duration = m.default_sample_duration, this.default_sample_size = m.default_sample_size, this.default_sample_flags = m.default_sample_flags, this.flags = m.flags;
                    break;
                  case "tfdt":
                    this.version = m.version, this.baseMediaDecodeTime = m.baseMediaDecodeTime, this.flags = m.flags;
                    break;
                  case "trun":
                    if (this.sample_count = m.sample_count, this.first_sample_flags = m.first_sample_flags, this.data_offset = m.data_offset, this.flags = m.flags, this.samples = m.samples, m.samples) {
                      this.samples = [];
                      for (var N = 0, T = m.samples.length; N < T; N++) {
                        var R = {
                          sample_size: m.samples[N].sample_size,
                          sample_duration: m.samples[N].sample_duration,
                          sample_composition_time_offset: m.samples[N].sample_composition_time_offset
                        };
                        this.samples.push(R);
                      }
                    }
                    break;
                }
              }
              return p(g, [{
                key: "getChildBox",
                value: function(A) {
                  for (var b = 0; b < this.boxes.length; b++)
                    if (this.boxes[b].type === A)
                      return this.boxes[b];
                }
              }, {
                key: "getChildBoxes",
                value: function(A) {
                  for (var b = [], S = 0; S < this.boxes.length; S++)
                    this.boxes[S].type === A && b.push(this.boxes[S]);
                  return b;
                }
              }]), g;
            }();
            const v = d;
          }
        ),
        /***/
        "./src/streaming/vo/IsoBoxSearchInfo.js": (
          /*!**********************************************!*\
            !*** ./src/streaming/vo/IsoBoxSearchInfo.js ***!
            \**********************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = function d(v, g, m) {
              h(this, d), this.lastCompletedOffset = v, this.found = g, this.size = m;
            };
            const p = f;
          }
        ),
        /***/
        "./src/streaming/vo/MetricsList.js": (
          /*!*****************************************!*\
            !*** ./src/streaming/vo/MetricsList.js ***!
            \*****************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = function d() {
              h(this, d), this.TcpList = [], this.HttpList = [], this.RepSwitchList = [], this.BufferLevel = [], this.BufferState = [], this.PlayList = [], this.DroppedFrames = [], this.SchedulingInfo = [], this.DVRInfo = [], this.ManifestUpdate = [], this.RequestsQueue = null, this.DVBErrors = [];
            };
            const p = f;
          }
        ),
        /***/
        "./src/streaming/vo/TextRequest.js": (
          /*!*****************************************!*\
            !*** ./src/streaming/vo/TextRequest.js ***!
            \*****************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => R
              /* harmony export */
            });
            var h = i(
              /*! ../constants/Constants */
              "./src/streaming/constants/Constants.js"
            ), f = i(
              /*! ./FragmentRequest */
              "./src/streaming/vo/FragmentRequest.js"
            );
            function p(y) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? p = function(L) {
                return typeof L;
              } : p = function(L) {
                return L && typeof Symbol == "function" && L.constructor === Symbol && L !== Symbol.prototype ? "symbol" : typeof L;
              }, p(y);
            }
            function d(y, E) {
              if (!(y instanceof E))
                throw new TypeError("Cannot call a class as a function");
            }
            function v(y, E) {
              if (typeof E != "function" && E !== null)
                throw new TypeError("Super expression must either be null or a function");
              y.prototype = Object.create(E && E.prototype, { constructor: { value: y, writable: !0, configurable: !0 } }), E && g(y, E);
            }
            function g(y, E) {
              return g = Object.setPrototypeOf || function(_, O) {
                return _.__proto__ = O, _;
              }, g(y, E);
            }
            function m(y) {
              var E = S();
              return function() {
                var _ = N(y), O;
                if (E) {
                  var D = N(this).constructor;
                  O = Reflect.construct(_, arguments, D);
                } else
                  O = _.apply(this, arguments);
                return A(this, O);
              };
            }
            function A(y, E) {
              return E && (p(E) === "object" || typeof E == "function") ? E : b(y);
            }
            function b(y) {
              if (y === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return y;
            }
            function S() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return !1;
              if (typeof Proxy == "function")
                return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function N(y) {
              return N = Object.setPrototypeOf ? Object.getPrototypeOf : function(L) {
                return L.__proto__ || Object.getPrototypeOf(L);
              }, N(y);
            }
            var T = /* @__PURE__ */ function(y) {
              v(L, y);
              var E = m(L);
              function L(_, O) {
                var D;
                return d(this, L), D = E.call(this), D.url = _ || null, D.type = O || null, D.mediaType = h.default.STREAM, D.responseType = "", D;
              }
              return L;
            }(f.default);
            const R = T;
          }
        ),
        /***/
        "./src/streaming/vo/TextTrackInfo.js": (
          /*!*******************************************!*\
            !*** ./src/streaming/vo/TextTrackInfo.js ***!
            \*******************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => T
              /* harmony export */
            });
            var h = i(
              /*! ./../../dash/vo/MediaInfo */
              "./src/dash/vo/MediaInfo.js"
            );
            function f(R) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? f = function(E) {
                return typeof E;
              } : f = function(E) {
                return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
              }, f(R);
            }
            function p(R, y) {
              if (!(R instanceof y))
                throw new TypeError("Cannot call a class as a function");
            }
            function d(R, y) {
              if (typeof y != "function" && y !== null)
                throw new TypeError("Super expression must either be null or a function");
              R.prototype = Object.create(y && y.prototype, { constructor: { value: R, writable: !0, configurable: !0 } }), y && v(R, y);
            }
            function v(R, y) {
              return v = Object.setPrototypeOf || function(L, _) {
                return L.__proto__ = _, L;
              }, v(R, y);
            }
            function g(R) {
              var y = b();
              return function() {
                var L = S(R), _;
                if (y) {
                  var O = S(this).constructor;
                  _ = Reflect.construct(L, arguments, O);
                } else
                  _ = L.apply(this, arguments);
                return m(this, _);
              };
            }
            function m(R, y) {
              return y && (f(y) === "object" || typeof y == "function") ? y : A(R);
            }
            function A(R) {
              if (R === void 0)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return R;
            }
            function b() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                return !1;
              if (typeof Proxy == "function")
                return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }
            function S(R) {
              return S = Object.setPrototypeOf ? Object.getPrototypeOf : function(E) {
                return E.__proto__ || Object.getPrototypeOf(E);
              }, S(R);
            }
            var N = /* @__PURE__ */ function(R) {
              d(E, R);
              var y = g(E);
              function E() {
                var L;
                return p(this, E), L = y.call(this), L.captionData = null, L.label = null, L.defaultTrack = !1, L.kind = null, L.isFragmented = !1, L.isEmbedded = !1, L.isTTML = null, L;
              }
              return E;
            }(h.default);
            const T = N;
          }
        ),
        /***/
        "./src/streaming/vo/Thumbnail.js": (
          /*!***************************************!*\
            !*** ./src/streaming/vo/Thumbnail.js ***!
            \***************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = function d() {
              h(this, d), this.url = null, this.width = null, this.height = null, this.x = null, this.y = null;
            };
            const p = f;
          }
        ),
        /***/
        "./src/streaming/vo/ThumbnailTrackInfo.js": (
          /*!************************************************!*\
            !*** ./src/streaming/vo/ThumbnailTrackInfo.js ***!
            \************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = function d() {
              h(this, d), this.bitrate = 0, this.width = 0, this.height = 0, this.tilesHor = 0, this.tilesVert = 0, this.widthPerTile = 0, this.heightPerTile = 0, this.startNumber = 0, this.segmentDuration = 0, this.timescale = 0, this.templateUrl = "", this.id = "";
            };
            const p = f;
          }
        ),
        /***/
        "./src/streaming/vo/URIFragmentData.js": (
          /*!*********************************************!*\
            !*** ./src/streaming/vo/URIFragmentData.js ***!
            \*********************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = function d() {
              h(this, d), this.t = null, this.xywh = null, this.track = null, this.id = null, this.s = null, this.r = null;
            };
            const p = f;
          }
        ),
        /***/
        "./src/streaming/vo/metrics/BufferLevel.js": (
          /*!*************************************************!*\
            !*** ./src/streaming/vo/metrics/BufferLevel.js ***!
            \*************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = (
              /**
               * @description This Object holds reference to the current buffer level and the time it was recorded.
               */
              function d() {
                h(this, d), this.t = null, this.level = null;
              }
            );
            const p = f;
          }
        ),
        /***/
        "./src/streaming/vo/metrics/BufferState.js": (
          /*!*************************************************!*\
            !*** ./src/streaming/vo/metrics/BufferState.js ***!
            \*************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => d
              /* harmony export */
            });
            var h = i(
              /*! ../../constants/MetricsConstants */
              "./src/streaming/constants/MetricsConstants.js"
            );
            function f(v, g) {
              if (!(v instanceof g))
                throw new TypeError("Cannot call a class as a function");
            }
            var p = (
              /**
               * @description This Object holds reference to the current buffer state of the video element.
               */
              function v() {
                f(this, v), this.target = null, this.state = h.default.BUFFER_EMPTY;
              }
            );
            const d = p;
          }
        ),
        /***/
        "./src/streaming/vo/metrics/DVRInfo.js": (
          /*!*********************************************!*\
            !*** ./src/streaming/vo/metrics/DVRInfo.js ***!
            \*********************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = (
              /**
               * @description This Object holds reference to DVR availability window information.
               */
              function d() {
                h(this, d), this.time = null, this.range = null, this.manifestInfo = null;
              }
            );
            const p = f;
          }
        ),
        /***/
        "./src/streaming/vo/metrics/DroppedFrames.js": (
          /*!***************************************************!*\
            !*** ./src/streaming/vo/metrics/DroppedFrames.js ***!
            \***************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = (
              /**
               * @description This Object holds reference to DroppedFrames count and the time it was recorded.
               */
              function d() {
                h(this, d), this.time = null, this.droppedFrames = null;
              }
            );
            const p = f;
          }
        ),
        /***/
        "./src/streaming/vo/metrics/HTTPRequest.js": (
          /*!*************************************************!*\
            !*** ./src/streaming/vo/metrics/HTTPRequest.js ***!
            \*************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              HTTPRequest: () => (
                /* binding */
                f
              ),
              /* harmony export */
              HTTPRequestTrace: () => (
                /* binding */
                p
              )
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = (
              /**
               * @class
               */
              function d() {
                h(this, d), this.tcpid = null, this.type = null, this.url = null, this.actualurl = null, this.range = null, this.trequest = null, this.tresponse = null, this.responsecode = null, this.interval = null, this.trace = [], this.cmsd = null, this._stream = null, this._tfinish = null, this._mediaduration = null, this._quality = null, this._responseHeaders = null, this._serviceLocation = null, this._fileLoaderType = null;
              }
            ), p = (
              /**
               * @class
               */
              function d() {
                h(this, d), this.s = null, this.d = null, this.b = [];
              }
            );
            f.GET = "GET", f.HEAD = "HEAD", f.MPD_TYPE = "MPD", f.XLINK_EXPANSION_TYPE = "XLinkExpansion", f.INIT_SEGMENT_TYPE = "InitializationSegment", f.INDEX_SEGMENT_TYPE = "IndexSegment", f.MEDIA_SEGMENT_TYPE = "MediaSegment", f.BITSTREAM_SWITCHING_SEGMENT_TYPE = "BitstreamSwitchingSegment", f.MSS_FRAGMENT_INFO_SEGMENT_TYPE = "FragmentInfoSegment", f.DVB_REPORTING_TYPE = "DVBReporting", f.LICENSE = "license", f.CONTENT_STEERING_TYPE = "ContentSteering", f.OTHER_TYPE = "other";
          }
        ),
        /***/
        "./src/streaming/vo/metrics/ManifestUpdate.js": (
          /*!****************************************************!*\
            !*** ./src/streaming/vo/metrics/ManifestUpdate.js ***!
            \****************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              ManifestUpdate: () => (
                /* binding */
                f
              ),
              /* harmony export */
              ManifestUpdateRepresentationInfo: () => (
                /* binding */
                d
              ),
              /* harmony export */
              ManifestUpdateStreamInfo: () => (
                /* binding */
                p
              )
              /* harmony export */
            });
            function h(v, g) {
              if (!(v instanceof g))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = (
              /**
               * @class
               */
              function v() {
                h(this, v), this.mediaType = null, this.type = null, this.requestTime = null, this.fetchTime = null, this.availabilityStartTime = null, this.presentationStartTime = 0, this.clientTimeOffset = 0, this.currentTime = null, this.buffered = null, this.latency = 0, this.streamInfo = [], this.representationInfo = [];
              }
            ), p = (
              /**
               * @class
               */
              function v() {
                h(this, v), this.id = null, this.index = null, this.start = null, this.duration = null;
              }
            ), d = (
              /**
               * @class
               */
              function v() {
                h(this, v), this.id = null, this.index = null, this.mediaType = null, this.streamIndex = null, this.presentationTimeOffset = null, this.startNumber = null, this.fragmentInfoType = null;
              }
            );
          }
        ),
        /***/
        "./src/streaming/vo/metrics/PlayList.js": (
          /*!**********************************************!*\
            !*** ./src/streaming/vo/metrics/PlayList.js ***!
            \**********************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              PlayList: () => (
                /* binding */
                f
              ),
              /* harmony export */
              PlayListTrace: () => (
                /* binding */
                p
              )
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = (
              /**
               * @class
               */
              function d() {
                h(this, d), this.start = null, this.mstart = null, this.starttype = null, this.trace = [];
              }
            );
            f.INITIAL_PLAYOUT_START_REASON = "initial_playout", f.SEEK_START_REASON = "seek", f.RESUME_FROM_PAUSE_START_REASON = "resume", f.METRICS_COLLECTION_START_REASON = "metrics_collection_start";
            var p = (
              /**
               * @class
               */
              function d() {
                h(this, d), this.representationid = null, this.subreplevel = null, this.start = null, this.mstart = null, this.duration = null, this.playbackspeed = null, this.stopreason = null;
              }
            );
            p.REPRESENTATION_SWITCH_STOP_REASON = "representation_switch", p.REBUFFERING_REASON = "rebuffering", p.USER_REQUEST_STOP_REASON = "user_request", p.END_OF_PERIOD_STOP_REASON = "end_of_period", p.END_OF_CONTENT_STOP_REASON = "end_of_content", p.METRICS_COLLECTION_STOP_REASON = "metrics_collection_end", p.FAILURE_STOP_REASON = "failure";
          }
        ),
        /***/
        "./src/streaming/vo/metrics/RepresentationSwitch.js": (
          /*!**********************************************************!*\
            !*** ./src/streaming/vo/metrics/RepresentationSwitch.js ***!
            \**********************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = (
              /**
               * @description This Object holds reference to the info at quality switch between two representations.
               */
              function d() {
                h(this, d), this.t = null, this.mt = null, this.to = null, this.lto = null;
              }
            );
            const p = f;
          }
        ),
        /***/
        "./src/streaming/vo/metrics/RequestsQueue.js": (
          /*!***************************************************!*\
            !*** ./src/streaming/vo/metrics/RequestsQueue.js ***!
            \***************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = (
              /**
               * @description This Object holds reference to Fragment Model's request queues
               */
              function d() {
                h(this, d), this.loadingRequests = [], this.executedRequests = [];
              }
            );
            const p = f;
          }
        ),
        /***/
        "./src/streaming/vo/metrics/SchedulingInfo.js": (
          /*!****************************************************!*\
            !*** ./src/streaming/vo/metrics/SchedulingInfo.js ***!
            \****************************************************/
          /***/
          (c, l, i) => {
            i.r(l), i.d(l, {
              /* harmony export */
              default: () => p
              /* harmony export */
            });
            function h(d, v) {
              if (!(d instanceof v))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = (
              /**
               * @description This Object holds reference to the index handling of the current fragment being loaded or executed.
               */
              function d() {
                h(this, d), this.mediaType = null, this.t = null, this.type = null, this.startTime = null, this.availabilityStartTime = null, this.duration = null, this.quality = null, this.range = null, this.state = null;
              }
            );
            const p = f;
          }
        ),
        /***/
        "./node_modules/bcp-47-match/index.js": (
          /*!********************************************!*\
            !*** ./node_modules/bcp-47-match/index.js ***!
            \********************************************/
          /***/
          (c, l) => {
            l.basicFilter = p(i, !0), l.extendedFilter = p(h, !0), l.lookup = p(f);
            function i(v, g) {
              return g === "*" || v === g || v.indexOf(g + "-") > -1;
            }
            function h(v, g) {
              var m = v.split("-"), A = g.split("-"), b = 0, S = 0;
              if (A[S] !== "*" && m[b] !== A[S])
                return !1;
              for (b++, S++; S < A.length; ) {
                if (A[S] === "*") {
                  S++;
                  continue;
                }
                if (!m[b])
                  return !1;
                if (m[b] === A[S]) {
                  b++, S++;
                  continue;
                }
                if (m[b].length === 1)
                  return !1;
                b++;
              }
              return !0;
            }
            function f(v, g) {
              for (var m = g, A; ; ) {
                if (m === "*" || v === m)
                  return !0;
                if (A = m.lastIndexOf("-"), A < 0)
                  return !1;
                m.charAt(A - 2) === "-" && (A -= 2), m = m.slice(0, A);
              }
            }
            function p(v, g) {
              return m;
              function m(A, b) {
                for (var S = d(A, "tag"), N = d(b ?? "*", "range"), T = [], R = -1, y, E, L; ++R < N.length; )
                  if (y = N[R].toLowerCase(), !(!g && y === "*")) {
                    for (E = -1, L = []; ++E < S.length; )
                      if (v(S[E].toLowerCase(), y)) {
                        if (!g)
                          return S[E];
                        T.push(S[E]);
                      } else
                        L.push(S[E]);
                    S = L;
                  }
                return g ? T : void 0;
              }
            }
            function d(v, g) {
              var m = v && typeof v == "string" ? [v] : v;
              if (!m || typeof m != "object" || !("length" in m))
                throw new Error(
                  "Invalid " + g + " `" + m + "`, expected non-empty string"
                );
              return m;
            }
          }
        ),
        /***/
        "./node_modules/bcp-47-normalize/index.js": (
          /*!************************************************!*\
            !*** ./node_modules/bcp-47-normalize/index.js ***!
            \************************************************/
          /***/
          (c, l, i) => {
            c.exports = i(
              /*! ./lib */
              "./node_modules/bcp-47-normalize/lib/index.js"
            );
          }
        ),
        /***/
        "./node_modules/bcp-47-normalize/lib/index.js": (
          /*!****************************************************!*\
            !*** ./node_modules/bcp-47-normalize/lib/index.js ***!
            \****************************************************/
          /***/
          (c, l, i) => {
            var h = i(
              /*! bcp-47 */
              "./node_modules/bcp-47/index.js"
            ), f = i(
              /*! bcp-47-match */
              "./node_modules/bcp-47-match/index.js"
            ), p = i(
              /*! ./matches.json */
              "./node_modules/bcp-47-normalize/lib/matches.json"
            ), d = i(
              /*! ./fields.json */
              "./node_modules/bcp-47-normalize/lib/fields.json"
            ), v = i(
              /*! ./defaults.json */
              "./node_modules/bcp-47-normalize/lib/defaults.json"
            ), g = i(
              /*! ./many.json */
              "./node_modules/bcp-47-normalize/lib/many.json"
            );
            c.exports = S;
            var m = {}.hasOwnProperty, A = new Intl.Collator(), b = {
              variants: [],
              extensions: [],
              privateuse: [],
              irregular: null,
              regular: null
            };
            function S(E, L) {
              var _ = L || {}, O = h.parse(String(E || "").toLowerCase(), _), D = h.stringify(O), M = -1, C;
              if (!D)
                return D;
              for (; ++M < p.length; )
                f.extendedFilter(D, p[M].from).length && (N(O, p[M].from, p[M].to), D = h.stringify(O));
              for (M = -1; ++M < d.length; )
                T(O, d[M].from.field, d[M].from.value) && R(O, d[M].to.field, d[M].to.value);
              for (D = h.stringify(Object.assign({}, O, b)), M = -1; ++M < v.length; )
                D === v[M] && (N(
                  O,
                  v[M],
                  v[M].split("-").slice(0, -1).join("-")
                ), D = h.stringify(Object.assign({}, O, b)));
              if (O.extensions.sort(y), _.warning)
                for (C in g)
                  m.call(g[C], O[C]) && _.warning(
                    "Deprecated " + C + " `" + O[C] + "`, expected one of `" + g[C][O[C]].join("`, `") + "`",
                    null,
                    7
                  );
              return O.script && (O.script = O.script.charAt(0).toUpperCase() + O.script.slice(1)), O.region && (O.region = O.region.toUpperCase()), h.stringify(O);
            }
            function N(E, L, _) {
              var O = h.parse(L), D = h.parse(_), M = [], C;
              for (C in O)
                O[C] && O[C].length && T(E, C, O[C]) && M.push(C);
              for (C in D)
                D[C] && D[C].length && (M.indexOf(C) > -1 || !E[C] || !E[C].length) && R(E, C, D[C]);
            }
            function T(E, L, _) {
              var O = !1, D, M, C, I;
              if (_) {
                if (D = E[L], M = D, D && typeof D == "object")
                  for (M = [], C = -1; ++C < D.length; )
                    I = D[C], _.indexOf(I) < 0 ? M.push(I) : O = !0;
                else
                  D === _ && (M = null, O = !0);
                E[L] = M;
              }
              return O;
            }
            function R(E, L, _) {
              var O = E[L], D, M, C;
              if (O && typeof O == "object")
                for (D = [].concat(_), M = -1; ++M < D.length; )
                  C = D[M], O.indexOf(C) < 0 && O.push(C);
              else
                E[L] = _;
            }
            function y(E, L) {
              return A.compare(E.singleton, L.singleton);
            }
          }
        ),
        /***/
        "./node_modules/bcp-47/index.js": (
          /*!**************************************!*\
            !*** ./node_modules/bcp-47/index.js ***!
            \**************************************/
          /***/
          (c, l, i) => {
            l.parse = i(
              /*! ./lib/parse */
              "./node_modules/bcp-47/lib/parse.js"
            ), l.stringify = i(
              /*! ./lib/stringify */
              "./node_modules/bcp-47/lib/stringify.js"
            );
          }
        ),
        /***/
        "./node_modules/bcp-47/lib/parse.js": (
          /*!******************************************!*\
            !*** ./node_modules/bcp-47/lib/parse.js ***!
            \******************************************/
          /***/
          (c, l, i) => {
            var h = i(
              /*! is-alphanumerical */
              "./node_modules/is-alphanumerical/index.js"
            ), f = i(
              /*! is-alphabetical */
              "./node_modules/is-alphabetical/index.js"
            ), p = i(
              /*! is-decimal */
              "./node_modules/is-decimal/index.js"
            ), d = i(
              /*! ./regular.json */
              "./node_modules/bcp-47/lib/regular.json"
            ), v = i(
              /*! ./normalize.json */
              "./node_modules/bcp-47/lib/normalize.json"
            );
            c.exports = m;
            var g = {}.hasOwnProperty;
            function m(b, S) {
              var N = S || {}, T = A(), R = String(b), y = R.toLowerCase(), E = 0, L, _, O;
              if (b == null)
                throw new Error("Expected string, got `" + b + "`");
              if (g.call(v, y))
                return (N.normalize == null || N.normalize) && v[y] ? m(v[y]) : (T[d.indexOf(y) === -1 ? "irregular" : "regular"] = R, T);
              for (; f(y.charCodeAt(E)) && E < 9; )
                E++;
              if (E > 1 && E < 9) {
                if (T.language = R.slice(0, E), E < 4)
                  for (_ = 0; y.charCodeAt(E) === 45 && f(y.charCodeAt(E + 1)) && f(y.charCodeAt(E + 2)) && f(y.charCodeAt(E + 3)) && !f(y.charCodeAt(E + 4)); ) {
                    if (_ > 2)
                      return D(
                        E,
                        3,
                        "Too many extended language subtags, expected at most 3 subtags"
                      );
                    T.extendedLanguageSubtags.push(R.slice(E + 1, E + 4)), E += 4, _++;
                  }
                for (y.charCodeAt(E) === 45 && f(y.charCodeAt(E + 1)) && f(y.charCodeAt(E + 2)) && f(y.charCodeAt(E + 3)) && f(y.charCodeAt(E + 4)) && !f(y.charCodeAt(E + 5)) && (T.script = R.slice(E + 1, E + 5), E += 5), y.charCodeAt(E) === 45 && (f(y.charCodeAt(E + 1)) && f(y.charCodeAt(E + 2)) && !f(y.charCodeAt(E + 3)) ? (T.region = R.slice(E + 1, E + 3), E += 3) : p(y.charCodeAt(E + 1)) && p(y.charCodeAt(E + 2)) && p(y.charCodeAt(E + 3)) && !p(y.charCodeAt(E + 4)) && (T.region = R.slice(E + 1, E + 4), E += 4)); y.charCodeAt(E) === 45; ) {
                  for (O = L = E + 1; h(y.charCodeAt(O)); ) {
                    if (O - L > 7)
                      return D(
                        O,
                        1,
                        "Too long variant, expected at most 8 characters"
                      );
                    O++;
                  }
                  if (
                    // Long variant.
                    O - L > 4 || // Short variant.
                    O - L > 3 && p(y.charCodeAt(L))
                  )
                    T.variants.push(R.slice(L, O)), E = O;
                  else
                    break;
                }
                for (; y.charCodeAt(E) === 45 && !(y.charCodeAt(E + 1) === 120 || !h(y.charCodeAt(E + 1)) || y.charCodeAt(E + 2) !== 45 || !h(y.charCodeAt(E + 3))); ) {
                  for (O = E + 2, _ = 0; y.charCodeAt(O) === 45 && h(y.charCodeAt(O + 1)) && h(y.charCodeAt(O + 2)); )
                    for (L = O + 1, O = L + 2, _++; h(y.charCodeAt(O)); ) {
                      if (O - L > 7)
                        return D(
                          O,
                          2,
                          "Too long extension, expected at most 8 characters"
                        );
                      O++;
                    }
                  if (!_)
                    return D(
                      O,
                      4,
                      "Empty extension, extensions must have at least 2 characters of content"
                    );
                  T.extensions.push({
                    singleton: R.charAt(E + 1),
                    extensions: R.slice(E + 3, O).split("-")
                  }), E = O;
                }
              } else
                E = 0;
              if (E === 0 && y.charCodeAt(E) === 120 || y.charCodeAt(E) === 45 && y.charCodeAt(E + 1) === 120)
                for (O = E = E ? E + 2 : 1; y.charCodeAt(O) === 45 && h(y.charCodeAt(O + 1)); ) {
                  for (O = L = E + 1; h(y.charCodeAt(O)); ) {
                    if (O - L > 7)
                      return D(
                        O,
                        5,
                        "Too long private-use area, expected at most 8 characters"
                      );
                    O++;
                  }
                  T.privateuse.push(R.slice(E + 1, O)), E = O;
                }
              if (E !== R.length)
                return D(E, 6, "Found superfluous content after tag");
              return T;
              function D(M, C, I) {
                return N.warning && N.warning(I, C, M), N.forgiving ? T : A();
              }
            }
            function A() {
              return {
                language: null,
                extendedLanguageSubtags: [],
                script: null,
                region: null,
                variants: [],
                extensions: [],
                privateuse: [],
                irregular: null,
                regular: null
              };
            }
          }
        ),
        /***/
        "./node_modules/bcp-47/lib/stringify.js": (
          /*!**********************************************!*\
            !*** ./node_modules/bcp-47/lib/stringify.js ***!
            \**********************************************/
          /***/
          (c) => {
            c.exports = l;
            function l(i) {
              var h = i || {}, f = [], p, d, v;
              if (h.irregular || h.regular)
                return h.irregular || h.regular;
              if (h.language)
                for (f = f.concat(
                  h.language,
                  h.extendedLanguageSubtags || [],
                  h.script || [],
                  h.region || [],
                  h.variants || []
                ), p = h.extensions || [], d = -1; ++d < p.length; )
                  v = p[d], v.singleton && v.extensions && v.extensions.length && (f = f.concat(v.singleton, v.extensions));
              return h.privateuse && h.privateuse.length && (f = f.concat("x", h.privateuse)), f.join("-");
            }
          }
        ),
        /***/
        "./node_modules/buffer/index.js": (
          /*!**************************************!*\
            !*** ./node_modules/buffer/index.js ***!
            \**************************************/
          /***/
          (c, l, i) => {
            /*!
             * The buffer module from node.js, for the browser.
             *
             * @author   Feross Aboukhadijeh <https://feross.org>
             * @license  MIT
             */
            var h = i(
              /*! base64-js */
              "./node_modules/buffer/node_modules/base64-js/index.js"
            ), f = i(
              /*! ieee754 */
              "./node_modules/buffer/node_modules/ieee754/index.js"
            ), p = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
            l.Buffer = m, l.SlowBuffer = O, l.INSPECT_MAX_BYTES = 50;
            var d = 2147483647;
            l.kMaxLength = d, m.TYPED_ARRAY_SUPPORT = v(), !m.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
              "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
            );
            function v() {
              try {
                var K = new Uint8Array(1), U = { foo: function() {
                  return 42;
                } };
                return Object.setPrototypeOf(U, Uint8Array.prototype), Object.setPrototypeOf(K, U), K.foo() === 42;
              } catch {
                return !1;
              }
            }
            Object.defineProperty(m.prototype, "parent", {
              enumerable: !0,
              get: function() {
                if (m.isBuffer(this))
                  return this.buffer;
              }
            }), Object.defineProperty(m.prototype, "offset", {
              enumerable: !0,
              get: function() {
                if (m.isBuffer(this))
                  return this.byteOffset;
              }
            });
            function g(K) {
              if (K > d)
                throw new RangeError('The value "' + K + '" is invalid for option "size"');
              var U = new Uint8Array(K);
              return Object.setPrototypeOf(U, m.prototype), U;
            }
            function m(K, U, V) {
              if (typeof K == "number") {
                if (typeof U == "string")
                  throw new TypeError(
                    'The "string" argument must be of type string. Received type number'
                  );
                return N(K);
              }
              return A(K, U, V);
            }
            m.poolSize = 8192;
            function A(K, U, V) {
              if (typeof K == "string")
                return T(K, U);
              if (ArrayBuffer.isView(K))
                return y(K);
              if (K == null)
                throw new TypeError(
                  "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof K
                );
              if (B(K, ArrayBuffer) || K && B(K.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (B(K, SharedArrayBuffer) || K && B(K.buffer, SharedArrayBuffer)))
                return E(K, U, V);
              if (typeof K == "number")
                throw new TypeError(
                  'The "value" argument must not be of type number. Received type number'
                );
              var Q = K.valueOf && K.valueOf();
              if (Q != null && Q !== K)
                return m.from(Q, U, V);
              var fe = L(K);
              if (fe)
                return fe;
              if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof K[Symbol.toPrimitive] == "function")
                return m.from(
                  K[Symbol.toPrimitive]("string"),
                  U,
                  V
                );
              throw new TypeError(
                "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof K
              );
            }
            m.from = function(K, U, V) {
              return A(K, U, V);
            }, Object.setPrototypeOf(m.prototype, Uint8Array.prototype), Object.setPrototypeOf(m, Uint8Array);
            function b(K) {
              if (typeof K != "number")
                throw new TypeError('"size" argument must be of type number');
              if (K < 0)
                throw new RangeError('The value "' + K + '" is invalid for option "size"');
            }
            function S(K, U, V) {
              return b(K), K <= 0 ? g(K) : U !== void 0 ? typeof V == "string" ? g(K).fill(U, V) : g(K).fill(U) : g(K);
            }
            m.alloc = function(K, U, V) {
              return S(K, U, V);
            };
            function N(K) {
              return b(K), g(K < 0 ? 0 : _(K) | 0);
            }
            m.allocUnsafe = function(K) {
              return N(K);
            }, m.allocUnsafeSlow = function(K) {
              return N(K);
            };
            function T(K, U) {
              if ((typeof U != "string" || U === "") && (U = "utf8"), !m.isEncoding(U))
                throw new TypeError("Unknown encoding: " + U);
              var V = D(K, U) | 0, Q = g(V), fe = Q.write(K, U);
              return fe !== V && (Q = Q.slice(0, fe)), Q;
            }
            function R(K) {
              for (var U = K.length < 0 ? 0 : _(K.length) | 0, V = g(U), Q = 0; Q < U; Q += 1)
                V[Q] = K[Q] & 255;
              return V;
            }
            function y(K) {
              if (B(K, Uint8Array)) {
                var U = new Uint8Array(K);
                return E(U.buffer, U.byteOffset, U.byteLength);
              }
              return R(K);
            }
            function E(K, U, V) {
              if (U < 0 || K.byteLength < U)
                throw new RangeError('"offset" is outside of buffer bounds');
              if (K.byteLength < U + (V || 0))
                throw new RangeError('"length" is outside of buffer bounds');
              var Q;
              return U === void 0 && V === void 0 ? Q = new Uint8Array(K) : V === void 0 ? Q = new Uint8Array(K, U) : Q = new Uint8Array(K, U, V), Object.setPrototypeOf(Q, m.prototype), Q;
            }
            function L(K) {
              if (m.isBuffer(K)) {
                var U = _(K.length) | 0, V = g(U);
                return V.length === 0 || K.copy(V, 0, 0, U), V;
              }
              if (K.length !== void 0)
                return typeof K.length != "number" || W(K.length) ? g(0) : R(K);
              if (K.type === "Buffer" && Array.isArray(K.data))
                return R(K.data);
            }
            function _(K) {
              if (K >= d)
                throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + d.toString(16) + " bytes");
              return K | 0;
            }
            function O(K) {
              return +K != K && (K = 0), m.alloc(+K);
            }
            m.isBuffer = function(U) {
              return U != null && U._isBuffer === !0 && U !== m.prototype;
            }, m.compare = function(U, V) {
              if (B(U, Uint8Array) && (U = m.from(U, U.offset, U.byteLength)), B(V, Uint8Array) && (V = m.from(V, V.offset, V.byteLength)), !m.isBuffer(U) || !m.isBuffer(V))
                throw new TypeError(
                  'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
                );
              if (U === V)
                return 0;
              for (var Q = U.length, fe = V.length, ue = 0, q = Math.min(Q, fe); ue < q; ++ue)
                if (U[ue] !== V[ue]) {
                  Q = U[ue], fe = V[ue];
                  break;
                }
              return Q < fe ? -1 : fe < Q ? 1 : 0;
            }, m.isEncoding = function(U) {
              switch (String(U).toLowerCase()) {
                case "hex":
                case "utf8":
                case "utf-8":
                case "ascii":
                case "latin1":
                case "binary":
                case "base64":
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return !0;
                default:
                  return !1;
              }
            }, m.concat = function(U, V) {
              if (!Array.isArray(U))
                throw new TypeError('"list" argument must be an Array of Buffers');
              if (U.length === 0)
                return m.alloc(0);
              var Q;
              if (V === void 0)
                for (V = 0, Q = 0; Q < U.length; ++Q)
                  V += U[Q].length;
              var fe = m.allocUnsafe(V), ue = 0;
              for (Q = 0; Q < U.length; ++Q) {
                var q = U[Q];
                if (B(q, Uint8Array))
                  ue + q.length > fe.length ? m.from(q).copy(fe, ue) : Uint8Array.prototype.set.call(
                    fe,
                    q,
                    ue
                  );
                else if (m.isBuffer(q))
                  q.copy(fe, ue);
                else
                  throw new TypeError('"list" argument must be an Array of Buffers');
                ue += q.length;
              }
              return fe;
            };
            function D(K, U) {
              if (m.isBuffer(K))
                return K.length;
              if (ArrayBuffer.isView(K) || B(K, ArrayBuffer))
                return K.byteLength;
              if (typeof K != "string")
                throw new TypeError(
                  'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof K
                );
              var V = K.length, Q = arguments.length > 2 && arguments[2] === !0;
              if (!Q && V === 0)
                return 0;
              for (var fe = !1; ; )
                switch (U) {
                  case "ascii":
                  case "latin1":
                  case "binary":
                    return V;
                  case "utf8":
                  case "utf-8":
                    return te(K).length;
                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return V * 2;
                  case "hex":
                    return V >>> 1;
                  case "base64":
                    return x(K).length;
                  default:
                    if (fe)
                      return Q ? -1 : te(K).length;
                    U = ("" + U).toLowerCase(), fe = !0;
                }
            }
            m.byteLength = D;
            function M(K, U, V) {
              var Q = !1;
              if ((U === void 0 || U < 0) && (U = 0), U > this.length || ((V === void 0 || V > this.length) && (V = this.length), V <= 0) || (V >>>= 0, U >>>= 0, V <= U))
                return "";
              for (K || (K = "utf8"); ; )
                switch (K) {
                  case "hex":
                    return re(this, U, V);
                  case "utf8":
                  case "utf-8":
                    return J(this, U, V);
                  case "ascii":
                    return $(this, U, V);
                  case "latin1":
                  case "binary":
                    return ie(this, U, V);
                  case "base64":
                    return j(this, U, V);
                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return ce(this, U, V);
                  default:
                    if (Q)
                      throw new TypeError("Unknown encoding: " + K);
                    K = (K + "").toLowerCase(), Q = !0;
                }
            }
            m.prototype._isBuffer = !0;
            function C(K, U, V) {
              var Q = K[U];
              K[U] = K[V], K[V] = Q;
            }
            m.prototype.swap16 = function() {
              var U = this.length;
              if (U % 2 !== 0)
                throw new RangeError("Buffer size must be a multiple of 16-bits");
              for (var V = 0; V < U; V += 2)
                C(this, V, V + 1);
              return this;
            }, m.prototype.swap32 = function() {
              var U = this.length;
              if (U % 4 !== 0)
                throw new RangeError("Buffer size must be a multiple of 32-bits");
              for (var V = 0; V < U; V += 4)
                C(this, V, V + 3), C(this, V + 1, V + 2);
              return this;
            }, m.prototype.swap64 = function() {
              var U = this.length;
              if (U % 8 !== 0)
                throw new RangeError("Buffer size must be a multiple of 64-bits");
              for (var V = 0; V < U; V += 8)
                C(this, V, V + 7), C(this, V + 1, V + 6), C(this, V + 2, V + 5), C(this, V + 3, V + 4);
              return this;
            }, m.prototype.toString = function() {
              var U = this.length;
              return U === 0 ? "" : arguments.length === 0 ? J(this, 0, U) : M.apply(this, arguments);
            }, m.prototype.toLocaleString = m.prototype.toString, m.prototype.equals = function(U) {
              if (!m.isBuffer(U))
                throw new TypeError("Argument must be a Buffer");
              return this === U ? !0 : m.compare(this, U) === 0;
            }, m.prototype.inspect = function() {
              var U = "", V = l.INSPECT_MAX_BYTES;
              return U = this.toString("hex", 0, V).replace(/(.{2})/g, "$1 ").trim(), this.length > V && (U += " ... "), "<Buffer " + U + ">";
            }, p && (m.prototype[p] = m.prototype.inspect), m.prototype.compare = function(U, V, Q, fe, ue) {
              if (B(U, Uint8Array) && (U = m.from(U, U.offset, U.byteLength)), !m.isBuffer(U))
                throw new TypeError(
                  'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof U
                );
              if (V === void 0 && (V = 0), Q === void 0 && (Q = U ? U.length : 0), fe === void 0 && (fe = 0), ue === void 0 && (ue = this.length), V < 0 || Q > U.length || fe < 0 || ue > this.length)
                throw new RangeError("out of range index");
              if (fe >= ue && V >= Q)
                return 0;
              if (fe >= ue)
                return -1;
              if (V >= Q)
                return 1;
              if (V >>>= 0, Q >>>= 0, fe >>>= 0, ue >>>= 0, this === U)
                return 0;
              for (var q = ue - fe, _e = Q - V, ge = Math.min(q, _e), Ce = this.slice(fe, ue), Ee = U.slice(V, Q), Re = 0; Re < ge; ++Re)
                if (Ce[Re] !== Ee[Re]) {
                  q = Ce[Re], _e = Ee[Re];
                  break;
                }
              return q < _e ? -1 : _e < q ? 1 : 0;
            };
            function I(K, U, V, Q, fe) {
              if (K.length === 0)
                return -1;
              if (typeof V == "string" ? (Q = V, V = 0) : V > 2147483647 ? V = 2147483647 : V < -2147483648 && (V = -2147483648), V = +V, W(V) && (V = fe ? 0 : K.length - 1), V < 0 && (V = K.length + V), V >= K.length) {
                if (fe)
                  return -1;
                V = K.length - 1;
              } else if (V < 0)
                if (fe)
                  V = 0;
                else
                  return -1;
              if (typeof U == "string" && (U = m.from(U, Q)), m.isBuffer(U))
                return U.length === 0 ? -1 : w(K, U, V, Q, fe);
              if (typeof U == "number")
                return U = U & 255, typeof Uint8Array.prototype.indexOf == "function" ? fe ? Uint8Array.prototype.indexOf.call(K, U, V) : Uint8Array.prototype.lastIndexOf.call(K, U, V) : w(K, [U], V, Q, fe);
              throw new TypeError("val must be string, number or Buffer");
            }
            function w(K, U, V, Q, fe) {
              var ue = 1, q = K.length, _e = U.length;
              if (Q !== void 0 && (Q = String(Q).toLowerCase(), Q === "ucs2" || Q === "ucs-2" || Q === "utf16le" || Q === "utf-16le")) {
                if (K.length < 2 || U.length < 2)
                  return -1;
                ue = 2, q /= 2, _e /= 2, V /= 2;
              }
              function ge(ke, De) {
                return ue === 1 ? ke[De] : ke.readUInt16BE(De * ue);
              }
              var Ce;
              if (fe) {
                var Ee = -1;
                for (Ce = V; Ce < q; Ce++)
                  if (ge(K, Ce) === ge(U, Ee === -1 ? 0 : Ce - Ee)) {
                    if (Ee === -1 && (Ee = Ce), Ce - Ee + 1 === _e)
                      return Ee * ue;
                  } else
                    Ee !== -1 && (Ce -= Ce - Ee), Ee = -1;
              } else
                for (V + _e > q && (V = q - _e), Ce = V; Ce >= 0; Ce--) {
                  for (var Re = !0, Pe = 0; Pe < _e; Pe++)
                    if (ge(K, Ce + Pe) !== ge(U, Pe)) {
                      Re = !1;
                      break;
                    }
                  if (Re)
                    return Ce;
                }
              return -1;
            }
            m.prototype.includes = function(U, V, Q) {
              return this.indexOf(U, V, Q) !== -1;
            }, m.prototype.indexOf = function(U, V, Q) {
              return I(this, U, V, Q, !0);
            }, m.prototype.lastIndexOf = function(U, V, Q) {
              return I(this, U, V, Q, !1);
            };
            function F(K, U, V, Q) {
              V = Number(V) || 0;
              var fe = K.length - V;
              Q ? (Q = Number(Q), Q > fe && (Q = fe)) : Q = fe;
              var ue = U.length;
              Q > ue / 2 && (Q = ue / 2);
              for (var q = 0; q < Q; ++q) {
                var _e = parseInt(U.substr(q * 2, 2), 16);
                if (W(_e))
                  return q;
                K[V + q] = _e;
              }
              return q;
            }
            function k(K, U, V, Q) {
              return P(te(U, K.length - V), K, V, Q);
            }
            function H(K, U, V, Q) {
              return P(le(U), K, V, Q);
            }
            function Z(K, U, V, Q) {
              return P(x(U), K, V, Q);
            }
            function Y(K, U, V, Q) {
              return P(ne(U, K.length - V), K, V, Q);
            }
            m.prototype.write = function(U, V, Q, fe) {
              if (V === void 0)
                fe = "utf8", Q = this.length, V = 0;
              else if (Q === void 0 && typeof V == "string")
                fe = V, Q = this.length, V = 0;
              else if (isFinite(V))
                V = V >>> 0, isFinite(Q) ? (Q = Q >>> 0, fe === void 0 && (fe = "utf8")) : (fe = Q, Q = void 0);
              else
                throw new Error(
                  "Buffer.write(string, encoding, offset[, length]) is no longer supported"
                );
              var ue = this.length - V;
              if ((Q === void 0 || Q > ue) && (Q = ue), U.length > 0 && (Q < 0 || V < 0) || V > this.length)
                throw new RangeError("Attempt to write outside buffer bounds");
              fe || (fe = "utf8");
              for (var q = !1; ; )
                switch (fe) {
                  case "hex":
                    return F(this, U, V, Q);
                  case "utf8":
                  case "utf-8":
                    return k(this, U, V, Q);
                  case "ascii":
                  case "latin1":
                  case "binary":
                    return H(this, U, V, Q);
                  case "base64":
                    return Z(this, U, V, Q);
                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return Y(this, U, V, Q);
                  default:
                    if (q)
                      throw new TypeError("Unknown encoding: " + fe);
                    fe = ("" + fe).toLowerCase(), q = !0;
                }
            }, m.prototype.toJSON = function() {
              return {
                type: "Buffer",
                data: Array.prototype.slice.call(this._arr || this, 0)
              };
            };
            function j(K, U, V) {
              return U === 0 && V === K.length ? h.fromByteArray(K) : h.fromByteArray(K.slice(U, V));
            }
            function J(K, U, V) {
              V = Math.min(K.length, V);
              for (var Q = [], fe = U; fe < V; ) {
                var ue = K[fe], q = null, _e = ue > 239 ? 4 : ue > 223 ? 3 : ue > 191 ? 2 : 1;
                if (fe + _e <= V) {
                  var ge, Ce, Ee, Re;
                  switch (_e) {
                    case 1:
                      ue < 128 && (q = ue);
                      break;
                    case 2:
                      ge = K[fe + 1], (ge & 192) === 128 && (Re = (ue & 31) << 6 | ge & 63, Re > 127 && (q = Re));
                      break;
                    case 3:
                      ge = K[fe + 1], Ce = K[fe + 2], (ge & 192) === 128 && (Ce & 192) === 128 && (Re = (ue & 15) << 12 | (ge & 63) << 6 | Ce & 63, Re > 2047 && (Re < 55296 || Re > 57343) && (q = Re));
                      break;
                    case 4:
                      ge = K[fe + 1], Ce = K[fe + 2], Ee = K[fe + 3], (ge & 192) === 128 && (Ce & 192) === 128 && (Ee & 192) === 128 && (Re = (ue & 15) << 18 | (ge & 63) << 12 | (Ce & 63) << 6 | Ee & 63, Re > 65535 && Re < 1114112 && (q = Re));
                  }
                }
                q === null ? (q = 65533, _e = 1) : q > 65535 && (q -= 65536, Q.push(q >>> 10 & 1023 | 55296), q = 56320 | q & 1023), Q.push(q), fe += _e;
              }
              return G(Q);
            }
            var ae = 4096;
            function G(K) {
              var U = K.length;
              if (U <= ae)
                return String.fromCharCode.apply(String, K);
              for (var V = "", Q = 0; Q < U; )
                V += String.fromCharCode.apply(
                  String,
                  K.slice(Q, Q += ae)
                );
              return V;
            }
            function $(K, U, V) {
              var Q = "";
              V = Math.min(K.length, V);
              for (var fe = U; fe < V; ++fe)
                Q += String.fromCharCode(K[fe] & 127);
              return Q;
            }
            function ie(K, U, V) {
              var Q = "";
              V = Math.min(K.length, V);
              for (var fe = U; fe < V; ++fe)
                Q += String.fromCharCode(K[fe]);
              return Q;
            }
            function re(K, U, V) {
              var Q = K.length;
              (!U || U < 0) && (U = 0), (!V || V < 0 || V > Q) && (V = Q);
              for (var fe = "", ue = U; ue < V; ++ue)
                fe += X[K[ue]];
              return fe;
            }
            function ce(K, U, V) {
              for (var Q = K.slice(U, V), fe = "", ue = 0; ue < Q.length - 1; ue += 2)
                fe += String.fromCharCode(Q[ue] + Q[ue + 1] * 256);
              return fe;
            }
            m.prototype.slice = function(U, V) {
              var Q = this.length;
              U = ~~U, V = V === void 0 ? Q : ~~V, U < 0 ? (U += Q, U < 0 && (U = 0)) : U > Q && (U = Q), V < 0 ? (V += Q, V < 0 && (V = 0)) : V > Q && (V = Q), V < U && (V = U);
              var fe = this.subarray(U, V);
              return Object.setPrototypeOf(fe, m.prototype), fe;
            };
            function z(K, U, V) {
              if (K % 1 !== 0 || K < 0)
                throw new RangeError("offset is not uint");
              if (K + U > V)
                throw new RangeError("Trying to access beyond buffer length");
            }
            m.prototype.readUintLE = m.prototype.readUIntLE = function(U, V, Q) {
              U = U >>> 0, V = V >>> 0, Q || z(U, V, this.length);
              for (var fe = this[U], ue = 1, q = 0; ++q < V && (ue *= 256); )
                fe += this[U + q] * ue;
              return fe;
            }, m.prototype.readUintBE = m.prototype.readUIntBE = function(U, V, Q) {
              U = U >>> 0, V = V >>> 0, Q || z(U, V, this.length);
              for (var fe = this[U + --V], ue = 1; V > 0 && (ue *= 256); )
                fe += this[U + --V] * ue;
              return fe;
            }, m.prototype.readUint8 = m.prototype.readUInt8 = function(U, V) {
              return U = U >>> 0, V || z(U, 1, this.length), this[U];
            }, m.prototype.readUint16LE = m.prototype.readUInt16LE = function(U, V) {
              return U = U >>> 0, V || z(U, 2, this.length), this[U] | this[U + 1] << 8;
            }, m.prototype.readUint16BE = m.prototype.readUInt16BE = function(U, V) {
              return U = U >>> 0, V || z(U, 2, this.length), this[U] << 8 | this[U + 1];
            }, m.prototype.readUint32LE = m.prototype.readUInt32LE = function(U, V) {
              return U = U >>> 0, V || z(U, 4, this.length), (this[U] | this[U + 1] << 8 | this[U + 2] << 16) + this[U + 3] * 16777216;
            }, m.prototype.readUint32BE = m.prototype.readUInt32BE = function(U, V) {
              return U = U >>> 0, V || z(U, 4, this.length), this[U] * 16777216 + (this[U + 1] << 16 | this[U + 2] << 8 | this[U + 3]);
            }, m.prototype.readIntLE = function(U, V, Q) {
              U = U >>> 0, V = V >>> 0, Q || z(U, V, this.length);
              for (var fe = this[U], ue = 1, q = 0; ++q < V && (ue *= 256); )
                fe += this[U + q] * ue;
              return ue *= 128, fe >= ue && (fe -= Math.pow(2, 8 * V)), fe;
            }, m.prototype.readIntBE = function(U, V, Q) {
              U = U >>> 0, V = V >>> 0, Q || z(U, V, this.length);
              for (var fe = V, ue = 1, q = this[U + --fe]; fe > 0 && (ue *= 256); )
                q += this[U + --fe] * ue;
              return ue *= 128, q >= ue && (q -= Math.pow(2, 8 * V)), q;
            }, m.prototype.readInt8 = function(U, V) {
              return U = U >>> 0, V || z(U, 1, this.length), this[U] & 128 ? (255 - this[U] + 1) * -1 : this[U];
            }, m.prototype.readInt16LE = function(U, V) {
              U = U >>> 0, V || z(U, 2, this.length);
              var Q = this[U] | this[U + 1] << 8;
              return Q & 32768 ? Q | 4294901760 : Q;
            }, m.prototype.readInt16BE = function(U, V) {
              U = U >>> 0, V || z(U, 2, this.length);
              var Q = this[U + 1] | this[U] << 8;
              return Q & 32768 ? Q | 4294901760 : Q;
            }, m.prototype.readInt32LE = function(U, V) {
              return U = U >>> 0, V || z(U, 4, this.length), this[U] | this[U + 1] << 8 | this[U + 2] << 16 | this[U + 3] << 24;
            }, m.prototype.readInt32BE = function(U, V) {
              return U = U >>> 0, V || z(U, 4, this.length), this[U] << 24 | this[U + 1] << 16 | this[U + 2] << 8 | this[U + 3];
            }, m.prototype.readFloatLE = function(U, V) {
              return U = U >>> 0, V || z(U, 4, this.length), f.read(this, U, !0, 23, 4);
            }, m.prototype.readFloatBE = function(U, V) {
              return U = U >>> 0, V || z(U, 4, this.length), f.read(this, U, !1, 23, 4);
            }, m.prototype.readDoubleLE = function(U, V) {
              return U = U >>> 0, V || z(U, 8, this.length), f.read(this, U, !0, 52, 8);
            }, m.prototype.readDoubleBE = function(U, V) {
              return U = U >>> 0, V || z(U, 8, this.length), f.read(this, U, !1, 52, 8);
            };
            function oe(K, U, V, Q, fe, ue) {
              if (!m.isBuffer(K))
                throw new TypeError('"buffer" argument must be a Buffer instance');
              if (U > fe || U < ue)
                throw new RangeError('"value" argument is out of bounds');
              if (V + Q > K.length)
                throw new RangeError("Index out of range");
            }
            m.prototype.writeUintLE = m.prototype.writeUIntLE = function(U, V, Q, fe) {
              if (U = +U, V = V >>> 0, Q = Q >>> 0, !fe) {
                var ue = Math.pow(2, 8 * Q) - 1;
                oe(this, U, V, Q, ue, 0);
              }
              var q = 1, _e = 0;
              for (this[V] = U & 255; ++_e < Q && (q *= 256); )
                this[V + _e] = U / q & 255;
              return V + Q;
            }, m.prototype.writeUintBE = m.prototype.writeUIntBE = function(U, V, Q, fe) {
              if (U = +U, V = V >>> 0, Q = Q >>> 0, !fe) {
                var ue = Math.pow(2, 8 * Q) - 1;
                oe(this, U, V, Q, ue, 0);
              }
              var q = Q - 1, _e = 1;
              for (this[V + q] = U & 255; --q >= 0 && (_e *= 256); )
                this[V + q] = U / _e & 255;
              return V + Q;
            }, m.prototype.writeUint8 = m.prototype.writeUInt8 = function(U, V, Q) {
              return U = +U, V = V >>> 0, Q || oe(this, U, V, 1, 255, 0), this[V] = U & 255, V + 1;
            }, m.prototype.writeUint16LE = m.prototype.writeUInt16LE = function(U, V, Q) {
              return U = +U, V = V >>> 0, Q || oe(this, U, V, 2, 65535, 0), this[V] = U & 255, this[V + 1] = U >>> 8, V + 2;
            }, m.prototype.writeUint16BE = m.prototype.writeUInt16BE = function(U, V, Q) {
              return U = +U, V = V >>> 0, Q || oe(this, U, V, 2, 65535, 0), this[V] = U >>> 8, this[V + 1] = U & 255, V + 2;
            }, m.prototype.writeUint32LE = m.prototype.writeUInt32LE = function(U, V, Q) {
              return U = +U, V = V >>> 0, Q || oe(this, U, V, 4, 4294967295, 0), this[V + 3] = U >>> 24, this[V + 2] = U >>> 16, this[V + 1] = U >>> 8, this[V] = U & 255, V + 4;
            }, m.prototype.writeUint32BE = m.prototype.writeUInt32BE = function(U, V, Q) {
              return U = +U, V = V >>> 0, Q || oe(this, U, V, 4, 4294967295, 0), this[V] = U >>> 24, this[V + 1] = U >>> 16, this[V + 2] = U >>> 8, this[V + 3] = U & 255, V + 4;
            }, m.prototype.writeIntLE = function(U, V, Q, fe) {
              if (U = +U, V = V >>> 0, !fe) {
                var ue = Math.pow(2, 8 * Q - 1);
                oe(this, U, V, Q, ue - 1, -ue);
              }
              var q = 0, _e = 1, ge = 0;
              for (this[V] = U & 255; ++q < Q && (_e *= 256); )
                U < 0 && ge === 0 && this[V + q - 1] !== 0 && (ge = 1), this[V + q] = (U / _e >> 0) - ge & 255;
              return V + Q;
            }, m.prototype.writeIntBE = function(U, V, Q, fe) {
              if (U = +U, V = V >>> 0, !fe) {
                var ue = Math.pow(2, 8 * Q - 1);
                oe(this, U, V, Q, ue - 1, -ue);
              }
              var q = Q - 1, _e = 1, ge = 0;
              for (this[V + q] = U & 255; --q >= 0 && (_e *= 256); )
                U < 0 && ge === 0 && this[V + q + 1] !== 0 && (ge = 1), this[V + q] = (U / _e >> 0) - ge & 255;
              return V + Q;
            }, m.prototype.writeInt8 = function(U, V, Q) {
              return U = +U, V = V >>> 0, Q || oe(this, U, V, 1, 127, -128), U < 0 && (U = 255 + U + 1), this[V] = U & 255, V + 1;
            }, m.prototype.writeInt16LE = function(U, V, Q) {
              return U = +U, V = V >>> 0, Q || oe(this, U, V, 2, 32767, -32768), this[V] = U & 255, this[V + 1] = U >>> 8, V + 2;
            }, m.prototype.writeInt16BE = function(U, V, Q) {
              return U = +U, V = V >>> 0, Q || oe(this, U, V, 2, 32767, -32768), this[V] = U >>> 8, this[V + 1] = U & 255, V + 2;
            }, m.prototype.writeInt32LE = function(U, V, Q) {
              return U = +U, V = V >>> 0, Q || oe(this, U, V, 4, 2147483647, -2147483648), this[V] = U & 255, this[V + 1] = U >>> 8, this[V + 2] = U >>> 16, this[V + 3] = U >>> 24, V + 4;
            }, m.prototype.writeInt32BE = function(U, V, Q) {
              return U = +U, V = V >>> 0, Q || oe(this, U, V, 4, 2147483647, -2147483648), U < 0 && (U = 4294967295 + U + 1), this[V] = U >>> 24, this[V + 1] = U >>> 16, this[V + 2] = U >>> 8, this[V + 3] = U & 255, V + 4;
            };
            function de(K, U, V, Q, fe, ue) {
              if (V + Q > K.length)
                throw new RangeError("Index out of range");
              if (V < 0)
                throw new RangeError("Index out of range");
            }
            function pe(K, U, V, Q, fe) {
              return U = +U, V = V >>> 0, fe || de(K, U, V, 4), f.write(K, U, V, Q, 23, 4), V + 4;
            }
            m.prototype.writeFloatLE = function(U, V, Q) {
              return pe(this, U, V, !0, Q);
            }, m.prototype.writeFloatBE = function(U, V, Q) {
              return pe(this, U, V, !1, Q);
            };
            function he(K, U, V, Q, fe) {
              return U = +U, V = V >>> 0, fe || de(K, U, V, 8), f.write(K, U, V, Q, 52, 8), V + 8;
            }
            m.prototype.writeDoubleLE = function(U, V, Q) {
              return he(this, U, V, !0, Q);
            }, m.prototype.writeDoubleBE = function(U, V, Q) {
              return he(this, U, V, !1, Q);
            }, m.prototype.copy = function(U, V, Q, fe) {
              if (!m.isBuffer(U))
                throw new TypeError("argument should be a Buffer");
              if (Q || (Q = 0), !fe && fe !== 0 && (fe = this.length), V >= U.length && (V = U.length), V || (V = 0), fe > 0 && fe < Q && (fe = Q), fe === Q || U.length === 0 || this.length === 0)
                return 0;
              if (V < 0)
                throw new RangeError("targetStart out of bounds");
              if (Q < 0 || Q >= this.length)
                throw new RangeError("Index out of range");
              if (fe < 0)
                throw new RangeError("sourceEnd out of bounds");
              fe > this.length && (fe = this.length), U.length - V < fe - Q && (fe = U.length - V + Q);
              var ue = fe - Q;
              return this === U && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(V, Q, fe) : Uint8Array.prototype.set.call(
                U,
                this.subarray(Q, fe),
                V
              ), ue;
            }, m.prototype.fill = function(U, V, Q, fe) {
              if (typeof U == "string") {
                if (typeof V == "string" ? (fe = V, V = 0, Q = this.length) : typeof Q == "string" && (fe = Q, Q = this.length), fe !== void 0 && typeof fe != "string")
                  throw new TypeError("encoding must be a string");
                if (typeof fe == "string" && !m.isEncoding(fe))
                  throw new TypeError("Unknown encoding: " + fe);
                if (U.length === 1) {
                  var ue = U.charCodeAt(0);
                  (fe === "utf8" && ue < 128 || fe === "latin1") && (U = ue);
                }
              } else
                typeof U == "number" ? U = U & 255 : typeof U == "boolean" && (U = Number(U));
              if (V < 0 || this.length < V || this.length < Q)
                throw new RangeError("Out of range index");
              if (Q <= V)
                return this;
              V = V >>> 0, Q = Q === void 0 ? this.length : Q >>> 0, U || (U = 0);
              var q;
              if (typeof U == "number")
                for (q = V; q < Q; ++q)
                  this[q] = U;
              else {
                var _e = m.isBuffer(U) ? U : m.from(U, fe), ge = _e.length;
                if (ge === 0)
                  throw new TypeError('The value "' + U + '" is invalid for argument "value"');
                for (q = 0; q < Q - V; ++q)
                  this[q + V] = _e[q % ge];
              }
              return this;
            };
            var se = /[^+/0-9A-Za-z-_]/g;
            function ee(K) {
              if (K = K.split("=")[0], K = K.trim().replace(se, ""), K.length < 2)
                return "";
              for (; K.length % 4 !== 0; )
                K = K + "=";
              return K;
            }
            function te(K, U) {
              U = U || 1 / 0;
              for (var V, Q = K.length, fe = null, ue = [], q = 0; q < Q; ++q) {
                if (V = K.charCodeAt(q), V > 55295 && V < 57344) {
                  if (!fe) {
                    if (V > 56319) {
                      (U -= 3) > -1 && ue.push(239, 191, 189);
                      continue;
                    } else if (q + 1 === Q) {
                      (U -= 3) > -1 && ue.push(239, 191, 189);
                      continue;
                    }
                    fe = V;
                    continue;
                  }
                  if (V < 56320) {
                    (U -= 3) > -1 && ue.push(239, 191, 189), fe = V;
                    continue;
                  }
                  V = (fe - 55296 << 10 | V - 56320) + 65536;
                } else
                  fe && (U -= 3) > -1 && ue.push(239, 191, 189);
                if (fe = null, V < 128) {
                  if ((U -= 1) < 0)
                    break;
                  ue.push(V);
                } else if (V < 2048) {
                  if ((U -= 2) < 0)
                    break;
                  ue.push(
                    V >> 6 | 192,
                    V & 63 | 128
                  );
                } else if (V < 65536) {
                  if ((U -= 3) < 0)
                    break;
                  ue.push(
                    V >> 12 | 224,
                    V >> 6 & 63 | 128,
                    V & 63 | 128
                  );
                } else if (V < 1114112) {
                  if ((U -= 4) < 0)
                    break;
                  ue.push(
                    V >> 18 | 240,
                    V >> 12 & 63 | 128,
                    V >> 6 & 63 | 128,
                    V & 63 | 128
                  );
                } else
                  throw new Error("Invalid code point");
              }
              return ue;
            }
            function le(K) {
              for (var U = [], V = 0; V < K.length; ++V)
                U.push(K.charCodeAt(V) & 255);
              return U;
            }
            function ne(K, U) {
              for (var V, Q, fe, ue = [], q = 0; q < K.length && !((U -= 2) < 0); ++q)
                V = K.charCodeAt(q), Q = V >> 8, fe = V % 256, ue.push(fe), ue.push(Q);
              return ue;
            }
            function x(K) {
              return h.toByteArray(ee(K));
            }
            function P(K, U, V, Q) {
              for (var fe = 0; fe < Q && !(fe + V >= U.length || fe >= K.length); ++fe)
                U[fe + V] = K[fe];
              return fe;
            }
            function B(K, U) {
              return K instanceof U || K != null && K.constructor != null && K.constructor.name != null && K.constructor.name === U.name;
            }
            function W(K) {
              return K !== K;
            }
            var X = function() {
              for (var K = "0123456789abcdef", U = new Array(256), V = 0; V < 16; ++V)
                for (var Q = V * 16, fe = 0; fe < 16; ++fe)
                  U[Q + fe] = K[V] + K[fe];
              return U;
            }();
          }
        ),
        /***/
        "./node_modules/buffer/node_modules/base64-js/index.js": (
          /*!*************************************************************!*\
            !*** ./node_modules/buffer/node_modules/base64-js/index.js ***!
            \*************************************************************/
          /***/
          (c, l) => {
            l.byteLength = m, l.toByteArray = b, l.fromByteArray = T;
            for (var i = [], h = [], f = typeof Uint8Array < "u" ? Uint8Array : Array, p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", d = 0, v = p.length; d < v; ++d)
              i[d] = p[d], h[p.charCodeAt(d)] = d;
            h["-".charCodeAt(0)] = 62, h["_".charCodeAt(0)] = 63;
            function g(R) {
              var y = R.length;
              if (y % 4 > 0)
                throw new Error("Invalid string. Length must be a multiple of 4");
              var E = R.indexOf("=");
              E === -1 && (E = y);
              var L = E === y ? 0 : 4 - E % 4;
              return [E, L];
            }
            function m(R) {
              var y = g(R), E = y[0], L = y[1];
              return (E + L) * 3 / 4 - L;
            }
            function A(R, y, E) {
              return (y + E) * 3 / 4 - E;
            }
            function b(R) {
              var y, E = g(R), L = E[0], _ = E[1], O = new f(A(R, L, _)), D = 0, M = _ > 0 ? L - 4 : L, C;
              for (C = 0; C < M; C += 4)
                y = h[R.charCodeAt(C)] << 18 | h[R.charCodeAt(C + 1)] << 12 | h[R.charCodeAt(C + 2)] << 6 | h[R.charCodeAt(C + 3)], O[D++] = y >> 16 & 255, O[D++] = y >> 8 & 255, O[D++] = y & 255;
              return _ === 2 && (y = h[R.charCodeAt(C)] << 2 | h[R.charCodeAt(C + 1)] >> 4, O[D++] = y & 255), _ === 1 && (y = h[R.charCodeAt(C)] << 10 | h[R.charCodeAt(C + 1)] << 4 | h[R.charCodeAt(C + 2)] >> 2, O[D++] = y >> 8 & 255, O[D++] = y & 255), O;
            }
            function S(R) {
              return i[R >> 18 & 63] + i[R >> 12 & 63] + i[R >> 6 & 63] + i[R & 63];
            }
            function N(R, y, E) {
              for (var L, _ = [], O = y; O < E; O += 3)
                L = (R[O] << 16 & 16711680) + (R[O + 1] << 8 & 65280) + (R[O + 2] & 255), _.push(S(L));
              return _.join("");
            }
            function T(R) {
              for (var y, E = R.length, L = E % 3, _ = [], O = 16383, D = 0, M = E - L; D < M; D += O)
                _.push(N(R, D, D + O > M ? M : D + O));
              return L === 1 ? (y = R[E - 1], _.push(
                i[y >> 2] + i[y << 4 & 63] + "=="
              )) : L === 2 && (y = (R[E - 2] << 8) + R[E - 1], _.push(
                i[y >> 10] + i[y >> 4 & 63] + i[y << 2 & 63] + "="
              )), _.join("");
            }
          }
        ),
        /***/
        "./node_modules/buffer/node_modules/ieee754/index.js": (
          /*!***********************************************************!*\
            !*** ./node_modules/buffer/node_modules/ieee754/index.js ***!
            \***********************************************************/
          /***/
          (c, l) => {
            /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
            l.read = function(i, h, f, p, d) {
              var v, g, m = d * 8 - p - 1, A = (1 << m) - 1, b = A >> 1, S = -7, N = f ? d - 1 : 0, T = f ? -1 : 1, R = i[h + N];
              for (N += T, v = R & (1 << -S) - 1, R >>= -S, S += m; S > 0; v = v * 256 + i[h + N], N += T, S -= 8)
                ;
              for (g = v & (1 << -S) - 1, v >>= -S, S += p; S > 0; g = g * 256 + i[h + N], N += T, S -= 8)
                ;
              if (v === 0)
                v = 1 - b;
              else {
                if (v === A)
                  return g ? NaN : (R ? -1 : 1) * (1 / 0);
                g = g + Math.pow(2, p), v = v - b;
              }
              return (R ? -1 : 1) * g * Math.pow(2, v - p);
            }, l.write = function(i, h, f, p, d, v) {
              var g, m, A, b = v * 8 - d - 1, S = (1 << b) - 1, N = S >> 1, T = d === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, R = p ? 0 : v - 1, y = p ? 1 : -1, E = h < 0 || h === 0 && 1 / h < 0 ? 1 : 0;
              for (h = Math.abs(h), isNaN(h) || h === 1 / 0 ? (m = isNaN(h) ? 1 : 0, g = S) : (g = Math.floor(Math.log(h) / Math.LN2), h * (A = Math.pow(2, -g)) < 1 && (g--, A *= 2), g + N >= 1 ? h += T / A : h += T * Math.pow(2, 1 - N), h * A >= 2 && (g++, A /= 2), g + N >= S ? (m = 0, g = S) : g + N >= 1 ? (m = (h * A - 1) * Math.pow(2, d), g = g + N) : (m = h * Math.pow(2, N - 1) * Math.pow(2, d), g = 0)); d >= 8; i[f + R] = m & 255, R += y, m /= 256, d -= 8)
                ;
              for (g = g << d | m, b += d; b > 0; i[f + R] = g & 255, R += y, g /= 256, b -= 8)
                ;
              i[f + R - y] |= E * 128;
            };
          }
        ),
        /***/
        "./node_modules/codem-isoboxer/dist/iso_boxer.js": (
          /*!*******************************************************!*\
            !*** ./node_modules/codem-isoboxer/dist/iso_boxer.js ***!
            \*******************************************************/
          /***/
          (c, l) => {
            /*! codem-isoboxer v0.3.6 https://github.com/madebyhiro/codem-isoboxer/blob/master/LICENSE.txt */
            var i = {};
            i.parseBuffer = function(p) {
              return new h(p).parse();
            }, i.addBoxProcessor = function(p, d) {
              typeof p != "string" || typeof d != "function" || (f.prototype._boxProcessors[p] = d);
            }, i.createFile = function() {
              return new h();
            }, i.createBox = function(p, d, v) {
              var g = f.create(p);
              return d && d.append(g, v), g;
            }, i.createFullBox = function(p, d, v) {
              var g = i.createBox(p, d, v);
              return g.version = 0, g.flags = 0, g;
            }, i.Utils = {}, i.Utils.dataViewToString = function(p, d) {
              var v = d || "utf-8";
              if (typeof TextDecoder < "u")
                return new TextDecoder(v).decode(p);
              var g = [], m = 0;
              if (v === "utf-8")
                for (; m < p.byteLength; ) {
                  var A = p.getUint8(m++);
                  A < 128 || (A < 224 ? (A = (A & 31) << 6, A |= p.getUint8(m++) & 63) : A < 240 ? (A = (A & 15) << 12, A |= (p.getUint8(m++) & 63) << 6, A |= p.getUint8(m++) & 63) : (A = (A & 7) << 18, A |= (p.getUint8(m++) & 63) << 12, A |= (p.getUint8(m++) & 63) << 6, A |= p.getUint8(m++) & 63)), g.push(String.fromCharCode(A));
                }
              else
                for (; m < p.byteLength; )
                  g.push(String.fromCharCode(p.getUint8(m++)));
              return g.join("");
            }, i.Utils.utf8ToByteArray = function(p) {
              var d, v;
              if (typeof TextEncoder < "u")
                d = new TextEncoder().encode(p);
              else
                for (d = [], v = 0; v < p.length; ++v) {
                  var g = p.charCodeAt(v);
                  g < 128 ? d.push(g) : g < 2048 ? (d.push(192 | g >> 6), d.push(128 | 63 & g)) : g < 65536 ? (d.push(224 | g >> 12), d.push(128 | 63 & g >> 6), d.push(128 | 63 & g)) : (d.push(240 | g >> 18), d.push(128 | 63 & g >> 12), d.push(128 | 63 & g >> 6), d.push(128 | 63 & g));
                }
              return d;
            }, i.Utils.appendBox = function(p, d, v) {
              if (d._offset = p._cursor.offset, d._root = p._root ? p._root : p, d._raw = p._raw, d._parent = p, v !== -1) {
                if (v == null) {
                  p.boxes.push(d);
                  return;
                }
                var g = -1, m;
                if (typeof v == "number")
                  g = v;
                else {
                  if (typeof v == "string")
                    m = v;
                  else if (typeof v == "object" && v.type)
                    m = v.type;
                  else {
                    p.boxes.push(d);
                    return;
                  }
                  for (var A = 0; A < p.boxes.length; A++)
                    if (m === p.boxes[A].type) {
                      g = A + 1;
                      break;
                    }
                }
                p.boxes.splice(g, 0, d);
              }
            }, l.parseBuffer = i.parseBuffer, l.addBoxProcessor = i.addBoxProcessor, l.createFile = i.createFile, l.createBox = i.createBox, l.createFullBox = i.createFullBox, l.Utils = i.Utils, i.Cursor = function(p) {
              this.offset = typeof p > "u" ? 0 : p;
            };
            var h = function(p) {
              this._cursor = new i.Cursor(), this.boxes = [], p && (this._raw = new DataView(p));
            };
            h.prototype.fetch = function(p) {
              var d = this.fetchAll(p, !0);
              return d.length ? d[0] : null;
            }, h.prototype.fetchAll = function(p, d) {
              var v = [];
              return h._sweep.call(this, p, v, d), v;
            }, h.prototype.parse = function() {
              for (this._cursor.offset = 0, this.boxes = []; this._cursor.offset < this._raw.byteLength; ) {
                var p = f.parse(this);
                if (typeof p.type > "u")
                  break;
                this.boxes.push(p);
              }
              return this;
            }, h._sweep = function(p, d, v) {
              this.type && this.type == p && d.push(this);
              for (var g in this.boxes) {
                if (d.length && v)
                  return;
                h._sweep.call(this.boxes[g], p, d, v);
              }
            }, h.prototype.write = function() {
              var p = 0, d;
              for (d = 0; d < this.boxes.length; d++)
                p += this.boxes[d].getLength(!1);
              var v = new Uint8Array(p);
              for (this._rawo = new DataView(v.buffer), this.bytes = v, this._cursor.offset = 0, d = 0; d < this.boxes.length; d++)
                this.boxes[d].write();
              return v.buffer;
            }, h.prototype.append = function(p, d) {
              i.Utils.appendBox(this, p, d);
            };
            var f = function() {
              this._cursor = new i.Cursor();
            };
            f.parse = function(p) {
              var d = new f();
              return d._offset = p._cursor.offset, d._root = p._root ? p._root : p, d._raw = p._raw, d._parent = p, d._parseBox(), p._cursor.offset = d._raw.byteOffset + d._raw.byteLength, d;
            }, f.create = function(p) {
              var d = new f();
              return d.type = p, d.boxes = [], d;
            }, f.prototype._boxContainers = ["dinf", "edts", "mdia", "meco", "mfra", "minf", "moof", "moov", "mvex", "stbl", "strk", "traf", "trak", "tref", "udta", "vttc", "sinf", "schi", "encv", "enca"], f.prototype._boxProcessors = {}, f.prototype._procField = function(p, d, v) {
              this._parsing ? this[p] = this._readField(d, v) : this._writeField(d, v, this[p]);
            }, f.prototype._procFieldArray = function(p, d, v, g) {
              var m;
              if (this._parsing)
                for (this[p] = [], m = 0; m < d; m++)
                  this[p][m] = this._readField(v, g);
              else
                for (m = 0; m < this[p].length; m++)
                  this._writeField(v, g, this[p][m]);
            }, f.prototype._procFullBox = function() {
              this._procField("version", "uint", 8), this._procField("flags", "uint", 24);
            }, f.prototype._procEntries = function(p, d, v) {
              var g;
              if (this._parsing)
                for (this[p] = [], g = 0; g < d; g++)
                  this[p].push({}), v.call(this, this[p][g]);
              else
                for (g = 0; g < d; g++)
                  v.call(this, this[p][g]);
            }, f.prototype._procSubEntries = function(p, d, v, g) {
              var m;
              if (this._parsing)
                for (p[d] = [], m = 0; m < v; m++)
                  p[d].push({}), g.call(this, p[d][m]);
              else
                for (m = 0; m < v; m++)
                  g.call(this, p[d][m]);
            }, f.prototype._procEntryField = function(p, d, v, g) {
              this._parsing ? p[d] = this._readField(v, g) : this._writeField(v, g, p[d]);
            }, f.prototype._procSubBoxes = function(p, d) {
              var v;
              if (this._parsing)
                for (this[p] = [], v = 0; v < d; v++)
                  this[p].push(f.parse(this));
              else
                for (v = 0; v < d; v++)
                  this._rawo ? this[p][v].write() : this.size += this[p][v].getLength();
            }, f.prototype._readField = function(p, d) {
              switch (p) {
                case "uint":
                  return this._readUint(d);
                case "int":
                  return this._readInt(d);
                case "template":
                  return this._readTemplate(d);
                case "string":
                  return d === -1 ? this._readTerminatedString() : this._readString(d);
                case "data":
                  return this._readData(d);
                case "utf8":
                  return this._readUTF8String();
                default:
                  return -1;
              }
            }, f.prototype._readInt = function(p) {
              var d = null, v = this._cursor.offset - this._raw.byteOffset;
              switch (p) {
                case 8:
                  d = this._raw.getInt8(v);
                  break;
                case 16:
                  d = this._raw.getInt16(v);
                  break;
                case 32:
                  d = this._raw.getInt32(v);
                  break;
                case 64:
                  var g = this._raw.getInt32(v), m = this._raw.getInt32(v + 4);
                  d = g * Math.pow(2, 32) + m;
                  break;
              }
              return this._cursor.offset += p >> 3, d;
            }, f.prototype._readUint = function(p) {
              var d = null, v = this._cursor.offset - this._raw.byteOffset, g, m;
              switch (p) {
                case 8:
                  d = this._raw.getUint8(v);
                  break;
                case 16:
                  d = this._raw.getUint16(v);
                  break;
                case 24:
                  g = this._raw.getUint16(v), m = this._raw.getUint8(v + 2), d = (g << 8) + m;
                  break;
                case 32:
                  d = this._raw.getUint32(v);
                  break;
                case 64:
                  g = this._raw.getUint32(v), m = this._raw.getUint32(v + 4), d = g * Math.pow(2, 32) + m;
                  break;
              }
              return this._cursor.offset += p >> 3, d;
            }, f.prototype._readString = function(p) {
              for (var d = "", v = 0; v < p; v++) {
                var g = this._readUint(8);
                d += String.fromCharCode(g);
              }
              return d;
            }, f.prototype._readTemplate = function(p) {
              var d = this._readUint(p / 2), v = this._readUint(p / 2);
              return d + v / Math.pow(2, p / 2);
            }, f.prototype._readTerminatedString = function() {
              for (var p = ""; this._cursor.offset - this._offset < this._raw.byteLength; ) {
                var d = this._readUint(8);
                if (d === 0)
                  break;
                p += String.fromCharCode(d);
              }
              return p;
            }, f.prototype._readData = function(p) {
              var d = p > 0 ? p : this._raw.byteLength - (this._cursor.offset - this._offset);
              if (d > 0) {
                var v = new Uint8Array(this._raw.buffer, this._cursor.offset, d);
                return this._cursor.offset += d, v;
              } else
                return null;
            }, f.prototype._readUTF8String = function() {
              var p = this._raw.byteLength - (this._cursor.offset - this._offset), d = null;
              return p > 0 && (d = new DataView(this._raw.buffer, this._cursor.offset, p), this._cursor.offset += p), d && i.Utils.dataViewToString(d);
            }, f.prototype._parseBox = function() {
              if (this._parsing = !0, this._cursor.offset = this._offset, this._offset + 8 > this._raw.buffer.byteLength) {
                this._root._incomplete = !0;
                return;
              }
              switch (this._procField("size", "uint", 32), this._procField("type", "string", 4), this.size === 1 && this._procField("largesize", "uint", 64), this.type === "uuid" && this._procFieldArray("usertype", 16, "uint", 8), this.size) {
                case 0:
                  this._raw = new DataView(this._raw.buffer, this._offset, this._raw.byteLength - this._cursor.offset + 8);
                  break;
                case 1:
                  this._offset + this.size > this._raw.buffer.byteLength ? (this._incomplete = !0, this._root._incomplete = !0) : this._raw = new DataView(this._raw.buffer, this._offset, this.largesize);
                  break;
                default:
                  this._offset + this.size > this._raw.buffer.byteLength ? (this._incomplete = !0, this._root._incomplete = !0) : this._raw = new DataView(this._raw.buffer, this._offset, this.size);
              }
              this._incomplete || (this._boxProcessors[this.type] && this._boxProcessors[this.type].call(this), this._boxContainers.indexOf(this.type) !== -1 ? this._parseContainerBox() : this._data = this._readData());
            }, f.prototype._parseFullBox = function() {
              this.version = this._readUint(8), this.flags = this._readUint(24);
            }, f.prototype._parseContainerBox = function() {
              for (this.boxes = []; this._cursor.offset - this._raw.byteOffset < this._raw.byteLength; )
                this.boxes.push(f.parse(this));
            }, f.prototype.append = function(p, d) {
              i.Utils.appendBox(this, p, d);
            }, f.prototype.getLength = function() {
              if (this._parsing = !1, this._rawo = null, this.size = 0, this._procField("size", "uint", 32), this._procField("type", "string", 4), this.size === 1 && this._procField("largesize", "uint", 64), this.type === "uuid" && this._procFieldArray("usertype", 16, "uint", 8), this._boxProcessors[this.type] && this._boxProcessors[this.type].call(this), this._boxContainers.indexOf(this.type) !== -1)
                for (var p = 0; p < this.boxes.length; p++)
                  this.size += this.boxes[p].getLength();
              return this._data && this._writeData(this._data), this.size;
            }, f.prototype.write = function() {
              switch (this._parsing = !1, this._cursor.offset = this._parent._cursor.offset, this.size) {
                case 0:
                  this._rawo = new DataView(this._parent._rawo.buffer, this._cursor.offset, this.parent._rawo.byteLength - this._cursor.offset);
                  break;
                case 1:
                  this._rawo = new DataView(this._parent._rawo.buffer, this._cursor.offset, this.largesize);
                  break;
                default:
                  this._rawo = new DataView(this._parent._rawo.buffer, this._cursor.offset, this.size);
              }
              if (this._procField("size", "uint", 32), this._procField("type", "string", 4), this.size === 1 && this._procField("largesize", "uint", 64), this.type === "uuid" && this._procFieldArray("usertype", 16, "uint", 8), this._boxProcessors[this.type] && this._boxProcessors[this.type].call(this), this._boxContainers.indexOf(this.type) !== -1)
                for (var p = 0; p < this.boxes.length; p++)
                  this.boxes[p].write();
              return this._data && this._writeData(this._data), this._parent._cursor.offset += this.size, this.size;
            }, f.prototype._writeInt = function(p, d) {
              if (this._rawo) {
                var v = this._cursor.offset - this._rawo.byteOffset;
                switch (p) {
                  case 8:
                    this._rawo.setInt8(v, d);
                    break;
                  case 16:
                    this._rawo.setInt16(v, d);
                    break;
                  case 32:
                    this._rawo.setInt32(v, d);
                    break;
                  case 64:
                    var g = Math.floor(d / Math.pow(2, 32)), m = d - g * Math.pow(2, 32);
                    this._rawo.setUint32(v, g), this._rawo.setUint32(v + 4, m);
                    break;
                }
                this._cursor.offset += p >> 3;
              } else
                this.size += p >> 3;
            }, f.prototype._writeUint = function(p, d) {
              if (this._rawo) {
                var v = this._cursor.offset - this._rawo.byteOffset, g, m;
                switch (p) {
                  case 8:
                    this._rawo.setUint8(v, d);
                    break;
                  case 16:
                    this._rawo.setUint16(v, d);
                    break;
                  case 24:
                    g = (d & 16776960) >> 8, m = d & 255, this._rawo.setUint16(v, g), this._rawo.setUint8(v + 2, m);
                    break;
                  case 32:
                    this._rawo.setUint32(v, d);
                    break;
                  case 64:
                    g = Math.floor(d / Math.pow(2, 32)), m = d - g * Math.pow(2, 32), this._rawo.setUint32(v, g), this._rawo.setUint32(v + 4, m);
                    break;
                }
                this._cursor.offset += p >> 3;
              } else
                this.size += p >> 3;
            }, f.prototype._writeString = function(p, d) {
              for (var v = 0; v < p; v++)
                this._writeUint(8, d.charCodeAt(v));
            }, f.prototype._writeTerminatedString = function(p) {
              if (p.length !== 0) {
                for (var d = 0; d < p.length; d++)
                  this._writeUint(8, p.charCodeAt(d));
                this._writeUint(8, 0);
              }
            }, f.prototype._writeTemplate = function(p, d) {
              var v = Math.floor(d), g = (d - v) * Math.pow(2, p / 2);
              this._writeUint(p / 2, v), this._writeUint(p / 2, g);
            }, f.prototype._writeData = function(p) {
              var d;
              if (p)
                if (this._rawo) {
                  if (p instanceof Array) {
                    for (var v = this._cursor.offset - this._rawo.byteOffset, d = 0; d < p.length; d++)
                      this._rawo.setInt8(v + d, p[d]);
                    this._cursor.offset += p.length;
                  }
                  p instanceof Uint8Array && (this._root.bytes.set(p, this._cursor.offset), this._cursor.offset += p.length);
                } else
                  this.size += p.length;
            }, f.prototype._writeUTF8String = function(p) {
              var d = i.Utils.utf8ToByteArray(p);
              if (this._rawo)
                for (var v = new DataView(this._rawo.buffer, this._cursor.offset, d.length), g = 0; g < d.length; g++)
                  v.setUint8(g, d[g]);
              else
                this.size += d.length;
            }, f.prototype._writeField = function(p, d, v) {
              switch (p) {
                case "uint":
                  this._writeUint(d, v);
                  break;
                case "int":
                  this._writeInt(d, v);
                  break;
                case "template":
                  this._writeTemplate(d, v);
                  break;
                case "string":
                  d == -1 ? this._writeTerminatedString(v) : this._writeString(d, v);
                  break;
                case "data":
                  this._writeData(v);
                  break;
                case "utf8":
                  this._writeUTF8String(v);
                  break;
              }
            }, f.prototype._boxProcessors.avc1 = f.prototype._boxProcessors.encv = function() {
              this._procFieldArray("reserved1", 6, "uint", 8), this._procField("data_reference_index", "uint", 16), this._procField("pre_defined1", "uint", 16), this._procField("reserved2", "uint", 16), this._procFieldArray("pre_defined2", 3, "uint", 32), this._procField("width", "uint", 16), this._procField("height", "uint", 16), this._procField("horizresolution", "template", 32), this._procField("vertresolution", "template", 32), this._procField("reserved3", "uint", 32), this._procField("frame_count", "uint", 16), this._procFieldArray("compressorname", 32, "uint", 8), this._procField("depth", "uint", 16), this._procField("pre_defined3", "int", 16), this._procField("config", "data", -1);
            }, f.prototype._boxProcessors.dref = function() {
              this._procFullBox(), this._procField("entry_count", "uint", 32), this._procSubBoxes("entries", this.entry_count);
            }, f.prototype._boxProcessors.elst = function() {
              this._procFullBox(), this._procField("entry_count", "uint", 32), this._procEntries("entries", this.entry_count, function(p) {
                this._procEntryField(p, "segment_duration", "uint", this.version === 1 ? 64 : 32), this._procEntryField(p, "media_time", "int", this.version === 1 ? 64 : 32), this._procEntryField(p, "media_rate_integer", "int", 16), this._procEntryField(p, "media_rate_fraction", "int", 16);
              });
            }, f.prototype._boxProcessors.emsg = function() {
              this._procFullBox(), this.version == 1 ? (this._procField("timescale", "uint", 32), this._procField("presentation_time", "uint", 64), this._procField("event_duration", "uint", 32), this._procField("id", "uint", 32), this._procField("scheme_id_uri", "string", -1), this._procField("value", "string", -1)) : (this._procField("scheme_id_uri", "string", -1), this._procField("value", "string", -1), this._procField("timescale", "uint", 32), this._procField("presentation_time_delta", "uint", 32), this._procField("event_duration", "uint", 32), this._procField("id", "uint", 32)), this._procField("message_data", "data", -1);
            }, f.prototype._boxProcessors.free = f.prototype._boxProcessors.skip = function() {
              this._procField("data", "data", -1);
            }, f.prototype._boxProcessors.frma = function() {
              this._procField("data_format", "uint", 32);
            }, f.prototype._boxProcessors.ftyp = f.prototype._boxProcessors.styp = function() {
              this._procField("major_brand", "string", 4), this._procField("minor_version", "uint", 32);
              var p = -1;
              this._parsing && (p = (this._raw.byteLength - (this._cursor.offset - this._raw.byteOffset)) / 4), this._procFieldArray("compatible_brands", p, "string", 4);
            }, f.prototype._boxProcessors.hdlr = function() {
              this._procFullBox(), this._procField("pre_defined", "uint", 32), this._procField("handler_type", "string", 4), this._procFieldArray("reserved", 3, "uint", 32), this._procField("name", "string", -1);
            }, f.prototype._boxProcessors.mdat = function() {
              this._procField("data", "data", -1);
            }, f.prototype._boxProcessors.mdhd = function() {
              this._procFullBox(), this._procField("creation_time", "uint", this.version == 1 ? 64 : 32), this._procField("modification_time", "uint", this.version == 1 ? 64 : 32), this._procField("timescale", "uint", 32), this._procField("duration", "uint", this.version == 1 ? 64 : 32), !this._parsing && typeof this.language == "string" && (this.language = this.language.charCodeAt(0) - 96 << 10 | this.language.charCodeAt(1) - 96 << 5 | this.language.charCodeAt(2) - 96), this._procField("language", "uint", 16), this._parsing && (this.language = String.fromCharCode(
                (this.language >> 10 & 31) + 96,
                (this.language >> 5 & 31) + 96,
                (this.language & 31) + 96
              )), this._procField("pre_defined", "uint", 16);
            }, f.prototype._boxProcessors.mehd = function() {
              this._procFullBox(), this._procField("fragment_duration", "uint", this.version == 1 ? 64 : 32);
            }, f.prototype._boxProcessors.mfhd = function() {
              this._procFullBox(), this._procField("sequence_number", "uint", 32);
            }, f.prototype._boxProcessors.mfro = function() {
              this._procFullBox(), this._procField("mfra_size", "uint", 32);
            }, f.prototype._boxProcessors.mp4a = f.prototype._boxProcessors.enca = function() {
              this._procFieldArray("reserved1", 6, "uint", 8), this._procField("data_reference_index", "uint", 16), this._procFieldArray("reserved2", 2, "uint", 32), this._procField("channelcount", "uint", 16), this._procField("samplesize", "uint", 16), this._procField("pre_defined", "uint", 16), this._procField("reserved3", "uint", 16), this._procField("samplerate", "template", 32), this._procField("esds", "data", -1);
            }, f.prototype._boxProcessors.mvhd = function() {
              this._procFullBox(), this._procField("creation_time", "uint", this.version == 1 ? 64 : 32), this._procField("modification_time", "uint", this.version == 1 ? 64 : 32), this._procField("timescale", "uint", 32), this._procField("duration", "uint", this.version == 1 ? 64 : 32), this._procField("rate", "template", 32), this._procField("volume", "template", 16), this._procField("reserved1", "uint", 16), this._procFieldArray("reserved2", 2, "uint", 32), this._procFieldArray("matrix", 9, "template", 32), this._procFieldArray("pre_defined", 6, "uint", 32), this._procField("next_track_ID", "uint", 32);
            }, f.prototype._boxProcessors.payl = function() {
              this._procField("cue_text", "utf8");
            }, f.prototype._boxProcessors.pssh = function() {
              this._procFullBox(), this._procFieldArray("SystemID", 16, "uint", 8), this._procField("DataSize", "uint", 32), this._procFieldArray("Data", this.DataSize, "uint", 8);
            }, f.prototype._boxProcessors.schm = function() {
              this._procFullBox(), this._procField("scheme_type", "uint", 32), this._procField("scheme_version", "uint", 32), this.flags & 1 && this._procField("scheme_uri", "string", -1);
            }, f.prototype._boxProcessors.sdtp = function() {
              this._procFullBox();
              var p = -1;
              this._parsing && (p = this._raw.byteLength - (this._cursor.offset - this._raw.byteOffset)), this._procFieldArray("sample_dependency_table", p, "uint", 8);
            }, f.prototype._boxProcessors.sidx = function() {
              this._procFullBox(), this._procField("reference_ID", "uint", 32), this._procField("timescale", "uint", 32), this._procField("earliest_presentation_time", "uint", this.version == 1 ? 64 : 32), this._procField("first_offset", "uint", this.version == 1 ? 64 : 32), this._procField("reserved", "uint", 16), this._procField("reference_count", "uint", 16), this._procEntries("references", this.reference_count, function(p) {
                this._parsing || (p.reference = (p.reference_type & 1) << 31, p.reference |= p.referenced_size & 2147483647, p.sap = (p.starts_with_SAP & 1) << 31, p.sap |= (p.SAP_type & 3) << 28, p.sap |= p.SAP_delta_time & 268435455), this._procEntryField(p, "reference", "uint", 32), this._procEntryField(p, "subsegment_duration", "uint", 32), this._procEntryField(p, "sap", "uint", 32), this._parsing && (p.reference_type = p.reference >> 31 & 1, p.referenced_size = p.reference & 2147483647, p.starts_with_SAP = p.sap >> 31 & 1, p.SAP_type = p.sap >> 28 & 7, p.SAP_delta_time = p.sap & 268435455);
              });
            }, f.prototype._boxProcessors.smhd = function() {
              this._procFullBox(), this._procField("balance", "uint", 16), this._procField("reserved", "uint", 16);
            }, f.prototype._boxProcessors.ssix = function() {
              this._procFullBox(), this._procField("subsegment_count", "uint", 32), this._procEntries("subsegments", this.subsegment_count, function(p) {
                this._procEntryField(p, "ranges_count", "uint", 32), this._procSubEntries(p, "ranges", p.ranges_count, function(d) {
                  this._procEntryField(d, "level", "uint", 8), this._procEntryField(d, "range_size", "uint", 24);
                });
              });
            }, f.prototype._boxProcessors.stsd = function() {
              this._procFullBox(), this._procField("entry_count", "uint", 32), this._procSubBoxes("entries", this.entry_count);
            }, f.prototype._boxProcessors.subs = function() {
              this._procFullBox(), this._procField("entry_count", "uint", 32), this._procEntries("entries", this.entry_count, function(p) {
                this._procEntryField(p, "sample_delta", "uint", 32), this._procEntryField(p, "subsample_count", "uint", 16), this._procSubEntries(p, "subsamples", p.subsample_count, function(d) {
                  this._procEntryField(d, "subsample_size", "uint", this.version === 1 ? 32 : 16), this._procEntryField(d, "subsample_priority", "uint", 8), this._procEntryField(d, "discardable", "uint", 8), this._procEntryField(d, "codec_specific_parameters", "uint", 32);
                });
              });
            }, f.prototype._boxProcessors.tenc = function() {
              this._procFullBox(), this._procField("default_IsEncrypted", "uint", 24), this._procField("default_IV_size", "uint", 8), this._procFieldArray("default_KID", 16, "uint", 8);
            }, f.prototype._boxProcessors.tfdt = function() {
              this._procFullBox(), this._procField("baseMediaDecodeTime", "uint", this.version == 1 ? 64 : 32);
            }, f.prototype._boxProcessors.tfhd = function() {
              this._procFullBox(), this._procField("track_ID", "uint", 32), this.flags & 1 && this._procField("base_data_offset", "uint", 64), this.flags & 2 && this._procField("sample_description_offset", "uint", 32), this.flags & 8 && this._procField("default_sample_duration", "uint", 32), this.flags & 16 && this._procField("default_sample_size", "uint", 32), this.flags & 32 && this._procField("default_sample_flags", "uint", 32);
            }, f.prototype._boxProcessors.tfra = function() {
              this._procFullBox(), this._procField("track_ID", "uint", 32), this._parsing || (this.reserved = 0, this.reserved |= (this.length_size_of_traf_num & 48) << 4, this.reserved |= (this.length_size_of_trun_num & 12) << 2, this.reserved |= this.length_size_of_sample_num & 3), this._procField("reserved", "uint", 32), this._parsing && (this.length_size_of_traf_num = (this.reserved & 48) >> 4, this.length_size_of_trun_num = (this.reserved & 12) >> 2, this.length_size_of_sample_num = this.reserved & 3), this._procField("number_of_entry", "uint", 32), this._procEntries("entries", this.number_of_entry, function(p) {
                this._procEntryField(p, "time", "uint", this.version === 1 ? 64 : 32), this._procEntryField(p, "moof_offset", "uint", this.version === 1 ? 64 : 32), this._procEntryField(p, "traf_number", "uint", (this.length_size_of_traf_num + 1) * 8), this._procEntryField(p, "trun_number", "uint", (this.length_size_of_trun_num + 1) * 8), this._procEntryField(p, "sample_number", "uint", (this.length_size_of_sample_num + 1) * 8);
              });
            }, f.prototype._boxProcessors.tkhd = function() {
              this._procFullBox(), this._procField("creation_time", "uint", this.version == 1 ? 64 : 32), this._procField("modification_time", "uint", this.version == 1 ? 64 : 32), this._procField("track_ID", "uint", 32), this._procField("reserved1", "uint", 32), this._procField("duration", "uint", this.version == 1 ? 64 : 32), this._procFieldArray("reserved2", 2, "uint", 32), this._procField("layer", "uint", 16), this._procField("alternate_group", "uint", 16), this._procField("volume", "template", 16), this._procField("reserved3", "uint", 16), this._procFieldArray("matrix", 9, "template", 32), this._procField("width", "template", 32), this._procField("height", "template", 32);
            }, f.prototype._boxProcessors.trex = function() {
              this._procFullBox(), this._procField("track_ID", "uint", 32), this._procField("default_sample_description_index", "uint", 32), this._procField("default_sample_duration", "uint", 32), this._procField("default_sample_size", "uint", 32), this._procField("default_sample_flags", "uint", 32);
            }, f.prototype._boxProcessors.trun = function() {
              this._procFullBox(), this._procField("sample_count", "uint", 32), this.flags & 1 && this._procField("data_offset", "int", 32), this.flags & 4 && this._procField("first_sample_flags", "uint", 32), this._procEntries("samples", this.sample_count, function(p) {
                this.flags & 256 && this._procEntryField(p, "sample_duration", "uint", 32), this.flags & 512 && this._procEntryField(p, "sample_size", "uint", 32), this.flags & 1024 && this._procEntryField(p, "sample_flags", "uint", 32), this.flags & 2048 && this._procEntryField(p, "sample_composition_time_offset", this.version === 1 ? "int" : "uint", 32);
              });
            }, f.prototype._boxProcessors["url "] = f.prototype._boxProcessors["urn "] = function() {
              this._procFullBox(), this.type === "urn " && this._procField("name", "string", -1), this._procField("location", "string", -1);
            }, f.prototype._boxProcessors.vlab = function() {
              this._procField("source_label", "utf8");
            }, f.prototype._boxProcessors.vmhd = function() {
              this._procFullBox(), this._procField("graphicsmode", "uint", 16), this._procFieldArray("opcolor", 3, "uint", 16);
            }, f.prototype._boxProcessors.vttC = function() {
              this._procField("config", "utf8");
            }, f.prototype._boxProcessors.vtte = function() {
            };
          }
        ),
        /***/
        "./node_modules/es6-promise/auto.js": (
          /*!******************************************!*\
            !*** ./node_modules/es6-promise/auto.js ***!
            \******************************************/
          /***/
          (c, l, i) => {
            c.exports = i(
              /*! ./ */
              "./node_modules/es6-promise/dist/es6-promise.js"
            ).polyfill();
          }
        ),
        /***/
        "./node_modules/es6-promise/dist/es6-promise.js": (
          /*!******************************************************!*\
            !*** ./node_modules/es6-promise/dist/es6-promise.js ***!
            \******************************************************/
          /***/
          function(c, l, i) {
            /*!
             * @overview es6-promise - a tiny implementation of Promises/A+.
             * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
             * @license   Licensed under MIT license
             *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
             * @version   v4.2.8+1e68dce6
             */
            (function(h, f) {
              c.exports = f();
            })(this, function() {
              function h(q) {
                var _e = typeof q;
                return q !== null && (_e === "object" || _e === "function");
              }
              function f(q) {
                return typeof q == "function";
              }
              var p = void 0;
              Array.isArray ? p = Array.isArray : p = function(q) {
                return Object.prototype.toString.call(q) === "[object Array]";
              };
              var d = p, v = 0, g = void 0, m = void 0, A = function(_e, ge) {
                C[v] = _e, C[v + 1] = ge, v += 2, v === 2 && (m ? m(I) : F());
              };
              function b(q) {
                m = q;
              }
              function S(q) {
                A = q;
              }
              var N = typeof window < "u" ? window : void 0, T = N || {}, R = T.MutationObserver || T.WebKitMutationObserver, y = typeof self > "u" && typeof process < "u" && {}.toString.call(process) === "[object process]", E = typeof Uint8ClampedArray < "u" && typeof importScripts < "u" && typeof MessageChannel < "u";
              function L() {
                return function() {
                  return process.nextTick(I);
                };
              }
              function _() {
                return typeof g < "u" ? function() {
                  g(I);
                } : M();
              }
              function O() {
                var q = 0, _e = new R(I), ge = document.createTextNode("");
                return _e.observe(ge, { characterData: !0 }), function() {
                  ge.data = q = ++q % 2;
                };
              }
              function D() {
                var q = new MessageChannel();
                return q.port1.onmessage = I, function() {
                  return q.port2.postMessage(0);
                };
              }
              function M() {
                var q = setTimeout;
                return function() {
                  return q(I, 1);
                };
              }
              var C = new Array(1e3);
              function I() {
                for (var q = 0; q < v; q += 2) {
                  var _e = C[q], ge = C[q + 1];
                  _e(ge), C[q] = void 0, C[q + 1] = void 0;
                }
                v = 0;
              }
              function w() {
                try {
                  var q = Function("return this")().require("vertx");
                  return g = q.runOnLoop || q.runOnContext, _();
                } catch {
                  return M();
                }
              }
              var F = void 0;
              y ? F = L() : R ? F = O() : E ? F = D() : N === void 0 ? F = w() : F = M();
              function k(q, _e) {
                var ge = this, Ce = new this.constructor(Y);
                Ce[Z] === void 0 && P(Ce);
                var Ee = ge._state;
                if (Ee) {
                  var Re = arguments[Ee - 1];
                  A(function() {
                    return te(Ee, Ce, Re, ge._result);
                  });
                } else
                  se(ge, Ce, q, _e);
                return Ce;
              }
              function H(q) {
                var _e = this;
                if (q && typeof q == "object" && q.constructor === _e)
                  return q;
                var ge = new _e(Y);
                return oe(ge, q), ge;
              }
              var Z = Math.random().toString(36).substring(2);
              function Y() {
              }
              var j = void 0, J = 1, ae = 2;
              function G() {
                return new TypeError("You cannot resolve a promise with itself");
              }
              function $() {
                return new TypeError("A promises callback cannot return that same promise.");
              }
              function ie(q, _e, ge, Ce) {
                try {
                  q.call(_e, ge, Ce);
                } catch (Ee) {
                  return Ee;
                }
              }
              function re(q, _e, ge) {
                A(function(Ce) {
                  var Ee = !1, Re = ie(ge, _e, function(Pe) {
                    Ee || (Ee = !0, _e !== Pe ? oe(Ce, Pe) : pe(Ce, Pe));
                  }, function(Pe) {
                    Ee || (Ee = !0, he(Ce, Pe));
                  }, "Settle: " + (Ce._label || " unknown promise"));
                  !Ee && Re && (Ee = !0, he(Ce, Re));
                }, q);
              }
              function ce(q, _e) {
                _e._state === J ? pe(q, _e._result) : _e._state === ae ? he(q, _e._result) : se(_e, void 0, function(ge) {
                  return oe(q, ge);
                }, function(ge) {
                  return he(q, ge);
                });
              }
              function z(q, _e, ge) {
                _e.constructor === q.constructor && ge === k && _e.constructor.resolve === H ? ce(q, _e) : ge === void 0 ? pe(q, _e) : f(ge) ? re(q, _e, ge) : pe(q, _e);
              }
              function oe(q, _e) {
                if (q === _e)
                  he(q, G());
                else if (h(_e)) {
                  var ge = void 0;
                  try {
                    ge = _e.then;
                  } catch (Ce) {
                    he(q, Ce);
                    return;
                  }
                  z(q, _e, ge);
                } else
                  pe(q, _e);
              }
              function de(q) {
                q._onerror && q._onerror(q._result), ee(q);
              }
              function pe(q, _e) {
                q._state === j && (q._result = _e, q._state = J, q._subscribers.length !== 0 && A(ee, q));
              }
              function he(q, _e) {
                q._state === j && (q._state = ae, q._result = _e, A(de, q));
              }
              function se(q, _e, ge, Ce) {
                var Ee = q._subscribers, Re = Ee.length;
                q._onerror = null, Ee[Re] = _e, Ee[Re + J] = ge, Ee[Re + ae] = Ce, Re === 0 && q._state && A(ee, q);
              }
              function ee(q) {
                var _e = q._subscribers, ge = q._state;
                if (_e.length !== 0) {
                  for (var Ce = void 0, Ee = void 0, Re = q._result, Pe = 0; Pe < _e.length; Pe += 3)
                    Ce = _e[Pe], Ee = _e[Pe + ge], Ce ? te(ge, Ce, Ee, Re) : Ee(Re);
                  q._subscribers.length = 0;
                }
              }
              function te(q, _e, ge, Ce) {
                var Ee = f(ge), Re = void 0, Pe = void 0, ke = !0;
                if (Ee) {
                  try {
                    Re = ge(Ce);
                  } catch (De) {
                    ke = !1, Pe = De;
                  }
                  if (_e === Re) {
                    he(_e, $());
                    return;
                  }
                } else
                  Re = Ce;
                _e._state !== j || (Ee && ke ? oe(_e, Re) : ke === !1 ? he(_e, Pe) : q === J ? pe(_e, Re) : q === ae && he(_e, Re));
              }
              function le(q, _e) {
                try {
                  _e(function(Ce) {
                    oe(q, Ce);
                  }, function(Ce) {
                    he(q, Ce);
                  });
                } catch (ge) {
                  he(q, ge);
                }
              }
              var ne = 0;
              function x() {
                return ne++;
              }
              function P(q) {
                q[Z] = ne++, q._state = void 0, q._result = void 0, q._subscribers = [];
              }
              function B() {
                return new Error("Array Methods must be provided an Array");
              }
              var W = function() {
                function q(_e, ge) {
                  this._instanceConstructor = _e, this.promise = new _e(Y), this.promise[Z] || P(this.promise), d(ge) ? (this.length = ge.length, this._remaining = ge.length, this._result = new Array(this.length), this.length === 0 ? pe(this.promise, this._result) : (this.length = this.length || 0, this._enumerate(ge), this._remaining === 0 && pe(this.promise, this._result))) : he(this.promise, B());
                }
                return q.prototype._enumerate = function(ge) {
                  for (var Ce = 0; this._state === j && Ce < ge.length; Ce++)
                    this._eachEntry(ge[Ce], Ce);
                }, q.prototype._eachEntry = function(ge, Ce) {
                  var Ee = this._instanceConstructor, Re = Ee.resolve;
                  if (Re === H) {
                    var Pe = void 0, ke = void 0, De = !1;
                    try {
                      Pe = ge.then;
                    } catch (Ie) {
                      De = !0, ke = Ie;
                    }
                    if (Pe === k && ge._state !== j)
                      this._settledAt(ge._state, Ce, ge._result);
                    else if (typeof Pe != "function")
                      this._remaining--, this._result[Ce] = ge;
                    else if (Ee === fe) {
                      var Ae = new Ee(Y);
                      De ? he(Ae, ke) : z(Ae, ge, Pe), this._willSettleAt(Ae, Ce);
                    } else
                      this._willSettleAt(new Ee(function(Ie) {
                        return Ie(ge);
                      }), Ce);
                  } else
                    this._willSettleAt(Re(ge), Ce);
                }, q.prototype._settledAt = function(ge, Ce, Ee) {
                  var Re = this.promise;
                  Re._state === j && (this._remaining--, ge === ae ? he(Re, Ee) : this._result[Ce] = Ee), this._remaining === 0 && pe(Re, this._result);
                }, q.prototype._willSettleAt = function(ge, Ce) {
                  var Ee = this;
                  se(ge, void 0, function(Re) {
                    return Ee._settledAt(J, Ce, Re);
                  }, function(Re) {
                    return Ee._settledAt(ae, Ce, Re);
                  });
                }, q;
              }();
              function X(q) {
                return new W(this, q).promise;
              }
              function K(q) {
                var _e = this;
                return d(q) ? new _e(function(ge, Ce) {
                  for (var Ee = q.length, Re = 0; Re < Ee; Re++)
                    _e.resolve(q[Re]).then(ge, Ce);
                }) : new _e(function(ge, Ce) {
                  return Ce(new TypeError("You must pass an array to race."));
                });
              }
              function U(q) {
                var _e = this, ge = new _e(Y);
                return he(ge, q), ge;
              }
              function V() {
                throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
              }
              function Q() {
                throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
              }
              var fe = function() {
                function q(_e) {
                  this[Z] = x(), this._result = this._state = void 0, this._subscribers = [], Y !== _e && (typeof _e != "function" && V(), this instanceof q ? le(this, _e) : Q());
                }
                return q.prototype.catch = function(ge) {
                  return this.then(null, ge);
                }, q.prototype.finally = function(ge) {
                  var Ce = this, Ee = Ce.constructor;
                  return f(ge) ? Ce.then(function(Re) {
                    return Ee.resolve(ge()).then(function() {
                      return Re;
                    });
                  }, function(Re) {
                    return Ee.resolve(ge()).then(function() {
                      throw Re;
                    });
                  }) : Ce.then(ge, ge);
                }, q;
              }();
              fe.prototype.then = k, fe.all = X, fe.race = K, fe.resolve = H, fe.reject = U, fe._setScheduler = b, fe._setAsap = S, fe._asap = A;
              function ue() {
                var q = void 0;
                if (typeof i.g < "u")
                  q = i.g;
                else if (typeof self < "u")
                  q = self;
                else
                  try {
                    q = Function("return this")();
                  } catch {
                    throw new Error("polyfill failed because global object is unavailable in this environment");
                  }
                var _e = q.Promise;
                if (_e) {
                  var ge = null;
                  try {
                    ge = Object.prototype.toString.call(_e.resolve());
                  } catch {
                  }
                  if (ge === "[object Promise]" && !_e.cast)
                    return;
                }
                q.Promise = fe;
              }
              return fe.polyfill = ue, fe.Promise = fe, fe;
            });
          }
        ),
        /***/
        "./node_modules/events/events.js": (
          /*!***************************************!*\
            !*** ./node_modules/events/events.js ***!
            \***************************************/
          /***/
          (c) => {
            var l = typeof Reflect == "object" ? Reflect : null, i = l && typeof l.apply == "function" ? l.apply : function(M, C, I) {
              return Function.prototype.apply.call(M, C, I);
            }, h;
            l && typeof l.ownKeys == "function" ? h = l.ownKeys : Object.getOwnPropertySymbols ? h = function(M) {
              return Object.getOwnPropertyNames(M).concat(Object.getOwnPropertySymbols(M));
            } : h = function(M) {
              return Object.getOwnPropertyNames(M);
            };
            function f(D) {
              console && console.warn && console.warn(D);
            }
            var p = Number.isNaN || function(M) {
              return M !== M;
            };
            function d() {
              d.init.call(this);
            }
            c.exports = d, c.exports.once = L, d.EventEmitter = d, d.prototype._events = void 0, d.prototype._eventsCount = 0, d.prototype._maxListeners = void 0;
            var v = 10;
            function g(D) {
              if (typeof D != "function")
                throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof D);
            }
            Object.defineProperty(d, "defaultMaxListeners", {
              enumerable: !0,
              get: function() {
                return v;
              },
              set: function(D) {
                if (typeof D != "number" || D < 0 || p(D))
                  throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + D + ".");
                v = D;
              }
            }), d.init = function() {
              (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
            }, d.prototype.setMaxListeners = function(M) {
              if (typeof M != "number" || M < 0 || p(M))
                throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + M + ".");
              return this._maxListeners = M, this;
            };
            function m(D) {
              return D._maxListeners === void 0 ? d.defaultMaxListeners : D._maxListeners;
            }
            d.prototype.getMaxListeners = function() {
              return m(this);
            }, d.prototype.emit = function(M) {
              for (var C = [], I = 1; I < arguments.length; I++)
                C.push(arguments[I]);
              var w = M === "error", F = this._events;
              if (F !== void 0)
                w = w && F.error === void 0;
              else if (!w)
                return !1;
              if (w) {
                var k;
                if (C.length > 0 && (k = C[0]), k instanceof Error)
                  throw k;
                var H = new Error("Unhandled error." + (k ? " (" + k.message + ")" : ""));
                throw H.context = k, H;
              }
              var Z = F[M];
              if (Z === void 0)
                return !1;
              if (typeof Z == "function")
                i(Z, this, C);
              else
                for (var Y = Z.length, j = R(Z, Y), I = 0; I < Y; ++I)
                  i(j[I], this, C);
              return !0;
            };
            function A(D, M, C, I) {
              var w, F, k;
              if (g(C), F = D._events, F === void 0 ? (F = D._events = /* @__PURE__ */ Object.create(null), D._eventsCount = 0) : (F.newListener !== void 0 && (D.emit(
                "newListener",
                M,
                C.listener ? C.listener : C
              ), F = D._events), k = F[M]), k === void 0)
                k = F[M] = C, ++D._eventsCount;
              else if (typeof k == "function" ? k = F[M] = I ? [C, k] : [k, C] : I ? k.unshift(C) : k.push(C), w = m(D), w > 0 && k.length > w && !k.warned) {
                k.warned = !0;
                var H = new Error("Possible EventEmitter memory leak detected. " + k.length + " " + String(M) + " listeners added. Use emitter.setMaxListeners() to increase limit");
                H.name = "MaxListenersExceededWarning", H.emitter = D, H.type = M, H.count = k.length, f(H);
              }
              return D;
            }
            d.prototype.addListener = function(M, C) {
              return A(this, M, C, !1);
            }, d.prototype.on = d.prototype.addListener, d.prototype.prependListener = function(M, C) {
              return A(this, M, C, !0);
            };
            function b() {
              if (!this.fired)
                return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
            }
            function S(D, M, C) {
              var I = { fired: !1, wrapFn: void 0, target: D, type: M, listener: C }, w = b.bind(I);
              return w.listener = C, I.wrapFn = w, w;
            }
            d.prototype.once = function(M, C) {
              return g(C), this.on(M, S(this, M, C)), this;
            }, d.prototype.prependOnceListener = function(M, C) {
              return g(C), this.prependListener(M, S(this, M, C)), this;
            }, d.prototype.removeListener = function(M, C) {
              var I, w, F, k, H;
              if (g(C), w = this._events, w === void 0)
                return this;
              if (I = w[M], I === void 0)
                return this;
              if (I === C || I.listener === C)
                --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete w[M], w.removeListener && this.emit("removeListener", M, I.listener || C));
              else if (typeof I != "function") {
                for (F = -1, k = I.length - 1; k >= 0; k--)
                  if (I[k] === C || I[k].listener === C) {
                    H = I[k].listener, F = k;
                    break;
                  }
                if (F < 0)
                  return this;
                F === 0 ? I.shift() : y(I, F), I.length === 1 && (w[M] = I[0]), w.removeListener !== void 0 && this.emit("removeListener", M, H || C);
              }
              return this;
            }, d.prototype.off = d.prototype.removeListener, d.prototype.removeAllListeners = function(M) {
              var C, I, w;
              if (I = this._events, I === void 0)
                return this;
              if (I.removeListener === void 0)
                return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : I[M] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete I[M]), this;
              if (arguments.length === 0) {
                var F = Object.keys(I), k;
                for (w = 0; w < F.length; ++w)
                  k = F[w], k !== "removeListener" && this.removeAllListeners(k);
                return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
              }
              if (C = I[M], typeof C == "function")
                this.removeListener(M, C);
              else if (C !== void 0)
                for (w = C.length - 1; w >= 0; w--)
                  this.removeListener(M, C[w]);
              return this;
            };
            function N(D, M, C) {
              var I = D._events;
              if (I === void 0)
                return [];
              var w = I[M];
              return w === void 0 ? [] : typeof w == "function" ? C ? [w.listener || w] : [w] : C ? E(w) : R(w, w.length);
            }
            d.prototype.listeners = function(M) {
              return N(this, M, !0);
            }, d.prototype.rawListeners = function(M) {
              return N(this, M, !1);
            }, d.listenerCount = function(D, M) {
              return typeof D.listenerCount == "function" ? D.listenerCount(M) : T.call(D, M);
            }, d.prototype.listenerCount = T;
            function T(D) {
              var M = this._events;
              if (M !== void 0) {
                var C = M[D];
                if (typeof C == "function")
                  return 1;
                if (C !== void 0)
                  return C.length;
              }
              return 0;
            }
            d.prototype.eventNames = function() {
              return this._eventsCount > 0 ? h(this._events) : [];
            };
            function R(D, M) {
              for (var C = new Array(M), I = 0; I < M; ++I)
                C[I] = D[I];
              return C;
            }
            function y(D, M) {
              for (; M + 1 < D.length; M++)
                D[M] = D[M + 1];
              D.pop();
            }
            function E(D) {
              for (var M = new Array(D.length), C = 0; C < M.length; ++C)
                M[C] = D[C].listener || D[C];
              return M;
            }
            function L(D, M) {
              return new Promise(function(C, I) {
                function w(k) {
                  D.removeListener(M, F), I(k);
                }
                function F() {
                  typeof D.removeListener == "function" && D.removeListener("error", w), C([].slice.call(arguments));
                }
                O(D, M, F, { once: !0 }), M !== "error" && _(D, w, { once: !0 });
              });
            }
            function _(D, M, C) {
              typeof D.on == "function" && O(D, "error", M, C);
            }
            function O(D, M, C, I) {
              if (typeof D.on == "function")
                I.once ? D.once(M, C) : D.on(M, C);
              else if (typeof D.addEventListener == "function")
                D.addEventListener(M, function w(F) {
                  I.once && D.removeEventListener(M, w), C(F);
                });
              else
                throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof D);
            }
          }
        ),
        /***/
        "./node_modules/fast-deep-equal/index.js": (
          /*!***********************************************!*\
            !*** ./node_modules/fast-deep-equal/index.js ***!
            \***********************************************/
          /***/
          (c) => {
            var l = Array.isArray, i = Object.keys, h = Object.prototype.hasOwnProperty;
            c.exports = function f(p, d) {
              if (p === d)
                return !0;
              if (p && d && typeof p == "object" && typeof d == "object") {
                var v = l(p), g = l(d), m, A, b;
                if (v && g) {
                  if (A = p.length, A != d.length)
                    return !1;
                  for (m = A; m-- !== 0; )
                    if (!f(p[m], d[m]))
                      return !1;
                  return !0;
                }
                if (v != g)
                  return !1;
                var S = p instanceof Date, N = d instanceof Date;
                if (S != N)
                  return !1;
                if (S && N)
                  return p.getTime() == d.getTime();
                var T = p instanceof RegExp, R = d instanceof RegExp;
                if (T != R)
                  return !1;
                if (T && R)
                  return p.toString() == d.toString();
                var y = i(p);
                if (A = y.length, A !== i(d).length)
                  return !1;
                for (m = A; m-- !== 0; )
                  if (!h.call(d, y[m]))
                    return !1;
                for (m = A; m-- !== 0; )
                  if (b = y[m], !f(p[b], d[b]))
                    return !1;
                return !0;
              }
              return p !== p && d !== d;
            };
          }
        ),
        /***/
        "./node_modules/imsc/src/main/js/doc.js": (
          /*!**********************************************!*\
            !*** ./node_modules/imsc/src/main/js/doc.js ***!
            \**********************************************/
          /***/
          (c, l, i) => {
            (function(h, f, p, d, v) {
              h.fromXML = function(x, P, B) {
                var W = f.parser(!0, { xmlns: !0 }), X = [], K = [], U = [], V = 0, Q = null;
                W.onclosetag = function(ge) {
                  if (X[0] instanceof S)
                    for (var Ce in X[0].styles)
                      pe(X[0], X[0].styles[Ce], P);
                  else if (X[0] instanceof I || X[0] instanceof w) {
                    if (X[0].contents.length > 1) {
                      var Ee = [X[0].contents[0]], Re;
                      for (Re = 1; Re < X[0].contents.length; Re++)
                        X[0].contents[Re] instanceof F && Ee[Ee.length - 1] instanceof F ? Ee[Ee.length - 1].text += X[0].contents[Re].text : Ee.push(X[0].contents[Re]);
                      X[0].contents = Ee;
                    }
                    X[0] instanceof w && X[0].contents.length === 1 && X[0].contents[0] instanceof F && (X[0].text = X[0].contents[0].text, delete X[0].contents);
                  } else
                    X[0] instanceof m && (X[0].node.uri === p.ns_tt && X[0].node.local === "metadata" ? V-- : V > 0 && B && "onCloseTag" in B && B.onCloseTag());
                  U.shift(), K.shift(), X.shift();
                }, W.ontext = function(ge) {
                  if (X[0] !== void 0)
                    if (X[0] instanceof w || X[0] instanceof I) {
                      var Ce = new F();
                      Ce.initFromText(Q, X[0], ge, U[0], P), X[0].contents.push(Ce);
                    } else
                      X[0] instanceof m && V > 0 && B && "onText" in B && B.onText(ge);
                }, W.onopentag = function(ge) {
                  var Ce = ge.attributes["xml:space"];
                  Ce ? U.unshift(Ce.value) : U.length === 0 ? U.unshift("default") : U.unshift(U[0]);
                  var Ee = ge.attributes["xml:lang"];
                  if (Ee ? K.unshift(Ee.value) : K.length === 0 ? K.unshift("") : K.unshift(K[0]), ge.uri === p.ns_tt)
                    if (ge.local === "tt")
                      Q !== null && le(P, "Two <tt> elements at (" + this.line + "," + this.column + ")"), Q = new A(), Q.initFromNode(ge, P), X.unshift(Q);
                    else if (ge.local === "head")
                      X[0] instanceof A || le(P, "Parent of <head> element is not <tt> at (" + this.line + "," + this.column + ")"), Q.head !== null && le("Second <head> element at (" + this.line + "," + this.column + ")"), Q.head = new b(), X.unshift(Q.head);
                    else if (ge.local === "styling")
                      X[0] instanceof b || le(P, "Parent of <styling> element is not <head> at (" + this.line + "," + this.column + ")"), Q.head.styling !== null && le("Second <styling> element at (" + this.line + "," + this.column + ")"), Q.head.styling = new S(), X.unshift(Q.head.styling);
                    else if (ge.local === "style") {
                      var Re;
                      X[0] instanceof S ? (Re = new N(), Re.initFromNode(ge, P), Re.id ? Q.head.styling.styles[Re.id] = Re : te(P, "<style> element missing @id attribute"), X.unshift(Re)) : X[0] instanceof H ? (Re = new N(), Re.initFromNode(ge, P), se(Re.styleAttrs, X[0].styleAttrs), X.unshift(Re)) : le(P, "Parent of <style> element is not <styling> or <region> at (" + this.line + "," + this.column + ")");
                    } else if (ge.local === "layout")
                      X[0] instanceof b || le(P, "Parent of <layout> element is not <head> at " + this.line + "," + this.column + ")"), Q.head.layout !== null && le(P, "Second <layout> element at " + this.line + "," + this.column + ")"), Q.head.layout = new T(), X.unshift(Q.head.layout);
                    else if (ge.local === "region") {
                      X[0] instanceof T || le(P, "Parent of <region> element is not <layout> at " + this.line + "," + this.column + ")");
                      var Pe = new H();
                      Pe.initFromNode(Q, ge, P), !Pe.id || Pe.id in Q.head.layout.regions ? te(P, "Ignoring <region> with duplicate or missing @id at " + this.line + "," + this.column + ")") : Q.head.layout.regions[Pe.id] = Pe, X.unshift(Pe);
                    } else if (ge.local === "body") {
                      X[0] instanceof A || le(P, "Parent of <body> element is not <tt> at " + this.line + "," + this.column + ")"), Q.body !== null && le(P, "Second <body> element at " + this.line + "," + this.column + ")");
                      var ke = new M();
                      ke.initFromNode(Q, ge, P), Q.body = ke, X.unshift(ke);
                    } else if (ge.local === "div") {
                      X[0] instanceof C || X[0] instanceof M || le(P, "Parent of <div> element is not <body> or <div> at " + this.line + "," + this.column + ")");
                      var De = new C();
                      De.initFromNode(Q, X[0], ge, P), X[0].contents.push(De), X.unshift(De);
                    } else if (ge.local === "p") {
                      X[0] instanceof C || le(P, "Parent of <p> element is not <div> at " + this.line + "," + this.column + ")");
                      var Ae = new I();
                      Ae.initFromNode(Q, X[0], ge, P), X[0].contents.push(Ae), X.unshift(Ae);
                    } else if (ge.local === "span") {
                      X[0] instanceof w || X[0] instanceof I || le(P, "Parent of <span> element is not <span> or <p> at " + this.line + "," + this.column + ")");
                      var Ie = new w();
                      Ie.initFromNode(Q, X[0], ge, U[0], P), X[0].contents.push(Ie), X.unshift(Ie);
                    } else if (ge.local === "br") {
                      X[0] instanceof w || X[0] instanceof I || le(P, "Parent of <br> element is not <span> or <p> at " + this.line + "," + this.column + ")");
                      var Xe = new k();
                      Xe.initFromNode(Q, X[0], ge, P), X[0].contents.push(Xe), X.unshift(Xe);
                    } else if (ge.local === "set") {
                      X[0] instanceof w || X[0] instanceof I || X[0] instanceof C || X[0] instanceof M || X[0] instanceof H || X[0] instanceof k || le(P, "Parent of <set> element is not a content element or a region at " + this.line + "," + this.column + ")");
                      var it = new Z();
                      it.initFromNode(Q, X[0], ge, P), X[0].sets.push(it), X.unshift(it);
                    } else
                      X.unshift(new m(ge));
                  else
                    X.unshift(new m(ge));
                  if (X[0] instanceof m) {
                    if (ge.uri === p.ns_tt && ge.local === "metadata")
                      V++;
                    else if (V > 0 && B && "onOpenTag" in B) {
                      var rt = [];
                      for (var Ne in ge.attributes)
                        rt[ge.attributes[Ne].uri + " " + ge.attributes[Ne].local] = {
                          uri: ge.attributes[Ne].uri,
                          local: ge.attributes[Ne].local,
                          value: ge.attributes[Ne].value
                        };
                      B.onOpenTag(ge.uri, ge.local, rt);
                    }
                  }
                }, W.write(x).close(), Q.head !== null ? delete Q.head.styling : Q.head = new b(), Q.head.layout === null && (Q.head.layout = new T());
                var fe = !1;
                for (var ue in Q.head.layout.regions) {
                  fe = !0;
                  break;
                }
                if (!fe) {
                  var q = H.prototype.createDefaultRegion();
                  Q.head.layout.regions[q.id] = q;
                }
                for (var _e in Q.head.layout.regions)
                  g(Q, Q.head.layout.regions[_e], null, null);
                return Q.body && g(Q, Q.body, null, null), Q;
              };
              function g(x, P, B, W) {
                var X = W && W.timeContainer === "seq", K = 0;
                W && (X && B ? K = B.end : K = W.begin), P.begin = P.explicit_begin ? P.explicit_begin + K : K;
                var U = P.begin, V = null;
                for (var Q in P.sets)
                  g(x, P.sets[Q], V, P), P.timeContainer === "seq" ? U = P.sets[Q].end : U = Math.max(U, P.sets[Q].end), V = P.sets[Q];
                if (!("contents" in P))
                  X ? U = P.begin : U = Number.POSITIVE_INFINITY;
                else
                  for (var fe in P.contents)
                    g(x, P.contents[fe], V, P), P.timeContainer === "seq" ? U = P.contents[fe].end : U = Math.max(U, P.contents[fe].end), V = P.contents[fe];
                P.explicit_end !== null && P.explicit_dur !== null ? P.end = Math.min(P.begin + P.explicit_dur, K + P.explicit_end) : P.explicit_end === null && P.explicit_dur !== null ? P.end = P.begin + P.explicit_dur : P.explicit_end !== null && P.explicit_dur === null ? P.end = K + P.explicit_end : P.end = U, delete P.explicit_begin, delete P.explicit_dur, delete P.explicit_end, x._registerEvent(P);
              }
              function m(x) {
                this.node = x;
              }
              function A() {
                this.events = [], this.head = null, this.body = null;
              }
              A.prototype.initFromNode = function(x, P) {
                this.cellResolution = re(x, P);
                var B = ce(x, P);
                this.effectiveFrameRate = B.effectiveFrameRate, this.tickRate = B.tickRate, this.aspectRatio = ie(x, P);
                var W = $(x, p.ns_ttp, "timeBase");
                W !== null && W !== "media" && le(P, "Unsupported time base");
                var X = z(x, P);
                X === null ? this.pxDimensions = { h: 480, w: 640 } : ((X.h.unit !== "px" || X.w.unit !== "px") && le(P, "Extent on TT must be in px or absent"), this.pxDimensions = { h: X.h.value, w: X.w.value });
              }, A.prototype._registerEvent = function(x) {
                if (!(x.end <= x.begin)) {
                  var P = ne(this.events, x.begin);
                  if (P.found || this.events.splice(P.index, 0, x.begin), x.end !== Number.POSITIVE_INFINITY) {
                    var B = ne(this.events, x.end);
                    B.found || this.events.splice(B.index, 0, x.end);
                  }
                }
              }, A.prototype.getMediaTimeRange = function() {
                return [this.events[0], this.events[this.events.length - 1]];
              }, A.prototype.getMediaTimeEvents = function() {
                return this.events;
              };
              function b() {
                this.styling = null, this.layout = null;
              }
              function S() {
                this.styles = {};
              }
              function N() {
                this.id = null, this.styleAttrs = null, this.styleRefs = null;
              }
              N.prototype.initFromNode = function(x, P) {
                this.id = Y(x), this.styleAttrs = G(x, P), this.styleRefs = ae(x);
              };
              function T() {
                this.regions = {};
              }
              function R(x) {
                this.kind = x;
              }
              function y(x) {
                this.id = x;
              }
              y.prototype.initFromNode = function(x, P, B, W) {
                this.id = Y(B);
              };
              function E(x) {
                this.regionID = x;
              }
              E.prototype.initFromNode = function(x, P, B, W) {
                this.regionID = j(B);
              };
              function L(x) {
                this.styleAttrs = x;
              }
              L.prototype.initFromNode = function(x, P, B, W) {
                this.styleAttrs = G(B, W), x.head !== null && x.head.styling !== null && he(x.head.styling, ae(B), this.styleAttrs, W);
              };
              function _(x) {
                this.sets = x;
              }
              _.prototype.initFromNode = function(x, P, B, W) {
                this.sets = [];
              };
              function O(x) {
                this.contents = x;
              }
              O.prototype.initFromNode = function(x, P, B, W) {
                this.contents = [];
              };
              function D(x, P, B) {
                this.explicit_begin = x, this.explicit_end = P, this.explicit_dur = B;
              }
              D.prototype.initFromNode = function(x, P, B, W) {
                var X = de(x, P, B, W);
                this.explicit_begin = X.explicit_begin, this.explicit_end = X.explicit_end, this.explicit_dur = X.explicit_dur, this.timeContainer = J(B, W);
              };
              function M() {
                R.call(this, "body");
              }
              M.prototype.initFromNode = function(x, P, B) {
                L.prototype.initFromNode.call(this, x, null, P, B), D.prototype.initFromNode.call(this, x, null, P, B), _.prototype.initFromNode.call(this, x, null, P, B), E.prototype.initFromNode.call(this, x, null, P, B), O.prototype.initFromNode.call(this, x, null, P, B);
              };
              function C() {
                R.call(this, "div");
              }
              C.prototype.initFromNode = function(x, P, B, W) {
                L.prototype.initFromNode.call(this, x, P, B, W), D.prototype.initFromNode.call(this, x, P, B, W), _.prototype.initFromNode.call(this, x, P, B, W), E.prototype.initFromNode.call(this, x, P, B, W), O.prototype.initFromNode.call(this, x, P, B, W);
              };
              function I() {
                R.call(this, "p");
              }
              I.prototype.initFromNode = function(x, P, B, W) {
                L.prototype.initFromNode.call(this, x, P, B, W), D.prototype.initFromNode.call(this, x, P, B, W), _.prototype.initFromNode.call(this, x, P, B, W), E.prototype.initFromNode.call(this, x, P, B, W), O.prototype.initFromNode.call(this, x, P, B, W);
              };
              function w() {
                R.call(this, "span");
              }
              w.prototype.initFromNode = function(x, P, B, W, X) {
                L.prototype.initFromNode.call(this, x, P, B, X), D.prototype.initFromNode.call(this, x, P, B, X), _.prototype.initFromNode.call(this, x, P, B, X), E.prototype.initFromNode.call(this, x, P, B, X), O.prototype.initFromNode.call(this, x, P, B, X), this.space = W;
              };
              function F() {
                R.call(this, "span");
              }
              F.prototype.initFromText = function(x, P, B, W, X) {
                D.prototype.initFromNode.call(this, x, P, null, X), this.text = B, this.space = W;
              };
              function k() {
                R.call(this, "br");
              }
              k.prototype.initFromNode = function(x, P, B, W) {
                E.prototype.initFromNode.call(this, x, P, B, W), D.prototype.initFromNode.call(this, x, P, B, W);
              };
              function H() {
              }
              H.prototype.createDefaultRegion = function() {
                var x = new H();
                return y.call(x, ""), L.call(x, {}), _.call(x, []), D.call(x, 0, Number.POSITIVE_INFINITY, null), x;
              }, H.prototype.initFromNode = function(x, P, B) {
                y.prototype.initFromNode.call(this, x, null, P, B), L.prototype.initFromNode.call(this, x, null, P, B), D.prototype.initFromNode.call(this, x, null, P, B), _.prototype.initFromNode.call(this, x, null, P, B), x.head !== null && x.head.styling !== null && he(x.head.styling, ae(P), this.styleAttrs, B);
              };
              function Z() {
              }
              Z.prototype.initFromNode = function(x, P, B, W) {
                D.prototype.initFromNode.call(this, x, P, B, W);
                var X = G(B, W);
                this.qname = null, this.value = null;
                for (var K in X) {
                  if (this.qname) {
                    te(W, "More than one style specified on set");
                    break;
                  }
                  this.qname = K, this.value = X[K];
                }
              };
              function Y(x) {
                return x && "xml:id" in x.attributes && x.attributes["xml:id"].value || null;
              }
              function j(x) {
                return x && "region" in x.attributes ? x.attributes.region.value : "";
              }
              function J(x, P) {
                var B = x && "timeContainer" in x.attributes ? x.attributes.timeContainer.value : null;
                return !B || B === "par" ? "par" : B === "seq" ? "seq" : (te(P, "Illegal value of timeContainer (assuming 'par')"), "par");
              }
              function ae(x) {
                return x && "style" in x.attributes ? x.attributes.style.value.split(" ") : [];
              }
              function G(x, P) {
                var B = {};
                if (x !== null)
                  for (var W in x.attributes) {
                    var X = x.attributes[W].uri + " " + x.attributes[W].local, K = d.byQName[X];
                    if (K !== void 0) {
                      var U = K.parse(x.attributes[W].value);
                      U !== null ? (B[X] = U, K === d.byName.zIndex && ee(P, "zIndex attribute present but not used by IMSC1 since regions do not overlap")) : te(P, "Cannot parse styling attribute " + X + " --> " + x.attributes[W].value);
                    }
                  }
                return B;
              }
              function $(x, P, B) {
                for (var W in x.attributes)
                  if (x.attributes[W].uri === P && x.attributes[W].local === B)
                    return x.attributes[W].value;
                return null;
              }
              function ie(x, P) {
                var B = $(x, p.ns_ittp, "aspectRatio"), W = null;
                if (B !== null) {
                  var X = /(\d+) (\d+)/, K = X.exec(B);
                  if (K !== null) {
                    var U = parseInt(K[1]), V = parseInt(K[2]);
                    U !== 0 && V !== 0 ? W = U / V : te(P, "Illegal aspectRatio values (ignoring)");
                  } else
                    te(P, "Malformed aspectRatio attribute (ignoring)");
                }
                return W;
              }
              function re(x, P) {
                var B = $(x, p.ns_ttp, "cellResolution"), W = 15, X = 32;
                if (B !== null) {
                  var K = /(\d+) (\d+)/, U = K.exec(B);
                  U !== null ? (X = parseInt(U[1]), W = parseInt(U[2])) : ee(P, "Malformed cellResolution value (using initial value instead)");
                }
                return { w: X, h: W };
              }
              function ce(x, P) {
                var B = $(x, p.ns_ttp, "frameRate"), W = 30, X;
                if (B !== null) {
                  var K = /(\d+)/;
                  X = K.exec(B), X !== null ? W = parseInt(X[1]) : ee(P, "Malformed frame rate attribute (using initial value instead)");
                }
                var U = $(x, p.ns_ttp, "frameRateMultiplier"), V = 1;
                if (U !== null) {
                  var Q = /(\d+) (\d+)/;
                  X = Q.exec(U), X !== null ? V = parseInt(X[1]) / parseInt(X[2]) : ee(P, "Malformed frame rate multiplier attribute (using initial value instead)");
                }
                var fe = V * W, ue = 1, q = $(x, p.ns_ttp, "tickRate");
                if (q === null)
                  B !== null && (ue = fe);
                else {
                  var _e = /(\d+)/;
                  X = _e.exec(q), X !== null ? ue = parseInt(X[1]) : ee(P, "Malformed tick rate attribute (using initial value instead)");
                }
                return { effectiveFrameRate: fe, tickRate: ue };
              }
              function z(x, P) {
                var B = $(x, p.ns_tts, "extent");
                if (B === null)
                  return null;
                var W = B.split(" ");
                if (W.length !== 2)
                  return ee(P, "Malformed extent (ignoring)"), null;
                var X = v.parseLength(W[0]), K = v.parseLength(W[1]);
                return !K || !X ? (ee(P, "Malformed extent values (ignoring)"), null) : { h: K, w: X };
              }
              function oe(x, P, B) {
                var W = /^(\d{2,}):(\d\d):(\d\d(?:\.\d+)?)$/, X = /^(\d{2,}):(\d\d):(\d\d)\:(\d{2,})$/, K = /^(\d+(?:\.\d+)?)f$/, U = /^(\d+(?:\.\d+)?)t$/, V = /^(\d+(?:\.\d+)?)ms$/, Q = /^(\d+(?:\.\d+)?)s$/, fe = /^(\d+(?:\.\d+)?)h$/, ue = /^(\d+(?:\.\d+)?)m$/, q, _e = null;
                return (q = K.exec(B)) !== null ? P !== null && (_e = parseFloat(q[1]) / P) : (q = U.exec(B)) !== null ? x !== null && (_e = parseFloat(q[1]) / x) : (q = V.exec(B)) !== null ? _e = parseFloat(q[1]) / 1e3 : (q = Q.exec(B)) !== null ? _e = parseFloat(q[1]) : (q = fe.exec(B)) !== null ? _e = parseFloat(q[1]) * 3600 : (q = ue.exec(B)) !== null ? _e = parseFloat(q[1]) * 60 : (q = W.exec(B)) !== null ? _e = parseInt(q[1]) * 3600 + parseInt(q[2]) * 60 + parseFloat(q[3]) : (q = X.exec(B)) !== null && P !== null && (_e = parseInt(q[1]) * 3600 + parseInt(q[2]) * 60 + parseInt(q[3]) + (q[4] === null ? 0 : parseInt(q[4]) / P)), _e;
              }
              function de(x, P, B, W) {
                var X = null;
                B && "begin" in B.attributes && (X = oe(x.tickRate, x.effectiveFrameRate, B.attributes.begin.value), X === null && ee(W, "Malformed begin value " + B.attributes.begin.value + " (using 0)"));
                var K = null;
                B && "dur" in B.attributes && (K = oe(x.tickRate, x.effectiveFrameRate, B.attributes.dur.value), K === null && ee(W, "Malformed dur value " + B.attributes.dur.value + " (ignoring)"));
                var U = null;
                return B && "end" in B.attributes && (U = oe(x.tickRate, x.effectiveFrameRate, B.attributes.end.value), U === null && ee(W, "Malformed end value (ignoring)")), {
                  explicit_begin: X,
                  explicit_end: U,
                  explicit_dur: K
                };
              }
              function pe(x, P, B) {
                for (; P.styleRefs.length > 0; ) {
                  var W = P.styleRefs.pop();
                  if (!(W in x.styles)) {
                    te(B, "Non-existant style id referenced");
                    continue;
                  }
                  pe(x, x.styles[W], B), se(x.styles[W].styleAttrs, P.styleAttrs);
                }
              }
              function he(x, P, B, W) {
                for (var X = P.length - 1; X >= 0; X--) {
                  var K = P[X];
                  if (!(K in x.styles)) {
                    te(W, "Non-existant style id referenced");
                    continue;
                  }
                  se(x.styles[K].styleAttrs, B);
                }
              }
              function se(x, P) {
                for (var B in x)
                  B in P || (P[B] = x[B]);
              }
              function ee(x, P) {
                if (x && x.warn && x.warn(P))
                  throw P;
              }
              function te(x, P) {
                if (x && x.error && x.error(P))
                  throw P;
              }
              function le(x, P) {
                throw x && x.fatal && x.fatal(P), P;
              }
              function ne(x, P) {
                for (var B = 0, W = x.length - 1, X; B <= W; ) {
                  X = Math.floor((B + W) / 2);
                  var K = x[X];
                  if (K < P)
                    B = X + 1;
                  else if (K > P)
                    W = X - 1;
                  else
                    return { found: !0, index: X };
                }
                return { found: !1, index: B };
              }
            })(
              l,
              typeof sax > "u" ? i(
                /*! sax */
                "./node_modules/sax/lib/sax.js"
              ) : sax,
              typeof imscNames > "u" ? i(
                /*! ./names */
                "./node_modules/imsc/src/main/js/names.js"
              ) : imscNames,
              typeof imscStyles > "u" ? i(
                /*! ./styles */
                "./node_modules/imsc/src/main/js/styles.js"
              ) : imscStyles,
              typeof imscUtils > "u" ? i(
                /*! ./utils */
                "./node_modules/imsc/src/main/js/utils.js"
              ) : imscUtils
            );
          }
        ),
        /***/
        "./node_modules/imsc/src/main/js/html.js": (
          /*!***********************************************!*\
            !*** ./node_modules/imsc/src/main/js/html.js ***!
            \***********************************************/
          /***/
          (c, l, i) => {
            (function(h, f, p) {
              h.render = function(_, O, D, M, C, I, w, F, k) {
                var H = M || O.clientHeight, Z = C || O.clientWidth;
                if (_.aspectRatio !== null) {
                  var Y = H * _.aspectRatio;
                  Y > Z ? H = Math.round(Z / _.aspectRatio) : Z = Y;
                }
                var j = document.createElement("div");
                j.style.position = "relative", j.style.width = Z + "px", j.style.height = H + "px", j.style.margin = "auto", j.style.top = 0, j.style.bottom = 0, j.style.left = 0, j.style.right = 0, j.style.zIndex = 0;
                var J = {
                  h: H,
                  w: Z,
                  regionH: null,
                  regionW: null,
                  imgResolver: D,
                  displayForcedOnlyMode: I || !1,
                  isd: _,
                  errorHandler: w,
                  previousISDState: F,
                  enableRollUp: k || !1,
                  currentISDState: {},
                  flg: null,
                  /* current fillLineGap value if active, null otherwise */
                  lp: null,
                  /* current linePadding value if active, null otherwise */
                  mra: null,
                  /* current multiRowAlign value if active, null otherwise */
                  ipd: null,
                  /* inline progression direction (lr, rl, tb) */
                  bpd: null
                  /* block progression direction (lr, rl, tb) */
                };
                O.appendChild(j);
                for (var ae in _.contents)
                  d(J, j, _.contents[ae]);
                return J.currentISDState;
              };
              function d(_, O, D) {
                var M;
                if (D.kind === "region" ? (M = document.createElement("div"), M.style.position = "absolute") : D.kind === "body" || D.kind === "div" ? M = document.createElement("div") : D.kind === "p" ? M = document.createElement("p") : D.kind === "span" ? M = document.createElement("span") : D.kind === "br" && (M = document.createElement("br")), !M) {
                  L(_.errorHandler, "Error processing ISD element kind: " + D.kind);
                  return;
                }
                M.style.margin = "0";
                for (var C in R) {
                  var I = R[C], w = D.styleAttrs[I.qname];
                  w !== void 0 && I.map !== null && I.map(_, M, D, w);
                }
                var F = M;
                if (D.kind === "region") {
                  var k = D.styleAttrs[p.byName.writingMode.qname];
                  k === "lrtb" || k === "lr" ? (_.ipd = "lr", _.bpd = "tb") : k === "rltb" || k === "rl" ? (_.ipd = "rl", _.bpd = "tb") : k === "tblr" ? (_.ipd = "tb", _.bpd = "lr") : (k === "tbrl" || k === "tb") && (_.ipd = "tb", _.bpd = "rl");
                }
                var H = D.styleAttrs[p.byName.linePadding.qname];
                if (H && H > 0) {
                  var Z = Math.ceil(H * _.h) + "px";
                  _.bpd === "tb" ? (F.style.paddingLeft = Z, F.style.paddingRight = Z) : (F.style.paddingTop = Z, F.style.paddingBottom = Z), _.lp = H;
                }
                var Y = D.styleAttrs[p.byName.multiRowAlign.qname];
                if (Y && Y !== "auto") {
                  var j = document.createElement("span");
                  j.style.display = "inline-block", j.style.textAlign = Y, M.appendChild(j), F = j, _.mra = Y;
                }
                if (D.styleAttrs[p.byName.fillLineGap.qname] && (_.flg = !0), D.kind === "span" && D.text)
                  if (_.lp || _.mra || _.flg)
                    for (var J = "", ae = 0; ae < D.text.length; ae++) {
                      J += D.text.charAt(ae);
                      var G = D.text.charCodeAt(ae);
                      if (G < 55296 || G > 56319 || ae === D.text.length) {
                        var $ = document.createElement("span");
                        $.textContent = J, M.appendChild($), J = "";
                      }
                    }
                  else
                    M.textContent = D.text;
                O.appendChild(M);
                for (var ie in D.contents)
                  d(_, F, D.contents[ie]);
                var re = [];
                if ((_.lp || _.mra || _.flg) && D.kind === "p" && (S(_, F, re, null), _.mra && (g(re), _.mra = null), _.lp && (v(re, _.lp * _.h, _), _.lp = null), _.flg)) {
                  var ce = b(F.getBoundingClientRect(), _);
                  m(re, ce.before, ce.after, _), _.flg = null;
                }
                if (D.kind === "region" && (S(_, F, re), _.bpd === "tb" && _.enableRollUp && D.contents.length > 0 && D.styleAttrs[p.byName.displayAlign.qname] === "after")) {
                  var z = D.id === "" ? "_" : D.id, oe = new A(z, re);
                  if (_.currentISDState[oe.id] = oe, _.previousISDState && oe.id in _.previousISDState && _.previousISDState[oe.id].plist.length > 0 && oe.plist.length > 1 && oe.plist[oe.plist.length - 2].text === _.previousISDState[oe.id].plist[_.previousISDState[oe.id].plist.length - 1].text) {
                    var de = M.firstElementChild, pe = oe.plist[oe.plist.length - 1].after - oe.plist[oe.plist.length - 1].before;
                    de.style.bottom = "-" + pe + "px", de.style.transition = "transform 0.4s", de.style.position = "relative", de.style.transform = "translateY(-" + pe + "px)";
                  }
                }
              }
              function v(_, O, D) {
                for (var M in _) {
                  var C = _[M].elements.length, I = _[M].elements[_[M].start_elem], w = _[M].elements[_[M].end_elem], F = Math.ceil(O) + "px", k = "-" + Math.ceil(O) + "px";
                  C !== 0 && (D.ipd === "lr" ? (I.node.style.borderLeftColor = I.bgcolor || "#00000000", I.node.style.borderLeftStyle = "solid", I.node.style.borderLeftWidth = F, I.node.style.marginLeft = k) : D.ipd === "rl" ? (I.node.style.borderRightColor = I.bgcolor || "#00000000", I.node.style.borderRightStyle = "solid", I.node.style.borderRightWidth = F, I.node.style.marginRight = k) : D.ipd === "tb" && (I.node.style.borderTopColor = I.bgcolor || "#00000000", I.node.style.borderTopStyle = "solid", I.node.style.borderTopWidth = F, I.node.style.marginTop = k), D.ipd === "lr" ? (w.node.style.borderRightColor = w.bgcolor || "#00000000", w.node.style.borderRightStyle = "solid", w.node.style.borderRightWidth = F, w.node.style.marginRight = k) : D.ipd === "rl" ? (w.node.style.borderLeftColor = w.bgcolor || "#00000000", w.node.style.borderLeftStyle = "solid", w.node.style.borderLeftWidth = F, w.node.style.marginLeft = k) : D.ipd === "tb" && (w.node.style.borderBottomColor = w.bgcolor || "#00000000", w.node.style.borderBottomStyle = "solid", w.node.style.borderBottomWidth = F, w.node.style.marginBottom = k));
                }
              }
              function g(_) {
                for (var O = 0; O < _.length - 1; O++) {
                  var D = _[O].elements.length;
                  if (D !== 0 && _[O].br === !1) {
                    var M = document.createElement("br"), C = _[O].elements[D - 1].node;
                    C.parentElement.insertBefore(M, C.nextSibling);
                  }
                }
              }
              function m(_, O, D, M) {
                for (var C = Math.sign(D - O), I = 0; I <= _.length; I++) {
                  var w;
                  I === 0 ? w = O : I === _.length ? w = D : w = (_[I].before + _[I - 1].after) / 2;
                  var F, k;
                  if (I > 0)
                    for (var H = 0; H < _[I - 1].elements.length; H++)
                      _[I - 1].elements[H].bgcolor !== null && (k = _[I - 1].elements[H], C * (k.after - w) < 0 && (F = Math.ceil(Math.abs(w - k.after)) + "px", k.node.style.backgroundColor = k.bgcolor, M.bpd === "lr" ? k.node.style.paddingRight = F : M.bpd === "rl" ? k.node.style.paddingLeft = F : M.bpd === "tb" && (k.node.style.paddingBottom = F)));
                  if (I < _.length)
                    for (var Z = 0; Z < _[I].elements.length; Z++)
                      k = _[I].elements[Z], k.bgcolor !== null && C * (k.before - w) > 0 && (F = Math.ceil(Math.abs(k.before - w)) + "px", k.node.style.backgroundColor = k.bgcolor, M.bpd === "lr" ? k.node.style.paddingLeft = F : M.bpd === "rl" ? k.node.style.paddingRight = F : M.bpd === "tb" && (k.node.style.paddingTop = F));
                }
              }
              function A(_, O) {
                this.id = _, this.plist = O;
              }
              function b(_, O) {
                var D = { before: null, after: null, start: null, end: null };
                return O.bpd === "tb" ? (D.before = _.top, D.after = _.bottom, O.ipd === "lr" ? (D.start = _.left, D.end = _.right) : (D.start = _.right, D.end = _.left)) : O.bpd === "lr" ? (D.before = _.left, D.after = _.right, D.start = _.top, D.end = _.bottom) : O.bpd === "rl" && (D.before = _.right, D.after = _.left, D.start = _.top, D.end = _.bottom), D;
              }
              function S(_, O, D, M) {
                var C = O.style.backgroundColor || M;
                if (O.childElementCount === 0)
                  if (O.localName === "span") {
                    var I = O.getBoundingClientRect();
                    if (I.height === 0 || I.width === 0)
                      return;
                    var w = b(I, _);
                    if (D.length === 0 || !N(w.before, w.after, D[D.length - 1].before, D[D.length - 1].after))
                      D.push({
                        before: w.before,
                        after: w.after,
                        start: w.start,
                        end: w.end,
                        start_elem: 0,
                        end_elem: 0,
                        elements: [],
                        text: "",
                        br: !1
                      });
                    else {
                      var F = Math.sign(w.after - w.before), k = Math.sign(w.end - w.start);
                      F * (w.before - D[D.length - 1].before) < 0 && (D[D.length - 1].before = w.before), F * (w.after - D[D.length - 1].after) > 0 && (D[D.length - 1].after = w.after), k * (w.start - D[D.length - 1].start) < 0 && (D[D.length - 1].start = w.start, D[D.length - 1].start_elem = D[D.length - 1].elements.length), k * (w.end - D[D.length - 1].end) > 0 && (D[D.length - 1].end = w.end, D[D.length - 1].end_elem = D[D.length - 1].elements.length);
                    }
                    D[D.length - 1].text += O.textContent, D[D.length - 1].elements.push(
                      {
                        node: O,
                        bgcolor: C,
                        before: w.before,
                        after: w.after
                      }
                    );
                  } else
                    O.localName === "br" && D.length !== 0 && (D[D.length - 1].br = !0);
                else
                  for (var H = O.firstChild; H; )
                    H.nodeType === Node.ELEMENT_NODE && S(_, H, D, C), H = H.nextSibling;
              }
              function N(_, O, D, M) {
                return O < M && _ > D || M <= O && D >= _;
              }
              function T(_, O) {
                this.qname = _, this.map = O;
              }
              var R = [
                new T(
                  "http://www.w3.org/ns/ttml#styling backgroundColor",
                  function(_, O, D, M) {
                    M[3] !== 0 && (O.style.backgroundColor = "rgba(" + M[0].toString() + "," + M[1].toString() + "," + M[2].toString() + "," + (M[3] / 255).toString() + ")");
                  }
                ),
                new T(
                  "http://www.w3.org/ns/ttml#styling color",
                  function(_, O, D, M) {
                    O.style.color = "rgba(" + M[0].toString() + "," + M[1].toString() + "," + M[2].toString() + "," + (M[3] / 255).toString() + ")";
                  }
                ),
                new T(
                  "http://www.w3.org/ns/ttml#styling direction",
                  function(_, O, D, M) {
                    O.style.direction = M;
                  }
                ),
                new T(
                  "http://www.w3.org/ns/ttml#styling display",
                  function(_, O, D, M) {
                  }
                ),
                new T(
                  "http://www.w3.org/ns/ttml#styling displayAlign",
                  function(_, O, D, M) {
                    O.style.display = "flex", O.style.flexDirection = "column", M === "before" ? O.style.justifyContent = "flex-start" : M === "center" ? O.style.justifyContent = "center" : M === "after" && (O.style.justifyContent = "flex-end");
                  }
                ),
                new T(
                  "http://www.w3.org/ns/ttml#styling extent",
                  function(_, O, D, M) {
                    _.regionH = M.h * _.h, _.regionW = M.w * _.w;
                    var C = 0, I = 0, w = D.styleAttrs["http://www.w3.org/ns/ttml#styling padding"];
                    w && (C = (w[0] + w[2]) * _.h, I = (w[1] + w[3]) * _.w), O.style.height = _.regionH - C + "px", O.style.width = _.regionW - I + "px";
                  }
                ),
                new T(
                  "http://www.w3.org/ns/ttml#styling fontFamily",
                  function(_, O, D, M) {
                    var C = [];
                    for (var I in M)
                      M[I] === "monospaceSerif" ? (C.push("Courier New"), C.push('"Liberation Mono"'), C.push("Courier"), C.push("monospace")) : M[I] === "proportionalSansSerif" ? (C.push("Arial"), C.push("Helvetica"), C.push('"Liberation Sans"'), C.push("sans-serif")) : M[I] === "monospace" ? C.push("monospace") : M[I] === "sansSerif" ? C.push("sans-serif") : M[I] === "serif" ? C.push("serif") : M[I] === "monospaceSansSerif" ? (C.push("Consolas"), C.push("monospace")) : M[I] === "proportionalSerif" ? C.push("serif") : C.push(M[I]);
                    O.style.fontFamily = C.join(",");
                  }
                ),
                new T(
                  "http://www.w3.org/ns/ttml#styling fontSize",
                  function(_, O, D, M) {
                    O.style.fontSize = M * _.h + "px";
                  }
                ),
                new T(
                  "http://www.w3.org/ns/ttml#styling fontStyle",
                  function(_, O, D, M) {
                    O.style.fontStyle = M;
                  }
                ),
                new T(
                  "http://www.w3.org/ns/ttml#styling fontWeight",
                  function(_, O, D, M) {
                    O.style.fontWeight = M;
                  }
                ),
                new T(
                  "http://www.w3.org/ns/ttml#styling lineHeight",
                  function(_, O, D, M) {
                    M === "normal" ? O.style.lineHeight = "normal" : O.style.lineHeight = M * _.h + "px";
                  }
                ),
                new T(
                  "http://www.w3.org/ns/ttml#styling opacity",
                  function(_, O, D, M) {
                    O.style.opacity = M;
                  }
                ),
                new T(
                  "http://www.w3.org/ns/ttml#styling origin",
                  function(_, O, D, M) {
                    O.style.top = M.h * _.h + "px", O.style.left = M.w * _.w + "px";
                  }
                ),
                new T(
                  "http://www.w3.org/ns/ttml#styling overflow",
                  function(_, O, D, M) {
                    O.style.overflow = M;
                  }
                ),
                new T(
                  "http://www.w3.org/ns/ttml#styling padding",
                  function(_, O, D, M) {
                    var C = [];
                    C[0] = M[0] * _.h + "px", C[1] = M[3] * _.w + "px", C[2] = M[2] * _.h + "px", C[3] = M[1] * _.w + "px", O.style.padding = C.join(" ");
                  }
                ),
                new T(
                  "http://www.w3.org/ns/ttml#styling showBackground",
                  null
                ),
                new T(
                  "http://www.w3.org/ns/ttml#styling textAlign",
                  function(_, O, D, M) {
                    var C, I = D.styleAttrs[p.byName.direction.qname];
                    M === "start" ? C = I === "rtl" ? "right" : "left" : M === "end" ? C = I === "rtl" ? "left" : "right" : C = M, O.style.textAlign = C;
                  }
                ),
                new T(
                  "http://www.w3.org/ns/ttml#styling textDecoration",
                  function(_, O, D, M) {
                    O.style.textDecoration = M.join(" ").replace("lineThrough", "line-through");
                  }
                ),
                new T(
                  "http://www.w3.org/ns/ttml#styling textOutline",
                  function(_, O, D, M) {
                    M === "none" ? O.style.textShadow = "" : O.style.textShadow = "rgba(" + M.color[0].toString() + "," + M.color[1].toString() + "," + M.color[2].toString() + "," + (M.color[3] / 255).toString() + ") 0px 0px " + M.thickness * _.h + "px";
                  }
                ),
                new T(
                  "http://www.w3.org/ns/ttml#styling unicodeBidi",
                  function(_, O, D, M) {
                    var C;
                    M === "bidiOverride" ? C = "bidi-override" : C = M, O.style.unicodeBidi = C;
                  }
                ),
                new T(
                  "http://www.w3.org/ns/ttml#styling visibility",
                  function(_, O, D, M) {
                    O.style.visibility = M;
                  }
                ),
                new T(
                  "http://www.w3.org/ns/ttml#styling wrapOption",
                  function(_, O, D, M) {
                    M === "wrap" ? D.space === "preserve" ? O.style.whiteSpace = "pre-wrap" : O.style.whiteSpace = "normal" : D.space === "preserve" ? O.style.whiteSpace = "pre" : O.style.whiteSpace = "noWrap";
                  }
                ),
                new T(
                  "http://www.w3.org/ns/ttml#styling writingMode",
                  function(_, O, D, M) {
                    M === "lrtb" || M === "lr" || M === "rltb" || M === "rl" ? O.style.writingMode = "horizontal-tb" : M === "tblr" ? O.style.writingMode = "vertical-lr" : (M === "tbrl" || M === "tb") && (O.style.writingMode = "vertical-rl");
                  }
                ),
                new T(
                  "http://www.w3.org/ns/ttml#styling zIndex",
                  function(_, O, D, M) {
                    O.style.zIndex = M;
                  }
                ),
                new T(
                  "http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt backgroundImage",
                  function(_, O, D, M) {
                    if (_.imgResolver !== null && M !== null) {
                      var C = document.createElement("img"), I = _.imgResolver(M, C);
                      I && (C.src = I), C.height = _.regionH, C.width = _.regionW, O.appendChild(C);
                    }
                  }
                ),
                new T(
                  "http://www.w3.org/ns/ttml/profile/imsc1#styling forcedDisplay",
                  function(_, O, D, M) {
                    _.displayForcedOnlyMode && M === !1 && (O.style.visibility = "hidden");
                  }
                )
              ], y = {};
              for (var E in R)
                y[R[E].qname] = R[E];
              function L(_, O) {
                if (_ && _.error && _.error(O))
                  throw O;
              }
            })(
              l,
              typeof imscNames > "u" ? i(
                /*! ./names */
                "./node_modules/imsc/src/main/js/names.js"
              ) : imscNames,
              typeof imscStyles > "u" ? i(
                /*! ./styles */
                "./node_modules/imsc/src/main/js/styles.js"
              ) : imscStyles
            );
          }
        ),
        /***/
        "./node_modules/imsc/src/main/js/isd.js": (
          /*!**********************************************!*\
            !*** ./node_modules/imsc/src/main/js/isd.js ***!
            \**********************************************/
          /***/
          (c, l, i) => {
            (function(h, f, p) {
              h.generateISD = function(S, N, T) {
                var R = new m(S), y = {
                  /* empty for now */
                };
                for (var E in S.head.layout.regions) {
                  var L = d(S, N, S.head.layout.regions[E], S.body, null, "", S.head.layout.regions[E], T, y);
                  L !== null && R.contents.push(L.element);
                }
                return R;
              };
              function d(S, N, T, R, y, E, L, _, O) {
                if (N < L.begin || N >= L.end)
                  return null;
                var D = "regionID" in L && L.regionID !== "" ? L.regionID : E;
                if (y !== null && D !== T.id && (!("contents" in L) || "contents" in L && L.contents.length === 0 || D !== ""))
                  return null;
                var M = new A(L);
                for (var C in L.sets)
                  N < L.sets[C].begin || N >= L.sets[C].end || (M.styleAttrs[L.sets[C].qname] = L.sets[C].value);
                var I = {};
                for (var w in M.styleAttrs)
                  if (I[w] = !0, w === p.byName.writingMode.qname && !(p.byName.direction.qname in M.styleAttrs)) {
                    var F = M.styleAttrs[w];
                    F === "lrtb" || F === "lr" ? M.styleAttrs[p.byName.direction.qname] = "ltr" : (F === "rltb" || F === "rl") && (M.styleAttrs[p.byName.direction.qname] = "rtl");
                  }
                if (y !== null)
                  for (var k in p.all) {
                    var H = p.all[k];
                    if (H.qname === p.byName.textDecoration.qname) {
                      var Z = y.styleAttrs[H.qname], Y = M.styleAttrs[H.qname], j = [];
                      Y === void 0 ? j = Z : Y.indexOf("none") === -1 ? ((Y.indexOf("noUnderline") === -1 && Z.indexOf("underline") !== -1 || Y.indexOf("underline") !== -1) && j.push("underline"), (Y.indexOf("noLineThrough") === -1 && Z.indexOf("lineThrough") !== -1 || Y.indexOf("lineThrough") !== -1) && j.push("lineThrough"), (Y.indexOf("noOverline") === -1 && Z.indexOf("overline") !== -1 || Y.indexOf("overline") !== -1) && j.push("overline")) : j.push("none"), M.styleAttrs[H.qname] = j;
                    } else
                      H.inherit && H.qname in y.styleAttrs && !(H.qname in M.styleAttrs) && (M.styleAttrs[H.qname] = y.styleAttrs[H.qname]);
                  }
                for (var J in p.all) {
                  var ae = p.all[J];
                  ae.qname in M.styleAttrs || (M.kind === "region" || ae.inherit === !1 && ae.initial !== null) && (M.styleAttrs[ae.qname] = ae.parse(ae.initial), I[ae.qname] = !0);
                }
                for (var G in p.all) {
                  var $ = p.all[G];
                  if ($.qname in I && $.compute !== null) {
                    var ie = $.compute(
                      /*doc, parent, element, attr, context*/
                      S,
                      y,
                      M,
                      M.styleAttrs[$.qname],
                      O
                    );
                    ie !== null ? M.styleAttrs[$.qname] = ie : b(_, "Style '" + $.qname + "' on element '" + M.kind + "' cannot be computed");
                  }
                }
                if (M.styleAttrs[p.byName.display.qname] === "none")
                  return null;
                var re;
                y === null ? R === null ? re = [] : re = [R] : "contents" in L && (re = L.contents);
                for (var ce in re) {
                  var z = d(S, N, T, R, M, D, re[ce], _, O);
                  z !== null && M.contents.push(z.element);
                }
                for (var oe in M.styleAttrs) {
                  var de = p.byQName[oe];
                  de.applies.indexOf(M.kind) === -1 && delete M.styleAttrs[oe];
                }
                if (M.kind === "span" && M.text && M.space === "default") {
                  var pe = M.text.replace(/\s+/g, " ");
                  M.text = pe;
                }
                if (M.kind === "p") {
                  var he = [];
                  v(M, he);
                  for (var se = 0, ee = "after_br", te = 0; ; )
                    if (ee === "after_br")
                      se >= he.length || he[se].kind === "br" ? (ee = "before_br", te = se, se--) : (he[se].space !== "preserve" && (he[se].text = he[se].text.replace(/^\s+/g, "")), he[se].text.length > 0 ? (ee = "looking_br", se++) : he.splice(se, 1));
                    else if (ee === "before_br")
                      if (se < 0 || he[se].kind === "br") {
                        if (ee = "after_br", se = te + 1, se >= he.length)
                          break;
                      } else if (he[se].space !== "preserve" && (he[se].text = he[se].text.replace(/\s+$/g, "")), he[se].text.length > 0) {
                        if (ee = "after_br", se = te + 1, se >= he.length)
                          break;
                      } else
                        he.splice(se, 1), se--;
                    else
                      se >= he.length || he[se].kind === "br" ? (ee = "before_br", te = se, se--) : se++;
                  g(M);
                }
                return M.kind === "div" && p.byName.backgroundImage.qname in M.styleAttrs || M.kind === "br" || "contents" in M && M.contents.length > 0 || M.kind === "span" && M.text !== null || M.kind === "region" && M.styleAttrs[p.byName.showBackground.qname] === "always" ? {
                  region_id: D,
                  element: M
                } : null;
              }
              function v(S, N) {
                if ("contents" in S)
                  for (var T in S.contents)
                    v(S.contents[T], N);
                else
                  N.push(S);
              }
              function g(S) {
                if (S.kind === "br")
                  return !1;
                if ("text" in S)
                  return S.text.length === 0;
                if ("contents" in S) {
                  for (var N = S.contents.length; N--; )
                    g(S.contents[N]) && S.contents.splice(N, 1);
                  return S.contents.length === 0;
                }
              }
              function m(S) {
                this.contents = [], this.aspectRatio = S.aspectRatio;
              }
              function A(S) {
                this.kind = S.kind || "region", S.id && (this.id = S.id), this.styleAttrs = {};
                for (var N in S.styleAttrs)
                  this.styleAttrs[N] = S.styleAttrs[N];
                "text" in S ? this.text = S.text : S.kind !== "br" && (this.contents = []), "space" in S && (this.space = S.space);
              }
              function b(S, N) {
                if (S && S.error && S.error(N))
                  throw N;
              }
            })(
              l,
              typeof imscNames > "u" ? i(
                /*! ./names */
                "./node_modules/imsc/src/main/js/names.js"
              ) : imscNames,
              typeof imscStyles > "u" ? i(
                /*! ./styles */
                "./node_modules/imsc/src/main/js/styles.js"
              ) : imscStyles
            );
          }
        ),
        /***/
        "./node_modules/imsc/src/main/js/main.js": (
          /*!***********************************************!*\
            !*** ./node_modules/imsc/src/main/js/main.js ***!
            \***********************************************/
          /***/
          (c, l, i) => {
            l.generateISD = i(
              /*! ./isd */
              "./node_modules/imsc/src/main/js/isd.js"
            ).generateISD, l.fromXML = i(
              /*! ./doc */
              "./node_modules/imsc/src/main/js/doc.js"
            ).fromXML, l.renderHTML = i(
              /*! ./html */
              "./node_modules/imsc/src/main/js/html.js"
            ).render;
          }
        ),
        /***/
        "./node_modules/imsc/src/main/js/names.js": (
          /*!************************************************!*\
            !*** ./node_modules/imsc/src/main/js/names.js ***!
            \************************************************/
          /***/
          (c, l) => {
            (function(i) {
              i.ns_tt = "http://www.w3.org/ns/ttml", i.ns_tts = "http://www.w3.org/ns/ttml#styling", i.ns_ttp = "http://www.w3.org/ns/ttml#parameter", i.ns_xml = "http://www.w3.org/XML/1998/namespace", i.ns_itts = "http://www.w3.org/ns/ttml/profile/imsc1#styling", i.ns_ittp = "http://www.w3.org/ns/ttml/profile/imsc1#parameter", i.ns_smpte = "http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt", i.ns_ebutts = "urn:ebu:tt:style";
            })(l);
          }
        ),
        /***/
        "./node_modules/imsc/src/main/js/styles.js": (
          /*!*************************************************!*\
            !*** ./node_modules/imsc/src/main/js/styles.js ***!
            \*************************************************/
          /***/
          (c, l, i) => {
            (function(h, f, p) {
              function d(m, A, b, S, N, T, R, y) {
                this.name = A, this.ns = m, this.qname = m + " " + A, this.inherit = N, this.animatable = T, this.initial = b, this.applies = S, this.parse = R, this.compute = y;
              }
              h.all = [
                new d(
                  f.ns_tts,
                  "backgroundColor",
                  "transparent",
                  ["body", "div", "p", "region", "span"],
                  !1,
                  !0,
                  p.parseColor,
                  null
                ),
                new d(
                  f.ns_tts,
                  "color",
                  "white",
                  ["span"],
                  !0,
                  !0,
                  p.parseColor,
                  null
                ),
                new d(
                  f.ns_tts,
                  "direction",
                  "ltr",
                  ["p", "span"],
                  !0,
                  !0,
                  function(m) {
                    return m;
                  },
                  null
                ),
                new d(
                  f.ns_tts,
                  "display",
                  "auto",
                  ["body", "div", "p", "region", "span"],
                  !1,
                  !0,
                  function(m) {
                    return m;
                  },
                  null
                ),
                new d(
                  f.ns_tts,
                  "displayAlign",
                  "before",
                  ["region"],
                  !1,
                  !0,
                  function(m) {
                    return m;
                  },
                  null
                ),
                new d(
                  f.ns_tts,
                  "extent",
                  "auto",
                  ["tt", "region"],
                  !1,
                  !0,
                  function(m) {
                    if (m === "auto")
                      return m;
                    var A = m.split(" ");
                    if (A.length !== 2)
                      return null;
                    var b = p.parseLength(A[0]), S = p.parseLength(A[1]);
                    return !S || !b ? null : { h: S, w: b };
                  },
                  function(m, A, b, S, N) {
                    var T, R;
                    if (S === "auto")
                      T = 1;
                    else if (S.h.unit === "%")
                      T = S.h.value / 100;
                    else if (S.h.unit === "px")
                      T = S.h.value / m.pxDimensions.h;
                    else
                      return null;
                    if (S === "auto")
                      R = 1;
                    else if (S.w.unit === "%")
                      R = S.w.value / 100;
                    else if (S.w.unit === "px")
                      R = S.w.value / m.pxDimensions.w;
                    else
                      return null;
                    return { h: T, w: R };
                  }
                ),
                new d(
                  f.ns_tts,
                  "fontFamily",
                  "default",
                  ["span"],
                  !0,
                  !0,
                  function(m) {
                    var A = m.split(","), b = [];
                    for (var S in A)
                      A[S].charAt(0) !== "'" && A[S].charAt(0) !== '"' && A[S] === "default" ? b.push("monospaceSerif") : b.push(A[S]);
                    return b;
                  },
                  null
                ),
                new d(
                  f.ns_tts,
                  "fontSize",
                  "1c",
                  ["span"],
                  !0,
                  !0,
                  p.parseLength,
                  function(m, A, b, S, N) {
                    var T;
                    if (S.unit === "%")
                      A !== null ? T = A.styleAttrs[h.byName.fontSize.qname] * S.value / 100 : T = S.value / 100 / m.cellResolution.h;
                    else if (S.unit === "em")
                      A !== null ? T = A.styleAttrs[h.byName.fontSize.qname] * S.value : T = S.value / m.cellResolution.h;
                    else if (S.unit === "c")
                      T = S.value / m.cellResolution.h;
                    else if (S.unit === "px")
                      T = S.value / m.pxDimensions.h;
                    else
                      return null;
                    return T;
                  }
                ),
                new d(
                  f.ns_tts,
                  "fontStyle",
                  "normal",
                  ["span"],
                  !0,
                  !0,
                  function(m) {
                    return m;
                  },
                  null
                ),
                new d(
                  f.ns_tts,
                  "fontWeight",
                  "normal",
                  ["span"],
                  !0,
                  !0,
                  function(m) {
                    return m;
                  },
                  null
                ),
                new d(
                  f.ns_tts,
                  "lineHeight",
                  "normal",
                  ["p"],
                  !0,
                  !0,
                  function(m) {
                    return m === "normal" ? m : p.parseLength(m);
                  },
                  function(m, A, b, S, N) {
                    var T;
                    if (S === "normal")
                      T = S;
                    else if (S.unit === "%")
                      T = b.styleAttrs[h.byName.fontSize.qname] * S.value / 100;
                    else if (S.unit === "em")
                      T = b.styleAttrs[h.byName.fontSize.qname] * S.value;
                    else if (S.unit === "c")
                      T = S.value / m.cellResolution.h;
                    else if (S.unit === "px")
                      T = S.value / m.pxDimensions.h;
                    else
                      return null;
                    return T;
                  }
                ),
                new d(
                  f.ns_tts,
                  "opacity",
                  1,
                  ["region"],
                  !1,
                  !0,
                  parseFloat,
                  null
                ),
                new d(
                  f.ns_tts,
                  "origin",
                  "auto",
                  ["region"],
                  !1,
                  !0,
                  function(m) {
                    if (m === "auto")
                      return m;
                    var A = m.split(" ");
                    if (A.length !== 2)
                      return null;
                    var b = p.parseLength(A[0]), S = p.parseLength(A[1]);
                    return !S || !b ? null : { h: S, w: b };
                  },
                  function(m, A, b, S, N) {
                    var T, R;
                    if (S === "auto")
                      T = 0;
                    else if (S.h.unit === "%")
                      T = S.h.value / 100;
                    else if (S.h.unit === "px")
                      T = S.h.value / m.pxDimensions.h;
                    else
                      return null;
                    if (S === "auto")
                      R = 0;
                    else if (S.w.unit === "%")
                      R = S.w.value / 100;
                    else if (S.w.unit === "px")
                      R = S.w.value / m.pxDimensions.w;
                    else
                      return null;
                    return { h: T, w: R };
                  }
                ),
                new d(
                  f.ns_tts,
                  "overflow",
                  "hidden",
                  ["region"],
                  !1,
                  !0,
                  function(m) {
                    return m;
                  },
                  null
                ),
                new d(
                  f.ns_tts,
                  "padding",
                  "0px",
                  ["region"],
                  !1,
                  !0,
                  function(m) {
                    var A = m.split(" ");
                    if (A.length > 4)
                      return null;
                    var b = [];
                    for (var S in A) {
                      var N = p.parseLength(A[S]);
                      if (!N)
                        return null;
                      b.push(N);
                    }
                    return b;
                  },
                  function(m, A, b, S, N) {
                    var T;
                    if (S.length === 1)
                      T = [S[0], S[0], S[0], S[0]];
                    else if (S.length === 2)
                      T = [S[0], S[1], S[0], S[1]];
                    else if (S.length === 3)
                      T = [S[0], S[1], S[2], S[1]];
                    else if (S.length === 4)
                      T = [S[0], S[1], S[2], S[3]];
                    else
                      return null;
                    var R = b.styleAttrs[h.byName.writingMode.qname];
                    if (R === "lrtb" || R === "lr")
                      T = [T[0], T[3], T[2], T[1]];
                    else if (R === "rltb" || R === "rl")
                      T = [T[0], T[1], T[2], T[3]];
                    else if (R === "tblr")
                      T = [T[3], T[0], T[1], T[2]];
                    else if (R === "tbrl" || R === "tb")
                      T = [T[3], T[2], T[1], T[0]];
                    else
                      return null;
                    var y = [];
                    for (var E in T)
                      if (T[E].value === 0)
                        y[E] = 0;
                      else if (T[E].unit === "%")
                        E === "0" || E === "2" ? y[E] = b.styleAttrs[h.byName.extent.qname].h * T[E].value / 100 : y[E] = b.styleAttrs[h.byName.extent.qname].w * T[E].value / 100;
                      else if (T[E].unit === "em")
                        y[E] = b.styleAttrs[h.byName.fontSize.qname] * T[E].value;
                      else if (T[E].unit === "c")
                        y[E] = T[E].value / m.cellResolution.h;
                      else if (T[E].unit === "px")
                        E === "0" || E === "2" ? y[E] = T[E].value / m.pxDimensions.h : y[E] = T[E].value / m.pxDimensions.w;
                      else
                        return null;
                    return y;
                  }
                ),
                new d(
                  f.ns_tts,
                  "showBackground",
                  "always",
                  ["region"],
                  !1,
                  !0,
                  function(m) {
                    return m;
                  },
                  null
                ),
                new d(
                  f.ns_tts,
                  "textAlign",
                  "start",
                  ["p"],
                  !0,
                  !0,
                  function(m) {
                    return m;
                  },
                  function(m, A, b, S, N) {
                    return S === "left" ? "start" : S === "right" ? "end" : S;
                  }
                ),
                new d(
                  f.ns_tts,
                  "textDecoration",
                  "none",
                  ["span"],
                  !0,
                  !0,
                  function(m) {
                    return m.split(" ");
                  },
                  null
                ),
                new d(
                  f.ns_tts,
                  "textOutline",
                  "none",
                  ["span"],
                  !0,
                  !0,
                  function(m) {
                    if (m === "none")
                      return m;
                    var A = {}, b = m.split(" ");
                    if (b.length === 0 || b.length > 2)
                      return null;
                    var S = p.parseColor(b[0]);
                    if (A.color = S, S !== null && b.shift(), b.length !== 1)
                      return null;
                    var N = p.parseLength(b[0]);
                    return N ? (A.thickness = N, A) : null;
                  },
                  function(m, A, b, S, N) {
                    if (S === "none")
                      return S;
                    var T = {};
                    if (S.color === null ? T.color = b.styleAttrs[h.byName.color.qname] : T.color = S.color, S.thickness.unit === "%")
                      T.thickness = b.styleAttrs[h.byName.fontSize.qname] * S.thickness.value / 100;
                    else if (S.thickness.unit === "em")
                      T.thickness = b.styleAttrs[h.byName.fontSize.qname] * S.thickness.value;
                    else if (S.thickness.unit === "c")
                      T.thickness = S.thickness.value / m.cellResolution.h;
                    else if (S.thickness.unit === "px")
                      T.thickness = S.thickness.value / m.pxDimensions.h;
                    else
                      return null;
                    return T;
                  }
                ),
                new d(
                  f.ns_tts,
                  "unicodeBidi",
                  "normal",
                  ["span", "p"],
                  !1,
                  !0,
                  function(m) {
                    return m;
                  },
                  null
                ),
                new d(
                  f.ns_tts,
                  "visibility",
                  "visible",
                  ["body", "div", "p", "region", "span"],
                  !0,
                  !0,
                  function(m) {
                    return m;
                  },
                  null
                ),
                new d(
                  f.ns_tts,
                  "wrapOption",
                  "wrap",
                  ["span"],
                  !0,
                  !0,
                  function(m) {
                    return m;
                  },
                  null
                ),
                new d(
                  f.ns_tts,
                  "writingMode",
                  "lrtb",
                  ["region"],
                  !1,
                  !0,
                  function(m) {
                    return m;
                  },
                  null
                ),
                new d(
                  f.ns_tts,
                  "zIndex",
                  "auto",
                  ["region"],
                  !1,
                  !0,
                  function(m) {
                    var A;
                    return m === "auto" ? A = m : (A = parseInt(m), isNaN(A) && (A = null)), A;
                  },
                  null
                ),
                new d(
                  f.ns_ebutts,
                  "linePadding",
                  "0c",
                  ["p"],
                  !0,
                  !1,
                  p.parseLength,
                  function(m, A, b, S, N) {
                    return S.unit === "c" ? S.value / m.cellResolution.h : null;
                  }
                ),
                new d(
                  f.ns_ebutts,
                  "multiRowAlign",
                  "auto",
                  ["p"],
                  !0,
                  !1,
                  function(m) {
                    return m;
                  },
                  null
                ),
                new d(
                  f.ns_smpte,
                  "backgroundImage",
                  null,
                  ["div"],
                  !1,
                  !1,
                  function(m) {
                    return m;
                  },
                  null
                ),
                new d(
                  f.ns_itts,
                  "forcedDisplay",
                  "false",
                  ["body", "div", "p", "region", "span"],
                  !0,
                  !0,
                  function(m) {
                    return m === "true";
                  },
                  null
                ),
                new d(
                  f.ns_itts,
                  "fillLineGap",
                  "false",
                  ["p"],
                  !0,
                  !0,
                  function(m) {
                    return m === "true";
                  },
                  null
                )
              ], h.byQName = {};
              for (var v in h.all)
                h.byQName[h.all[v].qname] = h.all[v];
              h.byName = {};
              for (var g in h.all)
                h.byName[h.all[g].name] = h.all[g];
            })(
              l,
              typeof imscNames > "u" ? i(
                /*! ./names */
                "./node_modules/imsc/src/main/js/names.js"
              ) : imscNames,
              typeof imscUtils > "u" ? i(
                /*! ./utils */
                "./node_modules/imsc/src/main/js/utils.js"
              ) : imscUtils
            );
          }
        ),
        /***/
        "./node_modules/imsc/src/main/js/utils.js": (
          /*!************************************************!*\
            !*** ./node_modules/imsc/src/main/js/utils.js ***!
            \************************************************/
          /***/
          (c, l) => {
            (function(i) {
              var h = /#([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})?/, f = /rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/, p = /rgba\(\s*(\d+),\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/, d = {
                transparent: [0, 0, 0, 0],
                black: [0, 0, 0, 255],
                silver: [192, 192, 192, 255],
                gray: [128, 128, 128, 255],
                white: [255, 255, 255, 255],
                maroon: [128, 0, 0, 255],
                red: [255, 0, 0, 255],
                purple: [128, 0, 128, 255],
                fuchsia: [255, 0, 255, 255],
                magenta: [255, 0, 255, 255],
                green: [0, 128, 0, 255],
                lime: [0, 255, 0, 255],
                olive: [128, 128, 0, 255],
                yellow: [255, 255, 0, 255],
                navy: [0, 0, 128, 255],
                blue: [0, 0, 255, 255],
                teal: [0, 128, 128, 255],
                aqua: [0, 255, 255, 255],
                cyan: [0, 255, 255, 255]
              };
              i.parseColor = function(g) {
                var m, A = null, b = d[g.toLowerCase()];
                return b !== void 0 ? A = b : (m = h.exec(g)) !== null ? A = [
                  parseInt(m[1], 16),
                  parseInt(m[2], 16),
                  parseInt(m[3], 16),
                  m[4] !== void 0 ? parseInt(m[4], 16) : 255
                ] : (m = f.exec(g)) !== null ? A = [
                  parseInt(m[1]),
                  parseInt(m[2]),
                  parseInt(m[3]),
                  255
                ] : (m = p.exec(g)) !== null && (A = [
                  parseInt(m[1]),
                  parseInt(m[2]),
                  parseInt(m[3]),
                  parseInt(m[4])
                ]), A;
              };
              var v = /^((?:\+|\-)?\d*(?:\.\d+)?)(px|em|c|%)$/;
              i.parseLength = function(g) {
                var m, A = null;
                return (m = v.exec(g)) !== null && (A = { value: parseFloat(m[1]), unit: m[2] }), A;
              };
            })(l);
          }
        ),
        /***/
        "./node_modules/is-alphabetical/index.js": (
          /*!***********************************************!*\
            !*** ./node_modules/is-alphabetical/index.js ***!
            \***********************************************/
          /***/
          (c) => {
            c.exports = l;
            function l(i) {
              var h = typeof i == "string" ? i.charCodeAt(0) : i;
              return h >= 97 && h <= 122 || h >= 65 && h <= 90;
            }
          }
        ),
        /***/
        "./node_modules/is-alphanumerical/index.js": (
          /*!*************************************************!*\
            !*** ./node_modules/is-alphanumerical/index.js ***!
            \*************************************************/
          /***/
          (c, l, i) => {
            var h = i(
              /*! is-alphabetical */
              "./node_modules/is-alphabetical/index.js"
            ), f = i(
              /*! is-decimal */
              "./node_modules/is-decimal/index.js"
            );
            c.exports = p;
            function p(d) {
              return h(d) || f(d);
            }
          }
        ),
        /***/
        "./node_modules/is-decimal/index.js": (
          /*!******************************************!*\
            !*** ./node_modules/is-decimal/index.js ***!
            \******************************************/
          /***/
          (c) => {
            c.exports = l;
            function l(i) {
              var h = typeof i == "string" ? i.charCodeAt(0) : i;
              return h >= 48 && h <= 57;
            }
          }
        ),
        /***/
        "./node_modules/path-browserify/index.js": (
          /*!***********************************************!*\
            !*** ./node_modules/path-browserify/index.js ***!
            \***********************************************/
          /***/
          (c) => {
            function l(p) {
              if (typeof p != "string")
                throw new TypeError("Path must be a string. Received " + JSON.stringify(p));
            }
            function i(p, d) {
              for (var v = "", g = 0, m = -1, A = 0, b, S = 0; S <= p.length; ++S) {
                if (S < p.length)
                  b = p.charCodeAt(S);
                else {
                  if (b === 47)
                    break;
                  b = 47;
                }
                if (b === 47) {
                  if (!(m === S - 1 || A === 1))
                    if (m !== S - 1 && A === 2) {
                      if (v.length < 2 || g !== 2 || v.charCodeAt(v.length - 1) !== 46 || v.charCodeAt(v.length - 2) !== 46) {
                        if (v.length > 2) {
                          var N = v.lastIndexOf("/");
                          if (N !== v.length - 1) {
                            N === -1 ? (v = "", g = 0) : (v = v.slice(0, N), g = v.length - 1 - v.lastIndexOf("/")), m = S, A = 0;
                            continue;
                          }
                        } else if (v.length === 2 || v.length === 1) {
                          v = "", g = 0, m = S, A = 0;
                          continue;
                        }
                      }
                      d && (v.length > 0 ? v += "/.." : v = "..", g = 2);
                    } else
                      v.length > 0 ? v += "/" + p.slice(m + 1, S) : v = p.slice(m + 1, S), g = S - m - 1;
                  m = S, A = 0;
                } else
                  b === 46 && A !== -1 ? ++A : A = -1;
              }
              return v;
            }
            function h(p, d) {
              var v = d.dir || d.root, g = d.base || (d.name || "") + (d.ext || "");
              return v ? v === d.root ? v + g : v + p + g : g;
            }
            var f = {
              // path.resolve([from ...], to)
              resolve: function() {
                for (var d = "", v = !1, g, m = arguments.length - 1; m >= -1 && !v; m--) {
                  var A;
                  m >= 0 ? A = arguments[m] : (g === void 0 && (g = process.cwd()), A = g), l(A), A.length !== 0 && (d = A + "/" + d, v = A.charCodeAt(0) === 47);
                }
                return d = i(d, !v), v ? d.length > 0 ? "/" + d : "/" : d.length > 0 ? d : ".";
              },
              normalize: function(d) {
                if (l(d), d.length === 0)
                  return ".";
                var v = d.charCodeAt(0) === 47, g = d.charCodeAt(d.length - 1) === 47;
                return d = i(d, !v), d.length === 0 && !v && (d = "."), d.length > 0 && g && (d += "/"), v ? "/" + d : d;
              },
              isAbsolute: function(d) {
                return l(d), d.length > 0 && d.charCodeAt(0) === 47;
              },
              join: function() {
                if (arguments.length === 0)
                  return ".";
                for (var d, v = 0; v < arguments.length; ++v) {
                  var g = arguments[v];
                  l(g), g.length > 0 && (d === void 0 ? d = g : d += "/" + g);
                }
                return d === void 0 ? "." : f.normalize(d);
              },
              relative: function(d, v) {
                if (l(d), l(v), d === v || (d = f.resolve(d), v = f.resolve(v), d === v))
                  return "";
                for (var g = 1; g < d.length && d.charCodeAt(g) === 47; ++g)
                  ;
                for (var m = d.length, A = m - g, b = 1; b < v.length && v.charCodeAt(b) === 47; ++b)
                  ;
                for (var S = v.length, N = S - b, T = A < N ? A : N, R = -1, y = 0; y <= T; ++y) {
                  if (y === T) {
                    if (N > T) {
                      if (v.charCodeAt(b + y) === 47)
                        return v.slice(b + y + 1);
                      if (y === 0)
                        return v.slice(b + y);
                    } else
                      A > T && (d.charCodeAt(g + y) === 47 ? R = y : y === 0 && (R = 0));
                    break;
                  }
                  var E = d.charCodeAt(g + y), L = v.charCodeAt(b + y);
                  if (E !== L)
                    break;
                  E === 47 && (R = y);
                }
                var _ = "";
                for (y = g + R + 1; y <= m; ++y)
                  (y === m || d.charCodeAt(y) === 47) && (_.length === 0 ? _ += ".." : _ += "/..");
                return _.length > 0 ? _ + v.slice(b + R) : (b += R, v.charCodeAt(b) === 47 && ++b, v.slice(b));
              },
              _makeLong: function(d) {
                return d;
              },
              dirname: function(d) {
                if (l(d), d.length === 0)
                  return ".";
                for (var v = d.charCodeAt(0), g = v === 47, m = -1, A = !0, b = d.length - 1; b >= 1; --b)
                  if (v = d.charCodeAt(b), v === 47) {
                    if (!A) {
                      m = b;
                      break;
                    }
                  } else
                    A = !1;
                return m === -1 ? g ? "/" : "." : g && m === 1 ? "//" : d.slice(0, m);
              },
              basename: function(d, v) {
                if (v !== void 0 && typeof v != "string")
                  throw new TypeError('"ext" argument must be a string');
                l(d);
                var g = 0, m = -1, A = !0, b;
                if (v !== void 0 && v.length > 0 && v.length <= d.length) {
                  if (v.length === d.length && v === d)
                    return "";
                  var S = v.length - 1, N = -1;
                  for (b = d.length - 1; b >= 0; --b) {
                    var T = d.charCodeAt(b);
                    if (T === 47) {
                      if (!A) {
                        g = b + 1;
                        break;
                      }
                    } else
                      N === -1 && (A = !1, N = b + 1), S >= 0 && (T === v.charCodeAt(S) ? --S === -1 && (m = b) : (S = -1, m = N));
                  }
                  return g === m ? m = N : m === -1 && (m = d.length), d.slice(g, m);
                } else {
                  for (b = d.length - 1; b >= 0; --b)
                    if (d.charCodeAt(b) === 47) {
                      if (!A) {
                        g = b + 1;
                        break;
                      }
                    } else
                      m === -1 && (A = !1, m = b + 1);
                  return m === -1 ? "" : d.slice(g, m);
                }
              },
              extname: function(d) {
                l(d);
                for (var v = -1, g = 0, m = -1, A = !0, b = 0, S = d.length - 1; S >= 0; --S) {
                  var N = d.charCodeAt(S);
                  if (N === 47) {
                    if (!A) {
                      g = S + 1;
                      break;
                    }
                    continue;
                  }
                  m === -1 && (A = !1, m = S + 1), N === 46 ? v === -1 ? v = S : b !== 1 && (b = 1) : v !== -1 && (b = -1);
                }
                return v === -1 || m === -1 || // We saw a non-dot character immediately before the dot
                b === 0 || // The (right-most) trimmed path component is exactly '..'
                b === 1 && v === m - 1 && v === g + 1 ? "" : d.slice(v, m);
              },
              format: function(d) {
                if (d === null || typeof d != "object")
                  throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof d);
                return h("/", d);
              },
              parse: function(d) {
                l(d);
                var v = { root: "", dir: "", base: "", ext: "", name: "" };
                if (d.length === 0)
                  return v;
                var g = d.charCodeAt(0), m = g === 47, A;
                m ? (v.root = "/", A = 1) : A = 0;
                for (var b = -1, S = 0, N = -1, T = !0, R = d.length - 1, y = 0; R >= A; --R) {
                  if (g = d.charCodeAt(R), g === 47) {
                    if (!T) {
                      S = R + 1;
                      break;
                    }
                    continue;
                  }
                  N === -1 && (T = !1, N = R + 1), g === 46 ? b === -1 ? b = R : y !== 1 && (y = 1) : b !== -1 && (y = -1);
                }
                return b === -1 || N === -1 || // We saw a non-dot character immediately before the dot
                y === 0 || // The (right-most) trimmed path component is exactly '..'
                y === 1 && b === N - 1 && b === S + 1 ? N !== -1 && (S === 0 && m ? v.base = v.name = d.slice(1, N) : v.base = v.name = d.slice(S, N)) : (S === 0 && m ? (v.name = d.slice(1, b), v.base = d.slice(1, N)) : (v.name = d.slice(S, b), v.base = d.slice(S, N)), v.ext = d.slice(b, N)), S > 0 ? v.dir = d.slice(0, S - 1) : m && (v.dir = "/"), v;
              },
              sep: "/",
              delimiter: ":",
              win32: null,
              posix: null
            };
            f.posix = f, c.exports = f;
          }
        ),
        /***/
        "./node_modules/safe-buffer/index.js": (
          /*!*******************************************!*\
            !*** ./node_modules/safe-buffer/index.js ***!
            \*******************************************/
          /***/
          (c, l, i) => {
            var h = i(
              /*! buffer */
              "./node_modules/buffer/index.js"
            ), f = h.Buffer;
            function p(v, g) {
              for (var m in v)
                g[m] = v[m];
            }
            f.from && f.alloc && f.allocUnsafe && f.allocUnsafeSlow ? c.exports = h : (p(h, l), l.Buffer = d);
            function d(v, g, m) {
              return f(v, g, m);
            }
            p(f, d), d.from = function(v, g, m) {
              if (typeof v == "number")
                throw new TypeError("Argument must not be a number");
              return f(v, g, m);
            }, d.alloc = function(v, g, m) {
              if (typeof v != "number")
                throw new TypeError("Argument must be a number");
              var A = f(v);
              return g !== void 0 ? typeof m == "string" ? A.fill(g, m) : A.fill(g) : A.fill(0), A;
            }, d.allocUnsafe = function(v) {
              if (typeof v != "number")
                throw new TypeError("Argument must be a number");
              return f(v);
            }, d.allocUnsafeSlow = function(v) {
              if (typeof v != "number")
                throw new TypeError("Argument must be a number");
              return h.SlowBuffer(v);
            };
          }
        ),
        /***/
        "./node_modules/sax/lib/sax.js": (
          /*!*************************************!*\
            !*** ./node_modules/sax/lib/sax.js ***!
            \*************************************/
          /***/
          (c, l, i) => {
            (function(h) {
              h.parser = function(x, P) {
                return new p(x, P);
              }, h.SAXParser = p, h.SAXStream = S, h.createStream = b, h.MAX_BUFFER_LENGTH = 65536;
              var f = [
                "comment",
                "sgmlDecl",
                "textNode",
                "tagName",
                "doctype",
                "procInstName",
                "procInstBody",
                "entity",
                "attribName",
                "attribValue",
                "cdata",
                "script"
              ];
              h.EVENTS = [
                "text",
                "processinginstruction",
                "sgmldeclaration",
                "doctype",
                "comment",
                "opentagstart",
                "attribute",
                "opentag",
                "closetag",
                "opencdata",
                "cdata",
                "closecdata",
                "error",
                "end",
                "ready",
                "script",
                "opennamespace",
                "closenamespace"
              ];
              function p(x, P) {
                if (!(this instanceof p))
                  return new p(x, P);
                var B = this;
                v(B), B.q = B.c = "", B.bufferCheckPosition = h.MAX_BUFFER_LENGTH, B.opt = P || {}, B.opt.lowercase = B.opt.lowercase || B.opt.lowercasetags, B.looseCase = B.opt.lowercase ? "toLowerCase" : "toUpperCase", B.tags = [], B.closed = B.closedRoot = B.sawRoot = !1, B.tag = B.error = null, B.strict = !!x, B.noscript = !!(x || B.opt.noscript), B.state = j.BEGIN, B.strictEntities = B.opt.strictEntities, B.ENTITIES = B.strictEntities ? Object.create(h.XML_ENTITIES) : Object.create(h.ENTITIES), B.attribList = [], B.opt.xmlns && (B.ns = Object.create(M)), B.trackPosition = B.opt.position !== !1, B.trackPosition && (B.position = B.line = B.column = 0), ae(B, "onready");
              }
              Object.create || (Object.create = function(x) {
                function P() {
                }
                P.prototype = x;
                var B = new P();
                return B;
              }), Object.keys || (Object.keys = function(x) {
                var P = [];
                for (var B in x)
                  x.hasOwnProperty(B) && P.push(B);
                return P;
              });
              function d(x) {
                for (var P = Math.max(h.MAX_BUFFER_LENGTH, 10), B = 0, W = 0, X = f.length; W < X; W++) {
                  var K = x[f[W]].length;
                  if (K > P)
                    switch (f[W]) {
                      case "textNode":
                        $(x);
                        break;
                      case "cdata":
                        G(x, "oncdata", x.cdata), x.cdata = "";
                        break;
                      case "script":
                        G(x, "onscript", x.script), x.script = "";
                        break;
                      default:
                        re(x, "Max buffer length exceeded: " + f[W]);
                    }
                  B = Math.max(B, K);
                }
                var U = h.MAX_BUFFER_LENGTH - B;
                x.bufferCheckPosition = U + x.position;
              }
              function v(x) {
                for (var P = 0, B = f.length; P < B; P++)
                  x[f[P]] = "";
              }
              function g(x) {
                $(x), x.cdata !== "" && (G(x, "oncdata", x.cdata), x.cdata = ""), x.script !== "" && (G(x, "onscript", x.script), x.script = "");
              }
              p.prototype = {
                end: function() {
                  ce(this);
                },
                write: ne,
                resume: function() {
                  return this.error = null, this;
                },
                close: function() {
                  return this.write(null);
                },
                flush: function() {
                  g(this);
                }
              };
              var m;
              try {
                m = i(
                  /*! stream */
                  "./node_modules/stream-browserify/index.js"
                ).Stream;
              } catch {
                m = function() {
                };
              }
              var A = h.EVENTS.filter(function(x) {
                return x !== "error" && x !== "end";
              });
              function b(x, P) {
                return new S(x, P);
              }
              function S(x, P) {
                if (!(this instanceof S))
                  return new S(x, P);
                m.apply(this), this._parser = new p(x, P), this.writable = !0, this.readable = !0;
                var B = this;
                this._parser.onend = function() {
                  B.emit("end");
                }, this._parser.onerror = function(W) {
                  B.emit("error", W), B._parser.error = null;
                }, this._decoder = null, A.forEach(function(W) {
                  Object.defineProperty(B, "on" + W, {
                    get: function() {
                      return B._parser["on" + W];
                    },
                    set: function(X) {
                      if (!X)
                        return B.removeAllListeners(W), B._parser["on" + W] = X, X;
                      B.on(W, X);
                    },
                    enumerable: !0,
                    configurable: !1
                  });
                });
              }
              S.prototype = Object.create(m.prototype, {
                constructor: {
                  value: S
                }
              }), S.prototype.write = function(x) {
                if (typeof Buffer == "function" && typeof Buffer.isBuffer == "function" && Buffer.isBuffer(x)) {
                  if (!this._decoder) {
                    var P = i(
                      /*! string_decoder */
                      "./node_modules/string_decoder/lib/string_decoder.js"
                    ).StringDecoder;
                    this._decoder = new P("utf8");
                  }
                  x = this._decoder.write(x);
                }
                return this._parser.write(x.toString()), this.emit("data", x), !0;
              }, S.prototype.end = function(x) {
                return x && x.length && this.write(x), this._parser.end(), !0;
              }, S.prototype.on = function(x, P) {
                var B = this;
                return !B._parser["on" + x] && A.indexOf(x) !== -1 && (B._parser["on" + x] = function() {
                  var W = arguments.length === 1 ? [arguments[0]] : Array.apply(null, arguments);
                  W.splice(0, 0, x), B.emit.apply(B, W);
                }), m.prototype.on.call(B, x, P);
              };
              var N = `\r
	 `, T = "0124356789", R = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ", y = `'"`, E = N + ">", L = "[CDATA[", _ = "DOCTYPE", O = "http://www.w3.org/XML/1998/namespace", D = "http://www.w3.org/2000/xmlns/", M = { xml: O, xmlns: D };
              N = k(N), T = k(T), R = k(R);
              var C = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, I = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040\.\d-]/, w = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, F = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040\.\d-]/;
              y = k(y), E = k(E);
              function k(x) {
                return x.split("").reduce(function(P, B) {
                  return P[B] = !0, P;
                }, {});
              }
              function H(x) {
                return Object.prototype.toString.call(x) === "[object RegExp]";
              }
              function Z(x, P) {
                return H(x) ? !!P.match(x) : x[P];
              }
              function Y(x, P) {
                return !Z(x, P);
              }
              var j = 0;
              h.STATE = {
                BEGIN: j++,
                // leading byte order mark or whitespace
                BEGIN_WHITESPACE: j++,
                // leading whitespace
                TEXT: j++,
                // general stuff
                TEXT_ENTITY: j++,
                // &amp and such.
                OPEN_WAKA: j++,
                // <
                SGML_DECL: j++,
                // <!BLARG
                SGML_DECL_QUOTED: j++,
                // <!BLARG foo "bar
                DOCTYPE: j++,
                // <!DOCTYPE
                DOCTYPE_QUOTED: j++,
                // <!DOCTYPE "//blah
                DOCTYPE_DTD: j++,
                // <!DOCTYPE "//blah" [ ...
                DOCTYPE_DTD_QUOTED: j++,
                // <!DOCTYPE "//blah" [ "foo
                COMMENT_STARTING: j++,
                // <!-
                COMMENT: j++,
                // <!--
                COMMENT_ENDING: j++,
                // <!-- blah -
                COMMENT_ENDED: j++,
                // <!-- blah --
                CDATA: j++,
                // <![CDATA[ something
                CDATA_ENDING: j++,
                // ]
                CDATA_ENDING_2: j++,
                // ]]
                PROC_INST: j++,
                // <?hi
                PROC_INST_BODY: j++,
                // <?hi there
                PROC_INST_ENDING: j++,
                // <?hi "there" ?
                OPEN_TAG: j++,
                // <strong
                OPEN_TAG_SLASH: j++,
                // <strong /
                ATTRIB: j++,
                // <a
                ATTRIB_NAME: j++,
                // <a foo
                ATTRIB_NAME_SAW_WHITE: j++,
                // <a foo _
                ATTRIB_VALUE: j++,
                // <a foo=
                ATTRIB_VALUE_QUOTED: j++,
                // <a foo="bar
                ATTRIB_VALUE_CLOSED: j++,
                // <a foo="bar"
                ATTRIB_VALUE_UNQUOTED: j++,
                // <a foo=bar
                ATTRIB_VALUE_ENTITY_Q: j++,
                // <foo bar="&quot;"
                ATTRIB_VALUE_ENTITY_U: j++,
                // <foo bar=&quot
                CLOSE_TAG: j++,
                // </a
                CLOSE_TAG_SAW_WHITE: j++,
                // </a   >
                SCRIPT: j++,
                // <script> ...
                SCRIPT_ENDING: j++
                // <script> ... <
              }, h.XML_ENTITIES = {
                amp: "&",
                gt: ">",
                lt: "<",
                quot: '"',
                apos: "'"
              }, h.ENTITIES = {
                amp: "&",
                gt: ">",
                lt: "<",
                quot: '"',
                apos: "'",
                AElig: 198,
                Aacute: 193,
                Acirc: 194,
                Agrave: 192,
                Aring: 197,
                Atilde: 195,
                Auml: 196,
                Ccedil: 199,
                ETH: 208,
                Eacute: 201,
                Ecirc: 202,
                Egrave: 200,
                Euml: 203,
                Iacute: 205,
                Icirc: 206,
                Igrave: 204,
                Iuml: 207,
                Ntilde: 209,
                Oacute: 211,
                Ocirc: 212,
                Ograve: 210,
                Oslash: 216,
                Otilde: 213,
                Ouml: 214,
                THORN: 222,
                Uacute: 218,
                Ucirc: 219,
                Ugrave: 217,
                Uuml: 220,
                Yacute: 221,
                aacute: 225,
                acirc: 226,
                aelig: 230,
                agrave: 224,
                aring: 229,
                atilde: 227,
                auml: 228,
                ccedil: 231,
                eacute: 233,
                ecirc: 234,
                egrave: 232,
                eth: 240,
                euml: 235,
                iacute: 237,
                icirc: 238,
                igrave: 236,
                iuml: 239,
                ntilde: 241,
                oacute: 243,
                ocirc: 244,
                ograve: 242,
                oslash: 248,
                otilde: 245,
                ouml: 246,
                szlig: 223,
                thorn: 254,
                uacute: 250,
                ucirc: 251,
                ugrave: 249,
                uuml: 252,
                yacute: 253,
                yuml: 255,
                copy: 169,
                reg: 174,
                nbsp: 160,
                iexcl: 161,
                cent: 162,
                pound: 163,
                curren: 164,
                yen: 165,
                brvbar: 166,
                sect: 167,
                uml: 168,
                ordf: 170,
                laquo: 171,
                not: 172,
                shy: 173,
                macr: 175,
                deg: 176,
                plusmn: 177,
                sup1: 185,
                sup2: 178,
                sup3: 179,
                acute: 180,
                micro: 181,
                para: 182,
                middot: 183,
                cedil: 184,
                ordm: 186,
                raquo: 187,
                frac14: 188,
                frac12: 189,
                frac34: 190,
                iquest: 191,
                times: 215,
                divide: 247,
                OElig: 338,
                oelig: 339,
                Scaron: 352,
                scaron: 353,
                Yuml: 376,
                fnof: 402,
                circ: 710,
                tilde: 732,
                Alpha: 913,
                Beta: 914,
                Gamma: 915,
                Delta: 916,
                Epsilon: 917,
                Zeta: 918,
                Eta: 919,
                Theta: 920,
                Iota: 921,
                Kappa: 922,
                Lambda: 923,
                Mu: 924,
                Nu: 925,
                Xi: 926,
                Omicron: 927,
                Pi: 928,
                Rho: 929,
                Sigma: 931,
                Tau: 932,
                Upsilon: 933,
                Phi: 934,
                Chi: 935,
                Psi: 936,
                Omega: 937,
                alpha: 945,
                beta: 946,
                gamma: 947,
                delta: 948,
                epsilon: 949,
                zeta: 950,
                eta: 951,
                theta: 952,
                iota: 953,
                kappa: 954,
                lambda: 955,
                mu: 956,
                nu: 957,
                xi: 958,
                omicron: 959,
                pi: 960,
                rho: 961,
                sigmaf: 962,
                sigma: 963,
                tau: 964,
                upsilon: 965,
                phi: 966,
                chi: 967,
                psi: 968,
                omega: 969,
                thetasym: 977,
                upsih: 978,
                piv: 982,
                ensp: 8194,
                emsp: 8195,
                thinsp: 8201,
                zwnj: 8204,
                zwj: 8205,
                lrm: 8206,
                rlm: 8207,
                ndash: 8211,
                mdash: 8212,
                lsquo: 8216,
                rsquo: 8217,
                sbquo: 8218,
                ldquo: 8220,
                rdquo: 8221,
                bdquo: 8222,
                dagger: 8224,
                Dagger: 8225,
                bull: 8226,
                hellip: 8230,
                permil: 8240,
                prime: 8242,
                Prime: 8243,
                lsaquo: 8249,
                rsaquo: 8250,
                oline: 8254,
                frasl: 8260,
                euro: 8364,
                image: 8465,
                weierp: 8472,
                real: 8476,
                trade: 8482,
                alefsym: 8501,
                larr: 8592,
                uarr: 8593,
                rarr: 8594,
                darr: 8595,
                harr: 8596,
                crarr: 8629,
                lArr: 8656,
                uArr: 8657,
                rArr: 8658,
                dArr: 8659,
                hArr: 8660,
                forall: 8704,
                part: 8706,
                exist: 8707,
                empty: 8709,
                nabla: 8711,
                isin: 8712,
                notin: 8713,
                ni: 8715,
                prod: 8719,
                sum: 8721,
                minus: 8722,
                lowast: 8727,
                radic: 8730,
                prop: 8733,
                infin: 8734,
                ang: 8736,
                and: 8743,
                or: 8744,
                cap: 8745,
                cup: 8746,
                int: 8747,
                there4: 8756,
                sim: 8764,
                cong: 8773,
                asymp: 8776,
                ne: 8800,
                equiv: 8801,
                le: 8804,
                ge: 8805,
                sub: 8834,
                sup: 8835,
                nsub: 8836,
                sube: 8838,
                supe: 8839,
                oplus: 8853,
                otimes: 8855,
                perp: 8869,
                sdot: 8901,
                lceil: 8968,
                rceil: 8969,
                lfloor: 8970,
                rfloor: 8971,
                lang: 9001,
                rang: 9002,
                loz: 9674,
                spades: 9824,
                clubs: 9827,
                hearts: 9829,
                diams: 9830
              }, Object.keys(h.ENTITIES).forEach(function(x) {
                var P = h.ENTITIES[x], B = typeof P == "number" ? String.fromCharCode(P) : P;
                h.ENTITIES[x] = B;
              });
              for (var J in h.STATE)
                h.STATE[h.STATE[J]] = J;
              j = h.STATE;
              function ae(x, P, B) {
                x[P] && x[P](B);
              }
              function G(x, P, B) {
                x.textNode && $(x), ae(x, P, B);
              }
              function $(x) {
                x.textNode = ie(x.opt, x.textNode), x.textNode && ae(x, "ontext", x.textNode), x.textNode = "";
              }
              function ie(x, P) {
                return x.trim && (P = P.trim()), x.normalize && (P = P.replace(/\s+/g, " ")), P;
              }
              function re(x, P) {
                return $(x), x.trackPosition && (P += `
Line: ` + x.line + `
Column: ` + x.column + `
Char: ` + x.c), P = new Error(P), x.error = P, ae(x, "onerror", P), x;
              }
              function ce(x) {
                return x.sawRoot && !x.closedRoot && z(x, "Unclosed root tag"), x.state !== j.BEGIN && x.state !== j.BEGIN_WHITESPACE && x.state !== j.TEXT && re(x, "Unexpected end"), $(x), x.c = "", x.closed = !0, ae(x, "onend"), p.call(x, x.strict, x.opt), x;
              }
              function z(x, P) {
                if (typeof x != "object" || !(x instanceof p))
                  throw new Error("bad call to strictFail");
                x.strict && re(x, P);
              }
              function oe(x) {
                x.strict || (x.tagName = x.tagName[x.looseCase]());
                var P = x.tags[x.tags.length - 1] || x, B = x.tag = { name: x.tagName, attributes: {} };
                x.opt.xmlns && (B.ns = P.ns), x.attribList.length = 0, G(x, "onopentagstart", B);
              }
              function de(x, P) {
                var B = x.indexOf(":"), W = B < 0 ? ["", x] : x.split(":"), X = W[0], K = W[1];
                return P && x === "xmlns" && (X = "xmlns", K = ""), { prefix: X, local: K };
              }
              function pe(x) {
                if (x.strict || (x.attribName = x.attribName[x.looseCase]()), x.attribList.indexOf(x.attribName) !== -1 || x.tag.attributes.hasOwnProperty(x.attribName)) {
                  x.attribName = x.attribValue = "";
                  return;
                }
                if (x.opt.xmlns) {
                  var P = de(x.attribName, !0), B = P.prefix, W = P.local;
                  if (B === "xmlns")
                    if (W === "xml" && x.attribValue !== O)
                      z(
                        x,
                        "xml: prefix must be bound to " + O + `
Actual: ` + x.attribValue
                      );
                    else if (W === "xmlns" && x.attribValue !== D)
                      z(
                        x,
                        "xmlns: prefix must be bound to " + D + `
Actual: ` + x.attribValue
                      );
                    else {
                      var X = x.tag, K = x.tags[x.tags.length - 1] || x;
                      X.ns === K.ns && (X.ns = Object.create(K.ns)), X.ns[W] = x.attribValue;
                    }
                  x.attribList.push([x.attribName, x.attribValue]);
                } else
                  x.tag.attributes[x.attribName] = x.attribValue, G(x, "onattribute", {
                    name: x.attribName,
                    value: x.attribValue
                  });
                x.attribName = x.attribValue = "";
              }
              function he(x, P) {
                if (x.opt.xmlns) {
                  var B = x.tag, W = de(x.tagName);
                  B.prefix = W.prefix, B.local = W.local, B.uri = B.ns[W.prefix] || "", B.prefix && !B.uri && (z(x, "Unbound namespace prefix: " + JSON.stringify(x.tagName)), B.uri = W.prefix);
                  var X = x.tags[x.tags.length - 1] || x;
                  B.ns && X.ns !== B.ns && Object.keys(B.ns).forEach(function(Ee) {
                    G(x, "onopennamespace", {
                      prefix: Ee,
                      uri: B.ns[Ee]
                    });
                  });
                  for (var K = 0, U = x.attribList.length; K < U; K++) {
                    var V = x.attribList[K], Q = V[0], fe = V[1], ue = de(Q, !0), q = ue.prefix, _e = ue.local, ge = q === "" ? "" : B.ns[q] || "", Ce = {
                      name: Q,
                      value: fe,
                      prefix: q,
                      local: _e,
                      uri: ge
                    };
                    q && q !== "xmlns" && !ge && (z(x, "Unbound namespace prefix: " + JSON.stringify(q)), Ce.uri = q), x.tag.attributes[Q] = Ce, G(x, "onattribute", Ce);
                  }
                  x.attribList.length = 0;
                }
                x.tag.isSelfClosing = !!P, x.sawRoot = !0, x.tags.push(x.tag), G(x, "onopentag", x.tag), P || (!x.noscript && x.tagName.toLowerCase() === "script" ? x.state = j.SCRIPT : x.state = j.TEXT, x.tag = null, x.tagName = ""), x.attribName = x.attribValue = "", x.attribList.length = 0;
              }
              function se(x) {
                if (!x.tagName) {
                  z(x, "Weird empty close tag."), x.textNode += "</>", x.state = j.TEXT;
                  return;
                }
                if (x.script) {
                  if (x.tagName !== "script") {
                    x.script += "</" + x.tagName + ">", x.tagName = "", x.state = j.SCRIPT;
                    return;
                  }
                  G(x, "onscript", x.script), x.script = "";
                }
                var P = x.tags.length, B = x.tagName;
                x.strict || (B = B[x.looseCase]());
                for (var W = B; P--; ) {
                  var X = x.tags[P];
                  if (X.name !== W)
                    z(x, "Unexpected close tag");
                  else
                    break;
                }
                if (P < 0) {
                  z(x, "Unmatched closing tag: " + x.tagName), x.textNode += "</" + x.tagName + ">", x.state = j.TEXT;
                  return;
                }
                x.tagName = B;
                for (var K = x.tags.length; K-- > P; ) {
                  var U = x.tag = x.tags.pop();
                  x.tagName = x.tag.name, G(x, "onclosetag", x.tagName);
                  var V = {};
                  for (var Q in U.ns)
                    V[Q] = U.ns[Q];
                  var fe = x.tags[x.tags.length - 1] || x;
                  x.opt.xmlns && U.ns !== fe.ns && Object.keys(U.ns).forEach(function(ue) {
                    var q = U.ns[ue];
                    G(x, "onclosenamespace", { prefix: ue, uri: q });
                  });
                }
                P === 0 && (x.closedRoot = !0), x.tagName = x.attribValue = x.attribName = "", x.attribList.length = 0, x.state = j.TEXT;
              }
              function ee(x) {
                var P = x.entity, B = P.toLowerCase(), W, X = "";
                return x.ENTITIES[P] ? x.ENTITIES[P] : x.ENTITIES[B] ? x.ENTITIES[B] : (P = B, P.charAt(0) === "#" && (P.charAt(1) === "x" ? (P = P.slice(2), W = parseInt(P, 16), X = W.toString(16)) : (P = P.slice(1), W = parseInt(P, 10), X = W.toString(10))), P = P.replace(/^0+/, ""), X.toLowerCase() !== P ? (z(x, "Invalid character entity"), "&" + x.entity + ";") : String.fromCodePoint(W));
              }
              function te(x, P) {
                P === "<" ? (x.state = j.OPEN_WAKA, x.startTagPosition = x.position) : Y(N, P) && (z(x, "Non-whitespace before first tag."), x.textNode = P, x.state = j.TEXT);
              }
              function le(x, P) {
                var B = "";
                return P < x.length && (B = x.charAt(P)), B;
              }
              function ne(x) {
                var P = this;
                if (this.error)
                  throw this.error;
                if (P.closed)
                  return re(
                    P,
                    "Cannot write after close. Assign an onready handler."
                  );
                if (x === null)
                  return ce(P);
                typeof x == "object" && (x = x.toString());
                for (var B = 0, W = ""; W = le(x, B++), P.c = W, !!W; )
                  switch (P.trackPosition && (P.position++, W === `
` ? (P.line++, P.column = 0) : P.column++), P.state) {
                    case j.BEGIN:
                      if (P.state = j.BEGIN_WHITESPACE, W === "\uFEFF")
                        continue;
                      te(P, W);
                      continue;
                    case j.BEGIN_WHITESPACE:
                      te(P, W);
                      continue;
                    case j.TEXT:
                      if (P.sawRoot && !P.closedRoot) {
                        for (var X = B - 1; W && W !== "<" && W !== "&"; )
                          W = le(x, B++), W && P.trackPosition && (P.position++, W === `
` ? (P.line++, P.column = 0) : P.column++);
                        P.textNode += x.substring(X, B - 1);
                      }
                      W === "<" && !(P.sawRoot && P.closedRoot && !P.strict) ? (P.state = j.OPEN_WAKA, P.startTagPosition = P.position) : (Y(N, W) && (!P.sawRoot || P.closedRoot) && z(P, "Text data outside of root node."), W === "&" ? P.state = j.TEXT_ENTITY : P.textNode += W);
                      continue;
                    case j.SCRIPT:
                      W === "<" ? P.state = j.SCRIPT_ENDING : P.script += W;
                      continue;
                    case j.SCRIPT_ENDING:
                      W === "/" ? P.state = j.CLOSE_TAG : (P.script += "<" + W, P.state = j.SCRIPT);
                      continue;
                    case j.OPEN_WAKA:
                      if (W === "!")
                        P.state = j.SGML_DECL, P.sgmlDecl = "";
                      else if (!Z(N, W))
                        if (Z(C, W))
                          P.state = j.OPEN_TAG, P.tagName = W;
                        else if (W === "/")
                          P.state = j.CLOSE_TAG, P.tagName = "";
                        else if (W === "?")
                          P.state = j.PROC_INST, P.procInstName = P.procInstBody = "";
                        else {
                          if (z(P, "Unencoded <"), P.startTagPosition + 1 < P.position) {
                            var K = P.position - P.startTagPosition;
                            W = new Array(K).join(" ") + W;
                          }
                          P.textNode += "<" + W, P.state = j.TEXT;
                        }
                      continue;
                    case j.SGML_DECL:
                      (P.sgmlDecl + W).toUpperCase() === L ? (G(P, "onopencdata"), P.state = j.CDATA, P.sgmlDecl = "", P.cdata = "") : P.sgmlDecl + W === "--" ? (P.state = j.COMMENT, P.comment = "", P.sgmlDecl = "") : (P.sgmlDecl + W).toUpperCase() === _ ? (P.state = j.DOCTYPE, (P.doctype || P.sawRoot) && z(
                        P,
                        "Inappropriately located doctype declaration"
                      ), P.doctype = "", P.sgmlDecl = "") : W === ">" ? (G(P, "onsgmldeclaration", P.sgmlDecl), P.sgmlDecl = "", P.state = j.TEXT) : (Z(y, W) && (P.state = j.SGML_DECL_QUOTED), P.sgmlDecl += W);
                      continue;
                    case j.SGML_DECL_QUOTED:
                      W === P.q && (P.state = j.SGML_DECL, P.q = ""), P.sgmlDecl += W;
                      continue;
                    case j.DOCTYPE:
                      W === ">" ? (P.state = j.TEXT, G(P, "ondoctype", P.doctype), P.doctype = !0) : (P.doctype += W, W === "[" ? P.state = j.DOCTYPE_DTD : Z(y, W) && (P.state = j.DOCTYPE_QUOTED, P.q = W));
                      continue;
                    case j.DOCTYPE_QUOTED:
                      P.doctype += W, W === P.q && (P.q = "", P.state = j.DOCTYPE);
                      continue;
                    case j.DOCTYPE_DTD:
                      P.doctype += W, W === "]" ? P.state = j.DOCTYPE : Z(y, W) && (P.state = j.DOCTYPE_DTD_QUOTED, P.q = W);
                      continue;
                    case j.DOCTYPE_DTD_QUOTED:
                      P.doctype += W, W === P.q && (P.state = j.DOCTYPE_DTD, P.q = "");
                      continue;
                    case j.COMMENT:
                      W === "-" ? P.state = j.COMMENT_ENDING : P.comment += W;
                      continue;
                    case j.COMMENT_ENDING:
                      W === "-" ? (P.state = j.COMMENT_ENDED, P.comment = ie(P.opt, P.comment), P.comment && G(P, "oncomment", P.comment), P.comment = "") : (P.comment += "-" + W, P.state = j.COMMENT);
                      continue;
                    case j.COMMENT_ENDED:
                      W !== ">" ? (z(P, "Malformed comment"), P.comment += "--" + W, P.state = j.COMMENT) : P.state = j.TEXT;
                      continue;
                    case j.CDATA:
                      W === "]" ? P.state = j.CDATA_ENDING : P.cdata += W;
                      continue;
                    case j.CDATA_ENDING:
                      W === "]" ? P.state = j.CDATA_ENDING_2 : (P.cdata += "]" + W, P.state = j.CDATA);
                      continue;
                    case j.CDATA_ENDING_2:
                      W === ">" ? (P.cdata && G(P, "oncdata", P.cdata), G(P, "onclosecdata"), P.cdata = "", P.state = j.TEXT) : W === "]" ? P.cdata += "]" : (P.cdata += "]]" + W, P.state = j.CDATA);
                      continue;
                    case j.PROC_INST:
                      W === "?" ? P.state = j.PROC_INST_ENDING : Z(N, W) ? P.state = j.PROC_INST_BODY : P.procInstName += W;
                      continue;
                    case j.PROC_INST_BODY:
                      if (!P.procInstBody && Z(N, W))
                        continue;
                      W === "?" ? P.state = j.PROC_INST_ENDING : P.procInstBody += W;
                      continue;
                    case j.PROC_INST_ENDING:
                      W === ">" ? (G(P, "onprocessinginstruction", {
                        name: P.procInstName,
                        body: P.procInstBody
                      }), P.procInstName = P.procInstBody = "", P.state = j.TEXT) : (P.procInstBody += "?" + W, P.state = j.PROC_INST_BODY);
                      continue;
                    case j.OPEN_TAG:
                      Z(I, W) ? P.tagName += W : (oe(P), W === ">" ? he(P) : W === "/" ? P.state = j.OPEN_TAG_SLASH : (Y(N, W) && z(P, "Invalid character in tag name"), P.state = j.ATTRIB));
                      continue;
                    case j.OPEN_TAG_SLASH:
                      W === ">" ? (he(P, !0), se(P)) : (z(P, "Forward-slash in opening tag not followed by >"), P.state = j.ATTRIB);
                      continue;
                    case j.ATTRIB:
                      if (Z(N, W))
                        continue;
                      W === ">" ? he(P) : W === "/" ? P.state = j.OPEN_TAG_SLASH : Z(C, W) ? (P.attribName = W, P.attribValue = "", P.state = j.ATTRIB_NAME) : z(P, "Invalid attribute name");
                      continue;
                    case j.ATTRIB_NAME:
                      W === "=" ? P.state = j.ATTRIB_VALUE : W === ">" ? (z(P, "Attribute without value"), P.attribValue = P.attribName, pe(P), he(P)) : Z(N, W) ? P.state = j.ATTRIB_NAME_SAW_WHITE : Z(I, W) ? P.attribName += W : z(P, "Invalid attribute name");
                      continue;
                    case j.ATTRIB_NAME_SAW_WHITE:
                      if (W === "=")
                        P.state = j.ATTRIB_VALUE;
                      else {
                        if (Z(N, W))
                          continue;
                        z(P, "Attribute without value"), P.tag.attributes[P.attribName] = "", P.attribValue = "", G(P, "onattribute", {
                          name: P.attribName,
                          value: ""
                        }), P.attribName = "", W === ">" ? he(P) : Z(C, W) ? (P.attribName = W, P.state = j.ATTRIB_NAME) : (z(P, "Invalid attribute name"), P.state = j.ATTRIB);
                      }
                      continue;
                    case j.ATTRIB_VALUE:
                      if (Z(N, W))
                        continue;
                      Z(y, W) ? (P.q = W, P.state = j.ATTRIB_VALUE_QUOTED) : (z(P, "Unquoted attribute value"), P.state = j.ATTRIB_VALUE_UNQUOTED, P.attribValue = W);
                      continue;
                    case j.ATTRIB_VALUE_QUOTED:
                      if (W !== P.q) {
                        W === "&" ? P.state = j.ATTRIB_VALUE_ENTITY_Q : P.attribValue += W;
                        continue;
                      }
                      pe(P), P.q = "", P.state = j.ATTRIB_VALUE_CLOSED;
                      continue;
                    case j.ATTRIB_VALUE_CLOSED:
                      Z(N, W) ? P.state = j.ATTRIB : W === ">" ? he(P) : W === "/" ? P.state = j.OPEN_TAG_SLASH : Z(C, W) ? (z(P, "No whitespace between attributes"), P.attribName = W, P.attribValue = "", P.state = j.ATTRIB_NAME) : z(P, "Invalid attribute name");
                      continue;
                    case j.ATTRIB_VALUE_UNQUOTED:
                      if (Y(E, W)) {
                        W === "&" ? P.state = j.ATTRIB_VALUE_ENTITY_U : P.attribValue += W;
                        continue;
                      }
                      pe(P), W === ">" ? he(P) : P.state = j.ATTRIB;
                      continue;
                    case j.CLOSE_TAG:
                      if (P.tagName)
                        W === ">" ? se(P) : Z(I, W) ? P.tagName += W : P.script ? (P.script += "</" + P.tagName, P.tagName = "", P.state = j.SCRIPT) : (Y(N, W) && z(P, "Invalid tagname in closing tag"), P.state = j.CLOSE_TAG_SAW_WHITE);
                      else {
                        if (Z(N, W))
                          continue;
                        Y(C, W) ? P.script ? (P.script += "</" + W, P.state = j.SCRIPT) : z(P, "Invalid tagname in closing tag.") : P.tagName = W;
                      }
                      continue;
                    case j.CLOSE_TAG_SAW_WHITE:
                      if (Z(N, W))
                        continue;
                      W === ">" ? se(P) : z(P, "Invalid characters in closing tag");
                      continue;
                    case j.TEXT_ENTITY:
                    case j.ATTRIB_VALUE_ENTITY_Q:
                    case j.ATTRIB_VALUE_ENTITY_U:
                      var U, V;
                      switch (P.state) {
                        case j.TEXT_ENTITY:
                          U = j.TEXT, V = "textNode";
                          break;
                        case j.ATTRIB_VALUE_ENTITY_Q:
                          U = j.ATTRIB_VALUE_QUOTED, V = "attribValue";
                          break;
                        case j.ATTRIB_VALUE_ENTITY_U:
                          U = j.ATTRIB_VALUE_UNQUOTED, V = "attribValue";
                          break;
                      }
                      W === ";" ? (P[V] += ee(P), P.entity = "", P.state = U) : Z(P.entity.length ? F : w, W) ? P.entity += W : (z(P, "Invalid character in entity name"), P[V] += "&" + P.entity + W, P.entity = "", P.state = U);
                      continue;
                    default:
                      throw new Error(P, "Unknown state: " + P.state);
                  }
                return P.position >= P.bufferCheckPosition && d(P), P;
              }
              /*! http://mths.be/fromcodepoint v0.1.0 by @mathias */
              String.fromCodePoint || function() {
                var x = String.fromCharCode, P = Math.floor, B = function() {
                  var W = 16384, X = [], K, U, V = -1, Q = arguments.length;
                  if (!Q)
                    return "";
                  for (var fe = ""; ++V < Q; ) {
                    var ue = Number(arguments[V]);
                    if (!isFinite(ue) || // `NaN`, `+Infinity`, or `-Infinity`
                    ue < 0 || // not a valid Unicode code point
                    ue > 1114111 || // not a valid Unicode code point
                    P(ue) !== ue)
                      throw RangeError("Invalid code point: " + ue);
                    ue <= 65535 ? X.push(ue) : (ue -= 65536, K = (ue >> 10) + 55296, U = ue % 1024 + 56320, X.push(K, U)), (V + 1 === Q || X.length > W) && (fe += x.apply(null, X), X.length = 0);
                  }
                  return fe;
                };
                Object.defineProperty ? Object.defineProperty(String, "fromCodePoint", {
                  value: B,
                  configurable: !0,
                  writable: !0
                }) : String.fromCodePoint = B;
              }();
            })(l);
          }
        ),
        /***/
        "./node_modules/stream-browserify/index.js": (
          /*!*************************************************!*\
            !*** ./node_modules/stream-browserify/index.js ***!
            \*************************************************/
          /***/
          (c, l, i) => {
            c.exports = p;
            var h = i(
              /*! events */
              "./node_modules/events/events.js"
            ).EventEmitter, f = i(
              /*! inherits */
              "./node_modules/stream-browserify/node_modules/inherits/inherits_browser.js"
            );
            f(p, h), p.Readable = i(
              /*! readable-stream/lib/_stream_readable.js */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_readable.js"
            ), p.Writable = i(
              /*! readable-stream/lib/_stream_writable.js */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_writable.js"
            ), p.Duplex = i(
              /*! readable-stream/lib/_stream_duplex.js */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_duplex.js"
            ), p.Transform = i(
              /*! readable-stream/lib/_stream_transform.js */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_transform.js"
            ), p.PassThrough = i(
              /*! readable-stream/lib/_stream_passthrough.js */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_passthrough.js"
            ), p.finished = i(
              /*! readable-stream/lib/internal/streams/end-of-stream.js */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/end-of-stream.js"
            ), p.pipeline = i(
              /*! readable-stream/lib/internal/streams/pipeline.js */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/pipeline.js"
            ), p.Stream = p;
            function p() {
              h.call(this);
            }
            p.prototype.pipe = function(d, v) {
              var g = this;
              function m(y) {
                d.writable && d.write(y) === !1 && g.pause && g.pause();
              }
              g.on("data", m);
              function A() {
                g.readable && g.resume && g.resume();
              }
              d.on("drain", A), !d._isStdio && (!v || v.end !== !1) && (g.on("end", S), g.on("close", N));
              var b = !1;
              function S() {
                b || (b = !0, d.end());
              }
              function N() {
                b || (b = !0, typeof d.destroy == "function" && d.destroy());
              }
              function T(y) {
                if (R(), h.listenerCount(this, "error") === 0)
                  throw y;
              }
              g.on("error", T), d.on("error", T);
              function R() {
                g.removeListener("data", m), d.removeListener("drain", A), g.removeListener("end", S), g.removeListener("close", N), g.removeListener("error", T), d.removeListener("error", T), g.removeListener("end", R), g.removeListener("close", R), d.removeListener("close", R);
              }
              return g.on("end", R), g.on("close", R), d.on("close", R), d.emit("pipe", g), d;
            };
          }
        ),
        /***/
        "./node_modules/stream-browserify/node_modules/inherits/inherits_browser.js": (
          /*!**********************************************************************************!*\
            !*** ./node_modules/stream-browserify/node_modules/inherits/inherits_browser.js ***!
            \**********************************************************************************/
          /***/
          (c) => {
            typeof Object.create == "function" ? c.exports = function(i, h) {
              h && (i.super_ = h, i.prototype = Object.create(h.prototype, {
                constructor: {
                  value: i,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0
                }
              }));
            } : c.exports = function(i, h) {
              if (h) {
                i.super_ = h;
                var f = function() {
                };
                f.prototype = h.prototype, i.prototype = new f(), i.prototype.constructor = i;
              }
            };
          }
        ),
        /***/
        "./node_modules/stream-browserify/node_modules/readable-stream/errors-browser.js": (
          /*!***************************************************************************************!*\
            !*** ./node_modules/stream-browserify/node_modules/readable-stream/errors-browser.js ***!
            \***************************************************************************************/
          /***/
          (c) => {
            function l(g, m) {
              g.prototype = Object.create(m.prototype), g.prototype.constructor = g, g.__proto__ = m;
            }
            var i = {};
            function h(g, m, A) {
              A || (A = Error);
              function b(N, T, R) {
                return typeof m == "string" ? m : m(N, T, R);
              }
              var S = /* @__PURE__ */ function(N) {
                l(T, N);
                function T(R, y, E) {
                  return N.call(this, b(R, y, E)) || this;
                }
                return T;
              }(A);
              S.prototype.name = A.name, S.prototype.code = g, i[g] = S;
            }
            function f(g, m) {
              if (Array.isArray(g)) {
                var A = g.length;
                return g = g.map(function(b) {
                  return String(b);
                }), A > 2 ? "one of ".concat(m, " ").concat(g.slice(0, A - 1).join(", "), ", or ") + g[A - 1] : A === 2 ? "one of ".concat(m, " ").concat(g[0], " or ").concat(g[1]) : "of ".concat(m, " ").concat(g[0]);
              } else
                return "of ".concat(m, " ").concat(String(g));
            }
            function p(g, m, A) {
              return g.substr(!A || A < 0 ? 0 : +A, m.length) === m;
            }
            function d(g, m, A) {
              return (A === void 0 || A > g.length) && (A = g.length), g.substring(A - m.length, A) === m;
            }
            function v(g, m, A) {
              return typeof A != "number" && (A = 0), A + m.length > g.length ? !1 : g.indexOf(m, A) !== -1;
            }
            h("ERR_INVALID_OPT_VALUE", function(g, m) {
              return 'The value "' + m + '" is invalid for option "' + g + '"';
            }, TypeError), h("ERR_INVALID_ARG_TYPE", function(g, m, A) {
              var b;
              typeof m == "string" && p(m, "not ") ? (b = "must not be", m = m.replace(/^not /, "")) : b = "must be";
              var S;
              if (d(g, " argument"))
                S = "The ".concat(g, " ").concat(b, " ").concat(f(m, "type"));
              else {
                var N = v(g, ".") ? "property" : "argument";
                S = 'The "'.concat(g, '" ').concat(N, " ").concat(b, " ").concat(f(m, "type"));
              }
              return S += ". Received type ".concat(typeof A), S;
            }, TypeError), h("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), h("ERR_METHOD_NOT_IMPLEMENTED", function(g) {
              return "The " + g + " method is not implemented";
            }), h("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), h("ERR_STREAM_DESTROYED", function(g) {
              return "Cannot call " + g + " after a stream was destroyed";
            }), h("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), h("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), h("ERR_STREAM_WRITE_AFTER_END", "write after end"), h("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), h("ERR_UNKNOWN_ENCODING", function(g) {
              return "Unknown encoding: " + g;
            }, TypeError), h("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), c.exports.codes = i;
          }
        ),
        /***/
        "./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_duplex.js": (
          /*!*******************************************************************************************!*\
            !*** ./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_duplex.js ***!
            \*******************************************************************************************/
          /***/
          (c, l, i) => {
            var h = Object.keys || function(S) {
              var N = [];
              for (var T in S)
                N.push(T);
              return N;
            };
            c.exports = m;
            var f = i(
              /*! ./_stream_readable */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_readable.js"
            ), p = i(
              /*! ./_stream_writable */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_writable.js"
            );
            i(
              /*! inherits */
              "./node_modules/stream-browserify/node_modules/inherits/inherits_browser.js"
            )(m, f);
            for (var d = h(p.prototype), v = 0; v < d.length; v++) {
              var g = d[v];
              m.prototype[g] || (m.prototype[g] = p.prototype[g]);
            }
            function m(S) {
              if (!(this instanceof m))
                return new m(S);
              f.call(this, S), p.call(this, S), this.allowHalfOpen = !0, S && (S.readable === !1 && (this.readable = !1), S.writable === !1 && (this.writable = !1), S.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", A)));
            }
            Object.defineProperty(m.prototype, "writableHighWaterMark", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._writableState.highWaterMark;
              }
            }), Object.defineProperty(m.prototype, "writableBuffer", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._writableState && this._writableState.getBuffer();
              }
            }), Object.defineProperty(m.prototype, "writableLength", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._writableState.length;
              }
            });
            function A() {
              this._writableState.ended || process.nextTick(b, this);
            }
            function b(S) {
              S.end();
            }
            Object.defineProperty(m.prototype, "destroyed", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
              },
              set: function(N) {
                this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = N, this._writableState.destroyed = N);
              }
            });
          }
        ),
        /***/
        "./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_passthrough.js": (
          /*!************************************************************************************************!*\
            !*** ./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_passthrough.js ***!
            \************************************************************************************************/
          /***/
          (c, l, i) => {
            c.exports = f;
            var h = i(
              /*! ./_stream_transform */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_transform.js"
            );
            i(
              /*! inherits */
              "./node_modules/stream-browserify/node_modules/inherits/inherits_browser.js"
            )(f, h);
            function f(p) {
              if (!(this instanceof f))
                return new f(p);
              h.call(this, p);
            }
            f.prototype._transform = function(p, d, v) {
              v(null, p);
            };
          }
        ),
        /***/
        "./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_readable.js": (
          /*!*********************************************************************************************!*\
            !*** ./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_readable.js ***!
            \*********************************************************************************************/
          /***/
          (c, l, i) => {
            c.exports = H;
            var h;
            H.ReadableState = k, i(
              /*! events */
              "./node_modules/events/events.js"
            ).EventEmitter;
            var f = function(B, W) {
              return B.listeners(W).length;
            }, p = i(
              /*! ./internal/streams/stream */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/stream-browser.js"
            ), d = i(
              /*! buffer */
              "./node_modules/buffer/index.js"
            ).Buffer, v = i.g.Uint8Array || function() {
            };
            function g(P) {
              return d.from(P);
            }
            function m(P) {
              return d.isBuffer(P) || P instanceof v;
            }
            var A = i(
              /*! util */
              "?19e6"
            ), b;
            A && A.debuglog ? b = A.debuglog("stream") : b = function() {
            };
            var S = i(
              /*! ./internal/streams/buffer_list */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/buffer_list.js"
            ), N = i(
              /*! ./internal/streams/destroy */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/destroy.js"
            ), T = i(
              /*! ./internal/streams/state */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/state.js"
            ), R = T.getHighWaterMark, y = i(
              /*! ../errors */
              "./node_modules/stream-browserify/node_modules/readable-stream/errors-browser.js"
            ).codes, E = y.ERR_INVALID_ARG_TYPE, L = y.ERR_STREAM_PUSH_AFTER_EOF, _ = y.ERR_METHOD_NOT_IMPLEMENTED, O = y.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, D, M, C;
            i(
              /*! inherits */
              "./node_modules/stream-browserify/node_modules/inherits/inherits_browser.js"
            )(H, p);
            var I = N.errorOrDestroy, w = ["error", "close", "destroy", "pause", "resume"];
            function F(P, B, W) {
              if (typeof P.prependListener == "function")
                return P.prependListener(B, W);
              !P._events || !P._events[B] ? P.on(B, W) : Array.isArray(P._events[B]) ? P._events[B].unshift(W) : P._events[B] = [W, P._events[B]];
            }
            function k(P, B, W) {
              h = h || i(
                /*! ./_stream_duplex */
                "./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_duplex.js"
              ), P = P || {}, typeof W != "boolean" && (W = B instanceof h), this.objectMode = !!P.objectMode, W && (this.objectMode = this.objectMode || !!P.readableObjectMode), this.highWaterMark = R(this, P, "readableHighWaterMark", W), this.buffer = new S(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = P.emitClose !== !1, this.autoDestroy = !!P.autoDestroy, this.destroyed = !1, this.defaultEncoding = P.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, P.encoding && (D || (D = i(
                /*! string_decoder/ */
                "./node_modules/string_decoder/lib/string_decoder.js"
              ).StringDecoder), this.decoder = new D(P.encoding), this.encoding = P.encoding);
            }
            function H(P) {
              if (h = h || i(
                /*! ./_stream_duplex */
                "./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_duplex.js"
              ), !(this instanceof H))
                return new H(P);
              var B = this instanceof h;
              this._readableState = new k(P, this, B), this.readable = !0, P && (typeof P.read == "function" && (this._read = P.read), typeof P.destroy == "function" && (this._destroy = P.destroy)), p.call(this);
            }
            Object.defineProperty(H.prototype, "destroyed", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._readableState === void 0 ? !1 : this._readableState.destroyed;
              },
              set: function(B) {
                this._readableState && (this._readableState.destroyed = B);
              }
            }), H.prototype.destroy = N.destroy, H.prototype._undestroy = N.undestroy, H.prototype._destroy = function(P, B) {
              B(P);
            }, H.prototype.push = function(P, B) {
              var W = this._readableState, X;
              return W.objectMode ? X = !0 : typeof P == "string" && (B = B || W.defaultEncoding, B !== W.encoding && (P = d.from(P, B), B = ""), X = !0), Z(this, P, B, !1, X);
            }, H.prototype.unshift = function(P) {
              return Z(this, P, null, !0, !1);
            };
            function Z(P, B, W, X, K) {
              b("readableAddChunk", B);
              var U = P._readableState;
              if (B === null)
                U.reading = !1, $(P, U);
              else {
                var V;
                if (K || (V = j(U, B)), V)
                  I(P, V);
                else if (U.objectMode || B && B.length > 0)
                  if (typeof B != "string" && !U.objectMode && Object.getPrototypeOf(B) !== d.prototype && (B = g(B)), X)
                    U.endEmitted ? I(P, new O()) : Y(P, U, B, !0);
                  else if (U.ended)
                    I(P, new L());
                  else {
                    if (U.destroyed)
                      return !1;
                    U.reading = !1, U.decoder && !W ? (B = U.decoder.write(B), U.objectMode || B.length !== 0 ? Y(P, U, B, !1) : ce(P, U)) : Y(P, U, B, !1);
                  }
                else
                  X || (U.reading = !1, ce(P, U));
              }
              return !U.ended && (U.length < U.highWaterMark || U.length === 0);
            }
            function Y(P, B, W, X) {
              B.flowing && B.length === 0 && !B.sync ? (B.awaitDrain = 0, P.emit("data", W)) : (B.length += B.objectMode ? 1 : W.length, X ? B.buffer.unshift(W) : B.buffer.push(W), B.needReadable && ie(P)), ce(P, B);
            }
            function j(P, B) {
              var W;
              return !m(B) && typeof B != "string" && B !== void 0 && !P.objectMode && (W = new E("chunk", ["string", "Buffer", "Uint8Array"], B)), W;
            }
            H.prototype.isPaused = function() {
              return this._readableState.flowing === !1;
            }, H.prototype.setEncoding = function(P) {
              D || (D = i(
                /*! string_decoder/ */
                "./node_modules/string_decoder/lib/string_decoder.js"
              ).StringDecoder);
              var B = new D(P);
              this._readableState.decoder = B, this._readableState.encoding = this._readableState.decoder.encoding;
              for (var W = this._readableState.buffer.head, X = ""; W !== null; )
                X += B.write(W.data), W = W.next;
              return this._readableState.buffer.clear(), X !== "" && this._readableState.buffer.push(X), this._readableState.length = X.length, this;
            };
            var J = 1073741824;
            function ae(P) {
              return P >= J ? P = J : (P--, P |= P >>> 1, P |= P >>> 2, P |= P >>> 4, P |= P >>> 8, P |= P >>> 16, P++), P;
            }
            function G(P, B) {
              return P <= 0 || B.length === 0 && B.ended ? 0 : B.objectMode ? 1 : P !== P ? B.flowing && B.length ? B.buffer.head.data.length : B.length : (P > B.highWaterMark && (B.highWaterMark = ae(P)), P <= B.length ? P : B.ended ? B.length : (B.needReadable = !0, 0));
            }
            H.prototype.read = function(P) {
              b("read", P), P = parseInt(P, 10);
              var B = this._readableState, W = P;
              if (P !== 0 && (B.emittedReadable = !1), P === 0 && B.needReadable && ((B.highWaterMark !== 0 ? B.length >= B.highWaterMark : B.length > 0) || B.ended))
                return b("read: emitReadable", B.length, B.ended), B.length === 0 && B.ended ? le(this) : ie(this), null;
              if (P = G(P, B), P === 0 && B.ended)
                return B.length === 0 && le(this), null;
              var X = B.needReadable;
              b("need readable", X), (B.length === 0 || B.length - P < B.highWaterMark) && (X = !0, b("length less than watermark", X)), B.ended || B.reading ? (X = !1, b("reading or ended", X)) : X && (b("do read"), B.reading = !0, B.sync = !0, B.length === 0 && (B.needReadable = !0), this._read(B.highWaterMark), B.sync = !1, B.reading || (P = G(W, B)));
              var K;
              return P > 0 ? K = te(P, B) : K = null, K === null ? (B.needReadable = B.length <= B.highWaterMark, P = 0) : (B.length -= P, B.awaitDrain = 0), B.length === 0 && (B.ended || (B.needReadable = !0), W !== P && B.ended && le(this)), K !== null && this.emit("data", K), K;
            };
            function $(P, B) {
              if (b("onEofChunk"), !B.ended) {
                if (B.decoder) {
                  var W = B.decoder.end();
                  W && W.length && (B.buffer.push(W), B.length += B.objectMode ? 1 : W.length);
                }
                B.ended = !0, B.sync ? ie(P) : (B.needReadable = !1, B.emittedReadable || (B.emittedReadable = !0, re(P)));
              }
            }
            function ie(P) {
              var B = P._readableState;
              b("emitReadable", B.needReadable, B.emittedReadable), B.needReadable = !1, B.emittedReadable || (b("emitReadable", B.flowing), B.emittedReadable = !0, process.nextTick(re, P));
            }
            function re(P) {
              var B = P._readableState;
              b("emitReadable_", B.destroyed, B.length, B.ended), !B.destroyed && (B.length || B.ended) && (P.emit("readable"), B.emittedReadable = !1), B.needReadable = !B.flowing && !B.ended && B.length <= B.highWaterMark, ee(P);
            }
            function ce(P, B) {
              B.readingMore || (B.readingMore = !0, process.nextTick(z, P, B));
            }
            function z(P, B) {
              for (; !B.reading && !B.ended && (B.length < B.highWaterMark || B.flowing && B.length === 0); ) {
                var W = B.length;
                if (b("maybeReadMore read 0"), P.read(0), W === B.length)
                  break;
              }
              B.readingMore = !1;
            }
            H.prototype._read = function(P) {
              I(this, new _("_read()"));
            }, H.prototype.pipe = function(P, B) {
              var W = this, X = this._readableState;
              switch (X.pipesCount) {
                case 0:
                  X.pipes = P;
                  break;
                case 1:
                  X.pipes = [X.pipes, P];
                  break;
                default:
                  X.pipes.push(P);
                  break;
              }
              X.pipesCount += 1, b("pipe count=%d opts=%j", X.pipesCount, B);
              var K = (!B || B.end !== !1) && P !== process.stdout && P !== process.stderr, U = K ? Q : Re;
              X.endEmitted ? process.nextTick(U) : W.once("end", U), P.on("unpipe", V);
              function V(Pe, ke) {
                b("onunpipe"), Pe === W && ke && ke.hasUnpiped === !1 && (ke.hasUnpiped = !0, q());
              }
              function Q() {
                b("onend"), P.end();
              }
              var fe = oe(W);
              P.on("drain", fe);
              var ue = !1;
              function q() {
                b("cleanup"), P.removeListener("close", Ce), P.removeListener("finish", Ee), P.removeListener("drain", fe), P.removeListener("error", ge), P.removeListener("unpipe", V), W.removeListener("end", Q), W.removeListener("end", Re), W.removeListener("data", _e), ue = !0, X.awaitDrain && (!P._writableState || P._writableState.needDrain) && fe();
              }
              W.on("data", _e);
              function _e(Pe) {
                b("ondata");
                var ke = P.write(Pe);
                b("dest.write", ke), ke === !1 && ((X.pipesCount === 1 && X.pipes === P || X.pipesCount > 1 && x(X.pipes, P) !== -1) && !ue && (b("false write response, pause", X.awaitDrain), X.awaitDrain++), W.pause());
              }
              function ge(Pe) {
                b("onerror", Pe), Re(), P.removeListener("error", ge), f(P, "error") === 0 && I(P, Pe);
              }
              F(P, "error", ge);
              function Ce() {
                P.removeListener("finish", Ee), Re();
              }
              P.once("close", Ce);
              function Ee() {
                b("onfinish"), P.removeListener("close", Ce), Re();
              }
              P.once("finish", Ee);
              function Re() {
                b("unpipe"), W.unpipe(P);
              }
              return P.emit("pipe", W), X.flowing || (b("pipe resume"), W.resume()), P;
            };
            function oe(P) {
              return function() {
                var W = P._readableState;
                b("pipeOnDrain", W.awaitDrain), W.awaitDrain && W.awaitDrain--, W.awaitDrain === 0 && f(P, "data") && (W.flowing = !0, ee(P));
              };
            }
            H.prototype.unpipe = function(P) {
              var B = this._readableState, W = {
                hasUnpiped: !1
              };
              if (B.pipesCount === 0)
                return this;
              if (B.pipesCount === 1)
                return P && P !== B.pipes ? this : (P || (P = B.pipes), B.pipes = null, B.pipesCount = 0, B.flowing = !1, P && P.emit("unpipe", this, W), this);
              if (!P) {
                var X = B.pipes, K = B.pipesCount;
                B.pipes = null, B.pipesCount = 0, B.flowing = !1;
                for (var U = 0; U < K; U++)
                  X[U].emit("unpipe", this, {
                    hasUnpiped: !1
                  });
                return this;
              }
              var V = x(B.pipes, P);
              return V === -1 ? this : (B.pipes.splice(V, 1), B.pipesCount -= 1, B.pipesCount === 1 && (B.pipes = B.pipes[0]), P.emit("unpipe", this, W), this);
            }, H.prototype.on = function(P, B) {
              var W = p.prototype.on.call(this, P, B), X = this._readableState;
              return P === "data" ? (X.readableListening = this.listenerCount("readable") > 0, X.flowing !== !1 && this.resume()) : P === "readable" && !X.endEmitted && !X.readableListening && (X.readableListening = X.needReadable = !0, X.flowing = !1, X.emittedReadable = !1, b("on readable", X.length, X.reading), X.length ? ie(this) : X.reading || process.nextTick(pe, this)), W;
            }, H.prototype.addListener = H.prototype.on, H.prototype.removeListener = function(P, B) {
              var W = p.prototype.removeListener.call(this, P, B);
              return P === "readable" && process.nextTick(de, this), W;
            }, H.prototype.removeAllListeners = function(P) {
              var B = p.prototype.removeAllListeners.apply(this, arguments);
              return (P === "readable" || P === void 0) && process.nextTick(de, this), B;
            };
            function de(P) {
              var B = P._readableState;
              B.readableListening = P.listenerCount("readable") > 0, B.resumeScheduled && !B.paused ? B.flowing = !0 : P.listenerCount("data") > 0 && P.resume();
            }
            function pe(P) {
              b("readable nexttick read 0"), P.read(0);
            }
            H.prototype.resume = function() {
              var P = this._readableState;
              return P.flowing || (b("resume"), P.flowing = !P.readableListening, he(this, P)), P.paused = !1, this;
            };
            function he(P, B) {
              B.resumeScheduled || (B.resumeScheduled = !0, process.nextTick(se, P, B));
            }
            function se(P, B) {
              b("resume", B.reading), B.reading || P.read(0), B.resumeScheduled = !1, P.emit("resume"), ee(P), B.flowing && !B.reading && P.read(0);
            }
            H.prototype.pause = function() {
              return b("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (b("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
            };
            function ee(P) {
              var B = P._readableState;
              for (b("flow", B.flowing); B.flowing && P.read() !== null; )
                ;
            }
            H.prototype.wrap = function(P) {
              var B = this, W = this._readableState, X = !1;
              P.on("end", function() {
                if (b("wrapped end"), W.decoder && !W.ended) {
                  var V = W.decoder.end();
                  V && V.length && B.push(V);
                }
                B.push(null);
              }), P.on("data", function(V) {
                if (b("wrapped data"), W.decoder && (V = W.decoder.write(V)), !(W.objectMode && V == null) && !(!W.objectMode && (!V || !V.length))) {
                  var Q = B.push(V);
                  Q || (X = !0, P.pause());
                }
              });
              for (var K in P)
                this[K] === void 0 && typeof P[K] == "function" && (this[K] = function(Q) {
                  return function() {
                    return P[Q].apply(P, arguments);
                  };
                }(K));
              for (var U = 0; U < w.length; U++)
                P.on(w[U], this.emit.bind(this, w[U]));
              return this._read = function(V) {
                b("wrapped _read", V), X && (X = !1, P.resume());
              }, this;
            }, typeof Symbol == "function" && (H.prototype[Symbol.asyncIterator] = function() {
              return M === void 0 && (M = i(
                /*! ./internal/streams/async_iterator */
                "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/async_iterator.js"
              )), M(this);
            }), Object.defineProperty(H.prototype, "readableHighWaterMark", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._readableState.highWaterMark;
              }
            }), Object.defineProperty(H.prototype, "readableBuffer", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._readableState && this._readableState.buffer;
              }
            }), Object.defineProperty(H.prototype, "readableFlowing", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._readableState.flowing;
              },
              set: function(B) {
                this._readableState && (this._readableState.flowing = B);
              }
            }), H._fromList = te, Object.defineProperty(H.prototype, "readableLength", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._readableState.length;
              }
            });
            function te(P, B) {
              if (B.length === 0)
                return null;
              var W;
              return B.objectMode ? W = B.buffer.shift() : !P || P >= B.length ? (B.decoder ? W = B.buffer.join("") : B.buffer.length === 1 ? W = B.buffer.first() : W = B.buffer.concat(B.length), B.buffer.clear()) : W = B.buffer.consume(P, B.decoder), W;
            }
            function le(P) {
              var B = P._readableState;
              b("endReadable", B.endEmitted), B.endEmitted || (B.ended = !0, process.nextTick(ne, B, P));
            }
            function ne(P, B) {
              if (b("endReadableNT", P.endEmitted, P.length), !P.endEmitted && P.length === 0 && (P.endEmitted = !0, B.readable = !1, B.emit("end"), P.autoDestroy)) {
                var W = B._writableState;
                (!W || W.autoDestroy && W.finished) && B.destroy();
              }
            }
            typeof Symbol == "function" && (H.from = function(P, B) {
              return C === void 0 && (C = i(
                /*! ./internal/streams/from */
                "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/from-browser.js"
              )), C(H, P, B);
            });
            function x(P, B) {
              for (var W = 0, X = P.length; W < X; W++)
                if (P[W] === B)
                  return W;
              return -1;
            }
          }
        ),
        /***/
        "./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_transform.js": (
          /*!**********************************************************************************************!*\
            !*** ./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_transform.js ***!
            \**********************************************************************************************/
          /***/
          (c, l, i) => {
            c.exports = A;
            var h = i(
              /*! ../errors */
              "./node_modules/stream-browserify/node_modules/readable-stream/errors-browser.js"
            ).codes, f = h.ERR_METHOD_NOT_IMPLEMENTED, p = h.ERR_MULTIPLE_CALLBACK, d = h.ERR_TRANSFORM_ALREADY_TRANSFORMING, v = h.ERR_TRANSFORM_WITH_LENGTH_0, g = i(
              /*! ./_stream_duplex */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_duplex.js"
            );
            i(
              /*! inherits */
              "./node_modules/stream-browserify/node_modules/inherits/inherits_browser.js"
            )(A, g);
            function m(N, T) {
              var R = this._transformState;
              R.transforming = !1;
              var y = R.writecb;
              if (y === null)
                return this.emit("error", new p());
              R.writechunk = null, R.writecb = null, T != null && this.push(T), y(N);
              var E = this._readableState;
              E.reading = !1, (E.needReadable || E.length < E.highWaterMark) && this._read(E.highWaterMark);
            }
            function A(N) {
              if (!(this instanceof A))
                return new A(N);
              g.call(this, N), this._transformState = {
                afterTransform: m.bind(this),
                needTransform: !1,
                transforming: !1,
                writecb: null,
                writechunk: null,
                writeencoding: null
              }, this._readableState.needReadable = !0, this._readableState.sync = !1, N && (typeof N.transform == "function" && (this._transform = N.transform), typeof N.flush == "function" && (this._flush = N.flush)), this.on("prefinish", b);
            }
            function b() {
              var N = this;
              typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(T, R) {
                S(N, T, R);
              }) : S(this, null, null);
            }
            A.prototype.push = function(N, T) {
              return this._transformState.needTransform = !1, g.prototype.push.call(this, N, T);
            }, A.prototype._transform = function(N, T, R) {
              R(new f("_transform()"));
            }, A.prototype._write = function(N, T, R) {
              var y = this._transformState;
              if (y.writecb = R, y.writechunk = N, y.writeencoding = T, !y.transforming) {
                var E = this._readableState;
                (y.needTransform || E.needReadable || E.length < E.highWaterMark) && this._read(E.highWaterMark);
              }
            }, A.prototype._read = function(N) {
              var T = this._transformState;
              T.writechunk !== null && !T.transforming ? (T.transforming = !0, this._transform(T.writechunk, T.writeencoding, T.afterTransform)) : T.needTransform = !0;
            }, A.prototype._destroy = function(N, T) {
              g.prototype._destroy.call(this, N, function(R) {
                T(R);
              });
            };
            function S(N, T, R) {
              if (T)
                return N.emit("error", T);
              if (R != null && N.push(R), N._writableState.length)
                throw new v();
              if (N._transformState.transforming)
                throw new d();
              return N.push(null);
            }
          }
        ),
        /***/
        "./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_writable.js": (
          /*!*********************************************************************************************!*\
            !*** ./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_writable.js ***!
            \*********************************************************************************************/
          /***/
          (c, l, i) => {
            c.exports = k;
            function h(ee) {
              var te = this;
              this.next = null, this.entry = null, this.finish = function() {
                se(te, ee);
              };
            }
            var f;
            k.WritableState = w;
            var p = {
              deprecate: i(
                /*! util-deprecate */
                "./node_modules/util-deprecate/browser.js"
              )
            }, d = i(
              /*! ./internal/streams/stream */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/stream-browser.js"
            ), v = i(
              /*! buffer */
              "./node_modules/buffer/index.js"
            ).Buffer, g = i.g.Uint8Array || function() {
            };
            function m(ee) {
              return v.from(ee);
            }
            function A(ee) {
              return v.isBuffer(ee) || ee instanceof g;
            }
            var b = i(
              /*! ./internal/streams/destroy */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/destroy.js"
            ), S = i(
              /*! ./internal/streams/state */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/state.js"
            ), N = S.getHighWaterMark, T = i(
              /*! ../errors */
              "./node_modules/stream-browserify/node_modules/readable-stream/errors-browser.js"
            ).codes, R = T.ERR_INVALID_ARG_TYPE, y = T.ERR_METHOD_NOT_IMPLEMENTED, E = T.ERR_MULTIPLE_CALLBACK, L = T.ERR_STREAM_CANNOT_PIPE, _ = T.ERR_STREAM_DESTROYED, O = T.ERR_STREAM_NULL_VALUES, D = T.ERR_STREAM_WRITE_AFTER_END, M = T.ERR_UNKNOWN_ENCODING, C = b.errorOrDestroy;
            i(
              /*! inherits */
              "./node_modules/stream-browserify/node_modules/inherits/inherits_browser.js"
            )(k, d);
            function I() {
            }
            function w(ee, te, le) {
              f = f || i(
                /*! ./_stream_duplex */
                "./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_duplex.js"
              ), ee = ee || {}, typeof le != "boolean" && (le = te instanceof f), this.objectMode = !!ee.objectMode, le && (this.objectMode = this.objectMode || !!ee.writableObjectMode), this.highWaterMark = N(this, ee, "writableHighWaterMark", le), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
              var ne = ee.decodeStrings === !1;
              this.decodeStrings = !ne, this.defaultEncoding = ee.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(x) {
                $(te, x);
              }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = ee.emitClose !== !1, this.autoDestroy = !!ee.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new h(this);
            }
            w.prototype.getBuffer = function() {
              for (var te = this.bufferedRequest, le = []; te; )
                le.push(te), te = te.next;
              return le;
            }, function() {
              try {
                Object.defineProperty(w.prototype, "buffer", {
                  get: p.deprecate(function() {
                    return this.getBuffer();
                  }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
                });
              } catch {
              }
            }();
            var F;
            typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (F = Function.prototype[Symbol.hasInstance], Object.defineProperty(k, Symbol.hasInstance, {
              value: function(te) {
                return F.call(this, te) ? !0 : this !== k ? !1 : te && te._writableState instanceof w;
              }
            })) : F = function(te) {
              return te instanceof this;
            };
            function k(ee) {
              f = f || i(
                /*! ./_stream_duplex */
                "./node_modules/stream-browserify/node_modules/readable-stream/lib/_stream_duplex.js"
              );
              var te = this instanceof f;
              if (!te && !F.call(k, this))
                return new k(ee);
              this._writableState = new w(ee, this, te), this.writable = !0, ee && (typeof ee.write == "function" && (this._write = ee.write), typeof ee.writev == "function" && (this._writev = ee.writev), typeof ee.destroy == "function" && (this._destroy = ee.destroy), typeof ee.final == "function" && (this._final = ee.final)), d.call(this);
            }
            k.prototype.pipe = function() {
              C(this, new L());
            };
            function H(ee, te) {
              var le = new D();
              C(ee, le), process.nextTick(te, le);
            }
            function Z(ee, te, le, ne) {
              var x;
              return le === null ? x = new O() : typeof le != "string" && !te.objectMode && (x = new R("chunk", ["string", "Buffer"], le)), x ? (C(ee, x), process.nextTick(ne, x), !1) : !0;
            }
            k.prototype.write = function(ee, te, le) {
              var ne = this._writableState, x = !1, P = !ne.objectMode && A(ee);
              return P && !v.isBuffer(ee) && (ee = m(ee)), typeof te == "function" && (le = te, te = null), P ? te = "buffer" : te || (te = ne.defaultEncoding), typeof le != "function" && (le = I), ne.ending ? H(this, le) : (P || Z(this, ne, ee, le)) && (ne.pendingcb++, x = j(this, ne, P, ee, te, le)), x;
            }, k.prototype.cork = function() {
              this._writableState.corked++;
            }, k.prototype.uncork = function() {
              var ee = this._writableState;
              ee.corked && (ee.corked--, !ee.writing && !ee.corked && !ee.bufferProcessing && ee.bufferedRequest && ce(this, ee));
            }, k.prototype.setDefaultEncoding = function(te) {
              if (typeof te == "string" && (te = te.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((te + "").toLowerCase()) > -1))
                throw new M(te);
              return this._writableState.defaultEncoding = te, this;
            }, Object.defineProperty(k.prototype, "writableBuffer", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._writableState && this._writableState.getBuffer();
              }
            });
            function Y(ee, te, le) {
              return !ee.objectMode && ee.decodeStrings !== !1 && typeof te == "string" && (te = v.from(te, le)), te;
            }
            Object.defineProperty(k.prototype, "writableHighWaterMark", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._writableState.highWaterMark;
              }
            });
            function j(ee, te, le, ne, x, P) {
              if (!le) {
                var B = Y(te, ne, x);
                ne !== B && (le = !0, x = "buffer", ne = B);
              }
              var W = te.objectMode ? 1 : ne.length;
              te.length += W;
              var X = te.length < te.highWaterMark;
              if (X || (te.needDrain = !0), te.writing || te.corked) {
                var K = te.lastBufferedRequest;
                te.lastBufferedRequest = {
                  chunk: ne,
                  encoding: x,
                  isBuf: le,
                  callback: P,
                  next: null
                }, K ? K.next = te.lastBufferedRequest : te.bufferedRequest = te.lastBufferedRequest, te.bufferedRequestCount += 1;
              } else
                J(ee, te, !1, W, ne, x, P);
              return X;
            }
            function J(ee, te, le, ne, x, P, B) {
              te.writelen = ne, te.writecb = B, te.writing = !0, te.sync = !0, te.destroyed ? te.onwrite(new _("write")) : le ? ee._writev(x, te.onwrite) : ee._write(x, P, te.onwrite), te.sync = !1;
            }
            function ae(ee, te, le, ne, x) {
              --te.pendingcb, le ? (process.nextTick(x, ne), process.nextTick(pe, ee, te), ee._writableState.errorEmitted = !0, C(ee, ne)) : (x(ne), ee._writableState.errorEmitted = !0, C(ee, ne), pe(ee, te));
            }
            function G(ee) {
              ee.writing = !1, ee.writecb = null, ee.length -= ee.writelen, ee.writelen = 0;
            }
            function $(ee, te) {
              var le = ee._writableState, ne = le.sync, x = le.writecb;
              if (typeof x != "function")
                throw new E();
              if (G(le), te)
                ae(ee, le, ne, te, x);
              else {
                var P = z(le) || ee.destroyed;
                !P && !le.corked && !le.bufferProcessing && le.bufferedRequest && ce(ee, le), ne ? process.nextTick(ie, ee, le, P, x) : ie(ee, le, P, x);
              }
            }
            function ie(ee, te, le, ne) {
              le || re(ee, te), te.pendingcb--, ne(), pe(ee, te);
            }
            function re(ee, te) {
              te.length === 0 && te.needDrain && (te.needDrain = !1, ee.emit("drain"));
            }
            function ce(ee, te) {
              te.bufferProcessing = !0;
              var le = te.bufferedRequest;
              if (ee._writev && le && le.next) {
                var ne = te.bufferedRequestCount, x = new Array(ne), P = te.corkedRequestsFree;
                P.entry = le;
                for (var B = 0, W = !0; le; )
                  x[B] = le, le.isBuf || (W = !1), le = le.next, B += 1;
                x.allBuffers = W, J(ee, te, !0, te.length, x, "", P.finish), te.pendingcb++, te.lastBufferedRequest = null, P.next ? (te.corkedRequestsFree = P.next, P.next = null) : te.corkedRequestsFree = new h(te), te.bufferedRequestCount = 0;
              } else {
                for (; le; ) {
                  var X = le.chunk, K = le.encoding, U = le.callback, V = te.objectMode ? 1 : X.length;
                  if (J(ee, te, !1, V, X, K, U), le = le.next, te.bufferedRequestCount--, te.writing)
                    break;
                }
                le === null && (te.lastBufferedRequest = null);
              }
              te.bufferedRequest = le, te.bufferProcessing = !1;
            }
            k.prototype._write = function(ee, te, le) {
              le(new y("_write()"));
            }, k.prototype._writev = null, k.prototype.end = function(ee, te, le) {
              var ne = this._writableState;
              return typeof ee == "function" ? (le = ee, ee = null, te = null) : typeof te == "function" && (le = te, te = null), ee != null && this.write(ee, te), ne.corked && (ne.corked = 1, this.uncork()), ne.ending || he(this, ne, le), this;
            }, Object.defineProperty(k.prototype, "writableLength", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._writableState.length;
              }
            });
            function z(ee) {
              return ee.ending && ee.length === 0 && ee.bufferedRequest === null && !ee.finished && !ee.writing;
            }
            function oe(ee, te) {
              ee._final(function(le) {
                te.pendingcb--, le && C(ee, le), te.prefinished = !0, ee.emit("prefinish"), pe(ee, te);
              });
            }
            function de(ee, te) {
              !te.prefinished && !te.finalCalled && (typeof ee._final == "function" && !te.destroyed ? (te.pendingcb++, te.finalCalled = !0, process.nextTick(oe, ee, te)) : (te.prefinished = !0, ee.emit("prefinish")));
            }
            function pe(ee, te) {
              var le = z(te);
              if (le && (de(ee, te), te.pendingcb === 0 && (te.finished = !0, ee.emit("finish"), te.autoDestroy))) {
                var ne = ee._readableState;
                (!ne || ne.autoDestroy && ne.endEmitted) && ee.destroy();
              }
              return le;
            }
            function he(ee, te, le) {
              te.ending = !0, pe(ee, te), le && (te.finished ? process.nextTick(le) : ee.once("finish", le)), te.ended = !0, ee.writable = !1;
            }
            function se(ee, te, le) {
              var ne = ee.entry;
              for (ee.entry = null; ne; ) {
                var x = ne.callback;
                te.pendingcb--, x(le), ne = ne.next;
              }
              te.corkedRequestsFree.next = ee;
            }
            Object.defineProperty(k.prototype, "destroyed", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._writableState === void 0 ? !1 : this._writableState.destroyed;
              },
              set: function(te) {
                this._writableState && (this._writableState.destroyed = te);
              }
            }), k.prototype.destroy = b.destroy, k.prototype._undestroy = b.undestroy, k.prototype._destroy = function(ee, te) {
              te(ee);
            };
          }
        ),
        /***/
        "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/async_iterator.js": (
          /*!************************************************************************************************************!*\
            !*** ./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/async_iterator.js ***!
            \************************************************************************************************************/
          /***/
          (c, l, i) => {
            var h;
            function f(O, D, M) {
              return D in O ? Object.defineProperty(O, D, { value: M, enumerable: !0, configurable: !0, writable: !0 }) : O[D] = M, O;
            }
            var p = i(
              /*! ./end-of-stream */
              "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/end-of-stream.js"
            ), d = Symbol("lastResolve"), v = Symbol("lastReject"), g = Symbol("error"), m = Symbol("ended"), A = Symbol("lastPromise"), b = Symbol("handlePromise"), S = Symbol("stream");
            function N(O, D) {
              return {
                value: O,
                done: D
              };
            }
            function T(O) {
              var D = O[d];
              if (D !== null) {
                var M = O[S].read();
                M !== null && (O[A] = null, O[d] = null, O[v] = null, D(N(M, !1)));
              }
            }
            function R(O) {
              process.nextTick(T, O);
            }
            function y(O, D) {
              return function(M, C) {
                O.then(function() {
                  if (D[m]) {
                    M(N(void 0, !0));
                    return;
                  }
                  D[b](M, C);
                }, C);
              };
            }
            var E = Object.getPrototypeOf(function() {
            }), L = Object.setPrototypeOf((h = {
              get stream() {
                return this[S];
              },
              next: function() {
                var D = this, M = this[g];
                if (M !== null)
                  return Promise.reject(M);
                if (this[m])
                  return Promise.resolve(N(void 0, !0));
                if (this[S].destroyed)
                  return new Promise(function(F, k) {
                    process.nextTick(function() {
                      D[g] ? k(D[g]) : F(N(void 0, !0));
                    });
                  });
                var C = this[A], I;
                if (C)
                  I = new Promise(y(C, this));
                else {
                  var w = this[S].read();
                  if (w !== null)
                    return Promise.resolve(N(w, !1));
                  I = new Promise(this[b]);
                }
                return this[A] = I, I;
              }
            }, f(h, Symbol.asyncIterator, function() {
              return this;
            }), f(h, "return", function() {
              var D = this;
              return new Promise(function(M, C) {
                D[S].destroy(null, function(I) {
                  if (I) {
                    C(I);
                    return;
                  }
                  M(N(void 0, !0));
                });
              });
            }), h), E), _ = function(D) {
              var M, C = Object.create(L, (M = {}, f(M, S, {
                value: D,
                writable: !0
              }), f(M, d, {
                value: null,
                writable: !0
              }), f(M, v, {
                value: null,
                writable: !0
              }), f(M, g, {
                value: null,
                writable: !0
              }), f(M, m, {
                value: D._readableState.endEmitted,
                writable: !0
              }), f(M, b, {
                value: function(w, F) {
                  var k = C[S].read();
                  k ? (C[A] = null, C[d] = null, C[v] = null, w(N(k, !1))) : (C[d] = w, C[v] = F);
                },
                writable: !0
              }), M));
              return C[A] = null, p(D, function(I) {
                if (I && I.code !== "ERR_STREAM_PREMATURE_CLOSE") {
                  var w = C[v];
                  w !== null && (C[A] = null, C[d] = null, C[v] = null, w(I)), C[g] = I;
                  return;
                }
                var F = C[d];
                F !== null && (C[A] = null, C[d] = null, C[v] = null, F(N(void 0, !0))), C[m] = !0;
              }), D.on("readable", R.bind(null, C)), C;
            };
            c.exports = _;
          }
        ),
        /***/
        "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/buffer_list.js": (
          /*!*********************************************************************************************************!*\
            !*** ./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/buffer_list.js ***!
            \*********************************************************************************************************/
          /***/
          (c, l, i) => {
            function h(R, y) {
              var E = Object.keys(R);
              if (Object.getOwnPropertySymbols) {
                var L = Object.getOwnPropertySymbols(R);
                y && (L = L.filter(function(_) {
                  return Object.getOwnPropertyDescriptor(R, _).enumerable;
                })), E.push.apply(E, L);
              }
              return E;
            }
            function f(R) {
              for (var y = 1; y < arguments.length; y++) {
                var E = arguments[y] != null ? arguments[y] : {};
                y % 2 ? h(Object(E), !0).forEach(function(L) {
                  p(R, L, E[L]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(R, Object.getOwnPropertyDescriptors(E)) : h(Object(E)).forEach(function(L) {
                  Object.defineProperty(R, L, Object.getOwnPropertyDescriptor(E, L));
                });
              }
              return R;
            }
            function p(R, y, E) {
              return y in R ? Object.defineProperty(R, y, { value: E, enumerable: !0, configurable: !0, writable: !0 }) : R[y] = E, R;
            }
            function d(R, y) {
              if (!(R instanceof y))
                throw new TypeError("Cannot call a class as a function");
            }
            function v(R, y) {
              for (var E = 0; E < y.length; E++) {
                var L = y[E];
                L.enumerable = L.enumerable || !1, L.configurable = !0, "value" in L && (L.writable = !0), Object.defineProperty(R, L.key, L);
              }
            }
            function g(R, y, E) {
              return y && v(R.prototype, y), E && v(R, E), R;
            }
            var m = i(
              /*! buffer */
              "./node_modules/buffer/index.js"
            ), A = m.Buffer, b = i(
              /*! util */
              "?3e83"
            ), S = b.inspect, N = S && S.custom || "inspect";
            function T(R, y, E) {
              A.prototype.copy.call(R, y, E);
            }
            c.exports = /* @__PURE__ */ function() {
              function R() {
                d(this, R), this.head = null, this.tail = null, this.length = 0;
              }
              return g(R, [{
                key: "push",
                value: function(E) {
                  var L = {
                    data: E,
                    next: null
                  };
                  this.length > 0 ? this.tail.next = L : this.head = L, this.tail = L, ++this.length;
                }
              }, {
                key: "unshift",
                value: function(E) {
                  var L = {
                    data: E,
                    next: this.head
                  };
                  this.length === 0 && (this.tail = L), this.head = L, ++this.length;
                }
              }, {
                key: "shift",
                value: function() {
                  if (this.length !== 0) {
                    var E = this.head.data;
                    return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, E;
                  }
                }
              }, {
                key: "clear",
                value: function() {
                  this.head = this.tail = null, this.length = 0;
                }
              }, {
                key: "join",
                value: function(E) {
                  if (this.length === 0)
                    return "";
                  for (var L = this.head, _ = "" + L.data; L = L.next; )
                    _ += E + L.data;
                  return _;
                }
              }, {
                key: "concat",
                value: function(E) {
                  if (this.length === 0)
                    return A.alloc(0);
                  for (var L = A.allocUnsafe(E >>> 0), _ = this.head, O = 0; _; )
                    T(_.data, L, O), O += _.data.length, _ = _.next;
                  return L;
                }
                // Consumes a specified amount of bytes or characters from the buffered data.
              }, {
                key: "consume",
                value: function(E, L) {
                  var _;
                  return E < this.head.data.length ? (_ = this.head.data.slice(0, E), this.head.data = this.head.data.slice(E)) : E === this.head.data.length ? _ = this.shift() : _ = L ? this._getString(E) : this._getBuffer(E), _;
                }
              }, {
                key: "first",
                value: function() {
                  return this.head.data;
                }
                // Consumes a specified amount of characters from the buffered data.
              }, {
                key: "_getString",
                value: function(E) {
                  var L = this.head, _ = 1, O = L.data;
                  for (E -= O.length; L = L.next; ) {
                    var D = L.data, M = E > D.length ? D.length : E;
                    if (M === D.length ? O += D : O += D.slice(0, E), E -= M, E === 0) {
                      M === D.length ? (++_, L.next ? this.head = L.next : this.head = this.tail = null) : (this.head = L, L.data = D.slice(M));
                      break;
                    }
                    ++_;
                  }
                  return this.length -= _, O;
                }
                // Consumes a specified amount of bytes from the buffered data.
              }, {
                key: "_getBuffer",
                value: function(E) {
                  var L = A.allocUnsafe(E), _ = this.head, O = 1;
                  for (_.data.copy(L), E -= _.data.length; _ = _.next; ) {
                    var D = _.data, M = E > D.length ? D.length : E;
                    if (D.copy(L, L.length - E, 0, M), E -= M, E === 0) {
                      M === D.length ? (++O, _.next ? this.head = _.next : this.head = this.tail = null) : (this.head = _, _.data = D.slice(M));
                      break;
                    }
                    ++O;
                  }
                  return this.length -= O, L;
                }
                // Make sure the linked list only shows the minimal necessary information.
              }, {
                key: N,
                value: function(E, L) {
                  return S(this, f({}, L, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: !1
                  }));
                }
              }]), R;
            }();
          }
        ),
        /***/
        "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/destroy.js": (
          /*!*****************************************************************************************************!*\
            !*** ./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/destroy.js ***!
            \*****************************************************************************************************/
          /***/
          (c) => {
            function l(v, g) {
              var m = this, A = this._readableState && this._readableState.destroyed, b = this._writableState && this._writableState.destroyed;
              return A || b ? (g ? g(v) : v && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, process.nextTick(p, this, v)) : process.nextTick(p, this, v)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(v || null, function(S) {
                !g && S ? m._writableState ? m._writableState.errorEmitted ? process.nextTick(h, m) : (m._writableState.errorEmitted = !0, process.nextTick(i, m, S)) : process.nextTick(i, m, S) : g ? (process.nextTick(h, m), g(S)) : process.nextTick(h, m);
              }), this);
            }
            function i(v, g) {
              p(v, g), h(v);
            }
            function h(v) {
              v._writableState && !v._writableState.emitClose || v._readableState && !v._readableState.emitClose || v.emit("close");
            }
            function f() {
              this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
            }
            function p(v, g) {
              v.emit("error", g);
            }
            function d(v, g) {
              var m = v._readableState, A = v._writableState;
              m && m.autoDestroy || A && A.autoDestroy ? v.destroy(g) : v.emit("error", g);
            }
            c.exports = {
              destroy: l,
              undestroy: f,
              errorOrDestroy: d
            };
          }
        ),
        /***/
        "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/end-of-stream.js": (
          /*!***********************************************************************************************************!*\
            !*** ./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/end-of-stream.js ***!
            \***********************************************************************************************************/
          /***/
          (c, l, i) => {
            var h = i(
              /*! ../../../errors */
              "./node_modules/stream-browserify/node_modules/readable-stream/errors-browser.js"
            ).codes.ERR_STREAM_PREMATURE_CLOSE;
            function f(g) {
              var m = !1;
              return function() {
                if (!m) {
                  m = !0;
                  for (var A = arguments.length, b = new Array(A), S = 0; S < A; S++)
                    b[S] = arguments[S];
                  g.apply(this, b);
                }
              };
            }
            function p() {
            }
            function d(g) {
              return g.setHeader && typeof g.abort == "function";
            }
            function v(g, m, A) {
              if (typeof m == "function")
                return v(g, null, m);
              m || (m = {}), A = f(A || p);
              var b = m.readable || m.readable !== !1 && g.readable, S = m.writable || m.writable !== !1 && g.writable, N = function() {
                g.writable || R();
              }, T = g._writableState && g._writableState.finished, R = function() {
                S = !1, T = !0, b || A.call(g);
              }, y = g._readableState && g._readableState.endEmitted, E = function() {
                b = !1, y = !0, S || A.call(g);
              }, L = function(M) {
                A.call(g, M);
              }, _ = function() {
                var M;
                if (b && !y)
                  return (!g._readableState || !g._readableState.ended) && (M = new h()), A.call(g, M);
                if (S && !T)
                  return (!g._writableState || !g._writableState.ended) && (M = new h()), A.call(g, M);
              }, O = function() {
                g.req.on("finish", R);
              };
              return d(g) ? (g.on("complete", R), g.on("abort", _), g.req ? O() : g.on("request", O)) : S && !g._writableState && (g.on("end", N), g.on("close", N)), g.on("end", E), g.on("finish", R), m.error !== !1 && g.on("error", L), g.on("close", _), function() {
                g.removeListener("complete", R), g.removeListener("abort", _), g.removeListener("request", O), g.req && g.req.removeListener("finish", R), g.removeListener("end", N), g.removeListener("close", N), g.removeListener("finish", R), g.removeListener("end", E), g.removeListener("error", L), g.removeListener("close", _);
              };
            }
            c.exports = v;
          }
        ),
        /***/
        "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/from-browser.js": (
          /*!**********************************************************************************************************!*\
            !*** ./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/from-browser.js ***!
            \**********************************************************************************************************/
          /***/
          (c) => {
            c.exports = function() {
              throw new Error("Readable.from is not available in the browser");
            };
          }
        ),
        /***/
        "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/pipeline.js": (
          /*!******************************************************************************************************!*\
            !*** ./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/pipeline.js ***!
            \******************************************************************************************************/
          /***/
          (c, l, i) => {
            var h;
            function f(R) {
              var y = !1;
              return function() {
                y || (y = !0, R.apply(void 0, arguments));
              };
            }
            var p = i(
              /*! ../../../errors */
              "./node_modules/stream-browserify/node_modules/readable-stream/errors-browser.js"
            ).codes, d = p.ERR_MISSING_ARGS, v = p.ERR_STREAM_DESTROYED;
            function g(R) {
              if (R)
                throw R;
            }
            function m(R) {
              return R.setHeader && typeof R.abort == "function";
            }
            function A(R, y, E, L) {
              L = f(L);
              var _ = !1;
              R.on("close", function() {
                _ = !0;
              }), h === void 0 && (h = i(
                /*! ./end-of-stream */
                "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/end-of-stream.js"
              )), h(R, {
                readable: y,
                writable: E
              }, function(D) {
                if (D)
                  return L(D);
                _ = !0, L();
              });
              var O = !1;
              return function(D) {
                if (!_ && !O) {
                  if (O = !0, m(R))
                    return R.abort();
                  if (typeof R.destroy == "function")
                    return R.destroy();
                  L(D || new v("pipe"));
                }
              };
            }
            function b(R) {
              R();
            }
            function S(R, y) {
              return R.pipe(y);
            }
            function N(R) {
              return !R.length || typeof R[R.length - 1] != "function" ? g : R.pop();
            }
            function T() {
              for (var R = arguments.length, y = new Array(R), E = 0; E < R; E++)
                y[E] = arguments[E];
              var L = N(y);
              if (Array.isArray(y[0]) && (y = y[0]), y.length < 2)
                throw new d("streams");
              var _, O = y.map(function(D, M) {
                var C = M < y.length - 1, I = M > 0;
                return A(D, C, I, function(w) {
                  _ || (_ = w), w && O.forEach(b), !C && (O.forEach(b), L(_));
                });
              });
              return y.reduce(S);
            }
            c.exports = T;
          }
        ),
        /***/
        "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/state.js": (
          /*!***************************************************************************************************!*\
            !*** ./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/state.js ***!
            \***************************************************************************************************/
          /***/
          (c, l, i) => {
            var h = i(
              /*! ../../../errors */
              "./node_modules/stream-browserify/node_modules/readable-stream/errors-browser.js"
            ).codes.ERR_INVALID_OPT_VALUE;
            function f(d, v, g) {
              return d.highWaterMark != null ? d.highWaterMark : v ? d[g] : null;
            }
            function p(d, v, g, m) {
              var A = f(v, m, g);
              if (A != null) {
                if (!(isFinite(A) && Math.floor(A) === A) || A < 0) {
                  var b = m ? g : "highWaterMark";
                  throw new h(b, A);
                }
                return Math.floor(A);
              }
              return d.objectMode ? 16 : 16384;
            }
            c.exports = {
              getHighWaterMark: p
            };
          }
        ),
        /***/
        "./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/stream-browser.js": (
          /*!************************************************************************************************************!*\
            !*** ./node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/stream-browser.js ***!
            \************************************************************************************************************/
          /***/
          (c, l, i) => {
            c.exports = i(
              /*! events */
              "./node_modules/events/events.js"
            ).EventEmitter;
          }
        ),
        /***/
        "./node_modules/string_decoder/lib/string_decoder.js": (
          /*!***********************************************************!*\
            !*** ./node_modules/string_decoder/lib/string_decoder.js ***!
            \***********************************************************/
          /***/
          (c, l, i) => {
            var h = i(
              /*! safe-buffer */
              "./node_modules/safe-buffer/index.js"
            ).Buffer, f = h.isEncoding || function(O) {
              switch (O = "" + O, O && O.toLowerCase()) {
                case "hex":
                case "utf8":
                case "utf-8":
                case "ascii":
                case "binary":
                case "base64":
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                case "raw":
                  return !0;
                default:
                  return !1;
              }
            };
            function p(O) {
              if (!O)
                return "utf8";
              for (var D; ; )
                switch (O) {
                  case "utf8":
                  case "utf-8":
                    return "utf8";
                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return "utf16le";
                  case "latin1":
                  case "binary":
                    return "latin1";
                  case "base64":
                  case "ascii":
                  case "hex":
                    return O;
                  default:
                    if (D)
                      return;
                    O = ("" + O).toLowerCase(), D = !0;
                }
            }
            function d(O) {
              var D = p(O);
              if (typeof D != "string" && (h.isEncoding === f || !f(O)))
                throw new Error("Unknown encoding: " + O);
              return D || O;
            }
            l.StringDecoder = v;
            function v(O) {
              this.encoding = d(O);
              var D;
              switch (this.encoding) {
                case "utf16le":
                  this.text = T, this.end = R, D = 4;
                  break;
                case "utf8":
                  this.fillLast = b, D = 4;
                  break;
                case "base64":
                  this.text = y, this.end = E, D = 3;
                  break;
                default:
                  this.write = L, this.end = _;
                  return;
              }
              this.lastNeed = 0, this.lastTotal = 0, this.lastChar = h.allocUnsafe(D);
            }
            v.prototype.write = function(O) {
              if (O.length === 0)
                return "";
              var D, M;
              if (this.lastNeed) {
                if (D = this.fillLast(O), D === void 0)
                  return "";
                M = this.lastNeed, this.lastNeed = 0;
              } else
                M = 0;
              return M < O.length ? D ? D + this.text(O, M) : this.text(O, M) : D || "";
            }, v.prototype.end = N, v.prototype.text = S, v.prototype.fillLast = function(O) {
              if (this.lastNeed <= O.length)
                return O.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
              O.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, O.length), this.lastNeed -= O.length;
            };
            function g(O) {
              return O <= 127 ? 0 : O >> 5 === 6 ? 2 : O >> 4 === 14 ? 3 : O >> 3 === 30 ? 4 : O >> 6 === 2 ? -1 : -2;
            }
            function m(O, D, M) {
              var C = D.length - 1;
              if (C < M)
                return 0;
              var I = g(D[C]);
              return I >= 0 ? (I > 0 && (O.lastNeed = I - 1), I) : --C < M || I === -2 ? 0 : (I = g(D[C]), I >= 0 ? (I > 0 && (O.lastNeed = I - 2), I) : --C < M || I === -2 ? 0 : (I = g(D[C]), I >= 0 ? (I > 0 && (I === 2 ? I = 0 : O.lastNeed = I - 3), I) : 0));
            }
            function A(O, D, M) {
              if ((D[0] & 192) !== 128)
                return O.lastNeed = 0, "�";
              if (O.lastNeed > 1 && D.length > 1) {
                if ((D[1] & 192) !== 128)
                  return O.lastNeed = 1, "�";
                if (O.lastNeed > 2 && D.length > 2 && (D[2] & 192) !== 128)
                  return O.lastNeed = 2, "�";
              }
            }
            function b(O) {
              var D = this.lastTotal - this.lastNeed, M = A(this, O);
              if (M !== void 0)
                return M;
              if (this.lastNeed <= O.length)
                return O.copy(this.lastChar, D, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
              O.copy(this.lastChar, D, 0, O.length), this.lastNeed -= O.length;
            }
            function S(O, D) {
              var M = m(this, O, D);
              if (!this.lastNeed)
                return O.toString("utf8", D);
              this.lastTotal = M;
              var C = O.length - (M - this.lastNeed);
              return O.copy(this.lastChar, 0, C), O.toString("utf8", D, C);
            }
            function N(O) {
              var D = O && O.length ? this.write(O) : "";
              return this.lastNeed ? D + "�" : D;
            }
            function T(O, D) {
              if ((O.length - D) % 2 === 0) {
                var M = O.toString("utf16le", D);
                if (M) {
                  var C = M.charCodeAt(M.length - 1);
                  if (C >= 55296 && C <= 56319)
                    return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = O[O.length - 2], this.lastChar[1] = O[O.length - 1], M.slice(0, -1);
                }
                return M;
              }
              return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = O[O.length - 1], O.toString("utf16le", D, O.length - 1);
            }
            function R(O) {
              var D = O && O.length ? this.write(O) : "";
              if (this.lastNeed) {
                var M = this.lastTotal - this.lastNeed;
                return D + this.lastChar.toString("utf16le", 0, M);
              }
              return D;
            }
            function y(O, D) {
              var M = (O.length - D) % 3;
              return M === 0 ? O.toString("base64", D) : (this.lastNeed = 3 - M, this.lastTotal = 3, M === 1 ? this.lastChar[0] = O[O.length - 1] : (this.lastChar[0] = O[O.length - 2], this.lastChar[1] = O[O.length - 1]), O.toString("base64", D, O.length - M));
            }
            function E(O) {
              var D = O && O.length ? this.write(O) : "";
              return this.lastNeed ? D + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : D;
            }
            function L(O) {
              return O.toString(this.encoding);
            }
            function _(O) {
              return O && O.length ? this.write(O) : "";
            }
          }
        ),
        /***/
        "./node_modules/ua-parser-js/src/ua-parser.js": (
          /*!****************************************************!*\
            !*** ./node_modules/ua-parser-js/src/ua-parser.js ***!
            \****************************************************/
          /***/
          function(c, l, i) {
            var h;
            (function(f, p) {
              var d = "1.0.2", v = "", g = "?", m = "function", A = "undefined", b = "object", S = "string", N = "major", T = "model", R = "name", y = "type", E = "vendor", L = "version", _ = "architecture", O = "console", D = "mobile", M = "tablet", C = "smarttv", I = "wearable", w = "embedded", F = 255, k = "Amazon", H = "Apple", Z = "ASUS", Y = "BlackBerry", j = "Browser", J = "Chrome", ae = "Edge", G = "Firefox", $ = "Google", ie = "Huawei", re = "LG", ce = "Microsoft", z = "Motorola", oe = "Opera", de = "Samsung", pe = "Sony", he = "Xiaomi", se = "Zebra", ee = "Facebook", te = function(q, _e) {
                var ge = {};
                for (var Ce in q)
                  _e[Ce] && _e[Ce].length % 2 === 0 ? ge[Ce] = _e[Ce].concat(q[Ce]) : ge[Ce] = q[Ce];
                return ge;
              }, le = function(q) {
                for (var _e = {}, ge = 0; ge < q.length; ge++)
                  _e[q[ge].toUpperCase()] = q[ge];
                return _e;
              }, ne = function(q, _e) {
                return typeof q === S ? x(_e).indexOf(x(q)) !== -1 : !1;
              }, x = function(q) {
                return q.toLowerCase();
              }, P = function(q) {
                return typeof q === S ? q.replace(/[^\d\.]/g, v).split(".")[0] : p;
              }, B = function(q, _e) {
                if (typeof q === S)
                  return q = q.replace(/^\s\s*/, v).replace(/\s\s*$/, v), typeof _e === A ? q : q.substring(0, F);
              }, W = function(q, _e) {
                for (var ge = 0, Ce, Ee, Re, Pe, ke, De; ge < _e.length && !ke; ) {
                  var Ae = _e[ge], Ie = _e[ge + 1];
                  for (Ce = Ee = 0; Ce < Ae.length && !ke; )
                    if (ke = Ae[Ce++].exec(q), ke)
                      for (Re = 0; Re < Ie.length; Re++)
                        De = ke[++Ee], Pe = Ie[Re], typeof Pe === b && Pe.length > 0 ? Pe.length === 2 ? typeof Pe[1] == m ? this[Pe[0]] = Pe[1].call(this, De) : this[Pe[0]] = Pe[1] : Pe.length === 3 ? typeof Pe[1] === m && !(Pe[1].exec && Pe[1].test) ? this[Pe[0]] = De ? Pe[1].call(this, De, Pe[2]) : p : this[Pe[0]] = De ? De.replace(Pe[1], Pe[2]) : p : Pe.length === 4 && (this[Pe[0]] = De ? Pe[3].call(this, De.replace(Pe[1], Pe[2])) : p) : this[Pe] = De || p;
                  ge += 2;
                }
              }, X = function(q, _e) {
                for (var ge in _e)
                  if (typeof _e[ge] === b && _e[ge].length > 0) {
                    for (var Ce = 0; Ce < _e[ge].length; Ce++)
                      if (ne(_e[ge][Ce], q))
                        return ge === g ? p : ge;
                  } else if (ne(_e[ge], q))
                    return ge === g ? p : ge;
                return q;
              }, K = {
                "1.0": "/8",
                "1.2": "/1",
                "1.3": "/3",
                "2.0": "/412",
                "2.0.2": "/416",
                "2.0.3": "/417",
                "2.0.4": "/419",
                "?": "/"
              }, U = {
                ME: "4.90",
                "NT 3.11": "NT3.51",
                "NT 4.0": "NT4.0",
                2e3: "NT 5.0",
                XP: ["NT 5.1", "NT 5.2"],
                Vista: "NT 6.0",
                7: "NT 6.1",
                8: "NT 6.2",
                "8.1": "NT 6.3",
                10: ["NT 6.4", "NT 10.0"],
                RT: "ARM"
              }, V = {
                browser: [
                  [
                    /\b(?:crmo|crios)\/([\w\.]+)/i
                    // Chrome for Android/iOS
                  ],
                  [L, [R, "Chrome"]],
                  [
                    /edg(?:e|ios|a)?\/([\w\.]+)/i
                    // Microsoft Edge
                  ],
                  [L, [R, "Edge"]],
                  [
                    // Presto based
                    /(opera mini)\/([-\w\.]+)/i,
                    // Opera Mini
                    /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                    // Opera Mobi/Tablet
                    /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
                    // Opera
                  ],
                  [R, L],
                  [
                    /opios[\/ ]+([\w\.]+)/i
                    // Opera mini on iphone >= 8.0
                  ],
                  [L, [R, oe + " Mini"]],
                  [
                    /\bopr\/([\w\.]+)/i
                    // Opera Webkit
                  ],
                  [L, [R, oe]],
                  [
                    // Mixed
                    /(kindle)\/([\w\.]+)/i,
                    // Kindle
                    /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                    // Lunascape/Maxthon/Netfront/Jasmine/Blazer
                    // Trident based
                    /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,
                    // Avant/IEMobile/SlimBrowser
                    /(ba?idubrowser)[\/ ]?([\w\.]+)/i,
                    // Baidu Browser
                    /(?:ms|\()(ie) ([\w\.]+)/i,
                    // Internet Explorer
                    // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
                    /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([-\w\.]+)/i,
                    // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
                    /(weibo)__([\d\.]+)/i
                    // Weibo
                  ],
                  [R, L],
                  [
                    /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
                    // UCBrowser
                  ],
                  [L, [R, "UC" + j]],
                  [
                    /\bqbcore\/([\w\.]+)/i
                    // WeChat Desktop for Windows Built-in Browser
                  ],
                  [L, [R, "WeChat(Win) Desktop"]],
                  [
                    /micromessenger\/([\w\.]+)/i
                    // WeChat
                  ],
                  [L, [R, "WeChat"]],
                  [
                    /konqueror\/([\w\.]+)/i
                    // Konqueror
                  ],
                  [L, [R, "Konqueror"]],
                  [
                    /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
                    // IE11
                  ],
                  [L, [R, "IE"]],
                  [
                    /yabrowser\/([\w\.]+)/i
                    // Yandex
                  ],
                  [L, [R, "Yandex"]],
                  [
                    /(avast|avg)\/([\w\.]+)/i
                    // Avast/AVG Secure Browser
                  ],
                  [[R, /(.+)/, "$1 Secure " + j], L],
                  [
                    /\bfocus\/([\w\.]+)/i
                    // Firefox Focus
                  ],
                  [L, [R, G + " Focus"]],
                  [
                    /\bopt\/([\w\.]+)/i
                    // Opera Touch
                  ],
                  [L, [R, oe + " Touch"]],
                  [
                    /coc_coc\w+\/([\w\.]+)/i
                    // Coc Coc Browser
                  ],
                  [L, [R, "Coc Coc"]],
                  [
                    /dolfin\/([\w\.]+)/i
                    // Dolphin
                  ],
                  [L, [R, "Dolphin"]],
                  [
                    /coast\/([\w\.]+)/i
                    // Opera Coast
                  ],
                  [L, [R, oe + " Coast"]],
                  [
                    /miuibrowser\/([\w\.]+)/i
                    // MIUI Browser
                  ],
                  [L, [R, "MIUI " + j]],
                  [
                    /fxios\/([-\w\.]+)/i
                    // Firefox for iOS
                  ],
                  [L, [R, G]],
                  [
                    /\bqihu|(qi?ho?o?|360)browser/i
                    // 360
                  ],
                  [[R, "360 " + j]],
                  [
                    /(oculus|samsung|sailfish)browser\/([\w\.]+)/i
                  ],
                  [[R, /(.+)/, "$1 " + j], L],
                  [
                    // Oculus/Samsung/Sailfish Browser
                    /(comodo_dragon)\/([\w\.]+)/i
                    // Comodo Dragon
                  ],
                  [[R, /_/g, " "], L],
                  [
                    /(electron)\/([\w\.]+) safari/i,
                    // Electron-based App
                    /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                    // Tesla
                    /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i
                    // QQBrowser/Baidu App/2345 Browser
                  ],
                  [R, L],
                  [
                    /(metasr)[\/ ]?([\w\.]+)/i,
                    // SouGouBrowser
                    /(lbbrowser)/i
                    // LieBao Browser
                  ],
                  [R],
                  [
                    // WebView
                    /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
                    // Facebook App for iOS & Android
                  ],
                  [[R, ee], L],
                  [
                    /safari (line)\/([\w\.]+)/i,
                    // Line App for iOS
                    /\b(line)\/([\w\.]+)\/iab/i,
                    // Line App for Android
                    /(chromium|instagram)[\/ ]([-\w\.]+)/i
                    // Chromium/Instagram
                  ],
                  [R, L],
                  [
                    /\bgsa\/([\w\.]+) .*safari\//i
                    // Google Search Appliance on iOS
                  ],
                  [L, [R, "GSA"]],
                  [
                    /headlesschrome(?:\/([\w\.]+)| )/i
                    // Chrome Headless
                  ],
                  [L, [R, J + " Headless"]],
                  [
                    / wv\).+(chrome)\/([\w\.]+)/i
                    // Chrome WebView
                  ],
                  [[R, J + " WebView"], L],
                  [
                    /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
                    // Android Browser
                  ],
                  [L, [R, "Android " + j]],
                  [
                    /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
                    // Chrome/OmniWeb/Arora/Tizen/Nokia
                  ],
                  [R, L],
                  [
                    /version\/([\w\.]+) .*mobile\/\w+ (safari)/i
                    // Mobile Safari
                  ],
                  [L, [R, "Mobile Safari"]],
                  [
                    /version\/([\w\.]+) .*(mobile ?safari|safari)/i
                    // Safari & Safari Mobile
                  ],
                  [L, R],
                  [
                    /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
                    // Safari < 3.0
                  ],
                  [R, [L, X, K]],
                  [
                    /(webkit|khtml)\/([\w\.]+)/i
                  ],
                  [R, L],
                  [
                    // Gecko based
                    /(navigator|netscape\d?)\/([-\w\.]+)/i
                    // Netscape
                  ],
                  [[R, "Netscape"], L],
                  [
                    /mobile vr; rv:([\w\.]+)\).+firefox/i
                    // Firefox Reality
                  ],
                  [L, [R, G + " Reality"]],
                  [
                    /ekiohf.+(flow)\/([\w\.]+)/i,
                    // Flow
                    /(swiftfox)/i,
                    // Swiftfox
                    /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                    // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
                    /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                    // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
                    /(firefox)\/([\w\.]+)/i,
                    // Other Firefox-based
                    /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                    // Mozilla
                    // Other
                    /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                    // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
                    /(links) \(([\w\.]+)/i
                    // Links
                  ],
                  [R, L]
                ],
                cpu: [
                  [
                    /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
                    // AMD64 (x64)
                  ],
                  [[_, "amd64"]],
                  [
                    /(ia32(?=;))/i
                    // IA32 (quicktime)
                  ],
                  [[_, x]],
                  [
                    /((?:i[346]|x)86)[;\)]/i
                    // IA32 (x86)
                  ],
                  [[_, "ia32"]],
                  [
                    /\b(aarch64|arm(v?8e?l?|_?64))\b/i
                    // ARM64
                  ],
                  [[_, "arm64"]],
                  [
                    /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
                    // ARMHF
                  ],
                  [[_, "armhf"]],
                  [
                    // PocketPC mistakenly identified as PowerPC
                    /windows (ce|mobile); ppc;/i
                  ],
                  [[_, "arm"]],
                  [
                    /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
                    // PowerPC
                  ],
                  [[_, /ower/, v, x]],
                  [
                    /(sun4\w)[;\)]/i
                    // SPARC
                  ],
                  [[_, "sparc"]],
                  [
                    /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
                    // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
                  ],
                  [[_, x]]
                ],
                device: [
                  [
                    //////////////////////////
                    // MOBILES & TABLETS
                    // Ordered by popularity
                    /////////////////////////
                    // Samsung
                    /\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
                  ],
                  [T, [E, de], [y, M]],
                  [
                    /\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i,
                    /samsung[- ]([-\w]+)/i,
                    /sec-(sgh\w+)/i
                  ],
                  [T, [E, de], [y, D]],
                  [
                    // Apple
                    /\((ip(?:hone|od)[\w ]*);/i
                    // iPod/iPhone
                  ],
                  [T, [E, H], [y, D]],
                  [
                    /\((ipad);[-\w\),; ]+apple/i,
                    // iPad
                    /applecoremedia\/[\w\.]+ \((ipad)/i,
                    /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
                  ],
                  [T, [E, H], [y, M]],
                  [
                    // Huawei
                    /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
                  ],
                  [T, [E, ie], [y, M]],
                  [
                    /(?:huawei|honor)([-\w ]+)[;\)]/i,
                    /\b(nexus 6p|\w{2,4}-[atu]?[ln][01259x][012359][an]?)\b(?!.+d\/s)/i
                  ],
                  [T, [E, ie], [y, D]],
                  [
                    // Xiaomi
                    /\b(poco[\w ]+)(?: bui|\))/i,
                    // Xiaomi POCO
                    /\b; (\w+) build\/hm\1/i,
                    // Xiaomi Hongmi 'numeric' models
                    /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                    // Xiaomi Hongmi
                    /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                    // Xiaomi Redmi
                    /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
                    // Xiaomi Mi
                  ],
                  [[T, /_/g, " "], [E, he], [y, D]],
                  [
                    /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
                    // Mi Pad tablets
                  ],
                  [[T, /_/g, " "], [E, he], [y, M]],
                  [
                    // OPPO
                    /; (\w+) bui.+ oppo/i,
                    /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
                  ],
                  [T, [E, "OPPO"], [y, D]],
                  [
                    // Vivo
                    /vivo (\w+)(?: bui|\))/i,
                    /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
                  ],
                  [T, [E, "Vivo"], [y, D]],
                  [
                    // Realme
                    /\b(rmx[12]\d{3})(?: bui|;|\))/i
                  ],
                  [T, [E, "Realme"], [y, D]],
                  [
                    // Motorola
                    /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                    /\bmot(?:orola)?[- ](\w*)/i,
                    /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
                  ],
                  [T, [E, z], [y, D]],
                  [
                    /\b(mz60\d|xoom[2 ]{0,2}) build\//i
                  ],
                  [T, [E, z], [y, M]],
                  [
                    // LG
                    /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
                  ],
                  [T, [E, re], [y, M]],
                  [
                    /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                    /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                    /\blg-?([\d\w]+) bui/i
                  ],
                  [T, [E, re], [y, D]],
                  [
                    // Lenovo
                    /(ideatab[-\w ]+)/i,
                    /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
                  ],
                  [T, [E, "Lenovo"], [y, M]],
                  [
                    // Nokia
                    /(?:maemo|nokia).*(n900|lumia \d+)/i,
                    /nokia[-_ ]?([-\w\.]*)/i
                  ],
                  [[T, /_/g, " "], [E, "Nokia"], [y, D]],
                  [
                    // Google
                    /(pixel c)\b/i
                    // Google Pixel C
                  ],
                  [T, [E, $], [y, M]],
                  [
                    /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
                    // Google Pixel
                  ],
                  [T, [E, $], [y, D]],
                  [
                    // Sony
                    /droid.+ ([c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
                  ],
                  [T, [E, pe], [y, D]],
                  [
                    /sony tablet [ps]/i,
                    /\b(?:sony)?sgp\w+(?: bui|\))/i
                  ],
                  [[T, "Xperia Tablet"], [E, pe], [y, M]],
                  [
                    // OnePlus
                    / (kb2005|in20[12]5|be20[12][59])\b/i,
                    /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
                  ],
                  [T, [E, "OnePlus"], [y, D]],
                  [
                    // Amazon
                    /(alexa)webm/i,
                    /(kf[a-z]{2}wi)( bui|\))/i,
                    // Kindle Fire without Silk
                    /(kf[a-z]+)( bui|\)).+silk\//i
                    // Kindle Fire HD
                  ],
                  [T, [E, k], [y, M]],
                  [
                    /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
                    // Fire Phone
                  ],
                  [[T, /(.+)/g, "Fire Phone $1"], [E, k], [y, D]],
                  [
                    // BlackBerry
                    /(playbook);[-\w\),; ]+(rim)/i
                    // BlackBerry PlayBook
                  ],
                  [T, E, [y, M]],
                  [
                    /\b((?:bb[a-f]|st[hv])100-\d)/i,
                    /\(bb10; (\w+)/i
                    // BlackBerry 10
                  ],
                  [T, [E, Y], [y, D]],
                  [
                    // Asus
                    /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
                  ],
                  [T, [E, Z], [y, M]],
                  [
                    / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
                  ],
                  [T, [E, Z], [y, D]],
                  [
                    // HTC
                    /(nexus 9)/i
                    // HTC Nexus 9
                  ],
                  [T, [E, "HTC"], [y, M]],
                  [
                    /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                    // HTC
                    // ZTE
                    /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                    /(alcatel|geeksphone|nexian|panasonic|sony)[-_ ]?([-\w]*)/i
                    // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
                  ],
                  [E, [T, /_/g, " "], [y, D]],
                  [
                    // Acer
                    /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
                  ],
                  [T, [E, "Acer"], [y, M]],
                  [
                    // Meizu
                    /droid.+; (m[1-5] note) bui/i,
                    /\bmz-([-\w]{2,})/i
                  ],
                  [T, [E, "Meizu"], [y, D]],
                  [
                    // Sharp
                    /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
                  ],
                  [T, [E, "Sharp"], [y, D]],
                  [
                    // MIXED
                    /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
                    // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
                    /(hp) ([\w ]+\w)/i,
                    // HP iPAQ
                    /(asus)-?(\w+)/i,
                    // Asus
                    /(microsoft); (lumia[\w ]+)/i,
                    // Microsoft Lumia
                    /(lenovo)[-_ ]?([-\w]+)/i,
                    // Lenovo
                    /(jolla)/i,
                    // Jolla
                    /(oppo) ?([\w ]+) bui/i
                    // OPPO
                  ],
                  [E, T, [y, D]],
                  [
                    /(archos) (gamepad2?)/i,
                    // Archos
                    /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                    // HP TouchPad
                    /(kindle)\/([\w\.]+)/i,
                    // Kindle
                    /(nook)[\w ]+build\/(\w+)/i,
                    // Nook
                    /(dell) (strea[kpr\d ]*[\dko])/i,
                    // Dell Streak
                    /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                    // Le Pan Tablets
                    /(trinity)[- ]*(t\d{3}) bui/i,
                    // Trinity Tablets
                    /(gigaset)[- ]+(q\w{1,9}) bui/i,
                    // Gigaset Tablets
                    /(vodafone) ([\w ]+)(?:\)| bui)/i
                    // Vodafone
                  ],
                  [E, T, [y, M]],
                  [
                    /(surface duo)/i
                    // Surface Duo
                  ],
                  [T, [E, ce], [y, M]],
                  [
                    /droid [\d\.]+; (fp\du?)(?: b|\))/i
                    // Fairphone
                  ],
                  [T, [E, "Fairphone"], [y, D]],
                  [
                    /(u304aa)/i
                    // AT&T
                  ],
                  [T, [E, "AT&T"], [y, D]],
                  [
                    /\bsie-(\w*)/i
                    // Siemens
                  ],
                  [T, [E, "Siemens"], [y, D]],
                  [
                    /\b(rct\w+) b/i
                    // RCA Tablets
                  ],
                  [T, [E, "RCA"], [y, M]],
                  [
                    /\b(venue[\d ]{2,7}) b/i
                    // Dell Venue Tablets
                  ],
                  [T, [E, "Dell"], [y, M]],
                  [
                    /\b(q(?:mv|ta)\w+) b/i
                    // Verizon Tablet
                  ],
                  [T, [E, "Verizon"], [y, M]],
                  [
                    /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
                    // Barnes & Noble Tablet
                  ],
                  [T, [E, "Barnes & Noble"], [y, M]],
                  [
                    /\b(tm\d{3}\w+) b/i
                  ],
                  [T, [E, "NuVision"], [y, M]],
                  [
                    /\b(k88) b/i
                    // ZTE K Series Tablet
                  ],
                  [T, [E, "ZTE"], [y, M]],
                  [
                    /\b(nx\d{3}j) b/i
                    // ZTE Nubia
                  ],
                  [T, [E, "ZTE"], [y, D]],
                  [
                    /\b(gen\d{3}) b.+49h/i
                    // Swiss GEN Mobile
                  ],
                  [T, [E, "Swiss"], [y, D]],
                  [
                    /\b(zur\d{3}) b/i
                    // Swiss ZUR Tablet
                  ],
                  [T, [E, "Swiss"], [y, M]],
                  [
                    /\b((zeki)?tb.*\b) b/i
                    // Zeki Tablets
                  ],
                  [T, [E, "Zeki"], [y, M]],
                  [
                    /\b([yr]\d{2}) b/i,
                    /\b(dragon[- ]+touch |dt)(\w{5}) b/i
                    // Dragon Touch Tablet
                  ],
                  [[E, "Dragon Touch"], T, [y, M]],
                  [
                    /\b(ns-?\w{0,9}) b/i
                    // Insignia Tablets
                  ],
                  [T, [E, "Insignia"], [y, M]],
                  [
                    /\b((nxa|next)-?\w{0,9}) b/i
                    // NextBook Tablets
                  ],
                  [T, [E, "NextBook"], [y, M]],
                  [
                    /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
                    // Voice Xtreme Phones
                  ],
                  [[E, "Voice"], T, [y, D]],
                  [
                    /\b(lvtel\-)?(v1[12]) b/i
                    // LvTel Phones
                  ],
                  [[E, "LvTel"], T, [y, D]],
                  [
                    /\b(ph-1) /i
                    // Essential PH-1
                  ],
                  [T, [E, "Essential"], [y, D]],
                  [
                    /\b(v(100md|700na|7011|917g).*\b) b/i
                    // Envizen Tablets
                  ],
                  [T, [E, "Envizen"], [y, M]],
                  [
                    /\b(trio[-\w\. ]+) b/i
                    // MachSpeed Tablets
                  ],
                  [T, [E, "MachSpeed"], [y, M]],
                  [
                    /\btu_(1491) b/i
                    // Rotor Tablets
                  ],
                  [T, [E, "Rotor"], [y, M]],
                  [
                    /(shield[\w ]+) b/i
                    // Nvidia Shield Tablets
                  ],
                  [T, [E, "Nvidia"], [y, M]],
                  [
                    /(sprint) (\w+)/i
                    // Sprint Phones
                  ],
                  [E, T, [y, D]],
                  [
                    /(kin\.[onetw]{3})/i
                    // Microsoft Kin
                  ],
                  [[T, /\./g, " "], [E, ce], [y, D]],
                  [
                    /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
                    // Zebra
                  ],
                  [T, [E, se], [y, M]],
                  [
                    /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
                  ],
                  [T, [E, se], [y, D]],
                  [
                    ///////////////////
                    // CONSOLES
                    ///////////////////
                    /(ouya)/i,
                    // Ouya
                    /(nintendo) ([wids3utch]+)/i
                    // Nintendo
                  ],
                  [E, T, [y, O]],
                  [
                    /droid.+; (shield) bui/i
                    // Nvidia
                  ],
                  [T, [E, "Nvidia"], [y, O]],
                  [
                    /(playstation [345portablevi]+)/i
                    // Playstation
                  ],
                  [T, [E, pe], [y, O]],
                  [
                    /\b(xbox(?: one)?(?!; xbox))[\); ]/i
                    // Microsoft Xbox
                  ],
                  [T, [E, ce], [y, O]],
                  [
                    ///////////////////
                    // SMARTTVS
                    ///////////////////
                    /smart-tv.+(samsung)/i
                    // Samsung
                  ],
                  [E, [y, C]],
                  [
                    /hbbtv.+maple;(\d+)/i
                  ],
                  [[T, /^/, "SmartTV"], [E, de], [y, C]],
                  [
                    /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
                    // LG SmartTV
                  ],
                  [[E, re], [y, C]],
                  [
                    /(apple) ?tv/i
                    // Apple TV
                  ],
                  [E, [T, H + " TV"], [y, C]],
                  [
                    /crkey/i
                    // Google Chromecast
                  ],
                  [[T, J + "cast"], [E, $], [y, C]],
                  [
                    /droid.+aft(\w)( bui|\))/i
                    // Fire TV
                  ],
                  [T, [E, k], [y, C]],
                  [
                    /\(dtv[\);].+(aquos)/i
                    // Sharp
                  ],
                  [T, [E, "Sharp"], [y, C]],
                  [
                    /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                    // Roku
                    /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i
                    // HbbTV devices
                  ],
                  [[E, B], [T, B], [y, C]],
                  [
                    /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
                    // SmartTV from Unidentified Vendors
                  ],
                  [[y, C]],
                  [
                    ///////////////////
                    // WEARABLES
                    ///////////////////
                    /((pebble))app/i
                    // Pebble
                  ],
                  [E, T, [y, I]],
                  [
                    /droid.+; (glass) \d/i
                    // Google Glass
                  ],
                  [T, [E, $], [y, I]],
                  [
                    /droid.+; (wt63?0{2,3})\)/i
                  ],
                  [T, [E, se], [y, I]],
                  [
                    /(quest( 2)?)/i
                    // Oculus Quest
                  ],
                  [T, [E, ee], [y, I]],
                  [
                    ///////////////////
                    // EMBEDDED
                    ///////////////////
                    /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
                    // Tesla
                  ],
                  [E, [y, w]],
                  [
                    ////////////////////
                    // MIXED (GENERIC)
                    ///////////////////
                    /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i
                    // Android Phones from Unidentified Vendors
                  ],
                  [T, [y, D]],
                  [
                    /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
                    // Android Tablets from Unidentified Vendors
                  ],
                  [T, [y, M]],
                  [
                    /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
                    // Unidentifiable Tablet
                  ],
                  [[y, M]],
                  [
                    /(phone|mobile(?:[;\/]| safari)|pda(?=.+windows ce))/i
                    // Unidentifiable Mobile
                  ],
                  [[y, D]],
                  [
                    /(android[-\w\. ]{0,9});.+buil/i
                    // Generic Android Device
                  ],
                  [T, [E, "Generic"]]
                ],
                engine: [
                  [
                    /windows.+ edge\/([\w\.]+)/i
                    // EdgeHTML
                  ],
                  [L, [R, ae + "HTML"]],
                  [
                    /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
                    // Blink
                  ],
                  [L, [R, "Blink"]],
                  [
                    /(presto)\/([\w\.]+)/i,
                    // Presto
                    /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                    // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
                    /ekioh(flow)\/([\w\.]+)/i,
                    // Flow
                    /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                    // KHTML/Tasman/Links
                    /(icab)[\/ ]([23]\.[\d\.]+)/i
                    // iCab
                  ],
                  [R, L],
                  [
                    /rv\:([\w\.]{1,9})\b.+(gecko)/i
                    // Gecko
                  ],
                  [L, R]
                ],
                os: [
                  [
                    // Windows
                    /microsoft (windows) (vista|xp)/i
                    // Windows (iTunes)
                  ],
                  [R, L],
                  [
                    /(windows) nt 6\.2; (arm)/i,
                    // Windows RT
                    /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,
                    // Windows Phone
                    /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
                  ],
                  [R, [L, X, U]],
                  [
                    /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
                  ],
                  [[R, "Windows"], [L, X, U]],
                  [
                    // iOS/macOS
                    /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                    // iOS
                    /cfnetwork\/.+darwin/i
                  ],
                  [[L, /_/g, "."], [R, "iOS"]],
                  [
                    /(mac os x) ?([\w\. ]*)/i,
                    /(macintosh|mac_powerpc\b)(?!.+haiku)/i
                    // Mac OS
                  ],
                  [[R, "Mac OS"], [L, /_/g, "."]],
                  [
                    // Mobile OSes
                    /droid ([\w\.]+)\b.+(android[- ]x86)/i
                    // Android-x86
                  ],
                  [L, R],
                  [
                    // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
                    /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                    /(blackberry)\w*\/([\w\.]*)/i,
                    // Blackberry
                    /(tizen|kaios)[\/ ]([\w\.]+)/i,
                    // Tizen/KaiOS
                    /\((series40);/i
                    // Series 40
                  ],
                  [R, L],
                  [
                    /\(bb(10);/i
                    // BlackBerry 10
                  ],
                  [L, [R, Y]],
                  [
                    /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
                    // Symbian
                  ],
                  [L, [R, "Symbian"]],
                  [
                    /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
                    // Firefox OS
                  ],
                  [L, [R, G + " OS"]],
                  [
                    /web0s;.+rt(tv)/i,
                    /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
                    // WebOS
                  ],
                  [L, [R, "webOS"]],
                  [
                    // Google Chromecast
                    /crkey\/([\d\.]+)/i
                    // Google Chromecast
                  ],
                  [L, [R, J + "cast"]],
                  [
                    /(cros) [\w]+ ([\w\.]+\w)/i
                    // Chromium OS
                  ],
                  [[R, "Chromium OS"], L],
                  [
                    // Console
                    /(nintendo|playstation) ([wids345portablevuch]+)/i,
                    // Nintendo/Playstation
                    /(xbox); +xbox ([^\);]+)/i,
                    // Microsoft Xbox (360, One, X, S, Series X, Series S)
                    // Other
                    /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                    // Joli/Palm
                    /(mint)[\/\(\) ]?(\w*)/i,
                    // Mint
                    /(mageia|vectorlinux)[; ]/i,
                    // Mageia/VectorLinux
                    /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                    // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
                    /(hurd|linux) ?([\w\.]*)/i,
                    // Hurd/Linux
                    /(gnu) ?([\w\.]*)/i,
                    // GNU
                    /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                    // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
                    /(haiku) (\w+)/i
                    // Haiku
                  ],
                  [R, L],
                  [
                    /(sunos) ?([\w\.\d]*)/i
                    // Solaris
                  ],
                  [[R, "Solaris"], L],
                  [
                    /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                    // Solaris
                    /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                    // AIX
                    /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i,
                    // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX
                    /(unix) ?([\w\.]*)/i
                    // UNIX
                  ],
                  [R, L]
                ]
              }, Q = function(q, _e) {
                if (typeof q === b && (_e = q, q = p), !(this instanceof Q))
                  return new Q(q, _e).getResult();
                var ge = q || (typeof f !== A && f.navigator && f.navigator.userAgent ? f.navigator.userAgent : v), Ce = _e ? te(V, _e) : V;
                return this.getBrowser = function() {
                  var Ee = {};
                  return Ee[R] = p, Ee[L] = p, W.call(Ee, ge, Ce.browser), Ee.major = P(Ee.version), Ee;
                }, this.getCPU = function() {
                  var Ee = {};
                  return Ee[_] = p, W.call(Ee, ge, Ce.cpu), Ee;
                }, this.getDevice = function() {
                  var Ee = {};
                  return Ee[E] = p, Ee[T] = p, Ee[y] = p, W.call(Ee, ge, Ce.device), Ee;
                }, this.getEngine = function() {
                  var Ee = {};
                  return Ee[R] = p, Ee[L] = p, W.call(Ee, ge, Ce.engine), Ee;
                }, this.getOS = function() {
                  var Ee = {};
                  return Ee[R] = p, Ee[L] = p, W.call(Ee, ge, Ce.os), Ee;
                }, this.getResult = function() {
                  return {
                    ua: this.getUA(),
                    browser: this.getBrowser(),
                    engine: this.getEngine(),
                    os: this.getOS(),
                    device: this.getDevice(),
                    cpu: this.getCPU()
                  };
                }, this.getUA = function() {
                  return ge;
                }, this.setUA = function(Ee) {
                  return ge = typeof Ee === S && Ee.length > F ? B(Ee, F) : Ee, this;
                }, this.setUA(ge), this;
              };
              Q.VERSION = d, Q.BROWSER = le([R, L, N]), Q.CPU = le([_]), Q.DEVICE = le([T, E, y, O, D, C, M, I, w]), Q.ENGINE = Q.OS = le([R, L]), typeof l !== A ? (c.exports && (l = c.exports = Q), l.UAParser = Q) : i.amdO ? (h = (function() {
                return Q;
              }).call(l, i, l, c), h !== p && (c.exports = h)) : typeof f !== A && (f.UAParser = Q);
              var fe = typeof f !== A && (f.jQuery || f.Zepto);
              if (fe && !fe.ua) {
                var ue = new Q();
                fe.ua = ue.getResult(), fe.ua.get = function() {
                  return ue.getUA();
                }, fe.ua.set = function(q) {
                  ue.setUA(q);
                  var _e = ue.getResult();
                  for (var ge in _e)
                    fe.ua[ge] = _e[ge];
                };
              }
            })(typeof window == "object" ? window : this);
          }
        ),
        /***/
        "./node_modules/util-deprecate/browser.js": (
          /*!************************************************!*\
            !*** ./node_modules/util-deprecate/browser.js ***!
            \************************************************/
          /***/
          (c, l, i) => {
            c.exports = h;
            function h(p, d) {
              if (f("noDeprecation"))
                return p;
              var v = !1;
              function g() {
                if (!v) {
                  if (f("throwDeprecation"))
                    throw new Error(d);
                  f("traceDeprecation") ? console.trace(d) : console.warn(d), v = !0;
                }
                return p.apply(this, arguments);
              }
              return g;
            }
            function f(p) {
              try {
                if (!i.g.localStorage)
                  return !1;
              } catch {
                return !1;
              }
              var d = i.g.localStorage[p];
              return d == null ? !1 : String(d).toLowerCase() === "true";
            }
          }
        ),
        /***/
        "?3e83": (
          /*!**********************!*\
            !*** util (ignored) ***!
            \**********************/
          /***/
          () => {
          }
        ),
        /***/
        "?19e6": (
          /*!**********************!*\
            !*** util (ignored) ***!
            \**********************/
          /***/
          () => {
          }
        ),
        /***/
        "./node_modules/bcp-47-normalize/lib/defaults.json": (
          /*!*********************************************************!*\
            !*** ./node_modules/bcp-47-normalize/lib/defaults.json ***!
            \*********************************************************/
          /***/
          (c) => {
            c.exports = JSON.parse('["mni-beng-in","mni-mtei-in","sat-deva-in","sat-olck-in","shi-latn-ma","shi-tfng-ma","vai-latn-lr","vai-vaii-lr","yue-hans-cn","yue-hant-hk","az-arab-ir","az-cyrl-az","az-latn-az","bm-nkoo-ml","bs-cyrl-ba","bs-latn-ba","en-dsrt-us","ff-adlm-gn","ff-latn-sn","ha-arab-ng","hi-latn-in","iu-latn-ca","ks-arab-in","ks-deva-in","mn-mong-cn","ms-arab-my","pa-arab-pk","pa-guru-in","sd-arab-pk","sd-deva-in","sr-cyrl-rs","sr-latn-rs","su-latn-id","uz-arab-af","uz-cyrl-uz","uz-latn-uz","zh-hans-cn","zh-hant-tw","mni-beng","sat-olck","shi-tfng","vai-vaii","yue-hant","az-latn","bs-latn","ff-latn","jbo-001","ks-arab","pa-guru","prg-001","sd-arab","sr-cyrl","su-latn","uz-latn","zh-hans","agq-cm","ar-001","arn-cl","asa-tz","ast-es","bas-cm","bem-zm","bez-tz","bgn-pk","blt-vn","brx-in","bss-cm","byn-er","cad-us","cch-ng","ccp-bd","ceb-ph","cgg-ug","chr-us","cic-us","ckb-iq","dav-ke","dje-ne","doi-in","dsb-de","dua-cm","dyo-sn","ebu-ke","eo-001","ewo-cm","fil-ph","fur-it","gaa-gh","gez-et","gsw-ch","guz-ke","haw-us","hsb-de","ia-001","ife-tg","io-001","jgo-cm","jmc-tz","kab-dz","kaj-ng","kam-ke","kcg-ng","kde-tz","kea-cv","ken-cm","khq-ml","kkj-cm","kln-ke","kok-in","kpe-lr","ksb-tz","ksf-cm","ksh-de","lag-tz","lkt-us","lrc-ir","luo-ke","luy-ke","mai-in","mas-ke","mer-ke","mfe-mu","mgh-mz","mgo-cm","moh-ca","mua-cm","mus-us","myv-ru","mzn-ir","naq-na","nds-de","nmg-cm","nnh-cm","nqo-gn","nso-za","nus-ss","nyn-ug","osa-us","pcm-ng","quc-gt","rof-tz","rwk-tz","sah-ru","saq-ke","sbp-tz","scn-it","sdh-ir","seh-mz","ses-ml","sid-et","sma-se","smj-se","smn-fi","sms-fi","ssy-er","syr-iq","szl-pl","teo-ug","tig-er","trv-tw","trw-pk","twq-ne","tzm-ma","vo-001","vun-tz","wae-ch","wal-et","wbp-au","xog-ug","yav-cm","yi-001","zgh-ma","aa-et","af-za","ak-gh","am-et","an-es","as-in","ba-ru","be-by","bg-bg","bm-ml","bn-bd","bo-cn","br-fr","ca-es","ce-ru","co-fr","cs-cz","cu-ru","cv-ru","cy-gb","da-dk","de-de","dv-mv","dz-bt","ee-gh","el-gr","en-us","es-es","et-ee","eu-es","fa-ir","fi-fi","fo-fo","fr-fr","fy-nl","ga-ie","gd-gb","gl-es","gn-py","gu-in","gv-im","ha-ng","he-il","hi-in","hr-hr","hu-hu","hy-am","id-id","ig-ng","ii-cn","is-is","it-it","iu-ca","ja-jp","jv-id","ka-ge","ki-ke","kk-kz","kl-gl","km-kh","kn-in","ko-kr","ku-tr","kw-gb","ky-kg","lb-lu","lg-ug","ln-cd","lo-la","lt-lt","lu-cd","lv-lv","mg-mg","mi-nz","mk-mk","ml-in","mn-mn","mr-in","ms-my","mt-mt","my-mm","nb-no","nd-zw","ne-np","nl-nl","nn-no","nr-za","nv-us","ny-mw","oc-fr","om-et","or-in","os-ge","pl-pl","ps-af","pt-br","qu-pe","rm-ch","rn-bi","ro-ro","ru-ru","rw-rw","sa-in","sc-it","se-no","sg-cf","si-lk","sk-sk","sl-si","sn-zw","so-so","sq-al","ss-za","st-za","sv-se","sw-tz","ta-in","te-in","tg-tj","th-th","ti-et","tk-tm","tn-za","to-to","tr-tr","ts-za","tt-ru","ug-cn","uk-ua","ur-pk","ve-za","vi-vn","wa-be","wo-sn","xh-za","yo-ng","zu-za"]');
          }
        ),
        /***/
        "./node_modules/bcp-47-normalize/lib/fields.json": (
          /*!*******************************************************!*\
            !*** ./node_modules/bcp-47-normalize/lib/fields.json ***!
            \*******************************************************/
          /***/
          (c) => {
            c.exports = JSON.parse('[{"from":{"field":"script","value":"qaai"},"to":{"field":"script","value":"zinh"}},{"from":{"field":"region","value":"bu"},"to":{"field":"region","value":"mm"}},{"from":{"field":"region","value":"ct"},"to":{"field":"region","value":"ki"}},{"from":{"field":"region","value":"dd"},"to":{"field":"region","value":"de"}},{"from":{"field":"region","value":"dy"},"to":{"field":"region","value":"bj"}},{"from":{"field":"region","value":"fx"},"to":{"field":"region","value":"fr"}},{"from":{"field":"region","value":"hv"},"to":{"field":"region","value":"bf"}},{"from":{"field":"region","value":"jt"},"to":{"field":"region","value":"um"}},{"from":{"field":"region","value":"mi"},"to":{"field":"region","value":"um"}},{"from":{"field":"region","value":"nh"},"to":{"field":"region","value":"vu"}},{"from":{"field":"region","value":"nq"},"to":{"field":"region","value":"aq"}},{"from":{"field":"region","value":"pu"},"to":{"field":"region","value":"um"}},{"from":{"field":"region","value":"pz"},"to":{"field":"region","value":"pa"}},{"from":{"field":"region","value":"qu"},"to":{"field":"region","value":"eu"}},{"from":{"field":"region","value":"rh"},"to":{"field":"region","value":"zw"}},{"from":{"field":"region","value":"tp"},"to":{"field":"region","value":"tl"}},{"from":{"field":"region","value":"uk"},"to":{"field":"region","value":"gb"}},{"from":{"field":"region","value":"vd"},"to":{"field":"region","value":"vn"}},{"from":{"field":"region","value":"wk"},"to":{"field":"region","value":"um"}},{"from":{"field":"region","value":"yd"},"to":{"field":"region","value":"ye"}},{"from":{"field":"region","value":"zr"},"to":{"field":"region","value":"cd"}},{"from":{"field":"region","value":"230"},"to":{"field":"region","value":"et"}},{"from":{"field":"region","value":"280"},"to":{"field":"region","value":"de"}},{"from":{"field":"region","value":"736"},"to":{"field":"region","value":"sd"}},{"from":{"field":"region","value":"886"},"to":{"field":"region","value":"ye"}},{"from":{"field":"region","value":"958"},"to":{"field":"region","value":"aa"}},{"from":{"field":"region","value":"020"},"to":{"field":"region","value":"ad"}},{"from":{"field":"region","value":"784"},"to":{"field":"region","value":"ae"}},{"from":{"field":"region","value":"004"},"to":{"field":"region","value":"af"}},{"from":{"field":"region","value":"028"},"to":{"field":"region","value":"ag"}},{"from":{"field":"region","value":"660"},"to":{"field":"region","value":"ai"}},{"from":{"field":"region","value":"008"},"to":{"field":"region","value":"al"}},{"from":{"field":"region","value":"051"},"to":{"field":"region","value":"am"}},{"from":{"field":"region","value":"024"},"to":{"field":"region","value":"ao"}},{"from":{"field":"region","value":"010"},"to":{"field":"region","value":"aq"}},{"from":{"field":"region","value":"032"},"to":{"field":"region","value":"ar"}},{"from":{"field":"region","value":"016"},"to":{"field":"region","value":"as"}},{"from":{"field":"region","value":"040"},"to":{"field":"region","value":"at"}},{"from":{"field":"region","value":"036"},"to":{"field":"region","value":"au"}},{"from":{"field":"region","value":"533"},"to":{"field":"region","value":"aw"}},{"from":{"field":"region","value":"248"},"to":{"field":"region","value":"ax"}},{"from":{"field":"region","value":"031"},"to":{"field":"region","value":"az"}},{"from":{"field":"region","value":"070"},"to":{"field":"region","value":"ba"}},{"from":{"field":"region","value":"052"},"to":{"field":"region","value":"bb"}},{"from":{"field":"region","value":"050"},"to":{"field":"region","value":"bd"}},{"from":{"field":"region","value":"056"},"to":{"field":"region","value":"be"}},{"from":{"field":"region","value":"854"},"to":{"field":"region","value":"bf"}},{"from":{"field":"region","value":"100"},"to":{"field":"region","value":"bg"}},{"from":{"field":"region","value":"048"},"to":{"field":"region","value":"bh"}},{"from":{"field":"region","value":"108"},"to":{"field":"region","value":"bi"}},{"from":{"field":"region","value":"204"},"to":{"field":"region","value":"bj"}},{"from":{"field":"region","value":"652"},"to":{"field":"region","value":"bl"}},{"from":{"field":"region","value":"060"},"to":{"field":"region","value":"bm"}},{"from":{"field":"region","value":"096"},"to":{"field":"region","value":"bn"}},{"from":{"field":"region","value":"068"},"to":{"field":"region","value":"bo"}},{"from":{"field":"region","value":"535"},"to":{"field":"region","value":"bq"}},{"from":{"field":"region","value":"076"},"to":{"field":"region","value":"br"}},{"from":{"field":"region","value":"044"},"to":{"field":"region","value":"bs"}},{"from":{"field":"region","value":"064"},"to":{"field":"region","value":"bt"}},{"from":{"field":"region","value":"104"},"to":{"field":"region","value":"mm"}},{"from":{"field":"region","value":"074"},"to":{"field":"region","value":"bv"}},{"from":{"field":"region","value":"072"},"to":{"field":"region","value":"bw"}},{"from":{"field":"region","value":"112"},"to":{"field":"region","value":"by"}},{"from":{"field":"region","value":"084"},"to":{"field":"region","value":"bz"}},{"from":{"field":"region","value":"124"},"to":{"field":"region","value":"ca"}},{"from":{"field":"region","value":"166"},"to":{"field":"region","value":"cc"}},{"from":{"field":"region","value":"180"},"to":{"field":"region","value":"cd"}},{"from":{"field":"region","value":"140"},"to":{"field":"region","value":"cf"}},{"from":{"field":"region","value":"178"},"to":{"field":"region","value":"cg"}},{"from":{"field":"region","value":"756"},"to":{"field":"region","value":"ch"}},{"from":{"field":"region","value":"384"},"to":{"field":"region","value":"ci"}},{"from":{"field":"region","value":"184"},"to":{"field":"region","value":"ck"}},{"from":{"field":"region","value":"152"},"to":{"field":"region","value":"cl"}},{"from":{"field":"region","value":"120"},"to":{"field":"region","value":"cm"}},{"from":{"field":"region","value":"156"},"to":{"field":"region","value":"cn"}},{"from":{"field":"region","value":"170"},"to":{"field":"region","value":"co"}},{"from":{"field":"region","value":"188"},"to":{"field":"region","value":"cr"}},{"from":{"field":"region","value":"192"},"to":{"field":"region","value":"cu"}},{"from":{"field":"region","value":"132"},"to":{"field":"region","value":"cv"}},{"from":{"field":"region","value":"531"},"to":{"field":"region","value":"cw"}},{"from":{"field":"region","value":"162"},"to":{"field":"region","value":"cx"}},{"from":{"field":"region","value":"196"},"to":{"field":"region","value":"cy"}},{"from":{"field":"region","value":"203"},"to":{"field":"region","value":"cz"}},{"from":{"field":"region","value":"278"},"to":{"field":"region","value":"de"}},{"from":{"field":"region","value":"276"},"to":{"field":"region","value":"de"}},{"from":{"field":"region","value":"262"},"to":{"field":"region","value":"dj"}},{"from":{"field":"region","value":"208"},"to":{"field":"region","value":"dk"}},{"from":{"field":"region","value":"212"},"to":{"field":"region","value":"dm"}},{"from":{"field":"region","value":"214"},"to":{"field":"region","value":"do"}},{"from":{"field":"region","value":"012"},"to":{"field":"region","value":"dz"}},{"from":{"field":"region","value":"218"},"to":{"field":"region","value":"ec"}},{"from":{"field":"region","value":"233"},"to":{"field":"region","value":"ee"}},{"from":{"field":"region","value":"818"},"to":{"field":"region","value":"eg"}},{"from":{"field":"region","value":"732"},"to":{"field":"region","value":"eh"}},{"from":{"field":"region","value":"232"},"to":{"field":"region","value":"er"}},{"from":{"field":"region","value":"724"},"to":{"field":"region","value":"es"}},{"from":{"field":"region","value":"231"},"to":{"field":"region","value":"et"}},{"from":{"field":"region","value":"246"},"to":{"field":"region","value":"fi"}},{"from":{"field":"region","value":"242"},"to":{"field":"region","value":"fj"}},{"from":{"field":"region","value":"238"},"to":{"field":"region","value":"fk"}},{"from":{"field":"region","value":"583"},"to":{"field":"region","value":"fm"}},{"from":{"field":"region","value":"234"},"to":{"field":"region","value":"fo"}},{"from":{"field":"region","value":"250"},"to":{"field":"region","value":"fr"}},{"from":{"field":"region","value":"249"},"to":{"field":"region","value":"fr"}},{"from":{"field":"region","value":"266"},"to":{"field":"region","value":"ga"}},{"from":{"field":"region","value":"826"},"to":{"field":"region","value":"gb"}},{"from":{"field":"region","value":"308"},"to":{"field":"region","value":"gd"}},{"from":{"field":"region","value":"268"},"to":{"field":"region","value":"ge"}},{"from":{"field":"region","value":"254"},"to":{"field":"region","value":"gf"}},{"from":{"field":"region","value":"831"},"to":{"field":"region","value":"gg"}},{"from":{"field":"region","value":"288"},"to":{"field":"region","value":"gh"}},{"from":{"field":"region","value":"292"},"to":{"field":"region","value":"gi"}},{"from":{"field":"region","value":"304"},"to":{"field":"region","value":"gl"}},{"from":{"field":"region","value":"270"},"to":{"field":"region","value":"gm"}},{"from":{"field":"region","value":"324"},"to":{"field":"region","value":"gn"}},{"from":{"field":"region","value":"312"},"to":{"field":"region","value":"gp"}},{"from":{"field":"region","value":"226"},"to":{"field":"region","value":"gq"}},{"from":{"field":"region","value":"300"},"to":{"field":"region","value":"gr"}},{"from":{"field":"region","value":"239"},"to":{"field":"region","value":"gs"}},{"from":{"field":"region","value":"320"},"to":{"field":"region","value":"gt"}},{"from":{"field":"region","value":"316"},"to":{"field":"region","value":"gu"}},{"from":{"field":"region","value":"624"},"to":{"field":"region","value":"gw"}},{"from":{"field":"region","value":"328"},"to":{"field":"region","value":"gy"}},{"from":{"field":"region","value":"344"},"to":{"field":"region","value":"hk"}},{"from":{"field":"region","value":"334"},"to":{"field":"region","value":"hm"}},{"from":{"field":"region","value":"340"},"to":{"field":"region","value":"hn"}},{"from":{"field":"region","value":"191"},"to":{"field":"region","value":"hr"}},{"from":{"field":"region","value":"332"},"to":{"field":"region","value":"ht"}},{"from":{"field":"region","value":"348"},"to":{"field":"region","value":"hu"}},{"from":{"field":"region","value":"360"},"to":{"field":"region","value":"id"}},{"from":{"field":"region","value":"372"},"to":{"field":"region","value":"ie"}},{"from":{"field":"region","value":"376"},"to":{"field":"region","value":"il"}},{"from":{"field":"region","value":"833"},"to":{"field":"region","value":"im"}},{"from":{"field":"region","value":"356"},"to":{"field":"region","value":"in"}},{"from":{"field":"region","value":"086"},"to":{"field":"region","value":"io"}},{"from":{"field":"region","value":"368"},"to":{"field":"region","value":"iq"}},{"from":{"field":"region","value":"364"},"to":{"field":"region","value":"ir"}},{"from":{"field":"region","value":"352"},"to":{"field":"region","value":"is"}},{"from":{"field":"region","value":"380"},"to":{"field":"region","value":"it"}},{"from":{"field":"region","value":"832"},"to":{"field":"region","value":"je"}},{"from":{"field":"region","value":"388"},"to":{"field":"region","value":"jm"}},{"from":{"field":"region","value":"400"},"to":{"field":"region","value":"jo"}},{"from":{"field":"region","value":"392"},"to":{"field":"region","value":"jp"}},{"from":{"field":"region","value":"404"},"to":{"field":"region","value":"ke"}},{"from":{"field":"region","value":"417"},"to":{"field":"region","value":"kg"}},{"from":{"field":"region","value":"116"},"to":{"field":"region","value":"kh"}},{"from":{"field":"region","value":"296"},"to":{"field":"region","value":"ki"}},{"from":{"field":"region","value":"174"},"to":{"field":"region","value":"km"}},{"from":{"field":"region","value":"659"},"to":{"field":"region","value":"kn"}},{"from":{"field":"region","value":"408"},"to":{"field":"region","value":"kp"}},{"from":{"field":"region","value":"410"},"to":{"field":"region","value":"kr"}},{"from":{"field":"region","value":"414"},"to":{"field":"region","value":"kw"}},{"from":{"field":"region","value":"136"},"to":{"field":"region","value":"ky"}},{"from":{"field":"region","value":"398"},"to":{"field":"region","value":"kz"}},{"from":{"field":"region","value":"418"},"to":{"field":"region","value":"la"}},{"from":{"field":"region","value":"422"},"to":{"field":"region","value":"lb"}},{"from":{"field":"region","value":"662"},"to":{"field":"region","value":"lc"}},{"from":{"field":"region","value":"438"},"to":{"field":"region","value":"li"}},{"from":{"field":"region","value":"144"},"to":{"field":"region","value":"lk"}},{"from":{"field":"region","value":"430"},"to":{"field":"region","value":"lr"}},{"from":{"field":"region","value":"426"},"to":{"field":"region","value":"ls"}},{"from":{"field":"region","value":"440"},"to":{"field":"region","value":"lt"}},{"from":{"field":"region","value":"442"},"to":{"field":"region","value":"lu"}},{"from":{"field":"region","value":"428"},"to":{"field":"region","value":"lv"}},{"from":{"field":"region","value":"434"},"to":{"field":"region","value":"ly"}},{"from":{"field":"region","value":"504"},"to":{"field":"region","value":"ma"}},{"from":{"field":"region","value":"492"},"to":{"field":"region","value":"mc"}},{"from":{"field":"region","value":"498"},"to":{"field":"region","value":"md"}},{"from":{"field":"region","value":"499"},"to":{"field":"region","value":"me"}},{"from":{"field":"region","value":"663"},"to":{"field":"region","value":"mf"}},{"from":{"field":"region","value":"450"},"to":{"field":"region","value":"mg"}},{"from":{"field":"region","value":"584"},"to":{"field":"region","value":"mh"}},{"from":{"field":"region","value":"807"},"to":{"field":"region","value":"mk"}},{"from":{"field":"region","value":"466"},"to":{"field":"region","value":"ml"}},{"from":{"field":"region","value":"496"},"to":{"field":"region","value":"mn"}},{"from":{"field":"region","value":"446"},"to":{"field":"region","value":"mo"}},{"from":{"field":"region","value":"580"},"to":{"field":"region","value":"mp"}},{"from":{"field":"region","value":"474"},"to":{"field":"region","value":"mq"}},{"from":{"field":"region","value":"478"},"to":{"field":"region","value":"mr"}},{"from":{"field":"region","value":"500"},"to":{"field":"region","value":"ms"}},{"from":{"field":"region","value":"470"},"to":{"field":"region","value":"mt"}},{"from":{"field":"region","value":"480"},"to":{"field":"region","value":"mu"}},{"from":{"field":"region","value":"462"},"to":{"field":"region","value":"mv"}},{"from":{"field":"region","value":"454"},"to":{"field":"region","value":"mw"}},{"from":{"field":"region","value":"484"},"to":{"field":"region","value":"mx"}},{"from":{"field":"region","value":"458"},"to":{"field":"region","value":"my"}},{"from":{"field":"region","value":"508"},"to":{"field":"region","value":"mz"}},{"from":{"field":"region","value":"516"},"to":{"field":"region","value":"na"}},{"from":{"field":"region","value":"540"},"to":{"field":"region","value":"nc"}},{"from":{"field":"region","value":"562"},"to":{"field":"region","value":"ne"}},{"from":{"field":"region","value":"574"},"to":{"field":"region","value":"nf"}},{"from":{"field":"region","value":"566"},"to":{"field":"region","value":"ng"}},{"from":{"field":"region","value":"558"},"to":{"field":"region","value":"ni"}},{"from":{"field":"region","value":"528"},"to":{"field":"region","value":"nl"}},{"from":{"field":"region","value":"578"},"to":{"field":"region","value":"no"}},{"from":{"field":"region","value":"524"},"to":{"field":"region","value":"np"}},{"from":{"field":"region","value":"520"},"to":{"field":"region","value":"nr"}},{"from":{"field":"region","value":"570"},"to":{"field":"region","value":"nu"}},{"from":{"field":"region","value":"554"},"to":{"field":"region","value":"nz"}},{"from":{"field":"region","value":"512"},"to":{"field":"region","value":"om"}},{"from":{"field":"region","value":"591"},"to":{"field":"region","value":"pa"}},{"from":{"field":"region","value":"604"},"to":{"field":"region","value":"pe"}},{"from":{"field":"region","value":"258"},"to":{"field":"region","value":"pf"}},{"from":{"field":"region","value":"598"},"to":{"field":"region","value":"pg"}},{"from":{"field":"region","value":"608"},"to":{"field":"region","value":"ph"}},{"from":{"field":"region","value":"586"},"to":{"field":"region","value":"pk"}},{"from":{"field":"region","value":"616"},"to":{"field":"region","value":"pl"}},{"from":{"field":"region","value":"666"},"to":{"field":"region","value":"pm"}},{"from":{"field":"region","value":"612"},"to":{"field":"region","value":"pn"}},{"from":{"field":"region","value":"630"},"to":{"field":"region","value":"pr"}},{"from":{"field":"region","value":"275"},"to":{"field":"region","value":"ps"}},{"from":{"field":"region","value":"620"},"to":{"field":"region","value":"pt"}},{"from":{"field":"region","value":"585"},"to":{"field":"region","value":"pw"}},{"from":{"field":"region","value":"600"},"to":{"field":"region","value":"py"}},{"from":{"field":"region","value":"634"},"to":{"field":"region","value":"qa"}},{"from":{"field":"region","value":"959"},"to":{"field":"region","value":"qm"}},{"from":{"field":"region","value":"960"},"to":{"field":"region","value":"qn"}},{"from":{"field":"region","value":"962"},"to":{"field":"region","value":"qp"}},{"from":{"field":"region","value":"963"},"to":{"field":"region","value":"qq"}},{"from":{"field":"region","value":"964"},"to":{"field":"region","value":"qr"}},{"from":{"field":"region","value":"965"},"to":{"field":"region","value":"qs"}},{"from":{"field":"region","value":"966"},"to":{"field":"region","value":"qt"}},{"from":{"field":"region","value":"967"},"to":{"field":"region","value":"eu"}},{"from":{"field":"region","value":"968"},"to":{"field":"region","value":"qv"}},{"from":{"field":"region","value":"969"},"to":{"field":"region","value":"qw"}},{"from":{"field":"region","value":"970"},"to":{"field":"region","value":"qx"}},{"from":{"field":"region","value":"971"},"to":{"field":"region","value":"qy"}},{"from":{"field":"region","value":"972"},"to":{"field":"region","value":"qz"}},{"from":{"field":"region","value":"638"},"to":{"field":"region","value":"re"}},{"from":{"field":"region","value":"642"},"to":{"field":"region","value":"ro"}},{"from":{"field":"region","value":"688"},"to":{"field":"region","value":"rs"}},{"from":{"field":"region","value":"643"},"to":{"field":"region","value":"ru"}},{"from":{"field":"region","value":"646"},"to":{"field":"region","value":"rw"}},{"from":{"field":"region","value":"682"},"to":{"field":"region","value":"sa"}},{"from":{"field":"region","value":"090"},"to":{"field":"region","value":"sb"}},{"from":{"field":"region","value":"690"},"to":{"field":"region","value":"sc"}},{"from":{"field":"region","value":"729"},"to":{"field":"region","value":"sd"}},{"from":{"field":"region","value":"752"},"to":{"field":"region","value":"se"}},{"from":{"field":"region","value":"702"},"to":{"field":"region","value":"sg"}},{"from":{"field":"region","value":"654"},"to":{"field":"region","value":"sh"}},{"from":{"field":"region","value":"705"},"to":{"field":"region","value":"si"}},{"from":{"field":"region","value":"744"},"to":{"field":"region","value":"sj"}},{"from":{"field":"region","value":"703"},"to":{"field":"region","value":"sk"}},{"from":{"field":"region","value":"694"},"to":{"field":"region","value":"sl"}},{"from":{"field":"region","value":"674"},"to":{"field":"region","value":"sm"}},{"from":{"field":"region","value":"686"},"to":{"field":"region","value":"sn"}},{"from":{"field":"region","value":"706"},"to":{"field":"region","value":"so"}},{"from":{"field":"region","value":"740"},"to":{"field":"region","value":"sr"}},{"from":{"field":"region","value":"728"},"to":{"field":"region","value":"ss"}},{"from":{"field":"region","value":"678"},"to":{"field":"region","value":"st"}},{"from":{"field":"region","value":"222"},"to":{"field":"region","value":"sv"}},{"from":{"field":"region","value":"534"},"to":{"field":"region","value":"sx"}},{"from":{"field":"region","value":"760"},"to":{"field":"region","value":"sy"}},{"from":{"field":"region","value":"748"},"to":{"field":"region","value":"sz"}},{"from":{"field":"region","value":"796"},"to":{"field":"region","value":"tc"}},{"from":{"field":"region","value":"148"},"to":{"field":"region","value":"td"}},{"from":{"field":"region","value":"260"},"to":{"field":"region","value":"tf"}},{"from":{"field":"region","value":"768"},"to":{"field":"region","value":"tg"}},{"from":{"field":"region","value":"764"},"to":{"field":"region","value":"th"}},{"from":{"field":"region","value":"762"},"to":{"field":"region","value":"tj"}},{"from":{"field":"region","value":"772"},"to":{"field":"region","value":"tk"}},{"from":{"field":"region","value":"626"},"to":{"field":"region","value":"tl"}},{"from":{"field":"region","value":"795"},"to":{"field":"region","value":"tm"}},{"from":{"field":"region","value":"788"},"to":{"field":"region","value":"tn"}},{"from":{"field":"region","value":"776"},"to":{"field":"region","value":"to"}},{"from":{"field":"region","value":"792"},"to":{"field":"region","value":"tr"}},{"from":{"field":"region","value":"780"},"to":{"field":"region","value":"tt"}},{"from":{"field":"region","value":"798"},"to":{"field":"region","value":"tv"}},{"from":{"field":"region","value":"158"},"to":{"field":"region","value":"tw"}},{"from":{"field":"region","value":"834"},"to":{"field":"region","value":"tz"}},{"from":{"field":"region","value":"804"},"to":{"field":"region","value":"ua"}},{"from":{"field":"region","value":"800"},"to":{"field":"region","value":"ug"}},{"from":{"field":"region","value":"581"},"to":{"field":"region","value":"um"}},{"from":{"field":"region","value":"840"},"to":{"field":"region","value":"us"}},{"from":{"field":"region","value":"858"},"to":{"field":"region","value":"uy"}},{"from":{"field":"region","value":"860"},"to":{"field":"region","value":"uz"}},{"from":{"field":"region","value":"336"},"to":{"field":"region","value":"va"}},{"from":{"field":"region","value":"670"},"to":{"field":"region","value":"vc"}},{"from":{"field":"region","value":"862"},"to":{"field":"region","value":"ve"}},{"from":{"field":"region","value":"092"},"to":{"field":"region","value":"vg"}},{"from":{"field":"region","value":"850"},"to":{"field":"region","value":"vi"}},{"from":{"field":"region","value":"704"},"to":{"field":"region","value":"vn"}},{"from":{"field":"region","value":"548"},"to":{"field":"region","value":"vu"}},{"from":{"field":"region","value":"876"},"to":{"field":"region","value":"wf"}},{"from":{"field":"region","value":"882"},"to":{"field":"region","value":"ws"}},{"from":{"field":"region","value":"973"},"to":{"field":"region","value":"xa"}},{"from":{"field":"region","value":"974"},"to":{"field":"region","value":"xb"}},{"from":{"field":"region","value":"975"},"to":{"field":"region","value":"xc"}},{"from":{"field":"region","value":"976"},"to":{"field":"region","value":"xd"}},{"from":{"field":"region","value":"977"},"to":{"field":"region","value":"xe"}},{"from":{"field":"region","value":"978"},"to":{"field":"region","value":"xf"}},{"from":{"field":"region","value":"979"},"to":{"field":"region","value":"xg"}},{"from":{"field":"region","value":"980"},"to":{"field":"region","value":"xh"}},{"from":{"field":"region","value":"981"},"to":{"field":"region","value":"xi"}},{"from":{"field":"region","value":"982"},"to":{"field":"region","value":"xj"}},{"from":{"field":"region","value":"983"},"to":{"field":"region","value":"xk"}},{"from":{"field":"region","value":"984"},"to":{"field":"region","value":"xl"}},{"from":{"field":"region","value":"985"},"to":{"field":"region","value":"xm"}},{"from":{"field":"region","value":"986"},"to":{"field":"region","value":"xn"}},{"from":{"field":"region","value":"987"},"to":{"field":"region","value":"xo"}},{"from":{"field":"region","value":"988"},"to":{"field":"region","value":"xp"}},{"from":{"field":"region","value":"989"},"to":{"field":"region","value":"xq"}},{"from":{"field":"region","value":"990"},"to":{"field":"region","value":"xr"}},{"from":{"field":"region","value":"991"},"to":{"field":"region","value":"xs"}},{"from":{"field":"region","value":"992"},"to":{"field":"region","value":"xt"}},{"from":{"field":"region","value":"993"},"to":{"field":"region","value":"xu"}},{"from":{"field":"region","value":"994"},"to":{"field":"region","value":"xv"}},{"from":{"field":"region","value":"995"},"to":{"field":"region","value":"xw"}},{"from":{"field":"region","value":"996"},"to":{"field":"region","value":"xx"}},{"from":{"field":"region","value":"997"},"to":{"field":"region","value":"xy"}},{"from":{"field":"region","value":"998"},"to":{"field":"region","value":"xz"}},{"from":{"field":"region","value":"720"},"to":{"field":"region","value":"ye"}},{"from":{"field":"region","value":"887"},"to":{"field":"region","value":"ye"}},{"from":{"field":"region","value":"175"},"to":{"field":"region","value":"yt"}},{"from":{"field":"region","value":"710"},"to":{"field":"region","value":"za"}},{"from":{"field":"region","value":"894"},"to":{"field":"region","value":"zm"}},{"from":{"field":"region","value":"716"},"to":{"field":"region","value":"zw"}},{"from":{"field":"region","value":"999"},"to":{"field":"region","value":"zz"}},{"from":{"field":"variants","value":"aaland"},"to":{"field":"region","value":"ax"}},{"from":{"field":"variants","value":"polytoni"},"to":{"field":"variants","value":"polyton"}},{"from":{"field":"variants","value":"heploc"},"to":{"field":"variants","value":"alalc97"}},{"from":{"field":"variants","value":"arevela"},"to":{"field":"language","value":"hy"}},{"from":{"field":"variants","value":"arevmda"},"to":{"field":"language","value":"hyw"}}]');
          }
        ),
        /***/
        "./node_modules/bcp-47-normalize/lib/many.json": (
          /*!*****************************************************!*\
            !*** ./node_modules/bcp-47-normalize/lib/many.json ***!
            \*****************************************************/
          /***/
          (c) => {
            c.exports = JSON.parse('{"region":{"172":["ru","am","az","by","ge","kg","kz","md","tj","tm","ua","uz"],"200":["cz","sk"],"530":["cw","sx","bq"],"532":["cw","sx","bq"],"536":["sa","iq"],"582":["fm","mh","mp","pw"],"810":["ru","am","az","by","ee","ge","kz","kg","lv","lt","md","tj","tm","ua","uz"],"830":["je","gg"],"890":["rs","me","si","hr","mk","ba"],"891":["rs","me"],"an":["cw","sx","bq"],"cs":["rs","me"],"fq":["aq","tf"],"nt":["sa","iq"],"pc":["fm","mh","mp","pw"],"su":["ru","am","az","by","ee","ge","kz","kg","lv","lt","md","tj","tm","ua","uz"],"yu":["rs","me"],"062":["034","143"],"ant":["cw","sx","bq"],"scg":["rs","me"],"ntz":["sa","iq"],"sun":["ru","am","az","by","ee","ge","kz","kg","lv","lt","md","tj","tm","ua","uz"],"yug":["rs","me"]}}');
          }
        ),
        /***/
        "./node_modules/bcp-47-normalize/lib/matches.json": (
          /*!********************************************************!*\
            !*** ./node_modules/bcp-47-normalize/lib/matches.json ***!
            \********************************************************/
          /***/
          (c) => {
            c.exports = JSON.parse('[{"from":"in","to":"id"},{"from":"iw","to":"he"},{"from":"ji","to":"yi"},{"from":"jw","to":"jv"},{"from":"mo","to":"ro"},{"from":"scc","to":"sr"},{"from":"scr","to":"hr"},{"from":"aam","to":"aas"},{"from":"adp","to":"dz"},{"from":"aue","to":"ktz"},{"from":"ayx","to":"nun"},{"from":"bgm","to":"bcg"},{"from":"bjd","to":"drl"},{"from":"ccq","to":"rki"},{"from":"cjr","to":"mom"},{"from":"cka","to":"cmr"},{"from":"cmk","to":"xch"},{"from":"coy","to":"pij"},{"from":"cqu","to":"quh"},{"from":"drh","to":"mn"},{"from":"drw","to":"fa-af"},{"from":"gav","to":"dev"},{"from":"gfx","to":"vaj"},{"from":"ggn","to":"gvr"},{"from":"gti","to":"nyc"},{"from":"guv","to":"duz"},{"from":"hrr","to":"jal"},{"from":"ibi","to":"opa"},{"from":"ilw","to":"gal"},{"from":"jeg","to":"oyb"},{"from":"kgc","to":"tdf"},{"from":"kgh","to":"kml"},{"from":"koj","to":"kwv"},{"from":"krm","to":"bmf"},{"from":"ktr","to":"dtp"},{"from":"kvs","to":"gdj"},{"from":"kwq","to":"yam"},{"from":"kxe","to":"tvd"},{"from":"kzj","to":"dtp"},{"from":"kzt","to":"dtp"},{"from":"lii","to":"raq"},{"from":"lmm","to":"rmx"},{"from":"meg","to":"cir"},{"from":"mst","to":"mry"},{"from":"mwj","to":"vaj"},{"from":"myt","to":"mry"},{"from":"nad","to":"xny"},{"from":"ncp","to":"kdz"},{"from":"nnx","to":"ngv"},{"from":"nts","to":"pij"},{"from":"oun","to":"vaj"},{"from":"pcr","to":"adx"},{"from":"pmc","to":"huw"},{"from":"pmu","to":"phr"},{"from":"ppa","to":"bfy"},{"from":"ppr","to":"lcq"},{"from":"pry","to":"prt"},{"from":"puz","to":"pub"},{"from":"sca","to":"hle"},{"from":"skk","to":"oyb"},{"from":"tdu","to":"dtp"},{"from":"thc","to":"tpo"},{"from":"thx","to":"oyb"},{"from":"tie","to":"ras"},{"from":"tkk","to":"twm"},{"from":"tlw","to":"weo"},{"from":"tmp","to":"tyj"},{"from":"tne","to":"kak"},{"from":"tnf","to":"fa-af"},{"from":"tsf","to":"taj"},{"from":"uok","to":"ema"},{"from":"xba","to":"cax"},{"from":"xia","to":"acn"},{"from":"xkh","to":"waw"},{"from":"xsj","to":"suj"},{"from":"ybd","to":"rki"},{"from":"yma","to":"lrr"},{"from":"ymt","to":"mtm"},{"from":"yos","to":"zom"},{"from":"yuu","to":"yug"},{"from":"asd","to":"snz"},{"from":"dit","to":"dif"},{"from":"llo","to":"ngt"},{"from":"myd","to":"aog"},{"from":"nns","to":"nbr"},{"from":"sgn-br","to":"bzs"},{"from":"sgn-co","to":"csn"},{"from":"sgn-de","to":"gsg"},{"from":"sgn-dk","to":"dsl"},{"from":"sgn-fr","to":"fsl"},{"from":"sgn-gb","to":"bfi"},{"from":"sgn-gr","to":"gss"},{"from":"sgn-ie","to":"isg"},{"from":"sgn-it","to":"ise"},{"from":"sgn-jp","to":"jsl"},{"from":"sgn-mx","to":"mfs"},{"from":"sgn-ni","to":"ncs"},{"from":"sgn-nl","to":"dse"},{"from":"sgn-no","to":"nsi"},{"from":"sgn-pt","to":"psr"},{"from":"sgn-se","to":"swl"},{"from":"sgn-us","to":"ase"},{"from":"sgn-za","to":"sfs"},{"from":"no-bokmal","to":"nb"},{"from":"no-nynorsk","to":"nn"},{"from":"aa-saaho","to":"ssy"},{"from":"sh","to":"sr-latn"},{"from":"cnr","to":"sr-me"},{"from":"no","to":"nb"},{"from":"tl","to":"fil"},{"from":"az-az","to":"az-latn-az"},{"from":"bs-ba","to":"bs-latn-ba"},{"from":"ha-latn-gh","to":"ha-gh"},{"from":"ha-latn-ne","to":"ha-ne"},{"from":"ha-latn-ng","to":"ha-ng"},{"from":"kk-cyrl-kz","to":"kk-kz"},{"from":"ky-cyrl-kg","to":"ky-kg"},{"from":"ks-arab-in","to":"ks-in"},{"from":"mn-cyrl-mn","to":"mn-mn"},{"from":"ms-latn-bn","to":"ms-bn"},{"from":"ms-latn-my","to":"ms-my"},{"from":"ms-latn-sg","to":"ms-sg"},{"from":"pa-in","to":"pa-guru-in"},{"from":"pa-pk","to":"pa-arab-pk"},{"from":"shi-ma","to":"shi-tfng-ma"},{"from":"sr-ba","to":"sr-cyrl-ba"},{"from":"sr-me","to":"sr-latn-me"},{"from":"sr-rs","to":"sr-cyrl-rs"},{"from":"sr-xk","to":"sr-cyrl-xk"},{"from":"tzm-latn-ma","to":"tzm-ma"},{"from":"ug-arab-cn","to":"ug-cn"},{"from":"uz-af","to":"uz-arab-af"},{"from":"uz-uz","to":"uz-latn-uz"},{"from":"vai-lr","to":"vai-vaii-lr"},{"from":"yue-cn","to":"yue-hans-cn"},{"from":"yue-hk","to":"yue-hant-hk"},{"from":"zh-cn","to":"zh-hans-cn"},{"from":"zh-hk","to":"zh-hant-hk"},{"from":"zh-mo","to":"zh-hant-mo"},{"from":"zh-sg","to":"zh-hans-sg"},{"from":"zh-tw","to":"zh-hant-tw"},{"from":"aju","to":"jrb"},{"from":"als","to":"sq"},{"from":"arb","to":"ar"},{"from":"ayr","to":"ay"},{"from":"azj","to":"az"},{"from":"bcc","to":"bal"},{"from":"bcl","to":"bik"},{"from":"bxk","to":"luy"},{"from":"bxr","to":"bua"},{"from":"cld","to":"syr"},{"from":"cmn","to":"zh"},{"from":"cwd","to":"cr"},{"from":"dgo","to":"doi"},{"from":"dhd","to":"mwr"},{"from":"dik","to":"din"},{"from":"diq","to":"zza"},{"from":"lbk","to":"bnc"},{"from":"ekk","to":"et"},{"from":"emk","to":"man"},{"from":"esk","to":"ik"},{"from":"fat","to":"ak"},{"from":"fuc","to":"ff"},{"from":"gaz","to":"om"},{"from":"gbo","to":"grb"},{"from":"gno","to":"gon"},{"from":"gug","to":"gn"},{"from":"gya","to":"gba"},{"from":"hdn","to":"hai"},{"from":"hea","to":"hmn"},{"from":"ike","to":"iu"},{"from":"kmr","to":"ku"},{"from":"knc","to":"kr"},{"from":"kng","to":"kg"},{"from":"knn","to":"kok"},{"from":"kpv","to":"kv"},{"from":"lvs","to":"lv"},{"from":"mhr","to":"chm"},{"from":"mup","to":"raj"},{"from":"khk","to":"mn"},{"from":"npi","to":"ne"},{"from":"ojg","to":"oj"},{"from":"ory","to":"or"},{"from":"pbu","to":"ps"},{"from":"pes","to":"fa"},{"from":"plt","to":"mg"},{"from":"pnb","to":"lah"},{"from":"quz","to":"qu"},{"from":"rmy","to":"rom"},{"from":"spy","to":"kln"},{"from":"src","to":"sc"},{"from":"swh","to":"sw"},{"from":"ttq","to":"tmh"},{"from":"tw","to":"ak"},{"from":"umu","to":"del"},{"from":"uzn","to":"uz"},{"from":"xpe","to":"kpe"},{"from":"xsl","to":"den"},{"from":"ydd","to":"yi"},{"from":"zai","to":"zap"},{"from":"zsm","to":"ms"},{"from":"zyb","to":"za"},{"from":"him","to":"srx"},{"from":"mnk","to":"man"},{"from":"bh","to":"bho"},{"from":"prs","to":"fa-af"},{"from":"swc","to":"sw-cd"},{"from":"aar","to":"aa"},{"from":"abk","to":"ab"},{"from":"ave","to":"ae"},{"from":"afr","to":"af"},{"from":"aka","to":"ak"},{"from":"amh","to":"am"},{"from":"arg","to":"an"},{"from":"ara","to":"ar"},{"from":"asm","to":"as"},{"from":"ava","to":"av"},{"from":"aym","to":"ay"},{"from":"aze","to":"az"},{"from":"bak","to":"ba"},{"from":"bel","to":"be"},{"from":"bul","to":"bg"},{"from":"bih","to":"bho"},{"from":"bis","to":"bi"},{"from":"bam","to":"bm"},{"from":"ben","to":"bn"},{"from":"bod","to":"bo"},{"from":"bre","to":"br"},{"from":"bos","to":"bs"},{"from":"cat","to":"ca"},{"from":"che","to":"ce"},{"from":"cha","to":"ch"},{"from":"cos","to":"co"},{"from":"cre","to":"cr"},{"from":"ces","to":"cs"},{"from":"chu","to":"cu"},{"from":"chv","to":"cv"},{"from":"cym","to":"cy"},{"from":"dan","to":"da"},{"from":"deu","to":"de"},{"from":"div","to":"dv"},{"from":"dzo","to":"dz"},{"from":"ewe","to":"ee"},{"from":"ell","to":"el"},{"from":"eng","to":"en"},{"from":"epo","to":"eo"},{"from":"spa","to":"es"},{"from":"est","to":"et"},{"from":"eus","to":"eu"},{"from":"fas","to":"fa"},{"from":"ful","to":"ff"},{"from":"fin","to":"fi"},{"from":"fij","to":"fj"},{"from":"fao","to":"fo"},{"from":"fra","to":"fr"},{"from":"fry","to":"fy"},{"from":"gle","to":"ga"},{"from":"gla","to":"gd"},{"from":"glg","to":"gl"},{"from":"grn","to":"gn"},{"from":"guj","to":"gu"},{"from":"glv","to":"gv"},{"from":"hau","to":"ha"},{"from":"heb","to":"he"},{"from":"hin","to":"hi"},{"from":"hmo","to":"ho"},{"from":"hrv","to":"hr"},{"from":"hat","to":"ht"},{"from":"hun","to":"hu"},{"from":"hye","to":"hy"},{"from":"her","to":"hz"},{"from":"ina","to":"ia"},{"from":"ind","to":"id"},{"from":"ile","to":"ie"},{"from":"ibo","to":"ig"},{"from":"iii","to":"ii"},{"from":"ipk","to":"ik"},{"from":"ido","to":"io"},{"from":"isl","to":"is"},{"from":"ita","to":"it"},{"from":"iku","to":"iu"},{"from":"jpn","to":"ja"},{"from":"jav","to":"jv"},{"from":"kat","to":"ka"},{"from":"kon","to":"kg"},{"from":"kik","to":"ki"},{"from":"kua","to":"kj"},{"from":"kaz","to":"kk"},{"from":"kal","to":"kl"},{"from":"khm","to":"km"},{"from":"kan","to":"kn"},{"from":"kor","to":"ko"},{"from":"kau","to":"kr"},{"from":"kas","to":"ks"},{"from":"kur","to":"ku"},{"from":"kom","to":"kv"},{"from":"cor","to":"kw"},{"from":"kir","to":"ky"},{"from":"lat","to":"la"},{"from":"ltz","to":"lb"},{"from":"lug","to":"lg"},{"from":"lim","to":"li"},{"from":"lin","to":"ln"},{"from":"lao","to":"lo"},{"from":"lit","to":"lt"},{"from":"lub","to":"lu"},{"from":"lav","to":"lv"},{"from":"mlg","to":"mg"},{"from":"mah","to":"mh"},{"from":"mri","to":"mi"},{"from":"mkd","to":"mk"},{"from":"mal","to":"ml"},{"from":"mon","to":"mn"},{"from":"mol","to":"ro"},{"from":"mar","to":"mr"},{"from":"msa","to":"ms"},{"from":"mlt","to":"mt"},{"from":"mya","to":"my"},{"from":"nau","to":"na"},{"from":"nob","to":"nb"},{"from":"nde","to":"nd"},{"from":"nep","to":"ne"},{"from":"ndo","to":"ng"},{"from":"nld","to":"nl"},{"from":"nno","to":"nn"},{"from":"nor","to":"nb"},{"from":"nbl","to":"nr"},{"from":"nav","to":"nv"},{"from":"nya","to":"ny"},{"from":"oci","to":"oc"},{"from":"oji","to":"oj"},{"from":"orm","to":"om"},{"from":"ori","to":"or"},{"from":"oss","to":"os"},{"from":"pan","to":"pa"},{"from":"pli","to":"pi"},{"from":"pol","to":"pl"},{"from":"pus","to":"ps"},{"from":"por","to":"pt"},{"from":"que","to":"qu"},{"from":"roh","to":"rm"},{"from":"run","to":"rn"},{"from":"ron","to":"ro"},{"from":"rus","to":"ru"},{"from":"kin","to":"rw"},{"from":"san","to":"sa"},{"from":"srd","to":"sc"},{"from":"snd","to":"sd"},{"from":"sme","to":"se"},{"from":"sag","to":"sg"},{"from":"hbs","to":"sr-latn"},{"from":"sin","to":"si"},{"from":"slk","to":"sk"},{"from":"slv","to":"sl"},{"from":"smo","to":"sm"},{"from":"sna","to":"sn"},{"from":"som","to":"so"},{"from":"sqi","to":"sq"},{"from":"srp","to":"sr"},{"from":"ssw","to":"ss"},{"from":"sot","to":"st"},{"from":"sun","to":"su"},{"from":"swe","to":"sv"},{"from":"swa","to":"sw"},{"from":"tam","to":"ta"},{"from":"tel","to":"te"},{"from":"tgk","to":"tg"},{"from":"tha","to":"th"},{"from":"tir","to":"ti"},{"from":"tuk","to":"tk"},{"from":"tgl","to":"fil"},{"from":"tsn","to":"tn"},{"from":"ton","to":"to"},{"from":"tur","to":"tr"},{"from":"tso","to":"ts"},{"from":"tat","to":"tt"},{"from":"twi","to":"ak"},{"from":"tah","to":"ty"},{"from":"uig","to":"ug"},{"from":"ukr","to":"uk"},{"from":"urd","to":"ur"},{"from":"uzb","to":"uz"},{"from":"ven","to":"ve"},{"from":"vie","to":"vi"},{"from":"vol","to":"vo"},{"from":"wln","to":"wa"},{"from":"wol","to":"wo"},{"from":"xho","to":"xh"},{"from":"yid","to":"yi"},{"from":"yor","to":"yo"},{"from":"zha","to":"za"},{"from":"zho","to":"zh"},{"from":"zul","to":"zu"},{"from":"alb","to":"sq"},{"from":"arm","to":"hy"},{"from":"baq","to":"eu"},{"from":"bur","to":"my"},{"from":"chi","to":"zh"},{"from":"cze","to":"cs"},{"from":"dut","to":"nl"},{"from":"fre","to":"fr"},{"from":"geo","to":"ka"},{"from":"ger","to":"de"},{"from":"gre","to":"el"},{"from":"ice","to":"is"},{"from":"mac","to":"mk"},{"from":"mao","to":"mi"},{"from":"may","to":"ms"},{"from":"per","to":"fa"},{"from":"rum","to":"ro"},{"from":"slo","to":"sk"},{"from":"tib","to":"bo"},{"from":"wel","to":"cy"}]');
          }
        ),
        /***/
        "./node_modules/bcp-47/lib/normalize.json": (
          /*!************************************************!*\
            !*** ./node_modules/bcp-47/lib/normalize.json ***!
            \************************************************/
          /***/
          (c) => {
            c.exports = JSON.parse('{"en-gb-oed":"en-GB-oxendict","i-ami":"ami","i-bnn":"bnn","i-default":null,"i-enochian":null,"i-hak":"hak","i-klingon":"tlh","i-lux":"lb","i-mingo":null,"i-navajo":"nv","i-pwn":"pwn","i-tao":"tao","i-tay":"tay","i-tsu":"tsu","sgn-be-fr":"sfb","sgn-be-nl":"vgt","sgn-ch-de":"sgg","art-lojban":"jbo","cel-gaulish":null,"no-bok":"nb","no-nyn":"nn","zh-guoyu":"cmn","zh-hakka":"hak","zh-min":null,"zh-min-nan":"nan","zh-xiang":"hsn"}');
          }
        ),
        /***/
        "./node_modules/bcp-47/lib/regular.json": (
          /*!**********************************************!*\
            !*** ./node_modules/bcp-47/lib/regular.json ***!
            \**********************************************/
          /***/
          (c) => {
            c.exports = JSON.parse('["art-lojban","cel-gaulish","no-bok","no-nyn","zh-guoyu","zh-hakka","zh-min","zh-min-nan","zh-xiang"]');
          }
        )
        /******/
      }, r = {};
      function o(c) {
        var l = r[c];
        if (l !== void 0)
          return l.exports;
        var i = r[c] = {
          /******/
          // no module.id needed
          /******/
          // no module.loaded needed
          /******/
          exports: {}
          /******/
        };
        return t[c].call(i.exports, i, i.exports, o), i.exports;
      }
      o.amdO = {}, o.n = (c) => {
        var l = c && c.__esModule ? (
          /******/
          () => c.default
        ) : (
          /******/
          () => c
        );
        return o.d(l, { a: l }), l;
      }, o.d = (c, l) => {
        for (var i in l)
          o.o(l, i) && !o.o(c, i) && Object.defineProperty(c, i, { enumerable: !0, get: l[i] });
      }, o.g = function() {
        if (typeof globalThis == "object")
          return globalThis;
        try {
          return this || new Function("return this")();
        } catch {
          if (typeof window == "object")
            return window;
        }
      }(), o.o = (c, l) => Object.prototype.hasOwnProperty.call(c, l), o.r = (c) => {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(c, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(c, "__esModule", { value: !0 });
      };
      var u = {};
      return (() => {
        /*!******************!*\
          !*** ./index.js ***!
          \******************/
        o.r(u), o.d(u, {
          /* harmony export */
          Debug: () => (
            /* reexport safe */
            p.default
          ),
          /* harmony export */
          MediaPlayer: () => (
            /* reexport safe */
            c.MediaPlayer
          ),
          /* harmony export */
          MediaPlayerFactory: () => (
            /* reexport safe */
            f.default
          ),
          /* harmony export */
          MetricsReporting: () => (
            /* reexport safe */
            i.default
          ),
          /* harmony export */
          Protection: () => (
            /* reexport safe */
            h.default
          ),
          /* harmony export */
          default: () => d,
          /* harmony export */
          supportsMediaSource: () => (
            /* reexport safe */
            l.supportsMediaSource
          )
          /* harmony export */
        });
        var c = o(
          /*! ./index_mediaplayerOnly */
          "./index_mediaplayerOnly.js"
        ), l = o(
          /*! ./src/streaming/utils/Capabilities */
          "./src/streaming/utils/Capabilities.js"
        ), i = o(
          /*! ./src/streaming/metrics/MetricsReporting */
          "./src/streaming/metrics/MetricsReporting.js"
        ), h = o(
          /*! ./src/streaming/protection/Protection */
          "./src/streaming/protection/Protection.js"
        ), f = o(
          /*! ./src/streaming/MediaPlayerFactory */
          "./src/streaming/MediaPlayerFactory.js"
        ), p = o(
          /*! ./src/core/Debug */
          "./src/core/Debug.js"
        );
        dashjs.Protection = h.default, dashjs.MetricsReporting = i.default, dashjs.MediaPlayerFactory = f.default, dashjs.Debug = p.default, dashjs.supportsMediaSource = l.supportsMediaSource;
        const d = dashjs;
      })(), u = u.default, u;
    })()
  ));
})(X_);
var CU = X_.exports;
const Q_ = /* @__PURE__ */ Dt({
  __name: "KWebTvVideoPlayer",
  props: {
    idVideo: {}
  },
  setup(n) {
    const e = st(null), t = n, r = st([]);
    let o = null;
    un(() => t.idVideo, async (c) => {
      if (c && c.length > 0) {
        const l = await Jr.getVideoSources(c);
        e.value.readyState && u(), o && o.reset(), r.value = l.map((i) => ({
          src: `${i}/manifest.mpd`,
          //?t=",
          type: "video/mp4"
        })), e.value.canPlayType("application/vnd.apple.mpegurl") ? (e.value.src = l[0], e.value.addEventListener("loadedmetadata", function() {
          e.value.play();
        })) : (o == null && (o = CU.MediaPlayer().create()), o.initialize(e.value, r.value[0].src, !0));
      }
    }, { immediate: !0 });
    const u = () => {
      e.value.pause(), e.value.currentTime = 0;
    };
    return (c, l) => (Oe(), je("video", {
      style: { width: "100%" },
      ref_key: "kVideoPlayer",
      ref: e,
      controls: "",
      oncontextmenu: "return false"
    }, " Sorry, your browser does not support the video tag. ", 512));
  }
}), MU = { class: "card-wrapper" }, bU = { class: "card" }, RU = { class: "card-body" }, DU = /* @__PURE__ */ ve("br", null, null, -1), vf = /* @__PURE__ */ Dt({
  __name: "CmsContentLoad",
  setup(n) {
    return (e, t) => (Oe(), je("div", MU, [
      ve("div", bU, [
        ve("div", RU, [
          dt(Ye(Ro), {
            height: "2rem",
            class: "mb-2"
          }),
          dt(Ye(Ro), {
            width: "75%",
            class: "mb-2"
          }),
          dt(Ye(Ro), {
            width: "50%",
            class: "mb-2"
          }),
          dt(Ye(Ro), { class: "mb-2" }),
          DU,
          dt(Ye(Ro), {
            width: "40%",
            class: "mb-2"
          })
        ])
      ])
    ]));
  }
}), OU = /* @__PURE__ */ Dt({
  __name: "KCmsLast",
  props: {
    cmsNodeCode: { default: null },
    cmsContentBaseUrl: { default: null }
  },
  setup(n) {
    const { toDateTimeLongString: e } = Gr(), t = n;
    ln(async () => await u());
    const r = st(!1), o = st(null), u = async () => {
      var c;
      r.value = !0;
      try {
        if (o.value = null, t.cmsNodeCode) {
          const i = (await Qg.getTreeFromNode(t.cmsNodeCode, 1)).childNodes.sort((h, f) => new Date(f.publishedDate).getTime() - new Date(h.publishedDate).getTime());
          i.length > 0 && (o.value = {
            title: i[0].name,
            date: e(new Date(i[0].publishedDate)),
            description: (c = i[0].contents.find((h) => h.code == "text")) == null ? void 0 : c.value.value,
            url: t.cmsContentBaseUrl + i[0].url
          });
        }
      } finally {
        r.value = !1;
      }
    };
    return (c, l) => {
      var h, f, p, d;
      const i = Nt("KCard");
      return r.value ? (Oe(), Wt(vf, { key: 0 })) : (Oe(), Wt(i, {
        key: 1,
        showFlagIcon: !0,
        "text-class": "pb-4",
        topTitle: (h = o.value) == null ? void 0 : h.date,
        title: (f = o.value) == null ? void 0 : f.title,
        text: (p = o.value) == null ? void 0 : p.description,
        labelDetailButton: "Dettagli",
        "show-detail-button": !0,
        detailButtonLinkUrl: (d = o.value) == null ? void 0 : d.url
      }, null, 8, ["topTitle", "title", "text", "detailButtonLinkUrl"]));
    };
  }
}), PU = { class: "card-title" }, IU = { class: "card-title" }, NU = /* @__PURE__ */ Dt({
  __name: "KCmsLatest2",
  props: {
    cmsNodeCode: { default: null },
    cmsContentBaseUrl: { default: null }
  },
  setup(n) {
    const { toDateString: e } = Gr(), t = n;
    ln(async () => await c());
    const r = st(!1), o = st(null), u = st(null), c = async () => {
      var l, i;
      r.value = !0;
      try {
        if (o.value = null, u.value = null, t.cmsNodeCode) {
          const f = (await Qg.getTreeFromNode(t.cmsNodeCode, 2)).childNodes.sort((p, d) => new Date(d.publishedDate).getTime() - new Date(p.publishedDate).getTime());
          f.length > 0 && (o.value = {
            title: f[0].name,
            date: e(new Date(f[0].publishedDate)),
            description: (l = f[0].contents.find((p) => p.code == "text")) == null ? void 0 : l.value.value,
            url: t.cmsContentBaseUrl + f[0].url
          }, f.length > 1 && (u.value = {
            title: f[1].name,
            date: e(new Date(f[1].publishedDate)),
            description: (i = f[1].contents.find((p) => p.code == "text")) == null ? void 0 : i.value.value,
            url: t.cmsContentBaseUrl + f[1].url
          }));
        }
      } finally {
        r.value = !1;
      }
    };
    return (l, i) => {
      const h = Nt("KCard"), f = Nt("K2ColContainer");
      return Oe(), Wt(f, {
        col1Class: "p-3",
        col2Class: "p-3"
      }, Cm({
        col1: Ft(() => [
          r.value ? (Oe(), Wt(vf, { key: 0 })) : o.value ? (Oe(), Wt(h, {
            key: 1,
            flat: !0,
            topTitle: o.value.title,
            topTitleClass: "primary-color mb-1",
            topTitleDate: "",
            showDetailButton: !0,
            labelDetailButton: "scopri di più",
            detailButtonLinkUrl: o.value.url
          }, {
            "custom-content": Ft(() => [
              ve("h5", PU, lt(o.value.description), 1)
            ]),
            _: 1
          }, 8, ["topTitle", "detailButtonLinkUrl"])) : mt("", !0)
        ]),
        _: 2
      }, [
        u.value ? {
          name: "col2",
          fn: Ft(() => [
            r.value ? (Oe(), Wt(vf, { key: 0 })) : o.value ? (Oe(), Wt(h, {
              key: 1,
              flat: !0,
              topTitle: u.value.title,
              topTitleClass: "primary-color mb-1",
              topTitleDate: "",
              showDetailButton: !0,
              labelDetailButton: "scopri di più",
              detailButtonLinkUrl: u.value.url
            }, {
              "custom-content": Ft(() => [
                ve("h5", IU, lt(u.value.description), 1)
              ]),
              _: 1
            }, 8, ["topTitle", "detailButtonLinkUrl"])) : mt("", !0)
          ]),
          key: "0"
        } : void 0
      ]), 1024);
    };
  }
}), Em = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  KCmsLast: OU,
  KCmsLatest2: NU,
  KLatestNotifications: hU,
  KWebTvLatest: SU,
  KWebTvVideoPlayer: Q_
}, Symbol.toStringTag, { value: "Module" })), Ba = {
  mounted(n, e, t, r) {
    const o = () => {
      e.value.validate(), Ba.__renderValidation(n, e.value);
    }, u = Ba.__getInputFromElement(n);
    u.removeEventListener("blur", o), u.addEventListener("blur", o), un(e.value, () => {
      Ba.__renderValidation(n, e.value);
    });
  },
  updated(n, e, t, r) {
    Ba.__renderValidation(n, e.value);
  },
  // metodi specifici
  __getInputFromElement(n) {
    if (n.tagName == "input" || n.tagName == "textarea" || n.tagName == "select")
      return n;
    let e = n.querySelector("input");
    return e || (e = n.querySelector("textarea")), e || (e = n.querySelector("select")), e;
  },
  __renderValidation(n, e) {
    if (!e)
      return;
    const t = "is-invalid", r = "is-valid", o = ["form-feedback", "just-validate-error-label"], u = e == null ? void 0 : e.success, c = n.querySelectorAll(`.${o.join(".")}`);
    for (let i = 0; i < c.length; i++)
      c.item(i).remove();
    const l = Ba.__getInputFromElement(n);
    if (u === !0)
      l.classList.contains(t) && l.classList.remove(t), l.classList.contains(r) || l.classList.add(r);
    else if (u === !1) {
      l.classList.contains(t) || l.classList.add(t), l.classList.contains(r) && l.classList.remove(r);
      const i = (e == null ? void 0 : e.errors) || [], h = (e == null ? void 0 : e.messages) || [];
      if (h && h instanceof Array)
        for (let f = 0; f < h.length; f++) {
          const p = h[f], v = "fielderror_" + i[f];
          if (n.querySelectorAll(`.${v}`).length == 0) {
            const m = document.createElement("div");
            for (let A = 0; A < o.length; A++)
              m.classList.add(o[A]);
            m.classList.add(v), m.innerHTML = p, n.appendChild(m);
          }
        }
      if (e.scrollToFieldToken) {
        const f = n;
        f.dataset.lastScrollToken != e.scrollToFieldToken.toString() && (n.scrollIntoView({ behavior: "smooth" }), f.dataset.lastScrollToken = e.scrollToFieldToken.toString());
      }
    } else
      l.classList.contains(t) && l.classList.remove(t), l.classList.contains(r) && l.classList.remove(r);
  }
}, LU = {
  key: 0,
  class: "k-layout-centered-logo"
}, wU = ["src"], xU = { class: "k-layout-centered-box" }, BU = { class: "h5 mb-4" }, FU = { class: "d-flex justify-content-end mb-3" }, UU = ["loading"], kU = {
  key: 0,
  class: "progress-spinner progress-spinner-active",
  style: { width: "24px", height: "24px", margin: "0 25%" }
}, KU = /* @__PURE__ */ ve("span", { class: "visually-hidden" }, "Caricamento...", -1), jU = [
  KU
], WU = { key: 1 }, VU = { class: "mt-4 btn-links" }, HU = { key: 0 }, $U = /* @__PURE__ */ Dt({
  __name: "Login",
  setup(n) {
    const { getAppTitle: e, getPathForAsset: t, _appHomeRoutePath: r, _customRegistrationPagePath: o, _showLogoInLoginPage: u } = fn(), { kToast: c } = Dr(), l = e(), i = kn(), h = yr(), f = st(!1), p = st(""), d = st(""), v = async () => {
      if (A.value = "", p.value.length > 0 && d.value.length > 0)
        if (f.value = !0, await h.login(p.value, d.value), f.value = !1, !h.isLogged)
          h.userAuthData && h.userAuthData.passwordExpired === !0 ? (c.showInfo("Cambio password", "La password deve essere cambiata per il primo utilizzo."), i.push("/newpassword")) : h.userAuthData && h.userAuthData.requireVerificationCode === !0 ? (c.showInfo("Codice di verifia", "Inserire il codice di verifica inviato."), i.push("/codver")) : A.value = "Nome utente o password non validi.";
        else {
          let b = r.value;
          if (i.currentRoute.value.query) {
            let S = i.currentRoute.value.query.returnUrl;
            S && S.length > 0 && (b = S.toString());
          }
          i.push(b);
        }
      else
        A.value = "Specificare nome utente e password per proseguire.";
    }, g = () => {
      h.logout();
    }, m = Ht(() => h.isLogged), A = st("");
    return (b, S) => {
      const N = Nt("router-link"), T = Nt("KCard"), R = Nt("KAlert");
      return Oe(), je(dn, null, [
        Ye(u) ? (Oe(), je("div", LU, [
          ve("img", {
            alt: "logo",
            src: Ye(t)("logo.png"),
            style: { height: "50px" }
          }, null, 8, wU)
        ])) : mt("", !0),
        ve("div", xU, [
          dt(T, {
            shadow: !1,
            class: "k-layout-centered-card"
          }, Cm({ _: 2 }, [
            m.value ? {
              name: "custom-content",
              fn: Ft(() => [
                ve("h1", { class: "h5 mb-4" }, [
                  an(lt(Ye(l)) + " ", 1),
                  ve("br"),
                  an(" Accesso Eseguito")
                ]),
                dt(N, {
                  to: Ye(r),
                  "active-class": "active"
                }, {
                  default: Ft(() => [
                    an("TORNA ALLA HOME")
                  ]),
                  _: 1
                }, 8, ["to"]),
                ve("div", { class: "mt-4" }, [
                  ve("button", {
                    type: "button",
                    class: "btn btn-primary",
                    loading: f.value,
                    onClick: g
                  }, "Esci", 8, ["loading"])
                ])
              ]),
              key: "1"
            } : {
              name: "custom-content",
              fn: Ft(() => [
                ve("h1", BU, lt(Ye(l)) + " Login", 1),
                dt(Ye(z_), {
                  labelText: "Username",
                  modelValue: p.value,
                  "onUpdate:modelValue": S[0] || (S[0] = (y) => p.value = y),
                  autocomplete: "username",
                  onKeyup: pa(v, ["enter"])
                }, null, 8, ["modelValue"]),
                dt(Ye($_), {
                  labelText: "Password",
                  modelValue: d.value,
                  "onUpdate:modelValue": S[1] || (S[1] = (y) => d.value = y),
                  onKeyup: pa(v, ["enter"])
                }, null, 8, ["modelValue"]),
                ve("div", FU, [
                  ve("button", {
                    type: "button",
                    class: Ct(["btn btn-primary", { disabled: f.value }]),
                    style: { "min-width": "100px" },
                    loading: f.value,
                    onClick: v
                  }, [
                    f.value ? (Oe(), je("div", kU, jU)) : (Oe(), je("span", WU, "Accedi"))
                  ], 10, UU)
                ]),
                ve("div", VU, [
                  ve("button", {
                    type: "button",
                    class: "btn",
                    onClick: S[2] || (S[2] = (y) => {
                      Ye(i).push("/resetpassword");
                    })
                  }, "Non riesci ad accedere?"),
                  (Ye(o) || "") != "" ? (Oe(), je("div", HU, [
                    ve("button", {
                      type: "button",
                      class: "btn",
                      onClick: S[3] || (S[3] = (y) => Ye(i).push(Ye(o)))
                    }, "Non sei ancora registrato? Registrati")
                  ])) : mt("", !0)
                ])
              ]),
              key: "0"
            }
          ]), 1024),
          A.value && A.value.length > 0 ? (Oe(), Wt(R, {
            key: 0,
            level: "danger",
            body: A.value
          }, null, 8, ["body"])) : mt("", !0)
        ])
      ], 64);
    };
  }
}), GU = /* @__PURE__ */ Dt({
  __name: "Sso",
  setup(n) {
    const e = $r(), t = kn(), r = yr();
    return ln(async () => {
      await t.isReady();
      const o = e.params.token;
      await r.loginSso(o) && t.replace("/");
    }), (o, u) => (Oe(), je("div", null, "Redirect..."));
  }
}), zU = /* @__PURE__ */ Dt({
  __name: "NotFound",
  setup(n) {
    const e = kn(), t = $r(), r = yr(), { _appHomeRoutePath: o } = fn(), u = st("");
    let c = 0, l = 0;
    return ln(() => {
      c = 0, u.value = ".", l = setInterval(() => {
        c++, u.value = u.value + ".", c > 5 && (clearInterval(l), u.value = "404"), r.user && e.getRoutes().findIndex((i) => {
          var p, d, v;
          let h = i.path == ((p = t.redirectedFrom) == null ? void 0 : p.path);
          if (!h) {
            if (i.children.length > 0 && ((d = t.redirectedFrom) != null && d.params) && Array.isArray(t.redirectedFrom.params.pathMatch) && t.redirectedFrom.params.pathMatch.length > 0) {
              const g = i.path.startsWith("/" + t.redirectedFrom.params.pathMatch[0]), m = i.children.find((A) => A.path == t.redirectedFrom.params.pathMatch[t.redirectedFrom.params.pathMatch.length - 1]);
              h = g && m != null;
            }
            if (i.path.includes("/:") && ((v = t.redirectedFrom) != null && v.params) && Array.isArray(t.redirectedFrom.params.pathMatch) && t.redirectedFrom.params.pathMatch.length > 0) {
              const g = i.path.slice(1).split("/");
              for (var f = 0; f < g.length && !g[f].includes(":"); f++)
                h = g[f] == t.redirectedFrom.params.pathMatch[f];
            }
          }
          return h;
        }) >= 0 && (clearInterval(l), lr(() => {
          e.replace(t.redirectedFrom.path);
        }));
      }, 200);
    }), (i, h) => {
      const f = Nt("router-link");
      return Oe(), je(dn, null, [
        ve("h1", null, lt(u.value), 1),
        u.value == "404" ? (Oe(), Wt(f, {
          key: 0,
          to: Ye(o)
        }, {
          default: Ft(() => [
            an("Home")
          ]),
          _: 1
        }, 8, ["to"])) : mt("", !0)
      ], 64);
    };
  }
}), YU = {}, XU = /* @__PURE__ */ ve("h1", null, "NOT AUTHORIZED", -1);
function QU(n, e) {
  const t = Nt("router-link");
  return Oe(), je(dn, null, [
    XU,
    dt(t, {
      to: "/login",
      "active-class": "active"
    }, {
      default: Ft(() => [
        an("Please login")
      ]),
      _: 1
    })
  ], 64);
}
const JU = /* @__PURE__ */ ud(YU, [["render", QU]]), ZU = { class: "card" }, qU = ["loading"], ek = {
  key: 0,
  class: "progress-spinner progress-spinner-active",
  style: { width: "24px", height: "24px", margin: "0 25%" }
}, tk = /* @__PURE__ */ ve("span", { class: "visually-hidden" }, "salvataggio...", -1), nk = [
  tk
], rk = { key: 1 }, ik = /* @__PURE__ */ Dt({
  __name: "ChangePassword",
  setup(n) {
    const e = st(""), t = st(""), r = st(""), o = st(""), u = yr(), c = Sf();
    Mm();
    const l = st(!1), i = async () => {
      if (t.value != null && (t.value.trim().length < 8 || /^[a-zA-Z0-9~_&*%@$!.\-]+$/.test(t.value) == !1)) {
        o.value = "La password deve essere lunga almeno 8 caratteri. Può contenere lettere, numeri e i caratteri ~_&*%@$!.-";
        return;
      }
      if (t.value != r.value) {
        o.value = "La password e la sua conferma non coincidono.";
        return;
      }
      if (t.value == e.value) {
        o.value = "La nuova password deve essere diversa da quella attuale.";
        return;
      }
      if (e.value.length > 0 && t.value.length > 0 && r.value.length > 0) {
        l.value = !0;
        const h = await u.changePassword(e.value, t.value, r.value);
        l.value = !1, h ? h.success ? (c.add({ severity: "success", summary: "Completato", detail: "Operazione effettata correttamente.", life: 3e3 }), o.value = "", e.value = "", t.value = "", r.value = "") : (o.value = "Si è verificato un problema.", h.details.length > 0 && (o.value = h.details[0].message)) : o.value = "Si è verificato un problema.";
      } else
        o.value = "Specificare la vecchia password e la nuova password per proseguire.";
    };
    return ln(async () => {
    }), (h, f) => {
      const p = Nt("PageHeader"), d = Nt("KInputPassword"), v = Nt("KAlert"), g = Nt("Page");
      return Oe(), Wt(g, null, {
        default: Ft(() => [
          dt(p, { title: "Modifica Password" }),
          ve("div", ZU, [
            dt(d, {
              labelText: "Vecchia Password",
              modelValue: e.value,
              "onUpdate:modelValue": f[0] || (f[0] = (m) => e.value = m)
            }, null, 8, ["modelValue"]),
            dt(d, {
              labelText: "Nuova Password",
              modelValue: t.value,
              "onUpdate:modelValue": f[1] || (f[1] = (m) => t.value = m)
            }, null, 8, ["modelValue"]),
            dt(d, {
              labelText: "Conferma Nuova Password",
              modelValue: r.value,
              "onUpdate:modelValue": f[2] || (f[2] = (m) => r.value = m)
            }, null, 8, ["modelValue"]),
            ve("div", null, [
              ve("button", {
                type: "button",
                class: Ct(["btn btn-primary", { disabled: l.value }]),
                style: { "min-width": "100px" },
                loading: l.value,
                onClick: i
              }, [
                l.value ? (Oe(), je("div", ek, nk)) : (Oe(), je("span", rk, "Salva"))
              ], 10, qU)
            ])
          ]),
          o.value && o.value.length > 0 ? (Oe(), Wt(v, {
            key: 0,
            level: "danger",
            class: "mt-4",
            body: o.value
          }, null, 8, ["body"])) : mt("", !0)
        ]),
        _: 1
      });
    };
  }
}), ak = { class: "k-layout-centered-box" }, ok = /* @__PURE__ */ ve("h5", { class: "mb-2" }, "Codice di verifica", -1), sk = /* @__PURE__ */ ve("p", { class: "mb-6" }, " Ti è stato inviato un codice di verifica. Inserisci il codice e conferma per proseguire. ", -1), lk = { class: "d-flex justify-content-end" }, uk = ["loading"], ck = {
  key: 0,
  class: "progress-spinner progress-spinner-active",
  style: { width: "24px", height: "24px", margin: "0 25%" }
}, fk = /* @__PURE__ */ ve("span", { class: "visually-hidden" }, "Caricamento...", -1), dk = [
  fk
], hk = { key: 1 }, pk = /* @__PURE__ */ Dt({
  __name: "CodeVerification2FA",
  setup(n) {
    const e = st(""), t = st(""), r = kn(), o = yr(), { kToast: u } = Dr(), c = st(!1), l = async () => {
      await o.requestNewVerificationCode(), u.showInfo("Richiesta nuovo codice inviata.");
    }, i = async () => {
      if (e.value == null || e.value.trim().length == 0) {
        t.value = "Il codice di verifica inserito non è valido!";
        return;
      }
      t.value = null, c.value = !0;
      try {
        if (await o.loginWithVerificationCode(e.value), !o.isLogged)
          o.userAuthData && o.userAuthData.passwordExpired === !0 ? (u.showInfo("Cambio password", "La password deve essere cambiata per il primo utilizzo."), r.push("/newpassword")) : (u.showInfo("Codice di verifia", "Inserire il codice di verifica inviato."), t.value = "Il codice di verifica inserito non è valido!");
        else {
          let h = "/";
          r.push(h);
        }
      } finally {
        c.value = !1;
      }
    };
    return (h, f) => {
      const p = Nt("KInputText");
      return Oe(), je("div", ak, [
        dt(Ye(bm), {
          shadow: !1,
          class: "k-layout-centered-card"
        }, {
          "custom-content": Ft(() => [
            ok,
            sk,
            dt(p, {
              labelText: "Codice verifica",
              modelValue: e.value,
              "onUpdate:modelValue": f[0] || (f[0] = (d) => e.value = d),
              onKeyup: pa(i, ["enter"])
            }, null, 8, ["modelValue"]),
            ve("div", lk, [
              ve("button", {
                type: "button",
                class: Ct(["btn btn-primary", { disabled: c.value }]),
                style: { "min-width": "100px" },
                loading: c.value,
                onClick: i
              }, [
                c.value ? (Oe(), je("div", ck, dk)) : (Oe(), je("span", hk, "CONFERMA"))
              ], 10, uk)
            ]),
            ve("div", { class: "btn-links" }, [
              ve("button", {
                type: "button",
                class: "btn",
                onClick: l
              }, "Invia un altro codice.")
            ])
          ]),
          _: 1
        }),
        t.value && t.value.length > 0 ? (Oe(), Wt(Ye(Cf), {
          key: 0,
          level: Ye(ja).danger,
          body: t.value
        }, null, 8, ["level", "body"])) : mt("", !0)
      ]);
    };
  }
}), mk = { class: "k-layout-centered-box" }, gk = /* @__PURE__ */ ve("h5", null, "Cambio password per primo utilizzo", -1), vk = { class: "d-flex justify-content-end mt-4" }, _k = ["loading"], Ek = {
  key: 0,
  class: "progress-spinner progress-spinner-active",
  style: { width: "24px", height: "24px", margin: "0 25%" }
}, yk = /* @__PURE__ */ ve("span", { class: "visually-hidden" }, "...", -1), Tk = [
  yk
], Ak = { key: 1 }, Sk = /* @__PURE__ */ Dt({
  __name: "NewPassword",
  setup(n) {
    const e = st(""), t = st(""), r = st(""), o = st(""), u = kn(), c = yr(), l = st(!1), i = async () => {
      if (o.value = "", t.value != null && (t.value.trim().length < 8 || /^[a-zA-Z0-9~_&*%@$!.\-]+$/.test(t.value) == !1)) {
        o.value = "La password deve essere lunga almeno 8 caratteri. Può contenere lettere, numeri e i caratteri ~_&*%@$!.-";
        return;
      }
      if (t.value != r.value) {
        o.value = "La password e la sua conferma non coincidono.";
        return;
      }
      if (t.value == e.value) {
        o.value = "La nuova password deve essere diversa da quella attuale.";
        return;
      }
      if (e.value.length > 0 && t.value.length > 0 && r.value.length > 0) {
        l.value = !0;
        const h = await c.changeExpiredPassword(e.value, t.value, r.value);
        l.value = !1, h ? c.isLogged ? u.push("/") : c.userAuthData && c.userAuthData.requireVerificationCode === !0 ? u.push("/codver") : u.push({ name: "login" }) : o.value = "Si è verificato un problema.";
      } else
        o.value = "Specificare la vecchia password e la nuova password per proseguire.";
    };
    return (h, f) => {
      const p = Nt("KInputPassword"), d = Nt("KCard"), v = Nt("KAlert");
      return Oe(), je("div", mk, [
        dt(d, {
          shadow: !1,
          class: "k-layout-centered-card"
        }, {
          "custom-content": Ft(() => [
            gk,
            dt(p, {
              labelText: "Vecchia Password",
              modelValue: e.value,
              "onUpdate:modelValue": f[0] || (f[0] = (g) => e.value = g)
            }, null, 8, ["modelValue"]),
            dt(p, {
              labelText: "Nuova Password",
              modelValue: t.value,
              "onUpdate:modelValue": f[1] || (f[1] = (g) => t.value = g)
            }, null, 8, ["modelValue"]),
            dt(p, {
              labelText: "Conferma Nuova Password",
              modelValue: r.value,
              "onUpdate:modelValue": f[2] || (f[2] = (g) => r.value = g)
            }, null, 8, ["modelValue"]),
            ve("div", vk, [
              ve("button", {
                type: "button",
                class: Ct(["btn btn-primary", { disabled: l.value }]),
                style: { "min-width": "100px" },
                loading: l.value,
                onClick: i
              }, [
                l.value ? (Oe(), je("div", Ek, Tk)) : (Oe(), je("span", Ak, "Salva"))
              ], 10, _k)
            ])
          ]),
          _: 1
        }),
        o.value && o.value.length > 0 ? (Oe(), Wt(v, {
          key: 0,
          level: "danger",
          body: o.value
        }, null, 8, ["body"])) : mt("", !0)
      ]);
    };
  }
}), Ck = { class: "k-layout-centered-box" }, Mk = /* @__PURE__ */ ve("p", null, [
  /* @__PURE__ */ an(" Non ricordi la password?"),
  /* @__PURE__ */ ve("br"),
  /* @__PURE__ */ an("Inserisci la tua mail, riceverai un codice di verifica all'indirizzo specificato e le istruzioni per poterla modificare. ")
], -1), bk = { class: "field" }, Rk = /* @__PURE__ */ ve("label", { for: "mail" }, "Indirizzo e-mail", -1), Dk = {
  key: 0,
  class: "field"
}, Ok = /* @__PURE__ */ ve("label", { for: "verificationCode" }, "Inserice codice di verifica", -1), Pk = { class: "mt-4 btn-links" }, Ik = /* @__PURE__ */ Dt({
  __name: "ResetPassword",
  setup(n) {
    const e = kn(), { getAppTitle: t } = fn(), r = t(), o = st(""), u = st(""), { kToast: c } = Dr(), l = st(!1), i = st(!1), h = async () => {
      if (u.value = "", o.value.length > 0) {
        i.value = !0;
        try {
          await rr.generateVerificationCode(o.value);
        } catch (d) {
          console.error(d);
        }
      } else
        u.value = "Specificare l'indirizzo e-mail.";
    }, f = st(), p = async () => {
      if (u.value = "", f.value.length > 0 && o.value.length > 0) {
        l.value = !0;
        try {
          const v = await rr.verifyVerificationCode(o.value, f.value);
          if (v.success)
            e.push({ name: "resetpwdtoken", params: { token: v.data.passwordResetToken } });
          else {
            var d = v.details[0];
            d && d.code == "USER_VERIFCATION_CODE_INVALID" ? u.value = "Codice di verifica non valido" : u.value = "E' avvenuto un errore";
          }
        } catch (v) {
          c.showError("Errore", v.toString());
        }
        l.value = !1;
      } else
        o.value.length == 0 ? u.value = "Specificare la mail." : f.value.length == 0 && (u.value = "Specificare il codice di conferma.");
    };
    return (d, v) => {
      const g = Nt("KCard"), m = Nt("KAlert");
      return Oe(), je("div", Ck, [
        dt(g, {
          shadow: !1,
          class: "k-layout-centered-card"
        }, {
          "custom-content": Ft(() => [
            ve("h5", null, lt(Ye(r)), 1),
            Mk,
            ve("p", null, [
              ve("div", bk, [
                Rk,
                ha(ve("input", {
                  type: "text",
                  id: "mail",
                  "onUpdate:modelValue": v[0] || (v[0] = (A) => o.value = A),
                  class: "text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                }, null, 512), [
                  [Tc, o.value]
                ])
              ]),
              i.value ? (Oe(), je("div", Dk, [
                Ok,
                ha(ve("input", {
                  type: "text",
                  id: "verificationCode",
                  "onUpdate:modelValue": v[1] || (v[1] = (A) => f.value = A),
                  class: "text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                }, null, 512), [
                  [Tc, f.value]
                ])
              ])) : mt("", !0)
            ]),
            ve("div", Pk, [
              i.value ? (Oe(), je("button", {
                key: 0,
                type: "button",
                class: "btn mb-3",
                onClick: p
              }, "Verifica codice")) : mt("", !0),
              ve("div", null, [
                ve("button", {
                  type: "button",
                  class: "btn",
                  onClick: h
                }, lt(i.value ? "Invia di nuovo" : "Invia la richiesta"), 1)
              ])
            ])
          ]),
          _: 1
        }),
        u.value && u.value.length > 0 ? (Oe(), Wt(m, {
          key: 0,
          level: "danger",
          body: u.value
        }, null, 8, ["body"])) : mt("", !0)
      ]);
    };
  }
}), Nk = { class: "k-layout-centered-box" }, Lk = /* @__PURE__ */ ve("p", null, " Inserisci una nuova password per completare l'operazione di reset. ", -1), wk = /* @__PURE__ */ Dt({
  __name: "ResetPasswordWithToken",
  setup(n) {
    const e = $r(), t = kn(), { getAppTitle: r } = fn(), o = r();
    st("");
    const u = st(""), c = st(""), l = st("");
    yr();
    const i = Sf(), h = st(!1), f = async () => {
      if (l.value = "", u.value != null && (u.value.trim().length < 8 || /^[a-zA-Z0-9~_&*%@$!]+$/.test(u.value) == !1)) {
        l.value = "La password deve essere lunga almeno 8 caratteri. Può contenere lettere, numeri e i caratteri ~_&*%@$!";
        return;
      }
      if (u.value != c.value) {
        l.value = "La password e la sua conferma non coincidono.";
        return;
      }
      if (u.value.length > 0 && c.value.length > 0) {
        h.value = !0;
        const p = e.params.token;
        console.log("token"), console.log(p);
        const d = await rr.resetPasswordWithToken(p, u.value);
        h.value = !1, d ? d.success ? (i.add({ severity: "success", summary: "Completato", detail: "Operazione effettata correttamente.", life: 3e3 }), l.value = "", u.value = "", c.value = "", t.push({ name: "login" })) : (l.value = "Si è verificato un problema.", d.details.length > 0 && (l.value = d.details[0].message)) : l.value = "Si è verificato un problema.";
      }
    };
    return (p, d) => {
      const v = Nt("KInputPassword"), g = Nt("KCard"), m = Nt("KAlert");
      return Oe(), je("div", Nk, [
        dt(g, {
          shadow: !1,
          class: "k-layout-centered-card"
        }, {
          "custom-content": Ft(() => [
            ve("h5", null, lt(Ye(o)), 1),
            Lk,
            dt(v, {
              labelText: "Nuova Password",
              modelValue: u.value,
              "onUpdate:modelValue": d[0] || (d[0] = (A) => u.value = A)
            }, null, 8, ["modelValue"]),
            dt(v, {
              labelText: "Conferma Nuova Password",
              modelValue: c.value,
              "onUpdate:modelValue": d[1] || (d[1] = (A) => c.value = A)
            }, null, 8, ["modelValue"]),
            ve("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: f
            }, "Salva la nuova password")
          ]),
          _: 1
        }),
        l.value && l.value.length > 0 ? (Oe(), Wt(m, {
          key: 0,
          level: "danger",
          body: l.value
        }, null, 8, ["body"])) : mt("", !0)
      ]);
    };
  }
}), xk = { key: 0 }, Bk = /* @__PURE__ */ ve("hr", null, null, -1), Fk = {
  key: 0,
  class: "k-notification-actions"
}, Uk = { key: 0 }, kk = {
  key: 1,
  class: "k-notification-custom-panel"
}, Kk = /* @__PURE__ */ Dt({
  __name: "KNotificationDetail",
  setup(n) {
    const { toDateString: e, toDateTimeString: t } = Gr(), r = cd(), { getCustomNotificationHandlerForModule: o, _appOptionsNotification: u } = fn(), c = st(null);
    un(
      () => r.selectedNotification,
      (g, m) => {
        if (g != null) {
          const A = o(g.multichannelNotificationLite.module);
          if (A && A.detailViewHandler) {
            c.value = A.detailViewHandler;
            return;
          }
        }
        c.value = null;
      },
      { immediate: !0 }
    );
    const l = st(!1), i = st(!1), h = st(""), f = async () => {
      var g;
      if (h.value && h.value.length > 0) {
        const m = (g = r.selectedNotification.subject) != null && g.toUpperCase().startsWith("RE:") ? r.selectedNotification.subject : "RE: " + r.selectedNotification.subject;
        await vi.sendInAppNotification(
          r.selectedNotification.multichannelNotificationLite.sender.id,
          m,
          h.value
        ), r.loadNotifications(), h.value = "", i.value = !0, setTimeout(() => {
          i.value = !1, l.value = !1;
        }, 2e3);
      }
    }, p = st(!1), d = Ht({
      get: () => {
        var g;
        return ((g = r.selectedNotification) == null ? void 0 : g.isRead) == !0;
      },
      set: async (g) => {
        p.value = !0;
        try {
          if (r.selectedNotification) {
            const m = !r.selectedNotification.isRead;
            await r.setNotificationReadState(r.selectedNotification.id, m) && (r.selectedNotification.isRead = m);
          }
        } finally {
          p.value = !1;
        }
      }
    }), v = Ht(() => r.selectedNotification && r.selectedNotification.multichannelNotificationLite && r.selectedNotification.multichannelNotificationLite.sender ? r.selectedNotification.multichannelNotificationLite.sender.firstName + " " + r.selectedNotification.multichannelNotificationLite.sender.lastName : " -?- ");
    return (g, m) => {
      var S;
      const A = Nt("KToggle"), b = Nt("KSpinner");
      return Ye(r).selectedNotification ? (Oe(), je("div", xk, [
        dt(Ye(Ld), {
          title: Ye(r).selectedNotification.subject
        }, null, 8, ["title"]),
        ve("div", null, "Data e ora: " + lt(Ye(t)(Ye(r).selectedNotification.dateTime)), 1),
        ve("div", null, "Inviato da: " + lt(v.value), 1),
        Bk,
        ve("div", null, lt(Ye(r).selectedNotification.body), 1),
        dt(b, { loading: p.value }, {
          default: Ft(() => [
            dt(A, {
              modelValue: d.value,
              "onUpdate:modelValue": m[0] || (m[0] = (N) => d.value = N),
              label: "Notifica letta"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["loading"]),
        (S = Ye(u)) != null && S.disableNotificationReply ? mt("", !0) : (Oe(), je("div", Fk, [
          l.value ? mt("", !0) : (Oe(), je("button", {
            key: 0,
            type: "button",
            class: "btn btn-outline-primary btn-xs px-5",
            onClick: m[1] || (m[1] = (N) => l.value = !l.value)
          }, " RISPONDI ")),
          dt(Ac, {
            name: "fade",
            mode: "out-in"
          }, {
            default: Ft(() => [
              l.value ? (Oe(), je("div", Uk, [
                i.value ? (Oe(), Wt(Ye(Cf), {
                  key: 0,
                  level: Ye(ja).info,
                  title: "Messaggio di risposta inviato.."
                }, null, 8, ["level"])) : mt("", !0),
                i.value ? mt("", !0) : (Oe(), Wt(Ye(Y_), {
                  key: 1,
                  modelValue: h.value,
                  "onUpdate:modelValue": m[2] || (m[2] = (N) => h.value = N),
                  style: { "margin-bottom": "0" }
                }, null, 8, ["modelValue"])),
                i.value ? mt("", !0) : (Oe(), je("button", {
                  key: 2,
                  style: { "margin-left": "10px" },
                  type: "button",
                  class: "btn btn-primary btn-xs px-5",
                  onClick: m[3] || (m[3] = (N) => f())
                }, " INVIA RISPOSTA "))
              ])) : mt("", !0)
            ]),
            _: 1
          })
        ])),
        c.value ? (Oe(), je("div", kk, [
          (Oe(), Wt(Af(c.value), {
            notification: Ye(r).selectedNotification
          }, null, 8, ["notification"]))
        ])) : mt("", !0)
      ])) : mt("", !0);
    };
  }
});
const jk = {
  class: "d-inline-flex align-items-center",
  style: { "margin-left": "20px" }
}, ym = /* @__PURE__ */ Dt({
  __name: "Notifications",
  setup(n) {
    const { toDateTimeString: e } = Gr(), t = cd(), r = $r(), o = kn();
    st(!1);
    const u = st(!1), c = st("");
    un(
      () => r.params.id,
      async () => await l()
    ), un(() => u.value, (d, v) => {
      v != d && d == !1 && o.push({ name: "notifications-list" });
    }), un(() => c.value, async (d, v) => {
      v != d && (d == "" ? t.filter.readState = null : d == "false" ? t.filter.readState = !1 : d == "true" && (t.filter.readState = !0), await p());
    }), ln(async () => {
      await t.loadNotifications(!0), await o.isReady(), await l();
    });
    const l = async () => {
      let v = r.params.id;
      v || (v = "0"), await i(parseInt(v));
    }, i = async (d) => {
      if (d > 0) {
        let v = t.notifications.find((g) => g.id == d);
        v == null && (await t.loadNotification(d), v = t.notifications.find((g) => g.id == d)), v.isRead === !1 && await t.setNotificationReadState(d, !0) && (v.isRead = !0), t.selectedNotification = v;
      } else
        t.selectedNotification = null;
      lr(() => u.value = t.selectedNotification != null);
    }, h = (d) => {
      o.push({ name: "notification-detail", params: { id: d } });
    }, f = async (d) => {
      t.filter.page = d - 1, await t.loadNotifications();
    }, p = async () => {
      t.filter.page = 0, await t.loadNotifications();
    };
    return (d, v) => {
      const g = Nt("PageHeader"), m = Nt("KSelect"), A = Nt("KInputSearch"), b = Nt("Column"), S = Nt("DataTable"), N = Nt("KPaginator"), T = Nt("KModalSlide"), R = Nt("Page");
      return Oe(), Wt(R, { title: "Lista notifiche" }, {
        default: Ft(() => [
          dt(g, { title: "Centro notifiche" }),
          dt(A, {
            onSearch: p,
            modelValue: Ye(t).filter.search,
            "onUpdate:modelValue": v[1] || (v[1] = (y) => Ye(t).filter.search = y),
            placeholder: "Cerca per mittente, titolo, corpo"
          }, {
            default: Ft(() => [
              ve("div", jk, [
                an(" Filtro stato: "),
                dt(m, {
                  options: Ye(t).optionsStates,
                  modelValue: c.value,
                  "onUpdate:modelValue": v[0] || (v[0] = (y) => c.value = y),
                  style: { "margin-bottom": "0" }
                }, null, 8, ["options", "modelValue"])
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          dt(S, {
            "table-class": "k-data-table k-row-clickable",
            onRowClick: v[2] || (v[2] = (y) => h(y.data.id)),
            value: Ye(t).notifications,
            dataKey: "id",
            responsiveLayout: "scroll"
          }, {
            empty: Ft(() => [
              an(" Nessuna notifica presente. ")
            ]),
            default: Ft(() => [
              dt(b, {
                field: "dateTime",
                header: "Data"
              }, {
                body: Ft(({ data: y }) => [
                  ve("div", {
                    style: mr({ "font-weight": y.isRead ? "normal" : "bold" })
                  }, lt(Ye(e)(y.dateTime)), 5)
                ]),
                _: 1
              }),
              dt(b, {
                field: "sender",
                header: "Mittente"
              }, {
                body: Ft(({ data: y }) => [
                  ve("div", {
                    style: mr({ "font-weight": y.isRead ? "normal" : "bold" })
                  }, lt(y.multichannelNotificationLite.sender.firstName + " " + y.multichannelNotificationLite.sender.lastName), 5)
                ]),
                _: 1
              }),
              dt(b, {
                field: "subject",
                header: "Titolo"
              }, {
                body: Ft(({ data: y }) => [
                  ve("div", {
                    style: mr({ "font-weight": y.isRead ? "normal" : "bold" })
                  }, lt(y.subject), 5)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"]),
          dt(N, {
            "current-page": Ye(t).currentPage,
            "total-count": Ye(t).totalCount,
            "total-pages": Ye(t).totalPages,
            "show-total-count": !0,
            onPageSelected: f
          }, null, 8, ["current-page", "total-count", "total-pages"]),
          dt(T, {
            modelValue: u.value,
            "onUpdate:modelValue": v[3] || (v[3] = (y) => u.value = y),
            title: "Dettaglio Notifica"
          }, {
            default: Ft(() => [
              dt(Kk)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      });
    };
  }
}), Wk = {
  key: "k-projects",
  name: "Progetti",
  routes: Zg,
  initModule: () => {
    console.log("Modulo DPR&DI inizializzato.");
  },
  notificationPlugins: null,
  searchPlugins: null
}, Vk = { class: "card-wrapper" }, Hk = { class: "card card-img no-after" }, $k = { class: "img-responsive-wrapper" }, Gk = { class: "img-responsive" }, zk = { class: "img-wrapper" }, Yk = { class: "k-module-webtv-item-placeholder" }, Xk = ["src", "title", "alt"], Qk = { class: "k-module-webtv-item-play-overlay" }, Jk = /* @__PURE__ */ ve("div", null, [
  /* @__PURE__ */ ve("span", { class: "visually-hidden" }, "Play video")
], -1), Zk = {
  class: "card-body",
  style: { padding: "4px 0 24px 0" }
}, qk = {
  class: "card-title h5 mb-0",
  style: { overflow: "hidden", "text-overflow": "ellipsis", "white-space": "nowrap" }
}, eK = { class: "badge bg-primary" }, tK = /* @__PURE__ */ ve("span", { class: "text" }, "Vai al video", -1), nK = { class: "visually-hidden" }, rK = /* @__PURE__ */ Dt({
  __name: "KWebTvListItem",
  props: {
    video: {}
  },
  setup(n) {
    const e = Ql();
    return (t, r) => {
      const o = Nt("router-link");
      return Oe(), je("div", Vk, [
        ve("div", Hk, [
          ve("div", $k, [
            ve("div", Gk, [
              ve("figure", zk, [
                ve("span", Yk, [
                  ve("p", null, lt(t.video.title), 1)
                ]),
                ve("img", {
                  src: Ye(e).getMediumThumbnailUrl(t.video),
                  style: { position: "absolute" },
                  title: t.video.title,
                  alt: t.video.title
                }, null, 8, Xk),
                ve("span", Qk, [
                  dt(o, {
                    to: "video/" + t.video.id
                  }, {
                    default: Ft(() => [
                      Jk
                    ]),
                    _: 1
                  }, 8, ["to"])
                ])
              ])
            ])
          ]),
          ve("div", Zk, [
            ve("h3", qk, lt(t.video.title), 1),
            ve("div", null, [
              ve("span", eK, lt(t.video.categoryName), 1)
            ]),
            dt(o, {
              class: "read-more",
              style: { right: "0" },
              to: "video/" + t.video.id
            }, {
              default: Ft(() => [
                tK,
                ve("span", nK, lt(t.video.title), 1),
                dt(Ye(yn), { icon: "it-arrow-right" })
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ])
      ]);
    };
  }
});
const iK = { class: "row" }, aK = /* @__PURE__ */ Dt({
  __name: "KWebTvList",
  props: {
    items: {}
  },
  setup(n) {
    return (e, t) => (Oe(), je("div", iK, [
      (Oe(!0), je(dn, null, Un(e.items, (r) => (Oe(), je("div", {
        class: "col-12 col-md-6 col-lg-4",
        key: r.id
      }, [
        dt(rK, { video: r }, null, 8, ["video"])
      ]))), 128))
    ]));
  }
}), oK = /* @__PURE__ */ Dt({
  __name: "Video",
  setup(n) {
    const e = Ql(), t = st(!1);
    return ln(async () => {
      t.value = !0, await e.advancedSearch(), t.value = !1;
    }), (r, o) => {
      const u = Nt("PageHeader"), c = Nt("Page");
      return Oe(), Wt(c, { loading: t.value }, {
        default: Ft(() => [
          dt(u, { title: "Video" }),
          dt(Ye(G_), {
            modelValue: Ye(e).advancedSearchTerm,
            "onUpdate:modelValue": o[0] || (o[0] = (l) => Ye(e).advancedSearchTerm = l),
            onSearch: Ye(e).advancedSearch
          }, null, 8, ["modelValue", "onSearch"]),
          dt(aK, {
            items: Ye(e).advancedSearchResults
          }, null, 8, ["items"])
        ]),
        _: 1
      }, 8, ["loading"]);
    };
  }
}), sK = ["innerHTML"], lK = /* @__PURE__ */ Dt({
  __name: "VideoDetail",
  setup(n) {
    const e = $r(), t = st(e.params.id), r = st();
    return ln(async () => {
      r.value = await Jr.getVideoDetails(t.value);
    }), (o, u) => {
      const c = Nt("PageHeader"), l = Nt("Page");
      return Oe(), Wt(l, null, {
        default: Ft(() => [
          dt(c, {
            title: r.value ? r.value.title : "Caricamento video.."
          }, null, 8, ["title"]),
          dt(Q_, { idVideo: t.value }, null, 8, ["idVideo"]),
          ve("div", {
            innerHTML: r.value && r.value.description
          }, null, 8, sK)
        ]),
        _: 1
      });
    };
  }
}), uK = [
  {
    name: "video-list",
    path: "/video",
    component: oK,
    meta: {
      requiresAuth: !0,
      menu: {
        order: 50,
        label: "Video",
        iconAsset: "icons/ico-webtv.svg"
      }
    }
  },
  {
    name: "video-detail",
    path: "/video/:id",
    component: lK,
    meta: {
      requiresAuth: !0
    }
  }
], cK = {
  key: "k-webtv",
  name: "WEB TV",
  routes: uK,
  initModule: () => {
    console.log("Modulo WebTV inizializzato.");
  },
  notificationPlugins: null,
  searchPlugins: [Jg]
}, fK = [Wk, cK], Tm = [
  {
    name: "login",
    path: "/login",
    component: $U,
    meta: { layout: "anonymous" }
  },
  {
    path: "/sso/:token",
    component: GU,
    meta: { layout: "anonymous" }
  },
  {
    name: "forbidden",
    path: "/forbidden",
    component: JU,
    meta: { layout: "anonymous" }
  },
  {
    name: "notfound",
    path: "/404",
    component: zU,
    meta: { layout: "anonymous" }
  },
  {
    name: "changepwd",
    path: "/changepassword",
    component: ik,
    meta: {
      requiresAuth: !0
    }
  },
  {
    name: "code-verification",
    path: "/codver",
    component: pk,
    meta: { layout: "anonymous" }
  },
  {
    name: "newpwd",
    path: "/newpassword",
    component: Sk,
    meta: { layout: "anonymous" }
  },
  {
    name: "resetpwd",
    path: "/resetpassword",
    component: Ik,
    meta: { layout: "anonymous" }
  },
  {
    name: "resetpwdtoken",
    path: "/resetpassword-with-token/:token",
    component: wk,
    meta: { layout: "anonymous" }
  },
  {
    name: "notifications-list",
    path: "/notifications",
    component: ym,
    meta: {
      requiresAuth: !0
    }
  },
  {
    name: "notification-detail",
    path: "/notifications/:id",
    component: ym,
    meta: {
      requiresAuth: !0
    }
  }
], dK = (n) => {
  const e = n.optionalModules, t = n.routingOptions.routeBasePath, r = n.routingOptions.routerBeforeNavigateGuard;
  if (n.routingOptions.customUserLoginComponent) {
    const i = Tm.find((h) => h.name == "login");
    i.component = n.routingOptions.customUserLoginComponent;
  }
  const o = Tm, { _config: u } = fn();
  u && u.modules && u.modules.forEach((i) => {
    const h = fK.find((f) => f.key == i.key);
    h && h.routes && o.push(...h.routes);
  }), Array.isArray(e) ? e.forEach((i) => {
    i && i.routes && o.push(...i.routes);
  }) : Object.keys(e).forEach((i) => {
    const h = e[i];
    o.push(...h);
  }), o.forEach((i) => {
    i.meta == null && (i.meta = {}), i.meta.static = !0, i.children && i.children.forEach((h) => {
      h.meta == null && (h.meta = {}), h.meta.static = !0;
    });
  }), o.push({ path: "/:pathMatch(.*)*", name: "not-found", redirect: "/404", meta: { static: !0 } });
  const c = HE({
    history: $E(t),
    routes: o
  }), l = (i, h, f) => {
    if (r) {
      const p = r(i, h);
      p && p.length > 0 ? f(p) : f();
    } else
      f();
  };
  return c.beforeResolve(async (i, h, f) => {
    const p = yr();
    if (i.matched.some((d) => d.meta.requiresAuth === !0))
      if (p.isLogged)
        l(i.fullPath, h.fullPath, f);
      else if (await p.refreshToken(), p.isLogged)
        l(i.fullPath, h.fullPath, f);
      else {
        let d = "/login";
        i.fullPath && i.fullPath.length > 0 && (d += "?returnUrl=" + i.fullPath), f(d);
      }
    else
      f();
  }), c;
}, hK = {
  key: 0,
  role: "presentation",
  class: "k-badge-beta"
}, pK = /* @__PURE__ */ ve("div", { role: "presentation" }, "BETA", -1), mK = [
  pK
], gK = /* @__PURE__ */ Dt({
  __name: "AppContainer",
  setup(n) {
    const { _appBeta: e, _toastQueue: t, _confirmQueue: r } = fn(), o = Sf();
    un(
      t.value,
      () => {
        const d = t.value.pop();
        if (d) {
          let v = {
            severity: d.type,
            summary: d.message,
            detail: d.detail,
            life: d.life && d.life > 0 ? d.life : 3e3
          };
          o.add(v);
        }
      }
    );
    const u = Mm();
    un(
      r.value,
      () => {
        const d = r.value.pop();
        d && u.require({
          header: d.title,
          message: d.message,
          rejectClass: "p-button-outlined",
          acceptClass: "p-button-primary",
          accept: d.accept,
          reject: d.reject
        });
      }
    );
    const c = $r(), l = kn(), { appStarting: i, layouts: h } = RO(), f = yr(), p = Ht(() => i.value === !0 ? h.splash : h[c.meta.layout || "default"]);
    return un(
      () => f.isLogged,
      (d, v) => {
        v === !0 && d === !1 && l.push("/login");
      }
    ), (d, v) => (Oe(), je(dn, null, [
      Ye(e) ? (Oe(), je("div", hK, mK)) : mt("", !0),
      dt(Ye(ey)),
      dt(Ye(qE)),
      (Oe(), Wt(Af(p.value)))
    ], 64));
  }
});
const vK = { class: "intranet-page container-fluid" }, _K = {
  key: 0,
  class: "loading"
}, EK = /* @__PURE__ */ Dt({
  __name: "Page",
  props: {
    loading: { type: Boolean, default: !1 }
  },
  setup(n) {
    return (e, t) => (Oe(), je("div", vK, [
      pn(e.$slots, "default"),
      e.loading ? (Oe(), je("div", _K)) : mt("", !0)
    ]));
  }
});
const yK = { class: "d-flex align-items-center mb-2" }, TK = { class: "ms-auto" }, AK = /* @__PURE__ */ Dt({
  __name: "PageHeader",
  props: {
    title: { default: "" },
    sticky: { type: Boolean, default: !1 },
    showBackButton: { type: Boolean, default: !1 }
  },
  setup(n) {
    const e = n;
    return (t, r) => {
      const o = Nt("KBackButton");
      return Oe(), je("div", {
        class: Ct({ sticky: t.sticky, "k-page-header-sticky": t.sticky })
      }, [
        e.showBackButton ? (Oe(), Wt(o, {
          key: 0,
          class: "pb-1"
        })) : mt("", !0),
        ve("div", yK, [
          ve("div", null, [
            ve("h1", null, lt(t.title), 1)
          ]),
          ve("div", TK, [
            pn(t.$slots, "primary-actions")
          ])
        ]),
        ve("div", null, [
          pn(t.$slots, "secondary-actions")
        ])
      ], 2);
    };
  }
}), SK = { class: "c-line lightgrey-bg-c1 k-page-header-full" }, CK = { class: "d-flex align-items-center exit-menu" }, MK = { class: "top-text" }, bK = { class: "row" }, RK = { class: "title-text-underline" }, DK = {
  key: 0,
  class: "row focus-text m-0"
}, OK = /* @__PURE__ */ Dt({
  __name: "PageHeaderFull",
  props: {
    title: { default: null },
    titleUnderline: { default: null }
  },
  setup(n) {
    const e = Sm(), t = Ht(() => {
      const l = e["secondary-actions"];
      if (l) {
        const i = l();
        if (i.length > 0)
          return i[0].children != "v-if";
      }
      return !1;
    }), { toDateTimeLongString: r, toTimeHMString: o } = Gr(), u = st(/* @__PURE__ */ new Date()), c = st(0);
    return ln(() => {
      c.value = setInterval(() => {
        u.value = /* @__PURE__ */ new Date();
      }, 59e3);
    }), oi(() => clearInterval(c.value)), (l, i) => (Oe(), je("div", SK, [
      ve("div", CK, [
        pn(l.$slots, "primary-actions")
      ]),
      ve("div", MK, lt(Ye(r)(u.value)) + " - " + lt(Ye(o)(u.value)), 1),
      ve("div", bK, [
        ve("h1", null, [
          an(lt(l.title) + " ", 1),
          ve("span", RK, lt(l.titleUnderline), 1)
        ])
      ]),
      t.value ? (Oe(), je("div", DK, [
        pn(l.$slots, "secondary-actions")
      ])) : mt("", !0)
    ]));
  }
});
var J_ = { exports: {} };
(function(n, e) {
  (function(t, r) {
    n.exports = r();
  })(Gf, function() {
    var t = "minute", r = /[+-]\d\d(?::?\d\d)?/g, o = /([+-]|\d\d)/g;
    return function(u, c, l) {
      var i = c.prototype;
      l.utc = function(m) {
        var A = { date: m, utc: !0, args: arguments };
        return new c(A);
      }, i.utc = function(m) {
        var A = l(this.toDate(), { locale: this.$L, utc: !0 });
        return m ? A.add(this.utcOffset(), t) : A;
      }, i.local = function() {
        return l(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var h = i.parse;
      i.parse = function(m) {
        m.utc && (this.$u = !0), this.$utils().u(m.$offset) || (this.$offset = m.$offset), h.call(this, m);
      };
      var f = i.init;
      i.init = function() {
        if (this.$u) {
          var m = this.$d;
          this.$y = m.getUTCFullYear(), this.$M = m.getUTCMonth(), this.$D = m.getUTCDate(), this.$W = m.getUTCDay(), this.$H = m.getUTCHours(), this.$m = m.getUTCMinutes(), this.$s = m.getUTCSeconds(), this.$ms = m.getUTCMilliseconds();
        } else
          f.call(this);
      };
      var p = i.utcOffset;
      i.utcOffset = function(m, A) {
        var b = this.$utils().u;
        if (b(m))
          return this.$u ? 0 : b(this.$offset) ? p.call(this) : this.$offset;
        if (typeof m == "string" && (m = function(R) {
          R === void 0 && (R = "");
          var y = R.match(r);
          if (!y)
            return null;
          var E = ("" + y[0]).match(o) || ["-", 0, 0], L = E[0], _ = 60 * +E[1] + +E[2];
          return _ === 0 ? 0 : L === "+" ? _ : -_;
        }(m), m === null))
          return this;
        var S = Math.abs(m) <= 16 ? 60 * m : m, N = this;
        if (A)
          return N.$offset = S, N.$u = m === 0, N;
        if (m !== 0) {
          var T = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (N = this.local().add(S + T, t)).$offset = S, N.$x.$localOffset = T;
        } else
          N = this.utc();
        return N;
      };
      var d = i.format;
      i.format = function(m) {
        var A = m || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return d.call(this, A);
      }, i.valueOf = function() {
        var m = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * m;
      }, i.isUTC = function() {
        return !!this.$u;
      }, i.toISOString = function() {
        return this.toDate().toISOString();
      }, i.toString = function() {
        return this.toDate().toUTCString();
      };
      var v = i.toDate;
      i.toDate = function(m) {
        return m === "s" && this.$offset ? l(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : v.call(this);
      };
      var g = i.diff;
      i.diff = function(m, A, b) {
        if (m && this.$u === m.$u)
          return g.call(this, m, A, b);
        var S = this.local(), N = l(m).local();
        return g.call(S, N, A, b);
      };
    };
  });
})(J_);
var PK = J_.exports;
const IK = /* @__PURE__ */ Gl(PK);
gn.extend(IK);
function NK(n) {
  for (const e in _m)
    n.component(e, _m[e]);
  for (const e in Em)
    n.component(e, Em[e]);
  n.component("Page", EK), n.component("PageHeader", AK), n.component("PageHeaderFull", OK), n.directive("kvalidate", Ba);
}
const { storeAppOptions: LK, setCustomModuleResolver: wK, storePlugins: xK, storeConfig: BK } = fn(), { configureApiUrl: FK, initializePlatform: UK } = Dr(), uj = async (n) => {
  console.log(`DP365+ kappa app startup: Start initialization for app '${n == null ? void 0 : n.appName}', type '${n == null ? void 0 : n.appType}'.`);
  try {
    LK(n), FK(n.appApiBaseUrl), wK(n.customModuleResolver);
    const e = await UK(n.appType);
    if (e == null)
      throw new Error("DP365+ kappa app initialization failed. Platform configuration loading failed!");
    BK(e);
    const t = VE(gK);
    t.use(NK);
    let r = n.globalSearchPlugins || [], o = n.customNotificationPlugins || [];
    Array.isArray(n.optionalModules) && n.optionalModules.forEach((i) => {
      i && i.searchPlugins && r.push(...i.searchPlugins), i && i.notificationPlugins && o.push(...i.notificationPlugins);
    }), xK(r, o);
    const u = dK(n);
    t.use(u);
    const c = YE();
    return c.use(({ store: i }) => {
      i.router = Am(u);
    }), t.use(c), t.use(ty, {
      locale: {
        accept: "Sì",
        reject: "No",
        monthNames: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
        monthNamesShort: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dec"],
        dayNamesShort: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
        dayNamesMin: ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"],
        today: "Oggi",
        clear: "Cancella",
        firstDayOfWeek: 1
      },
      // GLOBAL PASS-THROUGH per aggiungere la prop scope ai th dei datatable per conformità agid
      pt: {
        column: {
          headerCell: {
            scope: "col"
          }
        },
        calendar: {
          input: {
            autocomplete: "off"
          }
        }
      }
    }), t.use(ry), t.use(ny), await yr().initUser(), Array.isArray(n.optionalModules) && n.optionalModules.forEach((i) => {
      i && i.initModule && i.initModule();
    }), t;
  } catch (e) {
    console.error("DP365+ client app initialization failed!", e);
  }
  return null;
};
export {
  ja as AlertLevel,
  rj as ApiResponseMessage,
  ij as BaseFinder,
  To as BaseService,
  oj as ExternalPage,
  Lo as InputChipsType,
  iy as K2ColContainer,
  ay as K3ColContainer,
  Cf as KAlert,
  cy as KBackButton,
  bm as KCard,
  RC as KCarousel,
  PC as KCheckbox,
  OU as KCmsLast,
  NU as KCmsLatest2,
  aM as KDataTableActions,
  lM as KDatePicker,
  hM as KDocumentPreview,
  xO as KFilterChips,
  kO as KGlobalCalendarCompact,
  jO as KGlobalSearchBar,
  Dx as KHtmlEditor,
  yn as KIcon,
  Nx as KInputChips,
  kx as KInputDate,
  Qx as KInputFile,
  TB as KInputNumber,
  $_ as KInputPassword,
  G_ as KInputSearch,
  z_ as KInputText,
  Y_ as KInputTextArea,
  hU as KLatestNotifications,
  IB as KLinkCarousel,
  kB as KModalCenter,
  ev as KModalFullPage,
  $B as KModalSlide,
  lF as KNavScroll,
  cF as KNavScrollItem,
  PF as KPaginator,
  wF as KRadioButton,
  Ld as KSectionHeader,
  WF as KSelect,
  fd as KSpinner,
  nU as KStepperHeader,
  sU as KTab,
  aU as KTabs,
  cU as KToggle,
  Ba as KValidateDirective,
  tv as KValidationRules,
  SU as KWebTvLatest,
  Q_ as KWebTvVideoPlayer,
  wo as ModalDimension,
  sR as SortingOrder,
  fi as TwoColumnLayoutRatio,
  Bo as UserRouteModuleType,
  Qg as cmsService,
  uj as createKappaApp,
  NK as default,
  aj as platformService,
  DR as useCalendarEventsStore,
  Gr as useFilters,
  Ns as useGlobalSearchStore,
  sj as useKValidation,
  RO as useLayouts,
  cd as useNotificationStore,
  Dr as usePlatformApi,
  yr as useUserStore,
  Jr as webTvService
};
